import gql from 'graphql-tag';
import * as Urql from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigFloat: { input: any; output: any; }
  BigInt: { input: string; output: string; }
  Cursor: { input: any; output: any; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>; output: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>; }
  UUID: { input: string; output: string; }
};

/** All input for the `addDocumentToMultipleSpaces` mutation. */
export type AddDocumentToMultipleSpacesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  targets?: InputMaybe<Array<InputMaybe<IdsOfSpaceAndSectionInput>>>;
};

/** The output of our `addDocumentToMultipleSpaces` mutation. */
export type AddDocumentToMultipleSpacesPayload = {
  __typename?: 'AddDocumentToMultipleSpacesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documentSpaceItems?: Maybe<Array<Maybe<DocumentSpaceItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `addFlowToMultipleSpaces` mutation. */
export type AddFlowToMultipleSpacesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  targets?: InputMaybe<Array<InputMaybe<IdsOfSpaceAndSectionInput>>>;
};

/** The output of our `addFlowToMultipleSpaces` mutation. */
export type AddFlowToMultipleSpacesPayload = {
  __typename?: 'AddFlowToMultipleSpacesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<AddFlowToMultipleSpacesRecord>>>;
};

/** The return type of our `addFlowToMultipleSpaces` mutation. */
export type AddFlowToMultipleSpacesRecord = {
  __typename?: 'AddFlowToMultipleSpacesRecord';
  canCurrentUserShare?: Maybe<Scalars['Boolean']['output']>;
  createdDocumentSpaceItemIds?: Maybe<Array<Maybe<Scalars['BigInt']['output']>>>;
  downloadAvailableForVisitor?: Maybe<Scalars['Boolean']['output']>;
  existingSpaceNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetResults?: Maybe<Scalars['JSON']['output']>;
  violations?: Maybe<Scalars['JSON']['output']>;
};

/** All input for the `addTeamNotification` mutation. */
export type AddTeamNotificationInput = {
  bodyText: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventType: PvNotificationEventType;
  headerText: Scalars['String']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** The output of our `addTeamNotification` mutation. */
export type AddTeamNotificationPayload = {
  __typename?: 'AddTeamNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our `addTeamNotification` mutation. */
export type AddTeamNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** A `String` edge in the connection. */
export type AlreadyUsedTagEdge = {
  __typename?: 'AlreadyUsedTagEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `String` at the end of the edge. */
  node?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `String` values. */
export type AlreadyUsedTagsConnection = {
  __typename?: 'AlreadyUsedTagsConnection';
  /** A list of edges which contains the `String` and cursor to aid in pagination. */
  edges: Array<AlreadyUsedTagEdge>;
  /** A list of `String` objects. */
  nodes: Array<Maybe<Scalars['String']['output']>>;
  /** The count of *all* `String` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** All input for the `appendContentsToFlow` mutation. */
export type AppendContentsToFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentIds?: InputMaybe<Array<InputMaybe<ContentIdentifierInput>>>;
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `appendContentsToFlow` mutation. */
export type AppendContentsToFlowPayload = {
  __typename?: 'AppendContentsToFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `appendPagesToFlow` mutation. */
export type AppendPagesToFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  pageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};

/** The output of our `appendPagesToFlow` mutation. */
export type AppendPagesToFlowPayload = {
  __typename?: 'AppendPagesToFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `appendVideosToFlow` mutation. */
export type AppendVideosToFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  videoIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};

/** The output of our `appendVideosToFlow` mutation. */
export type AppendVideosToFlowPayload = {
  __typename?: 'AppendVideosToFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `ArInternalMetadatum` values. */
export type ArInternalMetadataConnection = {
  __typename?: 'ArInternalMetadataConnection';
  /** A list of edges which contains the `ArInternalMetadatum` and cursor to aid in pagination. */
  edges: Array<ArInternalMetadataEdge>;
  /** A list of `ArInternalMetadatum` objects. */
  nodes: Array<Maybe<ArInternalMetadatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ArInternalMetadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ArInternalMetadatum` edge in the connection. */
export type ArInternalMetadataEdge = {
  __typename?: 'ArInternalMetadataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ArInternalMetadatum` at the end of the edge. */
  node?: Maybe<ArInternalMetadatum>;
};

/** Methods to use when ordering `ArInternalMetadatum`. */
export enum ArInternalMetadataOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type ArInternalMetadatum = Node & {
  __typename?: 'ArInternalMetadatum';
  createdAt: Scalars['Datetime']['output'];
  key: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ArInternalMetadatum` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ArInternalMetadatumCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ArInternalMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ArInternalMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ArInternalMetadatumFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ArInternalMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ArInternalMetadatumFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ArInternalMetadatum` */
export type ArInternalMetadatumInput = {
  createdAt: Scalars['Datetime']['input'];
  key: Scalars['String']['input'];
  updatedAt: Scalars['Datetime']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `ArInternalMetadatum`. Fields that are set will be updated. */
export type ArInternalMetadatumPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `assignCrmContactToDocumentSpace` mutation. */
export type AssignCrmContactToDocumentSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmContactId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
};

/** The output of our `assignCrmContactToDocumentSpace` mutation. */
export type AssignCrmContactToDocumentSpacePayload = {
  __typename?: 'AssignCrmContactToDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<AssignCrmContactToDocumentSpaceRecord>;
};

/** The return type of our `assignCrmContactToDocumentSpace` mutation. */
export type AssignCrmContactToDocumentSpaceRecord = {
  __typename?: 'AssignCrmContactToDocumentSpaceRecord';
  crmContact?: Maybe<CrmContact>;
  documentSpace?: Maybe<DocumentSpace>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against BigInt List fields. All fields are combined with a logical ‘and.’ */
export type BigIntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type Campaign = Node & {
  __typename?: 'Campaign';
  /** Reads and enables pagination through a set of `CampaignPhase`. */
  campaignPhases: CampaignPhasesConnection;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Team` that is related to this `Campaign`. */
  team?: Maybe<Team>;
  teamId: Scalars['BigInt']['output'];
};


export type CampaignCampaignPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignPhaseCondition>;
  filter?: InputMaybe<CampaignPhaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignPhasesOrderBy>>;
};

/**
 * A condition to be used against `Campaign` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CampaignCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isValid` field. */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Campaign` object types. All fields are combined with a logical ‘and.’ */
export type CampaignFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CampaignFilter>>;
  /** Filter by the object’s `campaignPhases` relation. */
  campaignPhases?: InputMaybe<CampaignToManyCampaignPhaseFilter>;
  /** Some related `campaignPhases` exist. */
  campaignPhasesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isValid` field. */
  isValid?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CampaignFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CampaignFilter>>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<TeamFilter>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Campaign` */
export type CampaignInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** Represents an update to a `Campaign`. Fields that are set will be updated. */
export type CampaignPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type CampaignPhase = Node & {
  __typename?: 'CampaignPhase';
  /** Reads a single `Campaign` that is related to this `CampaignPhase`. */
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `CampaignPhaseLink`. */
  campaignPhaseLinksByPhaseId: CampaignPhaseLinksConnection;
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `CrmContactPhaseMapping`. */
  crmContactPhaseMappingsByPhaseId: CrmContactPhaseMappingsConnection;
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type CampaignPhaseCampaignPhaseLinksByPhaseIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignPhaseLinkCondition>;
  filter?: InputMaybe<CampaignPhaseLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignPhaseLinksOrderBy>>;
};


export type CampaignPhaseCrmContactPhaseMappingsByPhaseIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactPhaseMappingCondition>;
  filter?: InputMaybe<CrmContactPhaseMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};

/**
 * A condition to be used against `CampaignPhase` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CampaignPhaseCondition = {
  /** Checks for equality with the object’s `campaignId` field. */
  campaignId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CampaignPhase` object types. All fields are combined with a logical ‘and.’ */
export type CampaignPhaseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CampaignPhaseFilter>>;
  /** Filter by the object’s `campaign` relation. */
  campaign?: InputMaybe<CampaignFilter>;
  /** Filter by the object’s `campaignId` field. */
  campaignId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `campaignPhaseLinksByPhaseId` relation. */
  campaignPhaseLinksByPhaseId?: InputMaybe<CampaignPhaseToManyCampaignPhaseLinkFilter>;
  /** Some related `campaignPhaseLinksByPhaseId` exist. */
  campaignPhaseLinksByPhaseIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContactPhaseMappingsByPhaseId` relation. */
  crmContactPhaseMappingsByPhaseId?: InputMaybe<CampaignPhaseToManyCrmContactPhaseMappingFilter>;
  /** Some related `crmContactPhaseMappingsByPhaseId` exist. */
  crmContactPhaseMappingsByPhaseIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CampaignPhaseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CampaignPhaseFilter>>;
};

/** An input for mutations affecting `CampaignPhase` */
export type CampaignPhaseInput = {
  campaignId: Scalars['BigInt']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
};

export type CampaignPhaseLink = Node & {
  __typename?: 'CampaignPhaseLink';
  /** Reads and enables pagination through a set of `CampaignQueryParam`. */
  campaignQueryParams: CampaignQueryParamsConnection;
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceVoucher`. */
  documentSpaceVouchers: DocumentSpaceVouchersConnection;
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `CampaignPhase` that is related to this `CampaignPhaseLink`. */
  phase?: Maybe<CampaignPhase>;
  phaseId: Scalars['BigInt']['output'];
};


export type CampaignPhaseLinkCampaignQueryParamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignQueryParamCondition>;
  filter?: InputMaybe<CampaignQueryParamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignQueryParamsOrderBy>>;
};


export type CampaignPhaseLinkDocumentSpaceVouchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceVoucherCondition>;
  filter?: InputMaybe<DocumentSpaceVoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceVouchersOrderBy>>;
};

/**
 * A condition to be used against `CampaignPhaseLink` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CampaignPhaseLinkCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phaseId` field. */
  phaseId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `CampaignPhaseLink` object types. All fields are combined with a logical ‘and.’ */
export type CampaignPhaseLinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CampaignPhaseLinkFilter>>;
  /** Filter by the object’s `campaignQueryParams` relation. */
  campaignQueryParams?: InputMaybe<CampaignPhaseLinkToManyCampaignQueryParamFilter>;
  /** Some related `campaignQueryParams` exist. */
  campaignQueryParamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpaceVouchers` relation. */
  documentSpaceVouchers?: InputMaybe<CampaignPhaseLinkToManyDocumentSpaceVoucherFilter>;
  /** Some related `documentSpaceVouchers` exist. */
  documentSpaceVouchersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CampaignPhaseLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CampaignPhaseLinkFilter>>;
  /** Filter by the object’s `phase` relation. */
  phase?: InputMaybe<CampaignPhaseFilter>;
  /** Filter by the object’s `phaseId` field. */
  phaseId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `CampaignPhaseLink` */
export type CampaignPhaseLinkInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  phaseId: Scalars['BigInt']['input'];
};

/** Represents an update to a `CampaignPhaseLink`. Fields that are set will be updated. */
export type CampaignPhaseLinkPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phaseId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against many `CampaignQueryParam` object types. All fields are combined with a logical ‘and.’ */
export type CampaignPhaseLinkToManyCampaignQueryParamFilter = {
  /** Every related `CampaignQueryParam` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CampaignQueryParamFilter>;
  /** No related `CampaignQueryParam` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CampaignQueryParamFilter>;
  /** Some related `CampaignQueryParam` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CampaignQueryParamFilter>;
};

/** A filter to be used against many `DocumentSpaceVoucher` object types. All fields are combined with a logical ‘and.’ */
export type CampaignPhaseLinkToManyDocumentSpaceVoucherFilter = {
  /** Every related `DocumentSpaceVoucher` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceVoucherFilter>;
  /** No related `DocumentSpaceVoucher` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceVoucherFilter>;
  /** Some related `DocumentSpaceVoucher` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceVoucherFilter>;
};

/** A connection to a list of `CampaignPhaseLink` values. */
export type CampaignPhaseLinksConnection = {
  __typename?: 'CampaignPhaseLinksConnection';
  /** A list of edges which contains the `CampaignPhaseLink` and cursor to aid in pagination. */
  edges: Array<CampaignPhaseLinksEdge>;
  /** A list of `CampaignPhaseLink` objects. */
  nodes: Array<Maybe<CampaignPhaseLink>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CampaignPhaseLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CampaignPhaseLink` edge in the connection. */
export type CampaignPhaseLinksEdge = {
  __typename?: 'CampaignPhaseLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CampaignPhaseLink` at the end of the edge. */
  node?: Maybe<CampaignPhaseLink>;
};

/** Methods to use when ordering `CampaignPhaseLink`. */
export enum CampaignPhaseLinksOrderBy {
  CampaignPhaseByPhaseIdCampaignIdAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CAMPAIGN_ID_ASC',
  CampaignPhaseByPhaseIdCampaignIdDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CAMPAIGN_ID_DESC',
  CampaignPhaseByPhaseIdCreatedAtAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CREATED_AT_ASC',
  CampaignPhaseByPhaseIdCreatedAtDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CREATED_AT_DESC',
  CampaignPhaseByPhaseIdIdAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__ID_ASC',
  CampaignPhaseByPhaseIdIdDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__ID_DESC',
  CampaignPhaseByPhaseIdNameAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__NAME_ASC',
  CampaignPhaseByPhaseIdNameDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__NAME_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdCountAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__COUNT_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdCountDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__COUNT_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxCampaignPhaseLinkIdAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CAMPAIGN_PHASE_LINK_ID_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxCampaignPhaseLinkIdDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CAMPAIGN_PHASE_LINK_ID_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxCreatedAtAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CREATED_AT_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxCreatedAtDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CREATED_AT_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxIdAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_ID_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxIdDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_ID_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxIsStaticAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_IS_STATIC_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxIsStaticDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_IS_STATIC_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxNameAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_NAME_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxNameDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_NAME_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxValueAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_VALUE_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMaxValueDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_VALUE_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinCampaignPhaseLinkIdAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CAMPAIGN_PHASE_LINK_ID_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinCampaignPhaseLinkIdDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CAMPAIGN_PHASE_LINK_ID_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinCreatedAtAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CREATED_AT_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinCreatedAtDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CREATED_AT_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinIdAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_ID_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinIdDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_ID_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinIsStaticAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_IS_STATIC_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinIsStaticDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_IS_STATIC_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinNameAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_NAME_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinNameDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_NAME_DESC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinValueAsc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_VALUE_ASC',
  CampaignQueryParamsByCampaignPhaseLinkIdMinValueDesc = 'CAMPAIGN_QUERY_PARAMS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_VALUE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdCountAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__COUNT_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdCountDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__COUNT_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxCampaignPhaseLinkIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CAMPAIGN_PHASE_LINK_ID_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxCampaignPhaseLinkIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CAMPAIGN_PHASE_LINK_ID_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxHashedSecretAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_HASHED_SECRET_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxHashedSecretDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_HASHED_SECRET_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxHashAlgorithmAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_HASH_ALGORITHM_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxHashAlgorithmDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_HASH_ALGORITHM_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_ID_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_ID_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxIsPreviewAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_IS_PREVIEW_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxIsPreviewDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_IS_PREVIEW_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxNameAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_NAME_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxNameDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_NAME_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxValidUntilAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_VALID_UNTIL_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMaxValidUntilDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MAX_VALID_UNTIL_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinCampaignPhaseLinkIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CAMPAIGN_PHASE_LINK_ID_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinCampaignPhaseLinkIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CAMPAIGN_PHASE_LINK_ID_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinCreatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinCreatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinHashedSecretAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_HASHED_SECRET_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinHashedSecretDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_HASHED_SECRET_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinHashAlgorithmAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_HASH_ALGORITHM_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinHashAlgorithmDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_HASH_ALGORITHM_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_ID_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_ID_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinIsPreviewAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_IS_PREVIEW_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinIsPreviewDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_IS_PREVIEW_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinNameAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_NAME_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinNameDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_NAME_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinSysPeriodAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinSysPeriodDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinValidUntilAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_VALID_UNTIL_ASC',
  DocumentSpaceVouchersByCampaignPhaseLinkIdMinValidUntilDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_CAMPAIGN_PHASE_LINK_ID__MIN_VALID_UNTIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhaseIdAsc = 'PHASE_ID_ASC',
  PhaseIdDesc = 'PHASE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `CampaignPhase`. Fields that are set will be updated. */
export type CampaignPhasePatch = {
  campaignId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `CampaignPhaseLink` object types. All fields are combined with a logical ‘and.’ */
export type CampaignPhaseToManyCampaignPhaseLinkFilter = {
  /** Every related `CampaignPhaseLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CampaignPhaseLinkFilter>;
  /** No related `CampaignPhaseLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CampaignPhaseLinkFilter>;
  /** Some related `CampaignPhaseLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CampaignPhaseLinkFilter>;
};

/** A filter to be used against many `CrmContactPhaseMapping` object types. All fields are combined with a logical ‘and.’ */
export type CampaignPhaseToManyCrmContactPhaseMappingFilter = {
  /** Every related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** No related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** Some related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactPhaseMappingFilter>;
};

/** A connection to a list of `CampaignPhase` values. */
export type CampaignPhasesConnection = {
  __typename?: 'CampaignPhasesConnection';
  /** A list of edges which contains the `CampaignPhase` and cursor to aid in pagination. */
  edges: Array<CampaignPhasesEdge>;
  /** A list of `CampaignPhase` objects. */
  nodes: Array<Maybe<CampaignPhase>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CampaignPhase` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CampaignPhase` edge in the connection. */
export type CampaignPhasesEdge = {
  __typename?: 'CampaignPhasesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CampaignPhase` at the end of the edge. */
  node?: Maybe<CampaignPhase>;
};

/** Methods to use when ordering `CampaignPhase`. */
export enum CampaignPhasesOrderBy {
  CampaignByCampaignIdCreatedAtAsc = 'CAMPAIGN_BY_CAMPAIGN_ID__CREATED_AT_ASC',
  CampaignByCampaignIdCreatedAtDesc = 'CAMPAIGN_BY_CAMPAIGN_ID__CREATED_AT_DESC',
  CampaignByCampaignIdIdAsc = 'CAMPAIGN_BY_CAMPAIGN_ID__ID_ASC',
  CampaignByCampaignIdIdDesc = 'CAMPAIGN_BY_CAMPAIGN_ID__ID_DESC',
  CampaignByCampaignIdIsValidAsc = 'CAMPAIGN_BY_CAMPAIGN_ID__IS_VALID_ASC',
  CampaignByCampaignIdIsValidDesc = 'CAMPAIGN_BY_CAMPAIGN_ID__IS_VALID_DESC',
  CampaignByCampaignIdNameAsc = 'CAMPAIGN_BY_CAMPAIGN_ID__NAME_ASC',
  CampaignByCampaignIdNameDesc = 'CAMPAIGN_BY_CAMPAIGN_ID__NAME_DESC',
  CampaignByCampaignIdTeamIdAsc = 'CAMPAIGN_BY_CAMPAIGN_ID__TEAM_ID_ASC',
  CampaignByCampaignIdTeamIdDesc = 'CAMPAIGN_BY_CAMPAIGN_ID__TEAM_ID_DESC',
  CampaignIdAsc = 'CAMPAIGN_ID_ASC',
  CampaignIdDesc = 'CAMPAIGN_ID_DESC',
  CampaignPhaseLinksByPhaseIdCountAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__COUNT_ASC',
  CampaignPhaseLinksByPhaseIdCountDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__COUNT_DESC',
  CampaignPhaseLinksByPhaseIdMaxCreatedAtAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_CREATED_AT_ASC',
  CampaignPhaseLinksByPhaseIdMaxCreatedAtDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_CREATED_AT_DESC',
  CampaignPhaseLinksByPhaseIdMaxIdAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_ID_ASC',
  CampaignPhaseLinksByPhaseIdMaxIdDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_ID_DESC',
  CampaignPhaseLinksByPhaseIdMaxNameAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_NAME_ASC',
  CampaignPhaseLinksByPhaseIdMaxNameDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_NAME_DESC',
  CampaignPhaseLinksByPhaseIdMaxPhaseIdAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_PHASE_ID_ASC',
  CampaignPhaseLinksByPhaseIdMaxPhaseIdDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MAX_PHASE_ID_DESC',
  CampaignPhaseLinksByPhaseIdMinCreatedAtAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_CREATED_AT_ASC',
  CampaignPhaseLinksByPhaseIdMinCreatedAtDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_CREATED_AT_DESC',
  CampaignPhaseLinksByPhaseIdMinIdAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_ID_ASC',
  CampaignPhaseLinksByPhaseIdMinIdDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_ID_DESC',
  CampaignPhaseLinksByPhaseIdMinNameAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_NAME_ASC',
  CampaignPhaseLinksByPhaseIdMinNameDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_NAME_DESC',
  CampaignPhaseLinksByPhaseIdMinPhaseIdAsc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_PHASE_ID_ASC',
  CampaignPhaseLinksByPhaseIdMinPhaseIdDesc = 'CAMPAIGN_PHASE_LINKS_BY_PHASE_ID__MIN_PHASE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactPhaseMappingsByPhaseIdCountAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__COUNT_ASC',
  CrmContactPhaseMappingsByPhaseIdCountDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__COUNT_DESC',
  CrmContactPhaseMappingsByPhaseIdMaxContactIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_CONTACT_ID_ASC',
  CrmContactPhaseMappingsByPhaseIdMaxContactIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_CONTACT_ID_DESC',
  CrmContactPhaseMappingsByPhaseIdMaxCreatedAtAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_CREATED_AT_ASC',
  CrmContactPhaseMappingsByPhaseIdMaxCreatedAtDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_CREATED_AT_DESC',
  CrmContactPhaseMappingsByPhaseIdMaxIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_ID_ASC',
  CrmContactPhaseMappingsByPhaseIdMaxIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_ID_DESC',
  CrmContactPhaseMappingsByPhaseIdMaxPhaseIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_PHASE_ID_ASC',
  CrmContactPhaseMappingsByPhaseIdMaxPhaseIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MAX_PHASE_ID_DESC',
  CrmContactPhaseMappingsByPhaseIdMinContactIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_CONTACT_ID_ASC',
  CrmContactPhaseMappingsByPhaseIdMinContactIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_CONTACT_ID_DESC',
  CrmContactPhaseMappingsByPhaseIdMinCreatedAtAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_CREATED_AT_ASC',
  CrmContactPhaseMappingsByPhaseIdMinCreatedAtDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_CREATED_AT_DESC',
  CrmContactPhaseMappingsByPhaseIdMinIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_ID_ASC',
  CrmContactPhaseMappingsByPhaseIdMinIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_ID_DESC',
  CrmContactPhaseMappingsByPhaseIdMinPhaseIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_PHASE_ID_ASC',
  CrmContactPhaseMappingsByPhaseIdMinPhaseIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_PHASE_ID__MIN_PHASE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CampaignQueryParam = Node & {
  __typename?: 'CampaignQueryParam';
  /** Reads a single `CampaignPhaseLink` that is related to this `CampaignQueryParam`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  campaignPhaseLinkId: Scalars['BigInt']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  isStatic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `CampaignQueryParam` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CampaignQueryParamCondition = {
  /** Checks for equality with the object’s `campaignPhaseLinkId` field. */
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isStatic` field. */
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CampaignQueryParam` object types. All fields are combined with a logical ‘and.’ */
export type CampaignQueryParamFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CampaignQueryParamFilter>>;
  /** Filter by the object’s `campaignPhaseLink` relation. */
  campaignPhaseLink?: InputMaybe<CampaignPhaseLinkFilter>;
  /** Filter by the object’s `campaignPhaseLinkId` field. */
  campaignPhaseLinkId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isStatic` field. */
  isStatic?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CampaignQueryParamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CampaignQueryParamFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CampaignQueryParam` */
export type CampaignQueryParamInput = {
  campaignPhaseLinkId: Scalars['BigInt']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isStatic: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `CampaignQueryParam`. Fields that are set will be updated. */
export type CampaignQueryParamPatch = {
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CampaignQueryParam` values. */
export type CampaignQueryParamsConnection = {
  __typename?: 'CampaignQueryParamsConnection';
  /** A list of edges which contains the `CampaignQueryParam` and cursor to aid in pagination. */
  edges: Array<CampaignQueryParamsEdge>;
  /** A list of `CampaignQueryParam` objects. */
  nodes: Array<Maybe<CampaignQueryParam>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CampaignQueryParam` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CampaignQueryParam` edge in the connection. */
export type CampaignQueryParamsEdge = {
  __typename?: 'CampaignQueryParamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CampaignQueryParam` at the end of the edge. */
  node?: Maybe<CampaignQueryParam>;
};

/** Methods to use when ordering `CampaignQueryParam`. */
export enum CampaignQueryParamsOrderBy {
  CampaignPhaseLinkByCampaignPhaseLinkIdCreatedAtAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__CREATED_AT_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdCreatedAtDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__CREATED_AT_DESC',
  CampaignPhaseLinkByCampaignPhaseLinkIdIdAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__ID_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdIdDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__ID_DESC',
  CampaignPhaseLinkByCampaignPhaseLinkIdNameAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__NAME_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdNameDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__NAME_DESC',
  CampaignPhaseLinkByCampaignPhaseLinkIdPhaseIdAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__PHASE_ID_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdPhaseIdDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__PHASE_ID_DESC',
  CampaignPhaseLinkIdAsc = 'CAMPAIGN_PHASE_LINK_ID_ASC',
  CampaignPhaseLinkIdDesc = 'CAMPAIGN_PHASE_LINK_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsStaticAsc = 'IS_STATIC_ASC',
  IsStaticDesc = 'IS_STATIC_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A filter to be used against many `CampaignPhase` object types. All fields are combined with a logical ‘and.’ */
export type CampaignToManyCampaignPhaseFilter = {
  /** Every related `CampaignPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CampaignPhaseFilter>;
  /** No related `CampaignPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CampaignPhaseFilter>;
  /** Some related `CampaignPhase` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CampaignPhaseFilter>;
};

/** A connection to a list of `Campaign` values. */
export type CampaignsConnection = {
  __typename?: 'CampaignsConnection';
  /** A list of edges which contains the `Campaign` and cursor to aid in pagination. */
  edges: Array<CampaignsEdge>;
  /** A list of `Campaign` objects. */
  nodes: Array<Maybe<Campaign>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Campaign` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Campaign` edge in the connection. */
export type CampaignsEdge = {
  __typename?: 'CampaignsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Campaign` at the end of the edge. */
  node?: Maybe<Campaign>;
};

/** Methods to use when ordering `Campaign`. */
export enum CampaignsOrderBy {
  CampaignPhasesByCampaignIdCountAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__COUNT_ASC',
  CampaignPhasesByCampaignIdCountDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__COUNT_DESC',
  CampaignPhasesByCampaignIdMaxCampaignIdAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_CAMPAIGN_ID_ASC',
  CampaignPhasesByCampaignIdMaxCampaignIdDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_CAMPAIGN_ID_DESC',
  CampaignPhasesByCampaignIdMaxCreatedAtAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_CREATED_AT_ASC',
  CampaignPhasesByCampaignIdMaxCreatedAtDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_CREATED_AT_DESC',
  CampaignPhasesByCampaignIdMaxIdAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_ID_ASC',
  CampaignPhasesByCampaignIdMaxIdDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_ID_DESC',
  CampaignPhasesByCampaignIdMaxNameAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_NAME_ASC',
  CampaignPhasesByCampaignIdMaxNameDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MAX_NAME_DESC',
  CampaignPhasesByCampaignIdMinCampaignIdAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_CAMPAIGN_ID_ASC',
  CampaignPhasesByCampaignIdMinCampaignIdDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_CAMPAIGN_ID_DESC',
  CampaignPhasesByCampaignIdMinCreatedAtAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_CREATED_AT_ASC',
  CampaignPhasesByCampaignIdMinCreatedAtDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_CREATED_AT_DESC',
  CampaignPhasesByCampaignIdMinIdAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_ID_ASC',
  CampaignPhasesByCampaignIdMinIdDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_ID_DESC',
  CampaignPhasesByCampaignIdMinNameAsc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_NAME_ASC',
  CampaignPhasesByCampaignIdMinNameDesc = 'CAMPAIGN_PHASES_BY_CAMPAIGN_ID__MIN_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsValidAsc = 'IS_VALID_ASC',
  IsValidDesc = 'IS_VALID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TeamByTeamIdAnalyticsAliasAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamByTeamIdAnalyticsAliasDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamByTeamIdAnalyticsEnabledAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamByTeamIdAnalyticsEnabledDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamByTeamIdCreatedAtAsc = 'TEAM_BY_TEAM_ID__CREATED_AT_ASC',
  TeamByTeamIdCreatedAtDesc = 'TEAM_BY_TEAM_ID__CREATED_AT_DESC',
  TeamByTeamIdFlagsAsc = 'TEAM_BY_TEAM_ID__FLAGS_ASC',
  TeamByTeamIdFlagsDesc = 'TEAM_BY_TEAM_ID__FLAGS_DESC',
  TeamByTeamIdIdAsc = 'TEAM_BY_TEAM_ID__ID_ASC',
  TeamByTeamIdIdDesc = 'TEAM_BY_TEAM_ID__ID_DESC',
  TeamByTeamIdIsOpenAsc = 'TEAM_BY_TEAM_ID__IS_OPEN_ASC',
  TeamByTeamIdIsOpenDesc = 'TEAM_BY_TEAM_ID__IS_OPEN_DESC',
  TeamByTeamIdIsVisibleAsc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_ASC',
  TeamByTeamIdIsVisibleDesc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_DESC',
  TeamByTeamIdMemberCountAsc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_ASC',
  TeamByTeamIdMemberCountDesc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_DESC',
  TeamByTeamIdNameAsc = 'TEAM_BY_TEAM_ID__NAME_ASC',
  TeamByTeamIdNameDesc = 'TEAM_BY_TEAM_ID__NAME_DESC',
  TeamByTeamIdNameLowercaseAsc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  TeamByTeamIdNameLowercaseDesc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  TeamByTeamIdSysPeriodAsc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_ASC',
  TeamByTeamIdSysPeriodDesc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_DESC',
  TeamByTeamIdTenantIdAsc = 'TEAM_BY_TEAM_ID__TENANT_ID_ASC',
  TeamByTeamIdTenantIdDesc = 'TEAM_BY_TEAM_ID__TENANT_ID_DESC',
  TeamByTeamIdTotalMemberCountAsc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamByTeamIdTotalMemberCountDesc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamByTeamIdUpdatedAtAsc = 'TEAM_BY_TEAM_ID__UPDATED_AT_ASC',
  TeamByTeamIdUpdatedAtDesc = 'TEAM_BY_TEAM_ID__UPDATED_AT_DESC',
  TeamByTeamIdUserConfigDefaultsAsc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamByTeamIdUserConfigDefaultsDesc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC'
}

/** All input for the `cloneDocumentSpace` mutation. */
export type CloneDocumentSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  includingVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  newName?: InputMaybe<Scalars['String']['input']>;
  withId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `cloneDocumentSpace` mutation. */
export type CloneDocumentSpacePayload = {
  __typename?: 'CloneDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  clonedSpace?: Maybe<DocumentSpace>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpace`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `User` that is related to this `DocumentSpace`. */
  creator?: Maybe<User>;
  /** An edge for our `DocumentSpace`. May be used by Relay 1. */
  documentSpaceEdge?: Maybe<DocumentSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpace`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our `cloneDocumentSpace` mutation. */
export type CloneDocumentSpacePayloadDocumentSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};

/** An input for mutations affecting `ContentIdentifier` */
export type ContentIdentifierInput = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ContentType>;
};

export enum ContentType {
  Page = 'PAGE',
  Video = 'VIDEO'
}

/** All input for the `copyDocument` mutation. */
export type CopyDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newName?: InputMaybe<Scalars['String']['input']>;
  targetWorkspaceId?: InputMaybe<Scalars['BigInt']['input']>;
  withId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `copyDocument` mutation. */
export type CopyDocumentPayload = {
  __typename?: 'CopyDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  copiedDocument?: Maybe<Document>;
  /** Reads a single `User` that is related to this `Document`. */
  createdBy?: Maybe<User>;
  /** An edge for our `Document`. May be used by Relay 1. */
  documentEdge?: Maybe<DocumentsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `Document`. */
  documentRevisionByIdAndCurrentRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `User` that is related to this `Document`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Document` that is related to this `Document`. */
  legalAppendix?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workspace` that is related to this `Document`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our `copyDocument` mutation. */
export type CopyDocumentPayloadDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};

/** All input for the `copyDocumentSpaceConfig` mutation. */
export type CopyDocumentSpaceConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  compatibilityGroupId?: InputMaybe<Scalars['BigInt']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  copyTranslations?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `copyDocumentSpaceConfig` mutation. */
export type CopyDocumentSpaceConfigPayload = {
  __typename?: 'CopyDocumentSpaceConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An edge for our `DocumentSpaceConfig`. May be used by Relay 1. */
  documentSpaceConfigEdge?: Maybe<DocumentSpaceConfigsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfig`. */
  languageCodeByDefaultLanguage?: Maybe<LanguageCode>;
  newConfig?: Maybe<DocumentSpaceConfig>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `DocumentSpaceConfig`. */
  team?: Maybe<Team>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceConfig`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `DocumentSpaceLinkGroup` that is related to this `DocumentSpaceConfig`. */
  tenantGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** Reads a single `User` that is related to this `DocumentSpaceConfig`. */
  updatedBy?: Maybe<User>;
};


/** The output of our `copyDocumentSpaceConfig` mutation. */
export type CopyDocumentSpaceConfigPayloadDocumentSpaceConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};

/** All input for the `copyFlow` mutation. */
export type CopyFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copySubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
  withId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `copyFlow` mutation. */
export type CopyFlowPayload = {
  __typename?: 'CopyFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  copiedFlow?: Maybe<Flow>;
  /** Reads a single `User` that is related to this `Flow`. */
  creator?: Maybe<User>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Reads a single `Flow` that is related to this `Flow`. */
  parent?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `copyFlow` mutation. */
export type CopyFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the `copyViewsToBackup` mutation. */
export type CopyViewsToBackupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `copyViewsToBackup` mutation. */
export type CopyViewsToBackupPayload = {
  __typename?: 'CopyViewsToBackupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `ArInternalMetadatum` mutation. */
export type CreateArInternalMetadatumInput = {
  /** The `ArInternalMetadatum` to be created by this mutation. */
  arInternalMetadatum: ArInternalMetadatumInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ArInternalMetadatum` mutation. */
export type CreateArInternalMetadatumPayload = {
  __typename?: 'CreateArInternalMetadatumPayload';
  /** The `ArInternalMetadatum` that was created by this mutation. */
  arInternalMetadatum?: Maybe<ArInternalMetadatum>;
  /** An edge for our `ArInternalMetadatum`. May be used by Relay 1. */
  arInternalMetadatumEdge?: Maybe<ArInternalMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ArInternalMetadatum` mutation. */
export type CreateArInternalMetadatumPayloadArInternalMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<ArInternalMetadataOrderBy>>;
};

/** All input for the create `Campaign` mutation. */
export type CreateCampaignInput = {
  /** The `Campaign` to be created by this mutation. */
  campaign: CampaignInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Campaign` mutation. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  /** The `Campaign` that was created by this mutation. */
  campaign?: Maybe<Campaign>;
  /** An edge for our `Campaign`. May be used by Relay 1. */
  campaignEdge?: Maybe<CampaignsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Campaign`. */
  team?: Maybe<Team>;
};


/** The output of our create `Campaign` mutation. */
export type CreateCampaignPayloadCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};

/** All input for the create `CampaignPhase` mutation. */
export type CreateCampaignPhaseInput = {
  /** The `CampaignPhase` to be created by this mutation. */
  campaignPhase: CampaignPhaseInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `CampaignPhaseLink` mutation. */
export type CreateCampaignPhaseLinkInput = {
  /** The `CampaignPhaseLink` to be created by this mutation. */
  campaignPhaseLink: CampaignPhaseLinkInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CampaignPhaseLink` mutation. */
export type CreateCampaignPhaseLinkPayload = {
  __typename?: 'CreateCampaignPhaseLinkPayload';
  /** The `CampaignPhaseLink` that was created by this mutation. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** An edge for our `CampaignPhaseLink`. May be used by Relay 1. */
  campaignPhaseLinkEdge?: Maybe<CampaignPhaseLinksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CampaignPhase` that is related to this `CampaignPhaseLink`. */
  phase?: Maybe<CampaignPhase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CampaignPhaseLink` mutation. */
export type CreateCampaignPhaseLinkPayloadCampaignPhaseLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignPhaseLinksOrderBy>>;
};

/** The output of our create `CampaignPhase` mutation. */
export type CreateCampaignPhasePayload = {
  __typename?: 'CreateCampaignPhasePayload';
  /** Reads a single `Campaign` that is related to this `CampaignPhase`. */
  campaign?: Maybe<Campaign>;
  /** The `CampaignPhase` that was created by this mutation. */
  campaignPhase?: Maybe<CampaignPhase>;
  /** An edge for our `CampaignPhase`. May be used by Relay 1. */
  campaignPhaseEdge?: Maybe<CampaignPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CampaignPhase` mutation. */
export type CreateCampaignPhasePayloadCampaignPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignPhasesOrderBy>>;
};

/** All input for the create `CampaignQueryParam` mutation. */
export type CreateCampaignQueryParamInput = {
  /** The `CampaignQueryParam` to be created by this mutation. */
  campaignQueryParam: CampaignQueryParamInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CampaignQueryParam` mutation. */
export type CreateCampaignQueryParamPayload = {
  __typename?: 'CreateCampaignQueryParamPayload';
  /** Reads a single `CampaignPhaseLink` that is related to this `CampaignQueryParam`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** The `CampaignQueryParam` that was created by this mutation. */
  campaignQueryParam?: Maybe<CampaignQueryParam>;
  /** An edge for our `CampaignQueryParam`. May be used by Relay 1. */
  campaignQueryParamEdge?: Maybe<CampaignQueryParamsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CampaignQueryParam` mutation. */
export type CreateCampaignQueryParamPayloadCampaignQueryParamEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignQueryParamsOrderBy>>;
};

/** All input for the create `CrmContactConsent` mutation. */
export type CreateCrmContactConsentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CrmContactConsent` to be created by this mutation. */
  crmContactConsent: CrmContactConsentInput;
};

/** The output of our create `CrmContactConsent` mutation. */
export type CreateCrmContactConsentPayload = {
  __typename?: 'CreateCrmContactConsentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `CrmContactConsent`. */
  createdBy?: Maybe<User>;
  /** Reads a single `CrmContact` that is related to this `CrmContactConsent`. */
  crm?: Maybe<CrmContact>;
  /** The `CrmContactConsent` that was created by this mutation. */
  crmContactConsent?: Maybe<CrmContactConsent>;
  /** An edge for our `CrmContactConsent`. May be used by Relay 1. */
  crmContactConsentEdge?: Maybe<CrmContactConsentsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactConsent`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CrmContactConsent` mutation. */
export type CreateCrmContactConsentPayloadCrmContactConsentEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};

/** All input for the create `CrmContact` mutation. */
export type CreateCrmContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CrmContact` to be created by this mutation. */
  crmContact: CrmContactInput;
};

/** The output of our create `CrmContact` mutation. */
export type CreateCrmContactPayload = {
  __typename?: 'CreateCrmContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CrmContact` that was created by this mutation. */
  crmContact?: Maybe<CrmContact>;
  /** An edge for our `CrmContact`. May be used by Relay 1. */
  crmContactEdge?: Maybe<CrmContactsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `CrmContact`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `CrmContact` mutation. */
export type CreateCrmContactPayloadCrmContactEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactsOrderBy>>;
};

/** All input for the create `CrmContactPhaseMapping` mutation. */
export type CreateCrmContactPhaseMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CrmContactPhaseMapping` to be created by this mutation. */
  crmContactPhaseMapping: CrmContactPhaseMappingInput;
};

/** The output of our create `CrmContactPhaseMapping` mutation. */
export type CreateCrmContactPhaseMappingPayload = {
  __typename?: 'CreateCrmContactPhaseMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `CrmContactPhaseMapping`. */
  contact?: Maybe<CrmContact>;
  /** The `CrmContactPhaseMapping` that was created by this mutation. */
  crmContactPhaseMapping?: Maybe<CrmContactPhaseMapping>;
  /** An edge for our `CrmContactPhaseMapping`. May be used by Relay 1. */
  crmContactPhaseMappingEdge?: Maybe<CrmContactPhaseMappingsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactPhaseMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Reads a single `CampaignPhase` that is related to this `CrmContactPhaseMapping`. */
  phase?: Maybe<CampaignPhase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CrmContactPhaseMapping` mutation. */
export type CreateCrmContactPhaseMappingPayloadCrmContactPhaseMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};

/** All input for the create `DocumentExpiration` mutation. */
export type CreateDocumentExpirationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentExpiration` to be created by this mutation. */
  documentExpiration: DocumentExpirationInput;
};

/** The output of our create `DocumentExpiration` mutation. */
export type CreateDocumentExpirationPayload = {
  __typename?: 'CreateDocumentExpirationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentExpiration`. */
  document?: Maybe<Document>;
  /** The `DocumentExpiration` that was created by this mutation. */
  documentExpiration?: Maybe<DocumentExpiration>;
  /** An edge for our `DocumentExpiration`. May be used by Relay 1. */
  documentExpirationEdge?: Maybe<DocumentExpirationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentExpiration` mutation. */
export type CreateDocumentExpirationPayloadDocumentExpirationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentExpirationsOrderBy>>;
};

/** All input for the create `Document` mutation. */
export type CreateDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Document` to be created by this mutation. */
  document: DocumentInput;
};

/** All input for the create `DocumentPage` mutation. */
export type CreateDocumentPageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentPage` to be created by this mutation. */
  documentPage: DocumentPageInput;
};

/** All input for the create `DocumentPageLink` mutation. */
export type CreateDocumentPageLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentPageLink` to be created by this mutation. */
  documentPageLink: DocumentPageLinkInput;
};

/** The output of our create `DocumentPageLink` mutation. */
export type CreateDocumentPageLinkPayload = {
  __typename?: 'CreateDocumentPageLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentPageLink` that was created by this mutation. */
  documentPageLink?: Maybe<DocumentPageLink>;
  /** An edge for our `DocumentPageLink`. May be used by Relay 1. */
  documentPageLinkEdge?: Maybe<DocumentPageLinksEdge>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  page?: Maybe<DocumentPage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  targetPage?: Maybe<DocumentPage>;
};


/** The output of our create `DocumentPageLink` mutation. */
export type CreateDocumentPageLinkPayloadDocumentPageLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageLinksOrderBy>>;
};

/** All input for the create `DocumentPageMatching` mutation. */
export type CreateDocumentPageMatchingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentPageMatching` to be created by this mutation. */
  documentPageMatching: DocumentPageMatchingInput;
};

/** The output of our create `DocumentPageMatching` mutation. */
export type CreateDocumentPageMatchingPayload = {
  __typename?: 'CreateDocumentPageMatchingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentPageMatching`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DocumentPage>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DocumentPage>;
  /** The `DocumentPageMatching` that was created by this mutation. */
  documentPageMatching?: Maybe<DocumentPageMatching>;
  /** An edge for our `DocumentPageMatching`. May be used by Relay 1. */
  documentPageMatchingEdge?: Maybe<DocumentPageMatchingsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndSourceRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndTargetRevisionNumber?: Maybe<DocumentRevision>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentPageMatching` mutation. */
export type CreateDocumentPageMatchingPayloadDocumentPageMatchingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};

/** All input for the create `DocumentPageMatchingsBak` mutation. */
export type CreateDocumentPageMatchingsBakInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentPageMatchingsBak` to be created by this mutation. */
  documentPageMatchingsBak: DocumentPageMatchingsBakInput;
};

/** The output of our create `DocumentPageMatchingsBak` mutation. */
export type CreateDocumentPageMatchingsBakPayload = {
  __typename?: 'CreateDocumentPageMatchingsBakPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentPageMatchingsBak` that was created by this mutation. */
  documentPageMatchingsBak?: Maybe<DocumentPageMatchingsBak>;
  /** An edge for our `DocumentPageMatchingsBak`. May be used by Relay 1. */
  documentPageMatchingsBakEdge?: Maybe<DocumentPageMatchingsBaksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentPageMatchingsBak` mutation. */
export type CreateDocumentPageMatchingsBakPayloadDocumentPageMatchingsBakEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageMatchingsBaksOrderBy>>;
};

/** The output of our create `DocumentPage` mutation. */
export type CreateDocumentPagePayload = {
  __typename?: 'CreateDocumentPagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  document?: Maybe<Document>;
  /** The `DocumentPage` that was created by this mutation. */
  documentPage?: Maybe<DocumentPage>;
  /** An edge for our `DocumentPage`. May be used by Relay 1. */
  documentPageEdge?: Maybe<DocumentPagesEdge>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPage`. */
  documentRevisionByDocumentIdAndRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  linkedDocument?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentPage` mutation. */
export type CreateDocumentPagePayloadDocumentPageEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};

/** The output of our create `Document` mutation. */
export type CreateDocumentPayload = {
  __typename?: 'CreateDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Document`. */
  createdBy?: Maybe<User>;
  /** The `Document` that was created by this mutation. */
  document?: Maybe<Document>;
  /** An edge for our `Document`. May be used by Relay 1. */
  documentEdge?: Maybe<DocumentsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `Document`. */
  documentRevisionByIdAndCurrentRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `User` that is related to this `Document`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Document` that is related to this `Document`. */
  legalAppendix?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workspace` that is related to this `Document`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our create `Document` mutation. */
export type CreateDocumentPayloadDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};

/** All input for the create `DocumentProcess` mutation. */
export type CreateDocumentProcessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentProcess` to be created by this mutation. */
  documentProcess: DocumentProcessInput;
};

/** The output of our create `DocumentProcess` mutation. */
export type CreateDocumentProcessPayload = {
  __typename?: 'CreateDocumentProcessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentProcess`. */
  document?: Maybe<Document>;
  /** The `DocumentProcess` that was created by this mutation. */
  documentProcess?: Maybe<DocumentProcess>;
  /** An edge for our `DocumentProcess`. May be used by Relay 1. */
  documentProcessEdge?: Maybe<DocumentProcessesEdge>;
  /** Reads a single `User` that is related to this `DocumentProcess`. */
  initiator?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentProcess`. */
  revision?: Maybe<DocumentRevision>;
};


/** The output of our create `DocumentProcess` mutation. */
export type CreateDocumentProcessPayloadDocumentProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};

/** All input for the create `DocumentRevision` mutation. */
export type CreateDocumentRevisionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentRevision` to be created by this mutation. */
  documentRevision: DocumentRevisionInput;
};

/** The output of our create `DocumentRevision` mutation. */
export type CreateDocumentRevisionPayload = {
  __typename?: 'CreateDocumentRevisionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentRevision`. */
  document?: Maybe<Document>;
  /** The `DocumentRevision` that was created by this mutation. */
  documentRevision?: Maybe<DocumentRevision>;
  /** An edge for our `DocumentRevision`. May be used by Relay 1. */
  documentRevisionEdge?: Maybe<DocumentRevisionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentRevision` mutation. */
export type CreateDocumentRevisionPayloadDocumentRevisionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentRevisionsOrderBy>>;
};

/** All input for the create `DocumentSpaceAccess` mutation. */
export type CreateDocumentSpaceAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceAccess` to be created by this mutation. */
  documentSpaceAccess: DocumentSpaceAccessInput;
};

/** The output of our create `DocumentSpaceAccess` mutation. */
export type CreateDocumentSpaceAccessPayload = {
  __typename?: 'CreateDocumentSpaceAccessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  creator?: Maybe<User>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceAccess`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceAccess` that was created by this mutation. */
  documentSpaceAccess?: Maybe<DocumentSpaceAccess>;
  /** An edge for our `DocumentSpaceAccess`. May be used by Relay 1. */
  documentSpaceAccessEdge?: Maybe<DocumentSpaceAccessesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  user?: Maybe<User>;
};


/** The output of our create `DocumentSpaceAccess` mutation. */
export type CreateDocumentSpaceAccessPayloadDocumentSpaceAccessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};

/** All input for the `createDocumentSpaceAccessToken` mutation. */
export type CreateDocumentSpaceAccessTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  mustMatchAllowedEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  optionalIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `createDocumentSpaceAccessToken` mutation. */
export type CreateDocumentSpaceAccessTokenPayload = {
  __typename?: 'CreateDocumentSpaceAccessTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  createdToken?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `DocumentSpaceConfigTranslation` mutation. */
export type CreateDocumentSpaceConfigTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceConfigTranslation` to be created by this mutation. */
  documentSpaceConfigTranslation: DocumentSpaceConfigTranslationInput;
};

/** The output of our create `DocumentSpaceConfigTranslation` mutation. */
export type CreateDocumentSpaceConfigTranslationPayload = {
  __typename?: 'CreateDocumentSpaceConfigTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceConfigTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** The `DocumentSpaceConfigTranslation` that was created by this mutation. */
  documentSpaceConfigTranslation?: Maybe<DocumentSpaceConfigTranslation>;
  /** An edge for our `DocumentSpaceConfigTranslation`. May be used by Relay 1. */
  documentSpaceConfigTranslationEdge?: Maybe<DocumentSpaceConfigTranslationsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfigTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceConfigTranslation` mutation. */
export type CreateDocumentSpaceConfigTranslationPayloadDocumentSpaceConfigTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceConfigTranslationsOrderBy>>;
};

/** All input for the `createDocumentSpaceConfigWithDefaults` mutation. */
export type CreateDocumentSpaceConfigWithDefaultsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  compatibilityGroupId?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `createDocumentSpaceConfigWithDefaults` mutation. */
export type CreateDocumentSpaceConfigWithDefaultsPayload = {
  __typename?: 'CreateDocumentSpaceConfigWithDefaultsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** An edge for our `DocumentSpaceConfig`. May be used by Relay 1. */
  documentSpaceConfigEdge?: Maybe<DocumentSpaceConfigsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfig`. */
  languageCodeByDefaultLanguage?: Maybe<LanguageCode>;
  newConfig?: Maybe<DocumentSpaceConfig>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `DocumentSpaceConfig`. */
  team?: Maybe<Team>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceConfig`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `DocumentSpaceLinkGroup` that is related to this `DocumentSpaceConfig`. */
  tenantGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** Reads a single `User` that is related to this `DocumentSpaceConfig`. */
  updatedBy?: Maybe<User>;
};


/** The output of our `createDocumentSpaceConfigWithDefaults` mutation. */
export type CreateDocumentSpaceConfigWithDefaultsPayloadDocumentSpaceConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};

/** All input for the create `DocumentSpaceCrmMapping` mutation. */
export type CreateDocumentSpaceCrmMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceCrmMapping` to be created by this mutation. */
  documentSpaceCrmMapping: DocumentSpaceCrmMappingInput;
};

/** The output of our create `DocumentSpaceCrmMapping` mutation. */
export type CreateDocumentSpaceCrmMappingPayload = {
  __typename?: 'CreateDocumentSpaceCrmMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `DocumentSpaceCrmMapping`. */
  crmContact?: Maybe<CrmContact>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceCrmMapping`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceCrmMapping` that was created by this mutation. */
  documentSpaceCrmMapping?: Maybe<DocumentSpaceCrmMapping>;
  /** An edge for our `DocumentSpaceCrmMapping`. May be used by Relay 1. */
  documentSpaceCrmMappingEdge?: Maybe<DocumentSpaceCrmMappingsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `DocumentSpaceCrmMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceCrmMapping` mutation. */
export type CreateDocumentSpaceCrmMappingPayloadDocumentSpaceCrmMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};

/** All input for the create `DocumentSpace` mutation. */
export type CreateDocumentSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpace` to be created by this mutation. */
  documentSpace: DocumentSpaceInput;
};

/** All input for the create `DocumentSpaceItem` mutation. */
export type CreateDocumentSpaceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceItem` to be created by this mutation. */
  documentSpaceItem: DocumentSpaceItemInput;
};

/** The output of our create `DocumentSpaceItem` mutation. */
export type CreateDocumentSpaceItemPayload = {
  __typename?: 'CreateDocumentSpaceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceItem` that was created by this mutation. */
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  /** An edge for our `DocumentSpaceItem`. May be used by Relay 1. */
  documentSpaceItemEdge?: Maybe<DocumentSpaceItemsEdge>;
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
};


/** The output of our create `DocumentSpaceItem` mutation. */
export type CreateDocumentSpaceItemPayloadDocumentSpaceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/** All input for the create `DocumentSpaceLinkGroup` mutation. */
export type CreateDocumentSpaceLinkGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceLinkGroup` to be created by this mutation. */
  documentSpaceLinkGroup: DocumentSpaceLinkGroupInput;
};

/** The output of our create `DocumentSpaceLinkGroup` mutation. */
export type CreateDocumentSpaceLinkGroupPayload = {
  __typename?: 'CreateDocumentSpaceLinkGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceLinkGroup` that was created by this mutation. */
  documentSpaceLinkGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** An edge for our `DocumentSpaceLinkGroup`. May be used by Relay 1. */
  documentSpaceLinkGroupEdge?: Maybe<DocumentSpaceLinkGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceLinkGroup`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `DocumentSpaceLinkGroup` mutation. */
export type CreateDocumentSpaceLinkGroupPayloadDocumentSpaceLinkGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkGroupsOrderBy>>;
};

/** All input for the create `DocumentSpaceLink` mutation. */
export type CreateDocumentSpaceLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceLink` to be created by this mutation. */
  documentSpaceLink: DocumentSpaceLinkInput;
};

/** All input for the create `DocumentSpaceLinkMapping` mutation. */
export type CreateDocumentSpaceLinkMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceLinkMapping` to be created by this mutation. */
  documentSpaceLinkMapping: DocumentSpaceLinkMappingInput;
};

/** The output of our create `DocumentSpaceLinkMapping` mutation. */
export type CreateDocumentSpaceLinkMappingPayload = {
  __typename?: 'CreateDocumentSpaceLinkMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceLinkMapping` that was created by this mutation. */
  documentSpaceLinkMapping?: Maybe<DocumentSpaceLinkMapping>;
  /** An edge for our `DocumentSpaceLinkMapping`. May be used by Relay 1. */
  documentSpaceLinkMappingEdge?: Maybe<DocumentSpaceLinkMappingsEdge>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkMapping`. */
  link?: Maybe<DocumentSpaceLink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLinkMapping`. */
  space?: Maybe<DocumentSpace>;
};


/** The output of our create `DocumentSpaceLinkMapping` mutation. */
export type CreateDocumentSpaceLinkMappingPayloadDocumentSpaceLinkMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkMappingsOrderBy>>;
};

/** The output of our create `DocumentSpaceLink` mutation. */
export type CreateDocumentSpaceLinkPayload = {
  __typename?: 'CreateDocumentSpaceLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLink`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLink`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceLink` that was created by this mutation. */
  documentSpaceLink?: Maybe<DocumentSpaceLink>;
  /** An edge for our `DocumentSpaceLink`. May be used by Relay 1. */
  documentSpaceLinkEdge?: Maybe<DocumentSpaceLinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceLink` mutation. */
export type CreateDocumentSpaceLinkPayloadDocumentSpaceLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinksOrderBy>>;
};

/** All input for the create `DocumentSpaceLinkTranslation` mutation. */
export type CreateDocumentSpaceLinkTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceLinkTranslation` to be created by this mutation. */
  documentSpaceLinkTranslation: DocumentSpaceLinkTranslationInput;
};

/** The output of our create `DocumentSpaceLinkTranslation` mutation. */
export type CreateDocumentSpaceLinkTranslationPayload = {
  __typename?: 'CreateDocumentSpaceLinkTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLinkTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** The `DocumentSpaceLinkTranslation` that was created by this mutation. */
  documentSpaceLinkTranslation?: Maybe<DocumentSpaceLinkTranslation>;
  /** An edge for our `DocumentSpaceLinkTranslation`. May be used by Relay 1. */
  documentSpaceLinkTranslationEdge?: Maybe<DocumentSpaceLinkTranslationsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceLinkTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkTranslation`. */
  link?: Maybe<DocumentSpaceLink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceLinkTranslation` mutation. */
export type CreateDocumentSpaceLinkTranslationPayloadDocumentSpaceLinkTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};

/** The output of our create `DocumentSpace` mutation. */
export type CreateDocumentSpacePayload = {
  __typename?: 'CreateDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpace`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `User` that is related to this `DocumentSpace`. */
  creator?: Maybe<User>;
  /** The `DocumentSpace` that was created by this mutation. */
  documentSpace?: Maybe<DocumentSpace>;
  /** An edge for our `DocumentSpace`. May be used by Relay 1. */
  documentSpaceEdge?: Maybe<DocumentSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpace`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `DocumentSpace` mutation. */
export type CreateDocumentSpacePayloadDocumentSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};

/** All input for the create `DocumentSpaceSection` mutation. */
export type CreateDocumentSpaceSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceSection` to be created by this mutation. */
  documentSpaceSection: DocumentSpaceSectionInput;
};

/** The output of our create `DocumentSpaceSection` mutation. */
export type CreateDocumentSpaceSectionPayload = {
  __typename?: 'CreateDocumentSpaceSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSection`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceSection` that was created by this mutation. */
  documentSpaceSection?: Maybe<DocumentSpaceSection>;
  /** An edge for our `DocumentSpaceSection`. May be used by Relay 1. */
  documentSpaceSectionEdge?: Maybe<DocumentSpaceSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceSection` mutation. */
export type CreateDocumentSpaceSectionPayloadDocumentSpaceSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSectionsOrderBy>>;
};

/** All input for the create `DocumentSpaceSession` mutation. */
export type CreateDocumentSpaceSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceSession` to be created by this mutation. */
  documentSpaceSession: DocumentSpaceSessionInput;
};

/** The output of our create `DocumentSpaceSession` mutation. */
export type CreateDocumentSpaceSessionPayload = {
  __typename?: 'CreateDocumentSpaceSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSession`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceSession` that was created by this mutation. */
  documentSpaceSession?: Maybe<DocumentSpaceSession>;
  /** An edge for our `DocumentSpaceSession`. May be used by Relay 1. */
  documentSpaceSessionEdge?: Maybe<DocumentSpaceSessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceSession` mutation. */
export type CreateDocumentSpaceSessionPayloadDocumentSpaceSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSessionsOrderBy>>;
};

/** All input for the create `DocumentSpaceTag` mutation. */
export type CreateDocumentSpaceTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceTag` to be created by this mutation. */
  documentSpaceTag: DocumentSpaceTagInput;
};

/** The output of our create `DocumentSpaceTag` mutation. */
export type CreateDocumentSpaceTagPayload = {
  __typename?: 'CreateDocumentSpaceTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceTag` that was created by this mutation. */
  documentSpaceTag?: Maybe<DocumentSpaceTag>;
  /** An edge for our `DocumentSpaceTag`. May be used by Relay 1. */
  documentSpaceTagEdge?: Maybe<DocumentSpaceTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceTag`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `DocumentSpaceTag` mutation. */
export type CreateDocumentSpaceTagPayloadDocumentSpaceTagEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceTagsOrderBy>>;
};

/** All input for the create `DocumentSpaceVoucher` mutation. */
export type CreateDocumentSpaceVoucherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpaceVoucher` to be created by this mutation. */
  documentSpaceVoucher: DocumentSpaceVoucherInput;
};

/** The output of our create `DocumentSpaceVoucher` mutation. */
export type CreateDocumentSpaceVoucherPayload = {
  __typename?: 'CreateDocumentSpaceVoucherPayload';
  /** Reads a single `CampaignPhaseLink` that is related to this `DocumentSpaceVoucher`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceVoucher`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceVoucher` that was created by this mutation. */
  documentSpaceVoucher?: Maybe<DocumentSpaceVoucher>;
  /** An edge for our `DocumentSpaceVoucher`. May be used by Relay 1. */
  documentSpaceVoucherEdge?: Maybe<DocumentSpaceVouchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpaceVoucher` mutation. */
export type CreateDocumentSpaceVoucherPayloadDocumentSpaceVoucherEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceVouchersOrderBy>>;
};

/** All input for the `createDocumentSpaceWithCrmContact` mutation. */
export type CreateDocumentSpaceWithCrmContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payload: PayloadOfCreateDocumentSpaceWithCrmContactInput;
};

/** The output of our `createDocumentSpaceWithCrmContact` mutation. */
export type CreateDocumentSpaceWithCrmContactPayload = {
  __typename?: 'CreateDocumentSpaceWithCrmContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<CreateDocumentSpaceWithCrmContactRecord>;
};

/** The return type of our `createDocumentSpaceWithCrmContact` mutation. */
export type CreateDocumentSpaceWithCrmContactRecord = {
  __typename?: 'CreateDocumentSpaceWithCrmContactRecord';
  crmContact?: Maybe<CrmContact>;
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
};

/** All input for the create `DocumentSpacesOldBak` mutation. */
export type CreateDocumentSpacesOldBakInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DocumentSpacesOldBak` to be created by this mutation. */
  documentSpacesOldBak: DocumentSpacesOldBakInput;
};

/** The output of our create `DocumentSpacesOldBak` mutation. */
export type CreateDocumentSpacesOldBakPayload = {
  __typename?: 'CreateDocumentSpacesOldBakPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpacesOldBak` that was created by this mutation. */
  documentSpacesOldBak?: Maybe<DocumentSpacesOldBak>;
  /** An edge for our `DocumentSpacesOldBak`. May be used by Relay 1. */
  documentSpacesOldBakEdge?: Maybe<DocumentSpacesOldBaksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentSpacesOldBak` mutation. */
export type CreateDocumentSpacesOldBakPayloadDocumentSpacesOldBakEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpacesOldBaksOrderBy>>;
};

/** All input for the create `Event` mutation. */
export type CreateEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Event` to be created by this mutation. */
  event: EventInput;
};

/** The output of our create `Event` mutation. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Event` that was created by this mutation. */
  event?: Maybe<Event>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `Flow` mutation. */
export type CreateFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Flow` to be created by this mutation. */
  flow: FlowInput;
};

/** All input for the create `FlowItem` mutation. */
export type CreateFlowItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FlowItem` to be created by this mutation. */
  flowItem: FlowItemInput;
};

/** The output of our create `FlowItem` mutation. */
export type CreateFlowItemPayload = {
  __typename?: 'CreateFlowItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `FlowItem`. */
  creator?: Maybe<User>;
  /** Reads a single `Flow` that is related to this `FlowItem`. */
  flow?: Maybe<Flow>;
  /** The `FlowItem` that was created by this mutation. */
  flowItem?: Maybe<FlowItem>;
  /** An edge for our `FlowItem`. May be used by Relay 1. */
  flowItemEdge?: Maybe<FlowItemsEdge>;
  /** Reads a single `DocumentPage` that is related to this `FlowItem`. */
  page?: Maybe<DocumentPage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Document` that is related to this `FlowItem`. */
  video?: Maybe<Document>;
};


/** The output of our create `FlowItem` mutation. */
export type CreateFlowItemPayloadFlowItemEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};

/** The output of our create `Flow` mutation. */
export type CreateFlowPayload = {
  __typename?: 'CreateFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Flow`. */
  creator?: Maybe<User>;
  /** The `Flow` that was created by this mutation. */
  flow?: Maybe<Flow>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Reads a single `Flow` that is related to this `Flow`. */
  parent?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Flow` mutation. */
export type CreateFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the create `FlowSubscription` mutation. */
export type CreateFlowSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FlowSubscription` to be created by this mutation. */
  flowSubscription: FlowSubscriptionInput;
};

/** The output of our create `FlowSubscription` mutation. */
export type CreateFlowSubscriptionPayload = {
  __typename?: 'CreateFlowSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Flow` that is related to this `FlowSubscription`. */
  flow?: Maybe<Flow>;
  /** The `FlowSubscription` that was created by this mutation. */
  flowSubscription?: Maybe<FlowSubscription>;
  /** An edge for our `FlowSubscription`. May be used by Relay 1. */
  flowSubscriptionEdge?: Maybe<FlowSubscriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `FlowSubscription`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `FlowSubscription`. */
  user?: Maybe<User>;
};


/** The output of our create `FlowSubscription` mutation. */
export type CreateFlowSubscriptionPayloadFlowSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};

/** All input for the create `InternalIpAddress` mutation. */
export type CreateInternalIpAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InternalIpAddress` to be created by this mutation. */
  internalIpAddress: InternalIpAddressInput;
};

/** The output of our create `InternalIpAddress` mutation. */
export type CreateInternalIpAddressPayload = {
  __typename?: 'CreateInternalIpAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `InternalIpAddress` that was created by this mutation. */
  internalIpAddress?: Maybe<InternalIpAddress>;
  /** An edge for our `InternalIpAddress`. May be used by Relay 1. */
  internalIpAddressEdge?: Maybe<InternalIpAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `InternalIpAddress`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `InternalIpAddress` mutation. */
export type CreateInternalIpAddressPayloadInternalIpAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InternalIpAddressesOrderBy>>;
};

/** All input for the create `LabelsOfDocumentView` mutation. */
export type CreateLabelsOfDocumentViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LabelsOfDocumentView` to be created by this mutation. */
  labelsOfDocumentView: LabelsOfDocumentViewInput;
};

/** The output of our create `LabelsOfDocumentView` mutation. */
export type CreateLabelsOfDocumentViewPayload = {
  __typename?: 'CreateLabelsOfDocumentViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `LabelsOfDocumentView`. */
  crmContact?: Maybe<CrmContact>;
  /** The `LabelsOfDocumentView` that was created by this mutation. */
  labelsOfDocumentView?: Maybe<LabelsOfDocumentView>;
  /** An edge for our `LabelsOfDocumentView`. May be used by Relay 1. */
  labelsOfDocumentViewEdge?: Maybe<LabelsOfDocumentViewsEdge>;
  /** Reads a single `User` that is related to this `LabelsOfDocumentView`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `CrmContactMatch` that is related to this `LabelsOfDocumentView`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LabelsOfDocumentView` mutation. */
export type CreateLabelsOfDocumentViewPayloadLabelsOfDocumentViewEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};

/** All input for the create `LanguageCode` mutation. */
export type CreateLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LanguageCode` to be created by this mutation. */
  languageCode: LanguageCodeInput;
};

/** The output of our create `LanguageCode` mutation. */
export type CreateLanguageCodePayload = {
  __typename?: 'CreateLanguageCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LanguageCode` that was created by this mutation. */
  languageCode?: Maybe<LanguageCode>;
  /** An edge for our `LanguageCode`. May be used by Relay 1. */
  languageCodeEdge?: Maybe<LanguageCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LanguageCode` mutation. */
export type CreateLanguageCodePayloadLanguageCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<LanguageCodesOrderBy>>;
};

/** All input for the create `LastCsvImport` mutation. */
export type CreateLastCsvImportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LastCsvImport` to be created by this mutation. */
  lastCsvImport: LastCsvImportInput;
};

/** The output of our create `LastCsvImport` mutation. */
export type CreateLastCsvImportPayload = {
  __typename?: 'CreateLastCsvImportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LastCsvImport` that was created by this mutation. */
  lastCsvImport?: Maybe<LastCsvImport>;
  /** An edge for our `LastCsvImport`. May be used by Relay 1. */
  lastCsvImportEdge?: Maybe<LastCsvImportsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LastCsvImport` mutation. */
export type CreateLastCsvImportPayloadLastCsvImportEdgeArgs = {
  orderBy?: InputMaybe<Array<LastCsvImportsOrderBy>>;
};

/** All input for the create `Membership` mutation. */
export type CreateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Membership` to be created by this mutation. */
  membership: MembershipInput;
};

/** The output of our create `Membership` mutation. */
export type CreateMembershipPayload = {
  __typename?: 'CreateMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Membership` that was created by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our create `Membership` mutation. */
export type CreateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the create `NonSyncableWorkspace` mutation. */
export type CreateNonSyncableWorkspaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `NonSyncableWorkspace` to be created by this mutation. */
  nonSyncableWorkspace: NonSyncableWorkspaceInput;
};

/** The output of our create `NonSyncableWorkspace` mutation. */
export type CreateNonSyncableWorkspacePayload = {
  __typename?: 'CreateNonSyncableWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NonSyncableWorkspace` that was created by this mutation. */
  nonSyncableWorkspace?: Maybe<NonSyncableWorkspace>;
  /** An edge for our `NonSyncableWorkspace`. May be used by Relay 1. */
  nonSyncableWorkspaceEdge?: Maybe<NonSyncableWorkspacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NonSyncableWorkspace` mutation. */
export type CreateNonSyncableWorkspacePayloadNonSyncableWorkspaceEdgeArgs = {
  orderBy?: InputMaybe<Array<NonSyncableWorkspacesOrderBy>>;
};

/** All input for the create `Notification` mutation. */
export type CreateNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Notification` to be created by this mutation. */
  notification: NotificationInput;
};

/** The output of our create `Notification` mutation. */
export type CreateNotificationPayload = {
  __typename?: 'CreateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Notification` that was created by this mutation. */
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our create `Notification` mutation. */
export type CreateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the create `OldDocumentSpace` mutation. */
export type CreateOldDocumentSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OldDocumentSpace` to be created by this mutation. */
  oldDocumentSpace: OldDocumentSpaceInput;
};

/** The output of our create `OldDocumentSpace` mutation. */
export type CreateOldDocumentSpacePayload = {
  __typename?: 'CreateOldDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OldDocumentSpace` that was created by this mutation. */
  oldDocumentSpace?: Maybe<OldDocumentSpace>;
  /** An edge for our `OldDocumentSpace`. May be used by Relay 1. */
  oldDocumentSpaceEdge?: Maybe<OldDocumentSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OldDocumentSpace` mutation. */
export type CreateOldDocumentSpacePayloadOldDocumentSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<OldDocumentSpacesOrderBy>>;
};

/** All input for the create `Order` mutation. */
export type CreateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Order` to be created by this mutation. */
  order: OrderInput;
};

/** The output of our create `Order` mutation. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /** Reads a single `User` that is related to this `Order`. */
  admin?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Order` that was created by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Order`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `Order` mutation. */
export type CreateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the create `PageHeatmap` mutation. */
export type CreatePageHeatmapInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PageHeatmap` to be created by this mutation. */
  pageHeatmap: PageHeatmapInput;
};

/** The output of our create `PageHeatmap` mutation. */
export type CreatePageHeatmapPayload = {
  __typename?: 'CreatePageHeatmapPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PageHeatmap` that was created by this mutation. */
  pageHeatmap?: Maybe<PageHeatmap>;
  /** An edge for our `PageHeatmap`. May be used by Relay 1. */
  pageHeatmapEdge?: Maybe<PageHeatmapsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PageHeatmap` mutation. */
export type CreatePageHeatmapPayloadPageHeatmapEdgeArgs = {
  orderBy?: InputMaybe<Array<PageHeatmapsOrderBy>>;
};

/** All input for the create `RegistrationToken` mutation. */
export type CreateRegistrationTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RegistrationToken` to be created by this mutation. */
  registrationToken: RegistrationTokenInput;
};

/** The output of our create `RegistrationToken` mutation. */
export type CreateRegistrationTokenPayload = {
  __typename?: 'CreateRegistrationTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RegistrationToken` that was created by this mutation. */
  registrationToken?: Maybe<RegistrationToken>;
  /** An edge for our `RegistrationToken`. May be used by Relay 1. */
  registrationTokenEdge?: Maybe<RegistrationTokensEdge>;
  /** Reads a single `User` that is related to this `RegistrationToken`. */
  user?: Maybe<User>;
};


/** The output of our create `RegistrationToken` mutation. */
export type CreateRegistrationTokenPayloadRegistrationTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<RegistrationTokensOrderBy>>;
};

/** All input for the create `RetentionPolicy` mutation. */
export type CreateRetentionPolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RetentionPolicy` to be created by this mutation. */
  retentionPolicy: RetentionPolicyInput;
};

/** The output of our create `RetentionPolicy` mutation. */
export type CreateRetentionPolicyPayload = {
  __typename?: 'CreateRetentionPolicyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RetentionPolicy` that was created by this mutation. */
  retentionPolicy?: Maybe<RetentionPolicy>;
  /** An edge for our `RetentionPolicy`. May be used by Relay 1. */
  retentionPolicyEdge?: Maybe<RetentionPoliciesEdge>;
  /** Reads a single `Team` that is related to this `RetentionPolicy`. */
  team?: Maybe<Team>;
  /** Reads a single `Tenant` that is related to this `RetentionPolicy`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `Workspace` that is related to this `RetentionPolicy`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our create `RetentionPolicy` mutation. */
export type CreateRetentionPolicyPayloadRetentionPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};

/** All input for the create `SchemaMigration` mutation. */
export type CreateSchemaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SchemaMigration` to be created by this mutation. */
  schemaMigration: SchemaMigrationInput;
};

/** The output of our create `SchemaMigration` mutation. */
export type CreateSchemaMigrationPayload = {
  __typename?: 'CreateSchemaMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigration` that was created by this mutation. */
  schemaMigration?: Maybe<SchemaMigration>;
  /** An edge for our `SchemaMigration`. May be used by Relay 1. */
  schemaMigrationEdge?: Maybe<SchemaMigrationsEdge>;
};


/** The output of our create `SchemaMigration` mutation. */
export type CreateSchemaMigrationPayloadSchemaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};

/** All input for the create `SerializedWorkspace` mutation. */
export type CreateSerializedWorkspaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SerializedWorkspace` to be created by this mutation. */
  serializedWorkspace: SerializedWorkspaceInput;
};

/** The output of our create `SerializedWorkspace` mutation. */
export type CreateSerializedWorkspacePayload = {
  __typename?: 'CreateSerializedWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SerializedWorkspace` that was created by this mutation. */
  serializedWorkspace?: Maybe<SerializedWorkspace>;
  /** An edge for our `SerializedWorkspace`. May be used by Relay 1. */
  serializedWorkspaceEdge?: Maybe<SerializedWorkspacesEdge>;
};


/** The output of our create `SerializedWorkspace` mutation. */
export type CreateSerializedWorkspacePayloadSerializedWorkspaceEdgeArgs = {
  orderBy?: InputMaybe<Array<SerializedWorkspacesOrderBy>>;
};

/** All input for the create `Setting` mutation. */
export type CreateSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Setting` to be created by this mutation. */
  setting: SettingInput;
};

/** The output of our create `Setting` mutation. */
export type CreateSettingPayload = {
  __typename?: 'CreateSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Setting` that was created by this mutation. */
  setting?: Maybe<Setting>;
  /** An edge for our `Setting`. May be used by Relay 1. */
  settingEdge?: Maybe<SettingsEdge>;
};


/** The output of our create `Setting` mutation. */
export type CreateSettingPayloadSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<SettingsOrderBy>>;
};

/** All input for the create `Team` mutation. */
export type CreateTeamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Team` to be created by this mutation. */
  team: TeamInput;
};

/** The output of our create `Team` mutation. */
export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Team` that was created by this mutation. */
  team?: Maybe<Team>;
  /** An edge for our `Team`. May be used by Relay 1. */
  teamEdge?: Maybe<TeamsEdge>;
  /** Reads a single `Tenant` that is related to this `Team`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `Team` mutation. */
export type CreateTeamPayloadTeamEdgeArgs = {
  orderBy?: InputMaybe<Array<TeamsOrderBy>>;
};

/** All input for the create `TempContact` mutation. */
export type CreateTempContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TempContact` to be created by this mutation. */
  tempContact: TempContactInput;
};

/** The output of our create `TempContact` mutation. */
export type CreateTempContactPayload = {
  __typename?: 'CreateTempContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TempContact` that was created by this mutation. */
  tempContact?: Maybe<TempContact>;
  /** An edge for our `TempContact`. May be used by Relay 1. */
  tempContactEdge?: Maybe<TempContactsEdge>;
};


/** The output of our create `TempContact` mutation. */
export type CreateTempContactPayloadTempContactEdgeArgs = {
  orderBy?: InputMaybe<Array<TempContactsOrderBy>>;
};

/** All input for the create `Tenant` mutation. */
export type CreateTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Tenant` to be created by this mutation. */
  tenant: TenantInput;
};

/** The output of our create `Tenant` mutation. */
export type CreateTenantPayload = {
  __typename?: 'CreateTenantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was created by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
  /** Reads a single `Workspace` that is related to this `Tenant`. */
  tutorialWorkspace?: Maybe<Workspace>;
};


/** The output of our create `Tenant` mutation. */
export type CreateTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the create `UrlBasedDocumentImport` mutation. */
export type CreateUrlBasedDocumentImportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UrlBasedDocumentImport` to be created by this mutation. */
  urlBasedDocumentImport: UrlBasedDocumentImportInput;
};

/** The output of our create `UrlBasedDocumentImport` mutation. */
export type CreateUrlBasedDocumentImportPayload = {
  __typename?: 'CreateUrlBasedDocumentImportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImport`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UrlBasedDocumentImport` that was created by this mutation. */
  urlBasedDocumentImport?: Maybe<UrlBasedDocumentImport>;
  /** An edge for our `UrlBasedDocumentImport`. May be used by Relay 1. */
  urlBasedDocumentImportEdge?: Maybe<UrlBasedDocumentImportsEdge>;
};


/** The output of our create `UrlBasedDocumentImport` mutation. */
export type CreateUrlBasedDocumentImportPayloadUrlBasedDocumentImportEdgeArgs = {
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportsOrderBy>>;
};

/** All input for the create `UrlBasedDocumentImportSetting` mutation. */
export type CreateUrlBasedDocumentImportSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UrlBasedDocumentImportSetting` to be created by this mutation. */
  urlBasedDocumentImportSetting: UrlBasedDocumentImportSettingInput;
};

/** The output of our create `UrlBasedDocumentImportSetting` mutation. */
export type CreateUrlBasedDocumentImportSettingPayload = {
  __typename?: 'CreateUrlBasedDocumentImportSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImportSetting`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UrlBasedDocumentImportSetting`. */
  updatedBy?: Maybe<User>;
  /** The `UrlBasedDocumentImportSetting` that was created by this mutation. */
  urlBasedDocumentImportSetting?: Maybe<UrlBasedDocumentImportSetting>;
  /** An edge for our `UrlBasedDocumentImportSetting`. May be used by Relay 1. */
  urlBasedDocumentImportSettingEdge?: Maybe<UrlBasedDocumentImportSettingsEdge>;
};


/** The output of our create `UrlBasedDocumentImportSetting` mutation. */
export type CreateUrlBasedDocumentImportSettingPayloadUrlBasedDocumentImportSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportSettingsOrderBy>>;
};

/** All input for the create `UserContactDetail` mutation. */
export type CreateUserContactDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserContactDetail` to be created by this mutation. */
  userContactDetail: UserContactDetailInput;
};

/** The output of our create `UserContactDetail` mutation. */
export type CreateUserContactDetailPayload = {
  __typename?: 'CreateUserContactDetailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContactDetail`. */
  user?: Maybe<User>;
  /** The `UserContactDetail` that was created by this mutation. */
  userContactDetail?: Maybe<UserContactDetail>;
  /** An edge for our `UserContactDetail`. May be used by Relay 1. */
  userContactDetailEdge?: Maybe<UserContactDetailsEdge>;
};


/** The output of our create `UserContactDetail` mutation. */
export type CreateUserContactDetailPayloadUserContactDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContactDetailsOrderBy>>;
};

/** All input for the `createUserFromFirebase` mutation. */
export type CreateUserFromFirebaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `createUserFromFirebase` mutation. */
export type CreateUserFromFirebasePayload = {
  __typename?: 'CreateUserFromFirebasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<CreateUserFromFirebaseRecord>;
};

/** The return type of our `createUserFromFirebase` mutation. */
export type CreateUserFromFirebaseRecord = {
  __typename?: 'CreateUserFromFirebaseRecord';
  me?: Maybe<User>;
  mySubscription?: Maybe<WorkspaceSubscription>;
  myWorkspace?: Maybe<Workspace>;
};

/** All input for the create `UserLicense` mutation. */
export type CreateUserLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserLicense` to be created by this mutation. */
  userLicense: UserLicenseInput;
};

/** The output of our create `UserLicense` mutation. */
export type CreateUserLicensePayload = {
  __typename?: 'CreateUserLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `UserLicense`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Order` that is related to this `UserLicense`. */
  order?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserLicense`. */
  user?: Maybe<User>;
  /** The `UserLicense` that was created by this mutation. */
  userLicense?: Maybe<UserLicense>;
  /** An edge for our `UserLicense`. May be used by Relay 1. */
  userLicenseEdge?: Maybe<UserLicensesEdge>;
};


/** The output of our create `UserLicense` mutation. */
export type CreateUserLicensePayloadUserLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};

/** All input for the create `VeevaDocumentMetadatum` mutation. */
export type CreateVeevaDocumentMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VeevaDocumentMetadatum` to be created by this mutation. */
  veevaDocumentMetadatum: VeevaDocumentMetadatumInput;
};

/** The output of our create `VeevaDocumentMetadatum` mutation. */
export type CreateVeevaDocumentMetadatumPayload = {
  __typename?: 'CreateVeevaDocumentMetadatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `VeevaDocumentMetadatum`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VeevaDocumentMetadatum` that was created by this mutation. */
  veevaDocumentMetadatum?: Maybe<VeevaDocumentMetadatum>;
  /** An edge for our `VeevaDocumentMetadatum`. May be used by Relay 1. */
  veevaDocumentMetadatumEdge?: Maybe<VeevaDocumentMetadataEdge>;
};


/** The output of our create `VeevaDocumentMetadatum` mutation. */
export type CreateVeevaDocumentMetadatumPayloadVeevaDocumentMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<VeevaDocumentMetadataOrderBy>>;
};

/** All input for the `createWorkspaceAndJoin` mutation. */
export type CreateWorkspaceAndJoinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `createWorkspaceAndJoin` mutation. */
export type CreateWorkspaceAndJoinPayload = {
  __typename?: 'CreateWorkspaceAndJoinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<CreateWorkspaceAndJoinRecord>;
};

/** The return type of our `createWorkspaceAndJoin` mutation. */
export type CreateWorkspaceAndJoinRecord = {
  __typename?: 'CreateWorkspaceAndJoinRecord';
  createdWorkspace?: Maybe<Workspace>;
  mySubscription?: Maybe<WorkspaceSubscription>;
};

/** All input for the create `Workspace` mutation. */
export type CreateWorkspaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Workspace` to be created by this mutation. */
  workspace: WorkspaceInput;
};

/** The output of our create `Workspace` mutation. */
export type CreateWorkspacePayload = {
  __typename?: 'CreateWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `Workspace`. */
  defaultLegalAppendix?: Maybe<Document>;
  /** Reads a single `Workspace` that is related to this `Workspace`. */
  parent?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `Workspace`. */
  personalWorkspaceOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Workspace`. */
  tenant?: Maybe<Tenant>;
  /** The `Workspace` that was created by this mutation. */
  workspace?: Maybe<Workspace>;
  /** An edge for our `Workspace`. May be used by Relay 1. */
  workspaceEdge?: Maybe<WorkspacesEdge>;
};


/** The output of our create `Workspace` mutation. */
export type CreateWorkspacePayloadWorkspaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

/** All input for the create `WorkspaceSubscription` mutation. */
export type CreateWorkspaceSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `WorkspaceSubscription` to be created by this mutation. */
  workspaceSubscription: WorkspaceSubscriptionInput;
};

/** The output of our create `WorkspaceSubscription` mutation. */
export type CreateWorkspaceSubscriptionPayload = {
  __typename?: 'CreateWorkspaceSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  /** The `WorkspaceSubscription` that was created by this mutation. */
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** An edge for our `WorkspaceSubscription`. May be used by Relay 1. */
  workspaceSubscriptionEdge?: Maybe<WorkspaceSubscriptionsEdge>;
};


/** The output of our create `WorkspaceSubscription` mutation. */
export type CreateWorkspaceSubscriptionPayloadWorkspaceSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

export type CrmContact = Node & {
  __typename?: 'CrmContact';
  active: Scalars['Boolean']['output'];
  alxnConsentStatus?: Maybe<Scalars['String']['output']>;
  alxnPrimaryParent?: Maybe<Scalars['String']['output']>;
  alxnProducts?: Maybe<Scalars['JSON']['output']>;
  alxnRole?: Maybe<Scalars['String']['output']>;
  alxnSpeciality?: Maybe<Scalars['String']['output']>;
  alxnTerritories?: Maybe<Scalars['JSON']['output']>;
  /** Users who hold one of the accepted roles on a document space mapped to this CRM contact (filtered by if_any: invited/visited). */
  authorsOfDocumentSpaces: UsersConnection;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `CrmContactConsent`. */
  crmContactConsentsByCrmId: CrmContactConsentsConnection;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContact`. */
  crmContactMatchById?: Maybe<CrmContactMatch>;
  /**
   * Reads and enables pagination through a set of `CrmContactMatch`.
   * @deprecated Please use crmContactMatchById instead
   */
  crmContactMatchesById: CrmContactMatchesConnection;
  /** Reads and enables pagination through a set of `CrmContactPhaseMapping`. */
  crmContactPhaseMappingsByContactId: CrmContactPhaseMappingsConnection;
  crmId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceCrmMapping`. */
  documentSpaceCrmMappings: DocumentSpaceCrmMappingsConnection;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasSpaceInvitations: Scalars['Boolean']['output'];
  hasSpaceVisits: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `LabelsOfDocumentView`. */
  labelsOfDocumentViews: LabelsOfDocumentViewsConnection;
  languagePref?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  localCrmId?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Tenant` that is related to this `CrmContact`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  territory?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type CrmContactAuthorsOfDocumentSpacesArgs = {
  acceptedRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ifAny?: InputMaybe<Array<InputMaybe<SpaceCondition>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type CrmContactCrmContactConsentsByCrmIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactConsentCondition>;
  filter?: InputMaybe<CrmContactConsentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};


export type CrmContactCrmContactMatchesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactMatchCondition>;
  filter?: InputMaybe<CrmContactMatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactMatchesOrderBy>>;
};


export type CrmContactCrmContactPhaseMappingsByContactIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactPhaseMappingCondition>;
  filter?: InputMaybe<CrmContactPhaseMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};


export type CrmContactDocumentSpaceCrmMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCrmMappingCondition>;
  filter?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};


export type CrmContactLabelsOfDocumentViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LabelsOfDocumentViewCondition>;
  filter?: InputMaybe<LabelsOfDocumentViewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};

/**
 * A condition to be used against `CrmContact` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CrmContactCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `alxnConsentStatus` field. */
  alxnConsentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnPrimaryParent` field. */
  alxnPrimaryParent?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnProducts` field. */
  alxnProducts?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `alxnRole` field. */
  alxnRole?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnSpeciality` field. */
  alxnSpeciality?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnTerritories` field. */
  alxnTerritories?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crmId` field. */
  crmId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hasSpaceInvitations` field. */
  hasSpaceInvitations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `hasSpaceVisits` field. */
  hasSpaceVisits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `languagePref` field. */
  languagePref?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `localCrmId` field. */
  localCrmId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mobile` field. */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `territory` field. */
  territory?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CrmContactConsent = Node & {
  __typename?: 'CrmContactConsent';
  consentFileStorageId?: Maybe<Scalars['String']['output']>;
  consentType: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `CrmContactConsent`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `CrmContact` that is related to this `CrmContactConsent`. */
  crm?: Maybe<CrmContact>;
  crmId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactConsent`. */
  matchId?: Maybe<CrmContactMatch>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `CrmContactConsent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CrmContactConsentCondition = {
  /** Checks for equality with the object’s `consentFileStorageId` field. */
  consentFileStorageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `consentType` field. */
  consentType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `crmId` field. */
  crmId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `payload` field. */
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `CrmContactConsent` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactConsentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CrmContactConsentFilter>>;
  /** Filter by the object’s `consentFileStorageId` field. */
  consentFileStorageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `consentType` field. */
  consentType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` relation. */
  createdBy?: InputMaybe<UserFilter>;
  /** A related `createdBy` exists. */
  createdByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `crm` relation. */
  crm?: InputMaybe<CrmContactFilter>;
  /** Filter by the object’s `crmId` field. */
  crmId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `matchId` relation. */
  matchId?: InputMaybe<CrmContactMatchFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CrmContactConsentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CrmContactConsentFilter>>;
  /** Filter by the object’s `payload` field. */
  payload?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `CrmContactConsent` */
export type CrmContactConsentInput = {
  consentFileStorageId?: InputMaybe<Scalars['String']['input']>;
  consentType: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdById?: InputMaybe<Scalars['BigInt']['input']>;
  crmId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `CrmContactConsent`. Fields that are set will be updated. */
export type CrmContactConsentPatch = {
  consentFileStorageId?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdById?: InputMaybe<Scalars['BigInt']['input']>;
  crmId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `CrmContactConsent` values. */
export type CrmContactConsentsConnection = {
  __typename?: 'CrmContactConsentsConnection';
  /** A list of edges which contains the `CrmContactConsent` and cursor to aid in pagination. */
  edges: Array<CrmContactConsentsEdge>;
  /** A list of `CrmContactConsent` objects. */
  nodes: Array<Maybe<CrmContactConsent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CrmContactConsent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CrmContactConsent` edge in the connection. */
export type CrmContactConsentsEdge = {
  __typename?: 'CrmContactConsentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CrmContactConsent` at the end of the edge. */
  node?: Maybe<CrmContactConsent>;
};

/** Methods to use when ordering `CrmContactConsent`. */
export enum CrmContactConsentsOrderBy {
  ConsentFileStorageIdAsc = 'CONSENT_FILE_STORAGE_ID_ASC',
  ConsentFileStorageIdDesc = 'CONSENT_FILE_STORAGE_ID_DESC',
  ConsentTypeAsc = 'CONSENT_TYPE_ASC',
  ConsentTypeDesc = 'CONSENT_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  CrmContactByCrmIdActiveAsc = 'CRM_CONTACT_BY_CRM_ID__ACTIVE_ASC',
  CrmContactByCrmIdActiveDesc = 'CRM_CONTACT_BY_CRM_ID__ACTIVE_DESC',
  CrmContactByCrmIdAlxnConsentStatusAsc = 'CRM_CONTACT_BY_CRM_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactByCrmIdAlxnConsentStatusDesc = 'CRM_CONTACT_BY_CRM_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactByCrmIdAlxnPrimaryParentAsc = 'CRM_CONTACT_BY_CRM_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactByCrmIdAlxnPrimaryParentDesc = 'CRM_CONTACT_BY_CRM_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactByCrmIdAlxnProductsAsc = 'CRM_CONTACT_BY_CRM_ID__ALXN_PRODUCTS_ASC',
  CrmContactByCrmIdAlxnProductsDesc = 'CRM_CONTACT_BY_CRM_ID__ALXN_PRODUCTS_DESC',
  CrmContactByCrmIdAlxnRoleAsc = 'CRM_CONTACT_BY_CRM_ID__ALXN_ROLE_ASC',
  CrmContactByCrmIdAlxnRoleDesc = 'CRM_CONTACT_BY_CRM_ID__ALXN_ROLE_DESC',
  CrmContactByCrmIdAlxnSpecialityAsc = 'CRM_CONTACT_BY_CRM_ID__ALXN_SPECIALITY_ASC',
  CrmContactByCrmIdAlxnSpecialityDesc = 'CRM_CONTACT_BY_CRM_ID__ALXN_SPECIALITY_DESC',
  CrmContactByCrmIdAlxnTerritoriesAsc = 'CRM_CONTACT_BY_CRM_ID__ALXN_TERRITORIES_ASC',
  CrmContactByCrmIdAlxnTerritoriesDesc = 'CRM_CONTACT_BY_CRM_ID__ALXN_TERRITORIES_DESC',
  CrmContactByCrmIdCityAsc = 'CRM_CONTACT_BY_CRM_ID__CITY_ASC',
  CrmContactByCrmIdCityDesc = 'CRM_CONTACT_BY_CRM_ID__CITY_DESC',
  CrmContactByCrmIdCountryAsc = 'CRM_CONTACT_BY_CRM_ID__COUNTRY_ASC',
  CrmContactByCrmIdCountryDesc = 'CRM_CONTACT_BY_CRM_ID__COUNTRY_DESC',
  CrmContactByCrmIdCreatedAtAsc = 'CRM_CONTACT_BY_CRM_ID__CREATED_AT_ASC',
  CrmContactByCrmIdCreatedAtDesc = 'CRM_CONTACT_BY_CRM_ID__CREATED_AT_DESC',
  CrmContactByCrmIdCrmIdAsc = 'CRM_CONTACT_BY_CRM_ID__CRM_ID_ASC',
  CrmContactByCrmIdCrmIdDesc = 'CRM_CONTACT_BY_CRM_ID__CRM_ID_DESC',
  CrmContactByCrmIdEmailAsc = 'CRM_CONTACT_BY_CRM_ID__EMAIL_ASC',
  CrmContactByCrmIdEmailDesc = 'CRM_CONTACT_BY_CRM_ID__EMAIL_DESC',
  CrmContactByCrmIdFirstNameAsc = 'CRM_CONTACT_BY_CRM_ID__FIRST_NAME_ASC',
  CrmContactByCrmIdFirstNameDesc = 'CRM_CONTACT_BY_CRM_ID__FIRST_NAME_DESC',
  CrmContactByCrmIdFullNameAsc = 'CRM_CONTACT_BY_CRM_ID__FULL_NAME_ASC',
  CrmContactByCrmIdFullNameDesc = 'CRM_CONTACT_BY_CRM_ID__FULL_NAME_DESC',
  CrmContactByCrmIdIdAsc = 'CRM_CONTACT_BY_CRM_ID__ID_ASC',
  CrmContactByCrmIdIdDesc = 'CRM_CONTACT_BY_CRM_ID__ID_DESC',
  CrmContactByCrmIdLanguagePrefAsc = 'CRM_CONTACT_BY_CRM_ID__LANGUAGE_PREF_ASC',
  CrmContactByCrmIdLanguagePrefDesc = 'CRM_CONTACT_BY_CRM_ID__LANGUAGE_PREF_DESC',
  CrmContactByCrmIdLastNameAsc = 'CRM_CONTACT_BY_CRM_ID__LAST_NAME_ASC',
  CrmContactByCrmIdLastNameDesc = 'CRM_CONTACT_BY_CRM_ID__LAST_NAME_DESC',
  CrmContactByCrmIdLocalCrmIdAsc = 'CRM_CONTACT_BY_CRM_ID__LOCAL_CRM_ID_ASC',
  CrmContactByCrmIdLocalCrmIdDesc = 'CRM_CONTACT_BY_CRM_ID__LOCAL_CRM_ID_DESC',
  CrmContactByCrmIdMobileAsc = 'CRM_CONTACT_BY_CRM_ID__MOBILE_ASC',
  CrmContactByCrmIdMobileDesc = 'CRM_CONTACT_BY_CRM_ID__MOBILE_DESC',
  CrmContactByCrmIdOrganizationAsc = 'CRM_CONTACT_BY_CRM_ID__ORGANIZATION_ASC',
  CrmContactByCrmIdOrganizationDesc = 'CRM_CONTACT_BY_CRM_ID__ORGANIZATION_DESC',
  CrmContactByCrmIdRegionAsc = 'CRM_CONTACT_BY_CRM_ID__REGION_ASC',
  CrmContactByCrmIdRegionDesc = 'CRM_CONTACT_BY_CRM_ID__REGION_DESC',
  CrmContactByCrmIdTenantIdAsc = 'CRM_CONTACT_BY_CRM_ID__TENANT_ID_ASC',
  CrmContactByCrmIdTenantIdDesc = 'CRM_CONTACT_BY_CRM_ID__TENANT_ID_DESC',
  CrmContactByCrmIdTerritoryAsc = 'CRM_CONTACT_BY_CRM_ID__TERRITORY_ASC',
  CrmContactByCrmIdTerritoryDesc = 'CRM_CONTACT_BY_CRM_ID__TERRITORY_DESC',
  CrmContactByCrmIdUpdatedAtAsc = 'CRM_CONTACT_BY_CRM_ID__UPDATED_AT_ASC',
  CrmContactByCrmIdUpdatedAtDesc = 'CRM_CONTACT_BY_CRM_ID__UPDATED_AT_DESC',
  CrmContactByCrmIdZipCodeAsc = 'CRM_CONTACT_BY_CRM_ID__ZIP_CODE_ASC',
  CrmContactByCrmIdZipCodeDesc = 'CRM_CONTACT_BY_CRM_ID__ZIP_CODE_DESC',
  CrmContactMatchByCrmIdActiveAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ACTIVE_ASC',
  CrmContactMatchByCrmIdActiveDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ACTIVE_DESC',
  CrmContactMatchByCrmIdAlxnConsentStatusAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchByCrmIdAlxnConsentStatusDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchByCrmIdAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchByCrmIdAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchByCrmIdAlxnProductsAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_PRODUCTS_ASC',
  CrmContactMatchByCrmIdAlxnProductsDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_PRODUCTS_DESC',
  CrmContactMatchByCrmIdAlxnRoleAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_ROLE_ASC',
  CrmContactMatchByCrmIdAlxnRoleDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_ROLE_DESC',
  CrmContactMatchByCrmIdAlxnSpecialityAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_SPECIALITY_ASC',
  CrmContactMatchByCrmIdAlxnSpecialityDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_SPECIALITY_DESC',
  CrmContactMatchByCrmIdAlxnTerritoriesAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_TERRITORIES_ASC',
  CrmContactMatchByCrmIdAlxnTerritoriesDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ALXN_TERRITORIES_DESC',
  CrmContactMatchByCrmIdCityAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__CITY_ASC',
  CrmContactMatchByCrmIdCityDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__CITY_DESC',
  CrmContactMatchByCrmIdCountryAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__COUNTRY_ASC',
  CrmContactMatchByCrmIdCountryDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__COUNTRY_DESC',
  CrmContactMatchByCrmIdCreatedAtAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__CREATED_AT_ASC',
  CrmContactMatchByCrmIdCreatedAtDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__CREATED_AT_DESC',
  CrmContactMatchByCrmIdCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__CRM_ID_ASC',
  CrmContactMatchByCrmIdCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__CRM_ID_DESC',
  CrmContactMatchByCrmIdEmailAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__EMAIL_ASC',
  CrmContactMatchByCrmIdEmailDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__EMAIL_DESC',
  CrmContactMatchByCrmIdFirstNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FIRST_NAME_ASC',
  CrmContactMatchByCrmIdFirstNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FIRST_NAME_DESC',
  CrmContactMatchByCrmIdFulltextRankAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FULLTEXT_RANK_ASC',
  CrmContactMatchByCrmIdFulltextRankDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FULLTEXT_RANK_DESC',
  CrmContactMatchByCrmIdFulltextSearchColumnAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchByCrmIdFulltextSearchColumnDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchByCrmIdFullNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FULL_NAME_ASC',
  CrmContactMatchByCrmIdFullNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__FULL_NAME_DESC',
  CrmContactMatchByCrmIdIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ID_ASC',
  CrmContactMatchByCrmIdIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ID_DESC',
  CrmContactMatchByCrmIdLanguagePrefAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__LANGUAGE_PREF_ASC',
  CrmContactMatchByCrmIdLanguagePrefDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__LANGUAGE_PREF_DESC',
  CrmContactMatchByCrmIdLastNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__LAST_NAME_ASC',
  CrmContactMatchByCrmIdLastNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__LAST_NAME_DESC',
  CrmContactMatchByCrmIdLocalCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__LOCAL_CRM_ID_ASC',
  CrmContactMatchByCrmIdLocalCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__LOCAL_CRM_ID_DESC',
  CrmContactMatchByCrmIdMobileAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__MOBILE_ASC',
  CrmContactMatchByCrmIdMobileDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__MOBILE_DESC',
  CrmContactMatchByCrmIdOrganizationAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ORGANIZATION_ASC',
  CrmContactMatchByCrmIdOrganizationDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ORGANIZATION_DESC',
  CrmContactMatchByCrmIdRegionAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__REGION_ASC',
  CrmContactMatchByCrmIdRegionDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__REGION_DESC',
  CrmContactMatchByCrmIdSimilarityAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__SIMILARITY_ASC',
  CrmContactMatchByCrmIdSimilarityDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__SIMILARITY_DESC',
  CrmContactMatchByCrmIdTenantIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__TENANT_ID_ASC',
  CrmContactMatchByCrmIdTenantIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__TENANT_ID_DESC',
  CrmContactMatchByCrmIdTerritoryAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__TERRITORY_ASC',
  CrmContactMatchByCrmIdTerritoryDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__TERRITORY_DESC',
  CrmContactMatchByCrmIdUpdatedAtAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__UPDATED_AT_ASC',
  CrmContactMatchByCrmIdUpdatedAtDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__UPDATED_AT_DESC',
  CrmContactMatchByCrmIdZipCodeAsc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ZIP_CODE_ASC',
  CrmContactMatchByCrmIdZipCodeDesc = 'CRM_CONTACT_MATCH_BY_CRM_ID__ZIP_CODE_DESC',
  CrmIdAsc = 'CRM_ID_ASC',
  CrmIdDesc = 'CRM_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PayloadAsc = 'PAYLOAD_ASC',
  PayloadDesc = 'PAYLOAD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserByCreatedByIdAppConsentGivenAtAsc = 'USER_BY_CREATED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByCreatedByIdAppConsentGivenAtDesc = 'USER_BY_CREATED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByCreatedByIdConfigAsc = 'USER_BY_CREATED_BY_ID__CONFIG_ASC',
  UserByCreatedByIdConfigDesc = 'USER_BY_CREATED_BY_ID__CONFIG_DESC',
  UserByCreatedByIdCreatedAtAsc = 'USER_BY_CREATED_BY_ID__CREATED_AT_ASC',
  UserByCreatedByIdCreatedAtDesc = 'USER_BY_CREATED_BY_ID__CREATED_AT_DESC',
  UserByCreatedByIdCrmContactVisibilityFilterAsc = 'USER_BY_CREATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByCreatedByIdCrmContactVisibilityFilterDesc = 'USER_BY_CREATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByCreatedByIdDefaultWorkspaceIdAsc = 'USER_BY_CREATED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByCreatedByIdDefaultWorkspaceIdDesc = 'USER_BY_CREATED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByCreatedByIdDisabledAsc = 'USER_BY_CREATED_BY_ID__DISABLED_ASC',
  UserByCreatedByIdDisabledDesc = 'USER_BY_CREATED_BY_ID__DISABLED_DESC',
  UserByCreatedByIdDisplayNameAsc = 'USER_BY_CREATED_BY_ID__DISPLAY_NAME_ASC',
  UserByCreatedByIdDisplayNameDesc = 'USER_BY_CREATED_BY_ID__DISPLAY_NAME_DESC',
  UserByCreatedByIdEmailAsc = 'USER_BY_CREATED_BY_ID__EMAIL_ASC',
  UserByCreatedByIdEmailDesc = 'USER_BY_CREATED_BY_ID__EMAIL_DESC',
  UserByCreatedByIdExternalGroupsAsc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByCreatedByIdExternalGroupsDesc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByCreatedByIdExternalGroupsSyncedAtAsc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByCreatedByIdExternalGroupsSyncedAtDesc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByCreatedByIdFirebaseAuthIdAsc = 'USER_BY_CREATED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByCreatedByIdFirebaseAuthIdDesc = 'USER_BY_CREATED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByCreatedByIdFlagsAsc = 'USER_BY_CREATED_BY_ID__FLAGS_ASC',
  UserByCreatedByIdFlagsDesc = 'USER_BY_CREATED_BY_ID__FLAGS_DESC',
  UserByCreatedByIdIdAsc = 'USER_BY_CREATED_BY_ID__ID_ASC',
  UserByCreatedByIdIdDesc = 'USER_BY_CREATED_BY_ID__ID_DESC',
  UserByCreatedByIdIsTenantAdminAsc = 'USER_BY_CREATED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByCreatedByIdIsTenantAdminDesc = 'USER_BY_CREATED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByCreatedByIdRegisteredAtAsc = 'USER_BY_CREATED_BY_ID__REGISTERED_AT_ASC',
  UserByCreatedByIdRegisteredAtDesc = 'USER_BY_CREATED_BY_ID__REGISTERED_AT_DESC',
  UserByCreatedByIdSysPeriodAsc = 'USER_BY_CREATED_BY_ID__SYS_PERIOD_ASC',
  UserByCreatedByIdSysPeriodDesc = 'USER_BY_CREATED_BY_ID__SYS_PERIOD_DESC',
  UserByCreatedByIdTenantIdAsc = 'USER_BY_CREATED_BY_ID__TENANT_ID_ASC',
  UserByCreatedByIdTenantIdDesc = 'USER_BY_CREATED_BY_ID__TENANT_ID_DESC',
  UserByCreatedByIdUpdatedAtAsc = 'USER_BY_CREATED_BY_ID__UPDATED_AT_ASC',
  UserByCreatedByIdUpdatedAtDesc = 'USER_BY_CREATED_BY_ID__UPDATED_AT_DESC'
}

/** A filter to be used against `CrmContact` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `alxnConsentStatus` field. */
  alxnConsentStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnPrimaryParent` field. */
  alxnPrimaryParent?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnProducts` field. */
  alxnProducts?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `alxnRole` field. */
  alxnRole?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnSpeciality` field. */
  alxnSpeciality?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnTerritories` field. */
  alxnTerritories?: InputMaybe<JsonFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CrmContactFilter>>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContactConsentsByCrmId` relation. */
  crmContactConsentsByCrmId?: InputMaybe<CrmContactToManyCrmContactConsentFilter>;
  /** Some related `crmContactConsentsByCrmId` exist. */
  crmContactConsentsByCrmIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmContactMatchById` relation. */
  crmContactMatchById?: InputMaybe<CrmContactMatchFilter>;
  /** A related `crmContactMatchById` exists. */
  crmContactMatchByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmContactPhaseMappingsByContactId` relation. */
  crmContactPhaseMappingsByContactId?: InputMaybe<CrmContactToManyCrmContactPhaseMappingFilter>;
  /** Some related `crmContactPhaseMappingsByContactId` exist. */
  crmContactPhaseMappingsByContactIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmId` field. */
  crmId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentSpaceCrmMappings` relation. */
  documentSpaceCrmMappings?: InputMaybe<CrmContactToManyDocumentSpaceCrmMappingFilter>;
  /** Some related `documentSpaceCrmMappings` exist. */
  documentSpaceCrmMappingsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hasSpaceInvitations` field. */
  hasSpaceInvitations?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasSpaceVisits` field. */
  hasSpaceVisits?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `labelsOfDocumentViews` relation. */
  labelsOfDocumentViews?: InputMaybe<CrmContactToManyLabelsOfDocumentViewFilter>;
  /** Some related `labelsOfDocumentViews` exist. */
  labelsOfDocumentViewsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `languagePref` field. */
  languagePref?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localCrmId` field. */
  localCrmId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mobile` field. */
  mobile?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CrmContactFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CrmContactFilter>>;
  /** Filter by the object’s `organization` field. */
  organization?: InputMaybe<StringFilter>;
  /** Filter by the object’s `region` field. */
  region?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `territory` field. */
  territory?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CrmContact` */
export type CrmContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alxnConsentStatus?: InputMaybe<Scalars['String']['input']>;
  alxnPrimaryParent?: InputMaybe<Scalars['String']['input']>;
  alxnProducts?: InputMaybe<Scalars['JSON']['input']>;
  alxnRole?: InputMaybe<Scalars['String']['input']>;
  alxnSpeciality?: InputMaybe<Scalars['String']['input']>;
  alxnTerritories?: InputMaybe<Scalars['JSON']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  languagePref?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  localCrmId?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['BigInt']['input'];
  territory?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CrmContactMatch = Node & {
  __typename?: 'CrmContactMatch';
  active: Scalars['Boolean']['output'];
  alxnConsentStatus?: Maybe<Scalars['String']['output']>;
  alxnPrimaryParent?: Maybe<Scalars['String']['output']>;
  alxnProducts?: Maybe<Scalars['JSON']['output']>;
  alxnRole?: Maybe<Scalars['String']['output']>;
  alxnSpeciality?: Maybe<Scalars['String']['output']>;
  alxnTerritories?: Maybe<Scalars['JSON']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `CrmContact` that is related to this `CrmContactMatch`. */
  crmContactById?: Maybe<CrmContact>;
  /** Reads and enables pagination through a set of `CrmContactConsent`. */
  crmContactConsentsByCrmId: CrmContactConsentsConnection;
  /** Reads and enables pagination through a set of `CrmContactPhaseMapping`. */
  crmContactPhaseMappingsByContactId: CrmContactPhaseMappingsConnection;
  crmId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceCrmMapping`. */
  documentSpaceCrmMappings: DocumentSpaceCrmMappingsConnection;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fulltextRank?: Maybe<Scalars['Float']['output']>;
  fulltextSearchColumn?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `LabelsOfDocumentView`. */
  labelsOfDocumentViewsByCrmContactId: LabelsOfDocumentViewsConnection;
  languagePref?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  localCrmId?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
  /** Reads a single `Tenant` that is related to this `CrmContactMatch`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  territory?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type CrmContactMatchCrmContactConsentsByCrmIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactConsentCondition>;
  filter?: InputMaybe<CrmContactConsentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};


export type CrmContactMatchCrmContactPhaseMappingsByContactIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactPhaseMappingCondition>;
  filter?: InputMaybe<CrmContactPhaseMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};


export type CrmContactMatchDocumentSpaceCrmMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCrmMappingCondition>;
  filter?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};


export type CrmContactMatchLabelsOfDocumentViewsByCrmContactIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LabelsOfDocumentViewCondition>;
  filter?: InputMaybe<LabelsOfDocumentViewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};

/**
 * A condition to be used against `CrmContactMatch` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CrmContactMatchCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `alxnConsentStatus` field. */
  alxnConsentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnPrimaryParent` field. */
  alxnPrimaryParent?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnProducts` field. */
  alxnProducts?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `alxnRole` field. */
  alxnRole?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnSpeciality` field. */
  alxnSpeciality?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alxnTerritories` field. */
  alxnTerritories?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crmId` field. */
  crmId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fulltextRank` field. */
  fulltextRank?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `fulltextSearchColumn` field. */
  fulltextSearchColumn?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `languagePref` field. */
  languagePref?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `localCrmId` field. */
  localCrmId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mobile` field. */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `similarity` field. */
  similarity?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `territory` field. */
  territory?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CrmContactMatch` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactMatchFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `alxnConsentStatus` field. */
  alxnConsentStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnPrimaryParent` field. */
  alxnPrimaryParent?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnProducts` field. */
  alxnProducts?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `alxnRole` field. */
  alxnRole?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnSpeciality` field. */
  alxnSpeciality?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alxnTerritories` field. */
  alxnTerritories?: InputMaybe<JsonFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CrmContactMatchFilter>>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContactById` relation. */
  crmContactById?: InputMaybe<CrmContactFilter>;
  /** Filter by the object’s `crmContactConsentsByCrmId` relation. */
  crmContactConsentsByCrmId?: InputMaybe<CrmContactMatchToManyCrmContactConsentFilter>;
  /** Some related `crmContactConsentsByCrmId` exist. */
  crmContactConsentsByCrmIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmContactPhaseMappingsByContactId` relation. */
  crmContactPhaseMappingsByContactId?: InputMaybe<CrmContactMatchToManyCrmContactPhaseMappingFilter>;
  /** Some related `crmContactPhaseMappingsByContactId` exist. */
  crmContactPhaseMappingsByContactIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmId` field. */
  crmId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentSpaceCrmMappings` relation. */
  documentSpaceCrmMappings?: InputMaybe<CrmContactMatchToManyDocumentSpaceCrmMappingFilter>;
  /** Some related `documentSpaceCrmMappings` exist. */
  documentSpaceCrmMappingsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fulltextRank` field. */
  fulltextRank?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `labelsOfDocumentViewsByCrmContactId` relation. */
  labelsOfDocumentViewsByCrmContactId?: InputMaybe<CrmContactMatchToManyLabelsOfDocumentViewFilter>;
  /** Some related `labelsOfDocumentViewsByCrmContactId` exist. */
  labelsOfDocumentViewsByCrmContactIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `languagePref` field. */
  languagePref?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localCrmId` field. */
  localCrmId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mobile` field. */
  mobile?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CrmContactMatchFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CrmContactMatchFilter>>;
  /** Filter by the object’s `organization` field. */
  organization?: InputMaybe<StringFilter>;
  /** Filter by the object’s `region` field. */
  region?: InputMaybe<StringFilter>;
  /** Filter by the object’s `similarity` field. */
  similarity?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `territory` field. */
  territory?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `CrmContactConsent` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactMatchToManyCrmContactConsentFilter = {
  /** Every related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactConsentFilter>;
  /** No related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactConsentFilter>;
  /** Some related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactConsentFilter>;
};

/** A filter to be used against many `CrmContactPhaseMapping` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactMatchToManyCrmContactPhaseMappingFilter = {
  /** Every related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** No related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** Some related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactPhaseMappingFilter>;
};

/** A filter to be used against many `DocumentSpaceCrmMapping` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactMatchToManyDocumentSpaceCrmMappingFilter = {
  /** Every related `DocumentSpaceCrmMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  /** No related `DocumentSpaceCrmMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  /** Some related `DocumentSpaceCrmMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceCrmMappingFilter>;
};

/** A filter to be used against many `LabelsOfDocumentView` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactMatchToManyLabelsOfDocumentViewFilter = {
  /** Every related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** No related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** Some related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LabelsOfDocumentViewFilter>;
};

/** A connection to a list of `CrmContactMatch` values. */
export type CrmContactMatchesConnection = {
  __typename?: 'CrmContactMatchesConnection';
  /** A list of edges which contains the `CrmContactMatch` and cursor to aid in pagination. */
  edges: Array<CrmContactMatchesEdge>;
  /** A list of `CrmContactMatch` objects. */
  nodes: Array<Maybe<CrmContactMatch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CrmContactMatch` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CrmContactMatch` edge in the connection. */
export type CrmContactMatchesEdge = {
  __typename?: 'CrmContactMatchesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CrmContactMatch` at the end of the edge. */
  node?: Maybe<CrmContactMatch>;
};

/** Methods to use when ordering `CrmContactMatch`. */
export enum CrmContactMatchesOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AlxnConsentStatusAsc = 'ALXN_CONSENT_STATUS_ASC',
  AlxnConsentStatusDesc = 'ALXN_CONSENT_STATUS_DESC',
  AlxnPrimaryParentAsc = 'ALXN_PRIMARY_PARENT_ASC',
  AlxnPrimaryParentDesc = 'ALXN_PRIMARY_PARENT_DESC',
  AlxnProductsAsc = 'ALXN_PRODUCTS_ASC',
  AlxnProductsDesc = 'ALXN_PRODUCTS_DESC',
  AlxnRoleAsc = 'ALXN_ROLE_ASC',
  AlxnRoleDesc = 'ALXN_ROLE_DESC',
  AlxnSpecialityAsc = 'ALXN_SPECIALITY_ASC',
  AlxnSpecialityDesc = 'ALXN_SPECIALITY_DESC',
  AlxnTerritoriesAsc = 'ALXN_TERRITORIES_ASC',
  AlxnTerritoriesDesc = 'ALXN_TERRITORIES_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactByIdActiveAsc = 'CRM_CONTACT_BY_ID__ACTIVE_ASC',
  CrmContactByIdActiveDesc = 'CRM_CONTACT_BY_ID__ACTIVE_DESC',
  CrmContactByIdAlxnConsentStatusAsc = 'CRM_CONTACT_BY_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactByIdAlxnConsentStatusDesc = 'CRM_CONTACT_BY_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactByIdAlxnPrimaryParentAsc = 'CRM_CONTACT_BY_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactByIdAlxnPrimaryParentDesc = 'CRM_CONTACT_BY_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactByIdAlxnProductsAsc = 'CRM_CONTACT_BY_ID__ALXN_PRODUCTS_ASC',
  CrmContactByIdAlxnProductsDesc = 'CRM_CONTACT_BY_ID__ALXN_PRODUCTS_DESC',
  CrmContactByIdAlxnRoleAsc = 'CRM_CONTACT_BY_ID__ALXN_ROLE_ASC',
  CrmContactByIdAlxnRoleDesc = 'CRM_CONTACT_BY_ID__ALXN_ROLE_DESC',
  CrmContactByIdAlxnSpecialityAsc = 'CRM_CONTACT_BY_ID__ALXN_SPECIALITY_ASC',
  CrmContactByIdAlxnSpecialityDesc = 'CRM_CONTACT_BY_ID__ALXN_SPECIALITY_DESC',
  CrmContactByIdAlxnTerritoriesAsc = 'CRM_CONTACT_BY_ID__ALXN_TERRITORIES_ASC',
  CrmContactByIdAlxnTerritoriesDesc = 'CRM_CONTACT_BY_ID__ALXN_TERRITORIES_DESC',
  CrmContactByIdCityAsc = 'CRM_CONTACT_BY_ID__CITY_ASC',
  CrmContactByIdCityDesc = 'CRM_CONTACT_BY_ID__CITY_DESC',
  CrmContactByIdCountryAsc = 'CRM_CONTACT_BY_ID__COUNTRY_ASC',
  CrmContactByIdCountryDesc = 'CRM_CONTACT_BY_ID__COUNTRY_DESC',
  CrmContactByIdCreatedAtAsc = 'CRM_CONTACT_BY_ID__CREATED_AT_ASC',
  CrmContactByIdCreatedAtDesc = 'CRM_CONTACT_BY_ID__CREATED_AT_DESC',
  CrmContactByIdCrmIdAsc = 'CRM_CONTACT_BY_ID__CRM_ID_ASC',
  CrmContactByIdCrmIdDesc = 'CRM_CONTACT_BY_ID__CRM_ID_DESC',
  CrmContactByIdEmailAsc = 'CRM_CONTACT_BY_ID__EMAIL_ASC',
  CrmContactByIdEmailDesc = 'CRM_CONTACT_BY_ID__EMAIL_DESC',
  CrmContactByIdFirstNameAsc = 'CRM_CONTACT_BY_ID__FIRST_NAME_ASC',
  CrmContactByIdFirstNameDesc = 'CRM_CONTACT_BY_ID__FIRST_NAME_DESC',
  CrmContactByIdFullNameAsc = 'CRM_CONTACT_BY_ID__FULL_NAME_ASC',
  CrmContactByIdFullNameDesc = 'CRM_CONTACT_BY_ID__FULL_NAME_DESC',
  CrmContactByIdIdAsc = 'CRM_CONTACT_BY_ID__ID_ASC',
  CrmContactByIdIdDesc = 'CRM_CONTACT_BY_ID__ID_DESC',
  CrmContactByIdLanguagePrefAsc = 'CRM_CONTACT_BY_ID__LANGUAGE_PREF_ASC',
  CrmContactByIdLanguagePrefDesc = 'CRM_CONTACT_BY_ID__LANGUAGE_PREF_DESC',
  CrmContactByIdLastNameAsc = 'CRM_CONTACT_BY_ID__LAST_NAME_ASC',
  CrmContactByIdLastNameDesc = 'CRM_CONTACT_BY_ID__LAST_NAME_DESC',
  CrmContactByIdLocalCrmIdAsc = 'CRM_CONTACT_BY_ID__LOCAL_CRM_ID_ASC',
  CrmContactByIdLocalCrmIdDesc = 'CRM_CONTACT_BY_ID__LOCAL_CRM_ID_DESC',
  CrmContactByIdMobileAsc = 'CRM_CONTACT_BY_ID__MOBILE_ASC',
  CrmContactByIdMobileDesc = 'CRM_CONTACT_BY_ID__MOBILE_DESC',
  CrmContactByIdOrganizationAsc = 'CRM_CONTACT_BY_ID__ORGANIZATION_ASC',
  CrmContactByIdOrganizationDesc = 'CRM_CONTACT_BY_ID__ORGANIZATION_DESC',
  CrmContactByIdRegionAsc = 'CRM_CONTACT_BY_ID__REGION_ASC',
  CrmContactByIdRegionDesc = 'CRM_CONTACT_BY_ID__REGION_DESC',
  CrmContactByIdTenantIdAsc = 'CRM_CONTACT_BY_ID__TENANT_ID_ASC',
  CrmContactByIdTenantIdDesc = 'CRM_CONTACT_BY_ID__TENANT_ID_DESC',
  CrmContactByIdTerritoryAsc = 'CRM_CONTACT_BY_ID__TERRITORY_ASC',
  CrmContactByIdTerritoryDesc = 'CRM_CONTACT_BY_ID__TERRITORY_DESC',
  CrmContactByIdUpdatedAtAsc = 'CRM_CONTACT_BY_ID__UPDATED_AT_ASC',
  CrmContactByIdUpdatedAtDesc = 'CRM_CONTACT_BY_ID__UPDATED_AT_DESC',
  CrmContactByIdZipCodeAsc = 'CRM_CONTACT_BY_ID__ZIP_CODE_ASC',
  CrmContactByIdZipCodeDesc = 'CRM_CONTACT_BY_ID__ZIP_CODE_DESC',
  CrmContactConsentsByCrmIdCountAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__COUNT_ASC',
  CrmContactConsentsByCrmIdCountDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__COUNT_DESC',
  CrmContactConsentsByCrmIdMaxConsentFileStorageIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_FILE_STORAGE_ID_ASC',
  CrmContactConsentsByCrmIdMaxConsentFileStorageIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_FILE_STORAGE_ID_DESC',
  CrmContactConsentsByCrmIdMaxConsentTypeAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_TYPE_ASC',
  CrmContactConsentsByCrmIdMaxConsentTypeDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_TYPE_DESC',
  CrmContactConsentsByCrmIdMaxCreatedAtAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_AT_ASC',
  CrmContactConsentsByCrmIdMaxCreatedAtDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_AT_DESC',
  CrmContactConsentsByCrmIdMaxCreatedByIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_BY_ID_ASC',
  CrmContactConsentsByCrmIdMaxCreatedByIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_BY_ID_DESC',
  CrmContactConsentsByCrmIdMaxCrmIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CRM_ID_ASC',
  CrmContactConsentsByCrmIdMaxCrmIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CRM_ID_DESC',
  CrmContactConsentsByCrmIdMaxIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_ID_ASC',
  CrmContactConsentsByCrmIdMaxIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_ID_DESC',
  CrmContactConsentsByCrmIdMaxPayloadAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_PAYLOAD_ASC',
  CrmContactConsentsByCrmIdMaxPayloadDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_PAYLOAD_DESC',
  CrmContactConsentsByCrmIdMinConsentFileStorageIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_FILE_STORAGE_ID_ASC',
  CrmContactConsentsByCrmIdMinConsentFileStorageIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_FILE_STORAGE_ID_DESC',
  CrmContactConsentsByCrmIdMinConsentTypeAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_TYPE_ASC',
  CrmContactConsentsByCrmIdMinConsentTypeDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_TYPE_DESC',
  CrmContactConsentsByCrmIdMinCreatedAtAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_AT_ASC',
  CrmContactConsentsByCrmIdMinCreatedAtDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_AT_DESC',
  CrmContactConsentsByCrmIdMinCreatedByIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_BY_ID_ASC',
  CrmContactConsentsByCrmIdMinCreatedByIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_BY_ID_DESC',
  CrmContactConsentsByCrmIdMinCrmIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CRM_ID_ASC',
  CrmContactConsentsByCrmIdMinCrmIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CRM_ID_DESC',
  CrmContactConsentsByCrmIdMinIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_ID_ASC',
  CrmContactConsentsByCrmIdMinIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_ID_DESC',
  CrmContactConsentsByCrmIdMinPayloadAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_PAYLOAD_ASC',
  CrmContactConsentsByCrmIdMinPayloadDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_PAYLOAD_DESC',
  CrmContactPhaseMappingsByContactIdCountAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__COUNT_ASC',
  CrmContactPhaseMappingsByContactIdCountDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__COUNT_DESC',
  CrmContactPhaseMappingsByContactIdMaxContactIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CONTACT_ID_ASC',
  CrmContactPhaseMappingsByContactIdMaxContactIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CONTACT_ID_DESC',
  CrmContactPhaseMappingsByContactIdMaxCreatedAtAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CREATED_AT_ASC',
  CrmContactPhaseMappingsByContactIdMaxCreatedAtDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CREATED_AT_DESC',
  CrmContactPhaseMappingsByContactIdMaxIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_ID_ASC',
  CrmContactPhaseMappingsByContactIdMaxIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_ID_DESC',
  CrmContactPhaseMappingsByContactIdMaxPhaseIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_PHASE_ID_ASC',
  CrmContactPhaseMappingsByContactIdMaxPhaseIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_PHASE_ID_DESC',
  CrmContactPhaseMappingsByContactIdMinContactIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CONTACT_ID_ASC',
  CrmContactPhaseMappingsByContactIdMinContactIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CONTACT_ID_DESC',
  CrmContactPhaseMappingsByContactIdMinCreatedAtAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CREATED_AT_ASC',
  CrmContactPhaseMappingsByContactIdMinCreatedAtDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CREATED_AT_DESC',
  CrmContactPhaseMappingsByContactIdMinIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_ID_ASC',
  CrmContactPhaseMappingsByContactIdMinIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_ID_DESC',
  CrmContactPhaseMappingsByContactIdMinPhaseIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_PHASE_ID_ASC',
  CrmContactPhaseMappingsByContactIdMinPhaseIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_PHASE_ID_DESC',
  CrmIdAsc = 'CRM_ID_ASC',
  CrmIdDesc = 'CRM_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdCountAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__COUNT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdCountDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__COUNT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCrmContactIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCrmContactIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCrmContactIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCrmContactIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinSysPeriodAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinSysPeriodDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  FulltextRankAsc = 'FULLTEXT_RANK_ASC',
  FulltextRankDesc = 'FULLTEXT_RANK_DESC',
  FulltextSearchColumnAsc = 'FULLTEXT_SEARCH_COLUMN_ASC',
  FulltextSearchColumnDesc = 'FULLTEXT_SEARCH_COLUMN_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdCountAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__COUNT_ASC',
  LabelsOfDocumentViewsByCrmContactIdCountDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__COUNT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxTextAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_TEXT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxTextDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_TEXT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinTextAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_TEXT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinTextDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_TEXT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_DESC',
  LanguagePrefAsc = 'LANGUAGE_PREF_ASC',
  LanguagePrefDesc = 'LANGUAGE_PREF_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LocalCrmIdAsc = 'LOCAL_CRM_ID_ASC',
  LocalCrmIdDesc = 'LOCAL_CRM_ID_DESC',
  MobileAsc = 'MOBILE_ASC',
  MobileDesc = 'MOBILE_DESC',
  Natural = 'NATURAL',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  SimilarityAsc = 'SIMILARITY_ASC',
  SimilarityDesc = 'SIMILARITY_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TerritoryAsc = 'TERRITORY_ASC',
  TerritoryDesc = 'TERRITORY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

/** Represents an update to a `CrmContact`. Fields that are set will be updated. */
export type CrmContactPatch = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alxnConsentStatus?: InputMaybe<Scalars['String']['input']>;
  alxnPrimaryParent?: InputMaybe<Scalars['String']['input']>;
  alxnProducts?: InputMaybe<Scalars['JSON']['input']>;
  alxnRole?: InputMaybe<Scalars['String']['input']>;
  alxnSpeciality?: InputMaybe<Scalars['String']['input']>;
  alxnTerritories?: InputMaybe<Scalars['JSON']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  languagePref?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  localCrmId?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CrmContactPhaseMapping = Node & {
  __typename?: 'CrmContactPhaseMapping';
  /** Reads a single `CrmContact` that is related to this `CrmContactPhaseMapping`. */
  contact?: Maybe<CrmContact>;
  contactId: Scalars['BigInt']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactPhaseMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `CampaignPhase` that is related to this `CrmContactPhaseMapping`. */
  phase?: Maybe<CampaignPhase>;
  phaseId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `CrmContactPhaseMapping` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CrmContactPhaseMappingCondition = {
  /** Checks for equality with the object’s `contactId` field. */
  contactId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `phaseId` field. */
  phaseId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `CrmContactPhaseMapping` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactPhaseMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CrmContactPhaseMappingFilter>>;
  /** Filter by the object’s `contact` relation. */
  contact?: InputMaybe<CrmContactFilter>;
  /** Filter by the object’s `contactId` field. */
  contactId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `matchId` relation. */
  matchId?: InputMaybe<CrmContactMatchFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CrmContactPhaseMappingFilter>>;
  /** Filter by the object’s `phase` relation. */
  phase?: InputMaybe<CampaignPhaseFilter>;
  /** Filter by the object’s `phaseId` field. */
  phaseId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `CrmContactPhaseMapping` */
export type CrmContactPhaseMappingInput = {
  contactId: Scalars['BigInt']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  phaseId: Scalars['BigInt']['input'];
};

/** Represents an update to a `CrmContactPhaseMapping`. Fields that are set will be updated. */
export type CrmContactPhaseMappingPatch = {
  contactId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  phaseId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `CrmContactPhaseMapping` values. */
export type CrmContactPhaseMappingsConnection = {
  __typename?: 'CrmContactPhaseMappingsConnection';
  /** A list of edges which contains the `CrmContactPhaseMapping` and cursor to aid in pagination. */
  edges: Array<CrmContactPhaseMappingsEdge>;
  /** A list of `CrmContactPhaseMapping` objects. */
  nodes: Array<Maybe<CrmContactPhaseMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CrmContactPhaseMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CrmContactPhaseMapping` edge in the connection. */
export type CrmContactPhaseMappingsEdge = {
  __typename?: 'CrmContactPhaseMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CrmContactPhaseMapping` at the end of the edge. */
  node?: Maybe<CrmContactPhaseMapping>;
};

/** Methods to use when ordering `CrmContactPhaseMapping`. */
export enum CrmContactPhaseMappingsOrderBy {
  CampaignPhaseByPhaseIdCampaignIdAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CAMPAIGN_ID_ASC',
  CampaignPhaseByPhaseIdCampaignIdDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CAMPAIGN_ID_DESC',
  CampaignPhaseByPhaseIdCreatedAtAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CREATED_AT_ASC',
  CampaignPhaseByPhaseIdCreatedAtDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__CREATED_AT_DESC',
  CampaignPhaseByPhaseIdIdAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__ID_ASC',
  CampaignPhaseByPhaseIdIdDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__ID_DESC',
  CampaignPhaseByPhaseIdNameAsc = 'CAMPAIGN_PHASE_BY_PHASE_ID__NAME_ASC',
  CampaignPhaseByPhaseIdNameDesc = 'CAMPAIGN_PHASE_BY_PHASE_ID__NAME_DESC',
  ContactIdAsc = 'CONTACT_ID_ASC',
  ContactIdDesc = 'CONTACT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactByContactIdActiveAsc = 'CRM_CONTACT_BY_CONTACT_ID__ACTIVE_ASC',
  CrmContactByContactIdActiveDesc = 'CRM_CONTACT_BY_CONTACT_ID__ACTIVE_DESC',
  CrmContactByContactIdAlxnConsentStatusAsc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactByContactIdAlxnConsentStatusDesc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactByContactIdAlxnPrimaryParentAsc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactByContactIdAlxnPrimaryParentDesc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactByContactIdAlxnProductsAsc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_PRODUCTS_ASC',
  CrmContactByContactIdAlxnProductsDesc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_PRODUCTS_DESC',
  CrmContactByContactIdAlxnRoleAsc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_ROLE_ASC',
  CrmContactByContactIdAlxnRoleDesc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_ROLE_DESC',
  CrmContactByContactIdAlxnSpecialityAsc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_SPECIALITY_ASC',
  CrmContactByContactIdAlxnSpecialityDesc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_SPECIALITY_DESC',
  CrmContactByContactIdAlxnTerritoriesAsc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_TERRITORIES_ASC',
  CrmContactByContactIdAlxnTerritoriesDesc = 'CRM_CONTACT_BY_CONTACT_ID__ALXN_TERRITORIES_DESC',
  CrmContactByContactIdCityAsc = 'CRM_CONTACT_BY_CONTACT_ID__CITY_ASC',
  CrmContactByContactIdCityDesc = 'CRM_CONTACT_BY_CONTACT_ID__CITY_DESC',
  CrmContactByContactIdCountryAsc = 'CRM_CONTACT_BY_CONTACT_ID__COUNTRY_ASC',
  CrmContactByContactIdCountryDesc = 'CRM_CONTACT_BY_CONTACT_ID__COUNTRY_DESC',
  CrmContactByContactIdCreatedAtAsc = 'CRM_CONTACT_BY_CONTACT_ID__CREATED_AT_ASC',
  CrmContactByContactIdCreatedAtDesc = 'CRM_CONTACT_BY_CONTACT_ID__CREATED_AT_DESC',
  CrmContactByContactIdCrmIdAsc = 'CRM_CONTACT_BY_CONTACT_ID__CRM_ID_ASC',
  CrmContactByContactIdCrmIdDesc = 'CRM_CONTACT_BY_CONTACT_ID__CRM_ID_DESC',
  CrmContactByContactIdEmailAsc = 'CRM_CONTACT_BY_CONTACT_ID__EMAIL_ASC',
  CrmContactByContactIdEmailDesc = 'CRM_CONTACT_BY_CONTACT_ID__EMAIL_DESC',
  CrmContactByContactIdFirstNameAsc = 'CRM_CONTACT_BY_CONTACT_ID__FIRST_NAME_ASC',
  CrmContactByContactIdFirstNameDesc = 'CRM_CONTACT_BY_CONTACT_ID__FIRST_NAME_DESC',
  CrmContactByContactIdFullNameAsc = 'CRM_CONTACT_BY_CONTACT_ID__FULL_NAME_ASC',
  CrmContactByContactIdFullNameDesc = 'CRM_CONTACT_BY_CONTACT_ID__FULL_NAME_DESC',
  CrmContactByContactIdIdAsc = 'CRM_CONTACT_BY_CONTACT_ID__ID_ASC',
  CrmContactByContactIdIdDesc = 'CRM_CONTACT_BY_CONTACT_ID__ID_DESC',
  CrmContactByContactIdLanguagePrefAsc = 'CRM_CONTACT_BY_CONTACT_ID__LANGUAGE_PREF_ASC',
  CrmContactByContactIdLanguagePrefDesc = 'CRM_CONTACT_BY_CONTACT_ID__LANGUAGE_PREF_DESC',
  CrmContactByContactIdLastNameAsc = 'CRM_CONTACT_BY_CONTACT_ID__LAST_NAME_ASC',
  CrmContactByContactIdLastNameDesc = 'CRM_CONTACT_BY_CONTACT_ID__LAST_NAME_DESC',
  CrmContactByContactIdLocalCrmIdAsc = 'CRM_CONTACT_BY_CONTACT_ID__LOCAL_CRM_ID_ASC',
  CrmContactByContactIdLocalCrmIdDesc = 'CRM_CONTACT_BY_CONTACT_ID__LOCAL_CRM_ID_DESC',
  CrmContactByContactIdMobileAsc = 'CRM_CONTACT_BY_CONTACT_ID__MOBILE_ASC',
  CrmContactByContactIdMobileDesc = 'CRM_CONTACT_BY_CONTACT_ID__MOBILE_DESC',
  CrmContactByContactIdOrganizationAsc = 'CRM_CONTACT_BY_CONTACT_ID__ORGANIZATION_ASC',
  CrmContactByContactIdOrganizationDesc = 'CRM_CONTACT_BY_CONTACT_ID__ORGANIZATION_DESC',
  CrmContactByContactIdRegionAsc = 'CRM_CONTACT_BY_CONTACT_ID__REGION_ASC',
  CrmContactByContactIdRegionDesc = 'CRM_CONTACT_BY_CONTACT_ID__REGION_DESC',
  CrmContactByContactIdTenantIdAsc = 'CRM_CONTACT_BY_CONTACT_ID__TENANT_ID_ASC',
  CrmContactByContactIdTenantIdDesc = 'CRM_CONTACT_BY_CONTACT_ID__TENANT_ID_DESC',
  CrmContactByContactIdTerritoryAsc = 'CRM_CONTACT_BY_CONTACT_ID__TERRITORY_ASC',
  CrmContactByContactIdTerritoryDesc = 'CRM_CONTACT_BY_CONTACT_ID__TERRITORY_DESC',
  CrmContactByContactIdUpdatedAtAsc = 'CRM_CONTACT_BY_CONTACT_ID__UPDATED_AT_ASC',
  CrmContactByContactIdUpdatedAtDesc = 'CRM_CONTACT_BY_CONTACT_ID__UPDATED_AT_DESC',
  CrmContactByContactIdZipCodeAsc = 'CRM_CONTACT_BY_CONTACT_ID__ZIP_CODE_ASC',
  CrmContactByContactIdZipCodeDesc = 'CRM_CONTACT_BY_CONTACT_ID__ZIP_CODE_DESC',
  CrmContactMatchByContactIdActiveAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ACTIVE_ASC',
  CrmContactMatchByContactIdActiveDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ACTIVE_DESC',
  CrmContactMatchByContactIdAlxnConsentStatusAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchByContactIdAlxnConsentStatusDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchByContactIdAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchByContactIdAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchByContactIdAlxnProductsAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_PRODUCTS_ASC',
  CrmContactMatchByContactIdAlxnProductsDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_PRODUCTS_DESC',
  CrmContactMatchByContactIdAlxnRoleAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_ROLE_ASC',
  CrmContactMatchByContactIdAlxnRoleDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_ROLE_DESC',
  CrmContactMatchByContactIdAlxnSpecialityAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_SPECIALITY_ASC',
  CrmContactMatchByContactIdAlxnSpecialityDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_SPECIALITY_DESC',
  CrmContactMatchByContactIdAlxnTerritoriesAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_TERRITORIES_ASC',
  CrmContactMatchByContactIdAlxnTerritoriesDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ALXN_TERRITORIES_DESC',
  CrmContactMatchByContactIdCityAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__CITY_ASC',
  CrmContactMatchByContactIdCityDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__CITY_DESC',
  CrmContactMatchByContactIdCountryAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__COUNTRY_ASC',
  CrmContactMatchByContactIdCountryDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__COUNTRY_DESC',
  CrmContactMatchByContactIdCreatedAtAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__CREATED_AT_ASC',
  CrmContactMatchByContactIdCreatedAtDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__CREATED_AT_DESC',
  CrmContactMatchByContactIdCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__CRM_ID_ASC',
  CrmContactMatchByContactIdCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__CRM_ID_DESC',
  CrmContactMatchByContactIdEmailAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__EMAIL_ASC',
  CrmContactMatchByContactIdEmailDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__EMAIL_DESC',
  CrmContactMatchByContactIdFirstNameAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FIRST_NAME_ASC',
  CrmContactMatchByContactIdFirstNameDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FIRST_NAME_DESC',
  CrmContactMatchByContactIdFulltextRankAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FULLTEXT_RANK_ASC',
  CrmContactMatchByContactIdFulltextRankDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FULLTEXT_RANK_DESC',
  CrmContactMatchByContactIdFulltextSearchColumnAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchByContactIdFulltextSearchColumnDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchByContactIdFullNameAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FULL_NAME_ASC',
  CrmContactMatchByContactIdFullNameDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__FULL_NAME_DESC',
  CrmContactMatchByContactIdIdAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ID_ASC',
  CrmContactMatchByContactIdIdDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ID_DESC',
  CrmContactMatchByContactIdLanguagePrefAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__LANGUAGE_PREF_ASC',
  CrmContactMatchByContactIdLanguagePrefDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__LANGUAGE_PREF_DESC',
  CrmContactMatchByContactIdLastNameAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__LAST_NAME_ASC',
  CrmContactMatchByContactIdLastNameDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__LAST_NAME_DESC',
  CrmContactMatchByContactIdLocalCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__LOCAL_CRM_ID_ASC',
  CrmContactMatchByContactIdLocalCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__LOCAL_CRM_ID_DESC',
  CrmContactMatchByContactIdMobileAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__MOBILE_ASC',
  CrmContactMatchByContactIdMobileDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__MOBILE_DESC',
  CrmContactMatchByContactIdOrganizationAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ORGANIZATION_ASC',
  CrmContactMatchByContactIdOrganizationDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ORGANIZATION_DESC',
  CrmContactMatchByContactIdRegionAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__REGION_ASC',
  CrmContactMatchByContactIdRegionDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__REGION_DESC',
  CrmContactMatchByContactIdSimilarityAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__SIMILARITY_ASC',
  CrmContactMatchByContactIdSimilarityDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__SIMILARITY_DESC',
  CrmContactMatchByContactIdTenantIdAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__TENANT_ID_ASC',
  CrmContactMatchByContactIdTenantIdDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__TENANT_ID_DESC',
  CrmContactMatchByContactIdTerritoryAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__TERRITORY_ASC',
  CrmContactMatchByContactIdTerritoryDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__TERRITORY_DESC',
  CrmContactMatchByContactIdUpdatedAtAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__UPDATED_AT_ASC',
  CrmContactMatchByContactIdUpdatedAtDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__UPDATED_AT_DESC',
  CrmContactMatchByContactIdZipCodeAsc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ZIP_CODE_ASC',
  CrmContactMatchByContactIdZipCodeDesc = 'CRM_CONTACT_MATCH_BY_CONTACT_ID__ZIP_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PhaseIdAsc = 'PHASE_ID_ASC',
  PhaseIdDesc = 'PHASE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against many `CrmContactConsent` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactToManyCrmContactConsentFilter = {
  /** Every related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactConsentFilter>;
  /** No related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactConsentFilter>;
  /** Some related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactConsentFilter>;
};

/** A filter to be used against many `CrmContactPhaseMapping` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactToManyCrmContactPhaseMappingFilter = {
  /** Every related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** No related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactPhaseMappingFilter>;
  /** Some related `CrmContactPhaseMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactPhaseMappingFilter>;
};

/** A filter to be used against many `DocumentSpaceCrmMapping` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactToManyDocumentSpaceCrmMappingFilter = {
  /** Every related `DocumentSpaceCrmMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  /** No related `DocumentSpaceCrmMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  /** Some related `DocumentSpaceCrmMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceCrmMappingFilter>;
};

/** A filter to be used against many `LabelsOfDocumentView` object types. All fields are combined with a logical ‘and.’ */
export type CrmContactToManyLabelsOfDocumentViewFilter = {
  /** Every related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** No related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** Some related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LabelsOfDocumentViewFilter>;
};

/** A connection to a list of `CrmContact` values. */
export type CrmContactsConnection = {
  __typename?: 'CrmContactsConnection';
  /** A list of edges which contains the `CrmContact` and cursor to aid in pagination. */
  edges: Array<CrmContactsEdge>;
  /** A list of `CrmContact` objects. */
  nodes: Array<Maybe<CrmContact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CrmContact` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CrmContact` edge in the connection. */
export type CrmContactsEdge = {
  __typename?: 'CrmContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CrmContact` at the end of the edge. */
  node?: Maybe<CrmContact>;
};

/** Methods to use when ordering `CrmContact`. */
export enum CrmContactsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  AlxnConsentStatusAsc = 'ALXN_CONSENT_STATUS_ASC',
  AlxnConsentStatusDesc = 'ALXN_CONSENT_STATUS_DESC',
  AlxnPrimaryParentAsc = 'ALXN_PRIMARY_PARENT_ASC',
  AlxnPrimaryParentDesc = 'ALXN_PRIMARY_PARENT_DESC',
  AlxnProductsAsc = 'ALXN_PRODUCTS_ASC',
  AlxnProductsDesc = 'ALXN_PRODUCTS_DESC',
  AlxnRoleAsc = 'ALXN_ROLE_ASC',
  AlxnRoleDesc = 'ALXN_ROLE_DESC',
  AlxnSpecialityAsc = 'ALXN_SPECIALITY_ASC',
  AlxnSpecialityDesc = 'ALXN_SPECIALITY_DESC',
  AlxnTerritoriesAsc = 'ALXN_TERRITORIES_ASC',
  AlxnTerritoriesDesc = 'ALXN_TERRITORIES_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactConsentsByCrmIdCountAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__COUNT_ASC',
  CrmContactConsentsByCrmIdCountDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__COUNT_DESC',
  CrmContactConsentsByCrmIdMaxConsentFileStorageIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_FILE_STORAGE_ID_ASC',
  CrmContactConsentsByCrmIdMaxConsentFileStorageIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_FILE_STORAGE_ID_DESC',
  CrmContactConsentsByCrmIdMaxConsentTypeAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_TYPE_ASC',
  CrmContactConsentsByCrmIdMaxConsentTypeDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CONSENT_TYPE_DESC',
  CrmContactConsentsByCrmIdMaxCreatedAtAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_AT_ASC',
  CrmContactConsentsByCrmIdMaxCreatedAtDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_AT_DESC',
  CrmContactConsentsByCrmIdMaxCreatedByIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_BY_ID_ASC',
  CrmContactConsentsByCrmIdMaxCreatedByIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CREATED_BY_ID_DESC',
  CrmContactConsentsByCrmIdMaxCrmIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CRM_ID_ASC',
  CrmContactConsentsByCrmIdMaxCrmIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_CRM_ID_DESC',
  CrmContactConsentsByCrmIdMaxIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_ID_ASC',
  CrmContactConsentsByCrmIdMaxIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_ID_DESC',
  CrmContactConsentsByCrmIdMaxPayloadAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_PAYLOAD_ASC',
  CrmContactConsentsByCrmIdMaxPayloadDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MAX_PAYLOAD_DESC',
  CrmContactConsentsByCrmIdMinConsentFileStorageIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_FILE_STORAGE_ID_ASC',
  CrmContactConsentsByCrmIdMinConsentFileStorageIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_FILE_STORAGE_ID_DESC',
  CrmContactConsentsByCrmIdMinConsentTypeAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_TYPE_ASC',
  CrmContactConsentsByCrmIdMinConsentTypeDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CONSENT_TYPE_DESC',
  CrmContactConsentsByCrmIdMinCreatedAtAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_AT_ASC',
  CrmContactConsentsByCrmIdMinCreatedAtDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_AT_DESC',
  CrmContactConsentsByCrmIdMinCreatedByIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_BY_ID_ASC',
  CrmContactConsentsByCrmIdMinCreatedByIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CREATED_BY_ID_DESC',
  CrmContactConsentsByCrmIdMinCrmIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CRM_ID_ASC',
  CrmContactConsentsByCrmIdMinCrmIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_CRM_ID_DESC',
  CrmContactConsentsByCrmIdMinIdAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_ID_ASC',
  CrmContactConsentsByCrmIdMinIdDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_ID_DESC',
  CrmContactConsentsByCrmIdMinPayloadAsc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_PAYLOAD_ASC',
  CrmContactConsentsByCrmIdMinPayloadDesc = 'CRM_CONTACT_CONSENTS_BY_CRM_ID__MIN_PAYLOAD_DESC',
  CrmContactMatchByIdActiveAsc = 'CRM_CONTACT_MATCH_BY_ID__ACTIVE_ASC',
  CrmContactMatchByIdActiveDesc = 'CRM_CONTACT_MATCH_BY_ID__ACTIVE_DESC',
  CrmContactMatchByIdAlxnConsentStatusAsc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchByIdAlxnConsentStatusDesc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchByIdAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchByIdAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchByIdAlxnProductsAsc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_PRODUCTS_ASC',
  CrmContactMatchByIdAlxnProductsDesc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_PRODUCTS_DESC',
  CrmContactMatchByIdAlxnRoleAsc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_ROLE_ASC',
  CrmContactMatchByIdAlxnRoleDesc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_ROLE_DESC',
  CrmContactMatchByIdAlxnSpecialityAsc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_SPECIALITY_ASC',
  CrmContactMatchByIdAlxnSpecialityDesc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_SPECIALITY_DESC',
  CrmContactMatchByIdAlxnTerritoriesAsc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_TERRITORIES_ASC',
  CrmContactMatchByIdAlxnTerritoriesDesc = 'CRM_CONTACT_MATCH_BY_ID__ALXN_TERRITORIES_DESC',
  CrmContactMatchByIdCityAsc = 'CRM_CONTACT_MATCH_BY_ID__CITY_ASC',
  CrmContactMatchByIdCityDesc = 'CRM_CONTACT_MATCH_BY_ID__CITY_DESC',
  CrmContactMatchByIdCountryAsc = 'CRM_CONTACT_MATCH_BY_ID__COUNTRY_ASC',
  CrmContactMatchByIdCountryDesc = 'CRM_CONTACT_MATCH_BY_ID__COUNTRY_DESC',
  CrmContactMatchByIdCreatedAtAsc = 'CRM_CONTACT_MATCH_BY_ID__CREATED_AT_ASC',
  CrmContactMatchByIdCreatedAtDesc = 'CRM_CONTACT_MATCH_BY_ID__CREATED_AT_DESC',
  CrmContactMatchByIdCrmIdAsc = 'CRM_CONTACT_MATCH_BY_ID__CRM_ID_ASC',
  CrmContactMatchByIdCrmIdDesc = 'CRM_CONTACT_MATCH_BY_ID__CRM_ID_DESC',
  CrmContactMatchByIdEmailAsc = 'CRM_CONTACT_MATCH_BY_ID__EMAIL_ASC',
  CrmContactMatchByIdEmailDesc = 'CRM_CONTACT_MATCH_BY_ID__EMAIL_DESC',
  CrmContactMatchByIdFirstNameAsc = 'CRM_CONTACT_MATCH_BY_ID__FIRST_NAME_ASC',
  CrmContactMatchByIdFirstNameDesc = 'CRM_CONTACT_MATCH_BY_ID__FIRST_NAME_DESC',
  CrmContactMatchByIdFulltextRankAsc = 'CRM_CONTACT_MATCH_BY_ID__FULLTEXT_RANK_ASC',
  CrmContactMatchByIdFulltextRankDesc = 'CRM_CONTACT_MATCH_BY_ID__FULLTEXT_RANK_DESC',
  CrmContactMatchByIdFulltextSearchColumnAsc = 'CRM_CONTACT_MATCH_BY_ID__FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchByIdFulltextSearchColumnDesc = 'CRM_CONTACT_MATCH_BY_ID__FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchByIdFullNameAsc = 'CRM_CONTACT_MATCH_BY_ID__FULL_NAME_ASC',
  CrmContactMatchByIdFullNameDesc = 'CRM_CONTACT_MATCH_BY_ID__FULL_NAME_DESC',
  CrmContactMatchByIdIdAsc = 'CRM_CONTACT_MATCH_BY_ID__ID_ASC',
  CrmContactMatchByIdIdDesc = 'CRM_CONTACT_MATCH_BY_ID__ID_DESC',
  CrmContactMatchByIdLanguagePrefAsc = 'CRM_CONTACT_MATCH_BY_ID__LANGUAGE_PREF_ASC',
  CrmContactMatchByIdLanguagePrefDesc = 'CRM_CONTACT_MATCH_BY_ID__LANGUAGE_PREF_DESC',
  CrmContactMatchByIdLastNameAsc = 'CRM_CONTACT_MATCH_BY_ID__LAST_NAME_ASC',
  CrmContactMatchByIdLastNameDesc = 'CRM_CONTACT_MATCH_BY_ID__LAST_NAME_DESC',
  CrmContactMatchByIdLocalCrmIdAsc = 'CRM_CONTACT_MATCH_BY_ID__LOCAL_CRM_ID_ASC',
  CrmContactMatchByIdLocalCrmIdDesc = 'CRM_CONTACT_MATCH_BY_ID__LOCAL_CRM_ID_DESC',
  CrmContactMatchByIdMobileAsc = 'CRM_CONTACT_MATCH_BY_ID__MOBILE_ASC',
  CrmContactMatchByIdMobileDesc = 'CRM_CONTACT_MATCH_BY_ID__MOBILE_DESC',
  CrmContactMatchByIdOrganizationAsc = 'CRM_CONTACT_MATCH_BY_ID__ORGANIZATION_ASC',
  CrmContactMatchByIdOrganizationDesc = 'CRM_CONTACT_MATCH_BY_ID__ORGANIZATION_DESC',
  CrmContactMatchByIdRegionAsc = 'CRM_CONTACT_MATCH_BY_ID__REGION_ASC',
  CrmContactMatchByIdRegionDesc = 'CRM_CONTACT_MATCH_BY_ID__REGION_DESC',
  CrmContactMatchByIdSimilarityAsc = 'CRM_CONTACT_MATCH_BY_ID__SIMILARITY_ASC',
  CrmContactMatchByIdSimilarityDesc = 'CRM_CONTACT_MATCH_BY_ID__SIMILARITY_DESC',
  CrmContactMatchByIdTenantIdAsc = 'CRM_CONTACT_MATCH_BY_ID__TENANT_ID_ASC',
  CrmContactMatchByIdTenantIdDesc = 'CRM_CONTACT_MATCH_BY_ID__TENANT_ID_DESC',
  CrmContactMatchByIdTerritoryAsc = 'CRM_CONTACT_MATCH_BY_ID__TERRITORY_ASC',
  CrmContactMatchByIdTerritoryDesc = 'CRM_CONTACT_MATCH_BY_ID__TERRITORY_DESC',
  CrmContactMatchByIdUpdatedAtAsc = 'CRM_CONTACT_MATCH_BY_ID__UPDATED_AT_ASC',
  CrmContactMatchByIdUpdatedAtDesc = 'CRM_CONTACT_MATCH_BY_ID__UPDATED_AT_DESC',
  CrmContactMatchByIdZipCodeAsc = 'CRM_CONTACT_MATCH_BY_ID__ZIP_CODE_ASC',
  CrmContactMatchByIdZipCodeDesc = 'CRM_CONTACT_MATCH_BY_ID__ZIP_CODE_DESC',
  CrmContactPhaseMappingsByContactIdCountAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__COUNT_ASC',
  CrmContactPhaseMappingsByContactIdCountDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__COUNT_DESC',
  CrmContactPhaseMappingsByContactIdMaxContactIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CONTACT_ID_ASC',
  CrmContactPhaseMappingsByContactIdMaxContactIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CONTACT_ID_DESC',
  CrmContactPhaseMappingsByContactIdMaxCreatedAtAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CREATED_AT_ASC',
  CrmContactPhaseMappingsByContactIdMaxCreatedAtDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_CREATED_AT_DESC',
  CrmContactPhaseMappingsByContactIdMaxIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_ID_ASC',
  CrmContactPhaseMappingsByContactIdMaxIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_ID_DESC',
  CrmContactPhaseMappingsByContactIdMaxPhaseIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_PHASE_ID_ASC',
  CrmContactPhaseMappingsByContactIdMaxPhaseIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MAX_PHASE_ID_DESC',
  CrmContactPhaseMappingsByContactIdMinContactIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CONTACT_ID_ASC',
  CrmContactPhaseMappingsByContactIdMinContactIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CONTACT_ID_DESC',
  CrmContactPhaseMappingsByContactIdMinCreatedAtAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CREATED_AT_ASC',
  CrmContactPhaseMappingsByContactIdMinCreatedAtDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_CREATED_AT_DESC',
  CrmContactPhaseMappingsByContactIdMinIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_ID_ASC',
  CrmContactPhaseMappingsByContactIdMinIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_ID_DESC',
  CrmContactPhaseMappingsByContactIdMinPhaseIdAsc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_PHASE_ID_ASC',
  CrmContactPhaseMappingsByContactIdMinPhaseIdDesc = 'CRM_CONTACT_PHASE_MAPPINGS_BY_CONTACT_ID__MIN_PHASE_ID_DESC',
  CrmIdAsc = 'CRM_ID_ASC',
  CrmIdDesc = 'CRM_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdCountAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__COUNT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdCountDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__COUNT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCrmContactIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxCrmContactIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCrmContactIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinCrmContactIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinIdAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_ID_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinIdDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_ID_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinSysPeriodAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinSysPeriodDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceCrmMappingsByCrmContactIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceCrmMappingsByCrmContactIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPINGS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdCountAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__COUNT_ASC',
  LabelsOfDocumentViewsByCrmContactIdCountDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__COUNT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CREATED_AT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxTextAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_TEXT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxTextDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_TEXT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMaxUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMaxUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MAX_UPDATED_AT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CREATED_AT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinTextAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_TEXT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinTextDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_TEXT_DESC',
  LabelsOfDocumentViewsByCrmContactIdMinUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_ASC',
  LabelsOfDocumentViewsByCrmContactIdMinUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_CRM_CONTACT_ID__MIN_UPDATED_AT_DESC',
  LanguagePrefAsc = 'LANGUAGE_PREF_ASC',
  LanguagePrefDesc = 'LANGUAGE_PREF_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LocalCrmIdAsc = 'LOCAL_CRM_ID_ASC',
  LocalCrmIdDesc = 'LOCAL_CRM_ID_DESC',
  MobileAsc = 'MOBILE_ASC',
  MobileDesc = 'MOBILE_DESC',
  Natural = 'NATURAL',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TerritoryAsc = 'TERRITORY_ASC',
  TerritoryDesc = 'TERRITORY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** A range of `Datetime`. */
export type DatetimeRange = {
  __typename?: 'DatetimeRange';
  /** The ending bound of our range. */
  end?: Maybe<DatetimeRangeBound>;
  /** The starting bound of our range. */
  start?: Maybe<DatetimeRangeBound>;
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DatetimeRangeBound = {
  __typename?: 'DatetimeRangeBound';
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['output'];
  /** The value at one end of our range. */
  value: Scalars['Datetime']['output'];
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DatetimeRangeBoundInput = {
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['input'];
  /** The value at one end of our range. */
  value: Scalars['Datetime']['input'];
};

/** A filter to be used against DatetimeRange fields. All fields are combined with a logical ‘and.’ */
export type DatetimeRangeFilter = {
  /** Adjacent to the specified range. */
  adjacentTo?: InputMaybe<DatetimeRangeInput>;
  /** Contained by the specified range. */
  containedBy?: InputMaybe<DatetimeRangeInput>;
  /** Contains the specified range. */
  contains?: InputMaybe<DatetimeRangeInput>;
  /** Contains the specified value. */
  containsElement?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DatetimeRangeInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DatetimeRangeInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DatetimeRangeInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DatetimeRangeInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DatetimeRangeInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DatetimeRangeInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Does not extend left of the specified range. */
  notExtendsLeftOf?: InputMaybe<DatetimeRangeInput>;
  /** Does not extend right of the specified range. */
  notExtendsRightOf?: InputMaybe<DatetimeRangeInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DatetimeRangeInput>>;
  /** Overlaps the specified range. */
  overlaps?: InputMaybe<DatetimeRangeInput>;
  /** Strictly left of the specified range. */
  strictlyLeftOf?: InputMaybe<DatetimeRangeInput>;
  /** Strictly right of the specified range. */
  strictlyRightOf?: InputMaybe<DatetimeRangeInput>;
};

/** A range of `Datetime`. */
export type DatetimeRangeInput = {
  /** The ending bound of our range. */
  end?: InputMaybe<DatetimeRangeBoundInput>;
  /** The starting bound of our range. */
  start?: InputMaybe<DatetimeRangeBoundInput>;
};

/** All input for the `deleteArInternalMetadatumByNodeId` mutation. */
export type DeleteArInternalMetadatumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ArInternalMetadatum` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteArInternalMetadatum` mutation. */
export type DeleteArInternalMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

/** The output of our delete `ArInternalMetadatum` mutation. */
export type DeleteArInternalMetadatumPayload = {
  __typename?: 'DeleteArInternalMetadatumPayload';
  /** The `ArInternalMetadatum` that was deleted by this mutation. */
  arInternalMetadatum?: Maybe<ArInternalMetadatum>;
  /** An edge for our `ArInternalMetadatum`. May be used by Relay 1. */
  arInternalMetadatumEdge?: Maybe<ArInternalMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedArInternalMetadatumNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ArInternalMetadatum` mutation. */
export type DeleteArInternalMetadatumPayloadArInternalMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<ArInternalMetadataOrderBy>>;
};

/** All input for the `deleteCampaignByNodeId` mutation. */
export type DeleteCampaignByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Campaign` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCampaign` mutation. */
export type DeleteCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Campaign` mutation. */
export type DeleteCampaignPayload = {
  __typename?: 'DeleteCampaignPayload';
  /** The `Campaign` that was deleted by this mutation. */
  campaign?: Maybe<Campaign>;
  /** An edge for our `Campaign`. May be used by Relay 1. */
  campaignEdge?: Maybe<CampaignsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCampaignNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Campaign`. */
  team?: Maybe<Team>;
};


/** The output of our delete `Campaign` mutation. */
export type DeleteCampaignPayloadCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};

/** All input for the `deleteCampaignPhaseByNodeId` mutation. */
export type DeleteCampaignPhaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CampaignPhase` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCampaignPhase` mutation. */
export type DeleteCampaignPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteCampaignPhaseLinkByNodeId` mutation. */
export type DeleteCampaignPhaseLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CampaignPhaseLink` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCampaignPhaseLink` mutation. */
export type DeleteCampaignPhaseLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CampaignPhaseLink` mutation. */
export type DeleteCampaignPhaseLinkPayload = {
  __typename?: 'DeleteCampaignPhaseLinkPayload';
  /** The `CampaignPhaseLink` that was deleted by this mutation. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** An edge for our `CampaignPhaseLink`. May be used by Relay 1. */
  campaignPhaseLinkEdge?: Maybe<CampaignPhaseLinksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCampaignPhaseLinkNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `CampaignPhase` that is related to this `CampaignPhaseLink`. */
  phase?: Maybe<CampaignPhase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CampaignPhaseLink` mutation. */
export type DeleteCampaignPhaseLinkPayloadCampaignPhaseLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignPhaseLinksOrderBy>>;
};

/** The output of our delete `CampaignPhase` mutation. */
export type DeleteCampaignPhasePayload = {
  __typename?: 'DeleteCampaignPhasePayload';
  /** Reads a single `Campaign` that is related to this `CampaignPhase`. */
  campaign?: Maybe<Campaign>;
  /** The `CampaignPhase` that was deleted by this mutation. */
  campaignPhase?: Maybe<CampaignPhase>;
  /** An edge for our `CampaignPhase`. May be used by Relay 1. */
  campaignPhaseEdge?: Maybe<CampaignPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCampaignPhaseNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CampaignPhase` mutation. */
export type DeleteCampaignPhasePayloadCampaignPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignPhasesOrderBy>>;
};

/** All input for the `deleteCampaignQueryParamByNodeId` mutation. */
export type DeleteCampaignQueryParamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CampaignQueryParam` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCampaignQueryParam` mutation. */
export type DeleteCampaignQueryParamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CampaignQueryParam` mutation. */
export type DeleteCampaignQueryParamPayload = {
  __typename?: 'DeleteCampaignQueryParamPayload';
  /** Reads a single `CampaignPhaseLink` that is related to this `CampaignQueryParam`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** The `CampaignQueryParam` that was deleted by this mutation. */
  campaignQueryParam?: Maybe<CampaignQueryParam>;
  /** An edge for our `CampaignQueryParam`. May be used by Relay 1. */
  campaignQueryParamEdge?: Maybe<CampaignQueryParamsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCampaignQueryParamNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CampaignQueryParam` mutation. */
export type DeleteCampaignQueryParamPayloadCampaignQueryParamEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignQueryParamsOrderBy>>;
};

/** All input for the `deleteCrmContactByCrmIdAndTenantId` mutation. */
export type DeleteCrmContactByCrmIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmId: Scalars['String']['input'];
  tenantId: Scalars['BigInt']['input'];
};

/** All input for the `deleteCrmContactByNodeId` mutation. */
export type DeleteCrmContactByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CrmContact` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCrmContactConsentByNodeId` mutation. */
export type DeleteCrmContactConsentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CrmContactConsent` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCrmContactConsent` mutation. */
export type DeleteCrmContactConsentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CrmContactConsent` mutation. */
export type DeleteCrmContactConsentPayload = {
  __typename?: 'DeleteCrmContactConsentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `CrmContactConsent`. */
  createdBy?: Maybe<User>;
  /** Reads a single `CrmContact` that is related to this `CrmContactConsent`. */
  crm?: Maybe<CrmContact>;
  /** The `CrmContactConsent` that was deleted by this mutation. */
  crmContactConsent?: Maybe<CrmContactConsent>;
  /** An edge for our `CrmContactConsent`. May be used by Relay 1. */
  crmContactConsentEdge?: Maybe<CrmContactConsentsEdge>;
  deletedCrmContactConsentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactConsent`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CrmContactConsent` mutation. */
export type DeleteCrmContactConsentPayloadCrmContactConsentEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};

/** All input for the `deleteCrmContact` mutation. */
export type DeleteCrmContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CrmContact` mutation. */
export type DeleteCrmContactPayload = {
  __typename?: 'DeleteCrmContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CrmContact` that was deleted by this mutation. */
  crmContact?: Maybe<CrmContact>;
  /** An edge for our `CrmContact`. May be used by Relay 1. */
  crmContactEdge?: Maybe<CrmContactsEdge>;
  deletedCrmContactNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `CrmContact`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `CrmContact` mutation. */
export type DeleteCrmContactPayloadCrmContactEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactsOrderBy>>;
};

/** All input for the `deleteCrmContactPhaseMappingByNodeId` mutation. */
export type DeleteCrmContactPhaseMappingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CrmContactPhaseMapping` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCrmContactPhaseMappingByPhaseIdAndContactId` mutation. */
export type DeleteCrmContactPhaseMappingByPhaseIdAndContactIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['BigInt']['input'];
  phaseId: Scalars['BigInt']['input'];
};

/** All input for the `deleteCrmContactPhaseMapping` mutation. */
export type DeleteCrmContactPhaseMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `CrmContactPhaseMapping` mutation. */
export type DeleteCrmContactPhaseMappingPayload = {
  __typename?: 'DeleteCrmContactPhaseMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `CrmContactPhaseMapping`. */
  contact?: Maybe<CrmContact>;
  /** The `CrmContactPhaseMapping` that was deleted by this mutation. */
  crmContactPhaseMapping?: Maybe<CrmContactPhaseMapping>;
  /** An edge for our `CrmContactPhaseMapping`. May be used by Relay 1. */
  crmContactPhaseMappingEdge?: Maybe<CrmContactPhaseMappingsEdge>;
  deletedCrmContactPhaseMappingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactPhaseMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Reads a single `CampaignPhase` that is related to this `CrmContactPhaseMapping`. */
  phase?: Maybe<CampaignPhase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CrmContactPhaseMapping` mutation. */
export type DeleteCrmContactPhaseMappingPayloadCrmContactPhaseMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};

/** All input for the `deleteDocumentByFirestoreId` mutation. */
export type DeleteDocumentByFirestoreIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firestoreId: Scalars['String']['input'];
};

/** All input for the `deleteDocumentByNodeId` mutation. */
export type DeleteDocumentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Document` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentExpirationByNodeId` mutation. */
export type DeleteDocumentExpirationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentExpiration` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentExpiration` mutation. */
export type DeleteDocumentExpirationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentExpiration` mutation. */
export type DeleteDocumentExpirationPayload = {
  __typename?: 'DeleteDocumentExpirationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentExpirationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentExpiration`. */
  document?: Maybe<Document>;
  /** The `DocumentExpiration` that was deleted by this mutation. */
  documentExpiration?: Maybe<DocumentExpiration>;
  /** An edge for our `DocumentExpiration`. May be used by Relay 1. */
  documentExpirationEdge?: Maybe<DocumentExpirationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentExpiration` mutation. */
export type DeleteDocumentExpirationPayloadDocumentExpirationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentExpirationsOrderBy>>;
};

/** All input for the `deleteDocument` mutation. */
export type DeleteDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentPageByDocumentIdAndRevisionNumberAndPageNumber` mutation. */
export type DeleteDocumentPageByDocumentIdAndRevisionNumberAndPageNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Document, the page belongs to. */
  documentId: Scalars['BigInt']['input'];
  /** Number of this page in the related document. */
  pageNumber: Scalars['Int']['input'];
  revisionNumber: Scalars['Int']['input'];
};

/** All input for the `deleteDocumentPageByNodeId` mutation. */
export type DeleteDocumentPageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentPage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentPage` mutation. */
export type DeleteDocumentPageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentPageLinkByNodeId` mutation. */
export type DeleteDocumentPageLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentPageLink` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentPageLink` mutation. */
export type DeleteDocumentPageLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentPageLink` mutation. */
export type DeleteDocumentPageLinkPayload = {
  __typename?: 'DeleteDocumentPageLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentPageLinkNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentPageLink` that was deleted by this mutation. */
  documentPageLink?: Maybe<DocumentPageLink>;
  /** An edge for our `DocumentPageLink`. May be used by Relay 1. */
  documentPageLinkEdge?: Maybe<DocumentPageLinksEdge>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  page?: Maybe<DocumentPage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  targetPage?: Maybe<DocumentPage>;
};


/** The output of our delete `DocumentPageLink` mutation. */
export type DeleteDocumentPageLinkPayloadDocumentPageLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageLinksOrderBy>>;
};

/** All input for the `deleteDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber` mutation. */
export type DeleteDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  sourcePageNumber: Scalars['Int']['input'];
  sourceRevisionNumber: Scalars['Int']['input'];
};

/** All input for the `deleteDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber` mutation. */
export type DeleteDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  targetPageNumber: Scalars['Int']['input'];
  targetRevisionNumber: Scalars['Int']['input'];
};

/** All input for the `deleteDocumentPageMatchingByNodeId` mutation. */
export type DeleteDocumentPageMatchingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentPageMatching` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentPageMatching` mutation. */
export type DeleteDocumentPageMatchingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentPageMatching` mutation. */
export type DeleteDocumentPageMatchingPayload = {
  __typename?: 'DeleteDocumentPageMatchingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentPageMatchingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentPageMatching`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DocumentPage>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DocumentPage>;
  /** The `DocumentPageMatching` that was deleted by this mutation. */
  documentPageMatching?: Maybe<DocumentPageMatching>;
  /** An edge for our `DocumentPageMatching`. May be used by Relay 1. */
  documentPageMatchingEdge?: Maybe<DocumentPageMatchingsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndSourceRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndTargetRevisionNumber?: Maybe<DocumentRevision>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentPageMatching` mutation. */
export type DeleteDocumentPageMatchingPayloadDocumentPageMatchingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};

/** The output of our delete `DocumentPage` mutation. */
export type DeleteDocumentPagePayload = {
  __typename?: 'DeleteDocumentPagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentPageNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  document?: Maybe<Document>;
  /** The `DocumentPage` that was deleted by this mutation. */
  documentPage?: Maybe<DocumentPage>;
  /** An edge for our `DocumentPage`. May be used by Relay 1. */
  documentPageEdge?: Maybe<DocumentPagesEdge>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPage`. */
  documentRevisionByDocumentIdAndRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  linkedDocument?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentPage` mutation. */
export type DeleteDocumentPagePayloadDocumentPageEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};

/** The output of our delete `Document` mutation. */
export type DeleteDocumentPayload = {
  __typename?: 'DeleteDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Document`. */
  createdBy?: Maybe<User>;
  deletedDocumentNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Document` that was deleted by this mutation. */
  document?: Maybe<Document>;
  /** An edge for our `Document`. May be used by Relay 1. */
  documentEdge?: Maybe<DocumentsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `Document`. */
  documentRevisionByIdAndCurrentRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `User` that is related to this `Document`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Document` that is related to this `Document`. */
  legalAppendix?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workspace` that is related to this `Document`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our delete `Document` mutation. */
export type DeleteDocumentPayloadDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};

/** All input for the `deleteDocumentProcessByNodeId` mutation. */
export type DeleteDocumentProcessByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentProcess` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentProcess` mutation. */
export type DeleteDocumentProcessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentProcess` mutation. */
export type DeleteDocumentProcessPayload = {
  __typename?: 'DeleteDocumentProcessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentProcessNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentProcess`. */
  document?: Maybe<Document>;
  /** The `DocumentProcess` that was deleted by this mutation. */
  documentProcess?: Maybe<DocumentProcess>;
  /** An edge for our `DocumentProcess`. May be used by Relay 1. */
  documentProcessEdge?: Maybe<DocumentProcessesEdge>;
  /** Reads a single `User` that is related to this `DocumentProcess`. */
  initiator?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentProcess`. */
  revision?: Maybe<DocumentRevision>;
};


/** The output of our delete `DocumentProcess` mutation. */
export type DeleteDocumentProcessPayloadDocumentProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};

/** All input for the `deleteDocumentRevisionByNodeId` mutation. */
export type DeleteDocumentRevisionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentRevision` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentRevision` mutation. */
export type DeleteDocumentRevisionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  revisionNumber: Scalars['Int']['input'];
};

/** The output of our delete `DocumentRevision` mutation. */
export type DeleteDocumentRevisionPayload = {
  __typename?: 'DeleteDocumentRevisionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentRevisionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentRevision`. */
  document?: Maybe<Document>;
  /** The `DocumentRevision` that was deleted by this mutation. */
  documentRevision?: Maybe<DocumentRevision>;
  /** An edge for our `DocumentRevision`. May be used by Relay 1. */
  documentRevisionEdge?: Maybe<DocumentRevisionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentRevision` mutation. */
export type DeleteDocumentRevisionPayloadDocumentRevisionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentRevisionsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceAccessByNodeId` mutation. */
export type DeleteDocumentSpaceAccessByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceAccess` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceAccessByUserIdAndDocumentSpaceId` mutation. */
export type DeleteDocumentSpaceAccessByUserIdAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceAccess` mutation. */
export type DeleteDocumentSpaceAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceAccess` mutation. */
export type DeleteDocumentSpaceAccessPayload = {
  __typename?: 'DeleteDocumentSpaceAccessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  creator?: Maybe<User>;
  deletedDocumentSpaceAccessNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceAccess`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceAccess` that was deleted by this mutation. */
  documentSpaceAccess?: Maybe<DocumentSpaceAccess>;
  /** An edge for our `DocumentSpaceAccess`. May be used by Relay 1. */
  documentSpaceAccessEdge?: Maybe<DocumentSpaceAccessesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  user?: Maybe<User>;
};


/** The output of our delete `DocumentSpaceAccess` mutation. */
export type DeleteDocumentSpaceAccessPayloadDocumentSpaceAccessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};

/** All input for the `deleteDocumentSpaceByCodeOnAccessCard` mutation. */
export type DeleteDocumentSpaceByCodeOnAccessCardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeOnAccessCard: Scalars['String']['input'];
};

/** All input for the `deleteDocumentSpaceByNodeId` mutation. */
export type DeleteDocumentSpaceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpace` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceConfigTranslationByConfigIdAndLanguageCode` mutation. */
export type DeleteDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
};

/** All input for the `deleteDocumentSpaceConfigTranslationByNodeId` mutation. */
export type DeleteDocumentSpaceConfigTranslationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceConfigTranslation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceConfigTranslation` mutation. */
export type DeleteDocumentSpaceConfigTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceConfigTranslation` mutation. */
export type DeleteDocumentSpaceConfigTranslationPayload = {
  __typename?: 'DeleteDocumentSpaceConfigTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceConfigTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  deletedDocumentSpaceConfigTranslationNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentSpaceConfigTranslation` that was deleted by this mutation. */
  documentSpaceConfigTranslation?: Maybe<DocumentSpaceConfigTranslation>;
  /** An edge for our `DocumentSpaceConfigTranslation`. May be used by Relay 1. */
  documentSpaceConfigTranslationEdge?: Maybe<DocumentSpaceConfigTranslationsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfigTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentSpaceConfigTranslation` mutation. */
export type DeleteDocumentSpaceConfigTranslationPayloadDocumentSpaceConfigTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceConfigTranslationsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceCrmMappingByDocumentSpaceId` mutation. */
export type DeleteDocumentSpaceCrmMappingByDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceCrmMappingByNodeId` mutation. */
export type DeleteDocumentSpaceCrmMappingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceCrmMapping` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceCrmMapping` mutation. */
export type DeleteDocumentSpaceCrmMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceCrmMapping` mutation. */
export type DeleteDocumentSpaceCrmMappingPayload = {
  __typename?: 'DeleteDocumentSpaceCrmMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `DocumentSpaceCrmMapping`. */
  crmContact?: Maybe<CrmContact>;
  deletedDocumentSpaceCrmMappingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceCrmMapping`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceCrmMapping` that was deleted by this mutation. */
  documentSpaceCrmMapping?: Maybe<DocumentSpaceCrmMapping>;
  /** An edge for our `DocumentSpaceCrmMapping`. May be used by Relay 1. */
  documentSpaceCrmMappingEdge?: Maybe<DocumentSpaceCrmMappingsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `DocumentSpaceCrmMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentSpaceCrmMapping` mutation. */
export type DeleteDocumentSpaceCrmMappingPayloadDocumentSpaceCrmMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};

/** All input for the `deleteDocumentSpace` mutation. */
export type DeleteDocumentSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceItemByDocumentIdAndDocumentSpaceId` mutation. */
export type DeleteDocumentSpaceItemByDocumentIdAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPosition` mutation. */
export type DeleteDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
  sectionId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceItemByNodeId` mutation. */
export type DeleteDocumentSpaceItemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceItem` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceItem` mutation. */
export type DeleteDocumentSpaceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceItem` mutation. */
export type DeleteDocumentSpaceItemPayload = {
  __typename?: 'DeleteDocumentSpaceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceItemNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceItem` that was deleted by this mutation. */
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  /** An edge for our `DocumentSpaceItem`. May be used by Relay 1. */
  documentSpaceItemEdge?: Maybe<DocumentSpaceItemsEdge>;
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
};


/** The output of our delete `DocumentSpaceItem` mutation. */
export type DeleteDocumentSpaceItemPayloadDocumentSpaceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceLinkByNodeId` mutation. */
export type DeleteDocumentSpaceLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLink` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceLinkByPositionAndConfigId` mutation. */
export type DeleteDocumentSpaceLinkByPositionAndConfigIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
};

/** All input for the `deleteDocumentSpaceLinkByPositionAndDocumentSpaceId` mutation. */
export type DeleteDocumentSpaceLinkByPositionAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
};

/** All input for the `deleteDocumentSpaceLinkGroupByNodeId` mutation. */
export type DeleteDocumentSpaceLinkGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLinkGroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceLinkGroupByTenantIdAndId` mutation. */
export type DeleteDocumentSpaceLinkGroupByTenantIdAndIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  tenantId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceLinkGroup` mutation. */
export type DeleteDocumentSpaceLinkGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceLinkGroup` mutation. */
export type DeleteDocumentSpaceLinkGroupPayload = {
  __typename?: 'DeleteDocumentSpaceLinkGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceLinkGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentSpaceLinkGroup` that was deleted by this mutation. */
  documentSpaceLinkGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** An edge for our `DocumentSpaceLinkGroup`. May be used by Relay 1. */
  documentSpaceLinkGroupEdge?: Maybe<DocumentSpaceLinkGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceLinkGroup`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `DocumentSpaceLinkGroup` mutation. */
export type DeleteDocumentSpaceLinkGroupPayloadDocumentSpaceLinkGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkGroupsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceLink` mutation. */
export type DeleteDocumentSpaceLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceLinkMappingByNodeId` mutation. */
export type DeleteDocumentSpaceLinkMappingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLinkMapping` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceLinkMappingBySpaceIdAndLinkId` mutation. */
export type DeleteDocumentSpaceLinkMappingBySpaceIdAndLinkIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  linkId: Scalars['BigInt']['input'];
  spaceId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceLinkMapping` mutation. */
export type DeleteDocumentSpaceLinkMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceLinkMapping` mutation. */
export type DeleteDocumentSpaceLinkMappingPayload = {
  __typename?: 'DeleteDocumentSpaceLinkMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceLinkMappingNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentSpaceLinkMapping` that was deleted by this mutation. */
  documentSpaceLinkMapping?: Maybe<DocumentSpaceLinkMapping>;
  /** An edge for our `DocumentSpaceLinkMapping`. May be used by Relay 1. */
  documentSpaceLinkMappingEdge?: Maybe<DocumentSpaceLinkMappingsEdge>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkMapping`. */
  link?: Maybe<DocumentSpaceLink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLinkMapping`. */
  space?: Maybe<DocumentSpace>;
};


/** The output of our delete `DocumentSpaceLinkMapping` mutation. */
export type DeleteDocumentSpaceLinkMappingPayloadDocumentSpaceLinkMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkMappingsOrderBy>>;
};

/** The output of our delete `DocumentSpaceLink` mutation. */
export type DeleteDocumentSpaceLinkPayload = {
  __typename?: 'DeleteDocumentSpaceLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLink`. */
  config?: Maybe<DocumentSpaceConfig>;
  deletedDocumentSpaceLinkNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLink`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceLink` that was deleted by this mutation. */
  documentSpaceLink?: Maybe<DocumentSpaceLink>;
  /** An edge for our `DocumentSpaceLink`. May be used by Relay 1. */
  documentSpaceLinkEdge?: Maybe<DocumentSpaceLinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentSpaceLink` mutation. */
export type DeleteDocumentSpaceLinkPayloadDocumentSpaceLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinksOrderBy>>;
};

/** All input for the `deleteDocumentSpaceLinkTranslationByLinkIdAndLanguageCode` mutation. */
export type DeleteDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  linkId: Scalars['BigInt']['input'];
};

/** All input for the `deleteDocumentSpaceLinkTranslationByNodeId` mutation. */
export type DeleteDocumentSpaceLinkTranslationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLinkTranslation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCode` mutation. */
export type DeleteDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
  position: Scalars['BigFloat']['input'];
};

/** All input for the `deleteDocumentSpaceLinkTranslation` mutation. */
export type DeleteDocumentSpaceLinkTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceLinkTranslation` mutation. */
export type DeleteDocumentSpaceLinkTranslationPayload = {
  __typename?: 'DeleteDocumentSpaceLinkTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLinkTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  deletedDocumentSpaceLinkTranslationNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentSpaceLinkTranslation` that was deleted by this mutation. */
  documentSpaceLinkTranslation?: Maybe<DocumentSpaceLinkTranslation>;
  /** An edge for our `DocumentSpaceLinkTranslation`. May be used by Relay 1. */
  documentSpaceLinkTranslationEdge?: Maybe<DocumentSpaceLinkTranslationsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceLinkTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkTranslation`. */
  link?: Maybe<DocumentSpaceLink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentSpaceLinkTranslation` mutation. */
export type DeleteDocumentSpaceLinkTranslationPayloadDocumentSpaceLinkTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};

/** The output of our delete `DocumentSpace` mutation. */
export type DeleteDocumentSpacePayload = {
  __typename?: 'DeleteDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpace`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `User` that is related to this `DocumentSpace`. */
  creator?: Maybe<User>;
  deletedDocumentSpaceNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentSpace` that was deleted by this mutation. */
  documentSpace?: Maybe<DocumentSpace>;
  /** An edge for our `DocumentSpace`. May be used by Relay 1. */
  documentSpaceEdge?: Maybe<DocumentSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpace`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `DocumentSpace` mutation. */
export type DeleteDocumentSpacePayloadDocumentSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};

/** All input for the `deleteDocumentSpaceSection` mutation. */
export type DeleteDocumentSpaceSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  moveDocumentsToSectionId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `deleteDocumentSpaceSection` mutation. */
export type DeleteDocumentSpaceSectionPayload = {
  __typename?: 'DeleteDocumentSpaceSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSection`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceSection?: Maybe<DocumentSpaceSection>;
  /** An edge for our `DocumentSpaceSection`. May be used by Relay 1. */
  documentSpaceSectionEdge?: Maybe<DocumentSpaceSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteDocumentSpaceSection` mutation. */
export type DeleteDocumentSpaceSectionPayloadDocumentSpaceSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSectionsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceSessionByFingerprintAndDocumentSpaceId` mutation. */
export type DeleteDocumentSpaceSessionByFingerprintAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  fingerprint: Scalars['String']['input'];
};

/** All input for the `deleteDocumentSpaceSessionByNodeId` mutation. */
export type DeleteDocumentSpaceSessionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceSession` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceSession` mutation. */
export type DeleteDocumentSpaceSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fingerprint: Scalars['String']['input'];
};

/** The output of our delete `DocumentSpaceSession` mutation. */
export type DeleteDocumentSpaceSessionPayload = {
  __typename?: 'DeleteDocumentSpaceSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceSessionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSession`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceSession` that was deleted by this mutation. */
  documentSpaceSession?: Maybe<DocumentSpaceSession>;
  /** An edge for our `DocumentSpaceSession`. May be used by Relay 1. */
  documentSpaceSessionEdge?: Maybe<DocumentSpaceSessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentSpaceSession` mutation. */
export type DeleteDocumentSpaceSessionPayloadDocumentSpaceSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSessionsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceTagByNodeId` mutation. */
export type DeleteDocumentSpaceTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceTag` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceTag` mutation. */
export type DeleteDocumentSpaceTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceTag` mutation. */
export type DeleteDocumentSpaceTagPayload = {
  __typename?: 'DeleteDocumentSpaceTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceTagNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DocumentSpaceTag` that was deleted by this mutation. */
  documentSpaceTag?: Maybe<DocumentSpaceTag>;
  /** An edge for our `DocumentSpaceTag`. May be used by Relay 1. */
  documentSpaceTagEdge?: Maybe<DocumentSpaceTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceTag`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `DocumentSpaceTag` mutation. */
export type DeleteDocumentSpaceTagPayloadDocumentSpaceTagEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceTagsOrderBy>>;
};

/** All input for the `deleteDocumentSpaceVoucherByNodeId` mutation. */
export type DeleteDocumentSpaceVoucherByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceVoucher` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDocumentSpaceVoucher` mutation. */
export type DeleteDocumentSpaceVoucherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DocumentSpaceVoucher` mutation. */
export type DeleteDocumentSpaceVoucherPayload = {
  __typename?: 'DeleteDocumentSpaceVoucherPayload';
  /** Reads a single `CampaignPhaseLink` that is related to this `DocumentSpaceVoucher`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceVoucherNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceVoucher`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceVoucher` that was deleted by this mutation. */
  documentSpaceVoucher?: Maybe<DocumentSpaceVoucher>;
  /** An edge for our `DocumentSpaceVoucher`. May be used by Relay 1. */
  documentSpaceVoucherEdge?: Maybe<DocumentSpaceVouchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentSpaceVoucher` mutation. */
export type DeleteDocumentSpaceVoucherPayloadDocumentSpaceVoucherEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceVouchersOrderBy>>;
};

/** All input for the `deleteFlowByNodeId` mutation. */
export type DeleteFlowByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Flow` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteFlow` mutation. */
export type DeleteFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `deleteFlowItemByNodeId` mutation. */
export type DeleteFlowItemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FlowItem` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteFlowItem` mutation. */
export type DeleteFlowItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `FlowItem` mutation. */
export type DeleteFlowItemPayload = {
  __typename?: 'DeleteFlowItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `FlowItem`. */
  creator?: Maybe<User>;
  deletedFlowItemNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Flow` that is related to this `FlowItem`. */
  flow?: Maybe<Flow>;
  /** The `FlowItem` that was deleted by this mutation. */
  flowItem?: Maybe<FlowItem>;
  /** An edge for our `FlowItem`. May be used by Relay 1. */
  flowItemEdge?: Maybe<FlowItemsEdge>;
  /** Reads a single `DocumentPage` that is related to this `FlowItem`. */
  page?: Maybe<DocumentPage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Document` that is related to this `FlowItem`. */
  video?: Maybe<Document>;
};


/** The output of our delete `FlowItem` mutation. */
export type DeleteFlowItemPayloadFlowItemEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};

/** The output of our delete `Flow` mutation. */
export type DeleteFlowPayload = {
  __typename?: 'DeleteFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Flow`. */
  creator?: Maybe<User>;
  deletedFlowNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Flow` that was deleted by this mutation. */
  flow?: Maybe<Flow>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Reads a single `Flow` that is related to this `Flow`. */
  parent?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Flow` mutation. */
export type DeleteFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the `deleteFlowSubscriptionByFlowIdAndTeamId` mutation. */
export type DeleteFlowSubscriptionByFlowIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `deleteFlowSubscriptionByFlowIdAndUserId` mutation. */
export type DeleteFlowSubscriptionByFlowIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** All input for the `deleteFlowSubscriptionByNodeId` mutation. */
export type DeleteFlowSubscriptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FlowSubscription` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteFlowSubscription` mutation. */
export type DeleteFlowSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `FlowSubscription` mutation. */
export type DeleteFlowSubscriptionPayload = {
  __typename?: 'DeleteFlowSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFlowSubscriptionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Flow` that is related to this `FlowSubscription`. */
  flow?: Maybe<Flow>;
  /** The `FlowSubscription` that was deleted by this mutation. */
  flowSubscription?: Maybe<FlowSubscription>;
  /** An edge for our `FlowSubscription`. May be used by Relay 1. */
  flowSubscriptionEdge?: Maybe<FlowSubscriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `FlowSubscription`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `FlowSubscription`. */
  user?: Maybe<User>;
};


/** The output of our delete `FlowSubscription` mutation. */
export type DeleteFlowSubscriptionPayloadFlowSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};

/** All input for the `deleteInternalIpAddressByNodeId` mutation. */
export type DeleteInternalIpAddressByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `InternalIpAddress` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteInternalIpAddress` mutation. */
export type DeleteInternalIpAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `InternalIpAddress` mutation. */
export type DeleteInternalIpAddressPayload = {
  __typename?: 'DeleteInternalIpAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInternalIpAddressNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `InternalIpAddress` that was deleted by this mutation. */
  internalIpAddress?: Maybe<InternalIpAddress>;
  /** An edge for our `InternalIpAddress`. May be used by Relay 1. */
  internalIpAddressEdge?: Maybe<InternalIpAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `InternalIpAddress`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `InternalIpAddress` mutation. */
export type DeleteInternalIpAddressPayloadInternalIpAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InternalIpAddressesOrderBy>>;
};

/** All input for the `deleteLabelsOfDocumentViewByNodeId` mutation. */
export type DeleteLabelsOfDocumentViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LabelsOfDocumentView` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteLabelsOfDocumentView` mutation. */
export type DeleteLabelsOfDocumentViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentViewId: Scalars['UUID']['input'];
};

/** The output of our delete `LabelsOfDocumentView` mutation. */
export type DeleteLabelsOfDocumentViewPayload = {
  __typename?: 'DeleteLabelsOfDocumentViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `LabelsOfDocumentView`. */
  crmContact?: Maybe<CrmContact>;
  deletedLabelsOfDocumentViewNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LabelsOfDocumentView` that was deleted by this mutation. */
  labelsOfDocumentView?: Maybe<LabelsOfDocumentView>;
  /** An edge for our `LabelsOfDocumentView`. May be used by Relay 1. */
  labelsOfDocumentViewEdge?: Maybe<LabelsOfDocumentViewsEdge>;
  /** Reads a single `User` that is related to this `LabelsOfDocumentView`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `CrmContactMatch` that is related to this `LabelsOfDocumentView`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LabelsOfDocumentView` mutation. */
export type DeleteLabelsOfDocumentViewPayloadLabelsOfDocumentViewEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};

/** All input for the `deleteLanguageCodeByNodeId` mutation. */
export type DeleteLanguageCodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LanguageCode` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteLanguageCode` mutation. */
export type DeleteLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

/** The output of our delete `LanguageCode` mutation. */
export type DeleteLanguageCodePayload = {
  __typename?: 'DeleteLanguageCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLanguageCodeNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LanguageCode` that was deleted by this mutation. */
  languageCode?: Maybe<LanguageCode>;
  /** An edge for our `LanguageCode`. May be used by Relay 1. */
  languageCodeEdge?: Maybe<LanguageCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LanguageCode` mutation. */
export type DeleteLanguageCodePayloadLanguageCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<LanguageCodesOrderBy>>;
};

/** All input for the `deleteMembershipByNodeId` mutation. */
export type DeleteMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Membership` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteMembershipBySubteamIdAndTeamId` mutation. */
export type DeleteMembershipBySubteamIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subteamId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `deleteMembershipByUserIdAndTeamId` mutation. */
export type DeleteMembershipByUserIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** All input for the `deleteMembership` mutation. */
export type DeleteMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Membership` mutation. */
export type DeleteMembershipPayload = {
  __typename?: 'DeleteMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMembershipNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Membership` that was deleted by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our delete `Membership` mutation. */
export type DeleteMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the `deleteMultipleFlowItems` mutation. */
export type DeleteMultipleFlowItemsInput = {
  byId?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `deleteMultipleFlowItems` mutation. */
export type DeleteMultipleFlowItemsPayload = {
  __typename?: 'DeleteMultipleFlowItemsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteNotificationByNodeId` mutation. */
export type DeleteNotificationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Notification` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteNotification` mutation. */
export type DeleteNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `Notification` mutation. */
export type DeleteNotificationPayload = {
  __typename?: 'DeleteNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNotificationNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Notification` that was deleted by this mutation. */
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our delete `Notification` mutation. */
export type DeleteNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `deleteOrderByNodeId` mutation. */
export type DeleteOrderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Order` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteOrder` mutation. */
export type DeleteOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Order` mutation. */
export type DeleteOrderPayload = {
  __typename?: 'DeleteOrderPayload';
  /** Reads a single `User` that is related to this `Order`. */
  admin?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Order` that was deleted by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Order`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `Order` mutation. */
export type DeleteOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `deleteRegistrationTokenByNodeId` mutation. */
export type DeleteRegistrationTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RegistrationToken` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteRegistrationToken` mutation. */
export type DeleteRegistrationTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  registrationToken: Scalars['String']['input'];
};

/** The output of our delete `RegistrationToken` mutation. */
export type DeleteRegistrationTokenPayload = {
  __typename?: 'DeleteRegistrationTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRegistrationTokenNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RegistrationToken` that was deleted by this mutation. */
  registrationToken?: Maybe<RegistrationToken>;
  /** An edge for our `RegistrationToken`. May be used by Relay 1. */
  registrationTokenEdge?: Maybe<RegistrationTokensEdge>;
  /** Reads a single `User` that is related to this `RegistrationToken`. */
  user?: Maybe<User>;
};


/** The output of our delete `RegistrationToken` mutation. */
export type DeleteRegistrationTokenPayloadRegistrationTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<RegistrationTokensOrderBy>>;
};

/** All input for the `deleteRetentionPolicyByNodeId` mutation. */
export type DeleteRetentionPolicyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RetentionPolicy` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteRetentionPolicyByTeamId` mutation. */
export type DeleteRetentionPolicyByTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `deleteRetentionPolicyByTenantId` mutation. */
export type DeleteRetentionPolicyByTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['BigInt']['input'];
};

/** All input for the `deleteRetentionPolicyByWorkspaceId` mutation. */
export type DeleteRetentionPolicyByWorkspaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['BigInt']['input'];
};

/** All input for the `deleteRetentionPolicy` mutation. */
export type DeleteRetentionPolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `RetentionPolicy` mutation. */
export type DeleteRetentionPolicyPayload = {
  __typename?: 'DeleteRetentionPolicyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRetentionPolicyNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RetentionPolicy` that was deleted by this mutation. */
  retentionPolicy?: Maybe<RetentionPolicy>;
  /** An edge for our `RetentionPolicy`. May be used by Relay 1. */
  retentionPolicyEdge?: Maybe<RetentionPoliciesEdge>;
  /** Reads a single `Team` that is related to this `RetentionPolicy`. */
  team?: Maybe<Team>;
  /** Reads a single `Tenant` that is related to this `RetentionPolicy`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `Workspace` that is related to this `RetentionPolicy`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our delete `RetentionPolicy` mutation. */
export type DeleteRetentionPolicyPayloadRetentionPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};

/** All input for the `deleteSchemaMigrationByNodeId` mutation. */
export type DeleteSchemaMigrationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaMigration` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteSchemaMigration` mutation. */
export type DeleteSchemaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};

/** The output of our delete `SchemaMigration` mutation. */
export type DeleteSchemaMigrationPayload = {
  __typename?: 'DeleteSchemaMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaMigrationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigration` that was deleted by this mutation. */
  schemaMigration?: Maybe<SchemaMigration>;
  /** An edge for our `SchemaMigration`. May be used by Relay 1. */
  schemaMigrationEdge?: Maybe<SchemaMigrationsEdge>;
};


/** The output of our delete `SchemaMigration` mutation. */
export type DeleteSchemaMigrationPayloadSchemaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};

/** All input for the `deleteSettingByNodeId` mutation. */
export type DeleteSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Setting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteSetting` mutation. */
export type DeleteSettingInput = {
  attribute: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our delete `Setting` mutation. */
export type DeleteSettingPayload = {
  __typename?: 'DeleteSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSettingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Setting` that was deleted by this mutation. */
  setting?: Maybe<Setting>;
  /** An edge for our `Setting`. May be used by Relay 1. */
  settingEdge?: Maybe<SettingsEdge>;
};


/** The output of our delete `Setting` mutation. */
export type DeleteSettingPayloadSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<SettingsOrderBy>>;
};

/** All input for the `deleteSharedSpaceTemplate` mutation. */
export type DeleteSharedSpaceTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  replacementConfigId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `deleteSharedSpaceTemplate` mutation. */
export type DeleteSharedSpaceTemplatePayload = {
  __typename?: 'DeleteSharedSpaceTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<DeleteSharedSpaceTemplateRecord>;
};

/** The return type of our `deleteSharedSpaceTemplate` mutation. */
export type DeleteSharedSpaceTemplateRecord = {
  __typename?: 'DeleteSharedSpaceTemplateRecord';
  affectedSpaceCount?: Maybe<Scalars['Int']['output']>;
  deletedConfigId?: Maybe<Scalars['BigInt']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  usedReplacementConfigId?: Maybe<Scalars['BigInt']['output']>;
};

/** All input for the `deleteTeamByNodeId` mutation. */
export type DeleteTeamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Team` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteTeam` mutation. */
export type DeleteTeamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Team` mutation. */
export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTeamNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Team` that was deleted by this mutation. */
  team?: Maybe<Team>;
  /** An edge for our `Team`. May be used by Relay 1. */
  teamEdge?: Maybe<TeamsEdge>;
  /** Reads a single `Tenant` that is related to this `Team`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `Team` mutation. */
export type DeleteTeamPayloadTeamEdgeArgs = {
  orderBy?: InputMaybe<Array<TeamsOrderBy>>;
};

/** All input for the `deleteTenantByName` mutation. */
export type DeleteTenantByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** All input for the `deleteTenantByNodeId` mutation. */
export type DeleteTenantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Tenant` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteTenant` mutation. */
export type DeleteTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Tenant` mutation. */
export type DeleteTenantPayload = {
  __typename?: 'DeleteTenantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTenantNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was deleted by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
  /** Reads a single `Workspace` that is related to this `Tenant`. */
  tutorialWorkspace?: Maybe<Workspace>;
};


/** The output of our delete `Tenant` mutation. */
export type DeleteTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the `deleteUrlBasedDocumentImportByNodeId` mutation. */
export type DeleteUrlBasedDocumentImportByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UrlBasedDocumentImport` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUrlBasedDocumentImport` mutation. */
export type DeleteUrlBasedDocumentImportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `UrlBasedDocumentImport` mutation. */
export type DeleteUrlBasedDocumentImportPayload = {
  __typename?: 'DeleteUrlBasedDocumentImportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUrlBasedDocumentImportNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImport`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UrlBasedDocumentImport` that was deleted by this mutation. */
  urlBasedDocumentImport?: Maybe<UrlBasedDocumentImport>;
  /** An edge for our `UrlBasedDocumentImport`. May be used by Relay 1. */
  urlBasedDocumentImportEdge?: Maybe<UrlBasedDocumentImportsEdge>;
};


/** The output of our delete `UrlBasedDocumentImport` mutation. */
export type DeleteUrlBasedDocumentImportPayloadUrlBasedDocumentImportEdgeArgs = {
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportsOrderBy>>;
};

/** All input for the `deleteUrlBasedDocumentImportSettingByNodeId` mutation. */
export type DeleteUrlBasedDocumentImportSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UrlBasedDocumentImportSetting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUrlBasedDocumentImportSetting` mutation. */
export type DeleteUrlBasedDocumentImportSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
};

/** The output of our delete `UrlBasedDocumentImportSetting` mutation. */
export type DeleteUrlBasedDocumentImportSettingPayload = {
  __typename?: 'DeleteUrlBasedDocumentImportSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUrlBasedDocumentImportSettingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImportSetting`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UrlBasedDocumentImportSetting`. */
  updatedBy?: Maybe<User>;
  /** The `UrlBasedDocumentImportSetting` that was deleted by this mutation. */
  urlBasedDocumentImportSetting?: Maybe<UrlBasedDocumentImportSetting>;
  /** An edge for our `UrlBasedDocumentImportSetting`. May be used by Relay 1. */
  urlBasedDocumentImportSettingEdge?: Maybe<UrlBasedDocumentImportSettingsEdge>;
};


/** The output of our delete `UrlBasedDocumentImportSetting` mutation. */
export type DeleteUrlBasedDocumentImportSettingPayloadUrlBasedDocumentImportSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportSettingsOrderBy>>;
};

/** All input for the `deleteUserContactDetailByNodeId` mutation. */
export type DeleteUserContactDetailByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserContactDetail` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserContactDetailByUserId` mutation. */
export type DeleteUserContactDetailByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['BigInt']['input'];
};

/** All input for the `deleteUserContactDetail` mutation. */
export type DeleteUserContactDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `UserContactDetail` mutation. */
export type DeleteUserContactDetailPayload = {
  __typename?: 'DeleteUserContactDetailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserContactDetailNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContactDetail`. */
  user?: Maybe<User>;
  /** The `UserContactDetail` that was deleted by this mutation. */
  userContactDetail?: Maybe<UserContactDetail>;
  /** An edge for our `UserContactDetail`. May be used by Relay 1. */
  userContactDetailEdge?: Maybe<UserContactDetailsEdge>;
};


/** The output of our delete `UserContactDetail` mutation. */
export type DeleteUserContactDetailPayloadUserContactDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContactDetailsOrderBy>>;
};

/** All input for the `deleteUserLicenseByNodeId` mutation. */
export type DeleteUserLicenseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserLicense` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserLicense` mutation. */
export type DeleteUserLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** The output of our delete `UserLicense` mutation. */
export type DeleteUserLicensePayload = {
  __typename?: 'DeleteUserLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserLicenseNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `User` that is related to this `UserLicense`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Order` that is related to this `UserLicense`. */
  order?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserLicense`. */
  user?: Maybe<User>;
  /** The `UserLicense` that was deleted by this mutation. */
  userLicense?: Maybe<UserLicense>;
  /** An edge for our `UserLicense`. May be used by Relay 1. */
  userLicenseEdge?: Maybe<UserLicensesEdge>;
};


/** The output of our delete `UserLicense` mutation. */
export type DeleteUserLicensePayloadUserLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};

/** All input for the `deleteVeevaDocumentMetadatumByNodeId` mutation. */
export type DeleteVeevaDocumentMetadatumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VeevaDocumentMetadatum` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteVeevaDocumentMetadatum` mutation. */
export type DeleteVeevaDocumentMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
};

/** The output of our delete `VeevaDocumentMetadatum` mutation. */
export type DeleteVeevaDocumentMetadatumPayload = {
  __typename?: 'DeleteVeevaDocumentMetadatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVeevaDocumentMetadatumNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `VeevaDocumentMetadatum`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VeevaDocumentMetadatum` that was deleted by this mutation. */
  veevaDocumentMetadatum?: Maybe<VeevaDocumentMetadatum>;
  /** An edge for our `VeevaDocumentMetadatum`. May be used by Relay 1. */
  veevaDocumentMetadatumEdge?: Maybe<VeevaDocumentMetadataEdge>;
};


/** The output of our delete `VeevaDocumentMetadatum` mutation. */
export type DeleteVeevaDocumentMetadatumPayloadVeevaDocumentMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<VeevaDocumentMetadataOrderBy>>;
};

/** All input for the `deleteWorkspaceByFirebaseId` mutation. */
export type DeleteWorkspaceByFirebaseIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firebaseId: Scalars['String']['input'];
};

/** All input for the `deleteWorkspaceByNodeId` mutation. */
export type DeleteWorkspaceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Workspace` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWorkspace` mutation. */
export type DeleteWorkspaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Workspace` mutation. */
export type DeleteWorkspacePayload = {
  __typename?: 'DeleteWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `Workspace`. */
  defaultLegalAppendix?: Maybe<Document>;
  deletedWorkspaceNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Workspace` that is related to this `Workspace`. */
  parent?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `Workspace`. */
  personalWorkspaceOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Workspace`. */
  tenant?: Maybe<Tenant>;
  /** The `Workspace` that was deleted by this mutation. */
  workspace?: Maybe<Workspace>;
  /** An edge for our `Workspace`. May be used by Relay 1. */
  workspaceEdge?: Maybe<WorkspacesEdge>;
};


/** The output of our delete `Workspace` mutation. */
export type DeleteWorkspacePayloadWorkspaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

/** All input for the `deleteWorkspaceSubscriptionByNodeId` mutation. */
export type DeleteWorkspaceSubscriptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkspaceSubscription` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWorkspaceSubscriptionBySubteamIdAndTeamId` mutation. */
export type DeleteWorkspaceSubscriptionBySubteamIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subteamId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `deleteWorkspaceSubscriptionByUserIdAndTeamId` mutation. */
export type DeleteWorkspaceSubscriptionByUserIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** All input for the `deleteWorkspaceSubscription` mutation. */
export type DeleteWorkspaceSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `WorkspaceSubscription` mutation. */
export type DeleteWorkspaceSubscriptionPayload = {
  __typename?: 'DeleteWorkspaceSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWorkspaceSubscriptionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  /** The `WorkspaceSubscription` that was deleted by this mutation. */
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** An edge for our `WorkspaceSubscription`. May be used by Relay 1. */
  workspaceSubscriptionEdge?: Maybe<WorkspaceSubscriptionsEdge>;
};


/** The output of our delete `WorkspaceSubscription` mutation. */
export type DeleteWorkspaceSubscriptionPayloadWorkspaceSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

export type Document = Node & {
  __typename?: 'Document';
  /** Reads and enables pagination through a set of `Document`. */
  allLinkedDocuments: DocumentsConnection;
  /** Allow signed-in readers to download this document in Classic. Independent of Shared Space downloads. Only document administrators may update it. */
  allowUserDownload: Scalars['Boolean']['output'];
  avgWatchTimeInPresentationsOverTime: DocumentsAvgWatchTimeInPresentationsOverTimeConnection;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Document`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `DocumentPage`. */
  currentDocumentPages: DocumentPagesConnection;
  currentRevisionNumber?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  displayDate: Scalars['Datetime']['output'];
  displayTeaserTextInSpace: Scalars['Boolean']['output'];
  displayTitle: Scalars['String']['output'];
  /** Reads a single `DocumentExpiration` that is related to this `Document`. */
  documentExpiration?: Maybe<DocumentExpiration>;
  /**
   * Reads and enables pagination through a set of `DocumentExpiration`.
   * @deprecated Please use documentExpiration instead
   */
  documentExpirations: DocumentExpirationsConnection;
  /** Reads and enables pagination through a set of `DocumentHistoryEntry`. */
  documentHistoryEntries: DocumentHistoryEntriesConnection;
  /** Reads and enables pagination through a set of `DocumentPageMatching`. */
  documentPageMatchings: DocumentPageMatchingsConnection;
  /** Reads and enables pagination through a set of `DocumentPage`. */
  documentPages: DocumentPagesConnection;
  /** Reads and enables pagination through a set of `DocumentPage`. */
  documentPagesByLinkedDocumentId: DocumentPagesConnection;
  /** Reads and enables pagination through a set of `DocumentProcess`. */
  documentProcesses: DocumentProcessesConnection;
  /** Reads a single `DocumentRevision` that is related to this `Document`. */
  documentRevisionByIdAndCurrentRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads and enables pagination through a set of `DocumentRevision`. */
  documentRevisions: DocumentRevisionsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceItem`. */
  documentSpaceItems: DocumentSpaceItemsConnection;
  /** Reads and enables pagination through a set of `Document`. */
  documentsByLegalAppendixId: DocumentsConnection;
  doesSupportFlows: Scalars['Boolean']['output'];
  doesSupportSharedspace: Scalars['Boolean']['output'];
  downloadUrl: Scalars['String']['output'];
  enableMagicPages?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['Datetime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLinkId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  firestoreId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `FlowItem`. */
  flowItemsByVideoId: FlowItemsConnection;
  id: Scalars['BigInt']['output'];
  /** @deprecated Use `normalPages` instead */
  ignoredPages: Scalars['Int']['output'];
  importSource?: Maybe<Scalars['String']['output']>;
  initialFileName: Scalars['String']['output'];
  internalLinks: Scalars['JSON']['output'];
  isDownloadable: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isUnbranded: Scalars['Boolean']['output'];
  lastModifiedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Document`. */
  lastModifiedBy?: Maybe<User>;
  lastModifiedById?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Document` that is related to this `Document`. */
  legalAppendix?: Maybe<Document>;
  legalAppendixId?: Maybe<Scalars['BigInt']['output']>;
  /** @sortable@filterable */
  linkingPages: DocumentPagesConnection;
  linksCanBeClickedByViewer: Scalars['Boolean']['output'];
  literatureReferences: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `MaDocumentSpaceDocumentStatistic`. */
  maDocumentSpaceDocumentStatistics: MaDocumentSpaceDocumentStatisticsConnection;
  /** Reads and enables pagination through a set of `MaDocumentSpacePageStatistic`. */
  maDocumentSpacePageStatistics: MaDocumentSpacePageStatisticsConnection;
  /** Reads and enables pagination through a set of `MaDocumentSpaceVideoStatistic`. */
  maDocumentSpaceVideoStatistics: MaDocumentSpaceVideoStatisticsConnection;
  mimeType: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numNormalPages: Scalars['Int']['output'];
  order: Scalars['BigFloat']['output'];
  originalDownloadUrl?: Maybe<Scalars['String']['output']>;
  originalMimeType?: Maybe<Scalars['String']['output']>;
  originalStorageId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PageHeatmap`. */
  pageHeatmap: PageHeatmapsConnection;
  pages: Scalars['Int']['output'];
  rootWorkspace?: Maybe<Workspace>;
  spaceUsageCount?: Maybe<Scalars['Int']['output']>;
  storageId: Scalars['String']['output'];
  sysPeriod: DatetimeRange;
  tags: Array<Maybe<Scalars['String']['output']>>;
  teaserText: Scalars['String']['output'];
  thumbnailDownloadUrl: Scalars['String']['output'];
  thumbnailStorageId: Scalars['String']['output'];
  topTitle: Scalars['String']['output'];
  uploadedAt: Scalars['Datetime']['output'];
  /** Reads a single `UrlBasedDocumentImportSetting` that is related to this `Document`. */
  urlBasedDocumentImportSetting?: Maybe<UrlBasedDocumentImportSetting>;
  /**
   * Reads and enables pagination through a set of `UrlBasedDocumentImportSetting`.
   * @deprecated Please use urlBasedDocumentImportSetting instead
   */
  urlBasedDocumentImportSettings: UrlBasedDocumentImportSettingsConnection;
  /** Reads and enables pagination through a set of `UrlBasedDocumentImport`. */
  urlBasedDocumentImports: UrlBasedDocumentImportsConnection;
  /**
   * Reads and enables pagination through a set of `VeevaDocumentMetadatum`.
   * @deprecated Please use veevaDocumentMetadatum instead
   */
  veevaDocumentMetadata: VeevaDocumentMetadataConnection;
  /** Reads a single `VeevaDocumentMetadatum` that is related to this `Document`. */
  veevaDocumentMetadatum?: Maybe<VeevaDocumentMetadatum>;
  viewsInPresentationsOverTime: DocumentsViewsInPresentationsOverTimeConnection;
  /** Reads a single `Workspace` that is related to this `Document`. */
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `Workspace`. */
  workspacesByDefaultLegalAppendixId: WorkspacesConnection;
};


export type DocumentAllLinkedDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentAvgWatchTimeInPresentationsOverTimeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentsAvgWatchTimeInPresentationsOverTimeRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skipViewsIfShorterThan?: InputMaybe<IntervalInput>;
  step?: InputMaybe<IntervalInput>;
  timeFrame?: InputMaybe<DatetimeRangeInput>;
};


export type DocumentCurrentDocumentPagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentDocumentExpirationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentExpirationCondition>;
  filter?: InputMaybe<DocumentExpirationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentExpirationsOrderBy>>;
};


export type DocumentDocumentHistoryEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentHistoryEntryCondition>;
  filter?: InputMaybe<DocumentHistoryEntryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentHistoryEntriesOrderBy>>;
};


export type DocumentDocumentPageMatchingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingCondition>;
  filter?: InputMaybe<DocumentPageMatchingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};


export type DocumentDocumentPagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageCondition>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};


export type DocumentDocumentPagesByLinkedDocumentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageCondition>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};


export type DocumentDocumentProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentProcessCondition>;
  filter?: InputMaybe<DocumentProcessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};


export type DocumentDocumentRevisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentRevisionCondition>;
  filter?: InputMaybe<DocumentRevisionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentRevisionsOrderBy>>;
};


export type DocumentDocumentSpaceItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceItemCondition>;
  filter?: InputMaybe<DocumentSpaceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};


export type DocumentDocumentsByLegalAppendixIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentCondition>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};


export type DocumentFlowItemsByVideoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowItemCondition>;
  filter?: InputMaybe<FlowItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};


export type DocumentLinkingPagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentMaDocumentSpaceDocumentStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceDocumentStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceDocumentStatisticsOrderBy>>;
};


export type DocumentMaDocumentSpacePageStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpacePageStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpacePageStatisticsOrderBy>>;
};


export type DocumentMaDocumentSpaceVideoStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceVideoStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceVideoStatisticsOrderBy>>;
};


export type DocumentPageHeatmapArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PageHeatmapCondition>;
  filter?: InputMaybe<PageHeatmapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PageHeatmapsOrderBy>>;
  skipViewsIfShorterThan?: InputMaybe<IntervalInput>;
  timeFrame?: InputMaybe<DatetimeRangeInput>;
};


export type DocumentUrlBasedDocumentImportSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UrlBasedDocumentImportSettingCondition>;
  filter?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportSettingsOrderBy>>;
};


export type DocumentUrlBasedDocumentImportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UrlBasedDocumentImportCondition>;
  filter?: InputMaybe<UrlBasedDocumentImportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportsOrderBy>>;
};


export type DocumentVeevaDocumentMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VeevaDocumentMetadatumCondition>;
  filter?: InputMaybe<VeevaDocumentMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VeevaDocumentMetadataOrderBy>>;
};


export type DocumentViewsInPresentationsOverTimeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentsViewsInPresentationsOverTimeRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skipViewsIfShorterThan?: InputMaybe<IntervalInput>;
  step?: InputMaybe<IntervalInput>;
  timeFrame?: InputMaybe<DatetimeRangeInput>;
};


export type DocumentWorkspacesByDefaultLegalAppendixIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceCondition>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

/**
 * A condition to be used against `Document` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DocumentCondition = {
  /** Checks for equality with the object’s `allowUserDownload` field. */
  allowUserDownload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `currentRevisionNumber` field. */
  currentRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `displayDate` field. */
  displayDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `displayTeaserTextInSpace` field. */
  displayTeaserTextInSpace?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `doesSupportFlows` field. */
  doesSupportFlows?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `doesSupportSharedspace` field. */
  doesSupportSharedspace?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `downloadUrl` field. */
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `enableMagicPages` field. */
  enableMagicPages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalLinkId` field. */
  externalLinkId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fileName` field. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fileSize` field. */
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `firestoreId` field. */
  firestoreId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `ignoredPages` field. */
  ignoredPages?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `initialFileName` field. */
  initialFileName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `internalLinks` field. */
  internalLinks?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `isDownloadable` field. */
  isDownloadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isPublished` field. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isUnbranded` field. */
  isUnbranded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lastModifiedAt` field. */
  lastModifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `lastModifiedById` field. */
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `legalAppendixId` field. */
  legalAppendixId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `linksCanBeClickedByViewer` field. */
  linksCanBeClickedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `literatureReferences` field. */
  literatureReferences?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `mimeType` field. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `originalDownloadUrl` field. */
  originalDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalMimeType` field. */
  originalMimeType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalStorageId` field. */
  originalStorageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pages` field. */
  pages?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `storageId` field. */
  storageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `teaserText` field. */
  teaserText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `thumbnailStorageId` field. */
  thumbnailStorageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `topTitle` field. */
  topTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `uploadedAt` field. */
  uploadedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type DocumentExpiration = Node & {
  __typename?: 'DocumentExpiration';
  /** Reads a single `Document` that is related to this `DocumentExpiration`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  expiredAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `DocumentExpiration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentExpirationCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `expiredAt` field. */
  expiredAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentExpiration` object types. All fields are combined with a logical ‘and.’ */
export type DocumentExpirationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentExpirationFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `expiredAt` field. */
  expiredAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentExpirationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentExpirationFilter>>;
};

/** An input for mutations affecting `DocumentExpiration` */
export type DocumentExpirationInput = {
  documentId: Scalars['BigInt']['input'];
  expiredAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentExpiration`. Fields that are set will be updated. */
export type DocumentExpirationPatch = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  expiredAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentExpiration` values. */
export type DocumentExpirationsConnection = {
  __typename?: 'DocumentExpirationsConnection';
  /** A list of edges which contains the `DocumentExpiration` and cursor to aid in pagination. */
  edges: Array<DocumentExpirationsEdge>;
  /** A list of `DocumentExpiration` objects. */
  nodes: Array<Maybe<DocumentExpiration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentExpiration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentExpiration` edge in the connection. */
export type DocumentExpirationsEdge = {
  __typename?: 'DocumentExpirationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentExpiration` at the end of the edge. */
  node?: Maybe<DocumentExpiration>;
};

/** Methods to use when ordering `DocumentExpiration`. */
export enum DocumentExpirationsOrderBy {
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  ExpiredAtAsc = 'EXPIRED_AT_ASC',
  ExpiredAtDesc = 'EXPIRED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against `Document` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFilter = {
  /** Filter by the object’s `allowUserDownload` field. */
  allowUserDownload?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` relation. */
  createdBy?: InputMaybe<UserFilter>;
  /** A related `createdBy` exists. */
  createdByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `currentRevisionNumber` field. */
  currentRevisionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayDate` field. */
  displayDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayTeaserTextInSpace` field. */
  displayTeaserTextInSpace?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentExpiration` relation. */
  documentExpiration?: InputMaybe<DocumentExpirationFilter>;
  /** A related `documentExpiration` exists. */
  documentExpirationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentHistoryEntries` relation. */
  documentHistoryEntries?: InputMaybe<DocumentToManyDocumentHistoryEntryFilter>;
  /** Some related `documentHistoryEntries` exist. */
  documentHistoryEntriesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPageMatchings` relation. */
  documentPageMatchings?: InputMaybe<DocumentToManyDocumentPageMatchingFilter>;
  /** Some related `documentPageMatchings` exist. */
  documentPageMatchingsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPages` relation. */
  documentPages?: InputMaybe<DocumentToManyDocumentPageFilter>;
  /** Filter by the object’s `documentPagesByLinkedDocumentId` relation. */
  documentPagesByLinkedDocumentId?: InputMaybe<DocumentToManyDocumentPageFilter>;
  /** Some related `documentPagesByLinkedDocumentId` exist. */
  documentPagesByLinkedDocumentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `documentPages` exist. */
  documentPagesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentProcesses` relation. */
  documentProcesses?: InputMaybe<DocumentToManyDocumentProcessFilter>;
  /** Some related `documentProcesses` exist. */
  documentProcessesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentRevisionByIdAndCurrentRevisionNumber` relation. */
  documentRevisionByIdAndCurrentRevisionNumber?: InputMaybe<DocumentRevisionFilter>;
  /** A related `documentRevisionByIdAndCurrentRevisionNumber` exists. */
  documentRevisionByIdAndCurrentRevisionNumberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentRevisions` relation. */
  documentRevisions?: InputMaybe<DocumentToManyDocumentRevisionFilter>;
  /** Some related `documentRevisions` exist. */
  documentRevisionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceItems` relation. */
  documentSpaceItems?: InputMaybe<DocumentToManyDocumentSpaceItemFilter>;
  /** Some related `documentSpaceItems` exist. */
  documentSpaceItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentsByLegalAppendixId` relation. */
  documentsByLegalAppendixId?: InputMaybe<DocumentToManyDocumentFilter>;
  /** Some related `documentsByLegalAppendixId` exist. */
  documentsByLegalAppendixIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `doesSupportFlows` field. */
  doesSupportFlows?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `doesSupportSharedspace` field. */
  doesSupportSharedspace?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `downloadUrl` field. */
  downloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `enableMagicPages` field. */
  enableMagicPages?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalLinkId` field. */
  externalLinkId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileName` field. */
  fileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileSize` field. */
  fileSize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `firestoreId` field. */
  firestoreId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flowItemsByVideoId` relation. */
  flowItemsByVideoId?: InputMaybe<DocumentToManyFlowItemFilter>;
  /** Some related `flowItemsByVideoId` exist. */
  flowItemsByVideoIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ftsDocumentHits` relation. */
  ftsDocumentHits?: InputMaybe<DocumentToManyFtsDocumentHitFilter>;
  /** Some related `ftsDocumentHits` exist. */
  ftsDocumentHitsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `ignoredPages` field. */
  ignoredPages?: InputMaybe<IntFilter>;
  /** Filter by the object’s `importSource` field. */
  importSource?: InputMaybe<StringFilter>;
  /** Filter by the object’s `initialFileName` field. */
  initialFileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `internalLinks` field. */
  internalLinks?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `isDownloadable` field. */
  isDownloadable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isProcessing` field. */
  isProcessing?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isPublished` field. */
  isPublished?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isUnbranded` field. */
  isUnbranded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastModifiedAt` field. */
  lastModifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lastModifiedBy` relation. */
  lastModifiedBy?: InputMaybe<UserFilter>;
  /** A related `lastModifiedBy` exists. */
  lastModifiedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lastModifiedById` field. */
  lastModifiedById?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `legalAppendix` relation. */
  legalAppendix?: InputMaybe<DocumentFilter>;
  /** A related `legalAppendix` exists. */
  legalAppendixExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `legalAppendixId` field. */
  legalAppendixId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `linksCanBeClickedByViewer` field. */
  linksCanBeClickedByViewer?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `literatureReferences` field. */
  literatureReferences?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `maDocumentSpaceDocumentStatistics` relation. */
  maDocumentSpaceDocumentStatistics?: InputMaybe<DocumentToManyMaDocumentSpaceDocumentStatisticFilter>;
  /** Some related `maDocumentSpaceDocumentStatistics` exist. */
  maDocumentSpaceDocumentStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maDocumentSpacePageStatistics` relation. */
  maDocumentSpacePageStatistics?: InputMaybe<DocumentToManyMaDocumentSpacePageStatisticFilter>;
  /** Some related `maDocumentSpacePageStatistics` exist. */
  maDocumentSpacePageStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maDocumentSpaceVideoStatistics` relation. */
  maDocumentSpaceVideoStatistics?: InputMaybe<DocumentToManyMaDocumentSpaceVideoStatisticFilter>;
  /** Some related `maDocumentSpaceVideoStatistics` exist. */
  maDocumentSpaceVideoStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `mimeType` field. */
  mimeType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `numNormalPages` field. */
  numNormalPages?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `originalDownloadUrl` field. */
  originalDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `originalMimeType` field. */
  originalMimeType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `originalStorageId` field. */
  originalStorageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pages` field. */
  pages?: InputMaybe<IntFilter>;
  /** Filter by the object’s `spaceUsageCount` field. */
  spaceUsageCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `storageId` field. */
  storageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `teaserText` field. */
  teaserText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `thumbnailStorageId` field. */
  thumbnailStorageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `topTitle` field. */
  topTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uploadedAt` field. */
  uploadedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `urlBasedDocumentImportSetting` relation. */
  urlBasedDocumentImportSetting?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  /** A related `urlBasedDocumentImportSetting` exists. */
  urlBasedDocumentImportSettingExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `urlBasedDocumentImports` relation. */
  urlBasedDocumentImports?: InputMaybe<DocumentToManyUrlBasedDocumentImportFilter>;
  /** Some related `urlBasedDocumentImports` exist. */
  urlBasedDocumentImportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `veevaDocumentMetadatum` relation. */
  veevaDocumentMetadatum?: InputMaybe<VeevaDocumentMetadatumFilter>;
  /** A related `veevaDocumentMetadatum` exists. */
  veevaDocumentMetadatumExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspace` relation. */
  workspace?: InputMaybe<WorkspaceFilter>;
  /** Filter by the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `workspacesByDefaultLegalAppendixId` relation. */
  workspacesByDefaultLegalAppendixId?: InputMaybe<DocumentToManyWorkspaceFilter>;
  /** Some related `workspacesByDefaultLegalAppendixId` exist. */
  workspacesByDefaultLegalAppendixIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `DocumentHistoryEntry` values. */
export type DocumentHistoryEntriesConnection = {
  __typename?: 'DocumentHistoryEntriesConnection';
  /** A list of edges which contains the `DocumentHistoryEntry` and cursor to aid in pagination. */
  edges: Array<DocumentHistoryEntriesEdge>;
  /** A list of `DocumentHistoryEntry` objects. */
  nodes: Array<Maybe<DocumentHistoryEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentHistoryEntry` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentHistoryEntry` edge in the connection. */
export type DocumentHistoryEntriesEdge = {
  __typename?: 'DocumentHistoryEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentHistoryEntry` at the end of the edge. */
  node?: Maybe<DocumentHistoryEntry>;
};

/** Methods to use when ordering `DocumentHistoryEntry`. */
export enum DocumentHistoryEntriesOrderBy {
  ActiveDurationAsc = 'ACTIVE_DURATION_ASC',
  ActiveDurationDesc = 'ACTIVE_DURATION_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelsOfDocumentViewByIdCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__CREATED_AT_ASC',
  LabelsOfDocumentViewByIdCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__CREATED_AT_DESC',
  LabelsOfDocumentViewByIdCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewByIdCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewByIdDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewByIdDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewByIdLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewByIdLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewByIdTextAsc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__TEXT_ASC',
  LabelsOfDocumentViewByIdTextDesc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__TEXT_DESC',
  LabelsOfDocumentViewByIdUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__UPDATED_AT_ASC',
  LabelsOfDocumentViewByIdUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEW_BY_ID__UPDATED_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RunIdAsc = 'RUN_ID_ASC',
  RunIdDesc = 'RUN_ID_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  TimeRangeAsc = 'TIME_RANGE_ASC',
  TimeRangeDesc = 'TIME_RANGE_DESC'
}

export type DocumentHistoryEntry = Node & {
  __typename?: 'DocumentHistoryEntry';
  activeDuration?: Maybe<Interval>;
  date?: Maybe<Scalars['Date']['output']>;
  /** Reads a single `Document` that is related to this `DocumentHistoryEntry`. */
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  duration?: Maybe<Interval>;
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  flow?: Maybe<Flow>;
  id: Scalars['UUID']['output'];
  /** Reads a single `LabelsOfDocumentView` that is related to this `DocumentHistoryEntry`. */
  label?: Maybe<LabelsOfDocumentView>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  runId?: Maybe<Scalars['UUID']['output']>;
  startsAt?: Maybe<Scalars['Datetime']['output']>;
  timeRange?: Maybe<DatetimeRange>;
};

/**
 * A condition to be used against `DocumentHistoryEntry` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentHistoryEntryCondition = {
  /** Checks for equality with the object’s `activeDuration` field. */
  activeDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `runId` field. */
  runId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `timeRange` field. */
  timeRange?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `DocumentHistoryEntry` object types. All fields are combined with a logical ‘and.’ */
export type DocumentHistoryEntryFilter = {
  /** Filter by the object’s `activeDuration` field. */
  activeDuration?: InputMaybe<IntervalFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentHistoryEntryFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `label` relation. */
  label?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** A related `label` exists. */
  labelExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentHistoryEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentHistoryEntryFilter>>;
  /** Filter by the object’s `runId` field. */
  runId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `timeRange` field. */
  timeRange?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `Document` */
export type DocumentInput = {
  /** Allow signed-in readers to download this document in Classic. Independent of Shared Space downloads. Only document administrators may update it. */
  allowUserDownload?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdById?: InputMaybe<Scalars['BigInt']['input']>;
  currentRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  displayDate?: InputMaybe<Scalars['Datetime']['input']>;
  displayTeaserTextInSpace?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  doesSupportFlows?: InputMaybe<Scalars['Boolean']['input']>;
  doesSupportSharedspace?: InputMaybe<Scalars['Boolean']['input']>;
  downloadUrl: Scalars['String']['input'];
  enableMagicPages?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Datetime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLinkId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['BigInt']['input'];
  firestoreId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  ignoredPages?: InputMaybe<Scalars['Int']['input']>;
  internalLinks?: InputMaybe<Scalars['JSON']['input']>;
  isDownloadable?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isUnbranded?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  legalAppendixId?: InputMaybe<Scalars['BigInt']['input']>;
  linksCanBeClickedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
  literatureReferences?: InputMaybe<Scalars['JSON']['input']>;
  mimeType: Scalars['String']['input'];
  order?: InputMaybe<Scalars['BigFloat']['input']>;
  originalDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  originalMimeType?: InputMaybe<Scalars['String']['input']>;
  originalStorageId?: InputMaybe<Scalars['String']['input']>;
  pages: Scalars['Int']['input'];
  storageId: Scalars['String']['input'];
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teaserText?: InputMaybe<Scalars['String']['input']>;
  thumbnailDownloadUrl: Scalars['String']['input'];
  thumbnailStorageId: Scalars['String']['input'];
  topTitle?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['Datetime']['input']>;
  workspaceId: Scalars['BigInt']['input'];
};

/** Page of a document. */
export type DocumentPage = Node & {
  __typename?: 'DocumentPage';
  createdAt: Scalars['Datetime']['output'];
  crossRevId: Scalars['UUID']['output'];
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  document?: Maybe<Document>;
  /** Document, the page belongs to. */
  documentId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `DocumentPageLink`. */
  documentPageLinksByPageId: DocumentPageLinksConnection;
  /** Reads and enables pagination through a set of `DocumentPageLink`. */
  documentPageLinksByTargetPageId: DocumentPageLinksConnection;
  /** Reads a single `DocumentPageMatching` that is related to this `DocumentPage`. */
  documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DocumentPageMatching>;
  /** Reads a single `DocumentPageMatching` that is related to this `DocumentPage`. */
  documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DocumentPageMatching>;
  /**
   * Reads and enables pagination through a set of `DocumentPageMatching`.
   * @deprecated Please use documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber instead
   */
  documentPageMatchingsByDocumentIdAndSourceRevisionNumberAndSourcePageNumber: DocumentPageMatchingsConnection;
  /**
   * Reads and enables pagination through a set of `DocumentPageMatching`.
   * @deprecated Please use documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber instead
   */
  documentPageMatchingsByDocumentIdAndTargetRevisionNumberAndTargetPageNumber: DocumentPageMatchingsConnection;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPage`. */
  documentRevisionByDocumentIdAndRevisionNumber?: Maybe<DocumentRevision>;
  /** Extracted plain text of this page. (Optional.) */
  extractedText?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `FlowItem`. */
  flowItemsByPageId: FlowItemsConnection;
  id: Scalars['BigInt']['output'];
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  linkedDocument?: Maybe<Document>;
  linkedDocumentId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Number of this page in the related document. */
  pageNumber: Scalars['Int']['output'];
  pageType: PageType;
  revisionNumber: Scalars['Int']['output'];
  /** Thumbnail of this page. (Optional. Please use WEBP for compression.) */
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


/** Page of a document. */
export type DocumentPageDocumentPageLinksByPageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageLinkCondition>;
  filter?: InputMaybe<DocumentPageLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageLinksOrderBy>>;
};


/** Page of a document. */
export type DocumentPageDocumentPageLinksByTargetPageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageLinkCondition>;
  filter?: InputMaybe<DocumentPageLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageLinksOrderBy>>;
};


/** Page of a document. */
export type DocumentPageDocumentPageMatchingsByDocumentIdAndSourceRevisionNumberAndSourcePageNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingCondition>;
  filter?: InputMaybe<DocumentPageMatchingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};


/** Page of a document. */
export type DocumentPageDocumentPageMatchingsByDocumentIdAndTargetRevisionNumberAndTargetPageNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingCondition>;
  filter?: InputMaybe<DocumentPageMatchingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};


/** Page of a document. */
export type DocumentPageFlowItemsByPageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowItemCondition>;
  filter?: InputMaybe<FlowItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};

/**
 * A condition to be used against `DocumentPage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentPageCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crossRevId` field. */
  crossRevId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `extractedText` field. */
  extractedText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `linkedDocumentId` field. */
  linkedDocumentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `pageType` field. */
  pageType?: InputMaybe<PageType>;
  /** Checks for equality with the object’s `revisionNumber` field. */
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `thumbnail` field. */
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentPage` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentPageFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crossRevId` field. */
  crossRevId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentPageLinksByPageId` relation. */
  documentPageLinksByPageId?: InputMaybe<DocumentPageToManyDocumentPageLinkFilter>;
  /** Some related `documentPageLinksByPageId` exist. */
  documentPageLinksByPageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPageLinksByTargetPageId` relation. */
  documentPageLinksByTargetPageId?: InputMaybe<DocumentPageToManyDocumentPageLinkFilter>;
  /** Some related `documentPageLinksByTargetPageId` exist. */
  documentPageLinksByTargetPageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber` relation. */
  documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: InputMaybe<DocumentPageMatchingFilter>;
  /** A related `documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber` exists. */
  documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber` relation. */
  documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: InputMaybe<DocumentPageMatchingFilter>;
  /** A related `documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber` exists. */
  documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentRevisionByDocumentIdAndRevisionNumber` relation. */
  documentRevisionByDocumentIdAndRevisionNumber?: InputMaybe<DocumentRevisionFilter>;
  /** Filter by the object’s `extractedText` field. */
  extractedText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flowItemsByPageId` relation. */
  flowItemsByPageId?: InputMaybe<DocumentPageToManyFlowItemFilter>;
  /** Some related `flowItemsByPageId` exist. */
  flowItemsByPageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ftsPageHitsByPageId` relation. */
  ftsPageHitsByPageId?: InputMaybe<DocumentPageToManyFtsPageHitFilter>;
  /** Some related `ftsPageHitsByPageId` exist. */
  ftsPageHitsByPageIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `linkedDocument` relation. */
  linkedDocument?: InputMaybe<DocumentFilter>;
  /** A related `linkedDocument` exists. */
  linkedDocumentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `linkedDocumentId` field. */
  linkedDocumentId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentPageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentPageFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pageType` field. */
  pageType?: InputMaybe<PageTypeFilter>;
  /** Filter by the object’s `revisionNumber` field. */
  revisionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentPage` */
export type DocumentPageInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crossRevId?: InputMaybe<Scalars['UUID']['input']>;
  /** Document, the page belongs to. */
  documentId: Scalars['BigInt']['input'];
  /** Extracted plain text of this page. (Optional.) */
  extractedText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  linkedDocumentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Number of this page in the related document. */
  pageNumber: Scalars['Int']['input'];
  pageType?: InputMaybe<PageType>;
  revisionNumber: Scalars['Int']['input'];
  /** Thumbnail of this page. (Optional. Please use WEBP for compression.) */
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DocumentPageLink = Node & {
  __typename?: 'DocumentPageLink';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  linkType?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  page?: Maybe<DocumentPage>;
  pageId: Scalars['BigInt']['output'];
  positionBottom: Scalars['BigFloat']['output'];
  positionLeft: Scalars['BigFloat']['output'];
  positionRight: Scalars['BigFloat']['output'];
  positionTop: Scalars['BigFloat']['output'];
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  targetPage?: Maybe<DocumentPage>;
  targetPageId?: Maybe<Scalars['BigInt']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DocumentPageLink` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentPageLinkCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `linkType` field. */
  linkType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pageId` field. */
  pageId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `positionBottom` field. */
  positionBottom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `positionLeft` field. */
  positionLeft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `positionRight` field. */
  positionRight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `positionTop` field. */
  positionTop?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `targetPageId` field. */
  targetPageId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `targetUrl` field. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentPageLink` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageLinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentPageLinkFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `linkType` field. */
  linkType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentPageLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentPageLinkFilter>>;
  /** Filter by the object’s `page` relation. */
  page?: InputMaybe<DocumentPageFilter>;
  /** Filter by the object’s `pageId` field. */
  pageId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `positionBottom` field. */
  positionBottom?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `positionLeft` field. */
  positionLeft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `positionRight` field. */
  positionRight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `positionTop` field. */
  positionTop?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `targetPage` relation. */
  targetPage?: InputMaybe<DocumentPageFilter>;
  /** A related `targetPage` exists. */
  targetPageExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `targetPageId` field. */
  targetPageId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `targetUrl` field. */
  targetUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentPageLink` */
export type DocumentPageLinkInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['BigInt']['input'];
  positionBottom: Scalars['BigFloat']['input'];
  positionLeft: Scalars['BigFloat']['input'];
  positionRight: Scalars['BigFloat']['input'];
  positionTop: Scalars['BigFloat']['input'];
  targetPageId?: InputMaybe<Scalars['BigInt']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentPageLink`. Fields that are set will be updated. */
export type DocumentPageLinkPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['BigInt']['input']>;
  positionBottom?: InputMaybe<Scalars['BigFloat']['input']>;
  positionLeft?: InputMaybe<Scalars['BigFloat']['input']>;
  positionRight?: InputMaybe<Scalars['BigFloat']['input']>;
  positionTop?: InputMaybe<Scalars['BigFloat']['input']>;
  targetPageId?: InputMaybe<Scalars['BigInt']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentPageLink` values. */
export type DocumentPageLinksConnection = {
  __typename?: 'DocumentPageLinksConnection';
  /** A list of edges which contains the `DocumentPageLink` and cursor to aid in pagination. */
  edges: Array<DocumentPageLinksEdge>;
  /** A list of `DocumentPageLink` objects. */
  nodes: Array<Maybe<DocumentPageLink>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentPageLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentPageLink` edge in the connection. */
export type DocumentPageLinksEdge = {
  __typename?: 'DocumentPageLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentPageLink` at the end of the edge. */
  node?: Maybe<DocumentPageLink>;
};

/** Methods to use when ordering `DocumentPageLink`. */
export enum DocumentPageLinksOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentPageByPageIdCreatedAtAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__CREATED_AT_ASC',
  DocumentPageByPageIdCreatedAtDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__CREATED_AT_DESC',
  DocumentPageByPageIdCrossRevIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__CROSS_REV_ID_ASC',
  DocumentPageByPageIdCrossRevIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__CROSS_REV_ID_DESC',
  DocumentPageByPageIdDocumentIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__DOCUMENT_ID_ASC',
  DocumentPageByPageIdDocumentIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__DOCUMENT_ID_DESC',
  DocumentPageByPageIdExtractedTextAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__EXTRACTED_TEXT_ASC',
  DocumentPageByPageIdExtractedTextDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__EXTRACTED_TEXT_DESC',
  DocumentPageByPageIdIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__ID_ASC',
  DocumentPageByPageIdIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__ID_DESC',
  DocumentPageByPageIdLinkedDocumentIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__LINKED_DOCUMENT_ID_ASC',
  DocumentPageByPageIdLinkedDocumentIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__LINKED_DOCUMENT_ID_DESC',
  DocumentPageByPageIdPageNumberAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_NUMBER_ASC',
  DocumentPageByPageIdPageNumberDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_NUMBER_DESC',
  DocumentPageByPageIdPageTypeAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_TYPE_ASC',
  DocumentPageByPageIdPageTypeDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_TYPE_DESC',
  DocumentPageByPageIdRevisionNumberAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__REVISION_NUMBER_ASC',
  DocumentPageByPageIdRevisionNumberDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__REVISION_NUMBER_DESC',
  DocumentPageByPageIdThumbnailAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__THUMBNAIL_ASC',
  DocumentPageByPageIdThumbnailDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__THUMBNAIL_DESC',
  DocumentPageByPageIdUpdatedAtAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__UPDATED_AT_ASC',
  DocumentPageByPageIdUpdatedAtDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__UPDATED_AT_DESC',
  DocumentPageByTargetPageIdCreatedAtAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__CREATED_AT_ASC',
  DocumentPageByTargetPageIdCreatedAtDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__CREATED_AT_DESC',
  DocumentPageByTargetPageIdCrossRevIdAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__CROSS_REV_ID_ASC',
  DocumentPageByTargetPageIdCrossRevIdDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__CROSS_REV_ID_DESC',
  DocumentPageByTargetPageIdDocumentIdAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__DOCUMENT_ID_ASC',
  DocumentPageByTargetPageIdDocumentIdDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__DOCUMENT_ID_DESC',
  DocumentPageByTargetPageIdExtractedTextAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__EXTRACTED_TEXT_ASC',
  DocumentPageByTargetPageIdExtractedTextDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__EXTRACTED_TEXT_DESC',
  DocumentPageByTargetPageIdIdAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__ID_ASC',
  DocumentPageByTargetPageIdIdDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__ID_DESC',
  DocumentPageByTargetPageIdLinkedDocumentIdAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__LINKED_DOCUMENT_ID_ASC',
  DocumentPageByTargetPageIdLinkedDocumentIdDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__LINKED_DOCUMENT_ID_DESC',
  DocumentPageByTargetPageIdPageNumberAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__PAGE_NUMBER_ASC',
  DocumentPageByTargetPageIdPageNumberDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__PAGE_NUMBER_DESC',
  DocumentPageByTargetPageIdPageTypeAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__PAGE_TYPE_ASC',
  DocumentPageByTargetPageIdPageTypeDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__PAGE_TYPE_DESC',
  DocumentPageByTargetPageIdRevisionNumberAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__REVISION_NUMBER_ASC',
  DocumentPageByTargetPageIdRevisionNumberDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__REVISION_NUMBER_DESC',
  DocumentPageByTargetPageIdThumbnailAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__THUMBNAIL_ASC',
  DocumentPageByTargetPageIdThumbnailDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__THUMBNAIL_DESC',
  DocumentPageByTargetPageIdUpdatedAtAsc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__UPDATED_AT_ASC',
  DocumentPageByTargetPageIdUpdatedAtDesc = 'DOCUMENT_PAGE_BY_TARGET_PAGE_ID__UPDATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinkTypeAsc = 'LINK_TYPE_ASC',
  LinkTypeDesc = 'LINK_TYPE_DESC',
  Natural = 'NATURAL',
  PageIdAsc = 'PAGE_ID_ASC',
  PageIdDesc = 'PAGE_ID_DESC',
  PositionBottomAsc = 'POSITION_BOTTOM_ASC',
  PositionBottomDesc = 'POSITION_BOTTOM_DESC',
  PositionLeftAsc = 'POSITION_LEFT_ASC',
  PositionLeftDesc = 'POSITION_LEFT_DESC',
  PositionRightAsc = 'POSITION_RIGHT_ASC',
  PositionRightDesc = 'POSITION_RIGHT_DESC',
  PositionTopAsc = 'POSITION_TOP_ASC',
  PositionTopDesc = 'POSITION_TOP_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TargetPageIdAsc = 'TARGET_PAGE_ID_ASC',
  TargetPageIdDesc = 'TARGET_PAGE_ID_DESC',
  TargetUrlAsc = 'TARGET_URL_ASC',
  TargetUrlDesc = 'TARGET_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type DocumentPageMatching = Node & {
  __typename?: 'DocumentPageMatching';
  /** Reads a single `Document` that is related to this `DocumentPageMatching`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DocumentPage>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DocumentPage>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndSourceRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndTargetRevisionNumber?: Maybe<DocumentRevision>;
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  sourcePageNumber: Scalars['Int']['output'];
  sourceRevisionNumber: Scalars['Int']['output'];
  targetPageNumber: Scalars['Int']['output'];
  targetRevisionNumber: Scalars['Int']['output'];
};

/**
 * A condition to be used against `DocumentPageMatching` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentPageMatchingCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `sourcePageNumber` field. */
  sourcePageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceRevisionNumber` field. */
  sourceRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetPageNumber` field. */
  targetPageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetRevisionNumber` field. */
  targetRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `DocumentPageMatching` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageMatchingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentPageMatchingFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumber` relation. */
  documentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: InputMaybe<DocumentPageFilter>;
  /** Filter by the object’s `documentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumber` relation. */
  documentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: InputMaybe<DocumentPageFilter>;
  /** Filter by the object’s `documentRevisionByDocumentIdAndSourceRevisionNumber` relation. */
  documentRevisionByDocumentIdAndSourceRevisionNumber?: InputMaybe<DocumentRevisionFilter>;
  /** Filter by the object’s `documentRevisionByDocumentIdAndTargetRevisionNumber` relation. */
  documentRevisionByDocumentIdAndTargetRevisionNumber?: InputMaybe<DocumentRevisionFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentPageMatchingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentPageMatchingFilter>>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `sourcePageNumber` field. */
  sourcePageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceRevisionNumber` field. */
  sourceRevisionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetPageNumber` field. */
  targetPageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetRevisionNumber` field. */
  targetRevisionNumber?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DocumentPageMatching` */
export type DocumentPageMatchingInput = {
  documentId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourcePageNumber: Scalars['Int']['input'];
  sourceRevisionNumber: Scalars['Int']['input'];
  targetPageNumber: Scalars['Int']['input'];
  targetRevisionNumber: Scalars['Int']['input'];
};

/** Represents an update to a `DocumentPageMatching`. Fields that are set will be updated. */
export type DocumentPageMatchingPatch = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourcePageNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  targetPageNumber?: InputMaybe<Scalars['Int']['input']>;
  targetRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentPageMatchingsBak = {
  __typename?: 'DocumentPageMatchingsBak';
  documentId?: Maybe<Scalars['BigInt']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  sourcePageNumber?: Maybe<Scalars['Int']['output']>;
  sourceRevisionNumber?: Maybe<Scalars['Int']['output']>;
  targetPageNumber?: Maybe<Scalars['Int']['output']>;
  targetRevisionNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `DocumentPageMatchingsBak` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentPageMatchingsBakCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sourcePageNumber` field. */
  sourcePageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceRevisionNumber` field. */
  sourceRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetPageNumber` field. */
  targetPageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetRevisionNumber` field. */
  targetRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `DocumentPageMatchingsBak` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageMatchingsBakFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentPageMatchingsBakFilter>>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentPageMatchingsBakFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentPageMatchingsBakFilter>>;
  /** Filter by the object’s `sourcePageNumber` field. */
  sourcePageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceRevisionNumber` field. */
  sourceRevisionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetPageNumber` field. */
  targetPageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetRevisionNumber` field. */
  targetRevisionNumber?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DocumentPageMatchingsBak` */
export type DocumentPageMatchingsBakInput = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourcePageNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  targetPageNumber?: InputMaybe<Scalars['Int']['input']>;
  targetRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `DocumentPageMatchingsBak` values. */
export type DocumentPageMatchingsBaksConnection = {
  __typename?: 'DocumentPageMatchingsBaksConnection';
  /** A list of edges which contains the `DocumentPageMatchingsBak` and cursor to aid in pagination. */
  edges: Array<DocumentPageMatchingsBaksEdge>;
  /** A list of `DocumentPageMatchingsBak` objects. */
  nodes: Array<Maybe<DocumentPageMatchingsBak>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentPageMatchingsBak` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentPageMatchingsBak` edge in the connection. */
export type DocumentPageMatchingsBaksEdge = {
  __typename?: 'DocumentPageMatchingsBaksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentPageMatchingsBak` at the end of the edge. */
  node?: Maybe<DocumentPageMatchingsBak>;
};

/** Methods to use when ordering `DocumentPageMatchingsBak`. */
export enum DocumentPageMatchingsBaksOrderBy {
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  SourcePageNumberAsc = 'SOURCE_PAGE_NUMBER_ASC',
  SourcePageNumberDesc = 'SOURCE_PAGE_NUMBER_DESC',
  SourceRevisionNumberAsc = 'SOURCE_REVISION_NUMBER_ASC',
  SourceRevisionNumberDesc = 'SOURCE_REVISION_NUMBER_DESC',
  TargetPageNumberAsc = 'TARGET_PAGE_NUMBER_ASC',
  TargetPageNumberDesc = 'TARGET_PAGE_NUMBER_DESC',
  TargetRevisionNumberAsc = 'TARGET_REVISION_NUMBER_ASC',
  TargetRevisionNumberDesc = 'TARGET_REVISION_NUMBER_DESC'
}

/** A connection to a list of `DocumentPageMatching` values. */
export type DocumentPageMatchingsConnection = {
  __typename?: 'DocumentPageMatchingsConnection';
  /** A list of edges which contains the `DocumentPageMatching` and cursor to aid in pagination. */
  edges: Array<DocumentPageMatchingsEdge>;
  /** A list of `DocumentPageMatching` objects. */
  nodes: Array<Maybe<DocumentPageMatching>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentPageMatching` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentPageMatching` edge in the connection. */
export type DocumentPageMatchingsEdge = {
  __typename?: 'DocumentPageMatchingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentPageMatching` at the end of the edge. */
  node?: Maybe<DocumentPageMatching>;
};

/** Methods to use when ordering `DocumentPageMatching`. */
export enum DocumentPageMatchingsOrderBy {
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberCreatedAtAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__CREATED_AT_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberCreatedAtDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__CREATED_AT_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberCrossRevIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__CROSS_REV_ID_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberCrossRevIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__CROSS_REV_ID_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberDocumentIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__DOCUMENT_ID_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberDocumentIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__DOCUMENT_ID_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberExtractedTextAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__EXTRACTED_TEXT_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberExtractedTextDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__EXTRACTED_TEXT_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__ID_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__ID_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberLinkedDocumentIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__LINKED_DOCUMENT_ID_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberLinkedDocumentIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__LINKED_DOCUMENT_ID_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberPageNumberAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__PAGE_NUMBER_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberPageNumberDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__PAGE_NUMBER_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberPageTypeAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__PAGE_TYPE_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberPageTypeDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__PAGE_TYPE_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberRevisionNumberAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__REVISION_NUMBER_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberRevisionNumberDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__REVISION_NUMBER_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberThumbnailAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__THUMBNAIL_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberThumbnailDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__THUMBNAIL_DESC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberUpdatedAtAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__UPDATED_AT_ASC',
  DocumentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumberUpdatedAtDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__UPDATED_AT_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberCreatedAtAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__CREATED_AT_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberCreatedAtDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__CREATED_AT_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberCrossRevIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__CROSS_REV_ID_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberCrossRevIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__CROSS_REV_ID_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberDocumentIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__DOCUMENT_ID_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberDocumentIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__DOCUMENT_ID_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberExtractedTextAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__EXTRACTED_TEXT_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberExtractedTextDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__EXTRACTED_TEXT_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__ID_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__ID_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberLinkedDocumentIdAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__LINKED_DOCUMENT_ID_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberLinkedDocumentIdDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__LINKED_DOCUMENT_ID_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberPageNumberAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__PAGE_NUMBER_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberPageNumberDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__PAGE_NUMBER_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberPageTypeAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__PAGE_TYPE_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberPageTypeDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__PAGE_TYPE_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberRevisionNumberAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__REVISION_NUMBER_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberRevisionNumberDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__REVISION_NUMBER_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberThumbnailAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__THUMBNAIL_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberThumbnailDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__THUMBNAIL_DESC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberUpdatedAtAsc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__UPDATED_AT_ASC',
  DocumentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumberUpdatedAtDesc = 'DOCUMENT_PAGE_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__UPDATED_AT_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberDocumentIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__DOCUMENT_ID_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberDocumentIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__DOCUMENT_ID_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberFileNameAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__FILE_NAME_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberFileNameDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__FILE_NAME_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberFileSizeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__FILE_SIZE_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberFileSizeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__FILE_SIZE_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberIsCurrentAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__IS_CURRENT_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberIsCurrentDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__IS_CURRENT_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberOriginalDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberOriginalDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberOriginalMimeTypeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberOriginalMimeTypeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberOriginalStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberOriginalStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberPagesAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__PAGES_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberPagesDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__PAGES_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberProcessingErrorAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__PROCESSING_ERROR_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberProcessingErrorDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__PROCESSING_ERROR_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberRevisionNumberAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__REVISION_NUMBER_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberRevisionNumberDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__REVISION_NUMBER_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberThumbnailDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberThumbnailDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberThumbnailStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberThumbnailStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberUploadedAtAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__UPLOADED_AT_ASC',
  DocumentRevisionByDocumentIdAndSourceRevisionNumberUploadedAtDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__UPLOADED_AT_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberDocumentIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__DOCUMENT_ID_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberDocumentIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__DOCUMENT_ID_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberFileNameAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__FILE_NAME_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberFileNameDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__FILE_NAME_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberFileSizeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__FILE_SIZE_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberFileSizeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__FILE_SIZE_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberIsCurrentAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__IS_CURRENT_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberIsCurrentDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__IS_CURRENT_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberOriginalDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberOriginalDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberOriginalMimeTypeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberOriginalMimeTypeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberOriginalStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberOriginalStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberPagesAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__PAGES_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberPagesDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__PAGES_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberProcessingErrorAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__PROCESSING_ERROR_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberProcessingErrorDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__PROCESSING_ERROR_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberRevisionNumberAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__REVISION_NUMBER_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberRevisionNumberDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__REVISION_NUMBER_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberThumbnailDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberThumbnailDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberThumbnailStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberThumbnailStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberUploadedAtAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__UPLOADED_AT_ASC',
  DocumentRevisionByDocumentIdAndTargetRevisionNumberUploadedAtDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__UPLOADED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  SourcePageNumberAsc = 'SOURCE_PAGE_NUMBER_ASC',
  SourcePageNumberDesc = 'SOURCE_PAGE_NUMBER_DESC',
  SourceRevisionNumberAsc = 'SOURCE_REVISION_NUMBER_ASC',
  SourceRevisionNumberDesc = 'SOURCE_REVISION_NUMBER_DESC',
  TargetPageNumberAsc = 'TARGET_PAGE_NUMBER_ASC',
  TargetPageNumberDesc = 'TARGET_PAGE_NUMBER_DESC',
  TargetRevisionNumberAsc = 'TARGET_REVISION_NUMBER_ASC',
  TargetRevisionNumberDesc = 'TARGET_REVISION_NUMBER_DESC'
}

/** Represents an update to a `DocumentPage`. Fields that are set will be updated. */
export type DocumentPagePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crossRevId?: InputMaybe<Scalars['UUID']['input']>;
  /** Document, the page belongs to. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Extracted plain text of this page. (Optional.) */
  extractedText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  linkedDocumentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Number of this page in the related document. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageType?: InputMaybe<PageType>;
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Thumbnail of this page. (Optional. Please use WEBP for compression.) */
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `DocumentPageLink` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageToManyDocumentPageLinkFilter = {
  /** Every related `DocumentPageLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentPageLinkFilter>;
  /** No related `DocumentPageLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentPageLinkFilter>;
  /** Some related `DocumentPageLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentPageLinkFilter>;
};

/** A filter to be used against many `FlowItem` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageToManyFlowItemFilter = {
  /** Every related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowItemFilter>;
  /** No related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowItemFilter>;
  /** Some related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowItemFilter>;
};

/** A filter to be used against many `FtsPageHit` object types. All fields are combined with a logical ‘and.’ */
export type DocumentPageToManyFtsPageHitFilter = {
  /** Every related `FtsPageHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FtsPageHitFilter>;
  /** No related `FtsPageHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FtsPageHitFilter>;
  /** Some related `FtsPageHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FtsPageHitFilter>;
};

/** A connection to a list of `DocumentPage` values. */
export type DocumentPagesConnection = {
  __typename?: 'DocumentPagesConnection';
  /** A list of edges which contains the `DocumentPage` and cursor to aid in pagination. */
  edges: Array<DocumentPagesEdge>;
  /** A list of `DocumentPage` objects. */
  nodes: Array<Maybe<DocumentPage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentPage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentPage` edge in the connection. */
export type DocumentPagesEdge = {
  __typename?: 'DocumentPagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentPage` at the end of the edge. */
  node?: Maybe<DocumentPage>;
};

/** Methods to use when ordering `DocumentPage`. */
export enum DocumentPagesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrossRevIdAsc = 'CROSS_REV_ID_ASC',
  CrossRevIdDesc = 'CROSS_REV_ID_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentByLinkedDocumentIdConfigAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CONFIG_ASC',
  DocumentByLinkedDocumentIdConfigDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CONFIG_DESC',
  DocumentByLinkedDocumentIdCreatedAtAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByLinkedDocumentIdCreatedAtDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByLinkedDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByLinkedDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByLinkedDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByLinkedDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByLinkedDocumentIdDeletedAtAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByLinkedDocumentIdDeletedAtDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByLinkedDocumentIdDisplayDateAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByLinkedDocumentIdDisplayDateDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByLinkedDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByLinkedDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByLinkedDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByLinkedDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByLinkedDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByLinkedDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByLinkedDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByLinkedDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByLinkedDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByLinkedDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByLinkedDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByLinkedDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByLinkedDocumentIdExpirationDateAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByLinkedDocumentIdExpirationDateDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByLinkedDocumentIdExternalIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByLinkedDocumentIdExternalIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByLinkedDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByLinkedDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByLinkedDocumentIdFileNameAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByLinkedDocumentIdFileNameDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByLinkedDocumentIdFileSizeAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByLinkedDocumentIdFileSizeDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByLinkedDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByLinkedDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByLinkedDocumentIdIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ID_ASC',
  DocumentByLinkedDocumentIdIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ID_DESC',
  DocumentByLinkedDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByLinkedDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByLinkedDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByLinkedDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByLinkedDocumentIdInternalLinksAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByLinkedDocumentIdInternalLinksDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByLinkedDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByLinkedDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByLinkedDocumentIdIsPublishedAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByLinkedDocumentIdIsPublishedDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByLinkedDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByLinkedDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByLinkedDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByLinkedDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByLinkedDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByLinkedDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByLinkedDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByLinkedDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByLinkedDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByLinkedDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByLinkedDocumentIdMimeTypeAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByLinkedDocumentIdMimeTypeDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByLinkedDocumentIdOrderAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORDER_ASC',
  DocumentByLinkedDocumentIdOrderDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORDER_DESC',
  DocumentByLinkedDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByLinkedDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByLinkedDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByLinkedDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByLinkedDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByLinkedDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByLinkedDocumentIdPagesAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__PAGES_ASC',
  DocumentByLinkedDocumentIdPagesDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__PAGES_DESC',
  DocumentByLinkedDocumentIdStorageIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByLinkedDocumentIdStorageIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByLinkedDocumentIdSysPeriodAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByLinkedDocumentIdSysPeriodDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByLinkedDocumentIdTagsAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__TAGS_ASC',
  DocumentByLinkedDocumentIdTagsDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__TAGS_DESC',
  DocumentByLinkedDocumentIdTeaserTextAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByLinkedDocumentIdTeaserTextDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByLinkedDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByLinkedDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByLinkedDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByLinkedDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByLinkedDocumentIdTopTitleAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByLinkedDocumentIdTopTitleDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByLinkedDocumentIdUploadedAtAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByLinkedDocumentIdUploadedAtDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByLinkedDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByLinkedDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_LINKED_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentPageLinksByPageIdCountAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__COUNT_ASC',
  DocumentPageLinksByPageIdCountDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__COUNT_DESC',
  DocumentPageLinksByPageIdMaxCreatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_CREATED_AT_ASC',
  DocumentPageLinksByPageIdMaxCreatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_CREATED_AT_DESC',
  DocumentPageLinksByPageIdMaxIdAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_ID_ASC',
  DocumentPageLinksByPageIdMaxIdDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_ID_DESC',
  DocumentPageLinksByPageIdMaxLinkTypeAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_LINK_TYPE_ASC',
  DocumentPageLinksByPageIdMaxLinkTypeDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_LINK_TYPE_DESC',
  DocumentPageLinksByPageIdMaxPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_PAGE_ID_ASC',
  DocumentPageLinksByPageIdMaxPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_PAGE_ID_DESC',
  DocumentPageLinksByPageIdMaxPositionBottomAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_BOTTOM_ASC',
  DocumentPageLinksByPageIdMaxPositionBottomDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_BOTTOM_DESC',
  DocumentPageLinksByPageIdMaxPositionLeftAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_LEFT_ASC',
  DocumentPageLinksByPageIdMaxPositionLeftDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_LEFT_DESC',
  DocumentPageLinksByPageIdMaxPositionRightAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_RIGHT_ASC',
  DocumentPageLinksByPageIdMaxPositionRightDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_RIGHT_DESC',
  DocumentPageLinksByPageIdMaxPositionTopAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_TOP_ASC',
  DocumentPageLinksByPageIdMaxPositionTopDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_POSITION_TOP_DESC',
  DocumentPageLinksByPageIdMaxTargetPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_TARGET_PAGE_ID_ASC',
  DocumentPageLinksByPageIdMaxTargetPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_TARGET_PAGE_ID_DESC',
  DocumentPageLinksByPageIdMaxTargetUrlAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_TARGET_URL_ASC',
  DocumentPageLinksByPageIdMaxTargetUrlDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_TARGET_URL_DESC',
  DocumentPageLinksByPageIdMaxUpdatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_UPDATED_AT_ASC',
  DocumentPageLinksByPageIdMaxUpdatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MAX_UPDATED_AT_DESC',
  DocumentPageLinksByPageIdMinCreatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_CREATED_AT_ASC',
  DocumentPageLinksByPageIdMinCreatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_CREATED_AT_DESC',
  DocumentPageLinksByPageIdMinIdAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_ID_ASC',
  DocumentPageLinksByPageIdMinIdDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_ID_DESC',
  DocumentPageLinksByPageIdMinLinkTypeAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_LINK_TYPE_ASC',
  DocumentPageLinksByPageIdMinLinkTypeDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_LINK_TYPE_DESC',
  DocumentPageLinksByPageIdMinPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_PAGE_ID_ASC',
  DocumentPageLinksByPageIdMinPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_PAGE_ID_DESC',
  DocumentPageLinksByPageIdMinPositionBottomAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_BOTTOM_ASC',
  DocumentPageLinksByPageIdMinPositionBottomDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_BOTTOM_DESC',
  DocumentPageLinksByPageIdMinPositionLeftAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_LEFT_ASC',
  DocumentPageLinksByPageIdMinPositionLeftDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_LEFT_DESC',
  DocumentPageLinksByPageIdMinPositionRightAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_RIGHT_ASC',
  DocumentPageLinksByPageIdMinPositionRightDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_RIGHT_DESC',
  DocumentPageLinksByPageIdMinPositionTopAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_TOP_ASC',
  DocumentPageLinksByPageIdMinPositionTopDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_POSITION_TOP_DESC',
  DocumentPageLinksByPageIdMinTargetPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_TARGET_PAGE_ID_ASC',
  DocumentPageLinksByPageIdMinTargetPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_TARGET_PAGE_ID_DESC',
  DocumentPageLinksByPageIdMinTargetUrlAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_TARGET_URL_ASC',
  DocumentPageLinksByPageIdMinTargetUrlDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_TARGET_URL_DESC',
  DocumentPageLinksByPageIdMinUpdatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_UPDATED_AT_ASC',
  DocumentPageLinksByPageIdMinUpdatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_PAGE_ID__MIN_UPDATED_AT_DESC',
  DocumentPageLinksByTargetPageIdCountAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__COUNT_ASC',
  DocumentPageLinksByTargetPageIdCountDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__COUNT_DESC',
  DocumentPageLinksByTargetPageIdMaxCreatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_CREATED_AT_ASC',
  DocumentPageLinksByTargetPageIdMaxCreatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_CREATED_AT_DESC',
  DocumentPageLinksByTargetPageIdMaxIdAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_ID_ASC',
  DocumentPageLinksByTargetPageIdMaxIdDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_ID_DESC',
  DocumentPageLinksByTargetPageIdMaxLinkTypeAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_LINK_TYPE_ASC',
  DocumentPageLinksByTargetPageIdMaxLinkTypeDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_LINK_TYPE_DESC',
  DocumentPageLinksByTargetPageIdMaxPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_PAGE_ID_ASC',
  DocumentPageLinksByTargetPageIdMaxPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_PAGE_ID_DESC',
  DocumentPageLinksByTargetPageIdMaxPositionBottomAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_BOTTOM_ASC',
  DocumentPageLinksByTargetPageIdMaxPositionBottomDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_BOTTOM_DESC',
  DocumentPageLinksByTargetPageIdMaxPositionLeftAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_LEFT_ASC',
  DocumentPageLinksByTargetPageIdMaxPositionLeftDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_LEFT_DESC',
  DocumentPageLinksByTargetPageIdMaxPositionRightAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_RIGHT_ASC',
  DocumentPageLinksByTargetPageIdMaxPositionRightDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_RIGHT_DESC',
  DocumentPageLinksByTargetPageIdMaxPositionTopAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_TOP_ASC',
  DocumentPageLinksByTargetPageIdMaxPositionTopDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_POSITION_TOP_DESC',
  DocumentPageLinksByTargetPageIdMaxTargetPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_TARGET_PAGE_ID_ASC',
  DocumentPageLinksByTargetPageIdMaxTargetPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_TARGET_PAGE_ID_DESC',
  DocumentPageLinksByTargetPageIdMaxTargetUrlAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_TARGET_URL_ASC',
  DocumentPageLinksByTargetPageIdMaxTargetUrlDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_TARGET_URL_DESC',
  DocumentPageLinksByTargetPageIdMaxUpdatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_UPDATED_AT_ASC',
  DocumentPageLinksByTargetPageIdMaxUpdatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MAX_UPDATED_AT_DESC',
  DocumentPageLinksByTargetPageIdMinCreatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_CREATED_AT_ASC',
  DocumentPageLinksByTargetPageIdMinCreatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_CREATED_AT_DESC',
  DocumentPageLinksByTargetPageIdMinIdAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_ID_ASC',
  DocumentPageLinksByTargetPageIdMinIdDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_ID_DESC',
  DocumentPageLinksByTargetPageIdMinLinkTypeAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_LINK_TYPE_ASC',
  DocumentPageLinksByTargetPageIdMinLinkTypeDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_LINK_TYPE_DESC',
  DocumentPageLinksByTargetPageIdMinPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_PAGE_ID_ASC',
  DocumentPageLinksByTargetPageIdMinPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_PAGE_ID_DESC',
  DocumentPageLinksByTargetPageIdMinPositionBottomAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_BOTTOM_ASC',
  DocumentPageLinksByTargetPageIdMinPositionBottomDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_BOTTOM_DESC',
  DocumentPageLinksByTargetPageIdMinPositionLeftAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_LEFT_ASC',
  DocumentPageLinksByTargetPageIdMinPositionLeftDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_LEFT_DESC',
  DocumentPageLinksByTargetPageIdMinPositionRightAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_RIGHT_ASC',
  DocumentPageLinksByTargetPageIdMinPositionRightDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_RIGHT_DESC',
  DocumentPageLinksByTargetPageIdMinPositionTopAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_TOP_ASC',
  DocumentPageLinksByTargetPageIdMinPositionTopDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_POSITION_TOP_DESC',
  DocumentPageLinksByTargetPageIdMinTargetPageIdAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_TARGET_PAGE_ID_ASC',
  DocumentPageLinksByTargetPageIdMinTargetPageIdDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_TARGET_PAGE_ID_DESC',
  DocumentPageLinksByTargetPageIdMinTargetUrlAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_TARGET_URL_ASC',
  DocumentPageLinksByTargetPageIdMinTargetUrlDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_TARGET_URL_DESC',
  DocumentPageLinksByTargetPageIdMinUpdatedAtAsc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_UPDATED_AT_ASC',
  DocumentPageLinksByTargetPageIdMinUpdatedAtDesc = 'DOCUMENT_PAGE_LINKS_BY_TARGET_PAGE_ID__MIN_UPDATED_AT_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberDocumentIdAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__DOCUMENT_ID_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberDocumentIdDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__DOCUMENT_ID_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberIdAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__ID_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberIdDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__ID_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberScoreAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__SCORE_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberScoreDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__SCORE_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER_AND_SOURCE_PAGE_NUMBER__TARGET_REVISION_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberDocumentIdAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__DOCUMENT_ID_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberDocumentIdDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__DOCUMENT_ID_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberIdAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__ID_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberIdDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__ID_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberScoreAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__SCORE_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberScoreDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__SCORE_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHING_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER_AND_TARGET_PAGE_NUMBER__TARGET_REVISION_NUMBER_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberDocumentIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOCUMENT_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberDocumentIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOCUMENT_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileNameAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_NAME_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileNameDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_NAME_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileSizeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_SIZE_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileSizeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_SIZE_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberIsCurrentAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__IS_CURRENT_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberIsCurrentDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__IS_CURRENT_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalMimeTypeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalMimeTypeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberPagesAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PAGES_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberPagesDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PAGES_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberProcessingErrorAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PROCESSING_ERROR_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberProcessingErrorDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PROCESSING_ERROR_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberRevisionNumberAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__REVISION_NUMBER_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberRevisionNumberDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__REVISION_NUMBER_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberUploadedAtAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__UPLOADED_AT_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberUploadedAtDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__UPLOADED_AT_DESC',
  ExtractedTextAsc = 'EXTRACTED_TEXT_ASC',
  ExtractedTextDesc = 'EXTRACTED_TEXT_DESC',
  FlowItemsByPageIdCountAsc = 'FLOW_ITEMS_BY_PAGE_ID__COUNT_ASC',
  FlowItemsByPageIdCountDesc = 'FLOW_ITEMS_BY_PAGE_ID__COUNT_DESC',
  FlowItemsByPageIdMaxCreatedAtAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_CREATED_AT_ASC',
  FlowItemsByPageIdMaxCreatedAtDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_CREATED_AT_DESC',
  FlowItemsByPageIdMaxCreatorIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_CREATOR_ID_ASC',
  FlowItemsByPageIdMaxCreatorIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_CREATOR_ID_DESC',
  FlowItemsByPageIdMaxFlowIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_FLOW_ID_ASC',
  FlowItemsByPageIdMaxFlowIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_FLOW_ID_DESC',
  FlowItemsByPageIdMaxIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_ID_ASC',
  FlowItemsByPageIdMaxIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_ID_DESC',
  FlowItemsByPageIdMaxOrderAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_ORDER_ASC',
  FlowItemsByPageIdMaxOrderDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_ORDER_DESC',
  FlowItemsByPageIdMaxPageIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_PAGE_ID_ASC',
  FlowItemsByPageIdMaxPageIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_PAGE_ID_DESC',
  FlowItemsByPageIdMaxSysPeriodAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_SYS_PERIOD_ASC',
  FlowItemsByPageIdMaxSysPeriodDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_SYS_PERIOD_DESC',
  FlowItemsByPageIdMaxUpdatedAtAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_UPDATED_AT_ASC',
  FlowItemsByPageIdMaxUpdatedAtDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_UPDATED_AT_DESC',
  FlowItemsByPageIdMaxVideoIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_VIDEO_ID_ASC',
  FlowItemsByPageIdMaxVideoIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MAX_VIDEO_ID_DESC',
  FlowItemsByPageIdMinCreatedAtAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_CREATED_AT_ASC',
  FlowItemsByPageIdMinCreatedAtDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_CREATED_AT_DESC',
  FlowItemsByPageIdMinCreatorIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_CREATOR_ID_ASC',
  FlowItemsByPageIdMinCreatorIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_CREATOR_ID_DESC',
  FlowItemsByPageIdMinFlowIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_FLOW_ID_ASC',
  FlowItemsByPageIdMinFlowIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_FLOW_ID_DESC',
  FlowItemsByPageIdMinIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_ID_ASC',
  FlowItemsByPageIdMinIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_ID_DESC',
  FlowItemsByPageIdMinOrderAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_ORDER_ASC',
  FlowItemsByPageIdMinOrderDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_ORDER_DESC',
  FlowItemsByPageIdMinPageIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_PAGE_ID_ASC',
  FlowItemsByPageIdMinPageIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_PAGE_ID_DESC',
  FlowItemsByPageIdMinSysPeriodAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_SYS_PERIOD_ASC',
  FlowItemsByPageIdMinSysPeriodDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_SYS_PERIOD_DESC',
  FlowItemsByPageIdMinUpdatedAtAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_UPDATED_AT_ASC',
  FlowItemsByPageIdMinUpdatedAtDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_UPDATED_AT_DESC',
  FlowItemsByPageIdMinVideoIdAsc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_VIDEO_ID_ASC',
  FlowItemsByPageIdMinVideoIdDesc = 'FLOW_ITEMS_BY_PAGE_ID__MIN_VIDEO_ID_DESC',
  FtsPageHitsByPageIdCountAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__COUNT_ASC',
  FtsPageHitsByPageIdCountDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__COUNT_DESC',
  FtsPageHitsByPageIdMaxHeadlineAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_HEADLINE_ASC',
  FtsPageHitsByPageIdMaxHeadlineDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_HEADLINE_DESC',
  FtsPageHitsByPageIdMaxPageIdAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_PAGE_ID_ASC',
  FtsPageHitsByPageIdMaxPageIdDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_PAGE_ID_DESC',
  FtsPageHitsByPageIdMaxPageNumberAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_PAGE_NUMBER_ASC',
  FtsPageHitsByPageIdMaxPageNumberDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_PAGE_NUMBER_DESC',
  FtsPageHitsByPageIdMaxScoreAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_SCORE_ASC',
  FtsPageHitsByPageIdMaxScoreDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MAX_SCORE_DESC',
  FtsPageHitsByPageIdMinHeadlineAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_HEADLINE_ASC',
  FtsPageHitsByPageIdMinHeadlineDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_HEADLINE_DESC',
  FtsPageHitsByPageIdMinPageIdAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_PAGE_ID_ASC',
  FtsPageHitsByPageIdMinPageIdDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_PAGE_ID_DESC',
  FtsPageHitsByPageIdMinPageNumberAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_PAGE_NUMBER_ASC',
  FtsPageHitsByPageIdMinPageNumberDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_PAGE_NUMBER_DESC',
  FtsPageHitsByPageIdMinScoreAsc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_SCORE_ASC',
  FtsPageHitsByPageIdMinScoreDesc = 'FTS_PAGE_HITS_BY_PAGE_ID__MIN_SCORE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinkedDocumentIdAsc = 'LINKED_DOCUMENT_ID_ASC',
  LinkedDocumentIdDesc = 'LINKED_DOCUMENT_ID_DESC',
  Natural = 'NATURAL',
  PageNumberAsc = 'PAGE_NUMBER_ASC',
  PageNumberDesc = 'PAGE_NUMBER_DESC',
  PageTypeAsc = 'PAGE_TYPE_ASC',
  PageTypeDesc = 'PAGE_TYPE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RevisionNumberAsc = 'REVISION_NUMBER_ASC',
  RevisionNumberDesc = 'REVISION_NUMBER_DESC',
  ThumbnailAsc = 'THUMBNAIL_ASC',
  ThumbnailDesc = 'THUMBNAIL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Represents an update to a `Document`. Fields that are set will be updated. */
export type DocumentPatch = {
  /** Allow signed-in readers to download this document in Classic. Independent of Shared Space downloads. Only document administrators may update it. */
  allowUserDownload?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdById?: InputMaybe<Scalars['BigInt']['input']>;
  currentRevisionNumber?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  displayDate?: InputMaybe<Scalars['Datetime']['input']>;
  displayTeaserTextInSpace?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  doesSupportFlows?: InputMaybe<Scalars['Boolean']['input']>;
  doesSupportSharedspace?: InputMaybe<Scalars['Boolean']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  enableMagicPages?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Datetime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLinkId?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  firestoreId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  ignoredPages?: InputMaybe<Scalars['Int']['input']>;
  internalLinks?: InputMaybe<Scalars['JSON']['input']>;
  isDownloadable?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isUnbranded?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  legalAppendixId?: InputMaybe<Scalars['BigInt']['input']>;
  linksCanBeClickedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
  literatureReferences?: InputMaybe<Scalars['JSON']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['BigFloat']['input']>;
  originalDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  originalMimeType?: InputMaybe<Scalars['String']['input']>;
  originalStorageId?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  storageId?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teaserText?: InputMaybe<Scalars['String']['input']>;
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailStorageId?: InputMaybe<Scalars['String']['input']>;
  topTitle?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['Datetime']['input']>;
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type DocumentProcess = Node & {
  __typename?: 'DocumentProcess';
  /** Reads a single `Document` that is related to this `DocumentProcess`. */
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  failedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['BigInt']['output'];
  /** Reads a single `User` that is related to this `DocumentProcess`. */
  initiator?: Maybe<User>;
  initiatorId?: Maybe<Scalars['BigInt']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  progress: Scalars['Int']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentProcess`. */
  revision?: Maybe<DocumentRevision>;
  revisionNumber?: Maybe<Scalars['Int']['output']>;
  stage: Scalars['String']['output'];
  startedAt: Scalars['Datetime']['output'];
  succeededAt?: Maybe<Scalars['Datetime']['output']>;
  unitOfWork: Scalars['String']['output'];
};

/**
 * A condition to be used against `DocumentProcess` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentProcessCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `failedAt` field. */
  failedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `initiatorId` field. */
  initiatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lastError` field. */
  lastError?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `progress` field. */
  progress?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `revisionNumber` field. */
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `succeededAt` field. */
  succeededAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `unitOfWork` field. */
  unitOfWork?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DocumentProcess` object types. All fields are combined with a logical ‘and.’ */
export type DocumentProcessFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentProcessFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `failedAt` field. */
  failedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `initiator` relation. */
  initiator?: InputMaybe<UserFilter>;
  /** A related `initiator` exists. */
  initiatorExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `initiatorId` field. */
  initiatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lastError` field. */
  lastError?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentProcessFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentProcessFilter>>;
  /** Filter by the object’s `progress` field. */
  progress?: InputMaybe<IntFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `revision` relation. */
  revision?: InputMaybe<DocumentRevisionFilter>;
  /** A related `revision` exists. */
  revisionExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `revisionNumber` field. */
  revisionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `succeededAt` field. */
  succeededAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `unitOfWork` field. */
  unitOfWork?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `DocumentProcess` */
export type DocumentProcessInput = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  failedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  initiatorId?: InputMaybe<Scalars['BigInt']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  stage: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
  succeededAt?: InputMaybe<Scalars['Datetime']['input']>;
  unitOfWork: Scalars['String']['input'];
};

/** Represents an update to a `DocumentProcess`. Fields that are set will be updated. */
export type DocumentProcessPatch = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  failedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  initiatorId?: InputMaybe<Scalars['BigInt']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
  succeededAt?: InputMaybe<Scalars['Datetime']['input']>;
  unitOfWork?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `DocumentProcess` values. */
export type DocumentProcessesConnection = {
  __typename?: 'DocumentProcessesConnection';
  /** A list of edges which contains the `DocumentProcess` and cursor to aid in pagination. */
  edges: Array<DocumentProcessesEdge>;
  /** A list of `DocumentProcess` objects. */
  nodes: Array<Maybe<DocumentProcess>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentProcess` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentProcess` edge in the connection. */
export type DocumentProcessesEdge = {
  __typename?: 'DocumentProcessesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentProcess` at the end of the edge. */
  node?: Maybe<DocumentProcess>;
};

/** Methods to use when ordering `DocumentProcess`. */
export enum DocumentProcessesOrderBy {
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberDocumentIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOCUMENT_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberDocumentIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOCUMENT_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileNameAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_NAME_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileNameDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_NAME_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileSizeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_SIZE_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberFileSizeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__FILE_SIZE_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberIsCurrentAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__IS_CURRENT_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberIsCurrentDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__IS_CURRENT_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalMimeTypeAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalMimeTypeDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberOriginalStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberPagesAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PAGES_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberPagesDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PAGES_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberProcessingErrorAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PROCESSING_ERROR_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberProcessingErrorDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__PROCESSING_ERROR_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberRevisionNumberAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__REVISION_NUMBER_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberRevisionNumberDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__REVISION_NUMBER_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailDownloadUrlAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailDownloadUrlDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailStorageIdAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberThumbnailStorageIdDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionByDocumentIdAndRevisionNumberUploadedAtAsc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__UPLOADED_AT_ASC',
  DocumentRevisionByDocumentIdAndRevisionNumberUploadedAtDesc = 'DOCUMENT_REVISION_BY_DOCUMENT_ID_AND_REVISION_NUMBER__UPLOADED_AT_DESC',
  FailedAtAsc = 'FAILED_AT_ASC',
  FailedAtDesc = 'FAILED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InitiatorIdAsc = 'INITIATOR_ID_ASC',
  InitiatorIdDesc = 'INITIATOR_ID_DESC',
  LastErrorAsc = 'LAST_ERROR_ASC',
  LastErrorDesc = 'LAST_ERROR_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgressAsc = 'PROGRESS_ASC',
  ProgressDesc = 'PROGRESS_DESC',
  ResultAsc = 'RESULT_ASC',
  ResultDesc = 'RESULT_DESC',
  RevisionNumberAsc = 'REVISION_NUMBER_ASC',
  RevisionNumberDesc = 'REVISION_NUMBER_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  SucceededAtAsc = 'SUCCEEDED_AT_ASC',
  SucceededAtDesc = 'SUCCEEDED_AT_DESC',
  UnitOfWorkAsc = 'UNIT_OF_WORK_ASC',
  UnitOfWorkDesc = 'UNIT_OF_WORK_DESC',
  UserByInitiatorIdAppConsentGivenAtAsc = 'USER_BY_INITIATOR_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByInitiatorIdAppConsentGivenAtDesc = 'USER_BY_INITIATOR_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByInitiatorIdConfigAsc = 'USER_BY_INITIATOR_ID__CONFIG_ASC',
  UserByInitiatorIdConfigDesc = 'USER_BY_INITIATOR_ID__CONFIG_DESC',
  UserByInitiatorIdCreatedAtAsc = 'USER_BY_INITIATOR_ID__CREATED_AT_ASC',
  UserByInitiatorIdCreatedAtDesc = 'USER_BY_INITIATOR_ID__CREATED_AT_DESC',
  UserByInitiatorIdCrmContactVisibilityFilterAsc = 'USER_BY_INITIATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByInitiatorIdCrmContactVisibilityFilterDesc = 'USER_BY_INITIATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByInitiatorIdDefaultWorkspaceIdAsc = 'USER_BY_INITIATOR_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByInitiatorIdDefaultWorkspaceIdDesc = 'USER_BY_INITIATOR_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByInitiatorIdDisabledAsc = 'USER_BY_INITIATOR_ID__DISABLED_ASC',
  UserByInitiatorIdDisabledDesc = 'USER_BY_INITIATOR_ID__DISABLED_DESC',
  UserByInitiatorIdDisplayNameAsc = 'USER_BY_INITIATOR_ID__DISPLAY_NAME_ASC',
  UserByInitiatorIdDisplayNameDesc = 'USER_BY_INITIATOR_ID__DISPLAY_NAME_DESC',
  UserByInitiatorIdEmailAsc = 'USER_BY_INITIATOR_ID__EMAIL_ASC',
  UserByInitiatorIdEmailDesc = 'USER_BY_INITIATOR_ID__EMAIL_DESC',
  UserByInitiatorIdExternalGroupsAsc = 'USER_BY_INITIATOR_ID__EXTERNAL_GROUPS_ASC',
  UserByInitiatorIdExternalGroupsDesc = 'USER_BY_INITIATOR_ID__EXTERNAL_GROUPS_DESC',
  UserByInitiatorIdExternalGroupsSyncedAtAsc = 'USER_BY_INITIATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByInitiatorIdExternalGroupsSyncedAtDesc = 'USER_BY_INITIATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByInitiatorIdFirebaseAuthIdAsc = 'USER_BY_INITIATOR_ID__FIREBASE_AUTH_ID_ASC',
  UserByInitiatorIdFirebaseAuthIdDesc = 'USER_BY_INITIATOR_ID__FIREBASE_AUTH_ID_DESC',
  UserByInitiatorIdFlagsAsc = 'USER_BY_INITIATOR_ID__FLAGS_ASC',
  UserByInitiatorIdFlagsDesc = 'USER_BY_INITIATOR_ID__FLAGS_DESC',
  UserByInitiatorIdIdAsc = 'USER_BY_INITIATOR_ID__ID_ASC',
  UserByInitiatorIdIdDesc = 'USER_BY_INITIATOR_ID__ID_DESC',
  UserByInitiatorIdIsTenantAdminAsc = 'USER_BY_INITIATOR_ID__IS_TENANT_ADMIN_ASC',
  UserByInitiatorIdIsTenantAdminDesc = 'USER_BY_INITIATOR_ID__IS_TENANT_ADMIN_DESC',
  UserByInitiatorIdRegisteredAtAsc = 'USER_BY_INITIATOR_ID__REGISTERED_AT_ASC',
  UserByInitiatorIdRegisteredAtDesc = 'USER_BY_INITIATOR_ID__REGISTERED_AT_DESC',
  UserByInitiatorIdSysPeriodAsc = 'USER_BY_INITIATOR_ID__SYS_PERIOD_ASC',
  UserByInitiatorIdSysPeriodDesc = 'USER_BY_INITIATOR_ID__SYS_PERIOD_DESC',
  UserByInitiatorIdTenantIdAsc = 'USER_BY_INITIATOR_ID__TENANT_ID_ASC',
  UserByInitiatorIdTenantIdDesc = 'USER_BY_INITIATOR_ID__TENANT_ID_DESC',
  UserByInitiatorIdUpdatedAtAsc = 'USER_BY_INITIATOR_ID__UPDATED_AT_ASC',
  UserByInitiatorIdUpdatedAtDesc = 'USER_BY_INITIATOR_ID__UPDATED_AT_DESC'
}

export type DocumentRevision = Node & {
  __typename?: 'DocumentRevision';
  /** Reads a single `Document` that is related to this `DocumentRevision`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `DocumentPageMatching`. */
  documentPageMatchingsByDocumentIdAndSourceRevisionNumber: DocumentPageMatchingsConnection;
  /** Reads and enables pagination through a set of `DocumentPageMatching`. */
  documentPageMatchingsByDocumentIdAndTargetRevisionNumber: DocumentPageMatchingsConnection;
  /** Reads and enables pagination through a set of `DocumentPage`. */
  documentPagesByDocumentIdAndRevisionNumber: DocumentPagesConnection;
  /** Reads and enables pagination through a set of `DocumentProcess`. */
  documentProcessesByDocumentIdAndRevisionNumber: DocumentProcessesConnection;
  /** Reads and enables pagination through a set of `Document`. */
  documentsByIdAndCurrentRevisionNumber: DocumentsConnection;
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  hasProcessingError: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  originalDownloadUrl?: Maybe<Scalars['String']['output']>;
  originalMimeType?: Maybe<Scalars['String']['output']>;
  originalStorageId?: Maybe<Scalars['String']['output']>;
  pages: Scalars['Int']['output'];
  revisionNumber: Scalars['Int']['output'];
  storageId: Scalars['String']['output'];
  thumbnailDownloadUrl: Scalars['String']['output'];
  thumbnailStorageId: Scalars['String']['output'];
  uploadedAt: Scalars['Datetime']['output'];
};


export type DocumentRevisionDocumentPageMatchingsByDocumentIdAndSourceRevisionNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingCondition>;
  filter?: InputMaybe<DocumentPageMatchingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};


export type DocumentRevisionDocumentPageMatchingsByDocumentIdAndTargetRevisionNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingCondition>;
  filter?: InputMaybe<DocumentPageMatchingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};


export type DocumentRevisionDocumentPagesByDocumentIdAndRevisionNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageCondition>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};


export type DocumentRevisionDocumentProcessesByDocumentIdAndRevisionNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentProcessCondition>;
  filter?: InputMaybe<DocumentProcessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};


export type DocumentRevisionDocumentsByIdAndCurrentRevisionNumberArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentCondition>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};

/**
 * A condition to be used against `DocumentRevision` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentRevisionCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `downloadUrl` field. */
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fileName` field. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fileSize` field. */
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `originalDownloadUrl` field. */
  originalDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalMimeType` field. */
  originalMimeType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalStorageId` field. */
  originalStorageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pages` field. */
  pages?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `revisionNumber` field. */
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `storageId` field. */
  storageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `thumbnailStorageId` field. */
  thumbnailStorageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `uploadedAt` field. */
  uploadedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentRevision` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRevisionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentRevisionFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentPageMatchingsByDocumentIdAndSourceRevisionNumber` relation. */
  documentPageMatchingsByDocumentIdAndSourceRevisionNumber?: InputMaybe<DocumentRevisionToManyDocumentPageMatchingFilter>;
  /** Some related `documentPageMatchingsByDocumentIdAndSourceRevisionNumber` exist. */
  documentPageMatchingsByDocumentIdAndSourceRevisionNumberExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPageMatchingsByDocumentIdAndTargetRevisionNumber` relation. */
  documentPageMatchingsByDocumentIdAndTargetRevisionNumber?: InputMaybe<DocumentRevisionToManyDocumentPageMatchingFilter>;
  /** Some related `documentPageMatchingsByDocumentIdAndTargetRevisionNumber` exist. */
  documentPageMatchingsByDocumentIdAndTargetRevisionNumberExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPagesByDocumentIdAndRevisionNumber` relation. */
  documentPagesByDocumentIdAndRevisionNumber?: InputMaybe<DocumentRevisionToManyDocumentPageFilter>;
  /** Some related `documentPagesByDocumentIdAndRevisionNumber` exist. */
  documentPagesByDocumentIdAndRevisionNumberExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentProcessesByDocumentIdAndRevisionNumber` relation. */
  documentProcessesByDocumentIdAndRevisionNumber?: InputMaybe<DocumentRevisionToManyDocumentProcessFilter>;
  /** Some related `documentProcessesByDocumentIdAndRevisionNumber` exist. */
  documentProcessesByDocumentIdAndRevisionNumberExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentsByIdAndCurrentRevisionNumber` relation. */
  documentsByIdAndCurrentRevisionNumber?: InputMaybe<DocumentRevisionToManyDocumentFilter>;
  /** Some related `documentsByIdAndCurrentRevisionNumber` exist. */
  documentsByIdAndCurrentRevisionNumberExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `downloadUrl` field. */
  downloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileName` field. */
  fileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileSize` field. */
  fileSize?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `hasProcessingError` field. */
  hasProcessingError?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentRevisionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentRevisionFilter>>;
  /** Filter by the object’s `originalDownloadUrl` field. */
  originalDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `originalMimeType` field. */
  originalMimeType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `originalStorageId` field. */
  originalStorageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pages` field. */
  pages?: InputMaybe<IntFilter>;
  /** Filter by the object’s `revisionNumber` field. */
  revisionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `storageId` field. */
  storageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `thumbnailStorageId` field. */
  thumbnailStorageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uploadedAt` field. */
  uploadedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentRevision` */
export type DocumentRevisionInput = {
  documentId: Scalars['BigInt']['input'];
  downloadUrl: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['BigInt']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  originalDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  originalMimeType?: InputMaybe<Scalars['String']['input']>;
  originalStorageId?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  revisionNumber: Scalars['Int']['input'];
  storageId: Scalars['String']['input'];
  thumbnailDownloadUrl: Scalars['String']['input'];
  thumbnailStorageId: Scalars['String']['input'];
  uploadedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentRevision`. Fields that are set will be updated. */
export type DocumentRevisionPatch = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  originalDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  originalMimeType?: InputMaybe<Scalars['String']['input']>;
  originalStorageId?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Scalars['Int']['input']>;
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  storageId?: InputMaybe<Scalars['String']['input']>;
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailStorageId?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `Document` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRevisionToManyDocumentFilter = {
  /** Every related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFilter>;
  /** No related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFilter>;
  /** Some related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFilter>;
};

/** A filter to be used against many `DocumentPage` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRevisionToManyDocumentPageFilter = {
  /** Every related `DocumentPage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentPageFilter>;
  /** No related `DocumentPage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentPageFilter>;
  /** Some related `DocumentPage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentPageFilter>;
};

/** A filter to be used against many `DocumentPageMatching` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRevisionToManyDocumentPageMatchingFilter = {
  /** Every related `DocumentPageMatching` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentPageMatchingFilter>;
  /** No related `DocumentPageMatching` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentPageMatchingFilter>;
  /** Some related `DocumentPageMatching` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentPageMatchingFilter>;
};

/** A filter to be used against many `DocumentProcess` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRevisionToManyDocumentProcessFilter = {
  /** Every related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentProcessFilter>;
  /** No related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentProcessFilter>;
  /** Some related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentProcessFilter>;
};

/** A connection to a list of `DocumentRevision` values. */
export type DocumentRevisionsConnection = {
  __typename?: 'DocumentRevisionsConnection';
  /** A list of edges which contains the `DocumentRevision` and cursor to aid in pagination. */
  edges: Array<DocumentRevisionsEdge>;
  /** A list of `DocumentRevision` objects. */
  nodes: Array<Maybe<DocumentRevision>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentRevision` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentRevision` edge in the connection. */
export type DocumentRevisionsEdge = {
  __typename?: 'DocumentRevisionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentRevision` at the end of the edge. */
  node?: Maybe<DocumentRevision>;
};

/** Methods to use when ordering `DocumentRevision`. */
export enum DocumentRevisionsOrderBy {
  DocumentsByIdAndCurrentRevisionNumberCountAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__COUNT_ASC',
  DocumentsByIdAndCurrentRevisionNumberCountDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__COUNT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxConfigAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CONFIG_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxConfigDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CONFIG_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxCreatedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CREATED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxCreatedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CREATED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxCreatedByIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CREATED_BY_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxCreatedByIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CREATED_BY_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxCurrentRevisionNumberAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxCurrentRevisionNumberDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDeletedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DELETED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDeletedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DELETED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDisplayDateAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DISPLAY_DATE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDisplayDateDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DISPLAY_DATE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDisplayTitleAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DISPLAY_TITLE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDisplayTitleDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DISPLAY_TITLE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDoesSupportFlowsAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDoesSupportFlowsDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxDownloadUrlAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DOWNLOAD_URL_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxDownloadUrlDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_DOWNLOAD_URL_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxEnableMagicPagesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxEnableMagicPagesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxExpirationDateAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_EXPIRATION_DATE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxExpirationDateDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_EXPIRATION_DATE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxExternalIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_EXTERNAL_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxExternalIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_EXTERNAL_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxExternalLinkIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_EXTERNAL_LINK_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxExternalLinkIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_EXTERNAL_LINK_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxFileNameAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_FILE_NAME_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxFileNameDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_FILE_NAME_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxFileSizeAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_FILE_SIZE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxFileSizeDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_FILE_SIZE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxFirestoreIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_FIRESTORE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxFirestoreIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_FIRESTORE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxIgnoredPagesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_IGNORED_PAGES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxIgnoredPagesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_IGNORED_PAGES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxInitialFileNameAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_INITIAL_FILE_NAME_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxInitialFileNameDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_INITIAL_FILE_NAME_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxInternalLinksAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_INTERNAL_LINKS_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxInternalLinksDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_INTERNAL_LINKS_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxIsDownloadableAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_IS_DOWNLOADABLE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxIsDownloadableDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_IS_DOWNLOADABLE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxIsPublishedAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_IS_PUBLISHED_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxIsPublishedDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_IS_PUBLISHED_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxLastModifiedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LAST_MODIFIED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxLastModifiedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LAST_MODIFIED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxLastModifiedByIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxLastModifiedByIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxLegalAppendixIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LEGAL_APPENDIX_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxLegalAppendixIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LEGAL_APPENDIX_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxLiteratureReferencesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LITERATURE_REFERENCES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxLiteratureReferencesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_LITERATURE_REFERENCES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxMimeTypeAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_MIME_TYPE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxMimeTypeDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_MIME_TYPE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxOrderAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORDER_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxOrderDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORDER_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxOriginalDownloadUrlAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxOriginalDownloadUrlDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxOriginalMimeTypeAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxOriginalMimeTypeDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxOriginalStorageIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxOriginalStorageIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxPagesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_PAGES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxPagesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_PAGES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxStorageIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_STORAGE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxStorageIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_STORAGE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxSysPeriodAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_SYS_PERIOD_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxSysPeriodDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_SYS_PERIOD_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxTagsAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_TAGS_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxTagsDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_TAGS_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxTeaserTextAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_TEASER_TEXT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxTeaserTextDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_TEASER_TEXT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxThumbnailStorageIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxThumbnailStorageIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxTopTitleAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_TOP_TITLE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxTopTitleDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_TOP_TITLE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxUploadedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_UPLOADED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxUploadedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_UPLOADED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMaxWorkspaceIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_WORKSPACE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMaxWorkspaceIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MAX_WORKSPACE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinConfigAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CONFIG_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinConfigDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CONFIG_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinCreatedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CREATED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinCreatedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CREATED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinCreatedByIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CREATED_BY_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinCreatedByIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CREATED_BY_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinCurrentRevisionNumberAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinCurrentRevisionNumberDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDeletedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DELETED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDeletedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DELETED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDisplayDateAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DISPLAY_DATE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDisplayDateDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DISPLAY_DATE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDisplayTitleAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DISPLAY_TITLE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDisplayTitleDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DISPLAY_TITLE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDoesSupportFlowsAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDoesSupportFlowsDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinDownloadUrlAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DOWNLOAD_URL_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinDownloadUrlDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_DOWNLOAD_URL_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinEnableMagicPagesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinEnableMagicPagesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinExpirationDateAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_EXPIRATION_DATE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinExpirationDateDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_EXPIRATION_DATE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinExternalIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_EXTERNAL_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinExternalIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_EXTERNAL_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinExternalLinkIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_EXTERNAL_LINK_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinExternalLinkIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_EXTERNAL_LINK_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinFileNameAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_FILE_NAME_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinFileNameDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_FILE_NAME_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinFileSizeAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_FILE_SIZE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinFileSizeDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_FILE_SIZE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinFirestoreIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_FIRESTORE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinFirestoreIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_FIRESTORE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinIgnoredPagesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_IGNORED_PAGES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinIgnoredPagesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_IGNORED_PAGES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinInitialFileNameAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_INITIAL_FILE_NAME_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinInitialFileNameDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_INITIAL_FILE_NAME_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinInternalLinksAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_INTERNAL_LINKS_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinInternalLinksDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_INTERNAL_LINKS_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinIsDownloadableAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_IS_DOWNLOADABLE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinIsDownloadableDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_IS_DOWNLOADABLE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinIsPublishedAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_IS_PUBLISHED_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinIsPublishedDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_IS_PUBLISHED_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinLastModifiedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LAST_MODIFIED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinLastModifiedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LAST_MODIFIED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinLastModifiedByIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinLastModifiedByIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinLegalAppendixIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LEGAL_APPENDIX_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinLegalAppendixIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LEGAL_APPENDIX_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinLiteratureReferencesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LITERATURE_REFERENCES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinLiteratureReferencesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_LITERATURE_REFERENCES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinMimeTypeAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_MIME_TYPE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinMimeTypeDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_MIME_TYPE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinOrderAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORDER_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinOrderDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORDER_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinOriginalDownloadUrlAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinOriginalDownloadUrlDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinOriginalMimeTypeAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinOriginalMimeTypeDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinOriginalStorageIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinOriginalStorageIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinPagesAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_PAGES_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinPagesDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_PAGES_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinStorageIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_STORAGE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinStorageIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_STORAGE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinSysPeriodAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_SYS_PERIOD_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinSysPeriodDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_SYS_PERIOD_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinTagsAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_TAGS_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinTagsDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_TAGS_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinTeaserTextAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_TEASER_TEXT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinTeaserTextDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_TEASER_TEXT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinThumbnailStorageIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinThumbnailStorageIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinTopTitleAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_TOP_TITLE_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinTopTitleDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_TOP_TITLE_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinUploadedAtAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_UPLOADED_AT_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinUploadedAtDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_UPLOADED_AT_DESC',
  DocumentsByIdAndCurrentRevisionNumberMinWorkspaceIdAsc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_WORKSPACE_ID_ASC',
  DocumentsByIdAndCurrentRevisionNumberMinWorkspaceIdDesc = 'DOCUMENTS_BY_ID_AND_CURRENT_REVISION_NUMBER__MIN_WORKSPACE_ID_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberCountAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__COUNT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberCountDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__COUNT_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxCreatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_CREATED_AT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxCreatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_CREATED_AT_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxCrossRevIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_CROSS_REV_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxCrossRevIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_CROSS_REV_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxExtractedTextAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_EXTRACTED_TEXT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxExtractedTextDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_EXTRACTED_TEXT_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxLinkedDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_LINKED_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxLinkedDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_LINKED_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxPageNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_PAGE_NUMBER_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxPageNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_PAGE_NUMBER_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxPageTypeAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_PAGE_TYPE_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxPageTypeDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_PAGE_TYPE_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxRevisionNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_REVISION_NUMBER_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxRevisionNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_REVISION_NUMBER_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxThumbnailAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_THUMBNAIL_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxThumbnailDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_THUMBNAIL_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxUpdatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_UPDATED_AT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMaxUpdatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_UPDATED_AT_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinCreatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_CREATED_AT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinCreatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_CREATED_AT_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinCrossRevIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_CROSS_REV_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinCrossRevIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_CROSS_REV_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinExtractedTextAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_EXTRACTED_TEXT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinExtractedTextDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_EXTRACTED_TEXT_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinLinkedDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_LINKED_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinLinkedDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_LINKED_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinPageNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_PAGE_NUMBER_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinPageNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_PAGE_NUMBER_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinPageTypeAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_PAGE_TYPE_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinPageTypeDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_PAGE_TYPE_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinRevisionNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_REVISION_NUMBER_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinRevisionNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_REVISION_NUMBER_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinThumbnailAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_THUMBNAIL_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinThumbnailDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_THUMBNAIL_DESC',
  DocumentPagesByDocumentIdAndRevisionNumberMinUpdatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_UPDATED_AT_ASC',
  DocumentPagesByDocumentIdAndRevisionNumberMinUpdatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_UPDATED_AT_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberCountAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__COUNT_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberCountDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__COUNT_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxDocumentIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_DOCUMENT_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxDocumentIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_DOCUMENT_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxScoreAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_SCORE_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxScoreDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_SCORE_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMaxTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MAX_TARGET_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinDocumentIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_DOCUMENT_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinDocumentIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_DOCUMENT_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinScoreAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_SCORE_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinScoreDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_SCORE_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndSourceRevisionNumberMinTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_SOURCE_REVISION_NUMBER__MIN_TARGET_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberCountAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__COUNT_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberCountDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__COUNT_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxDocumentIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_DOCUMENT_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxDocumentIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_DOCUMENT_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxScoreAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_SCORE_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxScoreDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_SCORE_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMaxTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MAX_TARGET_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinDocumentIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_DOCUMENT_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinDocumentIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_DOCUMENT_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_ID_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_ID_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinScoreAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_SCORE_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinScoreDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_SCORE_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdAndTargetRevisionNumberMinTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID_AND_TARGET_REVISION_NUMBER__MIN_TARGET_REVISION_NUMBER_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberCountAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__COUNT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberCountDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__COUNT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxDocumentIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_DOCUMENT_ID_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxDocumentIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_DOCUMENT_ID_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxFailedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_FAILED_AT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxFailedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_FAILED_AT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_ID_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_ID_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxInitiatorIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_INITIATOR_ID_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxInitiatorIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_INITIATOR_ID_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxLastErrorAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_LAST_ERROR_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxLastErrorDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_LAST_ERROR_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxProgressAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_PROGRESS_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxProgressDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_PROGRESS_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxResultAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_RESULT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxResultDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_RESULT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxRevisionNumberAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_REVISION_NUMBER_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxRevisionNumberDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_REVISION_NUMBER_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxStageAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_STAGE_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxStageDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_STAGE_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxStartedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_STARTED_AT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxStartedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_STARTED_AT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxSucceededAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_SUCCEEDED_AT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxSucceededAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_SUCCEEDED_AT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxUnitOfWorkAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_UNIT_OF_WORK_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMaxUnitOfWorkDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MAX_UNIT_OF_WORK_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinDocumentIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_DOCUMENT_ID_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinDocumentIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_DOCUMENT_ID_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinFailedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_FAILED_AT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinFailedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_FAILED_AT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_ID_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_ID_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinInitiatorIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_INITIATOR_ID_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinInitiatorIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_INITIATOR_ID_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinLastErrorAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_LAST_ERROR_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinLastErrorDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_LAST_ERROR_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinProgressAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_PROGRESS_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinProgressDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_PROGRESS_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinResultAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_RESULT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinResultDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_RESULT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinRevisionNumberAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_REVISION_NUMBER_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinRevisionNumberDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_REVISION_NUMBER_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinStageAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_STAGE_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinStageDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_STAGE_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinStartedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_STARTED_AT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinStartedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_STARTED_AT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinSucceededAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_SUCCEEDED_AT_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinSucceededAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_SUCCEEDED_AT_DESC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinUnitOfWorkAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_UNIT_OF_WORK_ASC',
  DocumentProcessesByDocumentIdAndRevisionNumberMinUnitOfWorkDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID_AND_REVISION_NUMBER__MIN_UNIT_OF_WORK_DESC',
  DownloadUrlAsc = 'DOWNLOAD_URL_ASC',
  DownloadUrlDesc = 'DOWNLOAD_URL_DESC',
  FileNameAsc = 'FILE_NAME_ASC',
  FileNameDesc = 'FILE_NAME_DESC',
  FileSizeAsc = 'FILE_SIZE_ASC',
  FileSizeDesc = 'FILE_SIZE_DESC',
  IsCurrentAsc = 'IS_CURRENT_ASC',
  IsCurrentDesc = 'IS_CURRENT_DESC',
  Natural = 'NATURAL',
  OriginalDownloadUrlAsc = 'ORIGINAL_DOWNLOAD_URL_ASC',
  OriginalDownloadUrlDesc = 'ORIGINAL_DOWNLOAD_URL_DESC',
  OriginalMimeTypeAsc = 'ORIGINAL_MIME_TYPE_ASC',
  OriginalMimeTypeDesc = 'ORIGINAL_MIME_TYPE_DESC',
  OriginalStorageIdAsc = 'ORIGINAL_STORAGE_ID_ASC',
  OriginalStorageIdDesc = 'ORIGINAL_STORAGE_ID_DESC',
  PagesAsc = 'PAGES_ASC',
  PagesDesc = 'PAGES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessingErrorAsc = 'PROCESSING_ERROR_ASC',
  ProcessingErrorDesc = 'PROCESSING_ERROR_DESC',
  RevisionNumberAsc = 'REVISION_NUMBER_ASC',
  RevisionNumberDesc = 'REVISION_NUMBER_DESC',
  StorageIdAsc = 'STORAGE_ID_ASC',
  StorageIdDesc = 'STORAGE_ID_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC',
  ThumbnailStorageIdAsc = 'THUMBNAIL_STORAGE_ID_ASC',
  ThumbnailStorageIdDesc = 'THUMBNAIL_STORAGE_ID_DESC',
  UploadedAtAsc = 'UPLOADED_AT_ASC',
  UploadedAtDesc = 'UPLOADED_AT_DESC'
}

export type DocumentSpace = Node & {
  __typename?: 'DocumentSpace';
  allowedEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  codeOnAccessCard?: Maybe<Scalars['String']['output']>;
  codeOnAccessCardLastUsedAt?: Maybe<Scalars['Datetime']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpace`. */
  config?: Maybe<DocumentSpaceConfig>;
  configId?: Maybe<Scalars['BigInt']['output']>;
  /** @deprecated true */
  contactDetails?: Maybe<UserContactDetail>;
  /** @deprecated true */
  contactDetailsId?: Maybe<Scalars['BigInt']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `DocumentSpace`. */
  creator?: Maybe<User>;
  creatorId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceAccess`. */
  documentSpaceAccesses: DocumentSpaceAccessesConnection;
  /** Reads a single `DocumentSpaceCrmMapping` that is related to this `DocumentSpace`. */
  documentSpaceCrmMapping?: Maybe<DocumentSpaceCrmMapping>;
  /**
   * Reads and enables pagination through a set of `DocumentSpaceCrmMapping`.
   * @deprecated Please use documentSpaceCrmMapping instead
   */
  documentSpaceCrmMappings: DocumentSpaceCrmMappingsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceItem`. */
  documentSpaceItems: DocumentSpaceItemsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkMapping`. */
  documentSpaceLinkMappingsBySpaceId: DocumentSpaceLinkMappingsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLink`. */
  documentSpaceLinks: DocumentSpaceLinksConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceSection`. */
  documentSpaceSections: DocumentSpaceSectionsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceSession`. */
  documentSpaceSessions: DocumentSpaceSessionsConnection;
  /**
   * Reads and enables pagination through a set of `DocumentSpaceVisitStatistic`.
   * @deprecated Please use visitStatistics instead
   */
  documentSpaceVisitStatistics: DocumentSpaceVisitStatisticsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceVoucher`. */
  documentSpaceVouchers: DocumentSpaceVouchersConnection;
  encryptedPassword?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `MaDocumentSpaceDocumentStatistic`. */
  maDocumentSpaceDocumentStatistics: MaDocumentSpaceDocumentStatisticsConnection;
  /** Reads and enables pagination through a set of `MaDocumentSpaceLinkStatistic`. */
  maDocumentSpaceLinkStatistics: MaDocumentSpaceLinkStatisticsConnection;
  /** Reads and enables pagination through a set of `MaDocumentSpacePageStatistic`. */
  maDocumentSpacePageStatistics: MaDocumentSpacePageStatisticsConnection;
  /** Reads a single `MaDocumentSpaceStatistic` that is related to this `DocumentSpace`. */
  maDocumentSpaceStatistic?: Maybe<MaDocumentSpaceStatistic>;
  /**
   * Reads and enables pagination through a set of `MaDocumentSpaceStatistic`.
   * @deprecated Please use maDocumentSpaceStatistic instead
   */
  maDocumentSpaceStatistics: MaDocumentSpaceStatisticsConnection;
  /** Reads and enables pagination through a set of `MaDocumentSpaceVideoStatistic`. */
  maDocumentSpaceVideoStatistics: MaDocumentSpaceVideoStatisticsConnection;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  personalMessage?: Maybe<Scalars['String']['output']>;
  showContactDetails: Scalars['Boolean']['output'];
  sysPeriod: DatetimeRange;
  /** Reads a single `Tenant` that is related to this `DocumentSpace`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  trackingDeactivated: Scalars['Boolean']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `DocumentSpaceVisitStatistic` that is related to this `DocumentSpace`. */
  visitStatistics?: Maybe<DocumentSpaceVisitStatistic>;
};


export type DocumentSpaceDocumentSpaceAccessesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceAccessCondition>;
  filter?: InputMaybe<DocumentSpaceAccessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};


export type DocumentSpaceDocumentSpaceCrmMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCrmMappingCondition>;
  filter?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};


export type DocumentSpaceDocumentSpaceItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceItemCondition>;
  filter?: InputMaybe<DocumentSpaceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};


export type DocumentSpaceDocumentSpaceLinkMappingsBySpaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkMappingCondition>;
  filter?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkMappingsOrderBy>>;
};


export type DocumentSpaceDocumentSpaceLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkCondition>;
  filter?: InputMaybe<DocumentSpaceLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinksOrderBy>>;
};


export type DocumentSpaceDocumentSpaceSectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceSectionCondition>;
  filter?: InputMaybe<DocumentSpaceSectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceSectionsOrderBy>>;
};


export type DocumentSpaceDocumentSpaceSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceSessionCondition>;
  filter?: InputMaybe<DocumentSpaceSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceSessionsOrderBy>>;
};


export type DocumentSpaceDocumentSpaceVisitStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceVisitStatisticCondition>;
  filter?: InputMaybe<DocumentSpaceVisitStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceVisitStatisticsOrderBy>>;
};


export type DocumentSpaceDocumentSpaceVouchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceVoucherCondition>;
  filter?: InputMaybe<DocumentSpaceVoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceVouchersOrderBy>>;
};


export type DocumentSpaceMaDocumentSpaceDocumentStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceDocumentStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceDocumentStatisticsOrderBy>>;
};


export type DocumentSpaceMaDocumentSpaceLinkStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceLinkStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceLinkStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceLinkStatisticsOrderBy>>;
};


export type DocumentSpaceMaDocumentSpacePageStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpacePageStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpacePageStatisticsOrderBy>>;
};


export type DocumentSpaceMaDocumentSpaceStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceStatisticsOrderBy>>;
};


export type DocumentSpaceMaDocumentSpaceVideoStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceVideoStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceVideoStatisticsOrderBy>>;
};

export type DocumentSpaceAccess = Node & {
  __typename?: 'DocumentSpaceAccess';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['BigInt']['output']>;
  displayContactDetails: Scalars['Boolean']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceAccess`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  user?: Maybe<User>;
  userId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `DocumentSpaceAccess` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceAccessCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `displayContactDetails` field. */
  displayContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `DocumentSpaceAccess` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceAccessFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceAccessFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` relation. */
  creator?: InputMaybe<UserFilter>;
  /** A related `creator` exists. */
  creatorExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `displayContactDetails` field. */
  displayContactDetails?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceAccessFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceAccessFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `DocumentSpaceAccess` */
export type DocumentSpaceAccessInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  displayContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  role: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['BigInt']['input'];
};

/** Represents an update to a `DocumentSpaceAccess`. Fields that are set will be updated. */
export type DocumentSpaceAccessPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  displayContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `DocumentSpaceAccess` values. */
export type DocumentSpaceAccessesConnection = {
  __typename?: 'DocumentSpaceAccessesConnection';
  /** A list of edges which contains the `DocumentSpaceAccess` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceAccessesEdge>;
  /** A list of `DocumentSpaceAccess` objects. */
  nodes: Array<Maybe<DocumentSpaceAccess>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceAccess` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceAccess` edge in the connection. */
export type DocumentSpaceAccessesEdge = {
  __typename?: 'DocumentSpaceAccessesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceAccess` at the end of the edge. */
  node?: Maybe<DocumentSpaceAccess>;
};

/** Methods to use when ordering `DocumentSpaceAccess`. */
export enum DocumentSpaceAccessesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorIdAsc = 'CREATOR_ID_ASC',
  CreatorIdDesc = 'CREATOR_ID_DESC',
  DisplayContactDetailsAsc = 'DISPLAY_CONTACT_DETAILS_ASC',
  DisplayContactDetailsDesc = 'DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByCreatorIdAppConsentGivenAtAsc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByCreatorIdAppConsentGivenAtDesc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByCreatorIdConfigAsc = 'USER_BY_CREATOR_ID__CONFIG_ASC',
  UserByCreatorIdConfigDesc = 'USER_BY_CREATOR_ID__CONFIG_DESC',
  UserByCreatorIdCreatedAtAsc = 'USER_BY_CREATOR_ID__CREATED_AT_ASC',
  UserByCreatorIdCreatedAtDesc = 'USER_BY_CREATOR_ID__CREATED_AT_DESC',
  UserByCreatorIdCrmContactVisibilityFilterAsc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByCreatorIdCrmContactVisibilityFilterDesc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByCreatorIdDefaultWorkspaceIdAsc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByCreatorIdDefaultWorkspaceIdDesc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByCreatorIdDisabledAsc = 'USER_BY_CREATOR_ID__DISABLED_ASC',
  UserByCreatorIdDisabledDesc = 'USER_BY_CREATOR_ID__DISABLED_DESC',
  UserByCreatorIdDisplayNameAsc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_ASC',
  UserByCreatorIdDisplayNameDesc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_DESC',
  UserByCreatorIdEmailAsc = 'USER_BY_CREATOR_ID__EMAIL_ASC',
  UserByCreatorIdEmailDesc = 'USER_BY_CREATOR_ID__EMAIL_DESC',
  UserByCreatorIdExternalGroupsAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_ASC',
  UserByCreatorIdExternalGroupsDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_DESC',
  UserByCreatorIdExternalGroupsSyncedAtAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByCreatorIdExternalGroupsSyncedAtDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByCreatorIdFirebaseAuthIdAsc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_ASC',
  UserByCreatorIdFirebaseAuthIdDesc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_DESC',
  UserByCreatorIdFlagsAsc = 'USER_BY_CREATOR_ID__FLAGS_ASC',
  UserByCreatorIdFlagsDesc = 'USER_BY_CREATOR_ID__FLAGS_DESC',
  UserByCreatorIdIdAsc = 'USER_BY_CREATOR_ID__ID_ASC',
  UserByCreatorIdIdDesc = 'USER_BY_CREATOR_ID__ID_DESC',
  UserByCreatorIdIsTenantAdminAsc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_ASC',
  UserByCreatorIdIsTenantAdminDesc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_DESC',
  UserByCreatorIdRegisteredAtAsc = 'USER_BY_CREATOR_ID__REGISTERED_AT_ASC',
  UserByCreatorIdRegisteredAtDesc = 'USER_BY_CREATOR_ID__REGISTERED_AT_DESC',
  UserByCreatorIdSysPeriodAsc = 'USER_BY_CREATOR_ID__SYS_PERIOD_ASC',
  UserByCreatorIdSysPeriodDesc = 'USER_BY_CREATOR_ID__SYS_PERIOD_DESC',
  UserByCreatorIdTenantIdAsc = 'USER_BY_CREATOR_ID__TENANT_ID_ASC',
  UserByCreatorIdTenantIdDesc = 'USER_BY_CREATOR_ID__TENANT_ID_DESC',
  UserByCreatorIdUpdatedAtAsc = 'USER_BY_CREATOR_ID__UPDATED_AT_ASC',
  UserByCreatorIdUpdatedAtDesc = 'USER_BY_CREATOR_ID__UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/**
 * A condition to be used against `DocumentSpace` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceCondition = {
  /** Checks for equality with the object’s `allowedEmailAddresses` field. */
  allowedEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `codeOnAccessCard` field. */
  codeOnAccessCard?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `codeOnAccessCardLastUsedAt` field. */
  codeOnAccessCardLastUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `contactDetailsId` field. */
  contactDetailsId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `showContactDetails` field. */
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `trackingDeactivated` field. */
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DocumentSpaceConfig = Node & {
  __typename?: 'DocumentSpaceConfig';
  contentTitle?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  customCss?: Maybe<Scalars['String']['output']>;
  defaultLanguage: Scalars['String']['output'];
  displayHero: Scalars['Boolean']['output'];
  displayOptIn?: Maybe<Scalars['Boolean']['output']>;
  displayOptOut: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceConfigTranslation`. */
  documentSpaceConfigTranslationsByConfigId: DocumentSpaceConfigTranslationsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkTranslation`. */
  documentSpaceLinkTranslationsByConfigId: DocumentSpaceLinkTranslationsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLink`. */
  documentSpaceLinksByConfigId: DocumentSpaceLinksConnection;
  /** Reads and enables pagination through a set of `DocumentSpace`. */
  documentSpacesByConfigId: DocumentSpacesConnection;
  footerLinks?: Maybe<Scalars['JSON']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['BigInt']['output'];
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  heroLinkText?: Maybe<Scalars['String']['output']>;
  heroLinkUrl?: Maybe<Scalars['String']['output']>;
  heroScaling?: Maybe<Scalars['String']['output']>;
  heroSubtitle?: Maybe<Scalars['String']['output']>;
  heroTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  indication?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfig`. */
  languageCodeByDefaultLanguage?: Maybe<LanguageCode>;
  legalNote?: Maybe<Scalars['String']['output']>;
  legalNoteUrl?: Maybe<Scalars['String']['output']>;
  linkedTabOrder: Scalars['Int']['output'];
  logoSmallUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newTab?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  optInContent?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  requiresEmailAuthentication: Scalars['Boolean']['output'];
  spaceCount?: Maybe<Scalars['Int']['output']>;
  stylesheet?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Team` that is related to this `DocumentSpaceConfig`. */
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['BigInt']['output']>;
  template?: Maybe<DocumentSpaceTemplate>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceConfig`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `DocumentSpaceLinkGroup` that is related to this `DocumentSpaceConfig`. */
  tenantGroup?: Maybe<DocumentSpaceLinkGroup>;
  tenantId: Scalars['BigInt']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `DocumentSpaceConfig`. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['BigInt']['output']>;
};


export type DocumentSpaceConfigDocumentSpaceConfigTranslationsByConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigTranslationsOrderBy>>;
};


export type DocumentSpaceConfigDocumentSpaceLinkTranslationsByConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};


export type DocumentSpaceConfigDocumentSpaceLinksByConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkCondition>;
  filter?: InputMaybe<DocumentSpaceLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinksOrderBy>>;
};


export type DocumentSpaceConfigDocumentSpacesByConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCondition>;
  filter?: InputMaybe<DocumentSpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};

/**
 * A condition to be used against `DocumentSpaceConfig` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceConfigCondition = {
  /** Checks for equality with the object’s `contentTitle` field. */
  contentTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `customCss` field. */
  customCss?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultLanguage` field. */
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `displayHero` field. */
  displayHero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `displayOptIn` field. */
  displayOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `displayOptOut` field. */
  displayOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `footerLinks` field. */
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `footerText` field. */
  footerText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `heroImageUrl` field. */
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroLinkText` field. */
  heroLinkText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroLinkUrl` field. */
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroScaling` field. */
  heroScaling?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroSubtitle` field. */
  heroSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroTitle` field. */
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `indication` field. */
  indication?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legalNote` field. */
  legalNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legalNoteUrl` field. */
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `linkedTabOrder` field. */
  linkedTabOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `logoSmallUrl` field. */
  logoSmallUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logoUrl` field. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `newTab` field. */
  newTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `optInContent` field. */
  optInContent?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `productName` field. */
  productName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `requiresEmailAuthentication` field. */
  requiresEmailAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `stylesheet` field. */
  stylesheet?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `template` field. */
  template?: InputMaybe<DocumentSpaceTemplate>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedById` field. */
  updatedById?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `DocumentSpaceConfig` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceConfigFilter>>;
  /** Filter by the object’s `contentTitle` field. */
  contentTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customCss` field. */
  customCss?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultLanguage` field. */
  defaultLanguage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayHero` field. */
  displayHero?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `displayOptIn` field. */
  displayOptIn?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `displayOptOut` field. */
  displayOptOut?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `documentSpaceConfigTranslationsByConfigId` relation. */
  documentSpaceConfigTranslationsByConfigId?: InputMaybe<DocumentSpaceConfigToManyDocumentSpaceConfigTranslationFilter>;
  /** Some related `documentSpaceConfigTranslationsByConfigId` exist. */
  documentSpaceConfigTranslationsByConfigIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinkTranslationsByConfigId` relation. */
  documentSpaceLinkTranslationsByConfigId?: InputMaybe<DocumentSpaceConfigToManyDocumentSpaceLinkTranslationFilter>;
  /** Some related `documentSpaceLinkTranslationsByConfigId` exist. */
  documentSpaceLinkTranslationsByConfigIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinksByConfigId` relation. */
  documentSpaceLinksByConfigId?: InputMaybe<DocumentSpaceConfigToManyDocumentSpaceLinkFilter>;
  /** Some related `documentSpaceLinksByConfigId` exist. */
  documentSpaceLinksByConfigIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpacesByConfigId` relation. */
  documentSpacesByConfigId?: InputMaybe<DocumentSpaceConfigToManyDocumentSpaceFilter>;
  /** Some related `documentSpacesByConfigId` exist. */
  documentSpacesByConfigIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `footerLinks` field. */
  footerLinks?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `footerText` field. */
  footerText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `heroImageUrl` field. */
  heroImageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroLinkText` field. */
  heroLinkText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroLinkUrl` field. */
  heroLinkUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroScaling` field. */
  heroScaling?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroSubtitle` field. */
  heroSubtitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroTitle` field. */
  heroTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `indication` field. */
  indication?: InputMaybe<StringFilter>;
  /** Filter by the object’s `languageCodeByDefaultLanguage` relation. */
  languageCodeByDefaultLanguage?: InputMaybe<LanguageCodeFilter>;
  /** Filter by the object’s `legalNote` field. */
  legalNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `legalNoteUrl` field. */
  legalNoteUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `linkedTabOrder` field. */
  linkedTabOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `logoSmallUrl` field. */
  logoSmallUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logoUrl` field. */
  logoUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `newTab` field. */
  newTab?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceConfigFilter>;
  /** Filter by the object’s `optInContent` field. */
  optInContent?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceConfigFilter>>;
  /** Filter by the object’s `productName` field. */
  productName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `requiresEmailAuthentication` field. */
  requiresEmailAuthentication?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `spaceCount` field. */
  spaceCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stylesheet` field. */
  stylesheet?: InputMaybe<StringFilter>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<TeamFilter>;
  /** A related `team` exists. */
  teamExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `template` field. */
  template?: InputMaybe<DocumentSpaceTemplateFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantGroup` relation. */
  tenantGroup?: InputMaybe<DocumentSpaceLinkGroupFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` relation. */
  updatedBy?: InputMaybe<UserFilter>;
  /** A related `updatedBy` exists. */
  updatedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `updatedById` field. */
  updatedById?: InputMaybe<BigIntFilter>;
};

/** Represents an update to a `DocumentSpaceConfig`. Fields that are set will be updated. */
export type DocumentSpaceConfigPatch = {
  contentTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  customCss?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  displayHero?: InputMaybe<Scalars['Boolean']['input']>;
  displayOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  displayOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  heroLinkText?: InputMaybe<Scalars['String']['input']>;
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
  heroScaling?: InputMaybe<Scalars['String']['input']>;
  heroSubtitle?: InputMaybe<Scalars['String']['input']>;
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  indication?: InputMaybe<Scalars['String']['input']>;
  legalNote?: InputMaybe<Scalars['String']['input']>;
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
  linkedTabOrder?: InputMaybe<Scalars['Int']['input']>;
  logoSmallUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newTab?: InputMaybe<Scalars['Boolean']['input']>;
  optInContent?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  requiresEmailAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  stylesheet?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  template?: InputMaybe<DocumentSpaceTemplate>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedById?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against many `DocumentSpaceConfigTranslation` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceConfigToManyDocumentSpaceConfigTranslationFilter = {
  /** Every related `DocumentSpaceConfigTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  /** No related `DocumentSpaceConfigTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  /** Some related `DocumentSpaceConfigTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
};

/** A filter to be used against many `DocumentSpace` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceConfigToManyDocumentSpaceFilter = {
  /** Every related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceFilter>;
  /** No related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceFilter>;
  /** Some related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceFilter>;
};

/** A filter to be used against many `DocumentSpaceLink` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceConfigToManyDocumentSpaceLinkFilter = {
  /** Every related `DocumentSpaceLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkFilter>;
  /** No related `DocumentSpaceLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkFilter>;
  /** Some related `DocumentSpaceLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkFilter>;
};

/** A filter to be used against many `DocumentSpaceLinkTranslation` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceConfigToManyDocumentSpaceLinkTranslationFilter = {
  /** Every related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** No related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** Some related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
};

export type DocumentSpaceConfigTranslation = Node & {
  __typename?: 'DocumentSpaceConfigTranslation';
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceConfigTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  configId?: Maybe<Scalars['BigInt']['output']>;
  createdAt: Scalars['Datetime']['output'];
  footerLinks?: Maybe<Scalars['JSON']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  heroLinkText?: Maybe<Scalars['String']['output']>;
  heroLinkUrl?: Maybe<Scalars['String']['output']>;
  heroSubtitle?: Maybe<Scalars['String']['output']>;
  heroTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  languageCode: Scalars['String']['output'];
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfigTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  legalNote?: Maybe<Scalars['String']['output']>;
  legalNoteUrl?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  optInContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DocumentSpaceConfigTranslation` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceConfigTranslationCondition = {
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `footerLinks` field. */
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `footerText` field. */
  footerText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroImageUrl` field. */
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroLinkText` field. */
  heroLinkText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroLinkUrl` field. */
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroSubtitle` field. */
  heroSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `heroTitle` field. */
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `languageCode` field. */
  languageCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legalNote` field. */
  legalNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `legalNoteUrl` field. */
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `optInContent` field. */
  optInContent?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceConfigTranslation` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceConfigTranslationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceConfigTranslationFilter>>;
  /** Filter by the object’s `config` relation. */
  config?: InputMaybe<DocumentSpaceConfigFilter>;
  /** A related `config` exists. */
  configExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `footerLinks` field. */
  footerLinks?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `footerText` field. */
  footerText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroImageUrl` field. */
  heroImageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroLinkText` field. */
  heroLinkText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroLinkUrl` field. */
  heroLinkUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroSubtitle` field. */
  heroSubtitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `heroTitle` field. */
  heroTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `languageCode` field. */
  languageCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `languageCodeByLanguageCode` relation. */
  languageCodeByLanguageCode?: InputMaybe<LanguageCodeFilter>;
  /** Filter by the object’s `legalNote` field. */
  legalNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `legalNoteUrl` field. */
  legalNoteUrl?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  /** Filter by the object’s `optInContent` field. */
  optInContent?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceConfigTranslationFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceConfigTranslation` */
export type DocumentSpaceConfigTranslationInput = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  heroLinkText?: InputMaybe<Scalars['String']['input']>;
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
  heroSubtitle?: InputMaybe<Scalars['String']['input']>;
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  languageCode: Scalars['String']['input'];
  legalNote?: InputMaybe<Scalars['String']['input']>;
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
  optInContent?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceConfigTranslation`. Fields that are set will be updated. */
export type DocumentSpaceConfigTranslationPatch = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  heroLinkText?: InputMaybe<Scalars['String']['input']>;
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
  heroSubtitle?: InputMaybe<Scalars['String']['input']>;
  heroTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  legalNote?: InputMaybe<Scalars['String']['input']>;
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
  optInContent?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentSpaceConfigTranslation` values. */
export type DocumentSpaceConfigTranslationsConnection = {
  __typename?: 'DocumentSpaceConfigTranslationsConnection';
  /** A list of edges which contains the `DocumentSpaceConfigTranslation` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceConfigTranslationsEdge>;
  /** A list of `DocumentSpaceConfigTranslation` objects. */
  nodes: Array<Maybe<DocumentSpaceConfigTranslation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceConfigTranslation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceConfigTranslation` edge in the connection. */
export type DocumentSpaceConfigTranslationsEdge = {
  __typename?: 'DocumentSpaceConfigTranslationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceConfigTranslation` at the end of the edge. */
  node?: Maybe<DocumentSpaceConfigTranslation>;
};

/** Methods to use when ordering `DocumentSpaceConfigTranslation`. */
export enum DocumentSpaceConfigTranslationsOrderBy {
  ConfigIdAsc = 'CONFIG_ID_ASC',
  ConfigIdDesc = 'CONFIG_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceConfigByConfigIdContentTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_ASC',
  DocumentSpaceConfigByConfigIdContentTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_DESC',
  DocumentSpaceConfigByConfigIdCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_ASC',
  DocumentSpaceConfigByConfigIdCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_DESC',
  DocumentSpaceConfigByConfigIdCustomCssAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_ASC',
  DocumentSpaceConfigByConfigIdCustomCssDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_DESC',
  DocumentSpaceConfigByConfigIdDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigByConfigIdDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigByConfigIdDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_ASC',
  DocumentSpaceConfigByConfigIdDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigByConfigIdFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_ASC',
  DocumentSpaceConfigByConfigIdFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_DESC',
  DocumentSpaceConfigByConfigIdFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_ASC',
  DocumentSpaceConfigByConfigIdFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_DESC',
  DocumentSpaceConfigByConfigIdGroupIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_ASC',
  DocumentSpaceConfigByConfigIdGroupIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_DESC',
  DocumentSpaceConfigByConfigIdHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroScalingAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_ASC',
  DocumentSpaceConfigByConfigIdHeroScalingDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_DESC',
  DocumentSpaceConfigByConfigIdHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_DESC',
  DocumentSpaceConfigByConfigIdHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_DESC',
  DocumentSpaceConfigByConfigIdIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_ASC',
  DocumentSpaceConfigByConfigIdIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigByConfigIdLogoUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_DESC',
  DocumentSpaceConfigByConfigIdNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_ASC',
  DocumentSpaceConfigByConfigIdNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_DESC',
  DocumentSpaceConfigByConfigIdNewTabAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_ASC',
  DocumentSpaceConfigByConfigIdNewTabDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_DESC',
  DocumentSpaceConfigByConfigIdOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigByConfigIdOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigByConfigIdProductNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_ASC',
  DocumentSpaceConfigByConfigIdProductNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_DESC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigByConfigIdStylesheetAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_ASC',
  DocumentSpaceConfigByConfigIdStylesheetDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_DESC',
  DocumentSpaceConfigByConfigIdTeamIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_ASC',
  DocumentSpaceConfigByConfigIdTeamIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_DESC',
  DocumentSpaceConfigByConfigIdTemplateAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_ASC',
  DocumentSpaceConfigByConfigIdTemplateDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_DESC',
  DocumentSpaceConfigByConfigIdTenantIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_ASC',
  DocumentSpaceConfigByConfigIdTenantIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_DESC',
  DocumentSpaceConfigByConfigIdTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_ASC',
  DocumentSpaceConfigByConfigIdTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_DESC',
  DocumentSpaceConfigByConfigIdUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_ASC',
  DocumentSpaceConfigByConfigIdUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_DESC',
  DocumentSpaceConfigByConfigIdUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_ASC',
  DocumentSpaceConfigByConfigIdUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_DESC',
  FooterLinksAsc = 'FOOTER_LINKS_ASC',
  FooterLinksDesc = 'FOOTER_LINKS_DESC',
  FooterTextAsc = 'FOOTER_TEXT_ASC',
  FooterTextDesc = 'FOOTER_TEXT_DESC',
  HeroImageUrlAsc = 'HERO_IMAGE_URL_ASC',
  HeroImageUrlDesc = 'HERO_IMAGE_URL_DESC',
  HeroLinkTextAsc = 'HERO_LINK_TEXT_ASC',
  HeroLinkTextDesc = 'HERO_LINK_TEXT_DESC',
  HeroLinkUrlAsc = 'HERO_LINK_URL_ASC',
  HeroLinkUrlDesc = 'HERO_LINK_URL_DESC',
  HeroSubtitleAsc = 'HERO_SUBTITLE_ASC',
  HeroSubtitleDesc = 'HERO_SUBTITLE_DESC',
  HeroTitleAsc = 'HERO_TITLE_ASC',
  HeroTitleDesc = 'HERO_TITLE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LanguageCodeAsc = 'LANGUAGE_CODE_ASC',
  LanguageCodeByLanguageCodeCodeAsc = 'LANGUAGE_CODE_BY_LANGUAGE_CODE__CODE_ASC',
  LanguageCodeByLanguageCodeCodeDesc = 'LANGUAGE_CODE_BY_LANGUAGE_CODE__CODE_DESC',
  LanguageCodeDesc = 'LANGUAGE_CODE_DESC',
  LegalNoteAsc = 'LEGAL_NOTE_ASC',
  LegalNoteDesc = 'LEGAL_NOTE_DESC',
  LegalNoteUrlAsc = 'LEGAL_NOTE_URL_ASC',
  LegalNoteUrlDesc = 'LEGAL_NOTE_URL_DESC',
  Natural = 'NATURAL',
  OptInContentAsc = 'OPT_IN_CONTENT_ASC',
  OptInContentDesc = 'OPT_IN_CONTENT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `DocumentSpaceConfig` values. */
export type DocumentSpaceConfigsConnection = {
  __typename?: 'DocumentSpaceConfigsConnection';
  /** A list of edges which contains the `DocumentSpaceConfig` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceConfigsEdge>;
  /** A list of `DocumentSpaceConfig` objects. */
  nodes: Array<Maybe<DocumentSpaceConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceConfig` edge in the connection. */
export type DocumentSpaceConfigsEdge = {
  __typename?: 'DocumentSpaceConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceConfig` at the end of the edge. */
  node?: Maybe<DocumentSpaceConfig>;
};

/** Methods to use when ordering `DocumentSpaceConfig`. */
export enum DocumentSpaceConfigsOrderBy {
  ContentTitleAsc = 'CONTENT_TITLE_ASC',
  ContentTitleDesc = 'CONTENT_TITLE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomCssAsc = 'CUSTOM_CSS_ASC',
  CustomCssDesc = 'CUSTOM_CSS_DESC',
  DefaultLanguageAsc = 'DEFAULT_LANGUAGE_ASC',
  DefaultLanguageDesc = 'DEFAULT_LANGUAGE_DESC',
  DisplayHeroAsc = 'DISPLAY_HERO_ASC',
  DisplayHeroDesc = 'DISPLAY_HERO_DESC',
  DisplayOptInAsc = 'DISPLAY_OPT_IN_ASC',
  DisplayOptInDesc = 'DISPLAY_OPT_IN_DESC',
  DisplayOptOutAsc = 'DISPLAY_OPT_OUT_ASC',
  DisplayOptOutDesc = 'DISPLAY_OPT_OUT_DESC',
  DocumentSpacesByConfigIdCountAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__COUNT_ASC',
  DocumentSpacesByConfigIdCountDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__COUNT_DESC',
  DocumentSpacesByConfigIdMaxAllowedEmailAddressesAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpacesByConfigIdMaxAllowedEmailAddressesDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpacesByConfigIdMaxCodeOnAccessCardAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CODE_ON_ACCESS_CARD_ASC',
  DocumentSpacesByConfigIdMaxCodeOnAccessCardDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CODE_ON_ACCESS_CARD_DESC',
  DocumentSpacesByConfigIdMaxCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpacesByConfigIdMaxCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpacesByConfigIdMaxCommentAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_COMMENT_ASC',
  DocumentSpacesByConfigIdMaxCommentDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_COMMENT_DESC',
  DocumentSpacesByConfigIdMaxConfigIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CONFIG_ID_ASC',
  DocumentSpacesByConfigIdMaxConfigIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CONFIG_ID_DESC',
  DocumentSpacesByConfigIdMaxCreatedAtAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CREATED_AT_ASC',
  DocumentSpacesByConfigIdMaxCreatedAtDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CREATED_AT_DESC',
  DocumentSpacesByConfigIdMaxCreatorIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CREATOR_ID_ASC',
  DocumentSpacesByConfigIdMaxCreatorIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_CREATOR_ID_DESC',
  DocumentSpacesByConfigIdMaxEncryptedPasswordAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_ENCRYPTED_PASSWORD_ASC',
  DocumentSpacesByConfigIdMaxEncryptedPasswordDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_ENCRYPTED_PASSWORD_DESC',
  DocumentSpacesByConfigIdMaxIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_ID_ASC',
  DocumentSpacesByConfigIdMaxIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_ID_DESC',
  DocumentSpacesByConfigIdMaxNameAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_NAME_ASC',
  DocumentSpacesByConfigIdMaxNameDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_NAME_DESC',
  DocumentSpacesByConfigIdMaxPersonalMessageAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_PERSONAL_MESSAGE_ASC',
  DocumentSpacesByConfigIdMaxPersonalMessageDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_PERSONAL_MESSAGE_DESC',
  DocumentSpacesByConfigIdMaxShowContactDetailsAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_SHOW_CONTACT_DETAILS_ASC',
  DocumentSpacesByConfigIdMaxShowContactDetailsDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_SHOW_CONTACT_DETAILS_DESC',
  DocumentSpacesByConfigIdMaxSysPeriodAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpacesByConfigIdMaxSysPeriodDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpacesByConfigIdMaxTenantIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_TENANT_ID_ASC',
  DocumentSpacesByConfigIdMaxTenantIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_TENANT_ID_DESC',
  DocumentSpacesByConfigIdMaxTrackingDeactivatedAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_TRACKING_DEACTIVATED_ASC',
  DocumentSpacesByConfigIdMaxTrackingDeactivatedDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_TRACKING_DEACTIVATED_DESC',
  DocumentSpacesByConfigIdMaxUpdatedAtAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_UPDATED_AT_ASC',
  DocumentSpacesByConfigIdMaxUpdatedAtDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MAX_UPDATED_AT_DESC',
  DocumentSpacesByConfigIdMinAllowedEmailAddressesAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpacesByConfigIdMinAllowedEmailAddressesDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpacesByConfigIdMinCodeOnAccessCardAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CODE_ON_ACCESS_CARD_ASC',
  DocumentSpacesByConfigIdMinCodeOnAccessCardDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CODE_ON_ACCESS_CARD_DESC',
  DocumentSpacesByConfigIdMinCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpacesByConfigIdMinCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpacesByConfigIdMinCommentAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_COMMENT_ASC',
  DocumentSpacesByConfigIdMinCommentDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_COMMENT_DESC',
  DocumentSpacesByConfigIdMinConfigIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CONFIG_ID_ASC',
  DocumentSpacesByConfigIdMinConfigIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CONFIG_ID_DESC',
  DocumentSpacesByConfigIdMinCreatedAtAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CREATED_AT_ASC',
  DocumentSpacesByConfigIdMinCreatedAtDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CREATED_AT_DESC',
  DocumentSpacesByConfigIdMinCreatorIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CREATOR_ID_ASC',
  DocumentSpacesByConfigIdMinCreatorIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_CREATOR_ID_DESC',
  DocumentSpacesByConfigIdMinEncryptedPasswordAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_ENCRYPTED_PASSWORD_ASC',
  DocumentSpacesByConfigIdMinEncryptedPasswordDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_ENCRYPTED_PASSWORD_DESC',
  DocumentSpacesByConfigIdMinIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_ID_ASC',
  DocumentSpacesByConfigIdMinIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_ID_DESC',
  DocumentSpacesByConfigIdMinNameAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_NAME_ASC',
  DocumentSpacesByConfigIdMinNameDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_NAME_DESC',
  DocumentSpacesByConfigIdMinPersonalMessageAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_PERSONAL_MESSAGE_ASC',
  DocumentSpacesByConfigIdMinPersonalMessageDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_PERSONAL_MESSAGE_DESC',
  DocumentSpacesByConfigIdMinShowContactDetailsAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_SHOW_CONTACT_DETAILS_ASC',
  DocumentSpacesByConfigIdMinShowContactDetailsDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_SHOW_CONTACT_DETAILS_DESC',
  DocumentSpacesByConfigIdMinSysPeriodAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpacesByConfigIdMinSysPeriodDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpacesByConfigIdMinTenantIdAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_TENANT_ID_ASC',
  DocumentSpacesByConfigIdMinTenantIdDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_TENANT_ID_DESC',
  DocumentSpacesByConfigIdMinTrackingDeactivatedAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_TRACKING_DEACTIVATED_ASC',
  DocumentSpacesByConfigIdMinTrackingDeactivatedDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_TRACKING_DEACTIVATED_DESC',
  DocumentSpacesByConfigIdMinUpdatedAtAsc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_UPDATED_AT_ASC',
  DocumentSpacesByConfigIdMinUpdatedAtDesc = 'DOCUMENT_SPACES_BY_CONFIG_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdCountAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__COUNT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdCountDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__COUNT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxConfigIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_CONFIG_ID_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxConfigIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_CONFIG_ID_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_ID_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_ID_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxLanguageCodeAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_LANGUAGE_CODE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxLanguageCodeDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_LANGUAGE_CODE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinConfigIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_CONFIG_ID_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinConfigIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_CONFIG_ID_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_ID_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_ID_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinLanguageCodeAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_LANGUAGE_CODE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinLanguageCodeDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_LANGUAGE_CODE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigTranslationsByConfigIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigTranslationsByConfigIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_CONFIG_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceLinksByConfigIdCountAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__COUNT_ASC',
  DocumentSpaceLinksByConfigIdCountDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__COUNT_DESC',
  DocumentSpaceLinksByConfigIdMaxConfigIdAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_CONFIG_ID_ASC',
  DocumentSpaceLinksByConfigIdMaxConfigIdDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_CONFIG_ID_DESC',
  DocumentSpaceLinksByConfigIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceLinksByConfigIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceLinksByConfigIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceLinksByConfigIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinksByConfigIdMaxIdAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_ID_ASC',
  DocumentSpaceLinksByConfigIdMaxIdDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_ID_DESC',
  DocumentSpaceLinksByConfigIdMaxIsMandatoryAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_IS_MANDATORY_ASC',
  DocumentSpaceLinksByConfigIdMaxIsMandatoryDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_IS_MANDATORY_DESC',
  DocumentSpaceLinksByConfigIdMaxPositionAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_POSITION_ASC',
  DocumentSpaceLinksByConfigIdMaxPositionDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_POSITION_DESC',
  DocumentSpaceLinksByConfigIdMaxSectionTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_SECTION_TITLE_ASC',
  DocumentSpaceLinksByConfigIdMaxSectionTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_SECTION_TITLE_DESC',
  DocumentSpaceLinksByConfigIdMaxTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_TITLE_ASC',
  DocumentSpaceLinksByConfigIdMaxTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_TITLE_DESC',
  DocumentSpaceLinksByConfigIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceLinksByConfigIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceLinksByConfigIdMaxUrlAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_URL_ASC',
  DocumentSpaceLinksByConfigIdMaxUrlDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MAX_URL_DESC',
  DocumentSpaceLinksByConfigIdMinConfigIdAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_CONFIG_ID_ASC',
  DocumentSpaceLinksByConfigIdMinConfigIdDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_CONFIG_ID_DESC',
  DocumentSpaceLinksByConfigIdMinCreatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceLinksByConfigIdMinCreatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceLinksByConfigIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceLinksByConfigIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinksByConfigIdMinIdAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_ID_ASC',
  DocumentSpaceLinksByConfigIdMinIdDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_ID_DESC',
  DocumentSpaceLinksByConfigIdMinIsMandatoryAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_IS_MANDATORY_ASC',
  DocumentSpaceLinksByConfigIdMinIsMandatoryDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_IS_MANDATORY_DESC',
  DocumentSpaceLinksByConfigIdMinPositionAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_POSITION_ASC',
  DocumentSpaceLinksByConfigIdMinPositionDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_POSITION_DESC',
  DocumentSpaceLinksByConfigIdMinSectionTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_SECTION_TITLE_ASC',
  DocumentSpaceLinksByConfigIdMinSectionTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_SECTION_TITLE_DESC',
  DocumentSpaceLinksByConfigIdMinTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_TITLE_ASC',
  DocumentSpaceLinksByConfigIdMinTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_TITLE_DESC',
  DocumentSpaceLinksByConfigIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceLinksByConfigIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceLinksByConfigIdMinUrlAsc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_URL_ASC',
  DocumentSpaceLinksByConfigIdMinUrlDesc = 'DOCUMENT_SPACE_LINKS_BY_CONFIG_ID__MIN_URL_DESC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdCreatedAtAsc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__CREATED_AT_ASC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdCreatedAtDesc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__CREATED_AT_DESC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdIdAsc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__ID_ASC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdIdDesc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__ID_DESC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdNameAsc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__NAME_ASC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdNameDesc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__NAME_DESC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdTenantIdAsc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__TENANT_ID_ASC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdTenantIdDesc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__TENANT_ID_DESC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdUpdatedAtAsc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__UPDATED_AT_ASC',
  DocumentSpaceLinkGroupByTenantIdAndGroupIdUpdatedAtDesc = 'DOCUMENT_SPACE_LINK_GROUP_BY_TENANT_ID_AND_GROUP_ID__UPDATED_AT_DESC',
  DocumentSpaceLinkTranslationsByConfigIdCountAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__COUNT_ASC',
  DocumentSpaceLinkTranslationsByConfigIdCountDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__COUNT_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxConfigIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_CONFIG_ID_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxConfigIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_CONFIG_ID_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_ID_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_ID_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxLanguageCodeAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_LANGUAGE_CODE_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxLanguageCodeDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_LANGUAGE_CODE_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxLinkIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_LINK_ID_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxLinkIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_LINK_ID_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxPositionAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_POSITION_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxPositionDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_POSITION_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxSectionTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_SECTION_TITLE_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxSectionTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_SECTION_TITLE_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_TITLE_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_TITLE_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMaxUrlAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_URL_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMaxUrlDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MAX_URL_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinConfigIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_CONFIG_ID_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinConfigIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_CONFIG_ID_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_ID_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_ID_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinLanguageCodeAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_LANGUAGE_CODE_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinLanguageCodeDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_LANGUAGE_CODE_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinLinkIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_LINK_ID_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinLinkIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_LINK_ID_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinPositionAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_POSITION_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinPositionDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_POSITION_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinSectionTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_SECTION_TITLE_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinSectionTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_SECTION_TITLE_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_TITLE_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_TITLE_DESC',
  DocumentSpaceLinkTranslationsByConfigIdMinUrlAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_URL_ASC',
  DocumentSpaceLinkTranslationsByConfigIdMinUrlDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_CONFIG_ID__MIN_URL_DESC',
  FooterLinksAsc = 'FOOTER_LINKS_ASC',
  FooterLinksDesc = 'FOOTER_LINKS_DESC',
  FooterTextAsc = 'FOOTER_TEXT_ASC',
  FooterTextDesc = 'FOOTER_TEXT_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  HeroImageUrlAsc = 'HERO_IMAGE_URL_ASC',
  HeroImageUrlDesc = 'HERO_IMAGE_URL_DESC',
  HeroLinkTextAsc = 'HERO_LINK_TEXT_ASC',
  HeroLinkTextDesc = 'HERO_LINK_TEXT_DESC',
  HeroLinkUrlAsc = 'HERO_LINK_URL_ASC',
  HeroLinkUrlDesc = 'HERO_LINK_URL_DESC',
  HeroScalingAsc = 'HERO_SCALING_ASC',
  HeroScalingDesc = 'HERO_SCALING_DESC',
  HeroSubtitleAsc = 'HERO_SUBTITLE_ASC',
  HeroSubtitleDesc = 'HERO_SUBTITLE_DESC',
  HeroTitleAsc = 'HERO_TITLE_ASC',
  HeroTitleDesc = 'HERO_TITLE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LanguageCodeByDefaultLanguageCodeAsc = 'LANGUAGE_CODE_BY_DEFAULT_LANGUAGE__CODE_ASC',
  LanguageCodeByDefaultLanguageCodeDesc = 'LANGUAGE_CODE_BY_DEFAULT_LANGUAGE__CODE_DESC',
  LegalNoteAsc = 'LEGAL_NOTE_ASC',
  LegalNoteDesc = 'LEGAL_NOTE_DESC',
  LegalNoteUrlAsc = 'LEGAL_NOTE_URL_ASC',
  LegalNoteUrlDesc = 'LEGAL_NOTE_URL_DESC',
  LinkedTabOrderAsc = 'LINKED_TAB_ORDER_ASC',
  LinkedTabOrderDesc = 'LINKED_TAB_ORDER_DESC',
  LogoSmallUrlAsc = 'LOGO_SMALL_URL_ASC',
  LogoSmallUrlDesc = 'LOGO_SMALL_URL_DESC',
  LogoUrlAsc = 'LOGO_URL_ASC',
  LogoUrlDesc = 'LOGO_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NewTabAsc = 'NEW_TAB_ASC',
  NewTabDesc = 'NEW_TAB_DESC',
  OptInContentAsc = 'OPT_IN_CONTENT_ASC',
  OptInContentDesc = 'OPT_IN_CONTENT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  RequiresEmailAuthenticationAsc = 'REQUIRES_EMAIL_AUTHENTICATION_ASC',
  RequiresEmailAuthenticationDesc = 'REQUIRES_EMAIL_AUTHENTICATION_DESC',
  StylesheetAsc = 'STYLESHEET_ASC',
  StylesheetDesc = 'STYLESHEET_DESC',
  TeamByTeamIdAnalyticsAliasAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamByTeamIdAnalyticsAliasDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamByTeamIdAnalyticsEnabledAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamByTeamIdAnalyticsEnabledDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamByTeamIdCreatedAtAsc = 'TEAM_BY_TEAM_ID__CREATED_AT_ASC',
  TeamByTeamIdCreatedAtDesc = 'TEAM_BY_TEAM_ID__CREATED_AT_DESC',
  TeamByTeamIdFlagsAsc = 'TEAM_BY_TEAM_ID__FLAGS_ASC',
  TeamByTeamIdFlagsDesc = 'TEAM_BY_TEAM_ID__FLAGS_DESC',
  TeamByTeamIdIdAsc = 'TEAM_BY_TEAM_ID__ID_ASC',
  TeamByTeamIdIdDesc = 'TEAM_BY_TEAM_ID__ID_DESC',
  TeamByTeamIdIsOpenAsc = 'TEAM_BY_TEAM_ID__IS_OPEN_ASC',
  TeamByTeamIdIsOpenDesc = 'TEAM_BY_TEAM_ID__IS_OPEN_DESC',
  TeamByTeamIdIsVisibleAsc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_ASC',
  TeamByTeamIdIsVisibleDesc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_DESC',
  TeamByTeamIdMemberCountAsc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_ASC',
  TeamByTeamIdMemberCountDesc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_DESC',
  TeamByTeamIdNameAsc = 'TEAM_BY_TEAM_ID__NAME_ASC',
  TeamByTeamIdNameDesc = 'TEAM_BY_TEAM_ID__NAME_DESC',
  TeamByTeamIdNameLowercaseAsc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  TeamByTeamIdNameLowercaseDesc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  TeamByTeamIdSysPeriodAsc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_ASC',
  TeamByTeamIdSysPeriodDesc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_DESC',
  TeamByTeamIdTenantIdAsc = 'TEAM_BY_TEAM_ID__TENANT_ID_ASC',
  TeamByTeamIdTenantIdDesc = 'TEAM_BY_TEAM_ID__TENANT_ID_DESC',
  TeamByTeamIdTotalMemberCountAsc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamByTeamIdTotalMemberCountDesc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamByTeamIdUpdatedAtAsc = 'TEAM_BY_TEAM_ID__UPDATED_AT_ASC',
  TeamByTeamIdUpdatedAtDesc = 'TEAM_BY_TEAM_ID__UPDATED_AT_DESC',
  TeamByTeamIdUserConfigDefaultsAsc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamByTeamIdUserConfigDefaultsDesc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  TemplateAsc = 'TEMPLATE_ASC',
  TemplateDesc = 'TEMPLATE_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByIdAsc = 'UPDATED_BY_ID_ASC',
  UpdatedByIdDesc = 'UPDATED_BY_ID_DESC',
  UserByUpdatedByIdAppConsentGivenAtAsc = 'USER_BY_UPDATED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUpdatedByIdAppConsentGivenAtDesc = 'USER_BY_UPDATED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUpdatedByIdConfigAsc = 'USER_BY_UPDATED_BY_ID__CONFIG_ASC',
  UserByUpdatedByIdConfigDesc = 'USER_BY_UPDATED_BY_ID__CONFIG_DESC',
  UserByUpdatedByIdCreatedAtAsc = 'USER_BY_UPDATED_BY_ID__CREATED_AT_ASC',
  UserByUpdatedByIdCreatedAtDesc = 'USER_BY_UPDATED_BY_ID__CREATED_AT_DESC',
  UserByUpdatedByIdCrmContactVisibilityFilterAsc = 'USER_BY_UPDATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUpdatedByIdCrmContactVisibilityFilterDesc = 'USER_BY_UPDATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUpdatedByIdDefaultWorkspaceIdAsc = 'USER_BY_UPDATED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUpdatedByIdDefaultWorkspaceIdDesc = 'USER_BY_UPDATED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUpdatedByIdDisabledAsc = 'USER_BY_UPDATED_BY_ID__DISABLED_ASC',
  UserByUpdatedByIdDisabledDesc = 'USER_BY_UPDATED_BY_ID__DISABLED_DESC',
  UserByUpdatedByIdDisplayNameAsc = 'USER_BY_UPDATED_BY_ID__DISPLAY_NAME_ASC',
  UserByUpdatedByIdDisplayNameDesc = 'USER_BY_UPDATED_BY_ID__DISPLAY_NAME_DESC',
  UserByUpdatedByIdEmailAsc = 'USER_BY_UPDATED_BY_ID__EMAIL_ASC',
  UserByUpdatedByIdEmailDesc = 'USER_BY_UPDATED_BY_ID__EMAIL_DESC',
  UserByUpdatedByIdExternalGroupsAsc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByUpdatedByIdExternalGroupsDesc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByUpdatedByIdExternalGroupsSyncedAtAsc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUpdatedByIdExternalGroupsSyncedAtDesc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUpdatedByIdFirebaseAuthIdAsc = 'USER_BY_UPDATED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByUpdatedByIdFirebaseAuthIdDesc = 'USER_BY_UPDATED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByUpdatedByIdFlagsAsc = 'USER_BY_UPDATED_BY_ID__FLAGS_ASC',
  UserByUpdatedByIdFlagsDesc = 'USER_BY_UPDATED_BY_ID__FLAGS_DESC',
  UserByUpdatedByIdIdAsc = 'USER_BY_UPDATED_BY_ID__ID_ASC',
  UserByUpdatedByIdIdDesc = 'USER_BY_UPDATED_BY_ID__ID_DESC',
  UserByUpdatedByIdIsTenantAdminAsc = 'USER_BY_UPDATED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByUpdatedByIdIsTenantAdminDesc = 'USER_BY_UPDATED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByUpdatedByIdRegisteredAtAsc = 'USER_BY_UPDATED_BY_ID__REGISTERED_AT_ASC',
  UserByUpdatedByIdRegisteredAtDesc = 'USER_BY_UPDATED_BY_ID__REGISTERED_AT_DESC',
  UserByUpdatedByIdSysPeriodAsc = 'USER_BY_UPDATED_BY_ID__SYS_PERIOD_ASC',
  UserByUpdatedByIdSysPeriodDesc = 'USER_BY_UPDATED_BY_ID__SYS_PERIOD_DESC',
  UserByUpdatedByIdTenantIdAsc = 'USER_BY_UPDATED_BY_ID__TENANT_ID_ASC',
  UserByUpdatedByIdTenantIdDesc = 'USER_BY_UPDATED_BY_ID__TENANT_ID_DESC',
  UserByUpdatedByIdUpdatedAtAsc = 'USER_BY_UPDATED_BY_ID__UPDATED_AT_ASC',
  UserByUpdatedByIdUpdatedAtDesc = 'USER_BY_UPDATED_BY_ID__UPDATED_AT_DESC'
}

export type DocumentSpaceCrmMapping = Node & {
  __typename?: 'DocumentSpaceCrmMapping';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `CrmContact` that is related to this `DocumentSpaceCrmMapping`. */
  crmContact?: Maybe<CrmContact>;
  crmContactId: Scalars['BigInt']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceCrmMapping`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads a single `CrmContactMatch` that is related to this `DocumentSpaceCrmMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  sysPeriod: DatetimeRange;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DocumentSpaceCrmMapping` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceCrmMappingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crmContactId` field. */
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceCrmMapping` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceCrmMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceCrmMappingFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContact` relation. */
  crmContact?: InputMaybe<CrmContactFilter>;
  /** Filter by the object’s `crmContactId` field. */
  crmContactId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `matchId` relation. */
  matchId?: InputMaybe<CrmContactMatchFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceCrmMappingFilter>>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceCrmMapping` */
export type DocumentSpaceCrmMappingInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmContactId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceCrmMapping`. Fields that are set will be updated. */
export type DocumentSpaceCrmMappingPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentSpaceCrmMapping` values. */
export type DocumentSpaceCrmMappingsConnection = {
  __typename?: 'DocumentSpaceCrmMappingsConnection';
  /** A list of edges which contains the `DocumentSpaceCrmMapping` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceCrmMappingsEdge>;
  /** A list of `DocumentSpaceCrmMapping` objects. */
  nodes: Array<Maybe<DocumentSpaceCrmMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceCrmMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceCrmMapping` edge in the connection. */
export type DocumentSpaceCrmMappingsEdge = {
  __typename?: 'DocumentSpaceCrmMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceCrmMapping` at the end of the edge. */
  node?: Maybe<DocumentSpaceCrmMapping>;
};

/** Methods to use when ordering `DocumentSpaceCrmMapping`. */
export enum DocumentSpaceCrmMappingsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactByCrmContactIdActiveAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ACTIVE_ASC',
  CrmContactByCrmContactIdActiveDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ACTIVE_DESC',
  CrmContactByCrmContactIdAlxnConsentStatusAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactByCrmContactIdAlxnConsentStatusDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactByCrmContactIdAlxnPrimaryParentAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactByCrmContactIdAlxnPrimaryParentDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactByCrmContactIdAlxnProductsAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_ASC',
  CrmContactByCrmContactIdAlxnProductsDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_DESC',
  CrmContactByCrmContactIdAlxnRoleAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_ROLE_ASC',
  CrmContactByCrmContactIdAlxnRoleDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_ROLE_DESC',
  CrmContactByCrmContactIdAlxnSpecialityAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_ASC',
  CrmContactByCrmContactIdAlxnSpecialityDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_DESC',
  CrmContactByCrmContactIdAlxnTerritoriesAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_ASC',
  CrmContactByCrmContactIdAlxnTerritoriesDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_DESC',
  CrmContactByCrmContactIdCityAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CITY_ASC',
  CrmContactByCrmContactIdCityDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CITY_DESC',
  CrmContactByCrmContactIdCountryAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__COUNTRY_ASC',
  CrmContactByCrmContactIdCountryDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__COUNTRY_DESC',
  CrmContactByCrmContactIdCreatedAtAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CREATED_AT_ASC',
  CrmContactByCrmContactIdCreatedAtDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CREATED_AT_DESC',
  CrmContactByCrmContactIdCrmIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CRM_ID_ASC',
  CrmContactByCrmContactIdCrmIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CRM_ID_DESC',
  CrmContactByCrmContactIdEmailAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__EMAIL_ASC',
  CrmContactByCrmContactIdEmailDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__EMAIL_DESC',
  CrmContactByCrmContactIdFirstNameAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FIRST_NAME_ASC',
  CrmContactByCrmContactIdFirstNameDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FIRST_NAME_DESC',
  CrmContactByCrmContactIdFullNameAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FULL_NAME_ASC',
  CrmContactByCrmContactIdFullNameDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FULL_NAME_DESC',
  CrmContactByCrmContactIdIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ID_ASC',
  CrmContactByCrmContactIdIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ID_DESC',
  CrmContactByCrmContactIdLanguagePrefAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LANGUAGE_PREF_ASC',
  CrmContactByCrmContactIdLanguagePrefDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LANGUAGE_PREF_DESC',
  CrmContactByCrmContactIdLastNameAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LAST_NAME_ASC',
  CrmContactByCrmContactIdLastNameDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LAST_NAME_DESC',
  CrmContactByCrmContactIdLocalCrmIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_ASC',
  CrmContactByCrmContactIdLocalCrmIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_DESC',
  CrmContactByCrmContactIdMobileAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__MOBILE_ASC',
  CrmContactByCrmContactIdMobileDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__MOBILE_DESC',
  CrmContactByCrmContactIdOrganizationAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ORGANIZATION_ASC',
  CrmContactByCrmContactIdOrganizationDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ORGANIZATION_DESC',
  CrmContactByCrmContactIdRegionAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__REGION_ASC',
  CrmContactByCrmContactIdRegionDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__REGION_DESC',
  CrmContactByCrmContactIdTenantIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TENANT_ID_ASC',
  CrmContactByCrmContactIdTenantIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TENANT_ID_DESC',
  CrmContactByCrmContactIdTerritoryAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TERRITORY_ASC',
  CrmContactByCrmContactIdTerritoryDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TERRITORY_DESC',
  CrmContactByCrmContactIdUpdatedAtAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__UPDATED_AT_ASC',
  CrmContactByCrmContactIdUpdatedAtDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__UPDATED_AT_DESC',
  CrmContactByCrmContactIdZipCodeAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ZIP_CODE_ASC',
  CrmContactByCrmContactIdZipCodeDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ZIP_CODE_DESC',
  CrmContactIdAsc = 'CRM_CONTACT_ID_ASC',
  CrmContactIdDesc = 'CRM_CONTACT_ID_DESC',
  CrmContactMatchByCrmContactIdActiveAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ACTIVE_ASC',
  CrmContactMatchByCrmContactIdActiveDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ACTIVE_DESC',
  CrmContactMatchByCrmContactIdAlxnConsentStatusAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchByCrmContactIdAlxnConsentStatusDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchByCrmContactIdAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchByCrmContactIdAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchByCrmContactIdAlxnProductsAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_ASC',
  CrmContactMatchByCrmContactIdAlxnProductsDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_DESC',
  CrmContactMatchByCrmContactIdAlxnRoleAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_ROLE_ASC',
  CrmContactMatchByCrmContactIdAlxnRoleDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_ROLE_DESC',
  CrmContactMatchByCrmContactIdAlxnSpecialityAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_ASC',
  CrmContactMatchByCrmContactIdAlxnSpecialityDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_DESC',
  CrmContactMatchByCrmContactIdAlxnTerritoriesAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_ASC',
  CrmContactMatchByCrmContactIdAlxnTerritoriesDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_DESC',
  CrmContactMatchByCrmContactIdCityAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CITY_ASC',
  CrmContactMatchByCrmContactIdCityDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CITY_DESC',
  CrmContactMatchByCrmContactIdCountryAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__COUNTRY_ASC',
  CrmContactMatchByCrmContactIdCountryDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__COUNTRY_DESC',
  CrmContactMatchByCrmContactIdCreatedAtAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CREATED_AT_ASC',
  CrmContactMatchByCrmContactIdCreatedAtDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CREATED_AT_DESC',
  CrmContactMatchByCrmContactIdCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CRM_ID_ASC',
  CrmContactMatchByCrmContactIdCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CRM_ID_DESC',
  CrmContactMatchByCrmContactIdEmailAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__EMAIL_ASC',
  CrmContactMatchByCrmContactIdEmailDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__EMAIL_DESC',
  CrmContactMatchByCrmContactIdFirstNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FIRST_NAME_ASC',
  CrmContactMatchByCrmContactIdFirstNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FIRST_NAME_DESC',
  CrmContactMatchByCrmContactIdFulltextRankAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_RANK_ASC',
  CrmContactMatchByCrmContactIdFulltextRankDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_RANK_DESC',
  CrmContactMatchByCrmContactIdFulltextSearchColumnAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchByCrmContactIdFulltextSearchColumnDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchByCrmContactIdFullNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULL_NAME_ASC',
  CrmContactMatchByCrmContactIdFullNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULL_NAME_DESC',
  CrmContactMatchByCrmContactIdIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ID_ASC',
  CrmContactMatchByCrmContactIdIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ID_DESC',
  CrmContactMatchByCrmContactIdLanguagePrefAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LANGUAGE_PREF_ASC',
  CrmContactMatchByCrmContactIdLanguagePrefDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LANGUAGE_PREF_DESC',
  CrmContactMatchByCrmContactIdLastNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LAST_NAME_ASC',
  CrmContactMatchByCrmContactIdLastNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LAST_NAME_DESC',
  CrmContactMatchByCrmContactIdLocalCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_ASC',
  CrmContactMatchByCrmContactIdLocalCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_DESC',
  CrmContactMatchByCrmContactIdMobileAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__MOBILE_ASC',
  CrmContactMatchByCrmContactIdMobileDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__MOBILE_DESC',
  CrmContactMatchByCrmContactIdOrganizationAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ORGANIZATION_ASC',
  CrmContactMatchByCrmContactIdOrganizationDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ORGANIZATION_DESC',
  CrmContactMatchByCrmContactIdRegionAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__REGION_ASC',
  CrmContactMatchByCrmContactIdRegionDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__REGION_DESC',
  CrmContactMatchByCrmContactIdSimilarityAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__SIMILARITY_ASC',
  CrmContactMatchByCrmContactIdSimilarityDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__SIMILARITY_DESC',
  CrmContactMatchByCrmContactIdTenantIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TENANT_ID_ASC',
  CrmContactMatchByCrmContactIdTenantIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TENANT_ID_DESC',
  CrmContactMatchByCrmContactIdTerritoryAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TERRITORY_ASC',
  CrmContactMatchByCrmContactIdTerritoryDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TERRITORY_DESC',
  CrmContactMatchByCrmContactIdUpdatedAtAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__UPDATED_AT_ASC',
  CrmContactMatchByCrmContactIdUpdatedAtDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__UPDATED_AT_DESC',
  CrmContactMatchByCrmContactIdZipCodeAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ZIP_CODE_ASC',
  CrmContactMatchByCrmContactIdZipCodeDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ZIP_CODE_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type DocumentSpaceDetailStatistic = {
  __typename?: 'DocumentSpaceDetailStatistic';
  avgDuration?: Maybe<Interval>;
  downloads?: Maybe<Scalars['BigInt']['output']>;
  linkClicks?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numSessions?: Maybe<Scalars['BigInt']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceDetailStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceDetailStatisticCondition = {
  /** Checks for equality with the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `downloads` field. */
  downloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `linkClicks` field. */
  linkClicks?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numSessions` field. */
  numSessions?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `DocumentSpaceDetailStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceDetailStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceDetailStatisticFilter>>;
  /** Filter by the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `downloads` field. */
  downloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `linkClicks` field. */
  linkClicks?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceDetailStatisticFilter>;
  /** Filter by the object’s `numSessions` field. */
  numSessions?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceDetailStatisticFilter>>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `DocumentSpaceDetailStatistic` values. */
export type DocumentSpaceDetailStatisticsConnection = {
  __typename?: 'DocumentSpaceDetailStatisticsConnection';
  /** A list of edges which contains the `DocumentSpaceDetailStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceDetailStatisticsEdge>;
  /** A list of `DocumentSpaceDetailStatistic` objects. */
  nodes: Array<Maybe<DocumentSpaceDetailStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceDetailStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceDetailStatistic` edge in the connection. */
export type DocumentSpaceDetailStatisticsEdge = {
  __typename?: 'DocumentSpaceDetailStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceDetailStatistic` at the end of the edge. */
  node?: Maybe<DocumentSpaceDetailStatistic>;
};

/** Methods to use when ordering `DocumentSpaceDetailStatistic`. */
export enum DocumentSpaceDetailStatisticsOrderBy {
  AvgDurationAsc = 'AVG_DURATION_ASC',
  AvgDurationDesc = 'AVG_DURATION_DESC',
  DownloadsAsc = 'DOWNLOADS_ASC',
  DownloadsDesc = 'DOWNLOADS_DESC',
  LinkClicksAsc = 'LINK_CLICKS_ASC',
  LinkClicksDesc = 'LINK_CLICKS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NumSessionsAsc = 'NUM_SESSIONS_ASC',
  NumSessionsDesc = 'NUM_SESSIONS_DESC',
  SpaceIdAsc = 'SPACE_ID_ASC',
  SpaceIdDesc = 'SPACE_ID_DESC'
}

export type DocumentSpaceDocStatistic = {
  __typename?: 'DocumentSpaceDocStatistic';
  avgDuration?: Maybe<Interval>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  docId?: Maybe<Scalars['Int']['output']>;
  downloads?: Maybe<Scalars['BigInt']['output']>;
  maxDuration?: Maybe<Interval>;
  numViews?: Maybe<Scalars['BigInt']['output']>;
  score?: Maybe<Scalars['BigInt']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  spaceItemId?: Maybe<Scalars['Int']['output']>;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceDocStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceDocStatisticCondition = {
  /** Checks for equality with the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `docId` field. */
  docId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `downloads` field. */
  downloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxDuration` field. */
  maxDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `numViews` field. */
  numViews?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `spaceItemId` field. */
  spaceItemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DocumentSpaceDocStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceDocStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceDocStatisticFilter>>;
  /** Filter by the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `docId` field. */
  docId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `downloads` field. */
  downloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxDuration` field. */
  maxDuration?: InputMaybe<IntervalFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceDocStatisticFilter>;
  /** Filter by the object’s `numViews` field. */
  numViews?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceDocStatisticFilter>>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `spaceItemId` field. */
  spaceItemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
};

/** A connection to a list of `DocumentSpaceDocStatistic` values. */
export type DocumentSpaceDocStatisticsConnection = {
  __typename?: 'DocumentSpaceDocStatisticsConnection';
  /** A list of edges which contains the `DocumentSpaceDocStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceDocStatisticsEdge>;
  /** A list of `DocumentSpaceDocStatistic` objects. */
  nodes: Array<Maybe<DocumentSpaceDocStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceDocStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceDocStatistic` edge in the connection. */
export type DocumentSpaceDocStatisticsEdge = {
  __typename?: 'DocumentSpaceDocStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceDocStatistic` at the end of the edge. */
  node?: Maybe<DocumentSpaceDocStatistic>;
};

/** Methods to use when ordering `DocumentSpaceDocStatistic`. */
export enum DocumentSpaceDocStatisticsOrderBy {
  AvgDurationAsc = 'AVG_DURATION_ASC',
  AvgDurationDesc = 'AVG_DURATION_DESC',
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocIdAsc = 'DOC_ID_ASC',
  DocIdDesc = 'DOC_ID_DESC',
  DownloadsAsc = 'DOWNLOADS_ASC',
  DownloadsDesc = 'DOWNLOADS_DESC',
  MaxDurationAsc = 'MAX_DURATION_ASC',
  MaxDurationDesc = 'MAX_DURATION_DESC',
  Natural = 'NATURAL',
  NumViewsAsc = 'NUM_VIEWS_ASC',
  NumViewsDesc = 'NUM_VIEWS_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  SpaceIdAsc = 'SPACE_ID_ASC',
  SpaceIdDesc = 'SPACE_ID_DESC',
  SpaceItemIdAsc = 'SPACE_ITEM_ID_ASC',
  SpaceItemIdDesc = 'SPACE_ITEM_ID_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC'
}

/** A filter to be used against `DocumentSpace` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceFilter = {
  /** Filter by the object’s `allowedEmailAddresses` field. */
  allowedEmailAddresses?: InputMaybe<StringListFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceFilter>>;
  /** Filter by the object’s `codeOnAccessCard` field. */
  codeOnAccessCard?: InputMaybe<StringFilter>;
  /** Filter by the object’s `codeOnAccessCardLastUsedAt` field. */
  codeOnAccessCardLastUsedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `config` relation. */
  config?: InputMaybe<DocumentSpaceConfigFilter>;
  /** A related `config` exists. */
  configExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `contactDetailsId` field. */
  contactDetailsId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` relation. */
  creator?: InputMaybe<UserFilter>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpaceAccesses` relation. */
  documentSpaceAccesses?: InputMaybe<DocumentSpaceToManyDocumentSpaceAccessFilter>;
  /** Some related `documentSpaceAccesses` exist. */
  documentSpaceAccessesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceCrmMapping` relation. */
  documentSpaceCrmMapping?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  /** A related `documentSpaceCrmMapping` exists. */
  documentSpaceCrmMappingExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceItems` relation. */
  documentSpaceItems?: InputMaybe<DocumentSpaceToManyDocumentSpaceItemFilter>;
  /** Some related `documentSpaceItems` exist. */
  documentSpaceItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinkMappingsBySpaceId` relation. */
  documentSpaceLinkMappingsBySpaceId?: InputMaybe<DocumentSpaceToManyDocumentSpaceLinkMappingFilter>;
  /** Some related `documentSpaceLinkMappingsBySpaceId` exist. */
  documentSpaceLinkMappingsBySpaceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinks` relation. */
  documentSpaceLinks?: InputMaybe<DocumentSpaceToManyDocumentSpaceLinkFilter>;
  /** Some related `documentSpaceLinks` exist. */
  documentSpaceLinksExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceSections` relation. */
  documentSpaceSections?: InputMaybe<DocumentSpaceToManyDocumentSpaceSectionFilter>;
  /** Some related `documentSpaceSections` exist. */
  documentSpaceSectionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceSessions` relation. */
  documentSpaceSessions?: InputMaybe<DocumentSpaceToManyDocumentSpaceSessionFilter>;
  /** Some related `documentSpaceSessions` exist. */
  documentSpaceSessionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceVouchers` relation. */
  documentSpaceVouchers?: InputMaybe<DocumentSpaceToManyDocumentSpaceVoucherFilter>;
  /** Some related `documentSpaceVouchers` exist. */
  documentSpaceVouchersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ftsDocumentSpaceHits` relation. */
  ftsDocumentSpaceHits?: InputMaybe<DocumentSpaceToManyFtsDocumentSpaceHitFilter>;
  /** Some related `ftsDocumentSpaceHits` exist. */
  ftsDocumentSpaceHitsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maDocumentSpaceDocumentStatistics` relation. */
  maDocumentSpaceDocumentStatistics?: InputMaybe<DocumentSpaceToManyMaDocumentSpaceDocumentStatisticFilter>;
  /** Some related `maDocumentSpaceDocumentStatistics` exist. */
  maDocumentSpaceDocumentStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maDocumentSpaceLinkStatistics` relation. */
  maDocumentSpaceLinkStatistics?: InputMaybe<DocumentSpaceToManyMaDocumentSpaceLinkStatisticFilter>;
  /** Some related `maDocumentSpaceLinkStatistics` exist. */
  maDocumentSpaceLinkStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maDocumentSpacePageStatistics` relation. */
  maDocumentSpacePageStatistics?: InputMaybe<DocumentSpaceToManyMaDocumentSpacePageStatisticFilter>;
  /** Some related `maDocumentSpacePageStatistics` exist. */
  maDocumentSpacePageStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maDocumentSpaceStatistic` relation. */
  maDocumentSpaceStatistic?: InputMaybe<MaDocumentSpaceStatisticFilter>;
  /** A related `maDocumentSpaceStatistic` exists. */
  maDocumentSpaceStatisticExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maDocumentSpaceVideoStatistics` relation. */
  maDocumentSpaceVideoStatistics?: InputMaybe<DocumentSpaceToManyMaDocumentSpaceVideoStatisticFilter>;
  /** Some related `maDocumentSpaceVideoStatistics` exist. */
  maDocumentSpaceVideoStatisticsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceFilter>>;
  /** Filter by the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `showContactDetails` field. */
  showContactDetails?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `trackingDeactivated` field. */
  trackingDeactivated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `visitStatistics` relation. */
  visitStatistics?: InputMaybe<DocumentSpaceVisitStatisticFilter>;
  /** A related `visitStatistics` exists. */
  visitStatisticsExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `DocumentSpace` */
export type DocumentSpaceInput = {
  allowedEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  codeOnAccessCard?: InputMaybe<Scalars['String']['input']>;
  codeOnAccessCardLastUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DocumentSpaceItem = Node & {
  __typename?: 'DocumentSpaceItem';
  addedAt: Scalars['Datetime']['output'];
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  flowId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  position?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
  sectionId: Scalars['BigInt']['output'];
  sysPeriod: DatetimeRange;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DocumentSpaceItem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceItemCondition = {
  /** Checks for equality with the object’s `addedAt` field. */
  addedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `flowId` field. */
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sectionId` field. */
  sectionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceItem` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceItemFilter = {
  /** Filter by the object’s `addedAt` field. */
  addedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceItemFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `flow` relation. */
  flow?: InputMaybe<FlowFilter>;
  /** A related `flow` exists. */
  flowExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flowId` field. */
  flowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceItemFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `section` relation. */
  section?: InputMaybe<DocumentSpaceSectionFilter>;
  /** Filter by the object’s `sectionId` field. */
  sectionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceItem` */
export type DocumentSpaceItemInput = {
  addedAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sectionId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceItem`. Fields that are set will be updated. */
export type DocumentSpaceItemPatch = {
  addedAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sectionId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentSpaceItem` values. */
export type DocumentSpaceItemsConnection = {
  __typename?: 'DocumentSpaceItemsConnection';
  /** A list of edges which contains the `DocumentSpaceItem` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceItemsEdge>;
  /** A list of `DocumentSpaceItem` objects. */
  nodes: Array<Maybe<DocumentSpaceItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceItem` edge in the connection. */
export type DocumentSpaceItemsEdge = {
  __typename?: 'DocumentSpaceItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceItem` at the end of the edge. */
  node?: Maybe<DocumentSpaceItem>;
};

/** Methods to use when ordering `DocumentSpaceItem`. */
export enum DocumentSpaceItemsOrderBy {
  AddedAtAsc = 'ADDED_AT_ASC',
  AddedAtDesc = 'ADDED_AT_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceSectionBySectionIdCreatedAtAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__CREATED_AT_ASC',
  DocumentSpaceSectionBySectionIdCreatedAtDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__CREATED_AT_DESC',
  DocumentSpaceSectionBySectionIdDocumentSpaceIdAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceSectionBySectionIdDocumentSpaceIdDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceSectionBySectionIdIdAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__ID_ASC',
  DocumentSpaceSectionBySectionIdIdDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__ID_DESC',
  DocumentSpaceSectionBySectionIdPositionAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__POSITION_ASC',
  DocumentSpaceSectionBySectionIdPositionDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__POSITION_DESC',
  DocumentSpaceSectionBySectionIdSysPeriodAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__SYS_PERIOD_ASC',
  DocumentSpaceSectionBySectionIdSysPeriodDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__SYS_PERIOD_DESC',
  DocumentSpaceSectionBySectionIdTitleAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__TITLE_ASC',
  DocumentSpaceSectionBySectionIdTitleDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__TITLE_DESC',
  DocumentSpaceSectionBySectionIdUpdatedAtAsc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__UPDATED_AT_ASC',
  DocumentSpaceSectionBySectionIdUpdatedAtDesc = 'DOCUMENT_SPACE_SECTION_BY_SECTION_ID__UPDATED_AT_DESC',
  FlowByFlowIdCreatedAtAsc = 'FLOW_BY_FLOW_ID__CREATED_AT_ASC',
  FlowByFlowIdCreatedAtDesc = 'FLOW_BY_FLOW_ID__CREATED_AT_DESC',
  FlowByFlowIdCreatorIdAsc = 'FLOW_BY_FLOW_ID__CREATOR_ID_ASC',
  FlowByFlowIdCreatorIdDesc = 'FLOW_BY_FLOW_ID__CREATOR_ID_DESC',
  FlowByFlowIdFirestoreIdAsc = 'FLOW_BY_FLOW_ID__FIRESTORE_ID_ASC',
  FlowByFlowIdFirestoreIdDesc = 'FLOW_BY_FLOW_ID__FIRESTORE_ID_DESC',
  FlowByFlowIdIdAsc = 'FLOW_BY_FLOW_ID__ID_ASC',
  FlowByFlowIdIdDesc = 'FLOW_BY_FLOW_ID__ID_DESC',
  FlowByFlowIdParentIdAsc = 'FLOW_BY_FLOW_ID__PARENT_ID_ASC',
  FlowByFlowIdParentIdDesc = 'FLOW_BY_FLOW_ID__PARENT_ID_DESC',
  FlowByFlowIdSysPeriodAsc = 'FLOW_BY_FLOW_ID__SYS_PERIOD_ASC',
  FlowByFlowIdSysPeriodDesc = 'FLOW_BY_FLOW_ID__SYS_PERIOD_DESC',
  FlowByFlowIdThumbnailUrlAsc = 'FLOW_BY_FLOW_ID__THUMBNAIL_URL_ASC',
  FlowByFlowIdThumbnailUrlDesc = 'FLOW_BY_FLOW_ID__THUMBNAIL_URL_DESC',
  FlowByFlowIdTitleAsc = 'FLOW_BY_FLOW_ID__TITLE_ASC',
  FlowByFlowIdTitleDesc = 'FLOW_BY_FLOW_ID__TITLE_DESC',
  FlowByFlowIdUpdatedAtAsc = 'FLOW_BY_FLOW_ID__UPDATED_AT_ASC',
  FlowByFlowIdUpdatedAtDesc = 'FLOW_BY_FLOW_ID__UPDATED_AT_DESC',
  FlowIdAsc = 'FLOW_ID_ASC',
  FlowIdDesc = 'FLOW_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SectionIdAsc = 'SECTION_ID_ASC',
  SectionIdDesc = 'SECTION_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type DocumentSpaceLink = Node & {
  __typename?: 'DocumentSpaceLink';
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLink`. */
  config?: Maybe<DocumentSpaceConfig>;
  configId?: Maybe<Scalars['BigInt']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLink`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkMapping`. */
  documentSpaceLinkMappingsByLinkId: DocumentSpaceLinkMappingsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkTranslation`. */
  documentSpaceLinkTranslationsByLinkId: DocumentSpaceLinkTranslationsConnection;
  id: Scalars['BigInt']['output'];
  isMandatory: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  position?: Maybe<Scalars['BigFloat']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  url: Scalars['String']['output'];
};


export type DocumentSpaceLinkDocumentSpaceLinkMappingsByLinkIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkMappingCondition>;
  filter?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkMappingsOrderBy>>;
};


export type DocumentSpaceLinkDocumentSpaceLinkTranslationsByLinkIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};

/**
 * A condition to be used against `DocumentSpaceLink` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceLinkCondition = {
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isMandatory` field. */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sectionTitle` field. */
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DocumentSpaceLink` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceLinkFilter>>;
  /** Filter by the object’s `config` relation. */
  config?: InputMaybe<DocumentSpaceConfigFilter>;
  /** A related `config` exists. */
  configExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpaceLinkMappingsByLinkId` relation. */
  documentSpaceLinkMappingsByLinkId?: InputMaybe<DocumentSpaceLinkToManyDocumentSpaceLinkMappingFilter>;
  /** Some related `documentSpaceLinkMappingsByLinkId` exist. */
  documentSpaceLinkMappingsByLinkIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinkTranslationsByLinkId` relation. */
  documentSpaceLinkTranslationsByLinkId?: InputMaybe<DocumentSpaceLinkToManyDocumentSpaceLinkTranslationFilter>;
  /** Some related `documentSpaceLinkTranslationsByLinkId` exist. */
  documentSpaceLinkTranslationsByLinkIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isMandatory` field. */
  isMandatory?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceLinkFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sectionTitle` field. */
  sectionTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** Tenant-scoped compatibility groups for Shared Space Templates (document_space_configs). Templates are link-compatible when they share a group. */
export type DocumentSpaceLinkGroup = Node & {
  __typename?: 'DocumentSpaceLinkGroup';
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceConfig`. */
  documentSpaceConfigsByTenantIdAndGroupId: DocumentSpaceConfigsConnection;
  id: Scalars['BigInt']['output'];
  /** Admin-facing label (unique per tenant, case-insensitive, trimmed). */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Tenant` that is related to this `DocumentSpaceLinkGroup`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


/** Tenant-scoped compatibility groups for Shared Space Templates (document_space_configs). Templates are link-compatible when they share a group. */
export type DocumentSpaceLinkGroupDocumentSpaceConfigsByTenantIdAndGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigCondition>;
  filter?: InputMaybe<DocumentSpaceConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};

/**
 * A condition to be used against `DocumentSpaceLinkGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceLinkGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceLinkGroup` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceLinkGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpaceConfigsByTenantIdAndGroupId` relation. */
  documentSpaceConfigsByTenantIdAndGroupId?: InputMaybe<DocumentSpaceLinkGroupToManyDocumentSpaceConfigFilter>;
  /** Some related `documentSpaceConfigsByTenantIdAndGroupId` exist. */
  documentSpaceConfigsByTenantIdAndGroupIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceLinkGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceLinkGroupFilter>>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceLinkGroup` */
export type DocumentSpaceLinkGroupInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Admin-facing label (unique per tenant, case-insensitive, trimmed). */
  name: Scalars['String']['input'];
  tenantId: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceLinkGroup`. Fields that are set will be updated. */
export type DocumentSpaceLinkGroupPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Admin-facing label (unique per tenant, case-insensitive, trimmed). */
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `DocumentSpaceConfig` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkGroupToManyDocumentSpaceConfigFilter = {
  /** Every related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigFilter>;
  /** No related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigFilter>;
  /** Some related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigFilter>;
};

/** A connection to a list of `DocumentSpaceLinkGroup` values. */
export type DocumentSpaceLinkGroupsConnection = {
  __typename?: 'DocumentSpaceLinkGroupsConnection';
  /** A list of edges which contains the `DocumentSpaceLinkGroup` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceLinkGroupsEdge>;
  /** A list of `DocumentSpaceLinkGroup` objects. */
  nodes: Array<Maybe<DocumentSpaceLinkGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceLinkGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceLinkGroup` edge in the connection. */
export type DocumentSpaceLinkGroupsEdge = {
  __typename?: 'DocumentSpaceLinkGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceLinkGroup` at the end of the edge. */
  node?: Maybe<DocumentSpaceLinkGroup>;
};

/** Methods to use when ordering `DocumentSpaceLinkGroup`. */
export enum DocumentSpaceLinkGroupsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdCountAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__COUNT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdCountDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__COUNT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_GROUP_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_GROUP_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_SCALING_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_SCALING_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LOGO_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_LOGO_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_NAME_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_NAME_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_NEW_TAB_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_NEW_TAB_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_STYLESHEET_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_STYLESHEET_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TEAM_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TEAM_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TEMPLATE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TEMPLATE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TENANT_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TENANT_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMaxUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MAX_UPDATED_BY_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_GROUP_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_GROUP_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_SCALING_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_SCALING_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LOGO_URL_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_LOGO_URL_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_NAME_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_NAME_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_NEW_TAB_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_NEW_TAB_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_STYLESHEET_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_STYLESHEET_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TEAM_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TEAM_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TEMPLATE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TEMPLATE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TENANT_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TENANT_ID_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByTenantIdAndGroupIdMinUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID_AND_GROUP_ID__MIN_UPDATED_BY_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** An input for mutations affecting `DocumentSpaceLink` */
export type DocumentSpaceLinkInput = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  url: Scalars['String']['input'];
};

export type DocumentSpaceLinkMapping = Node & {
  __typename?: 'DocumentSpaceLinkMapping';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkMapping`. */
  link?: Maybe<DocumentSpaceLink>;
  linkId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLinkMapping`. */
  space?: Maybe<DocumentSpace>;
  spaceId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceLinkMapping` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceLinkMappingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `linkId` field. */
  linkId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `DocumentSpaceLinkMapping` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceLinkMappingFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `link` relation. */
  link?: InputMaybe<DocumentSpaceLinkFilter>;
  /** A related `link` exists. */
  linkExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `linkId` field. */
  linkId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceLinkMappingFilter>>;
  /** Filter by the object’s `space` relation. */
  space?: InputMaybe<DocumentSpaceFilter>;
  /** A related `space` exists. */
  spaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `DocumentSpaceLinkMapping` */
export type DocumentSpaceLinkMappingInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  linkId?: InputMaybe<Scalars['BigInt']['input']>;
  spaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `DocumentSpaceLinkMapping`. Fields that are set will be updated. */
export type DocumentSpaceLinkMappingPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  linkId?: InputMaybe<Scalars['BigInt']['input']>;
  spaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `DocumentSpaceLinkMapping` values. */
export type DocumentSpaceLinkMappingsConnection = {
  __typename?: 'DocumentSpaceLinkMappingsConnection';
  /** A list of edges which contains the `DocumentSpaceLinkMapping` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceLinkMappingsEdge>;
  /** A list of `DocumentSpaceLinkMapping` objects. */
  nodes: Array<Maybe<DocumentSpaceLinkMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceLinkMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceLinkMapping` edge in the connection. */
export type DocumentSpaceLinkMappingsEdge = {
  __typename?: 'DocumentSpaceLinkMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceLinkMapping` at the end of the edge. */
  node?: Maybe<DocumentSpaceLinkMapping>;
};

/** Methods to use when ordering `DocumentSpaceLinkMapping`. */
export enum DocumentSpaceLinkMappingsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceBySpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceBySpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceBySpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceBySpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceBySpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceBySpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceBySpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__COMMENT_ASC',
  DocumentSpaceBySpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__COMMENT_DESC',
  DocumentSpaceBySpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceBySpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceBySpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceBySpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceBySpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceBySpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceBySpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceBySpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceBySpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceBySpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceBySpaceIdIdAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__ID_ASC',
  DocumentSpaceBySpaceIdIdDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__ID_DESC',
  DocumentSpaceBySpaceIdNameAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__NAME_ASC',
  DocumentSpaceBySpaceIdNameDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__NAME_DESC',
  DocumentSpaceBySpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceBySpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceBySpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceBySpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceBySpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceBySpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceBySpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceBySpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceBySpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceBySpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceBySpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceBySpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceLinkByLinkIdConfigIdAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CONFIG_ID_ASC',
  DocumentSpaceLinkByLinkIdConfigIdDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CONFIG_ID_DESC',
  DocumentSpaceLinkByLinkIdCreatedAtAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CREATED_AT_ASC',
  DocumentSpaceLinkByLinkIdCreatedAtDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CREATED_AT_DESC',
  DocumentSpaceLinkByLinkIdDocumentSpaceIdAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceLinkByLinkIdDocumentSpaceIdDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinkByLinkIdIdAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__ID_ASC',
  DocumentSpaceLinkByLinkIdIdDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__ID_DESC',
  DocumentSpaceLinkByLinkIdIsMandatoryAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__IS_MANDATORY_ASC',
  DocumentSpaceLinkByLinkIdIsMandatoryDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__IS_MANDATORY_DESC',
  DocumentSpaceLinkByLinkIdPositionAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__POSITION_ASC',
  DocumentSpaceLinkByLinkIdPositionDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__POSITION_DESC',
  DocumentSpaceLinkByLinkIdSectionTitleAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__SECTION_TITLE_ASC',
  DocumentSpaceLinkByLinkIdSectionTitleDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__SECTION_TITLE_DESC',
  DocumentSpaceLinkByLinkIdTitleAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__TITLE_ASC',
  DocumentSpaceLinkByLinkIdTitleDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__TITLE_DESC',
  DocumentSpaceLinkByLinkIdUpdatedAtAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__UPDATED_AT_ASC',
  DocumentSpaceLinkByLinkIdUpdatedAtDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__UPDATED_AT_DESC',
  DocumentSpaceLinkByLinkIdUrlAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__URL_ASC',
  DocumentSpaceLinkByLinkIdUrlDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__URL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinkIdAsc = 'LINK_ID_ASC',
  LinkIdDesc = 'LINK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpaceIdAsc = 'SPACE_ID_ASC',
  SpaceIdDesc = 'SPACE_ID_DESC'
}

/** Represents an update to a `DocumentSpaceLink`. Fields that are set will be updated. */
export type DocumentSpaceLinkPatch = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentSpaceLinkStatistic = {
  __typename?: 'DocumentSpaceLinkStatistic';
  numClicks?: Maybe<Scalars['BigInt']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceLinkStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceLinkStatisticCondition = {
  /** Checks for equality with the object’s `numClicks` field. */
  numClicks?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DocumentSpaceLinkStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceLinkStatisticFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceLinkStatisticFilter>;
  /** Filter by the object’s `numClicks` field. */
  numClicks?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceLinkStatisticFilter>>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** A connection to a list of `DocumentSpaceLinkStatistic` values. */
export type DocumentSpaceLinkStatisticsConnection = {
  __typename?: 'DocumentSpaceLinkStatisticsConnection';
  /** A list of edges which contains the `DocumentSpaceLinkStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceLinkStatisticsEdge>;
  /** A list of `DocumentSpaceLinkStatistic` objects. */
  nodes: Array<Maybe<DocumentSpaceLinkStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceLinkStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceLinkStatistic` edge in the connection. */
export type DocumentSpaceLinkStatisticsEdge = {
  __typename?: 'DocumentSpaceLinkStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceLinkStatistic` at the end of the edge. */
  node?: Maybe<DocumentSpaceLinkStatistic>;
};

/** Methods to use when ordering `DocumentSpaceLinkStatistic`. */
export enum DocumentSpaceLinkStatisticsOrderBy {
  Natural = 'NATURAL',
  NumClicksAsc = 'NUM_CLICKS_ASC',
  NumClicksDesc = 'NUM_CLICKS_DESC',
  SpaceIdAsc = 'SPACE_ID_ASC',
  SpaceIdDesc = 'SPACE_ID_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

/** A filter to be used against many `DocumentSpaceLinkMapping` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkToManyDocumentSpaceLinkMappingFilter = {
  /** Every related `DocumentSpaceLinkMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  /** No related `DocumentSpaceLinkMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  /** Some related `DocumentSpaceLinkMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkMappingFilter>;
};

/** A filter to be used against many `DocumentSpaceLinkTranslation` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkToManyDocumentSpaceLinkTranslationFilter = {
  /** Every related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** No related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** Some related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
};

export type DocumentSpaceLinkTranslation = Node & {
  __typename?: 'DocumentSpaceLinkTranslation';
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLinkTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  configId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  languageCode: Scalars['String']['output'];
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceLinkTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkTranslation`. */
  link?: Maybe<DocumentSpaceLink>;
  linkId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  position?: Maybe<Scalars['BigFloat']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * A condition to be used against `DocumentSpaceLinkTranslation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceLinkTranslationCondition = {
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `languageCode` field. */
  languageCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `linkId` field. */
  linkId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sectionTitle` field. */
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DocumentSpaceLinkTranslation` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceLinkTranslationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceLinkTranslationFilter>>;
  /** Filter by the object’s `config` relation. */
  config?: InputMaybe<DocumentSpaceConfigFilter>;
  /** A related `config` exists. */
  configExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `languageCode` field. */
  languageCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `languageCodeByLanguageCode` relation. */
  languageCodeByLanguageCode?: InputMaybe<LanguageCodeFilter>;
  /** Filter by the object’s `link` relation. */
  link?: InputMaybe<DocumentSpaceLinkFilter>;
  /** A related `link` exists. */
  linkExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `linkId` field. */
  linkId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceLinkTranslationFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sectionTitle` field. */
  sectionTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `DocumentSpaceLinkTranslation` */
export type DocumentSpaceLinkTranslationInput = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  languageCode: Scalars['String']['input'];
  linkId?: InputMaybe<Scalars['BigInt']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Represents an update to a `DocumentSpaceLinkTranslation`. Fields that are set will be updated. */
export type DocumentSpaceLinkTranslationPatch = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  linkId?: InputMaybe<Scalars['BigInt']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `DocumentSpaceLinkTranslation` values. */
export type DocumentSpaceLinkTranslationsConnection = {
  __typename?: 'DocumentSpaceLinkTranslationsConnection';
  /** A list of edges which contains the `DocumentSpaceLinkTranslation` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceLinkTranslationsEdge>;
  /** A list of `DocumentSpaceLinkTranslation` objects. */
  nodes: Array<Maybe<DocumentSpaceLinkTranslation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceLinkTranslation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceLinkTranslation` edge in the connection. */
export type DocumentSpaceLinkTranslationsEdge = {
  __typename?: 'DocumentSpaceLinkTranslationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceLinkTranslation` at the end of the edge. */
  node?: Maybe<DocumentSpaceLinkTranslation>;
};

/** Methods to use when ordering `DocumentSpaceLinkTranslation`. */
export enum DocumentSpaceLinkTranslationsOrderBy {
  ConfigIdAsc = 'CONFIG_ID_ASC',
  ConfigIdDesc = 'CONFIG_ID_DESC',
  DocumentSpaceConfigByConfigIdContentTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_ASC',
  DocumentSpaceConfigByConfigIdContentTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_DESC',
  DocumentSpaceConfigByConfigIdCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_ASC',
  DocumentSpaceConfigByConfigIdCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_DESC',
  DocumentSpaceConfigByConfigIdCustomCssAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_ASC',
  DocumentSpaceConfigByConfigIdCustomCssDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_DESC',
  DocumentSpaceConfigByConfigIdDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigByConfigIdDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigByConfigIdDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_ASC',
  DocumentSpaceConfigByConfigIdDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigByConfigIdFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_ASC',
  DocumentSpaceConfigByConfigIdFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_DESC',
  DocumentSpaceConfigByConfigIdFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_ASC',
  DocumentSpaceConfigByConfigIdFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_DESC',
  DocumentSpaceConfigByConfigIdGroupIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_ASC',
  DocumentSpaceConfigByConfigIdGroupIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_DESC',
  DocumentSpaceConfigByConfigIdHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroScalingAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_ASC',
  DocumentSpaceConfigByConfigIdHeroScalingDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_DESC',
  DocumentSpaceConfigByConfigIdHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_DESC',
  DocumentSpaceConfigByConfigIdHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_DESC',
  DocumentSpaceConfigByConfigIdIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_ASC',
  DocumentSpaceConfigByConfigIdIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigByConfigIdLogoUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_DESC',
  DocumentSpaceConfigByConfigIdNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_ASC',
  DocumentSpaceConfigByConfigIdNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_DESC',
  DocumentSpaceConfigByConfigIdNewTabAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_ASC',
  DocumentSpaceConfigByConfigIdNewTabDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_DESC',
  DocumentSpaceConfigByConfigIdOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigByConfigIdOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigByConfigIdProductNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_ASC',
  DocumentSpaceConfigByConfigIdProductNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_DESC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigByConfigIdStylesheetAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_ASC',
  DocumentSpaceConfigByConfigIdStylesheetDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_DESC',
  DocumentSpaceConfigByConfigIdTeamIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_ASC',
  DocumentSpaceConfigByConfigIdTeamIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_DESC',
  DocumentSpaceConfigByConfigIdTemplateAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_ASC',
  DocumentSpaceConfigByConfigIdTemplateDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_DESC',
  DocumentSpaceConfigByConfigIdTenantIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_ASC',
  DocumentSpaceConfigByConfigIdTenantIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_DESC',
  DocumentSpaceConfigByConfigIdTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_ASC',
  DocumentSpaceConfigByConfigIdTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_DESC',
  DocumentSpaceConfigByConfigIdUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_ASC',
  DocumentSpaceConfigByConfigIdUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_DESC',
  DocumentSpaceConfigByConfigIdUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_ASC',
  DocumentSpaceConfigByConfigIdUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_DESC',
  DocumentSpaceLinkByLinkIdConfigIdAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CONFIG_ID_ASC',
  DocumentSpaceLinkByLinkIdConfigIdDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CONFIG_ID_DESC',
  DocumentSpaceLinkByLinkIdCreatedAtAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CREATED_AT_ASC',
  DocumentSpaceLinkByLinkIdCreatedAtDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__CREATED_AT_DESC',
  DocumentSpaceLinkByLinkIdDocumentSpaceIdAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceLinkByLinkIdDocumentSpaceIdDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinkByLinkIdIdAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__ID_ASC',
  DocumentSpaceLinkByLinkIdIdDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__ID_DESC',
  DocumentSpaceLinkByLinkIdIsMandatoryAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__IS_MANDATORY_ASC',
  DocumentSpaceLinkByLinkIdIsMandatoryDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__IS_MANDATORY_DESC',
  DocumentSpaceLinkByLinkIdPositionAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__POSITION_ASC',
  DocumentSpaceLinkByLinkIdPositionDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__POSITION_DESC',
  DocumentSpaceLinkByLinkIdSectionTitleAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__SECTION_TITLE_ASC',
  DocumentSpaceLinkByLinkIdSectionTitleDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__SECTION_TITLE_DESC',
  DocumentSpaceLinkByLinkIdTitleAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__TITLE_ASC',
  DocumentSpaceLinkByLinkIdTitleDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__TITLE_DESC',
  DocumentSpaceLinkByLinkIdUpdatedAtAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__UPDATED_AT_ASC',
  DocumentSpaceLinkByLinkIdUpdatedAtDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__UPDATED_AT_DESC',
  DocumentSpaceLinkByLinkIdUrlAsc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__URL_ASC',
  DocumentSpaceLinkByLinkIdUrlDesc = 'DOCUMENT_SPACE_LINK_BY_LINK_ID__URL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LanguageCodeAsc = 'LANGUAGE_CODE_ASC',
  LanguageCodeByLanguageCodeCodeAsc = 'LANGUAGE_CODE_BY_LANGUAGE_CODE__CODE_ASC',
  LanguageCodeByLanguageCodeCodeDesc = 'LANGUAGE_CODE_BY_LANGUAGE_CODE__CODE_DESC',
  LanguageCodeDesc = 'LANGUAGE_CODE_DESC',
  LinkIdAsc = 'LINK_ID_ASC',
  LinkIdDesc = 'LINK_ID_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SectionTitleAsc = 'SECTION_TITLE_ASC',
  SectionTitleDesc = 'SECTION_TITLE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

/** A connection to a list of `DocumentSpaceLink` values. */
export type DocumentSpaceLinksConnection = {
  __typename?: 'DocumentSpaceLinksConnection';
  /** A list of edges which contains the `DocumentSpaceLink` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceLinksEdge>;
  /** A list of `DocumentSpaceLink` objects. */
  nodes: Array<Maybe<DocumentSpaceLink>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceLink` edge in the connection. */
export type DocumentSpaceLinksEdge = {
  __typename?: 'DocumentSpaceLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceLink` at the end of the edge. */
  node?: Maybe<DocumentSpaceLink>;
};

/** Methods to use when ordering `DocumentSpaceLink`. */
export enum DocumentSpaceLinksOrderBy {
  ConfigIdAsc = 'CONFIG_ID_ASC',
  ConfigIdDesc = 'CONFIG_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceConfigByConfigIdContentTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_ASC',
  DocumentSpaceConfigByConfigIdContentTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_DESC',
  DocumentSpaceConfigByConfigIdCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_ASC',
  DocumentSpaceConfigByConfigIdCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_DESC',
  DocumentSpaceConfigByConfigIdCustomCssAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_ASC',
  DocumentSpaceConfigByConfigIdCustomCssDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_DESC',
  DocumentSpaceConfigByConfigIdDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigByConfigIdDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigByConfigIdDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_ASC',
  DocumentSpaceConfigByConfigIdDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigByConfigIdFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_ASC',
  DocumentSpaceConfigByConfigIdFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_DESC',
  DocumentSpaceConfigByConfigIdFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_ASC',
  DocumentSpaceConfigByConfigIdFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_DESC',
  DocumentSpaceConfigByConfigIdGroupIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_ASC',
  DocumentSpaceConfigByConfigIdGroupIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_DESC',
  DocumentSpaceConfigByConfigIdHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroScalingAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_ASC',
  DocumentSpaceConfigByConfigIdHeroScalingDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_DESC',
  DocumentSpaceConfigByConfigIdHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_DESC',
  DocumentSpaceConfigByConfigIdHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_DESC',
  DocumentSpaceConfigByConfigIdIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_ASC',
  DocumentSpaceConfigByConfigIdIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigByConfigIdLogoUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_DESC',
  DocumentSpaceConfigByConfigIdNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_ASC',
  DocumentSpaceConfigByConfigIdNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_DESC',
  DocumentSpaceConfigByConfigIdNewTabAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_ASC',
  DocumentSpaceConfigByConfigIdNewTabDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_DESC',
  DocumentSpaceConfigByConfigIdOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigByConfigIdOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigByConfigIdProductNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_ASC',
  DocumentSpaceConfigByConfigIdProductNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_DESC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigByConfigIdStylesheetAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_ASC',
  DocumentSpaceConfigByConfigIdStylesheetDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_DESC',
  DocumentSpaceConfigByConfigIdTeamIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_ASC',
  DocumentSpaceConfigByConfigIdTeamIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_DESC',
  DocumentSpaceConfigByConfigIdTemplateAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_ASC',
  DocumentSpaceConfigByConfigIdTemplateDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_DESC',
  DocumentSpaceConfigByConfigIdTenantIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_ASC',
  DocumentSpaceConfigByConfigIdTenantIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_DESC',
  DocumentSpaceConfigByConfigIdTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_ASC',
  DocumentSpaceConfigByConfigIdTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_DESC',
  DocumentSpaceConfigByConfigIdUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_ASC',
  DocumentSpaceConfigByConfigIdUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_DESC',
  DocumentSpaceConfigByConfigIdUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_ASC',
  DocumentSpaceConfigByConfigIdUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinkMappingsByLinkIdCountAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__COUNT_ASC',
  DocumentSpaceLinkMappingsByLinkIdCountDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__COUNT_DESC',
  DocumentSpaceLinkMappingsByLinkIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceLinkMappingsByLinkIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceLinkMappingsByLinkIdMaxIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_ID_ASC',
  DocumentSpaceLinkMappingsByLinkIdMaxIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_ID_DESC',
  DocumentSpaceLinkMappingsByLinkIdMaxLinkIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_LINK_ID_ASC',
  DocumentSpaceLinkMappingsByLinkIdMaxLinkIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_LINK_ID_DESC',
  DocumentSpaceLinkMappingsByLinkIdMaxSpaceIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_SPACE_ID_ASC',
  DocumentSpaceLinkMappingsByLinkIdMaxSpaceIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MAX_SPACE_ID_DESC',
  DocumentSpaceLinkMappingsByLinkIdMinCreatedAtAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceLinkMappingsByLinkIdMinCreatedAtDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceLinkMappingsByLinkIdMinIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_ID_ASC',
  DocumentSpaceLinkMappingsByLinkIdMinIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_ID_DESC',
  DocumentSpaceLinkMappingsByLinkIdMinLinkIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_LINK_ID_ASC',
  DocumentSpaceLinkMappingsByLinkIdMinLinkIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_LINK_ID_DESC',
  DocumentSpaceLinkMappingsByLinkIdMinSpaceIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_SPACE_ID_ASC',
  DocumentSpaceLinkMappingsByLinkIdMinSpaceIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_LINK_ID__MIN_SPACE_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdCountAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__COUNT_ASC',
  DocumentSpaceLinkTranslationsByLinkIdCountDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__COUNT_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxConfigIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_CONFIG_ID_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxConfigIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_CONFIG_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_ID_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxLanguageCodeAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_LANGUAGE_CODE_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxLanguageCodeDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_LANGUAGE_CODE_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxLinkIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_LINK_ID_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxLinkIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_LINK_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxPositionAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_POSITION_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxPositionDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_POSITION_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxSectionTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_SECTION_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxSectionTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_SECTION_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMaxUrlAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_URL_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMaxUrlDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MAX_URL_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinConfigIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_CONFIG_ID_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinConfigIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_CONFIG_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_ID_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinLanguageCodeAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_LANGUAGE_CODE_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinLanguageCodeDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_LANGUAGE_CODE_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinLinkIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_LINK_ID_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinLinkIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_LINK_ID_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinPositionAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_POSITION_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinPositionDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_POSITION_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinSectionTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_SECTION_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinSectionTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_SECTION_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLinkIdMinUrlAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_URL_ASC',
  DocumentSpaceLinkTranslationsByLinkIdMinUrlDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LINK_ID__MIN_URL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsMandatoryAsc = 'IS_MANDATORY_ASC',
  IsMandatoryDesc = 'IS_MANDATORY_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SectionTitleAsc = 'SECTION_TITLE_ASC',
  SectionTitleDesc = 'SECTION_TITLE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

export type DocumentSpacePageStatistic = {
  __typename?: 'DocumentSpacePageStatistic';
  displayTitle?: Maybe<Scalars['String']['output']>;
  docId?: Maybe<Scalars['Int']['output']>;
  numViews?: Maybe<Scalars['BigInt']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `DocumentSpacePageStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpacePageStatisticCondition = {
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `docId` field. */
  docId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `numViews` field. */
  numViews?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `DocumentSpacePageStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpacePageStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpacePageStatisticFilter>>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `docId` field. */
  docId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpacePageStatisticFilter>;
  /** Filter by the object’s `numViews` field. */
  numViews?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpacePageStatisticFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `DocumentSpacePageStatistic` values. */
export type DocumentSpacePageStatisticsConnection = {
  __typename?: 'DocumentSpacePageStatisticsConnection';
  /** A list of edges which contains the `DocumentSpacePageStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentSpacePageStatisticsEdge>;
  /** A list of `DocumentSpacePageStatistic` objects. */
  nodes: Array<Maybe<DocumentSpacePageStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpacePageStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpacePageStatistic` edge in the connection. */
export type DocumentSpacePageStatisticsEdge = {
  __typename?: 'DocumentSpacePageStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpacePageStatistic` at the end of the edge. */
  node?: Maybe<DocumentSpacePageStatistic>;
};

/** Methods to use when ordering `DocumentSpacePageStatistic`. */
export enum DocumentSpacePageStatisticsOrderBy {
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocIdAsc = 'DOC_ID_ASC',
  DocIdDesc = 'DOC_ID_DESC',
  Natural = 'NATURAL',
  NumViewsAsc = 'NUM_VIEWS_ASC',
  NumViewsDesc = 'NUM_VIEWS_DESC',
  PageNumberAsc = 'PAGE_NUMBER_ASC',
  PageNumberDesc = 'PAGE_NUMBER_DESC',
  SpaceIdAsc = 'SPACE_ID_ASC',
  SpaceIdDesc = 'SPACE_ID_DESC'
}

/** Represents an update to a `DocumentSpace`. Fields that are set will be updated. */
export type DocumentSpacePatch = {
  allowedEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  codeOnAccessCard?: InputMaybe<Scalars['String']['input']>;
  codeOnAccessCardLastUsedAt?: InputMaybe<Scalars['Datetime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DocumentSpaceSection = Node & {
  __typename?: 'DocumentSpaceSection';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSection`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceItem`. */
  documentSpaceItemsBySectionId: DocumentSpaceItemsConnection;
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  position: Scalars['BigFloat']['output'];
  sysPeriod: DatetimeRange;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


export type DocumentSpaceSectionDocumentSpaceItemsBySectionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceItemCondition>;
  filter?: InputMaybe<DocumentSpaceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/**
 * A condition to be used against `DocumentSpaceSection` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceSectionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceSection` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceSectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceSectionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpaceItemsBySectionId` relation. */
  documentSpaceItemsBySectionId?: InputMaybe<DocumentSpaceSectionToManyDocumentSpaceItemFilter>;
  /** Some related `documentSpaceItemsBySectionId` exist. */
  documentSpaceItemsBySectionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceSectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceSectionFilter>>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceSection` */
export type DocumentSpaceSectionInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceSection`. Fields that are set will be updated. */
export type DocumentSpaceSectionPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  position?: InputMaybe<Scalars['BigFloat']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `DocumentSpaceItem` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceSectionToManyDocumentSpaceItemFilter = {
  /** Every related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceItemFilter>;
  /** No related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceItemFilter>;
  /** Some related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceItemFilter>;
};

/** A connection to a list of `DocumentSpaceSection` values. */
export type DocumentSpaceSectionsConnection = {
  __typename?: 'DocumentSpaceSectionsConnection';
  /** A list of edges which contains the `DocumentSpaceSection` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceSectionsEdge>;
  /** A list of `DocumentSpaceSection` objects. */
  nodes: Array<Maybe<DocumentSpaceSection>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceSection` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceSection` edge in the connection. */
export type DocumentSpaceSectionsEdge = {
  __typename?: 'DocumentSpaceSectionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceSection` at the end of the edge. */
  node?: Maybe<DocumentSpaceSection>;
};

/** Methods to use when ordering `DocumentSpaceSection`. */
export enum DocumentSpaceSectionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsBySectionIdCountAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__COUNT_ASC',
  DocumentSpaceItemsBySectionIdCountDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__COUNT_DESC',
  DocumentSpaceItemsBySectionIdMaxAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_ADDED_AT_ASC',
  DocumentSpaceItemsBySectionIdMaxAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_ADDED_AT_DESC',
  DocumentSpaceItemsBySectionIdMaxDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_DOCUMENT_ID_ASC',
  DocumentSpaceItemsBySectionIdMaxDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_DOCUMENT_ID_DESC',
  DocumentSpaceItemsBySectionIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsBySectionIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsBySectionIdMaxFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_FLOW_ID_ASC',
  DocumentSpaceItemsBySectionIdMaxFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_FLOW_ID_DESC',
  DocumentSpaceItemsBySectionIdMaxIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_ID_ASC',
  DocumentSpaceItemsBySectionIdMaxIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_ID_DESC',
  DocumentSpaceItemsBySectionIdMaxPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_POSITION_ASC',
  DocumentSpaceItemsBySectionIdMaxPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_POSITION_DESC',
  DocumentSpaceItemsBySectionIdMaxSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_SECTION_ID_ASC',
  DocumentSpaceItemsBySectionIdMaxSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_SECTION_ID_DESC',
  DocumentSpaceItemsBySectionIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceItemsBySectionIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceItemsBySectionIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceItemsBySectionIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceItemsBySectionIdMinAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_ADDED_AT_ASC',
  DocumentSpaceItemsBySectionIdMinAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_ADDED_AT_DESC',
  DocumentSpaceItemsBySectionIdMinDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_DOCUMENT_ID_ASC',
  DocumentSpaceItemsBySectionIdMinDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_DOCUMENT_ID_DESC',
  DocumentSpaceItemsBySectionIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsBySectionIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsBySectionIdMinFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_FLOW_ID_ASC',
  DocumentSpaceItemsBySectionIdMinFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_FLOW_ID_DESC',
  DocumentSpaceItemsBySectionIdMinIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_ID_ASC',
  DocumentSpaceItemsBySectionIdMinIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_ID_DESC',
  DocumentSpaceItemsBySectionIdMinPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_POSITION_ASC',
  DocumentSpaceItemsBySectionIdMinPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_POSITION_DESC',
  DocumentSpaceItemsBySectionIdMinSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_SECTION_ID_ASC',
  DocumentSpaceItemsBySectionIdMinSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_SECTION_ID_DESC',
  DocumentSpaceItemsBySectionIdMinSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceItemsBySectionIdMinSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceItemsBySectionIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceItemsBySectionIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_SECTION_ID__MIN_UPDATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type DocumentSpaceSession = Node & {
  __typename?: 'DocumentSpaceSession';
  consentGiven: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSession`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  fingerprint: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DocumentSpaceSession` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceSessionCondition = {
  /** Checks for equality with the object’s `consentGiven` field. */
  consentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fingerprint` field. */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceSession` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceSessionFilter>>;
  /** Filter by the object’s `consentGiven` field. */
  consentGiven?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fingerprint` field. */
  fingerprint?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceSessionFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceSession` */
export type DocumentSpaceSessionInput = {
  consentGiven: Scalars['Boolean']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  fingerprint: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceSession`. Fields that are set will be updated. */
export type DocumentSpaceSessionPatch = {
  consentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentSpaceSession` values. */
export type DocumentSpaceSessionsConnection = {
  __typename?: 'DocumentSpaceSessionsConnection';
  /** A list of edges which contains the `DocumentSpaceSession` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceSessionsEdge>;
  /** A list of `DocumentSpaceSession` objects. */
  nodes: Array<Maybe<DocumentSpaceSession>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceSession` edge in the connection. */
export type DocumentSpaceSessionsEdge = {
  __typename?: 'DocumentSpaceSessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceSession` at the end of the edge. */
  node?: Maybe<DocumentSpaceSession>;
};

/** Methods to use when ordering `DocumentSpaceSession`. */
export enum DocumentSpaceSessionsOrderBy {
  ConsentGivenAsc = 'CONSENT_GIVEN_ASC',
  ConsentGivenDesc = 'CONSENT_GIVEN_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  FingerprintAsc = 'FINGERPRINT_ASC',
  FingerprintDesc = 'FINGERPRINT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type DocumentSpaceStatistic = {
  __typename?: 'DocumentSpaceStatistic';
  activeScreenTime?: Maybe<Interval>;
  clientHash?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idleTime?: Maybe<Interval>;
  involvedSpaces?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfEvents?: Maybe<Scalars['BigInt']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  sessionId?: Maybe<Scalars['UUID']['output']>;
  startsAt?: Maybe<Scalars['Datetime']['output']>;
  totalDuration?: Maybe<Interval>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * A condition to be used against `DocumentSpaceStatistic` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceStatisticCondition = {
  /** Checks for equality with the object’s `activeScreenTime` field. */
  activeScreenTime?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `clientHash` field. */
  clientHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idleTime` field. */
  idleTime?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `involvedSpaces` field. */
  involvedSpaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numberOfEvents` field. */
  numberOfEvents?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `preview` field. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sessionId` field. */
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalDuration` field. */
  totalDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `types` field. */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A filter to be used against `DocumentSpaceStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceStatisticFilter = {
  /** Filter by the object’s `activeScreenTime` field. */
  activeScreenTime?: InputMaybe<IntervalFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceStatisticFilter>>;
  /** Filter by the object’s `clientHash` field. */
  clientHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idleTime` field. */
  idleTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `involvedSpaces` field. */
  involvedSpaces?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceStatisticFilter>;
  /** Filter by the object’s `numberOfEvents` field. */
  numberOfEvents?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceStatisticFilter>>;
  /** Filter by the object’s `preview` field. */
  preview?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sessionId` field. */
  sessionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalDuration` field. */
  totalDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `types` field. */
  types?: InputMaybe<StringListFilter>;
};

/** A connection to a list of `DocumentSpaceStatistic` values. */
export type DocumentSpaceStatisticsConnection = {
  __typename?: 'DocumentSpaceStatisticsConnection';
  /** A list of edges which contains the `DocumentSpaceStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceStatisticsEdge>;
  /** A list of `DocumentSpaceStatistic` objects. */
  nodes: Array<Maybe<DocumentSpaceStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceStatistic` edge in the connection. */
export type DocumentSpaceStatisticsEdge = {
  __typename?: 'DocumentSpaceStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceStatistic` at the end of the edge. */
  node?: Maybe<DocumentSpaceStatistic>;
};

/** Methods to use when ordering `DocumentSpaceStatistic`. */
export enum DocumentSpaceStatisticsOrderBy {
  ActiveScreenTimeAsc = 'ACTIVE_SCREEN_TIME_ASC',
  ActiveScreenTimeDesc = 'ACTIVE_SCREEN_TIME_DESC',
  ClientHashAsc = 'CLIENT_HASH_ASC',
  ClientHashDesc = 'CLIENT_HASH_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdleTimeAsc = 'IDLE_TIME_ASC',
  IdleTimeDesc = 'IDLE_TIME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvolvedSpacesAsc = 'INVOLVED_SPACES_ASC',
  InvolvedSpacesDesc = 'INVOLVED_SPACES_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NumberOfEventsAsc = 'NUMBER_OF_EVENTS_ASC',
  NumberOfEventsDesc = 'NUMBER_OF_EVENTS_DESC',
  PreviewAsc = 'PREVIEW_ASC',
  PreviewDesc = 'PREVIEW_DESC',
  SessionIdAsc = 'SESSION_ID_ASC',
  SessionIdDesc = 'SESSION_ID_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  TotalDurationAsc = 'TOTAL_DURATION_ASC',
  TotalDurationDesc = 'TOTAL_DURATION_DESC',
  TypesAsc = 'TYPES_ASC',
  TypesDesc = 'TYPES_DESC'
}

export type DocumentSpaceTag = Node & {
  __typename?: 'DocumentSpaceTag';
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  scriptSrc?: Maybe<Scalars['String']['output']>;
  scripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagType?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceTag`. */
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceTag` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceTagCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `scriptSrc` field. */
  scriptSrc?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `scripts` field. */
  scripts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `tagType` field. */
  tagType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `DocumentSpaceTag` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceTagFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceTagFilter>>;
  /** Filter by the object’s `scriptSrc` field. */
  scriptSrc?: InputMaybe<StringFilter>;
  /** Filter by the object’s `scripts` field. */
  scripts?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `tagType` field. */
  tagType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** A related `tenant` exists. */
  tenantExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `DocumentSpaceTag` */
export type DocumentSpaceTagInput = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  scriptSrc?: InputMaybe<Scalars['String']['input']>;
  scripts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `DocumentSpaceTag`. Fields that are set will be updated. */
export type DocumentSpaceTagPatch = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  scriptSrc?: InputMaybe<Scalars['String']['input']>;
  scripts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `DocumentSpaceTag` values. */
export type DocumentSpaceTagsConnection = {
  __typename?: 'DocumentSpaceTagsConnection';
  /** A list of edges which contains the `DocumentSpaceTag` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceTagsEdge>;
  /** A list of `DocumentSpaceTag` objects. */
  nodes: Array<Maybe<DocumentSpaceTag>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceTag` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceTag` edge in the connection. */
export type DocumentSpaceTagsEdge = {
  __typename?: 'DocumentSpaceTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceTag` at the end of the edge. */
  node?: Maybe<DocumentSpaceTag>;
};

/** Methods to use when ordering `DocumentSpaceTag`. */
export enum DocumentSpaceTagsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScriptsAsc = 'SCRIPTS_ASC',
  ScriptsDesc = 'SCRIPTS_DESC',
  ScriptSrcAsc = 'SCRIPT_SRC_ASC',
  ScriptSrcDesc = 'SCRIPT_SRC_DESC',
  TagTypeAsc = 'TAG_TYPE_ASC',
  TagTypeDesc = 'TAG_TYPE_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

export enum DocumentSpaceTemplate {
  Classic = 'CLASSIC',
  Roche = 'ROCHE',
  Trendy = 'TRENDY'
}

/** A filter to be used against DocumentSpaceTemplate fields. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceTemplateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DocumentSpaceTemplate>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DocumentSpaceTemplate>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DocumentSpaceTemplate>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DocumentSpaceTemplate>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DocumentSpaceTemplate>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DocumentSpaceTemplate>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DocumentSpaceTemplate>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DocumentSpaceTemplate>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DocumentSpaceTemplate>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DocumentSpaceTemplate>>;
};

/** A filter to be used against many `DocumentSpaceAccess` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceAccessFilter = {
  /** Every related `DocumentSpaceAccess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceAccessFilter>;
  /** No related `DocumentSpaceAccess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceAccessFilter>;
  /** Some related `DocumentSpaceAccess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceAccessFilter>;
};

/** A filter to be used against many `DocumentSpaceItem` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceItemFilter = {
  /** Every related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceItemFilter>;
  /** No related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceItemFilter>;
  /** Some related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceItemFilter>;
};

/** A filter to be used against many `DocumentSpaceLink` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceLinkFilter = {
  /** Every related `DocumentSpaceLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkFilter>;
  /** No related `DocumentSpaceLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkFilter>;
  /** Some related `DocumentSpaceLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkFilter>;
};

/** A filter to be used against many `DocumentSpaceLinkMapping` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceLinkMappingFilter = {
  /** Every related `DocumentSpaceLinkMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  /** No related `DocumentSpaceLinkMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  /** Some related `DocumentSpaceLinkMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkMappingFilter>;
};

/** A filter to be used against many `DocumentSpaceSection` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceSectionFilter = {
  /** Every related `DocumentSpaceSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceSectionFilter>;
  /** No related `DocumentSpaceSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceSectionFilter>;
  /** Some related `DocumentSpaceSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceSectionFilter>;
};

/** A filter to be used against many `DocumentSpaceSession` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceSessionFilter = {
  /** Every related `DocumentSpaceSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceSessionFilter>;
  /** No related `DocumentSpaceSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceSessionFilter>;
  /** Some related `DocumentSpaceSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceSessionFilter>;
};

/** A filter to be used against many `DocumentSpaceVoucher` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyDocumentSpaceVoucherFilter = {
  /** Every related `DocumentSpaceVoucher` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceVoucherFilter>;
  /** No related `DocumentSpaceVoucher` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceVoucherFilter>;
  /** Some related `DocumentSpaceVoucher` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceVoucherFilter>;
};

/** A filter to be used against many `FtsDocumentSpaceHit` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyFtsDocumentSpaceHitFilter = {
  /** Every related `FtsDocumentSpaceHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FtsDocumentSpaceHitFilter>;
  /** No related `FtsDocumentSpaceHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FtsDocumentSpaceHitFilter>;
  /** Some related `FtsDocumentSpaceHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FtsDocumentSpaceHitFilter>;
};

/** A filter to be used against many `MaDocumentSpaceDocumentStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyMaDocumentSpaceDocumentStatisticFilter = {
  /** Every related `MaDocumentSpaceDocumentStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  /** No related `MaDocumentSpaceDocumentStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  /** Some related `MaDocumentSpaceDocumentStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
};

/** A filter to be used against many `MaDocumentSpaceLinkStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyMaDocumentSpaceLinkStatisticFilter = {
  /** Every related `MaDocumentSpaceLinkStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpaceLinkStatisticFilter>;
  /** No related `MaDocumentSpaceLinkStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpaceLinkStatisticFilter>;
  /** Some related `MaDocumentSpaceLinkStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpaceLinkStatisticFilter>;
};

/** A filter to be used against many `MaDocumentSpacePageStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyMaDocumentSpacePageStatisticFilter = {
  /** Every related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** No related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** Some related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
};

/** A filter to be used against many `MaDocumentSpaceVideoStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceToManyMaDocumentSpaceVideoStatisticFilter = {
  /** Every related `MaDocumentSpaceVideoStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  /** No related `MaDocumentSpaceVideoStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  /** Some related `MaDocumentSpaceVideoStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
};

export type DocumentSpaceVisitStatistic = Node & {
  __typename?: 'DocumentSpaceVisitStatistic';
  documentSpaceId: Scalars['BigInt']['output'];
  firstVisitAt?: Maybe<Scalars['Datetime']['output']>;
  lastVisitAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceVisitStatistic`. */
  space?: Maybe<DocumentSpace>;
  visitCount?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceVisitStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceVisitStatisticCondition = {
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `firstVisitAt` field. */
  firstVisitAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `lastVisitAt` field. */
  lastVisitAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `visitCount` field. */
  visitCount?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `DocumentSpaceVisitStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceVisitStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceVisitStatisticFilter>>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `firstVisitAt` field. */
  firstVisitAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lastVisitAt` field. */
  lastVisitAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceVisitStatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceVisitStatisticFilter>>;
  /** Filter by the object’s `space` relation. */
  space?: InputMaybe<DocumentSpaceFilter>;
  /** A related `space` exists. */
  spaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `visitCount` field. */
  visitCount?: InputMaybe<BigIntFilter>;
};

/** A connection to a list of `DocumentSpaceVisitStatistic` values. */
export type DocumentSpaceVisitStatisticsConnection = {
  __typename?: 'DocumentSpaceVisitStatisticsConnection';
  /** A list of edges which contains the `DocumentSpaceVisitStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceVisitStatisticsEdge>;
  /** A list of `DocumentSpaceVisitStatistic` objects. */
  nodes: Array<Maybe<DocumentSpaceVisitStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceVisitStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceVisitStatistic` edge in the connection. */
export type DocumentSpaceVisitStatisticsEdge = {
  __typename?: 'DocumentSpaceVisitStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceVisitStatistic` at the end of the edge. */
  node?: Maybe<DocumentSpaceVisitStatistic>;
};

/** Methods to use when ordering `DocumentSpaceVisitStatistic`. */
export enum DocumentSpaceVisitStatisticsOrderBy {
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  FirstVisitAtAsc = 'FIRST_VISIT_AT_ASC',
  FirstVisitAtDesc = 'FIRST_VISIT_AT_DESC',
  LastVisitAtAsc = 'LAST_VISIT_AT_ASC',
  LastVisitAtDesc = 'LAST_VISIT_AT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VisitCountAsc = 'VISIT_COUNT_ASC',
  VisitCountDesc = 'VISIT_COUNT_DESC'
}

export type DocumentSpaceVoucher = Node & {
  __typename?: 'DocumentSpaceVoucher';
  /** Reads a single `CampaignPhaseLink` that is related to this `DocumentSpaceVoucher`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  campaignPhaseLinkId?: Maybe<Scalars['BigInt']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceVoucher`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  hashAlgorithm: Scalars['String']['output'];
  hashedSecret: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  isPreview: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  sysPeriod: DatetimeRange;
  updatedAt: Scalars['Datetime']['output'];
  validUntil?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `DocumentSpaceVoucher` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpaceVoucherCondition = {
  /** Checks for equality with the object’s `campaignPhaseLinkId` field. */
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `hashAlgorithm` field. */
  hashAlgorithm?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hashedSecret` field. */
  hashedSecret?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isPreview` field. */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `validUntil` field. */
  validUntil?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpaceVoucher` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpaceVoucherFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpaceVoucherFilter>>;
  /** Filter by the object’s `campaignPhaseLink` relation. */
  campaignPhaseLink?: InputMaybe<CampaignPhaseLinkFilter>;
  /** A related `campaignPhaseLink` exists. */
  campaignPhaseLinkExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `campaignPhaseLinkId` field. */
  campaignPhaseLinkId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `hashAlgorithm` field. */
  hashAlgorithm?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hashedSecret` field. */
  hashedSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isPreview` field. */
  isPreview?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpaceVoucherFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpaceVoucherFilter>>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `validUntil` field. */
  validUntil?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpaceVoucher` */
export type DocumentSpaceVoucherInput = {
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  hashAlgorithm?: InputMaybe<Scalars['String']['input']>;
  hashedSecret: Scalars['String']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validUntil?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `DocumentSpaceVoucher`. Fields that are set will be updated. */
export type DocumentSpaceVoucherPatch = {
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  hashAlgorithm?: InputMaybe<Scalars['String']['input']>;
  hashedSecret?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validUntil?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentSpaceVoucher` values. */
export type DocumentSpaceVouchersConnection = {
  __typename?: 'DocumentSpaceVouchersConnection';
  /** A list of edges which contains the `DocumentSpaceVoucher` and cursor to aid in pagination. */
  edges: Array<DocumentSpaceVouchersEdge>;
  /** A list of `DocumentSpaceVoucher` objects. */
  nodes: Array<Maybe<DocumentSpaceVoucher>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpaceVoucher` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpaceVoucher` edge in the connection. */
export type DocumentSpaceVouchersEdge = {
  __typename?: 'DocumentSpaceVouchersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpaceVoucher` at the end of the edge. */
  node?: Maybe<DocumentSpaceVoucher>;
};

/** Methods to use when ordering `DocumentSpaceVoucher`. */
export enum DocumentSpaceVouchersOrderBy {
  CampaignPhaseLinkByCampaignPhaseLinkIdCreatedAtAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__CREATED_AT_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdCreatedAtDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__CREATED_AT_DESC',
  CampaignPhaseLinkByCampaignPhaseLinkIdIdAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__ID_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdIdDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__ID_DESC',
  CampaignPhaseLinkByCampaignPhaseLinkIdNameAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__NAME_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdNameDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__NAME_DESC',
  CampaignPhaseLinkByCampaignPhaseLinkIdPhaseIdAsc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__PHASE_ID_ASC',
  CampaignPhaseLinkByCampaignPhaseLinkIdPhaseIdDesc = 'CAMPAIGN_PHASE_LINK_BY_CAMPAIGN_PHASE_LINK_ID__PHASE_ID_DESC',
  CampaignPhaseLinkIdAsc = 'CAMPAIGN_PHASE_LINK_ID_ASC',
  CampaignPhaseLinkIdDesc = 'CAMPAIGN_PHASE_LINK_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  HashedSecretAsc = 'HASHED_SECRET_ASC',
  HashedSecretDesc = 'HASHED_SECRET_DESC',
  HashAlgorithmAsc = 'HASH_ALGORITHM_ASC',
  HashAlgorithmDesc = 'HASH_ALGORITHM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPreviewAsc = 'IS_PREVIEW_ASC',
  IsPreviewDesc = 'IS_PREVIEW_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidUntilAsc = 'VALID_UNTIL_ASC',
  ValidUntilDesc = 'VALID_UNTIL_DESC'
}

/** A connection to a list of `DocumentSpace` values. */
export type DocumentSpacesConnection = {
  __typename?: 'DocumentSpacesConnection';
  /** A list of edges which contains the `DocumentSpace` and cursor to aid in pagination. */
  edges: Array<DocumentSpacesEdge>;
  /** A list of `DocumentSpace` objects. */
  nodes: Array<Maybe<DocumentSpace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpace` edge in the connection. */
export type DocumentSpacesEdge = {
  __typename?: 'DocumentSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpace` at the end of the edge. */
  node?: Maybe<DocumentSpace>;
};

export type DocumentSpacesOldBak = {
  __typename?: 'DocumentSpacesOldBak';
  comment?: Maybe<Scalars['String']['output']>;
  configId?: Maybe<Scalars['BigInt']['output']>;
  contactDetailsId?: Maybe<Scalars['BigInt']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  creatorId?: Maybe<Scalars['BigInt']['output']>;
  encryptedPassword?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifyAboutVisits?: Maybe<Scalars['Boolean']['output']>;
  personalMessage?: Maybe<Scalars['String']['output']>;
  showContactDetails?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  trackingDeactivated?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `DocumentSpacesOldBak` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentSpacesOldBakCondition = {
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `contactDetailsId` field. */
  contactDetailsId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `notifyAboutVisits` field. */
  notifyAboutVisits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `showContactDetails` field. */
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `trackingDeactivated` field. */
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DocumentSpacesOldBak` object types. All fields are combined with a logical ‘and.’ */
export type DocumentSpacesOldBakFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentSpacesOldBakFilter>>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `contactDetailsId` field. */
  contactDetailsId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentSpacesOldBakFilter>;
  /** Filter by the object’s `notifyAboutVisits` field. */
  notifyAboutVisits?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentSpacesOldBakFilter>>;
  /** Filter by the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `showContactDetails` field. */
  showContactDetails?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `trackingDeactivated` field. */
  trackingDeactivated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentSpacesOldBak` */
export type DocumentSpacesOldBakInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  contactDetailsId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyAboutVisits?: InputMaybe<Scalars['Boolean']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `DocumentSpacesOldBak` values. */
export type DocumentSpacesOldBaksConnection = {
  __typename?: 'DocumentSpacesOldBaksConnection';
  /** A list of edges which contains the `DocumentSpacesOldBak` and cursor to aid in pagination. */
  edges: Array<DocumentSpacesOldBaksEdge>;
  /** A list of `DocumentSpacesOldBak` objects. */
  nodes: Array<Maybe<DocumentSpacesOldBak>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentSpacesOldBak` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentSpacesOldBak` edge in the connection. */
export type DocumentSpacesOldBaksEdge = {
  __typename?: 'DocumentSpacesOldBaksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentSpacesOldBak` at the end of the edge. */
  node?: Maybe<DocumentSpacesOldBak>;
};

/** Methods to use when ordering `DocumentSpacesOldBak`. */
export enum DocumentSpacesOldBaksOrderBy {
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  ConfigIdAsc = 'CONFIG_ID_ASC',
  ConfigIdDesc = 'CONFIG_ID_DESC',
  ContactDetailsIdAsc = 'CONTACT_DETAILS_ID_ASC',
  ContactDetailsIdDesc = 'CONTACT_DETAILS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorIdAsc = 'CREATOR_ID_ASC',
  CreatorIdDesc = 'CREATOR_ID_DESC',
  EncryptedPasswordAsc = 'ENCRYPTED_PASSWORD_ASC',
  EncryptedPasswordDesc = 'ENCRYPTED_PASSWORD_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NotifyAboutVisitsAsc = 'NOTIFY_ABOUT_VISITS_ASC',
  NotifyAboutVisitsDesc = 'NOTIFY_ABOUT_VISITS_DESC',
  PersonalMessageAsc = 'PERSONAL_MESSAGE_ASC',
  PersonalMessageDesc = 'PERSONAL_MESSAGE_DESC',
  ShowContactDetailsAsc = 'SHOW_CONTACT_DETAILS_ASC',
  ShowContactDetailsDesc = 'SHOW_CONTACT_DETAILS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TrackingDeactivatedAsc = 'TRACKING_DEACTIVATED_ASC',
  TrackingDeactivatedDesc = 'TRACKING_DEACTIVATED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Methods to use when ordering `DocumentSpace`. */
export enum DocumentSpacesOrderBy {
  AllowedEmailAddressesAsc = 'ALLOWED_EMAIL_ADDRESSES_ASC',
  AllowedEmailAddressesDesc = 'ALLOWED_EMAIL_ADDRESSES_DESC',
  CodeOnAccessCardAsc = 'CODE_ON_ACCESS_CARD_ASC',
  CodeOnAccessCardDesc = 'CODE_ON_ACCESS_CARD_DESC',
  CodeOnAccessCardLastUsedAtAsc = 'CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  CodeOnAccessCardLastUsedAtDesc = 'CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  ConfigIdAsc = 'CONFIG_ID_ASC',
  ConfigIdDesc = 'CONFIG_ID_DESC',
  ContactDetailsIdAsc = 'CONTACT_DETAILS_ID_ASC',
  ContactDetailsIdDesc = 'CONTACT_DETAILS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorIdAsc = 'CREATOR_ID_ASC',
  CreatorIdDesc = 'CREATOR_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdCountAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdCountDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxCreatorIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_CREATOR_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxCreatorIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_CREATOR_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxDisplayContactDetailsAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_DISPLAY_CONTACT_DETAILS_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxDisplayContactDetailsDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxRoleAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_ROLE_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxRoleDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_ROLE_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxUserIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_USER_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMaxUserIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MAX_USER_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinCreatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinCreatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinCreatorIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_CREATOR_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinCreatorIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_CREATOR_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinDisplayContactDetailsAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_DISPLAY_CONTACT_DETAILS_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinDisplayContactDetailsDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_ID_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinRoleAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_ROLE_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinRoleDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_ROLE_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceAccessesByDocumentSpaceIdMinUserIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_USER_ID_ASC',
  DocumentSpaceAccessesByDocumentSpaceIdMinUserIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_DOCUMENT_SPACE_ID__MIN_USER_ID_DESC',
  DocumentSpaceConfigByConfigIdContentTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_ASC',
  DocumentSpaceConfigByConfigIdContentTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CONTENT_TITLE_DESC',
  DocumentSpaceConfigByConfigIdCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_ASC',
  DocumentSpaceConfigByConfigIdCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CREATED_AT_DESC',
  DocumentSpaceConfigByConfigIdCustomCssAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_ASC',
  DocumentSpaceConfigByConfigIdCustomCssDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__CUSTOM_CSS_DESC',
  DocumentSpaceConfigByConfigIdDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigByConfigIdDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigByConfigIdDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_ASC',
  DocumentSpaceConfigByConfigIdDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_HERO_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigByConfigIdDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigByConfigIdDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigByConfigIdFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_ASC',
  DocumentSpaceConfigByConfigIdFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_LINKS_DESC',
  DocumentSpaceConfigByConfigIdFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_ASC',
  DocumentSpaceConfigByConfigIdFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__FOOTER_TEXT_DESC',
  DocumentSpaceConfigByConfigIdGroupIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_ASC',
  DocumentSpaceConfigByConfigIdGroupIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__GROUP_ID_DESC',
  DocumentSpaceConfigByConfigIdHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_ASC',
  DocumentSpaceConfigByConfigIdHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_LINK_URL_DESC',
  DocumentSpaceConfigByConfigIdHeroScalingAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_ASC',
  DocumentSpaceConfigByConfigIdHeroScalingDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SCALING_DESC',
  DocumentSpaceConfigByConfigIdHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_SUBTITLE_DESC',
  DocumentSpaceConfigByConfigIdHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_ASC',
  DocumentSpaceConfigByConfigIdHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__HERO_TITLE_DESC',
  DocumentSpaceConfigByConfigIdIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_ASC',
  DocumentSpaceConfigByConfigIdIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__ID_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_DESC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigByConfigIdLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigByConfigIdLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigByConfigIdLogoUrlAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_ASC',
  DocumentSpaceConfigByConfigIdLogoUrlDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__LOGO_URL_DESC',
  DocumentSpaceConfigByConfigIdNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_ASC',
  DocumentSpaceConfigByConfigIdNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NAME_DESC',
  DocumentSpaceConfigByConfigIdNewTabAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_ASC',
  DocumentSpaceConfigByConfigIdNewTabDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__NEW_TAB_DESC',
  DocumentSpaceConfigByConfigIdOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigByConfigIdOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigByConfigIdProductNameAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_ASC',
  DocumentSpaceConfigByConfigIdProductNameDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__PRODUCT_NAME_DESC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigByConfigIdRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigByConfigIdStylesheetAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_ASC',
  DocumentSpaceConfigByConfigIdStylesheetDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__STYLESHEET_DESC',
  DocumentSpaceConfigByConfigIdTeamIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_ASC',
  DocumentSpaceConfigByConfigIdTeamIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEAM_ID_DESC',
  DocumentSpaceConfigByConfigIdTemplateAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_ASC',
  DocumentSpaceConfigByConfigIdTemplateDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TEMPLATE_DESC',
  DocumentSpaceConfigByConfigIdTenantIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_ASC',
  DocumentSpaceConfigByConfigIdTenantIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TENANT_ID_DESC',
  DocumentSpaceConfigByConfigIdTitleAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_ASC',
  DocumentSpaceConfigByConfigIdTitleDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__TITLE_DESC',
  DocumentSpaceConfigByConfigIdUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_ASC',
  DocumentSpaceConfigByConfigIdUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_AT_DESC',
  DocumentSpaceConfigByConfigIdUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_ASC',
  DocumentSpaceConfigByConfigIdUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIG_BY_CONFIG_ID__UPDATED_BY_ID_DESC',
  DocumentSpaceCrmMappingByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceCrmMappingByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceCrmMappingByDocumentSpaceIdCrmContactIdAsc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__CRM_CONTACT_ID_ASC',
  DocumentSpaceCrmMappingByDocumentSpaceIdCrmContactIdDesc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__CRM_CONTACT_ID_DESC',
  DocumentSpaceCrmMappingByDocumentSpaceIdDocumentSpaceIdAsc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceCrmMappingByDocumentSpaceIdDocumentSpaceIdDesc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceCrmMappingByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceCrmMappingByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceCrmMappingByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceCrmMappingByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceCrmMappingByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceCrmMappingByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_CRM_MAPPING_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceItemsByDocumentSpaceIdCountAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  DocumentSpaceItemsByDocumentSpaceIdCountDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_ADDED_AT_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_ADDED_AT_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_FLOW_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_FLOW_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_POSITION_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_POSITION_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_SECTION_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_SECTION_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_ADDED_AT_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_ADDED_AT_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_FLOW_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_FLOW_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_POSITION_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_POSITION_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_SECTION_ID_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_SECTION_ID_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceItemsByDocumentSpaceIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceItemsByDocumentSpaceIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceLinksByDocumentSpaceIdCountAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  DocumentSpaceLinksByDocumentSpaceIdCountDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxConfigIdAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_CONFIG_ID_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxConfigIdDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_CONFIG_ID_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxIdAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_ID_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxIdDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_ID_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxIsMandatoryAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_IS_MANDATORY_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxIsMandatoryDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_IS_MANDATORY_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxPositionAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_POSITION_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxPositionDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_POSITION_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxSectionTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_SECTION_TITLE_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxSectionTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_SECTION_TITLE_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_TITLE_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_TITLE_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMaxUrlAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_URL_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMaxUrlDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MAX_URL_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinConfigIdAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_CONFIG_ID_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinConfigIdDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_CONFIG_ID_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinCreatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinCreatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinIdAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_ID_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinIdDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_ID_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinIsMandatoryAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_IS_MANDATORY_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinIsMandatoryDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_IS_MANDATORY_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinPositionAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_POSITION_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinPositionDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_POSITION_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinSectionTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_SECTION_TITLE_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinSectionTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_SECTION_TITLE_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinTitleAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_TITLE_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinTitleDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_TITLE_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceLinksByDocumentSpaceIdMinUrlAsc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_URL_ASC',
  DocumentSpaceLinksByDocumentSpaceIdMinUrlDesc = 'DOCUMENT_SPACE_LINKS_BY_DOCUMENT_SPACE_ID__MIN_URL_DESC',
  DocumentSpaceLinkMappingsBySpaceIdCountAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__COUNT_ASC',
  DocumentSpaceLinkMappingsBySpaceIdCountDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__COUNT_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMaxIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_ID_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMaxIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_ID_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMaxLinkIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_LINK_ID_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMaxLinkIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_LINK_ID_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMaxSpaceIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_SPACE_ID_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMaxSpaceIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MAX_SPACE_ID_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMinCreatedAtAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMinCreatedAtDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMinIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_ID_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMinIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_ID_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMinLinkIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_LINK_ID_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMinLinkIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_LINK_ID_DESC',
  DocumentSpaceLinkMappingsBySpaceIdMinSpaceIdAsc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_SPACE_ID_ASC',
  DocumentSpaceLinkMappingsBySpaceIdMinSpaceIdDesc = 'DOCUMENT_SPACE_LINK_MAPPINGS_BY_SPACE_ID__MIN_SPACE_ID_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdCountAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdCountDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxIdAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_ID_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxIdDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_ID_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxPositionAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_POSITION_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxPositionDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_POSITION_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxTitleAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_TITLE_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxTitleDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_TITLE_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinCreatedAtAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinCreatedAtDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinIdAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_ID_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinIdDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_ID_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinPositionAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_POSITION_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinPositionDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_POSITION_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinSysPeriodAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinSysPeriodDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinTitleAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_TITLE_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinTitleDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_TITLE_DESC',
  DocumentSpaceSectionsByDocumentSpaceIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceSectionsByDocumentSpaceIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_SECTIONS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdCountAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdCountDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxConsentGivenAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_CONSENT_GIVEN_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxConsentGivenDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_CONSENT_GIVEN_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxExpiresAtAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_EXPIRES_AT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxExpiresAtDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_EXPIRES_AT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxFingerprintAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_FINGERPRINT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxFingerprintDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_FINGERPRINT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMinConsentGivenAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_CONSENT_GIVEN_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMinConsentGivenDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_CONSENT_GIVEN_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMinCreatedAtAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMinCreatedAtDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMinExpiresAtAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_EXPIRES_AT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMinExpiresAtDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_EXPIRES_AT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMinFingerprintAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_FINGERPRINT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMinFingerprintDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_FINGERPRINT_DESC',
  DocumentSpaceSessionsByDocumentSpaceIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceSessionsByDocumentSpaceIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_SESSIONS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdDocumentSpaceIdAsc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdDocumentSpaceIdDesc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdFirstVisitAtAsc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__FIRST_VISIT_AT_ASC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdFirstVisitAtDesc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__FIRST_VISIT_AT_DESC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdLastVisitAtAsc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__LAST_VISIT_AT_ASC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdLastVisitAtDesc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__LAST_VISIT_AT_DESC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdVisitCountAsc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__VISIT_COUNT_ASC',
  DocumentSpaceVisitStatisticByDocumentSpaceIdVisitCountDesc = 'DOCUMENT_SPACE_VISIT_STATISTIC_BY_DOCUMENT_SPACE_ID__VISIT_COUNT_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdCountAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdCountDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxCampaignPhaseLinkIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_CAMPAIGN_PHASE_LINK_ID_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxCampaignPhaseLinkIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_CAMPAIGN_PHASE_LINK_ID_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxHashedSecretAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_HASHED_SECRET_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxHashedSecretDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_HASHED_SECRET_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxHashAlgorithmAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_HASH_ALGORITHM_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxHashAlgorithmDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_HASH_ALGORITHM_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_ID_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_ID_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxIsPreviewAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_IS_PREVIEW_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxIsPreviewDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_IS_PREVIEW_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxNameAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_NAME_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxNameDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_NAME_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxValidUntilAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_VALID_UNTIL_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMaxValidUntilDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MAX_VALID_UNTIL_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinCampaignPhaseLinkIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_CAMPAIGN_PHASE_LINK_ID_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinCampaignPhaseLinkIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_CAMPAIGN_PHASE_LINK_ID_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinCreatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinCreatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinHashedSecretAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_HASHED_SECRET_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinHashedSecretDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_HASHED_SECRET_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinHashAlgorithmAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_HASH_ALGORITHM_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinHashAlgorithmDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_HASH_ALGORITHM_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinIdAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_ID_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinIdDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_ID_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinIsPreviewAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_IS_PREVIEW_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinIsPreviewDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_IS_PREVIEW_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinNameAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_NAME_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinNameDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_NAME_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinSysPeriodAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinSysPeriodDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceVouchersByDocumentSpaceIdMinValidUntilAsc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_VALID_UNTIL_ASC',
  DocumentSpaceVouchersByDocumentSpaceIdMinValidUntilDesc = 'DOCUMENT_SPACE_VOUCHERS_BY_DOCUMENT_SPACE_ID__MIN_VALID_UNTIL_DESC',
  EncryptedPasswordAsc = 'ENCRYPTED_PASSWORD_ASC',
  EncryptedPasswordDesc = 'ENCRYPTED_PASSWORD_DESC',
  FirstVisitAtAsc = 'FIRST_VISIT_AT_ASC',
  FirstVisitAtDesc = 'FIRST_VISIT_AT_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdCountAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdCountDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxDetectedLanguageAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_DETECTED_LANGUAGE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxDetectedLanguageDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_DETECTED_LANGUAGE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfCrmContactAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_CRM_CONTACT_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfCrmContactDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_CRM_CONTACT_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfCrmContactHeadlineAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_CRM_CONTACT_HEADLINE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfCrmContactHeadlineDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_CRM_CONTACT_HEADLINE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfSpaceAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_SPACE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfSpaceDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_SPACE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfSpaceHeadlineAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_SPACE_HEADLINE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxNameOfSpaceHeadlineDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_NAME_OF_SPACE_HEADLINE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxPersonalMessageAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_PERSONAL_MESSAGE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxPersonalMessageDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_PERSONAL_MESSAGE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxPersonalMessageHeadlineAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_PERSONAL_MESSAGE_HEADLINE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxPersonalMessageHeadlineDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_PERSONAL_MESSAGE_HEADLINE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxTotalScoreAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_SCORE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMaxTotalScoreDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_SCORE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinDetectedLanguageAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_DETECTED_LANGUAGE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinDetectedLanguageDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_DETECTED_LANGUAGE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfCrmContactAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_CRM_CONTACT_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfCrmContactDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_CRM_CONTACT_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfCrmContactHeadlineAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_CRM_CONTACT_HEADLINE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfCrmContactHeadlineDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_CRM_CONTACT_HEADLINE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfSpaceAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_SPACE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfSpaceDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_SPACE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfSpaceHeadlineAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_SPACE_HEADLINE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinNameOfSpaceHeadlineDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_NAME_OF_SPACE_HEADLINE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinPersonalMessageAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_PERSONAL_MESSAGE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinPersonalMessageDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_PERSONAL_MESSAGE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinPersonalMessageHeadlineAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_PERSONAL_MESSAGE_HEADLINE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinPersonalMessageHeadlineDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_PERSONAL_MESSAGE_HEADLINE_DESC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinTotalScoreAsc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_SCORE_ASC',
  FtsDocumentSpaceHitsByDocumentSpaceIdMinTotalScoreDesc = 'FTS_DOCUMENT_SPACE_HITS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_SCORE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastVisitAtAsc = 'LAST_VISIT_AT_ASC',
  LastVisitAtDesc = 'LAST_VISIT_AT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdCountAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdCountDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxAverageConservativeDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxAverageConservativeDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxAverageDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxAverageDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxDisplayTitleAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DISPLAY_TITLE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxDisplayTitleDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DISPLAY_TITLE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxMaxConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxMaxConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxMaxDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxMaxDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxMimeTypeAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MIME_TYPE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxMimeTypeDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MIME_TYPE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxNumDownloadsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxNumDownloadsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxTotalConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxTotalConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxTotalDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMaxTotalDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinAverageConservativeDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinAverageConservativeDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinAverageDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinAverageDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinDisplayTitleAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DISPLAY_TITLE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinDisplayTitleDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DISPLAY_TITLE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinMaxConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinMaxConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinMaxDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinMaxDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinMimeTypeAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MIME_TYPE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinMimeTypeDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MIME_TYPE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinNumDownloadsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinNumDownloadsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinTotalConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinTotalConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinTotalDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentSpaceIdMinTotalDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdCountAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdCountDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMaxNumClicksAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_CLICKS_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMaxNumClicksDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_CLICKS_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMaxUrlAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_URL_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMaxUrlDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_URL_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMinNumClicksAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_CLICKS_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMinNumClicksDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_CLICKS_DESC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMinUrlAsc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_URL_ASC',
  MaDocumentSpaceLinkStatisticsByDocumentSpaceIdMinUrlDesc = 'MA_DOCUMENT_SPACE_LINK_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_URL_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdCountAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdCountDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxAverageConservativeDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxAverageConservativeDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxAverageDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxAverageDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxMaxConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxMaxConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxMaxDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxMaxDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxPageNumberAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_PAGE_NUMBER_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxPageNumberDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_PAGE_NUMBER_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxTotalConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxTotalConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxTotalDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMaxTotalDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinAverageConservativeDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinAverageConservativeDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinAverageDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinAverageDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinMaxConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinMaxConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinMaxDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinMaxDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinPageNumberAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_PAGE_NUMBER_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinPageNumberDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_PAGE_NUMBER_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinTotalConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinTotalConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinTotalDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdMinTotalDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpaceStatisticByDocumentSpaceIdAvgDurationAsc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__AVG_DURATION_ASC',
  MaDocumentSpaceStatisticByDocumentSpaceIdAvgDurationDesc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__AVG_DURATION_DESC',
  MaDocumentSpaceStatisticByDocumentSpaceIdDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceStatisticByDocumentSpaceIdDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceStatisticByDocumentSpaceIdNameAsc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  MaDocumentSpaceStatisticByDocumentSpaceIdNameDesc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  MaDocumentSpaceStatisticByDocumentSpaceIdNumDownloadsAsc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__NUM_DOWNLOADS_ASC',
  MaDocumentSpaceStatisticByDocumentSpaceIdNumDownloadsDesc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__NUM_DOWNLOADS_DESC',
  MaDocumentSpaceStatisticByDocumentSpaceIdNumLinkClicksAsc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__NUM_LINK_CLICKS_ASC',
  MaDocumentSpaceStatisticByDocumentSpaceIdNumLinkClicksDesc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__NUM_LINK_CLICKS_DESC',
  MaDocumentSpaceStatisticByDocumentSpaceIdTotalVisitsAsc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__TOTAL_VISITS_ASC',
  MaDocumentSpaceStatisticByDocumentSpaceIdTotalVisitsDesc = 'MA_DOCUMENT_SPACE_STATISTIC_BY_DOCUMENT_SPACE_ID__TOTAL_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdCountAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdCountDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__COUNT_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxAvgWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVG_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxAvgWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_AVG_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxDisplayTitleAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DISPLAY_TITLE_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxDisplayTitleDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DISPLAY_TITLE_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxMaxWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxMaxWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_MAX_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxNumDownloadsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxNumDownloadsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMaxThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinAvgWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVG_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinAvgWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_AVG_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinDisplayTitleAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DISPLAY_TITLE_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinDisplayTitleDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DISPLAY_TITLE_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinMaxWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinMaxWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_MAX_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinNumDownloadsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinNumDownloadsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentSpaceIdMinThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_SPACE_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameNullsLastAsc = 'NAME_NULLS_LAST_ASC',
  NameNullsLastDesc = 'NAME_NULLS_LAST_DESC',
  Natural = 'NATURAL',
  PersonalMessageAsc = 'PERSONAL_MESSAGE_ASC',
  PersonalMessageDesc = 'PERSONAL_MESSAGE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShowContactDetailsAsc = 'SHOW_CONTACT_DETAILS_ASC',
  ShowContactDetailsDesc = 'SHOW_CONTACT_DETAILS_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TrackingDeactivatedAsc = 'TRACKING_DEACTIVATED_ASC',
  TrackingDeactivatedDesc = 'TRACKING_DEACTIVATED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByCreatorIdAppConsentGivenAtAsc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByCreatorIdAppConsentGivenAtDesc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByCreatorIdConfigAsc = 'USER_BY_CREATOR_ID__CONFIG_ASC',
  UserByCreatorIdConfigDesc = 'USER_BY_CREATOR_ID__CONFIG_DESC',
  UserByCreatorIdCreatedAtAsc = 'USER_BY_CREATOR_ID__CREATED_AT_ASC',
  UserByCreatorIdCreatedAtDesc = 'USER_BY_CREATOR_ID__CREATED_AT_DESC',
  UserByCreatorIdCrmContactVisibilityFilterAsc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByCreatorIdCrmContactVisibilityFilterDesc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByCreatorIdDefaultWorkspaceIdAsc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByCreatorIdDefaultWorkspaceIdDesc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByCreatorIdDisabledAsc = 'USER_BY_CREATOR_ID__DISABLED_ASC',
  UserByCreatorIdDisabledDesc = 'USER_BY_CREATOR_ID__DISABLED_DESC',
  UserByCreatorIdDisplayNameAsc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_ASC',
  UserByCreatorIdDisplayNameDesc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_DESC',
  UserByCreatorIdEmailAsc = 'USER_BY_CREATOR_ID__EMAIL_ASC',
  UserByCreatorIdEmailDesc = 'USER_BY_CREATOR_ID__EMAIL_DESC',
  UserByCreatorIdExternalGroupsAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_ASC',
  UserByCreatorIdExternalGroupsDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_DESC',
  UserByCreatorIdExternalGroupsSyncedAtAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByCreatorIdExternalGroupsSyncedAtDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByCreatorIdFirebaseAuthIdAsc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_ASC',
  UserByCreatorIdFirebaseAuthIdDesc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_DESC',
  UserByCreatorIdFlagsAsc = 'USER_BY_CREATOR_ID__FLAGS_ASC',
  UserByCreatorIdFlagsDesc = 'USER_BY_CREATOR_ID__FLAGS_DESC',
  UserByCreatorIdIdAsc = 'USER_BY_CREATOR_ID__ID_ASC',
  UserByCreatorIdIdDesc = 'USER_BY_CREATOR_ID__ID_DESC',
  UserByCreatorIdIsTenantAdminAsc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_ASC',
  UserByCreatorIdIsTenantAdminDesc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_DESC',
  UserByCreatorIdRegisteredAtAsc = 'USER_BY_CREATOR_ID__REGISTERED_AT_ASC',
  UserByCreatorIdRegisteredAtDesc = 'USER_BY_CREATOR_ID__REGISTERED_AT_DESC',
  UserByCreatorIdSysPeriodAsc = 'USER_BY_CREATOR_ID__SYS_PERIOD_ASC',
  UserByCreatorIdSysPeriodDesc = 'USER_BY_CREATOR_ID__SYS_PERIOD_DESC',
  UserByCreatorIdTenantIdAsc = 'USER_BY_CREATOR_ID__TENANT_ID_ASC',
  UserByCreatorIdTenantIdDesc = 'USER_BY_CREATOR_ID__TENANT_ID_DESC',
  UserByCreatorIdUpdatedAtAsc = 'USER_BY_CREATOR_ID__UPDATED_AT_ASC',
  UserByCreatorIdUpdatedAtDesc = 'USER_BY_CREATOR_ID__UPDATED_AT_DESC',
  VisitCountAsc = 'VISIT_COUNT_ASC',
  VisitCountDesc = 'VISIT_COUNT_DESC'
}

export type DocumentStatistic = {
  __typename?: 'DocumentStatistic';
  displayTitle?: Maybe<Scalars['String']['output']>;
  docId?: Maybe<Scalars['Int']['output']>;
  numDownloads?: Maybe<Scalars['BigFloat']['output']>;
  numViews?: Maybe<Scalars['BigFloat']['output']>;
  score?: Maybe<Scalars['BigFloat']['output']>;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `DocumentStatistic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentStatisticCondition = {
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `docId` field. */
  docId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `numViews` field. */
  numViews?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DocumentStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentStatisticFilter>>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `docId` field. */
  docId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentStatisticFilter>;
  /** Filter by the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `numViews` field. */
  numViews?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentStatisticFilter>>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
};

/** A connection to a list of `DocumentStatistic` values. */
export type DocumentStatisticsConnection = {
  __typename?: 'DocumentStatisticsConnection';
  /** A list of edges which contains the `DocumentStatistic` and cursor to aid in pagination. */
  edges: Array<DocumentStatisticsEdge>;
  /** A list of `DocumentStatistic` objects. */
  nodes: Array<Maybe<DocumentStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentStatistic` edge in the connection. */
export type DocumentStatisticsEdge = {
  __typename?: 'DocumentStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentStatistic` at the end of the edge. */
  node?: Maybe<DocumentStatistic>;
};

/** Methods to use when ordering `DocumentStatistic`. */
export enum DocumentStatisticsOrderBy {
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocIdAsc = 'DOC_ID_ASC',
  DocIdDesc = 'DOC_ID_DESC',
  Natural = 'NATURAL',
  NumDownloadsAsc = 'NUM_DOWNLOADS_ASC',
  NumDownloadsDesc = 'NUM_DOWNLOADS_DESC',
  NumViewsAsc = 'NUM_VIEWS_ASC',
  NumViewsDesc = 'NUM_VIEWS_DESC',
  ScoreAsc = 'SCORE_ASC',
  ScoreDesc = 'SCORE_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC'
}

/** A filter to be used against many `Document` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentFilter = {
  /** Every related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFilter>;
  /** No related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFilter>;
  /** Some related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFilter>;
};

/** A filter to be used against many `DocumentHistoryEntry` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentHistoryEntryFilter = {
  /** Every related `DocumentHistoryEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentHistoryEntryFilter>;
  /** No related `DocumentHistoryEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentHistoryEntryFilter>;
  /** Some related `DocumentHistoryEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentHistoryEntryFilter>;
};

/** A filter to be used against many `DocumentPage` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentPageFilter = {
  /** Every related `DocumentPage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentPageFilter>;
  /** No related `DocumentPage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentPageFilter>;
  /** Some related `DocumentPage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentPageFilter>;
};

/** A filter to be used against many `DocumentPageMatching` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentPageMatchingFilter = {
  /** Every related `DocumentPageMatching` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentPageMatchingFilter>;
  /** No related `DocumentPageMatching` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentPageMatchingFilter>;
  /** Some related `DocumentPageMatching` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentPageMatchingFilter>;
};

/** A filter to be used against many `DocumentProcess` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentProcessFilter = {
  /** Every related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentProcessFilter>;
  /** No related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentProcessFilter>;
  /** Some related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentProcessFilter>;
};

/** A filter to be used against many `DocumentRevision` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentRevisionFilter = {
  /** Every related `DocumentRevision` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentRevisionFilter>;
  /** No related `DocumentRevision` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentRevisionFilter>;
  /** Some related `DocumentRevision` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentRevisionFilter>;
};

/** A filter to be used against many `DocumentSpaceItem` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyDocumentSpaceItemFilter = {
  /** Every related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceItemFilter>;
  /** No related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceItemFilter>;
  /** Some related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceItemFilter>;
};

/** A filter to be used against many `FlowItem` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyFlowItemFilter = {
  /** Every related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowItemFilter>;
  /** No related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowItemFilter>;
  /** Some related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowItemFilter>;
};

/** A filter to be used against many `FtsDocumentHit` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyFtsDocumentHitFilter = {
  /** Every related `FtsDocumentHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FtsDocumentHitFilter>;
  /** No related `FtsDocumentHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FtsDocumentHitFilter>;
  /** Some related `FtsDocumentHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FtsDocumentHitFilter>;
};

/** A filter to be used against many `MaDocumentSpaceDocumentStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyMaDocumentSpaceDocumentStatisticFilter = {
  /** Every related `MaDocumentSpaceDocumentStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  /** No related `MaDocumentSpaceDocumentStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  /** Some related `MaDocumentSpaceDocumentStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
};

/** A filter to be used against many `MaDocumentSpacePageStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyMaDocumentSpacePageStatisticFilter = {
  /** Every related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** No related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** Some related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
};

/** A filter to be used against many `MaDocumentSpaceVideoStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyMaDocumentSpaceVideoStatisticFilter = {
  /** Every related `MaDocumentSpaceVideoStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  /** No related `MaDocumentSpaceVideoStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  /** Some related `MaDocumentSpaceVideoStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
};

/** A filter to be used against many `UrlBasedDocumentImport` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyUrlBasedDocumentImportFilter = {
  /** Every related `UrlBasedDocumentImport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UrlBasedDocumentImportFilter>;
  /** No related `UrlBasedDocumentImport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UrlBasedDocumentImportFilter>;
  /** Some related `UrlBasedDocumentImport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UrlBasedDocumentImportFilter>;
};

/** A filter to be used against many `Workspace` object types. All fields are combined with a logical ‘and.’ */
export type DocumentToManyWorkspaceFilter = {
  /** Every related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceFilter>;
  /** No related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceFilter>;
  /** Some related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceFilter>;
};

/** The return type of our `documentUsageCounts` query. */
export type DocumentUsageCountsRecord = {
  __typename?: 'DocumentUsageCountsRecord';
  numCustomFlows?: Maybe<Scalars['Int']['output']>;
  numPresentations?: Maybe<Scalars['Int']['output']>;
  numSpaces?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` values. */
export type DocumentsAvgWatchTimeInPresentationsOverTimeConnection = {
  __typename?: 'DocumentsAvgWatchTimeInPresentationsOverTimeConnection';
  /** A list of edges which contains the `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` and cursor to aid in pagination. */
  edges: Array<DocumentsAvgWatchTimeInPresentationsOverTimeEdge>;
  /** A list of `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` objects. */
  nodes: Array<Maybe<DocumentsAvgWatchTimeInPresentationsOverTimeRecord>>;
  /** The count of *all* `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` edge in the connection. */
export type DocumentsAvgWatchTimeInPresentationsOverTimeEdge = {
  __typename?: 'DocumentsAvgWatchTimeInPresentationsOverTimeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` at the end of the edge. */
  node?: Maybe<DocumentsAvgWatchTimeInPresentationsOverTimeRecord>;
};

/** The return type of our `avgWatchTimeInPresentationsOverTime` query. */
export type DocumentsAvgWatchTimeInPresentationsOverTimeRecord = {
  __typename?: 'DocumentsAvgWatchTimeInPresentationsOverTimeRecord';
  avgWatchTimeInSeconds?: Maybe<Scalars['Float']['output']>;
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  startsAt?: Maybe<Scalars['Datetime']['output']>;
};

/** A filter to be used against `DocumentsAvgWatchTimeInPresentationsOverTimeRecord` object types. All fields are combined with a logical ‘and.’ */
export type DocumentsAvgWatchTimeInPresentationsOverTimeRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentsAvgWatchTimeInPresentationsOverTimeRecordFilter>>;
  /** Filter by the object’s `avgWatchTimeInSeconds` field. */
  avgWatchTimeInSeconds?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentsAvgWatchTimeInPresentationsOverTimeRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentsAvgWatchTimeInPresentationsOverTimeRecordFilter>>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `Document` values. */
export type DocumentsConnection = {
  __typename?: 'DocumentsConnection';
  /** A list of edges which contains the `Document` and cursor to aid in pagination. */
  edges: Array<DocumentsEdge>;
  /** A list of `Document` objects. */
  nodes: Array<Maybe<Document>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Document` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Document` edge in the connection. */
export type DocumentsEdge = {
  __typename?: 'DocumentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Document` at the end of the edge. */
  node?: Maybe<Document>;
};

/** Methods to use when ordering `Document`. */
export enum DocumentsOrderBy {
  AllowUserDownloadAsc = 'ALLOW_USER_DOWNLOAD_ASC',
  AllowUserDownloadDesc = 'ALLOW_USER_DOWNLOAD_DESC',
  ConfigAsc = 'CONFIG_ASC',
  ConfigDesc = 'CONFIG_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  CurrentRevisionNumberAsc = 'CURRENT_REVISION_NUMBER_ASC',
  CurrentRevisionNumberDesc = 'CURRENT_REVISION_NUMBER_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DisplayDateAsc = 'DISPLAY_DATE_ASC',
  DisplayDateDesc = 'DISPLAY_DATE_DESC',
  DisplayTeaserTextInSpaceAsc = 'DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DisplayTeaserTextInSpaceDesc = 'DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocumentsByLegalAppendixIdCountAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__COUNT_ASC',
  DocumentsByLegalAppendixIdCountDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__COUNT_DESC',
  DocumentsByLegalAppendixIdMaxConfigAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CONFIG_ASC',
  DocumentsByLegalAppendixIdMaxConfigDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CONFIG_DESC',
  DocumentsByLegalAppendixIdMaxCreatedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CREATED_AT_ASC',
  DocumentsByLegalAppendixIdMaxCreatedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CREATED_AT_DESC',
  DocumentsByLegalAppendixIdMaxCreatedByIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CREATED_BY_ID_ASC',
  DocumentsByLegalAppendixIdMaxCreatedByIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CREATED_BY_ID_DESC',
  DocumentsByLegalAppendixIdMaxCurrentRevisionNumberAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByLegalAppendixIdMaxCurrentRevisionNumberDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByLegalAppendixIdMaxDeletedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DELETED_AT_ASC',
  DocumentsByLegalAppendixIdMaxDeletedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DELETED_AT_DESC',
  DocumentsByLegalAppendixIdMaxDisplayDateAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DISPLAY_DATE_ASC',
  DocumentsByLegalAppendixIdMaxDisplayDateDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DISPLAY_DATE_DESC',
  DocumentsByLegalAppendixIdMaxDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByLegalAppendixIdMaxDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByLegalAppendixIdMaxDisplayTitleAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DISPLAY_TITLE_ASC',
  DocumentsByLegalAppendixIdMaxDisplayTitleDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DISPLAY_TITLE_DESC',
  DocumentsByLegalAppendixIdMaxDoesSupportFlowsAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByLegalAppendixIdMaxDoesSupportFlowsDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByLegalAppendixIdMaxDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByLegalAppendixIdMaxDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByLegalAppendixIdMaxDownloadUrlAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DOWNLOAD_URL_ASC',
  DocumentsByLegalAppendixIdMaxDownloadUrlDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_DOWNLOAD_URL_DESC',
  DocumentsByLegalAppendixIdMaxEnableMagicPagesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByLegalAppendixIdMaxEnableMagicPagesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByLegalAppendixIdMaxExpirationDateAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_EXPIRATION_DATE_ASC',
  DocumentsByLegalAppendixIdMaxExpirationDateDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_EXPIRATION_DATE_DESC',
  DocumentsByLegalAppendixIdMaxExternalIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_EXTERNAL_ID_ASC',
  DocumentsByLegalAppendixIdMaxExternalIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_EXTERNAL_ID_DESC',
  DocumentsByLegalAppendixIdMaxExternalLinkIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_EXTERNAL_LINK_ID_ASC',
  DocumentsByLegalAppendixIdMaxExternalLinkIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_EXTERNAL_LINK_ID_DESC',
  DocumentsByLegalAppendixIdMaxFileNameAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_FILE_NAME_ASC',
  DocumentsByLegalAppendixIdMaxFileNameDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_FILE_NAME_DESC',
  DocumentsByLegalAppendixIdMaxFileSizeAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_FILE_SIZE_ASC',
  DocumentsByLegalAppendixIdMaxFileSizeDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_FILE_SIZE_DESC',
  DocumentsByLegalAppendixIdMaxFirestoreIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_FIRESTORE_ID_ASC',
  DocumentsByLegalAppendixIdMaxFirestoreIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_FIRESTORE_ID_DESC',
  DocumentsByLegalAppendixIdMaxIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ID_ASC',
  DocumentsByLegalAppendixIdMaxIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ID_DESC',
  DocumentsByLegalAppendixIdMaxIgnoredPagesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_IGNORED_PAGES_ASC',
  DocumentsByLegalAppendixIdMaxIgnoredPagesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_IGNORED_PAGES_DESC',
  DocumentsByLegalAppendixIdMaxInitialFileNameAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_INITIAL_FILE_NAME_ASC',
  DocumentsByLegalAppendixIdMaxInitialFileNameDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_INITIAL_FILE_NAME_DESC',
  DocumentsByLegalAppendixIdMaxInternalLinksAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_INTERNAL_LINKS_ASC',
  DocumentsByLegalAppendixIdMaxInternalLinksDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_INTERNAL_LINKS_DESC',
  DocumentsByLegalAppendixIdMaxIsDownloadableAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_IS_DOWNLOADABLE_ASC',
  DocumentsByLegalAppendixIdMaxIsDownloadableDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_IS_DOWNLOADABLE_DESC',
  DocumentsByLegalAppendixIdMaxIsPublishedAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_IS_PUBLISHED_ASC',
  DocumentsByLegalAppendixIdMaxIsPublishedDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_IS_PUBLISHED_DESC',
  DocumentsByLegalAppendixIdMaxLastModifiedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LAST_MODIFIED_AT_ASC',
  DocumentsByLegalAppendixIdMaxLastModifiedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LAST_MODIFIED_AT_DESC',
  DocumentsByLegalAppendixIdMaxLastModifiedByIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByLegalAppendixIdMaxLastModifiedByIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByLegalAppendixIdMaxLegalAppendixIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LEGAL_APPENDIX_ID_ASC',
  DocumentsByLegalAppendixIdMaxLegalAppendixIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LEGAL_APPENDIX_ID_DESC',
  DocumentsByLegalAppendixIdMaxLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByLegalAppendixIdMaxLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByLegalAppendixIdMaxLiteratureReferencesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LITERATURE_REFERENCES_ASC',
  DocumentsByLegalAppendixIdMaxLiteratureReferencesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_LITERATURE_REFERENCES_DESC',
  DocumentsByLegalAppendixIdMaxMimeTypeAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_MIME_TYPE_ASC',
  DocumentsByLegalAppendixIdMaxMimeTypeDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_MIME_TYPE_DESC',
  DocumentsByLegalAppendixIdMaxOrderAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORDER_ASC',
  DocumentsByLegalAppendixIdMaxOrderDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORDER_DESC',
  DocumentsByLegalAppendixIdMaxOriginalDownloadUrlAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByLegalAppendixIdMaxOriginalDownloadUrlDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByLegalAppendixIdMaxOriginalMimeTypeAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByLegalAppendixIdMaxOriginalMimeTypeDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByLegalAppendixIdMaxOriginalStorageIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByLegalAppendixIdMaxOriginalStorageIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByLegalAppendixIdMaxPagesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_PAGES_ASC',
  DocumentsByLegalAppendixIdMaxPagesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_PAGES_DESC',
  DocumentsByLegalAppendixIdMaxStorageIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_STORAGE_ID_ASC',
  DocumentsByLegalAppendixIdMaxStorageIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_STORAGE_ID_DESC',
  DocumentsByLegalAppendixIdMaxSysPeriodAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_SYS_PERIOD_ASC',
  DocumentsByLegalAppendixIdMaxSysPeriodDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_SYS_PERIOD_DESC',
  DocumentsByLegalAppendixIdMaxTagsAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_TAGS_ASC',
  DocumentsByLegalAppendixIdMaxTagsDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_TAGS_DESC',
  DocumentsByLegalAppendixIdMaxTeaserTextAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_TEASER_TEXT_ASC',
  DocumentsByLegalAppendixIdMaxTeaserTextDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_TEASER_TEXT_DESC',
  DocumentsByLegalAppendixIdMaxThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByLegalAppendixIdMaxThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByLegalAppendixIdMaxThumbnailStorageIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByLegalAppendixIdMaxThumbnailStorageIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByLegalAppendixIdMaxTopTitleAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_TOP_TITLE_ASC',
  DocumentsByLegalAppendixIdMaxTopTitleDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_TOP_TITLE_DESC',
  DocumentsByLegalAppendixIdMaxUploadedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_UPLOADED_AT_ASC',
  DocumentsByLegalAppendixIdMaxUploadedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_UPLOADED_AT_DESC',
  DocumentsByLegalAppendixIdMaxWorkspaceIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_WORKSPACE_ID_ASC',
  DocumentsByLegalAppendixIdMaxWorkspaceIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MAX_WORKSPACE_ID_DESC',
  DocumentsByLegalAppendixIdMinConfigAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CONFIG_ASC',
  DocumentsByLegalAppendixIdMinConfigDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CONFIG_DESC',
  DocumentsByLegalAppendixIdMinCreatedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CREATED_AT_ASC',
  DocumentsByLegalAppendixIdMinCreatedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CREATED_AT_DESC',
  DocumentsByLegalAppendixIdMinCreatedByIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CREATED_BY_ID_ASC',
  DocumentsByLegalAppendixIdMinCreatedByIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CREATED_BY_ID_DESC',
  DocumentsByLegalAppendixIdMinCurrentRevisionNumberAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByLegalAppendixIdMinCurrentRevisionNumberDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByLegalAppendixIdMinDeletedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DELETED_AT_ASC',
  DocumentsByLegalAppendixIdMinDeletedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DELETED_AT_DESC',
  DocumentsByLegalAppendixIdMinDisplayDateAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DISPLAY_DATE_ASC',
  DocumentsByLegalAppendixIdMinDisplayDateDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DISPLAY_DATE_DESC',
  DocumentsByLegalAppendixIdMinDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByLegalAppendixIdMinDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByLegalAppendixIdMinDisplayTitleAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DISPLAY_TITLE_ASC',
  DocumentsByLegalAppendixIdMinDisplayTitleDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DISPLAY_TITLE_DESC',
  DocumentsByLegalAppendixIdMinDoesSupportFlowsAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByLegalAppendixIdMinDoesSupportFlowsDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByLegalAppendixIdMinDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByLegalAppendixIdMinDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByLegalAppendixIdMinDownloadUrlAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DOWNLOAD_URL_ASC',
  DocumentsByLegalAppendixIdMinDownloadUrlDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_DOWNLOAD_URL_DESC',
  DocumentsByLegalAppendixIdMinEnableMagicPagesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByLegalAppendixIdMinEnableMagicPagesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByLegalAppendixIdMinExpirationDateAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_EXPIRATION_DATE_ASC',
  DocumentsByLegalAppendixIdMinExpirationDateDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_EXPIRATION_DATE_DESC',
  DocumentsByLegalAppendixIdMinExternalIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_EXTERNAL_ID_ASC',
  DocumentsByLegalAppendixIdMinExternalIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_EXTERNAL_ID_DESC',
  DocumentsByLegalAppendixIdMinExternalLinkIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_EXTERNAL_LINK_ID_ASC',
  DocumentsByLegalAppendixIdMinExternalLinkIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_EXTERNAL_LINK_ID_DESC',
  DocumentsByLegalAppendixIdMinFileNameAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_FILE_NAME_ASC',
  DocumentsByLegalAppendixIdMinFileNameDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_FILE_NAME_DESC',
  DocumentsByLegalAppendixIdMinFileSizeAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_FILE_SIZE_ASC',
  DocumentsByLegalAppendixIdMinFileSizeDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_FILE_SIZE_DESC',
  DocumentsByLegalAppendixIdMinFirestoreIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_FIRESTORE_ID_ASC',
  DocumentsByLegalAppendixIdMinFirestoreIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_FIRESTORE_ID_DESC',
  DocumentsByLegalAppendixIdMinIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ID_ASC',
  DocumentsByLegalAppendixIdMinIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ID_DESC',
  DocumentsByLegalAppendixIdMinIgnoredPagesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_IGNORED_PAGES_ASC',
  DocumentsByLegalAppendixIdMinIgnoredPagesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_IGNORED_PAGES_DESC',
  DocumentsByLegalAppendixIdMinInitialFileNameAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_INITIAL_FILE_NAME_ASC',
  DocumentsByLegalAppendixIdMinInitialFileNameDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_INITIAL_FILE_NAME_DESC',
  DocumentsByLegalAppendixIdMinInternalLinksAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_INTERNAL_LINKS_ASC',
  DocumentsByLegalAppendixIdMinInternalLinksDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_INTERNAL_LINKS_DESC',
  DocumentsByLegalAppendixIdMinIsDownloadableAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_IS_DOWNLOADABLE_ASC',
  DocumentsByLegalAppendixIdMinIsDownloadableDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_IS_DOWNLOADABLE_DESC',
  DocumentsByLegalAppendixIdMinIsPublishedAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_IS_PUBLISHED_ASC',
  DocumentsByLegalAppendixIdMinIsPublishedDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_IS_PUBLISHED_DESC',
  DocumentsByLegalAppendixIdMinLastModifiedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LAST_MODIFIED_AT_ASC',
  DocumentsByLegalAppendixIdMinLastModifiedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LAST_MODIFIED_AT_DESC',
  DocumentsByLegalAppendixIdMinLastModifiedByIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByLegalAppendixIdMinLastModifiedByIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByLegalAppendixIdMinLegalAppendixIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LEGAL_APPENDIX_ID_ASC',
  DocumentsByLegalAppendixIdMinLegalAppendixIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LEGAL_APPENDIX_ID_DESC',
  DocumentsByLegalAppendixIdMinLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByLegalAppendixIdMinLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByLegalAppendixIdMinLiteratureReferencesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LITERATURE_REFERENCES_ASC',
  DocumentsByLegalAppendixIdMinLiteratureReferencesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_LITERATURE_REFERENCES_DESC',
  DocumentsByLegalAppendixIdMinMimeTypeAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_MIME_TYPE_ASC',
  DocumentsByLegalAppendixIdMinMimeTypeDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_MIME_TYPE_DESC',
  DocumentsByLegalAppendixIdMinOrderAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORDER_ASC',
  DocumentsByLegalAppendixIdMinOrderDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORDER_DESC',
  DocumentsByLegalAppendixIdMinOriginalDownloadUrlAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByLegalAppendixIdMinOriginalDownloadUrlDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByLegalAppendixIdMinOriginalMimeTypeAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByLegalAppendixIdMinOriginalMimeTypeDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByLegalAppendixIdMinOriginalStorageIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByLegalAppendixIdMinOriginalStorageIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByLegalAppendixIdMinPagesAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_PAGES_ASC',
  DocumentsByLegalAppendixIdMinPagesDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_PAGES_DESC',
  DocumentsByLegalAppendixIdMinStorageIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_STORAGE_ID_ASC',
  DocumentsByLegalAppendixIdMinStorageIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_STORAGE_ID_DESC',
  DocumentsByLegalAppendixIdMinSysPeriodAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_SYS_PERIOD_ASC',
  DocumentsByLegalAppendixIdMinSysPeriodDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_SYS_PERIOD_DESC',
  DocumentsByLegalAppendixIdMinTagsAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_TAGS_ASC',
  DocumentsByLegalAppendixIdMinTagsDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_TAGS_DESC',
  DocumentsByLegalAppendixIdMinTeaserTextAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_TEASER_TEXT_ASC',
  DocumentsByLegalAppendixIdMinTeaserTextDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_TEASER_TEXT_DESC',
  DocumentsByLegalAppendixIdMinThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByLegalAppendixIdMinThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByLegalAppendixIdMinThumbnailStorageIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByLegalAppendixIdMinThumbnailStorageIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByLegalAppendixIdMinTopTitleAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_TOP_TITLE_ASC',
  DocumentsByLegalAppendixIdMinTopTitleDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_TOP_TITLE_DESC',
  DocumentsByLegalAppendixIdMinUploadedAtAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_UPLOADED_AT_ASC',
  DocumentsByLegalAppendixIdMinUploadedAtDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_UPLOADED_AT_DESC',
  DocumentsByLegalAppendixIdMinWorkspaceIdAsc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_WORKSPACE_ID_ASC',
  DocumentsByLegalAppendixIdMinWorkspaceIdDesc = 'DOCUMENTS_BY_LEGAL_APPENDIX_ID__MIN_WORKSPACE_ID_DESC',
  DocumentByLegalAppendixIdConfigAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CONFIG_ASC',
  DocumentByLegalAppendixIdConfigDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CONFIG_DESC',
  DocumentByLegalAppendixIdCreatedAtAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CREATED_AT_ASC',
  DocumentByLegalAppendixIdCreatedAtDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CREATED_AT_DESC',
  DocumentByLegalAppendixIdCreatedByIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CREATED_BY_ID_ASC',
  DocumentByLegalAppendixIdCreatedByIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CREATED_BY_ID_DESC',
  DocumentByLegalAppendixIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByLegalAppendixIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByLegalAppendixIdDeletedAtAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DELETED_AT_ASC',
  DocumentByLegalAppendixIdDeletedAtDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DELETED_AT_DESC',
  DocumentByLegalAppendixIdDisplayDateAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DISPLAY_DATE_ASC',
  DocumentByLegalAppendixIdDisplayDateDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DISPLAY_DATE_DESC',
  DocumentByLegalAppendixIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByLegalAppendixIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByLegalAppendixIdDisplayTitleAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DISPLAY_TITLE_ASC',
  DocumentByLegalAppendixIdDisplayTitleDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DISPLAY_TITLE_DESC',
  DocumentByLegalAppendixIdDoesSupportFlowsAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByLegalAppendixIdDoesSupportFlowsDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByLegalAppendixIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByLegalAppendixIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByLegalAppendixIdDownloadUrlAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DOWNLOAD_URL_ASC',
  DocumentByLegalAppendixIdDownloadUrlDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__DOWNLOAD_URL_DESC',
  DocumentByLegalAppendixIdEnableMagicPagesAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByLegalAppendixIdEnableMagicPagesDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByLegalAppendixIdExpirationDateAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__EXPIRATION_DATE_ASC',
  DocumentByLegalAppendixIdExpirationDateDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__EXPIRATION_DATE_DESC',
  DocumentByLegalAppendixIdExternalIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__EXTERNAL_ID_ASC',
  DocumentByLegalAppendixIdExternalIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__EXTERNAL_ID_DESC',
  DocumentByLegalAppendixIdExternalLinkIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByLegalAppendixIdExternalLinkIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByLegalAppendixIdFileNameAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__FILE_NAME_ASC',
  DocumentByLegalAppendixIdFileNameDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__FILE_NAME_DESC',
  DocumentByLegalAppendixIdFileSizeAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__FILE_SIZE_ASC',
  DocumentByLegalAppendixIdFileSizeDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__FILE_SIZE_DESC',
  DocumentByLegalAppendixIdFirestoreIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__FIRESTORE_ID_ASC',
  DocumentByLegalAppendixIdFirestoreIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__FIRESTORE_ID_DESC',
  DocumentByLegalAppendixIdIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ID_ASC',
  DocumentByLegalAppendixIdIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ID_DESC',
  DocumentByLegalAppendixIdIgnoredPagesAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__IGNORED_PAGES_ASC',
  DocumentByLegalAppendixIdIgnoredPagesDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__IGNORED_PAGES_DESC',
  DocumentByLegalAppendixIdInitialFileNameAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__INITIAL_FILE_NAME_ASC',
  DocumentByLegalAppendixIdInitialFileNameDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__INITIAL_FILE_NAME_DESC',
  DocumentByLegalAppendixIdInternalLinksAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__INTERNAL_LINKS_ASC',
  DocumentByLegalAppendixIdInternalLinksDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__INTERNAL_LINKS_DESC',
  DocumentByLegalAppendixIdIsDownloadableAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__IS_DOWNLOADABLE_ASC',
  DocumentByLegalAppendixIdIsDownloadableDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__IS_DOWNLOADABLE_DESC',
  DocumentByLegalAppendixIdIsPublishedAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__IS_PUBLISHED_ASC',
  DocumentByLegalAppendixIdIsPublishedDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__IS_PUBLISHED_DESC',
  DocumentByLegalAppendixIdLastModifiedAtAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LAST_MODIFIED_AT_ASC',
  DocumentByLegalAppendixIdLastModifiedAtDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LAST_MODIFIED_AT_DESC',
  DocumentByLegalAppendixIdLastModifiedByIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByLegalAppendixIdLastModifiedByIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByLegalAppendixIdLegalAppendixIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByLegalAppendixIdLegalAppendixIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByLegalAppendixIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByLegalAppendixIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByLegalAppendixIdLiteratureReferencesAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LITERATURE_REFERENCES_ASC',
  DocumentByLegalAppendixIdLiteratureReferencesDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__LITERATURE_REFERENCES_DESC',
  DocumentByLegalAppendixIdMimeTypeAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__MIME_TYPE_ASC',
  DocumentByLegalAppendixIdMimeTypeDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__MIME_TYPE_DESC',
  DocumentByLegalAppendixIdOrderAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORDER_ASC',
  DocumentByLegalAppendixIdOrderDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORDER_DESC',
  DocumentByLegalAppendixIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByLegalAppendixIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByLegalAppendixIdOriginalMimeTypeAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByLegalAppendixIdOriginalMimeTypeDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByLegalAppendixIdOriginalStorageIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByLegalAppendixIdOriginalStorageIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByLegalAppendixIdPagesAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__PAGES_ASC',
  DocumentByLegalAppendixIdPagesDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__PAGES_DESC',
  DocumentByLegalAppendixIdStorageIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__STORAGE_ID_ASC',
  DocumentByLegalAppendixIdStorageIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__STORAGE_ID_DESC',
  DocumentByLegalAppendixIdSysPeriodAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__SYS_PERIOD_ASC',
  DocumentByLegalAppendixIdSysPeriodDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__SYS_PERIOD_DESC',
  DocumentByLegalAppendixIdTagsAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__TAGS_ASC',
  DocumentByLegalAppendixIdTagsDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__TAGS_DESC',
  DocumentByLegalAppendixIdTeaserTextAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__TEASER_TEXT_ASC',
  DocumentByLegalAppendixIdTeaserTextDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__TEASER_TEXT_DESC',
  DocumentByLegalAppendixIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByLegalAppendixIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByLegalAppendixIdThumbnailStorageIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByLegalAppendixIdThumbnailStorageIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByLegalAppendixIdTopTitleAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__TOP_TITLE_ASC',
  DocumentByLegalAppendixIdTopTitleDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__TOP_TITLE_DESC',
  DocumentByLegalAppendixIdUploadedAtAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__UPLOADED_AT_ASC',
  DocumentByLegalAppendixIdUploadedAtDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__UPLOADED_AT_DESC',
  DocumentByLegalAppendixIdWorkspaceIdAsc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__WORKSPACE_ID_ASC',
  DocumentByLegalAppendixIdWorkspaceIdDesc = 'DOCUMENT_BY_LEGAL_APPENDIX_ID__WORKSPACE_ID_DESC',
  DocumentExpirationByDocumentIdDocumentIdAsc = 'DOCUMENT_EXPIRATION_BY_DOCUMENT_ID__DOCUMENT_ID_ASC',
  DocumentExpirationByDocumentIdDocumentIdDesc = 'DOCUMENT_EXPIRATION_BY_DOCUMENT_ID__DOCUMENT_ID_DESC',
  DocumentExpirationByDocumentIdExpiredAtAsc = 'DOCUMENT_EXPIRATION_BY_DOCUMENT_ID__EXPIRED_AT_ASC',
  DocumentExpirationByDocumentIdExpiredAtDesc = 'DOCUMENT_EXPIRATION_BY_DOCUMENT_ID__EXPIRED_AT_DESC',
  DocumentHistoryEntriesByDocumentIdCountAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__COUNT_ASC',
  DocumentHistoryEntriesByDocumentIdCountDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__COUNT_DESC',
  DocumentHistoryEntriesByDocumentIdMaxActiveDurationAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_ACTIVE_DURATION_ASC',
  DocumentHistoryEntriesByDocumentIdMaxActiveDurationDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_ACTIVE_DURATION_DESC',
  DocumentHistoryEntriesByDocumentIdMaxDateAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_DATE_ASC',
  DocumentHistoryEntriesByDocumentIdMaxDateDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_DATE_DESC',
  DocumentHistoryEntriesByDocumentIdMaxDocumentIdAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentHistoryEntriesByDocumentIdMaxDocumentIdDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentHistoryEntriesByDocumentIdMaxDurationAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_DURATION_ASC',
  DocumentHistoryEntriesByDocumentIdMaxDurationDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_DURATION_DESC',
  DocumentHistoryEntriesByDocumentIdMaxEndsAtAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_ENDS_AT_ASC',
  DocumentHistoryEntriesByDocumentIdMaxEndsAtDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_ENDS_AT_DESC',
  DocumentHistoryEntriesByDocumentIdMaxIdAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_ID_ASC',
  DocumentHistoryEntriesByDocumentIdMaxIdDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_ID_DESC',
  DocumentHistoryEntriesByDocumentIdMaxRunIdAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_RUN_ID_ASC',
  DocumentHistoryEntriesByDocumentIdMaxRunIdDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_RUN_ID_DESC',
  DocumentHistoryEntriesByDocumentIdMaxStartsAtAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_STARTS_AT_ASC',
  DocumentHistoryEntriesByDocumentIdMaxStartsAtDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_STARTS_AT_DESC',
  DocumentHistoryEntriesByDocumentIdMaxTimeRangeAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_TIME_RANGE_ASC',
  DocumentHistoryEntriesByDocumentIdMaxTimeRangeDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MAX_TIME_RANGE_DESC',
  DocumentHistoryEntriesByDocumentIdMinActiveDurationAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_ACTIVE_DURATION_ASC',
  DocumentHistoryEntriesByDocumentIdMinActiveDurationDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_ACTIVE_DURATION_DESC',
  DocumentHistoryEntriesByDocumentIdMinDateAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_DATE_ASC',
  DocumentHistoryEntriesByDocumentIdMinDateDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_DATE_DESC',
  DocumentHistoryEntriesByDocumentIdMinDocumentIdAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentHistoryEntriesByDocumentIdMinDocumentIdDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentHistoryEntriesByDocumentIdMinDurationAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_DURATION_ASC',
  DocumentHistoryEntriesByDocumentIdMinDurationDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_DURATION_DESC',
  DocumentHistoryEntriesByDocumentIdMinEndsAtAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_ENDS_AT_ASC',
  DocumentHistoryEntriesByDocumentIdMinEndsAtDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_ENDS_AT_DESC',
  DocumentHistoryEntriesByDocumentIdMinIdAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_ID_ASC',
  DocumentHistoryEntriesByDocumentIdMinIdDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_ID_DESC',
  DocumentHistoryEntriesByDocumentIdMinRunIdAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_RUN_ID_ASC',
  DocumentHistoryEntriesByDocumentIdMinRunIdDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_RUN_ID_DESC',
  DocumentHistoryEntriesByDocumentIdMinStartsAtAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_STARTS_AT_ASC',
  DocumentHistoryEntriesByDocumentIdMinStartsAtDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_STARTS_AT_DESC',
  DocumentHistoryEntriesByDocumentIdMinTimeRangeAsc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_TIME_RANGE_ASC',
  DocumentHistoryEntriesByDocumentIdMinTimeRangeDesc = 'DOCUMENT_HISTORY_ENTRIES_BY_DOCUMENT_ID__MIN_TIME_RANGE_DESC',
  DocumentPagesByDocumentIdCountAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__COUNT_ASC',
  DocumentPagesByDocumentIdCountDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__COUNT_DESC',
  DocumentPagesByDocumentIdMaxCreatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_CREATED_AT_ASC',
  DocumentPagesByDocumentIdMaxCreatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_CREATED_AT_DESC',
  DocumentPagesByDocumentIdMaxCrossRevIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_CROSS_REV_ID_ASC',
  DocumentPagesByDocumentIdMaxCrossRevIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_CROSS_REV_ID_DESC',
  DocumentPagesByDocumentIdMaxDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdMaxDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdMaxExtractedTextAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_EXTRACTED_TEXT_ASC',
  DocumentPagesByDocumentIdMaxExtractedTextDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_EXTRACTED_TEXT_DESC',
  DocumentPagesByDocumentIdMaxIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_ID_ASC',
  DocumentPagesByDocumentIdMaxIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_ID_DESC',
  DocumentPagesByDocumentIdMaxLinkedDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_LINKED_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdMaxLinkedDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_LINKED_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdMaxPageNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_PAGE_NUMBER_ASC',
  DocumentPagesByDocumentIdMaxPageNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_PAGE_NUMBER_DESC',
  DocumentPagesByDocumentIdMaxPageTypeAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_PAGE_TYPE_ASC',
  DocumentPagesByDocumentIdMaxPageTypeDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_PAGE_TYPE_DESC',
  DocumentPagesByDocumentIdMaxRevisionNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_REVISION_NUMBER_ASC',
  DocumentPagesByDocumentIdMaxRevisionNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_REVISION_NUMBER_DESC',
  DocumentPagesByDocumentIdMaxThumbnailAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_THUMBNAIL_ASC',
  DocumentPagesByDocumentIdMaxThumbnailDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_THUMBNAIL_DESC',
  DocumentPagesByDocumentIdMaxUpdatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_UPDATED_AT_ASC',
  DocumentPagesByDocumentIdMaxUpdatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MAX_UPDATED_AT_DESC',
  DocumentPagesByDocumentIdMinCreatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_CREATED_AT_ASC',
  DocumentPagesByDocumentIdMinCreatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_CREATED_AT_DESC',
  DocumentPagesByDocumentIdMinCrossRevIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_CROSS_REV_ID_ASC',
  DocumentPagesByDocumentIdMinCrossRevIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_CROSS_REV_ID_DESC',
  DocumentPagesByDocumentIdMinDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdMinDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdMinExtractedTextAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_EXTRACTED_TEXT_ASC',
  DocumentPagesByDocumentIdMinExtractedTextDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_EXTRACTED_TEXT_DESC',
  DocumentPagesByDocumentIdMinIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_ID_ASC',
  DocumentPagesByDocumentIdMinIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_ID_DESC',
  DocumentPagesByDocumentIdMinLinkedDocumentIdAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_LINKED_DOCUMENT_ID_ASC',
  DocumentPagesByDocumentIdMinLinkedDocumentIdDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_LINKED_DOCUMENT_ID_DESC',
  DocumentPagesByDocumentIdMinPageNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_PAGE_NUMBER_ASC',
  DocumentPagesByDocumentIdMinPageNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_PAGE_NUMBER_DESC',
  DocumentPagesByDocumentIdMinPageTypeAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_PAGE_TYPE_ASC',
  DocumentPagesByDocumentIdMinPageTypeDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_PAGE_TYPE_DESC',
  DocumentPagesByDocumentIdMinRevisionNumberAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_REVISION_NUMBER_ASC',
  DocumentPagesByDocumentIdMinRevisionNumberDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_REVISION_NUMBER_DESC',
  DocumentPagesByDocumentIdMinThumbnailAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_THUMBNAIL_ASC',
  DocumentPagesByDocumentIdMinThumbnailDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_THUMBNAIL_DESC',
  DocumentPagesByDocumentIdMinUpdatedAtAsc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_UPDATED_AT_ASC',
  DocumentPagesByDocumentIdMinUpdatedAtDesc = 'DOCUMENT_PAGES_BY_DOCUMENT_ID__MIN_UPDATED_AT_DESC',
  DocumentPagesByLinkedDocumentIdCountAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__COUNT_ASC',
  DocumentPagesByLinkedDocumentIdCountDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__COUNT_DESC',
  DocumentPagesByLinkedDocumentIdMaxCreatedAtAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_CREATED_AT_ASC',
  DocumentPagesByLinkedDocumentIdMaxCreatedAtDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_CREATED_AT_DESC',
  DocumentPagesByLinkedDocumentIdMaxCrossRevIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_CROSS_REV_ID_ASC',
  DocumentPagesByLinkedDocumentIdMaxCrossRevIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_CROSS_REV_ID_DESC',
  DocumentPagesByLinkedDocumentIdMaxDocumentIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentPagesByLinkedDocumentIdMaxDocumentIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentPagesByLinkedDocumentIdMaxExtractedTextAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_EXTRACTED_TEXT_ASC',
  DocumentPagesByLinkedDocumentIdMaxExtractedTextDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_EXTRACTED_TEXT_DESC',
  DocumentPagesByLinkedDocumentIdMaxIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_ID_ASC',
  DocumentPagesByLinkedDocumentIdMaxIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_ID_DESC',
  DocumentPagesByLinkedDocumentIdMaxLinkedDocumentIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_LINKED_DOCUMENT_ID_ASC',
  DocumentPagesByLinkedDocumentIdMaxLinkedDocumentIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_LINKED_DOCUMENT_ID_DESC',
  DocumentPagesByLinkedDocumentIdMaxPageNumberAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_PAGE_NUMBER_ASC',
  DocumentPagesByLinkedDocumentIdMaxPageNumberDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_PAGE_NUMBER_DESC',
  DocumentPagesByLinkedDocumentIdMaxPageTypeAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_PAGE_TYPE_ASC',
  DocumentPagesByLinkedDocumentIdMaxPageTypeDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_PAGE_TYPE_DESC',
  DocumentPagesByLinkedDocumentIdMaxRevisionNumberAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_REVISION_NUMBER_ASC',
  DocumentPagesByLinkedDocumentIdMaxRevisionNumberDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_REVISION_NUMBER_DESC',
  DocumentPagesByLinkedDocumentIdMaxThumbnailAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_THUMBNAIL_ASC',
  DocumentPagesByLinkedDocumentIdMaxThumbnailDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_THUMBNAIL_DESC',
  DocumentPagesByLinkedDocumentIdMaxUpdatedAtAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_UPDATED_AT_ASC',
  DocumentPagesByLinkedDocumentIdMaxUpdatedAtDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MAX_UPDATED_AT_DESC',
  DocumentPagesByLinkedDocumentIdMinCreatedAtAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_CREATED_AT_ASC',
  DocumentPagesByLinkedDocumentIdMinCreatedAtDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_CREATED_AT_DESC',
  DocumentPagesByLinkedDocumentIdMinCrossRevIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_CROSS_REV_ID_ASC',
  DocumentPagesByLinkedDocumentIdMinCrossRevIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_CROSS_REV_ID_DESC',
  DocumentPagesByLinkedDocumentIdMinDocumentIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentPagesByLinkedDocumentIdMinDocumentIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentPagesByLinkedDocumentIdMinExtractedTextAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_EXTRACTED_TEXT_ASC',
  DocumentPagesByLinkedDocumentIdMinExtractedTextDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_EXTRACTED_TEXT_DESC',
  DocumentPagesByLinkedDocumentIdMinIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_ID_ASC',
  DocumentPagesByLinkedDocumentIdMinIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_ID_DESC',
  DocumentPagesByLinkedDocumentIdMinLinkedDocumentIdAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_LINKED_DOCUMENT_ID_ASC',
  DocumentPagesByLinkedDocumentIdMinLinkedDocumentIdDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_LINKED_DOCUMENT_ID_DESC',
  DocumentPagesByLinkedDocumentIdMinPageNumberAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_PAGE_NUMBER_ASC',
  DocumentPagesByLinkedDocumentIdMinPageNumberDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_PAGE_NUMBER_DESC',
  DocumentPagesByLinkedDocumentIdMinPageTypeAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_PAGE_TYPE_ASC',
  DocumentPagesByLinkedDocumentIdMinPageTypeDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_PAGE_TYPE_DESC',
  DocumentPagesByLinkedDocumentIdMinRevisionNumberAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_REVISION_NUMBER_ASC',
  DocumentPagesByLinkedDocumentIdMinRevisionNumberDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_REVISION_NUMBER_DESC',
  DocumentPagesByLinkedDocumentIdMinThumbnailAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_THUMBNAIL_ASC',
  DocumentPagesByLinkedDocumentIdMinThumbnailDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_THUMBNAIL_DESC',
  DocumentPagesByLinkedDocumentIdMinUpdatedAtAsc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_UPDATED_AT_ASC',
  DocumentPagesByLinkedDocumentIdMinUpdatedAtDesc = 'DOCUMENT_PAGES_BY_LINKED_DOCUMENT_ID__MIN_UPDATED_AT_DESC',
  DocumentPageMatchingsByDocumentIdCountAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__COUNT_ASC',
  DocumentPageMatchingsByDocumentIdCountDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__COUNT_DESC',
  DocumentPageMatchingsByDocumentIdMaxDocumentIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentPageMatchingsByDocumentIdMaxDocumentIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentPageMatchingsByDocumentIdMaxIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_ID_ASC',
  DocumentPageMatchingsByDocumentIdMaxIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_ID_DESC',
  DocumentPageMatchingsByDocumentIdMaxScoreAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_SCORE_ASC',
  DocumentPageMatchingsByDocumentIdMaxScoreDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_SCORE_DESC',
  DocumentPageMatchingsByDocumentIdMaxSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMaxSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMaxSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMaxSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMaxTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMaxTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMaxTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMaxTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MAX_TARGET_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMinDocumentIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentPageMatchingsByDocumentIdMinDocumentIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentPageMatchingsByDocumentIdMinIdAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_ID_ASC',
  DocumentPageMatchingsByDocumentIdMinIdDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_ID_DESC',
  DocumentPageMatchingsByDocumentIdMinScoreAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_SCORE_ASC',
  DocumentPageMatchingsByDocumentIdMinScoreDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_SCORE_DESC',
  DocumentPageMatchingsByDocumentIdMinSourcePageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_SOURCE_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMinSourcePageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_SOURCE_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMinSourceRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_SOURCE_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMinSourceRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_SOURCE_REVISION_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMinTargetPageNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_TARGET_PAGE_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMinTargetPageNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_TARGET_PAGE_NUMBER_DESC',
  DocumentPageMatchingsByDocumentIdMinTargetRevisionNumberAsc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_TARGET_REVISION_NUMBER_ASC',
  DocumentPageMatchingsByDocumentIdMinTargetRevisionNumberDesc = 'DOCUMENT_PAGE_MATCHINGS_BY_DOCUMENT_ID__MIN_TARGET_REVISION_NUMBER_DESC',
  DocumentProcessesByDocumentIdCountAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__COUNT_ASC',
  DocumentProcessesByDocumentIdCountDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__COUNT_DESC',
  DocumentProcessesByDocumentIdMaxDocumentIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentProcessesByDocumentIdMaxDocumentIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentProcessesByDocumentIdMaxFailedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_FAILED_AT_ASC',
  DocumentProcessesByDocumentIdMaxFailedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_FAILED_AT_DESC',
  DocumentProcessesByDocumentIdMaxIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_ID_ASC',
  DocumentProcessesByDocumentIdMaxIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_ID_DESC',
  DocumentProcessesByDocumentIdMaxInitiatorIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_INITIATOR_ID_ASC',
  DocumentProcessesByDocumentIdMaxInitiatorIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_INITIATOR_ID_DESC',
  DocumentProcessesByDocumentIdMaxLastErrorAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_LAST_ERROR_ASC',
  DocumentProcessesByDocumentIdMaxLastErrorDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_LAST_ERROR_DESC',
  DocumentProcessesByDocumentIdMaxProgressAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_PROGRESS_ASC',
  DocumentProcessesByDocumentIdMaxProgressDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_PROGRESS_DESC',
  DocumentProcessesByDocumentIdMaxResultAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_RESULT_ASC',
  DocumentProcessesByDocumentIdMaxResultDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_RESULT_DESC',
  DocumentProcessesByDocumentIdMaxRevisionNumberAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_REVISION_NUMBER_ASC',
  DocumentProcessesByDocumentIdMaxRevisionNumberDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_REVISION_NUMBER_DESC',
  DocumentProcessesByDocumentIdMaxStageAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_STAGE_ASC',
  DocumentProcessesByDocumentIdMaxStageDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_STAGE_DESC',
  DocumentProcessesByDocumentIdMaxStartedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_STARTED_AT_ASC',
  DocumentProcessesByDocumentIdMaxStartedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_STARTED_AT_DESC',
  DocumentProcessesByDocumentIdMaxSucceededAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_SUCCEEDED_AT_ASC',
  DocumentProcessesByDocumentIdMaxSucceededAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_SUCCEEDED_AT_DESC',
  DocumentProcessesByDocumentIdMaxUnitOfWorkAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_UNIT_OF_WORK_ASC',
  DocumentProcessesByDocumentIdMaxUnitOfWorkDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MAX_UNIT_OF_WORK_DESC',
  DocumentProcessesByDocumentIdMinDocumentIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentProcessesByDocumentIdMinDocumentIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentProcessesByDocumentIdMinFailedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_FAILED_AT_ASC',
  DocumentProcessesByDocumentIdMinFailedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_FAILED_AT_DESC',
  DocumentProcessesByDocumentIdMinIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_ID_ASC',
  DocumentProcessesByDocumentIdMinIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_ID_DESC',
  DocumentProcessesByDocumentIdMinInitiatorIdAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_INITIATOR_ID_ASC',
  DocumentProcessesByDocumentIdMinInitiatorIdDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_INITIATOR_ID_DESC',
  DocumentProcessesByDocumentIdMinLastErrorAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_LAST_ERROR_ASC',
  DocumentProcessesByDocumentIdMinLastErrorDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_LAST_ERROR_DESC',
  DocumentProcessesByDocumentIdMinProgressAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_PROGRESS_ASC',
  DocumentProcessesByDocumentIdMinProgressDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_PROGRESS_DESC',
  DocumentProcessesByDocumentIdMinResultAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_RESULT_ASC',
  DocumentProcessesByDocumentIdMinResultDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_RESULT_DESC',
  DocumentProcessesByDocumentIdMinRevisionNumberAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_REVISION_NUMBER_ASC',
  DocumentProcessesByDocumentIdMinRevisionNumberDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_REVISION_NUMBER_DESC',
  DocumentProcessesByDocumentIdMinStageAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_STAGE_ASC',
  DocumentProcessesByDocumentIdMinStageDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_STAGE_DESC',
  DocumentProcessesByDocumentIdMinStartedAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_STARTED_AT_ASC',
  DocumentProcessesByDocumentIdMinStartedAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_STARTED_AT_DESC',
  DocumentProcessesByDocumentIdMinSucceededAtAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_SUCCEEDED_AT_ASC',
  DocumentProcessesByDocumentIdMinSucceededAtDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_SUCCEEDED_AT_DESC',
  DocumentProcessesByDocumentIdMinUnitOfWorkAsc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_UNIT_OF_WORK_ASC',
  DocumentProcessesByDocumentIdMinUnitOfWorkDesc = 'DOCUMENT_PROCESSES_BY_DOCUMENT_ID__MIN_UNIT_OF_WORK_DESC',
  DocumentRevisionsByDocumentIdCountAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__COUNT_ASC',
  DocumentRevisionsByDocumentIdCountDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__COUNT_DESC',
  DocumentRevisionsByDocumentIdMaxDocumentIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentRevisionsByDocumentIdMaxDocumentIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentRevisionsByDocumentIdMaxDownloadUrlAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_DOWNLOAD_URL_ASC',
  DocumentRevisionsByDocumentIdMaxDownloadUrlDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_DOWNLOAD_URL_DESC',
  DocumentRevisionsByDocumentIdMaxFileNameAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_FILE_NAME_ASC',
  DocumentRevisionsByDocumentIdMaxFileNameDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_FILE_NAME_DESC',
  DocumentRevisionsByDocumentIdMaxFileSizeAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_FILE_SIZE_ASC',
  DocumentRevisionsByDocumentIdMaxFileSizeDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_FILE_SIZE_DESC',
  DocumentRevisionsByDocumentIdMaxIsCurrentAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_IS_CURRENT_ASC',
  DocumentRevisionsByDocumentIdMaxIsCurrentDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_IS_CURRENT_DESC',
  DocumentRevisionsByDocumentIdMaxOriginalDownloadUrlAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionsByDocumentIdMaxOriginalDownloadUrlDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionsByDocumentIdMaxOriginalMimeTypeAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionsByDocumentIdMaxOriginalMimeTypeDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionsByDocumentIdMaxOriginalStorageIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionsByDocumentIdMaxOriginalStorageIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionsByDocumentIdMaxPagesAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_PAGES_ASC',
  DocumentRevisionsByDocumentIdMaxPagesDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_PAGES_DESC',
  DocumentRevisionsByDocumentIdMaxProcessingErrorAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_PROCESSING_ERROR_ASC',
  DocumentRevisionsByDocumentIdMaxProcessingErrorDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_PROCESSING_ERROR_DESC',
  DocumentRevisionsByDocumentIdMaxRevisionNumberAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_REVISION_NUMBER_ASC',
  DocumentRevisionsByDocumentIdMaxRevisionNumberDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_REVISION_NUMBER_DESC',
  DocumentRevisionsByDocumentIdMaxStorageIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_STORAGE_ID_ASC',
  DocumentRevisionsByDocumentIdMaxStorageIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_STORAGE_ID_DESC',
  DocumentRevisionsByDocumentIdMaxThumbnailDownloadUrlAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionsByDocumentIdMaxThumbnailDownloadUrlDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionsByDocumentIdMaxThumbnailStorageIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionsByDocumentIdMaxThumbnailStorageIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionsByDocumentIdMaxUploadedAtAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_UPLOADED_AT_ASC',
  DocumentRevisionsByDocumentIdMaxUploadedAtDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MAX_UPLOADED_AT_DESC',
  DocumentRevisionsByDocumentIdMinDocumentIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentRevisionsByDocumentIdMinDocumentIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentRevisionsByDocumentIdMinDownloadUrlAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_DOWNLOAD_URL_ASC',
  DocumentRevisionsByDocumentIdMinDownloadUrlDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_DOWNLOAD_URL_DESC',
  DocumentRevisionsByDocumentIdMinFileNameAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_FILE_NAME_ASC',
  DocumentRevisionsByDocumentIdMinFileNameDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_FILE_NAME_DESC',
  DocumentRevisionsByDocumentIdMinFileSizeAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_FILE_SIZE_ASC',
  DocumentRevisionsByDocumentIdMinFileSizeDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_FILE_SIZE_DESC',
  DocumentRevisionsByDocumentIdMinIsCurrentAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_IS_CURRENT_ASC',
  DocumentRevisionsByDocumentIdMinIsCurrentDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_IS_CURRENT_DESC',
  DocumentRevisionsByDocumentIdMinOriginalDownloadUrlAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionsByDocumentIdMinOriginalDownloadUrlDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionsByDocumentIdMinOriginalMimeTypeAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionsByDocumentIdMinOriginalMimeTypeDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionsByDocumentIdMinOriginalStorageIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionsByDocumentIdMinOriginalStorageIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionsByDocumentIdMinPagesAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_PAGES_ASC',
  DocumentRevisionsByDocumentIdMinPagesDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_PAGES_DESC',
  DocumentRevisionsByDocumentIdMinProcessingErrorAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_PROCESSING_ERROR_ASC',
  DocumentRevisionsByDocumentIdMinProcessingErrorDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_PROCESSING_ERROR_DESC',
  DocumentRevisionsByDocumentIdMinRevisionNumberAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_REVISION_NUMBER_ASC',
  DocumentRevisionsByDocumentIdMinRevisionNumberDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_REVISION_NUMBER_DESC',
  DocumentRevisionsByDocumentIdMinStorageIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_STORAGE_ID_ASC',
  DocumentRevisionsByDocumentIdMinStorageIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_STORAGE_ID_DESC',
  DocumentRevisionsByDocumentIdMinThumbnailDownloadUrlAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionsByDocumentIdMinThumbnailDownloadUrlDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionsByDocumentIdMinThumbnailStorageIdAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionsByDocumentIdMinThumbnailStorageIdDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionsByDocumentIdMinUploadedAtAsc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_UPLOADED_AT_ASC',
  DocumentRevisionsByDocumentIdMinUploadedAtDesc = 'DOCUMENT_REVISIONS_BY_DOCUMENT_ID__MIN_UPLOADED_AT_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberDocumentIdAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__DOCUMENT_ID_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberDocumentIdDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__DOCUMENT_ID_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberDownloadUrlAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__DOWNLOAD_URL_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberDownloadUrlDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__DOWNLOAD_URL_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberFileNameAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__FILE_NAME_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberFileNameDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__FILE_NAME_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberFileSizeAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__FILE_SIZE_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberFileSizeDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__FILE_SIZE_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberIsCurrentAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__IS_CURRENT_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberIsCurrentDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__IS_CURRENT_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberOriginalDownloadUrlAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberOriginalDownloadUrlDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberOriginalMimeTypeAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__ORIGINAL_MIME_TYPE_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberOriginalMimeTypeDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__ORIGINAL_MIME_TYPE_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberOriginalStorageIdAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__ORIGINAL_STORAGE_ID_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberOriginalStorageIdDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__ORIGINAL_STORAGE_ID_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberPagesAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__PAGES_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberPagesDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__PAGES_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberProcessingErrorAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__PROCESSING_ERROR_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberProcessingErrorDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__PROCESSING_ERROR_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberRevisionNumberAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__REVISION_NUMBER_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberRevisionNumberDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__REVISION_NUMBER_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberStorageIdAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__STORAGE_ID_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberStorageIdDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__STORAGE_ID_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberThumbnailDownloadUrlAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberThumbnailDownloadUrlDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberThumbnailStorageIdAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberThumbnailStorageIdDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__THUMBNAIL_STORAGE_ID_DESC',
  DocumentRevisionByIdAndCurrentRevisionNumberUploadedAtAsc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__UPLOADED_AT_ASC',
  DocumentRevisionByIdAndCurrentRevisionNumberUploadedAtDesc = 'DOCUMENT_REVISION_BY_ID_AND_CURRENT_REVISION_NUMBER__UPLOADED_AT_DESC',
  DocumentSpaceItemsByDocumentIdCountAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__COUNT_ASC',
  DocumentSpaceItemsByDocumentIdCountDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__COUNT_DESC',
  DocumentSpaceItemsByDocumentIdMaxAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_ADDED_AT_ASC',
  DocumentSpaceItemsByDocumentIdMaxAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_ADDED_AT_DESC',
  DocumentSpaceItemsByDocumentIdMaxDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  DocumentSpaceItemsByDocumentIdMaxDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  DocumentSpaceItemsByDocumentIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsByDocumentIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsByDocumentIdMaxFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_FLOW_ID_ASC',
  DocumentSpaceItemsByDocumentIdMaxFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_FLOW_ID_DESC',
  DocumentSpaceItemsByDocumentIdMaxIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_ID_ASC',
  DocumentSpaceItemsByDocumentIdMaxIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_ID_DESC',
  DocumentSpaceItemsByDocumentIdMaxPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_POSITION_ASC',
  DocumentSpaceItemsByDocumentIdMaxPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_POSITION_DESC',
  DocumentSpaceItemsByDocumentIdMaxSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_SECTION_ID_ASC',
  DocumentSpaceItemsByDocumentIdMaxSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_SECTION_ID_DESC',
  DocumentSpaceItemsByDocumentIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceItemsByDocumentIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceItemsByDocumentIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceItemsByDocumentIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceItemsByDocumentIdMinAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_ADDED_AT_ASC',
  DocumentSpaceItemsByDocumentIdMinAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_ADDED_AT_DESC',
  DocumentSpaceItemsByDocumentIdMinDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  DocumentSpaceItemsByDocumentIdMinDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  DocumentSpaceItemsByDocumentIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsByDocumentIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsByDocumentIdMinFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_FLOW_ID_ASC',
  DocumentSpaceItemsByDocumentIdMinFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_FLOW_ID_DESC',
  DocumentSpaceItemsByDocumentIdMinIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_ID_ASC',
  DocumentSpaceItemsByDocumentIdMinIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_ID_DESC',
  DocumentSpaceItemsByDocumentIdMinPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_POSITION_ASC',
  DocumentSpaceItemsByDocumentIdMinPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_POSITION_DESC',
  DocumentSpaceItemsByDocumentIdMinSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_SECTION_ID_ASC',
  DocumentSpaceItemsByDocumentIdMinSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_SECTION_ID_DESC',
  DocumentSpaceItemsByDocumentIdMinSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceItemsByDocumentIdMinSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceItemsByDocumentIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceItemsByDocumentIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_DOCUMENT_ID__MIN_UPDATED_AT_DESC',
  DoesSupportFlowsAsc = 'DOES_SUPPORT_FLOWS_ASC',
  DoesSupportFlowsDesc = 'DOES_SUPPORT_FLOWS_DESC',
  DoesSupportSharedspaceAsc = 'DOES_SUPPORT_SHAREDSPACE_ASC',
  DoesSupportSharedspaceDesc = 'DOES_SUPPORT_SHAREDSPACE_DESC',
  DownloadUrlAsc = 'DOWNLOAD_URL_ASC',
  DownloadUrlDesc = 'DOWNLOAD_URL_DESC',
  EnableMagicPagesAsc = 'ENABLE_MAGIC_PAGES_ASC',
  EnableMagicPagesDesc = 'ENABLE_MAGIC_PAGES_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  ExternalLinkIdAsc = 'EXTERNAL_LINK_ID_ASC',
  ExternalLinkIdDesc = 'EXTERNAL_LINK_ID_DESC',
  FileNameAsc = 'FILE_NAME_ASC',
  FileNameDesc = 'FILE_NAME_DESC',
  FileSizeAsc = 'FILE_SIZE_ASC',
  FileSizeDesc = 'FILE_SIZE_DESC',
  FirestoreIdAsc = 'FIRESTORE_ID_ASC',
  FirestoreIdDesc = 'FIRESTORE_ID_DESC',
  FlowItemsByVideoIdCountAsc = 'FLOW_ITEMS_BY_VIDEO_ID__COUNT_ASC',
  FlowItemsByVideoIdCountDesc = 'FLOW_ITEMS_BY_VIDEO_ID__COUNT_DESC',
  FlowItemsByVideoIdMaxCreatedAtAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_CREATED_AT_ASC',
  FlowItemsByVideoIdMaxCreatedAtDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_CREATED_AT_DESC',
  FlowItemsByVideoIdMaxCreatorIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_CREATOR_ID_ASC',
  FlowItemsByVideoIdMaxCreatorIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_CREATOR_ID_DESC',
  FlowItemsByVideoIdMaxFlowIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_FLOW_ID_ASC',
  FlowItemsByVideoIdMaxFlowIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_FLOW_ID_DESC',
  FlowItemsByVideoIdMaxIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_ID_ASC',
  FlowItemsByVideoIdMaxIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_ID_DESC',
  FlowItemsByVideoIdMaxOrderAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_ORDER_ASC',
  FlowItemsByVideoIdMaxOrderDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_ORDER_DESC',
  FlowItemsByVideoIdMaxPageIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_PAGE_ID_ASC',
  FlowItemsByVideoIdMaxPageIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_PAGE_ID_DESC',
  FlowItemsByVideoIdMaxSysPeriodAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_SYS_PERIOD_ASC',
  FlowItemsByVideoIdMaxSysPeriodDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_SYS_PERIOD_DESC',
  FlowItemsByVideoIdMaxUpdatedAtAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_UPDATED_AT_ASC',
  FlowItemsByVideoIdMaxUpdatedAtDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_UPDATED_AT_DESC',
  FlowItemsByVideoIdMaxVideoIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_VIDEO_ID_ASC',
  FlowItemsByVideoIdMaxVideoIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MAX_VIDEO_ID_DESC',
  FlowItemsByVideoIdMinCreatedAtAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_CREATED_AT_ASC',
  FlowItemsByVideoIdMinCreatedAtDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_CREATED_AT_DESC',
  FlowItemsByVideoIdMinCreatorIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_CREATOR_ID_ASC',
  FlowItemsByVideoIdMinCreatorIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_CREATOR_ID_DESC',
  FlowItemsByVideoIdMinFlowIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_FLOW_ID_ASC',
  FlowItemsByVideoIdMinFlowIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_FLOW_ID_DESC',
  FlowItemsByVideoIdMinIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_ID_ASC',
  FlowItemsByVideoIdMinIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_ID_DESC',
  FlowItemsByVideoIdMinOrderAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_ORDER_ASC',
  FlowItemsByVideoIdMinOrderDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_ORDER_DESC',
  FlowItemsByVideoIdMinPageIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_PAGE_ID_ASC',
  FlowItemsByVideoIdMinPageIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_PAGE_ID_DESC',
  FlowItemsByVideoIdMinSysPeriodAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_SYS_PERIOD_ASC',
  FlowItemsByVideoIdMinSysPeriodDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_SYS_PERIOD_DESC',
  FlowItemsByVideoIdMinUpdatedAtAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_UPDATED_AT_ASC',
  FlowItemsByVideoIdMinUpdatedAtDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_UPDATED_AT_DESC',
  FlowItemsByVideoIdMinVideoIdAsc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_VIDEO_ID_ASC',
  FlowItemsByVideoIdMinVideoIdDesc = 'FLOW_ITEMS_BY_VIDEO_ID__MIN_VIDEO_ID_DESC',
  FtsDocumentHitsByDocumentIdCountAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__COUNT_ASC',
  FtsDocumentHitsByDocumentIdCountDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__COUNT_DESC',
  FtsDocumentHitsByDocumentIdMaxBestPageScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_BEST_PAGE_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMaxBestPageScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_BEST_PAGE_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMaxDocumentIdAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  FtsDocumentHitsByDocumentIdMaxDocumentIdDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  FtsDocumentHitsByDocumentIdMaxDocumentScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_DOCUMENT_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMaxDocumentScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_DOCUMENT_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMaxFileNameAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_FILE_NAME_ASC',
  FtsDocumentHitsByDocumentIdMaxFileNameDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_FILE_NAME_DESC',
  FtsDocumentHitsByDocumentIdMaxFileNameHeadlineAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_FILE_NAME_HEADLINE_ASC',
  FtsDocumentHitsByDocumentIdMaxFileNameHeadlineDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_FILE_NAME_HEADLINE_DESC',
  FtsDocumentHitsByDocumentIdMaxMatchingTagsAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_MATCHING_TAGS_ASC',
  FtsDocumentHitsByDocumentIdMaxMatchingTagsDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_MATCHING_TAGS_DESC',
  FtsDocumentHitsByDocumentIdMaxPageHitsAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_PAGE_HITS_ASC',
  FtsDocumentHitsByDocumentIdMaxPageHitsDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_PAGE_HITS_DESC',
  FtsDocumentHitsByDocumentIdMaxTagScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TAG_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMaxTagScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TAG_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMaxTitleAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TITLE_ASC',
  FtsDocumentHitsByDocumentIdMaxTitleDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TITLE_DESC',
  FtsDocumentHitsByDocumentIdMaxTitleHeadlineAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TITLE_HEADLINE_ASC',
  FtsDocumentHitsByDocumentIdMaxTitleHeadlineDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TITLE_HEADLINE_DESC',
  FtsDocumentHitsByDocumentIdMaxTotalMatchingPagesAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TOTAL_MATCHING_PAGES_ASC',
  FtsDocumentHitsByDocumentIdMaxTotalMatchingPagesDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TOTAL_MATCHING_PAGES_DESC',
  FtsDocumentHitsByDocumentIdMaxTotalScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TOTAL_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMaxTotalScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MAX_TOTAL_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMinBestPageScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_BEST_PAGE_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMinBestPageScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_BEST_PAGE_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMinDocumentIdAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  FtsDocumentHitsByDocumentIdMinDocumentIdDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  FtsDocumentHitsByDocumentIdMinDocumentScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_DOCUMENT_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMinDocumentScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_DOCUMENT_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMinFileNameAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_FILE_NAME_ASC',
  FtsDocumentHitsByDocumentIdMinFileNameDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_FILE_NAME_DESC',
  FtsDocumentHitsByDocumentIdMinFileNameHeadlineAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_FILE_NAME_HEADLINE_ASC',
  FtsDocumentHitsByDocumentIdMinFileNameHeadlineDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_FILE_NAME_HEADLINE_DESC',
  FtsDocumentHitsByDocumentIdMinMatchingTagsAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_MATCHING_TAGS_ASC',
  FtsDocumentHitsByDocumentIdMinMatchingTagsDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_MATCHING_TAGS_DESC',
  FtsDocumentHitsByDocumentIdMinPageHitsAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_PAGE_HITS_ASC',
  FtsDocumentHitsByDocumentIdMinPageHitsDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_PAGE_HITS_DESC',
  FtsDocumentHitsByDocumentIdMinTagScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TAG_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMinTagScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TAG_SCORE_DESC',
  FtsDocumentHitsByDocumentIdMinTitleAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TITLE_ASC',
  FtsDocumentHitsByDocumentIdMinTitleDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TITLE_DESC',
  FtsDocumentHitsByDocumentIdMinTitleHeadlineAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TITLE_HEADLINE_ASC',
  FtsDocumentHitsByDocumentIdMinTitleHeadlineDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TITLE_HEADLINE_DESC',
  FtsDocumentHitsByDocumentIdMinTotalMatchingPagesAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TOTAL_MATCHING_PAGES_ASC',
  FtsDocumentHitsByDocumentIdMinTotalMatchingPagesDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TOTAL_MATCHING_PAGES_DESC',
  FtsDocumentHitsByDocumentIdMinTotalScoreAsc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TOTAL_SCORE_ASC',
  FtsDocumentHitsByDocumentIdMinTotalScoreDesc = 'FTS_DOCUMENT_HITS_BY_DOCUMENT_ID__MIN_TOTAL_SCORE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IgnoredPagesAsc = 'IGNORED_PAGES_ASC',
  IgnoredPagesDesc = 'IGNORED_PAGES_DESC',
  InitialFileNameAsc = 'INITIAL_FILE_NAME_ASC',
  InitialFileNameDesc = 'INITIAL_FILE_NAME_DESC',
  InternalLinksAsc = 'INTERNAL_LINKS_ASC',
  InternalLinksDesc = 'INTERNAL_LINKS_DESC',
  IsDownloadableAsc = 'IS_DOWNLOADABLE_ASC',
  IsDownloadableDesc = 'IS_DOWNLOADABLE_DESC',
  IsPublishedAsc = 'IS_PUBLISHED_ASC',
  IsPublishedDesc = 'IS_PUBLISHED_DESC',
  LastModifiedAtAsc = 'LAST_MODIFIED_AT_ASC',
  LastModifiedAtDesc = 'LAST_MODIFIED_AT_DESC',
  LastModifiedByIdAsc = 'LAST_MODIFIED_BY_ID_ASC',
  LastModifiedByIdDesc = 'LAST_MODIFIED_BY_ID_DESC',
  LegalAppendixIdAsc = 'LEGAL_APPENDIX_ID_ASC',
  LegalAppendixIdDesc = 'LEGAL_APPENDIX_ID_DESC',
  LinksCanBeClickedByViewerAsc = 'LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  LinksCanBeClickedByViewerDesc = 'LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  LiteratureReferencesAsc = 'LITERATURE_REFERENCES_ASC',
  LiteratureReferencesDesc = 'LITERATURE_REFERENCES_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdCountAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__COUNT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdCountDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__COUNT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxAverageConservativeDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxAverageConservativeDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxAverageDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxAverageDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxDisplayTitleAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_DISPLAY_TITLE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxDisplayTitleDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_DISPLAY_TITLE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxMaxConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxMaxConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxMaxDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxMaxDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxMimeTypeAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_MIME_TYPE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxMimeTypeDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_MIME_TYPE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxNumDownloadsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxNumDownloadsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxTotalConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxTotalConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxTotalDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMaxTotalDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinAverageConservativeDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinAverageConservativeDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinAverageDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinAverageDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinDisplayTitleAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_DISPLAY_TITLE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinDisplayTitleDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_DISPLAY_TITLE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinMaxConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinMaxConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinMaxDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinMaxDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinMimeTypeAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_MIME_TYPE_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinMimeTypeDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_MIME_TYPE_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinNumDownloadsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinNumDownloadsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinTotalConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinTotalConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinTotalDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticsByDocumentIdMinTotalDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdCountAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__COUNT_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdCountDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__COUNT_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxAverageConservativeDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxAverageConservativeDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxAverageDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxAverageDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxMaxConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxMaxConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxMaxDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxMaxDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxPageNumberAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_PAGE_NUMBER_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxPageNumberDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_PAGE_NUMBER_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxTotalConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxTotalConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxTotalDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMaxTotalDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MAX_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinAverageConservativeDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinAverageConservativeDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinAverageDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinAverageDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinMaxConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinMaxConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinMaxDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinMaxDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinPageNumberAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_PAGE_NUMBER_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinPageNumberDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_PAGE_NUMBER_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinTotalConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinTotalConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentIdMinTotalDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentIdMinTotalDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_ID__MIN_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdCountAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__COUNT_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdCountDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__COUNT_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxAvgWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_AVG_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxAvgWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_AVG_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxDisplayTitleAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_DISPLAY_TITLE_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxDisplayTitleDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_DISPLAY_TITLE_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxMaxWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxMaxWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_MAX_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxNumDownloadsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxNumDownloadsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMaxThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinAvgWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_AVG_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinAvgWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_AVG_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinDisplayTitleAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_DISPLAY_TITLE_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinDisplayTitleDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_DISPLAY_TITLE_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinMaxWatchRateAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_WATCH_RATE_ACROSS_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinMaxWatchRateAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_MAX_WATCH_RATE_ACROSS_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinNumDownloadsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_DOWNLOADS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinNumDownloadsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_DOWNLOADS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceVideoStatisticsByDocumentIdMinThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_VIDEO_STATISTICS_BY_DOCUMENT_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  MimeTypeAsc = 'MIME_TYPE_ASC',
  MimeTypeDesc = 'MIME_TYPE_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  OrderNullsLastAsc = 'ORDER_NULLS_LAST_ASC',
  OrderNullsLastDesc = 'ORDER_NULLS_LAST_DESC',
  OriginalDownloadUrlAsc = 'ORIGINAL_DOWNLOAD_URL_ASC',
  OriginalDownloadUrlDesc = 'ORIGINAL_DOWNLOAD_URL_DESC',
  OriginalMimeTypeAsc = 'ORIGINAL_MIME_TYPE_ASC',
  OriginalMimeTypeDesc = 'ORIGINAL_MIME_TYPE_DESC',
  OriginalStorageIdAsc = 'ORIGINAL_STORAGE_ID_ASC',
  OriginalStorageIdDesc = 'ORIGINAL_STORAGE_ID_DESC',
  PagesAsc = 'PAGES_ASC',
  PagesDesc = 'PAGES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StorageIdAsc = 'STORAGE_ID_ASC',
  StorageIdDesc = 'STORAGE_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TeaserTextAsc = 'TEASER_TEXT_ASC',
  TeaserTextDesc = 'TEASER_TEXT_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC',
  ThumbnailStorageIdAsc = 'THUMBNAIL_STORAGE_ID_ASC',
  ThumbnailStorageIdDesc = 'THUMBNAIL_STORAGE_ID_DESC',
  TopTitleAsc = 'TOP_TITLE_ASC',
  TopTitleDesc = 'TOP_TITLE_DESC',
  UploadedAtAsc = 'UPLOADED_AT_ASC',
  UploadedAtDesc = 'UPLOADED_AT_DESC',
  UrlBasedDocumentImportsByDocumentIdCountAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__COUNT_ASC',
  UrlBasedDocumentImportsByDocumentIdCountDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__COUNT_DESC',
  UrlBasedDocumentImportsByDocumentIdMaxDocumentIdAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  UrlBasedDocumentImportsByDocumentIdMaxDocumentIdDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  UrlBasedDocumentImportsByDocumentIdMaxEtagAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_ETAG_ASC',
  UrlBasedDocumentImportsByDocumentIdMaxEtagDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_ETAG_DESC',
  UrlBasedDocumentImportsByDocumentIdMaxHashAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_HASH_ASC',
  UrlBasedDocumentImportsByDocumentIdMaxHashDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_HASH_DESC',
  UrlBasedDocumentImportsByDocumentIdMaxHttpStatusAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_HTTP_STATUS_ASC',
  UrlBasedDocumentImportsByDocumentIdMaxHttpStatusDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_HTTP_STATUS_DESC',
  UrlBasedDocumentImportsByDocumentIdMaxIdAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_ID_ASC',
  UrlBasedDocumentImportsByDocumentIdMaxIdDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_ID_DESC',
  UrlBasedDocumentImportsByDocumentIdMaxRunAtAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_RUN_AT_ASC',
  UrlBasedDocumentImportsByDocumentIdMaxRunAtDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MAX_RUN_AT_DESC',
  UrlBasedDocumentImportsByDocumentIdMinDocumentIdAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  UrlBasedDocumentImportsByDocumentIdMinDocumentIdDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  UrlBasedDocumentImportsByDocumentIdMinEtagAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_ETAG_ASC',
  UrlBasedDocumentImportsByDocumentIdMinEtagDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_ETAG_DESC',
  UrlBasedDocumentImportsByDocumentIdMinHashAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_HASH_ASC',
  UrlBasedDocumentImportsByDocumentIdMinHashDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_HASH_DESC',
  UrlBasedDocumentImportsByDocumentIdMinHttpStatusAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_HTTP_STATUS_ASC',
  UrlBasedDocumentImportsByDocumentIdMinHttpStatusDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_HTTP_STATUS_DESC',
  UrlBasedDocumentImportsByDocumentIdMinIdAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_ID_ASC',
  UrlBasedDocumentImportsByDocumentIdMinIdDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_ID_DESC',
  UrlBasedDocumentImportsByDocumentIdMinRunAtAsc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_RUN_AT_ASC',
  UrlBasedDocumentImportsByDocumentIdMinRunAtDesc = 'URL_BASED_DOCUMENT_IMPORTS_BY_DOCUMENT_ID__MIN_RUN_AT_DESC',
  UrlBasedDocumentImportSettingByDocumentIdCreatedAtAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__CREATED_AT_ASC',
  UrlBasedDocumentImportSettingByDocumentIdCreatedAtDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__CREATED_AT_DESC',
  UrlBasedDocumentImportSettingByDocumentIdDocumentIdAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__DOCUMENT_ID_ASC',
  UrlBasedDocumentImportSettingByDocumentIdDocumentIdDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__DOCUMENT_ID_DESC',
  UrlBasedDocumentImportSettingByDocumentIdSysPeriodAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  UrlBasedDocumentImportSettingByDocumentIdSysPeriodDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  UrlBasedDocumentImportSettingByDocumentIdUpdatedAtAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__UPDATED_AT_ASC',
  UrlBasedDocumentImportSettingByDocumentIdUpdatedAtDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__UPDATED_AT_DESC',
  UrlBasedDocumentImportSettingByDocumentIdUpdatedByIdAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__UPDATED_BY_ID_ASC',
  UrlBasedDocumentImportSettingByDocumentIdUpdatedByIdDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__UPDATED_BY_ID_DESC',
  UrlBasedDocumentImportSettingByDocumentIdUrlAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__URL_ASC',
  UrlBasedDocumentImportSettingByDocumentIdUrlDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTING_BY_DOCUMENT_ID__URL_DESC',
  UserByCreatedByIdAppConsentGivenAtAsc = 'USER_BY_CREATED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByCreatedByIdAppConsentGivenAtDesc = 'USER_BY_CREATED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByCreatedByIdConfigAsc = 'USER_BY_CREATED_BY_ID__CONFIG_ASC',
  UserByCreatedByIdConfigDesc = 'USER_BY_CREATED_BY_ID__CONFIG_DESC',
  UserByCreatedByIdCreatedAtAsc = 'USER_BY_CREATED_BY_ID__CREATED_AT_ASC',
  UserByCreatedByIdCreatedAtDesc = 'USER_BY_CREATED_BY_ID__CREATED_AT_DESC',
  UserByCreatedByIdCrmContactVisibilityFilterAsc = 'USER_BY_CREATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByCreatedByIdCrmContactVisibilityFilterDesc = 'USER_BY_CREATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByCreatedByIdDefaultWorkspaceIdAsc = 'USER_BY_CREATED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByCreatedByIdDefaultWorkspaceIdDesc = 'USER_BY_CREATED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByCreatedByIdDisabledAsc = 'USER_BY_CREATED_BY_ID__DISABLED_ASC',
  UserByCreatedByIdDisabledDesc = 'USER_BY_CREATED_BY_ID__DISABLED_DESC',
  UserByCreatedByIdDisplayNameAsc = 'USER_BY_CREATED_BY_ID__DISPLAY_NAME_ASC',
  UserByCreatedByIdDisplayNameDesc = 'USER_BY_CREATED_BY_ID__DISPLAY_NAME_DESC',
  UserByCreatedByIdEmailAsc = 'USER_BY_CREATED_BY_ID__EMAIL_ASC',
  UserByCreatedByIdEmailDesc = 'USER_BY_CREATED_BY_ID__EMAIL_DESC',
  UserByCreatedByIdExternalGroupsAsc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByCreatedByIdExternalGroupsDesc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByCreatedByIdExternalGroupsSyncedAtAsc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByCreatedByIdExternalGroupsSyncedAtDesc = 'USER_BY_CREATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByCreatedByIdFirebaseAuthIdAsc = 'USER_BY_CREATED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByCreatedByIdFirebaseAuthIdDesc = 'USER_BY_CREATED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByCreatedByIdFlagsAsc = 'USER_BY_CREATED_BY_ID__FLAGS_ASC',
  UserByCreatedByIdFlagsDesc = 'USER_BY_CREATED_BY_ID__FLAGS_DESC',
  UserByCreatedByIdIdAsc = 'USER_BY_CREATED_BY_ID__ID_ASC',
  UserByCreatedByIdIdDesc = 'USER_BY_CREATED_BY_ID__ID_DESC',
  UserByCreatedByIdIsTenantAdminAsc = 'USER_BY_CREATED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByCreatedByIdIsTenantAdminDesc = 'USER_BY_CREATED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByCreatedByIdRegisteredAtAsc = 'USER_BY_CREATED_BY_ID__REGISTERED_AT_ASC',
  UserByCreatedByIdRegisteredAtDesc = 'USER_BY_CREATED_BY_ID__REGISTERED_AT_DESC',
  UserByCreatedByIdSysPeriodAsc = 'USER_BY_CREATED_BY_ID__SYS_PERIOD_ASC',
  UserByCreatedByIdSysPeriodDesc = 'USER_BY_CREATED_BY_ID__SYS_PERIOD_DESC',
  UserByCreatedByIdTenantIdAsc = 'USER_BY_CREATED_BY_ID__TENANT_ID_ASC',
  UserByCreatedByIdTenantIdDesc = 'USER_BY_CREATED_BY_ID__TENANT_ID_DESC',
  UserByCreatedByIdUpdatedAtAsc = 'USER_BY_CREATED_BY_ID__UPDATED_AT_ASC',
  UserByCreatedByIdUpdatedAtDesc = 'USER_BY_CREATED_BY_ID__UPDATED_AT_DESC',
  UserByLastModifiedByIdAppConsentGivenAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByLastModifiedByIdAppConsentGivenAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByLastModifiedByIdConfigAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CONFIG_ASC',
  UserByLastModifiedByIdConfigDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CONFIG_DESC',
  UserByLastModifiedByIdCreatedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_ASC',
  UserByLastModifiedByIdCreatedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_DESC',
  UserByLastModifiedByIdCrmContactVisibilityFilterAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByLastModifiedByIdCrmContactVisibilityFilterDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByLastModifiedByIdDefaultWorkspaceIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByLastModifiedByIdDefaultWorkspaceIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByLastModifiedByIdDisabledAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DISABLED_ASC',
  UserByLastModifiedByIdDisabledDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DISABLED_DESC',
  UserByLastModifiedByIdDisplayNameAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DISPLAY_NAME_ASC',
  UserByLastModifiedByIdDisplayNameDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DISPLAY_NAME_DESC',
  UserByLastModifiedByIdEmailAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ASC',
  UserByLastModifiedByIdEmailDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EMAIL_DESC',
  UserByLastModifiedByIdExternalGroupsAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByLastModifiedByIdExternalGroupsDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByLastModifiedByIdExternalGroupsSyncedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByLastModifiedByIdExternalGroupsSyncedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByLastModifiedByIdFirebaseAuthIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByLastModifiedByIdFirebaseAuthIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByLastModifiedByIdFlagsAsc = 'USER_BY_LAST_MODIFIED_BY_ID__FLAGS_ASC',
  UserByLastModifiedByIdFlagsDesc = 'USER_BY_LAST_MODIFIED_BY_ID__FLAGS_DESC',
  UserByLastModifiedByIdIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__ID_ASC',
  UserByLastModifiedByIdIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__ID_DESC',
  UserByLastModifiedByIdIsTenantAdminAsc = 'USER_BY_LAST_MODIFIED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByLastModifiedByIdIsTenantAdminDesc = 'USER_BY_LAST_MODIFIED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByLastModifiedByIdRegisteredAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__REGISTERED_AT_ASC',
  UserByLastModifiedByIdRegisteredAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__REGISTERED_AT_DESC',
  UserByLastModifiedByIdSysPeriodAsc = 'USER_BY_LAST_MODIFIED_BY_ID__SYS_PERIOD_ASC',
  UserByLastModifiedByIdSysPeriodDesc = 'USER_BY_LAST_MODIFIED_BY_ID__SYS_PERIOD_DESC',
  UserByLastModifiedByIdTenantIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__TENANT_ID_ASC',
  UserByLastModifiedByIdTenantIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__TENANT_ID_DESC',
  UserByLastModifiedByIdUpdatedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_ASC',
  UserByLastModifiedByIdUpdatedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_DESC',
  VeevaDocumentMetadatumByDocumentIdDocumentIdAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__DOCUMENT_ID_ASC',
  VeevaDocumentMetadatumByDocumentIdDocumentIdDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__DOCUMENT_ID_DESC',
  VeevaDocumentMetadatumByDocumentIdDocumentNumberAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__DOCUMENT_NUMBER_ASC',
  VeevaDocumentMetadatumByDocumentIdDocumentNumberDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__DOCUMENT_NUMBER_DESC',
  VeevaDocumentMetadatumByDocumentIdExpirationDateAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  VeevaDocumentMetadatumByDocumentIdExpirationDateDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  VeevaDocumentMetadatumByDocumentIdLastCheckedAtAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__LAST_CHECKED_AT_ASC',
  VeevaDocumentMetadatumByDocumentIdLastCheckedAtDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__LAST_CHECKED_AT_DESC',
  VeevaDocumentMetadatumByDocumentIdMajorVersionAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__MAJOR_VERSION_ASC',
  VeevaDocumentMetadatumByDocumentIdMajorVersionDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__MAJOR_VERSION_DESC',
  VeevaDocumentMetadatumByDocumentIdMd5ChecksumAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__MD5CHECKSUM_ASC',
  VeevaDocumentMetadatumByDocumentIdMd5ChecksumDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__MD5CHECKSUM_DESC',
  VeevaDocumentMetadatumByDocumentIdMinorVersionAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__MINOR_VERSION_ASC',
  VeevaDocumentMetadatumByDocumentIdMinorVersionDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__MINOR_VERSION_DESC',
  VeevaDocumentMetadatumByDocumentIdSysPeriodAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  VeevaDocumentMetadatumByDocumentIdSysPeriodDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  VeevaDocumentMetadatumByDocumentIdVeevaDocumentIdAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__VEEVA_DOCUMENT_ID_ASC',
  VeevaDocumentMetadatumByDocumentIdVeevaDocumentIdDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__VEEVA_DOCUMENT_ID_DESC',
  VeevaDocumentMetadatumByDocumentIdVersionCreationDateAsc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__VERSION_CREATION_DATE_ASC',
  VeevaDocumentMetadatumByDocumentIdVersionCreationDateDesc = 'VEEVA_DOCUMENT_METADATUM_BY_DOCUMENT_ID__VERSION_CREATION_DATE_DESC',
  WorkspacesByDefaultLegalAppendixIdCountAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__COUNT_ASC',
  WorkspacesByDefaultLegalAppendixIdCountDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__COUNT_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxAnalyticsAliasAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ANALYTICS_ALIAS_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxAnalyticsAliasDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ANALYTICS_ALIAS_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxAnalyticsEnabledAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ANALYTICS_ENABLED_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxAnalyticsEnabledDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ANALYTICS_ENABLED_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxConfigAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CONFIG_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxConfigDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CONFIG_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxCreatedAtAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CREATED_AT_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxCreatedAtDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CREATED_AT_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxCustomBrandUrlAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CUSTOM_BRAND_URL_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxCustomBrandUrlDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CUSTOM_BRAND_URL_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxCustomShareLinkAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxCustomShareLinkDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxEmailSubjectAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_EMAIL_SUBJECT_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxEmailSubjectDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_EMAIL_SUBJECT_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxEmailTextAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_EMAIL_TEXT_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxEmailTextDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_EMAIL_TEXT_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxFirebaseIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_FIREBASE_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxFirebaseIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_FIREBASE_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxFlagsAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_FLAGS_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxFlagsDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_FLAGS_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxIsOpenAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_IS_OPEN_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxIsOpenDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_IS_OPEN_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxIsVisibleAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_IS_VISIBLE_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxIsVisibleDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_IS_VISIBLE_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxLaserPointerPositionAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_LASER_POINTER_POSITION_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxLaserPointerPositionDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_LASER_POINTER_POSITION_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxLinkPanelPositionAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_LINK_PANEL_POSITION_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxLinkPanelPositionDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_LINK_PANEL_POSITION_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxNameAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_NAME_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxNameDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_NAME_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxNameLowercaseAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_NAME_LOWERCASE_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxNameLowercaseDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_NAME_LOWERCASE_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxParentIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_PARENT_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxParentIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_PARENT_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxSysPeriodAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_SYS_PERIOD_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxSysPeriodDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_SYS_PERIOD_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxTagsAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_TAGS_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxTagsDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_TAGS_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxTeamRankAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_TEAM_RANK_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxTeamRankDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_TEAM_RANK_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxTenantIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_TENANT_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxTenantIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_TENANT_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxUpdatedAtAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_UPDATED_AT_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxUpdatedAtDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_UPDATED_AT_DESC',
  WorkspacesByDefaultLegalAppendixIdMaxUserConfigDefaultsAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByDefaultLegalAppendixIdMaxUserConfigDefaultsDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MAX_USER_CONFIG_DEFAULTS_DESC',
  WorkspacesByDefaultLegalAppendixIdMinAnalyticsAliasAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ANALYTICS_ALIAS_ASC',
  WorkspacesByDefaultLegalAppendixIdMinAnalyticsAliasDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ANALYTICS_ALIAS_DESC',
  WorkspacesByDefaultLegalAppendixIdMinAnalyticsEnabledAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ANALYTICS_ENABLED_ASC',
  WorkspacesByDefaultLegalAppendixIdMinAnalyticsEnabledDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ANALYTICS_ENABLED_DESC',
  WorkspacesByDefaultLegalAppendixIdMinAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByDefaultLegalAppendixIdMinAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByDefaultLegalAppendixIdMinAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByDefaultLegalAppendixIdMinAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByDefaultLegalAppendixIdMinConfigAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CONFIG_ASC',
  WorkspacesByDefaultLegalAppendixIdMinConfigDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CONFIG_DESC',
  WorkspacesByDefaultLegalAppendixIdMinCreatedAtAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CREATED_AT_ASC',
  WorkspacesByDefaultLegalAppendixIdMinCreatedAtDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CREATED_AT_DESC',
  WorkspacesByDefaultLegalAppendixIdMinCustomBrandUrlAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CUSTOM_BRAND_URL_ASC',
  WorkspacesByDefaultLegalAppendixIdMinCustomBrandUrlDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CUSTOM_BRAND_URL_DESC',
  WorkspacesByDefaultLegalAppendixIdMinCustomShareLinkAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByDefaultLegalAppendixIdMinCustomShareLinkDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByDefaultLegalAppendixIdMinDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMinDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMinEmailSubjectAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_EMAIL_SUBJECT_ASC',
  WorkspacesByDefaultLegalAppendixIdMinEmailSubjectDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_EMAIL_SUBJECT_DESC',
  WorkspacesByDefaultLegalAppendixIdMinEmailTextAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_EMAIL_TEXT_ASC',
  WorkspacesByDefaultLegalAppendixIdMinEmailTextDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_EMAIL_TEXT_DESC',
  WorkspacesByDefaultLegalAppendixIdMinFirebaseIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_FIREBASE_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMinFirebaseIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_FIREBASE_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMinFlagsAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_FLAGS_ASC',
  WorkspacesByDefaultLegalAppendixIdMinFlagsDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_FLAGS_DESC',
  WorkspacesByDefaultLegalAppendixIdMinHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByDefaultLegalAppendixIdMinHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByDefaultLegalAppendixIdMinIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMinIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMinIsOpenAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_IS_OPEN_ASC',
  WorkspacesByDefaultLegalAppendixIdMinIsOpenDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_IS_OPEN_DESC',
  WorkspacesByDefaultLegalAppendixIdMinIsVisibleAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_IS_VISIBLE_ASC',
  WorkspacesByDefaultLegalAppendixIdMinIsVisibleDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_IS_VISIBLE_DESC',
  WorkspacesByDefaultLegalAppendixIdMinLaserPointerPositionAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_LASER_POINTER_POSITION_ASC',
  WorkspacesByDefaultLegalAppendixIdMinLaserPointerPositionDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_LASER_POINTER_POSITION_DESC',
  WorkspacesByDefaultLegalAppendixIdMinLinkPanelPositionAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_LINK_PANEL_POSITION_ASC',
  WorkspacesByDefaultLegalAppendixIdMinLinkPanelPositionDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_LINK_PANEL_POSITION_DESC',
  WorkspacesByDefaultLegalAppendixIdMinNameAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_NAME_ASC',
  WorkspacesByDefaultLegalAppendixIdMinNameDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_NAME_DESC',
  WorkspacesByDefaultLegalAppendixIdMinNameLowercaseAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_NAME_LOWERCASE_ASC',
  WorkspacesByDefaultLegalAppendixIdMinNameLowercaseDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_NAME_LOWERCASE_DESC',
  WorkspacesByDefaultLegalAppendixIdMinParentIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_PARENT_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMinParentIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_PARENT_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMinPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMinPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMinSysPeriodAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_SYS_PERIOD_ASC',
  WorkspacesByDefaultLegalAppendixIdMinSysPeriodDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_SYS_PERIOD_DESC',
  WorkspacesByDefaultLegalAppendixIdMinTagsAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_TAGS_ASC',
  WorkspacesByDefaultLegalAppendixIdMinTagsDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_TAGS_DESC',
  WorkspacesByDefaultLegalAppendixIdMinTeamRankAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_TEAM_RANK_ASC',
  WorkspacesByDefaultLegalAppendixIdMinTeamRankDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_TEAM_RANK_DESC',
  WorkspacesByDefaultLegalAppendixIdMinTenantIdAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_TENANT_ID_ASC',
  WorkspacesByDefaultLegalAppendixIdMinTenantIdDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_TENANT_ID_DESC',
  WorkspacesByDefaultLegalAppendixIdMinUpdatedAtAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_UPDATED_AT_ASC',
  WorkspacesByDefaultLegalAppendixIdMinUpdatedAtDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_UPDATED_AT_DESC',
  WorkspacesByDefaultLegalAppendixIdMinUserConfigDefaultsAsc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByDefaultLegalAppendixIdMinUserConfigDefaultsDesc = 'WORKSPACES_BY_DEFAULT_LEGAL_APPENDIX_ID__MIN_USER_CONFIG_DEFAULTS_DESC',
  WorkspaceByWorkspaceIdAnalyticsAliasAsc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByWorkspaceIdAnalyticsAliasDesc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByWorkspaceIdAnalyticsEnabledAsc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByWorkspaceIdAnalyticsEnabledDesc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByWorkspaceIdConfigAsc = 'WORKSPACE_BY_WORKSPACE_ID__CONFIG_ASC',
  WorkspaceByWorkspaceIdConfigDesc = 'WORKSPACE_BY_WORKSPACE_ID__CONFIG_DESC',
  WorkspaceByWorkspaceIdCreatedAtAsc = 'WORKSPACE_BY_WORKSPACE_ID__CREATED_AT_ASC',
  WorkspaceByWorkspaceIdCreatedAtDesc = 'WORKSPACE_BY_WORKSPACE_ID__CREATED_AT_DESC',
  WorkspaceByWorkspaceIdCustomBrandUrlAsc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByWorkspaceIdCustomBrandUrlDesc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByWorkspaceIdCustomShareLinkAsc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByWorkspaceIdCustomShareLinkDesc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByWorkspaceIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByWorkspaceIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByWorkspaceIdEmailSubjectAsc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByWorkspaceIdEmailSubjectDesc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByWorkspaceIdEmailTextAsc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_TEXT_ASC',
  WorkspaceByWorkspaceIdEmailTextDesc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_TEXT_DESC',
  WorkspaceByWorkspaceIdFirebaseIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__FIREBASE_ID_ASC',
  WorkspaceByWorkspaceIdFirebaseIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__FIREBASE_ID_DESC',
  WorkspaceByWorkspaceIdFlagsAsc = 'WORKSPACE_BY_WORKSPACE_ID__FLAGS_ASC',
  WorkspaceByWorkspaceIdFlagsDesc = 'WORKSPACE_BY_WORKSPACE_ID__FLAGS_DESC',
  WorkspaceByWorkspaceIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByWorkspaceIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByWorkspaceIdIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__ID_ASC',
  WorkspaceByWorkspaceIdIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__ID_DESC',
  WorkspaceByWorkspaceIdIsOpenAsc = 'WORKSPACE_BY_WORKSPACE_ID__IS_OPEN_ASC',
  WorkspaceByWorkspaceIdIsOpenDesc = 'WORKSPACE_BY_WORKSPACE_ID__IS_OPEN_DESC',
  WorkspaceByWorkspaceIdIsVisibleAsc = 'WORKSPACE_BY_WORKSPACE_ID__IS_VISIBLE_ASC',
  WorkspaceByWorkspaceIdIsVisibleDesc = 'WORKSPACE_BY_WORKSPACE_ID__IS_VISIBLE_DESC',
  WorkspaceByWorkspaceIdLaserPointerPositionAsc = 'WORKSPACE_BY_WORKSPACE_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByWorkspaceIdLaserPointerPositionDesc = 'WORKSPACE_BY_WORKSPACE_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByWorkspaceIdLinkPanelPositionAsc = 'WORKSPACE_BY_WORKSPACE_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByWorkspaceIdLinkPanelPositionDesc = 'WORKSPACE_BY_WORKSPACE_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByWorkspaceIdMemberCountAsc = 'WORKSPACE_BY_WORKSPACE_ID__MEMBER_COUNT_ASC',
  WorkspaceByWorkspaceIdMemberCountDesc = 'WORKSPACE_BY_WORKSPACE_ID__MEMBER_COUNT_DESC',
  WorkspaceByWorkspaceIdNameAsc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_ASC',
  WorkspaceByWorkspaceIdNameDesc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_DESC',
  WorkspaceByWorkspaceIdNameLowercaseAsc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_LOWERCASE_ASC',
  WorkspaceByWorkspaceIdNameLowercaseDesc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_LOWERCASE_DESC',
  WorkspaceByWorkspaceIdParentIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__PARENT_ID_ASC',
  WorkspaceByWorkspaceIdParentIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__PARENT_ID_DESC',
  WorkspaceByWorkspaceIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByWorkspaceIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByWorkspaceIdSysPeriodAsc = 'WORKSPACE_BY_WORKSPACE_ID__SYS_PERIOD_ASC',
  WorkspaceByWorkspaceIdSysPeriodDesc = 'WORKSPACE_BY_WORKSPACE_ID__SYS_PERIOD_DESC',
  WorkspaceByWorkspaceIdTagsAsc = 'WORKSPACE_BY_WORKSPACE_ID__TAGS_ASC',
  WorkspaceByWorkspaceIdTagsDesc = 'WORKSPACE_BY_WORKSPACE_ID__TAGS_DESC',
  WorkspaceByWorkspaceIdTeamRankAsc = 'WORKSPACE_BY_WORKSPACE_ID__TEAM_RANK_ASC',
  WorkspaceByWorkspaceIdTeamRankDesc = 'WORKSPACE_BY_WORKSPACE_ID__TEAM_RANK_DESC',
  WorkspaceByWorkspaceIdTenantIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__TENANT_ID_ASC',
  WorkspaceByWorkspaceIdTenantIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__TENANT_ID_DESC',
  WorkspaceByWorkspaceIdTotalMemberCountAsc = 'WORKSPACE_BY_WORKSPACE_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByWorkspaceIdTotalMemberCountDesc = 'WORKSPACE_BY_WORKSPACE_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByWorkspaceIdUpdatedAtAsc = 'WORKSPACE_BY_WORKSPACE_ID__UPDATED_AT_ASC',
  WorkspaceByWorkspaceIdUpdatedAtDesc = 'WORKSPACE_BY_WORKSPACE_ID__UPDATED_AT_DESC',
  WorkspaceByWorkspaceIdUserConfigDefaultsAsc = 'WORKSPACE_BY_WORKSPACE_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByWorkspaceIdUserConfigDefaultsDesc = 'WORKSPACE_BY_WORKSPACE_ID__USER_CONFIG_DEFAULTS_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC'
}

/** A connection to a list of `DocumentsViewsInPresentationsOverTimeRecord` values. */
export type DocumentsViewsInPresentationsOverTimeConnection = {
  __typename?: 'DocumentsViewsInPresentationsOverTimeConnection';
  /** A list of edges which contains the `DocumentsViewsInPresentationsOverTimeRecord` and cursor to aid in pagination. */
  edges: Array<DocumentsViewsInPresentationsOverTimeEdge>;
  /** A list of `DocumentsViewsInPresentationsOverTimeRecord` objects. */
  nodes: Array<Maybe<DocumentsViewsInPresentationsOverTimeRecord>>;
  /** The count of *all* `DocumentsViewsInPresentationsOverTimeRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentsViewsInPresentationsOverTimeRecord` edge in the connection. */
export type DocumentsViewsInPresentationsOverTimeEdge = {
  __typename?: 'DocumentsViewsInPresentationsOverTimeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentsViewsInPresentationsOverTimeRecord` at the end of the edge. */
  node?: Maybe<DocumentsViewsInPresentationsOverTimeRecord>;
};

/** The return type of our `viewsInPresentationsOverTime` query. */
export type DocumentsViewsInPresentationsOverTimeRecord = {
  __typename?: 'DocumentsViewsInPresentationsOverTimeRecord';
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  nViews?: Maybe<Scalars['BigInt']['output']>;
  startsAt?: Maybe<Scalars['Datetime']['output']>;
};

/** A filter to be used against `DocumentsViewsInPresentationsOverTimeRecord` object types. All fields are combined with a logical ‘and.’ */
export type DocumentsViewsInPresentationsOverTimeRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentsViewsInPresentationsOverTimeRecordFilter>>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `nViews` field. */
  nViews?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentsViewsInPresentationsOverTimeRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentsViewsInPresentationsOverTimeRecordFilter>>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
};

/** All input for the `dragSpaceSection` mutation. */
export type DragSpaceSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<SpaceSectionDragType>;
  targetSectionId: Scalars['BigInt']['input'];
  withId: Scalars['BigInt']['input'];
};

/** The output of our `dragSpaceSection` mutation. */
export type DragSpaceSectionPayload = {
  __typename?: 'DragSpaceSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<DragSpaceSectionRecord>;
};

/** The return type of our `dragSpaceSection` mutation. */
export type DragSpaceSectionRecord = {
  __typename?: 'DragSpaceSectionRecord';
  movedSection?: Maybe<DocumentSpaceSection>;
  targetSection?: Maybe<DocumentSpaceSection>;
};

/** All input for the `enrollUserWithExternalGroupsInTeamsAndWorkspaces` mutation. */
export type EnrollUserWithExternalGroupsInTeamsAndWorkspacesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  u?: InputMaybe<UserInput>;
};

/** The output of our `enrollUserWithExternalGroupsInTeamsAndWorkspaces` mutation. */
export type EnrollUserWithExternalGroupsInTeamsAndWorkspacesPayload = {
  __typename?: 'EnrollUserWithExternalGroupsInTeamsAndWorkspacesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  memberships?: Maybe<Array<Maybe<Membership>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Event = Node & {
  __typename?: 'Event';
  clientHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['Datetime']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  remoteAddress?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trackedAt: Scalars['Datetime']['output'];
  type: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/** An input for mutations affecting `Event` */
export type EventInput = {
  clientHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  occurredAt?: InputMaybe<Scalars['Datetime']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  remoteAddress?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackedAt?: InputMaybe<Scalars['Datetime']['input']>;
  type: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type Flow = Node & {
  __typename?: 'Flow';
  /** Reads and enables pagination through a set of `FlowItem`. */
  allFlowItems: FlowItemsConnection;
  /** Reads and enables pagination through a set of `Flow`. */
  children: FlowsConnection;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Flow`. */
  creator?: Maybe<User>;
  /** Optional creating user. Allowed to manage the flow. */
  creatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `Document`. */
  distinctDocuments: DocumentsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceItem`. */
  documentSpaceItems: DocumentSpaceItemsConnection;
  firestoreId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `FlowItem`. */
  flowItems: FlowItemsConnection;
  /** Reads and enables pagination through a set of `FlowSubscription`. */
  flowSubscriptions: FlowSubscriptionsConnection;
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `DocumentPage`. */
  legalAppendixPages: DocumentPagesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Flow` that is related to this `Flow`. */
  parent?: Maybe<Flow>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  sysPeriod: DatetimeRange;
  /**
   * Returns the thumbnail URL for a flow, based on the first item in the flow.
   * If the first item is a page, it returns the URL for the page thumbnail.
   *
   * If the first item is a video, it returns the thumbnail download URL for the video.
   *
   * If there are no items or if the first item has neither a page nor a video, it returns null.
   *
   */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Public-facing name of the flow. */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowAllFlowItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FlowItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowDistinctDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowDocumentSpaceItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceItemCondition>;
  filter?: InputMaybe<DocumentSpaceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowFlowItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowItemCondition>;
  filter?: InputMaybe<FlowItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowFlowSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowSubscriptionCondition>;
  filter?: InputMaybe<FlowSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};


/** A flow is a sequence of slides, videos, and possibly other media later. It is an individual collage of marketing materials. */
export type FlowLegalAppendixPagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Flow` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FlowCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `firestoreId` field. */
  firestoreId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Flow` object types. All fields are combined with a logical ‘and.’ */
export type FlowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowFilter>>;
  /** Filter by the object’s `children` relation. */
  children?: InputMaybe<FlowToManyFlowFilter>;
  /** Some related `children` exist. */
  childrenExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` relation. */
  creator?: InputMaybe<UserFilter>;
  /** A related `creator` exists. */
  creatorExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpaceItems` relation. */
  documentSpaceItems?: InputMaybe<FlowToManyDocumentSpaceItemFilter>;
  /** Some related `documentSpaceItems` exist. */
  documentSpaceItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `firestoreId` field. */
  firestoreId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `flowItems` relation. */
  flowItems?: InputMaybe<FlowToManyFlowItemFilter>;
  /** Some related `flowItems` exist. */
  flowItemsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flowSubscriptions` relation. */
  flowSubscriptions?: InputMaybe<FlowToManyFlowSubscriptionFilter>;
  /** Some related `flowSubscriptions` exist. */
  flowSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ftsFlowHits` relation. */
  ftsFlowHits?: InputMaybe<FlowToManyFtsFlowHitFilter>;
  /** Some related `ftsFlowHits` exist. */
  ftsFlowHitsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowFilter>>;
  /** Filter by the object’s `parent` relation. */
  parent?: InputMaybe<FlowFilter>;
  /** A related `parent` exists. */
  parentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `thumbnailUrl` field. */
  thumbnailUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Flow` */
export type FlowInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Optional creating user. Allowed to manage the flow. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  firestoreId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Public-facing name of the flow. */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Flow items add a media element (such as slides, images, or videos) to a given flow. */
export type FlowItem = Node & {
  __typename?: 'FlowItem';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `FlowItem`. */
  creator?: Maybe<User>;
  /** The user that added this media element to the flow. (Optional.) */
  creatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Flow` that is related to this `FlowItem`. */
  flow?: Maybe<Flow>;
  /** The flow to which the media element should be added. */
  flowId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Flows are ordered containers like arrays or lists. Their items are ordered by their `order` attribute. Please use `id` or `created_at` to break ties. */
  order: Scalars['BigFloat']['output'];
  /** Reads a single `DocumentPage` that is related to this `FlowItem`. */
  page?: Maybe<DocumentPage>;
  /** Attached page. (Optional.) */
  pageId?: Maybe<Scalars['BigInt']['output']>;
  sysPeriod: DatetimeRange;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Document` that is related to this `FlowItem`. */
  video?: Maybe<Document>;
  /** Attached video. (Optional.) */
  videoId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `FlowItem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FlowItemCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `flowId` field. */
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `pageId` field. */
  pageId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `videoId` field. */
  videoId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `FlowItem` object types. All fields are combined with a logical ‘and.’ */
export type FlowItemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowItemFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` relation. */
  creator?: InputMaybe<UserFilter>;
  /** A related `creator` exists. */
  creatorExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `flow` relation. */
  flow?: InputMaybe<FlowFilter>;
  /** Filter by the object’s `flowId` field. */
  flowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowItemFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `page` relation. */
  page?: InputMaybe<DocumentPageFilter>;
  /** A related `page` exists. */
  pageExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `pageId` field. */
  pageId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `video` relation. */
  video?: InputMaybe<DocumentFilter>;
  /** A related `video` exists. */
  videoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `videoId` field. */
  videoId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `FlowItem` */
export type FlowItemInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The user that added this media element to the flow. (Optional.) */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The flow to which the media element should be added. */
  flowId: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Flows are ordered containers like arrays or lists. Their items are ordered by their `order` attribute. Please use `id` or `created_at` to break ties. */
  order?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Attached page. (Optional.) */
  pageId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Attached video. (Optional.) */
  videoId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `FlowItem`. Fields that are set will be updated. */
export type FlowItemPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The user that added this media element to the flow. (Optional.) */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The flow to which the media element should be added. */
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Flows are ordered containers like arrays or lists. Their items are ordered by their `order` attribute. Please use `id` or `created_at` to break ties. */
  order?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Attached page. (Optional.) */
  pageId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Attached video. (Optional.) */
  videoId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `FlowItem` values. */
export type FlowItemsConnection = {
  __typename?: 'FlowItemsConnection';
  /** A list of edges which contains the `FlowItem` and cursor to aid in pagination. */
  edges: Array<FlowItemsEdge>;
  /** A list of `FlowItem` objects. */
  nodes: Array<Maybe<FlowItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlowItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FlowItem` edge in the connection. */
export type FlowItemsEdge = {
  __typename?: 'FlowItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FlowItem` at the end of the edge. */
  node?: Maybe<FlowItem>;
};

/** Methods to use when ordering `FlowItem`. */
export enum FlowItemsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorIdAsc = 'CREATOR_ID_ASC',
  CreatorIdDesc = 'CREATOR_ID_DESC',
  DocumentByVideoIdConfigAsc = 'DOCUMENT_BY_VIDEO_ID__CONFIG_ASC',
  DocumentByVideoIdConfigDesc = 'DOCUMENT_BY_VIDEO_ID__CONFIG_DESC',
  DocumentByVideoIdCreatedAtAsc = 'DOCUMENT_BY_VIDEO_ID__CREATED_AT_ASC',
  DocumentByVideoIdCreatedAtDesc = 'DOCUMENT_BY_VIDEO_ID__CREATED_AT_DESC',
  DocumentByVideoIdCreatedByIdAsc = 'DOCUMENT_BY_VIDEO_ID__CREATED_BY_ID_ASC',
  DocumentByVideoIdCreatedByIdDesc = 'DOCUMENT_BY_VIDEO_ID__CREATED_BY_ID_DESC',
  DocumentByVideoIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_VIDEO_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByVideoIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_VIDEO_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByVideoIdDeletedAtAsc = 'DOCUMENT_BY_VIDEO_ID__DELETED_AT_ASC',
  DocumentByVideoIdDeletedAtDesc = 'DOCUMENT_BY_VIDEO_ID__DELETED_AT_DESC',
  DocumentByVideoIdDisplayDateAsc = 'DOCUMENT_BY_VIDEO_ID__DISPLAY_DATE_ASC',
  DocumentByVideoIdDisplayDateDesc = 'DOCUMENT_BY_VIDEO_ID__DISPLAY_DATE_DESC',
  DocumentByVideoIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_VIDEO_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByVideoIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_VIDEO_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByVideoIdDisplayTitleAsc = 'DOCUMENT_BY_VIDEO_ID__DISPLAY_TITLE_ASC',
  DocumentByVideoIdDisplayTitleDesc = 'DOCUMENT_BY_VIDEO_ID__DISPLAY_TITLE_DESC',
  DocumentByVideoIdDoesSupportFlowsAsc = 'DOCUMENT_BY_VIDEO_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByVideoIdDoesSupportFlowsDesc = 'DOCUMENT_BY_VIDEO_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByVideoIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_VIDEO_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByVideoIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_VIDEO_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByVideoIdDownloadUrlAsc = 'DOCUMENT_BY_VIDEO_ID__DOWNLOAD_URL_ASC',
  DocumentByVideoIdDownloadUrlDesc = 'DOCUMENT_BY_VIDEO_ID__DOWNLOAD_URL_DESC',
  DocumentByVideoIdEnableMagicPagesAsc = 'DOCUMENT_BY_VIDEO_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByVideoIdEnableMagicPagesDesc = 'DOCUMENT_BY_VIDEO_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByVideoIdExpirationDateAsc = 'DOCUMENT_BY_VIDEO_ID__EXPIRATION_DATE_ASC',
  DocumentByVideoIdExpirationDateDesc = 'DOCUMENT_BY_VIDEO_ID__EXPIRATION_DATE_DESC',
  DocumentByVideoIdExternalIdAsc = 'DOCUMENT_BY_VIDEO_ID__EXTERNAL_ID_ASC',
  DocumentByVideoIdExternalIdDesc = 'DOCUMENT_BY_VIDEO_ID__EXTERNAL_ID_DESC',
  DocumentByVideoIdExternalLinkIdAsc = 'DOCUMENT_BY_VIDEO_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByVideoIdExternalLinkIdDesc = 'DOCUMENT_BY_VIDEO_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByVideoIdFileNameAsc = 'DOCUMENT_BY_VIDEO_ID__FILE_NAME_ASC',
  DocumentByVideoIdFileNameDesc = 'DOCUMENT_BY_VIDEO_ID__FILE_NAME_DESC',
  DocumentByVideoIdFileSizeAsc = 'DOCUMENT_BY_VIDEO_ID__FILE_SIZE_ASC',
  DocumentByVideoIdFileSizeDesc = 'DOCUMENT_BY_VIDEO_ID__FILE_SIZE_DESC',
  DocumentByVideoIdFirestoreIdAsc = 'DOCUMENT_BY_VIDEO_ID__FIRESTORE_ID_ASC',
  DocumentByVideoIdFirestoreIdDesc = 'DOCUMENT_BY_VIDEO_ID__FIRESTORE_ID_DESC',
  DocumentByVideoIdIdAsc = 'DOCUMENT_BY_VIDEO_ID__ID_ASC',
  DocumentByVideoIdIdDesc = 'DOCUMENT_BY_VIDEO_ID__ID_DESC',
  DocumentByVideoIdIgnoredPagesAsc = 'DOCUMENT_BY_VIDEO_ID__IGNORED_PAGES_ASC',
  DocumentByVideoIdIgnoredPagesDesc = 'DOCUMENT_BY_VIDEO_ID__IGNORED_PAGES_DESC',
  DocumentByVideoIdInitialFileNameAsc = 'DOCUMENT_BY_VIDEO_ID__INITIAL_FILE_NAME_ASC',
  DocumentByVideoIdInitialFileNameDesc = 'DOCUMENT_BY_VIDEO_ID__INITIAL_FILE_NAME_DESC',
  DocumentByVideoIdInternalLinksAsc = 'DOCUMENT_BY_VIDEO_ID__INTERNAL_LINKS_ASC',
  DocumentByVideoIdInternalLinksDesc = 'DOCUMENT_BY_VIDEO_ID__INTERNAL_LINKS_DESC',
  DocumentByVideoIdIsDownloadableAsc = 'DOCUMENT_BY_VIDEO_ID__IS_DOWNLOADABLE_ASC',
  DocumentByVideoIdIsDownloadableDesc = 'DOCUMENT_BY_VIDEO_ID__IS_DOWNLOADABLE_DESC',
  DocumentByVideoIdIsPublishedAsc = 'DOCUMENT_BY_VIDEO_ID__IS_PUBLISHED_ASC',
  DocumentByVideoIdIsPublishedDesc = 'DOCUMENT_BY_VIDEO_ID__IS_PUBLISHED_DESC',
  DocumentByVideoIdLastModifiedAtAsc = 'DOCUMENT_BY_VIDEO_ID__LAST_MODIFIED_AT_ASC',
  DocumentByVideoIdLastModifiedAtDesc = 'DOCUMENT_BY_VIDEO_ID__LAST_MODIFIED_AT_DESC',
  DocumentByVideoIdLastModifiedByIdAsc = 'DOCUMENT_BY_VIDEO_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByVideoIdLastModifiedByIdDesc = 'DOCUMENT_BY_VIDEO_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByVideoIdLegalAppendixIdAsc = 'DOCUMENT_BY_VIDEO_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByVideoIdLegalAppendixIdDesc = 'DOCUMENT_BY_VIDEO_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByVideoIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_VIDEO_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByVideoIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_VIDEO_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByVideoIdLiteratureReferencesAsc = 'DOCUMENT_BY_VIDEO_ID__LITERATURE_REFERENCES_ASC',
  DocumentByVideoIdLiteratureReferencesDesc = 'DOCUMENT_BY_VIDEO_ID__LITERATURE_REFERENCES_DESC',
  DocumentByVideoIdMimeTypeAsc = 'DOCUMENT_BY_VIDEO_ID__MIME_TYPE_ASC',
  DocumentByVideoIdMimeTypeDesc = 'DOCUMENT_BY_VIDEO_ID__MIME_TYPE_DESC',
  DocumentByVideoIdOrderAsc = 'DOCUMENT_BY_VIDEO_ID__ORDER_ASC',
  DocumentByVideoIdOrderDesc = 'DOCUMENT_BY_VIDEO_ID__ORDER_DESC',
  DocumentByVideoIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_VIDEO_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByVideoIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_VIDEO_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByVideoIdOriginalMimeTypeAsc = 'DOCUMENT_BY_VIDEO_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByVideoIdOriginalMimeTypeDesc = 'DOCUMENT_BY_VIDEO_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByVideoIdOriginalStorageIdAsc = 'DOCUMENT_BY_VIDEO_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByVideoIdOriginalStorageIdDesc = 'DOCUMENT_BY_VIDEO_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByVideoIdPagesAsc = 'DOCUMENT_BY_VIDEO_ID__PAGES_ASC',
  DocumentByVideoIdPagesDesc = 'DOCUMENT_BY_VIDEO_ID__PAGES_DESC',
  DocumentByVideoIdStorageIdAsc = 'DOCUMENT_BY_VIDEO_ID__STORAGE_ID_ASC',
  DocumentByVideoIdStorageIdDesc = 'DOCUMENT_BY_VIDEO_ID__STORAGE_ID_DESC',
  DocumentByVideoIdSysPeriodAsc = 'DOCUMENT_BY_VIDEO_ID__SYS_PERIOD_ASC',
  DocumentByVideoIdSysPeriodDesc = 'DOCUMENT_BY_VIDEO_ID__SYS_PERIOD_DESC',
  DocumentByVideoIdTagsAsc = 'DOCUMENT_BY_VIDEO_ID__TAGS_ASC',
  DocumentByVideoIdTagsDesc = 'DOCUMENT_BY_VIDEO_ID__TAGS_DESC',
  DocumentByVideoIdTeaserTextAsc = 'DOCUMENT_BY_VIDEO_ID__TEASER_TEXT_ASC',
  DocumentByVideoIdTeaserTextDesc = 'DOCUMENT_BY_VIDEO_ID__TEASER_TEXT_DESC',
  DocumentByVideoIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_VIDEO_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByVideoIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_VIDEO_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByVideoIdThumbnailStorageIdAsc = 'DOCUMENT_BY_VIDEO_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByVideoIdThumbnailStorageIdDesc = 'DOCUMENT_BY_VIDEO_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByVideoIdTopTitleAsc = 'DOCUMENT_BY_VIDEO_ID__TOP_TITLE_ASC',
  DocumentByVideoIdTopTitleDesc = 'DOCUMENT_BY_VIDEO_ID__TOP_TITLE_DESC',
  DocumentByVideoIdUploadedAtAsc = 'DOCUMENT_BY_VIDEO_ID__UPLOADED_AT_ASC',
  DocumentByVideoIdUploadedAtDesc = 'DOCUMENT_BY_VIDEO_ID__UPLOADED_AT_DESC',
  DocumentByVideoIdWorkspaceIdAsc = 'DOCUMENT_BY_VIDEO_ID__WORKSPACE_ID_ASC',
  DocumentByVideoIdWorkspaceIdDesc = 'DOCUMENT_BY_VIDEO_ID__WORKSPACE_ID_DESC',
  DocumentPageByPageIdCreatedAtAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__CREATED_AT_ASC',
  DocumentPageByPageIdCreatedAtDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__CREATED_AT_DESC',
  DocumentPageByPageIdCrossRevIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__CROSS_REV_ID_ASC',
  DocumentPageByPageIdCrossRevIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__CROSS_REV_ID_DESC',
  DocumentPageByPageIdDocumentIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__DOCUMENT_ID_ASC',
  DocumentPageByPageIdDocumentIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__DOCUMENT_ID_DESC',
  DocumentPageByPageIdExtractedTextAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__EXTRACTED_TEXT_ASC',
  DocumentPageByPageIdExtractedTextDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__EXTRACTED_TEXT_DESC',
  DocumentPageByPageIdIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__ID_ASC',
  DocumentPageByPageIdIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__ID_DESC',
  DocumentPageByPageIdLinkedDocumentIdAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__LINKED_DOCUMENT_ID_ASC',
  DocumentPageByPageIdLinkedDocumentIdDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__LINKED_DOCUMENT_ID_DESC',
  DocumentPageByPageIdPageNumberAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_NUMBER_ASC',
  DocumentPageByPageIdPageNumberDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_NUMBER_DESC',
  DocumentPageByPageIdPageTypeAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_TYPE_ASC',
  DocumentPageByPageIdPageTypeDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__PAGE_TYPE_DESC',
  DocumentPageByPageIdRevisionNumberAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__REVISION_NUMBER_ASC',
  DocumentPageByPageIdRevisionNumberDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__REVISION_NUMBER_DESC',
  DocumentPageByPageIdThumbnailAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__THUMBNAIL_ASC',
  DocumentPageByPageIdThumbnailDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__THUMBNAIL_DESC',
  DocumentPageByPageIdUpdatedAtAsc = 'DOCUMENT_PAGE_BY_PAGE_ID__UPDATED_AT_ASC',
  DocumentPageByPageIdUpdatedAtDesc = 'DOCUMENT_PAGE_BY_PAGE_ID__UPDATED_AT_DESC',
  FlowByFlowIdCreatedAtAsc = 'FLOW_BY_FLOW_ID__CREATED_AT_ASC',
  FlowByFlowIdCreatedAtDesc = 'FLOW_BY_FLOW_ID__CREATED_AT_DESC',
  FlowByFlowIdCreatorIdAsc = 'FLOW_BY_FLOW_ID__CREATOR_ID_ASC',
  FlowByFlowIdCreatorIdDesc = 'FLOW_BY_FLOW_ID__CREATOR_ID_DESC',
  FlowByFlowIdFirestoreIdAsc = 'FLOW_BY_FLOW_ID__FIRESTORE_ID_ASC',
  FlowByFlowIdFirestoreIdDesc = 'FLOW_BY_FLOW_ID__FIRESTORE_ID_DESC',
  FlowByFlowIdIdAsc = 'FLOW_BY_FLOW_ID__ID_ASC',
  FlowByFlowIdIdDesc = 'FLOW_BY_FLOW_ID__ID_DESC',
  FlowByFlowIdParentIdAsc = 'FLOW_BY_FLOW_ID__PARENT_ID_ASC',
  FlowByFlowIdParentIdDesc = 'FLOW_BY_FLOW_ID__PARENT_ID_DESC',
  FlowByFlowIdSysPeriodAsc = 'FLOW_BY_FLOW_ID__SYS_PERIOD_ASC',
  FlowByFlowIdSysPeriodDesc = 'FLOW_BY_FLOW_ID__SYS_PERIOD_DESC',
  FlowByFlowIdThumbnailUrlAsc = 'FLOW_BY_FLOW_ID__THUMBNAIL_URL_ASC',
  FlowByFlowIdThumbnailUrlDesc = 'FLOW_BY_FLOW_ID__THUMBNAIL_URL_DESC',
  FlowByFlowIdTitleAsc = 'FLOW_BY_FLOW_ID__TITLE_ASC',
  FlowByFlowIdTitleDesc = 'FLOW_BY_FLOW_ID__TITLE_DESC',
  FlowByFlowIdUpdatedAtAsc = 'FLOW_BY_FLOW_ID__UPDATED_AT_ASC',
  FlowByFlowIdUpdatedAtDesc = 'FLOW_BY_FLOW_ID__UPDATED_AT_DESC',
  FlowIdAsc = 'FLOW_ID_ASC',
  FlowIdDesc = 'FLOW_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PageIdAsc = 'PAGE_ID_ASC',
  PageIdDesc = 'PAGE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByCreatorIdAppConsentGivenAtAsc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByCreatorIdAppConsentGivenAtDesc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByCreatorIdConfigAsc = 'USER_BY_CREATOR_ID__CONFIG_ASC',
  UserByCreatorIdConfigDesc = 'USER_BY_CREATOR_ID__CONFIG_DESC',
  UserByCreatorIdCreatedAtAsc = 'USER_BY_CREATOR_ID__CREATED_AT_ASC',
  UserByCreatorIdCreatedAtDesc = 'USER_BY_CREATOR_ID__CREATED_AT_DESC',
  UserByCreatorIdCrmContactVisibilityFilterAsc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByCreatorIdCrmContactVisibilityFilterDesc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByCreatorIdDefaultWorkspaceIdAsc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByCreatorIdDefaultWorkspaceIdDesc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByCreatorIdDisabledAsc = 'USER_BY_CREATOR_ID__DISABLED_ASC',
  UserByCreatorIdDisabledDesc = 'USER_BY_CREATOR_ID__DISABLED_DESC',
  UserByCreatorIdDisplayNameAsc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_ASC',
  UserByCreatorIdDisplayNameDesc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_DESC',
  UserByCreatorIdEmailAsc = 'USER_BY_CREATOR_ID__EMAIL_ASC',
  UserByCreatorIdEmailDesc = 'USER_BY_CREATOR_ID__EMAIL_DESC',
  UserByCreatorIdExternalGroupsAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_ASC',
  UserByCreatorIdExternalGroupsDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_DESC',
  UserByCreatorIdExternalGroupsSyncedAtAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByCreatorIdExternalGroupsSyncedAtDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByCreatorIdFirebaseAuthIdAsc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_ASC',
  UserByCreatorIdFirebaseAuthIdDesc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_DESC',
  UserByCreatorIdFlagsAsc = 'USER_BY_CREATOR_ID__FLAGS_ASC',
  UserByCreatorIdFlagsDesc = 'USER_BY_CREATOR_ID__FLAGS_DESC',
  UserByCreatorIdIdAsc = 'USER_BY_CREATOR_ID__ID_ASC',
  UserByCreatorIdIdDesc = 'USER_BY_CREATOR_ID__ID_DESC',
  UserByCreatorIdIsTenantAdminAsc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_ASC',
  UserByCreatorIdIsTenantAdminDesc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_DESC',
  UserByCreatorIdRegisteredAtAsc = 'USER_BY_CREATOR_ID__REGISTERED_AT_ASC',
  UserByCreatorIdRegisteredAtDesc = 'USER_BY_CREATOR_ID__REGISTERED_AT_DESC',
  UserByCreatorIdSysPeriodAsc = 'USER_BY_CREATOR_ID__SYS_PERIOD_ASC',
  UserByCreatorIdSysPeriodDesc = 'USER_BY_CREATOR_ID__SYS_PERIOD_DESC',
  UserByCreatorIdTenantIdAsc = 'USER_BY_CREATOR_ID__TENANT_ID_ASC',
  UserByCreatorIdTenantIdDesc = 'USER_BY_CREATOR_ID__TENANT_ID_DESC',
  UserByCreatorIdUpdatedAtAsc = 'USER_BY_CREATOR_ID__UPDATED_AT_ASC',
  UserByCreatorIdUpdatedAtDesc = 'USER_BY_CREATOR_ID__UPDATED_AT_DESC',
  VideoIdAsc = 'VIDEO_ID_ASC',
  VideoIdDesc = 'VIDEO_ID_DESC'
}

/** Represents an update to a `Flow`. Fields that are set will be updated. */
export type FlowPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Optional creating user. Allowed to manage the flow. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  firestoreId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Public-facing name of the flow. */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FlowSubscription = Node & {
  __typename?: 'FlowSubscription';
  /** Reads a single `Flow` that is related to this `FlowSubscription`. */
  flow?: Maybe<Flow>;
  flowId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  mayEdit: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Team` that is related to this `FlowSubscription`. */
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `User` that is related to this `FlowSubscription`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `FlowSubscription` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FlowSubscriptionCondition = {
  /** Checks for equality with the object’s `flowId` field. */
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `mayEdit` field. */
  mayEdit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `FlowSubscription` object types. All fields are combined with a logical ‘and.’ */
export type FlowSubscriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlowSubscriptionFilter>>;
  /** Filter by the object’s `flow` relation. */
  flow?: InputMaybe<FlowFilter>;
  /** A related `flow` exists. */
  flowExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flowId` field. */
  flowId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `mayEdit` field. */
  mayEdit?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlowSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlowSubscriptionFilter>>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<TeamFilter>;
  /** A related `team` exists. */
  teamExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `FlowSubscription` */
export type FlowSubscriptionInput = {
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  mayEdit?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `FlowSubscription`. Fields that are set will be updated. */
export type FlowSubscriptionPatch = {
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  mayEdit?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `FlowSubscription` values. */
export type FlowSubscriptionsConnection = {
  __typename?: 'FlowSubscriptionsConnection';
  /** A list of edges which contains the `FlowSubscription` and cursor to aid in pagination. */
  edges: Array<FlowSubscriptionsEdge>;
  /** A list of `FlowSubscription` objects. */
  nodes: Array<Maybe<FlowSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlowSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FlowSubscription` edge in the connection. */
export type FlowSubscriptionsEdge = {
  __typename?: 'FlowSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FlowSubscription` at the end of the edge. */
  node?: Maybe<FlowSubscription>;
};

/** Methods to use when ordering `FlowSubscription`. */
export enum FlowSubscriptionsOrderBy {
  FlowByFlowIdCreatedAtAsc = 'FLOW_BY_FLOW_ID__CREATED_AT_ASC',
  FlowByFlowIdCreatedAtDesc = 'FLOW_BY_FLOW_ID__CREATED_AT_DESC',
  FlowByFlowIdCreatorIdAsc = 'FLOW_BY_FLOW_ID__CREATOR_ID_ASC',
  FlowByFlowIdCreatorIdDesc = 'FLOW_BY_FLOW_ID__CREATOR_ID_DESC',
  FlowByFlowIdFirestoreIdAsc = 'FLOW_BY_FLOW_ID__FIRESTORE_ID_ASC',
  FlowByFlowIdFirestoreIdDesc = 'FLOW_BY_FLOW_ID__FIRESTORE_ID_DESC',
  FlowByFlowIdIdAsc = 'FLOW_BY_FLOW_ID__ID_ASC',
  FlowByFlowIdIdDesc = 'FLOW_BY_FLOW_ID__ID_DESC',
  FlowByFlowIdParentIdAsc = 'FLOW_BY_FLOW_ID__PARENT_ID_ASC',
  FlowByFlowIdParentIdDesc = 'FLOW_BY_FLOW_ID__PARENT_ID_DESC',
  FlowByFlowIdSysPeriodAsc = 'FLOW_BY_FLOW_ID__SYS_PERIOD_ASC',
  FlowByFlowIdSysPeriodDesc = 'FLOW_BY_FLOW_ID__SYS_PERIOD_DESC',
  FlowByFlowIdThumbnailUrlAsc = 'FLOW_BY_FLOW_ID__THUMBNAIL_URL_ASC',
  FlowByFlowIdThumbnailUrlDesc = 'FLOW_BY_FLOW_ID__THUMBNAIL_URL_DESC',
  FlowByFlowIdTitleAsc = 'FLOW_BY_FLOW_ID__TITLE_ASC',
  FlowByFlowIdTitleDesc = 'FLOW_BY_FLOW_ID__TITLE_DESC',
  FlowByFlowIdUpdatedAtAsc = 'FLOW_BY_FLOW_ID__UPDATED_AT_ASC',
  FlowByFlowIdUpdatedAtDesc = 'FLOW_BY_FLOW_ID__UPDATED_AT_DESC',
  FlowIdAsc = 'FLOW_ID_ASC',
  FlowIdDesc = 'FLOW_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MayEditAsc = 'MAY_EDIT_ASC',
  MayEditDesc = 'MAY_EDIT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TeamByTeamIdAnalyticsAliasAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamByTeamIdAnalyticsAliasDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamByTeamIdAnalyticsEnabledAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamByTeamIdAnalyticsEnabledDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamByTeamIdCreatedAtAsc = 'TEAM_BY_TEAM_ID__CREATED_AT_ASC',
  TeamByTeamIdCreatedAtDesc = 'TEAM_BY_TEAM_ID__CREATED_AT_DESC',
  TeamByTeamIdFlagsAsc = 'TEAM_BY_TEAM_ID__FLAGS_ASC',
  TeamByTeamIdFlagsDesc = 'TEAM_BY_TEAM_ID__FLAGS_DESC',
  TeamByTeamIdIdAsc = 'TEAM_BY_TEAM_ID__ID_ASC',
  TeamByTeamIdIdDesc = 'TEAM_BY_TEAM_ID__ID_DESC',
  TeamByTeamIdIsOpenAsc = 'TEAM_BY_TEAM_ID__IS_OPEN_ASC',
  TeamByTeamIdIsOpenDesc = 'TEAM_BY_TEAM_ID__IS_OPEN_DESC',
  TeamByTeamIdIsVisibleAsc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_ASC',
  TeamByTeamIdIsVisibleDesc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_DESC',
  TeamByTeamIdMemberCountAsc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_ASC',
  TeamByTeamIdMemberCountDesc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_DESC',
  TeamByTeamIdNameAsc = 'TEAM_BY_TEAM_ID__NAME_ASC',
  TeamByTeamIdNameDesc = 'TEAM_BY_TEAM_ID__NAME_DESC',
  TeamByTeamIdNameLowercaseAsc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  TeamByTeamIdNameLowercaseDesc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  TeamByTeamIdSysPeriodAsc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_ASC',
  TeamByTeamIdSysPeriodDesc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_DESC',
  TeamByTeamIdTenantIdAsc = 'TEAM_BY_TEAM_ID__TENANT_ID_ASC',
  TeamByTeamIdTenantIdDesc = 'TEAM_BY_TEAM_ID__TENANT_ID_DESC',
  TeamByTeamIdTotalMemberCountAsc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamByTeamIdTotalMemberCountDesc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamByTeamIdUpdatedAtAsc = 'TEAM_BY_TEAM_ID__UPDATED_AT_ASC',
  TeamByTeamIdUpdatedAtDesc = 'TEAM_BY_TEAM_ID__UPDATED_AT_DESC',
  TeamByTeamIdUserConfigDefaultsAsc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamByTeamIdUserConfigDefaultsDesc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against many `DocumentSpaceItem` object types. All fields are combined with a logical ‘and.’ */
export type FlowToManyDocumentSpaceItemFilter = {
  /** Every related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceItemFilter>;
  /** No related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceItemFilter>;
  /** Some related `DocumentSpaceItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceItemFilter>;
};

/** A filter to be used against many `Flow` object types. All fields are combined with a logical ‘and.’ */
export type FlowToManyFlowFilter = {
  /** Every related `Flow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowFilter>;
  /** No related `Flow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowFilter>;
  /** Some related `Flow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowFilter>;
};

/** A filter to be used against many `FlowItem` object types. All fields are combined with a logical ‘and.’ */
export type FlowToManyFlowItemFilter = {
  /** Every related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowItemFilter>;
  /** No related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowItemFilter>;
  /** Some related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowItemFilter>;
};

/** A filter to be used against many `FlowSubscription` object types. All fields are combined with a logical ‘and.’ */
export type FlowToManyFlowSubscriptionFilter = {
  /** Every related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowSubscriptionFilter>;
  /** No related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowSubscriptionFilter>;
  /** Some related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowSubscriptionFilter>;
};

/** A filter to be used against many `FtsFlowHit` object types. All fields are combined with a logical ‘and.’ */
export type FlowToManyFtsFlowHitFilter = {
  /** Every related `FtsFlowHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FtsFlowHitFilter>;
  /** No related `FtsFlowHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FtsFlowHitFilter>;
  /** Some related `FtsFlowHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FtsFlowHitFilter>;
};

/** A connection to a list of `Flow` values. */
export type FlowsConnection = {
  __typename?: 'FlowsConnection';
  /** A list of edges which contains the `Flow` and cursor to aid in pagination. */
  edges: Array<FlowsEdge>;
  /** A list of `Flow` objects. */
  nodes: Array<Maybe<Flow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Flow` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Flow` edge in the connection. */
export type FlowsEdge = {
  __typename?: 'FlowsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Flow` at the end of the edge. */
  node?: Maybe<Flow>;
};

/** Methods to use when ordering `Flow`. */
export enum FlowsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorIdAsc = 'CREATOR_ID_ASC',
  CreatorIdDesc = 'CREATOR_ID_DESC',
  DocumentSpaceItemsByFlowIdCountAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__COUNT_ASC',
  DocumentSpaceItemsByFlowIdCountDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__COUNT_DESC',
  DocumentSpaceItemsByFlowIdMaxAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_ADDED_AT_ASC',
  DocumentSpaceItemsByFlowIdMaxAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_ADDED_AT_DESC',
  DocumentSpaceItemsByFlowIdMaxDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_DOCUMENT_ID_ASC',
  DocumentSpaceItemsByFlowIdMaxDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_DOCUMENT_ID_DESC',
  DocumentSpaceItemsByFlowIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsByFlowIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsByFlowIdMaxFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_FLOW_ID_ASC',
  DocumentSpaceItemsByFlowIdMaxFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_FLOW_ID_DESC',
  DocumentSpaceItemsByFlowIdMaxIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_ID_ASC',
  DocumentSpaceItemsByFlowIdMaxIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_ID_DESC',
  DocumentSpaceItemsByFlowIdMaxPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_POSITION_ASC',
  DocumentSpaceItemsByFlowIdMaxPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_POSITION_DESC',
  DocumentSpaceItemsByFlowIdMaxSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_SECTION_ID_ASC',
  DocumentSpaceItemsByFlowIdMaxSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_SECTION_ID_DESC',
  DocumentSpaceItemsByFlowIdMaxSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpaceItemsByFlowIdMaxSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpaceItemsByFlowIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceItemsByFlowIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceItemsByFlowIdMinAddedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_ADDED_AT_ASC',
  DocumentSpaceItemsByFlowIdMinAddedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_ADDED_AT_DESC',
  DocumentSpaceItemsByFlowIdMinDocumentIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_DOCUMENT_ID_ASC',
  DocumentSpaceItemsByFlowIdMinDocumentIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_DOCUMENT_ID_DESC',
  DocumentSpaceItemsByFlowIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceItemsByFlowIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceItemsByFlowIdMinFlowIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_FLOW_ID_ASC',
  DocumentSpaceItemsByFlowIdMinFlowIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_FLOW_ID_DESC',
  DocumentSpaceItemsByFlowIdMinIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_ID_ASC',
  DocumentSpaceItemsByFlowIdMinIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_ID_DESC',
  DocumentSpaceItemsByFlowIdMinPositionAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_POSITION_ASC',
  DocumentSpaceItemsByFlowIdMinPositionDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_POSITION_DESC',
  DocumentSpaceItemsByFlowIdMinSectionIdAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_SECTION_ID_ASC',
  DocumentSpaceItemsByFlowIdMinSectionIdDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_SECTION_ID_DESC',
  DocumentSpaceItemsByFlowIdMinSysPeriodAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpaceItemsByFlowIdMinSysPeriodDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpaceItemsByFlowIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceItemsByFlowIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ITEMS_BY_FLOW_ID__MIN_UPDATED_AT_DESC',
  FirestoreIdAsc = 'FIRESTORE_ID_ASC',
  FirestoreIdDesc = 'FIRESTORE_ID_DESC',
  FlowsByParentIdCountAsc = 'FLOWS_BY_PARENT_ID__COUNT_ASC',
  FlowsByParentIdCountDesc = 'FLOWS_BY_PARENT_ID__COUNT_DESC',
  FlowsByParentIdMaxCreatedAtAsc = 'FLOWS_BY_PARENT_ID__MAX_CREATED_AT_ASC',
  FlowsByParentIdMaxCreatedAtDesc = 'FLOWS_BY_PARENT_ID__MAX_CREATED_AT_DESC',
  FlowsByParentIdMaxCreatorIdAsc = 'FLOWS_BY_PARENT_ID__MAX_CREATOR_ID_ASC',
  FlowsByParentIdMaxCreatorIdDesc = 'FLOWS_BY_PARENT_ID__MAX_CREATOR_ID_DESC',
  FlowsByParentIdMaxFirestoreIdAsc = 'FLOWS_BY_PARENT_ID__MAX_FIRESTORE_ID_ASC',
  FlowsByParentIdMaxFirestoreIdDesc = 'FLOWS_BY_PARENT_ID__MAX_FIRESTORE_ID_DESC',
  FlowsByParentIdMaxIdAsc = 'FLOWS_BY_PARENT_ID__MAX_ID_ASC',
  FlowsByParentIdMaxIdDesc = 'FLOWS_BY_PARENT_ID__MAX_ID_DESC',
  FlowsByParentIdMaxParentIdAsc = 'FLOWS_BY_PARENT_ID__MAX_PARENT_ID_ASC',
  FlowsByParentIdMaxParentIdDesc = 'FLOWS_BY_PARENT_ID__MAX_PARENT_ID_DESC',
  FlowsByParentIdMaxSysPeriodAsc = 'FLOWS_BY_PARENT_ID__MAX_SYS_PERIOD_ASC',
  FlowsByParentIdMaxSysPeriodDesc = 'FLOWS_BY_PARENT_ID__MAX_SYS_PERIOD_DESC',
  FlowsByParentIdMaxTitleAsc = 'FLOWS_BY_PARENT_ID__MAX_TITLE_ASC',
  FlowsByParentIdMaxTitleDesc = 'FLOWS_BY_PARENT_ID__MAX_TITLE_DESC',
  FlowsByParentIdMaxUpdatedAtAsc = 'FLOWS_BY_PARENT_ID__MAX_UPDATED_AT_ASC',
  FlowsByParentIdMaxUpdatedAtDesc = 'FLOWS_BY_PARENT_ID__MAX_UPDATED_AT_DESC',
  FlowsByParentIdMinCreatedAtAsc = 'FLOWS_BY_PARENT_ID__MIN_CREATED_AT_ASC',
  FlowsByParentIdMinCreatedAtDesc = 'FLOWS_BY_PARENT_ID__MIN_CREATED_AT_DESC',
  FlowsByParentIdMinCreatorIdAsc = 'FLOWS_BY_PARENT_ID__MIN_CREATOR_ID_ASC',
  FlowsByParentIdMinCreatorIdDesc = 'FLOWS_BY_PARENT_ID__MIN_CREATOR_ID_DESC',
  FlowsByParentIdMinFirestoreIdAsc = 'FLOWS_BY_PARENT_ID__MIN_FIRESTORE_ID_ASC',
  FlowsByParentIdMinFirestoreIdDesc = 'FLOWS_BY_PARENT_ID__MIN_FIRESTORE_ID_DESC',
  FlowsByParentIdMinIdAsc = 'FLOWS_BY_PARENT_ID__MIN_ID_ASC',
  FlowsByParentIdMinIdDesc = 'FLOWS_BY_PARENT_ID__MIN_ID_DESC',
  FlowsByParentIdMinParentIdAsc = 'FLOWS_BY_PARENT_ID__MIN_PARENT_ID_ASC',
  FlowsByParentIdMinParentIdDesc = 'FLOWS_BY_PARENT_ID__MIN_PARENT_ID_DESC',
  FlowsByParentIdMinSysPeriodAsc = 'FLOWS_BY_PARENT_ID__MIN_SYS_PERIOD_ASC',
  FlowsByParentIdMinSysPeriodDesc = 'FLOWS_BY_PARENT_ID__MIN_SYS_PERIOD_DESC',
  FlowsByParentIdMinTitleAsc = 'FLOWS_BY_PARENT_ID__MIN_TITLE_ASC',
  FlowsByParentIdMinTitleDesc = 'FLOWS_BY_PARENT_ID__MIN_TITLE_DESC',
  FlowsByParentIdMinUpdatedAtAsc = 'FLOWS_BY_PARENT_ID__MIN_UPDATED_AT_ASC',
  FlowsByParentIdMinUpdatedAtDesc = 'FLOWS_BY_PARENT_ID__MIN_UPDATED_AT_DESC',
  FlowByParentIdCreatedAtAsc = 'FLOW_BY_PARENT_ID__CREATED_AT_ASC',
  FlowByParentIdCreatedAtDesc = 'FLOW_BY_PARENT_ID__CREATED_AT_DESC',
  FlowByParentIdCreatorIdAsc = 'FLOW_BY_PARENT_ID__CREATOR_ID_ASC',
  FlowByParentIdCreatorIdDesc = 'FLOW_BY_PARENT_ID__CREATOR_ID_DESC',
  FlowByParentIdFirestoreIdAsc = 'FLOW_BY_PARENT_ID__FIRESTORE_ID_ASC',
  FlowByParentIdFirestoreIdDesc = 'FLOW_BY_PARENT_ID__FIRESTORE_ID_DESC',
  FlowByParentIdIdAsc = 'FLOW_BY_PARENT_ID__ID_ASC',
  FlowByParentIdIdDesc = 'FLOW_BY_PARENT_ID__ID_DESC',
  FlowByParentIdParentIdAsc = 'FLOW_BY_PARENT_ID__PARENT_ID_ASC',
  FlowByParentIdParentIdDesc = 'FLOW_BY_PARENT_ID__PARENT_ID_DESC',
  FlowByParentIdSysPeriodAsc = 'FLOW_BY_PARENT_ID__SYS_PERIOD_ASC',
  FlowByParentIdSysPeriodDesc = 'FLOW_BY_PARENT_ID__SYS_PERIOD_DESC',
  FlowByParentIdThumbnailUrlAsc = 'FLOW_BY_PARENT_ID__THUMBNAIL_URL_ASC',
  FlowByParentIdThumbnailUrlDesc = 'FLOW_BY_PARENT_ID__THUMBNAIL_URL_DESC',
  FlowByParentIdTitleAsc = 'FLOW_BY_PARENT_ID__TITLE_ASC',
  FlowByParentIdTitleDesc = 'FLOW_BY_PARENT_ID__TITLE_DESC',
  FlowByParentIdUpdatedAtAsc = 'FLOW_BY_PARENT_ID__UPDATED_AT_ASC',
  FlowByParentIdUpdatedAtDesc = 'FLOW_BY_PARENT_ID__UPDATED_AT_DESC',
  FlowItemsByFlowIdCountAsc = 'FLOW_ITEMS_BY_FLOW_ID__COUNT_ASC',
  FlowItemsByFlowIdCountDesc = 'FLOW_ITEMS_BY_FLOW_ID__COUNT_DESC',
  FlowItemsByFlowIdMaxCreatedAtAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_CREATED_AT_ASC',
  FlowItemsByFlowIdMaxCreatedAtDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_CREATED_AT_DESC',
  FlowItemsByFlowIdMaxCreatorIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_CREATOR_ID_ASC',
  FlowItemsByFlowIdMaxCreatorIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_CREATOR_ID_DESC',
  FlowItemsByFlowIdMaxFlowIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_FLOW_ID_ASC',
  FlowItemsByFlowIdMaxFlowIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_FLOW_ID_DESC',
  FlowItemsByFlowIdMaxIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_ID_ASC',
  FlowItemsByFlowIdMaxIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_ID_DESC',
  FlowItemsByFlowIdMaxOrderAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_ORDER_ASC',
  FlowItemsByFlowIdMaxOrderDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_ORDER_DESC',
  FlowItemsByFlowIdMaxPageIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_PAGE_ID_ASC',
  FlowItemsByFlowIdMaxPageIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_PAGE_ID_DESC',
  FlowItemsByFlowIdMaxSysPeriodAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_SYS_PERIOD_ASC',
  FlowItemsByFlowIdMaxSysPeriodDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_SYS_PERIOD_DESC',
  FlowItemsByFlowIdMaxUpdatedAtAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_UPDATED_AT_ASC',
  FlowItemsByFlowIdMaxUpdatedAtDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_UPDATED_AT_DESC',
  FlowItemsByFlowIdMaxVideoIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_VIDEO_ID_ASC',
  FlowItemsByFlowIdMaxVideoIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MAX_VIDEO_ID_DESC',
  FlowItemsByFlowIdMinCreatedAtAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_CREATED_AT_ASC',
  FlowItemsByFlowIdMinCreatedAtDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_CREATED_AT_DESC',
  FlowItemsByFlowIdMinCreatorIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_CREATOR_ID_ASC',
  FlowItemsByFlowIdMinCreatorIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_CREATOR_ID_DESC',
  FlowItemsByFlowIdMinFlowIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_FLOW_ID_ASC',
  FlowItemsByFlowIdMinFlowIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_FLOW_ID_DESC',
  FlowItemsByFlowIdMinIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_ID_ASC',
  FlowItemsByFlowIdMinIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_ID_DESC',
  FlowItemsByFlowIdMinOrderAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_ORDER_ASC',
  FlowItemsByFlowIdMinOrderDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_ORDER_DESC',
  FlowItemsByFlowIdMinPageIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_PAGE_ID_ASC',
  FlowItemsByFlowIdMinPageIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_PAGE_ID_DESC',
  FlowItemsByFlowIdMinSysPeriodAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_SYS_PERIOD_ASC',
  FlowItemsByFlowIdMinSysPeriodDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_SYS_PERIOD_DESC',
  FlowItemsByFlowIdMinUpdatedAtAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_UPDATED_AT_ASC',
  FlowItemsByFlowIdMinUpdatedAtDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_UPDATED_AT_DESC',
  FlowItemsByFlowIdMinVideoIdAsc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_VIDEO_ID_ASC',
  FlowItemsByFlowIdMinVideoIdDesc = 'FLOW_ITEMS_BY_FLOW_ID__MIN_VIDEO_ID_DESC',
  FlowSubscriptionsByFlowIdCountAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__COUNT_ASC',
  FlowSubscriptionsByFlowIdCountDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__COUNT_DESC',
  FlowSubscriptionsByFlowIdMaxFlowIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_FLOW_ID_ASC',
  FlowSubscriptionsByFlowIdMaxFlowIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_FLOW_ID_DESC',
  FlowSubscriptionsByFlowIdMaxIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_ID_ASC',
  FlowSubscriptionsByFlowIdMaxIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_ID_DESC',
  FlowSubscriptionsByFlowIdMaxMayEditAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_MAY_EDIT_ASC',
  FlowSubscriptionsByFlowIdMaxMayEditDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_MAY_EDIT_DESC',
  FlowSubscriptionsByFlowIdMaxTeamIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_TEAM_ID_ASC',
  FlowSubscriptionsByFlowIdMaxTeamIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_TEAM_ID_DESC',
  FlowSubscriptionsByFlowIdMaxUserIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_USER_ID_ASC',
  FlowSubscriptionsByFlowIdMaxUserIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MAX_USER_ID_DESC',
  FlowSubscriptionsByFlowIdMinFlowIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_FLOW_ID_ASC',
  FlowSubscriptionsByFlowIdMinFlowIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_FLOW_ID_DESC',
  FlowSubscriptionsByFlowIdMinIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_ID_ASC',
  FlowSubscriptionsByFlowIdMinIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_ID_DESC',
  FlowSubscriptionsByFlowIdMinMayEditAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_MAY_EDIT_ASC',
  FlowSubscriptionsByFlowIdMinMayEditDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_MAY_EDIT_DESC',
  FlowSubscriptionsByFlowIdMinTeamIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_TEAM_ID_ASC',
  FlowSubscriptionsByFlowIdMinTeamIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_TEAM_ID_DESC',
  FlowSubscriptionsByFlowIdMinUserIdAsc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_USER_ID_ASC',
  FlowSubscriptionsByFlowIdMinUserIdDesc = 'FLOW_SUBSCRIPTIONS_BY_FLOW_ID__MIN_USER_ID_DESC',
  FtsFlowHitsByFlowIdCountAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__COUNT_ASC',
  FtsFlowHitsByFlowIdCountDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__COUNT_DESC',
  FtsFlowHitsByFlowIdMaxBestPageScoreAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_BEST_PAGE_SCORE_ASC',
  FtsFlowHitsByFlowIdMaxBestPageScoreDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_BEST_PAGE_SCORE_DESC',
  FtsFlowHitsByFlowIdMaxFlowIdAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_FLOW_ID_ASC',
  FtsFlowHitsByFlowIdMaxFlowIdDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_FLOW_ID_DESC',
  FtsFlowHitsByFlowIdMaxPageHitsAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_PAGE_HITS_ASC',
  FtsFlowHitsByFlowIdMaxPageHitsDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_PAGE_HITS_DESC',
  FtsFlowHitsByFlowIdMaxTitleAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TITLE_ASC',
  FtsFlowHitsByFlowIdMaxTitleDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TITLE_DESC',
  FtsFlowHitsByFlowIdMaxTitleHeadlineAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TITLE_HEADLINE_ASC',
  FtsFlowHitsByFlowIdMaxTitleHeadlineDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TITLE_HEADLINE_DESC',
  FtsFlowHitsByFlowIdMaxTitleScoreAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TITLE_SCORE_ASC',
  FtsFlowHitsByFlowIdMaxTitleScoreDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TITLE_SCORE_DESC',
  FtsFlowHitsByFlowIdMaxTotalMatchingPagesAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TOTAL_MATCHING_PAGES_ASC',
  FtsFlowHitsByFlowIdMaxTotalMatchingPagesDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TOTAL_MATCHING_PAGES_DESC',
  FtsFlowHitsByFlowIdMaxTotalScoreAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TOTAL_SCORE_ASC',
  FtsFlowHitsByFlowIdMaxTotalScoreDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MAX_TOTAL_SCORE_DESC',
  FtsFlowHitsByFlowIdMinBestPageScoreAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_BEST_PAGE_SCORE_ASC',
  FtsFlowHitsByFlowIdMinBestPageScoreDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_BEST_PAGE_SCORE_DESC',
  FtsFlowHitsByFlowIdMinFlowIdAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_FLOW_ID_ASC',
  FtsFlowHitsByFlowIdMinFlowIdDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_FLOW_ID_DESC',
  FtsFlowHitsByFlowIdMinPageHitsAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_PAGE_HITS_ASC',
  FtsFlowHitsByFlowIdMinPageHitsDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_PAGE_HITS_DESC',
  FtsFlowHitsByFlowIdMinTitleAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TITLE_ASC',
  FtsFlowHitsByFlowIdMinTitleDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TITLE_DESC',
  FtsFlowHitsByFlowIdMinTitleHeadlineAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TITLE_HEADLINE_ASC',
  FtsFlowHitsByFlowIdMinTitleHeadlineDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TITLE_HEADLINE_DESC',
  FtsFlowHitsByFlowIdMinTitleScoreAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TITLE_SCORE_ASC',
  FtsFlowHitsByFlowIdMinTitleScoreDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TITLE_SCORE_DESC',
  FtsFlowHitsByFlowIdMinTotalMatchingPagesAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TOTAL_MATCHING_PAGES_ASC',
  FtsFlowHitsByFlowIdMinTotalMatchingPagesDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TOTAL_MATCHING_PAGES_DESC',
  FtsFlowHitsByFlowIdMinTotalScoreAsc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TOTAL_SCORE_ASC',
  FtsFlowHitsByFlowIdMinTotalScoreDesc = 'FTS_FLOW_HITS_BY_FLOW_ID__MIN_TOTAL_SCORE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByCreatorIdAppConsentGivenAtAsc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByCreatorIdAppConsentGivenAtDesc = 'USER_BY_CREATOR_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByCreatorIdConfigAsc = 'USER_BY_CREATOR_ID__CONFIG_ASC',
  UserByCreatorIdConfigDesc = 'USER_BY_CREATOR_ID__CONFIG_DESC',
  UserByCreatorIdCreatedAtAsc = 'USER_BY_CREATOR_ID__CREATED_AT_ASC',
  UserByCreatorIdCreatedAtDesc = 'USER_BY_CREATOR_ID__CREATED_AT_DESC',
  UserByCreatorIdCrmContactVisibilityFilterAsc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByCreatorIdCrmContactVisibilityFilterDesc = 'USER_BY_CREATOR_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByCreatorIdDefaultWorkspaceIdAsc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByCreatorIdDefaultWorkspaceIdDesc = 'USER_BY_CREATOR_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByCreatorIdDisabledAsc = 'USER_BY_CREATOR_ID__DISABLED_ASC',
  UserByCreatorIdDisabledDesc = 'USER_BY_CREATOR_ID__DISABLED_DESC',
  UserByCreatorIdDisplayNameAsc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_ASC',
  UserByCreatorIdDisplayNameDesc = 'USER_BY_CREATOR_ID__DISPLAY_NAME_DESC',
  UserByCreatorIdEmailAsc = 'USER_BY_CREATOR_ID__EMAIL_ASC',
  UserByCreatorIdEmailDesc = 'USER_BY_CREATOR_ID__EMAIL_DESC',
  UserByCreatorIdExternalGroupsAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_ASC',
  UserByCreatorIdExternalGroupsDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_DESC',
  UserByCreatorIdExternalGroupsSyncedAtAsc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByCreatorIdExternalGroupsSyncedAtDesc = 'USER_BY_CREATOR_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByCreatorIdFirebaseAuthIdAsc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_ASC',
  UserByCreatorIdFirebaseAuthIdDesc = 'USER_BY_CREATOR_ID__FIREBASE_AUTH_ID_DESC',
  UserByCreatorIdFlagsAsc = 'USER_BY_CREATOR_ID__FLAGS_ASC',
  UserByCreatorIdFlagsDesc = 'USER_BY_CREATOR_ID__FLAGS_DESC',
  UserByCreatorIdIdAsc = 'USER_BY_CREATOR_ID__ID_ASC',
  UserByCreatorIdIdDesc = 'USER_BY_CREATOR_ID__ID_DESC',
  UserByCreatorIdIsTenantAdminAsc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_ASC',
  UserByCreatorIdIsTenantAdminDesc = 'USER_BY_CREATOR_ID__IS_TENANT_ADMIN_DESC',
  UserByCreatorIdRegisteredAtAsc = 'USER_BY_CREATOR_ID__REGISTERED_AT_ASC',
  UserByCreatorIdRegisteredAtDesc = 'USER_BY_CREATOR_ID__REGISTERED_AT_DESC',
  UserByCreatorIdSysPeriodAsc = 'USER_BY_CREATOR_ID__SYS_PERIOD_ASC',
  UserByCreatorIdSysPeriodDesc = 'USER_BY_CREATOR_ID__SYS_PERIOD_DESC',
  UserByCreatorIdTenantIdAsc = 'USER_BY_CREATOR_ID__TENANT_ID_ASC',
  UserByCreatorIdTenantIdDesc = 'USER_BY_CREATOR_ID__TENANT_ID_DESC',
  UserByCreatorIdUpdatedAtAsc = 'USER_BY_CREATOR_ID__UPDATED_AT_ASC',
  UserByCreatorIdUpdatedAtDesc = 'USER_BY_CREATOR_ID__UPDATED_AT_DESC'
}

export type FtsDocumentHit = {
  __typename?: 'FtsDocumentHit';
  bestPageScore?: Maybe<Scalars['Float']['output']>;
  /** Reads a single `Document` that is related to this `FtsDocumentHit`. */
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  documentScore?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileNameHeadline?: Maybe<Scalars['String']['output']>;
  matchingTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageHits?: Maybe<Array<Maybe<FtsPageHit>>>;
  tagScore?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHeadline?: Maybe<Scalars['String']['output']>;
  totalMatchingPages?: Maybe<Scalars['BigInt']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `FtsDocumentHit` object types. All fields are combined with a logical ‘and.’ */
export type FtsDocumentHitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FtsDocumentHitFilter>>;
  /** Filter by the object’s `bestPageScore` field. */
  bestPageScore?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentScore` field. */
  documentScore?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `fileName` field. */
  fileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileNameHeadline` field. */
  fileNameHeadline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `matchingTags` field. */
  matchingTags?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FtsDocumentHitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FtsDocumentHitFilter>>;
  /** Filter by the object’s `tagScore` field. */
  tagScore?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `titleHeadline` field. */
  titleHeadline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `totalMatchingPages` field. */
  totalMatchingPages?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalScore` field. */
  totalScore?: InputMaybe<FloatFilter>;
};

/** A connection to a list of `FtsDocumentHit` values. */
export type FtsDocumentHitsConnection = {
  __typename?: 'FtsDocumentHitsConnection';
  /** A list of edges which contains the `FtsDocumentHit` and cursor to aid in pagination. */
  edges: Array<FtsDocumentHitsEdge>;
  /** A list of `FtsDocumentHit` objects. */
  nodes: Array<Maybe<FtsDocumentHit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FtsDocumentHit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FtsDocumentHit` edge in the connection. */
export type FtsDocumentHitsEdge = {
  __typename?: 'FtsDocumentHitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FtsDocumentHit` at the end of the edge. */
  node?: Maybe<FtsDocumentHit>;
};

export type FtsDocumentSpaceHit = {
  __typename?: 'FtsDocumentSpaceHit';
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `FtsDocumentSpaceHit`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  nameOfCrmContact?: Maybe<Scalars['String']['output']>;
  nameOfCrmContactHeadline?: Maybe<Scalars['String']['output']>;
  nameOfSpace?: Maybe<Scalars['String']['output']>;
  nameOfSpaceHeadline?: Maybe<Scalars['String']['output']>;
  personalMessage?: Maybe<Scalars['String']['output']>;
  personalMessageHeadline?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `FtsDocumentSpaceHit` object types. All fields are combined with a logical ‘and.’ */
export type FtsDocumentSpaceHitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FtsDocumentSpaceHitFilter>>;
  /** Filter by the object’s `detectedLanguage` field. */
  detectedLanguage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nameOfCrmContact` field. */
  nameOfCrmContact?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameOfCrmContactHeadline` field. */
  nameOfCrmContactHeadline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameOfSpace` field. */
  nameOfSpace?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameOfSpaceHeadline` field. */
  nameOfSpaceHeadline?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FtsDocumentSpaceHitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FtsDocumentSpaceHitFilter>>;
  /** Filter by the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `personalMessageHeadline` field. */
  personalMessageHeadline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `totalScore` field. */
  totalScore?: InputMaybe<FloatFilter>;
};

/** A connection to a list of `FtsDocumentSpaceHit` values. */
export type FtsDocumentSpaceHitsConnection = {
  __typename?: 'FtsDocumentSpaceHitsConnection';
  /** A list of edges which contains the `FtsDocumentSpaceHit` and cursor to aid in pagination. */
  edges: Array<FtsDocumentSpaceHitsEdge>;
  /** A list of `FtsDocumentSpaceHit` objects. */
  nodes: Array<Maybe<FtsDocumentSpaceHit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FtsDocumentSpaceHit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FtsDocumentSpaceHit` edge in the connection. */
export type FtsDocumentSpaceHitsEdge = {
  __typename?: 'FtsDocumentSpaceHitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FtsDocumentSpaceHit` at the end of the edge. */
  node?: Maybe<FtsDocumentSpaceHit>;
};

export type FtsFlowHit = {
  __typename?: 'FtsFlowHit';
  bestPageScore?: Maybe<Scalars['Float']['output']>;
  /** Reads a single `Flow` that is related to this `FtsFlowHit`. */
  flow?: Maybe<Flow>;
  flowId?: Maybe<Scalars['BigInt']['output']>;
  pageHits?: Maybe<Array<Maybe<FtsPageHit>>>;
  title?: Maybe<Scalars['String']['output']>;
  titleHeadline?: Maybe<Scalars['String']['output']>;
  titleScore?: Maybe<Scalars['Float']['output']>;
  totalMatchingPages?: Maybe<Scalars['BigInt']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `FtsFlowHit` object types. All fields are combined with a logical ‘and.’ */
export type FtsFlowHitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FtsFlowHitFilter>>;
  /** Filter by the object’s `bestPageScore` field. */
  bestPageScore?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `flow` relation. */
  flow?: InputMaybe<FlowFilter>;
  /** A related `flow` exists. */
  flowExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flowId` field. */
  flowId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FtsFlowHitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FtsFlowHitFilter>>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `titleHeadline` field. */
  titleHeadline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `titleScore` field. */
  titleScore?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `totalMatchingPages` field. */
  totalMatchingPages?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalScore` field. */
  totalScore?: InputMaybe<FloatFilter>;
};

/** A connection to a list of `FtsFlowHit` values. */
export type FtsFlowHitsConnection = {
  __typename?: 'FtsFlowHitsConnection';
  /** A list of edges which contains the `FtsFlowHit` and cursor to aid in pagination. */
  edges: Array<FtsFlowHitsEdge>;
  /** A list of `FtsFlowHit` objects. */
  nodes: Array<Maybe<FtsFlowHit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FtsFlowHit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FtsFlowHit` edge in the connection. */
export type FtsFlowHitsEdge = {
  __typename?: 'FtsFlowHitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FtsFlowHit` at the end of the edge. */
  node?: Maybe<FtsFlowHit>;
};

export enum FtsLanguage {
  DutchWords = 'DUTCH_WORDS',
  EnglishWords = 'ENGLISH_WORDS',
  FrenchWords = 'FRENCH_WORDS',
  GermanWords = 'GERMAN_WORDS',
  ItalianWords = 'ITALIAN_WORDS',
  PortugueseWords = 'PORTUGUESE_WORDS'
}

export type FtsPageHit = {
  __typename?: 'FtsPageHit';
  headline?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentPage` that is related to this `FtsPageHit`. */
  page?: Maybe<DocumentPage>;
  pageId?: Maybe<Scalars['BigInt']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `FtsPageHit` object types. All fields are combined with a logical ‘and.’ */
export type FtsPageHitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FtsPageHitFilter>>;
  /** Filter by the object’s `headline` field. */
  headline?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FtsPageHitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FtsPageHitFilter>>;
  /** Filter by the object’s `page` relation. */
  page?: InputMaybe<DocumentPageFilter>;
  /** A related `page` exists. */
  pageExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `pageId` field. */
  pageId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<FloatFilter>;
};

/** All input for the `generateCodeForAccessCard` mutation. */
export type GenerateCodeForAccessCardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  failIfBlank?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `generateCodeForAccessCard` mutation. */
export type GenerateCodeForAccessCardPayload = {
  __typename?: 'GenerateCodeForAccessCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpace`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `User` that is related to this `DocumentSpace`. */
  creator?: Maybe<User>;
  documentSpace?: Maybe<DocumentSpace>;
  /** An edge for our `DocumentSpace`. May be used by Relay 1. */
  documentSpaceEdge?: Maybe<DocumentSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpace`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our `generateCodeForAccessCard` mutation. */
export type GenerateCodeForAccessCardPayloadDocumentSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};

/** A connection to a list of `GetRetentionPolicyForWorkspaceRecord` values. */
export type GetRetentionPolicyForWorkspaceConnection = {
  __typename?: 'GetRetentionPolicyForWorkspaceConnection';
  /** A list of edges which contains the `GetRetentionPolicyForWorkspaceRecord` and cursor to aid in pagination. */
  edges: Array<GetRetentionPolicyForWorkspaceEdge>;
  /** A list of `GetRetentionPolicyForWorkspaceRecord` objects. */
  nodes: Array<Maybe<GetRetentionPolicyForWorkspaceRecord>>;
  /** The count of *all* `GetRetentionPolicyForWorkspaceRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GetRetentionPolicyForWorkspaceRecord` edge in the connection. */
export type GetRetentionPolicyForWorkspaceEdge = {
  __typename?: 'GetRetentionPolicyForWorkspaceEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GetRetentionPolicyForWorkspaceRecord` at the end of the edge. */
  node?: Maybe<GetRetentionPolicyForWorkspaceRecord>;
};

/** The return type of our `getRetentionPolicyForWorkspace` query. */
export type GetRetentionPolicyForWorkspaceRecord = {
  __typename?: 'GetRetentionPolicyForWorkspaceRecord';
  autoExpireLocalUploadsDays?: Maybe<Scalars['Int']['output']>;
  expiryDateEditable?: Maybe<Scalars['Boolean']['output']>;
  gracePeriodDays?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `GetRetentionPolicyForWorkspaceRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetRetentionPolicyForWorkspaceRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetRetentionPolicyForWorkspaceRecordFilter>>;
  /** Filter by the object’s `autoExpireLocalUploadsDays` field. */
  autoExpireLocalUploadsDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expiryDateEditable` field. */
  expiryDateEditable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `gracePeriodDays` field. */
  gracePeriodDays?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetRetentionPolicyForWorkspaceRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetRetentionPolicyForWorkspaceRecordFilter>>;
};

/** A connection to a list of `GuessLanguageDetailedRecord` values. */
export type GuessLanguageDetailedConnection = {
  __typename?: 'GuessLanguageDetailedConnection';
  /** A list of edges which contains the `GuessLanguageDetailedRecord` and cursor to aid in pagination. */
  edges: Array<GuessLanguageDetailedEdge>;
  /** A list of `GuessLanguageDetailedRecord` objects. */
  nodes: Array<Maybe<GuessLanguageDetailedRecord>>;
  /** The count of *all* `GuessLanguageDetailedRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GuessLanguageDetailedRecord` edge in the connection. */
export type GuessLanguageDetailedEdge = {
  __typename?: 'GuessLanguageDetailedEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GuessLanguageDetailedRecord` at the end of the edge. */
  node?: Maybe<GuessLanguageDetailedRecord>;
};

/** The return type of our `guessLanguageDetailed` query. */
export type GuessLanguageDetailedRecord = {
  __typename?: 'GuessLanguageDetailedRecord';
  confidence?: Maybe<Scalars['BigFloat']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  runnerUpScore?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `GuessLanguageDetailedRecord` object types. All fields are combined with a logical ‘and.’ */
export type GuessLanguageDetailedRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GuessLanguageDetailedRecordFilter>>;
  /** Filter by the object’s `confidence` field. */
  confidence?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `language` field. */
  language?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GuessLanguageDetailedRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GuessLanguageDetailedRecordFilter>>;
  /** Filter by the object’s `runnerUpScore` field. */
  runnerUpScore?: InputMaybe<IntFilter>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `IdsOfSpaceAndSection` */
export type IdsOfSpaceAndSectionInput = {
  sectionId?: InputMaybe<Scalars['BigInt']['input']>;
  spaceId: Scalars['BigInt']['input'];
};

/** All input for the `insertSpaceSectionAfter` mutation. */
export type InsertSpaceSectionAfterInput = {
  afterSectionId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newSection: InsertSpaceSectionAttributeInput;
};

/** The output of our `insertSpaceSectionAfter` mutation. */
export type InsertSpaceSectionAfterPayload = {
  __typename?: 'InsertSpaceSectionAfterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSection`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceSection?: Maybe<DocumentSpaceSection>;
  /** An edge for our `DocumentSpaceSection`. May be used by Relay 1. */
  documentSpaceSectionEdge?: Maybe<DocumentSpaceSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `insertSpaceSectionAfter` mutation. */
export type InsertSpaceSectionAfterPayloadDocumentSpaceSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSectionsOrderBy>>;
};

/** An input for mutations affecting `InsertSpaceSectionAttribute` */
export type InsertSpaceSectionAttributeInput = {
  title: Scalars['String']['input'];
};

export type InspectWorkspaceSerialization = {
  __typename?: 'InspectWorkspaceSerialization';
  countOfMemberships?: Maybe<Scalars['BigInt']['output']>;
  firebaseId?: Maybe<Scalars['String']['output']>;
  flattened?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subteamNames?: Maybe<Scalars['String']['output']>;
  userEmails?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `InspectWorkspaceSerialization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type InspectWorkspaceSerializationCondition = {
  /** Checks for equality with the object’s `countOfMemberships` field. */
  countOfMemberships?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flattened` field. */
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `subteamNames` field. */
  subteamNames?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userEmails` field. */
  userEmails?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `InspectWorkspaceSerialization` object types. All fields are combined with a logical ‘and.’ */
export type InspectWorkspaceSerializationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InspectWorkspaceSerializationFilter>>;
  /** Filter by the object’s `countOfMemberships` field. */
  countOfMemberships?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InspectWorkspaceSerializationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InspectWorkspaceSerializationFilter>>;
  /** Filter by the object’s `subteamNames` field. */
  subteamNames?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userEmails` field. */
  userEmails?: InputMaybe<StringFilter>;
};

/** A connection to a list of `InspectWorkspaceSerialization` values. */
export type InspectWorkspaceSerializationsConnection = {
  __typename?: 'InspectWorkspaceSerializationsConnection';
  /** A list of edges which contains the `InspectWorkspaceSerialization` and cursor to aid in pagination. */
  edges: Array<InspectWorkspaceSerializationsEdge>;
  /** A list of `InspectWorkspaceSerialization` objects. */
  nodes: Array<Maybe<InspectWorkspaceSerialization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InspectWorkspaceSerialization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InspectWorkspaceSerialization` edge in the connection. */
export type InspectWorkspaceSerializationsEdge = {
  __typename?: 'InspectWorkspaceSerializationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InspectWorkspaceSerialization` at the end of the edge. */
  node?: Maybe<InspectWorkspaceSerialization>;
};

/** Methods to use when ordering `InspectWorkspaceSerialization`. */
export enum InspectWorkspaceSerializationsOrderBy {
  CountOfMembershipsAsc = 'COUNT_OF_MEMBERSHIPS_ASC',
  CountOfMembershipsDesc = 'COUNT_OF_MEMBERSHIPS_DESC',
  FirebaseIdAsc = 'FIREBASE_ID_ASC',
  FirebaseIdDesc = 'FIREBASE_ID_DESC',
  FlattenedAsc = 'FLATTENED_ASC',
  FlattenedDesc = 'FLATTENED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  SubteamNamesAsc = 'SUBTEAM_NAMES_ASC',
  SubteamNamesDesc = 'SUBTEAM_NAMES_DESC',
  UserEmailsAsc = 'USER_EMAILS_ASC',
  UserEmailsDesc = 'USER_EMAILS_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InternalIpAddress = Node & {
  __typename?: 'InternalIpAddress';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rangeEnd: Scalars['String']['output'];
  rangeStart: Scalars['String']['output'];
  /** Reads a single `Tenant` that is related to this `InternalIpAddress`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `InternalIpAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InternalIpAddressCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `rangeEnd` field. */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rangeStart` field. */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `InternalIpAddress` object types. All fields are combined with a logical ‘and.’ */
export type InternalIpAddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InternalIpAddressFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InternalIpAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InternalIpAddressFilter>>;
  /** Filter by the object’s `rangeEnd` field. */
  rangeEnd?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rangeStart` field. */
  rangeStart?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `InternalIpAddress` */
export type InternalIpAddressInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  rangeEnd: Scalars['String']['input'];
  rangeStart: Scalars['String']['input'];
  tenantId: Scalars['BigInt']['input'];
};

/** Represents an update to a `InternalIpAddress`. Fields that are set will be updated. */
export type InternalIpAddressPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `InternalIpAddress` values. */
export type InternalIpAddressesConnection = {
  __typename?: 'InternalIpAddressesConnection';
  /** A list of edges which contains the `InternalIpAddress` and cursor to aid in pagination. */
  edges: Array<InternalIpAddressesEdge>;
  /** A list of `InternalIpAddress` objects. */
  nodes: Array<Maybe<InternalIpAddress>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InternalIpAddress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InternalIpAddress` edge in the connection. */
export type InternalIpAddressesEdge = {
  __typename?: 'InternalIpAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InternalIpAddress` at the end of the edge. */
  node?: Maybe<InternalIpAddress>;
};

/** Methods to use when ordering `InternalIpAddress`. */
export enum InternalIpAddressesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RangeEndAsc = 'RANGE_END_ASC',
  RangeEndDesc = 'RANGE_END_DESC',
  RangeStartAsc = 'RANGE_START_ASC',
  RangeStartDesc = 'RANGE_START_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']['output']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']['output']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']['output']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']['output']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the `inviteToSpaceByEmail` mutation. */
export type InviteToSpaceByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  invitedUserId?: InputMaybe<Scalars['BigInt']['input']>;
  notifyUser?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `inviteToSpaceByEmail` mutation. */
export type InviteToSpaceByEmailPayload = {
  __typename?: 'InviteToSpaceByEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  creator?: Maybe<User>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceAccess`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceAccess?: Maybe<DocumentSpaceAccess>;
  /** An edge for our `DocumentSpaceAccess`. May be used by Relay 1. */
  documentSpaceAccessEdge?: Maybe<DocumentSpaceAccessesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  user?: Maybe<User>;
};


/** The output of our `inviteToSpaceByEmail` mutation. */
export type InviteToSpaceByEmailPayloadDocumentSpaceAccessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};

/** All input for the `inviteToTeamByEmail` mutation. */
export type InviteToTeamByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `inviteToTeamByEmail` mutation. */
export type InviteToTeamByEmailPayload = {
  __typename?: 'InviteToTeamByEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  memberships?: Maybe<Array<Maybe<Membership>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** All input for the `joinTeam` mutation. */
export type JoinTeamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `joinTeam` mutation. */
export type JoinTeamPayload = {
  __typename?: 'JoinTeamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<JoinTeamRecord>;
};

/** The return type of our `joinTeam` mutation. */
export type JoinTeamRecord = {
  __typename?: 'JoinTeamRecord';
  membership?: Maybe<Membership>;
  team?: Maybe<Team>;
};

export type LabelsOfDocumentView = Node & {
  __typename?: 'LabelsOfDocumentView';
  /** Revision required by replacePresentationHcps. */
  assignmentRevision: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `CrmContact` that is related to this `LabelsOfDocumentView`. */
  crmContact?: Maybe<CrmContact>;
  crmContactId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Reads and enables pagination through a set of `DocumentHistoryEntry`.
   * @deprecated Please use label instead
   */
  documentHistoryEntriesById: DocumentHistoryEntriesConnection;
  documentViewId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `CrmContact`. */
  hcpContacts: CrmContactsConnection;
  /** Number of HCP assignments, independent of contact visibility. */
  hcpCount: Scalars['Int']['output'];
  /** Reads a single `DocumentHistoryEntry` that is related to this `LabelsOfDocumentView`. */
  label?: Maybe<DocumentHistoryEntry>;
  /** Reads a single `User` that is related to this `LabelsOfDocumentView`. */
  lastModifiedBy?: Maybe<User>;
  lastModifiedById?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `CrmContactMatch` that is related to this `LabelsOfDocumentView`. */
  matchId?: Maybe<CrmContactMatch>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type LabelsOfDocumentViewDocumentHistoryEntriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentHistoryEntryCondition>;
  filter?: InputMaybe<DocumentHistoryEntryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentHistoryEntriesOrderBy>>;
};

/**
 * A condition to be used against `LabelsOfDocumentView` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LabelsOfDocumentViewCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crmContactId` field. */
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentViewId` field. */
  documentViewId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `lastModifiedById` field. */
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `LabelsOfDocumentView` object types. All fields are combined with a logical ‘and.’ */
export type LabelsOfDocumentViewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LabelsOfDocumentViewFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContact` relation. */
  crmContact?: InputMaybe<CrmContactFilter>;
  /** A related `crmContact` exists. */
  crmContactExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmContactId` field. */
  crmContactId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentViewId` field. */
  documentViewId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `label` relation. */
  label?: InputMaybe<DocumentHistoryEntryFilter>;
  /** A related `label` exists. */
  labelExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lastModifiedBy` relation. */
  lastModifiedBy?: InputMaybe<UserFilter>;
  /** A related `lastModifiedBy` exists. */
  lastModifiedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lastModifiedById` field. */
  lastModifiedById?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `matchId` relation. */
  matchId?: InputMaybe<CrmContactMatchFilter>;
  /** A related `matchId` exists. */
  matchIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LabelsOfDocumentViewFilter>>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LabelsOfDocumentView` */
export type LabelsOfDocumentViewInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  documentViewId: Scalars['UUID']['input'];
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `LabelsOfDocumentView`. Fields that are set will be updated. */
export type LabelsOfDocumentViewPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  documentViewId?: InputMaybe<Scalars['UUID']['input']>;
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `LabelsOfDocumentView` values. */
export type LabelsOfDocumentViewsConnection = {
  __typename?: 'LabelsOfDocumentViewsConnection';
  /** A list of edges which contains the `LabelsOfDocumentView` and cursor to aid in pagination. */
  edges: Array<LabelsOfDocumentViewsEdge>;
  /** A list of `LabelsOfDocumentView` objects. */
  nodes: Array<Maybe<LabelsOfDocumentView>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LabelsOfDocumentView` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LabelsOfDocumentView` edge in the connection. */
export type LabelsOfDocumentViewsEdge = {
  __typename?: 'LabelsOfDocumentViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LabelsOfDocumentView` at the end of the edge. */
  node?: Maybe<LabelsOfDocumentView>;
};

/** Methods to use when ordering `LabelsOfDocumentView`. */
export enum LabelsOfDocumentViewsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactByCrmContactIdActiveAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ACTIVE_ASC',
  CrmContactByCrmContactIdActiveDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ACTIVE_DESC',
  CrmContactByCrmContactIdAlxnConsentStatusAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactByCrmContactIdAlxnConsentStatusDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactByCrmContactIdAlxnPrimaryParentAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactByCrmContactIdAlxnPrimaryParentDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactByCrmContactIdAlxnProductsAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_ASC',
  CrmContactByCrmContactIdAlxnProductsDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_DESC',
  CrmContactByCrmContactIdAlxnRoleAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_ROLE_ASC',
  CrmContactByCrmContactIdAlxnRoleDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_ROLE_DESC',
  CrmContactByCrmContactIdAlxnSpecialityAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_ASC',
  CrmContactByCrmContactIdAlxnSpecialityDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_DESC',
  CrmContactByCrmContactIdAlxnTerritoriesAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_ASC',
  CrmContactByCrmContactIdAlxnTerritoriesDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_DESC',
  CrmContactByCrmContactIdCityAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CITY_ASC',
  CrmContactByCrmContactIdCityDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CITY_DESC',
  CrmContactByCrmContactIdCountryAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__COUNTRY_ASC',
  CrmContactByCrmContactIdCountryDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__COUNTRY_DESC',
  CrmContactByCrmContactIdCreatedAtAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CREATED_AT_ASC',
  CrmContactByCrmContactIdCreatedAtDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CREATED_AT_DESC',
  CrmContactByCrmContactIdCrmIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CRM_ID_ASC',
  CrmContactByCrmContactIdCrmIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__CRM_ID_DESC',
  CrmContactByCrmContactIdEmailAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__EMAIL_ASC',
  CrmContactByCrmContactIdEmailDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__EMAIL_DESC',
  CrmContactByCrmContactIdFirstNameAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FIRST_NAME_ASC',
  CrmContactByCrmContactIdFirstNameDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FIRST_NAME_DESC',
  CrmContactByCrmContactIdFullNameAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FULL_NAME_ASC',
  CrmContactByCrmContactIdFullNameDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__FULL_NAME_DESC',
  CrmContactByCrmContactIdIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ID_ASC',
  CrmContactByCrmContactIdIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ID_DESC',
  CrmContactByCrmContactIdLanguagePrefAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LANGUAGE_PREF_ASC',
  CrmContactByCrmContactIdLanguagePrefDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LANGUAGE_PREF_DESC',
  CrmContactByCrmContactIdLastNameAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LAST_NAME_ASC',
  CrmContactByCrmContactIdLastNameDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LAST_NAME_DESC',
  CrmContactByCrmContactIdLocalCrmIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_ASC',
  CrmContactByCrmContactIdLocalCrmIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_DESC',
  CrmContactByCrmContactIdMobileAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__MOBILE_ASC',
  CrmContactByCrmContactIdMobileDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__MOBILE_DESC',
  CrmContactByCrmContactIdOrganizationAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ORGANIZATION_ASC',
  CrmContactByCrmContactIdOrganizationDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ORGANIZATION_DESC',
  CrmContactByCrmContactIdRegionAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__REGION_ASC',
  CrmContactByCrmContactIdRegionDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__REGION_DESC',
  CrmContactByCrmContactIdTenantIdAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TENANT_ID_ASC',
  CrmContactByCrmContactIdTenantIdDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TENANT_ID_DESC',
  CrmContactByCrmContactIdTerritoryAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TERRITORY_ASC',
  CrmContactByCrmContactIdTerritoryDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__TERRITORY_DESC',
  CrmContactByCrmContactIdUpdatedAtAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__UPDATED_AT_ASC',
  CrmContactByCrmContactIdUpdatedAtDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__UPDATED_AT_DESC',
  CrmContactByCrmContactIdZipCodeAsc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ZIP_CODE_ASC',
  CrmContactByCrmContactIdZipCodeDesc = 'CRM_CONTACT_BY_CRM_CONTACT_ID__ZIP_CODE_DESC',
  CrmContactIdAsc = 'CRM_CONTACT_ID_ASC',
  CrmContactIdDesc = 'CRM_CONTACT_ID_DESC',
  CrmContactMatchByCrmContactIdActiveAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ACTIVE_ASC',
  CrmContactMatchByCrmContactIdActiveDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ACTIVE_DESC',
  CrmContactMatchByCrmContactIdAlxnConsentStatusAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchByCrmContactIdAlxnConsentStatusDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchByCrmContactIdAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchByCrmContactIdAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchByCrmContactIdAlxnProductsAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_ASC',
  CrmContactMatchByCrmContactIdAlxnProductsDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_PRODUCTS_DESC',
  CrmContactMatchByCrmContactIdAlxnRoleAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_ROLE_ASC',
  CrmContactMatchByCrmContactIdAlxnRoleDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_ROLE_DESC',
  CrmContactMatchByCrmContactIdAlxnSpecialityAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_ASC',
  CrmContactMatchByCrmContactIdAlxnSpecialityDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_SPECIALITY_DESC',
  CrmContactMatchByCrmContactIdAlxnTerritoriesAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_ASC',
  CrmContactMatchByCrmContactIdAlxnTerritoriesDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ALXN_TERRITORIES_DESC',
  CrmContactMatchByCrmContactIdCityAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CITY_ASC',
  CrmContactMatchByCrmContactIdCityDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CITY_DESC',
  CrmContactMatchByCrmContactIdCountryAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__COUNTRY_ASC',
  CrmContactMatchByCrmContactIdCountryDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__COUNTRY_DESC',
  CrmContactMatchByCrmContactIdCreatedAtAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CREATED_AT_ASC',
  CrmContactMatchByCrmContactIdCreatedAtDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CREATED_AT_DESC',
  CrmContactMatchByCrmContactIdCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CRM_ID_ASC',
  CrmContactMatchByCrmContactIdCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__CRM_ID_DESC',
  CrmContactMatchByCrmContactIdEmailAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__EMAIL_ASC',
  CrmContactMatchByCrmContactIdEmailDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__EMAIL_DESC',
  CrmContactMatchByCrmContactIdFirstNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FIRST_NAME_ASC',
  CrmContactMatchByCrmContactIdFirstNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FIRST_NAME_DESC',
  CrmContactMatchByCrmContactIdFulltextRankAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_RANK_ASC',
  CrmContactMatchByCrmContactIdFulltextRankDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_RANK_DESC',
  CrmContactMatchByCrmContactIdFulltextSearchColumnAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchByCrmContactIdFulltextSearchColumnDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchByCrmContactIdFullNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULL_NAME_ASC',
  CrmContactMatchByCrmContactIdFullNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__FULL_NAME_DESC',
  CrmContactMatchByCrmContactIdIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ID_ASC',
  CrmContactMatchByCrmContactIdIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ID_DESC',
  CrmContactMatchByCrmContactIdLanguagePrefAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LANGUAGE_PREF_ASC',
  CrmContactMatchByCrmContactIdLanguagePrefDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LANGUAGE_PREF_DESC',
  CrmContactMatchByCrmContactIdLastNameAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LAST_NAME_ASC',
  CrmContactMatchByCrmContactIdLastNameDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LAST_NAME_DESC',
  CrmContactMatchByCrmContactIdLocalCrmIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_ASC',
  CrmContactMatchByCrmContactIdLocalCrmIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__LOCAL_CRM_ID_DESC',
  CrmContactMatchByCrmContactIdMobileAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__MOBILE_ASC',
  CrmContactMatchByCrmContactIdMobileDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__MOBILE_DESC',
  CrmContactMatchByCrmContactIdOrganizationAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ORGANIZATION_ASC',
  CrmContactMatchByCrmContactIdOrganizationDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ORGANIZATION_DESC',
  CrmContactMatchByCrmContactIdRegionAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__REGION_ASC',
  CrmContactMatchByCrmContactIdRegionDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__REGION_DESC',
  CrmContactMatchByCrmContactIdSimilarityAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__SIMILARITY_ASC',
  CrmContactMatchByCrmContactIdSimilarityDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__SIMILARITY_DESC',
  CrmContactMatchByCrmContactIdTenantIdAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TENANT_ID_ASC',
  CrmContactMatchByCrmContactIdTenantIdDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TENANT_ID_DESC',
  CrmContactMatchByCrmContactIdTerritoryAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TERRITORY_ASC',
  CrmContactMatchByCrmContactIdTerritoryDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__TERRITORY_DESC',
  CrmContactMatchByCrmContactIdUpdatedAtAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__UPDATED_AT_ASC',
  CrmContactMatchByCrmContactIdUpdatedAtDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__UPDATED_AT_DESC',
  CrmContactMatchByCrmContactIdZipCodeAsc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ZIP_CODE_ASC',
  CrmContactMatchByCrmContactIdZipCodeDesc = 'CRM_CONTACT_MATCH_BY_CRM_CONTACT_ID__ZIP_CODE_DESC',
  DocumentHistoryEntryByIdActiveDurationAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__ACTIVE_DURATION_ASC',
  DocumentHistoryEntryByIdActiveDurationDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__ACTIVE_DURATION_DESC',
  DocumentHistoryEntryByIdDateAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__DATE_ASC',
  DocumentHistoryEntryByIdDateDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__DATE_DESC',
  DocumentHistoryEntryByIdDocumentIdAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__DOCUMENT_ID_ASC',
  DocumentHistoryEntryByIdDocumentIdDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__DOCUMENT_ID_DESC',
  DocumentHistoryEntryByIdDurationAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__DURATION_ASC',
  DocumentHistoryEntryByIdDurationDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__DURATION_DESC',
  DocumentHistoryEntryByIdEndsAtAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__ENDS_AT_ASC',
  DocumentHistoryEntryByIdEndsAtDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__ENDS_AT_DESC',
  DocumentHistoryEntryByIdIdAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__ID_ASC',
  DocumentHistoryEntryByIdIdDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__ID_DESC',
  DocumentHistoryEntryByIdRunIdAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__RUN_ID_ASC',
  DocumentHistoryEntryByIdRunIdDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__RUN_ID_DESC',
  DocumentHistoryEntryByIdStartsAtAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__STARTS_AT_ASC',
  DocumentHistoryEntryByIdStartsAtDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__STARTS_AT_DESC',
  DocumentHistoryEntryByIdTimeRangeAsc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__TIME_RANGE_ASC',
  DocumentHistoryEntryByIdTimeRangeDesc = 'DOCUMENT_HISTORY_ENTRY_BY_ID__TIME_RANGE_DESC',
  DocumentViewIdAsc = 'DOCUMENT_VIEW_ID_ASC',
  DocumentViewIdDesc = 'DOCUMENT_VIEW_ID_DESC',
  LastModifiedByIdAsc = 'LAST_MODIFIED_BY_ID_ASC',
  LastModifiedByIdDesc = 'LAST_MODIFIED_BY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TextAsc = 'TEXT_ASC',
  TextDesc = 'TEXT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByLastModifiedByIdAppConsentGivenAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByLastModifiedByIdAppConsentGivenAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByLastModifiedByIdConfigAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CONFIG_ASC',
  UserByLastModifiedByIdConfigDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CONFIG_DESC',
  UserByLastModifiedByIdCreatedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_ASC',
  UserByLastModifiedByIdCreatedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_DESC',
  UserByLastModifiedByIdCrmContactVisibilityFilterAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByLastModifiedByIdCrmContactVisibilityFilterDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByLastModifiedByIdDefaultWorkspaceIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByLastModifiedByIdDefaultWorkspaceIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByLastModifiedByIdDisabledAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DISABLED_ASC',
  UserByLastModifiedByIdDisabledDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DISABLED_DESC',
  UserByLastModifiedByIdDisplayNameAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DISPLAY_NAME_ASC',
  UserByLastModifiedByIdDisplayNameDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DISPLAY_NAME_DESC',
  UserByLastModifiedByIdEmailAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ASC',
  UserByLastModifiedByIdEmailDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EMAIL_DESC',
  UserByLastModifiedByIdExternalGroupsAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByLastModifiedByIdExternalGroupsDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByLastModifiedByIdExternalGroupsSyncedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByLastModifiedByIdExternalGroupsSyncedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByLastModifiedByIdFirebaseAuthIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByLastModifiedByIdFirebaseAuthIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByLastModifiedByIdFlagsAsc = 'USER_BY_LAST_MODIFIED_BY_ID__FLAGS_ASC',
  UserByLastModifiedByIdFlagsDesc = 'USER_BY_LAST_MODIFIED_BY_ID__FLAGS_DESC',
  UserByLastModifiedByIdIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__ID_ASC',
  UserByLastModifiedByIdIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__ID_DESC',
  UserByLastModifiedByIdIsTenantAdminAsc = 'USER_BY_LAST_MODIFIED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByLastModifiedByIdIsTenantAdminDesc = 'USER_BY_LAST_MODIFIED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByLastModifiedByIdRegisteredAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__REGISTERED_AT_ASC',
  UserByLastModifiedByIdRegisteredAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__REGISTERED_AT_DESC',
  UserByLastModifiedByIdSysPeriodAsc = 'USER_BY_LAST_MODIFIED_BY_ID__SYS_PERIOD_ASC',
  UserByLastModifiedByIdSysPeriodDesc = 'USER_BY_LAST_MODIFIED_BY_ID__SYS_PERIOD_DESC',
  UserByLastModifiedByIdTenantIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__TENANT_ID_ASC',
  UserByLastModifiedByIdTenantIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__TENANT_ID_DESC',
  UserByLastModifiedByIdUpdatedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_ASC',
  UserByLastModifiedByIdUpdatedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_DESC'
}

export type LanguageCode = Node & {
  __typename?: 'LanguageCode';
  code: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceConfigTranslation`. */
  documentSpaceConfigTranslationsByLanguageCode: DocumentSpaceConfigTranslationsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceConfig`. */
  documentSpaceConfigsByDefaultLanguage: DocumentSpaceConfigsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkTranslation`. */
  documentSpaceLinkTranslationsByLanguageCode: DocumentSpaceLinkTranslationsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type LanguageCodeDocumentSpaceConfigTranslationsByLanguageCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigTranslationsOrderBy>>;
};


export type LanguageCodeDocumentSpaceConfigsByDefaultLanguageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigCondition>;
  filter?: InputMaybe<DocumentSpaceConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};


export type LanguageCodeDocumentSpaceLinkTranslationsByLanguageCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};

/**
 * A condition to be used against `LanguageCode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LanguageCodeCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LanguageCode` object types. All fields are combined with a logical ‘and.’ */
export type LanguageCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LanguageCodeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentSpaceConfigTranslationsByLanguageCode` relation. */
  documentSpaceConfigTranslationsByLanguageCode?: InputMaybe<LanguageCodeToManyDocumentSpaceConfigTranslationFilter>;
  /** Some related `documentSpaceConfigTranslationsByLanguageCode` exist. */
  documentSpaceConfigTranslationsByLanguageCodeExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceConfigsByDefaultLanguage` relation. */
  documentSpaceConfigsByDefaultLanguage?: InputMaybe<LanguageCodeToManyDocumentSpaceConfigFilter>;
  /** Some related `documentSpaceConfigsByDefaultLanguage` exist. */
  documentSpaceConfigsByDefaultLanguageExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinkTranslationsByLanguageCode` relation. */
  documentSpaceLinkTranslationsByLanguageCode?: InputMaybe<LanguageCodeToManyDocumentSpaceLinkTranslationFilter>;
  /** Some related `documentSpaceLinkTranslationsByLanguageCode` exist. */
  documentSpaceLinkTranslationsByLanguageCodeExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LanguageCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LanguageCodeFilter>>;
};

/** An input for mutations affecting `LanguageCode` */
export type LanguageCodeInput = {
  code: Scalars['String']['input'];
};

/** Represents an update to a `LanguageCode`. Fields that are set will be updated. */
export type LanguageCodePatch = {
  code?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `DocumentSpaceConfig` object types. All fields are combined with a logical ‘and.’ */
export type LanguageCodeToManyDocumentSpaceConfigFilter = {
  /** Every related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigFilter>;
  /** No related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigFilter>;
  /** Some related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigFilter>;
};

/** A filter to be used against many `DocumentSpaceConfigTranslation` object types. All fields are combined with a logical ‘and.’ */
export type LanguageCodeToManyDocumentSpaceConfigTranslationFilter = {
  /** Every related `DocumentSpaceConfigTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  /** No related `DocumentSpaceConfigTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  /** Some related `DocumentSpaceConfigTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
};

/** A filter to be used against many `DocumentSpaceLinkTranslation` object types. All fields are combined with a logical ‘and.’ */
export type LanguageCodeToManyDocumentSpaceLinkTranslationFilter = {
  /** Every related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** No related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  /** Some related `DocumentSpaceLinkTranslation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
};

/** A connection to a list of `LanguageCode` values. */
export type LanguageCodesConnection = {
  __typename?: 'LanguageCodesConnection';
  /** A list of edges which contains the `LanguageCode` and cursor to aid in pagination. */
  edges: Array<LanguageCodesEdge>;
  /** A list of `LanguageCode` objects. */
  nodes: Array<Maybe<LanguageCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LanguageCode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LanguageCode` edge in the connection. */
export type LanguageCodesEdge = {
  __typename?: 'LanguageCodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LanguageCode` at the end of the edge. */
  node?: Maybe<LanguageCode>;
};

/** Methods to use when ordering `LanguageCode`. */
export enum LanguageCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  DocumentSpaceConfigsByDefaultLanguageCountAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__COUNT_ASC',
  DocumentSpaceConfigsByDefaultLanguageCountDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__COUNT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_GROUP_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_GROUP_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_SCALING_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_SCALING_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LOGO_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_LOGO_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_NAME_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_NAME_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_NEW_TAB_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_NEW_TAB_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_STYLESHEET_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_STYLESHEET_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TEAM_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TEAM_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TEMPLATE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TEMPLATE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TENANT_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TENANT_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_TITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMaxUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMaxUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MAX_UPDATED_BY_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_GROUP_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_GROUP_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_SCALING_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_SCALING_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LOGO_URL_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_LOGO_URL_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_NAME_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_NAME_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_NEW_TAB_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_NEW_TAB_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_STYLESHEET_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_STYLESHEET_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TEAM_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TEAM_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TEMPLATE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TEMPLATE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TENANT_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TENANT_ID_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TITLE_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_TITLE_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigsByDefaultLanguageMinUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByDefaultLanguageMinUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_DEFAULT_LANGUAGE__MIN_UPDATED_BY_ID_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeCountAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__COUNT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeCountDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__COUNT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxConfigIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_CONFIG_ID_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxConfigIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_CONFIG_ID_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_ID_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_ID_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxLanguageCodeAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LANGUAGE_CODE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxLanguageCodeDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LANGUAGE_CODE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinConfigIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_CONFIG_ID_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinConfigIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_CONFIG_ID_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinIdAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_ID_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinIdDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_ID_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinLanguageCodeAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LANGUAGE_CODE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinLanguageCodeDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LANGUAGE_CODE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigTranslationsByLanguageCodeMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIG_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_UPDATED_AT_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeCountAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__COUNT_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeCountDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__COUNT_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxConfigIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_CONFIG_ID_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxConfigIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_CONFIG_ID_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_ID_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_ID_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxLanguageCodeAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LANGUAGE_CODE_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxLanguageCodeDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LANGUAGE_CODE_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxLinkIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LINK_ID_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxLinkIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_LINK_ID_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxPositionAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_POSITION_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxPositionDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_POSITION_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxSectionTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_SECTION_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxSectionTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_SECTION_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxUrlAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_URL_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMaxUrlDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MAX_URL_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinConfigIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_CONFIG_ID_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinConfigIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_CONFIG_ID_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_ID_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_ID_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinLanguageCodeAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LANGUAGE_CODE_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinLanguageCodeDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LANGUAGE_CODE_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinLinkIdAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LINK_ID_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinLinkIdDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_LINK_ID_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinPositionAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_POSITION_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinPositionDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_POSITION_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinSectionTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_SECTION_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinSectionTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_SECTION_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinTitleAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_TITLE_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinTitleDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_TITLE_DESC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinUrlAsc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_URL_ASC',
  DocumentSpaceLinkTranslationsByLanguageCodeMinUrlDesc = 'DOCUMENT_SPACE_LINK_TRANSLATIONS_BY_LANGUAGE_CODE__MIN_URL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type LastCsvImport = {
  __typename?: 'LastCsvImport';
  brand?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  crmId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  ignore1?: Maybe<Scalars['String']['output']>;
  ignore2?: Maybe<Scalars['String']['output']>;
  ignore3?: Maybe<Scalars['String']['output']>;
  ignore4?: Maybe<Scalars['String']['output']>;
  insertionOrder?: Maybe<Scalars['BigInt']['output']>;
  languagePref?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `LastCsvImport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LastCsvImportCondition = {
  /** Checks for equality with the object’s `brand` field. */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `crmId` field. */
  crmId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ignore1` field. */
  ignore1?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ignore2` field. */
  ignore2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ignore3` field. */
  ignore3?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ignore4` field. */
  ignore4?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `insertionOrder` field. */
  insertionOrder?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `languagePref` field. */
  languagePref?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `LastCsvImport` object types. All fields are combined with a logical ‘and.’ */
export type LastCsvImportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LastCsvImportFilter>>;
  /** Filter by the object’s `brand` field. */
  brand?: InputMaybe<StringFilter>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `crmId` field. */
  crmId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ignore1` field. */
  ignore1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ignore2` field. */
  ignore2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ignore3` field. */
  ignore3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ignore4` field. */
  ignore4?: InputMaybe<StringFilter>;
  /** Filter by the object’s `insertionOrder` field. */
  insertionOrder?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `languagePref` field. */
  languagePref?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LastCsvImportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LastCsvImportFilter>>;
  /** Filter by the object’s `organization` field. */
  organization?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `LastCsvImport` */
export type LastCsvImportInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  crmId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  ignore1?: InputMaybe<Scalars['String']['input']>;
  ignore2?: InputMaybe<Scalars['String']['input']>;
  ignore3?: InputMaybe<Scalars['String']['input']>;
  ignore4?: InputMaybe<Scalars['String']['input']>;
  insertionOrder?: InputMaybe<Scalars['BigInt']['input']>;
  languagePref?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `LastCsvImport` values. */
export type LastCsvImportsConnection = {
  __typename?: 'LastCsvImportsConnection';
  /** A list of edges which contains the `LastCsvImport` and cursor to aid in pagination. */
  edges: Array<LastCsvImportsEdge>;
  /** A list of `LastCsvImport` objects. */
  nodes: Array<Maybe<LastCsvImport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LastCsvImport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LastCsvImport` edge in the connection. */
export type LastCsvImportsEdge = {
  __typename?: 'LastCsvImportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LastCsvImport` at the end of the edge. */
  node?: Maybe<LastCsvImport>;
};

/** Methods to use when ordering `LastCsvImport`. */
export enum LastCsvImportsOrderBy {
  BrandAsc = 'BRAND_ASC',
  BrandDesc = 'BRAND_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CrmIdAsc = 'CRM_ID_ASC',
  CrmIdDesc = 'CRM_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  Ignore1Asc = 'IGNORE1_ASC',
  Ignore1Desc = 'IGNORE1_DESC',
  Ignore2Asc = 'IGNORE2_ASC',
  Ignore2Desc = 'IGNORE2_DESC',
  Ignore3Asc = 'IGNORE3_ASC',
  Ignore3Desc = 'IGNORE3_DESC',
  Ignore4Asc = 'IGNORE4_ASC',
  Ignore4Desc = 'IGNORE4_DESC',
  InsertionOrderAsc = 'INSERTION_ORDER_ASC',
  InsertionOrderDesc = 'INSERTION_ORDER_DESC',
  LanguagePrefAsc = 'LANGUAGE_PREF_ASC',
  LanguagePrefDesc = 'LANGUAGE_PREF_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

/** All input for the `leaveTeam` mutation. */
export type LeaveTeamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `leaveTeam` mutation. */
export type LeaveTeamPayload = {
  __typename?: 'LeaveTeamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMembership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our `leaveTeam` mutation. */
export type LeaveTeamPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

export type MaDocumentSpaceDocumentStatistic = Node & {
  __typename?: 'MaDocumentSpaceDocumentStatistic';
  averageConservativeDurationInDocumentPerVisit?: Maybe<Interval>;
  averageDurationInDocumentPerVisit?: Maybe<Interval>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `MaDocumentSpaceDocumentStatistic`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  /** Reads a single `DocumentSpace` that is related to this `MaDocumentSpaceDocumentStatistic`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  maxConservativeDurationInDocumentAcrossVisits?: Maybe<Interval>;
  maxDurationInDocumentAcrossVisits?: Maybe<Interval>;
  mimeType?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numDownloads?: Maybe<Scalars['BigInt']['output']>;
  numVisits?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `MaDocumentSpacePageStatistic`. */
  relatedPages: MaDocumentSpacePageStatisticsConnection;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
  totalConservativeDurationInDocumentAcrossVisits?: Maybe<Interval>;
  totalDurationInDocumentAcrossVisits?: Maybe<Interval>;
};


export type MaDocumentSpaceDocumentStatisticRelatedPagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpacePageStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpacePageStatisticsOrderBy>>;
};

/**
 * A condition to be used against `MaDocumentSpaceDocumentStatistic` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentSpaceDocumentStatisticCondition = {
  /** Checks for equality with the object’s `averageConservativeDurationInDocumentPerVisit` field. */
  averageConservativeDurationInDocumentPerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `averageDurationInDocumentPerVisit` field. */
  averageDurationInDocumentPerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxConservativeDurationInDocumentAcrossVisits` field. */
  maxConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `maxDurationInDocumentAcrossVisits` field. */
  maxDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `mimeType` field. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numVisits` field. */
  numVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `totalConservativeDurationInDocumentAcrossVisits` field. */
  totalConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `totalDurationInDocumentAcrossVisits` field. */
  totalDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `MaDocumentSpaceDocumentStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpaceDocumentStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentSpaceDocumentStatisticFilter>>;
  /** Filter by the object’s `averageConservativeDurationInDocumentPerVisit` field. */
  averageConservativeDurationInDocumentPerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `averageDurationInDocumentPerVisit` field. */
  averageDurationInDocumentPerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxConservativeDurationInDocumentAcrossVisits` field. */
  maxConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `maxDurationInDocumentAcrossVisits` field. */
  maxDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `mimeType` field. */
  mimeType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  /** Filter by the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numVisits` field. */
  numVisits?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentSpaceDocumentStatisticFilter>>;
  /** Filter by the object’s `relatedPages` relation. */
  relatedPages?: InputMaybe<MaDocumentSpaceDocumentStatisticToManyMaDocumentSpacePageStatisticFilter>;
  /** Some related `relatedPages` exist. */
  relatedPagesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `totalConservativeDurationInDocumentAcrossVisits` field. */
  totalConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `totalDurationInDocumentAcrossVisits` field. */
  totalDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
};

/** A filter to be used against many `MaDocumentSpacePageStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpaceDocumentStatisticToManyMaDocumentSpacePageStatisticFilter = {
  /** Every related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** No related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** Some related `MaDocumentSpacePageStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
};

/** A connection to a list of `MaDocumentSpaceDocumentStatistic` values. */
export type MaDocumentSpaceDocumentStatisticsConnection = {
  __typename?: 'MaDocumentSpaceDocumentStatisticsConnection';
  /** A list of edges which contains the `MaDocumentSpaceDocumentStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentSpaceDocumentStatisticsEdge>;
  /** A list of `MaDocumentSpaceDocumentStatistic` objects. */
  nodes: Array<Maybe<MaDocumentSpaceDocumentStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentSpaceDocumentStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentSpaceDocumentStatistic` edge in the connection. */
export type MaDocumentSpaceDocumentStatisticsEdge = {
  __typename?: 'MaDocumentSpaceDocumentStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentSpaceDocumentStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentSpaceDocumentStatistic>;
};

/** Methods to use when ordering `MaDocumentSpaceDocumentStatistic`. */
export enum MaDocumentSpaceDocumentStatisticsOrderBy {
  AverageConservativeDurationInDocumentPerVisitAsc = 'AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  AverageConservativeDurationInDocumentPerVisitDesc = 'AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  AverageDurationInDocumentPerVisitAsc = 'AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  AverageDurationInDocumentPerVisitDesc = 'AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  MaxConservativeDurationInDocumentAcrossVisitsAsc = 'MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaxConservativeDurationInDocumentAcrossVisitsDesc = 'MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaxDurationInDocumentAcrossVisitsAsc = 'MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaxDurationInDocumentAcrossVisitsDesc = 'MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdCountAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__COUNT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdCountDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__COUNT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxAverageConservativeDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxAverageConservativeDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxAverageDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxAverageDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxDocumentIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_DOCUMENT_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxDocumentIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_DOCUMENT_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxMaxConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxMaxConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxMaxDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxMaxDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxNumVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_NUM_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxNumVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_NUM_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxPageNumberAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_PAGE_NUMBER_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxPageNumberDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_PAGE_NUMBER_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxTotalConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxTotalConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxTotalDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMaxTotalDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinAverageConservativeDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinAverageConservativeDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinAverageDurationOnPagePerVisitAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinAverageDurationOnPagePerVisitDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinDocumentIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_DOCUMENT_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinDocumentIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_DOCUMENT_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinMaxConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinMaxConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinMaxDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinMaxDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinNumVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_NUM_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinNumVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_NUM_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinPageNumberAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_PAGE_NUMBER_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinPageNumberDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_PAGE_NUMBER_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinTotalConservativeDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinTotalConservativeDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinTotalDurationOnPageAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaDocumentSpacePageStatisticsByDocumentSpaceIdAndDocumentIdMinTotalDurationOnPageAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_PAGE_STATISTICS_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIN_TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MimeTypeAsc = 'MIME_TYPE_ASC',
  MimeTypeDesc = 'MIME_TYPE_DESC',
  Natural = 'NATURAL',
  NumDownloadsAsc = 'NUM_DOWNLOADS_ASC',
  NumDownloadsDesc = 'NUM_DOWNLOADS_DESC',
  NumVisitsAsc = 'NUM_VISITS_ASC',
  NumVisitsDesc = 'NUM_VISITS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC',
  TotalConservativeDurationInDocumentAcrossVisitsAsc = 'TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  TotalConservativeDurationInDocumentAcrossVisitsDesc = 'TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  TotalDurationInDocumentAcrossVisitsAsc = 'TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  TotalDurationInDocumentAcrossVisitsDesc = 'TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC'
}

export type MaDocumentSpaceLinkStatistic = Node & {
  __typename?: 'MaDocumentSpaceLinkStatistic';
  /** Reads a single `DocumentSpace` that is related to this `MaDocumentSpaceLinkStatistic`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numClicks?: Maybe<Scalars['BigInt']['output']>;
  url: Scalars['String']['output'];
};

/**
 * A condition to be used against `MaDocumentSpaceLinkStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentSpaceLinkStatisticCondition = {
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numClicks` field. */
  numClicks?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MaDocumentSpaceLinkStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpaceLinkStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentSpaceLinkStatisticFilter>>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentSpaceLinkStatisticFilter>;
  /** Filter by the object’s `numClicks` field. */
  numClicks?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentSpaceLinkStatisticFilter>>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MaDocumentSpaceLinkStatistic` values. */
export type MaDocumentSpaceLinkStatisticsConnection = {
  __typename?: 'MaDocumentSpaceLinkStatisticsConnection';
  /** A list of edges which contains the `MaDocumentSpaceLinkStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentSpaceLinkStatisticsEdge>;
  /** A list of `MaDocumentSpaceLinkStatistic` objects. */
  nodes: Array<Maybe<MaDocumentSpaceLinkStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentSpaceLinkStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentSpaceLinkStatistic` edge in the connection. */
export type MaDocumentSpaceLinkStatisticsEdge = {
  __typename?: 'MaDocumentSpaceLinkStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentSpaceLinkStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentSpaceLinkStatistic>;
};

/** Methods to use when ordering `MaDocumentSpaceLinkStatistic`. */
export enum MaDocumentSpaceLinkStatisticsOrderBy {
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  Natural = 'NATURAL',
  NumClicksAsc = 'NUM_CLICKS_ASC',
  NumClicksDesc = 'NUM_CLICKS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

export type MaDocumentSpacePageStatistic = Node & {
  __typename?: 'MaDocumentSpacePageStatistic';
  averageConservativeDurationOnPagePerVisit?: Maybe<Interval>;
  averageDurationOnPagePerVisit?: Maybe<Interval>;
  /** Reads a single `Document` that is related to this `MaDocumentSpacePageStatistic`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  /** Reads a single `DocumentSpace` that is related to this `MaDocumentSpacePageStatistic`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  maxConservativeDurationOnPageAcrossVisits?: Maybe<Interval>;
  maxDurationOnPageAcrossVisits?: Maybe<Interval>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numVisits?: Maybe<Scalars['BigInt']['output']>;
  pageNumber: Scalars['BigInt']['output'];
  /** Reads a single `MaDocumentSpaceDocumentStatistic` that is related to this `MaDocumentSpacePageStatistic`. */
  relatedDocument?: Maybe<MaDocumentSpaceDocumentStatistic>;
  totalConservativeDurationOnPageAcrossVisits?: Maybe<Interval>;
  totalDurationOnPageAcrossVisits?: Maybe<Interval>;
};

/**
 * A condition to be used against `MaDocumentSpacePageStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentSpacePageStatisticCondition = {
  /** Checks for equality with the object’s `averageConservativeDurationOnPagePerVisit` field. */
  averageConservativeDurationOnPagePerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `averageDurationOnPagePerVisit` field. */
  averageDurationOnPagePerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxConservativeDurationOnPageAcrossVisits` field. */
  maxConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `maxDurationOnPageAcrossVisits` field. */
  maxDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `numVisits` field. */
  numVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalConservativeDurationOnPageAcrossVisits` field. */
  totalConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `totalDurationOnPageAcrossVisits` field. */
  totalDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `MaDocumentSpacePageStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpacePageStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentSpacePageStatisticFilter>>;
  /** Filter by the object’s `averageConservativeDurationOnPagePerVisit` field. */
  averageConservativeDurationOnPagePerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `averageDurationOnPagePerVisit` field. */
  averageDurationOnPagePerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxConservativeDurationOnPageAcrossVisits` field. */
  maxConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `maxDurationOnPageAcrossVisits` field. */
  maxDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  /** Filter by the object’s `numVisits` field. */
  numVisits?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentSpacePageStatisticFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `relatedDocument` relation. */
  relatedDocument?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  /** A related `relatedDocument` exists. */
  relatedDocumentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `totalConservativeDurationOnPageAcrossVisits` field. */
  totalConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `totalDurationOnPageAcrossVisits` field. */
  totalDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
};

/** A connection to a list of `MaDocumentSpacePageStatistic` values. */
export type MaDocumentSpacePageStatisticsConnection = {
  __typename?: 'MaDocumentSpacePageStatisticsConnection';
  /** A list of edges which contains the `MaDocumentSpacePageStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentSpacePageStatisticsEdge>;
  /** A list of `MaDocumentSpacePageStatistic` objects. */
  nodes: Array<Maybe<MaDocumentSpacePageStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentSpacePageStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentSpacePageStatistic` edge in the connection. */
export type MaDocumentSpacePageStatisticsEdge = {
  __typename?: 'MaDocumentSpacePageStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentSpacePageStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentSpacePageStatistic>;
};

/** Methods to use when ordering `MaDocumentSpacePageStatistic`. */
export enum MaDocumentSpacePageStatisticsOrderBy {
  AverageConservativeDurationOnPagePerVisitAsc = 'AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  AverageConservativeDurationOnPagePerVisitDesc = 'AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  AverageDurationOnPagePerVisitAsc = 'AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  AverageDurationOnPagePerVisitDesc = 'AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  MaxConservativeDurationOnPageAcrossVisitsAsc = 'MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaxConservativeDurationOnPageAcrossVisitsDesc = 'MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaxDurationOnPageAcrossVisitsAsc = 'MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaxDurationOnPageAcrossVisitsDesc = 'MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdAverageConservativeDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdAverageConservativeDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdAverageDurationInDocumentPerVisitAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdAverageDurationInDocumentPerVisitDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdDisplayTitleAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdDisplayTitleDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdDocumentIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__DOCUMENT_ID_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdDocumentIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__DOCUMENT_ID_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdDocumentSpaceIdAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__DOCUMENT_SPACE_ID_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdDocumentSpaceIdDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__DOCUMENT_SPACE_ID_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdMaxConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdMaxConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdMaxDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdMaxDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdMimeTypeAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIME_TYPE_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdMimeTypeDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__MIME_TYPE_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdNumDownloadsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__NUM_DOWNLOADS_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdNumDownloadsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__NUM_DOWNLOADS_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdNumVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__NUM_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdNumVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__NUM_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdThumbnailDownloadUrlAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdThumbnailDownloadUrlDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdTotalConservativeDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdTotalConservativeDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdTotalDurationInDocumentAcrossVisitsAsc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaDocumentSpaceDocumentStatisticByDocumentSpaceIdAndDocumentIdTotalDurationInDocumentAcrossVisitsDesc = 'MA_DOCUMENT_SPACE_DOCUMENT_STATISTIC_BY_DOCUMENT_SPACE_ID_AND_DOCUMENT_ID__TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  Natural = 'NATURAL',
  NumVisitsAsc = 'NUM_VISITS_ASC',
  NumVisitsDesc = 'NUM_VISITS_DESC',
  PageNumberAsc = 'PAGE_NUMBER_ASC',
  PageNumberDesc = 'PAGE_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TotalConservativeDurationOnPageAcrossVisitsAsc = 'TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  TotalConservativeDurationOnPageAcrossVisitsDesc = 'TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  TotalDurationOnPageAcrossVisitsAsc = 'TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  TotalDurationOnPageAcrossVisitsDesc = 'TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC'
}

export type MaDocumentSpaceStatistic = Node & {
  __typename?: 'MaDocumentSpaceStatistic';
  avgDuration?: Maybe<Interval>;
  /** Reads a single `DocumentSpace` that is related to this `MaDocumentSpaceStatistic`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numDownloads?: Maybe<Scalars['BigInt']['output']>;
  numLinkClicks?: Maybe<Scalars['BigInt']['output']>;
  totalVisits?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `MaDocumentSpaceStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentSpaceStatisticCondition = {
  /** Checks for equality with the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numLinkClicks` field. */
  numLinkClicks?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalVisits` field. */
  totalVisits?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `MaDocumentSpaceStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpaceStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentSpaceStatisticFilter>>;
  /** Filter by the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentSpaceStatisticFilter>;
  /** Filter by the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numLinkClicks` field. */
  numLinkClicks?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentSpaceStatisticFilter>>;
  /** Filter by the object’s `totalVisits` field. */
  totalVisits?: InputMaybe<BigIntFilter>;
};

/** A connection to a list of `MaDocumentSpaceStatistic` values. */
export type MaDocumentSpaceStatisticsConnection = {
  __typename?: 'MaDocumentSpaceStatisticsConnection';
  /** A list of edges which contains the `MaDocumentSpaceStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentSpaceStatisticsEdge>;
  /** A list of `MaDocumentSpaceStatistic` objects. */
  nodes: Array<Maybe<MaDocumentSpaceStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentSpaceStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentSpaceStatistic` edge in the connection. */
export type MaDocumentSpaceStatisticsEdge = {
  __typename?: 'MaDocumentSpaceStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentSpaceStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentSpaceStatistic>;
};

/** Methods to use when ordering `MaDocumentSpaceStatistic`. */
export enum MaDocumentSpaceStatisticsOrderBy {
  AvgDurationAsc = 'AVG_DURATION_ASC',
  AvgDurationDesc = 'AVG_DURATION_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NumDownloadsAsc = 'NUM_DOWNLOADS_ASC',
  NumDownloadsDesc = 'NUM_DOWNLOADS_DESC',
  NumLinkClicksAsc = 'NUM_LINK_CLICKS_ASC',
  NumLinkClicksDesc = 'NUM_LINK_CLICKS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TotalVisitsAsc = 'TOTAL_VISITS_ASC',
  TotalVisitsDesc = 'TOTAL_VISITS_DESC'
}

export type MaDocumentSpaceVideoStatistic = Node & {
  __typename?: 'MaDocumentSpaceVideoStatistic';
  avgWatchRateAcrossVisits?: Maybe<Scalars['BigFloat']['output']>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['BigInt']['output'];
  /** Reads a single `DocumentSpace` that is related to this `MaDocumentSpaceVideoStatistic`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId: Scalars['BigInt']['output'];
  maxWatchRateAcrossVisits?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numDownloads?: Maybe<Scalars['BigInt']['output']>;
  numVisits?: Maybe<Scalars['BigInt']['output']>;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `MaDocumentSpaceVideoStatistic`. */
  video?: Maybe<Document>;
};

/**
 * A condition to be used against `MaDocumentSpaceVideoStatistic` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentSpaceVideoStatisticCondition = {
  /** Checks for equality with the object’s `avgWatchRateAcrossVisits` field. */
  avgWatchRateAcrossVisits?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxWatchRateAcrossVisits` field. */
  maxWatchRateAcrossVisits?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numVisits` field. */
  numVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MaDocumentSpaceVideoStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpaceVideoStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentSpaceVideoStatisticFilter>>;
  /** Filter by the object’s `avgWatchRateAcrossVisits` field. */
  avgWatchRateAcrossVisits?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxWatchRateAcrossVisits` field. */
  maxWatchRateAcrossVisits?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  /** Filter by the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numVisits` field. */
  numVisits?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentSpaceVideoStatisticFilter>>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `video` relation. */
  video?: InputMaybe<DocumentFilter>;
  /** A related `video` exists. */
  videoExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `MaDocumentSpaceVideoStatistic` values. */
export type MaDocumentSpaceVideoStatisticsConnection = {
  __typename?: 'MaDocumentSpaceVideoStatisticsConnection';
  /** A list of edges which contains the `MaDocumentSpaceVideoStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentSpaceVideoStatisticsEdge>;
  /** A list of `MaDocumentSpaceVideoStatistic` objects. */
  nodes: Array<Maybe<MaDocumentSpaceVideoStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentSpaceVideoStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentSpaceVideoStatistic` edge in the connection. */
export type MaDocumentSpaceVideoStatisticsEdge = {
  __typename?: 'MaDocumentSpaceVideoStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentSpaceVideoStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentSpaceVideoStatistic>;
};

/** Methods to use when ordering `MaDocumentSpaceVideoStatistic`. */
export enum MaDocumentSpaceVideoStatisticsOrderBy {
  AvgWatchRateAcrossVisitsAsc = 'AVG_WATCH_RATE_ACROSS_VISITS_ASC',
  AvgWatchRateAcrossVisitsDesc = 'AVG_WATCH_RATE_ACROSS_VISITS_DESC',
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpaceByDocumentSpaceIdAllowedEmailAddressesDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_DESC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCommentAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_ASC',
  DocumentSpaceByDocumentSpaceIdCommentDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__COMMENT_DESC',
  DocumentSpaceByDocumentSpaceIdConfigIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_ASC',
  DocumentSpaceByDocumentSpaceIdConfigIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONFIG_ID_DESC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_ASC',
  DocumentSpaceByDocumentSpaceIdContactDetailsIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CONTACT_DETAILS_ID_DESC',
  DocumentSpaceByDocumentSpaceIdCreatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdCreatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATED_AT_DESC',
  DocumentSpaceByDocumentSpaceIdCreatorIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_ASC',
  DocumentSpaceByDocumentSpaceIdCreatorIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__CREATOR_ID_DESC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_ASC',
  DocumentSpaceByDocumentSpaceIdEncryptedPasswordDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ENCRYPTED_PASSWORD_DESC',
  DocumentSpaceByDocumentSpaceIdIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_ASC',
  DocumentSpaceByDocumentSpaceIdIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__ID_DESC',
  DocumentSpaceByDocumentSpaceIdNameAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_ASC',
  DocumentSpaceByDocumentSpaceIdNameDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__NAME_DESC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_ASC',
  DocumentSpaceByDocumentSpaceIdPersonalMessageDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__PERSONAL_MESSAGE_DESC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_ASC',
  DocumentSpaceByDocumentSpaceIdShowContactDetailsDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SHOW_CONTACT_DETAILS_DESC',
  DocumentSpaceByDocumentSpaceIdSysPeriodAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_ASC',
  DocumentSpaceByDocumentSpaceIdSysPeriodDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__SYS_PERIOD_DESC',
  DocumentSpaceByDocumentSpaceIdTenantIdAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_ASC',
  DocumentSpaceByDocumentSpaceIdTenantIdDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TENANT_ID_DESC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_ASC',
  DocumentSpaceByDocumentSpaceIdTrackingDeactivatedDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__TRACKING_DEACTIVATED_DESC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtAsc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_ASC',
  DocumentSpaceByDocumentSpaceIdUpdatedAtDesc = 'DOCUMENT_SPACE_BY_DOCUMENT_SPACE_ID__UPDATED_AT_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  MaxWatchRateAcrossVisitsAsc = 'MAX_WATCH_RATE_ACROSS_VISITS_ASC',
  MaxWatchRateAcrossVisitsDesc = 'MAX_WATCH_RATE_ACROSS_VISITS_DESC',
  Natural = 'NATURAL',
  NumDownloadsAsc = 'NUM_DOWNLOADS_ASC',
  NumDownloadsDesc = 'NUM_DOWNLOADS_DESC',
  NumVisitsAsc = 'NUM_VISITS_ASC',
  NumVisitsDesc = 'NUM_VISITS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC'
}

export type MaDocumentSpaceVisitsStatistic = Node & {
  __typename?: 'MaDocumentSpaceVisitsStatistic';
  clientHash?: Maybe<Scalars['String']['output']>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  duration?: Maybe<Interval>;
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  extension?: Maybe<DatetimeRange>;
  id: Scalars['BigInt']['output'];
  interactions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  startsAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `MaDocumentSpaceVisitsStatistic` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentSpaceVisitsStatisticCondition = {
  /** Checks for equality with the object’s `clientHash` field. */
  clientHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `extension` field. */
  extension?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `interactions` field. */
  interactions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `isPreview` field. */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MaDocumentSpaceVisitsStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentSpaceVisitsStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentSpaceVisitsStatisticFilter>>;
  /** Filter by the object’s `clientHash` field. */
  clientHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `extension` field. */
  extension?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `interactions` field. */
  interactions?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `isPreview` field. */
  isPreview?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentSpaceVisitsStatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentSpaceVisitsStatisticFilter>>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `MaDocumentSpaceVisitsStatistic` values. */
export type MaDocumentSpaceVisitsStatisticsConnection = {
  __typename?: 'MaDocumentSpaceVisitsStatisticsConnection';
  /** A list of edges which contains the `MaDocumentSpaceVisitsStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentSpaceVisitsStatisticsEdge>;
  /** A list of `MaDocumentSpaceVisitsStatistic` objects. */
  nodes: Array<Maybe<MaDocumentSpaceVisitsStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentSpaceVisitsStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentSpaceVisitsStatistic` edge in the connection. */
export type MaDocumentSpaceVisitsStatisticsEdge = {
  __typename?: 'MaDocumentSpaceVisitsStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentSpaceVisitsStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentSpaceVisitsStatistic>;
};

/** Methods to use when ordering `MaDocumentSpaceVisitsStatistic`. */
export enum MaDocumentSpaceVisitsStatisticsOrderBy {
  ClientHashAsc = 'CLIENT_HASH_ASC',
  ClientHashDesc = 'CLIENT_HASH_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  ExtensionAsc = 'EXTENSION_ASC',
  ExtensionDesc = 'EXTENSION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InteractionsAsc = 'INTERACTIONS_ASC',
  InteractionsDesc = 'INTERACTIONS_DESC',
  IsPreviewAsc = 'IS_PREVIEW_ASC',
  IsPreviewDesc = 'IS_PREVIEW_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC'
}

export type MaDocumentStatistic = {
  __typename?: 'MaDocumentStatistic';
  averageConservativeDurationInDocumentPerVisit?: Maybe<Interval>;
  averageDurationInDocumentPerVisit?: Maybe<Interval>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  maxConservativeDurationInDocumentAcrossVisits?: Maybe<Interval>;
  maxDurationInDocumentAcrossVisits?: Maybe<Interval>;
  mimeType?: Maybe<Scalars['String']['output']>;
  numCurrentShares?: Maybe<Scalars['BigInt']['output']>;
  numDownloads?: Maybe<Scalars['BigInt']['output']>;
  numShares?: Maybe<Scalars['BigInt']['output']>;
  numVisits?: Maybe<Scalars['BigInt']['output']>;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
  totalConservativeDurationInDocumentAcrossVisits?: Maybe<Interval>;
  totalDurationInDocumentAcrossVisits?: Maybe<Interval>;
};

/**
 * A condition to be used against `MaDocumentStatistic` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MaDocumentStatisticCondition = {
  /** Checks for equality with the object’s `averageConservativeDurationInDocumentPerVisit` field. */
  averageConservativeDurationInDocumentPerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `averageDurationInDocumentPerVisit` field. */
  averageDurationInDocumentPerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxConservativeDurationInDocumentAcrossVisits` field. */
  maxConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `maxDurationInDocumentAcrossVisits` field. */
  maxDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `mimeType` field. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numCurrentShares` field. */
  numCurrentShares?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numShares` field. */
  numShares?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `numVisits` field. */
  numVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `totalConservativeDurationInDocumentAcrossVisits` field. */
  totalConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `totalDurationInDocumentAcrossVisits` field. */
  totalDurationInDocumentAcrossVisits?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `MaDocumentStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaDocumentStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaDocumentStatisticFilter>>;
  /** Filter by the object’s `averageConservativeDurationInDocumentPerVisit` field. */
  averageConservativeDurationInDocumentPerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `averageDurationInDocumentPerVisit` field. */
  averageDurationInDocumentPerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxConservativeDurationInDocumentAcrossVisits` field. */
  maxConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `maxDurationInDocumentAcrossVisits` field. */
  maxDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `mimeType` field. */
  mimeType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaDocumentStatisticFilter>;
  /** Filter by the object’s `numCurrentShares` field. */
  numCurrentShares?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numDownloads` field. */
  numDownloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numShares` field. */
  numShares?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numVisits` field. */
  numVisits?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaDocumentStatisticFilter>>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `totalConservativeDurationInDocumentAcrossVisits` field. */
  totalConservativeDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `totalDurationInDocumentAcrossVisits` field. */
  totalDurationInDocumentAcrossVisits?: InputMaybe<IntervalFilter>;
};

/** A connection to a list of `MaDocumentStatistic` values. */
export type MaDocumentStatisticsConnection = {
  __typename?: 'MaDocumentStatisticsConnection';
  /** A list of edges which contains the `MaDocumentStatistic` and cursor to aid in pagination. */
  edges: Array<MaDocumentStatisticsEdge>;
  /** A list of `MaDocumentStatistic` objects. */
  nodes: Array<Maybe<MaDocumentStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaDocumentStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaDocumentStatistic` edge in the connection. */
export type MaDocumentStatisticsEdge = {
  __typename?: 'MaDocumentStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaDocumentStatistic` at the end of the edge. */
  node?: Maybe<MaDocumentStatistic>;
};

/** Methods to use when ordering `MaDocumentStatistic`. */
export enum MaDocumentStatisticsOrderBy {
  AverageConservativeDurationInDocumentPerVisitAsc = 'AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  AverageConservativeDurationInDocumentPerVisitDesc = 'AVERAGE_CONSERVATIVE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  AverageDurationInDocumentPerVisitAsc = 'AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_ASC',
  AverageDurationInDocumentPerVisitDesc = 'AVERAGE_DURATION_IN_DOCUMENT_PER_VISIT_DESC',
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  MaxConservativeDurationInDocumentAcrossVisitsAsc = 'MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaxConservativeDurationInDocumentAcrossVisitsDesc = 'MAX_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MaxDurationInDocumentAcrossVisitsAsc = 'MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  MaxDurationInDocumentAcrossVisitsDesc = 'MAX_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  MimeTypeAsc = 'MIME_TYPE_ASC',
  MimeTypeDesc = 'MIME_TYPE_DESC',
  Natural = 'NATURAL',
  NumCurrentSharesAsc = 'NUM_CURRENT_SHARES_ASC',
  NumCurrentSharesDesc = 'NUM_CURRENT_SHARES_DESC',
  NumDownloadsAsc = 'NUM_DOWNLOADS_ASC',
  NumDownloadsDesc = 'NUM_DOWNLOADS_DESC',
  NumSharesAsc = 'NUM_SHARES_ASC',
  NumSharesDesc = 'NUM_SHARES_DESC',
  NumVisitsAsc = 'NUM_VISITS_ASC',
  NumVisitsDesc = 'NUM_VISITS_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC',
  TotalConservativeDurationInDocumentAcrossVisitsAsc = 'TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  TotalConservativeDurationInDocumentAcrossVisitsDesc = 'TOTAL_CONSERVATIVE_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC',
  TotalDurationInDocumentAcrossVisitsAsc = 'TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_ASC',
  TotalDurationInDocumentAcrossVisitsDesc = 'TOTAL_DURATION_IN_DOCUMENT_ACROSS_VISITS_DESC'
}

/** A `MaGroupedDocumentSpaceVisitsRecord` edge in the connection. */
export type MaGroupedDocumentSpaceVisitEdge = {
  __typename?: 'MaGroupedDocumentSpaceVisitEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaGroupedDocumentSpaceVisitsRecord` at the end of the edge. */
  node?: Maybe<MaGroupedDocumentSpaceVisitsRecord>;
};

/** A connection to a list of `MaGroupedDocumentSpaceVisitsRecord` values. */
export type MaGroupedDocumentSpaceVisitsConnection = {
  __typename?: 'MaGroupedDocumentSpaceVisitsConnection';
  /** A list of edges which contains the `MaGroupedDocumentSpaceVisitsRecord` and cursor to aid in pagination. */
  edges: Array<MaGroupedDocumentSpaceVisitEdge>;
  /** A list of `MaGroupedDocumentSpaceVisitsRecord` objects. */
  nodes: Array<Maybe<MaGroupedDocumentSpaceVisitsRecord>>;
  /** The count of *all* `MaGroupedDocumentSpaceVisitsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `maGroupedDocumentSpaceVisits` query. */
export type MaGroupedDocumentSpaceVisitsRecord = {
  __typename?: 'MaGroupedDocumentSpaceVisitsRecord';
  documentDownload?: Maybe<Scalars['Boolean']['output']>;
  documentHit?: Maybe<Scalars['Boolean']['output']>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  latestVisit?: Maybe<Scalars['Datetime']['output']>;
  linkClick?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalVisits?: Maybe<Scalars['BigInt']['output']>;
  videoHit?: Maybe<Scalars['Boolean']['output']>;
  visitDay?: Maybe<Scalars['Date']['output']>;
};

/** A filter to be used against `MaGroupedDocumentSpaceVisitsRecord` object types. All fields are combined with a logical ‘and.’ */
export type MaGroupedDocumentSpaceVisitsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaGroupedDocumentSpaceVisitsRecordFilter>>;
  /** Filter by the object’s `documentDownload` field. */
  documentDownload?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `documentHit` field. */
  documentHit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `latestVisit` field. */
  latestVisit?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `linkClick` field. */
  linkClick?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaGroupedDocumentSpaceVisitsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaGroupedDocumentSpaceVisitsRecordFilter>>;
  /** Filter by the object’s `totalVisits` field. */
  totalVisits?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `videoHit` field. */
  videoHit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `visitDay` field. */
  visitDay?: InputMaybe<DateFilter>;
};

/** A `MaLatestSpaceVisitsRecord` edge in the connection. */
export type MaLatestSpaceVisitEdge = {
  __typename?: 'MaLatestSpaceVisitEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaLatestSpaceVisitsRecord` at the end of the edge. */
  node?: Maybe<MaLatestSpaceVisitsRecord>;
};

/** A connection to a list of `MaLatestSpaceVisitsRecord` values. */
export type MaLatestSpaceVisitsConnection = {
  __typename?: 'MaLatestSpaceVisitsConnection';
  /** A list of edges which contains the `MaLatestSpaceVisitsRecord` and cursor to aid in pagination. */
  edges: Array<MaLatestSpaceVisitEdge>;
  /** A list of `MaLatestSpaceVisitsRecord` objects. */
  nodes: Array<Maybe<MaLatestSpaceVisitsRecord>>;
  /** The count of *all* `MaLatestSpaceVisitsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `maLatestSpaceVisits` query. */
export type MaLatestSpaceVisitsRecord = {
  __typename?: 'MaLatestSpaceVisitsRecord';
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  latestVisitDay?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `MaLatestSpaceVisitsRecord` object types. All fields are combined with a logical ‘and.’ */
export type MaLatestSpaceVisitsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaLatestSpaceVisitsRecordFilter>>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `latestVisitDay` field. */
  latestVisitDay?: InputMaybe<DateFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaLatestSpaceVisitsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaLatestSpaceVisitsRecordFilter>>;
};

export type MaLinkStatistic = {
  __typename?: 'MaLinkStatistic';
  numClicks?: Maybe<Scalars['BigInt']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MaLinkStatistic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MaLinkStatisticCondition = {
  /** Checks for equality with the object’s `numClicks` field. */
  numClicks?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MaLinkStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaLinkStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaLinkStatisticFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<MaLinkStatisticFilter>;
  /** Filter by the object’s `numClicks` field. */
  numClicks?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaLinkStatisticFilter>>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MaLinkStatistic` values. */
export type MaLinkStatisticsConnection = {
  __typename?: 'MaLinkStatisticsConnection';
  /** A list of edges which contains the `MaLinkStatistic` and cursor to aid in pagination. */
  edges: Array<MaLinkStatisticsEdge>;
  /** A list of `MaLinkStatistic` objects. */
  nodes: Array<Maybe<MaLinkStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaLinkStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaLinkStatistic` edge in the connection. */
export type MaLinkStatisticsEdge = {
  __typename?: 'MaLinkStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaLinkStatistic` at the end of the edge. */
  node?: Maybe<MaLinkStatistic>;
};

/** Methods to use when ordering `MaLinkStatistic`. */
export enum MaLinkStatisticsOrderBy {
  Natural = 'NATURAL',
  NumClicksAsc = 'NUM_CLICKS_ASC',
  NumClicksDesc = 'NUM_CLICKS_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC'
}

export type MaPageStatistic = {
  __typename?: 'MaPageStatistic';
  averageConservativeDurationOnPagePerVisit?: Maybe<Interval>;
  averageDurationOnPagePerVisit?: Maybe<Interval>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  maxConservativeDurationOnPageAcrossVisits?: Maybe<Interval>;
  maxDurationOnPageAcrossVisits?: Maybe<Interval>;
  numVisits?: Maybe<Scalars['BigInt']['output']>;
  pageNumber?: Maybe<Scalars['BigInt']['output']>;
  totalConservativeDurationOnPageAcrossVisits?: Maybe<Interval>;
  totalDurationOnPageAcrossVisits?: Maybe<Interval>;
};

/**
 * A condition to be used against `MaPageStatistic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MaPageStatisticCondition = {
  /** Checks for equality with the object’s `averageConservativeDurationOnPagePerVisit` field. */
  averageConservativeDurationOnPagePerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `averageDurationOnPagePerVisit` field. */
  averageDurationOnPagePerVisit?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxConservativeDurationOnPageAcrossVisits` field. */
  maxConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `maxDurationOnPageAcrossVisits` field. */
  maxDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `numVisits` field. */
  numVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalConservativeDurationOnPageAcrossVisits` field. */
  totalConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `totalDurationOnPageAcrossVisits` field. */
  totalDurationOnPageAcrossVisits?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `MaPageStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MaPageStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaPageStatisticFilter>>;
  /** Filter by the object’s `averageConservativeDurationOnPagePerVisit` field. */
  averageConservativeDurationOnPagePerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `averageDurationOnPagePerVisit` field. */
  averageDurationOnPagePerVisit?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxConservativeDurationOnPageAcrossVisits` field. */
  maxConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `maxDurationOnPageAcrossVisits` field. */
  maxDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaPageStatisticFilter>;
  /** Filter by the object’s `numVisits` field. */
  numVisits?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaPageStatisticFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalConservativeDurationOnPageAcrossVisits` field. */
  totalConservativeDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `totalDurationOnPageAcrossVisits` field. */
  totalDurationOnPageAcrossVisits?: InputMaybe<IntervalFilter>;
};

/** A connection to a list of `MaPageStatistic` values. */
export type MaPageStatisticsConnection = {
  __typename?: 'MaPageStatisticsConnection';
  /** A list of edges which contains the `MaPageStatistic` and cursor to aid in pagination. */
  edges: Array<MaPageStatisticsEdge>;
  /** A list of `MaPageStatistic` objects. */
  nodes: Array<Maybe<MaPageStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaPageStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaPageStatistic` edge in the connection. */
export type MaPageStatisticsEdge = {
  __typename?: 'MaPageStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaPageStatistic` at the end of the edge. */
  node?: Maybe<MaPageStatistic>;
};

/** Methods to use when ordering `MaPageStatistic`. */
export enum MaPageStatisticsOrderBy {
  AverageConservativeDurationOnPagePerVisitAsc = 'AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_ASC',
  AverageConservativeDurationOnPagePerVisitDesc = 'AVERAGE_CONSERVATIVE_DURATION_ON_PAGE_PER_VISIT_DESC',
  AverageDurationOnPagePerVisitAsc = 'AVERAGE_DURATION_ON_PAGE_PER_VISIT_ASC',
  AverageDurationOnPagePerVisitDesc = 'AVERAGE_DURATION_ON_PAGE_PER_VISIT_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  MaxConservativeDurationOnPageAcrossVisitsAsc = 'MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaxConservativeDurationOnPageAcrossVisitsDesc = 'MAX_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  MaxDurationOnPageAcrossVisitsAsc = 'MAX_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  MaxDurationOnPageAcrossVisitsDesc = 'MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  Natural = 'NATURAL',
  NumVisitsAsc = 'NUM_VISITS_ASC',
  NumVisitsDesc = 'NUM_VISITS_DESC',
  PageNumberAsc = 'PAGE_NUMBER_ASC',
  PageNumberDesc = 'PAGE_NUMBER_DESC',
  TotalConservativeDurationOnPageAcrossVisitsAsc = 'TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  TotalConservativeDurationOnPageAcrossVisitsDesc = 'TOTAL_CONSERVATIVE_DURATION_ON_PAGE_ACROSS_VISITS_DESC',
  TotalDurationOnPageAcrossVisitsAsc = 'TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_ASC',
  TotalDurationOnPageAcrossVisitsDesc = 'TOTAL_DURATION_ON_PAGE_ACROSS_VISITS_DESC'
}

export type MaSpaceUsageByTeam = {
  __typename?: 'MaSpaceUsageByTeam';
  analyticsAlias?: Maybe<Scalars['String']['output']>;
  nTotalClicks?: Maybe<Scalars['BigFloat']['output']>;
  nTotalDocumentVisits?: Maybe<Scalars['BigFloat']['output']>;
  nTotalDownloads?: Maybe<Scalars['BigFloat']['output']>;
  nTotalSpaceVisits?: Maybe<Scalars['BigInt']['output']>;
  nTotalSpaces?: Maybe<Scalars['BigInt']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `MaSpaceUsageByTeam` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MaSpaceUsageByTeamCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nTotalClicks` field. */
  nTotalClicks?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `nTotalDocumentVisits` field. */
  nTotalDocumentVisits?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `nTotalDownloads` field. */
  nTotalDownloads?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `nTotalSpaceVisits` field. */
  nTotalSpaceVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTotalSpaces` field. */
  nTotalSpaces?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `MaSpaceUsageByTeam` object types. All fields are combined with a logical ‘and.’ */
export type MaSpaceUsageByTeamFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaSpaceUsageByTeamFilter>>;
  /** Filter by the object’s `nTotalClicks` field. */
  nTotalClicks?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `nTotalDocumentVisits` field. */
  nTotalDocumentVisits?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `nTotalDownloads` field. */
  nTotalDownloads?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `nTotalSpaceVisits` field. */
  nTotalSpaceVisits?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTotalSpaces` field. */
  nTotalSpaces?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaSpaceUsageByTeamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaSpaceUsageByTeamFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
};

export type MaSpaceUsageByTeamsAndYear = {
  __typename?: 'MaSpaceUsageByTeamsAndYear';
  analyticsAlias?: Maybe<Scalars['String']['output']>;
  nTotalClicks?: Maybe<Scalars['BigInt']['output']>;
  nTotalDocumentVisits?: Maybe<Scalars['BigInt']['output']>;
  nTotalDownloads?: Maybe<Scalars['BigInt']['output']>;
  nTotalSpaceVisits?: Maybe<Scalars['BigInt']['output']>;
  nTotalSpaces?: Maybe<Scalars['BigInt']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  year?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `MaSpaceUsageByTeamsAndYear` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MaSpaceUsageByTeamsAndYearCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nTotalClicks` field. */
  nTotalClicks?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTotalDocumentVisits` field. */
  nTotalDocumentVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTotalDownloads` field. */
  nTotalDownloads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTotalSpaceVisits` field. */
  nTotalSpaceVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTotalSpaces` field. */
  nTotalSpaces?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `MaSpaceUsageByTeamsAndYear` object types. All fields are combined with a logical ‘and.’ */
export type MaSpaceUsageByTeamsAndYearFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaSpaceUsageByTeamsAndYearFilter>>;
  /** Filter by the object’s `nTotalClicks` field. */
  nTotalClicks?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTotalDocumentVisits` field. */
  nTotalDocumentVisits?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTotalDownloads` field. */
  nTotalDownloads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTotalSpaceVisits` field. */
  nTotalSpaceVisits?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTotalSpaces` field. */
  nTotalSpaces?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaSpaceUsageByTeamsAndYearFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaSpaceUsageByTeamsAndYearFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `MaSpaceUsageByTeamsAndYear` values. */
export type MaSpaceUsageByTeamsAndYearsConnection = {
  __typename?: 'MaSpaceUsageByTeamsAndYearsConnection';
  /** A list of edges which contains the `MaSpaceUsageByTeamsAndYear` and cursor to aid in pagination. */
  edges: Array<MaSpaceUsageByTeamsAndYearsEdge>;
  /** A list of `MaSpaceUsageByTeamsAndYear` objects. */
  nodes: Array<Maybe<MaSpaceUsageByTeamsAndYear>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaSpaceUsageByTeamsAndYear` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaSpaceUsageByTeamsAndYear` edge in the connection. */
export type MaSpaceUsageByTeamsAndYearsEdge = {
  __typename?: 'MaSpaceUsageByTeamsAndYearsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaSpaceUsageByTeamsAndYear` at the end of the edge. */
  node?: Maybe<MaSpaceUsageByTeamsAndYear>;
};

/** Methods to use when ordering `MaSpaceUsageByTeamsAndYear`. */
export enum MaSpaceUsageByTeamsAndYearsOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  Natural = 'NATURAL',
  NTotalClicksAsc = 'N_TOTAL_CLICKS_ASC',
  NTotalClicksDesc = 'N_TOTAL_CLICKS_DESC',
  NTotalDocumentVisitsAsc = 'N_TOTAL_DOCUMENT_VISITS_ASC',
  NTotalDocumentVisitsDesc = 'N_TOTAL_DOCUMENT_VISITS_DESC',
  NTotalDownloadsAsc = 'N_TOTAL_DOWNLOADS_ASC',
  NTotalDownloadsDesc = 'N_TOTAL_DOWNLOADS_DESC',
  NTotalSpacesAsc = 'N_TOTAL_SPACES_ASC',
  NTotalSpacesDesc = 'N_TOTAL_SPACES_DESC',
  NTotalSpaceVisitsAsc = 'N_TOTAL_SPACE_VISITS_ASC',
  NTotalSpaceVisitsDesc = 'N_TOTAL_SPACE_VISITS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

/** A connection to a list of `MaSpaceUsageByTeam` values. */
export type MaSpaceUsageByTeamsConnection = {
  __typename?: 'MaSpaceUsageByTeamsConnection';
  /** A list of edges which contains the `MaSpaceUsageByTeam` and cursor to aid in pagination. */
  edges: Array<MaSpaceUsageByTeamsEdge>;
  /** A list of `MaSpaceUsageByTeam` objects. */
  nodes: Array<Maybe<MaSpaceUsageByTeam>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaSpaceUsageByTeam` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaSpaceUsageByTeam` edge in the connection. */
export type MaSpaceUsageByTeamsEdge = {
  __typename?: 'MaSpaceUsageByTeamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaSpaceUsageByTeam` at the end of the edge. */
  node?: Maybe<MaSpaceUsageByTeam>;
};

/** Methods to use when ordering `MaSpaceUsageByTeam`. */
export enum MaSpaceUsageByTeamsOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  Natural = 'NATURAL',
  NTotalClicksAsc = 'N_TOTAL_CLICKS_ASC',
  NTotalClicksDesc = 'N_TOTAL_CLICKS_DESC',
  NTotalDocumentVisitsAsc = 'N_TOTAL_DOCUMENT_VISITS_ASC',
  NTotalDocumentVisitsDesc = 'N_TOTAL_DOCUMENT_VISITS_DESC',
  NTotalDownloadsAsc = 'N_TOTAL_DOWNLOADS_ASC',
  NTotalDownloadsDesc = 'N_TOTAL_DOWNLOADS_DESC',
  NTotalSpacesAsc = 'N_TOTAL_SPACES_ASC',
  NTotalSpacesDesc = 'N_TOTAL_SPACES_DESC',
  NTotalSpaceVisitsAsc = 'N_TOTAL_SPACE_VISITS_ASC',
  NTotalSpaceVisitsDesc = 'N_TOTAL_SPACE_VISITS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

export type MaUsageByTeam = {
  __typename?: 'MaUsageByTeam';
  analyticsAlias?: Maybe<Scalars['String']['output']>;
  nNewUsersCreatedInLastSixMonths?: Maybe<Scalars['BigInt']['output']>;
  nNewUsersCreatedInLastYear?: Maybe<Scalars['BigInt']['output']>;
  nNewUsersRegisteredInLastSixMonths?: Maybe<Scalars['BigInt']['output']>;
  nNewUsersRegisteredInLastYear?: Maybe<Scalars['BigInt']['output']>;
  nPresentations?: Maybe<Scalars['BigInt']['output']>;
  nTimesOpenedADocument?: Maybe<Scalars['BigInt']['output']>;
  nTimesOpenedTheApp?: Maybe<Scalars['BigInt']['output']>;
  nUploads?: Maybe<Scalars['BigInt']['output']>;
  nUsersThatOpenedTheAppAtLeastOnce?: Maybe<Scalars['BigInt']['output']>;
  nUsersThatPresentedAtLeastOnce?: Maybe<Scalars['BigInt']['output']>;
  nUsersTotal?: Maybe<Scalars['BigInt']['output']>;
  nUsersTotalRegistered?: Maybe<Scalars['BigInt']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `MaUsageByTeam` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MaUsageByTeamCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nNewUsersCreatedInLastSixMonths` field. */
  nNewUsersCreatedInLastSixMonths?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nNewUsersCreatedInLastYear` field. */
  nNewUsersCreatedInLastYear?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nNewUsersRegisteredInLastSixMonths` field. */
  nNewUsersRegisteredInLastSixMonths?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nNewUsersRegisteredInLastYear` field. */
  nNewUsersRegisteredInLastYear?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nPresentations` field. */
  nPresentations?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTimesOpenedADocument` field. */
  nTimesOpenedADocument?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTimesOpenedTheApp` field. */
  nTimesOpenedTheApp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUploads` field. */
  nUploads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersThatOpenedTheAppAtLeastOnce` field. */
  nUsersThatOpenedTheAppAtLeastOnce?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersThatPresentedAtLeastOnce` field. */
  nUsersThatPresentedAtLeastOnce?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersTotal` field. */
  nUsersTotal?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersTotalRegistered` field. */
  nUsersTotalRegistered?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `MaUsageByTeam` object types. All fields are combined with a logical ‘and.’ */
export type MaUsageByTeamFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaUsageByTeamFilter>>;
  /** Filter by the object’s `nNewUsersCreatedInLastSixMonths` field. */
  nNewUsersCreatedInLastSixMonths?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nNewUsersCreatedInLastYear` field. */
  nNewUsersCreatedInLastYear?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nNewUsersRegisteredInLastSixMonths` field. */
  nNewUsersRegisteredInLastSixMonths?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nNewUsersRegisteredInLastYear` field. */
  nNewUsersRegisteredInLastYear?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nPresentations` field. */
  nPresentations?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTimesOpenedADocument` field. */
  nTimesOpenedADocument?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTimesOpenedTheApp` field. */
  nTimesOpenedTheApp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUploads` field. */
  nUploads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersThatOpenedTheAppAtLeastOnce` field. */
  nUsersThatOpenedTheAppAtLeastOnce?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersThatPresentedAtLeastOnce` field. */
  nUsersThatPresentedAtLeastOnce?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersTotal` field. */
  nUsersTotal?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersTotalRegistered` field. */
  nUsersTotalRegistered?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaUsageByTeamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaUsageByTeamFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
};

export type MaUsageByTeamsAllTimeMembershipAndYear = {
  __typename?: 'MaUsageByTeamsAllTimeMembershipAndYear';
  analyticsAlias?: Maybe<Scalars['String']['output']>;
  nPresentations?: Maybe<Scalars['BigInt']['output']>;
  nTimesOpenedADocument?: Maybe<Scalars['BigInt']['output']>;
  nTimesOpenedTheApp?: Maybe<Scalars['BigInt']['output']>;
  nUploads?: Maybe<Scalars['BigInt']['output']>;
  nUsersThatOpenedTheAppAtLeastOnce?: Maybe<Scalars['BigInt']['output']>;
  nUsersThatPresentedAtLeastOnce?: Maybe<Scalars['BigInt']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  year?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `MaUsageByTeamsAllTimeMembershipAndYear` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type MaUsageByTeamsAllTimeMembershipAndYearCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nPresentations` field. */
  nPresentations?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTimesOpenedADocument` field. */
  nTimesOpenedADocument?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTimesOpenedTheApp` field. */
  nTimesOpenedTheApp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUploads` field. */
  nUploads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersThatOpenedTheAppAtLeastOnce` field. */
  nUsersThatOpenedTheAppAtLeastOnce?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersThatPresentedAtLeastOnce` field. */
  nUsersThatPresentedAtLeastOnce?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `MaUsageByTeamsAllTimeMembershipAndYear` object types. All fields are combined with a logical ‘and.’ */
export type MaUsageByTeamsAllTimeMembershipAndYearFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaUsageByTeamsAllTimeMembershipAndYearFilter>>;
  /** Filter by the object’s `nPresentations` field. */
  nPresentations?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTimesOpenedADocument` field. */
  nTimesOpenedADocument?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTimesOpenedTheApp` field. */
  nTimesOpenedTheApp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUploads` field. */
  nUploads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersThatOpenedTheAppAtLeastOnce` field. */
  nUsersThatOpenedTheAppAtLeastOnce?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersThatPresentedAtLeastOnce` field. */
  nUsersThatPresentedAtLeastOnce?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaUsageByTeamsAllTimeMembershipAndYearFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaUsageByTeamsAllTimeMembershipAndYearFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `MaUsageByTeamsAllTimeMembershipAndYear` values. */
export type MaUsageByTeamsAllTimeMembershipAndYearsConnection = {
  __typename?: 'MaUsageByTeamsAllTimeMembershipAndYearsConnection';
  /** A list of edges which contains the `MaUsageByTeamsAllTimeMembershipAndYear` and cursor to aid in pagination. */
  edges: Array<MaUsageByTeamsAllTimeMembershipAndYearsEdge>;
  /** A list of `MaUsageByTeamsAllTimeMembershipAndYear` objects. */
  nodes: Array<Maybe<MaUsageByTeamsAllTimeMembershipAndYear>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaUsageByTeamsAllTimeMembershipAndYear` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaUsageByTeamsAllTimeMembershipAndYear` edge in the connection. */
export type MaUsageByTeamsAllTimeMembershipAndYearsEdge = {
  __typename?: 'MaUsageByTeamsAllTimeMembershipAndYearsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaUsageByTeamsAllTimeMembershipAndYear` at the end of the edge. */
  node?: Maybe<MaUsageByTeamsAllTimeMembershipAndYear>;
};

/** Methods to use when ordering `MaUsageByTeamsAllTimeMembershipAndYear`. */
export enum MaUsageByTeamsAllTimeMembershipAndYearsOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  Natural = 'NATURAL',
  NPresentationsAsc = 'N_PRESENTATIONS_ASC',
  NPresentationsDesc = 'N_PRESENTATIONS_DESC',
  NTimesOpenedADocumentAsc = 'N_TIMES_OPENED_A_DOCUMENT_ASC',
  NTimesOpenedADocumentDesc = 'N_TIMES_OPENED_A_DOCUMENT_DESC',
  NTimesOpenedTheAppAsc = 'N_TIMES_OPENED_THE_APP_ASC',
  NTimesOpenedTheAppDesc = 'N_TIMES_OPENED_THE_APP_DESC',
  NUploadsAsc = 'N_UPLOADS_ASC',
  NUploadsDesc = 'N_UPLOADS_DESC',
  NUsersThatOpenedTheAppAtLeastOnceAsc = 'N_USERS_THAT_OPENED_THE_APP_AT_LEAST_ONCE_ASC',
  NUsersThatOpenedTheAppAtLeastOnceDesc = 'N_USERS_THAT_OPENED_THE_APP_AT_LEAST_ONCE_DESC',
  NUsersThatPresentedAtLeastOnceAsc = 'N_USERS_THAT_PRESENTED_AT_LEAST_ONCE_ASC',
  NUsersThatPresentedAtLeastOnceDesc = 'N_USERS_THAT_PRESENTED_AT_LEAST_ONCE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type MaUsageByTeamsAndYear = {
  __typename?: 'MaUsageByTeamsAndYear';
  analyticsAlias?: Maybe<Scalars['String']['output']>;
  nPresentations?: Maybe<Scalars['BigInt']['output']>;
  nTimesOpenedADocument?: Maybe<Scalars['BigInt']['output']>;
  nTimesOpenedTheApp?: Maybe<Scalars['BigInt']['output']>;
  nUploads?: Maybe<Scalars['BigInt']['output']>;
  nUsersThatOpenedTheAppAtLeastOnce?: Maybe<Scalars['BigInt']['output']>;
  nUsersThatPresentedAtLeastOnce?: Maybe<Scalars['BigInt']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  year?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `MaUsageByTeamsAndYear` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MaUsageByTeamsAndYearCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nPresentations` field. */
  nPresentations?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTimesOpenedADocument` field. */
  nTimesOpenedADocument?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nTimesOpenedTheApp` field. */
  nTimesOpenedTheApp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUploads` field. */
  nUploads?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersThatOpenedTheAppAtLeastOnce` field. */
  nUsersThatOpenedTheAppAtLeastOnce?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `nUsersThatPresentedAtLeastOnce` field. */
  nUsersThatPresentedAtLeastOnce?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `MaUsageByTeamsAndYear` object types. All fields are combined with a logical ‘and.’ */
export type MaUsageByTeamsAndYearFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaUsageByTeamsAndYearFilter>>;
  /** Filter by the object’s `nPresentations` field. */
  nPresentations?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTimesOpenedADocument` field. */
  nTimesOpenedADocument?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nTimesOpenedTheApp` field. */
  nTimesOpenedTheApp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUploads` field. */
  nUploads?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersThatOpenedTheAppAtLeastOnce` field. */
  nUsersThatOpenedTheAppAtLeastOnce?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `nUsersThatPresentedAtLeastOnce` field. */
  nUsersThatPresentedAtLeastOnce?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaUsageByTeamsAndYearFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaUsageByTeamsAndYearFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `MaUsageByTeamsAndYear` values. */
export type MaUsageByTeamsAndYearsConnection = {
  __typename?: 'MaUsageByTeamsAndYearsConnection';
  /** A list of edges which contains the `MaUsageByTeamsAndYear` and cursor to aid in pagination. */
  edges: Array<MaUsageByTeamsAndYearsEdge>;
  /** A list of `MaUsageByTeamsAndYear` objects. */
  nodes: Array<Maybe<MaUsageByTeamsAndYear>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaUsageByTeamsAndYear` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaUsageByTeamsAndYear` edge in the connection. */
export type MaUsageByTeamsAndYearsEdge = {
  __typename?: 'MaUsageByTeamsAndYearsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaUsageByTeamsAndYear` at the end of the edge. */
  node?: Maybe<MaUsageByTeamsAndYear>;
};

/** Methods to use when ordering `MaUsageByTeamsAndYear`. */
export enum MaUsageByTeamsAndYearsOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  Natural = 'NATURAL',
  NPresentationsAsc = 'N_PRESENTATIONS_ASC',
  NPresentationsDesc = 'N_PRESENTATIONS_DESC',
  NTimesOpenedADocumentAsc = 'N_TIMES_OPENED_A_DOCUMENT_ASC',
  NTimesOpenedADocumentDesc = 'N_TIMES_OPENED_A_DOCUMENT_DESC',
  NTimesOpenedTheAppAsc = 'N_TIMES_OPENED_THE_APP_ASC',
  NTimesOpenedTheAppDesc = 'N_TIMES_OPENED_THE_APP_DESC',
  NUploadsAsc = 'N_UPLOADS_ASC',
  NUploadsDesc = 'N_UPLOADS_DESC',
  NUsersThatOpenedTheAppAtLeastOnceAsc = 'N_USERS_THAT_OPENED_THE_APP_AT_LEAST_ONCE_ASC',
  NUsersThatOpenedTheAppAtLeastOnceDesc = 'N_USERS_THAT_OPENED_THE_APP_AT_LEAST_ONCE_DESC',
  NUsersThatPresentedAtLeastOnceAsc = 'N_USERS_THAT_PRESENTED_AT_LEAST_ONCE_ASC',
  NUsersThatPresentedAtLeastOnceDesc = 'N_USERS_THAT_PRESENTED_AT_LEAST_ONCE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

/** A connection to a list of `MaUsageByTeam` values. */
export type MaUsageByTeamsConnection = {
  __typename?: 'MaUsageByTeamsConnection';
  /** A list of edges which contains the `MaUsageByTeam` and cursor to aid in pagination. */
  edges: Array<MaUsageByTeamsEdge>;
  /** A list of `MaUsageByTeam` objects. */
  nodes: Array<Maybe<MaUsageByTeam>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaUsageByTeam` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaUsageByTeam` edge in the connection. */
export type MaUsageByTeamsEdge = {
  __typename?: 'MaUsageByTeamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaUsageByTeam` at the end of the edge. */
  node?: Maybe<MaUsageByTeam>;
};

/** Methods to use when ordering `MaUsageByTeam`. */
export enum MaUsageByTeamsOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  Natural = 'NATURAL',
  NNewUsersCreatedInLastSixMonthsAsc = 'N_NEW_USERS_CREATED_IN_LAST_SIX_MONTHS_ASC',
  NNewUsersCreatedInLastSixMonthsDesc = 'N_NEW_USERS_CREATED_IN_LAST_SIX_MONTHS_DESC',
  NNewUsersCreatedInLastYearAsc = 'N_NEW_USERS_CREATED_IN_LAST_YEAR_ASC',
  NNewUsersCreatedInLastYearDesc = 'N_NEW_USERS_CREATED_IN_LAST_YEAR_DESC',
  NNewUsersRegisteredInLastSixMonthsAsc = 'N_NEW_USERS_REGISTERED_IN_LAST_SIX_MONTHS_ASC',
  NNewUsersRegisteredInLastSixMonthsDesc = 'N_NEW_USERS_REGISTERED_IN_LAST_SIX_MONTHS_DESC',
  NNewUsersRegisteredInLastYearAsc = 'N_NEW_USERS_REGISTERED_IN_LAST_YEAR_ASC',
  NNewUsersRegisteredInLastYearDesc = 'N_NEW_USERS_REGISTERED_IN_LAST_YEAR_DESC',
  NPresentationsAsc = 'N_PRESENTATIONS_ASC',
  NPresentationsDesc = 'N_PRESENTATIONS_DESC',
  NTimesOpenedADocumentAsc = 'N_TIMES_OPENED_A_DOCUMENT_ASC',
  NTimesOpenedADocumentDesc = 'N_TIMES_OPENED_A_DOCUMENT_DESC',
  NTimesOpenedTheAppAsc = 'N_TIMES_OPENED_THE_APP_ASC',
  NTimesOpenedTheAppDesc = 'N_TIMES_OPENED_THE_APP_DESC',
  NUploadsAsc = 'N_UPLOADS_ASC',
  NUploadsDesc = 'N_UPLOADS_DESC',
  NUsersThatOpenedTheAppAtLeastOnceAsc = 'N_USERS_THAT_OPENED_THE_APP_AT_LEAST_ONCE_ASC',
  NUsersThatOpenedTheAppAtLeastOnceDesc = 'N_USERS_THAT_OPENED_THE_APP_AT_LEAST_ONCE_DESC',
  NUsersThatPresentedAtLeastOnceAsc = 'N_USERS_THAT_PRESENTED_AT_LEAST_ONCE_ASC',
  NUsersThatPresentedAtLeastOnceDesc = 'N_USERS_THAT_PRESENTED_AT_LEAST_ONCE_DESC',
  NUsersTotalAsc = 'N_USERS_TOTAL_ASC',
  NUsersTotalDesc = 'N_USERS_TOTAL_DESC',
  NUsersTotalRegisteredAsc = 'N_USERS_TOTAL_REGISTERED_ASC',
  NUsersTotalRegisteredDesc = 'N_USERS_TOTAL_REGISTERED_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

export type MaVisitDetail = {
  __typename?: 'MaVisitDetail';
  displayTitle?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  duration?: Maybe<Interval>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  startsAt?: Maybe<Scalars['Datetime']['output']>;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visitId?: Maybe<Scalars['BigInt']['output']>;
  watchRate?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `MaVisitDetail` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MaVisitDetailCondition = {
  /** Checks for equality with the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `isPreview` field. */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `visitId` field. */
  visitId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `watchRate` field. */
  watchRate?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `MaVisitDetail` object types. All fields are combined with a logical ‘and.’ */
export type MaVisitDetailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MaVisitDetailFilter>>;
  /** Filter by the object’s `displayTitle` field. */
  displayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `isPreview` field. */
  isPreview?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MaVisitDetailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MaVisitDetailFilter>>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `thumbnailDownloadUrl` field. */
  thumbnailDownloadUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `visitId` field. */
  visitId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `watchRate` field. */
  watchRate?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `MaVisitDetail` values. */
export type MaVisitDetailsConnection = {
  __typename?: 'MaVisitDetailsConnection';
  /** A list of edges which contains the `MaVisitDetail` and cursor to aid in pagination. */
  edges: Array<MaVisitDetailsEdge>;
  /** A list of `MaVisitDetail` objects. */
  nodes: Array<Maybe<MaVisitDetail>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MaVisitDetail` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MaVisitDetail` edge in the connection. */
export type MaVisitDetailsEdge = {
  __typename?: 'MaVisitDetailsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MaVisitDetail` at the end of the edge. */
  node?: Maybe<MaVisitDetail>;
};

/** Methods to use when ordering `MaVisitDetail`. */
export enum MaVisitDetailsOrderBy {
  DisplayTitleAsc = 'DISPLAY_TITLE_ASC',
  DisplayTitleDesc = 'DISPLAY_TITLE_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IsPreviewAsc = 'IS_PREVIEW_ASC',
  IsPreviewDesc = 'IS_PREVIEW_DESC',
  Natural = 'NATURAL',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  ThumbnailDownloadUrlAsc = 'THUMBNAIL_DOWNLOAD_URL_ASC',
  ThumbnailDownloadUrlDesc = 'THUMBNAIL_DOWNLOAD_URL_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC',
  VisitIdAsc = 'VISIT_ID_ASC',
  VisitIdDesc = 'VISIT_ID_DESC',
  WatchRateAsc = 'WATCH_RATE_ASC',
  WatchRateDesc = 'WATCH_RATE_DESC'
}

/** All input for the `markAsSelfStudy` mutation. */
export type MarkAsSelfStudyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentViewId: Array<InputMaybe<Scalars['UUID']['input']>>;
};

/** The output of our `markAsSelfStudy` mutation. */
export type MarkAsSelfStudyPayload = {
  __typename?: 'MarkAsSelfStudyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  labelsOfDocumentViews?: Maybe<Array<Maybe<LabelsOfDocumentView>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `markAsVisit` mutation. */
export type MarkAsVisitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  documentViewId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** The output of our `markAsVisit` mutation. */
export type MarkAsVisitPayload = {
  __typename?: 'MarkAsVisitPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  labelsOfDocumentViews?: Maybe<Array<Maybe<LabelsOfDocumentView>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type MatchingDocument = {
  __typename?: 'MatchingDocument';
  /** Reads a single `Document` that is related to this `MatchingDocument`. */
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['BigInt']['output']>;
  matchInDisplayTitle?: Maybe<Scalars['String']['output']>;
  matchInFileName?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `MatchingDocument` object types. All fields are combined with a logical ‘and.’ */
export type MatchingDocumentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MatchingDocumentFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** A related `document` exists. */
  documentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `matchInDisplayTitle` field. */
  matchInDisplayTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `matchInFileName` field. */
  matchInFileName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MatchingDocumentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MatchingDocumentFilter>>;
  /** Filter by the object’s `rank` field. */
  rank?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `similarity` field. */
  similarity?: InputMaybe<FloatFilter>;
};

export type MatchingDocumentSpace = {
  __typename?: 'MatchingDocumentSpace';
  documentMatches?: Maybe<Array<Maybe<MatchingDocument>>>;
  /** Reads a single `DocumentSpace` that is related to this `MatchingDocumentSpace`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  matchInName?: Maybe<Scalars['String']['output']>;
  matchInPersonalMessage?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `MatchingDocumentSpace` object types. All fields are combined with a logical ‘and.’ */
export type MatchingDocumentSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MatchingDocumentSpaceFilter>>;
  /** Filter by the object’s `documentSpace` relation. */
  documentSpace?: InputMaybe<DocumentSpaceFilter>;
  /** A related `documentSpace` exists. */
  documentSpaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `matchInName` field. */
  matchInName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `matchInPersonalMessage` field. */
  matchInPersonalMessage?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MatchingDocumentSpaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MatchingDocumentSpaceFilter>>;
  /** Filter by the object’s `rank` field. */
  rank?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `similarity` field. */
  similarity?: InputMaybe<FloatFilter>;
};

/** A connection to a list of `MatchingDocumentSpace` values. */
export type MatchingDocumentSpacesConnection = {
  __typename?: 'MatchingDocumentSpacesConnection';
  /** A list of edges which contains the `MatchingDocumentSpace` and cursor to aid in pagination. */
  edges: Array<MatchingDocumentSpacesEdge>;
  /** A list of `MatchingDocumentSpace` objects. */
  nodes: Array<Maybe<MatchingDocumentSpace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MatchingDocumentSpace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MatchingDocumentSpace` edge in the connection. */
export type MatchingDocumentSpacesEdge = {
  __typename?: 'MatchingDocumentSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MatchingDocumentSpace` at the end of the edge. */
  node?: Maybe<MatchingDocumentSpace>;
};

/** A connection to a list of `MatchingDocument` values. */
export type MatchingDocumentsConnection = {
  __typename?: 'MatchingDocumentsConnection';
  /** A list of edges which contains the `MatchingDocument` and cursor to aid in pagination. */
  edges: Array<MatchingDocumentsEdge>;
  /** A list of `MatchingDocument` objects. */
  nodes: Array<Maybe<MatchingDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MatchingDocument` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MatchingDocument` edge in the connection. */
export type MatchingDocumentsEdge = {
  __typename?: 'MatchingDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MatchingDocument` at the end of the edge. */
  node?: Maybe<MatchingDocument>;
};

export type Membership = Node & {
  __typename?: 'Membership';
  createdAt: Scalars['Datetime']['output'];
  currentState: MembershipState;
  id: Scalars['BigInt']['output'];
  isManagedManually: Scalars['Boolean']['output'];
  isSyncedWithExternalGroups: Scalars['Boolean']['output'];
  mayAdministrate: Scalars['Boolean']['output'];
  mayBanUsers: Scalars['Boolean']['output'];
  mayDecideMembershipRequests: Scalars['Boolean']['output'];
  mayInviteUsers: Scalars['Boolean']['output'];
  mayOrderLicencesForThisTeam: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  subteamId?: Maybe<Scalars['BigInt']['output']>;
  sysPeriod: DatetimeRange;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  teamId: Scalars['BigInt']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
  /** Whether the member of this membership currently holds an active license. Admin-scoped to the membership team: NULL unless the caller administrates that team. */
  userHasActiveLicense?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `Membership` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MembershipCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currentState` field. */
  currentState?: InputMaybe<MembershipState>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isManagedManually` field. */
  isManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isSyncedWithExternalGroups` field. */
  isSyncedWithExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayAdministrate` field. */
  mayAdministrate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayBanUsers` field. */
  mayBanUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayDecideMembershipRequests` field. */
  mayDecideMembershipRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayInviteUsers` field. */
  mayInviteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayOrderLicencesForThisTeam` field. */
  mayOrderLicencesForThisTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `subteamId` field. */
  subteamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Membership` object types. All fields are combined with a logical ‘and.’ */
export type MembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MembershipFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentState` field. */
  currentState?: InputMaybe<MembershipStateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isManagedManually` field. */
  isManagedManually?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSyncedWithExternalGroups` field. */
  isSyncedWithExternalGroups?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayAdministrate` field. */
  mayAdministrate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayBanUsers` field. */
  mayBanUsers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayDecideMembershipRequests` field. */
  mayDecideMembershipRequests?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayInviteUsers` field. */
  mayInviteUsers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayOrderLicencesForThisTeam` field. */
  mayOrderLicencesForThisTeam?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MembershipFilter>>;
  /** Filter by the object’s `subteam` relation. */
  subteam?: InputMaybe<TeamFilter>;
  /** A related `subteam` exists. */
  subteamExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `subteamId` field. */
  subteamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<TeamFilter>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Membership` */
export type MembershipInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currentState: MembershipState;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedWithExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  mayAdministrate?: InputMaybe<Scalars['Boolean']['input']>;
  mayBanUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayDecideMembershipRequests?: InputMaybe<Scalars['Boolean']['input']>;
  mayInviteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayOrderLicencesForThisTeam?: InputMaybe<Scalars['Boolean']['input']>;
  subteamId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  teamId: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `Membership`. Fields that are set will be updated. */
export type MembershipPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currentState?: InputMaybe<MembershipState>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedWithExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  mayAdministrate?: InputMaybe<Scalars['Boolean']['input']>;
  mayBanUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayDecideMembershipRequests?: InputMaybe<Scalars['Boolean']['input']>;
  mayInviteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayOrderLicencesForThisTeam?: InputMaybe<Scalars['Boolean']['input']>;
  subteamId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

export enum MembershipState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  RefusedInvitation = 'REFUSED_INVITATION',
  WaitsForAccess = 'WAITS_FOR_ACCESS'
}

/** A filter to be used against MembershipState fields. All fields are combined with a logical ‘and.’ */
export type MembershipStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MembershipState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MembershipState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MembershipState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MembershipState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MembershipState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MembershipState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MembershipState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MembershipState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MembershipState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MembershipState>>;
};

/** A connection to a list of `Membership` values. */
export type MembershipsConnection = {
  __typename?: 'MembershipsConnection';
  /** A list of edges which contains the `Membership` and cursor to aid in pagination. */
  edges: Array<MembershipsEdge>;
  /** A list of `Membership` objects. */
  nodes: Array<Maybe<Membership>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Membership` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Membership` edge in the connection. */
export type MembershipsEdge = {
  __typename?: 'MembershipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Membership` at the end of the edge. */
  node?: Maybe<Membership>;
};

/** Methods to use when ordering `Membership`. */
export enum MembershipsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrentStateAsc = 'CURRENT_STATE_ASC',
  CurrentStateDesc = 'CURRENT_STATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsManagedManuallyAsc = 'IS_MANAGED_MANUALLY_ASC',
  IsManagedManuallyDesc = 'IS_MANAGED_MANUALLY_DESC',
  IsSyncedWithExternalGroupsAsc = 'IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  IsSyncedWithExternalGroupsDesc = 'IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MayAdministrateAsc = 'MAY_ADMINISTRATE_ASC',
  MayAdministrateDesc = 'MAY_ADMINISTRATE_DESC',
  MayBanUsersAsc = 'MAY_BAN_USERS_ASC',
  MayBanUsersDesc = 'MAY_BAN_USERS_DESC',
  MayDecideMembershipRequestsAsc = 'MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MayDecideMembershipRequestsDesc = 'MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MayInviteUsersAsc = 'MAY_INVITE_USERS_ASC',
  MayInviteUsersDesc = 'MAY_INVITE_USERS_DESC',
  MayOrderLicencesForThisTeamAsc = 'MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MayOrderLicencesForThisTeamDesc = 'MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubteamIdAsc = 'SUBTEAM_ID_ASC',
  SubteamIdDesc = 'SUBTEAM_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TeamBySubteamIdAnalyticsAliasAsc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamBySubteamIdAnalyticsAliasDesc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamBySubteamIdAnalyticsEnabledAsc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamBySubteamIdAnalyticsEnabledDesc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamBySubteamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamBySubteamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamBySubteamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamBySubteamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamBySubteamIdCreatedAtAsc = 'TEAM_BY_SUBTEAM_ID__CREATED_AT_ASC',
  TeamBySubteamIdCreatedAtDesc = 'TEAM_BY_SUBTEAM_ID__CREATED_AT_DESC',
  TeamBySubteamIdFlagsAsc = 'TEAM_BY_SUBTEAM_ID__FLAGS_ASC',
  TeamBySubteamIdFlagsDesc = 'TEAM_BY_SUBTEAM_ID__FLAGS_DESC',
  TeamBySubteamIdIdAsc = 'TEAM_BY_SUBTEAM_ID__ID_ASC',
  TeamBySubteamIdIdDesc = 'TEAM_BY_SUBTEAM_ID__ID_DESC',
  TeamBySubteamIdIsOpenAsc = 'TEAM_BY_SUBTEAM_ID__IS_OPEN_ASC',
  TeamBySubteamIdIsOpenDesc = 'TEAM_BY_SUBTEAM_ID__IS_OPEN_DESC',
  TeamBySubteamIdIsVisibleAsc = 'TEAM_BY_SUBTEAM_ID__IS_VISIBLE_ASC',
  TeamBySubteamIdIsVisibleDesc = 'TEAM_BY_SUBTEAM_ID__IS_VISIBLE_DESC',
  TeamBySubteamIdMemberCountAsc = 'TEAM_BY_SUBTEAM_ID__MEMBER_COUNT_ASC',
  TeamBySubteamIdMemberCountDesc = 'TEAM_BY_SUBTEAM_ID__MEMBER_COUNT_DESC',
  TeamBySubteamIdNameAsc = 'TEAM_BY_SUBTEAM_ID__NAME_ASC',
  TeamBySubteamIdNameDesc = 'TEAM_BY_SUBTEAM_ID__NAME_DESC',
  TeamBySubteamIdNameLowercaseAsc = 'TEAM_BY_SUBTEAM_ID__NAME_LOWERCASE_ASC',
  TeamBySubteamIdNameLowercaseDesc = 'TEAM_BY_SUBTEAM_ID__NAME_LOWERCASE_DESC',
  TeamBySubteamIdSysPeriodAsc = 'TEAM_BY_SUBTEAM_ID__SYS_PERIOD_ASC',
  TeamBySubteamIdSysPeriodDesc = 'TEAM_BY_SUBTEAM_ID__SYS_PERIOD_DESC',
  TeamBySubteamIdTenantIdAsc = 'TEAM_BY_SUBTEAM_ID__TENANT_ID_ASC',
  TeamBySubteamIdTenantIdDesc = 'TEAM_BY_SUBTEAM_ID__TENANT_ID_DESC',
  TeamBySubteamIdTotalMemberCountAsc = 'TEAM_BY_SUBTEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamBySubteamIdTotalMemberCountDesc = 'TEAM_BY_SUBTEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamBySubteamIdUpdatedAtAsc = 'TEAM_BY_SUBTEAM_ID__UPDATED_AT_ASC',
  TeamBySubteamIdUpdatedAtDesc = 'TEAM_BY_SUBTEAM_ID__UPDATED_AT_DESC',
  TeamBySubteamIdUserConfigDefaultsAsc = 'TEAM_BY_SUBTEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamBySubteamIdUserConfigDefaultsDesc = 'TEAM_BY_SUBTEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamByTeamIdAnalyticsAliasAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamByTeamIdAnalyticsAliasDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamByTeamIdAnalyticsEnabledAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamByTeamIdAnalyticsEnabledDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamByTeamIdCreatedAtAsc = 'TEAM_BY_TEAM_ID__CREATED_AT_ASC',
  TeamByTeamIdCreatedAtDesc = 'TEAM_BY_TEAM_ID__CREATED_AT_DESC',
  TeamByTeamIdFlagsAsc = 'TEAM_BY_TEAM_ID__FLAGS_ASC',
  TeamByTeamIdFlagsDesc = 'TEAM_BY_TEAM_ID__FLAGS_DESC',
  TeamByTeamIdIdAsc = 'TEAM_BY_TEAM_ID__ID_ASC',
  TeamByTeamIdIdDesc = 'TEAM_BY_TEAM_ID__ID_DESC',
  TeamByTeamIdIsOpenAsc = 'TEAM_BY_TEAM_ID__IS_OPEN_ASC',
  TeamByTeamIdIsOpenDesc = 'TEAM_BY_TEAM_ID__IS_OPEN_DESC',
  TeamByTeamIdIsVisibleAsc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_ASC',
  TeamByTeamIdIsVisibleDesc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_DESC',
  TeamByTeamIdMemberCountAsc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_ASC',
  TeamByTeamIdMemberCountDesc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_DESC',
  TeamByTeamIdNameAsc = 'TEAM_BY_TEAM_ID__NAME_ASC',
  TeamByTeamIdNameDesc = 'TEAM_BY_TEAM_ID__NAME_DESC',
  TeamByTeamIdNameLowercaseAsc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  TeamByTeamIdNameLowercaseDesc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  TeamByTeamIdSysPeriodAsc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_ASC',
  TeamByTeamIdSysPeriodDesc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_DESC',
  TeamByTeamIdTenantIdAsc = 'TEAM_BY_TEAM_ID__TENANT_ID_ASC',
  TeamByTeamIdTenantIdDesc = 'TEAM_BY_TEAM_ID__TENANT_ID_DESC',
  TeamByTeamIdTotalMemberCountAsc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamByTeamIdTotalMemberCountDesc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamByTeamIdUpdatedAtAsc = 'TEAM_BY_TEAM_ID__UPDATED_AT_ASC',
  TeamByTeamIdUpdatedAtDesc = 'TEAM_BY_TEAM_ID__UPDATED_AT_DESC',
  TeamByTeamIdUserConfigDefaultsAsc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamByTeamIdUserConfigDefaultsDesc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** All input for the `moveSpaceItem` mutation. */
export type MoveSpaceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<SpaceItemMoveType>;
  targetItemId: Scalars['BigInt']['input'];
  withId: Scalars['BigInt']['input'];
};

/** The output of our `moveSpaceItem` mutation. */
export type MoveSpaceItemPayload = {
  __typename?: 'MoveSpaceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<MoveSpaceItemRecord>;
};

/** The return type of our `moveSpaceItem` mutation. */
export type MoveSpaceItemRecord = {
  __typename?: 'MoveSpaceItemRecord';
  movedItem?: Maybe<DocumentSpaceItem>;
  targetItem?: Maybe<DocumentSpaceItem>;
};

/** All input for the `moveSpaceItemToSection` mutation. */
export type MoveSpaceItemToSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  targetSectionId: Scalars['BigInt']['input'];
  withId: Scalars['BigInt']['input'];
};

/** The output of our `moveSpaceItemToSection` mutation. */
export type MoveSpaceItemToSectionPayload = {
  __typename?: 'MoveSpaceItemToSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<MoveSpaceItemToSectionRecord>;
};

/** The return type of our `moveSpaceItemToSection` mutation. */
export type MoveSpaceItemToSectionRecord = {
  __typename?: 'MoveSpaceItemToSectionRecord';
  movedItem?: Maybe<DocumentSpaceItem>;
  targetSection?: Maybe<DocumentSpaceSection>;
};

/** All input for the `moveSpaceSection` mutation. */
export type MoveSpaceSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<SpaceSectionMoveType>;
  withId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `moveSpaceSection` mutation. */
export type MoveSpaceSectionPayload = {
  __typename?: 'MoveSpaceSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<MoveSpaceSectionRecord>;
};

/** The return type of our `moveSpaceSection` mutation. */
export type MoveSpaceSectionRecord = {
  __typename?: 'MoveSpaceSectionRecord';
  movedSection?: Maybe<DocumentSpaceSection>;
  swappedSection?: Maybe<DocumentSpaceSection>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  addDocumentToMultipleSpaces?: Maybe<AddDocumentToMultipleSpacesPayload>;
  addFlowToMultipleSpaces?: Maybe<AddFlowToMultipleSpacesPayload>;
  addTeamNotification?: Maybe<AddTeamNotificationPayload>;
  appendContentsToFlow?: Maybe<AppendContentsToFlowPayload>;
  appendPagesToFlow?: Maybe<AppendPagesToFlowPayload>;
  appendVideosToFlow?: Maybe<AppendVideosToFlowPayload>;
  assignCrmContactToDocumentSpace?: Maybe<AssignCrmContactToDocumentSpacePayload>;
  cloneDocumentSpace?: Maybe<CloneDocumentSpacePayload>;
  copyDocument?: Maybe<CopyDocumentPayload>;
  copyDocumentSpaceConfig?: Maybe<CopyDocumentSpaceConfigPayload>;
  copyFlow?: Maybe<CopyFlowPayload>;
  copyViewsToBackup?: Maybe<CopyViewsToBackupPayload>;
  /** Creates a single `ArInternalMetadatum`. */
  createArInternalMetadatum?: Maybe<CreateArInternalMetadatumPayload>;
  /** Creates a single `Campaign`. */
  createCampaign?: Maybe<CreateCampaignPayload>;
  /** Creates a single `CampaignPhase`. */
  createCampaignPhase?: Maybe<CreateCampaignPhasePayload>;
  /** Creates a single `CampaignPhaseLink`. */
  createCampaignPhaseLink?: Maybe<CreateCampaignPhaseLinkPayload>;
  /** Creates a single `CampaignQueryParam`. */
  createCampaignQueryParam?: Maybe<CreateCampaignQueryParamPayload>;
  /** Creates a single `CrmContact`. */
  createCrmContact?: Maybe<CreateCrmContactPayload>;
  /** Creates a single `CrmContactConsent`. */
  createCrmContactConsent?: Maybe<CreateCrmContactConsentPayload>;
  /** Creates a single `CrmContactPhaseMapping`. */
  createCrmContactPhaseMapping?: Maybe<CreateCrmContactPhaseMappingPayload>;
  /** Creates a single `Document`. */
  createDocument?: Maybe<CreateDocumentPayload>;
  /** Creates a single `DocumentExpiration`. */
  createDocumentExpiration?: Maybe<CreateDocumentExpirationPayload>;
  /** Creates a single `DocumentPage`. */
  createDocumentPage?: Maybe<CreateDocumentPagePayload>;
  /** Creates a single `DocumentPageLink`. */
  createDocumentPageLink?: Maybe<CreateDocumentPageLinkPayload>;
  /** Creates a single `DocumentPageMatching`. */
  createDocumentPageMatching?: Maybe<CreateDocumentPageMatchingPayload>;
  /** Creates a single `DocumentPageMatchingsBak`. */
  createDocumentPageMatchingsBak?: Maybe<CreateDocumentPageMatchingsBakPayload>;
  /** Creates a single `DocumentProcess`. */
  createDocumentProcess?: Maybe<CreateDocumentProcessPayload>;
  /** Creates a single `DocumentRevision`. */
  createDocumentRevision?: Maybe<CreateDocumentRevisionPayload>;
  /** Creates a single `DocumentSpace`. */
  createDocumentSpace?: Maybe<CreateDocumentSpacePayload>;
  /** Creates a single `DocumentSpaceAccess`. */
  createDocumentSpaceAccess?: Maybe<CreateDocumentSpaceAccessPayload>;
  createDocumentSpaceAccessToken?: Maybe<CreateDocumentSpaceAccessTokenPayload>;
  /** Creates a single `DocumentSpaceConfigTranslation`. */
  createDocumentSpaceConfigTranslation?: Maybe<CreateDocumentSpaceConfigTranslationPayload>;
  createDocumentSpaceConfigWithDefaults?: Maybe<CreateDocumentSpaceConfigWithDefaultsPayload>;
  /** Creates a single `DocumentSpaceCrmMapping`. */
  createDocumentSpaceCrmMapping?: Maybe<CreateDocumentSpaceCrmMappingPayload>;
  /** Creates a single `DocumentSpaceItem`. */
  createDocumentSpaceItem?: Maybe<CreateDocumentSpaceItemPayload>;
  /** Creates a single `DocumentSpaceLink`. */
  createDocumentSpaceLink?: Maybe<CreateDocumentSpaceLinkPayload>;
  /** Creates a single `DocumentSpaceLinkGroup`. */
  createDocumentSpaceLinkGroup?: Maybe<CreateDocumentSpaceLinkGroupPayload>;
  /** Creates a single `DocumentSpaceLinkMapping`. */
  createDocumentSpaceLinkMapping?: Maybe<CreateDocumentSpaceLinkMappingPayload>;
  /** Creates a single `DocumentSpaceLinkTranslation`. */
  createDocumentSpaceLinkTranslation?: Maybe<CreateDocumentSpaceLinkTranslationPayload>;
  /** Creates a single `DocumentSpaceSection`. */
  createDocumentSpaceSection?: Maybe<CreateDocumentSpaceSectionPayload>;
  /** Creates a single `DocumentSpaceSession`. */
  createDocumentSpaceSession?: Maybe<CreateDocumentSpaceSessionPayload>;
  /** Creates a single `DocumentSpaceTag`. */
  createDocumentSpaceTag?: Maybe<CreateDocumentSpaceTagPayload>;
  /** Creates a single `DocumentSpaceVoucher`. */
  createDocumentSpaceVoucher?: Maybe<CreateDocumentSpaceVoucherPayload>;
  createDocumentSpaceWithCrmContact?: Maybe<CreateDocumentSpaceWithCrmContactPayload>;
  /** Creates a single `DocumentSpacesOldBak`. */
  createDocumentSpacesOldBak?: Maybe<CreateDocumentSpacesOldBakPayload>;
  /** Creates a single `Event`. */
  createEvent?: Maybe<CreateEventPayload>;
  /** Creates a single `Flow`. */
  createFlow?: Maybe<CreateFlowPayload>;
  /** Creates a single `FlowItem`. */
  createFlowItem?: Maybe<CreateFlowItemPayload>;
  /** Creates a single `FlowSubscription`. */
  createFlowSubscription?: Maybe<CreateFlowSubscriptionPayload>;
  /** Creates a single `InternalIpAddress`. */
  createInternalIpAddress?: Maybe<CreateInternalIpAddressPayload>;
  /** Creates a single `LabelsOfDocumentView`. */
  createLabelsOfDocumentView?: Maybe<CreateLabelsOfDocumentViewPayload>;
  /** Creates a single `LanguageCode`. */
  createLanguageCode?: Maybe<CreateLanguageCodePayload>;
  /** Creates a single `LastCsvImport`. */
  createLastCsvImport?: Maybe<CreateLastCsvImportPayload>;
  /** Creates a single `Membership`. */
  createMembership?: Maybe<CreateMembershipPayload>;
  /** Creates a single `NonSyncableWorkspace`. */
  createNonSyncableWorkspace?: Maybe<CreateNonSyncableWorkspacePayload>;
  /** Creates a single `Notification`. */
  createNotification?: Maybe<CreateNotificationPayload>;
  /** Creates a single `OldDocumentSpace`. */
  createOldDocumentSpace?: Maybe<CreateOldDocumentSpacePayload>;
  /** Creates a single `Order`. */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Creates a single `PageHeatmap`. */
  createPageHeatmap?: Maybe<CreatePageHeatmapPayload>;
  /** Creates a single `RegistrationToken`. */
  createRegistrationToken?: Maybe<CreateRegistrationTokenPayload>;
  /** Creates a single `RetentionPolicy`. */
  createRetentionPolicy?: Maybe<CreateRetentionPolicyPayload>;
  /** Creates a single `SchemaMigration`. */
  createSchemaMigration?: Maybe<CreateSchemaMigrationPayload>;
  /** Creates a single `SerializedWorkspace`. */
  createSerializedWorkspace?: Maybe<CreateSerializedWorkspacePayload>;
  /** Creates a single `Setting`. */
  createSetting?: Maybe<CreateSettingPayload>;
  /** Creates a single `Team`. */
  createTeam?: Maybe<CreateTeamPayload>;
  /** Creates a single `TempContact`. */
  createTempContact?: Maybe<CreateTempContactPayload>;
  /** Creates a single `Tenant`. */
  createTenant?: Maybe<CreateTenantPayload>;
  /** Creates a single `UrlBasedDocumentImport`. */
  createUrlBasedDocumentImport?: Maybe<CreateUrlBasedDocumentImportPayload>;
  /** Creates a single `UrlBasedDocumentImportSetting`. */
  createUrlBasedDocumentImportSetting?: Maybe<CreateUrlBasedDocumentImportSettingPayload>;
  /** Creates a single `UserContactDetail`. */
  createUserContactDetail?: Maybe<CreateUserContactDetailPayload>;
  createUserFromFirebase?: Maybe<CreateUserFromFirebasePayload>;
  /** Creates a single `UserLicense`. */
  createUserLicense?: Maybe<CreateUserLicensePayload>;
  /** Creates a single `VeevaDocumentMetadatum`. */
  createVeevaDocumentMetadatum?: Maybe<CreateVeevaDocumentMetadatumPayload>;
  /** Creates a single `Workspace`. */
  createWorkspace?: Maybe<CreateWorkspacePayload>;
  createWorkspaceAndJoin?: Maybe<CreateWorkspaceAndJoinPayload>;
  /** Creates a single `WorkspaceSubscription`. */
  createWorkspaceSubscription?: Maybe<CreateWorkspaceSubscriptionPayload>;
  /** Deletes a single `ArInternalMetadatum` using a unique key. */
  deleteArInternalMetadatum?: Maybe<DeleteArInternalMetadatumPayload>;
  /** Deletes a single `ArInternalMetadatum` using its globally unique id. */
  deleteArInternalMetadatumByNodeId?: Maybe<DeleteArInternalMetadatumPayload>;
  /** Deletes a single `Campaign` using a unique key. */
  deleteCampaign?: Maybe<DeleteCampaignPayload>;
  /** Deletes a single `Campaign` using its globally unique id. */
  deleteCampaignByNodeId?: Maybe<DeleteCampaignPayload>;
  /** Deletes a single `CampaignPhase` using a unique key. */
  deleteCampaignPhase?: Maybe<DeleteCampaignPhasePayload>;
  /** Deletes a single `CampaignPhase` using its globally unique id. */
  deleteCampaignPhaseByNodeId?: Maybe<DeleteCampaignPhasePayload>;
  /** Deletes a single `CampaignPhaseLink` using a unique key. */
  deleteCampaignPhaseLink?: Maybe<DeleteCampaignPhaseLinkPayload>;
  /** Deletes a single `CampaignPhaseLink` using its globally unique id. */
  deleteCampaignPhaseLinkByNodeId?: Maybe<DeleteCampaignPhaseLinkPayload>;
  /** Deletes a single `CampaignQueryParam` using a unique key. */
  deleteCampaignQueryParam?: Maybe<DeleteCampaignQueryParamPayload>;
  /** Deletes a single `CampaignQueryParam` using its globally unique id. */
  deleteCampaignQueryParamByNodeId?: Maybe<DeleteCampaignQueryParamPayload>;
  /** Deletes a single `CrmContact` using a unique key. */
  deleteCrmContact?: Maybe<DeleteCrmContactPayload>;
  /** Deletes a single `CrmContact` using a unique key. */
  deleteCrmContactByCrmIdAndTenantId?: Maybe<DeleteCrmContactPayload>;
  /** Deletes a single `CrmContact` using its globally unique id. */
  deleteCrmContactByNodeId?: Maybe<DeleteCrmContactPayload>;
  /** Deletes a single `CrmContactConsent` using a unique key. */
  deleteCrmContactConsent?: Maybe<DeleteCrmContactConsentPayload>;
  /** Deletes a single `CrmContactConsent` using its globally unique id. */
  deleteCrmContactConsentByNodeId?: Maybe<DeleteCrmContactConsentPayload>;
  /** Deletes a single `CrmContactPhaseMapping` using a unique key. */
  deleteCrmContactPhaseMapping?: Maybe<DeleteCrmContactPhaseMappingPayload>;
  /** Deletes a single `CrmContactPhaseMapping` using its globally unique id. */
  deleteCrmContactPhaseMappingByNodeId?: Maybe<DeleteCrmContactPhaseMappingPayload>;
  /** Deletes a single `CrmContactPhaseMapping` using a unique key. */
  deleteCrmContactPhaseMappingByPhaseIdAndContactId?: Maybe<DeleteCrmContactPhaseMappingPayload>;
  /** Deletes a single `Document` using a unique key. */
  deleteDocument?: Maybe<DeleteDocumentPayload>;
  /** Deletes a single `Document` using a unique key. */
  deleteDocumentByFirestoreId?: Maybe<DeleteDocumentPayload>;
  /** Deletes a single `Document` using its globally unique id. */
  deleteDocumentByNodeId?: Maybe<DeleteDocumentPayload>;
  /** Deletes a single `DocumentExpiration` using a unique key. */
  deleteDocumentExpiration?: Maybe<DeleteDocumentExpirationPayload>;
  /** Deletes a single `DocumentExpiration` using its globally unique id. */
  deleteDocumentExpirationByNodeId?: Maybe<DeleteDocumentExpirationPayload>;
  /** Deletes a single `DocumentPage` using a unique key. */
  deleteDocumentPage?: Maybe<DeleteDocumentPagePayload>;
  /** Deletes a single `DocumentPage` using a unique key. */
  deleteDocumentPageByDocumentIdAndRevisionNumberAndPageNumber?: Maybe<DeleteDocumentPagePayload>;
  /** Deletes a single `DocumentPage` using its globally unique id. */
  deleteDocumentPageByNodeId?: Maybe<DeleteDocumentPagePayload>;
  /** Deletes a single `DocumentPageLink` using a unique key. */
  deleteDocumentPageLink?: Maybe<DeleteDocumentPageLinkPayload>;
  /** Deletes a single `DocumentPageLink` using its globally unique id. */
  deleteDocumentPageLinkByNodeId?: Maybe<DeleteDocumentPageLinkPayload>;
  /** Deletes a single `DocumentPageMatching` using a unique key. */
  deleteDocumentPageMatching?: Maybe<DeleteDocumentPageMatchingPayload>;
  /** Deletes a single `DocumentPageMatching` using a unique key. */
  deleteDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DeleteDocumentPageMatchingPayload>;
  /** Deletes a single `DocumentPageMatching` using a unique key. */
  deleteDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DeleteDocumentPageMatchingPayload>;
  /** Deletes a single `DocumentPageMatching` using its globally unique id. */
  deleteDocumentPageMatchingByNodeId?: Maybe<DeleteDocumentPageMatchingPayload>;
  /** Deletes a single `DocumentProcess` using a unique key. */
  deleteDocumentProcess?: Maybe<DeleteDocumentProcessPayload>;
  /** Deletes a single `DocumentProcess` using its globally unique id. */
  deleteDocumentProcessByNodeId?: Maybe<DeleteDocumentProcessPayload>;
  /** Deletes a single `DocumentRevision` using a unique key. */
  deleteDocumentRevision?: Maybe<DeleteDocumentRevisionPayload>;
  /** Deletes a single `DocumentRevision` using its globally unique id. */
  deleteDocumentRevisionByNodeId?: Maybe<DeleteDocumentRevisionPayload>;
  /** Deletes a single `DocumentSpace` using a unique key. */
  deleteDocumentSpace?: Maybe<DeleteDocumentSpacePayload>;
  /** Deletes a single `DocumentSpaceAccess` using a unique key. */
  deleteDocumentSpaceAccess?: Maybe<DeleteDocumentSpaceAccessPayload>;
  /** Deletes a single `DocumentSpaceAccess` using its globally unique id. */
  deleteDocumentSpaceAccessByNodeId?: Maybe<DeleteDocumentSpaceAccessPayload>;
  /** Deletes a single `DocumentSpaceAccess` using a unique key. */
  deleteDocumentSpaceAccessByUserIdAndDocumentSpaceId?: Maybe<DeleteDocumentSpaceAccessPayload>;
  /** Deletes a single `DocumentSpace` using a unique key. */
  deleteDocumentSpaceByCodeOnAccessCard?: Maybe<DeleteDocumentSpacePayload>;
  /** Deletes a single `DocumentSpace` using its globally unique id. */
  deleteDocumentSpaceByNodeId?: Maybe<DeleteDocumentSpacePayload>;
  /** Deletes a single `DocumentSpaceConfigTranslation` using a unique key. */
  deleteDocumentSpaceConfigTranslation?: Maybe<DeleteDocumentSpaceConfigTranslationPayload>;
  /** Deletes a single `DocumentSpaceConfigTranslation` using a unique key. */
  deleteDocumentSpaceConfigTranslationByConfigIdAndLanguageCode?: Maybe<DeleteDocumentSpaceConfigTranslationPayload>;
  /** Deletes a single `DocumentSpaceConfigTranslation` using its globally unique id. */
  deleteDocumentSpaceConfigTranslationByNodeId?: Maybe<DeleteDocumentSpaceConfigTranslationPayload>;
  /** Deletes a single `DocumentSpaceCrmMapping` using a unique key. */
  deleteDocumentSpaceCrmMapping?: Maybe<DeleteDocumentSpaceCrmMappingPayload>;
  /** Deletes a single `DocumentSpaceCrmMapping` using a unique key. */
  deleteDocumentSpaceCrmMappingByDocumentSpaceId?: Maybe<DeleteDocumentSpaceCrmMappingPayload>;
  /** Deletes a single `DocumentSpaceCrmMapping` using its globally unique id. */
  deleteDocumentSpaceCrmMappingByNodeId?: Maybe<DeleteDocumentSpaceCrmMappingPayload>;
  /** Deletes a single `DocumentSpaceItem` using a unique key. */
  deleteDocumentSpaceItem?: Maybe<DeleteDocumentSpaceItemPayload>;
  /** Deletes a single `DocumentSpaceItem` using a unique key. */
  deleteDocumentSpaceItemByDocumentIdAndDocumentSpaceId?: Maybe<DeleteDocumentSpaceItemPayload>;
  /** Deletes a single `DocumentSpaceItem` using a unique key. */
  deleteDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPosition?: Maybe<DeleteDocumentSpaceItemPayload>;
  /** Deletes a single `DocumentSpaceItem` using its globally unique id. */
  deleteDocumentSpaceItemByNodeId?: Maybe<DeleteDocumentSpaceItemPayload>;
  /** Deletes a single `DocumentSpaceLink` using a unique key. */
  deleteDocumentSpaceLink?: Maybe<DeleteDocumentSpaceLinkPayload>;
  /** Deletes a single `DocumentSpaceLink` using its globally unique id. */
  deleteDocumentSpaceLinkByNodeId?: Maybe<DeleteDocumentSpaceLinkPayload>;
  /** Deletes a single `DocumentSpaceLink` using a unique key. */
  deleteDocumentSpaceLinkByPositionAndConfigId?: Maybe<DeleteDocumentSpaceLinkPayload>;
  /** Deletes a single `DocumentSpaceLink` using a unique key. */
  deleteDocumentSpaceLinkByPositionAndDocumentSpaceId?: Maybe<DeleteDocumentSpaceLinkPayload>;
  /** Deletes a single `DocumentSpaceLinkGroup` using a unique key. */
  deleteDocumentSpaceLinkGroup?: Maybe<DeleteDocumentSpaceLinkGroupPayload>;
  /** Deletes a single `DocumentSpaceLinkGroup` using its globally unique id. */
  deleteDocumentSpaceLinkGroupByNodeId?: Maybe<DeleteDocumentSpaceLinkGroupPayload>;
  /** Deletes a single `DocumentSpaceLinkGroup` using a unique key. */
  deleteDocumentSpaceLinkGroupByTenantIdAndId?: Maybe<DeleteDocumentSpaceLinkGroupPayload>;
  /** Deletes a single `DocumentSpaceLinkMapping` using a unique key. */
  deleteDocumentSpaceLinkMapping?: Maybe<DeleteDocumentSpaceLinkMappingPayload>;
  /** Deletes a single `DocumentSpaceLinkMapping` using its globally unique id. */
  deleteDocumentSpaceLinkMappingByNodeId?: Maybe<DeleteDocumentSpaceLinkMappingPayload>;
  /** Deletes a single `DocumentSpaceLinkMapping` using a unique key. */
  deleteDocumentSpaceLinkMappingBySpaceIdAndLinkId?: Maybe<DeleteDocumentSpaceLinkMappingPayload>;
  /** Deletes a single `DocumentSpaceLinkTranslation` using a unique key. */
  deleteDocumentSpaceLinkTranslation?: Maybe<DeleteDocumentSpaceLinkTranslationPayload>;
  /** Deletes a single `DocumentSpaceLinkTranslation` using a unique key. */
  deleteDocumentSpaceLinkTranslationByLinkIdAndLanguageCode?: Maybe<DeleteDocumentSpaceLinkTranslationPayload>;
  /** Deletes a single `DocumentSpaceLinkTranslation` using its globally unique id. */
  deleteDocumentSpaceLinkTranslationByNodeId?: Maybe<DeleteDocumentSpaceLinkTranslationPayload>;
  /** Deletes a single `DocumentSpaceLinkTranslation` using a unique key. */
  deleteDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCode?: Maybe<DeleteDocumentSpaceLinkTranslationPayload>;
  deleteDocumentSpaceSection?: Maybe<DeleteDocumentSpaceSectionPayload>;
  /** Deletes a single `DocumentSpaceSession` using a unique key. */
  deleteDocumentSpaceSession?: Maybe<DeleteDocumentSpaceSessionPayload>;
  /** Deletes a single `DocumentSpaceSession` using a unique key. */
  deleteDocumentSpaceSessionByFingerprintAndDocumentSpaceId?: Maybe<DeleteDocumentSpaceSessionPayload>;
  /** Deletes a single `DocumentSpaceSession` using its globally unique id. */
  deleteDocumentSpaceSessionByNodeId?: Maybe<DeleteDocumentSpaceSessionPayload>;
  /** Deletes a single `DocumentSpaceTag` using a unique key. */
  deleteDocumentSpaceTag?: Maybe<DeleteDocumentSpaceTagPayload>;
  /** Deletes a single `DocumentSpaceTag` using its globally unique id. */
  deleteDocumentSpaceTagByNodeId?: Maybe<DeleteDocumentSpaceTagPayload>;
  /** Deletes a single `DocumentSpaceVoucher` using a unique key. */
  deleteDocumentSpaceVoucher?: Maybe<DeleteDocumentSpaceVoucherPayload>;
  /** Deletes a single `DocumentSpaceVoucher` using its globally unique id. */
  deleteDocumentSpaceVoucherByNodeId?: Maybe<DeleteDocumentSpaceVoucherPayload>;
  /** Deletes a single `Flow` using a unique key. */
  deleteFlow?: Maybe<DeleteFlowPayload>;
  /** Deletes a single `Flow` using its globally unique id. */
  deleteFlowByNodeId?: Maybe<DeleteFlowPayload>;
  /** Deletes a single `FlowItem` using a unique key. */
  deleteFlowItem?: Maybe<DeleteFlowItemPayload>;
  /** Deletes a single `FlowItem` using its globally unique id. */
  deleteFlowItemByNodeId?: Maybe<DeleteFlowItemPayload>;
  /** Deletes a single `FlowSubscription` using a unique key. */
  deleteFlowSubscription?: Maybe<DeleteFlowSubscriptionPayload>;
  /** Deletes a single `FlowSubscription` using a unique key. */
  deleteFlowSubscriptionByFlowIdAndTeamId?: Maybe<DeleteFlowSubscriptionPayload>;
  /** Deletes a single `FlowSubscription` using a unique key. */
  deleteFlowSubscriptionByFlowIdAndUserId?: Maybe<DeleteFlowSubscriptionPayload>;
  /** Deletes a single `FlowSubscription` using its globally unique id. */
  deleteFlowSubscriptionByNodeId?: Maybe<DeleteFlowSubscriptionPayload>;
  /** Deletes a single `InternalIpAddress` using a unique key. */
  deleteInternalIpAddress?: Maybe<DeleteInternalIpAddressPayload>;
  /** Deletes a single `InternalIpAddress` using its globally unique id. */
  deleteInternalIpAddressByNodeId?: Maybe<DeleteInternalIpAddressPayload>;
  /** Deletes a single `LabelsOfDocumentView` using a unique key. */
  deleteLabelsOfDocumentView?: Maybe<DeleteLabelsOfDocumentViewPayload>;
  /** Deletes a single `LabelsOfDocumentView` using its globally unique id. */
  deleteLabelsOfDocumentViewByNodeId?: Maybe<DeleteLabelsOfDocumentViewPayload>;
  /** Deletes a single `LanguageCode` using a unique key. */
  deleteLanguageCode?: Maybe<DeleteLanguageCodePayload>;
  /** Deletes a single `LanguageCode` using its globally unique id. */
  deleteLanguageCodeByNodeId?: Maybe<DeleteLanguageCodePayload>;
  /** Deletes a single `Membership` using a unique key. */
  deleteMembership?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `Membership` using its globally unique id. */
  deleteMembershipByNodeId?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `Membership` using a unique key. */
  deleteMembershipBySubteamIdAndTeamId?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `Membership` using a unique key. */
  deleteMembershipByUserIdAndTeamId?: Maybe<DeleteMembershipPayload>;
  deleteMultipleFlowItems?: Maybe<DeleteMultipleFlowItemsPayload>;
  /** Deletes a single `Notification` using a unique key. */
  deleteNotification?: Maybe<DeleteNotificationPayload>;
  /** Deletes a single `Notification` using its globally unique id. */
  deleteNotificationByNodeId?: Maybe<DeleteNotificationPayload>;
  /** Deletes a single `Order` using a unique key. */
  deleteOrder?: Maybe<DeleteOrderPayload>;
  /** Deletes a single `Order` using its globally unique id. */
  deleteOrderByNodeId?: Maybe<DeleteOrderPayload>;
  /** Deletes a single `RegistrationToken` using a unique key. */
  deleteRegistrationToken?: Maybe<DeleteRegistrationTokenPayload>;
  /** Deletes a single `RegistrationToken` using its globally unique id. */
  deleteRegistrationTokenByNodeId?: Maybe<DeleteRegistrationTokenPayload>;
  /** Deletes a single `RetentionPolicy` using a unique key. */
  deleteRetentionPolicy?: Maybe<DeleteRetentionPolicyPayload>;
  /** Deletes a single `RetentionPolicy` using its globally unique id. */
  deleteRetentionPolicyByNodeId?: Maybe<DeleteRetentionPolicyPayload>;
  /** Deletes a single `RetentionPolicy` using a unique key. */
  deleteRetentionPolicyByTeamId?: Maybe<DeleteRetentionPolicyPayload>;
  /** Deletes a single `RetentionPolicy` using a unique key. */
  deleteRetentionPolicyByTenantId?: Maybe<DeleteRetentionPolicyPayload>;
  /** Deletes a single `RetentionPolicy` using a unique key. */
  deleteRetentionPolicyByWorkspaceId?: Maybe<DeleteRetentionPolicyPayload>;
  /** Deletes a single `SchemaMigration` using a unique key. */
  deleteSchemaMigration?: Maybe<DeleteSchemaMigrationPayload>;
  /** Deletes a single `SchemaMigration` using its globally unique id. */
  deleteSchemaMigrationByNodeId?: Maybe<DeleteSchemaMigrationPayload>;
  /** Deletes a single `Setting` using a unique key. */
  deleteSetting?: Maybe<DeleteSettingPayload>;
  /** Deletes a single `Setting` using its globally unique id. */
  deleteSettingByNodeId?: Maybe<DeleteSettingPayload>;
  deleteSharedSpaceTemplate?: Maybe<DeleteSharedSpaceTemplatePayload>;
  /** Deletes a single `Team` using a unique key. */
  deleteTeam?: Maybe<DeleteTeamPayload>;
  /** Deletes a single `Team` using its globally unique id. */
  deleteTeamByNodeId?: Maybe<DeleteTeamPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenant?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantByName?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using its globally unique id. */
  deleteTenantByNodeId?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `UrlBasedDocumentImport` using a unique key. */
  deleteUrlBasedDocumentImport?: Maybe<DeleteUrlBasedDocumentImportPayload>;
  /** Deletes a single `UrlBasedDocumentImport` using its globally unique id. */
  deleteUrlBasedDocumentImportByNodeId?: Maybe<DeleteUrlBasedDocumentImportPayload>;
  /** Deletes a single `UrlBasedDocumentImportSetting` using a unique key. */
  deleteUrlBasedDocumentImportSetting?: Maybe<DeleteUrlBasedDocumentImportSettingPayload>;
  /** Deletes a single `UrlBasedDocumentImportSetting` using its globally unique id. */
  deleteUrlBasedDocumentImportSettingByNodeId?: Maybe<DeleteUrlBasedDocumentImportSettingPayload>;
  /** Deletes a single `UserContactDetail` using a unique key. */
  deleteUserContactDetail?: Maybe<DeleteUserContactDetailPayload>;
  /** Deletes a single `UserContactDetail` using its globally unique id. */
  deleteUserContactDetailByNodeId?: Maybe<DeleteUserContactDetailPayload>;
  /** Deletes a single `UserContactDetail` using a unique key. */
  deleteUserContactDetailByUserId?: Maybe<DeleteUserContactDetailPayload>;
  /** Deletes a single `UserLicense` using a unique key. */
  deleteUserLicense?: Maybe<DeleteUserLicensePayload>;
  /** Deletes a single `UserLicense` using its globally unique id. */
  deleteUserLicenseByNodeId?: Maybe<DeleteUserLicensePayload>;
  /** Deletes a single `VeevaDocumentMetadatum` using a unique key. */
  deleteVeevaDocumentMetadatum?: Maybe<DeleteVeevaDocumentMetadatumPayload>;
  /** Deletes a single `VeevaDocumentMetadatum` using its globally unique id. */
  deleteVeevaDocumentMetadatumByNodeId?: Maybe<DeleteVeevaDocumentMetadatumPayload>;
  /** Deletes a single `Workspace` using a unique key. */
  deleteWorkspace?: Maybe<DeleteWorkspacePayload>;
  /** Deletes a single `Workspace` using a unique key. */
  deleteWorkspaceByFirebaseId?: Maybe<DeleteWorkspacePayload>;
  /** Deletes a single `Workspace` using its globally unique id. */
  deleteWorkspaceByNodeId?: Maybe<DeleteWorkspacePayload>;
  /** Deletes a single `WorkspaceSubscription` using a unique key. */
  deleteWorkspaceSubscription?: Maybe<DeleteWorkspaceSubscriptionPayload>;
  /** Deletes a single `WorkspaceSubscription` using its globally unique id. */
  deleteWorkspaceSubscriptionByNodeId?: Maybe<DeleteWorkspaceSubscriptionPayload>;
  /** Deletes a single `WorkspaceSubscription` using a unique key. */
  deleteWorkspaceSubscriptionBySubteamIdAndTeamId?: Maybe<DeleteWorkspaceSubscriptionPayload>;
  /** Deletes a single `WorkspaceSubscription` using a unique key. */
  deleteWorkspaceSubscriptionByUserIdAndTeamId?: Maybe<DeleteWorkspaceSubscriptionPayload>;
  dragSpaceSection?: Maybe<DragSpaceSectionPayload>;
  enrollUserWithExternalGroupsInTeamsAndWorkspaces?: Maybe<EnrollUserWithExternalGroupsInTeamsAndWorkspacesPayload>;
  generateCodeForAccessCard?: Maybe<GenerateCodeForAccessCardPayload>;
  insertSpaceSectionAfter?: Maybe<InsertSpaceSectionAfterPayload>;
  inviteToSpaceByEmail?: Maybe<InviteToSpaceByEmailPayload>;
  inviteToTeamByEmail?: Maybe<InviteToTeamByEmailPayload>;
  joinTeam?: Maybe<JoinTeamPayload>;
  leaveTeam?: Maybe<LeaveTeamPayload>;
  markAsSelfStudy?: Maybe<MarkAsSelfStudyPayload>;
  markAsVisit?: Maybe<MarkAsVisitPayload>;
  /** Creates one or many `DocumentSpaceItem`. */
  mnCreateDocumentSpaceItem?: Maybe<MnCreateDocumentSpaceItemPayload>;
  /** Creates one or many `Membership`. */
  mnCreateMembership?: Maybe<MnCreateMembershipPayload>;
  /** Creates one or many `WorkspaceSubscription`. */
  mnCreateWorkspaceSubscription?: Maybe<MnCreateWorkspaceSubscriptionPayload>;
  /** Deletes one or many `DocumentSpaceItem` a unique key via a patch. */
  mnDeleteDocumentSpaceItem?: Maybe<MnDeleteDocumentSpaceItemPayload>;
  /** Deletes one or many `Membership` a unique key via a patch. */
  mnDeleteMembership?: Maybe<MnDeleteMembershipPayload>;
  /** Deletes one or many `WorkspaceSubscription` a unique key via a patch. */
  mnDeleteWorkspaceSubscription?: Maybe<MnDeleteWorkspaceSubscriptionPayload>;
  /** Updates one or many `DocumentSpaceItem` using a unique key and a patch. */
  mnUpdateDocumentSpaceItem?: Maybe<MnUpdateDocumentSpaceItemPayload>;
  /** Updates one or many `Membership` using a unique key and a patch. */
  mnUpdateMembership?: Maybe<MnUpdateMembershipPayload>;
  /** Updates one or many `WorkspaceSubscription` using a unique key and a patch. */
  mnUpdateWorkspaceSubscription?: Maybe<MnUpdateWorkspaceSubscriptionPayload>;
  moveSpaceItem?: Maybe<MoveSpaceItemPayload>;
  moveSpaceItemToSection?: Maybe<MoveSpaceItemToSectionPayload>;
  moveSpaceSection?: Maybe<MoveSpaceSectionPayload>;
  myWorkspaces?: Maybe<MyWorkspacesPayload>;
  placeDocument?: Maybe<PlaceDocumentPayload>;
  placeDocumentAbove?: Maybe<PlaceDocumentAbovePayload>;
  placeDocumentBelow?: Maybe<PlaceDocumentBelowPayload>;
  placeDocumentBetween?: Maybe<PlaceDocumentBetweenPayload>;
  placeFlowItem?: Maybe<PlaceFlowItemPayload>;
  placeFlowItemBefore?: Maybe<PlaceFlowItemBeforePayload>;
  placeFlowItemBehind?: Maybe<PlaceFlowItemBehindPayload>;
  placeFlowItemBetween?: Maybe<PlaceFlowItemBetweenPayload>;
  /**
   * # Parameters
   *
   * - `byId` is the (PostgreSQL) identifier of the workspace you want to add tags to.
   * - `addTags` is a string or an array of strings, naming the tags you want to add.
   *
   *
   * # Result
   *
   * You can query `result` for
   *
   * - `mergedTags`
   * - and/or the affected `workspace`.
   *
   *
   * # Example
   *
   * ```{graphql}
   * mutation AddTagsToWorkspace {
   *     pvAddTagsToWorkspace(input: {addTags: "test3", byId: "11"}) {
   *         result {
   *             mergedTags
   *             workspace {
   *                 id
   *                 name
   *                 tags
   *             }
   *         }
   *     }
   * }
   * ```
   *
   * @deprecated Workspaces should no longer be tagged. Instead, directly tag documents.
   */
  pvAddTagsToWorkspace?: Maybe<PvAddTagsToWorkspacePayload>;
  pvAddUserNotification?: Maybe<PvAddUserNotificationPayload>;
  pvAddWorkspaceNotification?: Maybe<PvAddWorkspaceNotificationPayload>;
  pvCreateVoucherForDocumentSpace?: Maybe<PvCreateVoucherForDocumentSpacePayload>;
  /**
   * # Parameter
   *
   * - `byId` is the (PostgreSQL) identifier of the workspace you want to add tags to.
   * - `dropTags` is a string or an array of strings, naming the tags you want to drop.
   *
   *
   * # Result
   *
   * You can query the `result` for
   *
   * - the `remainingTags`
   * - and/or the affected `workspace`.
   *
   *
   * # Example
   *
   * ```{graphql}
   * mutation AddTagsToWorkspace {
   *     pvAddTagsToWorkspace(input: {addTags: "test3", byId: "11"}) {
   *         result {
   *             mergedTags
   *             workspace {
   *                 id
   *                 name
   *                 tags
   *             }
   *         }
   *     }
   * }
   * ```
   *
   */
  pvDropTagsFromWorkspace?: Maybe<PvDropTagsFromWorkspacePayload>;
  pvSendTeamMessage?: Maybe<PvSendTeamMessagePayload>;
  setRegistrationToken?: Maybe<SetRegistrationTokenPayload>;
  transferOwnershipOfSpace?: Maybe<TransferOwnershipOfSpacePayload>;
  unregisterMe?: Maybe<UnregisterMePayload>;
  unregisterUser?: Maybe<UnregisterUserPayload>;
  /** Updates a single `ArInternalMetadatum` using a unique key and a patch. */
  updateArInternalMetadatum?: Maybe<UpdateArInternalMetadatumPayload>;
  /** Updates a single `ArInternalMetadatum` using its globally unique id and a patch. */
  updateArInternalMetadatumByNodeId?: Maybe<UpdateArInternalMetadatumPayload>;
  /** Updates a single `Campaign` using a unique key and a patch. */
  updateCampaign?: Maybe<UpdateCampaignPayload>;
  /** Updates a single `Campaign` using its globally unique id and a patch. */
  updateCampaignByNodeId?: Maybe<UpdateCampaignPayload>;
  /** Updates a single `CampaignPhase` using a unique key and a patch. */
  updateCampaignPhase?: Maybe<UpdateCampaignPhasePayload>;
  /** Updates a single `CampaignPhase` using its globally unique id and a patch. */
  updateCampaignPhaseByNodeId?: Maybe<UpdateCampaignPhasePayload>;
  /** Updates a single `CampaignPhaseLink` using a unique key and a patch. */
  updateCampaignPhaseLink?: Maybe<UpdateCampaignPhaseLinkPayload>;
  /** Updates a single `CampaignPhaseLink` using its globally unique id and a patch. */
  updateCampaignPhaseLinkByNodeId?: Maybe<UpdateCampaignPhaseLinkPayload>;
  /** Updates a single `CampaignQueryParam` using a unique key and a patch. */
  updateCampaignQueryParam?: Maybe<UpdateCampaignQueryParamPayload>;
  /** Updates a single `CampaignQueryParam` using its globally unique id and a patch. */
  updateCampaignQueryParamByNodeId?: Maybe<UpdateCampaignQueryParamPayload>;
  /** Updates a single `CrmContact` using a unique key and a patch. */
  updateCrmContact?: Maybe<UpdateCrmContactPayload>;
  /** Updates a single `CrmContact` using a unique key and a patch. */
  updateCrmContactByCrmIdAndTenantId?: Maybe<UpdateCrmContactPayload>;
  /** Updates a single `CrmContact` using its globally unique id and a patch. */
  updateCrmContactByNodeId?: Maybe<UpdateCrmContactPayload>;
  /** Updates a single `CrmContactConsent` using a unique key and a patch. */
  updateCrmContactConsent?: Maybe<UpdateCrmContactConsentPayload>;
  /** Updates a single `CrmContactConsent` using its globally unique id and a patch. */
  updateCrmContactConsentByNodeId?: Maybe<UpdateCrmContactConsentPayload>;
  /** Updates a single `CrmContactPhaseMapping` using a unique key and a patch. */
  updateCrmContactPhaseMapping?: Maybe<UpdateCrmContactPhaseMappingPayload>;
  /** Updates a single `CrmContactPhaseMapping` using its globally unique id and a patch. */
  updateCrmContactPhaseMappingByNodeId?: Maybe<UpdateCrmContactPhaseMappingPayload>;
  /** Updates a single `CrmContactPhaseMapping` using a unique key and a patch. */
  updateCrmContactPhaseMappingByPhaseIdAndContactId?: Maybe<UpdateCrmContactPhaseMappingPayload>;
  /** Updates a single `Document` using a unique key and a patch. */
  updateDocument?: Maybe<UpdateDocumentPayload>;
  /** Updates a single `Document` using a unique key and a patch. */
  updateDocumentByFirestoreId?: Maybe<UpdateDocumentPayload>;
  /** Updates a single `Document` using its globally unique id and a patch. */
  updateDocumentByNodeId?: Maybe<UpdateDocumentPayload>;
  /** Updates a single `DocumentExpiration` using a unique key and a patch. */
  updateDocumentExpiration?: Maybe<UpdateDocumentExpirationPayload>;
  /** Updates a single `DocumentExpiration` using its globally unique id and a patch. */
  updateDocumentExpirationByNodeId?: Maybe<UpdateDocumentExpirationPayload>;
  /** Updates a single `DocumentPage` using a unique key and a patch. */
  updateDocumentPage?: Maybe<UpdateDocumentPagePayload>;
  /** Updates a single `DocumentPage` using a unique key and a patch. */
  updateDocumentPageByDocumentIdAndRevisionNumberAndPageNumber?: Maybe<UpdateDocumentPagePayload>;
  /** Updates a single `DocumentPage` using its globally unique id and a patch. */
  updateDocumentPageByNodeId?: Maybe<UpdateDocumentPagePayload>;
  /** Updates a single `DocumentPageLink` using a unique key and a patch. */
  updateDocumentPageLink?: Maybe<UpdateDocumentPageLinkPayload>;
  /** Updates a single `DocumentPageLink` using its globally unique id and a patch. */
  updateDocumentPageLinkByNodeId?: Maybe<UpdateDocumentPageLinkPayload>;
  /** Updates a single `DocumentPageMatching` using a unique key and a patch. */
  updateDocumentPageMatching?: Maybe<UpdateDocumentPageMatchingPayload>;
  /** Updates a single `DocumentPageMatching` using a unique key and a patch. */
  updateDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<UpdateDocumentPageMatchingPayload>;
  /** Updates a single `DocumentPageMatching` using a unique key and a patch. */
  updateDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<UpdateDocumentPageMatchingPayload>;
  /** Updates a single `DocumentPageMatching` using its globally unique id and a patch. */
  updateDocumentPageMatchingByNodeId?: Maybe<UpdateDocumentPageMatchingPayload>;
  /** Updates a single `DocumentProcess` using a unique key and a patch. */
  updateDocumentProcess?: Maybe<UpdateDocumentProcessPayload>;
  /** Updates a single `DocumentProcess` using its globally unique id and a patch. */
  updateDocumentProcessByNodeId?: Maybe<UpdateDocumentProcessPayload>;
  /** Updates a single `DocumentRevision` using a unique key and a patch. */
  updateDocumentRevision?: Maybe<UpdateDocumentRevisionPayload>;
  /** Updates a single `DocumentRevision` using its globally unique id and a patch. */
  updateDocumentRevisionByNodeId?: Maybe<UpdateDocumentRevisionPayload>;
  /** Updates a single `DocumentSpace` using a unique key and a patch. */
  updateDocumentSpace?: Maybe<UpdateDocumentSpacePayload>;
  /** Updates a single `DocumentSpaceAccess` using a unique key and a patch. */
  updateDocumentSpaceAccess?: Maybe<UpdateDocumentSpaceAccessPayload>;
  /** Updates a single `DocumentSpaceAccess` using its globally unique id and a patch. */
  updateDocumentSpaceAccessByNodeId?: Maybe<UpdateDocumentSpaceAccessPayload>;
  /** Updates a single `DocumentSpaceAccess` using a unique key and a patch. */
  updateDocumentSpaceAccessByUserIdAndDocumentSpaceId?: Maybe<UpdateDocumentSpaceAccessPayload>;
  /** Updates a single `DocumentSpace` using a unique key and a patch. */
  updateDocumentSpaceByCodeOnAccessCard?: Maybe<UpdateDocumentSpacePayload>;
  /** Updates a single `DocumentSpace` using its globally unique id and a patch. */
  updateDocumentSpaceByNodeId?: Maybe<UpdateDocumentSpacePayload>;
  /** Updates a single `DocumentSpaceConfig` using a unique key and a patch. */
  updateDocumentSpaceConfig?: Maybe<UpdateDocumentSpaceConfigPayload>;
  /** Updates a single `DocumentSpaceConfig` using its globally unique id and a patch. */
  updateDocumentSpaceConfigByNodeId?: Maybe<UpdateDocumentSpaceConfigPayload>;
  /** Updates a single `DocumentSpaceConfigTranslation` using a unique key and a patch. */
  updateDocumentSpaceConfigTranslation?: Maybe<UpdateDocumentSpaceConfigTranslationPayload>;
  /** Updates a single `DocumentSpaceConfigTranslation` using a unique key and a patch. */
  updateDocumentSpaceConfigTranslationByConfigIdAndLanguageCode?: Maybe<UpdateDocumentSpaceConfigTranslationPayload>;
  /** Updates a single `DocumentSpaceConfigTranslation` using its globally unique id and a patch. */
  updateDocumentSpaceConfigTranslationByNodeId?: Maybe<UpdateDocumentSpaceConfigTranslationPayload>;
  /** Updates a single `DocumentSpaceCrmMapping` using a unique key and a patch. */
  updateDocumentSpaceCrmMapping?: Maybe<UpdateDocumentSpaceCrmMappingPayload>;
  /** Updates a single `DocumentSpaceCrmMapping` using a unique key and a patch. */
  updateDocumentSpaceCrmMappingByDocumentSpaceId?: Maybe<UpdateDocumentSpaceCrmMappingPayload>;
  /** Updates a single `DocumentSpaceCrmMapping` using its globally unique id and a patch. */
  updateDocumentSpaceCrmMappingByNodeId?: Maybe<UpdateDocumentSpaceCrmMappingPayload>;
  /** Updates a single `DocumentSpaceItem` using a unique key and a patch. */
  updateDocumentSpaceItem?: Maybe<UpdateDocumentSpaceItemPayload>;
  /** Updates a single `DocumentSpaceItem` using a unique key and a patch. */
  updateDocumentSpaceItemByDocumentIdAndDocumentSpaceId?: Maybe<UpdateDocumentSpaceItemPayload>;
  /** Updates a single `DocumentSpaceItem` using a unique key and a patch. */
  updateDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPosition?: Maybe<UpdateDocumentSpaceItemPayload>;
  /** Updates a single `DocumentSpaceItem` using its globally unique id and a patch. */
  updateDocumentSpaceItemByNodeId?: Maybe<UpdateDocumentSpaceItemPayload>;
  /** Updates a single `DocumentSpaceLink` using a unique key and a patch. */
  updateDocumentSpaceLink?: Maybe<UpdateDocumentSpaceLinkPayload>;
  /** Updates a single `DocumentSpaceLink` using its globally unique id and a patch. */
  updateDocumentSpaceLinkByNodeId?: Maybe<UpdateDocumentSpaceLinkPayload>;
  /** Updates a single `DocumentSpaceLink` using a unique key and a patch. */
  updateDocumentSpaceLinkByPositionAndConfigId?: Maybe<UpdateDocumentSpaceLinkPayload>;
  /** Updates a single `DocumentSpaceLink` using a unique key and a patch. */
  updateDocumentSpaceLinkByPositionAndDocumentSpaceId?: Maybe<UpdateDocumentSpaceLinkPayload>;
  /** Updates a single `DocumentSpaceLinkGroup` using a unique key and a patch. */
  updateDocumentSpaceLinkGroup?: Maybe<UpdateDocumentSpaceLinkGroupPayload>;
  /** Updates a single `DocumentSpaceLinkGroup` using its globally unique id and a patch. */
  updateDocumentSpaceLinkGroupByNodeId?: Maybe<UpdateDocumentSpaceLinkGroupPayload>;
  /** Updates a single `DocumentSpaceLinkGroup` using a unique key and a patch. */
  updateDocumentSpaceLinkGroupByTenantIdAndId?: Maybe<UpdateDocumentSpaceLinkGroupPayload>;
  /** Updates a single `DocumentSpaceLinkMapping` using a unique key and a patch. */
  updateDocumentSpaceLinkMapping?: Maybe<UpdateDocumentSpaceLinkMappingPayload>;
  /** Updates a single `DocumentSpaceLinkMapping` using its globally unique id and a patch. */
  updateDocumentSpaceLinkMappingByNodeId?: Maybe<UpdateDocumentSpaceLinkMappingPayload>;
  /** Updates a single `DocumentSpaceLinkMapping` using a unique key and a patch. */
  updateDocumentSpaceLinkMappingBySpaceIdAndLinkId?: Maybe<UpdateDocumentSpaceLinkMappingPayload>;
  /** Updates a single `DocumentSpaceLinkTranslation` using a unique key and a patch. */
  updateDocumentSpaceLinkTranslation?: Maybe<UpdateDocumentSpaceLinkTranslationPayload>;
  /** Updates a single `DocumentSpaceLinkTranslation` using a unique key and a patch. */
  updateDocumentSpaceLinkTranslationByLinkIdAndLanguageCode?: Maybe<UpdateDocumentSpaceLinkTranslationPayload>;
  /** Updates a single `DocumentSpaceLinkTranslation` using its globally unique id and a patch. */
  updateDocumentSpaceLinkTranslationByNodeId?: Maybe<UpdateDocumentSpaceLinkTranslationPayload>;
  /** Updates a single `DocumentSpaceLinkTranslation` using a unique key and a patch. */
  updateDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCode?: Maybe<UpdateDocumentSpaceLinkTranslationPayload>;
  /** Updates a single `DocumentSpaceSection` using a unique key and a patch. */
  updateDocumentSpaceSection?: Maybe<UpdateDocumentSpaceSectionPayload>;
  /** Updates a single `DocumentSpaceSection` using a unique key and a patch. */
  updateDocumentSpaceSectionByDocumentSpaceIdAndPosition?: Maybe<UpdateDocumentSpaceSectionPayload>;
  /** Updates a single `DocumentSpaceSection` using its globally unique id and a patch. */
  updateDocumentSpaceSectionByNodeId?: Maybe<UpdateDocumentSpaceSectionPayload>;
  /** Updates a single `DocumentSpaceSection` using a unique key and a patch. */
  updateDocumentSpaceSectionByTitleAndDocumentSpaceId?: Maybe<UpdateDocumentSpaceSectionPayload>;
  /** Updates a single `DocumentSpaceSession` using a unique key and a patch. */
  updateDocumentSpaceSession?: Maybe<UpdateDocumentSpaceSessionPayload>;
  /** Updates a single `DocumentSpaceSession` using a unique key and a patch. */
  updateDocumentSpaceSessionByFingerprintAndDocumentSpaceId?: Maybe<UpdateDocumentSpaceSessionPayload>;
  /** Updates a single `DocumentSpaceSession` using its globally unique id and a patch. */
  updateDocumentSpaceSessionByNodeId?: Maybe<UpdateDocumentSpaceSessionPayload>;
  /** Updates a single `DocumentSpaceTag` using a unique key and a patch. */
  updateDocumentSpaceTag?: Maybe<UpdateDocumentSpaceTagPayload>;
  /** Updates a single `DocumentSpaceTag` using its globally unique id and a patch. */
  updateDocumentSpaceTagByNodeId?: Maybe<UpdateDocumentSpaceTagPayload>;
  /** Updates a single `DocumentSpaceVoucher` using a unique key and a patch. */
  updateDocumentSpaceVoucher?: Maybe<UpdateDocumentSpaceVoucherPayload>;
  /** Updates a single `DocumentSpaceVoucher` using its globally unique id and a patch. */
  updateDocumentSpaceVoucherByNodeId?: Maybe<UpdateDocumentSpaceVoucherPayload>;
  /** Updates a single `Flow` using a unique key and a patch. */
  updateFlow?: Maybe<UpdateFlowPayload>;
  /** Updates a single `Flow` using its globally unique id and a patch. */
  updateFlowByNodeId?: Maybe<UpdateFlowPayload>;
  /** Updates a single `FlowItem` using a unique key and a patch. */
  updateFlowItem?: Maybe<UpdateFlowItemPayload>;
  /** Updates a single `FlowItem` using its globally unique id and a patch. */
  updateFlowItemByNodeId?: Maybe<UpdateFlowItemPayload>;
  /** Updates a single `FlowSubscription` using a unique key and a patch. */
  updateFlowSubscription?: Maybe<UpdateFlowSubscriptionPayload>;
  /** Updates a single `FlowSubscription` using a unique key and a patch. */
  updateFlowSubscriptionByFlowIdAndTeamId?: Maybe<UpdateFlowSubscriptionPayload>;
  /** Updates a single `FlowSubscription` using a unique key and a patch. */
  updateFlowSubscriptionByFlowIdAndUserId?: Maybe<UpdateFlowSubscriptionPayload>;
  /** Updates a single `FlowSubscription` using its globally unique id and a patch. */
  updateFlowSubscriptionByNodeId?: Maybe<UpdateFlowSubscriptionPayload>;
  /** Updates a single `InternalIpAddress` using a unique key and a patch. */
  updateInternalIpAddress?: Maybe<UpdateInternalIpAddressPayload>;
  /** Updates a single `InternalIpAddress` using its globally unique id and a patch. */
  updateInternalIpAddressByNodeId?: Maybe<UpdateInternalIpAddressPayload>;
  /** Updates a single `LabelsOfDocumentView` using a unique key and a patch. */
  updateLabelsOfDocumentView?: Maybe<UpdateLabelsOfDocumentViewPayload>;
  /** Updates a single `LabelsOfDocumentView` using its globally unique id and a patch. */
  updateLabelsOfDocumentViewByNodeId?: Maybe<UpdateLabelsOfDocumentViewPayload>;
  /** Updates a single `LanguageCode` using a unique key and a patch. */
  updateLanguageCode?: Maybe<UpdateLanguageCodePayload>;
  /** Updates a single `LanguageCode` using its globally unique id and a patch. */
  updateLanguageCodeByNodeId?: Maybe<UpdateLanguageCodePayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembership?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using its globally unique id and a patch. */
  updateMembershipByNodeId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembershipBySubteamIdAndTeamId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembershipByUserIdAndTeamId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Notification` using a unique key and a patch. */
  updateNotification?: Maybe<UpdateNotificationPayload>;
  /** Updates a single `Notification` using its globally unique id and a patch. */
  updateNotificationByNodeId?: Maybe<UpdateNotificationPayload>;
  /** Updates a single `Order` using a unique key and a patch. */
  updateOrder?: Maybe<UpdateOrderPayload>;
  /** Updates a single `Order` using its globally unique id and a patch. */
  updateOrderByNodeId?: Maybe<UpdateOrderPayload>;
  /** Updates a single `RegistrationToken` using a unique key and a patch. */
  updateRegistrationToken?: Maybe<UpdateRegistrationTokenPayload>;
  /** Updates a single `RegistrationToken` using its globally unique id and a patch. */
  updateRegistrationTokenByNodeId?: Maybe<UpdateRegistrationTokenPayload>;
  /** Updates a single `RetentionPolicy` using a unique key and a patch. */
  updateRetentionPolicy?: Maybe<UpdateRetentionPolicyPayload>;
  /** Updates a single `RetentionPolicy` using its globally unique id and a patch. */
  updateRetentionPolicyByNodeId?: Maybe<UpdateRetentionPolicyPayload>;
  /** Updates a single `RetentionPolicy` using a unique key and a patch. */
  updateRetentionPolicyByTeamId?: Maybe<UpdateRetentionPolicyPayload>;
  /** Updates a single `RetentionPolicy` using a unique key and a patch. */
  updateRetentionPolicyByTenantId?: Maybe<UpdateRetentionPolicyPayload>;
  /** Updates a single `RetentionPolicy` using a unique key and a patch. */
  updateRetentionPolicyByWorkspaceId?: Maybe<UpdateRetentionPolicyPayload>;
  /** Updates a single `SchemaMigration` using a unique key and a patch. */
  updateSchemaMigration?: Maybe<UpdateSchemaMigrationPayload>;
  /** Updates a single `SchemaMigration` using its globally unique id and a patch. */
  updateSchemaMigrationByNodeId?: Maybe<UpdateSchemaMigrationPayload>;
  /** Updates a single `Setting` using a unique key and a patch. */
  updateSetting?: Maybe<UpdateSettingPayload>;
  /** Updates a single `Setting` using its globally unique id and a patch. */
  updateSettingByNodeId?: Maybe<UpdateSettingPayload>;
  /** Updates a single `Team` using a unique key and a patch. */
  updateTeam?: Maybe<UpdateTeamPayload>;
  /** Updates a single `Team` using its globally unique id and a patch. */
  updateTeamByNodeId?: Maybe<UpdateTeamPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenant?: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantByName?: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using its globally unique id and a patch. */
  updateTenantByNodeId?: Maybe<UpdateTenantPayload>;
  /** Updates a single `UrlBasedDocumentImport` using a unique key and a patch. */
  updateUrlBasedDocumentImport?: Maybe<UpdateUrlBasedDocumentImportPayload>;
  /** Updates a single `UrlBasedDocumentImport` using its globally unique id and a patch. */
  updateUrlBasedDocumentImportByNodeId?: Maybe<UpdateUrlBasedDocumentImportPayload>;
  /** Updates a single `UrlBasedDocumentImportSetting` using a unique key and a patch. */
  updateUrlBasedDocumentImportSetting?: Maybe<UpdateUrlBasedDocumentImportSettingPayload>;
  /** Updates a single `UrlBasedDocumentImportSetting` using its globally unique id and a patch. */
  updateUrlBasedDocumentImportSettingByNodeId?: Maybe<UpdateUrlBasedDocumentImportSettingPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByEmail?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserByNodeId?: Maybe<UpdateUserPayload>;
  updateUserConfigPartial?: Maybe<UpdateUserConfigPartialPayload>;
  /** Updates a single `UserContactDetail` using a unique key and a patch. */
  updateUserContactDetail?: Maybe<UpdateUserContactDetailPayload>;
  /** Updates a single `UserContactDetail` using its globally unique id and a patch. */
  updateUserContactDetailByNodeId?: Maybe<UpdateUserContactDetailPayload>;
  /** Updates a single `UserContactDetail` using a unique key and a patch. */
  updateUserContactDetailByUserId?: Maybe<UpdateUserContactDetailPayload>;
  /** Updates a single `UserLicense` using a unique key and a patch. */
  updateUserLicense?: Maybe<UpdateUserLicensePayload>;
  /** Updates a single `UserLicense` using its globally unique id and a patch. */
  updateUserLicenseByNodeId?: Maybe<UpdateUserLicensePayload>;
  /** Updates a single `VeevaDocumentMetadatum` using a unique key and a patch. */
  updateVeevaDocumentMetadatum?: Maybe<UpdateVeevaDocumentMetadatumPayload>;
  /** Updates a single `VeevaDocumentMetadatum` using its globally unique id and a patch. */
  updateVeevaDocumentMetadatumByNodeId?: Maybe<UpdateVeevaDocumentMetadatumPayload>;
  /** Updates a single `Workspace` using a unique key and a patch. */
  updateWorkspace?: Maybe<UpdateWorkspacePayload>;
  /** Updates a single `Workspace` using a unique key and a patch. */
  updateWorkspaceByFirebaseId?: Maybe<UpdateWorkspacePayload>;
  /** Updates a single `Workspace` using its globally unique id and a patch. */
  updateWorkspaceByNodeId?: Maybe<UpdateWorkspacePayload>;
  /** Updates a single `WorkspaceSubscription` using a unique key and a patch. */
  updateWorkspaceSubscription?: Maybe<UpdateWorkspaceSubscriptionPayload>;
  /** Updates a single `WorkspaceSubscription` using its globally unique id and a patch. */
  updateWorkspaceSubscriptionByNodeId?: Maybe<UpdateWorkspaceSubscriptionPayload>;
  /** Updates a single `WorkspaceSubscription` using a unique key and a patch. */
  updateWorkspaceSubscriptionBySubteamIdAndTeamId?: Maybe<UpdateWorkspaceSubscriptionPayload>;
  /** Updates a single `WorkspaceSubscription` using a unique key and a patch. */
  updateWorkspaceSubscriptionByUserIdAndTeamId?: Maybe<UpdateWorkspaceSubscriptionPayload>;
  verifyDocumentSpaceAccessToken?: Maybe<VerifyDocumentSpaceAccessTokenPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddDocumentToMultipleSpacesArgs = {
  input: AddDocumentToMultipleSpacesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddFlowToMultipleSpacesArgs = {
  input: AddFlowToMultipleSpacesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddTeamNotificationArgs = {
  input: AddTeamNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppendContentsToFlowArgs = {
  input: AppendContentsToFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppendPagesToFlowArgs = {
  input: AppendPagesToFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppendVideosToFlowArgs = {
  input: AppendVideosToFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssignCrmContactToDocumentSpaceArgs = {
  input: AssignCrmContactToDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloneDocumentSpaceArgs = {
  input: CloneDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyDocumentArgs = {
  input: CopyDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyDocumentSpaceConfigArgs = {
  input: CopyDocumentSpaceConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyFlowArgs = {
  input: CopyFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyViewsToBackupArgs = {
  input: CopyViewsToBackupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateArInternalMetadatumArgs = {
  input: CreateArInternalMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCampaignPhaseArgs = {
  input: CreateCampaignPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCampaignPhaseLinkArgs = {
  input: CreateCampaignPhaseLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCampaignQueryParamArgs = {
  input: CreateCampaignQueryParamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCrmContactArgs = {
  input: CreateCrmContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCrmContactConsentArgs = {
  input: CreateCrmContactConsentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCrmContactPhaseMappingArgs = {
  input: CreateCrmContactPhaseMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentExpirationArgs = {
  input: CreateDocumentExpirationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentPageArgs = {
  input: CreateDocumentPageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentPageLinkArgs = {
  input: CreateDocumentPageLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentPageMatchingArgs = {
  input: CreateDocumentPageMatchingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentPageMatchingsBakArgs = {
  input: CreateDocumentPageMatchingsBakInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentProcessArgs = {
  input: CreateDocumentProcessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentRevisionArgs = {
  input: CreateDocumentRevisionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceArgs = {
  input: CreateDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceAccessArgs = {
  input: CreateDocumentSpaceAccessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceAccessTokenArgs = {
  input: CreateDocumentSpaceAccessTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceConfigTranslationArgs = {
  input: CreateDocumentSpaceConfigTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceConfigWithDefaultsArgs = {
  input: CreateDocumentSpaceConfigWithDefaultsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceCrmMappingArgs = {
  input: CreateDocumentSpaceCrmMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceItemArgs = {
  input: CreateDocumentSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceLinkArgs = {
  input: CreateDocumentSpaceLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceLinkGroupArgs = {
  input: CreateDocumentSpaceLinkGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceLinkMappingArgs = {
  input: CreateDocumentSpaceLinkMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceLinkTranslationArgs = {
  input: CreateDocumentSpaceLinkTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceSectionArgs = {
  input: CreateDocumentSpaceSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceSessionArgs = {
  input: CreateDocumentSpaceSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceTagArgs = {
  input: CreateDocumentSpaceTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceVoucherArgs = {
  input: CreateDocumentSpaceVoucherInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpaceWithCrmContactArgs = {
  input: CreateDocumentSpaceWithCrmContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentSpacesOldBakArgs = {
  input: CreateDocumentSpacesOldBakInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowArgs = {
  input: CreateFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowItemArgs = {
  input: CreateFlowItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFlowSubscriptionArgs = {
  input: CreateFlowSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInternalIpAddressArgs = {
  input: CreateInternalIpAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLabelsOfDocumentViewArgs = {
  input: CreateLabelsOfDocumentViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLanguageCodeArgs = {
  input: CreateLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLastCsvImportArgs = {
  input: CreateLastCsvImportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNonSyncableWorkspaceArgs = {
  input: CreateNonSyncableWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOldDocumentSpaceArgs = {
  input: CreateOldDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePageHeatmapArgs = {
  input: CreatePageHeatmapInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRegistrationTokenArgs = {
  input: CreateRegistrationTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRetentionPolicyArgs = {
  input: CreateRetentionPolicyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaMigrationArgs = {
  input: CreateSchemaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSerializedWorkspaceArgs = {
  input: CreateSerializedWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSettingArgs = {
  input: CreateSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTempContactArgs = {
  input: CreateTempContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUrlBasedDocumentImportArgs = {
  input: CreateUrlBasedDocumentImportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUrlBasedDocumentImportSettingArgs = {
  input: CreateUrlBasedDocumentImportSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserContactDetailArgs = {
  input: CreateUserContactDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserFromFirebaseArgs = {
  input: CreateUserFromFirebaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserLicenseArgs = {
  input: CreateUserLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVeevaDocumentMetadatumArgs = {
  input: CreateVeevaDocumentMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkspaceAndJoinArgs = {
  input: CreateWorkspaceAndJoinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkspaceSubscriptionArgs = {
  input: CreateWorkspaceSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteArInternalMetadatumArgs = {
  input: DeleteArInternalMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteArInternalMetadatumByNodeIdArgs = {
  input: DeleteArInternalMetadatumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignByNodeIdArgs = {
  input: DeleteCampaignByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignPhaseArgs = {
  input: DeleteCampaignPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignPhaseByNodeIdArgs = {
  input: DeleteCampaignPhaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignPhaseLinkArgs = {
  input: DeleteCampaignPhaseLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignPhaseLinkByNodeIdArgs = {
  input: DeleteCampaignPhaseLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignQueryParamArgs = {
  input: DeleteCampaignQueryParamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCampaignQueryParamByNodeIdArgs = {
  input: DeleteCampaignQueryParamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactArgs = {
  input: DeleteCrmContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactByCrmIdAndTenantIdArgs = {
  input: DeleteCrmContactByCrmIdAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactByNodeIdArgs = {
  input: DeleteCrmContactByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactConsentArgs = {
  input: DeleteCrmContactConsentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactConsentByNodeIdArgs = {
  input: DeleteCrmContactConsentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactPhaseMappingArgs = {
  input: DeleteCrmContactPhaseMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactPhaseMappingByNodeIdArgs = {
  input: DeleteCrmContactPhaseMappingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCrmContactPhaseMappingByPhaseIdAndContactIdArgs = {
  input: DeleteCrmContactPhaseMappingByPhaseIdAndContactIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentByFirestoreIdArgs = {
  input: DeleteDocumentByFirestoreIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentByNodeIdArgs = {
  input: DeleteDocumentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentExpirationArgs = {
  input: DeleteDocumentExpirationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentExpirationByNodeIdArgs = {
  input: DeleteDocumentExpirationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageArgs = {
  input: DeleteDocumentPageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageByDocumentIdAndRevisionNumberAndPageNumberArgs = {
  input: DeleteDocumentPageByDocumentIdAndRevisionNumberAndPageNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageByNodeIdArgs = {
  input: DeleteDocumentPageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageLinkArgs = {
  input: DeleteDocumentPageLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageLinkByNodeIdArgs = {
  input: DeleteDocumentPageLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageMatchingArgs = {
  input: DeleteDocumentPageMatchingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberArgs = {
  input: DeleteDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberArgs = {
  input: DeleteDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentPageMatchingByNodeIdArgs = {
  input: DeleteDocumentPageMatchingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentProcessArgs = {
  input: DeleteDocumentProcessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentProcessByNodeIdArgs = {
  input: DeleteDocumentProcessByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentRevisionArgs = {
  input: DeleteDocumentRevisionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentRevisionByNodeIdArgs = {
  input: DeleteDocumentRevisionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceArgs = {
  input: DeleteDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceAccessArgs = {
  input: DeleteDocumentSpaceAccessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceAccessByNodeIdArgs = {
  input: DeleteDocumentSpaceAccessByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceAccessByUserIdAndDocumentSpaceIdArgs = {
  input: DeleteDocumentSpaceAccessByUserIdAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceByCodeOnAccessCardArgs = {
  input: DeleteDocumentSpaceByCodeOnAccessCardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceByNodeIdArgs = {
  input: DeleteDocumentSpaceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceConfigTranslationArgs = {
  input: DeleteDocumentSpaceConfigTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeArgs = {
  input: DeleteDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceConfigTranslationByNodeIdArgs = {
  input: DeleteDocumentSpaceConfigTranslationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceCrmMappingArgs = {
  input: DeleteDocumentSpaceCrmMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceCrmMappingByDocumentSpaceIdArgs = {
  input: DeleteDocumentSpaceCrmMappingByDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceCrmMappingByNodeIdArgs = {
  input: DeleteDocumentSpaceCrmMappingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceItemArgs = {
  input: DeleteDocumentSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceItemByDocumentIdAndDocumentSpaceIdArgs = {
  input: DeleteDocumentSpaceItemByDocumentIdAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionArgs = {
  input: DeleteDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceItemByNodeIdArgs = {
  input: DeleteDocumentSpaceItemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkArgs = {
  input: DeleteDocumentSpaceLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkByNodeIdArgs = {
  input: DeleteDocumentSpaceLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkByPositionAndConfigIdArgs = {
  input: DeleteDocumentSpaceLinkByPositionAndConfigIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkByPositionAndDocumentSpaceIdArgs = {
  input: DeleteDocumentSpaceLinkByPositionAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkGroupArgs = {
  input: DeleteDocumentSpaceLinkGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkGroupByNodeIdArgs = {
  input: DeleteDocumentSpaceLinkGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkGroupByTenantIdAndIdArgs = {
  input: DeleteDocumentSpaceLinkGroupByTenantIdAndIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkMappingArgs = {
  input: DeleteDocumentSpaceLinkMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkMappingByNodeIdArgs = {
  input: DeleteDocumentSpaceLinkMappingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkMappingBySpaceIdAndLinkIdArgs = {
  input: DeleteDocumentSpaceLinkMappingBySpaceIdAndLinkIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkTranslationArgs = {
  input: DeleteDocumentSpaceLinkTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeArgs = {
  input: DeleteDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkTranslationByNodeIdArgs = {
  input: DeleteDocumentSpaceLinkTranslationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeArgs = {
  input: DeleteDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceSectionArgs = {
  input: DeleteDocumentSpaceSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceSessionArgs = {
  input: DeleteDocumentSpaceSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceSessionByFingerprintAndDocumentSpaceIdArgs = {
  input: DeleteDocumentSpaceSessionByFingerprintAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceSessionByNodeIdArgs = {
  input: DeleteDocumentSpaceSessionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceTagArgs = {
  input: DeleteDocumentSpaceTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceTagByNodeIdArgs = {
  input: DeleteDocumentSpaceTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceVoucherArgs = {
  input: DeleteDocumentSpaceVoucherInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentSpaceVoucherByNodeIdArgs = {
  input: DeleteDocumentSpaceVoucherByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowArgs = {
  input: DeleteFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowByNodeIdArgs = {
  input: DeleteFlowByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowItemArgs = {
  input: DeleteFlowItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowItemByNodeIdArgs = {
  input: DeleteFlowItemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowSubscriptionArgs = {
  input: DeleteFlowSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowSubscriptionByFlowIdAndTeamIdArgs = {
  input: DeleteFlowSubscriptionByFlowIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowSubscriptionByFlowIdAndUserIdArgs = {
  input: DeleteFlowSubscriptionByFlowIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFlowSubscriptionByNodeIdArgs = {
  input: DeleteFlowSubscriptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInternalIpAddressArgs = {
  input: DeleteInternalIpAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInternalIpAddressByNodeIdArgs = {
  input: DeleteInternalIpAddressByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelsOfDocumentViewArgs = {
  input: DeleteLabelsOfDocumentViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelsOfDocumentViewByNodeIdArgs = {
  input: DeleteLabelsOfDocumentViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLanguageCodeArgs = {
  input: DeleteLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLanguageCodeByNodeIdArgs = {
  input: DeleteLanguageCodeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipArgs = {
  input: DeleteMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipByNodeIdArgs = {
  input: DeleteMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipBySubteamIdAndTeamIdArgs = {
  input: DeleteMembershipBySubteamIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipByUserIdAndTeamIdArgs = {
  input: DeleteMembershipByUserIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMultipleFlowItemsArgs = {
  input: DeleteMultipleFlowItemsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationArgs = {
  input: DeleteNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationByNodeIdArgs = {
  input: DeleteNotificationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderByNodeIdArgs = {
  input: DeleteOrderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRegistrationTokenArgs = {
  input: DeleteRegistrationTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRegistrationTokenByNodeIdArgs = {
  input: DeleteRegistrationTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRetentionPolicyArgs = {
  input: DeleteRetentionPolicyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRetentionPolicyByNodeIdArgs = {
  input: DeleteRetentionPolicyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRetentionPolicyByTeamIdArgs = {
  input: DeleteRetentionPolicyByTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRetentionPolicyByTenantIdArgs = {
  input: DeleteRetentionPolicyByTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRetentionPolicyByWorkspaceIdArgs = {
  input: DeleteRetentionPolicyByWorkspaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaMigrationArgs = {
  input: DeleteSchemaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaMigrationByNodeIdArgs = {
  input: DeleteSchemaMigrationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSettingArgs = {
  input: DeleteSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSettingByNodeIdArgs = {
  input: DeleteSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSharedSpaceTemplateArgs = {
  input: DeleteSharedSpaceTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTeamByNodeIdArgs = {
  input: DeleteTeamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantArgs = {
  input: DeleteTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByNameArgs = {
  input: DeleteTenantByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByNodeIdArgs = {
  input: DeleteTenantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUrlBasedDocumentImportArgs = {
  input: DeleteUrlBasedDocumentImportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUrlBasedDocumentImportByNodeIdArgs = {
  input: DeleteUrlBasedDocumentImportByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUrlBasedDocumentImportSettingArgs = {
  input: DeleteUrlBasedDocumentImportSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUrlBasedDocumentImportSettingByNodeIdArgs = {
  input: DeleteUrlBasedDocumentImportSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContactDetailArgs = {
  input: DeleteUserContactDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContactDetailByNodeIdArgs = {
  input: DeleteUserContactDetailByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContactDetailByUserIdArgs = {
  input: DeleteUserContactDetailByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserLicenseArgs = {
  input: DeleteUserLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserLicenseByNodeIdArgs = {
  input: DeleteUserLicenseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVeevaDocumentMetadatumArgs = {
  input: DeleteVeevaDocumentMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVeevaDocumentMetadatumByNodeIdArgs = {
  input: DeleteVeevaDocumentMetadatumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceArgs = {
  input: DeleteWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceByFirebaseIdArgs = {
  input: DeleteWorkspaceByFirebaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceByNodeIdArgs = {
  input: DeleteWorkspaceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceSubscriptionArgs = {
  input: DeleteWorkspaceSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceSubscriptionByNodeIdArgs = {
  input: DeleteWorkspaceSubscriptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceSubscriptionBySubteamIdAndTeamIdArgs = {
  input: DeleteWorkspaceSubscriptionBySubteamIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkspaceSubscriptionByUserIdAndTeamIdArgs = {
  input: DeleteWorkspaceSubscriptionByUserIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDragSpaceSectionArgs = {
  input: DragSpaceSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEnrollUserWithExternalGroupsInTeamsAndWorkspacesArgs = {
  input: EnrollUserWithExternalGroupsInTeamsAndWorkspacesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateCodeForAccessCardArgs = {
  input: GenerateCodeForAccessCardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInsertSpaceSectionAfterArgs = {
  input: InsertSpaceSectionAfterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteToSpaceByEmailArgs = {
  input: InviteToSpaceByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteToTeamByEmailArgs = {
  input: InviteToTeamByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationJoinTeamArgs = {
  input: JoinTeamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLeaveTeamArgs = {
  input: LeaveTeamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkAsSelfStudyArgs = {
  input: MarkAsSelfStudyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkAsVisitArgs = {
  input: MarkAsVisitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateDocumentSpaceItemArgs = {
  input: MnCreateDocumentSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateMembershipArgs = {
  input: MnCreateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateWorkspaceSubscriptionArgs = {
  input: MnCreateWorkspaceSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteDocumentSpaceItemArgs = {
  input: MnDeleteDocumentSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteMembershipArgs = {
  input: MnDeleteMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteWorkspaceSubscriptionArgs = {
  input: MnDeleteWorkspaceSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateDocumentSpaceItemArgs = {
  input: MnUpdateDocumentSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateMembershipArgs = {
  input: MnUpdateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateWorkspaceSubscriptionArgs = {
  input: MnUpdateWorkspaceSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMoveSpaceItemArgs = {
  input: MoveSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMoveSpaceItemToSectionArgs = {
  input: MoveSpaceItemToSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMoveSpaceSectionArgs = {
  input: MoveSpaceSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMyWorkspacesArgs = {
  input: MyWorkspacesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceDocumentArgs = {
  input: PlaceDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceDocumentAboveArgs = {
  input: PlaceDocumentAboveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceDocumentBelowArgs = {
  input: PlaceDocumentBelowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceDocumentBetweenArgs = {
  input: PlaceDocumentBetweenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceFlowItemArgs = {
  input: PlaceFlowItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceFlowItemBeforeArgs = {
  input: PlaceFlowItemBeforeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceFlowItemBehindArgs = {
  input: PlaceFlowItemBehindInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlaceFlowItemBetweenArgs = {
  input: PlaceFlowItemBetweenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPvAddTagsToWorkspaceArgs = {
  input: PvAddTagsToWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPvAddUserNotificationArgs = {
  input: PvAddUserNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPvAddWorkspaceNotificationArgs = {
  input: PvAddWorkspaceNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPvCreateVoucherForDocumentSpaceArgs = {
  input: PvCreateVoucherForDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPvDropTagsFromWorkspaceArgs = {
  input: PvDropTagsFromWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPvSendTeamMessageArgs = {
  input: PvSendTeamMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetRegistrationTokenArgs = {
  input: SetRegistrationTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTransferOwnershipOfSpaceArgs = {
  input: TransferOwnershipOfSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnregisterMeArgs = {
  input: UnregisterMeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnregisterUserArgs = {
  input: UnregisterUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateArInternalMetadatumArgs = {
  input: UpdateArInternalMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateArInternalMetadatumByNodeIdArgs = {
  input: UpdateArInternalMetadatumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignByNodeIdArgs = {
  input: UpdateCampaignByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignPhaseArgs = {
  input: UpdateCampaignPhaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignPhaseByNodeIdArgs = {
  input: UpdateCampaignPhaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignPhaseLinkArgs = {
  input: UpdateCampaignPhaseLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignPhaseLinkByNodeIdArgs = {
  input: UpdateCampaignPhaseLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignQueryParamArgs = {
  input: UpdateCampaignQueryParamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCampaignQueryParamByNodeIdArgs = {
  input: UpdateCampaignQueryParamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactArgs = {
  input: UpdateCrmContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactByCrmIdAndTenantIdArgs = {
  input: UpdateCrmContactByCrmIdAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactByNodeIdArgs = {
  input: UpdateCrmContactByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactConsentArgs = {
  input: UpdateCrmContactConsentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactConsentByNodeIdArgs = {
  input: UpdateCrmContactConsentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactPhaseMappingArgs = {
  input: UpdateCrmContactPhaseMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactPhaseMappingByNodeIdArgs = {
  input: UpdateCrmContactPhaseMappingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCrmContactPhaseMappingByPhaseIdAndContactIdArgs = {
  input: UpdateCrmContactPhaseMappingByPhaseIdAndContactIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentByFirestoreIdArgs = {
  input: UpdateDocumentByFirestoreIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentByNodeIdArgs = {
  input: UpdateDocumentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentExpirationArgs = {
  input: UpdateDocumentExpirationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentExpirationByNodeIdArgs = {
  input: UpdateDocumentExpirationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageArgs = {
  input: UpdateDocumentPageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageByDocumentIdAndRevisionNumberAndPageNumberArgs = {
  input: UpdateDocumentPageByDocumentIdAndRevisionNumberAndPageNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageByNodeIdArgs = {
  input: UpdateDocumentPageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageLinkArgs = {
  input: UpdateDocumentPageLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageLinkByNodeIdArgs = {
  input: UpdateDocumentPageLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageMatchingArgs = {
  input: UpdateDocumentPageMatchingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberArgs = {
  input: UpdateDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberArgs = {
  input: UpdateDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentPageMatchingByNodeIdArgs = {
  input: UpdateDocumentPageMatchingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentProcessArgs = {
  input: UpdateDocumentProcessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentProcessByNodeIdArgs = {
  input: UpdateDocumentProcessByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentRevisionArgs = {
  input: UpdateDocumentRevisionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentRevisionByNodeIdArgs = {
  input: UpdateDocumentRevisionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceArgs = {
  input: UpdateDocumentSpaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceAccessArgs = {
  input: UpdateDocumentSpaceAccessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceAccessByNodeIdArgs = {
  input: UpdateDocumentSpaceAccessByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceAccessByUserIdAndDocumentSpaceIdArgs = {
  input: UpdateDocumentSpaceAccessByUserIdAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceByCodeOnAccessCardArgs = {
  input: UpdateDocumentSpaceByCodeOnAccessCardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceByNodeIdArgs = {
  input: UpdateDocumentSpaceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceConfigArgs = {
  input: UpdateDocumentSpaceConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceConfigByNodeIdArgs = {
  input: UpdateDocumentSpaceConfigByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceConfigTranslationArgs = {
  input: UpdateDocumentSpaceConfigTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeArgs = {
  input: UpdateDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceConfigTranslationByNodeIdArgs = {
  input: UpdateDocumentSpaceConfigTranslationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceCrmMappingArgs = {
  input: UpdateDocumentSpaceCrmMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceCrmMappingByDocumentSpaceIdArgs = {
  input: UpdateDocumentSpaceCrmMappingByDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceCrmMappingByNodeIdArgs = {
  input: UpdateDocumentSpaceCrmMappingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceItemArgs = {
  input: UpdateDocumentSpaceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceItemByDocumentIdAndDocumentSpaceIdArgs = {
  input: UpdateDocumentSpaceItemByDocumentIdAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionArgs = {
  input: UpdateDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceItemByNodeIdArgs = {
  input: UpdateDocumentSpaceItemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkArgs = {
  input: UpdateDocumentSpaceLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkByNodeIdArgs = {
  input: UpdateDocumentSpaceLinkByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkByPositionAndConfigIdArgs = {
  input: UpdateDocumentSpaceLinkByPositionAndConfigIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkByPositionAndDocumentSpaceIdArgs = {
  input: UpdateDocumentSpaceLinkByPositionAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkGroupArgs = {
  input: UpdateDocumentSpaceLinkGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkGroupByNodeIdArgs = {
  input: UpdateDocumentSpaceLinkGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkGroupByTenantIdAndIdArgs = {
  input: UpdateDocumentSpaceLinkGroupByTenantIdAndIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkMappingArgs = {
  input: UpdateDocumentSpaceLinkMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkMappingByNodeIdArgs = {
  input: UpdateDocumentSpaceLinkMappingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkMappingBySpaceIdAndLinkIdArgs = {
  input: UpdateDocumentSpaceLinkMappingBySpaceIdAndLinkIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkTranslationArgs = {
  input: UpdateDocumentSpaceLinkTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeArgs = {
  input: UpdateDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkTranslationByNodeIdArgs = {
  input: UpdateDocumentSpaceLinkTranslationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeArgs = {
  input: UpdateDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSectionArgs = {
  input: UpdateDocumentSpaceSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSectionByDocumentSpaceIdAndPositionArgs = {
  input: UpdateDocumentSpaceSectionByDocumentSpaceIdAndPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSectionByNodeIdArgs = {
  input: UpdateDocumentSpaceSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSectionByTitleAndDocumentSpaceIdArgs = {
  input: UpdateDocumentSpaceSectionByTitleAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSessionArgs = {
  input: UpdateDocumentSpaceSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSessionByFingerprintAndDocumentSpaceIdArgs = {
  input: UpdateDocumentSpaceSessionByFingerprintAndDocumentSpaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceSessionByNodeIdArgs = {
  input: UpdateDocumentSpaceSessionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceTagArgs = {
  input: UpdateDocumentSpaceTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceTagByNodeIdArgs = {
  input: UpdateDocumentSpaceTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceVoucherArgs = {
  input: UpdateDocumentSpaceVoucherInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentSpaceVoucherByNodeIdArgs = {
  input: UpdateDocumentSpaceVoucherByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowArgs = {
  input: UpdateFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowByNodeIdArgs = {
  input: UpdateFlowByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowItemArgs = {
  input: UpdateFlowItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowItemByNodeIdArgs = {
  input: UpdateFlowItemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowSubscriptionArgs = {
  input: UpdateFlowSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowSubscriptionByFlowIdAndTeamIdArgs = {
  input: UpdateFlowSubscriptionByFlowIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowSubscriptionByFlowIdAndUserIdArgs = {
  input: UpdateFlowSubscriptionByFlowIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFlowSubscriptionByNodeIdArgs = {
  input: UpdateFlowSubscriptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInternalIpAddressArgs = {
  input: UpdateInternalIpAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInternalIpAddressByNodeIdArgs = {
  input: UpdateInternalIpAddressByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelsOfDocumentViewArgs = {
  input: UpdateLabelsOfDocumentViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelsOfDocumentViewByNodeIdArgs = {
  input: UpdateLabelsOfDocumentViewByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLanguageCodeArgs = {
  input: UpdateLanguageCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLanguageCodeByNodeIdArgs = {
  input: UpdateLanguageCodeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipByNodeIdArgs = {
  input: UpdateMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipBySubteamIdAndTeamIdArgs = {
  input: UpdateMembershipBySubteamIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipByUserIdAndTeamIdArgs = {
  input: UpdateMembershipByUserIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationByNodeIdArgs = {
  input: UpdateNotificationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderByNodeIdArgs = {
  input: UpdateOrderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRegistrationTokenArgs = {
  input: UpdateRegistrationTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRegistrationTokenByNodeIdArgs = {
  input: UpdateRegistrationTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRetentionPolicyArgs = {
  input: UpdateRetentionPolicyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRetentionPolicyByNodeIdArgs = {
  input: UpdateRetentionPolicyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRetentionPolicyByTeamIdArgs = {
  input: UpdateRetentionPolicyByTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRetentionPolicyByTenantIdArgs = {
  input: UpdateRetentionPolicyByTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRetentionPolicyByWorkspaceIdArgs = {
  input: UpdateRetentionPolicyByWorkspaceIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaMigrationArgs = {
  input: UpdateSchemaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaMigrationByNodeIdArgs = {
  input: UpdateSchemaMigrationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSettingArgs = {
  input: UpdateSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSettingByNodeIdArgs = {
  input: UpdateSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTeamByNodeIdArgs = {
  input: UpdateTeamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByNameArgs = {
  input: UpdateTenantByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByNodeIdArgs = {
  input: UpdateTenantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUrlBasedDocumentImportArgs = {
  input: UpdateUrlBasedDocumentImportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUrlBasedDocumentImportByNodeIdArgs = {
  input: UpdateUrlBasedDocumentImportByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUrlBasedDocumentImportSettingArgs = {
  input: UpdateUrlBasedDocumentImportSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUrlBasedDocumentImportSettingByNodeIdArgs = {
  input: UpdateUrlBasedDocumentImportSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByEmailArgs = {
  input: UpdateUserByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByNodeIdArgs = {
  input: UpdateUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserConfigPartialArgs = {
  input: UpdateUserConfigPartialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserContactDetailArgs = {
  input: UpdateUserContactDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserContactDetailByNodeIdArgs = {
  input: UpdateUserContactDetailByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserContactDetailByUserIdArgs = {
  input: UpdateUserContactDetailByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserLicenseArgs = {
  input: UpdateUserLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserLicenseByNodeIdArgs = {
  input: UpdateUserLicenseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVeevaDocumentMetadatumArgs = {
  input: UpdateVeevaDocumentMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVeevaDocumentMetadatumByNodeIdArgs = {
  input: UpdateVeevaDocumentMetadatumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceByFirebaseIdArgs = {
  input: UpdateWorkspaceByFirebaseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceByNodeIdArgs = {
  input: UpdateWorkspaceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceSubscriptionArgs = {
  input: UpdateWorkspaceSubscriptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceSubscriptionByNodeIdArgs = {
  input: UpdateWorkspaceSubscriptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceSubscriptionBySubteamIdAndTeamIdArgs = {
  input: UpdateWorkspaceSubscriptionBySubteamIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkspaceSubscriptionByUserIdAndTeamIdArgs = {
  input: UpdateWorkspaceSubscriptionByUserIdAndTeamIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyDocumentSpaceAccessTokenArgs = {
  input: VerifyDocumentSpaceAccessTokenInput;
};

/** A `BigInt` edge in the connection. */
export type MyAdministratedDocumentSpaceIdEdge = {
  __typename?: 'MyAdministratedDocumentSpaceIdEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BigInt` at the end of the edge. */
  node?: Maybe<Scalars['BigInt']['output']>;
};

/** A connection to a list of `BigInt` values. */
export type MyAdministratedDocumentSpaceIdsConnection = {
  __typename?: 'MyAdministratedDocumentSpaceIdsConnection';
  /** A list of edges which contains the `BigInt` and cursor to aid in pagination. */
  edges: Array<MyAdministratedDocumentSpaceIdEdge>;
  /** A list of `BigInt` objects. */
  nodes: Array<Maybe<Scalars['BigInt']['output']>>;
  /** The count of *all* `BigInt` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BigInt` edge in the connection. */
export type MyDocumentSpaceIdEdge = {
  __typename?: 'MyDocumentSpaceIdEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BigInt` at the end of the edge. */
  node?: Maybe<Scalars['BigInt']['output']>;
};

/** A connection to a list of `BigInt` values. */
export type MyDocumentSpaceIdsConnection = {
  __typename?: 'MyDocumentSpaceIdsConnection';
  /** A list of edges which contains the `BigInt` and cursor to aid in pagination. */
  edges: Array<MyDocumentSpaceIdEdge>;
  /** A list of `BigInt` objects. */
  nodes: Array<Maybe<Scalars['BigInt']['output']>>;
  /** The count of *all* `BigInt` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BigInt` edge in the connection. */
export type MyEditableDocumentSpaceIdEdge = {
  __typename?: 'MyEditableDocumentSpaceIdEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BigInt` at the end of the edge. */
  node?: Maybe<Scalars['BigInt']['output']>;
};

/** A connection to a list of `BigInt` values. */
export type MyEditableDocumentSpaceIdsConnection = {
  __typename?: 'MyEditableDocumentSpaceIdsConnection';
  /** A list of edges which contains the `BigInt` and cursor to aid in pagination. */
  edges: Array<MyEditableDocumentSpaceIdEdge>;
  /** A list of `BigInt` objects. */
  nodes: Array<Maybe<Scalars['BigInt']['output']>>;
  /** The count of *all* `BigInt` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BigInt` edge in the connection. */
export type MyOwnedDocumentSpaceIdEdge = {
  __typename?: 'MyOwnedDocumentSpaceIdEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BigInt` at the end of the edge. */
  node?: Maybe<Scalars['BigInt']['output']>;
};

/** A connection to a list of `BigInt` values. */
export type MyOwnedDocumentSpaceIdsConnection = {
  __typename?: 'MyOwnedDocumentSpaceIdsConnection';
  /** A list of edges which contains the `BigInt` and cursor to aid in pagination. */
  edges: Array<MyOwnedDocumentSpaceIdEdge>;
  /** A list of `BigInt` objects. */
  nodes: Array<Maybe<Scalars['BigInt']['output']>>;
  /** The count of *all* `BigInt` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** All input for the `myWorkspaces` mutation. */
export type MyWorkspacesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  includeChildWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The output of our `myWorkspaces` mutation. */
export type MyWorkspacesPayload = {
  __typename?: 'MyWorkspacesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type NonSyncableWorkspace = {
  __typename?: 'NonSyncableWorkspace';
  customBrandUrl?: Maybe<Scalars['String']['output']>;
  customShareLink?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailText?: Maybe<Scalars['String']['output']>;
  firebaseId?: Maybe<Scalars['String']['output']>;
  hideProjectorButtonInPresentation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  laserPointerPosition?: Maybe<Scalars['Int']['output']>;
  linkPanelPosition?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  personalWorkspaceOfUserId?: Maybe<Scalars['BigInt']['output']>;
  teamRank?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `NonSyncableWorkspace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type NonSyncableWorkspaceCondition = {
  /** Checks for equality with the object’s `customBrandUrl` field. */
  customBrandUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `customShareLink` field. */
  customShareLink?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailText` field. */
  emailText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hideProjectorButtonInPresentation` field. */
  hideProjectorButtonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isOpen` field. */
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isVisible` field. */
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `laserPointerPosition` field. */
  laserPointerPosition?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `linkPanelPosition` field. */
  linkPanelPosition?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `personalWorkspaceOfUserId` field. */
  personalWorkspaceOfUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `teamRank` field. */
  teamRank?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `NonSyncableWorkspace` object types. All fields are combined with a logical ‘and.’ */
export type NonSyncableWorkspaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NonSyncableWorkspaceFilter>>;
  /** Filter by the object’s `customBrandUrl` field. */
  customBrandUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `customShareLink` field. */
  customShareLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailText` field. */
  emailText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hideProjectorButtonInPresentation` field. */
  hideProjectorButtonInPresentation?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isOpen` field. */
  isOpen?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isVisible` field. */
  isVisible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `laserPointerPosition` field. */
  laserPointerPosition?: InputMaybe<IntFilter>;
  /** Filter by the object’s `linkPanelPosition` field. */
  linkPanelPosition?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NonSyncableWorkspaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NonSyncableWorkspaceFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `personalWorkspaceOfUserId` field. */
  personalWorkspaceOfUserId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `teamRank` field. */
  teamRank?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `NonSyncableWorkspace` */
export type NonSyncableWorkspaceInput = {
  customBrandUrl?: InputMaybe<Scalars['String']['input']>;
  customShareLink?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  hideProjectorButtonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  laserPointerPosition?: InputMaybe<Scalars['Int']['input']>;
  linkPanelPosition?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  personalWorkspaceOfUserId?: InputMaybe<Scalars['BigInt']['input']>;
  teamRank?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `NonSyncableWorkspace` values. */
export type NonSyncableWorkspacesConnection = {
  __typename?: 'NonSyncableWorkspacesConnection';
  /** A list of edges which contains the `NonSyncableWorkspace` and cursor to aid in pagination. */
  edges: Array<NonSyncableWorkspacesEdge>;
  /** A list of `NonSyncableWorkspace` objects. */
  nodes: Array<Maybe<NonSyncableWorkspace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NonSyncableWorkspace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NonSyncableWorkspace` edge in the connection. */
export type NonSyncableWorkspacesEdge = {
  __typename?: 'NonSyncableWorkspacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NonSyncableWorkspace` at the end of the edge. */
  node?: Maybe<NonSyncableWorkspace>;
};

/** Methods to use when ordering `NonSyncableWorkspace`. */
export enum NonSyncableWorkspacesOrderBy {
  CustomBrandUrlAsc = 'CUSTOM_BRAND_URL_ASC',
  CustomBrandUrlDesc = 'CUSTOM_BRAND_URL_DESC',
  CustomShareLinkAsc = 'CUSTOM_SHARE_LINK_ASC',
  CustomShareLinkDesc = 'CUSTOM_SHARE_LINK_DESC',
  EmailSubjectAsc = 'EMAIL_SUBJECT_ASC',
  EmailSubjectDesc = 'EMAIL_SUBJECT_DESC',
  EmailTextAsc = 'EMAIL_TEXT_ASC',
  EmailTextDesc = 'EMAIL_TEXT_DESC',
  FirebaseIdAsc = 'FIREBASE_ID_ASC',
  FirebaseIdDesc = 'FIREBASE_ID_DESC',
  HideProjectorButtonInPresentationAsc = 'HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  HideProjectorButtonInPresentationDesc = 'HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOpenAsc = 'IS_OPEN_ASC',
  IsOpenDesc = 'IS_OPEN_DESC',
  IsVisibleAsc = 'IS_VISIBLE_ASC',
  IsVisibleDesc = 'IS_VISIBLE_DESC',
  LaserPointerPositionAsc = 'LASER_POINTER_POSITION_ASC',
  LaserPointerPositionDesc = 'LASER_POINTER_POSITION_DESC',
  LinkPanelPositionAsc = 'LINK_PANEL_POSITION_ASC',
  LinkPanelPositionDesc = 'LINK_PANEL_POSITION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PersonalWorkspaceOfUserIdAsc = 'PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  PersonalWorkspaceOfUserIdDesc = 'PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  TeamRankAsc = 'TEAM_RANK_ASC',
  TeamRankDesc = 'TEAM_RANK_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

export type Notification = Node & {
  __typename?: 'Notification';
  bodyText: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  eventType: PvNotificationEventType;
  headerText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  senderId: Scalars['BigInt']['output'];
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `bodyText` field. */
  bodyText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<PvNotificationEventType>;
  /** Checks for equality with the object’s `headerText` field. */
  headerText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `bodyText` field. */
  bodyText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<PvNotificationEventTypeFilter>;
  /** Filter by the object’s `headerText` field. */
  headerText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `sender` relation. */
  sender?: InputMaybe<UserFilter>;
  /** Filter by the object’s `senderId` field. */
  senderId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<TeamFilter>;
  /** A related `team` exists. */
  teamExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `workspace` relation. */
  workspace?: InputMaybe<WorkspaceFilter>;
  /** A related `workspace` exists. */
  workspaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Notification` */
export type NotificationInput = {
  bodyText: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventType: PvNotificationEventType;
  headerText: Scalars['String']['input'];
  senderId: Scalars['BigInt']['input'];
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `Notification`. Fields that are set will be updated. */
export type NotificationPatch = {
  bodyText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventType?: InputMaybe<PvNotificationEventType>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['BigInt']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `Notification` values. */
export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<NotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Maybe<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Notification` edge in the connection. */
export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Notification` at the end of the edge. */
  node?: Maybe<Notification>;
};

/** Methods to use when ordering `Notification`. */
export enum NotificationsOrderBy {
  BodyTextAsc = 'BODY_TEXT_ASC',
  BodyTextDesc = 'BODY_TEXT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  EventTypeAsc = 'EVENT_TYPE_ASC',
  EventTypeDesc = 'EVENT_TYPE_DESC',
  HeaderTextAsc = 'HEADER_TEXT_ASC',
  HeaderTextDesc = 'HEADER_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SenderIdAsc = 'SENDER_ID_ASC',
  SenderIdDesc = 'SENDER_ID_DESC',
  TeamByTeamIdAnalyticsAliasAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamByTeamIdAnalyticsAliasDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamByTeamIdAnalyticsEnabledAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamByTeamIdAnalyticsEnabledDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamByTeamIdCreatedAtAsc = 'TEAM_BY_TEAM_ID__CREATED_AT_ASC',
  TeamByTeamIdCreatedAtDesc = 'TEAM_BY_TEAM_ID__CREATED_AT_DESC',
  TeamByTeamIdFlagsAsc = 'TEAM_BY_TEAM_ID__FLAGS_ASC',
  TeamByTeamIdFlagsDesc = 'TEAM_BY_TEAM_ID__FLAGS_DESC',
  TeamByTeamIdIdAsc = 'TEAM_BY_TEAM_ID__ID_ASC',
  TeamByTeamIdIdDesc = 'TEAM_BY_TEAM_ID__ID_DESC',
  TeamByTeamIdIsOpenAsc = 'TEAM_BY_TEAM_ID__IS_OPEN_ASC',
  TeamByTeamIdIsOpenDesc = 'TEAM_BY_TEAM_ID__IS_OPEN_DESC',
  TeamByTeamIdIsVisibleAsc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_ASC',
  TeamByTeamIdIsVisibleDesc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_DESC',
  TeamByTeamIdMemberCountAsc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_ASC',
  TeamByTeamIdMemberCountDesc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_DESC',
  TeamByTeamIdNameAsc = 'TEAM_BY_TEAM_ID__NAME_ASC',
  TeamByTeamIdNameDesc = 'TEAM_BY_TEAM_ID__NAME_DESC',
  TeamByTeamIdNameLowercaseAsc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  TeamByTeamIdNameLowercaseDesc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  TeamByTeamIdSysPeriodAsc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_ASC',
  TeamByTeamIdSysPeriodDesc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_DESC',
  TeamByTeamIdTenantIdAsc = 'TEAM_BY_TEAM_ID__TENANT_ID_ASC',
  TeamByTeamIdTenantIdDesc = 'TEAM_BY_TEAM_ID__TENANT_ID_DESC',
  TeamByTeamIdTotalMemberCountAsc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamByTeamIdTotalMemberCountDesc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamByTeamIdUpdatedAtAsc = 'TEAM_BY_TEAM_ID__UPDATED_AT_ASC',
  TeamByTeamIdUpdatedAtDesc = 'TEAM_BY_TEAM_ID__UPDATED_AT_DESC',
  TeamByTeamIdUserConfigDefaultsAsc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamByTeamIdUserConfigDefaultsDesc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  UserBySenderIdAppConsentGivenAtAsc = 'USER_BY_SENDER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserBySenderIdAppConsentGivenAtDesc = 'USER_BY_SENDER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserBySenderIdConfigAsc = 'USER_BY_SENDER_ID__CONFIG_ASC',
  UserBySenderIdConfigDesc = 'USER_BY_SENDER_ID__CONFIG_DESC',
  UserBySenderIdCreatedAtAsc = 'USER_BY_SENDER_ID__CREATED_AT_ASC',
  UserBySenderIdCreatedAtDesc = 'USER_BY_SENDER_ID__CREATED_AT_DESC',
  UserBySenderIdCrmContactVisibilityFilterAsc = 'USER_BY_SENDER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserBySenderIdCrmContactVisibilityFilterDesc = 'USER_BY_SENDER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserBySenderIdDefaultWorkspaceIdAsc = 'USER_BY_SENDER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserBySenderIdDefaultWorkspaceIdDesc = 'USER_BY_SENDER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserBySenderIdDisabledAsc = 'USER_BY_SENDER_ID__DISABLED_ASC',
  UserBySenderIdDisabledDesc = 'USER_BY_SENDER_ID__DISABLED_DESC',
  UserBySenderIdDisplayNameAsc = 'USER_BY_SENDER_ID__DISPLAY_NAME_ASC',
  UserBySenderIdDisplayNameDesc = 'USER_BY_SENDER_ID__DISPLAY_NAME_DESC',
  UserBySenderIdEmailAsc = 'USER_BY_SENDER_ID__EMAIL_ASC',
  UserBySenderIdEmailDesc = 'USER_BY_SENDER_ID__EMAIL_DESC',
  UserBySenderIdExternalGroupsAsc = 'USER_BY_SENDER_ID__EXTERNAL_GROUPS_ASC',
  UserBySenderIdExternalGroupsDesc = 'USER_BY_SENDER_ID__EXTERNAL_GROUPS_DESC',
  UserBySenderIdExternalGroupsSyncedAtAsc = 'USER_BY_SENDER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserBySenderIdExternalGroupsSyncedAtDesc = 'USER_BY_SENDER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserBySenderIdFirebaseAuthIdAsc = 'USER_BY_SENDER_ID__FIREBASE_AUTH_ID_ASC',
  UserBySenderIdFirebaseAuthIdDesc = 'USER_BY_SENDER_ID__FIREBASE_AUTH_ID_DESC',
  UserBySenderIdFlagsAsc = 'USER_BY_SENDER_ID__FLAGS_ASC',
  UserBySenderIdFlagsDesc = 'USER_BY_SENDER_ID__FLAGS_DESC',
  UserBySenderIdIdAsc = 'USER_BY_SENDER_ID__ID_ASC',
  UserBySenderIdIdDesc = 'USER_BY_SENDER_ID__ID_DESC',
  UserBySenderIdIsTenantAdminAsc = 'USER_BY_SENDER_ID__IS_TENANT_ADMIN_ASC',
  UserBySenderIdIsTenantAdminDesc = 'USER_BY_SENDER_ID__IS_TENANT_ADMIN_DESC',
  UserBySenderIdRegisteredAtAsc = 'USER_BY_SENDER_ID__REGISTERED_AT_ASC',
  UserBySenderIdRegisteredAtDesc = 'USER_BY_SENDER_ID__REGISTERED_AT_DESC',
  UserBySenderIdSysPeriodAsc = 'USER_BY_SENDER_ID__SYS_PERIOD_ASC',
  UserBySenderIdSysPeriodDesc = 'USER_BY_SENDER_ID__SYS_PERIOD_DESC',
  UserBySenderIdTenantIdAsc = 'USER_BY_SENDER_ID__TENANT_ID_ASC',
  UserBySenderIdTenantIdDesc = 'USER_BY_SENDER_ID__TENANT_ID_DESC',
  UserBySenderIdUpdatedAtAsc = 'USER_BY_SENDER_ID__UPDATED_AT_ASC',
  UserBySenderIdUpdatedAtDesc = 'USER_BY_SENDER_ID__UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  WorkspaceByWorkspaceIdAnalyticsAliasAsc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByWorkspaceIdAnalyticsAliasDesc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByWorkspaceIdAnalyticsEnabledAsc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByWorkspaceIdAnalyticsEnabledDesc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByWorkspaceIdConfigAsc = 'WORKSPACE_BY_WORKSPACE_ID__CONFIG_ASC',
  WorkspaceByWorkspaceIdConfigDesc = 'WORKSPACE_BY_WORKSPACE_ID__CONFIG_DESC',
  WorkspaceByWorkspaceIdCreatedAtAsc = 'WORKSPACE_BY_WORKSPACE_ID__CREATED_AT_ASC',
  WorkspaceByWorkspaceIdCreatedAtDesc = 'WORKSPACE_BY_WORKSPACE_ID__CREATED_AT_DESC',
  WorkspaceByWorkspaceIdCustomBrandUrlAsc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByWorkspaceIdCustomBrandUrlDesc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByWorkspaceIdCustomShareLinkAsc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByWorkspaceIdCustomShareLinkDesc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByWorkspaceIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByWorkspaceIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByWorkspaceIdEmailSubjectAsc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByWorkspaceIdEmailSubjectDesc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByWorkspaceIdEmailTextAsc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_TEXT_ASC',
  WorkspaceByWorkspaceIdEmailTextDesc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_TEXT_DESC',
  WorkspaceByWorkspaceIdFirebaseIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__FIREBASE_ID_ASC',
  WorkspaceByWorkspaceIdFirebaseIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__FIREBASE_ID_DESC',
  WorkspaceByWorkspaceIdFlagsAsc = 'WORKSPACE_BY_WORKSPACE_ID__FLAGS_ASC',
  WorkspaceByWorkspaceIdFlagsDesc = 'WORKSPACE_BY_WORKSPACE_ID__FLAGS_DESC',
  WorkspaceByWorkspaceIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByWorkspaceIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByWorkspaceIdIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__ID_ASC',
  WorkspaceByWorkspaceIdIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__ID_DESC',
  WorkspaceByWorkspaceIdIsOpenAsc = 'WORKSPACE_BY_WORKSPACE_ID__IS_OPEN_ASC',
  WorkspaceByWorkspaceIdIsOpenDesc = 'WORKSPACE_BY_WORKSPACE_ID__IS_OPEN_DESC',
  WorkspaceByWorkspaceIdIsVisibleAsc = 'WORKSPACE_BY_WORKSPACE_ID__IS_VISIBLE_ASC',
  WorkspaceByWorkspaceIdIsVisibleDesc = 'WORKSPACE_BY_WORKSPACE_ID__IS_VISIBLE_DESC',
  WorkspaceByWorkspaceIdLaserPointerPositionAsc = 'WORKSPACE_BY_WORKSPACE_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByWorkspaceIdLaserPointerPositionDesc = 'WORKSPACE_BY_WORKSPACE_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByWorkspaceIdLinkPanelPositionAsc = 'WORKSPACE_BY_WORKSPACE_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByWorkspaceIdLinkPanelPositionDesc = 'WORKSPACE_BY_WORKSPACE_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByWorkspaceIdMemberCountAsc = 'WORKSPACE_BY_WORKSPACE_ID__MEMBER_COUNT_ASC',
  WorkspaceByWorkspaceIdMemberCountDesc = 'WORKSPACE_BY_WORKSPACE_ID__MEMBER_COUNT_DESC',
  WorkspaceByWorkspaceIdNameAsc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_ASC',
  WorkspaceByWorkspaceIdNameDesc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_DESC',
  WorkspaceByWorkspaceIdNameLowercaseAsc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_LOWERCASE_ASC',
  WorkspaceByWorkspaceIdNameLowercaseDesc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_LOWERCASE_DESC',
  WorkspaceByWorkspaceIdParentIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__PARENT_ID_ASC',
  WorkspaceByWorkspaceIdParentIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__PARENT_ID_DESC',
  WorkspaceByWorkspaceIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByWorkspaceIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByWorkspaceIdSysPeriodAsc = 'WORKSPACE_BY_WORKSPACE_ID__SYS_PERIOD_ASC',
  WorkspaceByWorkspaceIdSysPeriodDesc = 'WORKSPACE_BY_WORKSPACE_ID__SYS_PERIOD_DESC',
  WorkspaceByWorkspaceIdTagsAsc = 'WORKSPACE_BY_WORKSPACE_ID__TAGS_ASC',
  WorkspaceByWorkspaceIdTagsDesc = 'WORKSPACE_BY_WORKSPACE_ID__TAGS_DESC',
  WorkspaceByWorkspaceIdTeamRankAsc = 'WORKSPACE_BY_WORKSPACE_ID__TEAM_RANK_ASC',
  WorkspaceByWorkspaceIdTeamRankDesc = 'WORKSPACE_BY_WORKSPACE_ID__TEAM_RANK_DESC',
  WorkspaceByWorkspaceIdTenantIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__TENANT_ID_ASC',
  WorkspaceByWorkspaceIdTenantIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__TENANT_ID_DESC',
  WorkspaceByWorkspaceIdTotalMemberCountAsc = 'WORKSPACE_BY_WORKSPACE_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByWorkspaceIdTotalMemberCountDesc = 'WORKSPACE_BY_WORKSPACE_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByWorkspaceIdUpdatedAtAsc = 'WORKSPACE_BY_WORKSPACE_ID__UPDATED_AT_ASC',
  WorkspaceByWorkspaceIdUpdatedAtDesc = 'WORKSPACE_BY_WORKSPACE_ID__UPDATED_AT_DESC',
  WorkspaceByWorkspaceIdUserConfigDefaultsAsc = 'WORKSPACE_BY_WORKSPACE_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByWorkspaceIdUserConfigDefaultsDesc = 'WORKSPACE_BY_WORKSPACE_ID__USER_CONFIG_DEFAULTS_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC'
}

export type ObsoleteUserSubscription = {
  __typename?: 'ObsoleteUserSubscription';
  firebaseAuthId?: Maybe<Scalars['String']['output']>;
  membershipIdOfUserInTeam?: Maybe<Scalars['BigInt']['output']>;
  teamId?: Maybe<Scalars['BigInt']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamSubscriptionId?: Maybe<Scalars['BigInt']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['BigInt']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userSubscriptionId?: Maybe<Scalars['BigInt']['output']>;
  workspaceId?: Maybe<Scalars['BigInt']['output']>;
  workspaceInFirebase?: Maybe<Scalars['String']['output']>;
  workspaceName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ObsoleteUserSubscription` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ObsoleteUserSubscriptionCondition = {
  /** Checks for equality with the object’s `firebaseAuthId` field. */
  firebaseAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `membershipIdOfUserInTeam` field. */
  membershipIdOfUserInTeam?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `teamName` field. */
  teamName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `teamSubscriptionId` field. */
  teamSubscriptionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `userEmail` field. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `userName` field. */
  userName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userSubscriptionId` field. */
  userSubscriptionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `workspaceInFirebase` field. */
  workspaceInFirebase?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `workspaceName` field. */
  workspaceName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ObsoleteUserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type ObsoleteUserSubscriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObsoleteUserSubscriptionFilter>>;
  /** Filter by the object’s `firebaseAuthId` field. */
  firebaseAuthId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `membershipIdOfUserInTeam` field. */
  membershipIdOfUserInTeam?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObsoleteUserSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObsoleteUserSubscriptionFilter>>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `teamName` field. */
  teamName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `teamSubscriptionId` field. */
  teamSubscriptionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `userEmail` field. */
  userEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `userName` field. */
  userName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userSubscriptionId` field. */
  userSubscriptionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `workspaceInFirebase` field. */
  workspaceInFirebase?: InputMaybe<StringFilter>;
  /** Filter by the object’s `workspaceName` field. */
  workspaceName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ObsoleteUserSubscription` values. */
export type ObsoleteUserSubscriptionsConnection = {
  __typename?: 'ObsoleteUserSubscriptionsConnection';
  /** A list of edges which contains the `ObsoleteUserSubscription` and cursor to aid in pagination. */
  edges: Array<ObsoleteUserSubscriptionsEdge>;
  /** A list of `ObsoleteUserSubscription` objects. */
  nodes: Array<Maybe<ObsoleteUserSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObsoleteUserSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ObsoleteUserSubscription` edge in the connection. */
export type ObsoleteUserSubscriptionsEdge = {
  __typename?: 'ObsoleteUserSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ObsoleteUserSubscription` at the end of the edge. */
  node?: Maybe<ObsoleteUserSubscription>;
};

/** Methods to use when ordering `ObsoleteUserSubscription`. */
export enum ObsoleteUserSubscriptionsOrderBy {
  FirebaseAuthIdAsc = 'FIREBASE_AUTH_ID_ASC',
  FirebaseAuthIdDesc = 'FIREBASE_AUTH_ID_DESC',
  MembershipIdOfUserInTeamAsc = 'MEMBERSHIP_ID_OF_USER_IN_TEAM_ASC',
  MembershipIdOfUserInTeamDesc = 'MEMBERSHIP_ID_OF_USER_IN_TEAM_DESC',
  Natural = 'NATURAL',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  TeamNameAsc = 'TEAM_NAME_ASC',
  TeamNameDesc = 'TEAM_NAME_DESC',
  TeamSubscriptionIdAsc = 'TEAM_SUBSCRIPTION_ID_ASC',
  TeamSubscriptionIdDesc = 'TEAM_SUBSCRIPTION_ID_DESC',
  UserEmailAsc = 'USER_EMAIL_ASC',
  UserEmailDesc = 'USER_EMAIL_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UserNameAsc = 'USER_NAME_ASC',
  UserNameDesc = 'USER_NAME_DESC',
  UserSubscriptionIdAsc = 'USER_SUBSCRIPTION_ID_ASC',
  UserSubscriptionIdDesc = 'USER_SUBSCRIPTION_ID_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC',
  WorkspaceInFirebaseAsc = 'WORKSPACE_IN_FIREBASE_ASC',
  WorkspaceInFirebaseDesc = 'WORKSPACE_IN_FIREBASE_DESC',
  WorkspaceNameAsc = 'WORKSPACE_NAME_ASC',
  WorkspaceNameDesc = 'WORKSPACE_NAME_DESC'
}

/** Snapshot from 2024-04-20T12:00:54.278043 */
export type OldDocumentSpace = {
  __typename?: 'OldDocumentSpace';
  comment?: Maybe<Scalars['String']['output']>;
  configId?: Maybe<Scalars['BigInt']['output']>;
  contactDetailsId?: Maybe<Scalars['BigInt']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  creatorId?: Maybe<Scalars['BigInt']['output']>;
  encryptedPassword?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifyAboutVisits?: Maybe<Scalars['Boolean']['output']>;
  personalMessage?: Maybe<Scalars['String']['output']>;
  showContactDetails?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  trackingDeactivated?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `OldDocumentSpace` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OldDocumentSpaceCondition = {
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `contactDetailsId` field. */
  contactDetailsId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `notifyAboutVisits` field. */
  notifyAboutVisits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `showContactDetails` field. */
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `trackingDeactivated` field. */
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `OldDocumentSpace` object types. All fields are combined with a logical ‘and.’ */
export type OldDocumentSpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OldDocumentSpaceFilter>>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `contactDetailsId` field. */
  contactDetailsId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OldDocumentSpaceFilter>;
  /** Filter by the object’s `notifyAboutVisits` field. */
  notifyAboutVisits?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OldDocumentSpaceFilter>>;
  /** Filter by the object’s `personalMessage` field. */
  personalMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `showContactDetails` field. */
  showContactDetails?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `trackingDeactivated` field. */
  trackingDeactivated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `OldDocumentSpace` */
export type OldDocumentSpaceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  contactDetailsId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['BigInt']['input']>;
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyAboutVisits?: InputMaybe<Scalars['Boolean']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  showContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  trackingDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `OldDocumentSpace` values. */
export type OldDocumentSpacesConnection = {
  __typename?: 'OldDocumentSpacesConnection';
  /** A list of edges which contains the `OldDocumentSpace` and cursor to aid in pagination. */
  edges: Array<OldDocumentSpacesEdge>;
  /** A list of `OldDocumentSpace` objects. */
  nodes: Array<Maybe<OldDocumentSpace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OldDocumentSpace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OldDocumentSpace` edge in the connection. */
export type OldDocumentSpacesEdge = {
  __typename?: 'OldDocumentSpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OldDocumentSpace` at the end of the edge. */
  node?: Maybe<OldDocumentSpace>;
};

/** Methods to use when ordering `OldDocumentSpace`. */
export enum OldDocumentSpacesOrderBy {
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  ConfigIdAsc = 'CONFIG_ID_ASC',
  ConfigIdDesc = 'CONFIG_ID_DESC',
  ContactDetailsIdAsc = 'CONTACT_DETAILS_ID_ASC',
  ContactDetailsIdDesc = 'CONTACT_DETAILS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorIdAsc = 'CREATOR_ID_ASC',
  CreatorIdDesc = 'CREATOR_ID_DESC',
  EncryptedPasswordAsc = 'ENCRYPTED_PASSWORD_ASC',
  EncryptedPasswordDesc = 'ENCRYPTED_PASSWORD_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NotifyAboutVisitsAsc = 'NOTIFY_ABOUT_VISITS_ASC',
  NotifyAboutVisitsDesc = 'NOTIFY_ABOUT_VISITS_DESC',
  PersonalMessageAsc = 'PERSONAL_MESSAGE_ASC',
  PersonalMessageDesc = 'PERSONAL_MESSAGE_DESC',
  ShowContactDetailsAsc = 'SHOW_CONTACT_DETAILS_ASC',
  ShowContactDetailsDesc = 'SHOW_CONTACT_DETAILS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TrackingDeactivatedAsc = 'TRACKING_DEACTIVATED_ASC',
  TrackingDeactivatedDesc = 'TRACKING_DEACTIVATED_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Order = Node & {
  __typename?: 'Order';
  /** Reads a single `User` that is related to this `Order`. */
  admin?: Maybe<User>;
  adminId?: Maybe<Scalars['BigInt']['output']>;
  amountCents: Scalars['BigInt']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fastbillReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  /** Optional human-editable invoice reference (nullable, unique when present) */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  licensesCount: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numTeamLicenses: Scalars['Int']['output'];
  pipedriveReference?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Tenant` that is related to this `Order`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `UserLicense`. */
  userLicenses: UserLicensesConnection;
  validityPeriod: DatetimeRange;
};


export type OrderUserLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserLicenseCondition>;
  filter?: InputMaybe<UserLicenseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};

/** A condition to be used against `Order` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OrderCondition = {
  /** Checks for equality with the object’s `adminId` field. */
  adminId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `amountCents` field. */
  amountCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `contactEmail` field. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `contactName` field. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fastbillReference` field. */
  fastbillReference?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `invoiceNumber` field. */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `licensesCount` field. */
  licensesCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `numTeamLicenses` field. */
  numTeamLicenses?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `pipedriveReference` field. */
  pipedriveReference?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `validityPeriod` field. */
  validityPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `Order` object types. All fields are combined with a logical ‘and.’ */
export type OrderFilter = {
  /** Filter by the object’s `admin` relation. */
  admin?: InputMaybe<UserFilter>;
  /** A related `admin` exists. */
  adminExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `adminId` field. */
  adminId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `amountCents` field. */
  amountCents?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderFilter>>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contactEmail` field. */
  contactEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contactName` field. */
  contactName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fastbillReference` field. */
  fastbillReference?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `invoiceNumber` field. */
  invoiceNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `licensesCount` field. */
  licensesCount?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderFilter>;
  /** Filter by the object’s `numTeamLicenses` field. */
  numTeamLicenses?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderFilter>>;
  /** Filter by the object’s `pipedriveReference` field. */
  pipedriveReference?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `userLicenses` relation. */
  userLicenses?: InputMaybe<OrderToManyUserLicenseFilter>;
  /** Some related `userLicenses` exist. */
  userLicensesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `validityPeriod` field. */
  validityPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `Order` */
export type OrderInput = {
  adminId?: InputMaybe<Scalars['BigInt']['input']>;
  amountCents?: InputMaybe<Scalars['BigInt']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  fastbillReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Optional human-editable invoice reference (nullable, unique when present) */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  licensesCount: Scalars['Int']['input'];
  numTeamLicenses?: InputMaybe<Scalars['Int']['input']>;
  pipedriveReference?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['BigInt']['input'];
  validityPeriod: DatetimeRangeInput;
};

/** Represents an update to a `Order`. Fields that are set will be updated. */
export type OrderPatch = {
  adminId?: InputMaybe<Scalars['BigInt']['input']>;
  amountCents?: InputMaybe<Scalars['BigInt']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fastbillReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Optional human-editable invoice reference (nullable, unique when present) */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  licensesCount?: InputMaybe<Scalars['Int']['input']>;
  numTeamLicenses?: InputMaybe<Scalars['Int']['input']>;
  pipedriveReference?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  validityPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against many `UserLicense` object types. All fields are combined with a logical ‘and.’ */
export type OrderToManyUserLicenseFilter = {
  /** Every related `UserLicense` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserLicenseFilter>;
  /** No related `UserLicense` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserLicenseFilter>;
  /** Some related `UserLicense` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserLicenseFilter>;
};

/** A connection to a list of `Order` values. */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges which contains the `Order` and cursor to aid in pagination. */
  edges: Array<OrdersEdge>;
  /** A list of `Order` objects. */
  nodes: Array<Maybe<Order>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Order` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Order` edge in the connection. */
export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Order` at the end of the edge. */
  node?: Maybe<Order>;
};

/** Methods to use when ordering `Order`. */
export enum OrdersOrderBy {
  AdminIdAsc = 'ADMIN_ID_ASC',
  AdminIdDesc = 'ADMIN_ID_DESC',
  AmountCentsAsc = 'AMOUNT_CENTS_ASC',
  AmountCentsDesc = 'AMOUNT_CENTS_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  ContactEmailAsc = 'CONTACT_EMAIL_ASC',
  ContactEmailDesc = 'CONTACT_EMAIL_DESC',
  ContactNameAsc = 'CONTACT_NAME_ASC',
  ContactNameDesc = 'CONTACT_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FastbillReferenceAsc = 'FASTBILL_REFERENCE_ASC',
  FastbillReferenceDesc = 'FASTBILL_REFERENCE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvoiceNumberAsc = 'INVOICE_NUMBER_ASC',
  InvoiceNumberDesc = 'INVOICE_NUMBER_DESC',
  LicensesCountAsc = 'LICENSES_COUNT_ASC',
  LicensesCountDesc = 'LICENSES_COUNT_DESC',
  Natural = 'NATURAL',
  NumTeamLicensesAsc = 'NUM_TEAM_LICENSES_ASC',
  NumTeamLicensesDesc = 'NUM_TEAM_LICENSES_DESC',
  PipedriveReferenceAsc = 'PIPEDRIVE_REFERENCE_ASC',
  PipedriveReferenceDesc = 'PIPEDRIVE_REFERENCE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserByAdminIdAppConsentGivenAtAsc = 'USER_BY_ADMIN_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByAdminIdAppConsentGivenAtDesc = 'USER_BY_ADMIN_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByAdminIdConfigAsc = 'USER_BY_ADMIN_ID__CONFIG_ASC',
  UserByAdminIdConfigDesc = 'USER_BY_ADMIN_ID__CONFIG_DESC',
  UserByAdminIdCreatedAtAsc = 'USER_BY_ADMIN_ID__CREATED_AT_ASC',
  UserByAdminIdCreatedAtDesc = 'USER_BY_ADMIN_ID__CREATED_AT_DESC',
  UserByAdminIdCrmContactVisibilityFilterAsc = 'USER_BY_ADMIN_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByAdminIdCrmContactVisibilityFilterDesc = 'USER_BY_ADMIN_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByAdminIdDefaultWorkspaceIdAsc = 'USER_BY_ADMIN_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByAdminIdDefaultWorkspaceIdDesc = 'USER_BY_ADMIN_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByAdminIdDisabledAsc = 'USER_BY_ADMIN_ID__DISABLED_ASC',
  UserByAdminIdDisabledDesc = 'USER_BY_ADMIN_ID__DISABLED_DESC',
  UserByAdminIdDisplayNameAsc = 'USER_BY_ADMIN_ID__DISPLAY_NAME_ASC',
  UserByAdminIdDisplayNameDesc = 'USER_BY_ADMIN_ID__DISPLAY_NAME_DESC',
  UserByAdminIdEmailAsc = 'USER_BY_ADMIN_ID__EMAIL_ASC',
  UserByAdminIdEmailDesc = 'USER_BY_ADMIN_ID__EMAIL_DESC',
  UserByAdminIdExternalGroupsAsc = 'USER_BY_ADMIN_ID__EXTERNAL_GROUPS_ASC',
  UserByAdminIdExternalGroupsDesc = 'USER_BY_ADMIN_ID__EXTERNAL_GROUPS_DESC',
  UserByAdminIdExternalGroupsSyncedAtAsc = 'USER_BY_ADMIN_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByAdminIdExternalGroupsSyncedAtDesc = 'USER_BY_ADMIN_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByAdminIdFirebaseAuthIdAsc = 'USER_BY_ADMIN_ID__FIREBASE_AUTH_ID_ASC',
  UserByAdminIdFirebaseAuthIdDesc = 'USER_BY_ADMIN_ID__FIREBASE_AUTH_ID_DESC',
  UserByAdminIdFlagsAsc = 'USER_BY_ADMIN_ID__FLAGS_ASC',
  UserByAdminIdFlagsDesc = 'USER_BY_ADMIN_ID__FLAGS_DESC',
  UserByAdminIdIdAsc = 'USER_BY_ADMIN_ID__ID_ASC',
  UserByAdminIdIdDesc = 'USER_BY_ADMIN_ID__ID_DESC',
  UserByAdminIdIsTenantAdminAsc = 'USER_BY_ADMIN_ID__IS_TENANT_ADMIN_ASC',
  UserByAdminIdIsTenantAdminDesc = 'USER_BY_ADMIN_ID__IS_TENANT_ADMIN_DESC',
  UserByAdminIdRegisteredAtAsc = 'USER_BY_ADMIN_ID__REGISTERED_AT_ASC',
  UserByAdminIdRegisteredAtDesc = 'USER_BY_ADMIN_ID__REGISTERED_AT_DESC',
  UserByAdminIdSysPeriodAsc = 'USER_BY_ADMIN_ID__SYS_PERIOD_ASC',
  UserByAdminIdSysPeriodDesc = 'USER_BY_ADMIN_ID__SYS_PERIOD_DESC',
  UserByAdminIdTenantIdAsc = 'USER_BY_ADMIN_ID__TENANT_ID_ASC',
  UserByAdminIdTenantIdDesc = 'USER_BY_ADMIN_ID__TENANT_ID_DESC',
  UserByAdminIdUpdatedAtAsc = 'USER_BY_ADMIN_ID__UPDATED_AT_ASC',
  UserByAdminIdUpdatedAtDesc = 'USER_BY_ADMIN_ID__UPDATED_AT_DESC',
  UserLicensesByOrderIdCountAsc = 'USER_LICENSES_BY_ORDER_ID__COUNT_ASC',
  UserLicensesByOrderIdCountDesc = 'USER_LICENSES_BY_ORDER_ID__COUNT_DESC',
  UserLicensesByOrderIdMaxLastModifiedByIdAsc = 'USER_LICENSES_BY_ORDER_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  UserLicensesByOrderIdMaxLastModifiedByIdDesc = 'USER_LICENSES_BY_ORDER_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  UserLicensesByOrderIdMaxOrderIdAsc = 'USER_LICENSES_BY_ORDER_ID__MAX_ORDER_ID_ASC',
  UserLicensesByOrderIdMaxOrderIdDesc = 'USER_LICENSES_BY_ORDER_ID__MAX_ORDER_ID_DESC',
  UserLicensesByOrderIdMaxUserIdAsc = 'USER_LICENSES_BY_ORDER_ID__MAX_USER_ID_ASC',
  UserLicensesByOrderIdMaxUserIdDesc = 'USER_LICENSES_BY_ORDER_ID__MAX_USER_ID_DESC',
  UserLicensesByOrderIdMaxValidityPeriodAsc = 'USER_LICENSES_BY_ORDER_ID__MAX_VALIDITY_PERIOD_ASC',
  UserLicensesByOrderIdMaxValidityPeriodDesc = 'USER_LICENSES_BY_ORDER_ID__MAX_VALIDITY_PERIOD_DESC',
  UserLicensesByOrderIdMinLastModifiedByIdAsc = 'USER_LICENSES_BY_ORDER_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  UserLicensesByOrderIdMinLastModifiedByIdDesc = 'USER_LICENSES_BY_ORDER_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  UserLicensesByOrderIdMinOrderIdAsc = 'USER_LICENSES_BY_ORDER_ID__MIN_ORDER_ID_ASC',
  UserLicensesByOrderIdMinOrderIdDesc = 'USER_LICENSES_BY_ORDER_ID__MIN_ORDER_ID_DESC',
  UserLicensesByOrderIdMinUserIdAsc = 'USER_LICENSES_BY_ORDER_ID__MIN_USER_ID_ASC',
  UserLicensesByOrderIdMinUserIdDesc = 'USER_LICENSES_BY_ORDER_ID__MIN_USER_ID_DESC',
  UserLicensesByOrderIdMinValidityPeriodAsc = 'USER_LICENSES_BY_ORDER_ID__MIN_VALIDITY_PERIOD_ASC',
  UserLicensesByOrderIdMinValidityPeriodDesc = 'USER_LICENSES_BY_ORDER_ID__MIN_VALIDITY_PERIOD_DESC',
  ValidityPeriodAsc = 'VALIDITY_PERIOD_ASC',
  ValidityPeriodDesc = 'VALIDITY_PERIOD_DESC'
}

export type PageHeatmap = {
  __typename?: 'PageHeatmap';
  avgDuration?: Maybe<Scalars['Float']['output']>;
  crossRevId?: Maybe<Scalars['UUID']['output']>;
  nVisits?: Maybe<Scalars['BigInt']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `PageHeatmap` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PageHeatmapCondition = {
  /** Checks for equality with the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `crossRevId` field. */
  crossRevId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `nVisits` field. */
  nVisits?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `PageHeatmap` object types. All fields are combined with a logical ‘and.’ */
export type PageHeatmapFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PageHeatmapFilter>>;
  /** Filter by the object’s `avgDuration` field. */
  avgDuration?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `crossRevId` field. */
  crossRevId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nVisits` field. */
  nVisits?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PageHeatmapFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PageHeatmapFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PageHeatmap` */
export type PageHeatmapInput = {
  avgDuration?: InputMaybe<Scalars['Float']['input']>;
  crossRevId?: InputMaybe<Scalars['UUID']['input']>;
  nVisits?: InputMaybe<Scalars['BigInt']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `PageHeatmap` values. */
export type PageHeatmapsConnection = {
  __typename?: 'PageHeatmapsConnection';
  /** A list of edges which contains the `PageHeatmap` and cursor to aid in pagination. */
  edges: Array<PageHeatmapsEdge>;
  /** A list of `PageHeatmap` objects. */
  nodes: Array<Maybe<PageHeatmap>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PageHeatmap` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PageHeatmap` edge in the connection. */
export type PageHeatmapsEdge = {
  __typename?: 'PageHeatmapsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PageHeatmap` at the end of the edge. */
  node?: Maybe<PageHeatmap>;
};

/** Methods to use when ordering `PageHeatmap`. */
export enum PageHeatmapsOrderBy {
  AvgDurationAsc = 'AVG_DURATION_ASC',
  AvgDurationDesc = 'AVG_DURATION_DESC',
  CrossRevIdAsc = 'CROSS_REV_ID_ASC',
  CrossRevIdDesc = 'CROSS_REV_ID_DESC',
  Natural = 'NATURAL',
  NVisitsAsc = 'N_VISITS_ASC',
  NVisitsDesc = 'N_VISITS_DESC',
  PageNumberAsc = 'PAGE_NUMBER_ASC',
  PageNumberDesc = 'PAGE_NUMBER_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export enum PageType {
  MagicLink = 'MAGIC_LINK',
  Normal = 'NORMAL',
  Popover = 'POPOVER'
}

/** A filter to be used against PageType fields. All fields are combined with a logical ‘and.’ */
export type PageTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PageType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PageType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PageType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PageType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PageType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PageType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PageType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PageType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PageType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PageType>>;
};

/** An input for mutations affecting `PayloadOfCreateDocumentSpaceWithCrmContact` */
export type PayloadOfCreateDocumentSpaceWithCrmContactInput = {
  configId?: InputMaybe<Scalars['BigInt']['input']>;
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  personalMessage?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `placeDocumentAbove` mutation. */
export type PlaceDocumentAboveInput = {
  aboveId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withId: Scalars['BigInt']['input'];
};

/** The output of our `placeDocumentAbove` mutation. */
export type PlaceDocumentAbovePayload = {
  __typename?: 'PlaceDocumentAbovePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeDocumentBelow` mutation. */
export type PlaceDocumentBelowInput = {
  belowId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withId: Scalars['BigInt']['input'];
};

/** The output of our `placeDocumentBelow` mutation. */
export type PlaceDocumentBelowPayload = {
  __typename?: 'PlaceDocumentBelowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeDocumentBetween` mutation. */
export type PlaceDocumentBetweenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lowerId: Scalars['BigInt']['input'];
  upperId: Scalars['BigInt']['input'];
  withId: Scalars['BigInt']['input'];
};

/** The output of our `placeDocumentBetween` mutation. */
export type PlaceDocumentBetweenPayload = {
  __typename?: 'PlaceDocumentBetweenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeDocument` mutation. */
export type PlaceDocumentInput = {
  aboveId?: InputMaybe<Scalars['BigInt']['input']>;
  belowId?: InputMaybe<Scalars['BigInt']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `placeDocument` mutation. */
export type PlaceDocumentPayload = {
  __typename?: 'PlaceDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeFlowItemBefore` mutation. */
export type PlaceFlowItemBeforeInput = {
  beforeId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withId: Scalars['BigInt']['input'];
};

/** The output of our `placeFlowItemBefore` mutation. */
export type PlaceFlowItemBeforePayload = {
  __typename?: 'PlaceFlowItemBeforePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeFlowItemBehind` mutation. */
export type PlaceFlowItemBehindInput = {
  behindId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withId: Scalars['BigInt']['input'];
};

/** The output of our `placeFlowItemBehind` mutation. */
export type PlaceFlowItemBehindPayload = {
  __typename?: 'PlaceFlowItemBehindPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeFlowItemBetween` mutation. */
export type PlaceFlowItemBetweenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  predecessorId: Scalars['BigInt']['input'];
  successorId: Scalars['BigInt']['input'];
  withId: Scalars['BigInt']['input'];
};

/** The output of our `placeFlowItemBetween` mutation. */
export type PlaceFlowItemBetweenPayload = {
  __typename?: 'PlaceFlowItemBetweenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `placeFlowItem` mutation. */
export type PlaceFlowItemInput = {
  beforeId?: InputMaybe<Scalars['BigInt']['input']>;
  behindId?: InputMaybe<Scalars['BigInt']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `placeFlowItem` mutation. */
export type PlaceFlowItemPayload = {
  __typename?: 'PlaceFlowItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  flowItems?: Maybe<Array<Maybe<FlowItem>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A `PreviewFlowShareToSpacesRecord` edge in the connection. */
export type PreviewFlowShareToSpaceEdge = {
  __typename?: 'PreviewFlowShareToSpaceEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PreviewFlowShareToSpacesRecord` at the end of the edge. */
  node?: Maybe<PreviewFlowShareToSpacesRecord>;
};

/** A connection to a list of `PreviewFlowShareToSpacesRecord` values. */
export type PreviewFlowShareToSpacesConnection = {
  __typename?: 'PreviewFlowShareToSpacesConnection';
  /** A list of edges which contains the `PreviewFlowShareToSpacesRecord` and cursor to aid in pagination. */
  edges: Array<PreviewFlowShareToSpaceEdge>;
  /** A list of `PreviewFlowShareToSpacesRecord` objects. */
  nodes: Array<Maybe<PreviewFlowShareToSpacesRecord>>;
  /** The count of *all* `PreviewFlowShareToSpacesRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `previewFlowShareToSpaces` query. */
export type PreviewFlowShareToSpacesRecord = {
  __typename?: 'PreviewFlowShareToSpacesRecord';
  canCurrentUserShare?: Maybe<Scalars['Boolean']['output']>;
  createdDocumentSpaceItemIds?: Maybe<Array<Maybe<Scalars['BigInt']['output']>>>;
  downloadAvailableForVisitor?: Maybe<Scalars['Boolean']['output']>;
  existingSpaceNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetResults?: Maybe<Scalars['JSON']['output']>;
  violations?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `PreviewFlowShareToSpacesRecord` object types. All fields are combined with a logical ‘and.’ */
export type PreviewFlowShareToSpacesRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreviewFlowShareToSpacesRecordFilter>>;
  /** Filter by the object’s `canCurrentUserShare` field. */
  canCurrentUserShare?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdDocumentSpaceItemIds` field. */
  createdDocumentSpaceItemIds?: InputMaybe<BigIntListFilter>;
  /** Filter by the object’s `downloadAvailableForVisitor` field. */
  downloadAvailableForVisitor?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `existingSpaceNames` field. */
  existingSpaceNames?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreviewFlowShareToSpacesRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreviewFlowShareToSpacesRecordFilter>>;
  /** Filter by the object’s `targetResults` field. */
  targetResults?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `violations` field. */
  violations?: InputMaybe<JsonFilter>;
};

/** All input for the `pvAddTagsToWorkspace` mutation. */
export type PvAddTagsToWorkspaceInput = {
  addTags: Array<InputMaybe<Scalars['String']['input']>>;
  byId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `pvAddTagsToWorkspace` mutation. */
export type PvAddTagsToWorkspacePayload = {
  __typename?: 'PvAddTagsToWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<PvAddTagsToWorkspaceRecord>;
};

/** The return type of our `pvAddTagsToWorkspace` mutation. */
export type PvAddTagsToWorkspaceRecord = {
  __typename?: 'PvAddTagsToWorkspaceRecord';
  mergedTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workspace?: Maybe<Workspace>;
};

/** All input for the `pvAddUserNotification` mutation. */
export type PvAddUserNotificationInput = {
  bodyText: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventType: PvNotificationEventType;
  firebaseUserId: Scalars['String']['input'];
  headerText: Scalars['String']['input'];
};

/** The output of our `pvAddUserNotification` mutation. */
export type PvAddUserNotificationPayload = {
  __typename?: 'PvAddUserNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our `pvAddUserNotification` mutation. */
export type PvAddUserNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `pvAddWorkspaceNotification` mutation. */
export type PvAddWorkspaceNotificationInput = {
  bodyText: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  eventType: PvNotificationEventType;
  firebaseWorkspaceId: Scalars['String']['input'];
  headerText: Scalars['String']['input'];
};

/** The output of our `pvAddWorkspaceNotification` mutation. */
export type PvAddWorkspaceNotificationPayload = {
  __typename?: 'PvAddWorkspaceNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our `pvAddWorkspaceNotification` mutation. */
export type PvAddWorkspaceNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `pvCreateVoucherForDocumentSpace` mutation. */
export type PvCreateVoucherForDocumentSpaceInput = {
  byId?: InputMaybe<Scalars['BigInt']['input']>;
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The output of our `pvCreateVoucherForDocumentSpace` mutation. */
export type PvCreateVoucherForDocumentSpacePayload = {
  __typename?: 'PvCreateVoucherForDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<PvCreateVoucherForDocumentSpaceRecord>;
};

/** The return type of our `pvCreateVoucherForDocumentSpace` mutation. */
export type PvCreateVoucherForDocumentSpaceRecord = {
  __typename?: 'PvCreateVoucherForDocumentSpaceRecord';
  documentSpace?: Maybe<DocumentSpace>;
  rawUrlSegment?: Maybe<Scalars['String']['output']>;
  urlSegment?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<DocumentSpaceVoucher>;
};

/** All input for the `pvDropTagsFromWorkspace` mutation. */
export type PvDropTagsFromWorkspaceInput = {
  byId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dropTags: Array<InputMaybe<Scalars['String']['input']>>;
};

/** The output of our `pvDropTagsFromWorkspace` mutation. */
export type PvDropTagsFromWorkspacePayload = {
  __typename?: 'PvDropTagsFromWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<PvDropTagsFromWorkspaceRecord>;
};

/** The return type of our `pvDropTagsFromWorkspace` mutation. */
export type PvDropTagsFromWorkspaceRecord = {
  __typename?: 'PvDropTagsFromWorkspaceRecord';
  remainingTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workspace?: Maybe<Workspace>;
};

export enum PvNotificationEventType {
  DocUpdate = 'DOC_UPDATE',
  Message = 'MESSAGE',
  NewSpaceCollab = 'NEW_SPACE_COLLAB'
}

/** A filter to be used against PvNotificationEventType fields. All fields are combined with a logical ‘and.’ */
export type PvNotificationEventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PvNotificationEventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PvNotificationEventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PvNotificationEventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PvNotificationEventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PvNotificationEventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PvNotificationEventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PvNotificationEventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PvNotificationEventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PvNotificationEventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PvNotificationEventType>>;
};

/** All input for the `pvSendTeamMessage` mutation. */
export type PvSendTeamMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  includeSender?: InputMaybe<Scalars['Boolean']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  recipientUserIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};

/** The output of our `pvSendTeamMessage` mutation. */
export type PvSendTeamMessagePayload = {
  __typename?: 'PvSendTeamMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  sentCount?: Maybe<Scalars['Int']['output']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  alreadyUsedTags?: Maybe<AlreadyUsedTagsConnection>;
  alreadyUsedTagsList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Reads and enables pagination through a set of `ArInternalMetadatum`. */
  arInternalMetadata?: Maybe<ArInternalMetadataConnection>;
  arInternalMetadatum?: Maybe<ArInternalMetadatum>;
  /** Reads a single `ArInternalMetadatum` using its globally unique `ID`. */
  arInternalMetadatumByNodeId?: Maybe<ArInternalMetadatum>;
  campaign?: Maybe<Campaign>;
  /** Reads a single `Campaign` using its globally unique `ID`. */
  campaignByNodeId?: Maybe<Campaign>;
  campaignPhase?: Maybe<CampaignPhase>;
  /** Reads a single `CampaignPhase` using its globally unique `ID`. */
  campaignPhaseByNodeId?: Maybe<CampaignPhase>;
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** Reads a single `CampaignPhaseLink` using its globally unique `ID`. */
  campaignPhaseLinkByNodeId?: Maybe<CampaignPhaseLink>;
  /** Reads and enables pagination through a set of `CampaignPhaseLink`. */
  campaignPhaseLinks?: Maybe<CampaignPhaseLinksConnection>;
  /** Reads and enables pagination through a set of `CampaignPhase`. */
  campaignPhases?: Maybe<CampaignPhasesConnection>;
  campaignQueryParam?: Maybe<CampaignQueryParam>;
  /** Reads a single `CampaignQueryParam` using its globally unique `ID`. */
  campaignQueryParamByNodeId?: Maybe<CampaignQueryParam>;
  /** Reads and enables pagination through a set of `CampaignQueryParam`. */
  campaignQueryParams?: Maybe<CampaignQueryParamsConnection>;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaigns?: Maybe<CampaignsConnection>;
  coalesceAggSfunc?: Maybe<Scalars['String']['output']>;
  crmContact?: Maybe<CrmContact>;
  crmContactByCrmIdAndTenantId?: Maybe<CrmContact>;
  /** Reads a single `CrmContact` using its globally unique `ID`. */
  crmContactByNodeId?: Maybe<CrmContact>;
  crmContactConsent?: Maybe<CrmContactConsent>;
  /** Reads a single `CrmContactConsent` using its globally unique `ID`. */
  crmContactConsentByNodeId?: Maybe<CrmContactConsent>;
  /** Reads and enables pagination through a set of `CrmContactConsent`. */
  crmContactConsents?: Maybe<CrmContactConsentsConnection>;
  crmContactMatch?: Maybe<CrmContactMatch>;
  /** Reads a single `CrmContactMatch` using its globally unique `ID`. */
  crmContactMatchByNodeId?: Maybe<CrmContactMatch>;
  crmContactPhaseMapping?: Maybe<CrmContactPhaseMapping>;
  /** Reads a single `CrmContactPhaseMapping` using its globally unique `ID`. */
  crmContactPhaseMappingByNodeId?: Maybe<CrmContactPhaseMapping>;
  crmContactPhaseMappingByPhaseIdAndContactId?: Maybe<CrmContactPhaseMapping>;
  /** Reads and enables pagination through a set of `CrmContactPhaseMapping`. */
  crmContactPhaseMappings?: Maybe<CrmContactPhaseMappingsConnection>;
  /** Reads and enables pagination through a set of `CrmContact`. */
  crmContacts?: Maybe<CrmContactsConnection>;
  decodeBase64UrlSegment?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentByFirestoreId?: Maybe<Document>;
  /** Reads a single `Document` using its globally unique `ID`. */
  documentByNodeId?: Maybe<Document>;
  documentExpiration?: Maybe<DocumentExpiration>;
  /** Reads a single `DocumentExpiration` using its globally unique `ID`. */
  documentExpirationByNodeId?: Maybe<DocumentExpiration>;
  /** Reads and enables pagination through a set of `DocumentExpiration`. */
  documentExpirations?: Maybe<DocumentExpirationsConnection>;
  /** Reads and enables pagination through a set of `DocumentHistoryEntry`. */
  documentHistoryEntries?: Maybe<DocumentHistoryEntriesConnection>;
  documentHistoryEntry?: Maybe<DocumentHistoryEntry>;
  /** Reads a single `DocumentHistoryEntry` using its globally unique `ID`. */
  documentHistoryEntryByNodeId?: Maybe<DocumentHistoryEntry>;
  documentPage?: Maybe<DocumentPage>;
  documentPageByDocumentIdAndRevisionNumberAndPageNumber?: Maybe<DocumentPage>;
  /** Reads a single `DocumentPage` using its globally unique `ID`. */
  documentPageByNodeId?: Maybe<DocumentPage>;
  documentPageLink?: Maybe<DocumentPageLink>;
  /** Reads a single `DocumentPageLink` using its globally unique `ID`. */
  documentPageLinkByNodeId?: Maybe<DocumentPageLink>;
  /** Reads and enables pagination through a set of `DocumentPageLink`. */
  documentPageLinks?: Maybe<DocumentPageLinksConnection>;
  documentPageMatching?: Maybe<DocumentPageMatching>;
  documentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DocumentPageMatching>;
  documentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DocumentPageMatching>;
  /** Reads a single `DocumentPageMatching` using its globally unique `ID`. */
  documentPageMatchingByNodeId?: Maybe<DocumentPageMatching>;
  /** Reads and enables pagination through a set of `DocumentPageMatching`. */
  documentPageMatchings?: Maybe<DocumentPageMatchingsConnection>;
  /** Reads and enables pagination through a set of `DocumentPageMatchingsBak`. */
  documentPageMatchingsBaks?: Maybe<DocumentPageMatchingsBaksConnection>;
  /** Reads and enables pagination through a set of `DocumentPage`. */
  documentPages?: Maybe<DocumentPagesConnection>;
  documentProcess?: Maybe<DocumentProcess>;
  /** Reads a single `DocumentProcess` using its globally unique `ID`. */
  documentProcessByNodeId?: Maybe<DocumentProcess>;
  /** Reads and enables pagination through a set of `DocumentProcess`. */
  documentProcesses?: Maybe<DocumentProcessesConnection>;
  documentRevision?: Maybe<DocumentRevision>;
  /** Reads a single `DocumentRevision` using its globally unique `ID`. */
  documentRevisionByNodeId?: Maybe<DocumentRevision>;
  /** Reads and enables pagination through a set of `DocumentRevision`. */
  documentRevisions?: Maybe<DocumentRevisionsConnection>;
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceAccess?: Maybe<DocumentSpaceAccess>;
  /** Reads a single `DocumentSpaceAccess` using its globally unique `ID`. */
  documentSpaceAccessByNodeId?: Maybe<DocumentSpaceAccess>;
  documentSpaceAccessByUserIdAndDocumentSpaceId?: Maybe<DocumentSpaceAccess>;
  /** Reads and enables pagination through a set of `DocumentSpaceAccess`. */
  documentSpaceAccesses?: Maybe<DocumentSpaceAccessesConnection>;
  documentSpaceByCodeOnAccessCard?: Maybe<DocumentSpace>;
  /** Reads a single `DocumentSpace` using its globally unique `ID`. */
  documentSpaceByNodeId?: Maybe<DocumentSpace>;
  documentSpaceConfig?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `DocumentSpaceConfig` using its globally unique `ID`. */
  documentSpaceConfigByNodeId?: Maybe<DocumentSpaceConfig>;
  documentSpaceConfigTranslation?: Maybe<DocumentSpaceConfigTranslation>;
  documentSpaceConfigTranslationByConfigIdAndLanguageCode?: Maybe<DocumentSpaceConfigTranslation>;
  /** Reads a single `DocumentSpaceConfigTranslation` using its globally unique `ID`. */
  documentSpaceConfigTranslationByNodeId?: Maybe<DocumentSpaceConfigTranslation>;
  /** Reads and enables pagination through a set of `DocumentSpaceConfigTranslation`. */
  documentSpaceConfigTranslations?: Maybe<DocumentSpaceConfigTranslationsConnection>;
  /** Reads and enables pagination through a set of `DocumentSpaceConfig`. */
  documentSpaceConfigs?: Maybe<DocumentSpaceConfigsConnection>;
  documentSpaceCrmMapping?: Maybe<DocumentSpaceCrmMapping>;
  documentSpaceCrmMappingByDocumentSpaceId?: Maybe<DocumentSpaceCrmMapping>;
  /** Reads a single `DocumentSpaceCrmMapping` using its globally unique `ID`. */
  documentSpaceCrmMappingByNodeId?: Maybe<DocumentSpaceCrmMapping>;
  /** Reads and enables pagination through a set of `DocumentSpaceCrmMapping`. */
  documentSpaceCrmMappings?: Maybe<DocumentSpaceCrmMappingsConnection>;
  /** Reads and enables pagination through a set of `DocumentSpaceDetailStatistic`. */
  documentSpaceDetailStatistics?: Maybe<DocumentSpaceDetailStatisticsConnection>;
  /** Reads and enables pagination through a set of `DocumentSpaceDocStatistic`. */
  documentSpaceDocStatistics?: Maybe<DocumentSpaceDocStatisticsConnection>;
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  documentSpaceItemByDocumentIdAndDocumentSpaceId?: Maybe<DocumentSpaceItem>;
  documentSpaceItemByDocumentSpaceIdAndSectionIdAndPosition?: Maybe<DocumentSpaceItem>;
  /** Reads a single `DocumentSpaceItem` using its globally unique `ID`. */
  documentSpaceItemByNodeId?: Maybe<DocumentSpaceItem>;
  /** Reads and enables pagination through a set of `DocumentSpaceItem`. */
  documentSpaceItems?: Maybe<DocumentSpaceItemsConnection>;
  documentSpaceLink?: Maybe<DocumentSpaceLink>;
  /** Reads a single `DocumentSpaceLink` using its globally unique `ID`. */
  documentSpaceLinkByNodeId?: Maybe<DocumentSpaceLink>;
  documentSpaceLinkByPositionAndConfigId?: Maybe<DocumentSpaceLink>;
  documentSpaceLinkByPositionAndDocumentSpaceId?: Maybe<DocumentSpaceLink>;
  documentSpaceLinkGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** Reads a single `DocumentSpaceLinkGroup` using its globally unique `ID`. */
  documentSpaceLinkGroupByNodeId?: Maybe<DocumentSpaceLinkGroup>;
  documentSpaceLinkGroupByTenantIdAndId?: Maybe<DocumentSpaceLinkGroup>;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkGroup`. */
  documentSpaceLinkGroups?: Maybe<DocumentSpaceLinkGroupsConnection>;
  documentSpaceLinkMapping?: Maybe<DocumentSpaceLinkMapping>;
  /** Reads a single `DocumentSpaceLinkMapping` using its globally unique `ID`. */
  documentSpaceLinkMappingByNodeId?: Maybe<DocumentSpaceLinkMapping>;
  documentSpaceLinkMappingBySpaceIdAndLinkId?: Maybe<DocumentSpaceLinkMapping>;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkMapping`. */
  documentSpaceLinkMappings?: Maybe<DocumentSpaceLinkMappingsConnection>;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkStatistic`. */
  documentSpaceLinkStatistics?: Maybe<DocumentSpaceLinkStatisticsConnection>;
  documentSpaceLinkTranslation?: Maybe<DocumentSpaceLinkTranslation>;
  documentSpaceLinkTranslationByLinkIdAndLanguageCode?: Maybe<DocumentSpaceLinkTranslation>;
  /** Reads a single `DocumentSpaceLinkTranslation` using its globally unique `ID`. */
  documentSpaceLinkTranslationByNodeId?: Maybe<DocumentSpaceLinkTranslation>;
  documentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCode?: Maybe<DocumentSpaceLinkTranslation>;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkTranslation`. */
  documentSpaceLinkTranslations?: Maybe<DocumentSpaceLinkTranslationsConnection>;
  /** Reads and enables pagination through a set of `DocumentSpaceLink`. */
  documentSpaceLinks?: Maybe<DocumentSpaceLinksConnection>;
  /** Reads and enables pagination through a set of `DocumentSpacePageStatistic`. */
  documentSpacePageStatistics?: Maybe<DocumentSpacePageStatisticsConnection>;
  documentSpaceSection?: Maybe<DocumentSpaceSection>;
  documentSpaceSectionByDocumentSpaceIdAndPosition?: Maybe<DocumentSpaceSection>;
  /** Reads a single `DocumentSpaceSection` using its globally unique `ID`. */
  documentSpaceSectionByNodeId?: Maybe<DocumentSpaceSection>;
  documentSpaceSectionByTitleAndDocumentSpaceId?: Maybe<DocumentSpaceSection>;
  /** Reads and enables pagination through a set of `DocumentSpaceSection`. */
  documentSpaceSections?: Maybe<DocumentSpaceSectionsConnection>;
  documentSpaceSession?: Maybe<DocumentSpaceSession>;
  documentSpaceSessionByFingerprintAndDocumentSpaceId?: Maybe<DocumentSpaceSession>;
  /** Reads a single `DocumentSpaceSession` using its globally unique `ID`. */
  documentSpaceSessionByNodeId?: Maybe<DocumentSpaceSession>;
  /** Reads and enables pagination through a set of `DocumentSpaceSession`. */
  documentSpaceSessions?: Maybe<DocumentSpaceSessionsConnection>;
  /** Reads and enables pagination through a set of `DocumentSpaceStatistic`. */
  documentSpaceStatistics?: Maybe<DocumentSpaceStatisticsConnection>;
  documentSpaceTag?: Maybe<DocumentSpaceTag>;
  /** Reads a single `DocumentSpaceTag` using its globally unique `ID`. */
  documentSpaceTagByNodeId?: Maybe<DocumentSpaceTag>;
  /** Reads and enables pagination through a set of `DocumentSpaceTag`. */
  documentSpaceTags?: Maybe<DocumentSpaceTagsConnection>;
  documentSpaceVisitStatistic?: Maybe<DocumentSpaceVisitStatistic>;
  /** Reads a single `DocumentSpaceVisitStatistic` using its globally unique `ID`. */
  documentSpaceVisitStatisticByNodeId?: Maybe<DocumentSpaceVisitStatistic>;
  /** Reads and enables pagination through a set of `DocumentSpaceVisitStatistic`. */
  documentSpaceVisitStatistics?: Maybe<DocumentSpaceVisitStatisticsConnection>;
  documentSpaceVoucher?: Maybe<DocumentSpaceVoucher>;
  /** Reads a single `DocumentSpaceVoucher` using its globally unique `ID`. */
  documentSpaceVoucherByNodeId?: Maybe<DocumentSpaceVoucher>;
  /** Reads and enables pagination through a set of `DocumentSpaceVoucher`. */
  documentSpaceVouchers?: Maybe<DocumentSpaceVouchersConnection>;
  /** Reads and enables pagination through a set of `DocumentSpace`. */
  documentSpaces?: Maybe<DocumentSpacesConnection>;
  /** Reads and enables pagination through a set of `DocumentSpacesOldBak`. */
  documentSpacesOldBaks?: Maybe<DocumentSpacesOldBaksConnection>;
  /** Reads and enables pagination through a set of `DocumentStatistic`. */
  documentStatistics?: Maybe<DocumentStatisticsConnection>;
  documentUsageCounts?: Maybe<DocumentUsageCountsRecord>;
  /** Reads and enables pagination through a set of `Document`. */
  documents?: Maybe<DocumentsConnection>;
  event?: Maybe<Event>;
  /** Reads a single `Event` using its globally unique `ID`. */
  eventByNodeId?: Maybe<Event>;
  flow?: Maybe<Flow>;
  /** Reads a single `Flow` using its globally unique `ID`. */
  flowByNodeId?: Maybe<Flow>;
  flowItem?: Maybe<FlowItem>;
  /** Reads a single `FlowItem` using its globally unique `ID`. */
  flowItemByNodeId?: Maybe<FlowItem>;
  /** Reads and enables pagination through a set of `FlowItem`. */
  flowItems?: Maybe<FlowItemsConnection>;
  flowSubscription?: Maybe<FlowSubscription>;
  flowSubscriptionByFlowIdAndTeamId?: Maybe<FlowSubscription>;
  flowSubscriptionByFlowIdAndUserId?: Maybe<FlowSubscription>;
  /** Reads a single `FlowSubscription` using its globally unique `ID`. */
  flowSubscriptionByNodeId?: Maybe<FlowSubscription>;
  /** Reads and enables pagination through a set of `FlowSubscription`. */
  flowSubscriptions?: Maybe<FlowSubscriptionsConnection>;
  /** Reads and enables pagination through a set of `Flow`. */
  flows?: Maybe<FlowsConnection>;
  /** Reads and enables pagination through a set of `FtsDocumentSpaceHit`. */
  ftsSearchDocumentSpaces?: Maybe<FtsDocumentSpaceHitsConnection>;
  /**
   * Full-text search across documents and their pages.
   * Returns the top matching documents with up to 3 best matching page hits nested as an array.
   * Use page_relevance_factor to weight page matches relative to title matches (default 1.0, lower values prioritize title matches).
   * Pass a subset of languages to optimize index usage.
   *
   */
  ftsSearchDocuments?: Maybe<FtsDocumentHitsConnection>;
  /**
   * Full-text search across flows and the pages attached to them.
   * Returns the top matching flows with up to 3 best matching page hits nested as an array.
   * Uses the simple_words configuration for flow titles and the detected page language for page matches.
   * Use page_relevance_factor to weight page matches relative to title matches (default 1.0, lower values prioritize title matches).
   * Pass a subset of languages to optimize page index usage.
   *
   */
  ftsSearchFlows?: Maybe<FtsFlowHitsConnection>;
  /** Reads and enables pagination through a set of `DocumentPage`. */
  getPagesOfSpace?: Maybe<DocumentPagesConnection>;
  /**
   * Returns the effective retention policy for a workspace by checking in order:
   * 1. Workspace-specific policy
   * 2. Team-specific policy (if the workspace is a team)
   * 3. Tenant-specific policy
   * 4. System defaults
   *
   * This function is SECURITY DEFINER to bypass RLS and read all policies.
   * The function itself is protected by the fact that it only returns data, and
   * users can only call it for workspaces they have access to through other means.
   *
   */
  getRetentionPolicyForWorkspace?: Maybe<GetRetentionPolicyForWorkspaceConnection>;
  guessLanguage?: Maybe<Scalars['String']['output']>;
  guessLanguageDetailed?: Maybe<GuessLanguageDetailedConnection>;
  /** Reads and enables pagination through a set of `InspectWorkspaceSerialization`. */
  inspectWorkspaceSerializations?: Maybe<InspectWorkspaceSerializationsConnection>;
  internalIpAddress?: Maybe<InternalIpAddress>;
  /** Reads a single `InternalIpAddress` using its globally unique `ID`. */
  internalIpAddressByNodeId?: Maybe<InternalIpAddress>;
  /** Reads and enables pagination through a set of `InternalIpAddress`. */
  internalIpAddresses?: Maybe<InternalIpAddressesConnection>;
  isSignedIn?: Maybe<Scalars['Boolean']['output']>;
  isValidEmail?: Maybe<Scalars['Boolean']['output']>;
  labelsOfDocumentView?: Maybe<LabelsOfDocumentView>;
  /** Reads a single `LabelsOfDocumentView` using its globally unique `ID`. */
  labelsOfDocumentViewByNodeId?: Maybe<LabelsOfDocumentView>;
  /** Reads and enables pagination through a set of `LabelsOfDocumentView`. */
  labelsOfDocumentViews?: Maybe<LabelsOfDocumentViewsConnection>;
  languageCode?: Maybe<LanguageCode>;
  /** Reads a single `LanguageCode` using its globally unique `ID`. */
  languageCodeByNodeId?: Maybe<LanguageCode>;
  /** Reads and enables pagination through a set of `LanguageCode`. */
  languageCodes?: Maybe<LanguageCodesConnection>;
  /** Reads and enables pagination through a set of `LastCsvImport`. */
  lastCsvImports?: Maybe<LastCsvImportsConnection>;
  maDocumentSpaceDocumentStatistic?: Maybe<MaDocumentSpaceDocumentStatistic>;
  /** Reads a single `MaDocumentSpaceDocumentStatistic` using its globally unique `ID`. */
  maDocumentSpaceDocumentStatisticByNodeId?: Maybe<MaDocumentSpaceDocumentStatistic>;
  /** Reads and enables pagination through a set of `MaDocumentSpaceDocumentStatistic`. */
  maDocumentSpaceDocumentStatistics?: Maybe<MaDocumentSpaceDocumentStatisticsConnection>;
  maDocumentSpaceLinkStatistic?: Maybe<MaDocumentSpaceLinkStatistic>;
  /** Reads a single `MaDocumentSpaceLinkStatistic` using its globally unique `ID`. */
  maDocumentSpaceLinkStatisticByNodeId?: Maybe<MaDocumentSpaceLinkStatistic>;
  /** Reads and enables pagination through a set of `MaDocumentSpaceLinkStatistic`. */
  maDocumentSpaceLinkStatistics?: Maybe<MaDocumentSpaceLinkStatisticsConnection>;
  maDocumentSpacePageStatistic?: Maybe<MaDocumentSpacePageStatistic>;
  /** Reads a single `MaDocumentSpacePageStatistic` using its globally unique `ID`. */
  maDocumentSpacePageStatisticByNodeId?: Maybe<MaDocumentSpacePageStatistic>;
  /** Reads and enables pagination through a set of `MaDocumentSpacePageStatistic`. */
  maDocumentSpacePageStatistics?: Maybe<MaDocumentSpacePageStatisticsConnection>;
  maDocumentSpaceStatistic?: Maybe<MaDocumentSpaceStatistic>;
  /** Reads a single `MaDocumentSpaceStatistic` using its globally unique `ID`. */
  maDocumentSpaceStatisticByNodeId?: Maybe<MaDocumentSpaceStatistic>;
  /** Reads and enables pagination through a set of `MaDocumentSpaceStatistic`. */
  maDocumentSpaceStatistics?: Maybe<MaDocumentSpaceStatisticsConnection>;
  maDocumentSpaceVideoStatistic?: Maybe<MaDocumentSpaceVideoStatistic>;
  /** Reads a single `MaDocumentSpaceVideoStatistic` using its globally unique `ID`. */
  maDocumentSpaceVideoStatisticByNodeId?: Maybe<MaDocumentSpaceVideoStatistic>;
  /** Reads and enables pagination through a set of `MaDocumentSpaceVideoStatistic`. */
  maDocumentSpaceVideoStatistics?: Maybe<MaDocumentSpaceVideoStatisticsConnection>;
  maDocumentSpaceVisitsStatistic?: Maybe<MaDocumentSpaceVisitsStatistic>;
  /** Reads a single `MaDocumentSpaceVisitsStatistic` using its globally unique `ID`. */
  maDocumentSpaceVisitsStatisticByNodeId?: Maybe<MaDocumentSpaceVisitsStatistic>;
  /** Reads and enables pagination through a set of `MaDocumentSpaceVisitsStatistic`. */
  maDocumentSpaceVisitsStatistics?: Maybe<MaDocumentSpaceVisitsStatisticsConnection>;
  /** Reads and enables pagination through a set of `MaDocumentStatistic`. */
  maDocumentStatistics?: Maybe<MaDocumentStatisticsConnection>;
  maGroupedDocumentSpaceVisits?: Maybe<MaGroupedDocumentSpaceVisitsConnection>;
  maLatestSpaceVisits?: Maybe<MaLatestSpaceVisitsConnection>;
  /** Reads and enables pagination through a set of `MaLinkStatistic`. */
  maLinkStatistics?: Maybe<MaLinkStatisticsConnection>;
  /** Reads and enables pagination through a set of `MaPageStatistic`. */
  maPageStatistics?: Maybe<MaPageStatisticsConnection>;
  /** Reads and enables pagination through a set of `MaSpaceUsageByTeam`. */
  maSpaceUsageByTeams?: Maybe<MaSpaceUsageByTeamsConnection>;
  /** Reads and enables pagination through a set of `MaSpaceUsageByTeamsAndYear`. */
  maSpaceUsageByTeamsAndYears?: Maybe<MaSpaceUsageByTeamsAndYearsConnection>;
  /** Reads and enables pagination through a set of `MaUsageByTeam`. */
  maUsageByTeams?: Maybe<MaUsageByTeamsConnection>;
  /** Reads and enables pagination through a set of `MaUsageByTeamsAllTimeMembershipAndYear`. */
  maUsageByTeamsAllTimeMembershipAndYears?: Maybe<MaUsageByTeamsAllTimeMembershipAndYearsConnection>;
  /** Reads and enables pagination through a set of `MaUsageByTeamsAndYear`. */
  maUsageByTeamsAndYears?: Maybe<MaUsageByTeamsAndYearsConnection>;
  /** Reads and enables pagination through a set of `MaVisitDetail`. */
  maVisitDetails?: Maybe<MaVisitDetailsConnection>;
  membership?: Maybe<Membership>;
  /** Reads a single `Membership` using its globally unique `ID`. */
  membershipByNodeId?: Maybe<Membership>;
  membershipBySubteamIdAndTeamId?: Maybe<Membership>;
  membershipByUserIdAndTeamId?: Maybe<Membership>;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships?: Maybe<MembershipsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  myAccount?: Maybe<UsersConnection>;
  myAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `Team`. */
  myAdminTeams?: Maybe<TeamsConnection>;
  myAdministratedDocumentSpaceIds?: Maybe<MyAdministratedDocumentSpaceIdsConnection>;
  /** Reads and enables pagination through a set of `Team`. */
  myAdministratedTeams?: Maybe<TeamsConnection>;
  myDocumentSpaceIds?: Maybe<MyDocumentSpaceIdsConnection>;
  myEditableDocumentSpaceIds?: Maybe<MyEditableDocumentSpaceIdsConnection>;
  /** Reads and enables pagination through a set of `FlowSubscription`. */
  myFlowSubscriptions?: Maybe<FlowSubscriptionsConnection>;
  /**
   * Reads and enables pagination through a set of `Team`.
   * @deprecated true
   */
  myJoinableTeams?: Maybe<TeamsConnection>;
  /** Reads and enables pagination through a set of `Membership`. */
  myMemberships?: Maybe<MembershipsConnection>;
  myOwnedDocumentSpaceIds?: Maybe<MyOwnedDocumentSpaceIdsConnection>;
  /** Reads and enables pagination through a set of `Team`. */
  myTeams?: Maybe<TeamsConnection>;
  /** Reads and enables pagination through a set of `Team`. */
  myTeamsByMembershipState?: Maybe<TeamsConnection>;
  myTenantId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `WorkspaceSubscription`. */
  myWorkspaceSubscriptions?: Maybe<WorkspaceSubscriptionsConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NonSyncableWorkspace`. */
  nonSyncableWorkspaces?: Maybe<NonSyncableWorkspacesConnection>;
  notification?: Maybe<Notification>;
  /** Reads a single `Notification` using its globally unique `ID`. */
  notificationByNodeId?: Maybe<Notification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications?: Maybe<NotificationsConnection>;
  /** Reads and enables pagination through a set of `ObsoleteUserSubscription`. */
  obsoleteUserSubscriptions?: Maybe<ObsoleteUserSubscriptionsConnection>;
  /** Reads and enables pagination through a set of `OldDocumentSpace`. */
  oldDocumentSpaces?: Maybe<OldDocumentSpacesConnection>;
  order?: Maybe<Order>;
  /** Reads a single `Order` using its globally unique `ID`. */
  orderByNodeId?: Maybe<Order>;
  /** Reads and enables pagination through a set of `Order`. */
  orders?: Maybe<OrdersConnection>;
  previewFlowShareToSpaces?: Maybe<PreviewFlowShareToSpacesConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads and enables pagination through a set of `CrmContactMatch`. */
  rankedSearchCrmContactsByName?: Maybe<CrmContactMatchesConnection>;
  registrationToken?: Maybe<RegistrationToken>;
  /** Reads a single `RegistrationToken` using its globally unique `ID`. */
  registrationTokenByNodeId?: Maybe<RegistrationToken>;
  /** Reads and enables pagination through a set of `RegistrationToken`. */
  registrationTokens?: Maybe<RegistrationTokensConnection>;
  /** Reads and enables pagination through a set of `RetentionPolicy`. */
  retentionPolicies?: Maybe<RetentionPoliciesConnection>;
  retentionPolicy?: Maybe<RetentionPolicy>;
  /** Reads a single `RetentionPolicy` using its globally unique `ID`. */
  retentionPolicyByNodeId?: Maybe<RetentionPolicy>;
  retentionPolicyByTeamId?: Maybe<RetentionPolicy>;
  retentionPolicyByTenantId?: Maybe<RetentionPolicy>;
  retentionPolicyByWorkspaceId?: Maybe<RetentionPolicy>;
  schemaMigration?: Maybe<SchemaMigration>;
  /** Reads a single `SchemaMigration` using its globally unique `ID`. */
  schemaMigrationByNodeId?: Maybe<SchemaMigration>;
  /** Reads and enables pagination through a set of `SchemaMigration`. */
  schemaMigrations?: Maybe<SchemaMigrationsConnection>;
  /** Reads and enables pagination through a set of `CrmContact`. */
  searchCrmContactsByName?: Maybe<CrmContactsConnection>;
  /** Reads and enables pagination through a set of `MatchingDocumentSpace`. */
  searchDocumentSpaces?: Maybe<MatchingDocumentSpacesConnection>;
  /** Reads and enables pagination through a set of `MatchingDocument`. */
  searchDocuments?: Maybe<MatchingDocumentsConnection>;
  /** Reads and enables pagination through a set of `SerializedWorkspace`. */
  serializedWorkspaces?: Maybe<SerializedWorkspacesConnection>;
  setting?: Maybe<Setting>;
  /** Reads a single `Setting` using its globally unique `ID`. */
  settingByNodeId?: Maybe<Setting>;
  /** Reads and enables pagination through a set of `Setting`. */
  settings?: Maybe<SettingsConnection>;
  shortenFullGroupNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Reads and enables pagination through a set of `SpaceVisit`. */
  spaceVisits?: Maybe<SpaceVisitsConnection>;
  team?: Maybe<Team>;
  /** Reads a single `Team` using its globally unique `ID`. */
  teamByNodeId?: Maybe<Team>;
  /** Reads and enables pagination through a set of `Team`. */
  teams?: Maybe<TeamsConnection>;
  /** Reads and enables pagination through a set of `TempContact`. */
  tempContacts?: Maybe<TempContactsConnection>;
  tenant?: Maybe<Tenant>;
  tenantByName?: Maybe<Tenant>;
  /** Reads a single `Tenant` using its globally unique `ID`. */
  tenantByNodeId?: Maybe<Tenant>;
  /** Reads and enables pagination through a set of `Tenant`. */
  tenants?: Maybe<TenantsConnection>;
  urlBasedDocumentImport?: Maybe<UrlBasedDocumentImport>;
  /** Reads a single `UrlBasedDocumentImport` using its globally unique `ID`. */
  urlBasedDocumentImportByNodeId?: Maybe<UrlBasedDocumentImport>;
  urlBasedDocumentImportSetting?: Maybe<UrlBasedDocumentImportSetting>;
  /** Reads a single `UrlBasedDocumentImportSetting` using its globally unique `ID`. */
  urlBasedDocumentImportSettingByNodeId?: Maybe<UrlBasedDocumentImportSetting>;
  /** Reads and enables pagination through a set of `UrlBasedDocumentImportSetting`. */
  urlBasedDocumentImportSettings?: Maybe<UrlBasedDocumentImportSettingsConnection>;
  /** Reads and enables pagination through a set of `UrlBasedDocumentImport`. */
  urlBasedDocumentImports?: Maybe<UrlBasedDocumentImportsConnection>;
  user?: Maybe<User>;
  userByEmail?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  userContactDetail?: Maybe<UserContactDetail>;
  /** Reads a single `UserContactDetail` using its globally unique `ID`. */
  userContactDetailByNodeId?: Maybe<UserContactDetail>;
  userContactDetailByUserId?: Maybe<UserContactDetail>;
  /** Reads and enables pagination through a set of `UserContactDetail`. */
  userContactDetails?: Maybe<UserContactDetailsConnection>;
  userLicense?: Maybe<UserLicense>;
  /** Reads a single `UserLicense` using its globally unique `ID`. */
  userLicenseByNodeId?: Maybe<UserLicense>;
  /** Reads and enables pagination through a set of `UserLicense`. */
  userLicenses?: Maybe<UserLicensesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Returns all users that have any of the given flags. */
  usersByFlags?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `VeevaDocumentMetadatum`. */
  veevaDocumentMetadata?: Maybe<VeevaDocumentMetadataConnection>;
  veevaDocumentMetadatum?: Maybe<VeevaDocumentMetadatum>;
  /** Reads a single `VeevaDocumentMetadatum` using its globally unique `ID`. */
  veevaDocumentMetadatumByNodeId?: Maybe<VeevaDocumentMetadatum>;
  workspace?: Maybe<Workspace>;
  workspaceByFirebaseId?: Maybe<Workspace>;
  /** Reads a single `Workspace` using its globally unique `ID`. */
  workspaceByNodeId?: Maybe<Workspace>;
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** Reads a single `WorkspaceSubscription` using its globally unique `ID`. */
  workspaceSubscriptionByNodeId?: Maybe<WorkspaceSubscription>;
  workspaceSubscriptionBySubteamIdAndTeamId?: Maybe<WorkspaceSubscription>;
  workspaceSubscriptionByUserIdAndTeamId?: Maybe<WorkspaceSubscription>;
  /** Reads and enables pagination through a set of `WorkspaceSubscription`. */
  workspaceSubscriptions?: Maybe<WorkspaceSubscriptionsConnection>;
  /** Reads and enables pagination through a set of `Workspace`. */
  workspaces?: Maybe<WorkspacesConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAlreadyUsedTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAlreadyUsedTagsListArgs = {
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryArInternalMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ArInternalMetadatumCondition>;
  filter?: InputMaybe<ArInternalMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ArInternalMetadataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryArInternalMetadatumArgs = {
  key: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryArInternalMetadatumByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignPhaseArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignPhaseByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignPhaseLinkArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignPhaseLinkByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignPhaseLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignPhaseLinkCondition>;
  filter?: InputMaybe<CampaignPhaseLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignPhaseLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignPhasesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignPhaseCondition>;
  filter?: InputMaybe<CampaignPhaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignPhasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignQueryParamArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignQueryParamByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignQueryParamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignQueryParamCondition>;
  filter?: InputMaybe<CampaignQueryParamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignQueryParamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCoalesceAggSfuncArgs = {
  currentValue?: InputMaybe<Scalars['String']['input']>;
  reducedValue?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactByCrmIdAndTenantIdArgs = {
  crmId: Scalars['String']['input'];
  tenantId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactConsentArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactConsentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactConsentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactConsentCondition>;
  filter?: InputMaybe<CrmContactConsentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactMatchArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactMatchByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactPhaseMappingArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactPhaseMappingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactPhaseMappingByPhaseIdAndContactIdArgs = {
  contactId: Scalars['BigInt']['input'];
  phaseId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactPhaseMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactPhaseMappingCondition>;
  filter?: InputMaybe<CrmContactPhaseMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCrmContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactCondition>;
  filter?: InputMaybe<CrmContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDecodeBase64UrlSegmentArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentByFirestoreIdArgs = {
  firestoreId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentExpirationArgs = {
  documentId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentExpirationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentExpirationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentExpirationCondition>;
  filter?: InputMaybe<DocumentExpirationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentExpirationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentHistoryEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentHistoryEntryCondition>;
  filter?: InputMaybe<DocumentHistoryEntryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentHistoryEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentHistoryEntryArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentHistoryEntryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageByDocumentIdAndRevisionNumberAndPageNumberArgs = {
  documentId: Scalars['BigInt']['input'];
  pageNumber: Scalars['Int']['input'];
  revisionNumber: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageLinkArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageLinkByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageLinkCondition>;
  filter?: InputMaybe<DocumentPageLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageMatchingArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberArgs = {
  documentId: Scalars['BigInt']['input'];
  sourcePageNumber: Scalars['Int']['input'];
  sourceRevisionNumber: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberArgs = {
  documentId: Scalars['BigInt']['input'];
  targetPageNumber: Scalars['Int']['input'];
  targetRevisionNumber: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageMatchingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageMatchingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingCondition>;
  filter?: InputMaybe<DocumentPageMatchingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPageMatchingsBaksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageMatchingsBakCondition>;
  filter?: InputMaybe<DocumentPageMatchingsBakFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPageMatchingsBaksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentPagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentPageCondition>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentProcessArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentProcessByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentProcessCondition>;
  filter?: InputMaybe<DocumentProcessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentRevisionArgs = {
  documentId: Scalars['BigInt']['input'];
  revisionNumber: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentRevisionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentRevisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentRevisionCondition>;
  filter?: InputMaybe<DocumentRevisionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentRevisionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceAccessArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceAccessByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceAccessByUserIdAndDocumentSpaceIdArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceAccessesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceAccessCondition>;
  filter?: InputMaybe<DocumentSpaceAccessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceByCodeOnAccessCardArgs = {
  codeOnAccessCard: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigTranslationArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeArgs = {
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigTranslationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigTranslationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceConfigTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigTranslationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigCondition>;
  filter?: InputMaybe<DocumentSpaceConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceCrmMappingArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceCrmMappingByDocumentSpaceIdArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceCrmMappingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceCrmMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCrmMappingCondition>;
  filter?: InputMaybe<DocumentSpaceCrmMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceDetailStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceDetailStatisticCondition>;
  filter?: InputMaybe<DocumentSpaceDetailStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceDetailStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceDocStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceDocStatisticCondition>;
  filter?: InputMaybe<DocumentSpaceDocStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceDocStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceItemArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceItemByDocumentIdAndDocumentSpaceIdArgs = {
  documentId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
  sectionId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceItemByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceItemCondition>;
  filter?: InputMaybe<DocumentSpaceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkByPositionAndConfigIdArgs = {
  configId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkByPositionAndDocumentSpaceIdArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkGroupArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkGroupByTenantIdAndIdArgs = {
  id: Scalars['BigInt']['input'];
  tenantId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkGroupCondition>;
  filter?: InputMaybe<DocumentSpaceLinkGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkMappingArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkMappingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkMappingBySpaceIdAndLinkIdArgs = {
  linkId: Scalars['BigInt']['input'];
  spaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkMappingCondition>;
  filter?: InputMaybe<DocumentSpaceLinkMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkStatisticCondition>;
  filter?: InputMaybe<DocumentSpaceLinkStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkTranslationArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeArgs = {
  languageCode: Scalars['String']['input'];
  linkId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkTranslationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeArgs = {
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
  position: Scalars['BigFloat']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinkTranslationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkTranslationCondition>;
  filter?: InputMaybe<DocumentSpaceLinkTranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkCondition>;
  filter?: InputMaybe<DocumentSpaceLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpacePageStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpacePageStatisticCondition>;
  filter?: InputMaybe<DocumentSpacePageStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpacePageStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSectionArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSectionByDocumentSpaceIdAndPositionArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSectionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSectionByTitleAndDocumentSpaceIdArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  title: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceSectionCondition>;
  filter?: InputMaybe<DocumentSpaceSectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSessionArgs = {
  fingerprint: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSessionByFingerprintAndDocumentSpaceIdArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  fingerprint: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSessionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceSessionCondition>;
  filter?: InputMaybe<DocumentSpaceSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceSessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceStatisticCondition>;
  filter?: InputMaybe<DocumentSpaceStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceTagArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceTagByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceTagCondition>;
  filter?: InputMaybe<DocumentSpaceTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceVisitStatisticArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceVisitStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceVisitStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceVisitStatisticCondition>;
  filter?: InputMaybe<DocumentSpaceVisitStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceVisitStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceVoucherArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceVoucherByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpaceVouchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceVoucherCondition>;
  filter?: InputMaybe<DocumentSpaceVoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceVouchersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCondition>;
  filter?: InputMaybe<DocumentSpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentSpacesOldBaksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpacesOldBakCondition>;
  filter?: InputMaybe<DocumentSpacesOldBakFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpacesOldBaksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentStatisticCondition>;
  filter?: InputMaybe<DocumentStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUsageCountsArgs = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentCondition>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowItemArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowItemByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowItemCondition>;
  filter?: InputMaybe<FlowItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowSubscriptionArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowSubscriptionByFlowIdAndTeamIdArgs = {
  flowId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowSubscriptionByFlowIdAndUserIdArgs = {
  flowId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowSubscriptionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowSubscriptionCondition>;
  filter?: InputMaybe<FlowSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFlowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFtsSearchDocumentSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FtsDocumentSpaceHitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fragmentsDelimiter?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<FtsLanguage>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxFragments?: InputMaybe<Scalars['Int']['input']>;
  maxFragmentsMessage?: InputMaybe<Scalars['Int']['input']>;
  maxWords?: InputMaybe<Scalars['Int']['input']>;
  maxWordsMessage?: InputMaybe<Scalars['Int']['input']>;
  minWords?: InputMaybe<Scalars['Int']['input']>;
  minWordsMessage?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  searchPersonalMessage?: InputMaybe<Scalars['Boolean']['input']>;
  startSelection?: InputMaybe<Scalars['String']['input']>;
  stopSelection?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFtsSearchDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FtsDocumentHitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fragmentsDelimiter?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<FtsLanguage>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxFragments?: InputMaybe<Scalars['Int']['input']>;
  maxFragmentsPage?: InputMaybe<Scalars['Int']['input']>;
  maxWords?: InputMaybe<Scalars['Int']['input']>;
  maxWordsPage?: InputMaybe<Scalars['Int']['input']>;
  minWords?: InputMaybe<Scalars['Int']['input']>;
  minWordsPage?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  pageRelevanceFactor?: InputMaybe<Scalars['Float']['input']>;
  startSelection?: InputMaybe<Scalars['String']['input']>;
  stopSelection?: InputMaybe<Scalars['String']['input']>;
  tagRelevanceFactor?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFtsSearchFlowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FtsFlowHitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fragmentsDelimiter?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<FtsLanguage>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxFragments?: InputMaybe<Scalars['Int']['input']>;
  maxFragmentsPage?: InputMaybe<Scalars['Int']['input']>;
  maxWords?: InputMaybe<Scalars['Int']['input']>;
  maxWordsPage?: InputMaybe<Scalars['Int']['input']>;
  minWords?: InputMaybe<Scalars['Int']['input']>;
  minWordsPage?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  pageRelevanceFactor?: InputMaybe<Scalars['Float']['input']>;
  startSelection?: InputMaybe<Scalars['String']['input']>;
  stopSelection?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPagesOfSpaceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentPageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['BigInt']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRetentionPolicyForWorkspaceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GetRetentionPolicyForWorkspaceRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  wsId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuessLanguageArgs = {
  amongLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  inputText?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGuessLanguageDetailedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  amongLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GuessLanguageDetailedRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inputText?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInspectWorkspaceSerializationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InspectWorkspaceSerializationCondition>;
  filter?: InputMaybe<InspectWorkspaceSerializationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InspectWorkspaceSerializationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInternalIpAddressArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInternalIpAddressByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInternalIpAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InternalIpAddressCondition>;
  filter?: InputMaybe<InternalIpAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InternalIpAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsValidEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLabelsOfDocumentViewArgs = {
  documentViewId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLabelsOfDocumentViewByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLabelsOfDocumentViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LabelsOfDocumentViewCondition>;
  filter?: InputMaybe<LabelsOfDocumentViewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLanguageCodeArgs = {
  code: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLanguageCodeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLanguageCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LanguageCodeCondition>;
  filter?: InputMaybe<LanguageCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LanguageCodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLastCsvImportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LastCsvImportCondition>;
  filter?: InputMaybe<LastCsvImportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LastCsvImportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceDocumentStatisticArgs = {
  documentId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceDocumentStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceDocumentStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceDocumentStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceDocumentStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceDocumentStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceLinkStatisticArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
  url: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceLinkStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceLinkStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceLinkStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceLinkStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceLinkStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpacePageStatisticArgs = {
  documentId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
  pageNumber: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpacePageStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpacePageStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpacePageStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpacePageStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpacePageStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceStatisticArgs = {
  documentSpaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceVideoStatisticArgs = {
  documentId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceVideoStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceVideoStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceVideoStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceVideoStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceVideoStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceVisitsStatisticArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceVisitsStatisticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentSpaceVisitsStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentSpaceVisitsStatisticCondition>;
  filter?: InputMaybe<MaDocumentSpaceVisitsStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentSpaceVisitsStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaDocumentStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaDocumentStatisticCondition>;
  filter?: InputMaybe<MaDocumentStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaDocumentStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaGroupedDocumentSpaceVisitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MaGroupedDocumentSpaceVisitsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePreview?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tz?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaLatestSpaceVisitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MaLatestSpaceVisitsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePreview?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tz?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaLinkStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaLinkStatisticCondition>;
  filter?: InputMaybe<MaLinkStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaLinkStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaPageStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaPageStatisticCondition>;
  filter?: InputMaybe<MaPageStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaPageStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaSpaceUsageByTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaSpaceUsageByTeamCondition>;
  filter?: InputMaybe<MaSpaceUsageByTeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaSpaceUsageByTeamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaSpaceUsageByTeamsAndYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaSpaceUsageByTeamsAndYearCondition>;
  filter?: InputMaybe<MaSpaceUsageByTeamsAndYearFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaSpaceUsageByTeamsAndYearsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaUsageByTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaUsageByTeamCondition>;
  filter?: InputMaybe<MaUsageByTeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaUsageByTeamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaUsageByTeamsAllTimeMembershipAndYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaUsageByTeamsAllTimeMembershipAndYearCondition>;
  filter?: InputMaybe<MaUsageByTeamsAllTimeMembershipAndYearFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaUsageByTeamsAllTimeMembershipAndYearsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaUsageByTeamsAndYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaUsageByTeamsAndYearCondition>;
  filter?: InputMaybe<MaUsageByTeamsAndYearFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaUsageByTeamsAndYearsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMaVisitDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MaVisitDetailCondition>;
  filter?: InputMaybe<MaVisitDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaVisitDetailsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipBySubteamIdAndTeamIdArgs = {
  subteamId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipByUserIdAndTeamIdArgs = {
  teamId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyAccountArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyAdminTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyAdministratedDocumentSpaceIdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BigIntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyAdministratedTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyDocumentSpaceIdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BigIntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyEditableDocumentSpaceIdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BigIntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyFlowSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FlowSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyJoinableTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyOwnedDocumentSpaceIdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BigIntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTeamsByMembershipStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  myCurrentState?: InputMaybe<MembershipState>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyWorkspaceSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<WorkspaceSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNonSyncableWorkspacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NonSyncableWorkspaceCondition>;
  filter?: InputMaybe<NonSyncableWorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NonSyncableWorkspacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObsoleteUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObsoleteUserSubscriptionCondition>;
  filter?: InputMaybe<ObsoleteUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObsoleteUserSubscriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOldDocumentSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OldDocumentSpaceCondition>;
  filter?: InputMaybe<OldDocumentSpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OldDocumentSpacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreviewFlowShareToSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PreviewFlowShareToSpacesRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flowId?: InputMaybe<Scalars['BigInt']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<InputMaybe<IdsOfSpaceAndSectionInput>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRankedSearchCrmContactsByNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactMatchCondition>;
  filter?: InputMaybe<CrmContactMatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ifPronunciationIsSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  ifSpellingIsSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactMatchesOrderBy>>;
  term?: InputMaybe<Scalars['String']['input']>;
  thresholdForSpellingSimilarity?: InputMaybe<Scalars['Float']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRegistrationTokenArgs = {
  registrationToken: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRegistrationTokenByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRegistrationTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RegistrationTokenCondition>;
  filter?: InputMaybe<RegistrationTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistrationTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRetentionPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RetentionPolicyCondition>;
  filter?: InputMaybe<RetentionPolicyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRetentionPolicyArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRetentionPolicyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRetentionPolicyByTeamIdArgs = {
  teamId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRetentionPolicyByTenantIdArgs = {
  tenantId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRetentionPolicyByWorkspaceIdArgs = {
  workspaceId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationArgs = {
  version: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaMigrationCondition>;
  filter?: InputMaybe<SchemaMigrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchCrmContactsByNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactCondition>;
  filter?: InputMaybe<CrmContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ifPronunciationIsSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  ifSpellingIsSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactsOrderBy>>;
  term?: InputMaybe<Scalars['String']['input']>;
  thresholdForSpellingSimilarity?: InputMaybe<Scalars['Float']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchDocumentSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MatchingDocumentSpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MatchingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mustBeAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rootId?: InputMaybe<Scalars['BigInt']['input']>;
  shortenMatches?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySerializedWorkspacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SerializedWorkspaceCondition>;
  filter?: InputMaybe<SerializedWorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SerializedWorkspacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySettingArgs = {
  attribute: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySettingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SettingCondition>;
  filter?: InputMaybe<SettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShortenFullGroupNamesArgs = {
  groupNames: Array<InputMaybe<Scalars['String']['input']>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySpaceVisitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceVisitCondition>;
  filter?: InputMaybe<SpaceVisitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpaceVisitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTeamArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTeamByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TeamCondition>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTempContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TempContactCondition>;
  filter?: InputMaybe<TempContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TempContactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantCondition>;
  filter?: InputMaybe<TenantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUrlBasedDocumentImportArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUrlBasedDocumentImportByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUrlBasedDocumentImportSettingArgs = {
  documentId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUrlBasedDocumentImportSettingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUrlBasedDocumentImportSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UrlBasedDocumentImportSettingCondition>;
  filter?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUrlBasedDocumentImportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UrlBasedDocumentImportCondition>;
  filter?: InputMaybe<UrlBasedDocumentImportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContactDetailArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContactDetailByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContactDetailByUserIdArgs = {
  userId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContactDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContactDetailCondition>;
  filter?: InputMaybe<UserContactDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContactDetailsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserLicenseArgs = {
  orderId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserLicenseByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserLicenseCondition>;
  filter?: InputMaybe<UserLicenseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersByFlagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  anyOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  restrictToTeamsOfTenants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVeevaDocumentMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VeevaDocumentMetadatumCondition>;
  filter?: InputMaybe<VeevaDocumentMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VeevaDocumentMetadataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVeevaDocumentMetadatumArgs = {
  documentId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVeevaDocumentMetadatumByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceByFirebaseIdArgs = {
  firebaseId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceSubscriptionArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceSubscriptionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceSubscriptionBySubteamIdAndTeamIdArgs = {
  subteamId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceSubscriptionByUserIdAndTeamIdArgs = {
  teamId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspaceSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceSubscriptionCondition>;
  filter?: InputMaybe<WorkspaceSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkspacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceCondition>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

export type RegistrationToken = Node & {
  __typename?: 'RegistrationToken';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  registrationToken: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `RegistrationToken`. */
  user?: Maybe<User>;
  userId: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `RegistrationToken` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RegistrationTokenCondition = {
  /** Checks for equality with the object’s `registrationToken` field. */
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `RegistrationToken` object types. All fields are combined with a logical ‘and.’ */
export type RegistrationTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RegistrationTokenFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<RegistrationTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RegistrationTokenFilter>>;
  /** Filter by the object’s `registrationToken` field. */
  registrationToken?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `RegistrationToken` */
export type RegistrationTokenInput = {
  registrationToken: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['BigInt']['input'];
};

/** Represents an update to a `RegistrationToken`. Fields that are set will be updated. */
export type RegistrationTokenPatch = {
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `RegistrationToken` values. */
export type RegistrationTokensConnection = {
  __typename?: 'RegistrationTokensConnection';
  /** A list of edges which contains the `RegistrationToken` and cursor to aid in pagination. */
  edges: Array<RegistrationTokensEdge>;
  /** A list of `RegistrationToken` objects. */
  nodes: Array<Maybe<RegistrationToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RegistrationToken` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RegistrationToken` edge in the connection. */
export type RegistrationTokensEdge = {
  __typename?: 'RegistrationTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RegistrationToken` at the end of the edge. */
  node?: Maybe<RegistrationToken>;
};

/** Methods to use when ordering `RegistrationToken`. */
export enum RegistrationTokensOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegistrationTokenAsc = 'REGISTRATION_TOKEN_ASC',
  RegistrationTokenDesc = 'REGISTRATION_TOKEN_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `RetentionPolicy` values. */
export type RetentionPoliciesConnection = {
  __typename?: 'RetentionPoliciesConnection';
  /** A list of edges which contains the `RetentionPolicy` and cursor to aid in pagination. */
  edges: Array<RetentionPoliciesEdge>;
  /** A list of `RetentionPolicy` objects. */
  nodes: Array<Maybe<RetentionPolicy>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RetentionPolicy` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RetentionPolicy` edge in the connection. */
export type RetentionPoliciesEdge = {
  __typename?: 'RetentionPoliciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RetentionPolicy` at the end of the edge. */
  node?: Maybe<RetentionPolicy>;
};

/** Methods to use when ordering `RetentionPolicy`. */
export enum RetentionPoliciesOrderBy {
  AutoExpireLocalUploadsDaysAsc = 'AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_ASC',
  AutoExpireLocalUploadsDaysDesc = 'AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExpiryDateEditableAsc = 'EXPIRY_DATE_EDITABLE_ASC',
  ExpiryDateEditableDesc = 'EXPIRY_DATE_EDITABLE_DESC',
  GracePeriodDaysAsc = 'GRACE_PERIOD_DAYS_ASC',
  GracePeriodDaysDesc = 'GRACE_PERIOD_DAYS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TeamByTeamIdAnalyticsAliasAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamByTeamIdAnalyticsAliasDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamByTeamIdAnalyticsEnabledAsc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamByTeamIdAnalyticsEnabledDesc = 'TEAM_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamByTeamIdCreatedAtAsc = 'TEAM_BY_TEAM_ID__CREATED_AT_ASC',
  TeamByTeamIdCreatedAtDesc = 'TEAM_BY_TEAM_ID__CREATED_AT_DESC',
  TeamByTeamIdFlagsAsc = 'TEAM_BY_TEAM_ID__FLAGS_ASC',
  TeamByTeamIdFlagsDesc = 'TEAM_BY_TEAM_ID__FLAGS_DESC',
  TeamByTeamIdIdAsc = 'TEAM_BY_TEAM_ID__ID_ASC',
  TeamByTeamIdIdDesc = 'TEAM_BY_TEAM_ID__ID_DESC',
  TeamByTeamIdIsOpenAsc = 'TEAM_BY_TEAM_ID__IS_OPEN_ASC',
  TeamByTeamIdIsOpenDesc = 'TEAM_BY_TEAM_ID__IS_OPEN_DESC',
  TeamByTeamIdIsVisibleAsc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_ASC',
  TeamByTeamIdIsVisibleDesc = 'TEAM_BY_TEAM_ID__IS_VISIBLE_DESC',
  TeamByTeamIdMemberCountAsc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_ASC',
  TeamByTeamIdMemberCountDesc = 'TEAM_BY_TEAM_ID__MEMBER_COUNT_DESC',
  TeamByTeamIdNameAsc = 'TEAM_BY_TEAM_ID__NAME_ASC',
  TeamByTeamIdNameDesc = 'TEAM_BY_TEAM_ID__NAME_DESC',
  TeamByTeamIdNameLowercaseAsc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  TeamByTeamIdNameLowercaseDesc = 'TEAM_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  TeamByTeamIdSysPeriodAsc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_ASC',
  TeamByTeamIdSysPeriodDesc = 'TEAM_BY_TEAM_ID__SYS_PERIOD_DESC',
  TeamByTeamIdTenantIdAsc = 'TEAM_BY_TEAM_ID__TENANT_ID_ASC',
  TeamByTeamIdTenantIdDesc = 'TEAM_BY_TEAM_ID__TENANT_ID_DESC',
  TeamByTeamIdTotalMemberCountAsc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamByTeamIdTotalMemberCountDesc = 'TEAM_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamByTeamIdUpdatedAtAsc = 'TEAM_BY_TEAM_ID__UPDATED_AT_ASC',
  TeamByTeamIdUpdatedAtDesc = 'TEAM_BY_TEAM_ID__UPDATED_AT_DESC',
  TeamByTeamIdUserConfigDefaultsAsc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamByTeamIdUserConfigDefaultsDesc = 'TEAM_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WorkspaceByWorkspaceIdAnalyticsAliasAsc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByWorkspaceIdAnalyticsAliasDesc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByWorkspaceIdAnalyticsEnabledAsc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByWorkspaceIdAnalyticsEnabledDesc = 'WORKSPACE_BY_WORKSPACE_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByWorkspaceIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByWorkspaceIdConfigAsc = 'WORKSPACE_BY_WORKSPACE_ID__CONFIG_ASC',
  WorkspaceByWorkspaceIdConfigDesc = 'WORKSPACE_BY_WORKSPACE_ID__CONFIG_DESC',
  WorkspaceByWorkspaceIdCreatedAtAsc = 'WORKSPACE_BY_WORKSPACE_ID__CREATED_AT_ASC',
  WorkspaceByWorkspaceIdCreatedAtDesc = 'WORKSPACE_BY_WORKSPACE_ID__CREATED_AT_DESC',
  WorkspaceByWorkspaceIdCustomBrandUrlAsc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByWorkspaceIdCustomBrandUrlDesc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByWorkspaceIdCustomShareLinkAsc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByWorkspaceIdCustomShareLinkDesc = 'WORKSPACE_BY_WORKSPACE_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByWorkspaceIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByWorkspaceIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByWorkspaceIdEmailSubjectAsc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByWorkspaceIdEmailSubjectDesc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByWorkspaceIdEmailTextAsc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_TEXT_ASC',
  WorkspaceByWorkspaceIdEmailTextDesc = 'WORKSPACE_BY_WORKSPACE_ID__EMAIL_TEXT_DESC',
  WorkspaceByWorkspaceIdFirebaseIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__FIREBASE_ID_ASC',
  WorkspaceByWorkspaceIdFirebaseIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__FIREBASE_ID_DESC',
  WorkspaceByWorkspaceIdFlagsAsc = 'WORKSPACE_BY_WORKSPACE_ID__FLAGS_ASC',
  WorkspaceByWorkspaceIdFlagsDesc = 'WORKSPACE_BY_WORKSPACE_ID__FLAGS_DESC',
  WorkspaceByWorkspaceIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByWorkspaceIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByWorkspaceIdIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__ID_ASC',
  WorkspaceByWorkspaceIdIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__ID_DESC',
  WorkspaceByWorkspaceIdIsOpenAsc = 'WORKSPACE_BY_WORKSPACE_ID__IS_OPEN_ASC',
  WorkspaceByWorkspaceIdIsOpenDesc = 'WORKSPACE_BY_WORKSPACE_ID__IS_OPEN_DESC',
  WorkspaceByWorkspaceIdIsVisibleAsc = 'WORKSPACE_BY_WORKSPACE_ID__IS_VISIBLE_ASC',
  WorkspaceByWorkspaceIdIsVisibleDesc = 'WORKSPACE_BY_WORKSPACE_ID__IS_VISIBLE_DESC',
  WorkspaceByWorkspaceIdLaserPointerPositionAsc = 'WORKSPACE_BY_WORKSPACE_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByWorkspaceIdLaserPointerPositionDesc = 'WORKSPACE_BY_WORKSPACE_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByWorkspaceIdLinkPanelPositionAsc = 'WORKSPACE_BY_WORKSPACE_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByWorkspaceIdLinkPanelPositionDesc = 'WORKSPACE_BY_WORKSPACE_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByWorkspaceIdMemberCountAsc = 'WORKSPACE_BY_WORKSPACE_ID__MEMBER_COUNT_ASC',
  WorkspaceByWorkspaceIdMemberCountDesc = 'WORKSPACE_BY_WORKSPACE_ID__MEMBER_COUNT_DESC',
  WorkspaceByWorkspaceIdNameAsc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_ASC',
  WorkspaceByWorkspaceIdNameDesc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_DESC',
  WorkspaceByWorkspaceIdNameLowercaseAsc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_LOWERCASE_ASC',
  WorkspaceByWorkspaceIdNameLowercaseDesc = 'WORKSPACE_BY_WORKSPACE_ID__NAME_LOWERCASE_DESC',
  WorkspaceByWorkspaceIdParentIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__PARENT_ID_ASC',
  WorkspaceByWorkspaceIdParentIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__PARENT_ID_DESC',
  WorkspaceByWorkspaceIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByWorkspaceIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByWorkspaceIdSysPeriodAsc = 'WORKSPACE_BY_WORKSPACE_ID__SYS_PERIOD_ASC',
  WorkspaceByWorkspaceIdSysPeriodDesc = 'WORKSPACE_BY_WORKSPACE_ID__SYS_PERIOD_DESC',
  WorkspaceByWorkspaceIdTagsAsc = 'WORKSPACE_BY_WORKSPACE_ID__TAGS_ASC',
  WorkspaceByWorkspaceIdTagsDesc = 'WORKSPACE_BY_WORKSPACE_ID__TAGS_DESC',
  WorkspaceByWorkspaceIdTeamRankAsc = 'WORKSPACE_BY_WORKSPACE_ID__TEAM_RANK_ASC',
  WorkspaceByWorkspaceIdTeamRankDesc = 'WORKSPACE_BY_WORKSPACE_ID__TEAM_RANK_DESC',
  WorkspaceByWorkspaceIdTenantIdAsc = 'WORKSPACE_BY_WORKSPACE_ID__TENANT_ID_ASC',
  WorkspaceByWorkspaceIdTenantIdDesc = 'WORKSPACE_BY_WORKSPACE_ID__TENANT_ID_DESC',
  WorkspaceByWorkspaceIdTotalMemberCountAsc = 'WORKSPACE_BY_WORKSPACE_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByWorkspaceIdTotalMemberCountDesc = 'WORKSPACE_BY_WORKSPACE_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByWorkspaceIdUpdatedAtAsc = 'WORKSPACE_BY_WORKSPACE_ID__UPDATED_AT_ASC',
  WorkspaceByWorkspaceIdUpdatedAtDesc = 'WORKSPACE_BY_WORKSPACE_ID__UPDATED_AT_DESC',
  WorkspaceByWorkspaceIdUserConfigDefaultsAsc = 'WORKSPACE_BY_WORKSPACE_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByWorkspaceIdUserConfigDefaultsDesc = 'WORKSPACE_BY_WORKSPACE_ID__USER_CONFIG_DEFAULTS_DESC',
  WorkspaceIdAsc = 'WORKSPACE_ID_ASC',
  WorkspaceIdDesc = 'WORKSPACE_ID_DESC'
}

export type RetentionPolicy = Node & {
  __typename?: 'RetentionPolicy';
  autoExpireLocalUploadsDays?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  expiryDateEditable: Scalars['Boolean']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Team` that is related to this `RetentionPolicy`. */
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Tenant` that is related to this `RetentionPolicy`. */
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Workspace` that is related to this `RetentionPolicy`. */
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `RetentionPolicy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RetentionPolicyCondition = {
  /** Checks for equality with the object’s `autoExpireLocalUploadsDays` field. */
  autoExpireLocalUploadsDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `expiryDateEditable` field. */
  expiryDateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `gracePeriodDays` field. */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `RetentionPolicy` object types. All fields are combined with a logical ‘and.’ */
export type RetentionPolicyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RetentionPolicyFilter>>;
  /** Filter by the object’s `autoExpireLocalUploadsDays` field. */
  autoExpireLocalUploadsDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `expiryDateEditable` field. */
  expiryDateEditable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `gracePeriodDays` field. */
  gracePeriodDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RetentionPolicyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RetentionPolicyFilter>>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<TeamFilter>;
  /** A related `team` exists. */
  teamExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** A related `tenant` exists. */
  tenantExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `workspace` relation. */
  workspace?: InputMaybe<WorkspaceFilter>;
  /** A related `workspace` exists. */
  workspaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspaceId` field. */
  workspaceId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `RetentionPolicy` */
export type RetentionPolicyInput = {
  autoExpireLocalUploadsDays?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiryDateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `RetentionPolicy`. Fields that are set will be updated. */
export type RetentionPolicyPatch = {
  autoExpireLocalUploadsDays?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiryDateEditable?: InputMaybe<Scalars['Boolean']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  workspaceId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type SchemaMigration = Node & {
  __typename?: 'SchemaMigration';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

/**
 * A condition to be used against `SchemaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SchemaMigrationCondition = {
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `SchemaMigration` object types. All fields are combined with a logical ‘and.’ */
export type SchemaMigrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SchemaMigrationFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<SchemaMigrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SchemaMigrationFilter>>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SchemaMigration` */
export type SchemaMigrationInput = {
  version: Scalars['String']['input'];
};

/** Represents an update to a `SchemaMigration`. Fields that are set will be updated. */
export type SchemaMigrationPatch = {
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `SchemaMigration` values. */
export type SchemaMigrationsConnection = {
  __typename?: 'SchemaMigrationsConnection';
  /** A list of edges which contains the `SchemaMigration` and cursor to aid in pagination. */
  edges: Array<SchemaMigrationsEdge>;
  /** A list of `SchemaMigration` objects. */
  nodes: Array<Maybe<SchemaMigration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SchemaMigration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SchemaMigration` edge in the connection. */
export type SchemaMigrationsEdge = {
  __typename?: 'SchemaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SchemaMigration` at the end of the edge. */
  node?: Maybe<SchemaMigration>;
};

/** Methods to use when ordering `SchemaMigration`. */
export enum SchemaMigrationsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

export type SerializedWorkspace = {
  __typename?: 'SerializedWorkspace';
  countOfMembers?: Maybe<Scalars['BigInt']['output']>;
  firebaseId?: Maybe<Scalars['String']['output']>;
  flattened?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `SerializedWorkspace` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SerializedWorkspaceCondition = {
  /** Checks for equality with the object’s `countOfMembers` field. */
  countOfMembers?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flattened` field. */
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `SerializedWorkspace` object types. All fields are combined with a logical ‘and.’ */
export type SerializedWorkspaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SerializedWorkspaceFilter>>;
  /** Filter by the object’s `countOfMembers` field. */
  countOfMembers?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SerializedWorkspaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SerializedWorkspaceFilter>>;
};

/** An input for mutations affecting `SerializedWorkspace` */
export type SerializedWorkspaceInput = {
  countOfMembers?: InputMaybe<Scalars['BigInt']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  flattened?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `SerializedWorkspace` values. */
export type SerializedWorkspacesConnection = {
  __typename?: 'SerializedWorkspacesConnection';
  /** A list of edges which contains the `SerializedWorkspace` and cursor to aid in pagination. */
  edges: Array<SerializedWorkspacesEdge>;
  /** A list of `SerializedWorkspace` objects. */
  nodes: Array<Maybe<SerializedWorkspace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SerializedWorkspace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SerializedWorkspace` edge in the connection. */
export type SerializedWorkspacesEdge = {
  __typename?: 'SerializedWorkspacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SerializedWorkspace` at the end of the edge. */
  node?: Maybe<SerializedWorkspace>;
};

/** Methods to use when ordering `SerializedWorkspace`. */
export enum SerializedWorkspacesOrderBy {
  CountOfMembersAsc = 'COUNT_OF_MEMBERS_ASC',
  CountOfMembersDesc = 'COUNT_OF_MEMBERS_DESC',
  FirebaseIdAsc = 'FIREBASE_ID_ASC',
  FirebaseIdDesc = 'FIREBASE_ID_DESC',
  FlattenedAsc = 'FLATTENED_ASC',
  FlattenedDesc = 'FLATTENED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL'
}

/** All input for the `setRegistrationToken` mutation. */
export type SetRegistrationTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** The output of our `setRegistrationToken` mutation. */
export type SetRegistrationTokenPayload = {
  __typename?: 'SetRegistrationTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Setting = Node & {
  __typename?: 'Setting';
  attribute: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  setting?: Maybe<Scalars['String']['output']>;
};

/** A condition to be used against `Setting` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SettingCondition = {
  /** Checks for equality with the object’s `attribute` field. */
  attribute?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `setting` field. */
  setting?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Setting` object types. All fields are combined with a logical ‘and.’ */
export type SettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SettingFilter>>;
  /** Filter by the object’s `attribute` field. */
  attribute?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SettingFilter>>;
  /** Filter by the object’s `setting` field. */
  setting?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Setting` */
export type SettingInput = {
  attribute: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `Setting`. Fields that are set will be updated. */
export type SettingPatch = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  setting?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Setting` values. */
export type SettingsConnection = {
  __typename?: 'SettingsConnection';
  /** A list of edges which contains the `Setting` and cursor to aid in pagination. */
  edges: Array<SettingsEdge>;
  /** A list of `Setting` objects. */
  nodes: Array<Maybe<Setting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Setting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Setting` edge in the connection. */
export type SettingsEdge = {
  __typename?: 'SettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Setting` at the end of the edge. */
  node?: Maybe<Setting>;
};

/** Methods to use when ordering `Setting`. */
export enum SettingsOrderBy {
  AttributeAsc = 'ATTRIBUTE_ASC',
  AttributeDesc = 'ATTRIBUTE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SettingAsc = 'SETTING_ASC',
  SettingDesc = 'SETTING_DESC'
}

export enum SpaceCondition {
  Invited = 'INVITED',
  Visited = 'VISITED'
}

export enum SpaceItemMoveType {
  After = 'AFTER',
  Before = 'BEFORE'
}

export enum SpaceSectionDragType {
  After = 'AFTER',
  Before = 'BEFORE'
}

export enum SpaceSectionMoveType {
  Down = 'DOWN',
  Up = 'UP'
}

export type SpaceVisit = {
  __typename?: 'SpaceVisit';
  clientHash?: Maybe<Scalars['String']['output']>;
  documentSpaceId?: Maybe<Scalars['BigInt']['output']>;
  duration?: Maybe<Interval>;
  endsAt?: Maybe<Scalars['Datetime']['output']>;
  extension?: Maybe<DatetimeRange>;
  id?: Maybe<Scalars['BigInt']['output']>;
  interactions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `SpaceVisit` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SpaceVisitCondition = {
  /** Checks for equality with the object’s `clientHash` field. */
  clientHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `extension` field. */
  extension?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `interactions` field. */
  interactions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `isPreview` field. */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SpaceVisit` object types. All fields are combined with a logical ‘and.’ */
export type SpaceVisitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpaceVisitFilter>>;
  /** Filter by the object’s `clientHash` field. */
  clientHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentSpaceId` field. */
  documentSpaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `extension` field. */
  extension?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `interactions` field. */
  interactions?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `isPreview` field. */
  isPreview?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpaceVisitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpaceVisitFilter>>;
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `SpaceVisit` values. */
export type SpaceVisitsConnection = {
  __typename?: 'SpaceVisitsConnection';
  /** A list of edges which contains the `SpaceVisit` and cursor to aid in pagination. */
  edges: Array<SpaceVisitsEdge>;
  /** A list of `SpaceVisit` objects. */
  nodes: Array<Maybe<SpaceVisit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpaceVisit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SpaceVisit` edge in the connection. */
export type SpaceVisitsEdge = {
  __typename?: 'SpaceVisitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SpaceVisit` at the end of the edge. */
  node?: Maybe<SpaceVisit>;
};

/** Methods to use when ordering `SpaceVisit`. */
export enum SpaceVisitsOrderBy {
  ClientHashAsc = 'CLIENT_HASH_ASC',
  ClientHashDesc = 'CLIENT_HASH_DESC',
  DocumentSpaceIdAsc = 'DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceIdDesc = 'DOCUMENT_SPACE_ID_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  ExtensionAsc = 'EXTENSION_ASC',
  ExtensionDesc = 'EXTENSION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InteractionsAsc = 'INTERACTIONS_ASC',
  InteractionsDesc = 'INTERACTIONS_DESC',
  IsPreviewAsc = 'IS_PREVIEW_ASC',
  IsPreviewDesc = 'IS_PREVIEW_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Team = Node & {
  __typename?: 'Team';
  analyticsAlias: Scalars['String']['output'];
  analyticsEnabled: Scalars['Boolean']['output'];
  assignIfExternalGroupsMatchAllOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignIfExternalGroupsMatchOneOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Reads and enables pagination through a set of `Campaign`. */
  campaigns: CampaignsConnection;
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `DocumentSpaceConfig`. */
  documentSpaceConfigs: DocumentSpaceConfigsConnection;
  flags: Array<Maybe<Scalars['String']['output']>>;
  /** Reads and enables pagination through a set of `FlowSubscription`. */
  flowSubscriptions: FlowSubscriptionsConnection;
  id: Scalars['BigInt']['output'];
  isOpen: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  isWorkspace?: Maybe<Scalars['Boolean']['output']>;
  memberCount?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships: MembershipsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  membershipsBySubteamId: MembershipsConnection;
  myMembership?: Maybe<Membership>;
  name: Scalars['String']['output'];
  nameLowercase?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  /**
   * Reads and enables pagination through a set of `RetentionPolicy`.
   * @deprecated Please use retentionPolicy instead
   */
  retentionPolicies: RetentionPoliciesConnection;
  /** Reads a single `RetentionPolicy` that is related to this `Team`. */
  retentionPolicy?: Maybe<RetentionPolicy>;
  sysPeriod: DatetimeRange;
  /** Reads a single `Tenant` that is related to this `Team`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  totalMemberCount?: Maybe<Scalars['BigInt']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userConfigDefaults: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `WorkspaceSubscription`. */
  workspaceSubscriptionsBySubteamId: WorkspaceSubscriptionsConnection;
};


export type TeamCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CampaignCondition>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};


export type TeamDocumentSpaceConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigCondition>;
  filter?: InputMaybe<DocumentSpaceConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};


export type TeamFlowSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowSubscriptionCondition>;
  filter?: InputMaybe<FlowSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};


export type TeamMemberCountArgs = {
  sumMembersOfSubteams?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TeamMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type TeamMembershipsBySubteamIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type TeamNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type TeamRetentionPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RetentionPolicyCondition>;
  filter?: InputMaybe<RetentionPolicyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};


export type TeamWorkspaceSubscriptionsBySubteamIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceSubscriptionCondition>;
  filter?: InputMaybe<WorkspaceSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

/** A condition to be used against `Team` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TeamCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `analyticsEnabled` field. */
  analyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `assignIfExternalGroupsMatchAllOf` field. */
  assignIfExternalGroupsMatchAllOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `assignIfExternalGroupsMatchOneOf` field. */
  assignIfExternalGroupsMatchOneOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `flags` field. */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isOpen` field. */
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isVisible` field. */
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `memberCount` field. */
  memberCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nameLowercase` field. */
  nameLowercase?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalMemberCount` field. */
  totalMemberCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userConfigDefaults` field. */
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `Team` object types. All fields are combined with a logical ‘and.’ */
export type TeamFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Filter by the object’s `analyticsEnabled` field. */
  analyticsEnabled?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TeamFilter>>;
  /** Filter by the object’s `assignIfExternalGroupsMatchAllOf` field. */
  assignIfExternalGroupsMatchAllOf?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `assignIfExternalGroupsMatchOneOf` field. */
  assignIfExternalGroupsMatchOneOf?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `campaigns` relation. */
  campaigns?: InputMaybe<TeamToManyCampaignFilter>;
  /** Some related `campaigns` exist. */
  campaignsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentSpaceConfigs` relation. */
  documentSpaceConfigs?: InputMaybe<TeamToManyDocumentSpaceConfigFilter>;
  /** Some related `documentSpaceConfigs` exist. */
  documentSpaceConfigsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flags` field. */
  flags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `flowSubscriptions` relation. */
  flowSubscriptions?: InputMaybe<TeamToManyFlowSubscriptionFilter>;
  /** Some related `flowSubscriptions` exist. */
  flowSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isOpen` field. */
  isOpen?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isVisible` field. */
  isVisible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isWorkspace` field. */
  isWorkspace?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `memberCount` field. */
  memberCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `memberships` relation. */
  memberships?: InputMaybe<TeamToManyMembershipFilter>;
  /** Filter by the object’s `membershipsBySubteamId` relation. */
  membershipsBySubteamId?: InputMaybe<TeamToManyMembershipFilter>;
  /** Some related `membershipsBySubteamId` exist. */
  membershipsBySubteamIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `memberships` exist. */
  membershipsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLowercase` field. */
  nameLowercase?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TeamFilter>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<TeamToManyNotificationFilter>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TeamFilter>>;
  /** Filter by the object’s `retentionPolicy` relation. */
  retentionPolicy?: InputMaybe<RetentionPolicyFilter>;
  /** A related `retentionPolicy` exists. */
  retentionPolicyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalMemberCount` field. */
  totalMemberCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userConfigDefaults` field. */
  userConfigDefaults?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `workspaceSubscriptionsBySubteamId` relation. */
  workspaceSubscriptionsBySubteamId?: InputMaybe<TeamToManyWorkspaceSubscriptionFilter>;
  /** Some related `workspaceSubscriptionsBySubteamId` exist. */
  workspaceSubscriptionsBySubteamIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `Team` */
export type TeamInput = {
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  analyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assignIfExternalGroupsMatchAllOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignIfExternalGroupsMatchOneOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameLowercase?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `Team`. Fields that are set will be updated. */
export type TeamPatch = {
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  analyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assignIfExternalGroupsMatchAllOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignIfExternalGroupsMatchOneOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameLowercase?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against many `Campaign` object types. All fields are combined with a logical ‘and.’ */
export type TeamToManyCampaignFilter = {
  /** Every related `Campaign` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CampaignFilter>;
  /** No related `Campaign` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CampaignFilter>;
  /** Some related `Campaign` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CampaignFilter>;
};

/** A filter to be used against many `DocumentSpaceConfig` object types. All fields are combined with a logical ‘and.’ */
export type TeamToManyDocumentSpaceConfigFilter = {
  /** Every related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigFilter>;
  /** No related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigFilter>;
  /** Some related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigFilter>;
};

/** A filter to be used against many `FlowSubscription` object types. All fields are combined with a logical ‘and.’ */
export type TeamToManyFlowSubscriptionFilter = {
  /** Every related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowSubscriptionFilter>;
  /** No related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowSubscriptionFilter>;
  /** Some related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowSubscriptionFilter>;
};

/** A filter to be used against many `Membership` object types. All fields are combined with a logical ‘and.’ */
export type TeamToManyMembershipFilter = {
  /** Every related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipFilter>;
  /** No related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipFilter>;
  /** Some related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type TeamToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `WorkspaceSubscription` object types. All fields are combined with a logical ‘and.’ */
export type TeamToManyWorkspaceSubscriptionFilter = {
  /** Every related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** No related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** Some related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceSubscriptionFilter>;
};

/** A connection to a list of `Team` values. */
export type TeamsConnection = {
  __typename?: 'TeamsConnection';
  /** A list of edges which contains the `Team` and cursor to aid in pagination. */
  edges: Array<TeamsEdge>;
  /** A list of `Team` objects. */
  nodes: Array<Maybe<Team>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Team` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Team` edge in the connection. */
export type TeamsEdge = {
  __typename?: 'TeamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Team` at the end of the edge. */
  node?: Maybe<Team>;
};

/** Methods to use when ordering `Team`. */
export enum TeamsOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  AnalyticsEnabledAsc = 'ANALYTICS_ENABLED_ASC',
  AnalyticsEnabledDesc = 'ANALYTICS_ENABLED_DESC',
  AssignIfExternalGroupsMatchAllOfAsc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  AssignIfExternalGroupsMatchAllOfDesc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  AssignIfExternalGroupsMatchOneOfAsc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  AssignIfExternalGroupsMatchOneOfDesc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  CampaignsByTeamIdCountAsc = 'CAMPAIGNS_BY_TEAM_ID__COUNT_ASC',
  CampaignsByTeamIdCountDesc = 'CAMPAIGNS_BY_TEAM_ID__COUNT_DESC',
  CampaignsByTeamIdMaxCreatedAtAsc = 'CAMPAIGNS_BY_TEAM_ID__MAX_CREATED_AT_ASC',
  CampaignsByTeamIdMaxCreatedAtDesc = 'CAMPAIGNS_BY_TEAM_ID__MAX_CREATED_AT_DESC',
  CampaignsByTeamIdMaxIdAsc = 'CAMPAIGNS_BY_TEAM_ID__MAX_ID_ASC',
  CampaignsByTeamIdMaxIdDesc = 'CAMPAIGNS_BY_TEAM_ID__MAX_ID_DESC',
  CampaignsByTeamIdMaxIsValidAsc = 'CAMPAIGNS_BY_TEAM_ID__MAX_IS_VALID_ASC',
  CampaignsByTeamIdMaxIsValidDesc = 'CAMPAIGNS_BY_TEAM_ID__MAX_IS_VALID_DESC',
  CampaignsByTeamIdMaxNameAsc = 'CAMPAIGNS_BY_TEAM_ID__MAX_NAME_ASC',
  CampaignsByTeamIdMaxNameDesc = 'CAMPAIGNS_BY_TEAM_ID__MAX_NAME_DESC',
  CampaignsByTeamIdMaxTeamIdAsc = 'CAMPAIGNS_BY_TEAM_ID__MAX_TEAM_ID_ASC',
  CampaignsByTeamIdMaxTeamIdDesc = 'CAMPAIGNS_BY_TEAM_ID__MAX_TEAM_ID_DESC',
  CampaignsByTeamIdMinCreatedAtAsc = 'CAMPAIGNS_BY_TEAM_ID__MIN_CREATED_AT_ASC',
  CampaignsByTeamIdMinCreatedAtDesc = 'CAMPAIGNS_BY_TEAM_ID__MIN_CREATED_AT_DESC',
  CampaignsByTeamIdMinIdAsc = 'CAMPAIGNS_BY_TEAM_ID__MIN_ID_ASC',
  CampaignsByTeamIdMinIdDesc = 'CAMPAIGNS_BY_TEAM_ID__MIN_ID_DESC',
  CampaignsByTeamIdMinIsValidAsc = 'CAMPAIGNS_BY_TEAM_ID__MIN_IS_VALID_ASC',
  CampaignsByTeamIdMinIsValidDesc = 'CAMPAIGNS_BY_TEAM_ID__MIN_IS_VALID_DESC',
  CampaignsByTeamIdMinNameAsc = 'CAMPAIGNS_BY_TEAM_ID__MIN_NAME_ASC',
  CampaignsByTeamIdMinNameDesc = 'CAMPAIGNS_BY_TEAM_ID__MIN_NAME_DESC',
  CampaignsByTeamIdMinTeamIdAsc = 'CAMPAIGNS_BY_TEAM_ID__MIN_TEAM_ID_ASC',
  CampaignsByTeamIdMinTeamIdDesc = 'CAMPAIGNS_BY_TEAM_ID__MIN_TEAM_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentSpaceConfigsByTeamIdCountAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__COUNT_ASC',
  DocumentSpaceConfigsByTeamIdCountDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__COUNT_DESC',
  DocumentSpaceConfigsByTeamIdMaxContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByTeamIdMaxContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByTeamIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigsByTeamIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigsByTeamIdMaxCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByTeamIdMaxCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByTeamIdMaxDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByTeamIdMaxDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByTeamIdMaxDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByTeamIdMaxDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByTeamIdMaxDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByTeamIdMaxDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByTeamIdMaxDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByTeamIdMaxDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByTeamIdMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByTeamIdMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByTeamIdMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByTeamIdMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByTeamIdMaxGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_GROUP_ID_ASC',
  DocumentSpaceConfigsByTeamIdMaxGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_GROUP_ID_DESC',
  DocumentSpaceConfigsByTeamIdMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByTeamIdMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByTeamIdMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByTeamIdMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByTeamIdMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByTeamIdMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByTeamIdMaxHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_SCALING_ASC',
  DocumentSpaceConfigsByTeamIdMaxHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_SCALING_DESC',
  DocumentSpaceConfigsByTeamIdMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByTeamIdMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByTeamIdMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigsByTeamIdMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigsByTeamIdMaxIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_ID_ASC',
  DocumentSpaceConfigsByTeamIdMaxIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_ID_DESC',
  DocumentSpaceConfigsByTeamIdMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByTeamIdMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByTeamIdMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByTeamIdMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByTeamIdMaxLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByTeamIdMaxLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByTeamIdMaxLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByTeamIdMaxLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByTeamIdMaxLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LOGO_URL_ASC',
  DocumentSpaceConfigsByTeamIdMaxLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_LOGO_URL_DESC',
  DocumentSpaceConfigsByTeamIdMaxNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_NAME_ASC',
  DocumentSpaceConfigsByTeamIdMaxNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_NAME_DESC',
  DocumentSpaceConfigsByTeamIdMaxNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_NEW_TAB_ASC',
  DocumentSpaceConfigsByTeamIdMaxNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_NEW_TAB_DESC',
  DocumentSpaceConfigsByTeamIdMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByTeamIdMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByTeamIdMaxProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByTeamIdMaxProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByTeamIdMaxRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByTeamIdMaxRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByTeamIdMaxStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_STYLESHEET_ASC',
  DocumentSpaceConfigsByTeamIdMaxStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_STYLESHEET_DESC',
  DocumentSpaceConfigsByTeamIdMaxTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TEAM_ID_ASC',
  DocumentSpaceConfigsByTeamIdMaxTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TEAM_ID_DESC',
  DocumentSpaceConfigsByTeamIdMaxTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TEMPLATE_ASC',
  DocumentSpaceConfigsByTeamIdMaxTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TEMPLATE_DESC',
  DocumentSpaceConfigsByTeamIdMaxTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TENANT_ID_ASC',
  DocumentSpaceConfigsByTeamIdMaxTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TENANT_ID_DESC',
  DocumentSpaceConfigsByTeamIdMaxTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TITLE_ASC',
  DocumentSpaceConfigsByTeamIdMaxTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_TITLE_DESC',
  DocumentSpaceConfigsByTeamIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigsByTeamIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTeamIdMaxUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByTeamIdMaxUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MAX_UPDATED_BY_ID_DESC',
  DocumentSpaceConfigsByTeamIdMinContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByTeamIdMinContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByTeamIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigsByTeamIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigsByTeamIdMinCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByTeamIdMinCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByTeamIdMinDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByTeamIdMinDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByTeamIdMinDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByTeamIdMinDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByTeamIdMinDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByTeamIdMinDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByTeamIdMinDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByTeamIdMinDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByTeamIdMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByTeamIdMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByTeamIdMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByTeamIdMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByTeamIdMinGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_GROUP_ID_ASC',
  DocumentSpaceConfigsByTeamIdMinGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_GROUP_ID_DESC',
  DocumentSpaceConfigsByTeamIdMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByTeamIdMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByTeamIdMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByTeamIdMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByTeamIdMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByTeamIdMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByTeamIdMinHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_SCALING_ASC',
  DocumentSpaceConfigsByTeamIdMinHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_SCALING_DESC',
  DocumentSpaceConfigsByTeamIdMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByTeamIdMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByTeamIdMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigsByTeamIdMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigsByTeamIdMinIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_ID_ASC',
  DocumentSpaceConfigsByTeamIdMinIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_ID_DESC',
  DocumentSpaceConfigsByTeamIdMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByTeamIdMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByTeamIdMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByTeamIdMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByTeamIdMinLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByTeamIdMinLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByTeamIdMinLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByTeamIdMinLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByTeamIdMinLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LOGO_URL_ASC',
  DocumentSpaceConfigsByTeamIdMinLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_LOGO_URL_DESC',
  DocumentSpaceConfigsByTeamIdMinNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_NAME_ASC',
  DocumentSpaceConfigsByTeamIdMinNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_NAME_DESC',
  DocumentSpaceConfigsByTeamIdMinNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_NEW_TAB_ASC',
  DocumentSpaceConfigsByTeamIdMinNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_NEW_TAB_DESC',
  DocumentSpaceConfigsByTeamIdMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByTeamIdMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByTeamIdMinProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByTeamIdMinProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByTeamIdMinRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByTeamIdMinRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByTeamIdMinStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_STYLESHEET_ASC',
  DocumentSpaceConfigsByTeamIdMinStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_STYLESHEET_DESC',
  DocumentSpaceConfigsByTeamIdMinTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TEAM_ID_ASC',
  DocumentSpaceConfigsByTeamIdMinTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TEAM_ID_DESC',
  DocumentSpaceConfigsByTeamIdMinTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TEMPLATE_ASC',
  DocumentSpaceConfigsByTeamIdMinTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TEMPLATE_DESC',
  DocumentSpaceConfigsByTeamIdMinTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TENANT_ID_ASC',
  DocumentSpaceConfigsByTeamIdMinTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TENANT_ID_DESC',
  DocumentSpaceConfigsByTeamIdMinTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TITLE_ASC',
  DocumentSpaceConfigsByTeamIdMinTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_TITLE_DESC',
  DocumentSpaceConfigsByTeamIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigsByTeamIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTeamIdMinUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByTeamIdMinUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TEAM_ID__MIN_UPDATED_BY_ID_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  FlowSubscriptionsByTeamIdCountAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__COUNT_ASC',
  FlowSubscriptionsByTeamIdCountDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__COUNT_DESC',
  FlowSubscriptionsByTeamIdMaxFlowIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_FLOW_ID_ASC',
  FlowSubscriptionsByTeamIdMaxFlowIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_FLOW_ID_DESC',
  FlowSubscriptionsByTeamIdMaxIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_ID_ASC',
  FlowSubscriptionsByTeamIdMaxIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_ID_DESC',
  FlowSubscriptionsByTeamIdMaxMayEditAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_EDIT_ASC',
  FlowSubscriptionsByTeamIdMaxMayEditDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_EDIT_DESC',
  FlowSubscriptionsByTeamIdMaxTeamIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_TEAM_ID_ASC',
  FlowSubscriptionsByTeamIdMaxTeamIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_TEAM_ID_DESC',
  FlowSubscriptionsByTeamIdMaxUserIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_USER_ID_ASC',
  FlowSubscriptionsByTeamIdMaxUserIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MAX_USER_ID_DESC',
  FlowSubscriptionsByTeamIdMinFlowIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_FLOW_ID_ASC',
  FlowSubscriptionsByTeamIdMinFlowIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_FLOW_ID_DESC',
  FlowSubscriptionsByTeamIdMinIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_ID_ASC',
  FlowSubscriptionsByTeamIdMinIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_ID_DESC',
  FlowSubscriptionsByTeamIdMinMayEditAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_EDIT_ASC',
  FlowSubscriptionsByTeamIdMinMayEditDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_EDIT_DESC',
  FlowSubscriptionsByTeamIdMinTeamIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_TEAM_ID_ASC',
  FlowSubscriptionsByTeamIdMinTeamIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_TEAM_ID_DESC',
  FlowSubscriptionsByTeamIdMinUserIdAsc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_USER_ID_ASC',
  FlowSubscriptionsByTeamIdMinUserIdDesc = 'FLOW_SUBSCRIPTIONS_BY_TEAM_ID__MIN_USER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOpenAsc = 'IS_OPEN_ASC',
  IsOpenDesc = 'IS_OPEN_DESC',
  IsVisibleAsc = 'IS_VISIBLE_ASC',
  IsVisibleDesc = 'IS_VISIBLE_DESC',
  MembershipsBySubteamIdCountAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__COUNT_ASC',
  MembershipsBySubteamIdCountDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__COUNT_DESC',
  MembershipsBySubteamIdMaxCreatedAtAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_CREATED_AT_ASC',
  MembershipsBySubteamIdMaxCreatedAtDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_CREATED_AT_DESC',
  MembershipsBySubteamIdMaxCurrentStateAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_CURRENT_STATE_ASC',
  MembershipsBySubteamIdMaxCurrentStateDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_CURRENT_STATE_DESC',
  MembershipsBySubteamIdMaxIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_ID_ASC',
  MembershipsBySubteamIdMaxIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_ID_DESC',
  MembershipsBySubteamIdMaxIsManagedManuallyAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_IS_MANAGED_MANUALLY_ASC',
  MembershipsBySubteamIdMaxIsManagedManuallyDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_IS_MANAGED_MANUALLY_DESC',
  MembershipsBySubteamIdMaxIsSyncedWithExternalGroupsAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  MembershipsBySubteamIdMaxIsSyncedWithExternalGroupsDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MembershipsBySubteamIdMaxMayAdministrateAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_ADMINISTRATE_ASC',
  MembershipsBySubteamIdMaxMayAdministrateDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_ADMINISTRATE_DESC',
  MembershipsBySubteamIdMaxMayBanUsersAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_BAN_USERS_ASC',
  MembershipsBySubteamIdMaxMayBanUsersDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_BAN_USERS_DESC',
  MembershipsBySubteamIdMaxMayDecideMembershipRequestsAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MembershipsBySubteamIdMaxMayDecideMembershipRequestsDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MembershipsBySubteamIdMaxMayInviteUsersAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_INVITE_USERS_ASC',
  MembershipsBySubteamIdMaxMayInviteUsersDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_INVITE_USERS_DESC',
  MembershipsBySubteamIdMaxMayOrderLicencesForThisTeamAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MembershipsBySubteamIdMaxMayOrderLicencesForThisTeamDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MembershipsBySubteamIdMaxSubteamIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_SUBTEAM_ID_ASC',
  MembershipsBySubteamIdMaxSubteamIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_SUBTEAM_ID_DESC',
  MembershipsBySubteamIdMaxSysPeriodAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_SYS_PERIOD_ASC',
  MembershipsBySubteamIdMaxSysPeriodDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_SYS_PERIOD_DESC',
  MembershipsBySubteamIdMaxTeamIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_TEAM_ID_ASC',
  MembershipsBySubteamIdMaxTeamIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_TEAM_ID_DESC',
  MembershipsBySubteamIdMaxUpdatedAtAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_UPDATED_AT_ASC',
  MembershipsBySubteamIdMaxUpdatedAtDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_UPDATED_AT_DESC',
  MembershipsBySubteamIdMaxUserIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_USER_ID_ASC',
  MembershipsBySubteamIdMaxUserIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MAX_USER_ID_DESC',
  MembershipsBySubteamIdMinCreatedAtAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_CREATED_AT_ASC',
  MembershipsBySubteamIdMinCreatedAtDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_CREATED_AT_DESC',
  MembershipsBySubteamIdMinCurrentStateAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_CURRENT_STATE_ASC',
  MembershipsBySubteamIdMinCurrentStateDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_CURRENT_STATE_DESC',
  MembershipsBySubteamIdMinIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_ID_ASC',
  MembershipsBySubteamIdMinIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_ID_DESC',
  MembershipsBySubteamIdMinIsManagedManuallyAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_IS_MANAGED_MANUALLY_ASC',
  MembershipsBySubteamIdMinIsManagedManuallyDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_IS_MANAGED_MANUALLY_DESC',
  MembershipsBySubteamIdMinIsSyncedWithExternalGroupsAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  MembershipsBySubteamIdMinIsSyncedWithExternalGroupsDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MembershipsBySubteamIdMinMayAdministrateAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_ADMINISTRATE_ASC',
  MembershipsBySubteamIdMinMayAdministrateDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_ADMINISTRATE_DESC',
  MembershipsBySubteamIdMinMayBanUsersAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_BAN_USERS_ASC',
  MembershipsBySubteamIdMinMayBanUsersDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_BAN_USERS_DESC',
  MembershipsBySubteamIdMinMayDecideMembershipRequestsAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MembershipsBySubteamIdMinMayDecideMembershipRequestsDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MembershipsBySubteamIdMinMayInviteUsersAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_INVITE_USERS_ASC',
  MembershipsBySubteamIdMinMayInviteUsersDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_INVITE_USERS_DESC',
  MembershipsBySubteamIdMinMayOrderLicencesForThisTeamAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MembershipsBySubteamIdMinMayOrderLicencesForThisTeamDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MembershipsBySubteamIdMinSubteamIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_SUBTEAM_ID_ASC',
  MembershipsBySubteamIdMinSubteamIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_SUBTEAM_ID_DESC',
  MembershipsBySubteamIdMinSysPeriodAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_SYS_PERIOD_ASC',
  MembershipsBySubteamIdMinSysPeriodDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_SYS_PERIOD_DESC',
  MembershipsBySubteamIdMinTeamIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_TEAM_ID_ASC',
  MembershipsBySubteamIdMinTeamIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_TEAM_ID_DESC',
  MembershipsBySubteamIdMinUpdatedAtAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_UPDATED_AT_ASC',
  MembershipsBySubteamIdMinUpdatedAtDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_UPDATED_AT_DESC',
  MembershipsBySubteamIdMinUserIdAsc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_USER_ID_ASC',
  MembershipsBySubteamIdMinUserIdDesc = 'MEMBERSHIPS_BY_SUBTEAM_ID__MIN_USER_ID_DESC',
  MembershipsByTeamIdCountAsc = 'MEMBERSHIPS_BY_TEAM_ID__COUNT_ASC',
  MembershipsByTeamIdCountDesc = 'MEMBERSHIPS_BY_TEAM_ID__COUNT_DESC',
  MembershipsByTeamIdMaxCreatedAtAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_CREATED_AT_ASC',
  MembershipsByTeamIdMaxCreatedAtDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_CREATED_AT_DESC',
  MembershipsByTeamIdMaxCurrentStateAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_CURRENT_STATE_ASC',
  MembershipsByTeamIdMaxCurrentStateDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_CURRENT_STATE_DESC',
  MembershipsByTeamIdMaxIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_ID_ASC',
  MembershipsByTeamIdMaxIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_ID_DESC',
  MembershipsByTeamIdMaxIsManagedManuallyAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_IS_MANAGED_MANUALLY_ASC',
  MembershipsByTeamIdMaxIsManagedManuallyDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_IS_MANAGED_MANUALLY_DESC',
  MembershipsByTeamIdMaxIsSyncedWithExternalGroupsAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  MembershipsByTeamIdMaxIsSyncedWithExternalGroupsDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MembershipsByTeamIdMaxMayAdministrateAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_ADMINISTRATE_ASC',
  MembershipsByTeamIdMaxMayAdministrateDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_ADMINISTRATE_DESC',
  MembershipsByTeamIdMaxMayBanUsersAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_BAN_USERS_ASC',
  MembershipsByTeamIdMaxMayBanUsersDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_BAN_USERS_DESC',
  MembershipsByTeamIdMaxMayDecideMembershipRequestsAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MembershipsByTeamIdMaxMayDecideMembershipRequestsDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MembershipsByTeamIdMaxMayInviteUsersAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_INVITE_USERS_ASC',
  MembershipsByTeamIdMaxMayInviteUsersDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_INVITE_USERS_DESC',
  MembershipsByTeamIdMaxMayOrderLicencesForThisTeamAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MembershipsByTeamIdMaxMayOrderLicencesForThisTeamDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MembershipsByTeamIdMaxSubteamIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_SUBTEAM_ID_ASC',
  MembershipsByTeamIdMaxSubteamIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_SUBTEAM_ID_DESC',
  MembershipsByTeamIdMaxSysPeriodAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_SYS_PERIOD_ASC',
  MembershipsByTeamIdMaxSysPeriodDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_SYS_PERIOD_DESC',
  MembershipsByTeamIdMaxTeamIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_TEAM_ID_ASC',
  MembershipsByTeamIdMaxTeamIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_TEAM_ID_DESC',
  MembershipsByTeamIdMaxUpdatedAtAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_UPDATED_AT_ASC',
  MembershipsByTeamIdMaxUpdatedAtDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_UPDATED_AT_DESC',
  MembershipsByTeamIdMaxUserIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_USER_ID_ASC',
  MembershipsByTeamIdMaxUserIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MAX_USER_ID_DESC',
  MembershipsByTeamIdMinCreatedAtAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_CREATED_AT_ASC',
  MembershipsByTeamIdMinCreatedAtDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_CREATED_AT_DESC',
  MembershipsByTeamIdMinCurrentStateAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_CURRENT_STATE_ASC',
  MembershipsByTeamIdMinCurrentStateDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_CURRENT_STATE_DESC',
  MembershipsByTeamIdMinIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_ID_ASC',
  MembershipsByTeamIdMinIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_ID_DESC',
  MembershipsByTeamIdMinIsManagedManuallyAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_IS_MANAGED_MANUALLY_ASC',
  MembershipsByTeamIdMinIsManagedManuallyDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_IS_MANAGED_MANUALLY_DESC',
  MembershipsByTeamIdMinIsSyncedWithExternalGroupsAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  MembershipsByTeamIdMinIsSyncedWithExternalGroupsDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MembershipsByTeamIdMinMayAdministrateAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_ADMINISTRATE_ASC',
  MembershipsByTeamIdMinMayAdministrateDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_ADMINISTRATE_DESC',
  MembershipsByTeamIdMinMayBanUsersAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_BAN_USERS_ASC',
  MembershipsByTeamIdMinMayBanUsersDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_BAN_USERS_DESC',
  MembershipsByTeamIdMinMayDecideMembershipRequestsAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MembershipsByTeamIdMinMayDecideMembershipRequestsDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MembershipsByTeamIdMinMayInviteUsersAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_INVITE_USERS_ASC',
  MembershipsByTeamIdMinMayInviteUsersDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_INVITE_USERS_DESC',
  MembershipsByTeamIdMinMayOrderLicencesForThisTeamAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MembershipsByTeamIdMinMayOrderLicencesForThisTeamDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MembershipsByTeamIdMinSubteamIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_SUBTEAM_ID_ASC',
  MembershipsByTeamIdMinSubteamIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_SUBTEAM_ID_DESC',
  MembershipsByTeamIdMinSysPeriodAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_SYS_PERIOD_ASC',
  MembershipsByTeamIdMinSysPeriodDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_SYS_PERIOD_DESC',
  MembershipsByTeamIdMinTeamIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_TEAM_ID_ASC',
  MembershipsByTeamIdMinTeamIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_TEAM_ID_DESC',
  MembershipsByTeamIdMinUpdatedAtAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_UPDATED_AT_ASC',
  MembershipsByTeamIdMinUpdatedAtDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_UPDATED_AT_DESC',
  MembershipsByTeamIdMinUserIdAsc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_USER_ID_ASC',
  MembershipsByTeamIdMinUserIdDesc = 'MEMBERSHIPS_BY_TEAM_ID__MIN_USER_ID_DESC',
  MemberCountAsc = 'MEMBER_COUNT_ASC',
  MemberCountDesc = 'MEMBER_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameLowercaseAsc = 'NAME_LOWERCASE_ASC',
  NameLowercaseDesc = 'NAME_LOWERCASE_DESC',
  Natural = 'NATURAL',
  NotificationsByTeamIdCountAsc = 'NOTIFICATIONS_BY_TEAM_ID__COUNT_ASC',
  NotificationsByTeamIdCountDesc = 'NOTIFICATIONS_BY_TEAM_ID__COUNT_DESC',
  NotificationsByTeamIdMaxBodyTextAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_BODY_TEXT_ASC',
  NotificationsByTeamIdMaxBodyTextDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_BODY_TEXT_DESC',
  NotificationsByTeamIdMaxCreatedAtAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_CREATED_AT_ASC',
  NotificationsByTeamIdMaxCreatedAtDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_CREATED_AT_DESC',
  NotificationsByTeamIdMaxDataAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_DATA_ASC',
  NotificationsByTeamIdMaxDataDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_DATA_DESC',
  NotificationsByTeamIdMaxEventTypeAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_EVENT_TYPE_ASC',
  NotificationsByTeamIdMaxEventTypeDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_EVENT_TYPE_DESC',
  NotificationsByTeamIdMaxHeaderTextAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_HEADER_TEXT_ASC',
  NotificationsByTeamIdMaxHeaderTextDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_HEADER_TEXT_DESC',
  NotificationsByTeamIdMaxIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_ID_ASC',
  NotificationsByTeamIdMaxIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_ID_DESC',
  NotificationsByTeamIdMaxSenderIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_SENDER_ID_ASC',
  NotificationsByTeamIdMaxSenderIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_SENDER_ID_DESC',
  NotificationsByTeamIdMaxTeamIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_TEAM_ID_ASC',
  NotificationsByTeamIdMaxTeamIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_TEAM_ID_DESC',
  NotificationsByTeamIdMaxUserIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_USER_ID_ASC',
  NotificationsByTeamIdMaxUserIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_USER_ID_DESC',
  NotificationsByTeamIdMaxWorkspaceIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_WORKSPACE_ID_ASC',
  NotificationsByTeamIdMaxWorkspaceIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MAX_WORKSPACE_ID_DESC',
  NotificationsByTeamIdMinBodyTextAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_BODY_TEXT_ASC',
  NotificationsByTeamIdMinBodyTextDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_BODY_TEXT_DESC',
  NotificationsByTeamIdMinCreatedAtAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_CREATED_AT_ASC',
  NotificationsByTeamIdMinCreatedAtDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_CREATED_AT_DESC',
  NotificationsByTeamIdMinDataAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_DATA_ASC',
  NotificationsByTeamIdMinDataDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_DATA_DESC',
  NotificationsByTeamIdMinEventTypeAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_EVENT_TYPE_ASC',
  NotificationsByTeamIdMinEventTypeDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_EVENT_TYPE_DESC',
  NotificationsByTeamIdMinHeaderTextAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_HEADER_TEXT_ASC',
  NotificationsByTeamIdMinHeaderTextDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_HEADER_TEXT_DESC',
  NotificationsByTeamIdMinIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_ID_ASC',
  NotificationsByTeamIdMinIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_ID_DESC',
  NotificationsByTeamIdMinSenderIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_SENDER_ID_ASC',
  NotificationsByTeamIdMinSenderIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_SENDER_ID_DESC',
  NotificationsByTeamIdMinTeamIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_TEAM_ID_ASC',
  NotificationsByTeamIdMinTeamIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_TEAM_ID_DESC',
  NotificationsByTeamIdMinUserIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_USER_ID_ASC',
  NotificationsByTeamIdMinUserIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_USER_ID_DESC',
  NotificationsByTeamIdMinWorkspaceIdAsc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_WORKSPACE_ID_ASC',
  NotificationsByTeamIdMinWorkspaceIdDesc = 'NOTIFICATIONS_BY_TEAM_ID__MIN_WORKSPACE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RetentionPolicyByTeamIdAutoExpireLocalUploadsDaysAsc = 'RETENTION_POLICY_BY_TEAM_ID__AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_ASC',
  RetentionPolicyByTeamIdAutoExpireLocalUploadsDaysDesc = 'RETENTION_POLICY_BY_TEAM_ID__AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_DESC',
  RetentionPolicyByTeamIdCreatedAtAsc = 'RETENTION_POLICY_BY_TEAM_ID__CREATED_AT_ASC',
  RetentionPolicyByTeamIdCreatedAtDesc = 'RETENTION_POLICY_BY_TEAM_ID__CREATED_AT_DESC',
  RetentionPolicyByTeamIdExpiryDateEditableAsc = 'RETENTION_POLICY_BY_TEAM_ID__EXPIRY_DATE_EDITABLE_ASC',
  RetentionPolicyByTeamIdExpiryDateEditableDesc = 'RETENTION_POLICY_BY_TEAM_ID__EXPIRY_DATE_EDITABLE_DESC',
  RetentionPolicyByTeamIdGracePeriodDaysAsc = 'RETENTION_POLICY_BY_TEAM_ID__GRACE_PERIOD_DAYS_ASC',
  RetentionPolicyByTeamIdGracePeriodDaysDesc = 'RETENTION_POLICY_BY_TEAM_ID__GRACE_PERIOD_DAYS_DESC',
  RetentionPolicyByTeamIdIdAsc = 'RETENTION_POLICY_BY_TEAM_ID__ID_ASC',
  RetentionPolicyByTeamIdIdDesc = 'RETENTION_POLICY_BY_TEAM_ID__ID_DESC',
  RetentionPolicyByTeamIdTeamIdAsc = 'RETENTION_POLICY_BY_TEAM_ID__TEAM_ID_ASC',
  RetentionPolicyByTeamIdTeamIdDesc = 'RETENTION_POLICY_BY_TEAM_ID__TEAM_ID_DESC',
  RetentionPolicyByTeamIdTenantIdAsc = 'RETENTION_POLICY_BY_TEAM_ID__TENANT_ID_ASC',
  RetentionPolicyByTeamIdTenantIdDesc = 'RETENTION_POLICY_BY_TEAM_ID__TENANT_ID_DESC',
  RetentionPolicyByTeamIdUpdatedAtAsc = 'RETENTION_POLICY_BY_TEAM_ID__UPDATED_AT_ASC',
  RetentionPolicyByTeamIdUpdatedAtDesc = 'RETENTION_POLICY_BY_TEAM_ID__UPDATED_AT_DESC',
  RetentionPolicyByTeamIdWorkspaceIdAsc = 'RETENTION_POLICY_BY_TEAM_ID__WORKSPACE_ID_ASC',
  RetentionPolicyByTeamIdWorkspaceIdDesc = 'RETENTION_POLICY_BY_TEAM_ID__WORKSPACE_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TotalMemberCountAsc = 'TOTAL_MEMBER_COUNT_ASC',
  TotalMemberCountDesc = 'TOTAL_MEMBER_COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserConfigDefaultsAsc = 'USER_CONFIG_DEFAULTS_ASC',
  UserConfigDefaultsDesc = 'USER_CONFIG_DEFAULTS_DESC',
  WorkspaceSubscriptionsBySubteamIdCountAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__COUNT_ASC',
  WorkspaceSubscriptionsBySubteamIdCountDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__COUNT_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxCreatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_CREATED_AT_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxCreatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_CREATED_AT_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxCurrentStateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_CURRENT_STATE_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxCurrentStateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_CURRENT_STATE_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxIsManagedManuallyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_IS_MANAGED_MANUALLY_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxIsManagedManuallyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_IS_MANAGED_MANUALLY_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxIsSyncedWithExternalGroupsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxIsSyncedWithExternalGroupsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayAdministrateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_ADMINISTRATE_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayAdministrateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_ADMINISTRATE_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayBanUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_BAN_USERS_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayBanUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_BAN_USERS_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayCreateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_CREATE_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayCreateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_CREATE_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayDecideMembershipRequestsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayDecideMembershipRequestsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayDeleteAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_DELETE_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayDeleteDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_DELETE_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayInviteUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_INVITE_USERS_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayInviteUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_INVITE_USERS_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayModifyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_MODIFY_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayModifyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_MODIFY_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayOrderLicencesForThisTeamAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayOrderLicencesForThisTeamDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayPublishAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_PUBLISH_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayPublishDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_PUBLISH_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayTestAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_TEST_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayTestDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_TEST_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxMayViewAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_VIEW_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxMayViewDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_MAY_VIEW_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxSubteamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_SUBTEAM_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxSubteamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_SUBTEAM_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxSysPeriodAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_SYS_PERIOD_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxSysPeriodDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_SYS_PERIOD_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxTeamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_TEAM_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxTeamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_TEAM_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxUpdatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_UPDATED_AT_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxUpdatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_UPDATED_AT_DESC',
  WorkspaceSubscriptionsBySubteamIdMaxUserIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_USER_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMaxUserIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MAX_USER_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMinCreatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_CREATED_AT_ASC',
  WorkspaceSubscriptionsBySubteamIdMinCreatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_CREATED_AT_DESC',
  WorkspaceSubscriptionsBySubteamIdMinCurrentStateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_CURRENT_STATE_ASC',
  WorkspaceSubscriptionsBySubteamIdMinCurrentStateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_CURRENT_STATE_DESC',
  WorkspaceSubscriptionsBySubteamIdMinIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMinIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMinIsManagedManuallyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_IS_MANAGED_MANUALLY_ASC',
  WorkspaceSubscriptionsBySubteamIdMinIsManagedManuallyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_IS_MANAGED_MANUALLY_DESC',
  WorkspaceSubscriptionsBySubteamIdMinIsSyncedWithExternalGroupsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  WorkspaceSubscriptionsBySubteamIdMinIsSyncedWithExternalGroupsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayAdministrateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_ADMINISTRATE_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayAdministrateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_ADMINISTRATE_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayBanUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_BAN_USERS_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayBanUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_BAN_USERS_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayCreateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_CREATE_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayCreateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_CREATE_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayDecideMembershipRequestsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayDecideMembershipRequestsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayDeleteAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_DELETE_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayDeleteDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_DELETE_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayInviteUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_INVITE_USERS_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayInviteUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_INVITE_USERS_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayModifyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_MODIFY_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayModifyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_MODIFY_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayOrderLicencesForThisTeamAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayOrderLicencesForThisTeamDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayPublishAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_PUBLISH_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayPublishDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_PUBLISH_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayTestAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_TEST_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayTestDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_TEST_DESC',
  WorkspaceSubscriptionsBySubteamIdMinMayViewAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_VIEW_ASC',
  WorkspaceSubscriptionsBySubteamIdMinMayViewDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_MAY_VIEW_DESC',
  WorkspaceSubscriptionsBySubteamIdMinSubteamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_SUBTEAM_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMinSubteamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_SUBTEAM_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMinSysPeriodAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_SYS_PERIOD_ASC',
  WorkspaceSubscriptionsBySubteamIdMinSysPeriodDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_SYS_PERIOD_DESC',
  WorkspaceSubscriptionsBySubteamIdMinTeamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_TEAM_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMinTeamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_TEAM_ID_DESC',
  WorkspaceSubscriptionsBySubteamIdMinUpdatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_UPDATED_AT_ASC',
  WorkspaceSubscriptionsBySubteamIdMinUpdatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_UPDATED_AT_DESC',
  WorkspaceSubscriptionsBySubteamIdMinUserIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_USER_ID_ASC',
  WorkspaceSubscriptionsBySubteamIdMinUserIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_SUBTEAM_ID__MIN_USER_ID_DESC'
}

export type TempContact = {
  __typename?: 'TempContact';
  crmId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  languagePref?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['BigInt']['output']>;
  territory?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `TempContact` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TempContactCondition = {
  /** Checks for equality with the object’s `crmId` field. */
  crmId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `languagePref` field. */
  languagePref?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organization` field. */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `territory` field. */
  territory?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `TempContact` object types. All fields are combined with a logical ‘and.’ */
export type TempContactFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TempContactFilter>>;
  /** Filter by the object’s `crmId` field. */
  crmId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `languagePref` field. */
  languagePref?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TempContactFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TempContactFilter>>;
  /** Filter by the object’s `organization` field. */
  organization?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `territory` field. */
  territory?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `TempContact` */
export type TempContactInput = {
  crmId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languagePref?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `TempContact` values. */
export type TempContactsConnection = {
  __typename?: 'TempContactsConnection';
  /** A list of edges which contains the `TempContact` and cursor to aid in pagination. */
  edges: Array<TempContactsEdge>;
  /** A list of `TempContact` objects. */
  nodes: Array<Maybe<TempContact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TempContact` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TempContact` edge in the connection. */
export type TempContactsEdge = {
  __typename?: 'TempContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TempContact` at the end of the edge. */
  node?: Maybe<TempContact>;
};

/** Methods to use when ordering `TempContact`. */
export enum TempContactsOrderBy {
  CrmIdAsc = 'CRM_ID_ASC',
  CrmIdDesc = 'CRM_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LanguagePrefAsc = 'LANGUAGE_PREF_ASC',
  LanguagePrefDesc = 'LANGUAGE_PREF_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TerritoryAsc = 'TERRITORY_ASC',
  TerritoryDesc = 'TERRITORY_DESC'
}

export type Tenant = Node & {
  __typename?: 'Tenant';
  autoAssignIfEmailLike?: Maybe<Scalars['String']['output']>;
  canUsersInviteOthers: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `CrmContactMatch`. */
  crmContactMatches: CrmContactMatchesConnection;
  /** Reads and enables pagination through a set of `CrmContact`. */
  crmContacts: CrmContactsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceConfig`. */
  documentSpaceConfigs: DocumentSpaceConfigsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceLinkGroup`. */
  documentSpaceLinkGroups: DocumentSpaceLinkGroupsConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceTag`. */
  documentSpaceTags: DocumentSpaceTagsConnection;
  /** Reads and enables pagination through a set of `DocumentSpace`. */
  documentSpaces: DocumentSpacesConnection;
  exportPresentationAnalyticsUserEmail: Scalars['Boolean']['output'];
  flags: Array<Maybe<Scalars['String']['output']>>;
  hasExternalGroups: Scalars['Boolean']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `InternalIpAddress`. */
  internalIpAddresses: InternalIpAddressesConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Order`. */
  orders: OrdersConnection;
  /**
   * Reads and enables pagination through a set of `RetentionPolicy`.
   * @deprecated Please use retentionPolicy instead
   */
  retentionPolicies: RetentionPoliciesConnection;
  /** Reads a single `RetentionPolicy` that is related to this `Tenant`. */
  retentionPolicy?: Maybe<RetentionPolicy>;
  setupPersonalWorkspacesOnRegistration: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Team`. */
  teams: TeamsConnection;
  /** Reads a single `Workspace` that is related to this `Tenant`. */
  tutorialWorkspace?: Maybe<Workspace>;
  tutorialWorkspaceId?: Maybe<Scalars['BigInt']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userConfigDefaults: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `User`. */
  users: UsersConnection;
  /** Reads and enables pagination through a set of `Workspace`. */
  workspaces: WorkspacesConnection;
};


export type TenantCrmContactMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactMatchCondition>;
  filter?: InputMaybe<CrmContactMatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactMatchesOrderBy>>;
};


export type TenantCrmContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactCondition>;
  filter?: InputMaybe<CrmContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactsOrderBy>>;
};


export type TenantDocumentSpaceConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigCondition>;
  filter?: InputMaybe<DocumentSpaceConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};


export type TenantDocumentSpaceLinkGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceLinkGroupCondition>;
  filter?: InputMaybe<DocumentSpaceLinkGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceLinkGroupsOrderBy>>;
};


export type TenantDocumentSpaceTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceTagCondition>;
  filter?: InputMaybe<DocumentSpaceTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceTagsOrderBy>>;
};


export type TenantDocumentSpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCondition>;
  filter?: InputMaybe<DocumentSpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};


export type TenantInternalIpAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InternalIpAddressCondition>;
  filter?: InputMaybe<InternalIpAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InternalIpAddressesOrderBy>>;
};


export type TenantOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type TenantRetentionPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RetentionPolicyCondition>;
  filter?: InputMaybe<RetentionPolicyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};


export type TenantTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TeamCondition>;
  filter?: InputMaybe<TeamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamsOrderBy>>;
};


export type TenantUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type TenantWorkspacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceCondition>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

/** A condition to be used against `Tenant` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TenantCondition = {
  /** Checks for equality with the object’s `autoAssignIfEmailLike` field. */
  autoAssignIfEmailLike?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `canUsersInviteOthers` field. */
  canUsersInviteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `exportPresentationAnalyticsUserEmail` field. */
  exportPresentationAnalyticsUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `flags` field. */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `hasExternalGroups` field. */
  hasExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `setupPersonalWorkspacesOnRegistration` field. */
  setupPersonalWorkspacesOnRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tutorialWorkspaceId` field. */
  tutorialWorkspaceId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userConfigDefaults` field. */
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `Tenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `autoAssignIfEmailLike` field. */
  autoAssignIfEmailLike?: InputMaybe<StringFilter>;
  /** Filter by the object’s `canUsersInviteOthers` field. */
  canUsersInviteOthers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContactMatches` relation. */
  crmContactMatches?: InputMaybe<TenantToManyCrmContactMatchFilter>;
  /** Some related `crmContactMatches` exist. */
  crmContactMatchesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmContacts` relation. */
  crmContacts?: InputMaybe<TenantToManyCrmContactFilter>;
  /** Some related `crmContacts` exist. */
  crmContactsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceConfigs` relation. */
  documentSpaceConfigs?: InputMaybe<TenantToManyDocumentSpaceConfigFilter>;
  /** Some related `documentSpaceConfigs` exist. */
  documentSpaceConfigsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceLinkGroups` relation. */
  documentSpaceLinkGroups?: InputMaybe<TenantToManyDocumentSpaceLinkGroupFilter>;
  /** Some related `documentSpaceLinkGroups` exist. */
  documentSpaceLinkGroupsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceTags` relation. */
  documentSpaceTags?: InputMaybe<TenantToManyDocumentSpaceTagFilter>;
  /** Some related `documentSpaceTags` exist. */
  documentSpaceTagsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaces` relation. */
  documentSpaces?: InputMaybe<TenantToManyDocumentSpaceFilter>;
  /** Some related `documentSpaces` exist. */
  documentSpacesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `exportPresentationAnalyticsUserEmail` field. */
  exportPresentationAnalyticsUserEmail?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `flags` field. */
  flags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `hasExternalGroups` field. */
  hasExternalGroups?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `internalIpAddresses` relation. */
  internalIpAddresses?: InputMaybe<TenantToManyInternalIpAddressFilter>;
  /** Some related `internalIpAddresses` exist. */
  internalIpAddressesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `orders` relation. */
  orders?: InputMaybe<TenantToManyOrderFilter>;
  /** Some related `orders` exist. */
  ordersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `retentionPolicy` relation. */
  retentionPolicy?: InputMaybe<RetentionPolicyFilter>;
  /** A related `retentionPolicy` exists. */
  retentionPolicyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `setupPersonalWorkspacesOnRegistration` field. */
  setupPersonalWorkspacesOnRegistration?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `teams` relation. */
  teams?: InputMaybe<TenantToManyTeamFilter>;
  /** Some related `teams` exist. */
  teamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tutorialWorkspace` relation. */
  tutorialWorkspace?: InputMaybe<WorkspaceFilter>;
  /** A related `tutorialWorkspace` exists. */
  tutorialWorkspaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tutorialWorkspaceId` field. */
  tutorialWorkspaceId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userConfigDefaults` field. */
  userConfigDefaults?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `users` relation. */
  users?: InputMaybe<TenantToManyUserFilter>;
  /** Some related `users` exist. */
  usersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspaces` relation. */
  workspaces?: InputMaybe<TenantToManyWorkspaceFilter>;
  /** Some related `workspaces` exist. */
  workspacesExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `Tenant` */
export type TenantInput = {
  autoAssignIfEmailLike?: InputMaybe<Scalars['String']['input']>;
  canUsersInviteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  exportPresentationAnalyticsUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  setupPersonalWorkspacesOnRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  tutorialWorkspaceId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `Tenant`. Fields that are set will be updated. */
export type TenantPatch = {
  autoAssignIfEmailLike?: InputMaybe<Scalars['String']['input']>;
  canUsersInviteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  exportPresentationAnalyticsUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  setupPersonalWorkspacesOnRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  tutorialWorkspaceId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against many `CrmContact` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyCrmContactFilter = {
  /** Every related `CrmContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactFilter>;
  /** No related `CrmContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactFilter>;
  /** Some related `CrmContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactFilter>;
};

/** A filter to be used against many `CrmContactMatch` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyCrmContactMatchFilter = {
  /** Every related `CrmContactMatch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactMatchFilter>;
  /** No related `CrmContactMatch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactMatchFilter>;
  /** Some related `CrmContactMatch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactMatchFilter>;
};

/** A filter to be used against many `DocumentSpaceConfig` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyDocumentSpaceConfigFilter = {
  /** Every related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigFilter>;
  /** No related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigFilter>;
  /** Some related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigFilter>;
};

/** A filter to be used against many `DocumentSpace` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyDocumentSpaceFilter = {
  /** Every related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceFilter>;
  /** No related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceFilter>;
  /** Some related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceFilter>;
};

/** A filter to be used against many `DocumentSpaceLinkGroup` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyDocumentSpaceLinkGroupFilter = {
  /** Every related `DocumentSpaceLinkGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceLinkGroupFilter>;
  /** No related `DocumentSpaceLinkGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceLinkGroupFilter>;
  /** Some related `DocumentSpaceLinkGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceLinkGroupFilter>;
};

/** A filter to be used against many `DocumentSpaceTag` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyDocumentSpaceTagFilter = {
  /** Every related `DocumentSpaceTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceTagFilter>;
  /** No related `DocumentSpaceTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceTagFilter>;
  /** Some related `DocumentSpaceTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceTagFilter>;
};

/** A filter to be used against many `InternalIpAddress` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyInternalIpAddressFilter = {
  /** Every related `InternalIpAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InternalIpAddressFilter>;
  /** No related `InternalIpAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InternalIpAddressFilter>;
  /** Some related `InternalIpAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InternalIpAddressFilter>;
};

/** A filter to be used against many `Order` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyOrderFilter = {
  /** Every related `Order` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OrderFilter>;
  /** No related `Order` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OrderFilter>;
  /** Some related `Order` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OrderFilter>;
};

/** A filter to be used against many `Team` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTeamFilter = {
  /** Every related `Team` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TeamFilter>;
  /** No related `Team` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TeamFilter>;
  /** Some related `Team` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TeamFilter>;
};

/** A filter to be used against many `User` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyUserFilter = {
  /** Every related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserFilter>;
  /** No related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserFilter>;
  /** Some related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserFilter>;
};

/** A filter to be used against many `Workspace` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyWorkspaceFilter = {
  /** Every related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceFilter>;
  /** No related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceFilter>;
  /** Some related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceFilter>;
};

/** A connection to a list of `Tenant` values. */
export type TenantsConnection = {
  __typename?: 'TenantsConnection';
  /** A list of edges which contains the `Tenant` and cursor to aid in pagination. */
  edges: Array<TenantsEdge>;
  /** A list of `Tenant` objects. */
  nodes: Array<Maybe<Tenant>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tenant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Tenant` edge in the connection. */
export type TenantsEdge = {
  __typename?: 'TenantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Tenant` at the end of the edge. */
  node?: Maybe<Tenant>;
};

/** Methods to use when ordering `Tenant`. */
export enum TenantsOrderBy {
  AutoAssignIfEmailLikeAsc = 'AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  AutoAssignIfEmailLikeDesc = 'AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  CanUsersInviteOthersAsc = 'CAN_USERS_INVITE_OTHERS_ASC',
  CanUsersInviteOthersDesc = 'CAN_USERS_INVITE_OTHERS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactsByTenantIdCountAsc = 'CRM_CONTACTS_BY_TENANT_ID__COUNT_ASC',
  CrmContactsByTenantIdCountDesc = 'CRM_CONTACTS_BY_TENANT_ID__COUNT_DESC',
  CrmContactsByTenantIdMaxActiveAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ACTIVE_ASC',
  CrmContactsByTenantIdMaxActiveDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ACTIVE_DESC',
  CrmContactsByTenantIdMaxAlxnConsentStatusAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_CONSENT_STATUS_ASC',
  CrmContactsByTenantIdMaxAlxnConsentStatusDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_CONSENT_STATUS_DESC',
  CrmContactsByTenantIdMaxAlxnPrimaryParentAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_PRIMARY_PARENT_ASC',
  CrmContactsByTenantIdMaxAlxnPrimaryParentDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_PRIMARY_PARENT_DESC',
  CrmContactsByTenantIdMaxAlxnProductsAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_PRODUCTS_ASC',
  CrmContactsByTenantIdMaxAlxnProductsDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_PRODUCTS_DESC',
  CrmContactsByTenantIdMaxAlxnRoleAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_ROLE_ASC',
  CrmContactsByTenantIdMaxAlxnRoleDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_ROLE_DESC',
  CrmContactsByTenantIdMaxAlxnSpecialityAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_SPECIALITY_ASC',
  CrmContactsByTenantIdMaxAlxnSpecialityDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_SPECIALITY_DESC',
  CrmContactsByTenantIdMaxAlxnTerritoriesAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_TERRITORIES_ASC',
  CrmContactsByTenantIdMaxAlxnTerritoriesDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ALXN_TERRITORIES_DESC',
  CrmContactsByTenantIdMaxCityAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_CITY_ASC',
  CrmContactsByTenantIdMaxCityDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_CITY_DESC',
  CrmContactsByTenantIdMaxCountryAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_COUNTRY_ASC',
  CrmContactsByTenantIdMaxCountryDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_COUNTRY_DESC',
  CrmContactsByTenantIdMaxCreatedAtAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  CrmContactsByTenantIdMaxCreatedAtDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  CrmContactsByTenantIdMaxCrmIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_CRM_ID_ASC',
  CrmContactsByTenantIdMaxCrmIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_CRM_ID_DESC',
  CrmContactsByTenantIdMaxEmailAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_EMAIL_ASC',
  CrmContactsByTenantIdMaxEmailDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_EMAIL_DESC',
  CrmContactsByTenantIdMaxFirstNameAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_FIRST_NAME_ASC',
  CrmContactsByTenantIdMaxFirstNameDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_FIRST_NAME_DESC',
  CrmContactsByTenantIdMaxFullNameAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_FULL_NAME_ASC',
  CrmContactsByTenantIdMaxFullNameDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_FULL_NAME_DESC',
  CrmContactsByTenantIdMaxIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ID_ASC',
  CrmContactsByTenantIdMaxIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ID_DESC',
  CrmContactsByTenantIdMaxLanguagePrefAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_LANGUAGE_PREF_ASC',
  CrmContactsByTenantIdMaxLanguagePrefDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_LANGUAGE_PREF_DESC',
  CrmContactsByTenantIdMaxLastNameAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_LAST_NAME_ASC',
  CrmContactsByTenantIdMaxLastNameDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_LAST_NAME_DESC',
  CrmContactsByTenantIdMaxLocalCrmIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_LOCAL_CRM_ID_ASC',
  CrmContactsByTenantIdMaxLocalCrmIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_LOCAL_CRM_ID_DESC',
  CrmContactsByTenantIdMaxMobileAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_MOBILE_ASC',
  CrmContactsByTenantIdMaxMobileDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_MOBILE_DESC',
  CrmContactsByTenantIdMaxOrganizationAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ORGANIZATION_ASC',
  CrmContactsByTenantIdMaxOrganizationDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ORGANIZATION_DESC',
  CrmContactsByTenantIdMaxRegionAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_REGION_ASC',
  CrmContactsByTenantIdMaxRegionDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_REGION_DESC',
  CrmContactsByTenantIdMaxTenantIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  CrmContactsByTenantIdMaxTenantIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  CrmContactsByTenantIdMaxTerritoryAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_TERRITORY_ASC',
  CrmContactsByTenantIdMaxTerritoryDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_TERRITORY_DESC',
  CrmContactsByTenantIdMaxUpdatedAtAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  CrmContactsByTenantIdMaxUpdatedAtDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  CrmContactsByTenantIdMaxZipCodeAsc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ZIP_CODE_ASC',
  CrmContactsByTenantIdMaxZipCodeDesc = 'CRM_CONTACTS_BY_TENANT_ID__MAX_ZIP_CODE_DESC',
  CrmContactsByTenantIdMinActiveAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ACTIVE_ASC',
  CrmContactsByTenantIdMinActiveDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ACTIVE_DESC',
  CrmContactsByTenantIdMinAlxnConsentStatusAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_CONSENT_STATUS_ASC',
  CrmContactsByTenantIdMinAlxnConsentStatusDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_CONSENT_STATUS_DESC',
  CrmContactsByTenantIdMinAlxnPrimaryParentAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_PRIMARY_PARENT_ASC',
  CrmContactsByTenantIdMinAlxnPrimaryParentDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_PRIMARY_PARENT_DESC',
  CrmContactsByTenantIdMinAlxnProductsAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_PRODUCTS_ASC',
  CrmContactsByTenantIdMinAlxnProductsDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_PRODUCTS_DESC',
  CrmContactsByTenantIdMinAlxnRoleAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_ROLE_ASC',
  CrmContactsByTenantIdMinAlxnRoleDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_ROLE_DESC',
  CrmContactsByTenantIdMinAlxnSpecialityAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_SPECIALITY_ASC',
  CrmContactsByTenantIdMinAlxnSpecialityDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_SPECIALITY_DESC',
  CrmContactsByTenantIdMinAlxnTerritoriesAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_TERRITORIES_ASC',
  CrmContactsByTenantIdMinAlxnTerritoriesDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ALXN_TERRITORIES_DESC',
  CrmContactsByTenantIdMinCityAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_CITY_ASC',
  CrmContactsByTenantIdMinCityDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_CITY_DESC',
  CrmContactsByTenantIdMinCountryAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_COUNTRY_ASC',
  CrmContactsByTenantIdMinCountryDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_COUNTRY_DESC',
  CrmContactsByTenantIdMinCreatedAtAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  CrmContactsByTenantIdMinCreatedAtDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  CrmContactsByTenantIdMinCrmIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_CRM_ID_ASC',
  CrmContactsByTenantIdMinCrmIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_CRM_ID_DESC',
  CrmContactsByTenantIdMinEmailAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_EMAIL_ASC',
  CrmContactsByTenantIdMinEmailDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_EMAIL_DESC',
  CrmContactsByTenantIdMinFirstNameAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_FIRST_NAME_ASC',
  CrmContactsByTenantIdMinFirstNameDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_FIRST_NAME_DESC',
  CrmContactsByTenantIdMinFullNameAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_FULL_NAME_ASC',
  CrmContactsByTenantIdMinFullNameDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_FULL_NAME_DESC',
  CrmContactsByTenantIdMinIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ID_ASC',
  CrmContactsByTenantIdMinIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ID_DESC',
  CrmContactsByTenantIdMinLanguagePrefAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_LANGUAGE_PREF_ASC',
  CrmContactsByTenantIdMinLanguagePrefDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_LANGUAGE_PREF_DESC',
  CrmContactsByTenantIdMinLastNameAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_LAST_NAME_ASC',
  CrmContactsByTenantIdMinLastNameDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_LAST_NAME_DESC',
  CrmContactsByTenantIdMinLocalCrmIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_LOCAL_CRM_ID_ASC',
  CrmContactsByTenantIdMinLocalCrmIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_LOCAL_CRM_ID_DESC',
  CrmContactsByTenantIdMinMobileAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_MOBILE_ASC',
  CrmContactsByTenantIdMinMobileDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_MOBILE_DESC',
  CrmContactsByTenantIdMinOrganizationAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ORGANIZATION_ASC',
  CrmContactsByTenantIdMinOrganizationDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ORGANIZATION_DESC',
  CrmContactsByTenantIdMinRegionAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_REGION_ASC',
  CrmContactsByTenantIdMinRegionDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_REGION_DESC',
  CrmContactsByTenantIdMinTenantIdAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  CrmContactsByTenantIdMinTenantIdDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  CrmContactsByTenantIdMinTerritoryAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_TERRITORY_ASC',
  CrmContactsByTenantIdMinTerritoryDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_TERRITORY_DESC',
  CrmContactsByTenantIdMinUpdatedAtAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  CrmContactsByTenantIdMinUpdatedAtDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  CrmContactsByTenantIdMinZipCodeAsc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ZIP_CODE_ASC',
  CrmContactsByTenantIdMinZipCodeDesc = 'CRM_CONTACTS_BY_TENANT_ID__MIN_ZIP_CODE_DESC',
  CrmContactMatchesByTenantIdCountAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__COUNT_ASC',
  CrmContactMatchesByTenantIdCountDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__COUNT_DESC',
  CrmContactMatchesByTenantIdMaxActiveAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ACTIVE_ASC',
  CrmContactMatchesByTenantIdMaxActiveDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ACTIVE_DESC',
  CrmContactMatchesByTenantIdMaxAlxnConsentStatusAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchesByTenantIdMaxAlxnConsentStatusDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchesByTenantIdMaxAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchesByTenantIdMaxAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchesByTenantIdMaxAlxnProductsAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_PRODUCTS_ASC',
  CrmContactMatchesByTenantIdMaxAlxnProductsDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_PRODUCTS_DESC',
  CrmContactMatchesByTenantIdMaxAlxnRoleAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_ROLE_ASC',
  CrmContactMatchesByTenantIdMaxAlxnRoleDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_ROLE_DESC',
  CrmContactMatchesByTenantIdMaxAlxnSpecialityAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_SPECIALITY_ASC',
  CrmContactMatchesByTenantIdMaxAlxnSpecialityDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_SPECIALITY_DESC',
  CrmContactMatchesByTenantIdMaxAlxnTerritoriesAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_TERRITORIES_ASC',
  CrmContactMatchesByTenantIdMaxAlxnTerritoriesDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ALXN_TERRITORIES_DESC',
  CrmContactMatchesByTenantIdMaxCityAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_CITY_ASC',
  CrmContactMatchesByTenantIdMaxCityDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_CITY_DESC',
  CrmContactMatchesByTenantIdMaxCountryAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_COUNTRY_ASC',
  CrmContactMatchesByTenantIdMaxCountryDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_COUNTRY_DESC',
  CrmContactMatchesByTenantIdMaxCreatedAtAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  CrmContactMatchesByTenantIdMaxCreatedAtDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  CrmContactMatchesByTenantIdMaxCrmIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_CRM_ID_ASC',
  CrmContactMatchesByTenantIdMaxCrmIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_CRM_ID_DESC',
  CrmContactMatchesByTenantIdMaxEmailAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_EMAIL_ASC',
  CrmContactMatchesByTenantIdMaxEmailDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_EMAIL_DESC',
  CrmContactMatchesByTenantIdMaxFirstNameAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FIRST_NAME_ASC',
  CrmContactMatchesByTenantIdMaxFirstNameDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FIRST_NAME_DESC',
  CrmContactMatchesByTenantIdMaxFulltextRankAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FULLTEXT_RANK_ASC',
  CrmContactMatchesByTenantIdMaxFulltextRankDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FULLTEXT_RANK_DESC',
  CrmContactMatchesByTenantIdMaxFulltextSearchColumnAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchesByTenantIdMaxFulltextSearchColumnDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchesByTenantIdMaxFullNameAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FULL_NAME_ASC',
  CrmContactMatchesByTenantIdMaxFullNameDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_FULL_NAME_DESC',
  CrmContactMatchesByTenantIdMaxIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ID_ASC',
  CrmContactMatchesByTenantIdMaxIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ID_DESC',
  CrmContactMatchesByTenantIdMaxLanguagePrefAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_LANGUAGE_PREF_ASC',
  CrmContactMatchesByTenantIdMaxLanguagePrefDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_LANGUAGE_PREF_DESC',
  CrmContactMatchesByTenantIdMaxLastNameAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_LAST_NAME_ASC',
  CrmContactMatchesByTenantIdMaxLastNameDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_LAST_NAME_DESC',
  CrmContactMatchesByTenantIdMaxLocalCrmIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_LOCAL_CRM_ID_ASC',
  CrmContactMatchesByTenantIdMaxLocalCrmIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_LOCAL_CRM_ID_DESC',
  CrmContactMatchesByTenantIdMaxMobileAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_MOBILE_ASC',
  CrmContactMatchesByTenantIdMaxMobileDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_MOBILE_DESC',
  CrmContactMatchesByTenantIdMaxOrganizationAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ORGANIZATION_ASC',
  CrmContactMatchesByTenantIdMaxOrganizationDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ORGANIZATION_DESC',
  CrmContactMatchesByTenantIdMaxRegionAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_REGION_ASC',
  CrmContactMatchesByTenantIdMaxRegionDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_REGION_DESC',
  CrmContactMatchesByTenantIdMaxSimilarityAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_SIMILARITY_ASC',
  CrmContactMatchesByTenantIdMaxSimilarityDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_SIMILARITY_DESC',
  CrmContactMatchesByTenantIdMaxTenantIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  CrmContactMatchesByTenantIdMaxTenantIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  CrmContactMatchesByTenantIdMaxTerritoryAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_TERRITORY_ASC',
  CrmContactMatchesByTenantIdMaxTerritoryDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_TERRITORY_DESC',
  CrmContactMatchesByTenantIdMaxUpdatedAtAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  CrmContactMatchesByTenantIdMaxUpdatedAtDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  CrmContactMatchesByTenantIdMaxZipCodeAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ZIP_CODE_ASC',
  CrmContactMatchesByTenantIdMaxZipCodeDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MAX_ZIP_CODE_DESC',
  CrmContactMatchesByTenantIdMinActiveAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ACTIVE_ASC',
  CrmContactMatchesByTenantIdMinActiveDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ACTIVE_DESC',
  CrmContactMatchesByTenantIdMinAlxnConsentStatusAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_CONSENT_STATUS_ASC',
  CrmContactMatchesByTenantIdMinAlxnConsentStatusDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_CONSENT_STATUS_DESC',
  CrmContactMatchesByTenantIdMinAlxnPrimaryParentAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_PRIMARY_PARENT_ASC',
  CrmContactMatchesByTenantIdMinAlxnPrimaryParentDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_PRIMARY_PARENT_DESC',
  CrmContactMatchesByTenantIdMinAlxnProductsAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_PRODUCTS_ASC',
  CrmContactMatchesByTenantIdMinAlxnProductsDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_PRODUCTS_DESC',
  CrmContactMatchesByTenantIdMinAlxnRoleAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_ROLE_ASC',
  CrmContactMatchesByTenantIdMinAlxnRoleDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_ROLE_DESC',
  CrmContactMatchesByTenantIdMinAlxnSpecialityAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_SPECIALITY_ASC',
  CrmContactMatchesByTenantIdMinAlxnSpecialityDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_SPECIALITY_DESC',
  CrmContactMatchesByTenantIdMinAlxnTerritoriesAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_TERRITORIES_ASC',
  CrmContactMatchesByTenantIdMinAlxnTerritoriesDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ALXN_TERRITORIES_DESC',
  CrmContactMatchesByTenantIdMinCityAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_CITY_ASC',
  CrmContactMatchesByTenantIdMinCityDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_CITY_DESC',
  CrmContactMatchesByTenantIdMinCountryAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_COUNTRY_ASC',
  CrmContactMatchesByTenantIdMinCountryDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_COUNTRY_DESC',
  CrmContactMatchesByTenantIdMinCreatedAtAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  CrmContactMatchesByTenantIdMinCreatedAtDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  CrmContactMatchesByTenantIdMinCrmIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_CRM_ID_ASC',
  CrmContactMatchesByTenantIdMinCrmIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_CRM_ID_DESC',
  CrmContactMatchesByTenantIdMinEmailAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_EMAIL_ASC',
  CrmContactMatchesByTenantIdMinEmailDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_EMAIL_DESC',
  CrmContactMatchesByTenantIdMinFirstNameAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FIRST_NAME_ASC',
  CrmContactMatchesByTenantIdMinFirstNameDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FIRST_NAME_DESC',
  CrmContactMatchesByTenantIdMinFulltextRankAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FULLTEXT_RANK_ASC',
  CrmContactMatchesByTenantIdMinFulltextRankDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FULLTEXT_RANK_DESC',
  CrmContactMatchesByTenantIdMinFulltextSearchColumnAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FULLTEXT_SEARCH_COLUMN_ASC',
  CrmContactMatchesByTenantIdMinFulltextSearchColumnDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FULLTEXT_SEARCH_COLUMN_DESC',
  CrmContactMatchesByTenantIdMinFullNameAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FULL_NAME_ASC',
  CrmContactMatchesByTenantIdMinFullNameDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_FULL_NAME_DESC',
  CrmContactMatchesByTenantIdMinIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ID_ASC',
  CrmContactMatchesByTenantIdMinIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ID_DESC',
  CrmContactMatchesByTenantIdMinLanguagePrefAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_LANGUAGE_PREF_ASC',
  CrmContactMatchesByTenantIdMinLanguagePrefDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_LANGUAGE_PREF_DESC',
  CrmContactMatchesByTenantIdMinLastNameAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_LAST_NAME_ASC',
  CrmContactMatchesByTenantIdMinLastNameDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_LAST_NAME_DESC',
  CrmContactMatchesByTenantIdMinLocalCrmIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_LOCAL_CRM_ID_ASC',
  CrmContactMatchesByTenantIdMinLocalCrmIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_LOCAL_CRM_ID_DESC',
  CrmContactMatchesByTenantIdMinMobileAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_MOBILE_ASC',
  CrmContactMatchesByTenantIdMinMobileDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_MOBILE_DESC',
  CrmContactMatchesByTenantIdMinOrganizationAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ORGANIZATION_ASC',
  CrmContactMatchesByTenantIdMinOrganizationDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ORGANIZATION_DESC',
  CrmContactMatchesByTenantIdMinRegionAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_REGION_ASC',
  CrmContactMatchesByTenantIdMinRegionDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_REGION_DESC',
  CrmContactMatchesByTenantIdMinSimilarityAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_SIMILARITY_ASC',
  CrmContactMatchesByTenantIdMinSimilarityDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_SIMILARITY_DESC',
  CrmContactMatchesByTenantIdMinTenantIdAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  CrmContactMatchesByTenantIdMinTenantIdDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  CrmContactMatchesByTenantIdMinTerritoryAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_TERRITORY_ASC',
  CrmContactMatchesByTenantIdMinTerritoryDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_TERRITORY_DESC',
  CrmContactMatchesByTenantIdMinUpdatedAtAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  CrmContactMatchesByTenantIdMinUpdatedAtDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  CrmContactMatchesByTenantIdMinZipCodeAsc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ZIP_CODE_ASC',
  CrmContactMatchesByTenantIdMinZipCodeDesc = 'CRM_CONTACT_MATCHES_BY_TENANT_ID__MIN_ZIP_CODE_DESC',
  DocumentSpacesByTenantIdCountAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__COUNT_ASC',
  DocumentSpacesByTenantIdCountDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__COUNT_DESC',
  DocumentSpacesByTenantIdMaxAllowedEmailAddressesAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpacesByTenantIdMaxAllowedEmailAddressesDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpacesByTenantIdMaxCodeOnAccessCardAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CODE_ON_ACCESS_CARD_ASC',
  DocumentSpacesByTenantIdMaxCodeOnAccessCardDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CODE_ON_ACCESS_CARD_DESC',
  DocumentSpacesByTenantIdMaxCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpacesByTenantIdMaxCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpacesByTenantIdMaxCommentAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_COMMENT_ASC',
  DocumentSpacesByTenantIdMaxCommentDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_COMMENT_DESC',
  DocumentSpacesByTenantIdMaxConfigIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CONFIG_ID_ASC',
  DocumentSpacesByTenantIdMaxConfigIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CONFIG_ID_DESC',
  DocumentSpacesByTenantIdMaxCreatedAtAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  DocumentSpacesByTenantIdMaxCreatedAtDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  DocumentSpacesByTenantIdMaxCreatorIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CREATOR_ID_ASC',
  DocumentSpacesByTenantIdMaxCreatorIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_CREATOR_ID_DESC',
  DocumentSpacesByTenantIdMaxEncryptedPasswordAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_ENCRYPTED_PASSWORD_ASC',
  DocumentSpacesByTenantIdMaxEncryptedPasswordDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_ENCRYPTED_PASSWORD_DESC',
  DocumentSpacesByTenantIdMaxIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_ID_ASC',
  DocumentSpacesByTenantIdMaxIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_ID_DESC',
  DocumentSpacesByTenantIdMaxNameAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_NAME_ASC',
  DocumentSpacesByTenantIdMaxNameDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_NAME_DESC',
  DocumentSpacesByTenantIdMaxPersonalMessageAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_PERSONAL_MESSAGE_ASC',
  DocumentSpacesByTenantIdMaxPersonalMessageDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_PERSONAL_MESSAGE_DESC',
  DocumentSpacesByTenantIdMaxShowContactDetailsAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_SHOW_CONTACT_DETAILS_ASC',
  DocumentSpacesByTenantIdMaxShowContactDetailsDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_SHOW_CONTACT_DETAILS_DESC',
  DocumentSpacesByTenantIdMaxSysPeriodAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpacesByTenantIdMaxSysPeriodDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpacesByTenantIdMaxTenantIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  DocumentSpacesByTenantIdMaxTenantIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  DocumentSpacesByTenantIdMaxTrackingDeactivatedAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_TRACKING_DEACTIVATED_ASC',
  DocumentSpacesByTenantIdMaxTrackingDeactivatedDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_TRACKING_DEACTIVATED_DESC',
  DocumentSpacesByTenantIdMaxUpdatedAtAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  DocumentSpacesByTenantIdMaxUpdatedAtDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  DocumentSpacesByTenantIdMinAllowedEmailAddressesAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpacesByTenantIdMinAllowedEmailAddressesDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpacesByTenantIdMinCodeOnAccessCardAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CODE_ON_ACCESS_CARD_ASC',
  DocumentSpacesByTenantIdMinCodeOnAccessCardDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CODE_ON_ACCESS_CARD_DESC',
  DocumentSpacesByTenantIdMinCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpacesByTenantIdMinCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpacesByTenantIdMinCommentAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_COMMENT_ASC',
  DocumentSpacesByTenantIdMinCommentDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_COMMENT_DESC',
  DocumentSpacesByTenantIdMinConfigIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CONFIG_ID_ASC',
  DocumentSpacesByTenantIdMinConfigIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CONFIG_ID_DESC',
  DocumentSpacesByTenantIdMinCreatedAtAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  DocumentSpacesByTenantIdMinCreatedAtDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  DocumentSpacesByTenantIdMinCreatorIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CREATOR_ID_ASC',
  DocumentSpacesByTenantIdMinCreatorIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_CREATOR_ID_DESC',
  DocumentSpacesByTenantIdMinEncryptedPasswordAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_ENCRYPTED_PASSWORD_ASC',
  DocumentSpacesByTenantIdMinEncryptedPasswordDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_ENCRYPTED_PASSWORD_DESC',
  DocumentSpacesByTenantIdMinIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_ID_ASC',
  DocumentSpacesByTenantIdMinIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_ID_DESC',
  DocumentSpacesByTenantIdMinNameAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_NAME_ASC',
  DocumentSpacesByTenantIdMinNameDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_NAME_DESC',
  DocumentSpacesByTenantIdMinPersonalMessageAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_PERSONAL_MESSAGE_ASC',
  DocumentSpacesByTenantIdMinPersonalMessageDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_PERSONAL_MESSAGE_DESC',
  DocumentSpacesByTenantIdMinShowContactDetailsAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_SHOW_CONTACT_DETAILS_ASC',
  DocumentSpacesByTenantIdMinShowContactDetailsDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_SHOW_CONTACT_DETAILS_DESC',
  DocumentSpacesByTenantIdMinSysPeriodAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpacesByTenantIdMinSysPeriodDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpacesByTenantIdMinTenantIdAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  DocumentSpacesByTenantIdMinTenantIdDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  DocumentSpacesByTenantIdMinTrackingDeactivatedAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_TRACKING_DEACTIVATED_ASC',
  DocumentSpacesByTenantIdMinTrackingDeactivatedDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_TRACKING_DEACTIVATED_DESC',
  DocumentSpacesByTenantIdMinUpdatedAtAsc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  DocumentSpacesByTenantIdMinUpdatedAtDesc = 'DOCUMENT_SPACES_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdCountAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__COUNT_ASC',
  DocumentSpaceConfigsByTenantIdCountDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__COUNT_DESC',
  DocumentSpaceConfigsByTenantIdMaxContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdMaxContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdMaxCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByTenantIdMaxCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByTenantIdMaxDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByTenantIdMaxDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByTenantIdMaxDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByTenantIdMaxDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByTenantIdMaxDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByTenantIdMaxDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByTenantIdMaxDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByTenantIdMaxDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByTenantIdMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByTenantIdMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByTenantIdMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdMaxGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_GROUP_ID_ASC',
  DocumentSpaceConfigsByTenantIdMaxGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_GROUP_ID_DESC',
  DocumentSpaceConfigsByTenantIdMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByTenantIdMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByTenantIdMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByTenantIdMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByTenantIdMaxHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_SCALING_ASC',
  DocumentSpaceConfigsByTenantIdMaxHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_SCALING_DESC',
  DocumentSpaceConfigsByTenantIdMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByTenantIdMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByTenantIdMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdMaxIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_ID_ASC',
  DocumentSpaceConfigsByTenantIdMaxIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_ID_DESC',
  DocumentSpaceConfigsByTenantIdMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByTenantIdMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByTenantIdMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByTenantIdMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByTenantIdMaxLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByTenantIdMaxLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByTenantIdMaxLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByTenantIdMaxLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByTenantIdMaxLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LOGO_URL_ASC',
  DocumentSpaceConfigsByTenantIdMaxLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_LOGO_URL_DESC',
  DocumentSpaceConfigsByTenantIdMaxNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_NAME_ASC',
  DocumentSpaceConfigsByTenantIdMaxNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_NAME_DESC',
  DocumentSpaceConfigsByTenantIdMaxNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_NEW_TAB_ASC',
  DocumentSpaceConfigsByTenantIdMaxNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_NEW_TAB_DESC',
  DocumentSpaceConfigsByTenantIdMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByTenantIdMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByTenantIdMaxProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByTenantIdMaxProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByTenantIdMaxRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByTenantIdMaxRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByTenantIdMaxStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_STYLESHEET_ASC',
  DocumentSpaceConfigsByTenantIdMaxStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_STYLESHEET_DESC',
  DocumentSpaceConfigsByTenantIdMaxTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TEAM_ID_ASC',
  DocumentSpaceConfigsByTenantIdMaxTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TEAM_ID_DESC',
  DocumentSpaceConfigsByTenantIdMaxTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TEMPLATE_ASC',
  DocumentSpaceConfigsByTenantIdMaxTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TEMPLATE_DESC',
  DocumentSpaceConfigsByTenantIdMaxTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  DocumentSpaceConfigsByTenantIdMaxTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  DocumentSpaceConfigsByTenantIdMaxTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdMaxTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdMaxUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByTenantIdMaxUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MAX_UPDATED_BY_ID_DESC',
  DocumentSpaceConfigsByTenantIdMinContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdMinContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdMinCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByTenantIdMinCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByTenantIdMinDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByTenantIdMinDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByTenantIdMinDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByTenantIdMinDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByTenantIdMinDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByTenantIdMinDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByTenantIdMinDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByTenantIdMinDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByTenantIdMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByTenantIdMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByTenantIdMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdMinGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_GROUP_ID_ASC',
  DocumentSpaceConfigsByTenantIdMinGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_GROUP_ID_DESC',
  DocumentSpaceConfigsByTenantIdMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByTenantIdMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByTenantIdMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByTenantIdMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByTenantIdMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByTenantIdMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByTenantIdMinHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_SCALING_ASC',
  DocumentSpaceConfigsByTenantIdMinHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_SCALING_DESC',
  DocumentSpaceConfigsByTenantIdMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByTenantIdMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByTenantIdMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdMinIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_ID_ASC',
  DocumentSpaceConfigsByTenantIdMinIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_ID_DESC',
  DocumentSpaceConfigsByTenantIdMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByTenantIdMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByTenantIdMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByTenantIdMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByTenantIdMinLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByTenantIdMinLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByTenantIdMinLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByTenantIdMinLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByTenantIdMinLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LOGO_URL_ASC',
  DocumentSpaceConfigsByTenantIdMinLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_LOGO_URL_DESC',
  DocumentSpaceConfigsByTenantIdMinNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_NAME_ASC',
  DocumentSpaceConfigsByTenantIdMinNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_NAME_DESC',
  DocumentSpaceConfigsByTenantIdMinNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_NEW_TAB_ASC',
  DocumentSpaceConfigsByTenantIdMinNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_NEW_TAB_DESC',
  DocumentSpaceConfigsByTenantIdMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByTenantIdMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByTenantIdMinProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByTenantIdMinProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByTenantIdMinRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByTenantIdMinRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByTenantIdMinStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_STYLESHEET_ASC',
  DocumentSpaceConfigsByTenantIdMinStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_STYLESHEET_DESC',
  DocumentSpaceConfigsByTenantIdMinTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TEAM_ID_ASC',
  DocumentSpaceConfigsByTenantIdMinTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TEAM_ID_DESC',
  DocumentSpaceConfigsByTenantIdMinTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TEMPLATE_ASC',
  DocumentSpaceConfigsByTenantIdMinTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TEMPLATE_DESC',
  DocumentSpaceConfigsByTenantIdMinTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  DocumentSpaceConfigsByTenantIdMinTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  DocumentSpaceConfigsByTenantIdMinTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TITLE_ASC',
  DocumentSpaceConfigsByTenantIdMinTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_TITLE_DESC',
  DocumentSpaceConfigsByTenantIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigsByTenantIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigsByTenantIdMinUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByTenantIdMinUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_TENANT_ID__MIN_UPDATED_BY_ID_DESC',
  DocumentSpaceLinkGroupsByTenantIdCountAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__COUNT_ASC',
  DocumentSpaceLinkGroupsByTenantIdCountDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__COUNT_DESC',
  DocumentSpaceLinkGroupsByTenantIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceLinkGroupsByTenantIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceLinkGroupsByTenantIdMaxIdAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_ID_ASC',
  DocumentSpaceLinkGroupsByTenantIdMaxIdDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_ID_DESC',
  DocumentSpaceLinkGroupsByTenantIdMaxNameAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_NAME_ASC',
  DocumentSpaceLinkGroupsByTenantIdMaxNameDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_NAME_DESC',
  DocumentSpaceLinkGroupsByTenantIdMaxTenantIdAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  DocumentSpaceLinkGroupsByTenantIdMaxTenantIdDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  DocumentSpaceLinkGroupsByTenantIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceLinkGroupsByTenantIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceLinkGroupsByTenantIdMinCreatedAtAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceLinkGroupsByTenantIdMinCreatedAtDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceLinkGroupsByTenantIdMinIdAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_ID_ASC',
  DocumentSpaceLinkGroupsByTenantIdMinIdDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_ID_DESC',
  DocumentSpaceLinkGroupsByTenantIdMinNameAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_NAME_ASC',
  DocumentSpaceLinkGroupsByTenantIdMinNameDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_NAME_DESC',
  DocumentSpaceLinkGroupsByTenantIdMinTenantIdAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  DocumentSpaceLinkGroupsByTenantIdMinTenantIdDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  DocumentSpaceLinkGroupsByTenantIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceLinkGroupsByTenantIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_LINK_GROUPS_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceTagsByTenantIdCountAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__COUNT_ASC',
  DocumentSpaceTagsByTenantIdCountDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__COUNT_DESC',
  DocumentSpaceTagsByTenantIdMaxIdAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_ID_ASC',
  DocumentSpaceTagsByTenantIdMaxIdDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_ID_DESC',
  DocumentSpaceTagsByTenantIdMaxScriptsAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_SCRIPTS_ASC',
  DocumentSpaceTagsByTenantIdMaxScriptsDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_SCRIPTS_DESC',
  DocumentSpaceTagsByTenantIdMaxScriptSrcAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_SCRIPT_SRC_ASC',
  DocumentSpaceTagsByTenantIdMaxScriptSrcDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_SCRIPT_SRC_DESC',
  DocumentSpaceTagsByTenantIdMaxTagTypeAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_TAG_TYPE_ASC',
  DocumentSpaceTagsByTenantIdMaxTagTypeDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_TAG_TYPE_DESC',
  DocumentSpaceTagsByTenantIdMaxTenantIdAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  DocumentSpaceTagsByTenantIdMaxTenantIdDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  DocumentSpaceTagsByTenantIdMinIdAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_ID_ASC',
  DocumentSpaceTagsByTenantIdMinIdDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_ID_DESC',
  DocumentSpaceTagsByTenantIdMinScriptsAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_SCRIPTS_ASC',
  DocumentSpaceTagsByTenantIdMinScriptsDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_SCRIPTS_DESC',
  DocumentSpaceTagsByTenantIdMinScriptSrcAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_SCRIPT_SRC_ASC',
  DocumentSpaceTagsByTenantIdMinScriptSrcDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_SCRIPT_SRC_DESC',
  DocumentSpaceTagsByTenantIdMinTagTypeAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_TAG_TYPE_ASC',
  DocumentSpaceTagsByTenantIdMinTagTypeDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_TAG_TYPE_DESC',
  DocumentSpaceTagsByTenantIdMinTenantIdAsc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  DocumentSpaceTagsByTenantIdMinTenantIdDesc = 'DOCUMENT_SPACE_TAGS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  ExportPresentationAnalyticsUserEmailAsc = 'EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  ExportPresentationAnalyticsUserEmailDesc = 'EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  HasExternalGroupsAsc = 'HAS_EXTERNAL_GROUPS_ASC',
  HasExternalGroupsDesc = 'HAS_EXTERNAL_GROUPS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InternalIpAddressesByTenantIdCountAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__COUNT_ASC',
  InternalIpAddressesByTenantIdCountDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__COUNT_DESC',
  InternalIpAddressesByTenantIdMaxCreatedAtAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  InternalIpAddressesByTenantIdMaxCreatedAtDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  InternalIpAddressesByTenantIdMaxIdAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_ID_ASC',
  InternalIpAddressesByTenantIdMaxIdDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_ID_DESC',
  InternalIpAddressesByTenantIdMaxRangeEndAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_RANGE_END_ASC',
  InternalIpAddressesByTenantIdMaxRangeEndDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_RANGE_END_DESC',
  InternalIpAddressesByTenantIdMaxRangeStartAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_RANGE_START_ASC',
  InternalIpAddressesByTenantIdMaxRangeStartDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_RANGE_START_DESC',
  InternalIpAddressesByTenantIdMaxTenantIdAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  InternalIpAddressesByTenantIdMaxTenantIdDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  InternalIpAddressesByTenantIdMinCreatedAtAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  InternalIpAddressesByTenantIdMinCreatedAtDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  InternalIpAddressesByTenantIdMinIdAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_ID_ASC',
  InternalIpAddressesByTenantIdMinIdDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_ID_DESC',
  InternalIpAddressesByTenantIdMinRangeEndAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_RANGE_END_ASC',
  InternalIpAddressesByTenantIdMinRangeEndDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_RANGE_END_DESC',
  InternalIpAddressesByTenantIdMinRangeStartAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_RANGE_START_ASC',
  InternalIpAddressesByTenantIdMinRangeStartDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_RANGE_START_DESC',
  InternalIpAddressesByTenantIdMinTenantIdAsc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  InternalIpAddressesByTenantIdMinTenantIdDesc = 'INTERNAL_IP_ADDRESSES_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrdersByTenantIdCountAsc = 'ORDERS_BY_TENANT_ID__COUNT_ASC',
  OrdersByTenantIdCountDesc = 'ORDERS_BY_TENANT_ID__COUNT_DESC',
  OrdersByTenantIdMaxAdminIdAsc = 'ORDERS_BY_TENANT_ID__MAX_ADMIN_ID_ASC',
  OrdersByTenantIdMaxAdminIdDesc = 'ORDERS_BY_TENANT_ID__MAX_ADMIN_ID_DESC',
  OrdersByTenantIdMaxAmountCentsAsc = 'ORDERS_BY_TENANT_ID__MAX_AMOUNT_CENTS_ASC',
  OrdersByTenantIdMaxAmountCentsDesc = 'ORDERS_BY_TENANT_ID__MAX_AMOUNT_CENTS_DESC',
  OrdersByTenantIdMaxCommentAsc = 'ORDERS_BY_TENANT_ID__MAX_COMMENT_ASC',
  OrdersByTenantIdMaxCommentDesc = 'ORDERS_BY_TENANT_ID__MAX_COMMENT_DESC',
  OrdersByTenantIdMaxContactEmailAsc = 'ORDERS_BY_TENANT_ID__MAX_CONTACT_EMAIL_ASC',
  OrdersByTenantIdMaxContactEmailDesc = 'ORDERS_BY_TENANT_ID__MAX_CONTACT_EMAIL_DESC',
  OrdersByTenantIdMaxContactNameAsc = 'ORDERS_BY_TENANT_ID__MAX_CONTACT_NAME_ASC',
  OrdersByTenantIdMaxContactNameDesc = 'ORDERS_BY_TENANT_ID__MAX_CONTACT_NAME_DESC',
  OrdersByTenantIdMaxCreatedAtAsc = 'ORDERS_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  OrdersByTenantIdMaxCreatedAtDesc = 'ORDERS_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  OrdersByTenantIdMaxCurrencyCodeAsc = 'ORDERS_BY_TENANT_ID__MAX_CURRENCY_CODE_ASC',
  OrdersByTenantIdMaxCurrencyCodeDesc = 'ORDERS_BY_TENANT_ID__MAX_CURRENCY_CODE_DESC',
  OrdersByTenantIdMaxDescriptionAsc = 'ORDERS_BY_TENANT_ID__MAX_DESCRIPTION_ASC',
  OrdersByTenantIdMaxDescriptionDesc = 'ORDERS_BY_TENANT_ID__MAX_DESCRIPTION_DESC',
  OrdersByTenantIdMaxFastbillReferenceAsc = 'ORDERS_BY_TENANT_ID__MAX_FASTBILL_REFERENCE_ASC',
  OrdersByTenantIdMaxFastbillReferenceDesc = 'ORDERS_BY_TENANT_ID__MAX_FASTBILL_REFERENCE_DESC',
  OrdersByTenantIdMaxIdAsc = 'ORDERS_BY_TENANT_ID__MAX_ID_ASC',
  OrdersByTenantIdMaxIdDesc = 'ORDERS_BY_TENANT_ID__MAX_ID_DESC',
  OrdersByTenantIdMaxInvoiceNumberAsc = 'ORDERS_BY_TENANT_ID__MAX_INVOICE_NUMBER_ASC',
  OrdersByTenantIdMaxInvoiceNumberDesc = 'ORDERS_BY_TENANT_ID__MAX_INVOICE_NUMBER_DESC',
  OrdersByTenantIdMaxLicensesCountAsc = 'ORDERS_BY_TENANT_ID__MAX_LICENSES_COUNT_ASC',
  OrdersByTenantIdMaxLicensesCountDesc = 'ORDERS_BY_TENANT_ID__MAX_LICENSES_COUNT_DESC',
  OrdersByTenantIdMaxNumTeamLicensesAsc = 'ORDERS_BY_TENANT_ID__MAX_NUM_TEAM_LICENSES_ASC',
  OrdersByTenantIdMaxNumTeamLicensesDesc = 'ORDERS_BY_TENANT_ID__MAX_NUM_TEAM_LICENSES_DESC',
  OrdersByTenantIdMaxPipedriveReferenceAsc = 'ORDERS_BY_TENANT_ID__MAX_PIPEDRIVE_REFERENCE_ASC',
  OrdersByTenantIdMaxPipedriveReferenceDesc = 'ORDERS_BY_TENANT_ID__MAX_PIPEDRIVE_REFERENCE_DESC',
  OrdersByTenantIdMaxTenantIdAsc = 'ORDERS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  OrdersByTenantIdMaxTenantIdDesc = 'ORDERS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  OrdersByTenantIdMaxValidityPeriodAsc = 'ORDERS_BY_TENANT_ID__MAX_VALIDITY_PERIOD_ASC',
  OrdersByTenantIdMaxValidityPeriodDesc = 'ORDERS_BY_TENANT_ID__MAX_VALIDITY_PERIOD_DESC',
  OrdersByTenantIdMinAdminIdAsc = 'ORDERS_BY_TENANT_ID__MIN_ADMIN_ID_ASC',
  OrdersByTenantIdMinAdminIdDesc = 'ORDERS_BY_TENANT_ID__MIN_ADMIN_ID_DESC',
  OrdersByTenantIdMinAmountCentsAsc = 'ORDERS_BY_TENANT_ID__MIN_AMOUNT_CENTS_ASC',
  OrdersByTenantIdMinAmountCentsDesc = 'ORDERS_BY_TENANT_ID__MIN_AMOUNT_CENTS_DESC',
  OrdersByTenantIdMinCommentAsc = 'ORDERS_BY_TENANT_ID__MIN_COMMENT_ASC',
  OrdersByTenantIdMinCommentDesc = 'ORDERS_BY_TENANT_ID__MIN_COMMENT_DESC',
  OrdersByTenantIdMinContactEmailAsc = 'ORDERS_BY_TENANT_ID__MIN_CONTACT_EMAIL_ASC',
  OrdersByTenantIdMinContactEmailDesc = 'ORDERS_BY_TENANT_ID__MIN_CONTACT_EMAIL_DESC',
  OrdersByTenantIdMinContactNameAsc = 'ORDERS_BY_TENANT_ID__MIN_CONTACT_NAME_ASC',
  OrdersByTenantIdMinContactNameDesc = 'ORDERS_BY_TENANT_ID__MIN_CONTACT_NAME_DESC',
  OrdersByTenantIdMinCreatedAtAsc = 'ORDERS_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  OrdersByTenantIdMinCreatedAtDesc = 'ORDERS_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  OrdersByTenantIdMinCurrencyCodeAsc = 'ORDERS_BY_TENANT_ID__MIN_CURRENCY_CODE_ASC',
  OrdersByTenantIdMinCurrencyCodeDesc = 'ORDERS_BY_TENANT_ID__MIN_CURRENCY_CODE_DESC',
  OrdersByTenantIdMinDescriptionAsc = 'ORDERS_BY_TENANT_ID__MIN_DESCRIPTION_ASC',
  OrdersByTenantIdMinDescriptionDesc = 'ORDERS_BY_TENANT_ID__MIN_DESCRIPTION_DESC',
  OrdersByTenantIdMinFastbillReferenceAsc = 'ORDERS_BY_TENANT_ID__MIN_FASTBILL_REFERENCE_ASC',
  OrdersByTenantIdMinFastbillReferenceDesc = 'ORDERS_BY_TENANT_ID__MIN_FASTBILL_REFERENCE_DESC',
  OrdersByTenantIdMinIdAsc = 'ORDERS_BY_TENANT_ID__MIN_ID_ASC',
  OrdersByTenantIdMinIdDesc = 'ORDERS_BY_TENANT_ID__MIN_ID_DESC',
  OrdersByTenantIdMinInvoiceNumberAsc = 'ORDERS_BY_TENANT_ID__MIN_INVOICE_NUMBER_ASC',
  OrdersByTenantIdMinInvoiceNumberDesc = 'ORDERS_BY_TENANT_ID__MIN_INVOICE_NUMBER_DESC',
  OrdersByTenantIdMinLicensesCountAsc = 'ORDERS_BY_TENANT_ID__MIN_LICENSES_COUNT_ASC',
  OrdersByTenantIdMinLicensesCountDesc = 'ORDERS_BY_TENANT_ID__MIN_LICENSES_COUNT_DESC',
  OrdersByTenantIdMinNumTeamLicensesAsc = 'ORDERS_BY_TENANT_ID__MIN_NUM_TEAM_LICENSES_ASC',
  OrdersByTenantIdMinNumTeamLicensesDesc = 'ORDERS_BY_TENANT_ID__MIN_NUM_TEAM_LICENSES_DESC',
  OrdersByTenantIdMinPipedriveReferenceAsc = 'ORDERS_BY_TENANT_ID__MIN_PIPEDRIVE_REFERENCE_ASC',
  OrdersByTenantIdMinPipedriveReferenceDesc = 'ORDERS_BY_TENANT_ID__MIN_PIPEDRIVE_REFERENCE_DESC',
  OrdersByTenantIdMinTenantIdAsc = 'ORDERS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  OrdersByTenantIdMinTenantIdDesc = 'ORDERS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  OrdersByTenantIdMinValidityPeriodAsc = 'ORDERS_BY_TENANT_ID__MIN_VALIDITY_PERIOD_ASC',
  OrdersByTenantIdMinValidityPeriodDesc = 'ORDERS_BY_TENANT_ID__MIN_VALIDITY_PERIOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RetentionPolicyByTenantIdAutoExpireLocalUploadsDaysAsc = 'RETENTION_POLICY_BY_TENANT_ID__AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_ASC',
  RetentionPolicyByTenantIdAutoExpireLocalUploadsDaysDesc = 'RETENTION_POLICY_BY_TENANT_ID__AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_DESC',
  RetentionPolicyByTenantIdCreatedAtAsc = 'RETENTION_POLICY_BY_TENANT_ID__CREATED_AT_ASC',
  RetentionPolicyByTenantIdCreatedAtDesc = 'RETENTION_POLICY_BY_TENANT_ID__CREATED_AT_DESC',
  RetentionPolicyByTenantIdExpiryDateEditableAsc = 'RETENTION_POLICY_BY_TENANT_ID__EXPIRY_DATE_EDITABLE_ASC',
  RetentionPolicyByTenantIdExpiryDateEditableDesc = 'RETENTION_POLICY_BY_TENANT_ID__EXPIRY_DATE_EDITABLE_DESC',
  RetentionPolicyByTenantIdGracePeriodDaysAsc = 'RETENTION_POLICY_BY_TENANT_ID__GRACE_PERIOD_DAYS_ASC',
  RetentionPolicyByTenantIdGracePeriodDaysDesc = 'RETENTION_POLICY_BY_TENANT_ID__GRACE_PERIOD_DAYS_DESC',
  RetentionPolicyByTenantIdIdAsc = 'RETENTION_POLICY_BY_TENANT_ID__ID_ASC',
  RetentionPolicyByTenantIdIdDesc = 'RETENTION_POLICY_BY_TENANT_ID__ID_DESC',
  RetentionPolicyByTenantIdTeamIdAsc = 'RETENTION_POLICY_BY_TENANT_ID__TEAM_ID_ASC',
  RetentionPolicyByTenantIdTeamIdDesc = 'RETENTION_POLICY_BY_TENANT_ID__TEAM_ID_DESC',
  RetentionPolicyByTenantIdTenantIdAsc = 'RETENTION_POLICY_BY_TENANT_ID__TENANT_ID_ASC',
  RetentionPolicyByTenantIdTenantIdDesc = 'RETENTION_POLICY_BY_TENANT_ID__TENANT_ID_DESC',
  RetentionPolicyByTenantIdUpdatedAtAsc = 'RETENTION_POLICY_BY_TENANT_ID__UPDATED_AT_ASC',
  RetentionPolicyByTenantIdUpdatedAtDesc = 'RETENTION_POLICY_BY_TENANT_ID__UPDATED_AT_DESC',
  RetentionPolicyByTenantIdWorkspaceIdAsc = 'RETENTION_POLICY_BY_TENANT_ID__WORKSPACE_ID_ASC',
  RetentionPolicyByTenantIdWorkspaceIdDesc = 'RETENTION_POLICY_BY_TENANT_ID__WORKSPACE_ID_DESC',
  SetupPersonalWorkspacesOnRegistrationAsc = 'SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  SetupPersonalWorkspacesOnRegistrationDesc = 'SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TeamsByTenantIdCountAsc = 'TEAMS_BY_TENANT_ID__COUNT_ASC',
  TeamsByTenantIdCountDesc = 'TEAMS_BY_TENANT_ID__COUNT_DESC',
  TeamsByTenantIdMaxAnalyticsAliasAsc = 'TEAMS_BY_TENANT_ID__MAX_ANALYTICS_ALIAS_ASC',
  TeamsByTenantIdMaxAnalyticsAliasDesc = 'TEAMS_BY_TENANT_ID__MAX_ANALYTICS_ALIAS_DESC',
  TeamsByTenantIdMaxAnalyticsEnabledAsc = 'TEAMS_BY_TENANT_ID__MAX_ANALYTICS_ENABLED_ASC',
  TeamsByTenantIdMaxAnalyticsEnabledDesc = 'TEAMS_BY_TENANT_ID__MAX_ANALYTICS_ENABLED_DESC',
  TeamsByTenantIdMaxAssignIfExternalGroupsMatchAllOfAsc = 'TEAMS_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamsByTenantIdMaxAssignIfExternalGroupsMatchAllOfDesc = 'TEAMS_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamsByTenantIdMaxAssignIfExternalGroupsMatchOneOfAsc = 'TEAMS_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamsByTenantIdMaxAssignIfExternalGroupsMatchOneOfDesc = 'TEAMS_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamsByTenantIdMaxCreatedAtAsc = 'TEAMS_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  TeamsByTenantIdMaxCreatedAtDesc = 'TEAMS_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  TeamsByTenantIdMaxFlagsAsc = 'TEAMS_BY_TENANT_ID__MAX_FLAGS_ASC',
  TeamsByTenantIdMaxFlagsDesc = 'TEAMS_BY_TENANT_ID__MAX_FLAGS_DESC',
  TeamsByTenantIdMaxIdAsc = 'TEAMS_BY_TENANT_ID__MAX_ID_ASC',
  TeamsByTenantIdMaxIdDesc = 'TEAMS_BY_TENANT_ID__MAX_ID_DESC',
  TeamsByTenantIdMaxIsOpenAsc = 'TEAMS_BY_TENANT_ID__MAX_IS_OPEN_ASC',
  TeamsByTenantIdMaxIsOpenDesc = 'TEAMS_BY_TENANT_ID__MAX_IS_OPEN_DESC',
  TeamsByTenantIdMaxIsVisibleAsc = 'TEAMS_BY_TENANT_ID__MAX_IS_VISIBLE_ASC',
  TeamsByTenantIdMaxIsVisibleDesc = 'TEAMS_BY_TENANT_ID__MAX_IS_VISIBLE_DESC',
  TeamsByTenantIdMaxNameAsc = 'TEAMS_BY_TENANT_ID__MAX_NAME_ASC',
  TeamsByTenantIdMaxNameDesc = 'TEAMS_BY_TENANT_ID__MAX_NAME_DESC',
  TeamsByTenantIdMaxNameLowercaseAsc = 'TEAMS_BY_TENANT_ID__MAX_NAME_LOWERCASE_ASC',
  TeamsByTenantIdMaxNameLowercaseDesc = 'TEAMS_BY_TENANT_ID__MAX_NAME_LOWERCASE_DESC',
  TeamsByTenantIdMaxSysPeriodAsc = 'TEAMS_BY_TENANT_ID__MAX_SYS_PERIOD_ASC',
  TeamsByTenantIdMaxSysPeriodDesc = 'TEAMS_BY_TENANT_ID__MAX_SYS_PERIOD_DESC',
  TeamsByTenantIdMaxTenantIdAsc = 'TEAMS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  TeamsByTenantIdMaxTenantIdDesc = 'TEAMS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  TeamsByTenantIdMaxUpdatedAtAsc = 'TEAMS_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  TeamsByTenantIdMaxUpdatedAtDesc = 'TEAMS_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  TeamsByTenantIdMaxUserConfigDefaultsAsc = 'TEAMS_BY_TENANT_ID__MAX_USER_CONFIG_DEFAULTS_ASC',
  TeamsByTenantIdMaxUserConfigDefaultsDesc = 'TEAMS_BY_TENANT_ID__MAX_USER_CONFIG_DEFAULTS_DESC',
  TeamsByTenantIdMinAnalyticsAliasAsc = 'TEAMS_BY_TENANT_ID__MIN_ANALYTICS_ALIAS_ASC',
  TeamsByTenantIdMinAnalyticsAliasDesc = 'TEAMS_BY_TENANT_ID__MIN_ANALYTICS_ALIAS_DESC',
  TeamsByTenantIdMinAnalyticsEnabledAsc = 'TEAMS_BY_TENANT_ID__MIN_ANALYTICS_ENABLED_ASC',
  TeamsByTenantIdMinAnalyticsEnabledDesc = 'TEAMS_BY_TENANT_ID__MIN_ANALYTICS_ENABLED_DESC',
  TeamsByTenantIdMinAssignIfExternalGroupsMatchAllOfAsc = 'TEAMS_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamsByTenantIdMinAssignIfExternalGroupsMatchAllOfDesc = 'TEAMS_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamsByTenantIdMinAssignIfExternalGroupsMatchOneOfAsc = 'TEAMS_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamsByTenantIdMinAssignIfExternalGroupsMatchOneOfDesc = 'TEAMS_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamsByTenantIdMinCreatedAtAsc = 'TEAMS_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  TeamsByTenantIdMinCreatedAtDesc = 'TEAMS_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  TeamsByTenantIdMinFlagsAsc = 'TEAMS_BY_TENANT_ID__MIN_FLAGS_ASC',
  TeamsByTenantIdMinFlagsDesc = 'TEAMS_BY_TENANT_ID__MIN_FLAGS_DESC',
  TeamsByTenantIdMinIdAsc = 'TEAMS_BY_TENANT_ID__MIN_ID_ASC',
  TeamsByTenantIdMinIdDesc = 'TEAMS_BY_TENANT_ID__MIN_ID_DESC',
  TeamsByTenantIdMinIsOpenAsc = 'TEAMS_BY_TENANT_ID__MIN_IS_OPEN_ASC',
  TeamsByTenantIdMinIsOpenDesc = 'TEAMS_BY_TENANT_ID__MIN_IS_OPEN_DESC',
  TeamsByTenantIdMinIsVisibleAsc = 'TEAMS_BY_TENANT_ID__MIN_IS_VISIBLE_ASC',
  TeamsByTenantIdMinIsVisibleDesc = 'TEAMS_BY_TENANT_ID__MIN_IS_VISIBLE_DESC',
  TeamsByTenantIdMinNameAsc = 'TEAMS_BY_TENANT_ID__MIN_NAME_ASC',
  TeamsByTenantIdMinNameDesc = 'TEAMS_BY_TENANT_ID__MIN_NAME_DESC',
  TeamsByTenantIdMinNameLowercaseAsc = 'TEAMS_BY_TENANT_ID__MIN_NAME_LOWERCASE_ASC',
  TeamsByTenantIdMinNameLowercaseDesc = 'TEAMS_BY_TENANT_ID__MIN_NAME_LOWERCASE_DESC',
  TeamsByTenantIdMinSysPeriodAsc = 'TEAMS_BY_TENANT_ID__MIN_SYS_PERIOD_ASC',
  TeamsByTenantIdMinSysPeriodDesc = 'TEAMS_BY_TENANT_ID__MIN_SYS_PERIOD_DESC',
  TeamsByTenantIdMinTenantIdAsc = 'TEAMS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  TeamsByTenantIdMinTenantIdDesc = 'TEAMS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  TeamsByTenantIdMinUpdatedAtAsc = 'TEAMS_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  TeamsByTenantIdMinUpdatedAtDesc = 'TEAMS_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  TeamsByTenantIdMinUserConfigDefaultsAsc = 'TEAMS_BY_TENANT_ID__MIN_USER_CONFIG_DEFAULTS_ASC',
  TeamsByTenantIdMinUserConfigDefaultsDesc = 'TEAMS_BY_TENANT_ID__MIN_USER_CONFIG_DEFAULTS_DESC',
  TutorialWorkspaceIdAsc = 'TUTORIAL_WORKSPACE_ID_ASC',
  TutorialWorkspaceIdDesc = 'TUTORIAL_WORKSPACE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsersByTenantIdCountAsc = 'USERS_BY_TENANT_ID__COUNT_ASC',
  UsersByTenantIdCountDesc = 'USERS_BY_TENANT_ID__COUNT_DESC',
  UsersByTenantIdMaxAppConsentGivenAtAsc = 'USERS_BY_TENANT_ID__MAX_APP_CONSENT_GIVEN_AT_ASC',
  UsersByTenantIdMaxAppConsentGivenAtDesc = 'USERS_BY_TENANT_ID__MAX_APP_CONSENT_GIVEN_AT_DESC',
  UsersByTenantIdMaxConfigAsc = 'USERS_BY_TENANT_ID__MAX_CONFIG_ASC',
  UsersByTenantIdMaxConfigDesc = 'USERS_BY_TENANT_ID__MAX_CONFIG_DESC',
  UsersByTenantIdMaxCreatedAtAsc = 'USERS_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  UsersByTenantIdMaxCreatedAtDesc = 'USERS_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  UsersByTenantIdMaxCrmContactVisibilityFilterAsc = 'USERS_BY_TENANT_ID__MAX_CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UsersByTenantIdMaxCrmContactVisibilityFilterDesc = 'USERS_BY_TENANT_ID__MAX_CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UsersByTenantIdMaxDefaultWorkspaceIdAsc = 'USERS_BY_TENANT_ID__MAX_DEFAULT_WORKSPACE_ID_ASC',
  UsersByTenantIdMaxDefaultWorkspaceIdDesc = 'USERS_BY_TENANT_ID__MAX_DEFAULT_WORKSPACE_ID_DESC',
  UsersByTenantIdMaxDisabledAsc = 'USERS_BY_TENANT_ID__MAX_DISABLED_ASC',
  UsersByTenantIdMaxDisabledDesc = 'USERS_BY_TENANT_ID__MAX_DISABLED_DESC',
  UsersByTenantIdMaxDisplayNameAsc = 'USERS_BY_TENANT_ID__MAX_DISPLAY_NAME_ASC',
  UsersByTenantIdMaxDisplayNameDesc = 'USERS_BY_TENANT_ID__MAX_DISPLAY_NAME_DESC',
  UsersByTenantIdMaxEmailAsc = 'USERS_BY_TENANT_ID__MAX_EMAIL_ASC',
  UsersByTenantIdMaxEmailDesc = 'USERS_BY_TENANT_ID__MAX_EMAIL_DESC',
  UsersByTenantIdMaxExternalGroupsAsc = 'USERS_BY_TENANT_ID__MAX_EXTERNAL_GROUPS_ASC',
  UsersByTenantIdMaxExternalGroupsDesc = 'USERS_BY_TENANT_ID__MAX_EXTERNAL_GROUPS_DESC',
  UsersByTenantIdMaxExternalGroupsSyncedAtAsc = 'USERS_BY_TENANT_ID__MAX_EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UsersByTenantIdMaxExternalGroupsSyncedAtDesc = 'USERS_BY_TENANT_ID__MAX_EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UsersByTenantIdMaxFirebaseAuthIdAsc = 'USERS_BY_TENANT_ID__MAX_FIREBASE_AUTH_ID_ASC',
  UsersByTenantIdMaxFirebaseAuthIdDesc = 'USERS_BY_TENANT_ID__MAX_FIREBASE_AUTH_ID_DESC',
  UsersByTenantIdMaxFlagsAsc = 'USERS_BY_TENANT_ID__MAX_FLAGS_ASC',
  UsersByTenantIdMaxFlagsDesc = 'USERS_BY_TENANT_ID__MAX_FLAGS_DESC',
  UsersByTenantIdMaxIdAsc = 'USERS_BY_TENANT_ID__MAX_ID_ASC',
  UsersByTenantIdMaxIdDesc = 'USERS_BY_TENANT_ID__MAX_ID_DESC',
  UsersByTenantIdMaxIsTenantAdminAsc = 'USERS_BY_TENANT_ID__MAX_IS_TENANT_ADMIN_ASC',
  UsersByTenantIdMaxIsTenantAdminDesc = 'USERS_BY_TENANT_ID__MAX_IS_TENANT_ADMIN_DESC',
  UsersByTenantIdMaxRegisteredAtAsc = 'USERS_BY_TENANT_ID__MAX_REGISTERED_AT_ASC',
  UsersByTenantIdMaxRegisteredAtDesc = 'USERS_BY_TENANT_ID__MAX_REGISTERED_AT_DESC',
  UsersByTenantIdMaxSysPeriodAsc = 'USERS_BY_TENANT_ID__MAX_SYS_PERIOD_ASC',
  UsersByTenantIdMaxSysPeriodDesc = 'USERS_BY_TENANT_ID__MAX_SYS_PERIOD_DESC',
  UsersByTenantIdMaxTenantIdAsc = 'USERS_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  UsersByTenantIdMaxTenantIdDesc = 'USERS_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  UsersByTenantIdMaxUpdatedAtAsc = 'USERS_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  UsersByTenantIdMaxUpdatedAtDesc = 'USERS_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  UsersByTenantIdMinAppConsentGivenAtAsc = 'USERS_BY_TENANT_ID__MIN_APP_CONSENT_GIVEN_AT_ASC',
  UsersByTenantIdMinAppConsentGivenAtDesc = 'USERS_BY_TENANT_ID__MIN_APP_CONSENT_GIVEN_AT_DESC',
  UsersByTenantIdMinConfigAsc = 'USERS_BY_TENANT_ID__MIN_CONFIG_ASC',
  UsersByTenantIdMinConfigDesc = 'USERS_BY_TENANT_ID__MIN_CONFIG_DESC',
  UsersByTenantIdMinCreatedAtAsc = 'USERS_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  UsersByTenantIdMinCreatedAtDesc = 'USERS_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  UsersByTenantIdMinCrmContactVisibilityFilterAsc = 'USERS_BY_TENANT_ID__MIN_CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UsersByTenantIdMinCrmContactVisibilityFilterDesc = 'USERS_BY_TENANT_ID__MIN_CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UsersByTenantIdMinDefaultWorkspaceIdAsc = 'USERS_BY_TENANT_ID__MIN_DEFAULT_WORKSPACE_ID_ASC',
  UsersByTenantIdMinDefaultWorkspaceIdDesc = 'USERS_BY_TENANT_ID__MIN_DEFAULT_WORKSPACE_ID_DESC',
  UsersByTenantIdMinDisabledAsc = 'USERS_BY_TENANT_ID__MIN_DISABLED_ASC',
  UsersByTenantIdMinDisabledDesc = 'USERS_BY_TENANT_ID__MIN_DISABLED_DESC',
  UsersByTenantIdMinDisplayNameAsc = 'USERS_BY_TENANT_ID__MIN_DISPLAY_NAME_ASC',
  UsersByTenantIdMinDisplayNameDesc = 'USERS_BY_TENANT_ID__MIN_DISPLAY_NAME_DESC',
  UsersByTenantIdMinEmailAsc = 'USERS_BY_TENANT_ID__MIN_EMAIL_ASC',
  UsersByTenantIdMinEmailDesc = 'USERS_BY_TENANT_ID__MIN_EMAIL_DESC',
  UsersByTenantIdMinExternalGroupsAsc = 'USERS_BY_TENANT_ID__MIN_EXTERNAL_GROUPS_ASC',
  UsersByTenantIdMinExternalGroupsDesc = 'USERS_BY_TENANT_ID__MIN_EXTERNAL_GROUPS_DESC',
  UsersByTenantIdMinExternalGroupsSyncedAtAsc = 'USERS_BY_TENANT_ID__MIN_EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UsersByTenantIdMinExternalGroupsSyncedAtDesc = 'USERS_BY_TENANT_ID__MIN_EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UsersByTenantIdMinFirebaseAuthIdAsc = 'USERS_BY_TENANT_ID__MIN_FIREBASE_AUTH_ID_ASC',
  UsersByTenantIdMinFirebaseAuthIdDesc = 'USERS_BY_TENANT_ID__MIN_FIREBASE_AUTH_ID_DESC',
  UsersByTenantIdMinFlagsAsc = 'USERS_BY_TENANT_ID__MIN_FLAGS_ASC',
  UsersByTenantIdMinFlagsDesc = 'USERS_BY_TENANT_ID__MIN_FLAGS_DESC',
  UsersByTenantIdMinIdAsc = 'USERS_BY_TENANT_ID__MIN_ID_ASC',
  UsersByTenantIdMinIdDesc = 'USERS_BY_TENANT_ID__MIN_ID_DESC',
  UsersByTenantIdMinIsTenantAdminAsc = 'USERS_BY_TENANT_ID__MIN_IS_TENANT_ADMIN_ASC',
  UsersByTenantIdMinIsTenantAdminDesc = 'USERS_BY_TENANT_ID__MIN_IS_TENANT_ADMIN_DESC',
  UsersByTenantIdMinRegisteredAtAsc = 'USERS_BY_TENANT_ID__MIN_REGISTERED_AT_ASC',
  UsersByTenantIdMinRegisteredAtDesc = 'USERS_BY_TENANT_ID__MIN_REGISTERED_AT_DESC',
  UsersByTenantIdMinSysPeriodAsc = 'USERS_BY_TENANT_ID__MIN_SYS_PERIOD_ASC',
  UsersByTenantIdMinSysPeriodDesc = 'USERS_BY_TENANT_ID__MIN_SYS_PERIOD_DESC',
  UsersByTenantIdMinTenantIdAsc = 'USERS_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  UsersByTenantIdMinTenantIdDesc = 'USERS_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  UsersByTenantIdMinUpdatedAtAsc = 'USERS_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  UsersByTenantIdMinUpdatedAtDesc = 'USERS_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  UserConfigDefaultsAsc = 'USER_CONFIG_DEFAULTS_ASC',
  UserConfigDefaultsDesc = 'USER_CONFIG_DEFAULTS_DESC',
  WorkspacesByTenantIdCountAsc = 'WORKSPACES_BY_TENANT_ID__COUNT_ASC',
  WorkspacesByTenantIdCountDesc = 'WORKSPACES_BY_TENANT_ID__COUNT_DESC',
  WorkspacesByTenantIdMaxAnalyticsAliasAsc = 'WORKSPACES_BY_TENANT_ID__MAX_ANALYTICS_ALIAS_ASC',
  WorkspacesByTenantIdMaxAnalyticsAliasDesc = 'WORKSPACES_BY_TENANT_ID__MAX_ANALYTICS_ALIAS_DESC',
  WorkspacesByTenantIdMaxAnalyticsEnabledAsc = 'WORKSPACES_BY_TENANT_ID__MAX_ANALYTICS_ENABLED_ASC',
  WorkspacesByTenantIdMaxAnalyticsEnabledDesc = 'WORKSPACES_BY_TENANT_ID__MAX_ANALYTICS_ENABLED_DESC',
  WorkspacesByTenantIdMaxAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByTenantIdMaxAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByTenantIdMaxAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByTenantIdMaxAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_TENANT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByTenantIdMaxConfigAsc = 'WORKSPACES_BY_TENANT_ID__MAX_CONFIG_ASC',
  WorkspacesByTenantIdMaxConfigDesc = 'WORKSPACES_BY_TENANT_ID__MAX_CONFIG_DESC',
  WorkspacesByTenantIdMaxCreatedAtAsc = 'WORKSPACES_BY_TENANT_ID__MAX_CREATED_AT_ASC',
  WorkspacesByTenantIdMaxCreatedAtDesc = 'WORKSPACES_BY_TENANT_ID__MAX_CREATED_AT_DESC',
  WorkspacesByTenantIdMaxCustomBrandUrlAsc = 'WORKSPACES_BY_TENANT_ID__MAX_CUSTOM_BRAND_URL_ASC',
  WorkspacesByTenantIdMaxCustomBrandUrlDesc = 'WORKSPACES_BY_TENANT_ID__MAX_CUSTOM_BRAND_URL_DESC',
  WorkspacesByTenantIdMaxCustomShareLinkAsc = 'WORKSPACES_BY_TENANT_ID__MAX_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByTenantIdMaxCustomShareLinkDesc = 'WORKSPACES_BY_TENANT_ID__MAX_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByTenantIdMaxDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_TENANT_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByTenantIdMaxDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_TENANT_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByTenantIdMaxEmailSubjectAsc = 'WORKSPACES_BY_TENANT_ID__MAX_EMAIL_SUBJECT_ASC',
  WorkspacesByTenantIdMaxEmailSubjectDesc = 'WORKSPACES_BY_TENANT_ID__MAX_EMAIL_SUBJECT_DESC',
  WorkspacesByTenantIdMaxEmailTextAsc = 'WORKSPACES_BY_TENANT_ID__MAX_EMAIL_TEXT_ASC',
  WorkspacesByTenantIdMaxEmailTextDesc = 'WORKSPACES_BY_TENANT_ID__MAX_EMAIL_TEXT_DESC',
  WorkspacesByTenantIdMaxFirebaseIdAsc = 'WORKSPACES_BY_TENANT_ID__MAX_FIREBASE_ID_ASC',
  WorkspacesByTenantIdMaxFirebaseIdDesc = 'WORKSPACES_BY_TENANT_ID__MAX_FIREBASE_ID_DESC',
  WorkspacesByTenantIdMaxFlagsAsc = 'WORKSPACES_BY_TENANT_ID__MAX_FLAGS_ASC',
  WorkspacesByTenantIdMaxFlagsDesc = 'WORKSPACES_BY_TENANT_ID__MAX_FLAGS_DESC',
  WorkspacesByTenantIdMaxHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_TENANT_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByTenantIdMaxHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_TENANT_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByTenantIdMaxIdAsc = 'WORKSPACES_BY_TENANT_ID__MAX_ID_ASC',
  WorkspacesByTenantIdMaxIdDesc = 'WORKSPACES_BY_TENANT_ID__MAX_ID_DESC',
  WorkspacesByTenantIdMaxIsOpenAsc = 'WORKSPACES_BY_TENANT_ID__MAX_IS_OPEN_ASC',
  WorkspacesByTenantIdMaxIsOpenDesc = 'WORKSPACES_BY_TENANT_ID__MAX_IS_OPEN_DESC',
  WorkspacesByTenantIdMaxIsVisibleAsc = 'WORKSPACES_BY_TENANT_ID__MAX_IS_VISIBLE_ASC',
  WorkspacesByTenantIdMaxIsVisibleDesc = 'WORKSPACES_BY_TENANT_ID__MAX_IS_VISIBLE_DESC',
  WorkspacesByTenantIdMaxLaserPointerPositionAsc = 'WORKSPACES_BY_TENANT_ID__MAX_LASER_POINTER_POSITION_ASC',
  WorkspacesByTenantIdMaxLaserPointerPositionDesc = 'WORKSPACES_BY_TENANT_ID__MAX_LASER_POINTER_POSITION_DESC',
  WorkspacesByTenantIdMaxLinkPanelPositionAsc = 'WORKSPACES_BY_TENANT_ID__MAX_LINK_PANEL_POSITION_ASC',
  WorkspacesByTenantIdMaxLinkPanelPositionDesc = 'WORKSPACES_BY_TENANT_ID__MAX_LINK_PANEL_POSITION_DESC',
  WorkspacesByTenantIdMaxNameAsc = 'WORKSPACES_BY_TENANT_ID__MAX_NAME_ASC',
  WorkspacesByTenantIdMaxNameDesc = 'WORKSPACES_BY_TENANT_ID__MAX_NAME_DESC',
  WorkspacesByTenantIdMaxNameLowercaseAsc = 'WORKSPACES_BY_TENANT_ID__MAX_NAME_LOWERCASE_ASC',
  WorkspacesByTenantIdMaxNameLowercaseDesc = 'WORKSPACES_BY_TENANT_ID__MAX_NAME_LOWERCASE_DESC',
  WorkspacesByTenantIdMaxParentIdAsc = 'WORKSPACES_BY_TENANT_ID__MAX_PARENT_ID_ASC',
  WorkspacesByTenantIdMaxParentIdDesc = 'WORKSPACES_BY_TENANT_ID__MAX_PARENT_ID_DESC',
  WorkspacesByTenantIdMaxPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_TENANT_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByTenantIdMaxPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_TENANT_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByTenantIdMaxSysPeriodAsc = 'WORKSPACES_BY_TENANT_ID__MAX_SYS_PERIOD_ASC',
  WorkspacesByTenantIdMaxSysPeriodDesc = 'WORKSPACES_BY_TENANT_ID__MAX_SYS_PERIOD_DESC',
  WorkspacesByTenantIdMaxTagsAsc = 'WORKSPACES_BY_TENANT_ID__MAX_TAGS_ASC',
  WorkspacesByTenantIdMaxTagsDesc = 'WORKSPACES_BY_TENANT_ID__MAX_TAGS_DESC',
  WorkspacesByTenantIdMaxTeamRankAsc = 'WORKSPACES_BY_TENANT_ID__MAX_TEAM_RANK_ASC',
  WorkspacesByTenantIdMaxTeamRankDesc = 'WORKSPACES_BY_TENANT_ID__MAX_TEAM_RANK_DESC',
  WorkspacesByTenantIdMaxTenantIdAsc = 'WORKSPACES_BY_TENANT_ID__MAX_TENANT_ID_ASC',
  WorkspacesByTenantIdMaxTenantIdDesc = 'WORKSPACES_BY_TENANT_ID__MAX_TENANT_ID_DESC',
  WorkspacesByTenantIdMaxUpdatedAtAsc = 'WORKSPACES_BY_TENANT_ID__MAX_UPDATED_AT_ASC',
  WorkspacesByTenantIdMaxUpdatedAtDesc = 'WORKSPACES_BY_TENANT_ID__MAX_UPDATED_AT_DESC',
  WorkspacesByTenantIdMaxUserConfigDefaultsAsc = 'WORKSPACES_BY_TENANT_ID__MAX_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByTenantIdMaxUserConfigDefaultsDesc = 'WORKSPACES_BY_TENANT_ID__MAX_USER_CONFIG_DEFAULTS_DESC',
  WorkspacesByTenantIdMinAnalyticsAliasAsc = 'WORKSPACES_BY_TENANT_ID__MIN_ANALYTICS_ALIAS_ASC',
  WorkspacesByTenantIdMinAnalyticsAliasDesc = 'WORKSPACES_BY_TENANT_ID__MIN_ANALYTICS_ALIAS_DESC',
  WorkspacesByTenantIdMinAnalyticsEnabledAsc = 'WORKSPACES_BY_TENANT_ID__MIN_ANALYTICS_ENABLED_ASC',
  WorkspacesByTenantIdMinAnalyticsEnabledDesc = 'WORKSPACES_BY_TENANT_ID__MIN_ANALYTICS_ENABLED_DESC',
  WorkspacesByTenantIdMinAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByTenantIdMinAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByTenantIdMinAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByTenantIdMinAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_TENANT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByTenantIdMinConfigAsc = 'WORKSPACES_BY_TENANT_ID__MIN_CONFIG_ASC',
  WorkspacesByTenantIdMinConfigDesc = 'WORKSPACES_BY_TENANT_ID__MIN_CONFIG_DESC',
  WorkspacesByTenantIdMinCreatedAtAsc = 'WORKSPACES_BY_TENANT_ID__MIN_CREATED_AT_ASC',
  WorkspacesByTenantIdMinCreatedAtDesc = 'WORKSPACES_BY_TENANT_ID__MIN_CREATED_AT_DESC',
  WorkspacesByTenantIdMinCustomBrandUrlAsc = 'WORKSPACES_BY_TENANT_ID__MIN_CUSTOM_BRAND_URL_ASC',
  WorkspacesByTenantIdMinCustomBrandUrlDesc = 'WORKSPACES_BY_TENANT_ID__MIN_CUSTOM_BRAND_URL_DESC',
  WorkspacesByTenantIdMinCustomShareLinkAsc = 'WORKSPACES_BY_TENANT_ID__MIN_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByTenantIdMinCustomShareLinkDesc = 'WORKSPACES_BY_TENANT_ID__MIN_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByTenantIdMinDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_TENANT_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByTenantIdMinDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_TENANT_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByTenantIdMinEmailSubjectAsc = 'WORKSPACES_BY_TENANT_ID__MIN_EMAIL_SUBJECT_ASC',
  WorkspacesByTenantIdMinEmailSubjectDesc = 'WORKSPACES_BY_TENANT_ID__MIN_EMAIL_SUBJECT_DESC',
  WorkspacesByTenantIdMinEmailTextAsc = 'WORKSPACES_BY_TENANT_ID__MIN_EMAIL_TEXT_ASC',
  WorkspacesByTenantIdMinEmailTextDesc = 'WORKSPACES_BY_TENANT_ID__MIN_EMAIL_TEXT_DESC',
  WorkspacesByTenantIdMinFirebaseIdAsc = 'WORKSPACES_BY_TENANT_ID__MIN_FIREBASE_ID_ASC',
  WorkspacesByTenantIdMinFirebaseIdDesc = 'WORKSPACES_BY_TENANT_ID__MIN_FIREBASE_ID_DESC',
  WorkspacesByTenantIdMinFlagsAsc = 'WORKSPACES_BY_TENANT_ID__MIN_FLAGS_ASC',
  WorkspacesByTenantIdMinFlagsDesc = 'WORKSPACES_BY_TENANT_ID__MIN_FLAGS_DESC',
  WorkspacesByTenantIdMinHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_TENANT_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByTenantIdMinHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_TENANT_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByTenantIdMinIdAsc = 'WORKSPACES_BY_TENANT_ID__MIN_ID_ASC',
  WorkspacesByTenantIdMinIdDesc = 'WORKSPACES_BY_TENANT_ID__MIN_ID_DESC',
  WorkspacesByTenantIdMinIsOpenAsc = 'WORKSPACES_BY_TENANT_ID__MIN_IS_OPEN_ASC',
  WorkspacesByTenantIdMinIsOpenDesc = 'WORKSPACES_BY_TENANT_ID__MIN_IS_OPEN_DESC',
  WorkspacesByTenantIdMinIsVisibleAsc = 'WORKSPACES_BY_TENANT_ID__MIN_IS_VISIBLE_ASC',
  WorkspacesByTenantIdMinIsVisibleDesc = 'WORKSPACES_BY_TENANT_ID__MIN_IS_VISIBLE_DESC',
  WorkspacesByTenantIdMinLaserPointerPositionAsc = 'WORKSPACES_BY_TENANT_ID__MIN_LASER_POINTER_POSITION_ASC',
  WorkspacesByTenantIdMinLaserPointerPositionDesc = 'WORKSPACES_BY_TENANT_ID__MIN_LASER_POINTER_POSITION_DESC',
  WorkspacesByTenantIdMinLinkPanelPositionAsc = 'WORKSPACES_BY_TENANT_ID__MIN_LINK_PANEL_POSITION_ASC',
  WorkspacesByTenantIdMinLinkPanelPositionDesc = 'WORKSPACES_BY_TENANT_ID__MIN_LINK_PANEL_POSITION_DESC',
  WorkspacesByTenantIdMinNameAsc = 'WORKSPACES_BY_TENANT_ID__MIN_NAME_ASC',
  WorkspacesByTenantIdMinNameDesc = 'WORKSPACES_BY_TENANT_ID__MIN_NAME_DESC',
  WorkspacesByTenantIdMinNameLowercaseAsc = 'WORKSPACES_BY_TENANT_ID__MIN_NAME_LOWERCASE_ASC',
  WorkspacesByTenantIdMinNameLowercaseDesc = 'WORKSPACES_BY_TENANT_ID__MIN_NAME_LOWERCASE_DESC',
  WorkspacesByTenantIdMinParentIdAsc = 'WORKSPACES_BY_TENANT_ID__MIN_PARENT_ID_ASC',
  WorkspacesByTenantIdMinParentIdDesc = 'WORKSPACES_BY_TENANT_ID__MIN_PARENT_ID_DESC',
  WorkspacesByTenantIdMinPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_TENANT_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByTenantIdMinPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_TENANT_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByTenantIdMinSysPeriodAsc = 'WORKSPACES_BY_TENANT_ID__MIN_SYS_PERIOD_ASC',
  WorkspacesByTenantIdMinSysPeriodDesc = 'WORKSPACES_BY_TENANT_ID__MIN_SYS_PERIOD_DESC',
  WorkspacesByTenantIdMinTagsAsc = 'WORKSPACES_BY_TENANT_ID__MIN_TAGS_ASC',
  WorkspacesByTenantIdMinTagsDesc = 'WORKSPACES_BY_TENANT_ID__MIN_TAGS_DESC',
  WorkspacesByTenantIdMinTeamRankAsc = 'WORKSPACES_BY_TENANT_ID__MIN_TEAM_RANK_ASC',
  WorkspacesByTenantIdMinTeamRankDesc = 'WORKSPACES_BY_TENANT_ID__MIN_TEAM_RANK_DESC',
  WorkspacesByTenantIdMinTenantIdAsc = 'WORKSPACES_BY_TENANT_ID__MIN_TENANT_ID_ASC',
  WorkspacesByTenantIdMinTenantIdDesc = 'WORKSPACES_BY_TENANT_ID__MIN_TENANT_ID_DESC',
  WorkspacesByTenantIdMinUpdatedAtAsc = 'WORKSPACES_BY_TENANT_ID__MIN_UPDATED_AT_ASC',
  WorkspacesByTenantIdMinUpdatedAtDesc = 'WORKSPACES_BY_TENANT_ID__MIN_UPDATED_AT_DESC',
  WorkspacesByTenantIdMinUserConfigDefaultsAsc = 'WORKSPACES_BY_TENANT_ID__MIN_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByTenantIdMinUserConfigDefaultsDesc = 'WORKSPACES_BY_TENANT_ID__MIN_USER_CONFIG_DEFAULTS_DESC',
  WorkspaceByTutorialWorkspaceIdAnalyticsAliasAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByTutorialWorkspaceIdAnalyticsAliasDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByTutorialWorkspaceIdAnalyticsEnabledAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByTutorialWorkspaceIdAnalyticsEnabledDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByTutorialWorkspaceIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByTutorialWorkspaceIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByTutorialWorkspaceIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByTutorialWorkspaceIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByTutorialWorkspaceIdConfigAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CONFIG_ASC',
  WorkspaceByTutorialWorkspaceIdConfigDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CONFIG_DESC',
  WorkspaceByTutorialWorkspaceIdCreatedAtAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CREATED_AT_ASC',
  WorkspaceByTutorialWorkspaceIdCreatedAtDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CREATED_AT_DESC',
  WorkspaceByTutorialWorkspaceIdCustomBrandUrlAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByTutorialWorkspaceIdCustomBrandUrlDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByTutorialWorkspaceIdCustomShareLinkAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByTutorialWorkspaceIdCustomShareLinkDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByTutorialWorkspaceIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByTutorialWorkspaceIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByTutorialWorkspaceIdEmailSubjectAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByTutorialWorkspaceIdEmailSubjectDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByTutorialWorkspaceIdEmailTextAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__EMAIL_TEXT_ASC',
  WorkspaceByTutorialWorkspaceIdEmailTextDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__EMAIL_TEXT_DESC',
  WorkspaceByTutorialWorkspaceIdFirebaseIdAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__FIREBASE_ID_ASC',
  WorkspaceByTutorialWorkspaceIdFirebaseIdDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__FIREBASE_ID_DESC',
  WorkspaceByTutorialWorkspaceIdFlagsAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__FLAGS_ASC',
  WorkspaceByTutorialWorkspaceIdFlagsDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__FLAGS_DESC',
  WorkspaceByTutorialWorkspaceIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByTutorialWorkspaceIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByTutorialWorkspaceIdIdAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ID_ASC',
  WorkspaceByTutorialWorkspaceIdIdDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__ID_DESC',
  WorkspaceByTutorialWorkspaceIdIsOpenAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__IS_OPEN_ASC',
  WorkspaceByTutorialWorkspaceIdIsOpenDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__IS_OPEN_DESC',
  WorkspaceByTutorialWorkspaceIdIsVisibleAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__IS_VISIBLE_ASC',
  WorkspaceByTutorialWorkspaceIdIsVisibleDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__IS_VISIBLE_DESC',
  WorkspaceByTutorialWorkspaceIdLaserPointerPositionAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByTutorialWorkspaceIdLaserPointerPositionDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByTutorialWorkspaceIdLinkPanelPositionAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByTutorialWorkspaceIdLinkPanelPositionDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByTutorialWorkspaceIdMemberCountAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__MEMBER_COUNT_ASC',
  WorkspaceByTutorialWorkspaceIdMemberCountDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__MEMBER_COUNT_DESC',
  WorkspaceByTutorialWorkspaceIdNameAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__NAME_ASC',
  WorkspaceByTutorialWorkspaceIdNameDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__NAME_DESC',
  WorkspaceByTutorialWorkspaceIdNameLowercaseAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__NAME_LOWERCASE_ASC',
  WorkspaceByTutorialWorkspaceIdNameLowercaseDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__NAME_LOWERCASE_DESC',
  WorkspaceByTutorialWorkspaceIdParentIdAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__PARENT_ID_ASC',
  WorkspaceByTutorialWorkspaceIdParentIdDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__PARENT_ID_DESC',
  WorkspaceByTutorialWorkspaceIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByTutorialWorkspaceIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByTutorialWorkspaceIdSysPeriodAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__SYS_PERIOD_ASC',
  WorkspaceByTutorialWorkspaceIdSysPeriodDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__SYS_PERIOD_DESC',
  WorkspaceByTutorialWorkspaceIdTagsAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TAGS_ASC',
  WorkspaceByTutorialWorkspaceIdTagsDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TAGS_DESC',
  WorkspaceByTutorialWorkspaceIdTeamRankAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TEAM_RANK_ASC',
  WorkspaceByTutorialWorkspaceIdTeamRankDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TEAM_RANK_DESC',
  WorkspaceByTutorialWorkspaceIdTenantIdAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TENANT_ID_ASC',
  WorkspaceByTutorialWorkspaceIdTenantIdDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TENANT_ID_DESC',
  WorkspaceByTutorialWorkspaceIdTotalMemberCountAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByTutorialWorkspaceIdTotalMemberCountDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByTutorialWorkspaceIdUpdatedAtAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__UPDATED_AT_ASC',
  WorkspaceByTutorialWorkspaceIdUpdatedAtDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__UPDATED_AT_DESC',
  WorkspaceByTutorialWorkspaceIdUserConfigDefaultsAsc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByTutorialWorkspaceIdUserConfigDefaultsDesc = 'WORKSPACE_BY_TUTORIAL_WORKSPACE_ID__USER_CONFIG_DEFAULTS_DESC'
}

/** All input for the `transferOwnershipOfSpace` mutation. */
export type TransferOwnershipOfSpaceInput = {
  accessId?: InputMaybe<Scalars['BigInt']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `transferOwnershipOfSpace` mutation. */
export type TransferOwnershipOfSpacePayload = {
  __typename?: 'TransferOwnershipOfSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  creator?: Maybe<User>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceAccess`. */
  documentSpace?: Maybe<DocumentSpace>;
  documentSpaceAccess?: Maybe<DocumentSpaceAccess>;
  /** An edge for our `DocumentSpaceAccess`. May be used by Relay 1. */
  documentSpaceAccessEdge?: Maybe<DocumentSpaceAccessesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  user?: Maybe<User>;
};


/** The output of our `transferOwnershipOfSpace` mutation. */
export type TransferOwnershipOfSpacePayloadDocumentSpaceAccessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `unregisterMe` mutation. */
export type UnregisterMeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `unregisterMe` mutation. */
export type UnregisterMePayload = {
  __typename?: 'UnregisterMePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Workspace` that is related to this `User`. */
  defaultWorkspace?: Maybe<Workspace>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  user?: Maybe<User>;
  /** Reads a single `UserContactDetail` that is related to this `User`. */
  userContactDetailById?: Maybe<UserContactDetail>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `unregisterMe` mutation. */
export type UnregisterMePayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `unregisterUser` mutation. */
export type UnregisterUserInput = {
  byId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `unregisterUser` mutation. */
export type UnregisterUserPayload = {
  __typename?: 'UnregisterUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Workspace` that is related to this `User`. */
  defaultWorkspace?: Maybe<Workspace>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  user?: Maybe<User>;
  /** Reads a single `UserContactDetail` that is related to this `User`. */
  userContactDetailById?: Maybe<UserContactDetail>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `unregisterUser` mutation. */
export type UnregisterUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateArInternalMetadatumByNodeId` mutation. */
export type UpdateArInternalMetadatumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ArInternalMetadatum` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ArInternalMetadatum` being updated. */
  patch: ArInternalMetadatumPatch;
};

/** All input for the `updateArInternalMetadatum` mutation. */
export type UpdateArInternalMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ArInternalMetadatum` being updated. */
  patch: ArInternalMetadatumPatch;
};

/** The output of our update `ArInternalMetadatum` mutation. */
export type UpdateArInternalMetadatumPayload = {
  __typename?: 'UpdateArInternalMetadatumPayload';
  /** The `ArInternalMetadatum` that was updated by this mutation. */
  arInternalMetadatum?: Maybe<ArInternalMetadatum>;
  /** An edge for our `ArInternalMetadatum`. May be used by Relay 1. */
  arInternalMetadatumEdge?: Maybe<ArInternalMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ArInternalMetadatum` mutation. */
export type UpdateArInternalMetadatumPayloadArInternalMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<ArInternalMetadataOrderBy>>;
};

/** All input for the `updateCampaignByNodeId` mutation. */
export type UpdateCampaignByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Campaign` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Campaign` being updated. */
  patch: CampaignPatch;
};

/** All input for the `updateCampaign` mutation. */
export type UpdateCampaignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Campaign` being updated. */
  patch: CampaignPatch;
};

/** The output of our update `Campaign` mutation. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  /** The `Campaign` that was updated by this mutation. */
  campaign?: Maybe<Campaign>;
  /** An edge for our `Campaign`. May be used by Relay 1. */
  campaignEdge?: Maybe<CampaignsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Campaign`. */
  team?: Maybe<Team>;
};


/** The output of our update `Campaign` mutation. */
export type UpdateCampaignPayloadCampaignEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignsOrderBy>>;
};

/** All input for the `updateCampaignPhaseByNodeId` mutation. */
export type UpdateCampaignPhaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CampaignPhase` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CampaignPhase` being updated. */
  patch: CampaignPhasePatch;
};

/** All input for the `updateCampaignPhase` mutation. */
export type UpdateCampaignPhaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CampaignPhase` being updated. */
  patch: CampaignPhasePatch;
};

/** All input for the `updateCampaignPhaseLinkByNodeId` mutation. */
export type UpdateCampaignPhaseLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CampaignPhaseLink` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CampaignPhaseLink` being updated. */
  patch: CampaignPhaseLinkPatch;
};

/** All input for the `updateCampaignPhaseLink` mutation. */
export type UpdateCampaignPhaseLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CampaignPhaseLink` being updated. */
  patch: CampaignPhaseLinkPatch;
};

/** The output of our update `CampaignPhaseLink` mutation. */
export type UpdateCampaignPhaseLinkPayload = {
  __typename?: 'UpdateCampaignPhaseLinkPayload';
  /** The `CampaignPhaseLink` that was updated by this mutation. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** An edge for our `CampaignPhaseLink`. May be used by Relay 1. */
  campaignPhaseLinkEdge?: Maybe<CampaignPhaseLinksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CampaignPhase` that is related to this `CampaignPhaseLink`. */
  phase?: Maybe<CampaignPhase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CampaignPhaseLink` mutation. */
export type UpdateCampaignPhaseLinkPayloadCampaignPhaseLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignPhaseLinksOrderBy>>;
};

/** The output of our update `CampaignPhase` mutation. */
export type UpdateCampaignPhasePayload = {
  __typename?: 'UpdateCampaignPhasePayload';
  /** Reads a single `Campaign` that is related to this `CampaignPhase`. */
  campaign?: Maybe<Campaign>;
  /** The `CampaignPhase` that was updated by this mutation. */
  campaignPhase?: Maybe<CampaignPhase>;
  /** An edge for our `CampaignPhase`. May be used by Relay 1. */
  campaignPhaseEdge?: Maybe<CampaignPhasesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CampaignPhase` mutation. */
export type UpdateCampaignPhasePayloadCampaignPhaseEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignPhasesOrderBy>>;
};

/** All input for the `updateCampaignQueryParamByNodeId` mutation. */
export type UpdateCampaignQueryParamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CampaignQueryParam` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CampaignQueryParam` being updated. */
  patch: CampaignQueryParamPatch;
};

/** All input for the `updateCampaignQueryParam` mutation. */
export type UpdateCampaignQueryParamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CampaignQueryParam` being updated. */
  patch: CampaignQueryParamPatch;
};

/** The output of our update `CampaignQueryParam` mutation. */
export type UpdateCampaignQueryParamPayload = {
  __typename?: 'UpdateCampaignQueryParamPayload';
  /** Reads a single `CampaignPhaseLink` that is related to this `CampaignQueryParam`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /** The `CampaignQueryParam` that was updated by this mutation. */
  campaignQueryParam?: Maybe<CampaignQueryParam>;
  /** An edge for our `CampaignQueryParam`. May be used by Relay 1. */
  campaignQueryParamEdge?: Maybe<CampaignQueryParamsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CampaignQueryParam` mutation. */
export type UpdateCampaignQueryParamPayloadCampaignQueryParamEdgeArgs = {
  orderBy?: InputMaybe<Array<CampaignQueryParamsOrderBy>>;
};

/** All input for the `updateCrmContactByCrmIdAndTenantId` mutation. */
export type UpdateCrmContactByCrmIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CrmContact` being updated. */
  patch: CrmContactPatch;
  tenantId: Scalars['BigInt']['input'];
};

/** All input for the `updateCrmContactByNodeId` mutation. */
export type UpdateCrmContactByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CrmContact` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CrmContact` being updated. */
  patch: CrmContactPatch;
};

/** All input for the `updateCrmContactConsentByNodeId` mutation. */
export type UpdateCrmContactConsentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CrmContactConsent` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CrmContactConsent` being updated. */
  patch: CrmContactConsentPatch;
};

/** All input for the `updateCrmContactConsent` mutation. */
export type UpdateCrmContactConsentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CrmContactConsent` being updated. */
  patch: CrmContactConsentPatch;
};

/** The output of our update `CrmContactConsent` mutation. */
export type UpdateCrmContactConsentPayload = {
  __typename?: 'UpdateCrmContactConsentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `CrmContactConsent`. */
  createdBy?: Maybe<User>;
  /** Reads a single `CrmContact` that is related to this `CrmContactConsent`. */
  crm?: Maybe<CrmContact>;
  /** The `CrmContactConsent` that was updated by this mutation. */
  crmContactConsent?: Maybe<CrmContactConsent>;
  /** An edge for our `CrmContactConsent`. May be used by Relay 1. */
  crmContactConsentEdge?: Maybe<CrmContactConsentsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactConsent`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CrmContactConsent` mutation. */
export type UpdateCrmContactConsentPayloadCrmContactConsentEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};

/** All input for the `updateCrmContact` mutation. */
export type UpdateCrmContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CrmContact` being updated. */
  patch: CrmContactPatch;
};

/** The output of our update `CrmContact` mutation. */
export type UpdateCrmContactPayload = {
  __typename?: 'UpdateCrmContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CrmContact` that was updated by this mutation. */
  crmContact?: Maybe<CrmContact>;
  /** An edge for our `CrmContact`. May be used by Relay 1. */
  crmContactEdge?: Maybe<CrmContactsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `CrmContact`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `CrmContact` mutation. */
export type UpdateCrmContactPayloadCrmContactEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactsOrderBy>>;
};

/** All input for the `updateCrmContactPhaseMappingByNodeId` mutation. */
export type UpdateCrmContactPhaseMappingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CrmContactPhaseMapping` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CrmContactPhaseMapping` being updated. */
  patch: CrmContactPhaseMappingPatch;
};

/** All input for the `updateCrmContactPhaseMappingByPhaseIdAndContactId` mutation. */
export type UpdateCrmContactPhaseMappingByPhaseIdAndContactIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CrmContactPhaseMapping` being updated. */
  patch: CrmContactPhaseMappingPatch;
  phaseId: Scalars['BigInt']['input'];
};

/** All input for the `updateCrmContactPhaseMapping` mutation. */
export type UpdateCrmContactPhaseMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `CrmContactPhaseMapping` being updated. */
  patch: CrmContactPhaseMappingPatch;
};

/** The output of our update `CrmContactPhaseMapping` mutation. */
export type UpdateCrmContactPhaseMappingPayload = {
  __typename?: 'UpdateCrmContactPhaseMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `CrmContactPhaseMapping`. */
  contact?: Maybe<CrmContact>;
  /** The `CrmContactPhaseMapping` that was updated by this mutation. */
  crmContactPhaseMapping?: Maybe<CrmContactPhaseMapping>;
  /** An edge for our `CrmContactPhaseMapping`. May be used by Relay 1. */
  crmContactPhaseMappingEdge?: Maybe<CrmContactPhaseMappingsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `CrmContactPhaseMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Reads a single `CampaignPhase` that is related to this `CrmContactPhaseMapping`. */
  phase?: Maybe<CampaignPhase>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CrmContactPhaseMapping` mutation. */
export type UpdateCrmContactPhaseMappingPayloadCrmContactPhaseMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<CrmContactPhaseMappingsOrderBy>>;
};

/** All input for the `updateDocumentByFirestoreId` mutation. */
export type UpdateDocumentByFirestoreIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firestoreId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Document` being updated. */
  patch: DocumentPatch;
};

/** All input for the `updateDocumentByNodeId` mutation. */
export type UpdateDocumentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Document` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Document` being updated. */
  patch: DocumentPatch;
};

/** All input for the `updateDocumentExpirationByNodeId` mutation. */
export type UpdateDocumentExpirationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentExpiration` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentExpiration` being updated. */
  patch: DocumentExpirationPatch;
};

/** All input for the `updateDocumentExpiration` mutation. */
export type UpdateDocumentExpirationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentExpiration` being updated. */
  patch: DocumentExpirationPatch;
};

/** The output of our update `DocumentExpiration` mutation. */
export type UpdateDocumentExpirationPayload = {
  __typename?: 'UpdateDocumentExpirationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentExpiration`. */
  document?: Maybe<Document>;
  /** The `DocumentExpiration` that was updated by this mutation. */
  documentExpiration?: Maybe<DocumentExpiration>;
  /** An edge for our `DocumentExpiration`. May be used by Relay 1. */
  documentExpirationEdge?: Maybe<DocumentExpirationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentExpiration` mutation. */
export type UpdateDocumentExpirationPayloadDocumentExpirationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentExpirationsOrderBy>>;
};

/** All input for the `updateDocument` mutation. */
export type UpdateDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Document` being updated. */
  patch: DocumentPatch;
};

/** All input for the `updateDocumentPageByDocumentIdAndRevisionNumberAndPageNumber` mutation. */
export type UpdateDocumentPageByDocumentIdAndRevisionNumberAndPageNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Document, the page belongs to. */
  documentId: Scalars['BigInt']['input'];
  /** Number of this page in the related document. */
  pageNumber: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `DocumentPage` being updated. */
  patch: DocumentPagePatch;
  revisionNumber: Scalars['Int']['input'];
};

/** All input for the `updateDocumentPageByNodeId` mutation. */
export type UpdateDocumentPageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentPage` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentPage` being updated. */
  patch: DocumentPagePatch;
};

/** All input for the `updateDocumentPage` mutation. */
export type UpdateDocumentPageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentPage` being updated. */
  patch: DocumentPagePatch;
};

/** All input for the `updateDocumentPageLinkByNodeId` mutation. */
export type UpdateDocumentPageLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentPageLink` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentPageLink` being updated. */
  patch: DocumentPageLinkPatch;
};

/** All input for the `updateDocumentPageLink` mutation. */
export type UpdateDocumentPageLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentPageLink` being updated. */
  patch: DocumentPageLinkPatch;
};

/** The output of our update `DocumentPageLink` mutation. */
export type UpdateDocumentPageLinkPayload = {
  __typename?: 'UpdateDocumentPageLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentPageLink` that was updated by this mutation. */
  documentPageLink?: Maybe<DocumentPageLink>;
  /** An edge for our `DocumentPageLink`. May be used by Relay 1. */
  documentPageLinkEdge?: Maybe<DocumentPageLinksEdge>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  page?: Maybe<DocumentPage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageLink`. */
  targetPage?: Maybe<DocumentPage>;
};


/** The output of our update `DocumentPageLink` mutation. */
export type UpdateDocumentPageLinkPayloadDocumentPageLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageLinksOrderBy>>;
};

/** All input for the `updateDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumber` mutation. */
export type UpdateDocumentPageMatchingByDocumentIdAndSourceRevisionNumberAndSourcePageNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentPageMatching` being updated. */
  patch: DocumentPageMatchingPatch;
  sourcePageNumber: Scalars['Int']['input'];
  sourceRevisionNumber: Scalars['Int']['input'];
};

/** All input for the `updateDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumber` mutation. */
export type UpdateDocumentPageMatchingByDocumentIdAndTargetRevisionNumberAndTargetPageNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentPageMatching` being updated. */
  patch: DocumentPageMatchingPatch;
  targetPageNumber: Scalars['Int']['input'];
  targetRevisionNumber: Scalars['Int']['input'];
};

/** All input for the `updateDocumentPageMatchingByNodeId` mutation. */
export type UpdateDocumentPageMatchingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentPageMatching` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentPageMatching` being updated. */
  patch: DocumentPageMatchingPatch;
};

/** All input for the `updateDocumentPageMatching` mutation. */
export type UpdateDocumentPageMatchingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentPageMatching` being updated. */
  patch: DocumentPageMatchingPatch;
};

/** The output of our update `DocumentPageMatching` mutation. */
export type UpdateDocumentPageMatchingPayload = {
  __typename?: 'UpdateDocumentPageMatchingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentPageMatching`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndSourceRevisionNumberAndSourcePageNumber?: Maybe<DocumentPage>;
  /** Reads a single `DocumentPage` that is related to this `DocumentPageMatching`. */
  documentPageByDocumentIdAndTargetRevisionNumberAndTargetPageNumber?: Maybe<DocumentPage>;
  /** The `DocumentPageMatching` that was updated by this mutation. */
  documentPageMatching?: Maybe<DocumentPageMatching>;
  /** An edge for our `DocumentPageMatching`. May be used by Relay 1. */
  documentPageMatchingEdge?: Maybe<DocumentPageMatchingsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndSourceRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPageMatching`. */
  documentRevisionByDocumentIdAndTargetRevisionNumber?: Maybe<DocumentRevision>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentPageMatching` mutation. */
export type UpdateDocumentPageMatchingPayloadDocumentPageMatchingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPageMatchingsOrderBy>>;
};

/** The output of our update `DocumentPage` mutation. */
export type UpdateDocumentPagePayload = {
  __typename?: 'UpdateDocumentPagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  document?: Maybe<Document>;
  /** The `DocumentPage` that was updated by this mutation. */
  documentPage?: Maybe<DocumentPage>;
  /** An edge for our `DocumentPage`. May be used by Relay 1. */
  documentPageEdge?: Maybe<DocumentPagesEdge>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentPage`. */
  documentRevisionByDocumentIdAndRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `Document` that is related to this `DocumentPage`. */
  linkedDocument?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentPage` mutation. */
export type UpdateDocumentPagePayloadDocumentPageEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentPagesOrderBy>>;
};

/** The output of our update `Document` mutation. */
export type UpdateDocumentPayload = {
  __typename?: 'UpdateDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Document`. */
  createdBy?: Maybe<User>;
  /** The `Document` that was updated by this mutation. */
  document?: Maybe<Document>;
  /** An edge for our `Document`. May be used by Relay 1. */
  documentEdge?: Maybe<DocumentsEdge>;
  /** Reads a single `DocumentRevision` that is related to this `Document`. */
  documentRevisionByIdAndCurrentRevisionNumber?: Maybe<DocumentRevision>;
  /** Reads a single `User` that is related to this `Document`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Document` that is related to this `Document`. */
  legalAppendix?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workspace` that is related to this `Document`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our update `Document` mutation. */
export type UpdateDocumentPayloadDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};

/** All input for the `updateDocumentProcessByNodeId` mutation. */
export type UpdateDocumentProcessByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentProcess` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentProcess` being updated. */
  patch: DocumentProcessPatch;
};

/** All input for the `updateDocumentProcess` mutation. */
export type UpdateDocumentProcessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentProcess` being updated. */
  patch: DocumentProcessPatch;
};

/** The output of our update `DocumentProcess` mutation. */
export type UpdateDocumentProcessPayload = {
  __typename?: 'UpdateDocumentProcessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentProcess`. */
  document?: Maybe<Document>;
  /** The `DocumentProcess` that was updated by this mutation. */
  documentProcess?: Maybe<DocumentProcess>;
  /** An edge for our `DocumentProcess`. May be used by Relay 1. */
  documentProcessEdge?: Maybe<DocumentProcessesEdge>;
  /** Reads a single `User` that is related to this `DocumentProcess`. */
  initiator?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentRevision` that is related to this `DocumentProcess`. */
  revision?: Maybe<DocumentRevision>;
};


/** The output of our update `DocumentProcess` mutation. */
export type UpdateDocumentProcessPayloadDocumentProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};

/** All input for the `updateDocumentRevisionByNodeId` mutation. */
export type UpdateDocumentRevisionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentRevision` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentRevision` being updated. */
  patch: DocumentRevisionPatch;
};

/** All input for the `updateDocumentRevision` mutation. */
export type UpdateDocumentRevisionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentRevision` being updated. */
  patch: DocumentRevisionPatch;
  revisionNumber: Scalars['Int']['input'];
};

/** The output of our update `DocumentRevision` mutation. */
export type UpdateDocumentRevisionPayload = {
  __typename?: 'UpdateDocumentRevisionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentRevision`. */
  document?: Maybe<Document>;
  /** The `DocumentRevision` that was updated by this mutation. */
  documentRevision?: Maybe<DocumentRevision>;
  /** An edge for our `DocumentRevision`. May be used by Relay 1. */
  documentRevisionEdge?: Maybe<DocumentRevisionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentRevision` mutation. */
export type UpdateDocumentRevisionPayloadDocumentRevisionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentRevisionsOrderBy>>;
};

/** All input for the `updateDocumentSpaceAccessByNodeId` mutation. */
export type UpdateDocumentSpaceAccessByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceAccess` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceAccess` being updated. */
  patch: DocumentSpaceAccessPatch;
};

/** All input for the `updateDocumentSpaceAccessByUserIdAndDocumentSpaceId` mutation. */
export type UpdateDocumentSpaceAccessByUserIdAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceAccess` being updated. */
  patch: DocumentSpaceAccessPatch;
  userId: Scalars['BigInt']['input'];
};

/** All input for the `updateDocumentSpaceAccess` mutation. */
export type UpdateDocumentSpaceAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceAccess` being updated. */
  patch: DocumentSpaceAccessPatch;
};

/** The output of our update `DocumentSpaceAccess` mutation. */
export type UpdateDocumentSpaceAccessPayload = {
  __typename?: 'UpdateDocumentSpaceAccessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  creator?: Maybe<User>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceAccess`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceAccess` that was updated by this mutation. */
  documentSpaceAccess?: Maybe<DocumentSpaceAccess>;
  /** An edge for our `DocumentSpaceAccess`. May be used by Relay 1. */
  documentSpaceAccessEdge?: Maybe<DocumentSpaceAccessesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentSpaceAccess`. */
  user?: Maybe<User>;
};


/** The output of our update `DocumentSpaceAccess` mutation. */
export type UpdateDocumentSpaceAccessPayloadDocumentSpaceAccessEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};

/** All input for the `updateDocumentSpaceByCodeOnAccessCard` mutation. */
export type UpdateDocumentSpaceByCodeOnAccessCardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeOnAccessCard: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DocumentSpace` being updated. */
  patch: DocumentSpacePatch;
};

/** All input for the `updateDocumentSpaceByNodeId` mutation. */
export type UpdateDocumentSpaceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpace` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpace` being updated. */
  patch: DocumentSpacePatch;
};

/** All input for the `updateDocumentSpaceConfigByNodeId` mutation. */
export type UpdateDocumentSpaceConfigByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceConfig` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceConfig` being updated. */
  patch: DocumentSpaceConfigPatch;
};

/** All input for the `updateDocumentSpaceConfig` mutation. */
export type UpdateDocumentSpaceConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceConfig` being updated. */
  patch: DocumentSpaceConfigPatch;
};

/** The output of our update `DocumentSpaceConfig` mutation. */
export type UpdateDocumentSpaceConfigPayload = {
  __typename?: 'UpdateDocumentSpaceConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceConfig` that was updated by this mutation. */
  documentSpaceConfig?: Maybe<DocumentSpaceConfig>;
  /** An edge for our `DocumentSpaceConfig`. May be used by Relay 1. */
  documentSpaceConfigEdge?: Maybe<DocumentSpaceConfigsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfig`. */
  languageCodeByDefaultLanguage?: Maybe<LanguageCode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `DocumentSpaceConfig`. */
  team?: Maybe<Team>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceConfig`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `DocumentSpaceLinkGroup` that is related to this `DocumentSpaceConfig`. */
  tenantGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** Reads a single `User` that is related to this `DocumentSpaceConfig`. */
  updatedBy?: Maybe<User>;
};


/** The output of our update `DocumentSpaceConfig` mutation. */
export type UpdateDocumentSpaceConfigPayloadDocumentSpaceConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};

/** All input for the `updateDocumentSpaceConfigTranslationByConfigIdAndLanguageCode` mutation. */
export type UpdateDocumentSpaceConfigTranslationByConfigIdAndLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceConfigTranslation` being updated. */
  patch: DocumentSpaceConfigTranslationPatch;
};

/** All input for the `updateDocumentSpaceConfigTranslationByNodeId` mutation. */
export type UpdateDocumentSpaceConfigTranslationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceConfigTranslation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceConfigTranslation` being updated. */
  patch: DocumentSpaceConfigTranslationPatch;
};

/** All input for the `updateDocumentSpaceConfigTranslation` mutation. */
export type UpdateDocumentSpaceConfigTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceConfigTranslation` being updated. */
  patch: DocumentSpaceConfigTranslationPatch;
};

/** The output of our update `DocumentSpaceConfigTranslation` mutation. */
export type UpdateDocumentSpaceConfigTranslationPayload = {
  __typename?: 'UpdateDocumentSpaceConfigTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceConfigTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** The `DocumentSpaceConfigTranslation` that was updated by this mutation. */
  documentSpaceConfigTranslation?: Maybe<DocumentSpaceConfigTranslation>;
  /** An edge for our `DocumentSpaceConfigTranslation`. May be used by Relay 1. */
  documentSpaceConfigTranslationEdge?: Maybe<DocumentSpaceConfigTranslationsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceConfigTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceConfigTranslation` mutation. */
export type UpdateDocumentSpaceConfigTranslationPayloadDocumentSpaceConfigTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceConfigTranslationsOrderBy>>;
};

/** All input for the `updateDocumentSpaceCrmMappingByDocumentSpaceId` mutation. */
export type UpdateDocumentSpaceCrmMappingByDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceCrmMapping` being updated. */
  patch: DocumentSpaceCrmMappingPatch;
};

/** All input for the `updateDocumentSpaceCrmMappingByNodeId` mutation. */
export type UpdateDocumentSpaceCrmMappingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceCrmMapping` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceCrmMapping` being updated. */
  patch: DocumentSpaceCrmMappingPatch;
};

/** All input for the `updateDocumentSpaceCrmMapping` mutation. */
export type UpdateDocumentSpaceCrmMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceCrmMapping` being updated. */
  patch: DocumentSpaceCrmMappingPatch;
};

/** The output of our update `DocumentSpaceCrmMapping` mutation. */
export type UpdateDocumentSpaceCrmMappingPayload = {
  __typename?: 'UpdateDocumentSpaceCrmMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `DocumentSpaceCrmMapping`. */
  crmContact?: Maybe<CrmContact>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceCrmMapping`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceCrmMapping` that was updated by this mutation. */
  documentSpaceCrmMapping?: Maybe<DocumentSpaceCrmMapping>;
  /** An edge for our `DocumentSpaceCrmMapping`. May be used by Relay 1. */
  documentSpaceCrmMappingEdge?: Maybe<DocumentSpaceCrmMappingsEdge>;
  /** Reads a single `CrmContactMatch` that is related to this `DocumentSpaceCrmMapping`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceCrmMapping` mutation. */
export type UpdateDocumentSpaceCrmMappingPayloadDocumentSpaceCrmMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceCrmMappingsOrderBy>>;
};

/** All input for the `updateDocumentSpace` mutation. */
export type UpdateDocumentSpaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpace` being updated. */
  patch: DocumentSpacePatch;
};

/** All input for the `updateDocumentSpaceItemByDocumentIdAndDocumentSpaceId` mutation. */
export type UpdateDocumentSpaceItemByDocumentIdAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceItem` being updated. */
  patch: DocumentSpaceItemPatch;
};

/** All input for the `updateDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPosition` mutation. */
export type UpdateDocumentSpaceItemByDocumentSpaceIdAndSectionIdAndPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceItem` being updated. */
  patch: DocumentSpaceItemPatch;
  position: Scalars['BigFloat']['input'];
  sectionId: Scalars['BigInt']['input'];
};

/** All input for the `updateDocumentSpaceItemByNodeId` mutation. */
export type UpdateDocumentSpaceItemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceItem` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceItem` being updated. */
  patch: DocumentSpaceItemPatch;
};

/** All input for the `updateDocumentSpaceItem` mutation. */
export type UpdateDocumentSpaceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceItem` being updated. */
  patch: DocumentSpaceItemPatch;
};

/** The output of our update `DocumentSpaceItem` mutation. */
export type UpdateDocumentSpaceItemPayload = {
  __typename?: 'UpdateDocumentSpaceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceItem` that was updated by this mutation. */
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  /** An edge for our `DocumentSpaceItem`. May be used by Relay 1. */
  documentSpaceItemEdge?: Maybe<DocumentSpaceItemsEdge>;
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
};


/** The output of our update `DocumentSpaceItem` mutation. */
export type UpdateDocumentSpaceItemPayloadDocumentSpaceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/** All input for the `updateDocumentSpaceLinkByNodeId` mutation. */
export type UpdateDocumentSpaceLinkByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLink` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLink` being updated. */
  patch: DocumentSpaceLinkPatch;
};

/** All input for the `updateDocumentSpaceLinkByPositionAndConfigId` mutation. */
export type UpdateDocumentSpaceLinkByPositionAndConfigIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLink` being updated. */
  patch: DocumentSpaceLinkPatch;
  position: Scalars['BigFloat']['input'];
};

/** All input for the `updateDocumentSpaceLinkByPositionAndDocumentSpaceId` mutation. */
export type UpdateDocumentSpaceLinkByPositionAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLink` being updated. */
  patch: DocumentSpaceLinkPatch;
  position: Scalars['BigFloat']['input'];
};

/** All input for the `updateDocumentSpaceLinkGroupByNodeId` mutation. */
export type UpdateDocumentSpaceLinkGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLinkGroup` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkGroup` being updated. */
  patch: DocumentSpaceLinkGroupPatch;
};

/** All input for the `updateDocumentSpaceLinkGroupByTenantIdAndId` mutation. */
export type UpdateDocumentSpaceLinkGroupByTenantIdAndIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkGroup` being updated. */
  patch: DocumentSpaceLinkGroupPatch;
  tenantId: Scalars['BigInt']['input'];
};

/** All input for the `updateDocumentSpaceLinkGroup` mutation. */
export type UpdateDocumentSpaceLinkGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkGroup` being updated. */
  patch: DocumentSpaceLinkGroupPatch;
};

/** The output of our update `DocumentSpaceLinkGroup` mutation. */
export type UpdateDocumentSpaceLinkGroupPayload = {
  __typename?: 'UpdateDocumentSpaceLinkGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceLinkGroup` that was updated by this mutation. */
  documentSpaceLinkGroup?: Maybe<DocumentSpaceLinkGroup>;
  /** An edge for our `DocumentSpaceLinkGroup`. May be used by Relay 1. */
  documentSpaceLinkGroupEdge?: Maybe<DocumentSpaceLinkGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceLinkGroup`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `DocumentSpaceLinkGroup` mutation. */
export type UpdateDocumentSpaceLinkGroupPayloadDocumentSpaceLinkGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkGroupsOrderBy>>;
};

/** All input for the `updateDocumentSpaceLink` mutation. */
export type UpdateDocumentSpaceLinkInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLink` being updated. */
  patch: DocumentSpaceLinkPatch;
};

/** All input for the `updateDocumentSpaceLinkMappingByNodeId` mutation. */
export type UpdateDocumentSpaceLinkMappingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLinkMapping` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkMapping` being updated. */
  patch: DocumentSpaceLinkMappingPatch;
};

/** All input for the `updateDocumentSpaceLinkMappingBySpaceIdAndLinkId` mutation. */
export type UpdateDocumentSpaceLinkMappingBySpaceIdAndLinkIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  linkId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkMapping` being updated. */
  patch: DocumentSpaceLinkMappingPatch;
  spaceId: Scalars['BigInt']['input'];
};

/** All input for the `updateDocumentSpaceLinkMapping` mutation. */
export type UpdateDocumentSpaceLinkMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkMapping` being updated. */
  patch: DocumentSpaceLinkMappingPatch;
};

/** The output of our update `DocumentSpaceLinkMapping` mutation. */
export type UpdateDocumentSpaceLinkMappingPayload = {
  __typename?: 'UpdateDocumentSpaceLinkMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceLinkMapping` that was updated by this mutation. */
  documentSpaceLinkMapping?: Maybe<DocumentSpaceLinkMapping>;
  /** An edge for our `DocumentSpaceLinkMapping`. May be used by Relay 1. */
  documentSpaceLinkMappingEdge?: Maybe<DocumentSpaceLinkMappingsEdge>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkMapping`. */
  link?: Maybe<DocumentSpaceLink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLinkMapping`. */
  space?: Maybe<DocumentSpace>;
};


/** The output of our update `DocumentSpaceLinkMapping` mutation. */
export type UpdateDocumentSpaceLinkMappingPayloadDocumentSpaceLinkMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkMappingsOrderBy>>;
};

/** The output of our update `DocumentSpaceLink` mutation. */
export type UpdateDocumentSpaceLinkPayload = {
  __typename?: 'UpdateDocumentSpaceLinkPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLink`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceLink`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceLink` that was updated by this mutation. */
  documentSpaceLink?: Maybe<DocumentSpaceLink>;
  /** An edge for our `DocumentSpaceLink`. May be used by Relay 1. */
  documentSpaceLinkEdge?: Maybe<DocumentSpaceLinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceLink` mutation. */
export type UpdateDocumentSpaceLinkPayloadDocumentSpaceLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinksOrderBy>>;
};

/** All input for the `updateDocumentSpaceLinkTranslationByLinkIdAndLanguageCode` mutation. */
export type UpdateDocumentSpaceLinkTranslationByLinkIdAndLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  linkId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkTranslation` being updated. */
  patch: DocumentSpaceLinkTranslationPatch;
};

/** All input for the `updateDocumentSpaceLinkTranslationByNodeId` mutation. */
export type UpdateDocumentSpaceLinkTranslationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceLinkTranslation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkTranslation` being updated. */
  patch: DocumentSpaceLinkTranslationPatch;
};

/** All input for the `updateDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCode` mutation. */
export type UpdateDocumentSpaceLinkTranslationByPositionAndConfigIdAndLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkTranslation` being updated. */
  patch: DocumentSpaceLinkTranslationPatch;
  position: Scalars['BigFloat']['input'];
};

/** All input for the `updateDocumentSpaceLinkTranslation` mutation. */
export type UpdateDocumentSpaceLinkTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceLinkTranslation` being updated. */
  patch: DocumentSpaceLinkTranslationPatch;
};

/** The output of our update `DocumentSpaceLinkTranslation` mutation. */
export type UpdateDocumentSpaceLinkTranslationPayload = {
  __typename?: 'UpdateDocumentSpaceLinkTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpaceLinkTranslation`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** The `DocumentSpaceLinkTranslation` that was updated by this mutation. */
  documentSpaceLinkTranslation?: Maybe<DocumentSpaceLinkTranslation>;
  /** An edge for our `DocumentSpaceLinkTranslation`. May be used by Relay 1. */
  documentSpaceLinkTranslationEdge?: Maybe<DocumentSpaceLinkTranslationsEdge>;
  /** Reads a single `LanguageCode` that is related to this `DocumentSpaceLinkTranslation`. */
  languageCodeByLanguageCode?: Maybe<LanguageCode>;
  /** Reads a single `DocumentSpaceLink` that is related to this `DocumentSpaceLinkTranslation`. */
  link?: Maybe<DocumentSpaceLink>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceLinkTranslation` mutation. */
export type UpdateDocumentSpaceLinkTranslationPayloadDocumentSpaceLinkTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceLinkTranslationsOrderBy>>;
};

/** The output of our update `DocumentSpace` mutation. */
export type UpdateDocumentSpacePayload = {
  __typename?: 'UpdateDocumentSpacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpaceConfig` that is related to this `DocumentSpace`. */
  config?: Maybe<DocumentSpaceConfig>;
  /** Reads a single `User` that is related to this `DocumentSpace`. */
  creator?: Maybe<User>;
  /** The `DocumentSpace` that was updated by this mutation. */
  documentSpace?: Maybe<DocumentSpace>;
  /** An edge for our `DocumentSpace`. May be used by Relay 1. */
  documentSpaceEdge?: Maybe<DocumentSpacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpace`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `DocumentSpace` mutation. */
export type UpdateDocumentSpacePayloadDocumentSpaceEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};

/** All input for the `updateDocumentSpaceSectionByDocumentSpaceIdAndPosition` mutation. */
export type UpdateDocumentSpaceSectionByDocumentSpaceIdAndPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSection` being updated. */
  patch: DocumentSpaceSectionPatch;
  position: Scalars['BigFloat']['input'];
};

/** All input for the `updateDocumentSpaceSectionByNodeId` mutation. */
export type UpdateDocumentSpaceSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceSection` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSection` being updated. */
  patch: DocumentSpaceSectionPatch;
};

/** All input for the `updateDocumentSpaceSectionByTitleAndDocumentSpaceId` mutation. */
export type UpdateDocumentSpaceSectionByTitleAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSection` being updated. */
  patch: DocumentSpaceSectionPatch;
  title: Scalars['String']['input'];
};

/** All input for the `updateDocumentSpaceSection` mutation. */
export type UpdateDocumentSpaceSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSection` being updated. */
  patch: DocumentSpaceSectionPatch;
};

/** The output of our update `DocumentSpaceSection` mutation. */
export type UpdateDocumentSpaceSectionPayload = {
  __typename?: 'UpdateDocumentSpaceSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSection`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceSection` that was updated by this mutation. */
  documentSpaceSection?: Maybe<DocumentSpaceSection>;
  /** An edge for our `DocumentSpaceSection`. May be used by Relay 1. */
  documentSpaceSectionEdge?: Maybe<DocumentSpaceSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceSection` mutation. */
export type UpdateDocumentSpaceSectionPayloadDocumentSpaceSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSectionsOrderBy>>;
};

/** All input for the `updateDocumentSpaceSessionByFingerprintAndDocumentSpaceId` mutation. */
export type UpdateDocumentSpaceSessionByFingerprintAndDocumentSpaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId: Scalars['BigInt']['input'];
  fingerprint: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSession` being updated. */
  patch: DocumentSpaceSessionPatch;
};

/** All input for the `updateDocumentSpaceSessionByNodeId` mutation. */
export type UpdateDocumentSpaceSessionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceSession` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSession` being updated. */
  patch: DocumentSpaceSessionPatch;
};

/** All input for the `updateDocumentSpaceSession` mutation. */
export type UpdateDocumentSpaceSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fingerprint: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceSession` being updated. */
  patch: DocumentSpaceSessionPatch;
};

/** The output of our update `DocumentSpaceSession` mutation. */
export type UpdateDocumentSpaceSessionPayload = {
  __typename?: 'UpdateDocumentSpaceSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceSession`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceSession` that was updated by this mutation. */
  documentSpaceSession?: Maybe<DocumentSpaceSession>;
  /** An edge for our `DocumentSpaceSession`. May be used by Relay 1. */
  documentSpaceSessionEdge?: Maybe<DocumentSpaceSessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceSession` mutation. */
export type UpdateDocumentSpaceSessionPayloadDocumentSpaceSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceSessionsOrderBy>>;
};

/** All input for the `updateDocumentSpaceTagByNodeId` mutation. */
export type UpdateDocumentSpaceTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceTag` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceTag` being updated. */
  patch: DocumentSpaceTagPatch;
};

/** All input for the `updateDocumentSpaceTag` mutation. */
export type UpdateDocumentSpaceTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceTag` being updated. */
  patch: DocumentSpaceTagPatch;
};

/** The output of our update `DocumentSpaceTag` mutation. */
export type UpdateDocumentSpaceTagPayload = {
  __typename?: 'UpdateDocumentSpaceTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DocumentSpaceTag` that was updated by this mutation. */
  documentSpaceTag?: Maybe<DocumentSpaceTag>;
  /** An edge for our `DocumentSpaceTag`. May be used by Relay 1. */
  documentSpaceTagEdge?: Maybe<DocumentSpaceTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `DocumentSpaceTag`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `DocumentSpaceTag` mutation. */
export type UpdateDocumentSpaceTagPayloadDocumentSpaceTagEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceTagsOrderBy>>;
};

/** All input for the `updateDocumentSpaceVoucherByNodeId` mutation. */
export type UpdateDocumentSpaceVoucherByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DocumentSpaceVoucher` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceVoucher` being updated. */
  patch: DocumentSpaceVoucherPatch;
};

/** All input for the `updateDocumentSpaceVoucher` mutation. */
export type UpdateDocumentSpaceVoucherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DocumentSpaceVoucher` being updated. */
  patch: DocumentSpaceVoucherPatch;
};

/** The output of our update `DocumentSpaceVoucher` mutation. */
export type UpdateDocumentSpaceVoucherPayload = {
  __typename?: 'UpdateDocumentSpaceVoucherPayload';
  /** Reads a single `CampaignPhaseLink` that is related to this `DocumentSpaceVoucher`. */
  campaignPhaseLink?: Maybe<CampaignPhaseLink>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceVoucher`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceVoucher` that was updated by this mutation. */
  documentSpaceVoucher?: Maybe<DocumentSpaceVoucher>;
  /** An edge for our `DocumentSpaceVoucher`. May be used by Relay 1. */
  documentSpaceVoucherEdge?: Maybe<DocumentSpaceVouchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentSpaceVoucher` mutation. */
export type UpdateDocumentSpaceVoucherPayloadDocumentSpaceVoucherEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceVouchersOrderBy>>;
};

/** All input for the `updateFlowByNodeId` mutation. */
export type UpdateFlowByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Flow` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Flow` being updated. */
  patch: FlowPatch;
};

/** All input for the `updateFlow` mutation. */
export type UpdateFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Flow` being updated. */
  patch: FlowPatch;
};

/** All input for the `updateFlowItemByNodeId` mutation. */
export type UpdateFlowItemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FlowItem` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `FlowItem` being updated. */
  patch: FlowItemPatch;
};

/** All input for the `updateFlowItem` mutation. */
export type UpdateFlowItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `FlowItem` being updated. */
  patch: FlowItemPatch;
};

/** The output of our update `FlowItem` mutation. */
export type UpdateFlowItemPayload = {
  __typename?: 'UpdateFlowItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `FlowItem`. */
  creator?: Maybe<User>;
  /** Reads a single `Flow` that is related to this `FlowItem`. */
  flow?: Maybe<Flow>;
  /** The `FlowItem` that was updated by this mutation. */
  flowItem?: Maybe<FlowItem>;
  /** An edge for our `FlowItem`. May be used by Relay 1. */
  flowItemEdge?: Maybe<FlowItemsEdge>;
  /** Reads a single `DocumentPage` that is related to this `FlowItem`. */
  page?: Maybe<DocumentPage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Document` that is related to this `FlowItem`. */
  video?: Maybe<Document>;
};


/** The output of our update `FlowItem` mutation. */
export type UpdateFlowItemPayloadFlowItemEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};

/** The output of our update `Flow` mutation. */
export type UpdateFlowPayload = {
  __typename?: 'UpdateFlowPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Flow`. */
  creator?: Maybe<User>;
  /** The `Flow` that was updated by this mutation. */
  flow?: Maybe<Flow>;
  /** An edge for our `Flow`. May be used by Relay 1. */
  flowEdge?: Maybe<FlowsEdge>;
  /** Reads a single `Flow` that is related to this `Flow`. */
  parent?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Flow` mutation. */
export type UpdateFlowPayloadFlowEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};

/** All input for the `updateFlowSubscriptionByFlowIdAndTeamId` mutation. */
export type UpdateFlowSubscriptionByFlowIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `FlowSubscription` being updated. */
  patch: FlowSubscriptionPatch;
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `updateFlowSubscriptionByFlowIdAndUserId` mutation. */
export type UpdateFlowSubscriptionByFlowIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `FlowSubscription` being updated. */
  patch: FlowSubscriptionPatch;
  userId: Scalars['BigInt']['input'];
};

/** All input for the `updateFlowSubscriptionByNodeId` mutation. */
export type UpdateFlowSubscriptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FlowSubscription` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `FlowSubscription` being updated. */
  patch: FlowSubscriptionPatch;
};

/** All input for the `updateFlowSubscription` mutation. */
export type UpdateFlowSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `FlowSubscription` being updated. */
  patch: FlowSubscriptionPatch;
};

/** The output of our update `FlowSubscription` mutation. */
export type UpdateFlowSubscriptionPayload = {
  __typename?: 'UpdateFlowSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Flow` that is related to this `FlowSubscription`. */
  flow?: Maybe<Flow>;
  /** The `FlowSubscription` that was updated by this mutation. */
  flowSubscription?: Maybe<FlowSubscription>;
  /** An edge for our `FlowSubscription`. May be used by Relay 1. */
  flowSubscriptionEdge?: Maybe<FlowSubscriptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `FlowSubscription`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `FlowSubscription`. */
  user?: Maybe<User>;
};


/** The output of our update `FlowSubscription` mutation. */
export type UpdateFlowSubscriptionPayloadFlowSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};

/** All input for the `updateInternalIpAddressByNodeId` mutation. */
export type UpdateInternalIpAddressByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `InternalIpAddress` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `InternalIpAddress` being updated. */
  patch: InternalIpAddressPatch;
};

/** All input for the `updateInternalIpAddress` mutation. */
export type UpdateInternalIpAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `InternalIpAddress` being updated. */
  patch: InternalIpAddressPatch;
};

/** The output of our update `InternalIpAddress` mutation. */
export type UpdateInternalIpAddressPayload = {
  __typename?: 'UpdateInternalIpAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `InternalIpAddress` that was updated by this mutation. */
  internalIpAddress?: Maybe<InternalIpAddress>;
  /** An edge for our `InternalIpAddress`. May be used by Relay 1. */
  internalIpAddressEdge?: Maybe<InternalIpAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `InternalIpAddress`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `InternalIpAddress` mutation. */
export type UpdateInternalIpAddressPayloadInternalIpAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InternalIpAddressesOrderBy>>;
};

/** All input for the `updateLabelsOfDocumentViewByNodeId` mutation. */
export type UpdateLabelsOfDocumentViewByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LabelsOfDocumentView` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `LabelsOfDocumentView` being updated. */
  patch: LabelsOfDocumentViewPatch;
};

/** All input for the `updateLabelsOfDocumentView` mutation. */
export type UpdateLabelsOfDocumentViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentViewId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `LabelsOfDocumentView` being updated. */
  patch: LabelsOfDocumentViewPatch;
};

/** The output of our update `LabelsOfDocumentView` mutation. */
export type UpdateLabelsOfDocumentViewPayload = {
  __typename?: 'UpdateLabelsOfDocumentViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CrmContact` that is related to this `LabelsOfDocumentView`. */
  crmContact?: Maybe<CrmContact>;
  /** The `LabelsOfDocumentView` that was updated by this mutation. */
  labelsOfDocumentView?: Maybe<LabelsOfDocumentView>;
  /** An edge for our `LabelsOfDocumentView`. May be used by Relay 1. */
  labelsOfDocumentViewEdge?: Maybe<LabelsOfDocumentViewsEdge>;
  /** Reads a single `User` that is related to this `LabelsOfDocumentView`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `CrmContactMatch` that is related to this `LabelsOfDocumentView`. */
  matchId?: Maybe<CrmContactMatch>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LabelsOfDocumentView` mutation. */
export type UpdateLabelsOfDocumentViewPayloadLabelsOfDocumentViewEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};

/** All input for the `updateLanguageCodeByNodeId` mutation. */
export type UpdateLanguageCodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LanguageCode` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `LanguageCode` being updated. */
  patch: LanguageCodePatch;
};

/** All input for the `updateLanguageCode` mutation. */
export type UpdateLanguageCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `LanguageCode` being updated. */
  patch: LanguageCodePatch;
};

/** The output of our update `LanguageCode` mutation. */
export type UpdateLanguageCodePayload = {
  __typename?: 'UpdateLanguageCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LanguageCode` that was updated by this mutation. */
  languageCode?: Maybe<LanguageCode>;
  /** An edge for our `LanguageCode`. May be used by Relay 1. */
  languageCodeEdge?: Maybe<LanguageCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LanguageCode` mutation. */
export type UpdateLanguageCodePayloadLanguageCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<LanguageCodesOrderBy>>;
};

/** All input for the `updateMembershipByNodeId` mutation. */
export type UpdateMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Membership` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
};

/** All input for the `updateMembershipBySubteamIdAndTeamId` mutation. */
export type UpdateMembershipBySubteamIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
  subteamId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `updateMembershipByUserIdAndTeamId` mutation. */
export type UpdateMembershipByUserIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
  teamId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** All input for the `updateMembership` mutation. */
export type UpdateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
};

/** The output of our update `Membership` mutation. */
export type UpdateMembershipPayload = {
  __typename?: 'UpdateMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Membership` that was updated by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our update `Membership` mutation. */
export type UpdateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the `updateNotificationByNodeId` mutation. */
export type UpdateNotificationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Notification` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Notification` being updated. */
  patch: NotificationPatch;
};

/** All input for the `updateNotification` mutation. */
export type UpdateNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Notification` being updated. */
  patch: NotificationPatch;
};

/** The output of our update `Notification` mutation. */
export type UpdateNotificationPayload = {
  __typename?: 'UpdateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Notification` that was updated by this mutation. */
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  sender?: Maybe<User>;
  /** Reads a single `Team` that is related to this `Notification`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Notification`. */
  user?: Maybe<User>;
  /** Reads a single `Workspace` that is related to this `Notification`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our update `Notification` mutation. */
export type UpdateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `updateOrderByNodeId` mutation. */
export type UpdateOrderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Order` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Order` being updated. */
  patch: OrderPatch;
};

/** All input for the `updateOrder` mutation. */
export type UpdateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Order` being updated. */
  patch: OrderPatch;
};

/** The output of our update `Order` mutation. */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  /** Reads a single `User` that is related to this `Order`. */
  admin?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Order` that was updated by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Order`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `Order` mutation. */
export type UpdateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `updateRegistrationTokenByNodeId` mutation. */
export type UpdateRegistrationTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RegistrationToken` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RegistrationToken` being updated. */
  patch: RegistrationTokenPatch;
};

/** All input for the `updateRegistrationToken` mutation. */
export type UpdateRegistrationTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `RegistrationToken` being updated. */
  patch: RegistrationTokenPatch;
  registrationToken: Scalars['String']['input'];
};

/** The output of our update `RegistrationToken` mutation. */
export type UpdateRegistrationTokenPayload = {
  __typename?: 'UpdateRegistrationTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RegistrationToken` that was updated by this mutation. */
  registrationToken?: Maybe<RegistrationToken>;
  /** An edge for our `RegistrationToken`. May be used by Relay 1. */
  registrationTokenEdge?: Maybe<RegistrationTokensEdge>;
  /** Reads a single `User` that is related to this `RegistrationToken`. */
  user?: Maybe<User>;
};


/** The output of our update `RegistrationToken` mutation. */
export type UpdateRegistrationTokenPayloadRegistrationTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<RegistrationTokensOrderBy>>;
};

/** All input for the `updateRetentionPolicyByNodeId` mutation. */
export type UpdateRetentionPolicyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RetentionPolicy` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RetentionPolicy` being updated. */
  patch: RetentionPolicyPatch;
};

/** All input for the `updateRetentionPolicyByTeamId` mutation. */
export type UpdateRetentionPolicyByTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `RetentionPolicy` being updated. */
  patch: RetentionPolicyPatch;
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `updateRetentionPolicyByTenantId` mutation. */
export type UpdateRetentionPolicyByTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `RetentionPolicy` being updated. */
  patch: RetentionPolicyPatch;
  tenantId: Scalars['BigInt']['input'];
};

/** All input for the `updateRetentionPolicyByWorkspaceId` mutation. */
export type UpdateRetentionPolicyByWorkspaceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `RetentionPolicy` being updated. */
  patch: RetentionPolicyPatch;
  workspaceId: Scalars['BigInt']['input'];
};

/** All input for the `updateRetentionPolicy` mutation. */
export type UpdateRetentionPolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `RetentionPolicy` being updated. */
  patch: RetentionPolicyPatch;
};

/** The output of our update `RetentionPolicy` mutation. */
export type UpdateRetentionPolicyPayload = {
  __typename?: 'UpdateRetentionPolicyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RetentionPolicy` that was updated by this mutation. */
  retentionPolicy?: Maybe<RetentionPolicy>;
  /** An edge for our `RetentionPolicy`. May be used by Relay 1. */
  retentionPolicyEdge?: Maybe<RetentionPoliciesEdge>;
  /** Reads a single `Team` that is related to this `RetentionPolicy`. */
  team?: Maybe<Team>;
  /** Reads a single `Tenant` that is related to this `RetentionPolicy`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `Workspace` that is related to this `RetentionPolicy`. */
  workspace?: Maybe<Workspace>;
};


/** The output of our update `RetentionPolicy` mutation. */
export type UpdateRetentionPolicyPayloadRetentionPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};

/** All input for the `updateSchemaMigrationByNodeId` mutation. */
export type UpdateSchemaMigrationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaMigration` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SchemaMigration` being updated. */
  patch: SchemaMigrationPatch;
};

/** All input for the `updateSchemaMigration` mutation. */
export type UpdateSchemaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `SchemaMigration` being updated. */
  patch: SchemaMigrationPatch;
  version: Scalars['String']['input'];
};

/** The output of our update `SchemaMigration` mutation. */
export type UpdateSchemaMigrationPayload = {
  __typename?: 'UpdateSchemaMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SchemaMigration` that was updated by this mutation. */
  schemaMigration?: Maybe<SchemaMigration>;
  /** An edge for our `SchemaMigration`. May be used by Relay 1. */
  schemaMigrationEdge?: Maybe<SchemaMigrationsEdge>;
};


/** The output of our update `SchemaMigration` mutation. */
export type UpdateSchemaMigrationPayloadSchemaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaMigrationsOrderBy>>;
};

/** All input for the `updateSettingByNodeId` mutation. */
export type UpdateSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Setting` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Setting` being updated. */
  patch: SettingPatch;
};

/** All input for the `updateSetting` mutation. */
export type UpdateSettingInput = {
  attribute: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Setting` being updated. */
  patch: SettingPatch;
};

/** The output of our update `Setting` mutation. */
export type UpdateSettingPayload = {
  __typename?: 'UpdateSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Setting` that was updated by this mutation. */
  setting?: Maybe<Setting>;
  /** An edge for our `Setting`. May be used by Relay 1. */
  settingEdge?: Maybe<SettingsEdge>;
};


/** The output of our update `Setting` mutation. */
export type UpdateSettingPayloadSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<SettingsOrderBy>>;
};

/** All input for the `updateTeamByNodeId` mutation. */
export type UpdateTeamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Team` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Team` being updated. */
  patch: TeamPatch;
};

/** All input for the `updateTeam` mutation. */
export type UpdateTeamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Team` being updated. */
  patch: TeamPatch;
};

/** The output of our update `Team` mutation. */
export type UpdateTeamPayload = {
  __typename?: 'UpdateTeamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Team` that was updated by this mutation. */
  team?: Maybe<Team>;
  /** An edge for our `Team`. May be used by Relay 1. */
  teamEdge?: Maybe<TeamsEdge>;
  /** Reads a single `Tenant` that is related to this `Team`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `Team` mutation. */
export type UpdateTeamPayloadTeamEdgeArgs = {
  orderBy?: InputMaybe<Array<TeamsOrderBy>>;
};

/** All input for the `updateTenantByName` mutation. */
export type UpdateTenantByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
};

/** All input for the `updateTenantByNodeId` mutation. */
export type UpdateTenantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Tenant` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
};

/** All input for the `updateTenant` mutation. */
export type UpdateTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
};

/** The output of our update `Tenant` mutation. */
export type UpdateTenantPayload = {
  __typename?: 'UpdateTenantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was updated by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
  /** Reads a single `Workspace` that is related to this `Tenant`. */
  tutorialWorkspace?: Maybe<Workspace>;
};


/** The output of our update `Tenant` mutation. */
export type UpdateTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the `updateUrlBasedDocumentImportByNodeId` mutation. */
export type UpdateUrlBasedDocumentImportByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UrlBasedDocumentImport` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UrlBasedDocumentImport` being updated. */
  patch: UrlBasedDocumentImportPatch;
};

/** All input for the `updateUrlBasedDocumentImport` mutation. */
export type UpdateUrlBasedDocumentImportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `UrlBasedDocumentImport` being updated. */
  patch: UrlBasedDocumentImportPatch;
};

/** The output of our update `UrlBasedDocumentImport` mutation. */
export type UpdateUrlBasedDocumentImportPayload = {
  __typename?: 'UpdateUrlBasedDocumentImportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImport`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UrlBasedDocumentImport` that was updated by this mutation. */
  urlBasedDocumentImport?: Maybe<UrlBasedDocumentImport>;
  /** An edge for our `UrlBasedDocumentImport`. May be used by Relay 1. */
  urlBasedDocumentImportEdge?: Maybe<UrlBasedDocumentImportsEdge>;
};


/** The output of our update `UrlBasedDocumentImport` mutation. */
export type UpdateUrlBasedDocumentImportPayloadUrlBasedDocumentImportEdgeArgs = {
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportsOrderBy>>;
};

/** All input for the `updateUrlBasedDocumentImportSettingByNodeId` mutation. */
export type UpdateUrlBasedDocumentImportSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UrlBasedDocumentImportSetting` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UrlBasedDocumentImportSetting` being updated. */
  patch: UrlBasedDocumentImportSettingPatch;
};

/** All input for the `updateUrlBasedDocumentImportSetting` mutation. */
export type UpdateUrlBasedDocumentImportSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `UrlBasedDocumentImportSetting` being updated. */
  patch: UrlBasedDocumentImportSettingPatch;
};

/** The output of our update `UrlBasedDocumentImportSetting` mutation. */
export type UpdateUrlBasedDocumentImportSettingPayload = {
  __typename?: 'UpdateUrlBasedDocumentImportSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImportSetting`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UrlBasedDocumentImportSetting`. */
  updatedBy?: Maybe<User>;
  /** The `UrlBasedDocumentImportSetting` that was updated by this mutation. */
  urlBasedDocumentImportSetting?: Maybe<UrlBasedDocumentImportSetting>;
  /** An edge for our `UrlBasedDocumentImportSetting`. May be used by Relay 1. */
  urlBasedDocumentImportSettingEdge?: Maybe<UrlBasedDocumentImportSettingsEdge>;
};


/** The output of our update `UrlBasedDocumentImportSetting` mutation. */
export type UpdateUrlBasedDocumentImportSettingPayloadUrlBasedDocumentImportSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportSettingsOrderBy>>;
};

/** All input for the `updateUserByEmail` mutation. */
export type UpdateUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserByNodeId` mutation. */
export type UpdateUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserConfigPartial` mutation. */
export type UpdateUserConfigPartialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configPatch: Scalars['JSON']['input'];
};

/** The output of our `updateUserConfigPartial` mutation. */
export type UpdateUserConfigPartialPayload = {
  __typename?: 'UpdateUserConfigPartialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Workspace` that is related to this `User`. */
  defaultWorkspace?: Maybe<Workspace>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  /** Reads a single `UserContactDetail` that is related to this `User`. */
  userContactDetailById?: Maybe<UserContactDetail>;
  userData?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `updateUserConfigPartial` mutation. */
export type UpdateUserConfigPartialPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserContactDetailByNodeId` mutation. */
export type UpdateUserContactDetailByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserContactDetail` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserContactDetail` being updated. */
  patch: UserContactDetailPatch;
};

/** All input for the `updateUserContactDetailByUserId` mutation. */
export type UpdateUserContactDetailByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UserContactDetail` being updated. */
  patch: UserContactDetailPatch;
  userId: Scalars['BigInt']['input'];
};

/** All input for the `updateUserContactDetail` mutation. */
export type UpdateUserContactDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `UserContactDetail` being updated. */
  patch: UserContactDetailPatch;
};

/** The output of our update `UserContactDetail` mutation. */
export type UpdateUserContactDetailPayload = {
  __typename?: 'UpdateUserContactDetailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContactDetail`. */
  user?: Maybe<User>;
  /** The `UserContactDetail` that was updated by this mutation. */
  userContactDetail?: Maybe<UserContactDetail>;
  /** An edge for our `UserContactDetail`. May be used by Relay 1. */
  userContactDetailEdge?: Maybe<UserContactDetailsEdge>;
};


/** The output of our update `UserContactDetail` mutation. */
export type UpdateUserContactDetailPayloadUserContactDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContactDetailsOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserLicenseByNodeId` mutation. */
export type UpdateUserLicenseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserLicense` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserLicense` being updated. */
  patch: UserLicensePatch;
};

/** All input for the `updateUserLicense` mutation. */
export type UpdateUserLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `UserLicense` being updated. */
  patch: UserLicensePatch;
  userId: Scalars['BigInt']['input'];
};

/** The output of our update `UserLicense` mutation. */
export type UpdateUserLicensePayload = {
  __typename?: 'UpdateUserLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `UserLicense`. */
  lastModifiedBy?: Maybe<User>;
  /** Reads a single `Order` that is related to this `UserLicense`. */
  order?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserLicense`. */
  user?: Maybe<User>;
  /** The `UserLicense` that was updated by this mutation. */
  userLicense?: Maybe<UserLicense>;
  /** An edge for our `UserLicense`. May be used by Relay 1. */
  userLicenseEdge?: Maybe<UserLicensesEdge>;
};


/** The output of our update `UserLicense` mutation. */
export type UpdateUserLicensePayloadUserLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Workspace` that is related to this `User`. */
  defaultWorkspace?: Maybe<Workspace>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** Reads a single `UserContactDetail` that is related to this `User`. */
  userContactDetailById?: Maybe<UserContactDetail>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateVeevaDocumentMetadatumByNodeId` mutation. */
export type UpdateVeevaDocumentMetadatumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VeevaDocumentMetadatum` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VeevaDocumentMetadatum` being updated. */
  patch: VeevaDocumentMetadatumPatch;
};

/** All input for the `updateVeevaDocumentMetadatum` mutation. */
export type UpdateVeevaDocumentMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `VeevaDocumentMetadatum` being updated. */
  patch: VeevaDocumentMetadatumPatch;
};

/** The output of our update `VeevaDocumentMetadatum` mutation. */
export type UpdateVeevaDocumentMetadatumPayload = {
  __typename?: 'UpdateVeevaDocumentMetadatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `VeevaDocumentMetadatum`. */
  document?: Maybe<Document>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VeevaDocumentMetadatum` that was updated by this mutation. */
  veevaDocumentMetadatum?: Maybe<VeevaDocumentMetadatum>;
  /** An edge for our `VeevaDocumentMetadatum`. May be used by Relay 1. */
  veevaDocumentMetadatumEdge?: Maybe<VeevaDocumentMetadataEdge>;
};


/** The output of our update `VeevaDocumentMetadatum` mutation. */
export type UpdateVeevaDocumentMetadatumPayloadVeevaDocumentMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<VeevaDocumentMetadataOrderBy>>;
};

/** All input for the `updateWorkspaceByFirebaseId` mutation. */
export type UpdateWorkspaceByFirebaseIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firebaseId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Workspace` being updated. */
  patch: WorkspacePatch;
};

/** All input for the `updateWorkspaceByNodeId` mutation. */
export type UpdateWorkspaceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Workspace` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Workspace` being updated. */
  patch: WorkspacePatch;
};

/** All input for the `updateWorkspace` mutation. */
export type UpdateWorkspaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Workspace` being updated. */
  patch: WorkspacePatch;
};

/** The output of our update `Workspace` mutation. */
export type UpdateWorkspacePayload = {
  __typename?: 'UpdateWorkspacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `Workspace`. */
  defaultLegalAppendix?: Maybe<Document>;
  /** Reads a single `Workspace` that is related to this `Workspace`. */
  parent?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `Workspace`. */
  personalWorkspaceOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Workspace`. */
  tenant?: Maybe<Tenant>;
  /** The `Workspace` that was updated by this mutation. */
  workspace?: Maybe<Workspace>;
  /** An edge for our `Workspace`. May be used by Relay 1. */
  workspaceEdge?: Maybe<WorkspacesEdge>;
};


/** The output of our update `Workspace` mutation. */
export type UpdateWorkspacePayloadWorkspaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

/** All input for the `updateWorkspaceSubscriptionByNodeId` mutation. */
export type UpdateWorkspaceSubscriptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkspaceSubscription` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WorkspaceSubscription` being updated. */
  patch: WorkspaceSubscriptionPatch;
};

/** All input for the `updateWorkspaceSubscriptionBySubteamIdAndTeamId` mutation. */
export type UpdateWorkspaceSubscriptionBySubteamIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `WorkspaceSubscription` being updated. */
  patch: WorkspaceSubscriptionPatch;
  subteamId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
};

/** All input for the `updateWorkspaceSubscriptionByUserIdAndTeamId` mutation. */
export type UpdateWorkspaceSubscriptionByUserIdAndTeamIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `WorkspaceSubscription` being updated. */
  patch: WorkspaceSubscriptionPatch;
  teamId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
};

/** All input for the `updateWorkspaceSubscription` mutation. */
export type UpdateWorkspaceSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `WorkspaceSubscription` being updated. */
  patch: WorkspaceSubscriptionPatch;
};

/** The output of our update `WorkspaceSubscription` mutation. */
export type UpdateWorkspaceSubscriptionPayload = {
  __typename?: 'UpdateWorkspaceSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  /** The `WorkspaceSubscription` that was updated by this mutation. */
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** An edge for our `WorkspaceSubscription`. May be used by Relay 1. */
  workspaceSubscriptionEdge?: Maybe<WorkspaceSubscriptionsEdge>;
};


/** The output of our update `WorkspaceSubscription` mutation. */
export type UpdateWorkspaceSubscriptionPayloadWorkspaceSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

export type UrlBasedDocumentImport = Node & {
  __typename?: 'UrlBasedDocumentImport';
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImport`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  httpStatus?: Maybe<Scalars['Int']['output']>;
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  runAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `UrlBasedDocumentImport` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UrlBasedDocumentImportCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `etag` field. */
  etag?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hash` field. */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `httpStatus` field. */
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `runAt` field. */
  runAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `UrlBasedDocumentImport` object types. All fields are combined with a logical ‘and.’ */
export type UrlBasedDocumentImportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UrlBasedDocumentImportFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `etag` field. */
  etag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hash` field. */
  hash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `httpStatus` field. */
  httpStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UrlBasedDocumentImportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UrlBasedDocumentImportFilter>>;
  /** Filter by the object’s `runAt` field. */
  runAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `UrlBasedDocumentImport` */
export type UrlBasedDocumentImportInput = {
  documentId: Scalars['BigInt']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  runAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `UrlBasedDocumentImport`. Fields that are set will be updated. */
export type UrlBasedDocumentImportPatch = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  runAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UrlBasedDocumentImportSetting = Node & {
  __typename?: 'UrlBasedDocumentImportSetting';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Document` that is related to this `UrlBasedDocumentImportSetting`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  sysPeriod?: Maybe<DatetimeRange>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UrlBasedDocumentImportSetting`. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['BigInt']['output']>;
  url: Scalars['String']['output'];
};

/**
 * A condition to be used against `UrlBasedDocumentImportSetting` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UrlBasedDocumentImportSettingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedById` field. */
  updatedById?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `UrlBasedDocumentImportSetting` object types. All fields are combined with a logical ‘and.’ */
export type UrlBasedDocumentImportSettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UrlBasedDocumentImportSettingFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UrlBasedDocumentImportSettingFilter>>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` relation. */
  updatedBy?: InputMaybe<UserFilter>;
  /** A related `updatedBy` exists. */
  updatedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `updatedById` field. */
  updatedById?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `UrlBasedDocumentImportSetting` */
export type UrlBasedDocumentImportSettingInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentId: Scalars['BigInt']['input'];
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedById?: InputMaybe<Scalars['BigInt']['input']>;
  url: Scalars['String']['input'];
};

/** Represents an update to a `UrlBasedDocumentImportSetting`. Fields that are set will be updated. */
export type UrlBasedDocumentImportSettingPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedById?: InputMaybe<Scalars['BigInt']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `UrlBasedDocumentImportSetting` values. */
export type UrlBasedDocumentImportSettingsConnection = {
  __typename?: 'UrlBasedDocumentImportSettingsConnection';
  /** A list of edges which contains the `UrlBasedDocumentImportSetting` and cursor to aid in pagination. */
  edges: Array<UrlBasedDocumentImportSettingsEdge>;
  /** A list of `UrlBasedDocumentImportSetting` objects. */
  nodes: Array<Maybe<UrlBasedDocumentImportSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UrlBasedDocumentImportSetting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UrlBasedDocumentImportSetting` edge in the connection. */
export type UrlBasedDocumentImportSettingsEdge = {
  __typename?: 'UrlBasedDocumentImportSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UrlBasedDocumentImportSetting` at the end of the edge. */
  node?: Maybe<UrlBasedDocumentImportSetting>;
};

/** Methods to use when ordering `UrlBasedDocumentImportSetting`. */
export enum UrlBasedDocumentImportSettingsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByIdAsc = 'UPDATED_BY_ID_ASC',
  UpdatedByIdDesc = 'UPDATED_BY_ID_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC',
  UserByUpdatedByIdAppConsentGivenAtAsc = 'USER_BY_UPDATED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUpdatedByIdAppConsentGivenAtDesc = 'USER_BY_UPDATED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUpdatedByIdConfigAsc = 'USER_BY_UPDATED_BY_ID__CONFIG_ASC',
  UserByUpdatedByIdConfigDesc = 'USER_BY_UPDATED_BY_ID__CONFIG_DESC',
  UserByUpdatedByIdCreatedAtAsc = 'USER_BY_UPDATED_BY_ID__CREATED_AT_ASC',
  UserByUpdatedByIdCreatedAtDesc = 'USER_BY_UPDATED_BY_ID__CREATED_AT_DESC',
  UserByUpdatedByIdCrmContactVisibilityFilterAsc = 'USER_BY_UPDATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUpdatedByIdCrmContactVisibilityFilterDesc = 'USER_BY_UPDATED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUpdatedByIdDefaultWorkspaceIdAsc = 'USER_BY_UPDATED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUpdatedByIdDefaultWorkspaceIdDesc = 'USER_BY_UPDATED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUpdatedByIdDisabledAsc = 'USER_BY_UPDATED_BY_ID__DISABLED_ASC',
  UserByUpdatedByIdDisabledDesc = 'USER_BY_UPDATED_BY_ID__DISABLED_DESC',
  UserByUpdatedByIdDisplayNameAsc = 'USER_BY_UPDATED_BY_ID__DISPLAY_NAME_ASC',
  UserByUpdatedByIdDisplayNameDesc = 'USER_BY_UPDATED_BY_ID__DISPLAY_NAME_DESC',
  UserByUpdatedByIdEmailAsc = 'USER_BY_UPDATED_BY_ID__EMAIL_ASC',
  UserByUpdatedByIdEmailDesc = 'USER_BY_UPDATED_BY_ID__EMAIL_DESC',
  UserByUpdatedByIdExternalGroupsAsc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByUpdatedByIdExternalGroupsDesc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByUpdatedByIdExternalGroupsSyncedAtAsc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUpdatedByIdExternalGroupsSyncedAtDesc = 'USER_BY_UPDATED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUpdatedByIdFirebaseAuthIdAsc = 'USER_BY_UPDATED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByUpdatedByIdFirebaseAuthIdDesc = 'USER_BY_UPDATED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByUpdatedByIdFlagsAsc = 'USER_BY_UPDATED_BY_ID__FLAGS_ASC',
  UserByUpdatedByIdFlagsDesc = 'USER_BY_UPDATED_BY_ID__FLAGS_DESC',
  UserByUpdatedByIdIdAsc = 'USER_BY_UPDATED_BY_ID__ID_ASC',
  UserByUpdatedByIdIdDesc = 'USER_BY_UPDATED_BY_ID__ID_DESC',
  UserByUpdatedByIdIsTenantAdminAsc = 'USER_BY_UPDATED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByUpdatedByIdIsTenantAdminDesc = 'USER_BY_UPDATED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByUpdatedByIdRegisteredAtAsc = 'USER_BY_UPDATED_BY_ID__REGISTERED_AT_ASC',
  UserByUpdatedByIdRegisteredAtDesc = 'USER_BY_UPDATED_BY_ID__REGISTERED_AT_DESC',
  UserByUpdatedByIdSysPeriodAsc = 'USER_BY_UPDATED_BY_ID__SYS_PERIOD_ASC',
  UserByUpdatedByIdSysPeriodDesc = 'USER_BY_UPDATED_BY_ID__SYS_PERIOD_DESC',
  UserByUpdatedByIdTenantIdAsc = 'USER_BY_UPDATED_BY_ID__TENANT_ID_ASC',
  UserByUpdatedByIdTenantIdDesc = 'USER_BY_UPDATED_BY_ID__TENANT_ID_DESC',
  UserByUpdatedByIdUpdatedAtAsc = 'USER_BY_UPDATED_BY_ID__UPDATED_AT_ASC',
  UserByUpdatedByIdUpdatedAtDesc = 'USER_BY_UPDATED_BY_ID__UPDATED_AT_DESC'
}

/** A connection to a list of `UrlBasedDocumentImport` values. */
export type UrlBasedDocumentImportsConnection = {
  __typename?: 'UrlBasedDocumentImportsConnection';
  /** A list of edges which contains the `UrlBasedDocumentImport` and cursor to aid in pagination. */
  edges: Array<UrlBasedDocumentImportsEdge>;
  /** A list of `UrlBasedDocumentImport` objects. */
  nodes: Array<Maybe<UrlBasedDocumentImport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UrlBasedDocumentImport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UrlBasedDocumentImport` edge in the connection. */
export type UrlBasedDocumentImportsEdge = {
  __typename?: 'UrlBasedDocumentImportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UrlBasedDocumentImport` at the end of the edge. */
  node?: Maybe<UrlBasedDocumentImport>;
};

/** Methods to use when ordering `UrlBasedDocumentImport`. */
export enum UrlBasedDocumentImportsOrderBy {
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  EtagAsc = 'ETAG_ASC',
  EtagDesc = 'ETAG_DESC',
  HashAsc = 'HASH_ASC',
  HashDesc = 'HASH_DESC',
  HttpStatusAsc = 'HTTP_STATUS_ASC',
  HttpStatusDesc = 'HTTP_STATUS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RunAtAsc = 'RUN_AT_ASC',
  RunAtDesc = 'RUN_AT_DESC'
}

export type User = Node & {
  __typename?: 'User';
  appConsentGivenAt?: Maybe<Scalars['Datetime']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `CrmContactConsent`. */
  crmContactConsentsByCreatedById: CrmContactConsentsConnection;
  crmContactVisibilityFilter?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Workspace` that is related to this `User`. */
  defaultWorkspace?: Maybe<Workspace>;
  defaultWorkspaceId?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `DocumentProcess`. */
  documentProcessesByInitiatorId: DocumentProcessesConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceAccess`. */
  documentSpaceAccesses: DocumentSpaceAccessesConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceAccess`. */
  documentSpaceAccessesByCreatorId: DocumentSpaceAccessesConnection;
  /** Reads and enables pagination through a set of `DocumentSpaceConfig`. */
  documentSpaceConfigsByUpdatedById: DocumentSpaceConfigsConnection;
  /** Reads and enables pagination through a set of `DocumentSpace`. */
  documentSpacesByCreatorId: DocumentSpacesConnection;
  /** Reads and enables pagination through a set of `Document`. */
  documentsByCreatedById: DocumentsConnection;
  /** Reads and enables pagination through a set of `Document`. */
  documentsByLastModifiedById: DocumentsConnection;
  email: Scalars['String']['output'];
  externalGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  externalGroupsSyncedAt?: Maybe<Scalars['Datetime']['output']>;
  firebaseAuthId?: Maybe<Scalars['String']['output']>;
  flags: Array<Maybe<Scalars['String']['output']>>;
  /** Reads and enables pagination through a set of `FlowItem`. */
  flowItemsByCreatorId: FlowItemsConnection;
  /** Reads and enables pagination through a set of `FlowSubscription`. */
  flowSubscriptions: FlowSubscriptionsConnection;
  /** Reads and enables pagination through a set of `Flow`. */
  flowsByCreatorId: FlowsConnection;
  id: Scalars['BigInt']['output'];
  isTenantAdmin: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `LabelsOfDocumentView`. */
  labelsOfDocumentViewsByLastModifiedById: LabelsOfDocumentViewsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships: MembershipsConnection;
  mergedConfig?: Maybe<Scalars['JSON']['output']>;
  mergedFlags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsBySenderId: NotificationsConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByAdminId: OrdersConnection;
  registeredAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `RegistrationToken`. */
  registrationTokens: RegistrationTokensConnection;
  sysPeriod: DatetimeRange;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UrlBasedDocumentImportSetting`. */
  urlBasedDocumentImportSettingsByUpdatedById: UrlBasedDocumentImportSettingsConnection;
  /** Reads a single `UserContactDetail` that is related to this `User`. */
  userContactDetail?: Maybe<UserContactDetail>;
  /** Reads a single `UserContactDetail` that is related to this `User`. */
  userContactDetailById?: Maybe<UserContactDetail>;
  /**
   * Reads and enables pagination through a set of `UserContactDetail`.
   * @deprecated Please use userContactDetail instead
   */
  userContactDetails: UserContactDetailsConnection;
  /** Reads and enables pagination through a set of `UserLicense`. */
  userLicenses: UserLicensesConnection;
  /** Reads and enables pagination through a set of `UserLicense`. */
  userLicensesByLastModifiedById: UserLicensesConnection;
  /** Reads and enables pagination through a set of `WorkspaceSubscription`. */
  workspaceSubscriptions: WorkspaceSubscriptionsConnection;
  /** Reads and enables pagination through a set of `Workspace`. */
  workspacesByPersonalWorkspaceOfUserId: WorkspacesConnection;
};


export type UserCrmContactConsentsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CrmContactConsentCondition>;
  filter?: InputMaybe<CrmContactConsentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContactConsentsOrderBy>>;
};


export type UserDocumentProcessesByInitiatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentProcessCondition>;
  filter?: InputMaybe<DocumentProcessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentProcessesOrderBy>>;
};


export type UserDocumentSpaceAccessesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceAccessCondition>;
  filter?: InputMaybe<DocumentSpaceAccessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};


export type UserDocumentSpaceAccessesByCreatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceAccessCondition>;
  filter?: InputMaybe<DocumentSpaceAccessFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceAccessesOrderBy>>;
};


export type UserDocumentSpaceConfigsByUpdatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceConfigCondition>;
  filter?: InputMaybe<DocumentSpaceConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpaceConfigsOrderBy>>;
};


export type UserDocumentSpacesByCreatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentSpaceCondition>;
  filter?: InputMaybe<DocumentSpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSpacesOrderBy>>;
};


export type UserDocumentsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentCondition>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};


export type UserDocumentsByLastModifiedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentCondition>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};


export type UserFlowItemsByCreatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowItemCondition>;
  filter?: InputMaybe<FlowItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowItemsOrderBy>>;
};


export type UserFlowSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowSubscriptionCondition>;
  filter?: InputMaybe<FlowSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowSubscriptionsOrderBy>>;
};


export type UserFlowsByCreatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlowCondition>;
  filter?: InputMaybe<FlowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlowsOrderBy>>;
};


export type UserLabelsOfDocumentViewsByLastModifiedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LabelsOfDocumentViewCondition>;
  filter?: InputMaybe<LabelsOfDocumentViewFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LabelsOfDocumentViewsOrderBy>>;
};


export type UserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type UserMergedConfigArgs = {
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserMergedFlagsArgs = {
  includeSuperteams?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type UserNotificationsBySenderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type UserOrdersByAdminIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type UserRegistrationTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RegistrationTokenCondition>;
  filter?: InputMaybe<RegistrationTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistrationTokensOrderBy>>;
};


export type UserUrlBasedDocumentImportSettingsByUpdatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UrlBasedDocumentImportSettingCondition>;
  filter?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UrlBasedDocumentImportSettingsOrderBy>>;
};


export type UserUserContactDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContactDetailCondition>;
  filter?: InputMaybe<UserContactDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContactDetailsOrderBy>>;
};


export type UserUserLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserLicenseCondition>;
  filter?: InputMaybe<UserLicenseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};


export type UserUserLicensesByLastModifiedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserLicenseCondition>;
  filter?: InputMaybe<UserLicenseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserLicensesOrderBy>>;
};


export type UserWorkspaceSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceSubscriptionCondition>;
  filter?: InputMaybe<WorkspaceSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};


export type UserWorkspacesByPersonalWorkspaceOfUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceCondition>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `appConsentGivenAt` field. */
  appConsentGivenAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crmContactVisibilityFilter` field. */
  crmContactVisibilityFilter?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultWorkspaceId` field. */
  defaultWorkspaceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `disabled` field. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalGroups` field. */
  externalGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `externalGroupsSyncedAt` field. */
  externalGroupsSyncedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `firebaseAuthId` field. */
  firebaseAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flags` field. */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isTenantAdmin` field. */
  isTenantAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mergedConfig` field. */
  mergedConfig?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UserContactDetail = Node & {
  __typename?: 'UserContactDetail';
  appointmentBookingUrl?: Maybe<Scalars['String']['output']>;
  businessCardUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserContactDetail`. */
  user?: Maybe<User>;
  /** Reads a single `User` that is related to this `UserContactDetail`. */
  userById?: Maybe<User>;
  userId: Scalars['BigInt']['output'];
  /**
   * Reads and enables pagination through a set of `User`.
   * @deprecated Please use userById instead
   */
  usersById: UsersConnection;
};


export type UserContactDetailUsersByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/**
 * A condition to be used against `UserContactDetail` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserContactDetailCondition = {
  /** Checks for equality with the object’s `appointmentBookingUrl` field. */
  appointmentBookingUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `businessCardUrl` field. */
  businessCardUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `profileImageUrl` field. */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `UserContactDetail` object types. All fields are combined with a logical ‘and.’ */
export type UserContactDetailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserContactDetailFilter>>;
  /** Filter by the object’s `appointmentBookingUrl` field. */
  appointmentBookingUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `businessCardUrl` field. */
  businessCardUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserContactDetailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserContactDetailFilter>>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `profileImageUrl` field. */
  profileImageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userById` relation. */
  userById?: InputMaybe<UserFilter>;
  /** A related `userById` exists. */
  userByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `UserContactDetail` */
export type UserContactDetailInput = {
  appointmentBookingUrl?: InputMaybe<Scalars['String']['input']>;
  businessCardUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['BigInt']['input'];
};

/** Represents an update to a `UserContactDetail`. Fields that are set will be updated. */
export type UserContactDetailPatch = {
  appointmentBookingUrl?: InputMaybe<Scalars['String']['input']>;
  businessCardUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `UserContactDetail` values. */
export type UserContactDetailsConnection = {
  __typename?: 'UserContactDetailsConnection';
  /** A list of edges which contains the `UserContactDetail` and cursor to aid in pagination. */
  edges: Array<UserContactDetailsEdge>;
  /** A list of `UserContactDetail` objects. */
  nodes: Array<Maybe<UserContactDetail>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserContactDetail` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserContactDetail` edge in the connection. */
export type UserContactDetailsEdge = {
  __typename?: 'UserContactDetailsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserContactDetail` at the end of the edge. */
  node?: Maybe<UserContactDetail>;
};

/** Methods to use when ordering `UserContactDetail`. */
export enum UserContactDetailsOrderBy {
  AppointmentBookingUrlAsc = 'APPOINTMENT_BOOKING_URL_ASC',
  AppointmentBookingUrlDesc = 'APPOINTMENT_BOOKING_URL_DESC',
  BusinessCardUrlAsc = 'BUSINESS_CARD_URL_ASC',
  BusinessCardUrlDesc = 'BUSINESS_CARD_URL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfileImageUrlAsc = 'PROFILE_IMAGE_URL_ASC',
  ProfileImageUrlDesc = 'PROFILE_IMAGE_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByIdAppConsentGivenAtAsc = 'USER_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByIdAppConsentGivenAtDesc = 'USER_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByIdConfigAsc = 'USER_BY_ID__CONFIG_ASC',
  UserByIdConfigDesc = 'USER_BY_ID__CONFIG_DESC',
  UserByIdCreatedAtAsc = 'USER_BY_ID__CREATED_AT_ASC',
  UserByIdCreatedAtDesc = 'USER_BY_ID__CREATED_AT_DESC',
  UserByIdCrmContactVisibilityFilterAsc = 'USER_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByIdCrmContactVisibilityFilterDesc = 'USER_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByIdDefaultWorkspaceIdAsc = 'USER_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByIdDefaultWorkspaceIdDesc = 'USER_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByIdDisabledAsc = 'USER_BY_ID__DISABLED_ASC',
  UserByIdDisabledDesc = 'USER_BY_ID__DISABLED_DESC',
  UserByIdDisplayNameAsc = 'USER_BY_ID__DISPLAY_NAME_ASC',
  UserByIdDisplayNameDesc = 'USER_BY_ID__DISPLAY_NAME_DESC',
  UserByIdEmailAsc = 'USER_BY_ID__EMAIL_ASC',
  UserByIdEmailDesc = 'USER_BY_ID__EMAIL_DESC',
  UserByIdExternalGroupsAsc = 'USER_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByIdExternalGroupsDesc = 'USER_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByIdExternalGroupsSyncedAtAsc = 'USER_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByIdExternalGroupsSyncedAtDesc = 'USER_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByIdFirebaseAuthIdAsc = 'USER_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByIdFirebaseAuthIdDesc = 'USER_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByIdFlagsAsc = 'USER_BY_ID__FLAGS_ASC',
  UserByIdFlagsDesc = 'USER_BY_ID__FLAGS_DESC',
  UserByIdIdAsc = 'USER_BY_ID__ID_ASC',
  UserByIdIdDesc = 'USER_BY_ID__ID_DESC',
  UserByIdIsTenantAdminAsc = 'USER_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByIdIsTenantAdminDesc = 'USER_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByIdRegisteredAtAsc = 'USER_BY_ID__REGISTERED_AT_ASC',
  UserByIdRegisteredAtDesc = 'USER_BY_ID__REGISTERED_AT_DESC',
  UserByIdSysPeriodAsc = 'USER_BY_ID__SYS_PERIOD_ASC',
  UserByIdSysPeriodDesc = 'USER_BY_ID__SYS_PERIOD_DESC',
  UserByIdTenantIdAsc = 'USER_BY_ID__TENANT_ID_ASC',
  UserByIdTenantIdDesc = 'USER_BY_ID__TENANT_ID_DESC',
  UserByIdUpdatedAtAsc = 'USER_BY_ID__UPDATED_AT_ASC',
  UserByIdUpdatedAtDesc = 'USER_BY_ID__UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `appConsentGivenAt` field. */
  appConsentGivenAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crmContactConsentsByCreatedById` relation. */
  crmContactConsentsByCreatedById?: InputMaybe<UserToManyCrmContactConsentFilter>;
  /** Some related `crmContactConsentsByCreatedById` exist. */
  crmContactConsentsByCreatedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `crmContactVisibilityFilter` field. */
  crmContactVisibilityFilter?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultWorkspace` relation. */
  defaultWorkspace?: InputMaybe<WorkspaceFilter>;
  /** A related `defaultWorkspace` exists. */
  defaultWorkspaceExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `defaultWorkspaceId` field. */
  defaultWorkspaceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `disabled` field. */
  disabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentProcessesByInitiatorId` relation. */
  documentProcessesByInitiatorId?: InputMaybe<UserToManyDocumentProcessFilter>;
  /** Some related `documentProcessesByInitiatorId` exist. */
  documentProcessesByInitiatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceAccesses` relation. */
  documentSpaceAccesses?: InputMaybe<UserToManyDocumentSpaceAccessFilter>;
  /** Filter by the object’s `documentSpaceAccessesByCreatorId` relation. */
  documentSpaceAccessesByCreatorId?: InputMaybe<UserToManyDocumentSpaceAccessFilter>;
  /** Some related `documentSpaceAccessesByCreatorId` exist. */
  documentSpaceAccessesByCreatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `documentSpaceAccesses` exist. */
  documentSpaceAccessesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpaceConfigsByUpdatedById` relation. */
  documentSpaceConfigsByUpdatedById?: InputMaybe<UserToManyDocumentSpaceConfigFilter>;
  /** Some related `documentSpaceConfigsByUpdatedById` exist. */
  documentSpaceConfigsByUpdatedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentSpacesByCreatorId` relation. */
  documentSpacesByCreatorId?: InputMaybe<UserToManyDocumentSpaceFilter>;
  /** Some related `documentSpacesByCreatorId` exist. */
  documentSpacesByCreatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentsByCreatedById` relation. */
  documentsByCreatedById?: InputMaybe<UserToManyDocumentFilter>;
  /** Some related `documentsByCreatedById` exist. */
  documentsByCreatedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentsByLastModifiedById` relation. */
  documentsByLastModifiedById?: InputMaybe<UserToManyDocumentFilter>;
  /** Some related `documentsByLastModifiedById` exist. */
  documentsByLastModifiedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalGroups` field. */
  externalGroups?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `externalGroupsSyncedAt` field. */
  externalGroupsSyncedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `firebaseAuthId` field. */
  firebaseAuthId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flags` field. */
  flags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `flowItemsByCreatorId` relation. */
  flowItemsByCreatorId?: InputMaybe<UserToManyFlowItemFilter>;
  /** Some related `flowItemsByCreatorId` exist. */
  flowItemsByCreatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flowSubscriptions` relation. */
  flowSubscriptions?: InputMaybe<UserToManyFlowSubscriptionFilter>;
  /** Some related `flowSubscriptions` exist. */
  flowSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `flowsByCreatorId` relation. */
  flowsByCreatorId?: InputMaybe<UserToManyFlowFilter>;
  /** Some related `flowsByCreatorId` exist. */
  flowsByCreatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isTenantAdmin` field. */
  isTenantAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `labelsOfDocumentViewsByLastModifiedById` relation. */
  labelsOfDocumentViewsByLastModifiedById?: InputMaybe<UserToManyLabelsOfDocumentViewFilter>;
  /** Some related `labelsOfDocumentViewsByLastModifiedById` exist. */
  labelsOfDocumentViewsByLastModifiedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberships` relation. */
  memberships?: InputMaybe<UserToManyMembershipFilter>;
  /** Some related `memberships` exist. */
  membershipsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `mergedConfig` field. */
  mergedConfig?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `mergedFlags` field. */
  mergedFlags?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<UserToManyNotificationFilter>;
  /** Filter by the object’s `notificationsBySenderId` relation. */
  notificationsBySenderId?: InputMaybe<UserToManyNotificationFilter>;
  /** Some related `notificationsBySenderId` exist. */
  notificationsBySenderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `ordersByAdminId` relation. */
  ordersByAdminId?: InputMaybe<UserToManyOrderFilter>;
  /** Some related `ordersByAdminId` exist. */
  ordersByAdminIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `registrationTokens` relation. */
  registrationTokens?: InputMaybe<UserToManyRegistrationTokenFilter>;
  /** Some related `registrationTokens` exist. */
  registrationTokensExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `urlBasedDocumentImportSettingsByUpdatedById` relation. */
  urlBasedDocumentImportSettingsByUpdatedById?: InputMaybe<UserToManyUrlBasedDocumentImportSettingFilter>;
  /** Some related `urlBasedDocumentImportSettingsByUpdatedById` exist. */
  urlBasedDocumentImportSettingsByUpdatedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userContactDetail` relation. */
  userContactDetail?: InputMaybe<UserContactDetailFilter>;
  /** Filter by the object’s `userContactDetailById` relation. */
  userContactDetailById?: InputMaybe<UserContactDetailFilter>;
  /** A related `userContactDetail` exists. */
  userContactDetailExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userLicenses` relation. */
  userLicenses?: InputMaybe<UserToManyUserLicenseFilter>;
  /** Filter by the object’s `userLicensesByLastModifiedById` relation. */
  userLicensesByLastModifiedById?: InputMaybe<UserToManyUserLicenseFilter>;
  /** Some related `userLicensesByLastModifiedById` exist. */
  userLicensesByLastModifiedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `userLicenses` exist. */
  userLicensesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspaceSubscriptions` relation. */
  workspaceSubscriptions?: InputMaybe<UserToManyWorkspaceSubscriptionFilter>;
  /** Some related `workspaceSubscriptions` exist. */
  workspaceSubscriptionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspacesByPersonalWorkspaceOfUserId` relation. */
  workspacesByPersonalWorkspaceOfUserId?: InputMaybe<UserToManyWorkspaceFilter>;
  /** Some related `workspacesByPersonalWorkspaceOfUserId` exist. */
  workspacesByPersonalWorkspaceOfUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  appConsentGivenAt?: InputMaybe<Scalars['Datetime']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  crmContactVisibilityFilter?: InputMaybe<Scalars['String']['input']>;
  defaultWorkspaceId?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalGroupsSyncedAt?: InputMaybe<Scalars['Datetime']['input']>;
  firebaseAuthId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isTenantAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  registeredAt?: InputMaybe<Scalars['Datetime']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tenantId: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UserLicense = Node & {
  __typename?: 'UserLicense';
  /** Reads a single `User` that is related to this `UserLicense`. */
  lastModifiedBy?: Maybe<User>;
  lastModifiedById?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `UserLicense`. */
  order?: Maybe<Order>;
  orderId: Scalars['BigInt']['output'];
  /** Reads a single `User` that is related to this `UserLicense`. */
  user?: Maybe<User>;
  userId: Scalars['BigInt']['output'];
  validityPeriod: DatetimeRange;
};

/**
 * A condition to be used against `UserLicense` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserLicenseCondition = {
  /** Checks for equality with the object’s `lastModifiedById` field. */
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `validityPeriod` field. */
  validityPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `UserLicense` object types. All fields are combined with a logical ‘and.’ */
export type UserLicenseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserLicenseFilter>>;
  /** Filter by the object’s `lastModifiedBy` relation. */
  lastModifiedBy?: InputMaybe<UserFilter>;
  /** A related `lastModifiedBy` exists. */
  lastModifiedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lastModifiedById` field. */
  lastModifiedById?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserLicenseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserLicenseFilter>>;
  /** Filter by the object’s `order` relation. */
  order?: InputMaybe<OrderFilter>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `validityPeriod` field. */
  validityPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `UserLicense` */
export type UserLicenseInput = {
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  orderId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
  validityPeriod: DatetimeRangeInput;
};

/** Represents an update to a `UserLicense`. Fields that are set will be updated. */
export type UserLicensePatch = {
  lastModifiedById?: InputMaybe<Scalars['BigInt']['input']>;
  orderId?: InputMaybe<Scalars['BigInt']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
  validityPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A connection to a list of `UserLicense` values. */
export type UserLicensesConnection = {
  __typename?: 'UserLicensesConnection';
  /** A list of edges which contains the `UserLicense` and cursor to aid in pagination. */
  edges: Array<UserLicensesEdge>;
  /** A list of `UserLicense` objects. */
  nodes: Array<Maybe<UserLicense>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserLicense` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserLicense` edge in the connection. */
export type UserLicensesEdge = {
  __typename?: 'UserLicensesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserLicense` at the end of the edge. */
  node?: Maybe<UserLicense>;
};

/** Methods to use when ordering `UserLicense`. */
export enum UserLicensesOrderBy {
  LastModifiedByIdAsc = 'LAST_MODIFIED_BY_ID_ASC',
  LastModifiedByIdDesc = 'LAST_MODIFIED_BY_ID_DESC',
  Natural = 'NATURAL',
  OrderByOrderIdAdminIdAsc = 'ORDER_BY_ORDER_ID__ADMIN_ID_ASC',
  OrderByOrderIdAdminIdDesc = 'ORDER_BY_ORDER_ID__ADMIN_ID_DESC',
  OrderByOrderIdAmountCentsAsc = 'ORDER_BY_ORDER_ID__AMOUNT_CENTS_ASC',
  OrderByOrderIdAmountCentsDesc = 'ORDER_BY_ORDER_ID__AMOUNT_CENTS_DESC',
  OrderByOrderIdCommentAsc = 'ORDER_BY_ORDER_ID__COMMENT_ASC',
  OrderByOrderIdCommentDesc = 'ORDER_BY_ORDER_ID__COMMENT_DESC',
  OrderByOrderIdContactEmailAsc = 'ORDER_BY_ORDER_ID__CONTACT_EMAIL_ASC',
  OrderByOrderIdContactEmailDesc = 'ORDER_BY_ORDER_ID__CONTACT_EMAIL_DESC',
  OrderByOrderIdContactNameAsc = 'ORDER_BY_ORDER_ID__CONTACT_NAME_ASC',
  OrderByOrderIdContactNameDesc = 'ORDER_BY_ORDER_ID__CONTACT_NAME_DESC',
  OrderByOrderIdCreatedAtAsc = 'ORDER_BY_ORDER_ID__CREATED_AT_ASC',
  OrderByOrderIdCreatedAtDesc = 'ORDER_BY_ORDER_ID__CREATED_AT_DESC',
  OrderByOrderIdCurrencyCodeAsc = 'ORDER_BY_ORDER_ID__CURRENCY_CODE_ASC',
  OrderByOrderIdCurrencyCodeDesc = 'ORDER_BY_ORDER_ID__CURRENCY_CODE_DESC',
  OrderByOrderIdDescriptionAsc = 'ORDER_BY_ORDER_ID__DESCRIPTION_ASC',
  OrderByOrderIdDescriptionDesc = 'ORDER_BY_ORDER_ID__DESCRIPTION_DESC',
  OrderByOrderIdFastbillReferenceAsc = 'ORDER_BY_ORDER_ID__FASTBILL_REFERENCE_ASC',
  OrderByOrderIdFastbillReferenceDesc = 'ORDER_BY_ORDER_ID__FASTBILL_REFERENCE_DESC',
  OrderByOrderIdIdAsc = 'ORDER_BY_ORDER_ID__ID_ASC',
  OrderByOrderIdIdDesc = 'ORDER_BY_ORDER_ID__ID_DESC',
  OrderByOrderIdInvoiceNumberAsc = 'ORDER_BY_ORDER_ID__INVOICE_NUMBER_ASC',
  OrderByOrderIdInvoiceNumberDesc = 'ORDER_BY_ORDER_ID__INVOICE_NUMBER_DESC',
  OrderByOrderIdLicensesCountAsc = 'ORDER_BY_ORDER_ID__LICENSES_COUNT_ASC',
  OrderByOrderIdLicensesCountDesc = 'ORDER_BY_ORDER_ID__LICENSES_COUNT_DESC',
  OrderByOrderIdNumTeamLicensesAsc = 'ORDER_BY_ORDER_ID__NUM_TEAM_LICENSES_ASC',
  OrderByOrderIdNumTeamLicensesDesc = 'ORDER_BY_ORDER_ID__NUM_TEAM_LICENSES_DESC',
  OrderByOrderIdPipedriveReferenceAsc = 'ORDER_BY_ORDER_ID__PIPEDRIVE_REFERENCE_ASC',
  OrderByOrderIdPipedriveReferenceDesc = 'ORDER_BY_ORDER_ID__PIPEDRIVE_REFERENCE_DESC',
  OrderByOrderIdTenantIdAsc = 'ORDER_BY_ORDER_ID__TENANT_ID_ASC',
  OrderByOrderIdTenantIdDesc = 'ORDER_BY_ORDER_ID__TENANT_ID_DESC',
  OrderByOrderIdValidityPeriodAsc = 'ORDER_BY_ORDER_ID__VALIDITY_PERIOD_ASC',
  OrderByOrderIdValidityPeriodDesc = 'ORDER_BY_ORDER_ID__VALIDITY_PERIOD_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserByLastModifiedByIdAppConsentGivenAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByLastModifiedByIdAppConsentGivenAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByLastModifiedByIdConfigAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CONFIG_ASC',
  UserByLastModifiedByIdConfigDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CONFIG_DESC',
  UserByLastModifiedByIdCreatedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_ASC',
  UserByLastModifiedByIdCreatedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_DESC',
  UserByLastModifiedByIdCrmContactVisibilityFilterAsc = 'USER_BY_LAST_MODIFIED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByLastModifiedByIdCrmContactVisibilityFilterDesc = 'USER_BY_LAST_MODIFIED_BY_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByLastModifiedByIdDefaultWorkspaceIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByLastModifiedByIdDefaultWorkspaceIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByLastModifiedByIdDisabledAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DISABLED_ASC',
  UserByLastModifiedByIdDisabledDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DISABLED_DESC',
  UserByLastModifiedByIdDisplayNameAsc = 'USER_BY_LAST_MODIFIED_BY_ID__DISPLAY_NAME_ASC',
  UserByLastModifiedByIdDisplayNameDesc = 'USER_BY_LAST_MODIFIED_BY_ID__DISPLAY_NAME_DESC',
  UserByLastModifiedByIdEmailAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ASC',
  UserByLastModifiedByIdEmailDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EMAIL_DESC',
  UserByLastModifiedByIdExternalGroupsAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_ASC',
  UserByLastModifiedByIdExternalGroupsDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_DESC',
  UserByLastModifiedByIdExternalGroupsSyncedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByLastModifiedByIdExternalGroupsSyncedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByLastModifiedByIdFirebaseAuthIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__FIREBASE_AUTH_ID_ASC',
  UserByLastModifiedByIdFirebaseAuthIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__FIREBASE_AUTH_ID_DESC',
  UserByLastModifiedByIdFlagsAsc = 'USER_BY_LAST_MODIFIED_BY_ID__FLAGS_ASC',
  UserByLastModifiedByIdFlagsDesc = 'USER_BY_LAST_MODIFIED_BY_ID__FLAGS_DESC',
  UserByLastModifiedByIdIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__ID_ASC',
  UserByLastModifiedByIdIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__ID_DESC',
  UserByLastModifiedByIdIsTenantAdminAsc = 'USER_BY_LAST_MODIFIED_BY_ID__IS_TENANT_ADMIN_ASC',
  UserByLastModifiedByIdIsTenantAdminDesc = 'USER_BY_LAST_MODIFIED_BY_ID__IS_TENANT_ADMIN_DESC',
  UserByLastModifiedByIdRegisteredAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__REGISTERED_AT_ASC',
  UserByLastModifiedByIdRegisteredAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__REGISTERED_AT_DESC',
  UserByLastModifiedByIdSysPeriodAsc = 'USER_BY_LAST_MODIFIED_BY_ID__SYS_PERIOD_ASC',
  UserByLastModifiedByIdSysPeriodDesc = 'USER_BY_LAST_MODIFIED_BY_ID__SYS_PERIOD_DESC',
  UserByLastModifiedByIdTenantIdAsc = 'USER_BY_LAST_MODIFIED_BY_ID__TENANT_ID_ASC',
  UserByLastModifiedByIdTenantIdDesc = 'USER_BY_LAST_MODIFIED_BY_ID__TENANT_ID_DESC',
  UserByLastModifiedByIdUpdatedAtAsc = 'USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_ASC',
  UserByLastModifiedByIdUpdatedAtDesc = 'USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValidityPeriodAsc = 'VALIDITY_PERIOD_ASC',
  ValidityPeriodDesc = 'VALIDITY_PERIOD_DESC'
}

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  appConsentGivenAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `CrmContactConsent` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyCrmContactConsentFilter = {
  /** Every related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CrmContactConsentFilter>;
  /** No related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CrmContactConsentFilter>;
  /** Some related `CrmContactConsent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CrmContactConsentFilter>;
};

/** A filter to be used against many `Document` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentFilter = {
  /** Every related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFilter>;
  /** No related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFilter>;
  /** Some related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFilter>;
};

/** A filter to be used against many `DocumentProcess` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentProcessFilter = {
  /** Every related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentProcessFilter>;
  /** No related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentProcessFilter>;
  /** Some related `DocumentProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentProcessFilter>;
};

/** A filter to be used against many `DocumentSpaceAccess` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentSpaceAccessFilter = {
  /** Every related `DocumentSpaceAccess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceAccessFilter>;
  /** No related `DocumentSpaceAccess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceAccessFilter>;
  /** Some related `DocumentSpaceAccess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceAccessFilter>;
};

/** A filter to be used against many `DocumentSpaceConfig` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentSpaceConfigFilter = {
  /** Every related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceConfigFilter>;
  /** No related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceConfigFilter>;
  /** Some related `DocumentSpaceConfig` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceConfigFilter>;
};

/** A filter to be used against many `DocumentSpace` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentSpaceFilter = {
  /** Every related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentSpaceFilter>;
  /** No related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentSpaceFilter>;
  /** Some related `DocumentSpace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentSpaceFilter>;
};

/** A filter to be used against many `Flow` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFlowFilter = {
  /** Every related `Flow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowFilter>;
  /** No related `Flow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowFilter>;
  /** Some related `Flow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowFilter>;
};

/** A filter to be used against many `FlowItem` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFlowItemFilter = {
  /** Every related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowItemFilter>;
  /** No related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowItemFilter>;
  /** Some related `FlowItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowItemFilter>;
};

/** A filter to be used against many `FlowSubscription` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFlowSubscriptionFilter = {
  /** Every related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FlowSubscriptionFilter>;
  /** No related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FlowSubscriptionFilter>;
  /** Some related `FlowSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FlowSubscriptionFilter>;
};

/** A filter to be used against many `LabelsOfDocumentView` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyLabelsOfDocumentViewFilter = {
  /** Every related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** No related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LabelsOfDocumentViewFilter>;
  /** Some related `LabelsOfDocumentView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LabelsOfDocumentViewFilter>;
};

/** A filter to be used against many `Membership` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyMembershipFilter = {
  /** Every related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipFilter>;
  /** No related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipFilter>;
  /** Some related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `Order` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyOrderFilter = {
  /** Every related `Order` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OrderFilter>;
  /** No related `Order` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OrderFilter>;
  /** Some related `Order` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OrderFilter>;
};

/** A filter to be used against many `RegistrationToken` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyRegistrationTokenFilter = {
  /** Every related `RegistrationToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RegistrationTokenFilter>;
  /** No related `RegistrationToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RegistrationTokenFilter>;
  /** Some related `RegistrationToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RegistrationTokenFilter>;
};

/** A filter to be used against many `UrlBasedDocumentImportSetting` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUrlBasedDocumentImportSettingFilter = {
  /** Every related `UrlBasedDocumentImportSetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  /** No related `UrlBasedDocumentImportSetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
  /** Some related `UrlBasedDocumentImportSetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UrlBasedDocumentImportSettingFilter>;
};

/** A filter to be used against many `UserLicense` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserLicenseFilter = {
  /** Every related `UserLicense` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserLicenseFilter>;
  /** No related `UserLicense` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserLicenseFilter>;
  /** Some related `UserLicense` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserLicenseFilter>;
};

/** A filter to be used against many `Workspace` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyWorkspaceFilter = {
  /** Every related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceFilter>;
  /** No related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceFilter>;
  /** Some related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceFilter>;
};

/** A filter to be used against many `WorkspaceSubscription` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyWorkspaceSubscriptionFilter = {
  /** Every related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** No related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** Some related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceSubscriptionFilter>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  AppConsentGivenAtAsc = 'APP_CONSENT_GIVEN_AT_ASC',
  AppConsentGivenAtDesc = 'APP_CONSENT_GIVEN_AT_DESC',
  ConfigAsc = 'CONFIG_ASC',
  ConfigDesc = 'CONFIG_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CrmContactConsentsByCreatedByIdCountAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__COUNT_ASC',
  CrmContactConsentsByCreatedByIdCountDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__COUNT_DESC',
  CrmContactConsentsByCreatedByIdMaxConsentFileStorageIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CONSENT_FILE_STORAGE_ID_ASC',
  CrmContactConsentsByCreatedByIdMaxConsentFileStorageIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CONSENT_FILE_STORAGE_ID_DESC',
  CrmContactConsentsByCreatedByIdMaxConsentTypeAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CONSENT_TYPE_ASC',
  CrmContactConsentsByCreatedByIdMaxConsentTypeDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CONSENT_TYPE_DESC',
  CrmContactConsentsByCreatedByIdMaxCreatedAtAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CREATED_AT_ASC',
  CrmContactConsentsByCreatedByIdMaxCreatedAtDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CREATED_AT_DESC',
  CrmContactConsentsByCreatedByIdMaxCreatedByIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CREATED_BY_ID_ASC',
  CrmContactConsentsByCreatedByIdMaxCreatedByIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CREATED_BY_ID_DESC',
  CrmContactConsentsByCreatedByIdMaxCrmIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CRM_ID_ASC',
  CrmContactConsentsByCreatedByIdMaxCrmIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_CRM_ID_DESC',
  CrmContactConsentsByCreatedByIdMaxIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_ID_ASC',
  CrmContactConsentsByCreatedByIdMaxIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_ID_DESC',
  CrmContactConsentsByCreatedByIdMaxPayloadAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_PAYLOAD_ASC',
  CrmContactConsentsByCreatedByIdMaxPayloadDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MAX_PAYLOAD_DESC',
  CrmContactConsentsByCreatedByIdMinConsentFileStorageIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CONSENT_FILE_STORAGE_ID_ASC',
  CrmContactConsentsByCreatedByIdMinConsentFileStorageIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CONSENT_FILE_STORAGE_ID_DESC',
  CrmContactConsentsByCreatedByIdMinConsentTypeAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CONSENT_TYPE_ASC',
  CrmContactConsentsByCreatedByIdMinConsentTypeDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CONSENT_TYPE_DESC',
  CrmContactConsentsByCreatedByIdMinCreatedAtAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CREATED_AT_ASC',
  CrmContactConsentsByCreatedByIdMinCreatedAtDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CREATED_AT_DESC',
  CrmContactConsentsByCreatedByIdMinCreatedByIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CREATED_BY_ID_ASC',
  CrmContactConsentsByCreatedByIdMinCreatedByIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CREATED_BY_ID_DESC',
  CrmContactConsentsByCreatedByIdMinCrmIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CRM_ID_ASC',
  CrmContactConsentsByCreatedByIdMinCrmIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_CRM_ID_DESC',
  CrmContactConsentsByCreatedByIdMinIdAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_ID_ASC',
  CrmContactConsentsByCreatedByIdMinIdDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_ID_DESC',
  CrmContactConsentsByCreatedByIdMinPayloadAsc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_PAYLOAD_ASC',
  CrmContactConsentsByCreatedByIdMinPayloadDesc = 'CRM_CONTACT_CONSENTS_BY_CREATED_BY_ID__MIN_PAYLOAD_DESC',
  CrmContactVisibilityFilterAsc = 'CRM_CONTACT_VISIBILITY_FILTER_ASC',
  CrmContactVisibilityFilterDesc = 'CRM_CONTACT_VISIBILITY_FILTER_DESC',
  DefaultWorkspaceIdAsc = 'DEFAULT_WORKSPACE_ID_ASC',
  DefaultWorkspaceIdDesc = 'DEFAULT_WORKSPACE_ID_DESC',
  DisabledAsc = 'DISABLED_ASC',
  DisabledDesc = 'DISABLED_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  DocumentsByCreatedByIdCountAsc = 'DOCUMENTS_BY_CREATED_BY_ID__COUNT_ASC',
  DocumentsByCreatedByIdCountDesc = 'DOCUMENTS_BY_CREATED_BY_ID__COUNT_DESC',
  DocumentsByCreatedByIdMaxConfigAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CONFIG_ASC',
  DocumentsByCreatedByIdMaxConfigDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CONFIG_DESC',
  DocumentsByCreatedByIdMaxCreatedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CREATED_AT_ASC',
  DocumentsByCreatedByIdMaxCreatedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CREATED_AT_DESC',
  DocumentsByCreatedByIdMaxCreatedByIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CREATED_BY_ID_ASC',
  DocumentsByCreatedByIdMaxCreatedByIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CREATED_BY_ID_DESC',
  DocumentsByCreatedByIdMaxCurrentRevisionNumberAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByCreatedByIdMaxCurrentRevisionNumberDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByCreatedByIdMaxDeletedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DELETED_AT_ASC',
  DocumentsByCreatedByIdMaxDeletedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DELETED_AT_DESC',
  DocumentsByCreatedByIdMaxDisplayDateAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DISPLAY_DATE_ASC',
  DocumentsByCreatedByIdMaxDisplayDateDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DISPLAY_DATE_DESC',
  DocumentsByCreatedByIdMaxDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByCreatedByIdMaxDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByCreatedByIdMaxDisplayTitleAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DISPLAY_TITLE_ASC',
  DocumentsByCreatedByIdMaxDisplayTitleDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DISPLAY_TITLE_DESC',
  DocumentsByCreatedByIdMaxDoesSupportFlowsAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByCreatedByIdMaxDoesSupportFlowsDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByCreatedByIdMaxDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByCreatedByIdMaxDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByCreatedByIdMaxDownloadUrlAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DOWNLOAD_URL_ASC',
  DocumentsByCreatedByIdMaxDownloadUrlDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_DOWNLOAD_URL_DESC',
  DocumentsByCreatedByIdMaxEnableMagicPagesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByCreatedByIdMaxEnableMagicPagesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByCreatedByIdMaxExpirationDateAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_EXPIRATION_DATE_ASC',
  DocumentsByCreatedByIdMaxExpirationDateDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_EXPIRATION_DATE_DESC',
  DocumentsByCreatedByIdMaxExternalIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_EXTERNAL_ID_ASC',
  DocumentsByCreatedByIdMaxExternalIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_EXTERNAL_ID_DESC',
  DocumentsByCreatedByIdMaxExternalLinkIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_EXTERNAL_LINK_ID_ASC',
  DocumentsByCreatedByIdMaxExternalLinkIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_EXTERNAL_LINK_ID_DESC',
  DocumentsByCreatedByIdMaxFileNameAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_FILE_NAME_ASC',
  DocumentsByCreatedByIdMaxFileNameDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_FILE_NAME_DESC',
  DocumentsByCreatedByIdMaxFileSizeAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_FILE_SIZE_ASC',
  DocumentsByCreatedByIdMaxFileSizeDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_FILE_SIZE_DESC',
  DocumentsByCreatedByIdMaxFirestoreIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_FIRESTORE_ID_ASC',
  DocumentsByCreatedByIdMaxFirestoreIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_FIRESTORE_ID_DESC',
  DocumentsByCreatedByIdMaxIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ID_ASC',
  DocumentsByCreatedByIdMaxIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ID_DESC',
  DocumentsByCreatedByIdMaxIgnoredPagesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_IGNORED_PAGES_ASC',
  DocumentsByCreatedByIdMaxIgnoredPagesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_IGNORED_PAGES_DESC',
  DocumentsByCreatedByIdMaxInitialFileNameAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_INITIAL_FILE_NAME_ASC',
  DocumentsByCreatedByIdMaxInitialFileNameDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_INITIAL_FILE_NAME_DESC',
  DocumentsByCreatedByIdMaxInternalLinksAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_INTERNAL_LINKS_ASC',
  DocumentsByCreatedByIdMaxInternalLinksDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_INTERNAL_LINKS_DESC',
  DocumentsByCreatedByIdMaxIsDownloadableAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_IS_DOWNLOADABLE_ASC',
  DocumentsByCreatedByIdMaxIsDownloadableDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_IS_DOWNLOADABLE_DESC',
  DocumentsByCreatedByIdMaxIsPublishedAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_IS_PUBLISHED_ASC',
  DocumentsByCreatedByIdMaxIsPublishedDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_IS_PUBLISHED_DESC',
  DocumentsByCreatedByIdMaxLastModifiedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LAST_MODIFIED_AT_ASC',
  DocumentsByCreatedByIdMaxLastModifiedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LAST_MODIFIED_AT_DESC',
  DocumentsByCreatedByIdMaxLastModifiedByIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByCreatedByIdMaxLastModifiedByIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByCreatedByIdMaxLegalAppendixIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LEGAL_APPENDIX_ID_ASC',
  DocumentsByCreatedByIdMaxLegalAppendixIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LEGAL_APPENDIX_ID_DESC',
  DocumentsByCreatedByIdMaxLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByCreatedByIdMaxLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByCreatedByIdMaxLiteratureReferencesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LITERATURE_REFERENCES_ASC',
  DocumentsByCreatedByIdMaxLiteratureReferencesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_LITERATURE_REFERENCES_DESC',
  DocumentsByCreatedByIdMaxMimeTypeAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_MIME_TYPE_ASC',
  DocumentsByCreatedByIdMaxMimeTypeDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_MIME_TYPE_DESC',
  DocumentsByCreatedByIdMaxOrderAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORDER_ASC',
  DocumentsByCreatedByIdMaxOrderDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORDER_DESC',
  DocumentsByCreatedByIdMaxOriginalDownloadUrlAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByCreatedByIdMaxOriginalDownloadUrlDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByCreatedByIdMaxOriginalMimeTypeAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByCreatedByIdMaxOriginalMimeTypeDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByCreatedByIdMaxOriginalStorageIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByCreatedByIdMaxOriginalStorageIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByCreatedByIdMaxPagesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_PAGES_ASC',
  DocumentsByCreatedByIdMaxPagesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_PAGES_DESC',
  DocumentsByCreatedByIdMaxStorageIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_STORAGE_ID_ASC',
  DocumentsByCreatedByIdMaxStorageIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_STORAGE_ID_DESC',
  DocumentsByCreatedByIdMaxSysPeriodAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_SYS_PERIOD_ASC',
  DocumentsByCreatedByIdMaxSysPeriodDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_SYS_PERIOD_DESC',
  DocumentsByCreatedByIdMaxTagsAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_TAGS_ASC',
  DocumentsByCreatedByIdMaxTagsDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_TAGS_DESC',
  DocumentsByCreatedByIdMaxTeaserTextAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_TEASER_TEXT_ASC',
  DocumentsByCreatedByIdMaxTeaserTextDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_TEASER_TEXT_DESC',
  DocumentsByCreatedByIdMaxThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByCreatedByIdMaxThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByCreatedByIdMaxThumbnailStorageIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByCreatedByIdMaxThumbnailStorageIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByCreatedByIdMaxTopTitleAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_TOP_TITLE_ASC',
  DocumentsByCreatedByIdMaxTopTitleDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_TOP_TITLE_DESC',
  DocumentsByCreatedByIdMaxUploadedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_UPLOADED_AT_ASC',
  DocumentsByCreatedByIdMaxUploadedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_UPLOADED_AT_DESC',
  DocumentsByCreatedByIdMaxWorkspaceIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_WORKSPACE_ID_ASC',
  DocumentsByCreatedByIdMaxWorkspaceIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MAX_WORKSPACE_ID_DESC',
  DocumentsByCreatedByIdMinConfigAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CONFIG_ASC',
  DocumentsByCreatedByIdMinConfigDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CONFIG_DESC',
  DocumentsByCreatedByIdMinCreatedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CREATED_AT_ASC',
  DocumentsByCreatedByIdMinCreatedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CREATED_AT_DESC',
  DocumentsByCreatedByIdMinCreatedByIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CREATED_BY_ID_ASC',
  DocumentsByCreatedByIdMinCreatedByIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CREATED_BY_ID_DESC',
  DocumentsByCreatedByIdMinCurrentRevisionNumberAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByCreatedByIdMinCurrentRevisionNumberDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByCreatedByIdMinDeletedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DELETED_AT_ASC',
  DocumentsByCreatedByIdMinDeletedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DELETED_AT_DESC',
  DocumentsByCreatedByIdMinDisplayDateAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DISPLAY_DATE_ASC',
  DocumentsByCreatedByIdMinDisplayDateDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DISPLAY_DATE_DESC',
  DocumentsByCreatedByIdMinDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByCreatedByIdMinDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByCreatedByIdMinDisplayTitleAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DISPLAY_TITLE_ASC',
  DocumentsByCreatedByIdMinDisplayTitleDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DISPLAY_TITLE_DESC',
  DocumentsByCreatedByIdMinDoesSupportFlowsAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByCreatedByIdMinDoesSupportFlowsDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByCreatedByIdMinDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByCreatedByIdMinDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByCreatedByIdMinDownloadUrlAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DOWNLOAD_URL_ASC',
  DocumentsByCreatedByIdMinDownloadUrlDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_DOWNLOAD_URL_DESC',
  DocumentsByCreatedByIdMinEnableMagicPagesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByCreatedByIdMinEnableMagicPagesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByCreatedByIdMinExpirationDateAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_EXPIRATION_DATE_ASC',
  DocumentsByCreatedByIdMinExpirationDateDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_EXPIRATION_DATE_DESC',
  DocumentsByCreatedByIdMinExternalIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_EXTERNAL_ID_ASC',
  DocumentsByCreatedByIdMinExternalIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_EXTERNAL_ID_DESC',
  DocumentsByCreatedByIdMinExternalLinkIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_EXTERNAL_LINK_ID_ASC',
  DocumentsByCreatedByIdMinExternalLinkIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_EXTERNAL_LINK_ID_DESC',
  DocumentsByCreatedByIdMinFileNameAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_FILE_NAME_ASC',
  DocumentsByCreatedByIdMinFileNameDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_FILE_NAME_DESC',
  DocumentsByCreatedByIdMinFileSizeAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_FILE_SIZE_ASC',
  DocumentsByCreatedByIdMinFileSizeDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_FILE_SIZE_DESC',
  DocumentsByCreatedByIdMinFirestoreIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_FIRESTORE_ID_ASC',
  DocumentsByCreatedByIdMinFirestoreIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_FIRESTORE_ID_DESC',
  DocumentsByCreatedByIdMinIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ID_ASC',
  DocumentsByCreatedByIdMinIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ID_DESC',
  DocumentsByCreatedByIdMinIgnoredPagesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_IGNORED_PAGES_ASC',
  DocumentsByCreatedByIdMinIgnoredPagesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_IGNORED_PAGES_DESC',
  DocumentsByCreatedByIdMinInitialFileNameAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_INITIAL_FILE_NAME_ASC',
  DocumentsByCreatedByIdMinInitialFileNameDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_INITIAL_FILE_NAME_DESC',
  DocumentsByCreatedByIdMinInternalLinksAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_INTERNAL_LINKS_ASC',
  DocumentsByCreatedByIdMinInternalLinksDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_INTERNAL_LINKS_DESC',
  DocumentsByCreatedByIdMinIsDownloadableAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_IS_DOWNLOADABLE_ASC',
  DocumentsByCreatedByIdMinIsDownloadableDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_IS_DOWNLOADABLE_DESC',
  DocumentsByCreatedByIdMinIsPublishedAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_IS_PUBLISHED_ASC',
  DocumentsByCreatedByIdMinIsPublishedDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_IS_PUBLISHED_DESC',
  DocumentsByCreatedByIdMinLastModifiedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LAST_MODIFIED_AT_ASC',
  DocumentsByCreatedByIdMinLastModifiedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LAST_MODIFIED_AT_DESC',
  DocumentsByCreatedByIdMinLastModifiedByIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByCreatedByIdMinLastModifiedByIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByCreatedByIdMinLegalAppendixIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LEGAL_APPENDIX_ID_ASC',
  DocumentsByCreatedByIdMinLegalAppendixIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LEGAL_APPENDIX_ID_DESC',
  DocumentsByCreatedByIdMinLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByCreatedByIdMinLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByCreatedByIdMinLiteratureReferencesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LITERATURE_REFERENCES_ASC',
  DocumentsByCreatedByIdMinLiteratureReferencesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_LITERATURE_REFERENCES_DESC',
  DocumentsByCreatedByIdMinMimeTypeAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_MIME_TYPE_ASC',
  DocumentsByCreatedByIdMinMimeTypeDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_MIME_TYPE_DESC',
  DocumentsByCreatedByIdMinOrderAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORDER_ASC',
  DocumentsByCreatedByIdMinOrderDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORDER_DESC',
  DocumentsByCreatedByIdMinOriginalDownloadUrlAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByCreatedByIdMinOriginalDownloadUrlDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByCreatedByIdMinOriginalMimeTypeAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByCreatedByIdMinOriginalMimeTypeDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByCreatedByIdMinOriginalStorageIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByCreatedByIdMinOriginalStorageIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByCreatedByIdMinPagesAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_PAGES_ASC',
  DocumentsByCreatedByIdMinPagesDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_PAGES_DESC',
  DocumentsByCreatedByIdMinStorageIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_STORAGE_ID_ASC',
  DocumentsByCreatedByIdMinStorageIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_STORAGE_ID_DESC',
  DocumentsByCreatedByIdMinSysPeriodAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_SYS_PERIOD_ASC',
  DocumentsByCreatedByIdMinSysPeriodDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_SYS_PERIOD_DESC',
  DocumentsByCreatedByIdMinTagsAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_TAGS_ASC',
  DocumentsByCreatedByIdMinTagsDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_TAGS_DESC',
  DocumentsByCreatedByIdMinTeaserTextAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_TEASER_TEXT_ASC',
  DocumentsByCreatedByIdMinTeaserTextDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_TEASER_TEXT_DESC',
  DocumentsByCreatedByIdMinThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByCreatedByIdMinThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByCreatedByIdMinThumbnailStorageIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByCreatedByIdMinThumbnailStorageIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByCreatedByIdMinTopTitleAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_TOP_TITLE_ASC',
  DocumentsByCreatedByIdMinTopTitleDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_TOP_TITLE_DESC',
  DocumentsByCreatedByIdMinUploadedAtAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_UPLOADED_AT_ASC',
  DocumentsByCreatedByIdMinUploadedAtDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_UPLOADED_AT_DESC',
  DocumentsByCreatedByIdMinWorkspaceIdAsc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_WORKSPACE_ID_ASC',
  DocumentsByCreatedByIdMinWorkspaceIdDesc = 'DOCUMENTS_BY_CREATED_BY_ID__MIN_WORKSPACE_ID_DESC',
  DocumentsByLastModifiedByIdCountAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__COUNT_ASC',
  DocumentsByLastModifiedByIdCountDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__COUNT_DESC',
  DocumentsByLastModifiedByIdMaxConfigAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CONFIG_ASC',
  DocumentsByLastModifiedByIdMaxConfigDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CONFIG_DESC',
  DocumentsByLastModifiedByIdMaxCreatedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CREATED_AT_ASC',
  DocumentsByLastModifiedByIdMaxCreatedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CREATED_AT_DESC',
  DocumentsByLastModifiedByIdMaxCreatedByIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CREATED_BY_ID_ASC',
  DocumentsByLastModifiedByIdMaxCreatedByIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CREATED_BY_ID_DESC',
  DocumentsByLastModifiedByIdMaxCurrentRevisionNumberAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByLastModifiedByIdMaxCurrentRevisionNumberDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByLastModifiedByIdMaxDeletedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DELETED_AT_ASC',
  DocumentsByLastModifiedByIdMaxDeletedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DELETED_AT_DESC',
  DocumentsByLastModifiedByIdMaxDisplayDateAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DISPLAY_DATE_ASC',
  DocumentsByLastModifiedByIdMaxDisplayDateDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DISPLAY_DATE_DESC',
  DocumentsByLastModifiedByIdMaxDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByLastModifiedByIdMaxDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByLastModifiedByIdMaxDisplayTitleAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DISPLAY_TITLE_ASC',
  DocumentsByLastModifiedByIdMaxDisplayTitleDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DISPLAY_TITLE_DESC',
  DocumentsByLastModifiedByIdMaxDoesSupportFlowsAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByLastModifiedByIdMaxDoesSupportFlowsDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByLastModifiedByIdMaxDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByLastModifiedByIdMaxDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByLastModifiedByIdMaxDownloadUrlAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DOWNLOAD_URL_ASC',
  DocumentsByLastModifiedByIdMaxDownloadUrlDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_DOWNLOAD_URL_DESC',
  DocumentsByLastModifiedByIdMaxEnableMagicPagesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByLastModifiedByIdMaxEnableMagicPagesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByLastModifiedByIdMaxExpirationDateAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_EXPIRATION_DATE_ASC',
  DocumentsByLastModifiedByIdMaxExpirationDateDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_EXPIRATION_DATE_DESC',
  DocumentsByLastModifiedByIdMaxExternalIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_EXTERNAL_ID_ASC',
  DocumentsByLastModifiedByIdMaxExternalIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_EXTERNAL_ID_DESC',
  DocumentsByLastModifiedByIdMaxExternalLinkIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_EXTERNAL_LINK_ID_ASC',
  DocumentsByLastModifiedByIdMaxExternalLinkIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_EXTERNAL_LINK_ID_DESC',
  DocumentsByLastModifiedByIdMaxFileNameAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_FILE_NAME_ASC',
  DocumentsByLastModifiedByIdMaxFileNameDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_FILE_NAME_DESC',
  DocumentsByLastModifiedByIdMaxFileSizeAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_FILE_SIZE_ASC',
  DocumentsByLastModifiedByIdMaxFileSizeDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_FILE_SIZE_DESC',
  DocumentsByLastModifiedByIdMaxFirestoreIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_FIRESTORE_ID_ASC',
  DocumentsByLastModifiedByIdMaxFirestoreIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_FIRESTORE_ID_DESC',
  DocumentsByLastModifiedByIdMaxIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ID_ASC',
  DocumentsByLastModifiedByIdMaxIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ID_DESC',
  DocumentsByLastModifiedByIdMaxIgnoredPagesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_IGNORED_PAGES_ASC',
  DocumentsByLastModifiedByIdMaxIgnoredPagesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_IGNORED_PAGES_DESC',
  DocumentsByLastModifiedByIdMaxInitialFileNameAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_INITIAL_FILE_NAME_ASC',
  DocumentsByLastModifiedByIdMaxInitialFileNameDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_INITIAL_FILE_NAME_DESC',
  DocumentsByLastModifiedByIdMaxInternalLinksAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_INTERNAL_LINKS_ASC',
  DocumentsByLastModifiedByIdMaxInternalLinksDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_INTERNAL_LINKS_DESC',
  DocumentsByLastModifiedByIdMaxIsDownloadableAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_IS_DOWNLOADABLE_ASC',
  DocumentsByLastModifiedByIdMaxIsDownloadableDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_IS_DOWNLOADABLE_DESC',
  DocumentsByLastModifiedByIdMaxIsPublishedAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_IS_PUBLISHED_ASC',
  DocumentsByLastModifiedByIdMaxIsPublishedDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_IS_PUBLISHED_DESC',
  DocumentsByLastModifiedByIdMaxLastModifiedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_AT_ASC',
  DocumentsByLastModifiedByIdMaxLastModifiedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_AT_DESC',
  DocumentsByLastModifiedByIdMaxLastModifiedByIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByLastModifiedByIdMaxLastModifiedByIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByLastModifiedByIdMaxLegalAppendixIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LEGAL_APPENDIX_ID_ASC',
  DocumentsByLastModifiedByIdMaxLegalAppendixIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LEGAL_APPENDIX_ID_DESC',
  DocumentsByLastModifiedByIdMaxLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByLastModifiedByIdMaxLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByLastModifiedByIdMaxLiteratureReferencesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LITERATURE_REFERENCES_ASC',
  DocumentsByLastModifiedByIdMaxLiteratureReferencesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_LITERATURE_REFERENCES_DESC',
  DocumentsByLastModifiedByIdMaxMimeTypeAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_MIME_TYPE_ASC',
  DocumentsByLastModifiedByIdMaxMimeTypeDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_MIME_TYPE_DESC',
  DocumentsByLastModifiedByIdMaxOrderAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORDER_ASC',
  DocumentsByLastModifiedByIdMaxOrderDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORDER_DESC',
  DocumentsByLastModifiedByIdMaxOriginalDownloadUrlAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByLastModifiedByIdMaxOriginalDownloadUrlDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByLastModifiedByIdMaxOriginalMimeTypeAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByLastModifiedByIdMaxOriginalMimeTypeDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByLastModifiedByIdMaxOriginalStorageIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByLastModifiedByIdMaxOriginalStorageIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByLastModifiedByIdMaxPagesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_PAGES_ASC',
  DocumentsByLastModifiedByIdMaxPagesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_PAGES_DESC',
  DocumentsByLastModifiedByIdMaxStorageIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_STORAGE_ID_ASC',
  DocumentsByLastModifiedByIdMaxStorageIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_STORAGE_ID_DESC',
  DocumentsByLastModifiedByIdMaxSysPeriodAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_SYS_PERIOD_ASC',
  DocumentsByLastModifiedByIdMaxSysPeriodDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_SYS_PERIOD_DESC',
  DocumentsByLastModifiedByIdMaxTagsAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_TAGS_ASC',
  DocumentsByLastModifiedByIdMaxTagsDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_TAGS_DESC',
  DocumentsByLastModifiedByIdMaxTeaserTextAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_TEASER_TEXT_ASC',
  DocumentsByLastModifiedByIdMaxTeaserTextDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_TEASER_TEXT_DESC',
  DocumentsByLastModifiedByIdMaxThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByLastModifiedByIdMaxThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByLastModifiedByIdMaxThumbnailStorageIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByLastModifiedByIdMaxThumbnailStorageIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByLastModifiedByIdMaxTopTitleAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_TOP_TITLE_ASC',
  DocumentsByLastModifiedByIdMaxTopTitleDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_TOP_TITLE_DESC',
  DocumentsByLastModifiedByIdMaxUploadedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_UPLOADED_AT_ASC',
  DocumentsByLastModifiedByIdMaxUploadedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_UPLOADED_AT_DESC',
  DocumentsByLastModifiedByIdMaxWorkspaceIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_WORKSPACE_ID_ASC',
  DocumentsByLastModifiedByIdMaxWorkspaceIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MAX_WORKSPACE_ID_DESC',
  DocumentsByLastModifiedByIdMinConfigAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CONFIG_ASC',
  DocumentsByLastModifiedByIdMinConfigDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CONFIG_DESC',
  DocumentsByLastModifiedByIdMinCreatedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CREATED_AT_ASC',
  DocumentsByLastModifiedByIdMinCreatedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CREATED_AT_DESC',
  DocumentsByLastModifiedByIdMinCreatedByIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CREATED_BY_ID_ASC',
  DocumentsByLastModifiedByIdMinCreatedByIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CREATED_BY_ID_DESC',
  DocumentsByLastModifiedByIdMinCurrentRevisionNumberAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByLastModifiedByIdMinCurrentRevisionNumberDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByLastModifiedByIdMinDeletedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DELETED_AT_ASC',
  DocumentsByLastModifiedByIdMinDeletedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DELETED_AT_DESC',
  DocumentsByLastModifiedByIdMinDisplayDateAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DISPLAY_DATE_ASC',
  DocumentsByLastModifiedByIdMinDisplayDateDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DISPLAY_DATE_DESC',
  DocumentsByLastModifiedByIdMinDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByLastModifiedByIdMinDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByLastModifiedByIdMinDisplayTitleAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DISPLAY_TITLE_ASC',
  DocumentsByLastModifiedByIdMinDisplayTitleDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DISPLAY_TITLE_DESC',
  DocumentsByLastModifiedByIdMinDoesSupportFlowsAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByLastModifiedByIdMinDoesSupportFlowsDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByLastModifiedByIdMinDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByLastModifiedByIdMinDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByLastModifiedByIdMinDownloadUrlAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DOWNLOAD_URL_ASC',
  DocumentsByLastModifiedByIdMinDownloadUrlDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_DOWNLOAD_URL_DESC',
  DocumentsByLastModifiedByIdMinEnableMagicPagesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByLastModifiedByIdMinEnableMagicPagesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByLastModifiedByIdMinExpirationDateAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_EXPIRATION_DATE_ASC',
  DocumentsByLastModifiedByIdMinExpirationDateDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_EXPIRATION_DATE_DESC',
  DocumentsByLastModifiedByIdMinExternalIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_EXTERNAL_ID_ASC',
  DocumentsByLastModifiedByIdMinExternalIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_EXTERNAL_ID_DESC',
  DocumentsByLastModifiedByIdMinExternalLinkIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_EXTERNAL_LINK_ID_ASC',
  DocumentsByLastModifiedByIdMinExternalLinkIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_EXTERNAL_LINK_ID_DESC',
  DocumentsByLastModifiedByIdMinFileNameAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_FILE_NAME_ASC',
  DocumentsByLastModifiedByIdMinFileNameDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_FILE_NAME_DESC',
  DocumentsByLastModifiedByIdMinFileSizeAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_FILE_SIZE_ASC',
  DocumentsByLastModifiedByIdMinFileSizeDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_FILE_SIZE_DESC',
  DocumentsByLastModifiedByIdMinFirestoreIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_FIRESTORE_ID_ASC',
  DocumentsByLastModifiedByIdMinFirestoreIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_FIRESTORE_ID_DESC',
  DocumentsByLastModifiedByIdMinIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ID_ASC',
  DocumentsByLastModifiedByIdMinIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ID_DESC',
  DocumentsByLastModifiedByIdMinIgnoredPagesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_IGNORED_PAGES_ASC',
  DocumentsByLastModifiedByIdMinIgnoredPagesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_IGNORED_PAGES_DESC',
  DocumentsByLastModifiedByIdMinInitialFileNameAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_INITIAL_FILE_NAME_ASC',
  DocumentsByLastModifiedByIdMinInitialFileNameDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_INITIAL_FILE_NAME_DESC',
  DocumentsByLastModifiedByIdMinInternalLinksAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_INTERNAL_LINKS_ASC',
  DocumentsByLastModifiedByIdMinInternalLinksDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_INTERNAL_LINKS_DESC',
  DocumentsByLastModifiedByIdMinIsDownloadableAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_IS_DOWNLOADABLE_ASC',
  DocumentsByLastModifiedByIdMinIsDownloadableDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_IS_DOWNLOADABLE_DESC',
  DocumentsByLastModifiedByIdMinIsPublishedAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_IS_PUBLISHED_ASC',
  DocumentsByLastModifiedByIdMinIsPublishedDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_IS_PUBLISHED_DESC',
  DocumentsByLastModifiedByIdMinLastModifiedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_AT_ASC',
  DocumentsByLastModifiedByIdMinLastModifiedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_AT_DESC',
  DocumentsByLastModifiedByIdMinLastModifiedByIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByLastModifiedByIdMinLastModifiedByIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByLastModifiedByIdMinLegalAppendixIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LEGAL_APPENDIX_ID_ASC',
  DocumentsByLastModifiedByIdMinLegalAppendixIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LEGAL_APPENDIX_ID_DESC',
  DocumentsByLastModifiedByIdMinLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByLastModifiedByIdMinLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByLastModifiedByIdMinLiteratureReferencesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LITERATURE_REFERENCES_ASC',
  DocumentsByLastModifiedByIdMinLiteratureReferencesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_LITERATURE_REFERENCES_DESC',
  DocumentsByLastModifiedByIdMinMimeTypeAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_MIME_TYPE_ASC',
  DocumentsByLastModifiedByIdMinMimeTypeDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_MIME_TYPE_DESC',
  DocumentsByLastModifiedByIdMinOrderAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORDER_ASC',
  DocumentsByLastModifiedByIdMinOrderDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORDER_DESC',
  DocumentsByLastModifiedByIdMinOriginalDownloadUrlAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByLastModifiedByIdMinOriginalDownloadUrlDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByLastModifiedByIdMinOriginalMimeTypeAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByLastModifiedByIdMinOriginalMimeTypeDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByLastModifiedByIdMinOriginalStorageIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByLastModifiedByIdMinOriginalStorageIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByLastModifiedByIdMinPagesAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_PAGES_ASC',
  DocumentsByLastModifiedByIdMinPagesDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_PAGES_DESC',
  DocumentsByLastModifiedByIdMinStorageIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_STORAGE_ID_ASC',
  DocumentsByLastModifiedByIdMinStorageIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_STORAGE_ID_DESC',
  DocumentsByLastModifiedByIdMinSysPeriodAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_SYS_PERIOD_ASC',
  DocumentsByLastModifiedByIdMinSysPeriodDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_SYS_PERIOD_DESC',
  DocumentsByLastModifiedByIdMinTagsAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_TAGS_ASC',
  DocumentsByLastModifiedByIdMinTagsDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_TAGS_DESC',
  DocumentsByLastModifiedByIdMinTeaserTextAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_TEASER_TEXT_ASC',
  DocumentsByLastModifiedByIdMinTeaserTextDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_TEASER_TEXT_DESC',
  DocumentsByLastModifiedByIdMinThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByLastModifiedByIdMinThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByLastModifiedByIdMinThumbnailStorageIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByLastModifiedByIdMinThumbnailStorageIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByLastModifiedByIdMinTopTitleAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_TOP_TITLE_ASC',
  DocumentsByLastModifiedByIdMinTopTitleDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_TOP_TITLE_DESC',
  DocumentsByLastModifiedByIdMinUploadedAtAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_UPLOADED_AT_ASC',
  DocumentsByLastModifiedByIdMinUploadedAtDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_UPLOADED_AT_DESC',
  DocumentsByLastModifiedByIdMinWorkspaceIdAsc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_WORKSPACE_ID_ASC',
  DocumentsByLastModifiedByIdMinWorkspaceIdDesc = 'DOCUMENTS_BY_LAST_MODIFIED_BY_ID__MIN_WORKSPACE_ID_DESC',
  DocumentProcessesByInitiatorIdCountAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__COUNT_ASC',
  DocumentProcessesByInitiatorIdCountDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__COUNT_DESC',
  DocumentProcessesByInitiatorIdMaxDocumentIdAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_DOCUMENT_ID_ASC',
  DocumentProcessesByInitiatorIdMaxDocumentIdDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_DOCUMENT_ID_DESC',
  DocumentProcessesByInitiatorIdMaxFailedAtAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_FAILED_AT_ASC',
  DocumentProcessesByInitiatorIdMaxFailedAtDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_FAILED_AT_DESC',
  DocumentProcessesByInitiatorIdMaxIdAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_ID_ASC',
  DocumentProcessesByInitiatorIdMaxIdDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_ID_DESC',
  DocumentProcessesByInitiatorIdMaxInitiatorIdAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_INITIATOR_ID_ASC',
  DocumentProcessesByInitiatorIdMaxInitiatorIdDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_INITIATOR_ID_DESC',
  DocumentProcessesByInitiatorIdMaxLastErrorAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_LAST_ERROR_ASC',
  DocumentProcessesByInitiatorIdMaxLastErrorDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_LAST_ERROR_DESC',
  DocumentProcessesByInitiatorIdMaxProgressAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_PROGRESS_ASC',
  DocumentProcessesByInitiatorIdMaxProgressDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_PROGRESS_DESC',
  DocumentProcessesByInitiatorIdMaxResultAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_RESULT_ASC',
  DocumentProcessesByInitiatorIdMaxResultDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_RESULT_DESC',
  DocumentProcessesByInitiatorIdMaxRevisionNumberAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_REVISION_NUMBER_ASC',
  DocumentProcessesByInitiatorIdMaxRevisionNumberDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_REVISION_NUMBER_DESC',
  DocumentProcessesByInitiatorIdMaxStageAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_STAGE_ASC',
  DocumentProcessesByInitiatorIdMaxStageDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_STAGE_DESC',
  DocumentProcessesByInitiatorIdMaxStartedAtAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_STARTED_AT_ASC',
  DocumentProcessesByInitiatorIdMaxStartedAtDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_STARTED_AT_DESC',
  DocumentProcessesByInitiatorIdMaxSucceededAtAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_SUCCEEDED_AT_ASC',
  DocumentProcessesByInitiatorIdMaxSucceededAtDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_SUCCEEDED_AT_DESC',
  DocumentProcessesByInitiatorIdMaxUnitOfWorkAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_UNIT_OF_WORK_ASC',
  DocumentProcessesByInitiatorIdMaxUnitOfWorkDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MAX_UNIT_OF_WORK_DESC',
  DocumentProcessesByInitiatorIdMinDocumentIdAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_DOCUMENT_ID_ASC',
  DocumentProcessesByInitiatorIdMinDocumentIdDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_DOCUMENT_ID_DESC',
  DocumentProcessesByInitiatorIdMinFailedAtAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_FAILED_AT_ASC',
  DocumentProcessesByInitiatorIdMinFailedAtDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_FAILED_AT_DESC',
  DocumentProcessesByInitiatorIdMinIdAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_ID_ASC',
  DocumentProcessesByInitiatorIdMinIdDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_ID_DESC',
  DocumentProcessesByInitiatorIdMinInitiatorIdAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_INITIATOR_ID_ASC',
  DocumentProcessesByInitiatorIdMinInitiatorIdDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_INITIATOR_ID_DESC',
  DocumentProcessesByInitiatorIdMinLastErrorAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_LAST_ERROR_ASC',
  DocumentProcessesByInitiatorIdMinLastErrorDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_LAST_ERROR_DESC',
  DocumentProcessesByInitiatorIdMinProgressAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_PROGRESS_ASC',
  DocumentProcessesByInitiatorIdMinProgressDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_PROGRESS_DESC',
  DocumentProcessesByInitiatorIdMinResultAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_RESULT_ASC',
  DocumentProcessesByInitiatorIdMinResultDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_RESULT_DESC',
  DocumentProcessesByInitiatorIdMinRevisionNumberAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_REVISION_NUMBER_ASC',
  DocumentProcessesByInitiatorIdMinRevisionNumberDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_REVISION_NUMBER_DESC',
  DocumentProcessesByInitiatorIdMinStageAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_STAGE_ASC',
  DocumentProcessesByInitiatorIdMinStageDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_STAGE_DESC',
  DocumentProcessesByInitiatorIdMinStartedAtAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_STARTED_AT_ASC',
  DocumentProcessesByInitiatorIdMinStartedAtDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_STARTED_AT_DESC',
  DocumentProcessesByInitiatorIdMinSucceededAtAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_SUCCEEDED_AT_ASC',
  DocumentProcessesByInitiatorIdMinSucceededAtDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_SUCCEEDED_AT_DESC',
  DocumentProcessesByInitiatorIdMinUnitOfWorkAsc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_UNIT_OF_WORK_ASC',
  DocumentProcessesByInitiatorIdMinUnitOfWorkDesc = 'DOCUMENT_PROCESSES_BY_INITIATOR_ID__MIN_UNIT_OF_WORK_DESC',
  DocumentSpacesByCreatorIdCountAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__COUNT_ASC',
  DocumentSpacesByCreatorIdCountDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__COUNT_DESC',
  DocumentSpacesByCreatorIdMaxAllowedEmailAddressesAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpacesByCreatorIdMaxAllowedEmailAddressesDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpacesByCreatorIdMaxCodeOnAccessCardAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CODE_ON_ACCESS_CARD_ASC',
  DocumentSpacesByCreatorIdMaxCodeOnAccessCardDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CODE_ON_ACCESS_CARD_DESC',
  DocumentSpacesByCreatorIdMaxCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpacesByCreatorIdMaxCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpacesByCreatorIdMaxCommentAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_COMMENT_ASC',
  DocumentSpacesByCreatorIdMaxCommentDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_COMMENT_DESC',
  DocumentSpacesByCreatorIdMaxConfigIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CONFIG_ID_ASC',
  DocumentSpacesByCreatorIdMaxConfigIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CONFIG_ID_DESC',
  DocumentSpacesByCreatorIdMaxCreatedAtAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CREATED_AT_ASC',
  DocumentSpacesByCreatorIdMaxCreatedAtDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CREATED_AT_DESC',
  DocumentSpacesByCreatorIdMaxCreatorIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CREATOR_ID_ASC',
  DocumentSpacesByCreatorIdMaxCreatorIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_CREATOR_ID_DESC',
  DocumentSpacesByCreatorIdMaxEncryptedPasswordAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_ENCRYPTED_PASSWORD_ASC',
  DocumentSpacesByCreatorIdMaxEncryptedPasswordDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_ENCRYPTED_PASSWORD_DESC',
  DocumentSpacesByCreatorIdMaxIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_ID_ASC',
  DocumentSpacesByCreatorIdMaxIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_ID_DESC',
  DocumentSpacesByCreatorIdMaxNameAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_NAME_ASC',
  DocumentSpacesByCreatorIdMaxNameDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_NAME_DESC',
  DocumentSpacesByCreatorIdMaxPersonalMessageAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_PERSONAL_MESSAGE_ASC',
  DocumentSpacesByCreatorIdMaxPersonalMessageDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_PERSONAL_MESSAGE_DESC',
  DocumentSpacesByCreatorIdMaxShowContactDetailsAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_SHOW_CONTACT_DETAILS_ASC',
  DocumentSpacesByCreatorIdMaxShowContactDetailsDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_SHOW_CONTACT_DETAILS_DESC',
  DocumentSpacesByCreatorIdMaxSysPeriodAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_SYS_PERIOD_ASC',
  DocumentSpacesByCreatorIdMaxSysPeriodDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_SYS_PERIOD_DESC',
  DocumentSpacesByCreatorIdMaxTenantIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_TENANT_ID_ASC',
  DocumentSpacesByCreatorIdMaxTenantIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_TENANT_ID_DESC',
  DocumentSpacesByCreatorIdMaxTrackingDeactivatedAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_TRACKING_DEACTIVATED_ASC',
  DocumentSpacesByCreatorIdMaxTrackingDeactivatedDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_TRACKING_DEACTIVATED_DESC',
  DocumentSpacesByCreatorIdMaxUpdatedAtAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_UPDATED_AT_ASC',
  DocumentSpacesByCreatorIdMaxUpdatedAtDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MAX_UPDATED_AT_DESC',
  DocumentSpacesByCreatorIdMinAllowedEmailAddressesAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_ALLOWED_EMAIL_ADDRESSES_ASC',
  DocumentSpacesByCreatorIdMinAllowedEmailAddressesDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_ALLOWED_EMAIL_ADDRESSES_DESC',
  DocumentSpacesByCreatorIdMinCodeOnAccessCardAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CODE_ON_ACCESS_CARD_ASC',
  DocumentSpacesByCreatorIdMinCodeOnAccessCardDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CODE_ON_ACCESS_CARD_DESC',
  DocumentSpacesByCreatorIdMinCodeOnAccessCardLastUsedAtAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CODE_ON_ACCESS_CARD_LAST_USED_AT_ASC',
  DocumentSpacesByCreatorIdMinCodeOnAccessCardLastUsedAtDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CODE_ON_ACCESS_CARD_LAST_USED_AT_DESC',
  DocumentSpacesByCreatorIdMinCommentAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_COMMENT_ASC',
  DocumentSpacesByCreatorIdMinCommentDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_COMMENT_DESC',
  DocumentSpacesByCreatorIdMinConfigIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CONFIG_ID_ASC',
  DocumentSpacesByCreatorIdMinConfigIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CONFIG_ID_DESC',
  DocumentSpacesByCreatorIdMinCreatedAtAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CREATED_AT_ASC',
  DocumentSpacesByCreatorIdMinCreatedAtDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CREATED_AT_DESC',
  DocumentSpacesByCreatorIdMinCreatorIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CREATOR_ID_ASC',
  DocumentSpacesByCreatorIdMinCreatorIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_CREATOR_ID_DESC',
  DocumentSpacesByCreatorIdMinEncryptedPasswordAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_ENCRYPTED_PASSWORD_ASC',
  DocumentSpacesByCreatorIdMinEncryptedPasswordDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_ENCRYPTED_PASSWORD_DESC',
  DocumentSpacesByCreatorIdMinIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_ID_ASC',
  DocumentSpacesByCreatorIdMinIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_ID_DESC',
  DocumentSpacesByCreatorIdMinNameAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_NAME_ASC',
  DocumentSpacesByCreatorIdMinNameDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_NAME_DESC',
  DocumentSpacesByCreatorIdMinPersonalMessageAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_PERSONAL_MESSAGE_ASC',
  DocumentSpacesByCreatorIdMinPersonalMessageDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_PERSONAL_MESSAGE_DESC',
  DocumentSpacesByCreatorIdMinShowContactDetailsAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_SHOW_CONTACT_DETAILS_ASC',
  DocumentSpacesByCreatorIdMinShowContactDetailsDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_SHOW_CONTACT_DETAILS_DESC',
  DocumentSpacesByCreatorIdMinSysPeriodAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_SYS_PERIOD_ASC',
  DocumentSpacesByCreatorIdMinSysPeriodDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_SYS_PERIOD_DESC',
  DocumentSpacesByCreatorIdMinTenantIdAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_TENANT_ID_ASC',
  DocumentSpacesByCreatorIdMinTenantIdDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_TENANT_ID_DESC',
  DocumentSpacesByCreatorIdMinTrackingDeactivatedAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_TRACKING_DEACTIVATED_ASC',
  DocumentSpacesByCreatorIdMinTrackingDeactivatedDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_TRACKING_DEACTIVATED_DESC',
  DocumentSpacesByCreatorIdMinUpdatedAtAsc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_UPDATED_AT_ASC',
  DocumentSpacesByCreatorIdMinUpdatedAtDesc = 'DOCUMENT_SPACES_BY_CREATOR_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceAccessesByCreatorIdCountAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__COUNT_ASC',
  DocumentSpaceAccessesByCreatorIdCountDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__COUNT_DESC',
  DocumentSpaceAccessesByCreatorIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceAccessesByCreatorIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceAccessesByCreatorIdMaxCreatorIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_CREATOR_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMaxCreatorIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_CREATOR_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMaxDisplayContactDetailsAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_DISPLAY_CONTACT_DETAILS_ASC',
  DocumentSpaceAccessesByCreatorIdMaxDisplayContactDetailsDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceAccessesByCreatorIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMaxIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMaxIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMaxRoleAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_ROLE_ASC',
  DocumentSpaceAccessesByCreatorIdMaxRoleDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_ROLE_DESC',
  DocumentSpaceAccessesByCreatorIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceAccessesByCreatorIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceAccessesByCreatorIdMaxUserIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_USER_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMaxUserIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MAX_USER_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMinCreatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceAccessesByCreatorIdMinCreatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceAccessesByCreatorIdMinCreatorIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_CREATOR_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMinCreatorIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_CREATOR_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMinDisplayContactDetailsAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_DISPLAY_CONTACT_DETAILS_ASC',
  DocumentSpaceAccessesByCreatorIdMinDisplayContactDetailsDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceAccessesByCreatorIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMinIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMinIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_ID_DESC',
  DocumentSpaceAccessesByCreatorIdMinRoleAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_ROLE_ASC',
  DocumentSpaceAccessesByCreatorIdMinRoleDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_ROLE_DESC',
  DocumentSpaceAccessesByCreatorIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceAccessesByCreatorIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceAccessesByCreatorIdMinUserIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_USER_ID_ASC',
  DocumentSpaceAccessesByCreatorIdMinUserIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_CREATOR_ID__MIN_USER_ID_DESC',
  DocumentSpaceAccessesByUserIdCountAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__COUNT_ASC',
  DocumentSpaceAccessesByUserIdCountDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__COUNT_DESC',
  DocumentSpaceAccessesByUserIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceAccessesByUserIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceAccessesByUserIdMaxCreatorIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_CREATOR_ID_ASC',
  DocumentSpaceAccessesByUserIdMaxCreatorIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_CREATOR_ID_DESC',
  DocumentSpaceAccessesByUserIdMaxDisplayContactDetailsAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_DISPLAY_CONTACT_DETAILS_ASC',
  DocumentSpaceAccessesByUserIdMaxDisplayContactDetailsDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceAccessesByUserIdMaxDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceAccessesByUserIdMaxDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceAccessesByUserIdMaxIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_ID_ASC',
  DocumentSpaceAccessesByUserIdMaxIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_ID_DESC',
  DocumentSpaceAccessesByUserIdMaxRoleAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_ROLE_ASC',
  DocumentSpaceAccessesByUserIdMaxRoleDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_ROLE_DESC',
  DocumentSpaceAccessesByUserIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceAccessesByUserIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceAccessesByUserIdMaxUserIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_USER_ID_ASC',
  DocumentSpaceAccessesByUserIdMaxUserIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MAX_USER_ID_DESC',
  DocumentSpaceAccessesByUserIdMinCreatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceAccessesByUserIdMinCreatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceAccessesByUserIdMinCreatorIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_CREATOR_ID_ASC',
  DocumentSpaceAccessesByUserIdMinCreatorIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_CREATOR_ID_DESC',
  DocumentSpaceAccessesByUserIdMinDisplayContactDetailsAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_DISPLAY_CONTACT_DETAILS_ASC',
  DocumentSpaceAccessesByUserIdMinDisplayContactDetailsDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_DISPLAY_CONTACT_DETAILS_DESC',
  DocumentSpaceAccessesByUserIdMinDocumentSpaceIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_DOCUMENT_SPACE_ID_ASC',
  DocumentSpaceAccessesByUserIdMinDocumentSpaceIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_DOCUMENT_SPACE_ID_DESC',
  DocumentSpaceAccessesByUserIdMinIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_ID_ASC',
  DocumentSpaceAccessesByUserIdMinIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_ID_DESC',
  DocumentSpaceAccessesByUserIdMinRoleAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_ROLE_ASC',
  DocumentSpaceAccessesByUserIdMinRoleDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_ROLE_DESC',
  DocumentSpaceAccessesByUserIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceAccessesByUserIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceAccessesByUserIdMinUserIdAsc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_USER_ID_ASC',
  DocumentSpaceAccessesByUserIdMinUserIdDesc = 'DOCUMENT_SPACE_ACCESSES_BY_USER_ID__MIN_USER_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdCountAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__COUNT_ASC',
  DocumentSpaceConfigsByUpdatedByIdCountDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__COUNT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_CREATED_AT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_CREATED_AT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_GROUP_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_GROUP_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_SCALING_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_SCALING_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_TITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_HERO_TITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LOGO_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_LOGO_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_NAME_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_NAME_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_NEW_TAB_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_NEW_TAB_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_STYLESHEET_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_STYLESHEET_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TEAM_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TEAM_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TEMPLATE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TEMPLATE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TENANT_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TENANT_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_TITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_UPDATED_AT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_UPDATED_AT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMaxUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMaxUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MAX_UPDATED_BY_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinContentTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_CONTENT_TITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinContentTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_CONTENT_TITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinCreatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_CREATED_AT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinCreatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_CREATED_AT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinCustomCssAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_CUSTOM_CSS_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinCustomCssDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_CUSTOM_CSS_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinDefaultLanguageAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DEFAULT_LANGUAGE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinDefaultLanguageDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DEFAULT_LANGUAGE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinDisplayHeroAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DISPLAY_HERO_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinDisplayHeroDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DISPLAY_HERO_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinDisplayOptInAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DISPLAY_OPT_IN_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinDisplayOptInDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DISPLAY_OPT_IN_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinDisplayOptOutAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DISPLAY_OPT_OUT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinDisplayOptOutDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_DISPLAY_OPT_OUT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinFooterLinksAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_FOOTER_LINKS_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinFooterLinksDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_FOOTER_LINKS_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinFooterTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_FOOTER_TEXT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinFooterTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_FOOTER_TEXT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinGroupIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_GROUP_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinGroupIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_GROUP_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroImageUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_IMAGE_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroImageUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_IMAGE_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroLinkTextAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_LINK_TEXT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroLinkTextDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_LINK_TEXT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroLinkUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_LINK_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroLinkUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_LINK_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroScalingAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_SCALING_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroScalingDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_SCALING_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroSubtitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_SUBTITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroSubtitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_SUBTITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_TITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinHeroTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_HERO_TITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinLegalNoteAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LEGAL_NOTE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinLegalNoteDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LEGAL_NOTE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinLegalNoteUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LEGAL_NOTE_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinLegalNoteUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LEGAL_NOTE_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinLinkedTabOrderAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LINKED_TAB_ORDER_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinLinkedTabOrderDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LINKED_TAB_ORDER_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinLogoSmallUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LOGO_SMALL_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinLogoSmallUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LOGO_SMALL_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinLogoUrlAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LOGO_URL_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinLogoUrlDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_LOGO_URL_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_NAME_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_NAME_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinNewTabAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_NEW_TAB_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinNewTabDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_NEW_TAB_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinOptInContentAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_OPT_IN_CONTENT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinOptInContentDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_OPT_IN_CONTENT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinProductNameAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_PRODUCT_NAME_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinProductNameDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_PRODUCT_NAME_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinRequiresEmailAuthenticationAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinRequiresEmailAuthenticationDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_REQUIRES_EMAIL_AUTHENTICATION_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinStylesheetAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_STYLESHEET_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinStylesheetDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_STYLESHEET_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinTeamIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TEAM_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinTeamIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TEAM_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinTemplateAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TEMPLATE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinTemplateDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TEMPLATE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinTenantIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TENANT_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinTenantIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TENANT_ID_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinTitleAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TITLE_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinTitleDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_TITLE_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinUpdatedAtAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_UPDATED_AT_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinUpdatedAtDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_UPDATED_AT_DESC',
  DocumentSpaceConfigsByUpdatedByIdMinUpdatedByIdAsc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_UPDATED_BY_ID_ASC',
  DocumentSpaceConfigsByUpdatedByIdMinUpdatedByIdDesc = 'DOCUMENT_SPACE_CONFIGS_BY_UPDATED_BY_ID__MIN_UPDATED_BY_ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  ExternalGroupsAsc = 'EXTERNAL_GROUPS_ASC',
  ExternalGroupsDesc = 'EXTERNAL_GROUPS_DESC',
  ExternalGroupsSyncedAtAsc = 'EXTERNAL_GROUPS_SYNCED_AT_ASC',
  ExternalGroupsSyncedAtDesc = 'EXTERNAL_GROUPS_SYNCED_AT_DESC',
  FirebaseAuthIdAsc = 'FIREBASE_AUTH_ID_ASC',
  FirebaseAuthIdDesc = 'FIREBASE_AUTH_ID_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  FlowsByCreatorIdCountAsc = 'FLOWS_BY_CREATOR_ID__COUNT_ASC',
  FlowsByCreatorIdCountDesc = 'FLOWS_BY_CREATOR_ID__COUNT_DESC',
  FlowsByCreatorIdMaxCreatedAtAsc = 'FLOWS_BY_CREATOR_ID__MAX_CREATED_AT_ASC',
  FlowsByCreatorIdMaxCreatedAtDesc = 'FLOWS_BY_CREATOR_ID__MAX_CREATED_AT_DESC',
  FlowsByCreatorIdMaxCreatorIdAsc = 'FLOWS_BY_CREATOR_ID__MAX_CREATOR_ID_ASC',
  FlowsByCreatorIdMaxCreatorIdDesc = 'FLOWS_BY_CREATOR_ID__MAX_CREATOR_ID_DESC',
  FlowsByCreatorIdMaxFirestoreIdAsc = 'FLOWS_BY_CREATOR_ID__MAX_FIRESTORE_ID_ASC',
  FlowsByCreatorIdMaxFirestoreIdDesc = 'FLOWS_BY_CREATOR_ID__MAX_FIRESTORE_ID_DESC',
  FlowsByCreatorIdMaxIdAsc = 'FLOWS_BY_CREATOR_ID__MAX_ID_ASC',
  FlowsByCreatorIdMaxIdDesc = 'FLOWS_BY_CREATOR_ID__MAX_ID_DESC',
  FlowsByCreatorIdMaxParentIdAsc = 'FLOWS_BY_CREATOR_ID__MAX_PARENT_ID_ASC',
  FlowsByCreatorIdMaxParentIdDesc = 'FLOWS_BY_CREATOR_ID__MAX_PARENT_ID_DESC',
  FlowsByCreatorIdMaxSysPeriodAsc = 'FLOWS_BY_CREATOR_ID__MAX_SYS_PERIOD_ASC',
  FlowsByCreatorIdMaxSysPeriodDesc = 'FLOWS_BY_CREATOR_ID__MAX_SYS_PERIOD_DESC',
  FlowsByCreatorIdMaxTitleAsc = 'FLOWS_BY_CREATOR_ID__MAX_TITLE_ASC',
  FlowsByCreatorIdMaxTitleDesc = 'FLOWS_BY_CREATOR_ID__MAX_TITLE_DESC',
  FlowsByCreatorIdMaxUpdatedAtAsc = 'FLOWS_BY_CREATOR_ID__MAX_UPDATED_AT_ASC',
  FlowsByCreatorIdMaxUpdatedAtDesc = 'FLOWS_BY_CREATOR_ID__MAX_UPDATED_AT_DESC',
  FlowsByCreatorIdMinCreatedAtAsc = 'FLOWS_BY_CREATOR_ID__MIN_CREATED_AT_ASC',
  FlowsByCreatorIdMinCreatedAtDesc = 'FLOWS_BY_CREATOR_ID__MIN_CREATED_AT_DESC',
  FlowsByCreatorIdMinCreatorIdAsc = 'FLOWS_BY_CREATOR_ID__MIN_CREATOR_ID_ASC',
  FlowsByCreatorIdMinCreatorIdDesc = 'FLOWS_BY_CREATOR_ID__MIN_CREATOR_ID_DESC',
  FlowsByCreatorIdMinFirestoreIdAsc = 'FLOWS_BY_CREATOR_ID__MIN_FIRESTORE_ID_ASC',
  FlowsByCreatorIdMinFirestoreIdDesc = 'FLOWS_BY_CREATOR_ID__MIN_FIRESTORE_ID_DESC',
  FlowsByCreatorIdMinIdAsc = 'FLOWS_BY_CREATOR_ID__MIN_ID_ASC',
  FlowsByCreatorIdMinIdDesc = 'FLOWS_BY_CREATOR_ID__MIN_ID_DESC',
  FlowsByCreatorIdMinParentIdAsc = 'FLOWS_BY_CREATOR_ID__MIN_PARENT_ID_ASC',
  FlowsByCreatorIdMinParentIdDesc = 'FLOWS_BY_CREATOR_ID__MIN_PARENT_ID_DESC',
  FlowsByCreatorIdMinSysPeriodAsc = 'FLOWS_BY_CREATOR_ID__MIN_SYS_PERIOD_ASC',
  FlowsByCreatorIdMinSysPeriodDesc = 'FLOWS_BY_CREATOR_ID__MIN_SYS_PERIOD_DESC',
  FlowsByCreatorIdMinTitleAsc = 'FLOWS_BY_CREATOR_ID__MIN_TITLE_ASC',
  FlowsByCreatorIdMinTitleDesc = 'FLOWS_BY_CREATOR_ID__MIN_TITLE_DESC',
  FlowsByCreatorIdMinUpdatedAtAsc = 'FLOWS_BY_CREATOR_ID__MIN_UPDATED_AT_ASC',
  FlowsByCreatorIdMinUpdatedAtDesc = 'FLOWS_BY_CREATOR_ID__MIN_UPDATED_AT_DESC',
  FlowItemsByCreatorIdCountAsc = 'FLOW_ITEMS_BY_CREATOR_ID__COUNT_ASC',
  FlowItemsByCreatorIdCountDesc = 'FLOW_ITEMS_BY_CREATOR_ID__COUNT_DESC',
  FlowItemsByCreatorIdMaxCreatedAtAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_CREATED_AT_ASC',
  FlowItemsByCreatorIdMaxCreatedAtDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_CREATED_AT_DESC',
  FlowItemsByCreatorIdMaxCreatorIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_CREATOR_ID_ASC',
  FlowItemsByCreatorIdMaxCreatorIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_CREATOR_ID_DESC',
  FlowItemsByCreatorIdMaxFlowIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_FLOW_ID_ASC',
  FlowItemsByCreatorIdMaxFlowIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_FLOW_ID_DESC',
  FlowItemsByCreatorIdMaxIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_ID_ASC',
  FlowItemsByCreatorIdMaxIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_ID_DESC',
  FlowItemsByCreatorIdMaxOrderAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_ORDER_ASC',
  FlowItemsByCreatorIdMaxOrderDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_ORDER_DESC',
  FlowItemsByCreatorIdMaxPageIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_PAGE_ID_ASC',
  FlowItemsByCreatorIdMaxPageIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_PAGE_ID_DESC',
  FlowItemsByCreatorIdMaxSysPeriodAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_SYS_PERIOD_ASC',
  FlowItemsByCreatorIdMaxSysPeriodDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_SYS_PERIOD_DESC',
  FlowItemsByCreatorIdMaxUpdatedAtAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_UPDATED_AT_ASC',
  FlowItemsByCreatorIdMaxUpdatedAtDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_UPDATED_AT_DESC',
  FlowItemsByCreatorIdMaxVideoIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_VIDEO_ID_ASC',
  FlowItemsByCreatorIdMaxVideoIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MAX_VIDEO_ID_DESC',
  FlowItemsByCreatorIdMinCreatedAtAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_CREATED_AT_ASC',
  FlowItemsByCreatorIdMinCreatedAtDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_CREATED_AT_DESC',
  FlowItemsByCreatorIdMinCreatorIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_CREATOR_ID_ASC',
  FlowItemsByCreatorIdMinCreatorIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_CREATOR_ID_DESC',
  FlowItemsByCreatorIdMinFlowIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_FLOW_ID_ASC',
  FlowItemsByCreatorIdMinFlowIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_FLOW_ID_DESC',
  FlowItemsByCreatorIdMinIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_ID_ASC',
  FlowItemsByCreatorIdMinIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_ID_DESC',
  FlowItemsByCreatorIdMinOrderAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_ORDER_ASC',
  FlowItemsByCreatorIdMinOrderDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_ORDER_DESC',
  FlowItemsByCreatorIdMinPageIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_PAGE_ID_ASC',
  FlowItemsByCreatorIdMinPageIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_PAGE_ID_DESC',
  FlowItemsByCreatorIdMinSysPeriodAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_SYS_PERIOD_ASC',
  FlowItemsByCreatorIdMinSysPeriodDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_SYS_PERIOD_DESC',
  FlowItemsByCreatorIdMinUpdatedAtAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_UPDATED_AT_ASC',
  FlowItemsByCreatorIdMinUpdatedAtDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_UPDATED_AT_DESC',
  FlowItemsByCreatorIdMinVideoIdAsc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_VIDEO_ID_ASC',
  FlowItemsByCreatorIdMinVideoIdDesc = 'FLOW_ITEMS_BY_CREATOR_ID__MIN_VIDEO_ID_DESC',
  FlowSubscriptionsByUserIdCountAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__COUNT_ASC',
  FlowSubscriptionsByUserIdCountDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__COUNT_DESC',
  FlowSubscriptionsByUserIdMaxFlowIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_FLOW_ID_ASC',
  FlowSubscriptionsByUserIdMaxFlowIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_FLOW_ID_DESC',
  FlowSubscriptionsByUserIdMaxIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_ID_ASC',
  FlowSubscriptionsByUserIdMaxIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_ID_DESC',
  FlowSubscriptionsByUserIdMaxMayEditAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_EDIT_ASC',
  FlowSubscriptionsByUserIdMaxMayEditDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_EDIT_DESC',
  FlowSubscriptionsByUserIdMaxTeamIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_TEAM_ID_ASC',
  FlowSubscriptionsByUserIdMaxTeamIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_TEAM_ID_DESC',
  FlowSubscriptionsByUserIdMaxUserIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_USER_ID_ASC',
  FlowSubscriptionsByUserIdMaxUserIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MAX_USER_ID_DESC',
  FlowSubscriptionsByUserIdMinFlowIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_FLOW_ID_ASC',
  FlowSubscriptionsByUserIdMinFlowIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_FLOW_ID_DESC',
  FlowSubscriptionsByUserIdMinIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_ID_ASC',
  FlowSubscriptionsByUserIdMinIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_ID_DESC',
  FlowSubscriptionsByUserIdMinMayEditAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_EDIT_ASC',
  FlowSubscriptionsByUserIdMinMayEditDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_EDIT_DESC',
  FlowSubscriptionsByUserIdMinTeamIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_TEAM_ID_ASC',
  FlowSubscriptionsByUserIdMinTeamIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_TEAM_ID_DESC',
  FlowSubscriptionsByUserIdMinUserIdAsc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_USER_ID_ASC',
  FlowSubscriptionsByUserIdMinUserIdDesc = 'FLOW_SUBSCRIPTIONS_BY_USER_ID__MIN_USER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsTenantAdminAsc = 'IS_TENANT_ADMIN_ASC',
  IsTenantAdminDesc = 'IS_TENANT_ADMIN_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdCountAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__COUNT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdCountDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__COUNT_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_CREATED_AT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_CREATED_AT_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxTextAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_TEXT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxTextDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_TEXT_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_UPDATED_AT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMaxUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MAX_UPDATED_AT_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMinCreatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_CREATED_AT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMinCreatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_CREATED_AT_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMinCrmContactIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_CRM_CONTACT_ID_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMinCrmContactIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_CRM_CONTACT_ID_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMinDocumentViewIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_DOCUMENT_VIEW_ID_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMinDocumentViewIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_DOCUMENT_VIEW_ID_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMinLastModifiedByIdAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMinLastModifiedByIdDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMinTextAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_TEXT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMinTextDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_TEXT_DESC',
  LabelsOfDocumentViewsByLastModifiedByIdMinUpdatedAtAsc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_UPDATED_AT_ASC',
  LabelsOfDocumentViewsByLastModifiedByIdMinUpdatedAtDesc = 'LABELS_OF_DOCUMENT_VIEWS_BY_LAST_MODIFIED_BY_ID__MIN_UPDATED_AT_DESC',
  MembershipsByUserIdCountAsc = 'MEMBERSHIPS_BY_USER_ID__COUNT_ASC',
  MembershipsByUserIdCountDesc = 'MEMBERSHIPS_BY_USER_ID__COUNT_DESC',
  MembershipsByUserIdMaxCreatedAtAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_CREATED_AT_ASC',
  MembershipsByUserIdMaxCreatedAtDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_CREATED_AT_DESC',
  MembershipsByUserIdMaxCurrentStateAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_CURRENT_STATE_ASC',
  MembershipsByUserIdMaxCurrentStateDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_CURRENT_STATE_DESC',
  MembershipsByUserIdMaxIdAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_ID_ASC',
  MembershipsByUserIdMaxIdDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_ID_DESC',
  MembershipsByUserIdMaxIsManagedManuallyAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_IS_MANAGED_MANUALLY_ASC',
  MembershipsByUserIdMaxIsManagedManuallyDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_IS_MANAGED_MANUALLY_DESC',
  MembershipsByUserIdMaxIsSyncedWithExternalGroupsAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  MembershipsByUserIdMaxIsSyncedWithExternalGroupsDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MembershipsByUserIdMaxMayAdministrateAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_ADMINISTRATE_ASC',
  MembershipsByUserIdMaxMayAdministrateDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_ADMINISTRATE_DESC',
  MembershipsByUserIdMaxMayBanUsersAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_BAN_USERS_ASC',
  MembershipsByUserIdMaxMayBanUsersDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_BAN_USERS_DESC',
  MembershipsByUserIdMaxMayDecideMembershipRequestsAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MembershipsByUserIdMaxMayDecideMembershipRequestsDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MembershipsByUserIdMaxMayInviteUsersAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_INVITE_USERS_ASC',
  MembershipsByUserIdMaxMayInviteUsersDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_INVITE_USERS_DESC',
  MembershipsByUserIdMaxMayOrderLicencesForThisTeamAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MembershipsByUserIdMaxMayOrderLicencesForThisTeamDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MembershipsByUserIdMaxSubteamIdAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_SUBTEAM_ID_ASC',
  MembershipsByUserIdMaxSubteamIdDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_SUBTEAM_ID_DESC',
  MembershipsByUserIdMaxSysPeriodAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_SYS_PERIOD_ASC',
  MembershipsByUserIdMaxSysPeriodDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_SYS_PERIOD_DESC',
  MembershipsByUserIdMaxTeamIdAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_TEAM_ID_ASC',
  MembershipsByUserIdMaxTeamIdDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_TEAM_ID_DESC',
  MembershipsByUserIdMaxUpdatedAtAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_UPDATED_AT_ASC',
  MembershipsByUserIdMaxUpdatedAtDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_UPDATED_AT_DESC',
  MembershipsByUserIdMaxUserIdAsc = 'MEMBERSHIPS_BY_USER_ID__MAX_USER_ID_ASC',
  MembershipsByUserIdMaxUserIdDesc = 'MEMBERSHIPS_BY_USER_ID__MAX_USER_ID_DESC',
  MembershipsByUserIdMinCreatedAtAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_CREATED_AT_ASC',
  MembershipsByUserIdMinCreatedAtDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_CREATED_AT_DESC',
  MembershipsByUserIdMinCurrentStateAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_CURRENT_STATE_ASC',
  MembershipsByUserIdMinCurrentStateDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_CURRENT_STATE_DESC',
  MembershipsByUserIdMinIdAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_ID_ASC',
  MembershipsByUserIdMinIdDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_ID_DESC',
  MembershipsByUserIdMinIsManagedManuallyAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_IS_MANAGED_MANUALLY_ASC',
  MembershipsByUserIdMinIsManagedManuallyDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_IS_MANAGED_MANUALLY_DESC',
  MembershipsByUserIdMinIsSyncedWithExternalGroupsAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  MembershipsByUserIdMinIsSyncedWithExternalGroupsDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MembershipsByUserIdMinMayAdministrateAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_ADMINISTRATE_ASC',
  MembershipsByUserIdMinMayAdministrateDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_ADMINISTRATE_DESC',
  MembershipsByUserIdMinMayBanUsersAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_BAN_USERS_ASC',
  MembershipsByUserIdMinMayBanUsersDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_BAN_USERS_DESC',
  MembershipsByUserIdMinMayDecideMembershipRequestsAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MembershipsByUserIdMinMayDecideMembershipRequestsDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MembershipsByUserIdMinMayInviteUsersAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_INVITE_USERS_ASC',
  MembershipsByUserIdMinMayInviteUsersDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_INVITE_USERS_DESC',
  MembershipsByUserIdMinMayOrderLicencesForThisTeamAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MembershipsByUserIdMinMayOrderLicencesForThisTeamDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MembershipsByUserIdMinSubteamIdAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_SUBTEAM_ID_ASC',
  MembershipsByUserIdMinSubteamIdDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_SUBTEAM_ID_DESC',
  MembershipsByUserIdMinSysPeriodAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_SYS_PERIOD_ASC',
  MembershipsByUserIdMinSysPeriodDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_SYS_PERIOD_DESC',
  MembershipsByUserIdMinTeamIdAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_TEAM_ID_ASC',
  MembershipsByUserIdMinTeamIdDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_TEAM_ID_DESC',
  MembershipsByUserIdMinUpdatedAtAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_UPDATED_AT_ASC',
  MembershipsByUserIdMinUpdatedAtDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_UPDATED_AT_DESC',
  MembershipsByUserIdMinUserIdAsc = 'MEMBERSHIPS_BY_USER_ID__MIN_USER_ID_ASC',
  MembershipsByUserIdMinUserIdDesc = 'MEMBERSHIPS_BY_USER_ID__MIN_USER_ID_DESC',
  Natural = 'NATURAL',
  NotificationsBySenderIdCountAsc = 'NOTIFICATIONS_BY_SENDER_ID__COUNT_ASC',
  NotificationsBySenderIdCountDesc = 'NOTIFICATIONS_BY_SENDER_ID__COUNT_DESC',
  NotificationsBySenderIdMaxBodyTextAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_BODY_TEXT_ASC',
  NotificationsBySenderIdMaxBodyTextDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_BODY_TEXT_DESC',
  NotificationsBySenderIdMaxCreatedAtAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_CREATED_AT_ASC',
  NotificationsBySenderIdMaxCreatedAtDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_CREATED_AT_DESC',
  NotificationsBySenderIdMaxDataAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_DATA_ASC',
  NotificationsBySenderIdMaxDataDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_DATA_DESC',
  NotificationsBySenderIdMaxEventTypeAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_EVENT_TYPE_ASC',
  NotificationsBySenderIdMaxEventTypeDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_EVENT_TYPE_DESC',
  NotificationsBySenderIdMaxHeaderTextAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_HEADER_TEXT_ASC',
  NotificationsBySenderIdMaxHeaderTextDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_HEADER_TEXT_DESC',
  NotificationsBySenderIdMaxIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_ID_ASC',
  NotificationsBySenderIdMaxIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_ID_DESC',
  NotificationsBySenderIdMaxSenderIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_SENDER_ID_ASC',
  NotificationsBySenderIdMaxSenderIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_SENDER_ID_DESC',
  NotificationsBySenderIdMaxTeamIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_TEAM_ID_ASC',
  NotificationsBySenderIdMaxTeamIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_TEAM_ID_DESC',
  NotificationsBySenderIdMaxUserIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_USER_ID_ASC',
  NotificationsBySenderIdMaxUserIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_USER_ID_DESC',
  NotificationsBySenderIdMaxWorkspaceIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_WORKSPACE_ID_ASC',
  NotificationsBySenderIdMaxWorkspaceIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MAX_WORKSPACE_ID_DESC',
  NotificationsBySenderIdMinBodyTextAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_BODY_TEXT_ASC',
  NotificationsBySenderIdMinBodyTextDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_BODY_TEXT_DESC',
  NotificationsBySenderIdMinCreatedAtAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_CREATED_AT_ASC',
  NotificationsBySenderIdMinCreatedAtDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_CREATED_AT_DESC',
  NotificationsBySenderIdMinDataAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_DATA_ASC',
  NotificationsBySenderIdMinDataDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_DATA_DESC',
  NotificationsBySenderIdMinEventTypeAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_EVENT_TYPE_ASC',
  NotificationsBySenderIdMinEventTypeDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_EVENT_TYPE_DESC',
  NotificationsBySenderIdMinHeaderTextAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_HEADER_TEXT_ASC',
  NotificationsBySenderIdMinHeaderTextDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_HEADER_TEXT_DESC',
  NotificationsBySenderIdMinIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_ID_ASC',
  NotificationsBySenderIdMinIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_ID_DESC',
  NotificationsBySenderIdMinSenderIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_SENDER_ID_ASC',
  NotificationsBySenderIdMinSenderIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_SENDER_ID_DESC',
  NotificationsBySenderIdMinTeamIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_TEAM_ID_ASC',
  NotificationsBySenderIdMinTeamIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_TEAM_ID_DESC',
  NotificationsBySenderIdMinUserIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_USER_ID_ASC',
  NotificationsBySenderIdMinUserIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_USER_ID_DESC',
  NotificationsBySenderIdMinWorkspaceIdAsc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_WORKSPACE_ID_ASC',
  NotificationsBySenderIdMinWorkspaceIdDesc = 'NOTIFICATIONS_BY_SENDER_ID__MIN_WORKSPACE_ID_DESC',
  NotificationsByUserIdCountAsc = 'NOTIFICATIONS_BY_USER_ID__COUNT_ASC',
  NotificationsByUserIdCountDesc = 'NOTIFICATIONS_BY_USER_ID__COUNT_DESC',
  NotificationsByUserIdMaxBodyTextAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_BODY_TEXT_ASC',
  NotificationsByUserIdMaxBodyTextDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_BODY_TEXT_DESC',
  NotificationsByUserIdMaxCreatedAtAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_CREATED_AT_ASC',
  NotificationsByUserIdMaxCreatedAtDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_CREATED_AT_DESC',
  NotificationsByUserIdMaxDataAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_DATA_ASC',
  NotificationsByUserIdMaxDataDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_DATA_DESC',
  NotificationsByUserIdMaxEventTypeAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_EVENT_TYPE_ASC',
  NotificationsByUserIdMaxEventTypeDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_EVENT_TYPE_DESC',
  NotificationsByUserIdMaxHeaderTextAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_HEADER_TEXT_ASC',
  NotificationsByUserIdMaxHeaderTextDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_HEADER_TEXT_DESC',
  NotificationsByUserIdMaxIdAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_ID_ASC',
  NotificationsByUserIdMaxIdDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_ID_DESC',
  NotificationsByUserIdMaxSenderIdAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_SENDER_ID_ASC',
  NotificationsByUserIdMaxSenderIdDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_SENDER_ID_DESC',
  NotificationsByUserIdMaxTeamIdAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_TEAM_ID_ASC',
  NotificationsByUserIdMaxTeamIdDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_TEAM_ID_DESC',
  NotificationsByUserIdMaxUserIdAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_USER_ID_ASC',
  NotificationsByUserIdMaxUserIdDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_USER_ID_DESC',
  NotificationsByUserIdMaxWorkspaceIdAsc = 'NOTIFICATIONS_BY_USER_ID__MAX_WORKSPACE_ID_ASC',
  NotificationsByUserIdMaxWorkspaceIdDesc = 'NOTIFICATIONS_BY_USER_ID__MAX_WORKSPACE_ID_DESC',
  NotificationsByUserIdMinBodyTextAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_BODY_TEXT_ASC',
  NotificationsByUserIdMinBodyTextDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_BODY_TEXT_DESC',
  NotificationsByUserIdMinCreatedAtAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_CREATED_AT_ASC',
  NotificationsByUserIdMinCreatedAtDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_CREATED_AT_DESC',
  NotificationsByUserIdMinDataAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_DATA_ASC',
  NotificationsByUserIdMinDataDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_DATA_DESC',
  NotificationsByUserIdMinEventTypeAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_EVENT_TYPE_ASC',
  NotificationsByUserIdMinEventTypeDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_EVENT_TYPE_DESC',
  NotificationsByUserIdMinHeaderTextAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_HEADER_TEXT_ASC',
  NotificationsByUserIdMinHeaderTextDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_HEADER_TEXT_DESC',
  NotificationsByUserIdMinIdAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_ID_ASC',
  NotificationsByUserIdMinIdDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_ID_DESC',
  NotificationsByUserIdMinSenderIdAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_SENDER_ID_ASC',
  NotificationsByUserIdMinSenderIdDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_SENDER_ID_DESC',
  NotificationsByUserIdMinTeamIdAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_TEAM_ID_ASC',
  NotificationsByUserIdMinTeamIdDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_TEAM_ID_DESC',
  NotificationsByUserIdMinUserIdAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_USER_ID_ASC',
  NotificationsByUserIdMinUserIdDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_USER_ID_DESC',
  NotificationsByUserIdMinWorkspaceIdAsc = 'NOTIFICATIONS_BY_USER_ID__MIN_WORKSPACE_ID_ASC',
  NotificationsByUserIdMinWorkspaceIdDesc = 'NOTIFICATIONS_BY_USER_ID__MIN_WORKSPACE_ID_DESC',
  OrdersByAdminIdCountAsc = 'ORDERS_BY_ADMIN_ID__COUNT_ASC',
  OrdersByAdminIdCountDesc = 'ORDERS_BY_ADMIN_ID__COUNT_DESC',
  OrdersByAdminIdMaxAdminIdAsc = 'ORDERS_BY_ADMIN_ID__MAX_ADMIN_ID_ASC',
  OrdersByAdminIdMaxAdminIdDesc = 'ORDERS_BY_ADMIN_ID__MAX_ADMIN_ID_DESC',
  OrdersByAdminIdMaxAmountCentsAsc = 'ORDERS_BY_ADMIN_ID__MAX_AMOUNT_CENTS_ASC',
  OrdersByAdminIdMaxAmountCentsDesc = 'ORDERS_BY_ADMIN_ID__MAX_AMOUNT_CENTS_DESC',
  OrdersByAdminIdMaxCommentAsc = 'ORDERS_BY_ADMIN_ID__MAX_COMMENT_ASC',
  OrdersByAdminIdMaxCommentDesc = 'ORDERS_BY_ADMIN_ID__MAX_COMMENT_DESC',
  OrdersByAdminIdMaxContactEmailAsc = 'ORDERS_BY_ADMIN_ID__MAX_CONTACT_EMAIL_ASC',
  OrdersByAdminIdMaxContactEmailDesc = 'ORDERS_BY_ADMIN_ID__MAX_CONTACT_EMAIL_DESC',
  OrdersByAdminIdMaxContactNameAsc = 'ORDERS_BY_ADMIN_ID__MAX_CONTACT_NAME_ASC',
  OrdersByAdminIdMaxContactNameDesc = 'ORDERS_BY_ADMIN_ID__MAX_CONTACT_NAME_DESC',
  OrdersByAdminIdMaxCreatedAtAsc = 'ORDERS_BY_ADMIN_ID__MAX_CREATED_AT_ASC',
  OrdersByAdminIdMaxCreatedAtDesc = 'ORDERS_BY_ADMIN_ID__MAX_CREATED_AT_DESC',
  OrdersByAdminIdMaxCurrencyCodeAsc = 'ORDERS_BY_ADMIN_ID__MAX_CURRENCY_CODE_ASC',
  OrdersByAdminIdMaxCurrencyCodeDesc = 'ORDERS_BY_ADMIN_ID__MAX_CURRENCY_CODE_DESC',
  OrdersByAdminIdMaxDescriptionAsc = 'ORDERS_BY_ADMIN_ID__MAX_DESCRIPTION_ASC',
  OrdersByAdminIdMaxDescriptionDesc = 'ORDERS_BY_ADMIN_ID__MAX_DESCRIPTION_DESC',
  OrdersByAdminIdMaxFastbillReferenceAsc = 'ORDERS_BY_ADMIN_ID__MAX_FASTBILL_REFERENCE_ASC',
  OrdersByAdminIdMaxFastbillReferenceDesc = 'ORDERS_BY_ADMIN_ID__MAX_FASTBILL_REFERENCE_DESC',
  OrdersByAdminIdMaxIdAsc = 'ORDERS_BY_ADMIN_ID__MAX_ID_ASC',
  OrdersByAdminIdMaxIdDesc = 'ORDERS_BY_ADMIN_ID__MAX_ID_DESC',
  OrdersByAdminIdMaxInvoiceNumberAsc = 'ORDERS_BY_ADMIN_ID__MAX_INVOICE_NUMBER_ASC',
  OrdersByAdminIdMaxInvoiceNumberDesc = 'ORDERS_BY_ADMIN_ID__MAX_INVOICE_NUMBER_DESC',
  OrdersByAdminIdMaxLicensesCountAsc = 'ORDERS_BY_ADMIN_ID__MAX_LICENSES_COUNT_ASC',
  OrdersByAdminIdMaxLicensesCountDesc = 'ORDERS_BY_ADMIN_ID__MAX_LICENSES_COUNT_DESC',
  OrdersByAdminIdMaxNumTeamLicensesAsc = 'ORDERS_BY_ADMIN_ID__MAX_NUM_TEAM_LICENSES_ASC',
  OrdersByAdminIdMaxNumTeamLicensesDesc = 'ORDERS_BY_ADMIN_ID__MAX_NUM_TEAM_LICENSES_DESC',
  OrdersByAdminIdMaxPipedriveReferenceAsc = 'ORDERS_BY_ADMIN_ID__MAX_PIPEDRIVE_REFERENCE_ASC',
  OrdersByAdminIdMaxPipedriveReferenceDesc = 'ORDERS_BY_ADMIN_ID__MAX_PIPEDRIVE_REFERENCE_DESC',
  OrdersByAdminIdMaxTenantIdAsc = 'ORDERS_BY_ADMIN_ID__MAX_TENANT_ID_ASC',
  OrdersByAdminIdMaxTenantIdDesc = 'ORDERS_BY_ADMIN_ID__MAX_TENANT_ID_DESC',
  OrdersByAdminIdMaxValidityPeriodAsc = 'ORDERS_BY_ADMIN_ID__MAX_VALIDITY_PERIOD_ASC',
  OrdersByAdminIdMaxValidityPeriodDesc = 'ORDERS_BY_ADMIN_ID__MAX_VALIDITY_PERIOD_DESC',
  OrdersByAdminIdMinAdminIdAsc = 'ORDERS_BY_ADMIN_ID__MIN_ADMIN_ID_ASC',
  OrdersByAdminIdMinAdminIdDesc = 'ORDERS_BY_ADMIN_ID__MIN_ADMIN_ID_DESC',
  OrdersByAdminIdMinAmountCentsAsc = 'ORDERS_BY_ADMIN_ID__MIN_AMOUNT_CENTS_ASC',
  OrdersByAdminIdMinAmountCentsDesc = 'ORDERS_BY_ADMIN_ID__MIN_AMOUNT_CENTS_DESC',
  OrdersByAdminIdMinCommentAsc = 'ORDERS_BY_ADMIN_ID__MIN_COMMENT_ASC',
  OrdersByAdminIdMinCommentDesc = 'ORDERS_BY_ADMIN_ID__MIN_COMMENT_DESC',
  OrdersByAdminIdMinContactEmailAsc = 'ORDERS_BY_ADMIN_ID__MIN_CONTACT_EMAIL_ASC',
  OrdersByAdminIdMinContactEmailDesc = 'ORDERS_BY_ADMIN_ID__MIN_CONTACT_EMAIL_DESC',
  OrdersByAdminIdMinContactNameAsc = 'ORDERS_BY_ADMIN_ID__MIN_CONTACT_NAME_ASC',
  OrdersByAdminIdMinContactNameDesc = 'ORDERS_BY_ADMIN_ID__MIN_CONTACT_NAME_DESC',
  OrdersByAdminIdMinCreatedAtAsc = 'ORDERS_BY_ADMIN_ID__MIN_CREATED_AT_ASC',
  OrdersByAdminIdMinCreatedAtDesc = 'ORDERS_BY_ADMIN_ID__MIN_CREATED_AT_DESC',
  OrdersByAdminIdMinCurrencyCodeAsc = 'ORDERS_BY_ADMIN_ID__MIN_CURRENCY_CODE_ASC',
  OrdersByAdminIdMinCurrencyCodeDesc = 'ORDERS_BY_ADMIN_ID__MIN_CURRENCY_CODE_DESC',
  OrdersByAdminIdMinDescriptionAsc = 'ORDERS_BY_ADMIN_ID__MIN_DESCRIPTION_ASC',
  OrdersByAdminIdMinDescriptionDesc = 'ORDERS_BY_ADMIN_ID__MIN_DESCRIPTION_DESC',
  OrdersByAdminIdMinFastbillReferenceAsc = 'ORDERS_BY_ADMIN_ID__MIN_FASTBILL_REFERENCE_ASC',
  OrdersByAdminIdMinFastbillReferenceDesc = 'ORDERS_BY_ADMIN_ID__MIN_FASTBILL_REFERENCE_DESC',
  OrdersByAdminIdMinIdAsc = 'ORDERS_BY_ADMIN_ID__MIN_ID_ASC',
  OrdersByAdminIdMinIdDesc = 'ORDERS_BY_ADMIN_ID__MIN_ID_DESC',
  OrdersByAdminIdMinInvoiceNumberAsc = 'ORDERS_BY_ADMIN_ID__MIN_INVOICE_NUMBER_ASC',
  OrdersByAdminIdMinInvoiceNumberDesc = 'ORDERS_BY_ADMIN_ID__MIN_INVOICE_NUMBER_DESC',
  OrdersByAdminIdMinLicensesCountAsc = 'ORDERS_BY_ADMIN_ID__MIN_LICENSES_COUNT_ASC',
  OrdersByAdminIdMinLicensesCountDesc = 'ORDERS_BY_ADMIN_ID__MIN_LICENSES_COUNT_DESC',
  OrdersByAdminIdMinNumTeamLicensesAsc = 'ORDERS_BY_ADMIN_ID__MIN_NUM_TEAM_LICENSES_ASC',
  OrdersByAdminIdMinNumTeamLicensesDesc = 'ORDERS_BY_ADMIN_ID__MIN_NUM_TEAM_LICENSES_DESC',
  OrdersByAdminIdMinPipedriveReferenceAsc = 'ORDERS_BY_ADMIN_ID__MIN_PIPEDRIVE_REFERENCE_ASC',
  OrdersByAdminIdMinPipedriveReferenceDesc = 'ORDERS_BY_ADMIN_ID__MIN_PIPEDRIVE_REFERENCE_DESC',
  OrdersByAdminIdMinTenantIdAsc = 'ORDERS_BY_ADMIN_ID__MIN_TENANT_ID_ASC',
  OrdersByAdminIdMinTenantIdDesc = 'ORDERS_BY_ADMIN_ID__MIN_TENANT_ID_DESC',
  OrdersByAdminIdMinValidityPeriodAsc = 'ORDERS_BY_ADMIN_ID__MIN_VALIDITY_PERIOD_ASC',
  OrdersByAdminIdMinValidityPeriodDesc = 'ORDERS_BY_ADMIN_ID__MIN_VALIDITY_PERIOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegisteredAtAsc = 'REGISTERED_AT_ASC',
  RegisteredAtDesc = 'REGISTERED_AT_DESC',
  RegistrationTokensByUserIdCountAsc = 'REGISTRATION_TOKENS_BY_USER_ID__COUNT_ASC',
  RegistrationTokensByUserIdCountDesc = 'REGISTRATION_TOKENS_BY_USER_ID__COUNT_DESC',
  RegistrationTokensByUserIdMaxRegistrationTokenAsc = 'REGISTRATION_TOKENS_BY_USER_ID__MAX_REGISTRATION_TOKEN_ASC',
  RegistrationTokensByUserIdMaxRegistrationTokenDesc = 'REGISTRATION_TOKENS_BY_USER_ID__MAX_REGISTRATION_TOKEN_DESC',
  RegistrationTokensByUserIdMaxUpdatedAtAsc = 'REGISTRATION_TOKENS_BY_USER_ID__MAX_UPDATED_AT_ASC',
  RegistrationTokensByUserIdMaxUpdatedAtDesc = 'REGISTRATION_TOKENS_BY_USER_ID__MAX_UPDATED_AT_DESC',
  RegistrationTokensByUserIdMaxUserIdAsc = 'REGISTRATION_TOKENS_BY_USER_ID__MAX_USER_ID_ASC',
  RegistrationTokensByUserIdMaxUserIdDesc = 'REGISTRATION_TOKENS_BY_USER_ID__MAX_USER_ID_DESC',
  RegistrationTokensByUserIdMinRegistrationTokenAsc = 'REGISTRATION_TOKENS_BY_USER_ID__MIN_REGISTRATION_TOKEN_ASC',
  RegistrationTokensByUserIdMinRegistrationTokenDesc = 'REGISTRATION_TOKENS_BY_USER_ID__MIN_REGISTRATION_TOKEN_DESC',
  RegistrationTokensByUserIdMinUpdatedAtAsc = 'REGISTRATION_TOKENS_BY_USER_ID__MIN_UPDATED_AT_ASC',
  RegistrationTokensByUserIdMinUpdatedAtDesc = 'REGISTRATION_TOKENS_BY_USER_ID__MIN_UPDATED_AT_DESC',
  RegistrationTokensByUserIdMinUserIdAsc = 'REGISTRATION_TOKENS_BY_USER_ID__MIN_USER_ID_ASC',
  RegistrationTokensByUserIdMinUserIdDesc = 'REGISTRATION_TOKENS_BY_USER_ID__MIN_USER_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdCountAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__COUNT_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdCountDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__COUNT_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxCreatedAtAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_CREATED_AT_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxCreatedAtDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_CREATED_AT_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxDocumentIdAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_DOCUMENT_ID_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxDocumentIdDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_DOCUMENT_ID_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxSysPeriodAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_SYS_PERIOD_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxSysPeriodDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_SYS_PERIOD_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxUpdatedAtAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_UPDATED_AT_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxUpdatedAtDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_UPDATED_AT_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxUpdatedByIdAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_UPDATED_BY_ID_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxUpdatedByIdDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_UPDATED_BY_ID_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxUrlAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_URL_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMaxUrlDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MAX_URL_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinCreatedAtAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_CREATED_AT_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinCreatedAtDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_CREATED_AT_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinDocumentIdAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_DOCUMENT_ID_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinDocumentIdDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_DOCUMENT_ID_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinSysPeriodAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_SYS_PERIOD_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinSysPeriodDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_SYS_PERIOD_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinUpdatedAtAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_UPDATED_AT_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinUpdatedAtDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_UPDATED_AT_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinUpdatedByIdAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_UPDATED_BY_ID_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinUpdatedByIdDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_UPDATED_BY_ID_DESC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinUrlAsc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_URL_ASC',
  UrlBasedDocumentImportSettingsByUpdatedByIdMinUrlDesc = 'URL_BASED_DOCUMENT_IMPORT_SETTINGS_BY_UPDATED_BY_ID__MIN_URL_DESC',
  UserContactDetailByIdAppointmentBookingUrlAsc = 'USER_CONTACT_DETAIL_BY_ID__APPOINTMENT_BOOKING_URL_ASC',
  UserContactDetailByIdAppointmentBookingUrlDesc = 'USER_CONTACT_DETAIL_BY_ID__APPOINTMENT_BOOKING_URL_DESC',
  UserContactDetailByIdBusinessCardUrlAsc = 'USER_CONTACT_DETAIL_BY_ID__BUSINESS_CARD_URL_ASC',
  UserContactDetailByIdBusinessCardUrlDesc = 'USER_CONTACT_DETAIL_BY_ID__BUSINESS_CARD_URL_DESC',
  UserContactDetailByIdCreatedAtAsc = 'USER_CONTACT_DETAIL_BY_ID__CREATED_AT_ASC',
  UserContactDetailByIdCreatedAtDesc = 'USER_CONTACT_DETAIL_BY_ID__CREATED_AT_DESC',
  UserContactDetailByIdDisplayNameAsc = 'USER_CONTACT_DETAIL_BY_ID__DISPLAY_NAME_ASC',
  UserContactDetailByIdDisplayNameDesc = 'USER_CONTACT_DETAIL_BY_ID__DISPLAY_NAME_DESC',
  UserContactDetailByIdEmailAsc = 'USER_CONTACT_DETAIL_BY_ID__EMAIL_ASC',
  UserContactDetailByIdEmailDesc = 'USER_CONTACT_DETAIL_BY_ID__EMAIL_DESC',
  UserContactDetailByIdIdAsc = 'USER_CONTACT_DETAIL_BY_ID__ID_ASC',
  UserContactDetailByIdIdDesc = 'USER_CONTACT_DETAIL_BY_ID__ID_DESC',
  UserContactDetailByIdJobTitleAsc = 'USER_CONTACT_DETAIL_BY_ID__JOB_TITLE_ASC',
  UserContactDetailByIdJobTitleDesc = 'USER_CONTACT_DETAIL_BY_ID__JOB_TITLE_DESC',
  UserContactDetailByIdPhoneAsc = 'USER_CONTACT_DETAIL_BY_ID__PHONE_ASC',
  UserContactDetailByIdPhoneDesc = 'USER_CONTACT_DETAIL_BY_ID__PHONE_DESC',
  UserContactDetailByIdProfileImageUrlAsc = 'USER_CONTACT_DETAIL_BY_ID__PROFILE_IMAGE_URL_ASC',
  UserContactDetailByIdProfileImageUrlDesc = 'USER_CONTACT_DETAIL_BY_ID__PROFILE_IMAGE_URL_DESC',
  UserContactDetailByIdUpdatedAtAsc = 'USER_CONTACT_DETAIL_BY_ID__UPDATED_AT_ASC',
  UserContactDetailByIdUpdatedAtDesc = 'USER_CONTACT_DETAIL_BY_ID__UPDATED_AT_DESC',
  UserContactDetailByIdUserIdAsc = 'USER_CONTACT_DETAIL_BY_ID__USER_ID_ASC',
  UserContactDetailByIdUserIdDesc = 'USER_CONTACT_DETAIL_BY_ID__USER_ID_DESC',
  UserContactDetailByUserIdAppointmentBookingUrlAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__APPOINTMENT_BOOKING_URL_ASC',
  UserContactDetailByUserIdAppointmentBookingUrlDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__APPOINTMENT_BOOKING_URL_DESC',
  UserContactDetailByUserIdBusinessCardUrlAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__BUSINESS_CARD_URL_ASC',
  UserContactDetailByUserIdBusinessCardUrlDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__BUSINESS_CARD_URL_DESC',
  UserContactDetailByUserIdCreatedAtAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__CREATED_AT_ASC',
  UserContactDetailByUserIdCreatedAtDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__CREATED_AT_DESC',
  UserContactDetailByUserIdDisplayNameAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__DISPLAY_NAME_ASC',
  UserContactDetailByUserIdDisplayNameDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__DISPLAY_NAME_DESC',
  UserContactDetailByUserIdEmailAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__EMAIL_ASC',
  UserContactDetailByUserIdEmailDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__EMAIL_DESC',
  UserContactDetailByUserIdIdAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__ID_ASC',
  UserContactDetailByUserIdIdDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__ID_DESC',
  UserContactDetailByUserIdJobTitleAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__JOB_TITLE_ASC',
  UserContactDetailByUserIdJobTitleDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__JOB_TITLE_DESC',
  UserContactDetailByUserIdPhoneAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__PHONE_ASC',
  UserContactDetailByUserIdPhoneDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__PHONE_DESC',
  UserContactDetailByUserIdProfileImageUrlAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__PROFILE_IMAGE_URL_ASC',
  UserContactDetailByUserIdProfileImageUrlDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__PROFILE_IMAGE_URL_DESC',
  UserContactDetailByUserIdUpdatedAtAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__UPDATED_AT_ASC',
  UserContactDetailByUserIdUpdatedAtDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__UPDATED_AT_DESC',
  UserContactDetailByUserIdUserIdAsc = 'USER_CONTACT_DETAIL_BY_USER_ID__USER_ID_ASC',
  UserContactDetailByUserIdUserIdDesc = 'USER_CONTACT_DETAIL_BY_USER_ID__USER_ID_DESC',
  UserLicensesByLastModifiedByIdCountAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__COUNT_ASC',
  UserLicensesByLastModifiedByIdCountDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__COUNT_DESC',
  UserLicensesByLastModifiedByIdMaxLastModifiedByIdAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  UserLicensesByLastModifiedByIdMaxLastModifiedByIdDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  UserLicensesByLastModifiedByIdMaxOrderIdAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_ORDER_ID_ASC',
  UserLicensesByLastModifiedByIdMaxOrderIdDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_ORDER_ID_DESC',
  UserLicensesByLastModifiedByIdMaxUserIdAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_USER_ID_ASC',
  UserLicensesByLastModifiedByIdMaxUserIdDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_USER_ID_DESC',
  UserLicensesByLastModifiedByIdMaxValidityPeriodAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_VALIDITY_PERIOD_ASC',
  UserLicensesByLastModifiedByIdMaxValidityPeriodDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MAX_VALIDITY_PERIOD_DESC',
  UserLicensesByLastModifiedByIdMinLastModifiedByIdAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  UserLicensesByLastModifiedByIdMinLastModifiedByIdDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  UserLicensesByLastModifiedByIdMinOrderIdAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_ORDER_ID_ASC',
  UserLicensesByLastModifiedByIdMinOrderIdDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_ORDER_ID_DESC',
  UserLicensesByLastModifiedByIdMinUserIdAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_USER_ID_ASC',
  UserLicensesByLastModifiedByIdMinUserIdDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_USER_ID_DESC',
  UserLicensesByLastModifiedByIdMinValidityPeriodAsc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_VALIDITY_PERIOD_ASC',
  UserLicensesByLastModifiedByIdMinValidityPeriodDesc = 'USER_LICENSES_BY_LAST_MODIFIED_BY_ID__MIN_VALIDITY_PERIOD_DESC',
  UserLicensesByUserIdCountAsc = 'USER_LICENSES_BY_USER_ID__COUNT_ASC',
  UserLicensesByUserIdCountDesc = 'USER_LICENSES_BY_USER_ID__COUNT_DESC',
  UserLicensesByUserIdMaxLastModifiedByIdAsc = 'USER_LICENSES_BY_USER_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  UserLicensesByUserIdMaxLastModifiedByIdDesc = 'USER_LICENSES_BY_USER_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  UserLicensesByUserIdMaxOrderIdAsc = 'USER_LICENSES_BY_USER_ID__MAX_ORDER_ID_ASC',
  UserLicensesByUserIdMaxOrderIdDesc = 'USER_LICENSES_BY_USER_ID__MAX_ORDER_ID_DESC',
  UserLicensesByUserIdMaxUserIdAsc = 'USER_LICENSES_BY_USER_ID__MAX_USER_ID_ASC',
  UserLicensesByUserIdMaxUserIdDesc = 'USER_LICENSES_BY_USER_ID__MAX_USER_ID_DESC',
  UserLicensesByUserIdMaxValidityPeriodAsc = 'USER_LICENSES_BY_USER_ID__MAX_VALIDITY_PERIOD_ASC',
  UserLicensesByUserIdMaxValidityPeriodDesc = 'USER_LICENSES_BY_USER_ID__MAX_VALIDITY_PERIOD_DESC',
  UserLicensesByUserIdMinLastModifiedByIdAsc = 'USER_LICENSES_BY_USER_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  UserLicensesByUserIdMinLastModifiedByIdDesc = 'USER_LICENSES_BY_USER_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  UserLicensesByUserIdMinOrderIdAsc = 'USER_LICENSES_BY_USER_ID__MIN_ORDER_ID_ASC',
  UserLicensesByUserIdMinOrderIdDesc = 'USER_LICENSES_BY_USER_ID__MIN_ORDER_ID_DESC',
  UserLicensesByUserIdMinUserIdAsc = 'USER_LICENSES_BY_USER_ID__MIN_USER_ID_ASC',
  UserLicensesByUserIdMinUserIdDesc = 'USER_LICENSES_BY_USER_ID__MIN_USER_ID_DESC',
  UserLicensesByUserIdMinValidityPeriodAsc = 'USER_LICENSES_BY_USER_ID__MIN_VALIDITY_PERIOD_ASC',
  UserLicensesByUserIdMinValidityPeriodDesc = 'USER_LICENSES_BY_USER_ID__MIN_VALIDITY_PERIOD_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdCountAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__COUNT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdCountDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__COUNT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAnalyticsAliasAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ANALYTICS_ALIAS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAnalyticsAliasDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ANALYTICS_ALIAS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAnalyticsEnabledAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ANALYTICS_ENABLED_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAnalyticsEnabledDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ANALYTICS_ENABLED_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxConfigAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CONFIG_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxConfigDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CONFIG_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxCreatedAtAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CREATED_AT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxCreatedAtDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CREATED_AT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxCustomBrandUrlAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CUSTOM_BRAND_URL_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxCustomBrandUrlDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CUSTOM_BRAND_URL_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxCustomShareLinkAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxCustomShareLinkDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxEmailSubjectAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_EMAIL_SUBJECT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxEmailSubjectDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_EMAIL_SUBJECT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxEmailTextAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_EMAIL_TEXT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxEmailTextDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_EMAIL_TEXT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxFirebaseIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_FIREBASE_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxFirebaseIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_FIREBASE_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxFlagsAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_FLAGS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxFlagsDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_FLAGS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxIsOpenAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_IS_OPEN_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxIsOpenDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_IS_OPEN_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxIsVisibleAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_IS_VISIBLE_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxIsVisibleDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_IS_VISIBLE_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxLaserPointerPositionAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_LASER_POINTER_POSITION_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxLaserPointerPositionDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_LASER_POINTER_POSITION_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxLinkPanelPositionAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_LINK_PANEL_POSITION_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxLinkPanelPositionDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_LINK_PANEL_POSITION_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxNameAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_NAME_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxNameDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_NAME_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxNameLowercaseAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_NAME_LOWERCASE_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxNameLowercaseDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_NAME_LOWERCASE_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxParentIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_PARENT_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxParentIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_PARENT_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxSysPeriodAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_SYS_PERIOD_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxSysPeriodDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_SYS_PERIOD_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxTagsAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_TAGS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxTagsDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_TAGS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxTeamRankAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_TEAM_RANK_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxTeamRankDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_TEAM_RANK_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxTenantIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_TENANT_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxTenantIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_TENANT_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxUpdatedAtAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_UPDATED_AT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxUpdatedAtDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_UPDATED_AT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxUserConfigDefaultsAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMaxUserConfigDefaultsDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MAX_USER_CONFIG_DEFAULTS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAnalyticsAliasAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ANALYTICS_ALIAS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAnalyticsAliasDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ANALYTICS_ALIAS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAnalyticsEnabledAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ANALYTICS_ENABLED_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAnalyticsEnabledDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ANALYTICS_ENABLED_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinConfigAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CONFIG_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinConfigDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CONFIG_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinCreatedAtAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CREATED_AT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinCreatedAtDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CREATED_AT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinCustomBrandUrlAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CUSTOM_BRAND_URL_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinCustomBrandUrlDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CUSTOM_BRAND_URL_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinCustomShareLinkAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinCustomShareLinkDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinEmailSubjectAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_EMAIL_SUBJECT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinEmailSubjectDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_EMAIL_SUBJECT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinEmailTextAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_EMAIL_TEXT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinEmailTextDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_EMAIL_TEXT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinFirebaseIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_FIREBASE_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinFirebaseIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_FIREBASE_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinFlagsAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_FLAGS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinFlagsDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_FLAGS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinIsOpenAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_IS_OPEN_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinIsOpenDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_IS_OPEN_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinIsVisibleAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_IS_VISIBLE_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinIsVisibleDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_IS_VISIBLE_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinLaserPointerPositionAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_LASER_POINTER_POSITION_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinLaserPointerPositionDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_LASER_POINTER_POSITION_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinLinkPanelPositionAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_LINK_PANEL_POSITION_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinLinkPanelPositionDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_LINK_PANEL_POSITION_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinNameAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_NAME_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinNameDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_NAME_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinNameLowercaseAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_NAME_LOWERCASE_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinNameLowercaseDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_NAME_LOWERCASE_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinParentIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_PARENT_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinParentIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_PARENT_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinSysPeriodAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_SYS_PERIOD_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinSysPeriodDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_SYS_PERIOD_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinTagsAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_TAGS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinTagsDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_TAGS_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinTeamRankAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_TEAM_RANK_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinTeamRankDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_TEAM_RANK_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinTenantIdAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_TENANT_ID_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinTenantIdDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_TENANT_ID_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinUpdatedAtAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_UPDATED_AT_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinUpdatedAtDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_UPDATED_AT_DESC',
  WorkspacesByPersonalWorkspaceOfUserIdMinUserConfigDefaultsAsc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByPersonalWorkspaceOfUserIdMinUserConfigDefaultsDesc = 'WORKSPACES_BY_PERSONAL_WORKSPACE_OF_USER_ID__MIN_USER_CONFIG_DEFAULTS_DESC',
  WorkspaceByDefaultWorkspaceIdAnalyticsAliasAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByDefaultWorkspaceIdAnalyticsAliasDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByDefaultWorkspaceIdAnalyticsEnabledAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByDefaultWorkspaceIdAnalyticsEnabledDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByDefaultWorkspaceIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByDefaultWorkspaceIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByDefaultWorkspaceIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByDefaultWorkspaceIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByDefaultWorkspaceIdConfigAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CONFIG_ASC',
  WorkspaceByDefaultWorkspaceIdConfigDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CONFIG_DESC',
  WorkspaceByDefaultWorkspaceIdCreatedAtAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CREATED_AT_ASC',
  WorkspaceByDefaultWorkspaceIdCreatedAtDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CREATED_AT_DESC',
  WorkspaceByDefaultWorkspaceIdCustomBrandUrlAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByDefaultWorkspaceIdCustomBrandUrlDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByDefaultWorkspaceIdCustomShareLinkAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByDefaultWorkspaceIdCustomShareLinkDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByDefaultWorkspaceIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByDefaultWorkspaceIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByDefaultWorkspaceIdEmailSubjectAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByDefaultWorkspaceIdEmailSubjectDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByDefaultWorkspaceIdEmailTextAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__EMAIL_TEXT_ASC',
  WorkspaceByDefaultWorkspaceIdEmailTextDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__EMAIL_TEXT_DESC',
  WorkspaceByDefaultWorkspaceIdFirebaseIdAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__FIREBASE_ID_ASC',
  WorkspaceByDefaultWorkspaceIdFirebaseIdDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__FIREBASE_ID_DESC',
  WorkspaceByDefaultWorkspaceIdFlagsAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__FLAGS_ASC',
  WorkspaceByDefaultWorkspaceIdFlagsDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__FLAGS_DESC',
  WorkspaceByDefaultWorkspaceIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByDefaultWorkspaceIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByDefaultWorkspaceIdIdAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ID_ASC',
  WorkspaceByDefaultWorkspaceIdIdDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__ID_DESC',
  WorkspaceByDefaultWorkspaceIdIsOpenAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__IS_OPEN_ASC',
  WorkspaceByDefaultWorkspaceIdIsOpenDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__IS_OPEN_DESC',
  WorkspaceByDefaultWorkspaceIdIsVisibleAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__IS_VISIBLE_ASC',
  WorkspaceByDefaultWorkspaceIdIsVisibleDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__IS_VISIBLE_DESC',
  WorkspaceByDefaultWorkspaceIdLaserPointerPositionAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByDefaultWorkspaceIdLaserPointerPositionDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByDefaultWorkspaceIdLinkPanelPositionAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByDefaultWorkspaceIdLinkPanelPositionDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByDefaultWorkspaceIdMemberCountAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__MEMBER_COUNT_ASC',
  WorkspaceByDefaultWorkspaceIdMemberCountDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__MEMBER_COUNT_DESC',
  WorkspaceByDefaultWorkspaceIdNameAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__NAME_ASC',
  WorkspaceByDefaultWorkspaceIdNameDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__NAME_DESC',
  WorkspaceByDefaultWorkspaceIdNameLowercaseAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__NAME_LOWERCASE_ASC',
  WorkspaceByDefaultWorkspaceIdNameLowercaseDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__NAME_LOWERCASE_DESC',
  WorkspaceByDefaultWorkspaceIdParentIdAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__PARENT_ID_ASC',
  WorkspaceByDefaultWorkspaceIdParentIdDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__PARENT_ID_DESC',
  WorkspaceByDefaultWorkspaceIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByDefaultWorkspaceIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByDefaultWorkspaceIdSysPeriodAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__SYS_PERIOD_ASC',
  WorkspaceByDefaultWorkspaceIdSysPeriodDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__SYS_PERIOD_DESC',
  WorkspaceByDefaultWorkspaceIdTagsAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TAGS_ASC',
  WorkspaceByDefaultWorkspaceIdTagsDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TAGS_DESC',
  WorkspaceByDefaultWorkspaceIdTeamRankAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TEAM_RANK_ASC',
  WorkspaceByDefaultWorkspaceIdTeamRankDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TEAM_RANK_DESC',
  WorkspaceByDefaultWorkspaceIdTenantIdAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TENANT_ID_ASC',
  WorkspaceByDefaultWorkspaceIdTenantIdDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TENANT_ID_DESC',
  WorkspaceByDefaultWorkspaceIdTotalMemberCountAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByDefaultWorkspaceIdTotalMemberCountDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByDefaultWorkspaceIdUpdatedAtAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__UPDATED_AT_ASC',
  WorkspaceByDefaultWorkspaceIdUpdatedAtDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__UPDATED_AT_DESC',
  WorkspaceByDefaultWorkspaceIdUserConfigDefaultsAsc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByDefaultWorkspaceIdUserConfigDefaultsDesc = 'WORKSPACE_BY_DEFAULT_WORKSPACE_ID__USER_CONFIG_DEFAULTS_DESC',
  WorkspaceSubscriptionsByUserIdCountAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__COUNT_ASC',
  WorkspaceSubscriptionsByUserIdCountDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__COUNT_DESC',
  WorkspaceSubscriptionsByUserIdMaxCreatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_CREATED_AT_ASC',
  WorkspaceSubscriptionsByUserIdMaxCreatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_CREATED_AT_DESC',
  WorkspaceSubscriptionsByUserIdMaxCurrentStateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_CURRENT_STATE_ASC',
  WorkspaceSubscriptionsByUserIdMaxCurrentStateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_CURRENT_STATE_DESC',
  WorkspaceSubscriptionsByUserIdMaxIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_ID_ASC',
  WorkspaceSubscriptionsByUserIdMaxIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_ID_DESC',
  WorkspaceSubscriptionsByUserIdMaxIsManagedManuallyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_IS_MANAGED_MANUALLY_ASC',
  WorkspaceSubscriptionsByUserIdMaxIsManagedManuallyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_IS_MANAGED_MANUALLY_DESC',
  WorkspaceSubscriptionsByUserIdMaxIsSyncedWithExternalGroupsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  WorkspaceSubscriptionsByUserIdMaxIsSyncedWithExternalGroupsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayAdministrateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_ADMINISTRATE_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayAdministrateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_ADMINISTRATE_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayBanUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_BAN_USERS_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayBanUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_BAN_USERS_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayCreateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_CREATE_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayCreateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_CREATE_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayDecideMembershipRequestsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayDecideMembershipRequestsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayDeleteAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_DELETE_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayDeleteDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_DELETE_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayInviteUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_INVITE_USERS_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayInviteUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_INVITE_USERS_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayModifyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_MODIFY_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayModifyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_MODIFY_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayOrderLicencesForThisTeamAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayOrderLicencesForThisTeamDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayPublishAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_PUBLISH_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayPublishDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_PUBLISH_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayTestAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_TEST_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayTestDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_TEST_DESC',
  WorkspaceSubscriptionsByUserIdMaxMayViewAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_VIEW_ASC',
  WorkspaceSubscriptionsByUserIdMaxMayViewDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_MAY_VIEW_DESC',
  WorkspaceSubscriptionsByUserIdMaxSubteamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_SUBTEAM_ID_ASC',
  WorkspaceSubscriptionsByUserIdMaxSubteamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_SUBTEAM_ID_DESC',
  WorkspaceSubscriptionsByUserIdMaxSysPeriodAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_SYS_PERIOD_ASC',
  WorkspaceSubscriptionsByUserIdMaxSysPeriodDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_SYS_PERIOD_DESC',
  WorkspaceSubscriptionsByUserIdMaxTeamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_TEAM_ID_ASC',
  WorkspaceSubscriptionsByUserIdMaxTeamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_TEAM_ID_DESC',
  WorkspaceSubscriptionsByUserIdMaxUpdatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_UPDATED_AT_ASC',
  WorkspaceSubscriptionsByUserIdMaxUpdatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_UPDATED_AT_DESC',
  WorkspaceSubscriptionsByUserIdMaxUserIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_USER_ID_ASC',
  WorkspaceSubscriptionsByUserIdMaxUserIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MAX_USER_ID_DESC',
  WorkspaceSubscriptionsByUserIdMinCreatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_CREATED_AT_ASC',
  WorkspaceSubscriptionsByUserIdMinCreatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_CREATED_AT_DESC',
  WorkspaceSubscriptionsByUserIdMinCurrentStateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_CURRENT_STATE_ASC',
  WorkspaceSubscriptionsByUserIdMinCurrentStateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_CURRENT_STATE_DESC',
  WorkspaceSubscriptionsByUserIdMinIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_ID_ASC',
  WorkspaceSubscriptionsByUserIdMinIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_ID_DESC',
  WorkspaceSubscriptionsByUserIdMinIsManagedManuallyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_IS_MANAGED_MANUALLY_ASC',
  WorkspaceSubscriptionsByUserIdMinIsManagedManuallyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_IS_MANAGED_MANUALLY_DESC',
  WorkspaceSubscriptionsByUserIdMinIsSyncedWithExternalGroupsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  WorkspaceSubscriptionsByUserIdMinIsSyncedWithExternalGroupsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  WorkspaceSubscriptionsByUserIdMinMayAdministrateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_ADMINISTRATE_ASC',
  WorkspaceSubscriptionsByUserIdMinMayAdministrateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_ADMINISTRATE_DESC',
  WorkspaceSubscriptionsByUserIdMinMayBanUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_BAN_USERS_ASC',
  WorkspaceSubscriptionsByUserIdMinMayBanUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_BAN_USERS_DESC',
  WorkspaceSubscriptionsByUserIdMinMayCreateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_CREATE_ASC',
  WorkspaceSubscriptionsByUserIdMinMayCreateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_CREATE_DESC',
  WorkspaceSubscriptionsByUserIdMinMayDecideMembershipRequestsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  WorkspaceSubscriptionsByUserIdMinMayDecideMembershipRequestsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  WorkspaceSubscriptionsByUserIdMinMayDeleteAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_DELETE_ASC',
  WorkspaceSubscriptionsByUserIdMinMayDeleteDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_DELETE_DESC',
  WorkspaceSubscriptionsByUserIdMinMayInviteUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_INVITE_USERS_ASC',
  WorkspaceSubscriptionsByUserIdMinMayInviteUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_INVITE_USERS_DESC',
  WorkspaceSubscriptionsByUserIdMinMayModifyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_MODIFY_ASC',
  WorkspaceSubscriptionsByUserIdMinMayModifyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_MODIFY_DESC',
  WorkspaceSubscriptionsByUserIdMinMayOrderLicencesForThisTeamAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  WorkspaceSubscriptionsByUserIdMinMayOrderLicencesForThisTeamDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  WorkspaceSubscriptionsByUserIdMinMayPublishAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_PUBLISH_ASC',
  WorkspaceSubscriptionsByUserIdMinMayPublishDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_PUBLISH_DESC',
  WorkspaceSubscriptionsByUserIdMinMayTestAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_TEST_ASC',
  WorkspaceSubscriptionsByUserIdMinMayTestDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_TEST_DESC',
  WorkspaceSubscriptionsByUserIdMinMayViewAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_VIEW_ASC',
  WorkspaceSubscriptionsByUserIdMinMayViewDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_MAY_VIEW_DESC',
  WorkspaceSubscriptionsByUserIdMinSubteamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_SUBTEAM_ID_ASC',
  WorkspaceSubscriptionsByUserIdMinSubteamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_SUBTEAM_ID_DESC',
  WorkspaceSubscriptionsByUserIdMinSysPeriodAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_SYS_PERIOD_ASC',
  WorkspaceSubscriptionsByUserIdMinSysPeriodDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_SYS_PERIOD_DESC',
  WorkspaceSubscriptionsByUserIdMinTeamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_TEAM_ID_ASC',
  WorkspaceSubscriptionsByUserIdMinTeamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_TEAM_ID_DESC',
  WorkspaceSubscriptionsByUserIdMinUpdatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_UPDATED_AT_ASC',
  WorkspaceSubscriptionsByUserIdMinUpdatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_UPDATED_AT_DESC',
  WorkspaceSubscriptionsByUserIdMinUserIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_USER_ID_ASC',
  WorkspaceSubscriptionsByUserIdMinUserIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_USER_ID__MIN_USER_ID_DESC'
}

/** A connection to a list of `VeevaDocumentMetadatum` values. */
export type VeevaDocumentMetadataConnection = {
  __typename?: 'VeevaDocumentMetadataConnection';
  /** A list of edges which contains the `VeevaDocumentMetadatum` and cursor to aid in pagination. */
  edges: Array<VeevaDocumentMetadataEdge>;
  /** A list of `VeevaDocumentMetadatum` objects. */
  nodes: Array<Maybe<VeevaDocumentMetadatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VeevaDocumentMetadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VeevaDocumentMetadatum` edge in the connection. */
export type VeevaDocumentMetadataEdge = {
  __typename?: 'VeevaDocumentMetadataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VeevaDocumentMetadatum` at the end of the edge. */
  node?: Maybe<VeevaDocumentMetadatum>;
};

/** Methods to use when ordering `VeevaDocumentMetadatum`. */
export enum VeevaDocumentMetadataOrderBy {
  DocumentByDocumentIdConfigAsc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_ASC',
  DocumentByDocumentIdConfigDesc = 'DOCUMENT_BY_DOCUMENT_ID__CONFIG_DESC',
  DocumentByDocumentIdCreatedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_ASC',
  DocumentByDocumentIdCreatedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_AT_DESC',
  DocumentByDocumentIdCreatedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_ASC',
  DocumentByDocumentIdCreatedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__CREATED_BY_ID_DESC',
  DocumentByDocumentIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDocumentIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DOCUMENT_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDocumentIdDeletedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_ASC',
  DocumentByDocumentIdDeletedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__DELETED_AT_DESC',
  DocumentByDocumentIdDisplayDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_ASC',
  DocumentByDocumentIdDisplayDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_DATE_DESC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDocumentIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDocumentIdDisplayTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_ASC',
  DocumentByDocumentIdDisplayTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__DISPLAY_TITLE_DESC',
  DocumentByDocumentIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDocumentIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDocumentIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDocumentIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDocumentIdDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_ASC',
  DocumentByDocumentIdDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__DOWNLOAD_URL_DESC',
  DocumentByDocumentIdEnableMagicPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDocumentIdEnableMagicPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDocumentIdExpirationDateAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_ASC',
  DocumentByDocumentIdExpirationDateDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXPIRATION_DATE_DESC',
  DocumentByDocumentIdExternalIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_ASC',
  DocumentByDocumentIdExternalIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_ID_DESC',
  DocumentByDocumentIdExternalLinkIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDocumentIdExternalLinkIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDocumentIdFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_ASC',
  DocumentByDocumentIdFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_NAME_DESC',
  DocumentByDocumentIdFileSizeAsc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_ASC',
  DocumentByDocumentIdFileSizeDesc = 'DOCUMENT_BY_DOCUMENT_ID__FILE_SIZE_DESC',
  DocumentByDocumentIdFirestoreIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_ASC',
  DocumentByDocumentIdFirestoreIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__FIRESTORE_ID_DESC',
  DocumentByDocumentIdIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ID_ASC',
  DocumentByDocumentIdIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ID_DESC',
  DocumentByDocumentIdIgnoredPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_ASC',
  DocumentByDocumentIdIgnoredPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__IGNORED_PAGES_DESC',
  DocumentByDocumentIdInitialFileNameAsc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDocumentIdInitialFileNameDesc = 'DOCUMENT_BY_DOCUMENT_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDocumentIdInternalLinksAsc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_ASC',
  DocumentByDocumentIdInternalLinksDesc = 'DOCUMENT_BY_DOCUMENT_ID__INTERNAL_LINKS_DESC',
  DocumentByDocumentIdIsDownloadableAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDocumentIdIsDownloadableDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDocumentIdIsPublishedAsc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_ASC',
  DocumentByDocumentIdIsPublishedDesc = 'DOCUMENT_BY_DOCUMENT_ID__IS_PUBLISHED_DESC',
  DocumentByDocumentIdLastModifiedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDocumentIdLastModifiedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDocumentIdLastModifiedByIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDocumentIdLastModifiedByIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDocumentIdLegalAppendixIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDocumentIdLegalAppendixIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDocumentIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDocumentIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DOCUMENT_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDocumentIdLiteratureReferencesAsc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDocumentIdLiteratureReferencesDesc = 'DOCUMENT_BY_DOCUMENT_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDocumentIdMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_ASC',
  DocumentByDocumentIdMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__MIME_TYPE_DESC',
  DocumentByDocumentIdOrderAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_ASC',
  DocumentByDocumentIdOrderDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORDER_DESC',
  DocumentByDocumentIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDocumentIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDocumentIdOriginalStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDocumentIdOriginalStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDocumentIdPagesAsc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_ASC',
  DocumentByDocumentIdPagesDesc = 'DOCUMENT_BY_DOCUMENT_ID__PAGES_DESC',
  DocumentByDocumentIdStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_ASC',
  DocumentByDocumentIdStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__STORAGE_ID_DESC',
  DocumentByDocumentIdSysPeriodAsc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_ASC',
  DocumentByDocumentIdSysPeriodDesc = 'DOCUMENT_BY_DOCUMENT_ID__SYS_PERIOD_DESC',
  DocumentByDocumentIdTagsAsc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_ASC',
  DocumentByDocumentIdTagsDesc = 'DOCUMENT_BY_DOCUMENT_ID__TAGS_DESC',
  DocumentByDocumentIdTeaserTextAsc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_ASC',
  DocumentByDocumentIdTeaserTextDesc = 'DOCUMENT_BY_DOCUMENT_ID__TEASER_TEXT_DESC',
  DocumentByDocumentIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDocumentIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDocumentIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDocumentIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDocumentIdTopTitleAsc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_ASC',
  DocumentByDocumentIdTopTitleDesc = 'DOCUMENT_BY_DOCUMENT_ID__TOP_TITLE_DESC',
  DocumentByDocumentIdUploadedAtAsc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_ASC',
  DocumentByDocumentIdUploadedAtDesc = 'DOCUMENT_BY_DOCUMENT_ID__UPLOADED_AT_DESC',
  DocumentByDocumentIdWorkspaceIdAsc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_ASC',
  DocumentByDocumentIdWorkspaceIdDesc = 'DOCUMENT_BY_DOCUMENT_ID__WORKSPACE_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  DocumentNumberAsc = 'DOCUMENT_NUMBER_ASC',
  DocumentNumberDesc = 'DOCUMENT_NUMBER_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  LastCheckedAtAsc = 'LAST_CHECKED_AT_ASC',
  LastCheckedAtDesc = 'LAST_CHECKED_AT_DESC',
  MajorVersionAsc = 'MAJOR_VERSION_ASC',
  MajorVersionDesc = 'MAJOR_VERSION_DESC',
  Md5ChecksumAsc = 'MD5CHECKSUM_ASC',
  Md5ChecksumDesc = 'MD5CHECKSUM_DESC',
  MinorVersionAsc = 'MINOR_VERSION_ASC',
  MinorVersionDesc = 'MINOR_VERSION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  VeevaDocumentIdAsc = 'VEEVA_DOCUMENT_ID_ASC',
  VeevaDocumentIdDesc = 'VEEVA_DOCUMENT_ID_DESC',
  VersionCreationDateAsc = 'VERSION_CREATION_DATE_ASC',
  VersionCreationDateDesc = 'VERSION_CREATION_DATE_DESC'
}

export type VeevaDocumentMetadatum = Node & {
  __typename?: 'VeevaDocumentMetadatum';
  /** Reads a single `Document` that is related to this `VeevaDocumentMetadatum`. */
  document?: Maybe<Document>;
  documentId: Scalars['BigInt']['output'];
  documentNumber?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  lastCheckedAt?: Maybe<Scalars['Datetime']['output']>;
  majorVersion: Scalars['Int']['output'];
  md5Checksum: Scalars['String']['output'];
  minorVersion: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  sysPeriod?: Maybe<DatetimeRange>;
  veevaDocumentId: Scalars['String']['output'];
  versionCreationDate?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `VeevaDocumentMetadatum` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VeevaDocumentMetadatumCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `documentNumber` field. */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `lastCheckedAt` field. */
  lastCheckedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `majorVersion` field. */
  majorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `md5Checksum` field. */
  md5Checksum?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `minorVersion` field. */
  minorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `veevaDocumentId` field. */
  veevaDocumentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `versionCreationDate` field. */
  versionCreationDate?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `VeevaDocumentMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type VeevaDocumentMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VeevaDocumentMetadatumFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<DocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documentNumber` field. */
  documentNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `lastCheckedAt` field. */
  lastCheckedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `majorVersion` field. */
  majorVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `md5Checksum` field. */
  md5Checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `minorVersion` field. */
  minorVersion?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VeevaDocumentMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VeevaDocumentMetadatumFilter>>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `veevaDocumentId` field. */
  veevaDocumentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `versionCreationDate` field. */
  versionCreationDate?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `VeevaDocumentMetadatum` */
export type VeevaDocumentMetadatumInput = {
  documentId: Scalars['BigInt']['input'];
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  lastCheckedAt?: InputMaybe<Scalars['Datetime']['input']>;
  majorVersion?: InputMaybe<Scalars['Int']['input']>;
  md5Checksum: Scalars['String']['input'];
  minorVersion?: InputMaybe<Scalars['Int']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  veevaDocumentId: Scalars['String']['input'];
  versionCreationDate?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `VeevaDocumentMetadatum`. Fields that are set will be updated. */
export type VeevaDocumentMetadatumPatch = {
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  lastCheckedAt?: InputMaybe<Scalars['Datetime']['input']>;
  majorVersion?: InputMaybe<Scalars['Int']['input']>;
  md5Checksum?: InputMaybe<Scalars['String']['input']>;
  minorVersion?: InputMaybe<Scalars['Int']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  veevaDocumentId?: InputMaybe<Scalars['String']['input']>;
  versionCreationDate?: InputMaybe<Scalars['Datetime']['input']>;
};

/** All input for the `verifyDocumentSpaceAccessToken` mutation. */
export type VerifyDocumentSpaceAccessTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentSpaceId?: InputMaybe<Scalars['BigInt']['input']>;
  tokenCode?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `verifyDocumentSpaceAccessToken` mutation. */
export type VerifyDocumentSpaceAccessTokenPayload = {
  __typename?: 'VerifyDocumentSpaceAccessTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Workspace = Node & {
  isHcpUploadWorkspace: Scalars['Boolean']['output'];
  __typename?: 'Workspace';
  analyticsAlias: Scalars['String']['output'];
  analyticsEnabled: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Workspace`. */
  ancestors: WorkspacesConnection;
  assignIfExternalGroupsMatchAllOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignIfExternalGroupsMatchOneOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `Workspace`. */
  childWorkspaces: WorkspacesConnection;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Datetime']['output'];
  customBrandUrl?: Maybe<Scalars['String']['output']>;
  customShareLink?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `Workspace`. */
  defaultLegalAppendix?: Maybe<Document>;
  defaultLegalAppendixId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `Workspace`. */
  descendants: WorkspacesConnection;
  /** Reads and enables pagination through a set of `Document`. */
  documents: DocumentsConnection;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailText?: Maybe<Scalars['String']['output']>;
  firebaseId: Scalars['String']['output'];
  flags: Array<Maybe<Scalars['String']['output']>>;
  folders?: Maybe<Scalars['JSON']['output']>;
  hideProjectorButtonInPresentation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  isOpen: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  laserPointerPosition?: Maybe<Scalars['Int']['output']>;
  linkPanelPosition?: Maybe<Scalars['String']['output']>;
  /** Whether the current user may use interactive URL-based document import in this workspace. Requires workspace administration plus the owning tenant direct flag and upload credential; exposes no credential detail. */
  mayUseUrlBasedDocumentImport: Scalars['Boolean']['output'];
  memberCount?: Maybe<Scalars['BigInt']['output']>;
  myPrivileges?: Maybe<WorkspacePrivilege>;
  name: Scalars['String']['output'];
  nameLowercase?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  /** Reads a single `Workspace` that is related to this `Workspace`. */
  parent?: Maybe<Workspace>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `User` that is related to this `Workspace`. */
  personalWorkspaceOfUser?: Maybe<User>;
  personalWorkspaceOfUserId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Reads and enables pagination through a set of `RetentionPolicy`.
   * @deprecated Please use retentionPolicy instead
   */
  retentionPolicies: RetentionPoliciesConnection;
  /** Reads a single `RetentionPolicy` that is related to this `Workspace`. */
  retentionPolicy?: Maybe<RetentionPolicy>;
  root?: Maybe<Workspace>;
  sysPeriod: DatetimeRange;
  /** @deprecated Instead, please use `alreadyUsedTags`. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  teamRank: Scalars['Float']['output'];
  /** Reads a single `Tenant` that is related to this `Workspace`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `Tenant`. */
  tenantsByTutorialWorkspaceId: TenantsConnection;
  totalMemberCount?: Maybe<Scalars['BigInt']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userConfigDefaults: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultWorkspaceId: UsersConnection;
  /** Reads and enables pagination through a set of `WorkspaceSubscription`. */
  workspaceSubscriptionsByTeamId: WorkspaceSubscriptionsConnection;
};


export type WorkspaceAncestorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WorkspaceChildWorkspacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceCondition>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};


export type WorkspaceDescendantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceCondition>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspacesOrderBy>>;
};


export type WorkspaceDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentCondition>;
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentsOrderBy>>;
};


export type WorkspaceFoldersArgs = {
  parents?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};


export type WorkspaceMemberCountArgs = {
  sumMembersOfSubteams?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WorkspaceNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type WorkspaceRetentionPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RetentionPolicyCondition>;
  filter?: InputMaybe<RetentionPolicyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RetentionPoliciesOrderBy>>;
};


export type WorkspaceTenantsByTutorialWorkspaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantCondition>;
  filter?: InputMaybe<TenantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};


export type WorkspaceUsersByDefaultWorkspaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type WorkspaceWorkspaceSubscriptionsByTeamIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkspaceSubscriptionCondition>;
  filter?: InputMaybe<WorkspaceSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

/**
 * A condition to be used against `Workspace` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WorkspaceCondition = {
  /** Checks for equality with the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `analyticsEnabled` field. */
  analyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `assignIfExternalGroupsMatchAllOf` field. */
  assignIfExternalGroupsMatchAllOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `assignIfExternalGroupsMatchOneOf` field. */
  assignIfExternalGroupsMatchOneOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `customBrandUrl` field. */
  customBrandUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `customShareLink` field. */
  customShareLink?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultLegalAppendixId` field. */
  defaultLegalAppendixId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailText` field. */
  emailText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flags` field. */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `hideProjectorButtonInPresentation` field. */
  hideProjectorButtonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isOpen` field. */
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isVisible` field. */
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `laserPointerPosition` field. */
  laserPointerPosition?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `linkPanelPosition` field. */
  linkPanelPosition?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberCount` field. */
  memberCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nameLowercase` field. */
  nameLowercase?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `personalWorkspaceOfUserId` field. */
  personalWorkspaceOfUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `teamRank` field. */
  teamRank?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalMemberCount` field. */
  totalMemberCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userConfigDefaults` field. */
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `Workspace` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceFilter = {
  /** Filter by the object’s `analyticsAlias` field. */
  analyticsAlias?: InputMaybe<StringFilter>;
  /** Filter by the object’s `analyticsEnabled` field. */
  analyticsEnabled?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkspaceFilter>>;
  /** Filter by the object’s `assignIfExternalGroupsMatchAllOf` field. */
  assignIfExternalGroupsMatchAllOf?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `assignIfExternalGroupsMatchOneOf` field. */
  assignIfExternalGroupsMatchOneOf?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `canBeDeleted` field. */
  canBeDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `childWorkspaces` relation. */
  childWorkspaces?: InputMaybe<WorkspaceToManyWorkspaceFilter>;
  /** Some related `childWorkspaces` exist. */
  childWorkspacesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customBrandUrl` field. */
  customBrandUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `customShareLink` field. */
  customShareLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultLegalAppendix` relation. */
  defaultLegalAppendix?: InputMaybe<DocumentFilter>;
  /** A related `defaultLegalAppendix` exists. */
  defaultLegalAppendixExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `defaultLegalAppendixId` field. */
  defaultLegalAppendixId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `documents` relation. */
  documents?: InputMaybe<WorkspaceToManyDocumentFilter>;
  /** Some related `documents` exist. */
  documentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailText` field. */
  emailText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firebaseId` field. */
  firebaseId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flags` field. */
  flags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `hideProjectorButtonInPresentation` field. */
  hideProjectorButtonInPresentation?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isOpen` field. */
  isOpen?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isVisible` field. */
  isVisible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `laserPointerPosition` field. */
  laserPointerPosition?: InputMaybe<IntFilter>;
  /** Filter by the object’s `linkPanelPosition` field. */
  linkPanelPosition?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mayUseUrlBasedDocumentImport` field. */
  mayUseUrlBasedDocumentImport?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `memberCount` field. */
  memberCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameLowercase` field. */
  nameLowercase?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkspaceFilter>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<WorkspaceToManyNotificationFilter>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkspaceFilter>>;
  /** Filter by the object’s `parent` relation. */
  parent?: InputMaybe<WorkspaceFilter>;
  /** A related `parent` exists. */
  parentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `personalWorkspaceOfUser` relation. */
  personalWorkspaceOfUser?: InputMaybe<UserFilter>;
  /** A related `personalWorkspaceOfUser` exists. */
  personalWorkspaceOfUserExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `personalWorkspaceOfUserId` field. */
  personalWorkspaceOfUserId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `retentionPolicy` relation. */
  retentionPolicy?: InputMaybe<RetentionPolicyFilter>;
  /** A related `retentionPolicy` exists. */
  retentionPolicyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `teamRank` field. */
  teamRank?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `tenantsByTutorialWorkspaceId` relation. */
  tenantsByTutorialWorkspaceId?: InputMaybe<WorkspaceToManyTenantFilter>;
  /** Some related `tenantsByTutorialWorkspaceId` exist. */
  tenantsByTutorialWorkspaceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `totalMemberCount` field. */
  totalMemberCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userConfigDefaults` field. */
  userConfigDefaults?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `usersByDefaultWorkspaceId` relation. */
  usersByDefaultWorkspaceId?: InputMaybe<WorkspaceToManyUserFilter>;
  /** Some related `usersByDefaultWorkspaceId` exist. */
  usersByDefaultWorkspaceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `workspaceSubscriptionsByTeamId` relation. */
  workspaceSubscriptionsByTeamId?: InputMaybe<WorkspaceToManyWorkspaceSubscriptionFilter>;
  /** Some related `workspaceSubscriptionsByTeamId` exist. */
  workspaceSubscriptionsByTeamIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `Workspace` */
export type WorkspaceInput = {
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  analyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assignIfExternalGroupsMatchAllOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignIfExternalGroupsMatchOneOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  customBrandUrl?: InputMaybe<Scalars['String']['input']>;
  customShareLink?: InputMaybe<Scalars['String']['input']>;
  defaultLegalAppendixId?: InputMaybe<Scalars['BigInt']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideProjectorButtonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  laserPointerPosition?: InputMaybe<Scalars['Int']['input']>;
  linkPanelPosition?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameLowercase?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  personalWorkspaceOfUserId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamRank?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `Workspace`. Fields that are set will be updated. */
export type WorkspacePatch = {
  analyticsAlias?: InputMaybe<Scalars['String']['input']>;
  analyticsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assignIfExternalGroupsMatchAllOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignIfExternalGroupsMatchOneOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  customBrandUrl?: InputMaybe<Scalars['String']['input']>;
  customShareLink?: InputMaybe<Scalars['String']['input']>;
  defaultLegalAppendixId?: InputMaybe<Scalars['BigInt']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideProjectorButtonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  laserPointerPosition?: InputMaybe<Scalars['Int']['input']>;
  linkPanelPosition?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameLowercase?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  personalWorkspaceOfUserId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamRank?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userConfigDefaults?: InputMaybe<Scalars['JSON']['input']>;
};

export type WorkspacePrivilege = {
  __typename?: 'WorkspacePrivilege';
  mayAdministrate?: Maybe<Scalars['Boolean']['output']>;
  mayBanUsers?: Maybe<Scalars['Boolean']['output']>;
  mayCreate?: Maybe<Scalars['Boolean']['output']>;
  mayDecideMembershipRequests?: Maybe<Scalars['Boolean']['output']>;
  mayDelete?: Maybe<Scalars['Boolean']['output']>;
  mayInviteUsers?: Maybe<Scalars['Boolean']['output']>;
  mayModify?: Maybe<Scalars['Boolean']['output']>;
  mayOrderLicencesForThisTeam?: Maybe<Scalars['Boolean']['output']>;
  mayPublish?: Maybe<Scalars['Boolean']['output']>;
  mayTest?: Maybe<Scalars['Boolean']['output']>;
  mayView?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkspaceSubscription = Node & {
  __typename?: 'WorkspaceSubscription';
  createdAt: Scalars['Datetime']['output'];
  currentState: MembershipState;
  id: Scalars['BigInt']['output'];
  isManagedManually: Scalars['Boolean']['output'];
  isSyncedWithExternalGroups: Scalars['Boolean']['output'];
  mayAdministrate: Scalars['Boolean']['output'];
  mayBanUsers: Scalars['Boolean']['output'];
  mayCreate: Scalars['Boolean']['output'];
  mayDecideMembershipRequests: Scalars['Boolean']['output'];
  mayDelete: Scalars['Boolean']['output'];
  mayInviteUsers: Scalars['Boolean']['output'];
  mayModify: Scalars['Boolean']['output'];
  mayOrderLicencesForThisTeam: Scalars['Boolean']['output'];
  mayPublish: Scalars['Boolean']['output'];
  mayTest: Scalars['Boolean']['output'];
  mayView: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  subteamId?: Maybe<Scalars['BigInt']['output']>;
  sysPeriod: DatetimeRange;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  teamId: Scalars['BigInt']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `WorkspaceSubscription` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type WorkspaceSubscriptionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currentState` field. */
  currentState?: InputMaybe<MembershipState>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isManagedManually` field. */
  isManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isSyncedWithExternalGroups` field. */
  isSyncedWithExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayAdministrate` field. */
  mayAdministrate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayBanUsers` field. */
  mayBanUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayCreate` field. */
  mayCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayDecideMembershipRequests` field. */
  mayDecideMembershipRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayDelete` field. */
  mayDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayInviteUsers` field. */
  mayInviteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayModify` field. */
  mayModify?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayOrderLicencesForThisTeam` field. */
  mayOrderLicencesForThisTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayPublish` field. */
  mayPublish?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayTest` field. */
  mayTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mayView` field. */
  mayView?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `subteamId` field. */
  subteamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `teamId` field. */
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `WorkspaceSubscription` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceSubscriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkspaceSubscriptionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentState` field. */
  currentState?: InputMaybe<MembershipStateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isManagedManually` field. */
  isManagedManually?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSyncedWithExternalGroups` field. */
  isSyncedWithExternalGroups?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayAdministrate` field. */
  mayAdministrate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayBanUsers` field. */
  mayBanUsers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayCreate` field. */
  mayCreate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayDecideMembershipRequests` field. */
  mayDecideMembershipRequests?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayDelete` field. */
  mayDelete?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayInviteUsers` field. */
  mayInviteUsers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayModify` field. */
  mayModify?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayOrderLicencesForThisTeam` field. */
  mayOrderLicencesForThisTeam?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayPublish` field. */
  mayPublish?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayTest` field. */
  mayTest?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mayView` field. */
  mayView?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkspaceSubscriptionFilter>>;
  /** Filter by the object’s `subteam` relation. */
  subteam?: InputMaybe<TeamFilter>;
  /** A related `subteam` exists. */
  subteamExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `subteamId` field. */
  subteamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `team` relation. */
  team?: InputMaybe<WorkspaceFilter>;
  /** Filter by the object’s `teamId` field. */
  teamId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `WorkspaceSubscription` */
export type WorkspaceSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currentState: MembershipState;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedWithExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  mayAdministrate?: InputMaybe<Scalars['Boolean']['input']>;
  mayBanUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayCreate?: InputMaybe<Scalars['Boolean']['input']>;
  mayDecideMembershipRequests?: InputMaybe<Scalars['Boolean']['input']>;
  mayDelete?: InputMaybe<Scalars['Boolean']['input']>;
  mayInviteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayModify?: InputMaybe<Scalars['Boolean']['input']>;
  mayOrderLicencesForThisTeam?: InputMaybe<Scalars['Boolean']['input']>;
  mayPublish?: InputMaybe<Scalars['Boolean']['input']>;
  mayTest?: InputMaybe<Scalars['Boolean']['input']>;
  mayView?: InputMaybe<Scalars['Boolean']['input']>;
  subteamId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  teamId: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `WorkspaceSubscription`. Fields that are set will be updated. */
export type WorkspaceSubscriptionPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currentState?: InputMaybe<MembershipState>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  isManagedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedWithExternalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  mayAdministrate?: InputMaybe<Scalars['Boolean']['input']>;
  mayBanUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayCreate?: InputMaybe<Scalars['Boolean']['input']>;
  mayDecideMembershipRequests?: InputMaybe<Scalars['Boolean']['input']>;
  mayDelete?: InputMaybe<Scalars['Boolean']['input']>;
  mayInviteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  mayModify?: InputMaybe<Scalars['Boolean']['input']>;
  mayOrderLicencesForThisTeam?: InputMaybe<Scalars['Boolean']['input']>;
  mayPublish?: InputMaybe<Scalars['Boolean']['input']>;
  mayTest?: InputMaybe<Scalars['Boolean']['input']>;
  mayView?: InputMaybe<Scalars['Boolean']['input']>;
  subteamId?: InputMaybe<Scalars['BigInt']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  teamId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `WorkspaceSubscription` values. */
export type WorkspaceSubscriptionsConnection = {
  __typename?: 'WorkspaceSubscriptionsConnection';
  /** A list of edges which contains the `WorkspaceSubscription` and cursor to aid in pagination. */
  edges: Array<WorkspaceSubscriptionsEdge>;
  /** A list of `WorkspaceSubscription` objects. */
  nodes: Array<Maybe<WorkspaceSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkspaceSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorkspaceSubscription` edge in the connection. */
export type WorkspaceSubscriptionsEdge = {
  __typename?: 'WorkspaceSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkspaceSubscription` at the end of the edge. */
  node?: Maybe<WorkspaceSubscription>;
};

/** Methods to use when ordering `WorkspaceSubscription`. */
export enum WorkspaceSubscriptionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrentStateAsc = 'CURRENT_STATE_ASC',
  CurrentStateDesc = 'CURRENT_STATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsManagedManuallyAsc = 'IS_MANAGED_MANUALLY_ASC',
  IsManagedManuallyDesc = 'IS_MANAGED_MANUALLY_DESC',
  IsSyncedWithExternalGroupsAsc = 'IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  IsSyncedWithExternalGroupsDesc = 'IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  MayAdministrateAsc = 'MAY_ADMINISTRATE_ASC',
  MayAdministrateDesc = 'MAY_ADMINISTRATE_DESC',
  MayBanUsersAsc = 'MAY_BAN_USERS_ASC',
  MayBanUsersDesc = 'MAY_BAN_USERS_DESC',
  MayCreateAsc = 'MAY_CREATE_ASC',
  MayCreateDesc = 'MAY_CREATE_DESC',
  MayDecideMembershipRequestsAsc = 'MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  MayDecideMembershipRequestsDesc = 'MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  MayDeleteAsc = 'MAY_DELETE_ASC',
  MayDeleteDesc = 'MAY_DELETE_DESC',
  MayInviteUsersAsc = 'MAY_INVITE_USERS_ASC',
  MayInviteUsersDesc = 'MAY_INVITE_USERS_DESC',
  MayModifyAsc = 'MAY_MODIFY_ASC',
  MayModifyDesc = 'MAY_MODIFY_DESC',
  MayOrderLicencesForThisTeamAsc = 'MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  MayOrderLicencesForThisTeamDesc = 'MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  MayPublishAsc = 'MAY_PUBLISH_ASC',
  MayPublishDesc = 'MAY_PUBLISH_DESC',
  MayTestAsc = 'MAY_TEST_ASC',
  MayTestDesc = 'MAY_TEST_DESC',
  MayViewAsc = 'MAY_VIEW_ASC',
  MayViewDesc = 'MAY_VIEW_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubteamIdAsc = 'SUBTEAM_ID_ASC',
  SubteamIdDesc = 'SUBTEAM_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TeamBySubteamIdAnalyticsAliasAsc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ALIAS_ASC',
  TeamBySubteamIdAnalyticsAliasDesc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ALIAS_DESC',
  TeamBySubteamIdAnalyticsEnabledAsc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ENABLED_ASC',
  TeamBySubteamIdAnalyticsEnabledDesc = 'TEAM_BY_SUBTEAM_ID__ANALYTICS_ENABLED_DESC',
  TeamBySubteamIdAssignIfExternalGroupsMatchAllOfAsc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  TeamBySubteamIdAssignIfExternalGroupsMatchAllOfDesc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  TeamBySubteamIdAssignIfExternalGroupsMatchOneOfAsc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  TeamBySubteamIdAssignIfExternalGroupsMatchOneOfDesc = 'TEAM_BY_SUBTEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  TeamBySubteamIdCreatedAtAsc = 'TEAM_BY_SUBTEAM_ID__CREATED_AT_ASC',
  TeamBySubteamIdCreatedAtDesc = 'TEAM_BY_SUBTEAM_ID__CREATED_AT_DESC',
  TeamBySubteamIdFlagsAsc = 'TEAM_BY_SUBTEAM_ID__FLAGS_ASC',
  TeamBySubteamIdFlagsDesc = 'TEAM_BY_SUBTEAM_ID__FLAGS_DESC',
  TeamBySubteamIdIdAsc = 'TEAM_BY_SUBTEAM_ID__ID_ASC',
  TeamBySubteamIdIdDesc = 'TEAM_BY_SUBTEAM_ID__ID_DESC',
  TeamBySubteamIdIsOpenAsc = 'TEAM_BY_SUBTEAM_ID__IS_OPEN_ASC',
  TeamBySubteamIdIsOpenDesc = 'TEAM_BY_SUBTEAM_ID__IS_OPEN_DESC',
  TeamBySubteamIdIsVisibleAsc = 'TEAM_BY_SUBTEAM_ID__IS_VISIBLE_ASC',
  TeamBySubteamIdIsVisibleDesc = 'TEAM_BY_SUBTEAM_ID__IS_VISIBLE_DESC',
  TeamBySubteamIdMemberCountAsc = 'TEAM_BY_SUBTEAM_ID__MEMBER_COUNT_ASC',
  TeamBySubteamIdMemberCountDesc = 'TEAM_BY_SUBTEAM_ID__MEMBER_COUNT_DESC',
  TeamBySubteamIdNameAsc = 'TEAM_BY_SUBTEAM_ID__NAME_ASC',
  TeamBySubteamIdNameDesc = 'TEAM_BY_SUBTEAM_ID__NAME_DESC',
  TeamBySubteamIdNameLowercaseAsc = 'TEAM_BY_SUBTEAM_ID__NAME_LOWERCASE_ASC',
  TeamBySubteamIdNameLowercaseDesc = 'TEAM_BY_SUBTEAM_ID__NAME_LOWERCASE_DESC',
  TeamBySubteamIdSysPeriodAsc = 'TEAM_BY_SUBTEAM_ID__SYS_PERIOD_ASC',
  TeamBySubteamIdSysPeriodDesc = 'TEAM_BY_SUBTEAM_ID__SYS_PERIOD_DESC',
  TeamBySubteamIdTenantIdAsc = 'TEAM_BY_SUBTEAM_ID__TENANT_ID_ASC',
  TeamBySubteamIdTenantIdDesc = 'TEAM_BY_SUBTEAM_ID__TENANT_ID_DESC',
  TeamBySubteamIdTotalMemberCountAsc = 'TEAM_BY_SUBTEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  TeamBySubteamIdTotalMemberCountDesc = 'TEAM_BY_SUBTEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  TeamBySubteamIdUpdatedAtAsc = 'TEAM_BY_SUBTEAM_ID__UPDATED_AT_ASC',
  TeamBySubteamIdUpdatedAtDesc = 'TEAM_BY_SUBTEAM_ID__UPDATED_AT_DESC',
  TeamBySubteamIdUserConfigDefaultsAsc = 'TEAM_BY_SUBTEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  TeamBySubteamIdUserConfigDefaultsDesc = 'TEAM_BY_SUBTEAM_ID__USER_CONFIG_DEFAULTS_DESC',
  TeamIdAsc = 'TEAM_ID_ASC',
  TeamIdDesc = 'TEAM_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdAppConsentGivenAtAsc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByUserIdAppConsentGivenAtDesc = 'USER_BY_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByUserIdConfigAsc = 'USER_BY_USER_ID__CONFIG_ASC',
  UserByUserIdConfigDesc = 'USER_BY_USER_ID__CONFIG_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdCrmContactVisibilityFilterAsc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByUserIdCrmContactVisibilityFilterDesc = 'USER_BY_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByUserIdDefaultWorkspaceIdAsc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByUserIdDefaultWorkspaceIdDesc = 'USER_BY_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByUserIdDisabledAsc = 'USER_BY_USER_ID__DISABLED_ASC',
  UserByUserIdDisabledDesc = 'USER_BY_USER_ID__DISABLED_DESC',
  UserByUserIdDisplayNameAsc = 'USER_BY_USER_ID__DISPLAY_NAME_ASC',
  UserByUserIdDisplayNameDesc = 'USER_BY_USER_ID__DISPLAY_NAME_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdExternalGroupsAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByUserIdExternalGroupsDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByUserIdExternalGroupsSyncedAtAsc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByUserIdExternalGroupsSyncedAtDesc = 'USER_BY_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByUserIdFirebaseAuthIdAsc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByUserIdFirebaseAuthIdDesc = 'USER_BY_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByUserIdFlagsAsc = 'USER_BY_USER_ID__FLAGS_ASC',
  UserByUserIdFlagsDesc = 'USER_BY_USER_ID__FLAGS_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsTenantAdminAsc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByUserIdIsTenantAdminDesc = 'USER_BY_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByUserIdRegisteredAtAsc = 'USER_BY_USER_ID__REGISTERED_AT_ASC',
  UserByUserIdRegisteredAtDesc = 'USER_BY_USER_ID__REGISTERED_AT_DESC',
  UserByUserIdSysPeriodAsc = 'USER_BY_USER_ID__SYS_PERIOD_ASC',
  UserByUserIdSysPeriodDesc = 'USER_BY_USER_ID__SYS_PERIOD_DESC',
  UserByUserIdTenantIdAsc = 'USER_BY_USER_ID__TENANT_ID_ASC',
  UserByUserIdTenantIdDesc = 'USER_BY_USER_ID__TENANT_ID_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  WorkspaceByTeamIdAnalyticsAliasAsc = 'WORKSPACE_BY_TEAM_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByTeamIdAnalyticsAliasDesc = 'WORKSPACE_BY_TEAM_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByTeamIdAnalyticsEnabledAsc = 'WORKSPACE_BY_TEAM_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByTeamIdAnalyticsEnabledDesc = 'WORKSPACE_BY_TEAM_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByTeamIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByTeamIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByTeamIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByTeamIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_TEAM_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByTeamIdConfigAsc = 'WORKSPACE_BY_TEAM_ID__CONFIG_ASC',
  WorkspaceByTeamIdConfigDesc = 'WORKSPACE_BY_TEAM_ID__CONFIG_DESC',
  WorkspaceByTeamIdCreatedAtAsc = 'WORKSPACE_BY_TEAM_ID__CREATED_AT_ASC',
  WorkspaceByTeamIdCreatedAtDesc = 'WORKSPACE_BY_TEAM_ID__CREATED_AT_DESC',
  WorkspaceByTeamIdCustomBrandUrlAsc = 'WORKSPACE_BY_TEAM_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByTeamIdCustomBrandUrlDesc = 'WORKSPACE_BY_TEAM_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByTeamIdCustomShareLinkAsc = 'WORKSPACE_BY_TEAM_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByTeamIdCustomShareLinkDesc = 'WORKSPACE_BY_TEAM_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByTeamIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_TEAM_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByTeamIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_TEAM_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByTeamIdEmailSubjectAsc = 'WORKSPACE_BY_TEAM_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByTeamIdEmailSubjectDesc = 'WORKSPACE_BY_TEAM_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByTeamIdEmailTextAsc = 'WORKSPACE_BY_TEAM_ID__EMAIL_TEXT_ASC',
  WorkspaceByTeamIdEmailTextDesc = 'WORKSPACE_BY_TEAM_ID__EMAIL_TEXT_DESC',
  WorkspaceByTeamIdFirebaseIdAsc = 'WORKSPACE_BY_TEAM_ID__FIREBASE_ID_ASC',
  WorkspaceByTeamIdFirebaseIdDesc = 'WORKSPACE_BY_TEAM_ID__FIREBASE_ID_DESC',
  WorkspaceByTeamIdFlagsAsc = 'WORKSPACE_BY_TEAM_ID__FLAGS_ASC',
  WorkspaceByTeamIdFlagsDesc = 'WORKSPACE_BY_TEAM_ID__FLAGS_DESC',
  WorkspaceByTeamIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_TEAM_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByTeamIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_TEAM_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByTeamIdIdAsc = 'WORKSPACE_BY_TEAM_ID__ID_ASC',
  WorkspaceByTeamIdIdDesc = 'WORKSPACE_BY_TEAM_ID__ID_DESC',
  WorkspaceByTeamIdIsOpenAsc = 'WORKSPACE_BY_TEAM_ID__IS_OPEN_ASC',
  WorkspaceByTeamIdIsOpenDesc = 'WORKSPACE_BY_TEAM_ID__IS_OPEN_DESC',
  WorkspaceByTeamIdIsVisibleAsc = 'WORKSPACE_BY_TEAM_ID__IS_VISIBLE_ASC',
  WorkspaceByTeamIdIsVisibleDesc = 'WORKSPACE_BY_TEAM_ID__IS_VISIBLE_DESC',
  WorkspaceByTeamIdLaserPointerPositionAsc = 'WORKSPACE_BY_TEAM_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByTeamIdLaserPointerPositionDesc = 'WORKSPACE_BY_TEAM_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByTeamIdLinkPanelPositionAsc = 'WORKSPACE_BY_TEAM_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByTeamIdLinkPanelPositionDesc = 'WORKSPACE_BY_TEAM_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByTeamIdMemberCountAsc = 'WORKSPACE_BY_TEAM_ID__MEMBER_COUNT_ASC',
  WorkspaceByTeamIdMemberCountDesc = 'WORKSPACE_BY_TEAM_ID__MEMBER_COUNT_DESC',
  WorkspaceByTeamIdNameAsc = 'WORKSPACE_BY_TEAM_ID__NAME_ASC',
  WorkspaceByTeamIdNameDesc = 'WORKSPACE_BY_TEAM_ID__NAME_DESC',
  WorkspaceByTeamIdNameLowercaseAsc = 'WORKSPACE_BY_TEAM_ID__NAME_LOWERCASE_ASC',
  WorkspaceByTeamIdNameLowercaseDesc = 'WORKSPACE_BY_TEAM_ID__NAME_LOWERCASE_DESC',
  WorkspaceByTeamIdParentIdAsc = 'WORKSPACE_BY_TEAM_ID__PARENT_ID_ASC',
  WorkspaceByTeamIdParentIdDesc = 'WORKSPACE_BY_TEAM_ID__PARENT_ID_DESC',
  WorkspaceByTeamIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_TEAM_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByTeamIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_TEAM_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByTeamIdSysPeriodAsc = 'WORKSPACE_BY_TEAM_ID__SYS_PERIOD_ASC',
  WorkspaceByTeamIdSysPeriodDesc = 'WORKSPACE_BY_TEAM_ID__SYS_PERIOD_DESC',
  WorkspaceByTeamIdTagsAsc = 'WORKSPACE_BY_TEAM_ID__TAGS_ASC',
  WorkspaceByTeamIdTagsDesc = 'WORKSPACE_BY_TEAM_ID__TAGS_DESC',
  WorkspaceByTeamIdTeamRankAsc = 'WORKSPACE_BY_TEAM_ID__TEAM_RANK_ASC',
  WorkspaceByTeamIdTeamRankDesc = 'WORKSPACE_BY_TEAM_ID__TEAM_RANK_DESC',
  WorkspaceByTeamIdTenantIdAsc = 'WORKSPACE_BY_TEAM_ID__TENANT_ID_ASC',
  WorkspaceByTeamIdTenantIdDesc = 'WORKSPACE_BY_TEAM_ID__TENANT_ID_DESC',
  WorkspaceByTeamIdTotalMemberCountAsc = 'WORKSPACE_BY_TEAM_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByTeamIdTotalMemberCountDesc = 'WORKSPACE_BY_TEAM_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByTeamIdUpdatedAtAsc = 'WORKSPACE_BY_TEAM_ID__UPDATED_AT_ASC',
  WorkspaceByTeamIdUpdatedAtDesc = 'WORKSPACE_BY_TEAM_ID__UPDATED_AT_DESC',
  WorkspaceByTeamIdUserConfigDefaultsAsc = 'WORKSPACE_BY_TEAM_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByTeamIdUserConfigDefaultsDesc = 'WORKSPACE_BY_TEAM_ID__USER_CONFIG_DEFAULTS_DESC'
}

/** A filter to be used against many `Document` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceToManyDocumentFilter = {
  /** Every related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFilter>;
  /** No related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFilter>;
  /** Some related `Document` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `Tenant` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceToManyTenantFilter = {
  /** Every related `Tenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantFilter>;
  /** No related `Tenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantFilter>;
  /** Some related `Tenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantFilter>;
};

/** A filter to be used against many `User` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceToManyUserFilter = {
  /** Every related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserFilter>;
  /** No related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserFilter>;
  /** Some related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserFilter>;
};

/** A filter to be used against many `Workspace` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceToManyWorkspaceFilter = {
  /** Every related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceFilter>;
  /** No related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceFilter>;
  /** Some related `Workspace` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceFilter>;
};

/** A filter to be used against many `WorkspaceSubscription` object types. All fields are combined with a logical ‘and.’ */
export type WorkspaceToManyWorkspaceSubscriptionFilter = {
  /** Every related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** No related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkspaceSubscriptionFilter>;
  /** Some related `WorkspaceSubscription` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkspaceSubscriptionFilter>;
};

/** A connection to a list of `Workspace` values. */
export type WorkspacesConnection = {
  __typename?: 'WorkspacesConnection';
  /** A list of edges which contains the `Workspace` and cursor to aid in pagination. */
  edges: Array<WorkspacesEdge>;
  /** A list of `Workspace` objects. */
  nodes: Array<Maybe<Workspace>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Workspace` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Workspace` edge in the connection. */
export type WorkspacesEdge = {
  __typename?: 'WorkspacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Workspace` at the end of the edge. */
  node?: Maybe<Workspace>;
};

/** Methods to use when ordering `Workspace`. */
export enum WorkspacesOrderBy {
  AnalyticsAliasAsc = 'ANALYTICS_ALIAS_ASC',
  AnalyticsAliasDesc = 'ANALYTICS_ALIAS_DESC',
  AnalyticsEnabledAsc = 'ANALYTICS_ENABLED_ASC',
  AnalyticsEnabledDesc = 'ANALYTICS_ENABLED_DESC',
  AssignIfExternalGroupsMatchAllOfAsc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  AssignIfExternalGroupsMatchAllOfDesc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  AssignIfExternalGroupsMatchOneOfAsc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  AssignIfExternalGroupsMatchOneOfDesc = 'ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  ConfigAsc = 'CONFIG_ASC',
  ConfigDesc = 'CONFIG_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomBrandUrlAsc = 'CUSTOM_BRAND_URL_ASC',
  CustomBrandUrlDesc = 'CUSTOM_BRAND_URL_DESC',
  CustomShareLinkAsc = 'CUSTOM_SHARE_LINK_ASC',
  CustomShareLinkDesc = 'CUSTOM_SHARE_LINK_DESC',
  DefaultLegalAppendixIdAsc = 'DEFAULT_LEGAL_APPENDIX_ID_ASC',
  DefaultLegalAppendixIdDesc = 'DEFAULT_LEGAL_APPENDIX_ID_DESC',
  DocumentsByWorkspaceIdCountAsc = 'DOCUMENTS_BY_WORKSPACE_ID__COUNT_ASC',
  DocumentsByWorkspaceIdCountDesc = 'DOCUMENTS_BY_WORKSPACE_ID__COUNT_DESC',
  DocumentsByWorkspaceIdMaxConfigAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CONFIG_ASC',
  DocumentsByWorkspaceIdMaxConfigDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CONFIG_DESC',
  DocumentsByWorkspaceIdMaxCreatedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CREATED_AT_ASC',
  DocumentsByWorkspaceIdMaxCreatedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CREATED_AT_DESC',
  DocumentsByWorkspaceIdMaxCreatedByIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CREATED_BY_ID_ASC',
  DocumentsByWorkspaceIdMaxCreatedByIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CREATED_BY_ID_DESC',
  DocumentsByWorkspaceIdMaxCurrentRevisionNumberAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByWorkspaceIdMaxCurrentRevisionNumberDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByWorkspaceIdMaxDeletedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DELETED_AT_ASC',
  DocumentsByWorkspaceIdMaxDeletedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DELETED_AT_DESC',
  DocumentsByWorkspaceIdMaxDisplayDateAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DISPLAY_DATE_ASC',
  DocumentsByWorkspaceIdMaxDisplayDateDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DISPLAY_DATE_DESC',
  DocumentsByWorkspaceIdMaxDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByWorkspaceIdMaxDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByWorkspaceIdMaxDisplayTitleAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DISPLAY_TITLE_ASC',
  DocumentsByWorkspaceIdMaxDisplayTitleDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DISPLAY_TITLE_DESC',
  DocumentsByWorkspaceIdMaxDoesSupportFlowsAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByWorkspaceIdMaxDoesSupportFlowsDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByWorkspaceIdMaxDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByWorkspaceIdMaxDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByWorkspaceIdMaxDownloadUrlAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DOWNLOAD_URL_ASC',
  DocumentsByWorkspaceIdMaxDownloadUrlDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_DOWNLOAD_URL_DESC',
  DocumentsByWorkspaceIdMaxEnableMagicPagesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByWorkspaceIdMaxEnableMagicPagesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByWorkspaceIdMaxExpirationDateAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_EXPIRATION_DATE_ASC',
  DocumentsByWorkspaceIdMaxExpirationDateDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_EXPIRATION_DATE_DESC',
  DocumentsByWorkspaceIdMaxExternalIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_EXTERNAL_ID_ASC',
  DocumentsByWorkspaceIdMaxExternalIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_EXTERNAL_ID_DESC',
  DocumentsByWorkspaceIdMaxExternalLinkIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_EXTERNAL_LINK_ID_ASC',
  DocumentsByWorkspaceIdMaxExternalLinkIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_EXTERNAL_LINK_ID_DESC',
  DocumentsByWorkspaceIdMaxFileNameAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_FILE_NAME_ASC',
  DocumentsByWorkspaceIdMaxFileNameDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_FILE_NAME_DESC',
  DocumentsByWorkspaceIdMaxFileSizeAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_FILE_SIZE_ASC',
  DocumentsByWorkspaceIdMaxFileSizeDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_FILE_SIZE_DESC',
  DocumentsByWorkspaceIdMaxFirestoreIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_FIRESTORE_ID_ASC',
  DocumentsByWorkspaceIdMaxFirestoreIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_FIRESTORE_ID_DESC',
  DocumentsByWorkspaceIdMaxIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ID_ASC',
  DocumentsByWorkspaceIdMaxIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ID_DESC',
  DocumentsByWorkspaceIdMaxIgnoredPagesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_IGNORED_PAGES_ASC',
  DocumentsByWorkspaceIdMaxIgnoredPagesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_IGNORED_PAGES_DESC',
  DocumentsByWorkspaceIdMaxInitialFileNameAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_INITIAL_FILE_NAME_ASC',
  DocumentsByWorkspaceIdMaxInitialFileNameDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_INITIAL_FILE_NAME_DESC',
  DocumentsByWorkspaceIdMaxInternalLinksAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_INTERNAL_LINKS_ASC',
  DocumentsByWorkspaceIdMaxInternalLinksDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_INTERNAL_LINKS_DESC',
  DocumentsByWorkspaceIdMaxIsDownloadableAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_IS_DOWNLOADABLE_ASC',
  DocumentsByWorkspaceIdMaxIsDownloadableDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_IS_DOWNLOADABLE_DESC',
  DocumentsByWorkspaceIdMaxIsPublishedAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_IS_PUBLISHED_ASC',
  DocumentsByWorkspaceIdMaxIsPublishedDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_IS_PUBLISHED_DESC',
  DocumentsByWorkspaceIdMaxLastModifiedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LAST_MODIFIED_AT_ASC',
  DocumentsByWorkspaceIdMaxLastModifiedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LAST_MODIFIED_AT_DESC',
  DocumentsByWorkspaceIdMaxLastModifiedByIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByWorkspaceIdMaxLastModifiedByIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByWorkspaceIdMaxLegalAppendixIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LEGAL_APPENDIX_ID_ASC',
  DocumentsByWorkspaceIdMaxLegalAppendixIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LEGAL_APPENDIX_ID_DESC',
  DocumentsByWorkspaceIdMaxLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByWorkspaceIdMaxLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByWorkspaceIdMaxLiteratureReferencesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LITERATURE_REFERENCES_ASC',
  DocumentsByWorkspaceIdMaxLiteratureReferencesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_LITERATURE_REFERENCES_DESC',
  DocumentsByWorkspaceIdMaxMimeTypeAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_MIME_TYPE_ASC',
  DocumentsByWorkspaceIdMaxMimeTypeDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_MIME_TYPE_DESC',
  DocumentsByWorkspaceIdMaxOrderAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORDER_ASC',
  DocumentsByWorkspaceIdMaxOrderDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORDER_DESC',
  DocumentsByWorkspaceIdMaxOriginalDownloadUrlAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByWorkspaceIdMaxOriginalDownloadUrlDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByWorkspaceIdMaxOriginalMimeTypeAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByWorkspaceIdMaxOriginalMimeTypeDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByWorkspaceIdMaxOriginalStorageIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByWorkspaceIdMaxOriginalStorageIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByWorkspaceIdMaxPagesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_PAGES_ASC',
  DocumentsByWorkspaceIdMaxPagesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_PAGES_DESC',
  DocumentsByWorkspaceIdMaxStorageIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_STORAGE_ID_ASC',
  DocumentsByWorkspaceIdMaxStorageIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_STORAGE_ID_DESC',
  DocumentsByWorkspaceIdMaxSysPeriodAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_SYS_PERIOD_ASC',
  DocumentsByWorkspaceIdMaxSysPeriodDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_SYS_PERIOD_DESC',
  DocumentsByWorkspaceIdMaxTagsAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_TAGS_ASC',
  DocumentsByWorkspaceIdMaxTagsDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_TAGS_DESC',
  DocumentsByWorkspaceIdMaxTeaserTextAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_TEASER_TEXT_ASC',
  DocumentsByWorkspaceIdMaxTeaserTextDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_TEASER_TEXT_DESC',
  DocumentsByWorkspaceIdMaxThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByWorkspaceIdMaxThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByWorkspaceIdMaxThumbnailStorageIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByWorkspaceIdMaxThumbnailStorageIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByWorkspaceIdMaxTopTitleAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_TOP_TITLE_ASC',
  DocumentsByWorkspaceIdMaxTopTitleDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_TOP_TITLE_DESC',
  DocumentsByWorkspaceIdMaxUploadedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_UPLOADED_AT_ASC',
  DocumentsByWorkspaceIdMaxUploadedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_UPLOADED_AT_DESC',
  DocumentsByWorkspaceIdMaxWorkspaceIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_WORKSPACE_ID_ASC',
  DocumentsByWorkspaceIdMaxWorkspaceIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MAX_WORKSPACE_ID_DESC',
  DocumentsByWorkspaceIdMinConfigAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CONFIG_ASC',
  DocumentsByWorkspaceIdMinConfigDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CONFIG_DESC',
  DocumentsByWorkspaceIdMinCreatedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CREATED_AT_ASC',
  DocumentsByWorkspaceIdMinCreatedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CREATED_AT_DESC',
  DocumentsByWorkspaceIdMinCreatedByIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CREATED_BY_ID_ASC',
  DocumentsByWorkspaceIdMinCreatedByIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CREATED_BY_ID_DESC',
  DocumentsByWorkspaceIdMinCurrentRevisionNumberAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CURRENT_REVISION_NUMBER_ASC',
  DocumentsByWorkspaceIdMinCurrentRevisionNumberDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_CURRENT_REVISION_NUMBER_DESC',
  DocumentsByWorkspaceIdMinDeletedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DELETED_AT_ASC',
  DocumentsByWorkspaceIdMinDeletedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DELETED_AT_DESC',
  DocumentsByWorkspaceIdMinDisplayDateAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DISPLAY_DATE_ASC',
  DocumentsByWorkspaceIdMinDisplayDateDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DISPLAY_DATE_DESC',
  DocumentsByWorkspaceIdMinDisplayTeaserTextInSpaceAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentsByWorkspaceIdMinDisplayTeaserTextInSpaceDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentsByWorkspaceIdMinDisplayTitleAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DISPLAY_TITLE_ASC',
  DocumentsByWorkspaceIdMinDisplayTitleDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DISPLAY_TITLE_DESC',
  DocumentsByWorkspaceIdMinDoesSupportFlowsAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DOES_SUPPORT_FLOWS_ASC',
  DocumentsByWorkspaceIdMinDoesSupportFlowsDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DOES_SUPPORT_FLOWS_DESC',
  DocumentsByWorkspaceIdMinDoesSupportSharedspaceAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentsByWorkspaceIdMinDoesSupportSharedspaceDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentsByWorkspaceIdMinDownloadUrlAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DOWNLOAD_URL_ASC',
  DocumentsByWorkspaceIdMinDownloadUrlDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_DOWNLOAD_URL_DESC',
  DocumentsByWorkspaceIdMinEnableMagicPagesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ENABLE_MAGIC_PAGES_ASC',
  DocumentsByWorkspaceIdMinEnableMagicPagesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ENABLE_MAGIC_PAGES_DESC',
  DocumentsByWorkspaceIdMinExpirationDateAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_EXPIRATION_DATE_ASC',
  DocumentsByWorkspaceIdMinExpirationDateDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_EXPIRATION_DATE_DESC',
  DocumentsByWorkspaceIdMinExternalIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_EXTERNAL_ID_ASC',
  DocumentsByWorkspaceIdMinExternalIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_EXTERNAL_ID_DESC',
  DocumentsByWorkspaceIdMinExternalLinkIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_EXTERNAL_LINK_ID_ASC',
  DocumentsByWorkspaceIdMinExternalLinkIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_EXTERNAL_LINK_ID_DESC',
  DocumentsByWorkspaceIdMinFileNameAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_FILE_NAME_ASC',
  DocumentsByWorkspaceIdMinFileNameDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_FILE_NAME_DESC',
  DocumentsByWorkspaceIdMinFileSizeAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_FILE_SIZE_ASC',
  DocumentsByWorkspaceIdMinFileSizeDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_FILE_SIZE_DESC',
  DocumentsByWorkspaceIdMinFirestoreIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_FIRESTORE_ID_ASC',
  DocumentsByWorkspaceIdMinFirestoreIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_FIRESTORE_ID_DESC',
  DocumentsByWorkspaceIdMinIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ID_ASC',
  DocumentsByWorkspaceIdMinIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ID_DESC',
  DocumentsByWorkspaceIdMinIgnoredPagesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_IGNORED_PAGES_ASC',
  DocumentsByWorkspaceIdMinIgnoredPagesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_IGNORED_PAGES_DESC',
  DocumentsByWorkspaceIdMinInitialFileNameAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_INITIAL_FILE_NAME_ASC',
  DocumentsByWorkspaceIdMinInitialFileNameDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_INITIAL_FILE_NAME_DESC',
  DocumentsByWorkspaceIdMinInternalLinksAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_INTERNAL_LINKS_ASC',
  DocumentsByWorkspaceIdMinInternalLinksDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_INTERNAL_LINKS_DESC',
  DocumentsByWorkspaceIdMinIsDownloadableAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_IS_DOWNLOADABLE_ASC',
  DocumentsByWorkspaceIdMinIsDownloadableDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_IS_DOWNLOADABLE_DESC',
  DocumentsByWorkspaceIdMinIsPublishedAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_IS_PUBLISHED_ASC',
  DocumentsByWorkspaceIdMinIsPublishedDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_IS_PUBLISHED_DESC',
  DocumentsByWorkspaceIdMinLastModifiedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LAST_MODIFIED_AT_ASC',
  DocumentsByWorkspaceIdMinLastModifiedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LAST_MODIFIED_AT_DESC',
  DocumentsByWorkspaceIdMinLastModifiedByIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LAST_MODIFIED_BY_ID_ASC',
  DocumentsByWorkspaceIdMinLastModifiedByIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LAST_MODIFIED_BY_ID_DESC',
  DocumentsByWorkspaceIdMinLegalAppendixIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LEGAL_APPENDIX_ID_ASC',
  DocumentsByWorkspaceIdMinLegalAppendixIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LEGAL_APPENDIX_ID_DESC',
  DocumentsByWorkspaceIdMinLinksCanBeClickedByViewerAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentsByWorkspaceIdMinLinksCanBeClickedByViewerDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentsByWorkspaceIdMinLiteratureReferencesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LITERATURE_REFERENCES_ASC',
  DocumentsByWorkspaceIdMinLiteratureReferencesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_LITERATURE_REFERENCES_DESC',
  DocumentsByWorkspaceIdMinMimeTypeAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_MIME_TYPE_ASC',
  DocumentsByWorkspaceIdMinMimeTypeDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_MIME_TYPE_DESC',
  DocumentsByWorkspaceIdMinOrderAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORDER_ASC',
  DocumentsByWorkspaceIdMinOrderDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORDER_DESC',
  DocumentsByWorkspaceIdMinOriginalDownloadUrlAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentsByWorkspaceIdMinOriginalDownloadUrlDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentsByWorkspaceIdMinOriginalMimeTypeAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORIGINAL_MIME_TYPE_ASC',
  DocumentsByWorkspaceIdMinOriginalMimeTypeDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORIGINAL_MIME_TYPE_DESC',
  DocumentsByWorkspaceIdMinOriginalStorageIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORIGINAL_STORAGE_ID_ASC',
  DocumentsByWorkspaceIdMinOriginalStorageIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_ORIGINAL_STORAGE_ID_DESC',
  DocumentsByWorkspaceIdMinPagesAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_PAGES_ASC',
  DocumentsByWorkspaceIdMinPagesDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_PAGES_DESC',
  DocumentsByWorkspaceIdMinStorageIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_STORAGE_ID_ASC',
  DocumentsByWorkspaceIdMinStorageIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_STORAGE_ID_DESC',
  DocumentsByWorkspaceIdMinSysPeriodAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_SYS_PERIOD_ASC',
  DocumentsByWorkspaceIdMinSysPeriodDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_SYS_PERIOD_DESC',
  DocumentsByWorkspaceIdMinTagsAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_TAGS_ASC',
  DocumentsByWorkspaceIdMinTagsDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_TAGS_DESC',
  DocumentsByWorkspaceIdMinTeaserTextAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_TEASER_TEXT_ASC',
  DocumentsByWorkspaceIdMinTeaserTextDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_TEASER_TEXT_DESC',
  DocumentsByWorkspaceIdMinThumbnailDownloadUrlAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentsByWorkspaceIdMinThumbnailDownloadUrlDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentsByWorkspaceIdMinThumbnailStorageIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_THUMBNAIL_STORAGE_ID_ASC',
  DocumentsByWorkspaceIdMinThumbnailStorageIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_THUMBNAIL_STORAGE_ID_DESC',
  DocumentsByWorkspaceIdMinTopTitleAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_TOP_TITLE_ASC',
  DocumentsByWorkspaceIdMinTopTitleDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_TOP_TITLE_DESC',
  DocumentsByWorkspaceIdMinUploadedAtAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_UPLOADED_AT_ASC',
  DocumentsByWorkspaceIdMinUploadedAtDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_UPLOADED_AT_DESC',
  DocumentsByWorkspaceIdMinWorkspaceIdAsc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_WORKSPACE_ID_ASC',
  DocumentsByWorkspaceIdMinWorkspaceIdDesc = 'DOCUMENTS_BY_WORKSPACE_ID__MIN_WORKSPACE_ID_DESC',
  DocumentByDefaultLegalAppendixIdConfigAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CONFIG_ASC',
  DocumentByDefaultLegalAppendixIdConfigDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CONFIG_DESC',
  DocumentByDefaultLegalAppendixIdCreatedAtAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CREATED_AT_ASC',
  DocumentByDefaultLegalAppendixIdCreatedAtDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CREATED_AT_DESC',
  DocumentByDefaultLegalAppendixIdCreatedByIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CREATED_BY_ID_ASC',
  DocumentByDefaultLegalAppendixIdCreatedByIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CREATED_BY_ID_DESC',
  DocumentByDefaultLegalAppendixIdCurrentRevisionNumberAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CURRENT_REVISION_NUMBER_ASC',
  DocumentByDefaultLegalAppendixIdCurrentRevisionNumberDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__CURRENT_REVISION_NUMBER_DESC',
  DocumentByDefaultLegalAppendixIdDeletedAtAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DELETED_AT_ASC',
  DocumentByDefaultLegalAppendixIdDeletedAtDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DELETED_AT_DESC',
  DocumentByDefaultLegalAppendixIdDisplayDateAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DISPLAY_DATE_ASC',
  DocumentByDefaultLegalAppendixIdDisplayDateDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DISPLAY_DATE_DESC',
  DocumentByDefaultLegalAppendixIdDisplayTeaserTextInSpaceAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DISPLAY_TEASER_TEXT_IN_SPACE_ASC',
  DocumentByDefaultLegalAppendixIdDisplayTeaserTextInSpaceDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DISPLAY_TEASER_TEXT_IN_SPACE_DESC',
  DocumentByDefaultLegalAppendixIdDisplayTitleAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DISPLAY_TITLE_ASC',
  DocumentByDefaultLegalAppendixIdDisplayTitleDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DISPLAY_TITLE_DESC',
  DocumentByDefaultLegalAppendixIdDoesSupportFlowsAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DOES_SUPPORT_FLOWS_ASC',
  DocumentByDefaultLegalAppendixIdDoesSupportFlowsDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DOES_SUPPORT_FLOWS_DESC',
  DocumentByDefaultLegalAppendixIdDoesSupportSharedspaceAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DOES_SUPPORT_SHAREDSPACE_ASC',
  DocumentByDefaultLegalAppendixIdDoesSupportSharedspaceDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DOES_SUPPORT_SHAREDSPACE_DESC',
  DocumentByDefaultLegalAppendixIdDownloadUrlAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DOWNLOAD_URL_ASC',
  DocumentByDefaultLegalAppendixIdDownloadUrlDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__DOWNLOAD_URL_DESC',
  DocumentByDefaultLegalAppendixIdEnableMagicPagesAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ENABLE_MAGIC_PAGES_ASC',
  DocumentByDefaultLegalAppendixIdEnableMagicPagesDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ENABLE_MAGIC_PAGES_DESC',
  DocumentByDefaultLegalAppendixIdExpirationDateAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__EXPIRATION_DATE_ASC',
  DocumentByDefaultLegalAppendixIdExpirationDateDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__EXPIRATION_DATE_DESC',
  DocumentByDefaultLegalAppendixIdExternalIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__EXTERNAL_ID_ASC',
  DocumentByDefaultLegalAppendixIdExternalIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__EXTERNAL_ID_DESC',
  DocumentByDefaultLegalAppendixIdExternalLinkIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__EXTERNAL_LINK_ID_ASC',
  DocumentByDefaultLegalAppendixIdExternalLinkIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__EXTERNAL_LINK_ID_DESC',
  DocumentByDefaultLegalAppendixIdFileNameAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__FILE_NAME_ASC',
  DocumentByDefaultLegalAppendixIdFileNameDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__FILE_NAME_DESC',
  DocumentByDefaultLegalAppendixIdFileSizeAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__FILE_SIZE_ASC',
  DocumentByDefaultLegalAppendixIdFileSizeDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__FILE_SIZE_DESC',
  DocumentByDefaultLegalAppendixIdFirestoreIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__FIRESTORE_ID_ASC',
  DocumentByDefaultLegalAppendixIdFirestoreIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__FIRESTORE_ID_DESC',
  DocumentByDefaultLegalAppendixIdIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ID_ASC',
  DocumentByDefaultLegalAppendixIdIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ID_DESC',
  DocumentByDefaultLegalAppendixIdIgnoredPagesAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__IGNORED_PAGES_ASC',
  DocumentByDefaultLegalAppendixIdIgnoredPagesDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__IGNORED_PAGES_DESC',
  DocumentByDefaultLegalAppendixIdInitialFileNameAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__INITIAL_FILE_NAME_ASC',
  DocumentByDefaultLegalAppendixIdInitialFileNameDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__INITIAL_FILE_NAME_DESC',
  DocumentByDefaultLegalAppendixIdInternalLinksAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__INTERNAL_LINKS_ASC',
  DocumentByDefaultLegalAppendixIdInternalLinksDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__INTERNAL_LINKS_DESC',
  DocumentByDefaultLegalAppendixIdIsDownloadableAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__IS_DOWNLOADABLE_ASC',
  DocumentByDefaultLegalAppendixIdIsDownloadableDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__IS_DOWNLOADABLE_DESC',
  DocumentByDefaultLegalAppendixIdIsPublishedAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__IS_PUBLISHED_ASC',
  DocumentByDefaultLegalAppendixIdIsPublishedDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__IS_PUBLISHED_DESC',
  DocumentByDefaultLegalAppendixIdLastModifiedAtAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LAST_MODIFIED_AT_ASC',
  DocumentByDefaultLegalAppendixIdLastModifiedAtDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LAST_MODIFIED_AT_DESC',
  DocumentByDefaultLegalAppendixIdLastModifiedByIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LAST_MODIFIED_BY_ID_ASC',
  DocumentByDefaultLegalAppendixIdLastModifiedByIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LAST_MODIFIED_BY_ID_DESC',
  DocumentByDefaultLegalAppendixIdLegalAppendixIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LEGAL_APPENDIX_ID_ASC',
  DocumentByDefaultLegalAppendixIdLegalAppendixIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LEGAL_APPENDIX_ID_DESC',
  DocumentByDefaultLegalAppendixIdLinksCanBeClickedByViewerAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_ASC',
  DocumentByDefaultLegalAppendixIdLinksCanBeClickedByViewerDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LINKS_CAN_BE_CLICKED_BY_VIEWER_DESC',
  DocumentByDefaultLegalAppendixIdLiteratureReferencesAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LITERATURE_REFERENCES_ASC',
  DocumentByDefaultLegalAppendixIdLiteratureReferencesDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__LITERATURE_REFERENCES_DESC',
  DocumentByDefaultLegalAppendixIdMimeTypeAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__MIME_TYPE_ASC',
  DocumentByDefaultLegalAppendixIdMimeTypeDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__MIME_TYPE_DESC',
  DocumentByDefaultLegalAppendixIdOrderAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORDER_ASC',
  DocumentByDefaultLegalAppendixIdOrderDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORDER_DESC',
  DocumentByDefaultLegalAppendixIdOriginalDownloadUrlAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORIGINAL_DOWNLOAD_URL_ASC',
  DocumentByDefaultLegalAppendixIdOriginalDownloadUrlDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORIGINAL_DOWNLOAD_URL_DESC',
  DocumentByDefaultLegalAppendixIdOriginalMimeTypeAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORIGINAL_MIME_TYPE_ASC',
  DocumentByDefaultLegalAppendixIdOriginalMimeTypeDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORIGINAL_MIME_TYPE_DESC',
  DocumentByDefaultLegalAppendixIdOriginalStorageIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORIGINAL_STORAGE_ID_ASC',
  DocumentByDefaultLegalAppendixIdOriginalStorageIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__ORIGINAL_STORAGE_ID_DESC',
  DocumentByDefaultLegalAppendixIdPagesAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__PAGES_ASC',
  DocumentByDefaultLegalAppendixIdPagesDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__PAGES_DESC',
  DocumentByDefaultLegalAppendixIdStorageIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__STORAGE_ID_ASC',
  DocumentByDefaultLegalAppendixIdStorageIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__STORAGE_ID_DESC',
  DocumentByDefaultLegalAppendixIdSysPeriodAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__SYS_PERIOD_ASC',
  DocumentByDefaultLegalAppendixIdSysPeriodDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__SYS_PERIOD_DESC',
  DocumentByDefaultLegalAppendixIdTagsAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__TAGS_ASC',
  DocumentByDefaultLegalAppendixIdTagsDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__TAGS_DESC',
  DocumentByDefaultLegalAppendixIdTeaserTextAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__TEASER_TEXT_ASC',
  DocumentByDefaultLegalAppendixIdTeaserTextDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__TEASER_TEXT_DESC',
  DocumentByDefaultLegalAppendixIdThumbnailDownloadUrlAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__THUMBNAIL_DOWNLOAD_URL_ASC',
  DocumentByDefaultLegalAppendixIdThumbnailDownloadUrlDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__THUMBNAIL_DOWNLOAD_URL_DESC',
  DocumentByDefaultLegalAppendixIdThumbnailStorageIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__THUMBNAIL_STORAGE_ID_ASC',
  DocumentByDefaultLegalAppendixIdThumbnailStorageIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__THUMBNAIL_STORAGE_ID_DESC',
  DocumentByDefaultLegalAppendixIdTopTitleAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__TOP_TITLE_ASC',
  DocumentByDefaultLegalAppendixIdTopTitleDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__TOP_TITLE_DESC',
  DocumentByDefaultLegalAppendixIdUploadedAtAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__UPLOADED_AT_ASC',
  DocumentByDefaultLegalAppendixIdUploadedAtDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__UPLOADED_AT_DESC',
  DocumentByDefaultLegalAppendixIdWorkspaceIdAsc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__WORKSPACE_ID_ASC',
  DocumentByDefaultLegalAppendixIdWorkspaceIdDesc = 'DOCUMENT_BY_DEFAULT_LEGAL_APPENDIX_ID__WORKSPACE_ID_DESC',
  EmailSubjectAsc = 'EMAIL_SUBJECT_ASC',
  EmailSubjectDesc = 'EMAIL_SUBJECT_DESC',
  EmailTextAsc = 'EMAIL_TEXT_ASC',
  EmailTextDesc = 'EMAIL_TEXT_DESC',
  FirebaseIdAsc = 'FIREBASE_ID_ASC',
  FirebaseIdDesc = 'FIREBASE_ID_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  HideProjectorButtonInPresentationAsc = 'HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  HideProjectorButtonInPresentationDesc = 'HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOpenAsc = 'IS_OPEN_ASC',
  IsOpenDesc = 'IS_OPEN_DESC',
  IsVisibleAsc = 'IS_VISIBLE_ASC',
  IsVisibleDesc = 'IS_VISIBLE_DESC',
  LaserPointerPositionAsc = 'LASER_POINTER_POSITION_ASC',
  LaserPointerPositionDesc = 'LASER_POINTER_POSITION_DESC',
  LinkPanelPositionAsc = 'LINK_PANEL_POSITION_ASC',
  LinkPanelPositionDesc = 'LINK_PANEL_POSITION_DESC',
  MemberCountAsc = 'MEMBER_COUNT_ASC',
  MemberCountDesc = 'MEMBER_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameLowercaseAsc = 'NAME_LOWERCASE_ASC',
  NameLowercaseDesc = 'NAME_LOWERCASE_DESC',
  Natural = 'NATURAL',
  NotificationsByWorkspaceIdCountAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__COUNT_ASC',
  NotificationsByWorkspaceIdCountDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__COUNT_DESC',
  NotificationsByWorkspaceIdMaxBodyTextAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_BODY_TEXT_ASC',
  NotificationsByWorkspaceIdMaxBodyTextDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_BODY_TEXT_DESC',
  NotificationsByWorkspaceIdMaxCreatedAtAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_CREATED_AT_ASC',
  NotificationsByWorkspaceIdMaxCreatedAtDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_CREATED_AT_DESC',
  NotificationsByWorkspaceIdMaxDataAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_DATA_ASC',
  NotificationsByWorkspaceIdMaxDataDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_DATA_DESC',
  NotificationsByWorkspaceIdMaxEventTypeAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_EVENT_TYPE_ASC',
  NotificationsByWorkspaceIdMaxEventTypeDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_EVENT_TYPE_DESC',
  NotificationsByWorkspaceIdMaxHeaderTextAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_HEADER_TEXT_ASC',
  NotificationsByWorkspaceIdMaxHeaderTextDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_HEADER_TEXT_DESC',
  NotificationsByWorkspaceIdMaxIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_ID_ASC',
  NotificationsByWorkspaceIdMaxIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_ID_DESC',
  NotificationsByWorkspaceIdMaxSenderIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_SENDER_ID_ASC',
  NotificationsByWorkspaceIdMaxSenderIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_SENDER_ID_DESC',
  NotificationsByWorkspaceIdMaxTeamIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_TEAM_ID_ASC',
  NotificationsByWorkspaceIdMaxTeamIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_TEAM_ID_DESC',
  NotificationsByWorkspaceIdMaxUserIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_USER_ID_ASC',
  NotificationsByWorkspaceIdMaxUserIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_USER_ID_DESC',
  NotificationsByWorkspaceIdMaxWorkspaceIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_WORKSPACE_ID_ASC',
  NotificationsByWorkspaceIdMaxWorkspaceIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MAX_WORKSPACE_ID_DESC',
  NotificationsByWorkspaceIdMinBodyTextAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_BODY_TEXT_ASC',
  NotificationsByWorkspaceIdMinBodyTextDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_BODY_TEXT_DESC',
  NotificationsByWorkspaceIdMinCreatedAtAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_CREATED_AT_ASC',
  NotificationsByWorkspaceIdMinCreatedAtDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_CREATED_AT_DESC',
  NotificationsByWorkspaceIdMinDataAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_DATA_ASC',
  NotificationsByWorkspaceIdMinDataDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_DATA_DESC',
  NotificationsByWorkspaceIdMinEventTypeAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_EVENT_TYPE_ASC',
  NotificationsByWorkspaceIdMinEventTypeDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_EVENT_TYPE_DESC',
  NotificationsByWorkspaceIdMinHeaderTextAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_HEADER_TEXT_ASC',
  NotificationsByWorkspaceIdMinHeaderTextDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_HEADER_TEXT_DESC',
  NotificationsByWorkspaceIdMinIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_ID_ASC',
  NotificationsByWorkspaceIdMinIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_ID_DESC',
  NotificationsByWorkspaceIdMinSenderIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_SENDER_ID_ASC',
  NotificationsByWorkspaceIdMinSenderIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_SENDER_ID_DESC',
  NotificationsByWorkspaceIdMinTeamIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_TEAM_ID_ASC',
  NotificationsByWorkspaceIdMinTeamIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_TEAM_ID_DESC',
  NotificationsByWorkspaceIdMinUserIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_USER_ID_ASC',
  NotificationsByWorkspaceIdMinUserIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_USER_ID_DESC',
  NotificationsByWorkspaceIdMinWorkspaceIdAsc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_WORKSPACE_ID_ASC',
  NotificationsByWorkspaceIdMinWorkspaceIdDesc = 'NOTIFICATIONS_BY_WORKSPACE_ID__MIN_WORKSPACE_ID_DESC',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PersonalWorkspaceOfUserIdAsc = 'PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  PersonalWorkspaceOfUserIdDesc = 'PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RetentionPolicyByWorkspaceIdAutoExpireLocalUploadsDaysAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_ASC',
  RetentionPolicyByWorkspaceIdAutoExpireLocalUploadsDaysDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__AUTO_EXPIRE_LOCAL_UPLOADS_DAYS_DESC',
  RetentionPolicyByWorkspaceIdCreatedAtAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__CREATED_AT_ASC',
  RetentionPolicyByWorkspaceIdCreatedAtDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__CREATED_AT_DESC',
  RetentionPolicyByWorkspaceIdExpiryDateEditableAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__EXPIRY_DATE_EDITABLE_ASC',
  RetentionPolicyByWorkspaceIdExpiryDateEditableDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__EXPIRY_DATE_EDITABLE_DESC',
  RetentionPolicyByWorkspaceIdGracePeriodDaysAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__GRACE_PERIOD_DAYS_ASC',
  RetentionPolicyByWorkspaceIdGracePeriodDaysDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__GRACE_PERIOD_DAYS_DESC',
  RetentionPolicyByWorkspaceIdIdAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__ID_ASC',
  RetentionPolicyByWorkspaceIdIdDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__ID_DESC',
  RetentionPolicyByWorkspaceIdTeamIdAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__TEAM_ID_ASC',
  RetentionPolicyByWorkspaceIdTeamIdDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__TEAM_ID_DESC',
  RetentionPolicyByWorkspaceIdTenantIdAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__TENANT_ID_ASC',
  RetentionPolicyByWorkspaceIdTenantIdDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__TENANT_ID_DESC',
  RetentionPolicyByWorkspaceIdUpdatedAtAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__UPDATED_AT_ASC',
  RetentionPolicyByWorkspaceIdUpdatedAtDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__UPDATED_AT_DESC',
  RetentionPolicyByWorkspaceIdWorkspaceIdAsc = 'RETENTION_POLICY_BY_WORKSPACE_ID__WORKSPACE_ID_ASC',
  RetentionPolicyByWorkspaceIdWorkspaceIdDesc = 'RETENTION_POLICY_BY_WORKSPACE_ID__WORKSPACE_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TeamRankAsc = 'TEAM_RANK_ASC',
  TeamRankDesc = 'TEAM_RANK_DESC',
  TenantsByTutorialWorkspaceIdCountAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__COUNT_ASC',
  TenantsByTutorialWorkspaceIdCountDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__COUNT_DESC',
  TenantsByTutorialWorkspaceIdMaxAutoAssignIfEmailLikeAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantsByTutorialWorkspaceIdMaxAutoAssignIfEmailLikeDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantsByTutorialWorkspaceIdMaxCanUsersInviteOthersAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_CAN_USERS_INVITE_OTHERS_ASC',
  TenantsByTutorialWorkspaceIdMaxCanUsersInviteOthersDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_CAN_USERS_INVITE_OTHERS_DESC',
  TenantsByTutorialWorkspaceIdMaxCreatedAtAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_CREATED_AT_ASC',
  TenantsByTutorialWorkspaceIdMaxCreatedAtDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_CREATED_AT_DESC',
  TenantsByTutorialWorkspaceIdMaxExportPresentationAnalyticsUserEmailAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantsByTutorialWorkspaceIdMaxExportPresentationAnalyticsUserEmailDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantsByTutorialWorkspaceIdMaxFlagsAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_FLAGS_ASC',
  TenantsByTutorialWorkspaceIdMaxFlagsDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_FLAGS_DESC',
  TenantsByTutorialWorkspaceIdMaxHasExternalGroupsAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_HAS_EXTERNAL_GROUPS_ASC',
  TenantsByTutorialWorkspaceIdMaxHasExternalGroupsDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_HAS_EXTERNAL_GROUPS_DESC',
  TenantsByTutorialWorkspaceIdMaxIdAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_ID_ASC',
  TenantsByTutorialWorkspaceIdMaxIdDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_ID_DESC',
  TenantsByTutorialWorkspaceIdMaxNameAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_NAME_ASC',
  TenantsByTutorialWorkspaceIdMaxNameDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_NAME_DESC',
  TenantsByTutorialWorkspaceIdMaxSetupPersonalWorkspacesOnRegistrationAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantsByTutorialWorkspaceIdMaxSetupPersonalWorkspacesOnRegistrationDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantsByTutorialWorkspaceIdMaxTutorialWorkspaceIdAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_TUTORIAL_WORKSPACE_ID_ASC',
  TenantsByTutorialWorkspaceIdMaxTutorialWorkspaceIdDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_TUTORIAL_WORKSPACE_ID_DESC',
  TenantsByTutorialWorkspaceIdMaxUpdatedAtAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_UPDATED_AT_ASC',
  TenantsByTutorialWorkspaceIdMaxUpdatedAtDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_UPDATED_AT_DESC',
  TenantsByTutorialWorkspaceIdMaxUserConfigDefaultsAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_USER_CONFIG_DEFAULTS_ASC',
  TenantsByTutorialWorkspaceIdMaxUserConfigDefaultsDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MAX_USER_CONFIG_DEFAULTS_DESC',
  TenantsByTutorialWorkspaceIdMinAutoAssignIfEmailLikeAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantsByTutorialWorkspaceIdMinAutoAssignIfEmailLikeDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantsByTutorialWorkspaceIdMinCanUsersInviteOthersAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_CAN_USERS_INVITE_OTHERS_ASC',
  TenantsByTutorialWorkspaceIdMinCanUsersInviteOthersDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_CAN_USERS_INVITE_OTHERS_DESC',
  TenantsByTutorialWorkspaceIdMinCreatedAtAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_CREATED_AT_ASC',
  TenantsByTutorialWorkspaceIdMinCreatedAtDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_CREATED_AT_DESC',
  TenantsByTutorialWorkspaceIdMinExportPresentationAnalyticsUserEmailAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantsByTutorialWorkspaceIdMinExportPresentationAnalyticsUserEmailDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantsByTutorialWorkspaceIdMinFlagsAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_FLAGS_ASC',
  TenantsByTutorialWorkspaceIdMinFlagsDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_FLAGS_DESC',
  TenantsByTutorialWorkspaceIdMinHasExternalGroupsAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_HAS_EXTERNAL_GROUPS_ASC',
  TenantsByTutorialWorkspaceIdMinHasExternalGroupsDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_HAS_EXTERNAL_GROUPS_DESC',
  TenantsByTutorialWorkspaceIdMinIdAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_ID_ASC',
  TenantsByTutorialWorkspaceIdMinIdDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_ID_DESC',
  TenantsByTutorialWorkspaceIdMinNameAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_NAME_ASC',
  TenantsByTutorialWorkspaceIdMinNameDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_NAME_DESC',
  TenantsByTutorialWorkspaceIdMinSetupPersonalWorkspacesOnRegistrationAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantsByTutorialWorkspaceIdMinSetupPersonalWorkspacesOnRegistrationDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantsByTutorialWorkspaceIdMinTutorialWorkspaceIdAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_TUTORIAL_WORKSPACE_ID_ASC',
  TenantsByTutorialWorkspaceIdMinTutorialWorkspaceIdDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_TUTORIAL_WORKSPACE_ID_DESC',
  TenantsByTutorialWorkspaceIdMinUpdatedAtAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_UPDATED_AT_ASC',
  TenantsByTutorialWorkspaceIdMinUpdatedAtDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_UPDATED_AT_DESC',
  TenantsByTutorialWorkspaceIdMinUserConfigDefaultsAsc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_USER_CONFIG_DEFAULTS_ASC',
  TenantsByTutorialWorkspaceIdMinUserConfigDefaultsDesc = 'TENANTS_BY_TUTORIAL_WORKSPACE_ID__MIN_USER_CONFIG_DEFAULTS_DESC',
  TenantByTenantIdAutoAssignIfEmailLikeAsc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_ASC',
  TenantByTenantIdAutoAssignIfEmailLikeDesc = 'TENANT_BY_TENANT_ID__AUTO_ASSIGN_IF_EMAIL_LIKE_DESC',
  TenantByTenantIdCanUsersInviteOthersAsc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_ASC',
  TenantByTenantIdCanUsersInviteOthersDesc = 'TENANT_BY_TENANT_ID__CAN_USERS_INVITE_OTHERS_DESC',
  TenantByTenantIdCreatedAtAsc = 'TENANT_BY_TENANT_ID__CREATED_AT_ASC',
  TenantByTenantIdCreatedAtDesc = 'TENANT_BY_TENANT_ID__CREATED_AT_DESC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailAsc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_ASC',
  TenantByTenantIdExportPresentationAnalyticsUserEmailDesc = 'TENANT_BY_TENANT_ID__EXPORT_PRESENTATION_ANALYTICS_USER_EMAIL_DESC',
  TenantByTenantIdFlagsAsc = 'TENANT_BY_TENANT_ID__FLAGS_ASC',
  TenantByTenantIdFlagsDesc = 'TENANT_BY_TENANT_ID__FLAGS_DESC',
  TenantByTenantIdHasExternalGroupsAsc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_ASC',
  TenantByTenantIdHasExternalGroupsDesc = 'TENANT_BY_TENANT_ID__HAS_EXTERNAL_GROUPS_DESC',
  TenantByTenantIdIdAsc = 'TENANT_BY_TENANT_ID__ID_ASC',
  TenantByTenantIdIdDesc = 'TENANT_BY_TENANT_ID__ID_DESC',
  TenantByTenantIdNameAsc = 'TENANT_BY_TENANT_ID__NAME_ASC',
  TenantByTenantIdNameDesc = 'TENANT_BY_TENANT_ID__NAME_DESC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationAsc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_ASC',
  TenantByTenantIdSetupPersonalWorkspacesOnRegistrationDesc = 'TENANT_BY_TENANT_ID__SETUP_PERSONAL_WORKSPACES_ON_REGISTRATION_DESC',
  TenantByTenantIdTutorialWorkspaceIdAsc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_ASC',
  TenantByTenantIdTutorialWorkspaceIdDesc = 'TENANT_BY_TENANT_ID__TUTORIAL_WORKSPACE_ID_DESC',
  TenantByTenantIdUpdatedAtAsc = 'TENANT_BY_TENANT_ID__UPDATED_AT_ASC',
  TenantByTenantIdUpdatedAtDesc = 'TENANT_BY_TENANT_ID__UPDATED_AT_DESC',
  TenantByTenantIdUserConfigDefaultsAsc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_ASC',
  TenantByTenantIdUserConfigDefaultsDesc = 'TENANT_BY_TENANT_ID__USER_CONFIG_DEFAULTS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TotalMemberCountAsc = 'TOTAL_MEMBER_COUNT_ASC',
  TotalMemberCountDesc = 'TOTAL_MEMBER_COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsersByDefaultWorkspaceIdCountAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__COUNT_ASC',
  UsersByDefaultWorkspaceIdCountDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__COUNT_DESC',
  UsersByDefaultWorkspaceIdMaxAppConsentGivenAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_APP_CONSENT_GIVEN_AT_ASC',
  UsersByDefaultWorkspaceIdMaxAppConsentGivenAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_APP_CONSENT_GIVEN_AT_DESC',
  UsersByDefaultWorkspaceIdMaxConfigAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_CONFIG_ASC',
  UsersByDefaultWorkspaceIdMaxConfigDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_CONFIG_DESC',
  UsersByDefaultWorkspaceIdMaxCreatedAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_CREATED_AT_ASC',
  UsersByDefaultWorkspaceIdMaxCreatedAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_CREATED_AT_DESC',
  UsersByDefaultWorkspaceIdMaxCrmContactVisibilityFilterAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UsersByDefaultWorkspaceIdMaxCrmContactVisibilityFilterDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UsersByDefaultWorkspaceIdMaxDefaultWorkspaceIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_DEFAULT_WORKSPACE_ID_ASC',
  UsersByDefaultWorkspaceIdMaxDefaultWorkspaceIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_DEFAULT_WORKSPACE_ID_DESC',
  UsersByDefaultWorkspaceIdMaxDisabledAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_DISABLED_ASC',
  UsersByDefaultWorkspaceIdMaxDisabledDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_DISABLED_DESC',
  UsersByDefaultWorkspaceIdMaxDisplayNameAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_DISPLAY_NAME_ASC',
  UsersByDefaultWorkspaceIdMaxDisplayNameDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_DISPLAY_NAME_DESC',
  UsersByDefaultWorkspaceIdMaxEmailAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_EMAIL_ASC',
  UsersByDefaultWorkspaceIdMaxEmailDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_EMAIL_DESC',
  UsersByDefaultWorkspaceIdMaxExternalGroupsAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_EXTERNAL_GROUPS_ASC',
  UsersByDefaultWorkspaceIdMaxExternalGroupsDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_EXTERNAL_GROUPS_DESC',
  UsersByDefaultWorkspaceIdMaxExternalGroupsSyncedAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UsersByDefaultWorkspaceIdMaxExternalGroupsSyncedAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UsersByDefaultWorkspaceIdMaxFirebaseAuthIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_FIREBASE_AUTH_ID_ASC',
  UsersByDefaultWorkspaceIdMaxFirebaseAuthIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_FIREBASE_AUTH_ID_DESC',
  UsersByDefaultWorkspaceIdMaxFlagsAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_FLAGS_ASC',
  UsersByDefaultWorkspaceIdMaxFlagsDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_FLAGS_DESC',
  UsersByDefaultWorkspaceIdMaxIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_ID_ASC',
  UsersByDefaultWorkspaceIdMaxIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_ID_DESC',
  UsersByDefaultWorkspaceIdMaxIsTenantAdminAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_IS_TENANT_ADMIN_ASC',
  UsersByDefaultWorkspaceIdMaxIsTenantAdminDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_IS_TENANT_ADMIN_DESC',
  UsersByDefaultWorkspaceIdMaxRegisteredAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_REGISTERED_AT_ASC',
  UsersByDefaultWorkspaceIdMaxRegisteredAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_REGISTERED_AT_DESC',
  UsersByDefaultWorkspaceIdMaxSysPeriodAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_SYS_PERIOD_ASC',
  UsersByDefaultWorkspaceIdMaxSysPeriodDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_SYS_PERIOD_DESC',
  UsersByDefaultWorkspaceIdMaxTenantIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_TENANT_ID_ASC',
  UsersByDefaultWorkspaceIdMaxTenantIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_TENANT_ID_DESC',
  UsersByDefaultWorkspaceIdMaxUpdatedAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_UPDATED_AT_ASC',
  UsersByDefaultWorkspaceIdMaxUpdatedAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MAX_UPDATED_AT_DESC',
  UsersByDefaultWorkspaceIdMinAppConsentGivenAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_APP_CONSENT_GIVEN_AT_ASC',
  UsersByDefaultWorkspaceIdMinAppConsentGivenAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_APP_CONSENT_GIVEN_AT_DESC',
  UsersByDefaultWorkspaceIdMinConfigAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_CONFIG_ASC',
  UsersByDefaultWorkspaceIdMinConfigDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_CONFIG_DESC',
  UsersByDefaultWorkspaceIdMinCreatedAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_CREATED_AT_ASC',
  UsersByDefaultWorkspaceIdMinCreatedAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_CREATED_AT_DESC',
  UsersByDefaultWorkspaceIdMinCrmContactVisibilityFilterAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UsersByDefaultWorkspaceIdMinCrmContactVisibilityFilterDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UsersByDefaultWorkspaceIdMinDefaultWorkspaceIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_DEFAULT_WORKSPACE_ID_ASC',
  UsersByDefaultWorkspaceIdMinDefaultWorkspaceIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_DEFAULT_WORKSPACE_ID_DESC',
  UsersByDefaultWorkspaceIdMinDisabledAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_DISABLED_ASC',
  UsersByDefaultWorkspaceIdMinDisabledDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_DISABLED_DESC',
  UsersByDefaultWorkspaceIdMinDisplayNameAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_DISPLAY_NAME_ASC',
  UsersByDefaultWorkspaceIdMinDisplayNameDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_DISPLAY_NAME_DESC',
  UsersByDefaultWorkspaceIdMinEmailAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_EMAIL_ASC',
  UsersByDefaultWorkspaceIdMinEmailDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_EMAIL_DESC',
  UsersByDefaultWorkspaceIdMinExternalGroupsAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_EXTERNAL_GROUPS_ASC',
  UsersByDefaultWorkspaceIdMinExternalGroupsDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_EXTERNAL_GROUPS_DESC',
  UsersByDefaultWorkspaceIdMinExternalGroupsSyncedAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UsersByDefaultWorkspaceIdMinExternalGroupsSyncedAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UsersByDefaultWorkspaceIdMinFirebaseAuthIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_FIREBASE_AUTH_ID_ASC',
  UsersByDefaultWorkspaceIdMinFirebaseAuthIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_FIREBASE_AUTH_ID_DESC',
  UsersByDefaultWorkspaceIdMinFlagsAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_FLAGS_ASC',
  UsersByDefaultWorkspaceIdMinFlagsDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_FLAGS_DESC',
  UsersByDefaultWorkspaceIdMinIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_ID_ASC',
  UsersByDefaultWorkspaceIdMinIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_ID_DESC',
  UsersByDefaultWorkspaceIdMinIsTenantAdminAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_IS_TENANT_ADMIN_ASC',
  UsersByDefaultWorkspaceIdMinIsTenantAdminDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_IS_TENANT_ADMIN_DESC',
  UsersByDefaultWorkspaceIdMinRegisteredAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_REGISTERED_AT_ASC',
  UsersByDefaultWorkspaceIdMinRegisteredAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_REGISTERED_AT_DESC',
  UsersByDefaultWorkspaceIdMinSysPeriodAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_SYS_PERIOD_ASC',
  UsersByDefaultWorkspaceIdMinSysPeriodDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_SYS_PERIOD_DESC',
  UsersByDefaultWorkspaceIdMinTenantIdAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_TENANT_ID_ASC',
  UsersByDefaultWorkspaceIdMinTenantIdDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_TENANT_ID_DESC',
  UsersByDefaultWorkspaceIdMinUpdatedAtAsc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_UPDATED_AT_ASC',
  UsersByDefaultWorkspaceIdMinUpdatedAtDesc = 'USERS_BY_DEFAULT_WORKSPACE_ID__MIN_UPDATED_AT_DESC',
  UserByPersonalWorkspaceOfUserIdAppConsentGivenAtAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__APP_CONSENT_GIVEN_AT_ASC',
  UserByPersonalWorkspaceOfUserIdAppConsentGivenAtDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__APP_CONSENT_GIVEN_AT_DESC',
  UserByPersonalWorkspaceOfUserIdConfigAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__CONFIG_ASC',
  UserByPersonalWorkspaceOfUserIdConfigDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__CONFIG_DESC',
  UserByPersonalWorkspaceOfUserIdCreatedAtAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__CREATED_AT_ASC',
  UserByPersonalWorkspaceOfUserIdCreatedAtDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__CREATED_AT_DESC',
  UserByPersonalWorkspaceOfUserIdCrmContactVisibilityFilterAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_ASC',
  UserByPersonalWorkspaceOfUserIdCrmContactVisibilityFilterDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__CRM_CONTACT_VISIBILITY_FILTER_DESC',
  UserByPersonalWorkspaceOfUserIdDefaultWorkspaceIdAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__DEFAULT_WORKSPACE_ID_ASC',
  UserByPersonalWorkspaceOfUserIdDefaultWorkspaceIdDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__DEFAULT_WORKSPACE_ID_DESC',
  UserByPersonalWorkspaceOfUserIdDisabledAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__DISABLED_ASC',
  UserByPersonalWorkspaceOfUserIdDisabledDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__DISABLED_DESC',
  UserByPersonalWorkspaceOfUserIdDisplayNameAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__DISPLAY_NAME_ASC',
  UserByPersonalWorkspaceOfUserIdDisplayNameDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__DISPLAY_NAME_DESC',
  UserByPersonalWorkspaceOfUserIdEmailAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__EMAIL_ASC',
  UserByPersonalWorkspaceOfUserIdEmailDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__EMAIL_DESC',
  UserByPersonalWorkspaceOfUserIdExternalGroupsAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__EXTERNAL_GROUPS_ASC',
  UserByPersonalWorkspaceOfUserIdExternalGroupsDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__EXTERNAL_GROUPS_DESC',
  UserByPersonalWorkspaceOfUserIdExternalGroupsSyncedAtAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_ASC',
  UserByPersonalWorkspaceOfUserIdExternalGroupsSyncedAtDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__EXTERNAL_GROUPS_SYNCED_AT_DESC',
  UserByPersonalWorkspaceOfUserIdFirebaseAuthIdAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__FIREBASE_AUTH_ID_ASC',
  UserByPersonalWorkspaceOfUserIdFirebaseAuthIdDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__FIREBASE_AUTH_ID_DESC',
  UserByPersonalWorkspaceOfUserIdFlagsAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__FLAGS_ASC',
  UserByPersonalWorkspaceOfUserIdFlagsDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__FLAGS_DESC',
  UserByPersonalWorkspaceOfUserIdIdAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__ID_ASC',
  UserByPersonalWorkspaceOfUserIdIdDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__ID_DESC',
  UserByPersonalWorkspaceOfUserIdIsTenantAdminAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__IS_TENANT_ADMIN_ASC',
  UserByPersonalWorkspaceOfUserIdIsTenantAdminDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__IS_TENANT_ADMIN_DESC',
  UserByPersonalWorkspaceOfUserIdRegisteredAtAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__REGISTERED_AT_ASC',
  UserByPersonalWorkspaceOfUserIdRegisteredAtDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__REGISTERED_AT_DESC',
  UserByPersonalWorkspaceOfUserIdSysPeriodAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__SYS_PERIOD_ASC',
  UserByPersonalWorkspaceOfUserIdSysPeriodDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__SYS_PERIOD_DESC',
  UserByPersonalWorkspaceOfUserIdTenantIdAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__TENANT_ID_ASC',
  UserByPersonalWorkspaceOfUserIdTenantIdDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__TENANT_ID_DESC',
  UserByPersonalWorkspaceOfUserIdUpdatedAtAsc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__UPDATED_AT_ASC',
  UserByPersonalWorkspaceOfUserIdUpdatedAtDesc = 'USER_BY_PERSONAL_WORKSPACE_OF_USER_ID__UPDATED_AT_DESC',
  UserConfigDefaultsAsc = 'USER_CONFIG_DEFAULTS_ASC',
  UserConfigDefaultsDesc = 'USER_CONFIG_DEFAULTS_DESC',
  WorkspacesByParentIdCountAsc = 'WORKSPACES_BY_PARENT_ID__COUNT_ASC',
  WorkspacesByParentIdCountDesc = 'WORKSPACES_BY_PARENT_ID__COUNT_DESC',
  WorkspacesByParentIdMaxAnalyticsAliasAsc = 'WORKSPACES_BY_PARENT_ID__MAX_ANALYTICS_ALIAS_ASC',
  WorkspacesByParentIdMaxAnalyticsAliasDesc = 'WORKSPACES_BY_PARENT_ID__MAX_ANALYTICS_ALIAS_DESC',
  WorkspacesByParentIdMaxAnalyticsEnabledAsc = 'WORKSPACES_BY_PARENT_ID__MAX_ANALYTICS_ENABLED_ASC',
  WorkspacesByParentIdMaxAnalyticsEnabledDesc = 'WORKSPACES_BY_PARENT_ID__MAX_ANALYTICS_ENABLED_DESC',
  WorkspacesByParentIdMaxAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_PARENT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByParentIdMaxAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_PARENT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByParentIdMaxAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_PARENT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByParentIdMaxAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_PARENT_ID__MAX_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByParentIdMaxConfigAsc = 'WORKSPACES_BY_PARENT_ID__MAX_CONFIG_ASC',
  WorkspacesByParentIdMaxConfigDesc = 'WORKSPACES_BY_PARENT_ID__MAX_CONFIG_DESC',
  WorkspacesByParentIdMaxCreatedAtAsc = 'WORKSPACES_BY_PARENT_ID__MAX_CREATED_AT_ASC',
  WorkspacesByParentIdMaxCreatedAtDesc = 'WORKSPACES_BY_PARENT_ID__MAX_CREATED_AT_DESC',
  WorkspacesByParentIdMaxCustomBrandUrlAsc = 'WORKSPACES_BY_PARENT_ID__MAX_CUSTOM_BRAND_URL_ASC',
  WorkspacesByParentIdMaxCustomBrandUrlDesc = 'WORKSPACES_BY_PARENT_ID__MAX_CUSTOM_BRAND_URL_DESC',
  WorkspacesByParentIdMaxCustomShareLinkAsc = 'WORKSPACES_BY_PARENT_ID__MAX_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByParentIdMaxCustomShareLinkDesc = 'WORKSPACES_BY_PARENT_ID__MAX_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByParentIdMaxDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_PARENT_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByParentIdMaxDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_PARENT_ID__MAX_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByParentIdMaxEmailSubjectAsc = 'WORKSPACES_BY_PARENT_ID__MAX_EMAIL_SUBJECT_ASC',
  WorkspacesByParentIdMaxEmailSubjectDesc = 'WORKSPACES_BY_PARENT_ID__MAX_EMAIL_SUBJECT_DESC',
  WorkspacesByParentIdMaxEmailTextAsc = 'WORKSPACES_BY_PARENT_ID__MAX_EMAIL_TEXT_ASC',
  WorkspacesByParentIdMaxEmailTextDesc = 'WORKSPACES_BY_PARENT_ID__MAX_EMAIL_TEXT_DESC',
  WorkspacesByParentIdMaxFirebaseIdAsc = 'WORKSPACES_BY_PARENT_ID__MAX_FIREBASE_ID_ASC',
  WorkspacesByParentIdMaxFirebaseIdDesc = 'WORKSPACES_BY_PARENT_ID__MAX_FIREBASE_ID_DESC',
  WorkspacesByParentIdMaxFlagsAsc = 'WORKSPACES_BY_PARENT_ID__MAX_FLAGS_ASC',
  WorkspacesByParentIdMaxFlagsDesc = 'WORKSPACES_BY_PARENT_ID__MAX_FLAGS_DESC',
  WorkspacesByParentIdMaxHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_PARENT_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByParentIdMaxHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_PARENT_ID__MAX_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByParentIdMaxIdAsc = 'WORKSPACES_BY_PARENT_ID__MAX_ID_ASC',
  WorkspacesByParentIdMaxIdDesc = 'WORKSPACES_BY_PARENT_ID__MAX_ID_DESC',
  WorkspacesByParentIdMaxIsOpenAsc = 'WORKSPACES_BY_PARENT_ID__MAX_IS_OPEN_ASC',
  WorkspacesByParentIdMaxIsOpenDesc = 'WORKSPACES_BY_PARENT_ID__MAX_IS_OPEN_DESC',
  WorkspacesByParentIdMaxIsVisibleAsc = 'WORKSPACES_BY_PARENT_ID__MAX_IS_VISIBLE_ASC',
  WorkspacesByParentIdMaxIsVisibleDesc = 'WORKSPACES_BY_PARENT_ID__MAX_IS_VISIBLE_DESC',
  WorkspacesByParentIdMaxLaserPointerPositionAsc = 'WORKSPACES_BY_PARENT_ID__MAX_LASER_POINTER_POSITION_ASC',
  WorkspacesByParentIdMaxLaserPointerPositionDesc = 'WORKSPACES_BY_PARENT_ID__MAX_LASER_POINTER_POSITION_DESC',
  WorkspacesByParentIdMaxLinkPanelPositionAsc = 'WORKSPACES_BY_PARENT_ID__MAX_LINK_PANEL_POSITION_ASC',
  WorkspacesByParentIdMaxLinkPanelPositionDesc = 'WORKSPACES_BY_PARENT_ID__MAX_LINK_PANEL_POSITION_DESC',
  WorkspacesByParentIdMaxNameAsc = 'WORKSPACES_BY_PARENT_ID__MAX_NAME_ASC',
  WorkspacesByParentIdMaxNameDesc = 'WORKSPACES_BY_PARENT_ID__MAX_NAME_DESC',
  WorkspacesByParentIdMaxNameLowercaseAsc = 'WORKSPACES_BY_PARENT_ID__MAX_NAME_LOWERCASE_ASC',
  WorkspacesByParentIdMaxNameLowercaseDesc = 'WORKSPACES_BY_PARENT_ID__MAX_NAME_LOWERCASE_DESC',
  WorkspacesByParentIdMaxParentIdAsc = 'WORKSPACES_BY_PARENT_ID__MAX_PARENT_ID_ASC',
  WorkspacesByParentIdMaxParentIdDesc = 'WORKSPACES_BY_PARENT_ID__MAX_PARENT_ID_DESC',
  WorkspacesByParentIdMaxPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_PARENT_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByParentIdMaxPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_PARENT_ID__MAX_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByParentIdMaxSysPeriodAsc = 'WORKSPACES_BY_PARENT_ID__MAX_SYS_PERIOD_ASC',
  WorkspacesByParentIdMaxSysPeriodDesc = 'WORKSPACES_BY_PARENT_ID__MAX_SYS_PERIOD_DESC',
  WorkspacesByParentIdMaxTagsAsc = 'WORKSPACES_BY_PARENT_ID__MAX_TAGS_ASC',
  WorkspacesByParentIdMaxTagsDesc = 'WORKSPACES_BY_PARENT_ID__MAX_TAGS_DESC',
  WorkspacesByParentIdMaxTeamRankAsc = 'WORKSPACES_BY_PARENT_ID__MAX_TEAM_RANK_ASC',
  WorkspacesByParentIdMaxTeamRankDesc = 'WORKSPACES_BY_PARENT_ID__MAX_TEAM_RANK_DESC',
  WorkspacesByParentIdMaxTenantIdAsc = 'WORKSPACES_BY_PARENT_ID__MAX_TENANT_ID_ASC',
  WorkspacesByParentIdMaxTenantIdDesc = 'WORKSPACES_BY_PARENT_ID__MAX_TENANT_ID_DESC',
  WorkspacesByParentIdMaxUpdatedAtAsc = 'WORKSPACES_BY_PARENT_ID__MAX_UPDATED_AT_ASC',
  WorkspacesByParentIdMaxUpdatedAtDesc = 'WORKSPACES_BY_PARENT_ID__MAX_UPDATED_AT_DESC',
  WorkspacesByParentIdMaxUserConfigDefaultsAsc = 'WORKSPACES_BY_PARENT_ID__MAX_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByParentIdMaxUserConfigDefaultsDesc = 'WORKSPACES_BY_PARENT_ID__MAX_USER_CONFIG_DEFAULTS_DESC',
  WorkspacesByParentIdMinAnalyticsAliasAsc = 'WORKSPACES_BY_PARENT_ID__MIN_ANALYTICS_ALIAS_ASC',
  WorkspacesByParentIdMinAnalyticsAliasDesc = 'WORKSPACES_BY_PARENT_ID__MIN_ANALYTICS_ALIAS_DESC',
  WorkspacesByParentIdMinAnalyticsEnabledAsc = 'WORKSPACES_BY_PARENT_ID__MIN_ANALYTICS_ENABLED_ASC',
  WorkspacesByParentIdMinAnalyticsEnabledDesc = 'WORKSPACES_BY_PARENT_ID__MIN_ANALYTICS_ENABLED_DESC',
  WorkspacesByParentIdMinAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACES_BY_PARENT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspacesByParentIdMinAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACES_BY_PARENT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspacesByParentIdMinAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACES_BY_PARENT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspacesByParentIdMinAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACES_BY_PARENT_ID__MIN_ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspacesByParentIdMinConfigAsc = 'WORKSPACES_BY_PARENT_ID__MIN_CONFIG_ASC',
  WorkspacesByParentIdMinConfigDesc = 'WORKSPACES_BY_PARENT_ID__MIN_CONFIG_DESC',
  WorkspacesByParentIdMinCreatedAtAsc = 'WORKSPACES_BY_PARENT_ID__MIN_CREATED_AT_ASC',
  WorkspacesByParentIdMinCreatedAtDesc = 'WORKSPACES_BY_PARENT_ID__MIN_CREATED_AT_DESC',
  WorkspacesByParentIdMinCustomBrandUrlAsc = 'WORKSPACES_BY_PARENT_ID__MIN_CUSTOM_BRAND_URL_ASC',
  WorkspacesByParentIdMinCustomBrandUrlDesc = 'WORKSPACES_BY_PARENT_ID__MIN_CUSTOM_BRAND_URL_DESC',
  WorkspacesByParentIdMinCustomShareLinkAsc = 'WORKSPACES_BY_PARENT_ID__MIN_CUSTOM_SHARE_LINK_ASC',
  WorkspacesByParentIdMinCustomShareLinkDesc = 'WORKSPACES_BY_PARENT_ID__MIN_CUSTOM_SHARE_LINK_DESC',
  WorkspacesByParentIdMinDefaultLegalAppendixIdAsc = 'WORKSPACES_BY_PARENT_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspacesByParentIdMinDefaultLegalAppendixIdDesc = 'WORKSPACES_BY_PARENT_ID__MIN_DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspacesByParentIdMinEmailSubjectAsc = 'WORKSPACES_BY_PARENT_ID__MIN_EMAIL_SUBJECT_ASC',
  WorkspacesByParentIdMinEmailSubjectDesc = 'WORKSPACES_BY_PARENT_ID__MIN_EMAIL_SUBJECT_DESC',
  WorkspacesByParentIdMinEmailTextAsc = 'WORKSPACES_BY_PARENT_ID__MIN_EMAIL_TEXT_ASC',
  WorkspacesByParentIdMinEmailTextDesc = 'WORKSPACES_BY_PARENT_ID__MIN_EMAIL_TEXT_DESC',
  WorkspacesByParentIdMinFirebaseIdAsc = 'WORKSPACES_BY_PARENT_ID__MIN_FIREBASE_ID_ASC',
  WorkspacesByParentIdMinFirebaseIdDesc = 'WORKSPACES_BY_PARENT_ID__MIN_FIREBASE_ID_DESC',
  WorkspacesByParentIdMinFlagsAsc = 'WORKSPACES_BY_PARENT_ID__MIN_FLAGS_ASC',
  WorkspacesByParentIdMinFlagsDesc = 'WORKSPACES_BY_PARENT_ID__MIN_FLAGS_DESC',
  WorkspacesByParentIdMinHideProjectorButtonInPresentationAsc = 'WORKSPACES_BY_PARENT_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspacesByParentIdMinHideProjectorButtonInPresentationDesc = 'WORKSPACES_BY_PARENT_ID__MIN_HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspacesByParentIdMinIdAsc = 'WORKSPACES_BY_PARENT_ID__MIN_ID_ASC',
  WorkspacesByParentIdMinIdDesc = 'WORKSPACES_BY_PARENT_ID__MIN_ID_DESC',
  WorkspacesByParentIdMinIsOpenAsc = 'WORKSPACES_BY_PARENT_ID__MIN_IS_OPEN_ASC',
  WorkspacesByParentIdMinIsOpenDesc = 'WORKSPACES_BY_PARENT_ID__MIN_IS_OPEN_DESC',
  WorkspacesByParentIdMinIsVisibleAsc = 'WORKSPACES_BY_PARENT_ID__MIN_IS_VISIBLE_ASC',
  WorkspacesByParentIdMinIsVisibleDesc = 'WORKSPACES_BY_PARENT_ID__MIN_IS_VISIBLE_DESC',
  WorkspacesByParentIdMinLaserPointerPositionAsc = 'WORKSPACES_BY_PARENT_ID__MIN_LASER_POINTER_POSITION_ASC',
  WorkspacesByParentIdMinLaserPointerPositionDesc = 'WORKSPACES_BY_PARENT_ID__MIN_LASER_POINTER_POSITION_DESC',
  WorkspacesByParentIdMinLinkPanelPositionAsc = 'WORKSPACES_BY_PARENT_ID__MIN_LINK_PANEL_POSITION_ASC',
  WorkspacesByParentIdMinLinkPanelPositionDesc = 'WORKSPACES_BY_PARENT_ID__MIN_LINK_PANEL_POSITION_DESC',
  WorkspacesByParentIdMinNameAsc = 'WORKSPACES_BY_PARENT_ID__MIN_NAME_ASC',
  WorkspacesByParentIdMinNameDesc = 'WORKSPACES_BY_PARENT_ID__MIN_NAME_DESC',
  WorkspacesByParentIdMinNameLowercaseAsc = 'WORKSPACES_BY_PARENT_ID__MIN_NAME_LOWERCASE_ASC',
  WorkspacesByParentIdMinNameLowercaseDesc = 'WORKSPACES_BY_PARENT_ID__MIN_NAME_LOWERCASE_DESC',
  WorkspacesByParentIdMinParentIdAsc = 'WORKSPACES_BY_PARENT_ID__MIN_PARENT_ID_ASC',
  WorkspacesByParentIdMinParentIdDesc = 'WORKSPACES_BY_PARENT_ID__MIN_PARENT_ID_DESC',
  WorkspacesByParentIdMinPersonalWorkspaceOfUserIdAsc = 'WORKSPACES_BY_PARENT_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspacesByParentIdMinPersonalWorkspaceOfUserIdDesc = 'WORKSPACES_BY_PARENT_ID__MIN_PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspacesByParentIdMinSysPeriodAsc = 'WORKSPACES_BY_PARENT_ID__MIN_SYS_PERIOD_ASC',
  WorkspacesByParentIdMinSysPeriodDesc = 'WORKSPACES_BY_PARENT_ID__MIN_SYS_PERIOD_DESC',
  WorkspacesByParentIdMinTagsAsc = 'WORKSPACES_BY_PARENT_ID__MIN_TAGS_ASC',
  WorkspacesByParentIdMinTagsDesc = 'WORKSPACES_BY_PARENT_ID__MIN_TAGS_DESC',
  WorkspacesByParentIdMinTeamRankAsc = 'WORKSPACES_BY_PARENT_ID__MIN_TEAM_RANK_ASC',
  WorkspacesByParentIdMinTeamRankDesc = 'WORKSPACES_BY_PARENT_ID__MIN_TEAM_RANK_DESC',
  WorkspacesByParentIdMinTenantIdAsc = 'WORKSPACES_BY_PARENT_ID__MIN_TENANT_ID_ASC',
  WorkspacesByParentIdMinTenantIdDesc = 'WORKSPACES_BY_PARENT_ID__MIN_TENANT_ID_DESC',
  WorkspacesByParentIdMinUpdatedAtAsc = 'WORKSPACES_BY_PARENT_ID__MIN_UPDATED_AT_ASC',
  WorkspacesByParentIdMinUpdatedAtDesc = 'WORKSPACES_BY_PARENT_ID__MIN_UPDATED_AT_DESC',
  WorkspacesByParentIdMinUserConfigDefaultsAsc = 'WORKSPACES_BY_PARENT_ID__MIN_USER_CONFIG_DEFAULTS_ASC',
  WorkspacesByParentIdMinUserConfigDefaultsDesc = 'WORKSPACES_BY_PARENT_ID__MIN_USER_CONFIG_DEFAULTS_DESC',
  WorkspaceByParentIdAnalyticsAliasAsc = 'WORKSPACE_BY_PARENT_ID__ANALYTICS_ALIAS_ASC',
  WorkspaceByParentIdAnalyticsAliasDesc = 'WORKSPACE_BY_PARENT_ID__ANALYTICS_ALIAS_DESC',
  WorkspaceByParentIdAnalyticsEnabledAsc = 'WORKSPACE_BY_PARENT_ID__ANALYTICS_ENABLED_ASC',
  WorkspaceByParentIdAnalyticsEnabledDesc = 'WORKSPACE_BY_PARENT_ID__ANALYTICS_ENABLED_DESC',
  WorkspaceByParentIdAssignIfExternalGroupsMatchAllOfAsc = 'WORKSPACE_BY_PARENT_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_ASC',
  WorkspaceByParentIdAssignIfExternalGroupsMatchAllOfDesc = 'WORKSPACE_BY_PARENT_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ALL_OF_DESC',
  WorkspaceByParentIdAssignIfExternalGroupsMatchOneOfAsc = 'WORKSPACE_BY_PARENT_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_ASC',
  WorkspaceByParentIdAssignIfExternalGroupsMatchOneOfDesc = 'WORKSPACE_BY_PARENT_ID__ASSIGN_IF_EXTERNAL_GROUPS_MATCH_ONE_OF_DESC',
  WorkspaceByParentIdConfigAsc = 'WORKSPACE_BY_PARENT_ID__CONFIG_ASC',
  WorkspaceByParentIdConfigDesc = 'WORKSPACE_BY_PARENT_ID__CONFIG_DESC',
  WorkspaceByParentIdCreatedAtAsc = 'WORKSPACE_BY_PARENT_ID__CREATED_AT_ASC',
  WorkspaceByParentIdCreatedAtDesc = 'WORKSPACE_BY_PARENT_ID__CREATED_AT_DESC',
  WorkspaceByParentIdCustomBrandUrlAsc = 'WORKSPACE_BY_PARENT_ID__CUSTOM_BRAND_URL_ASC',
  WorkspaceByParentIdCustomBrandUrlDesc = 'WORKSPACE_BY_PARENT_ID__CUSTOM_BRAND_URL_DESC',
  WorkspaceByParentIdCustomShareLinkAsc = 'WORKSPACE_BY_PARENT_ID__CUSTOM_SHARE_LINK_ASC',
  WorkspaceByParentIdCustomShareLinkDesc = 'WORKSPACE_BY_PARENT_ID__CUSTOM_SHARE_LINK_DESC',
  WorkspaceByParentIdDefaultLegalAppendixIdAsc = 'WORKSPACE_BY_PARENT_ID__DEFAULT_LEGAL_APPENDIX_ID_ASC',
  WorkspaceByParentIdDefaultLegalAppendixIdDesc = 'WORKSPACE_BY_PARENT_ID__DEFAULT_LEGAL_APPENDIX_ID_DESC',
  WorkspaceByParentIdEmailSubjectAsc = 'WORKSPACE_BY_PARENT_ID__EMAIL_SUBJECT_ASC',
  WorkspaceByParentIdEmailSubjectDesc = 'WORKSPACE_BY_PARENT_ID__EMAIL_SUBJECT_DESC',
  WorkspaceByParentIdEmailTextAsc = 'WORKSPACE_BY_PARENT_ID__EMAIL_TEXT_ASC',
  WorkspaceByParentIdEmailTextDesc = 'WORKSPACE_BY_PARENT_ID__EMAIL_TEXT_DESC',
  WorkspaceByParentIdFirebaseIdAsc = 'WORKSPACE_BY_PARENT_ID__FIREBASE_ID_ASC',
  WorkspaceByParentIdFirebaseIdDesc = 'WORKSPACE_BY_PARENT_ID__FIREBASE_ID_DESC',
  WorkspaceByParentIdFlagsAsc = 'WORKSPACE_BY_PARENT_ID__FLAGS_ASC',
  WorkspaceByParentIdFlagsDesc = 'WORKSPACE_BY_PARENT_ID__FLAGS_DESC',
  WorkspaceByParentIdHideProjectorButtonInPresentationAsc = 'WORKSPACE_BY_PARENT_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_ASC',
  WorkspaceByParentIdHideProjectorButtonInPresentationDesc = 'WORKSPACE_BY_PARENT_ID__HIDE_PROJECTOR_BUTTON_IN_PRESENTATION_DESC',
  WorkspaceByParentIdIdAsc = 'WORKSPACE_BY_PARENT_ID__ID_ASC',
  WorkspaceByParentIdIdDesc = 'WORKSPACE_BY_PARENT_ID__ID_DESC',
  WorkspaceByParentIdIsOpenAsc = 'WORKSPACE_BY_PARENT_ID__IS_OPEN_ASC',
  WorkspaceByParentIdIsOpenDesc = 'WORKSPACE_BY_PARENT_ID__IS_OPEN_DESC',
  WorkspaceByParentIdIsVisibleAsc = 'WORKSPACE_BY_PARENT_ID__IS_VISIBLE_ASC',
  WorkspaceByParentIdIsVisibleDesc = 'WORKSPACE_BY_PARENT_ID__IS_VISIBLE_DESC',
  WorkspaceByParentIdLaserPointerPositionAsc = 'WORKSPACE_BY_PARENT_ID__LASER_POINTER_POSITION_ASC',
  WorkspaceByParentIdLaserPointerPositionDesc = 'WORKSPACE_BY_PARENT_ID__LASER_POINTER_POSITION_DESC',
  WorkspaceByParentIdLinkPanelPositionAsc = 'WORKSPACE_BY_PARENT_ID__LINK_PANEL_POSITION_ASC',
  WorkspaceByParentIdLinkPanelPositionDesc = 'WORKSPACE_BY_PARENT_ID__LINK_PANEL_POSITION_DESC',
  WorkspaceByParentIdMemberCountAsc = 'WORKSPACE_BY_PARENT_ID__MEMBER_COUNT_ASC',
  WorkspaceByParentIdMemberCountDesc = 'WORKSPACE_BY_PARENT_ID__MEMBER_COUNT_DESC',
  WorkspaceByParentIdNameAsc = 'WORKSPACE_BY_PARENT_ID__NAME_ASC',
  WorkspaceByParentIdNameDesc = 'WORKSPACE_BY_PARENT_ID__NAME_DESC',
  WorkspaceByParentIdNameLowercaseAsc = 'WORKSPACE_BY_PARENT_ID__NAME_LOWERCASE_ASC',
  WorkspaceByParentIdNameLowercaseDesc = 'WORKSPACE_BY_PARENT_ID__NAME_LOWERCASE_DESC',
  WorkspaceByParentIdParentIdAsc = 'WORKSPACE_BY_PARENT_ID__PARENT_ID_ASC',
  WorkspaceByParentIdParentIdDesc = 'WORKSPACE_BY_PARENT_ID__PARENT_ID_DESC',
  WorkspaceByParentIdPersonalWorkspaceOfUserIdAsc = 'WORKSPACE_BY_PARENT_ID__PERSONAL_WORKSPACE_OF_USER_ID_ASC',
  WorkspaceByParentIdPersonalWorkspaceOfUserIdDesc = 'WORKSPACE_BY_PARENT_ID__PERSONAL_WORKSPACE_OF_USER_ID_DESC',
  WorkspaceByParentIdSysPeriodAsc = 'WORKSPACE_BY_PARENT_ID__SYS_PERIOD_ASC',
  WorkspaceByParentIdSysPeriodDesc = 'WORKSPACE_BY_PARENT_ID__SYS_PERIOD_DESC',
  WorkspaceByParentIdTagsAsc = 'WORKSPACE_BY_PARENT_ID__TAGS_ASC',
  WorkspaceByParentIdTagsDesc = 'WORKSPACE_BY_PARENT_ID__TAGS_DESC',
  WorkspaceByParentIdTeamRankAsc = 'WORKSPACE_BY_PARENT_ID__TEAM_RANK_ASC',
  WorkspaceByParentIdTeamRankDesc = 'WORKSPACE_BY_PARENT_ID__TEAM_RANK_DESC',
  WorkspaceByParentIdTenantIdAsc = 'WORKSPACE_BY_PARENT_ID__TENANT_ID_ASC',
  WorkspaceByParentIdTenantIdDesc = 'WORKSPACE_BY_PARENT_ID__TENANT_ID_DESC',
  WorkspaceByParentIdTotalMemberCountAsc = 'WORKSPACE_BY_PARENT_ID__TOTAL_MEMBER_COUNT_ASC',
  WorkspaceByParentIdTotalMemberCountDesc = 'WORKSPACE_BY_PARENT_ID__TOTAL_MEMBER_COUNT_DESC',
  WorkspaceByParentIdUpdatedAtAsc = 'WORKSPACE_BY_PARENT_ID__UPDATED_AT_ASC',
  WorkspaceByParentIdUpdatedAtDesc = 'WORKSPACE_BY_PARENT_ID__UPDATED_AT_DESC',
  WorkspaceByParentIdUserConfigDefaultsAsc = 'WORKSPACE_BY_PARENT_ID__USER_CONFIG_DEFAULTS_ASC',
  WorkspaceByParentIdUserConfigDefaultsDesc = 'WORKSPACE_BY_PARENT_ID__USER_CONFIG_DEFAULTS_DESC',
  WorkspaceSubscriptionsByTeamIdCountAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__COUNT_ASC',
  WorkspaceSubscriptionsByTeamIdCountDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__COUNT_DESC',
  WorkspaceSubscriptionsByTeamIdMaxCreatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_CREATED_AT_ASC',
  WorkspaceSubscriptionsByTeamIdMaxCreatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_CREATED_AT_DESC',
  WorkspaceSubscriptionsByTeamIdMaxCurrentStateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_CURRENT_STATE_ASC',
  WorkspaceSubscriptionsByTeamIdMaxCurrentStateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_CURRENT_STATE_DESC',
  WorkspaceSubscriptionsByTeamIdMaxIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMaxIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMaxIsManagedManuallyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_IS_MANAGED_MANUALLY_ASC',
  WorkspaceSubscriptionsByTeamIdMaxIsManagedManuallyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_IS_MANAGED_MANUALLY_DESC',
  WorkspaceSubscriptionsByTeamIdMaxIsSyncedWithExternalGroupsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  WorkspaceSubscriptionsByTeamIdMaxIsSyncedWithExternalGroupsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayAdministrateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_ADMINISTRATE_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayAdministrateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_ADMINISTRATE_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayBanUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_BAN_USERS_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayBanUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_BAN_USERS_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayCreateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_CREATE_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayCreateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_CREATE_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayDecideMembershipRequestsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayDecideMembershipRequestsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayDeleteAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_DELETE_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayDeleteDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_DELETE_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayInviteUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_INVITE_USERS_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayInviteUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_INVITE_USERS_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayModifyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_MODIFY_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayModifyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_MODIFY_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayOrderLicencesForThisTeamAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayOrderLicencesForThisTeamDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayPublishAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_PUBLISH_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayPublishDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_PUBLISH_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayTestAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_TEST_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayTestDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_TEST_DESC',
  WorkspaceSubscriptionsByTeamIdMaxMayViewAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_VIEW_ASC',
  WorkspaceSubscriptionsByTeamIdMaxMayViewDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_MAY_VIEW_DESC',
  WorkspaceSubscriptionsByTeamIdMaxSubteamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_SUBTEAM_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMaxSubteamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_SUBTEAM_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMaxSysPeriodAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_SYS_PERIOD_ASC',
  WorkspaceSubscriptionsByTeamIdMaxSysPeriodDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_SYS_PERIOD_DESC',
  WorkspaceSubscriptionsByTeamIdMaxTeamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_TEAM_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMaxTeamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_TEAM_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMaxUpdatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_UPDATED_AT_ASC',
  WorkspaceSubscriptionsByTeamIdMaxUpdatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_UPDATED_AT_DESC',
  WorkspaceSubscriptionsByTeamIdMaxUserIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_USER_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMaxUserIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MAX_USER_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMinCreatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_CREATED_AT_ASC',
  WorkspaceSubscriptionsByTeamIdMinCreatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_CREATED_AT_DESC',
  WorkspaceSubscriptionsByTeamIdMinCurrentStateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_CURRENT_STATE_ASC',
  WorkspaceSubscriptionsByTeamIdMinCurrentStateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_CURRENT_STATE_DESC',
  WorkspaceSubscriptionsByTeamIdMinIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMinIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMinIsManagedManuallyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_IS_MANAGED_MANUALLY_ASC',
  WorkspaceSubscriptionsByTeamIdMinIsManagedManuallyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_IS_MANAGED_MANUALLY_DESC',
  WorkspaceSubscriptionsByTeamIdMinIsSyncedWithExternalGroupsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_ASC',
  WorkspaceSubscriptionsByTeamIdMinIsSyncedWithExternalGroupsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_IS_SYNCED_WITH_EXTERNAL_GROUPS_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayAdministrateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_ADMINISTRATE_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayAdministrateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_ADMINISTRATE_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayBanUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_BAN_USERS_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayBanUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_BAN_USERS_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayCreateAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_CREATE_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayCreateDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_CREATE_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayDecideMembershipRequestsAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayDecideMembershipRequestsDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_DECIDE_MEMBERSHIP_REQUESTS_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayDeleteAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_DELETE_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayDeleteDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_DELETE_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayInviteUsersAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_INVITE_USERS_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayInviteUsersDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_INVITE_USERS_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayModifyAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_MODIFY_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayModifyDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_MODIFY_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayOrderLicencesForThisTeamAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayOrderLicencesForThisTeamDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_ORDER_LICENCES_FOR_THIS_TEAM_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayPublishAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_PUBLISH_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayPublishDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_PUBLISH_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayTestAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_TEST_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayTestDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_TEST_DESC',
  WorkspaceSubscriptionsByTeamIdMinMayViewAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_VIEW_ASC',
  WorkspaceSubscriptionsByTeamIdMinMayViewDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_MAY_VIEW_DESC',
  WorkspaceSubscriptionsByTeamIdMinSubteamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_SUBTEAM_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMinSubteamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_SUBTEAM_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMinSysPeriodAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_SYS_PERIOD_ASC',
  WorkspaceSubscriptionsByTeamIdMinSysPeriodDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_SYS_PERIOD_DESC',
  WorkspaceSubscriptionsByTeamIdMinTeamIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_TEAM_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMinTeamIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_TEAM_ID_DESC',
  WorkspaceSubscriptionsByTeamIdMinUpdatedAtAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_UPDATED_AT_ASC',
  WorkspaceSubscriptionsByTeamIdMinUpdatedAtDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_UPDATED_AT_DESC',
  WorkspaceSubscriptionsByTeamIdMinUserIdAsc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_USER_ID_ASC',
  WorkspaceSubscriptionsByTeamIdMinUserIdDesc = 'WORKSPACE_SUBSCRIPTIONS_BY_TEAM_ID__MIN_USER_ID_DESC'
}

/** All input for the create mn`DocumentSpaceItem` mutation. */
export type MnCreateDocumentSpaceItemInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `DocumentSpaceItem` to be created by this mutation. */
  mnDocumentSpaceItem?: InputMaybe<Array<DocumentSpaceItemInput>>;
};

/** The output of our many create `DocumentSpaceItem` mutation. */
export type MnCreateDocumentSpaceItemPayload = {
  __typename?: 'mnCreateDocumentSpaceItemPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceItem` that was created by this mutation. */
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  /** An edge for our `DocumentSpaceItem`. May be used by Relay 1. */
  documentSpaceItemEdge?: Maybe<DocumentSpaceItemsEdge>;
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
};


/** The output of our many create `DocumentSpaceItem` mutation. */
export type MnCreateDocumentSpaceItemPayloadDocumentSpaceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/** All input for the create mn`Membership` mutation. */
export type MnCreateMembershipInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Membership` to be created by this mutation. */
  mnMembership?: InputMaybe<Array<MembershipInput>>;
};

/** The output of our many create `Membership` mutation. */
export type MnCreateMembershipPayload = {
  __typename?: 'mnCreateMembershipPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Membership` that was created by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our many create `Membership` mutation. */
export type MnCreateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the create mn`WorkspaceSubscription` mutation. */
export type MnCreateWorkspaceSubscriptionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `WorkspaceSubscription` to be created by this mutation. */
  mnWorkspaceSubscription?: InputMaybe<Array<WorkspaceSubscriptionInput>>;
};

/** The output of our many create `WorkspaceSubscription` mutation. */
export type MnCreateWorkspaceSubscriptionPayload = {
  __typename?: 'mnCreateWorkspaceSubscriptionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  /** The `WorkspaceSubscription` that was created by this mutation. */
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** An edge for our `WorkspaceSubscription`. May be used by Relay 1. */
  workspaceSubscriptionEdge?: Maybe<WorkspaceSubscriptionsEdge>;
};


/** The output of our many create `WorkspaceSubscription` mutation. */
export type MnCreateWorkspaceSubscriptionPayloadWorkspaceSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

/** All input for the delete `mnDeleteDocumentSpaceItem` mutation. */
export type MnDeleteDocumentSpaceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `DocumentSpaceItem` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<DocumentSpaceItemPatch>>;
};

/** The output of our delete mn `DocumentSpaceItem` mutation. */
export type MnDeleteDocumentSpaceItemPayload = {
  __typename?: 'mnDeleteDocumentSpaceItemPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDocumentSpaceItemNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceItem` that was deleted by this mutation. */
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  /** An edge for our `DocumentSpaceItem`. May be used by Relay 1. */
  documentSpaceItemEdge?: Maybe<DocumentSpaceItemsEdge>;
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
};


/** The output of our delete mn `DocumentSpaceItem` mutation. */
export type MnDeleteDocumentSpaceItemPayloadDocumentSpaceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/** All input for the delete `mnDeleteMembership` mutation. */
export type MnDeleteMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Membership` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<MembershipPatch>>;
};

/** The output of our delete mn `Membership` mutation. */
export type MnDeleteMembershipPayload = {
  __typename?: 'mnDeleteMembershipPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMembershipNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Membership` that was deleted by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our delete mn `Membership` mutation. */
export type MnDeleteMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the delete `mnDeleteWorkspaceSubscription` mutation. */
export type MnDeleteWorkspaceSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `WorkspaceSubscription` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<WorkspaceSubscriptionPatch>>;
};

/** The output of our delete mn `WorkspaceSubscription` mutation. */
export type MnDeleteWorkspaceSubscriptionPayload = {
  __typename?: 'mnDeleteWorkspaceSubscriptionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWorkspaceSubscriptionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  /** The `WorkspaceSubscription` that was deleted by this mutation. */
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** An edge for our `WorkspaceSubscription`. May be used by Relay 1. */
  workspaceSubscriptionEdge?: Maybe<WorkspaceSubscriptionsEdge>;
};


/** The output of our delete mn `WorkspaceSubscription` mutation. */
export type MnDeleteWorkspaceSubscriptionPayloadWorkspaceSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

/** All input for the update `mnUpdateDocumentSpaceItem` mutation. */
export type MnUpdateDocumentSpaceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `DocumentSpaceItem` to be updated. */
  mnPatch?: InputMaybe<Array<DocumentSpaceItemPatch>>;
};

/** The output of our update mn `DocumentSpaceItem` mutation. */
export type MnUpdateDocumentSpaceItemPayload = {
  __typename?: 'mnUpdateDocumentSpaceItemPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Document` that is related to this `DocumentSpaceItem`. */
  document?: Maybe<Document>;
  /** Reads a single `DocumentSpace` that is related to this `DocumentSpaceItem`. */
  documentSpace?: Maybe<DocumentSpace>;
  /** The `DocumentSpaceItem` that was updated by this mutation. */
  documentSpaceItem?: Maybe<DocumentSpaceItem>;
  /** An edge for our `DocumentSpaceItem`. May be used by Relay 1. */
  documentSpaceItemEdge?: Maybe<DocumentSpaceItemsEdge>;
  /** Reads a single `Flow` that is related to this `DocumentSpaceItem`. */
  flow?: Maybe<Flow>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentSpaceSection` that is related to this `DocumentSpaceItem`. */
  section?: Maybe<DocumentSpaceSection>;
};


/** The output of our update mn `DocumentSpaceItem` mutation. */
export type MnUpdateDocumentSpaceItemPayloadDocumentSpaceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentSpaceItemsOrderBy>>;
};

/** All input for the update `mnUpdateMembership` mutation. */
export type MnUpdateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Membership` to be updated. */
  mnPatch?: InputMaybe<Array<MembershipPatch>>;
};

/** The output of our update mn `Membership` mutation. */
export type MnUpdateMembershipPayload = {
  __typename?: 'mnUpdateMembershipPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Membership` that was updated by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `Membership`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Team` that is related to this `Membership`. */
  team?: Maybe<Team>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our update mn `Membership` mutation. */
export type MnUpdateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the update `mnUpdateWorkspaceSubscription` mutation. */
export type MnUpdateWorkspaceSubscriptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `WorkspaceSubscription` to be updated. */
  mnPatch?: InputMaybe<Array<WorkspaceSubscriptionPatch>>;
};

/** The output of our update mn `WorkspaceSubscription` mutation. */
export type MnUpdateWorkspaceSubscriptionPayload = {
  __typename?: 'mnUpdateWorkspaceSubscriptionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Team` that is related to this `WorkspaceSubscription`. */
  subteam?: Maybe<Team>;
  /** Reads a single `Workspace` that is related to this `WorkspaceSubscription`. */
  team?: Maybe<Workspace>;
  /** Reads a single `User` that is related to this `WorkspaceSubscription`. */
  user?: Maybe<User>;
  /** The `WorkspaceSubscription` that was updated by this mutation. */
  workspaceSubscription?: Maybe<WorkspaceSubscription>;
  /** An edge for our `WorkspaceSubscription`. May be used by Relay 1. */
  workspaceSubscriptionEdge?: Maybe<WorkspaceSubscriptionsEdge>;
};


/** The output of our update mn `WorkspaceSubscription` mutation. */
export type MnUpdateWorkspaceSubscriptionPayloadWorkspaceSubscriptionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkspaceSubscriptionsOrderBy>>;
};

export type CreateUserFromFirebaseMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateUserFromFirebaseMutation = { __typename?: 'Mutation', createUserFromFirebase?: { __typename?: 'CreateUserFromFirebasePayload', result?: { __typename?: 'CreateUserFromFirebaseRecord', me?: { __typename?: 'User', firebaseAuthId?: string | null, email: string } | null } | null } | null };

export type AcceptAppConsentMutationVariables = Exact<{
  now: Scalars['Datetime']['input'];
  id: Scalars['BigInt']['input'];
}>;


export type AcceptAppConsentMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', clientMutationId?: string | null } | null };

export type DocumentSpaceSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type DocumentSpaceSearchQuery = { __typename?: 'Query', documentSpaces?: { __typename?: 'DocumentSpacesConnection', nodes: Array<{ __typename?: 'DocumentSpace', id: string, name?: string | null, createdAt: any, updatedAt: any } | null> } | null };

export type DocumentSpacePickerQueryVariables = Exact<{
  search: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type DocumentSpacePickerQuery = { __typename?: 'Query', documentSpaces?: { __typename?: 'DocumentSpacesConnection', nodes: Array<{ __typename?: 'DocumentSpace', id: string, name?: string | null, createdAt: any, updatedAt: any, documentSpaceItems: { __typename?: 'DocumentSpaceItemsConnection', nodes: Array<{ __typename?: 'DocumentSpaceItem', documentId?: string | null } | null> }, config?: { __typename?: 'DocumentSpaceConfig', name?: string | null } | null } | null> } | null };

export type DownloadableDocumentFragment = { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, isDownloadable: boolean, doesSupportFlows: boolean, isUnbranded: boolean, externalId?: string | null, expirationDate?: any | null, tags: Array<string | null>, fileName: string, firestoreId: string, numNormalPages: number, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, displayDate: any, fileSize: string, thumbnailDownloadUrl: string, originalMimeType?: string | null, workspace?: { __typename?: 'Workspace', id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, rootWorkspace?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null };

export type IncludeMagicPagesFragment = { __typename?: 'Document', documentRevisionByIdAndCurrentRevisionNumber?: { __typename?: 'DocumentRevision', documentPagesByDocumentIdAndRevisionNumber: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, pageType: PageType, pageNumber: number, linkedDocument?: { __typename?: 'Document', id: string, firestoreId: string } | null } | null> } } | null };

export type GetDocumentByIdQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type GetDocumentByIdQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, isDownloadable: boolean, doesSupportFlows: boolean, isUnbranded: boolean, externalId?: string | null, expirationDate?: any | null, tags: Array<string | null>, fileName: string, firestoreId: string, numNormalPages: number, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, displayDate: any, fileSize: string, thumbnailDownloadUrl: string, originalMimeType?: string | null, workspace?: { __typename?: 'Workspace', id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, rootWorkspace?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, documentRevisionByIdAndCurrentRevisionNumber?: { __typename?: 'DocumentRevision', documentPagesByDocumentIdAndRevisionNumber: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, pageType: PageType, pageNumber: number, linkedDocument?: { __typename?: 'Document', id: string, firestoreId: string } | null } | null> } } | null } | null };

export type GetDocumentByFirestoreIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDocumentByFirestoreIdQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, isDownloadable: boolean, doesSupportFlows: boolean, isUnbranded: boolean, externalId?: string | null, expirationDate?: any | null, tags: Array<string | null>, fileName: string, firestoreId: string, numNormalPages: number, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, displayDate: any, fileSize: string, thumbnailDownloadUrl: string, originalMimeType?: string | null, workspace?: { __typename?: 'Workspace', id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, rootWorkspace?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, documentRevisionByIdAndCurrentRevisionNumber?: { __typename?: 'DocumentRevision', documentPagesByDocumentIdAndRevisionNumber: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, pageType: PageType, pageNumber: number, linkedDocument?: { __typename?: 'Document', id: string, firestoreId: string } | null } | null> } } | null } | null };

export type GetTeamCandidatesQueryVariables = Exact<{
  search: Scalars['String']['input'];
  tenantId: Scalars['BigInt']['input'];
  teamId: Scalars['BigInt']['input'];
}>;


export type GetTeamCandidatesQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', id: string, name: string, users: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, displayName?: string | null, email: string, memberships: { __typename?: 'MembershipsConnection', nodes: Array<{ __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean } | null> } } | null> } } | null };

export type DocumentHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocumentHistoryQuery = { __typename?: 'Query', documentHistoryEntries?: { __typename?: 'DocumentHistoryEntriesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'DocumentHistoryEntry', id: string, runId?: string | null, date?: any | null, startsAt?: any | null, endsAt?: any | null, document?: { __typename?: 'Document', id: string, thumbnailDownloadUrl: string, displayTitle: string } | null, duration?: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null } | null, activeDuration?: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null } | null, label?: { __typename?: 'LabelsOfDocumentView', assignmentRevision: string, hcpCount: number, text: string, crmContactId?: string | null, hcpContacts: { __typename?: 'CrmContactsConnection', nodes: Array<{ __typename?: 'CrmContact', id: string, firstName?: string | null, lastName: string } | null> }, crmContact?: { __typename?: 'CrmContact', lastName: string, firstName?: string | null } | null } | null } | null> } | null };

export type NumUnlabeledDocumentViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type NumUnlabeledDocumentViewsQuery = { __typename?: 'Query', documentHistoryEntries?: { __typename?: 'DocumentHistoryEntriesConnection', totalCount: number } | null };

export type MarkAsVisitMutationVariables = Exact<{
  documentViewIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type MarkAsVisitMutation = { __typename?: 'Mutation', markAsVisit?: { __typename?: 'MarkAsVisitPayload', clientMutationId?: string | null } | null };

export type MarkAsSelfStudyMutationVariables = Exact<{
  documentViewIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type MarkAsSelfStudyMutation = { __typename?: 'Mutation', markAsSelfStudy?: { __typename?: 'MarkAsSelfStudyPayload', clientMutationId?: string | null } | null };

export type DocumentSearchResultFragment = { __typename?: 'Document', displayTitle: string, mimeType: string, originalMimeType?: string | null, pages: number, id: string, doesSupportSharedspace: boolean, thumbnailDownloadUrl: string, doesSupportFlows: boolean, tags: Array<string | null>, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, id: string, name: string } | null, workspace?: { __typename?: 'Workspace', name: string, parentId?: string | null } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null };

export type SearchDocumentsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  mustBeAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  rootId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type SearchDocumentsQuery = { __typename?: 'Query', searchDocuments?: { __typename?: 'MatchingDocumentsConnection', nodes: Array<{ __typename?: 'MatchingDocument', matchInDisplayTitle?: string | null, document?: { __typename?: 'Document', displayTitle: string, mimeType: string, originalMimeType?: string | null, pages: number, id: string, doesSupportSharedspace: boolean, thumbnailDownloadUrl: string, doesSupportFlows: boolean, tags: Array<string | null>, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, id: string, name: string } | null, workspace?: { __typename?: 'Workspace', name: string, parentId?: string | null } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null> } | null };

export type DocumentsByWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['BigInt']['input'];
}>;


export type DocumentsByWorkspaceQuery = { __typename?: 'Query', documents?: { __typename?: 'DocumentsConnection', nodes: Array<{ __typename?: 'Document', displayTitle: string, mimeType: string, originalMimeType?: string | null, pages: number, id: string, doesSupportSharedspace: boolean, thumbnailDownloadUrl: string, doesSupportFlows: boolean, tags: Array<string | null>, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, id: string, name: string } | null, workspace?: { __typename?: 'Workspace', name: string, parentId?: string | null } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null> } | null };

export type DocumentsSharedWithCrmContactQueryVariables = Exact<{
  crmContactId: Scalars['BigInt']['input'];
  documentSpaceId: Scalars['BigInt']['input'];
}>;


export type DocumentsSharedWithCrmContactQuery = { __typename?: 'Query', crmContact?: { __typename?: 'CrmContact', documentsSharedWithContact: { __typename?: 'DocumentsConnection', nodes: Array<{ __typename?: 'Document', id: string } | null> } } | null };

export type WorkspaceForDocumentQueryVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
}>;


export type WorkspaceForDocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', workspaceId: string, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, id: string } | null } | null };

export type AllDocumentSpaceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDocumentSpaceConfigsQuery = { __typename?: 'Query', myAdministratedTeams?: { __typename?: 'TeamsConnection', nodes: Array<{ __typename?: 'Team', id: string, name: string, tenant?: { __typename?: 'Tenant', id: string } | null, documentSpaceConfigs: { __typename?: 'DocumentSpaceConfigsConnection', nodes: Array<{ __typename?: 'DocumentSpaceConfig', id: string, groupId: string, name?: string | null, logoUrl?: string | null, heroImageUrl?: string | null, updatedAt: any, spaceCount?: number | null, tenantGroup?: { __typename?: 'DocumentSpaceLinkGroup', name: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null> } } | null> } | null };

export type DocumentSpaceConfigQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DocumentSpaceConfigQuery = { __typename?: 'Query', documentSpaceConfig?: { __typename?: 'DocumentSpaceConfig', id: string, createdAt: any, groupId: string, defaultLanguage: string, displayOptOut: boolean, footerLinks?: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null> | null, footerText?: string | null, heroImageUrl?: string | null, heroLinkText?: string | null, heroLinkUrl?: string | null, heroSubtitle?: string | null, heroTitle?: string | null, legalNote?: string | null, legalNoteUrl?: string | null, logoUrl?: string | null, name?: string | null, title?: string | null, productName?: string | null, indication?: string | null, linkedTabOrder: number, newTab?: boolean | null, requiresEmailAuthentication: boolean, spaceCount?: number | null, teamId?: string | null, updatedAt: any, team?: { __typename?: 'Team', name: string } | null, documentSpaceLinksByConfigId: { __typename?: 'DocumentSpaceLinksConnection', nodes: Array<{ __typename?: 'DocumentSpaceLink', isMandatory: boolean, position?: any | null, sectionTitle?: string | null, title: string, url: string, id: string, nodeId: string, documentSpaceLinkTranslationsByLinkId: { __typename?: 'DocumentSpaceLinkTranslationsConnection', nodes: Array<{ __typename?: 'DocumentSpaceLinkTranslation', id: string, languageCode: string, sectionTitle?: string | null, url: string, title: string } | null> } } | null> }, documentSpaceConfigTranslationsByConfigId: { __typename?: 'DocumentSpaceConfigTranslationsConnection', nodes: Array<{ __typename?: 'DocumentSpaceConfigTranslation', languageCode: string, id: string, heroImageUrl?: string | null, heroLinkUrl?: string | null, heroTitle?: string | null, footerText?: string | null, legalNote?: string | null, legalNoteUrl?: string | null, footerLinks?: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null> | null } | null> } } | null };

export type UpdateDocumentSpaceConfigBannerMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentSpaceConfigBannerMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigNameMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateDocumentSpaceConfigNameMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigSettingsMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  indication?: InputMaybe<Scalars['String']['input']>;
  requiresEmailAuthentication: Scalars['Boolean']['input'];
  groupId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type UpdateDocumentSpaceConfigSettingsMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigTranslationBannerMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  heroLinkUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentSpaceConfigTranslationBannerMutation = { __typename?: 'Mutation', updateDocumentSpaceConfigTranslation?: { __typename?: 'UpdateDocumentSpaceConfigTranslationPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigLinkMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  isMandatory: Scalars['Boolean']['input'];
}>;


export type UpdateDocumentSpaceConfigLinkMutation = { __typename?: 'Mutation', updateDocumentSpaceLink?: { __typename?: 'UpdateDocumentSpaceLinkPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigLinkTranslationMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
}>;


export type UpdateDocumentSpaceConfigLinkTranslationMutation = { __typename?: 'Mutation', updateDocumentSpaceLinkTranslation?: { __typename?: 'UpdateDocumentSpaceLinkTranslationPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigFooterMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  footerText?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentSpaceConfigFooterMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigTranslationFooterMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  footerText?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentSpaceConfigTranslationFooterMutation = { __typename?: 'Mutation', updateDocumentSpaceConfigTranslation?: { __typename?: 'UpdateDocumentSpaceConfigTranslationPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigFooterLinksMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateDocumentSpaceConfigFooterLinksMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigTranslationFooterLinksMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  footerLinks?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateDocumentSpaceConfigTranslationFooterLinksMutation = { __typename?: 'Mutation', updateDocumentSpaceConfigTranslation?: { __typename?: 'UpdateDocumentSpaceConfigTranslationPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigLegalNoteMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  legalNote?: InputMaybe<Scalars['String']['input']>;
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentSpaceConfigLegalNoteMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigTranslationLegalNoteMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  legalNote?: InputMaybe<Scalars['String']['input']>;
  legalNoteUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentSpaceConfigTranslationLegalNoteMutation = { __typename?: 'Mutation', updateDocumentSpaceConfigTranslation?: { __typename?: 'UpdateDocumentSpaceConfigTranslationPayload', clientMutationId?: string | null } | null };

export type DeleteDocumentSpaceConfigLinkMutationVariables = Exact<{
  linkId: Scalars['BigInt']['input'];
}>;


export type DeleteDocumentSpaceConfigLinkMutation = { __typename?: 'Mutation', deleteDocumentSpaceLink?: { __typename?: 'DeleteDocumentSpaceLinkPayload', clientMutationId?: string | null } | null };

export type CreateDocumentSpaceConfigLinkMutationVariables = Exact<{
  configId: Scalars['BigInt']['input'];
  url: Scalars['String']['input'];
  title: Scalars['String']['input'];
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  isMandatory: Scalars['Boolean']['input'];
}>;


export type CreateDocumentSpaceConfigLinkMutation = { __typename?: 'Mutation', createDocumentSpaceLink?: { __typename?: 'CreateDocumentSpaceLinkPayload', clientMutationId?: string | null, documentSpaceLink?: { __typename?: 'DocumentSpaceLink', id: string } | null } | null };

export type CreateDocumentSpaceConfigLinkTranslationMutationVariables = Exact<{
  linkId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
  url: Scalars['String']['input'];
  title: Scalars['String']['input'];
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDocumentSpaceConfigLinkTranslationMutation = { __typename?: 'Mutation', createDocumentSpaceLinkTranslation?: { __typename?: 'CreateDocumentSpaceLinkTranslationPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceConfigLogoMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  logoUrl: Scalars['String']['input'];
}>;


export type UpdateDocumentSpaceConfigLogoMutation = { __typename?: 'Mutation', updateDocumentSpaceConfig?: { __typename?: 'UpdateDocumentSpaceConfigPayload', clientMutationId?: string | null } | null };

export type CopyDocumentSpaceConfigMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
  teamId: Scalars['BigInt']['input'];
  copyTranslations: Scalars['Boolean']['input'];
  compatibilityGroupId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type CopyDocumentSpaceConfigMutation = { __typename?: 'Mutation', copyDocumentSpaceConfig?: { __typename?: 'CopyDocumentSpaceConfigPayload', newConfig?: { __typename?: 'DocumentSpaceConfig', id: string, name?: string | null } | null } | null };

export type CreateDocumentSpaceConfigWithDefaultsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  teamId: Scalars['BigInt']['input'];
  compatibilityGroupId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type CreateDocumentSpaceConfigWithDefaultsMutation = { __typename?: 'Mutation', createDocumentSpaceConfigWithDefaults?: { __typename?: 'CreateDocumentSpaceConfigWithDefaultsPayload', newConfig?: { __typename?: 'DocumentSpaceConfig', id: string, name?: string | null } | null } | null };

export type DeleteSharedSpaceTemplateMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  replacementConfigId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type DeleteSharedSpaceTemplateMutation = { __typename?: 'Mutation', deleteSharedSpaceTemplate?: { __typename?: 'DeleteSharedSpaceTemplatePayload', result?: { __typename?: 'DeleteSharedSpaceTemplateRecord', deletedConfigId?: string | null, usedReplacementConfigId?: string | null, affectedSpaceCount?: number | null, status?: string | null } | null } | null };

export type DocumentSpaceCompatibilityGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentSpaceCompatibilityGroupsQuery = { __typename?: 'Query', documentSpaceLinkGroups?: { __typename?: 'DocumentSpaceLinkGroupsConnection', nodes: Array<{ __typename?: 'DocumentSpaceLinkGroup', id: string, name: string, tenantId: string } | null> } | null };

export type CreateDocumentSpaceConfigTranslationMutationVariables = Exact<{
  configId: Scalars['BigInt']['input'];
  languageCode: Scalars['String']['input'];
}>;


export type CreateDocumentSpaceConfigTranslationMutation = { __typename?: 'Mutation', createDocumentSpaceConfigTranslation?: { __typename?: 'CreateDocumentSpaceConfigTranslationPayload', clientMutationId?: string | null, documentSpaceConfigTranslation?: { __typename?: 'DocumentSpaceConfigTranslation', id: string, languageCode: string } | null } | null };

export type DeleteDocumentSpaceConfigTranslationMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteDocumentSpaceConfigTranslationMutation = { __typename?: 'Mutation', deleteDocumentSpaceConfigTranslation?: { __typename?: 'DeleteDocumentSpaceConfigTranslationPayload', clientMutationId?: string | null } | null };

export type WorkspaceDocumentFragment = { __typename?: 'Document', fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, originalStorageId?: string | null, order: any, pages: number, storageId: string, teaserText: string, tags: Array<string | null>, thumbnailDownloadUrl: string, topTitle: string, isPublished: boolean, isUnbranded: boolean, doesSupportSharedspace: boolean, doesSupportFlows: boolean, numNormalPages: number, workspaceId: string, isDownloadable: boolean, allowUserDownload: boolean, externalId?: string | null, displayTeaserTextInSpace: boolean, expirationDate?: any | null, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, workspace?: { __typename?: 'Workspace', name: string, mayUseUrlBasedDocumentImport: boolean } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null };

export type WorkspaceDocumentWithLinkingPagesFragment = { __typename?: 'Document', importSource?: string | null, fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, originalStorageId?: string | null, order: any, pages: number, storageId: string, teaserText: string, tags: Array<string | null>, thumbnailDownloadUrl: string, topTitle: string, isPublished: boolean, isUnbranded: boolean, doesSupportSharedspace: boolean, doesSupportFlows: boolean, numNormalPages: number, workspaceId: string, isDownloadable: boolean, allowUserDownload: boolean, externalId?: string | null, displayTeaserTextInSpace: boolean, expirationDate?: any | null, linkingPages: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, pageNumber: number, document?: { __typename?: 'Document', displayTitle: string, id: string, firestoreId: string, thumbnailDownloadUrl: string, workspace?: { __typename?: 'Workspace', id: string } | null } | null } | null> }, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, workspace?: { __typename?: 'Workspace', name: string, mayUseUrlBasedDocumentImport: boolean } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null };

export type ShortDocumentFragment = { __typename?: 'Document', fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, order: any, pages: number };

export type WorkspaceDocumentsQueryVariables = Exact<{
  workspaceId: Scalars['BigInt']['input'];
}>;


export type WorkspaceDocumentsQuery = { __typename?: 'Query', documents?: { __typename?: 'DocumentsConnection', nodes: Array<{ __typename?: 'Document', fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, originalStorageId?: string | null, order: any, pages: number, storageId: string, teaserText: string, tags: Array<string | null>, thumbnailDownloadUrl: string, topTitle: string, isPublished: boolean, isUnbranded: boolean, doesSupportSharedspace: boolean, doesSupportFlows: boolean, numNormalPages: number, workspaceId: string, isDownloadable: boolean, allowUserDownload: boolean, externalId?: string | null, displayTeaserTextInSpace: boolean, expirationDate?: any | null, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, workspace?: { __typename?: 'Workspace', name: string, mayUseUrlBasedDocumentImport: boolean } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null> } | null };

export type DocumentQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', deletedAt?: any | null, importSource?: string | null, fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, originalStorageId?: string | null, order: any, pages: number, storageId: string, teaserText: string, tags: Array<string | null>, thumbnailDownloadUrl: string, topTitle: string, isPublished: boolean, isUnbranded: boolean, doesSupportSharedspace: boolean, doesSupportFlows: boolean, numNormalPages: number, workspaceId: string, isDownloadable: boolean, allowUserDownload: boolean, externalId?: string | null, displayTeaserTextInSpace: boolean, expirationDate?: any | null, rootWorkspace?: { __typename?: 'Workspace', id: string, isHcpUploadWorkspace: boolean, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, linkingPages: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, pageNumber: number, document?: { __typename?: 'Document', displayTitle: string, id: string, firestoreId: string, thumbnailDownloadUrl: string, workspace?: { __typename?: 'Workspace', id: string } | null } | null } | null> }, workspace?: { __typename?: 'Workspace', name: string, mayUseUrlBasedDocumentImport: boolean } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null, documentUsageCounts?: { __typename?: 'DocumentUsageCountsRecord', numCustomFlows?: number | null, numPresentations?: number | null, numSpaces?: number | null } | null };

export type DocumentEditorShellQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DocumentEditorShellQuery = { __typename?: 'Query', document?: { __typename?: 'Document', deletedAt?: any | null, fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, originalStorageId?: string | null, order: any, pages: number, storageId: string, teaserText: string, tags: Array<string | null>, thumbnailDownloadUrl: string, topTitle: string, isPublished: boolean, isUnbranded: boolean, doesSupportSharedspace: boolean, doesSupportFlows: boolean, numNormalPages: number, workspaceId: string, isDownloadable: boolean, allowUserDownload: boolean, externalId?: string | null, displayTeaserTextInSpace: boolean, expirationDate?: any | null, rootWorkspace?: { __typename?: 'Workspace', id: string, isHcpUploadWorkspace: boolean, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, workspace?: { __typename?: 'Workspace', name: string, mayUseUrlBasedDocumentImport: boolean } | null, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null };

export type ShortDocumentQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type ShortDocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', fileName: string, displayTitle: string, firestoreId: string, fileSize: string, downloadUrl: string, displayDate: any, id: string, lastModifiedAt: any, mimeType: string, originalMimeType?: string | null, order: any, pages: number } | null };

export type DocumentRevisionCheckQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DocumentRevisionCheckQuery = { __typename?: 'Query', document?: { __typename?: 'Document', mimeType: string, isProcessing: boolean, currentRevisionNumber?: number | null, documentRevisions: { __typename?: 'DocumentRevisionsConnection', nodes: Array<{ __typename?: 'DocumentRevision', revisionNumber: number, hasProcessingError: boolean } | null> } } | null };

export type CreateDocumentMutationVariables = Exact<{
  document: DocumentInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument?: { __typename?: 'CreateDocumentPayload', document?: { __typename?: 'Document', id: string, firestoreId: string } | null } | null };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  patch: DocumentPatch;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument?: { __typename?: 'UpdateDocumentPayload', document?: { __typename?: 'Document', id: string } | null } | null };

export type MoveDocumentMutationVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
  toWorkspaceId: Scalars['BigInt']['input'];
}>;


export type MoveDocumentMutation = { __typename?: 'Mutation', updateDocument?: { __typename?: 'UpdateDocumentPayload', document?: { __typename?: 'Document', id: string, workspaceId: string } | null } | null };

export type CopyDocumentMutationVariables = Exact<{
  newName: Scalars['String']['input'];
  targetWorkspaceId: Scalars['BigInt']['input'];
  withId: Scalars['BigInt']['input'];
}>;


export type CopyDocumentMutation = { __typename?: 'Mutation', copyDocument?: { __typename?: 'CopyDocumentPayload', clientMutationId?: string | null, copiedDocument?: { __typename?: 'Document', id: string } | null } | null };

export type ReorderDocumentMutationVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
  aboveId?: InputMaybe<Scalars['BigInt']['input']>;
  belowId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type ReorderDocumentMutation = { __typename?: 'Mutation', placeDocument?: { __typename?: 'PlaceDocumentPayload', documents?: Array<{ __typename?: 'Document', id: string } | null> | null } | null };

export type AllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsQuery = { __typename?: 'Query', alreadyUsedTagsList?: Array<string | null> | null };

export type DocumentUsageCountsQueryVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
}>;


export type DocumentUsageCountsQuery = { __typename?: 'Query', documentUsageCounts?: { __typename?: 'DocumentUsageCountsRecord', numCustomFlows?: number | null, numPresentations?: number | null, numSpaces?: number | null } | null };

export type ExternalDocumentFragment = { __typename?: 'Document', id: string, veevaDocumentMetadatum?: { __typename?: 'VeevaDocumentMetadatum', veevaDocumentId: string } | null, workspace?: { __typename?: 'Workspace', name: string, id: string, root?: { __typename?: 'Workspace', id: string } | null } | null };

export type FindVeevaDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindVeevaDocumentsQuery = { __typename?: 'Query', documents?: { __typename?: 'DocumentsConnection', nodes: Array<{ __typename?: 'Document', id: string, veevaDocumentMetadatum?: { __typename?: 'VeevaDocumentMetadatum', veevaDocumentId: string } | null, workspace?: { __typename?: 'Workspace', name: string, id: string, root?: { __typename?: 'Workspace', id: string } | null } | null } | null> } | null };

export type VeevaDocumentMetadataQueryVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
}>;


export type VeevaDocumentMetadataQuery = { __typename?: 'Query', veevaDocumentMetadata?: { __typename?: 'VeevaDocumentMetadataConnection', nodes: Array<{ __typename?: 'VeevaDocumentMetadatum', expirationDate?: any | null, majorVersion: number, minorVersion: number, versionCreationDate?: any | null, veevaDocumentId: string, documentNumber?: string | null } | null> } | null };

export type FetchCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentUserQuery = { __typename?: 'Query', myAccount?: { __typename?: 'UsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, displayName?: string | null, email: string, externalGroupsSyncedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, hasExternalGroups: boolean } | null } | null> } | null };

export type CreateWorkspaceMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspaceAndJoin?: { __typename?: 'CreateWorkspaceAndJoinPayload', result?: { __typename?: 'CreateWorkspaceAndJoinRecord', createdWorkspace?: { __typename?: 'Workspace', id: string, name: string } | null } | null } | null };

export type MyWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWorkspacesQuery = { __typename?: 'Query', workspaces?: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', name: string, id: string, tags?: Array<string | null> | null, parentId?: string | null, firebaseId: string, isHcpUploadWorkspace: boolean, root?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null } | null> } | null };

export type RootWorkspaceFragment = { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null };

export type MyRootWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRootWorkspacesQuery = { __typename?: 'Query', workspaces?: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null> } | null };

export type RootWorkspaceWithChildrenFragment = { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, tags?: Array<string | null> | null, parentId?: string | null, childWorkspaces: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, parentId?: string | null, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null, documents: { __typename?: 'DocumentsConnection', totalCount: number }, childWorkspaces: { __typename?: 'WorkspacesConnection', totalCount: number } } | null> }, root?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, descendants: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', id: string, name: string } | null> } };

export type RootWorkspacesWithChildrenQueryVariables = Exact<{ [key: string]: never; }>;


export type RootWorkspacesWithChildrenQuery = { __typename?: 'Query', workspaces?: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, tags?: Array<string | null> | null, parentId?: string | null, childWorkspaces: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, parentId?: string | null, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null, documents: { __typename?: 'DocumentsConnection', totalCount: number }, childWorkspaces: { __typename?: 'WorkspacesConnection', totalCount: number } } | null> }, root?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null, descendants: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', id: string, name: string } | null> } } | null> } | null };

export type ChildWorkspaceFragment = { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, parentId?: string | null, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null, documents: { __typename?: 'DocumentsConnection', totalCount: number }, childWorkspaces: { __typename?: 'WorkspacesConnection', totalCount: number } };

export type WorkspaceWithChildWorkspacesQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type WorkspaceWithChildWorkspacesQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, canBeDeleted?: boolean | null, mayUseUrlBasedDocumentImport: boolean, name: string, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, childWorkspaces: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, parentId?: string | null, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null, documents: { __typename?: 'DocumentsConnection', totalCount: number }, childWorkspaces: { __typename?: 'WorkspacesConnection', totalCount: number } } | null> }, ancestors: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', id: string, name: string } | null> }, parent?: { __typename?: 'Workspace', id: string, name: string } | null, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null, workspaceSubscriptionsByTeamId: { __typename?: 'WorkspaceSubscriptionsConnection', nodes: Array<{ __typename?: 'WorkspaceSubscription', subteam?: { __typename?: 'Team', name: string, id: string } | null } | null> } } | null };

export type WorkspaceTreeQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy: Array<WorkspacesOrderBy> | WorkspacesOrderBy;
}>;


export type WorkspaceTreeQuery = { __typename?: 'Query', workspaces?: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, childWorkspaces: { __typename?: 'WorkspacesConnection', totalCount: number }, descendants: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', id: string } | null> }, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null> } | null };

export type WorkspaceDetailsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type WorkspaceDetailsQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, canBeDeleted?: boolean | null, parentId?: string | null, totalMemberCount?: string | null, root?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean } | null, documents: { __typename?: 'DocumentsConnection', totalCount: number }, ancestors: { __typename?: 'WorkspacesConnection', totalCount: number, nodes: Array<{ __typename?: 'Workspace', id: string, name: string } | null> }, workspaceSubscriptionsByTeamId: { __typename?: 'WorkspaceSubscriptionsConnection', nodes: Array<{ __typename?: 'WorkspaceSubscription', subteam?: { __typename?: 'Team', name: string, id: string } | null } | null> } } | null };

export type UpdateWorkspaceNameMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateWorkspaceNameMutation = { __typename?: 'Mutation', updateWorkspace?: { __typename?: 'UpdateWorkspacePayload', clientMutationId?: string | null } | null };

export type TeamCandidatesForWorkspaceQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type TeamCandidatesForWorkspaceQuery = { __typename?: 'Query', myMemberships?: { __typename?: 'MembershipsConnection', nodes: Array<{ __typename?: 'Membership', team?: { __typename?: 'Team', id: string, name: string, workspaceSubscriptionsBySubteamId: { __typename?: 'WorkspaceSubscriptionsConnection', nodes: Array<{ __typename?: 'WorkspaceSubscription', id: string } | null> } } | null } | null> } | null };

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace?: { __typename?: 'DeleteWorkspacePayload', clientMutationId?: string | null } | null };

export type CreateSubfolderMutationVariables = Exact<{
  parentId: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateSubfolderMutation = { __typename?: 'Mutation', createWorkspaceAndJoin?: { __typename?: 'CreateWorkspaceAndJoinPayload', clientMutationId?: string | null, result?: { __typename?: 'CreateWorkspaceAndJoinRecord', createdWorkspace?: { __typename?: 'Workspace', id: string, firebaseId: string, isHcpUploadWorkspace: boolean } | null } | null } | null };

export type MoveFolderMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  parentId: Scalars['BigInt']['input'];
}>;


export type MoveFolderMutation = { __typename?: 'Mutation', updateWorkspace?: { __typename?: 'UpdateWorkspacePayload', clientMutationId?: string | null } | null };

export type InitQueryVariables = Exact<{ [key: string]: never; }>;


export type InitQuery = { __typename?: 'Query', myWorkspaces?: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', name: string, id: string, tags?: Array<string | null> | null, parentId?: string | null, firebaseId: string, isHcpUploadWorkspace: boolean, root?: { __typename?: 'Workspace', firebaseId: string, isHcpUploadWorkspace: boolean, id: string, tags?: Array<string | null> | null, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null } | null> } | null, myRootWorkspaces?: { __typename?: 'WorkspacesConnection', nodes: Array<{ __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string, myPrivileges?: { __typename?: 'WorkspacePrivilege', mayAdministrate?: boolean | null } | null } | null> } | null, myAccount?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', firebaseAuthId?: string | null, email: string, mergedFlags?: Array<string | null> | null, mergedConfig?: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null> | null, id: string, displayName?: string | null, tenantId: string, appConsentGivenAt?: any | null, userContactDetail?: { __typename?: 'UserContactDetail', profileImageUrl?: string | null } | null } | null> } | null, documentSpaceConfigs?: { __typename?: 'DocumentSpaceConfigsConnection', totalCount: number } | null };

export type SendWorkspaceNotificationMutationVariables = Exact<{
  eventType: PvNotificationEventType;
  workspaceId: Scalars['String']['input'];
  headerText: Scalars['String']['input'];
  bodyText: Scalars['String']['input'];
  documentId: Scalars['BigInt']['input'];
}>;


export type SendWorkspaceNotificationMutation = { __typename?: 'Mutation', pvAddWorkspaceNotification?: { __typename?: 'PvAddWorkspaceNotificationPayload', clientMutationId?: string | null } | null };

export type FtsSearchDocumentsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FtsSearchDocumentsQuery = { __typename?: 'Query', ftsSearchDocuments?: { __typename?: 'FtsDocumentHitsConnection', totalCount: number, nodes: Array<{ __typename?: 'FtsDocumentHit', titleHeadline?: string | null, fileNameHeadline?: string | null, documentScore?: number | null, bestPageScore?: number | null, totalScore?: number | null, totalMatchingPages?: string | null, pageHits?: Array<{ __typename?: 'FtsPageHit', pageNumber?: number | null, score?: number | null, headline?: string | null } | null> | null, document?: { __typename?: 'Document', displayTitle: string, mimeType: string, pages: number, id: string, firestoreId: string, displayDate: any, doesSupportSharedspace: boolean, thumbnailDownloadUrl: string, tags: Array<string | null>, rootWorkspace?: { __typename?: 'Workspace', isHcpUploadWorkspace: boolean, name: string, id: string } | null, workspace?: { __typename?: 'Workspace', name: string, id: string } | null } | null } | null> } | null };

export type FtsSearchDocumentSpacesQueryVariables = Exact<{
  term: Scalars['String']['input'];
  searchPersonalMessage?: InputMaybe<Scalars['Boolean']['input']>;
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FtsSearchDocumentSpacesQuery = { __typename?: 'Query', ftsSearchDocumentSpaces?: { __typename?: 'FtsDocumentSpaceHitsConnection', totalCount: number, nodes: Array<{ __typename?: 'FtsDocumentSpaceHit', documentSpaceId?: string | null, nameOfSpace?: string | null, nameOfSpaceHeadline?: string | null, nameOfCrmContact?: string | null, nameOfCrmContactHeadline?: string | null, personalMessage?: string | null, personalMessageHeadline?: string | null, totalScore?: number | null } | null> } | null };

export type FtsSearchFlowsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  creatorId: Scalars['BigInt']['input'];
}>;


export type FtsSearchFlowsQuery = { __typename?: 'Query', ftsSearchFlows?: { __typename?: 'FtsFlowHitsConnection', totalCount: number, nodes: Array<{ __typename?: 'FtsFlowHit', flowId?: string | null, title?: string | null, titleHeadline?: string | null, titleScore?: number | null, bestPageScore?: number | null, totalScore?: number | null, totalMatchingPages?: string | null, pageHits?: Array<{ __typename?: 'FtsPageHit', pageNumber?: number | null, score?: number | null, headline?: string | null } | null> | null, flow?: { __typename?: 'Flow', creatorId?: string | null, thumbnailUrl?: string | null, createdAt: any, updatedAt: any, allFlowItems: { __typename?: 'FlowItemsConnection', totalCount: number } } | null } | null> } | null };

export type LeaveTeamMutationVariables = Exact<{
  teamId: Scalars['BigInt']['input'];
}>;


export type LeaveTeamMutation = { __typename?: 'Mutation', leaveTeam?: { __typename?: 'LeaveTeamPayload', deletedMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState } | null } | null };

export type UserContactDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContactDetailQuery = { __typename?: 'Query', myAccount?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, userContactDetail?: { __typename?: 'UserContactDetail', id: string, userId: string, businessCardUrl?: string | null, appointmentBookingUrl?: string | null, displayName?: string | null, email?: string | null, jobTitle?: string | null, phone?: string | null, profileImageUrl?: string | null } | null } | null> } | null };

export type UpdateContactDetailsMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  appointmentBookingUrl?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateContactDetailsMutation = { __typename?: 'Mutation', updateUserContactDetail?: { __typename?: 'UpdateUserContactDetailPayload', userContactDetail?: { __typename?: 'UserContactDetail', displayName?: string | null, businessCardUrl?: string | null, appointmentBookingUrl?: string | null, email?: string | null, id: string, jobTitle?: string | null, phone?: string | null, profileImageUrl?: string | null, userId: string } | null } | null };

export type UpdateUserConfigMutationVariables = Exact<{
  configPartial: Scalars['JSON']['input'];
}>;


export type UpdateUserConfigMutation = { __typename?: 'Mutation', updateUserConfigPartial?: { __typename?: 'UpdateUserConfigPartialPayload', clientMutationId?: string | null } | null };

export type DocumentSpaceStatisticsQueryVariables = Exact<{
  includePreview: Scalars['Boolean']['input'];
}>;


export type DocumentSpaceStatisticsQuery = { __typename?: 'Query', maLatestSpaceVisits?: { __typename?: 'MaLatestSpaceVisitsConnection', totalCount: number, nodes: Array<{ __typename?: 'MaLatestSpaceVisitsRecord', documentSpaceId?: string | null, latestVisitDay?: any | null, name?: string | null } | null> } | null, documentSpaces?: { __typename?: 'DocumentSpacesConnection', totalCount: number } | null };

export type LatestSpaceVisitsQueryVariables = Exact<{
  documentSpaceId: Scalars['BigInt']['input'];
}>;


export type LatestSpaceVisitsQuery = { __typename?: 'Query', maDocumentSpaceVisitsStatistics?: { __typename?: 'MaDocumentSpaceVisitsStatisticsConnection', totalCount: number, nodes: Array<{ __typename?: 'MaDocumentSpaceVisitsStatistic', id: string, startsAt?: any | null, interactions?: Array<string | null> | null, isPreview?: boolean | null, duration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null };

export type DocumentSpaceVisitsQueryVariables = Exact<{
  documentSpaceId: Scalars['BigInt']['input'];
}>;


export type DocumentSpaceVisitsQuery = { __typename?: 'Query', maDocumentSpaceVisitsStatistics?: { __typename?: 'MaDocumentSpaceVisitsStatisticsConnection', totalCount: number, nodes: Array<{ __typename?: 'MaDocumentSpaceVisitsStatistic', id: string, startsAt?: any | null, interactions?: Array<string | null> | null, isPreview?: boolean | null, duration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null, maDocumentSpaceStatistics?: { __typename?: 'MaDocumentSpaceStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpaceStatistic', name?: string | null, numDownloads?: string | null, numLinkClicks?: string | null, totalVisits?: string | null, avgDuration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null };

export type DocumentSpaceVisitDetailsQueryVariables = Exact<{
  visitId: Scalars['BigInt']['input'];
}>;


export type DocumentSpaceVisitDetailsQuery = { __typename?: 'Query', maVisitDetails?: { __typename?: 'MaVisitDetailsConnection', nodes: Array<{ __typename?: 'MaVisitDetail', documentId?: string | null, displayTitle?: string | null, thumbnailDownloadUrl?: string | null, isPreview?: boolean | null, startsAt?: any | null, type?: string | null, url?: string | null, watchRate?: any | null, duration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null };

export type DocumentSpaceDetailStatisticsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DocumentSpaceDetailStatisticsQuery = { __typename?: 'Query', maDocumentSpaceVisitsStatistics?: { __typename?: 'MaDocumentSpaceVisitsStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpaceVisitsStatistic', startsAt?: any | null, interactions?: Array<string | null> | null, isPreview?: boolean | null, duration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null, maDocumentSpaceStatistics?: { __typename?: 'MaDocumentSpaceStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpaceStatistic', name?: string | null, numDownloads?: string | null, numLinkClicks?: string | null, totalVisits?: string | null, avgDuration?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null, maDocumentSpaceLinkStatistics?: { __typename?: 'MaDocumentSpaceLinkStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpaceLinkStatistic', numClicks?: string | null, url: string } | null> } | null, maDocumentSpaceDocumentStatistics?: { __typename?: 'MaDocumentSpaceDocumentStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpaceDocumentStatistic', numDownloads?: string | null, numVisits?: string | null, displayTitle?: string | null, documentId: string, mimeType?: string | null, thumbnailDownloadUrl?: string | null, averageDurationInDocumentPerVisit?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null, maxDurationInDocumentAcrossVisits?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null, maDocumentSpaceVideoStatistics?: { __typename?: 'MaDocumentSpaceVideoStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpaceVideoStatistic', displayTitle?: string | null, maxWatchRateAcrossVisits?: any | null, numDownloads?: string | null, numVisits?: string | null, thumbnailDownloadUrl?: string | null } | null> } | null };

export type TopPagesPerSpaceAndDocumentQueryVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  docId: Scalars['BigInt']['input'];
}>;


export type TopPagesPerSpaceAndDocumentQuery = { __typename?: 'Query', maDocumentSpacePageStatistics?: { __typename?: 'MaDocumentSpacePageStatisticsConnection', nodes: Array<{ __typename?: 'MaDocumentSpacePageStatistic', numVisits?: string | null, pageNumber: string, averageDurationOnPagePerVisit?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null, maxDurationOnPageAcrossVisits?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null };

export type DocumentStatisticsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<MaDocumentStatisticsOrderBy> | MaDocumentStatisticsOrderBy>;
  first: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type DocumentStatisticsQuery = { __typename?: 'Query', maDocumentStatistics?: { __typename?: 'MaDocumentStatisticsConnection', totalCount: number, nodes: Array<{ __typename?: 'MaDocumentStatistic', numDownloads?: string | null, numVisits?: string | null, numShares?: string | null, numCurrentShares?: string | null, displayTitle?: string | null, documentId?: string | null, mimeType?: string | null, thumbnailDownloadUrl?: string | null, averageDurationInDocumentPerVisit?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null, maxDurationInDocumentAcrossVisits?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null };

export type TopPagesPerDocumentQueryVariables = Exact<{
  docId: Scalars['BigInt']['input'];
}>;


export type TopPagesPerDocumentQuery = { __typename?: 'Query', maPageStatistics?: { __typename?: 'MaPageStatisticsConnection', nodes: Array<{ __typename?: 'MaPageStatistic', numVisits?: string | null, pageNumber?: string | null, averageDurationOnPagePerVisit?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null, maxDurationOnPageAcrossVisits?: { __typename?: 'Interval', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null> } | null };

export type UsageAnalyticsQueryVariables = Exact<{
  year: Scalars['BigFloat']['input'];
}>;


export type UsageAnalyticsQuery = { __typename?: 'Query', maUsageByTeamsAndYears?: { __typename?: 'MaUsageByTeamsAndYearsConnection', nodes: Array<{ __typename?: 'MaUsageByTeamsAndYear', analyticsAlias?: string | null, nPresentations?: string | null, nTimesOpenedADocument?: string | null, nTimesOpenedTheApp?: string | null, nUploads?: string | null, tenantId?: string | null, nUsersThatOpenedTheAppAtLeastOnce?: string | null, nUsersThatPresentedAtLeastOnce?: string | null, year?: any | null } | null> } | null, maUsageByTeamsAllTimeMembershipAndYears?: { __typename?: 'MaUsageByTeamsAllTimeMembershipAndYearsConnection', nodes: Array<{ __typename?: 'MaUsageByTeamsAllTimeMembershipAndYear', analyticsAlias?: string | null, nPresentations?: string | null, nTimesOpenedADocument?: string | null, nTimesOpenedTheApp?: string | null, nUploads?: string | null, tenantId?: string | null, nUsersThatOpenedTheAppAtLeastOnce?: string | null, nUsersThatPresentedAtLeastOnce?: string | null, year?: any | null } | null> } | null, maUsageByTeams?: { __typename?: 'MaUsageByTeamsConnection', nodes: Array<{ __typename?: 'MaUsageByTeam', analyticsAlias?: string | null, nUsersTotal?: string | null, nUsersTotalRegistered?: string | null, nNewUsersCreatedInLastSixMonths?: string | null, nNewUsersCreatedInLastYear?: string | null, nNewUsersRegisteredInLastSixMonths?: string | null, nNewUsersRegisteredInLastYear?: string | null } | null> } | null };

export type SpaceUsageAnalyticsQueryVariables = Exact<{
  year: Scalars['BigFloat']['input'];
}>;


export type SpaceUsageAnalyticsQuery = { __typename?: 'Query', maSpaceUsageByTeamsAndYears?: { __typename?: 'MaSpaceUsageByTeamsAndYearsConnection', nodes: Array<{ __typename?: 'MaSpaceUsageByTeamsAndYear', analyticsAlias?: string | null, nTotalClicks?: string | null, nTotalDocumentVisits?: string | null, nTotalDownloads?: string | null, nTotalSpaceVisits?: string | null, nTotalSpaces?: string | null } | null> } | null };

export type CustomFlowsQueryVariables = Exact<{
  creatorId: Scalars['BigInt']['input'];
}>;


export type CustomFlowsQuery = { __typename?: 'Query', flows?: { __typename?: 'FlowsConnection', nodes: Array<{ __typename?: 'Flow', id: string, title: string } | null> } | null };

export type DeleteCustomFlowMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteCustomFlowMutation = { __typename?: 'Mutation', deleteFlow?: { __typename?: 'DeleteFlowPayload', clientMutationId?: string | null, deletedFlowNodeId?: string | null } | null };

export type CreateCustomFlowMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateCustomFlowMutation = { __typename?: 'Mutation', createFlow?: { __typename?: 'CreateFlowPayload', flow?: { __typename?: 'Flow', id: string, title: string } | null } | null };

export type CopyCustomFlowMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  newTitle: Scalars['String']['input'];
}>;


export type CopyCustomFlowMutation = { __typename?: 'Mutation', copyFlow?: { __typename?: 'CopyFlowPayload', copiedFlow?: { __typename?: 'Flow', id: string, title: string } | null } | null };

export type FlowDocumentFragment = { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null };

export type CustomFlowWithoutExpiredDocumentsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type CustomFlowWithoutExpiredDocumentsQuery = { __typename?: 'Query', flow?: { __typename?: 'Flow', id: string, creatorId?: string | null, title: string, legalAppendixPages: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, document?: { __typename?: 'Document', displayTitle: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null> }, flowItems: { __typename?: 'FlowItemsConnection', nodes: Array<{ __typename?: 'FlowItem', id: string, pageId?: string | null, nodeId: string, page?: { __typename?: 'DocumentPage', id: string, pageNumber: number, document?: { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null, video?: { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null> }, distinctDocuments: { __typename?: 'DocumentsConnection', nodes: Array<{ __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null> } } | null };

export type CustomFlowQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type CustomFlowQuery = { __typename?: 'Query', flow?: { __typename?: 'Flow', id: string, creatorId?: string | null, title: string, legalAppendixPages: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string, document?: { __typename?: 'Document', displayTitle: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null> }, flowItems: { __typename?: 'FlowItemsConnection', nodes: Array<{ __typename?: 'FlowItem', id: string, pageId?: string | null, nodeId: string, page?: { __typename?: 'DocumentPage', id: string, pageNumber: number, document?: { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null, video?: { __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null } | null> }, distinctDocuments: { __typename?: 'DocumentsConnection', nodes: Array<{ __typename?: 'Document', id: string, downloadUrl: string, displayTitle: string, topTitle: string, teaserText: string, pages: number, mimeType: string, doesSupportSharedspace: boolean, fileName: string, firestoreId: string, deletedAt?: any | null, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, thumbnailDownloadUrl: string, numNormalPages: number, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null> } } | null };

export type GetDocumentPagesByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
}>;


export type GetDocumentPagesByDocumentIdQuery = { __typename?: 'Query', document?: { __typename?: 'Document', currentRevisionNumber?: number | null, documentRevisionByIdAndCurrentRevisionNumber?: { __typename?: 'DocumentRevision', documentPagesByDocumentIdAndRevisionNumber: { __typename?: 'DocumentPagesConnection', nodes: Array<{ __typename?: 'DocumentPage', id: string } | null> } } | null } | null };

export type AppendFlowItemsMutationVariables = Exact<{
  flowId: Scalars['BigInt']['input'];
  pageIds: Array<Scalars['BigInt']['input']> | Scalars['BigInt']['input'];
}>;


export type AppendFlowItemsMutation = { __typename?: 'Mutation', appendPagesToFlow?: { __typename?: 'AppendPagesToFlowPayload', flowItems?: Array<{ __typename?: 'FlowItem', pageId?: string | null } | null> | null } | null };

export type AppendVideoMutationVariables = Exact<{
  flowId: Scalars['BigInt']['input'];
  videoId: Scalars['BigInt']['input'];
}>;


export type AppendVideoMutation = { __typename?: 'Mutation', appendVideosToFlow?: { __typename?: 'AppendVideosToFlowPayload', clientMutationId?: string | null } | null };

export type RemoveFlowItemMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type RemoveFlowItemMutation = { __typename?: 'Mutation', deleteFlowItem?: { __typename?: 'DeleteFlowItemPayload', clientMutationId?: string | null, deletedFlowItemNodeId?: string | null } | null };

export type ReorderFlowPageMutationVariables = Exact<{
  flowItemId: Scalars['BigInt']['input'];
  beforeId?: InputMaybe<Scalars['BigInt']['input']>;
  behindId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type ReorderFlowPageMutation = { __typename?: 'Mutation', placeFlowItem?: { __typename?: 'PlaceFlowItemPayload', flowItems?: Array<{ __typename?: 'FlowItem', id: string } | null> | null } | null };

export type RenameCustomFlowMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  title: Scalars['String']['input'];
}>;


export type RenameCustomFlowMutation = { __typename?: 'Mutation', updateFlow?: { __typename?: 'UpdateFlowPayload', clientMutationId?: string | null } | null };

export type GetDocumentsOfSpaceQueryVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
}>;


export type GetDocumentsOfSpaceQuery = { __typename?: 'Query', documentSpace?: { __typename?: 'DocumentSpace', documentSpaceItems: { __typename?: 'DocumentSpaceItemsConnection', nodes: Array<{ __typename?: 'DocumentSpaceItem', documentId?: string | null } | null> } } | null };

export type FlowIsSharedQueryVariables = Exact<{
  flowId: Scalars['BigInt']['input'];
}>;


export type FlowIsSharedQuery = { __typename?: 'Query', documentSpaceItems?: { __typename?: 'DocumentSpaceItemsConnection', totalCount: number } | null };

export type PageConfigFragment = { __typename?: 'DocumentPage', id: string, pageNumber: number, pageType: PageType, updatedAt: any, documentId: string, linkedDocument?: { __typename?: 'Document', id: string, displayTitle: string, thumbnailDownloadUrl: string, pages: number, mimeType: string, originalMimeType?: string | null, firestoreId: string, workspace?: { __typename?: 'Workspace', id: string, root?: { __typename?: 'Workspace', id: string } | null } | null } | null };

export type MagicPagesQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type MagicPagesQuery = { __typename?: 'Query', document?: { __typename?: 'Document', documentRevisionByIdAndCurrentRevisionNumber?: { __typename?: 'DocumentRevision', documentPagesByDocumentIdAndRevisionNumber: { __typename?: 'DocumentPagesConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentPage', id: string, pageNumber: number, pageType: PageType, updatedAt: any, documentId: string, linkedDocument?: { __typename?: 'Document', id: string, displayTitle: string, thumbnailDownloadUrl: string, pages: number, mimeType: string, originalMimeType?: string | null, firestoreId: string, workspace?: { __typename?: 'Workspace', id: string, root?: { __typename?: 'Workspace', id: string } | null } | null } | null } | null> } } | null } | null };

export type UpdatePageTypeMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  pageType: PageType;
  linkedDocumentId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type UpdatePageTypeMutation = { __typename?: 'Mutation', updateDocumentPage?: { __typename?: 'UpdateDocumentPagePayload', clientMutationId?: string | null } | null };

export type DocumentSpacesQueryVariables = Exact<{
  orderBy: DocumentSpacesOrderBy;
}>;


export type DocumentSpacesQuery = { __typename?: 'Query', documentSpaces?: { __typename?: 'DocumentSpacesConnection', nodes: Array<{ __typename?: 'DocumentSpace', id: string, name?: string | null, createdAt: any, updatedAt: any, documentSpaceItems: { __typename?: 'DocumentSpaceItemsConnection', totalCount: number }, documentSpaceAccesses: { __typename?: 'DocumentSpaceAccessesConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentSpaceAccess', role: string, user?: { __typename?: 'User', id: string } | null } | null> }, config?: { __typename?: 'DocumentSpaceConfig', name?: string | null } | null, documentSpaceVouchers: { __typename?: 'DocumentSpaceVouchersConnection', totalCount: number }, visitStatistics?: { __typename?: 'DocumentSpaceVisitStatistic', lastVisitAt?: any | null } | null, documentSpaceCrmMapping?: { __typename?: 'DocumentSpaceCrmMapping', crmContact?: { __typename?: 'CrmContact', firstName?: string | null, lastName: string } | null } | null } | null> } | null };

export type DocumentSpacesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentSpacesCountQuery = { __typename?: 'Query', documentSpaces?: { __typename?: 'DocumentSpacesConnection', totalCount: number } | null };

export type DocumentSpacesSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type DocumentSpacesSearchQuery = { __typename?: 'Query', documentSpaces?: { __typename?: 'DocumentSpacesConnection', nodes: Array<{ __typename?: 'DocumentSpace', createdAt: any, updatedAt: any, name?: string | null, id: string, documentSpaceItems: { __typename?: 'DocumentSpaceItemsConnection', totalCount: number }, documentSpaceAccesses: { __typename?: 'DocumentSpaceAccessesConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentSpaceAccess', role: string, user?: { __typename?: 'User', id: string } | null } | null> } } | null> } | null };

export type DocumentSpaceQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DocumentSpaceQuery = { __typename?: 'Query', documentSpace?: { __typename?: 'DocumentSpace', name?: string | null, id: string, personalMessage?: string | null, tenantId: string, allowedEmailAddresses?: Array<string | null> | null, trackingDeactivated: boolean, visitStatistics?: { __typename?: 'DocumentSpaceVisitStatistic', firstVisitAt?: any | null, lastVisitAt?: any | null, visitCount?: string | null } | null, documentSpaceVouchers: { __typename?: 'DocumentSpaceVouchersConnection', totalCount: number }, config?: { __typename?: 'DocumentSpaceConfig', id: string, name?: string | null, requiresEmailAuthentication: boolean, documentSpaceLinksByConfigId: { __typename?: 'DocumentSpaceLinksConnection', nodes: Array<{ __typename?: 'DocumentSpaceLink', title: string, sectionTitle?: string | null, url: string, isMandatory: boolean, id: string, nodeId: string, position?: any | null, documentSpaceLinkMappingsByLinkId: { __typename?: 'DocumentSpaceLinkMappingsConnection', nodes: Array<{ __typename?: 'DocumentSpaceLinkMapping', id: string } | null> }, documentSpaceLinkTranslationsByLinkId: { __typename?: 'DocumentSpaceLinkTranslationsConnection', nodes: Array<{ __typename?: 'DocumentSpaceLinkTranslation', id: string, languageCode: string, sectionTitle?: string | null, title: string, url: string } | null> } } | null> } } | null, documentSpaceCrmMapping?: { __typename?: 'DocumentSpaceCrmMapping', crmContact?: { __typename?: 'CrmContact', crmId: string, email?: string | null, firstName?: string | null, id: string, lastName: string, territory?: string | null, organization?: string | null, mobile?: string | null, crmContactPhaseMappingsByContactId: { __typename?: 'CrmContactPhaseMappingsConnection', nodes: Array<{ __typename?: 'CrmContactPhaseMapping', phase?: { __typename?: 'CampaignPhase', campaignPhaseLinksByPhaseId: { __typename?: 'CampaignPhaseLinksConnection', nodes: Array<{ __typename?: 'CampaignPhaseLink', name: string, id: string } | null> } } | null } | null> }, authorsOfDocumentSpaces: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, displayName?: string | null } | null> } } | null } | null, documentSpaceSections: { __typename?: 'DocumentSpaceSectionsConnection', nodes: Array<{ __typename?: 'DocumentSpaceSection', id: string, title?: string | null, position: any, documentSpaceItemsBySectionId: { __typename?: 'DocumentSpaceItemsConnection', nodes: Array<{ __typename?: 'DocumentSpaceItem', id: string, position?: any | null, flowId?: string | null, document?: { __typename?: 'Document', createdById?: string | null, deletedAt?: any | null, displayDate: any, displayTitle: string, downloadUrl: string, fileName: string, fileSize: string, firestoreId: string, id: string, numNormalPages: number, internalLinks: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, isPublished: boolean, lastModifiedAt: any, lastModifiedById?: string | null, literatureReferences: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null>, mimeType: string, originalMimeType?: string | null, pages: number, storageId: string, tags: Array<string | null>, teaserText: string, thumbnailDownloadUrl: string, thumbnailStorageId: string, topTitle: string, uploadedAt: any, workspaceId: string, documentExpiration?: { __typename?: 'DocumentExpiration', expiredAt: any } | null } | null, flow?: { __typename?: 'Flow', id: string, title: string, thumbnailUrl?: string | null, flowItems: { __typename?: 'FlowItemsConnection', totalCount: number } } | null } | null> } } | null> }, documentSpaceLinks: { __typename?: 'DocumentSpaceLinksConnection', nodes: Array<{ __typename?: 'DocumentSpaceLink', id: string, nodeId: string, position?: any | null, sectionTitle?: string | null, title: string, url: string } | null> }, documentSpaceAccesses: { __typename?: 'DocumentSpaceAccessesConnection', nodes: Array<{ __typename?: 'DocumentSpaceAccess', displayContactDetails: boolean, id: string, role: string, userId: string, user?: { __typename?: 'User', id: string, displayName?: string | null, email: string, userContactDetail?: { __typename?: 'UserContactDetail', profileImageUrl?: string | null, businessCardUrl?: string | null, appointmentBookingUrl?: string | null, displayName?: string | null, email?: string | null, jobTitle?: string | null, id: string, phone?: string | null } | null } | null } | null> } } | null };

export type DocumentSpaceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentSpaceConfigsQuery = { __typename?: 'Query', documentSpaceConfigs?: { __typename?: 'DocumentSpaceConfigsConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentSpaceConfig', name?: string | null, id: string } | null> } | null };

export type UpdateDocumentSpaceConfigMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  configId: Scalars['BigInt']['input'];
}>;


export type UpdateDocumentSpaceConfigMutation = { __typename?: 'Mutation', updateDocumentSpace?: { __typename?: 'UpdateDocumentSpacePayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceNameMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateDocumentSpaceNameMutation = { __typename?: 'Mutation', updateDocumentSpace?: { __typename?: 'UpdateDocumentSpacePayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceMessageMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  message: Scalars['String']['input'];
}>;


export type UpdateDocumentSpaceMessageMutation = { __typename?: 'Mutation', updateDocumentSpace?: { __typename?: 'UpdateDocumentSpacePayload', clientMutationId?: string | null } | null };

export type DeactivateSpaceTrackingMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeactivateSpaceTrackingMutation = { __typename?: 'Mutation', updateDocumentSpace?: { __typename?: 'UpdateDocumentSpacePayload', clientMutationId?: string | null } | null };

export type UpdateAllowedEmailAddressMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateAllowedEmailAddressMutation = { __typename?: 'Mutation', updateDocumentSpace?: { __typename?: 'UpdateDocumentSpacePayload', clientMutationId?: string | null } | null };

export type CreateDocumentSpaceVoucherMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  campaignPhaseLinkId?: InputMaybe<Scalars['BigInt']['input']>;
  isPreview: Scalars['Boolean']['input'];
}>;


export type CreateDocumentSpaceVoucherMutation = { __typename?: 'Mutation', pvCreateVoucherForDocumentSpace?: { __typename?: 'PvCreateVoucherForDocumentSpacePayload', result?: { __typename?: 'PvCreateVoucherForDocumentSpaceRecord', urlSegment?: string | null } | null } | null };

export type CreateDocumentSpaceSectionMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDocumentSpaceSectionMutation = { __typename?: 'Mutation', createDocumentSpaceSection?: { __typename?: 'CreateDocumentSpaceSectionPayload', clientMutationId?: string | null } | null };

export type CreateDocumentSpaceItemMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  docId: Scalars['BigInt']['input'];
  sectionId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type CreateDocumentSpaceItemMutation = { __typename?: 'Mutation', createDocumentSpaceItem?: { __typename?: 'CreateDocumentSpaceItemPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceItemPositionMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  docId: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
}>;


export type UpdateDocumentSpaceItemPositionMutation = { __typename?: 'Mutation', updateDocumentSpaceItemByDocumentIdAndDocumentSpaceId?: { __typename?: 'UpdateDocumentSpaceItemPayload', clientMutationId?: string | null } | null };

export type DeleteDocumentSpaceItemMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  docId: Scalars['BigInt']['input'];
}>;


export type DeleteDocumentSpaceItemMutation = { __typename?: 'Mutation', deleteDocumentSpaceItemByDocumentIdAndDocumentSpaceId?: { __typename?: 'DeleteDocumentSpaceItemPayload', clientMutationId?: string | null } | null };

export type CreateDocumentSpaceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
  configId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type CreateDocumentSpaceMutation = { __typename?: 'Mutation', createDocumentSpaceWithCrmContact?: { __typename?: 'CreateDocumentSpaceWithCrmContactPayload', result?: { __typename?: 'CreateDocumentSpaceWithCrmContactRecord', documentSpace?: { __typename?: 'DocumentSpace', id: string } | null, crmContact?: { __typename?: 'CrmContact', id: string } | null } | null } | null };

export type DeleteDocumentSpaceMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteDocumentSpaceMutation = { __typename?: 'Mutation', deleteDocumentSpace?: { __typename?: 'DeleteDocumentSpacePayload', clientMutationId?: string | null } | null };

export type CloneDocumentSpaceMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  newName: Scalars['String']['input'];
  crmContactId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type CloneDocumentSpaceMutation = { __typename?: 'Mutation', cloneDocumentSpace?: { __typename?: 'CloneDocumentSpacePayload', clonedSpace?: { __typename?: 'DocumentSpace', id: string } | null } | null };

export type ShortDocumentSpaceFragment = { __typename?: 'DocumentSpace', id: string, name?: string | null, updatedAt: any };

export type GetShortDocumentSpacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShortDocumentSpacesQuery = { __typename?: 'Query', documentSpaces?: { __typename?: 'DocumentSpacesConnection', nodes: Array<{ __typename?: 'DocumentSpace', id: string, name?: string | null, updatedAt: any } | null> } | null };

export type SearchUsersWithinTenantQueryVariables = Exact<{
  search: Scalars['String']['input'];
  tenantId: Scalars['BigInt']['input'];
  spaceId: Scalars['BigInt']['input'];
}>;


export type SearchUsersWithinTenantQuery = { __typename?: 'Query', usersByFlags?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, displayName?: string | null, email: string, documentSpaceAccesses: { __typename?: 'DocumentSpaceAccessesConnection', nodes: Array<{ __typename?: 'DocumentSpaceAccess', id: string, role: string } | null> } } | null> } | null };

export type AddCollaboratorMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  userId: Scalars['BigInt']['input'];
  displayContactDetails: Scalars['Boolean']['input'];
}>;


export type AddCollaboratorMutation = { __typename?: 'Mutation', inviteToSpaceByEmail?: { __typename?: 'InviteToSpaceByEmailPayload', clientMutationId?: string | null } | null };

export type UpdateAccessMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  displayContactDetails: Scalars['Boolean']['input'];
}>;


export type UpdateAccessMutation = { __typename?: 'Mutation', updateDocumentSpaceAccess?: { __typename?: 'UpdateDocumentSpaceAccessPayload', clientMutationId?: string | null } | null };

export type RemoveAccessMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type RemoveAccessMutation = { __typename?: 'Mutation', deleteDocumentSpaceAccess?: { __typename?: 'DeleteDocumentSpaceAccessPayload', clientMutationId?: string | null } | null };

export type TransferOwnershipMutationVariables = Exact<{
  accessId: Scalars['BigInt']['input'];
  displayContactDetails: Scalars['Boolean']['input'];
}>;


export type TransferOwnershipMutation = { __typename?: 'Mutation', transferOwnershipOfSpace?: { __typename?: 'TransferOwnershipOfSpacePayload', clientMutationId?: string | null } | null, updateDocumentSpaceAccess?: { __typename?: 'UpdateDocumentSpaceAccessPayload', clientMutationId?: string | null } | null };

export type SearchDocumentSpacesQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type SearchDocumentSpacesQuery = { __typename?: 'Query', searchDocumentSpaces?: { __typename?: 'MatchingDocumentSpacesConnection', totalCount: number, nodes: Array<{ __typename?: 'MatchingDocumentSpace', matchInName?: string | null, matchInPersonalMessage?: string | null, similarity?: number | null, rank?: number | null, documentSpace?: { __typename?: 'DocumentSpace', id: string, name?: string | null, personalMessage?: string | null, createdAt: any, updatedAt: any, documentSpaceItems: { __typename?: 'DocumentSpaceItemsConnection', totalCount: number }, config?: { __typename?: 'DocumentSpaceConfig', name?: string | null } | null } | null, documentMatches?: Array<{ __typename?: 'MatchingDocument', matchInFileName?: string | null, matchInDisplayTitle?: string | null, rank?: number | null, similarity?: number | null, document?: { __typename?: 'Document', id: string, thumbnailDownloadUrl: string } | null } | null> | null } | null> } | null };

export type RenameSpaceSectionMutationVariables = Exact<{
  sectionId: Scalars['BigInt']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameSpaceSectionMutation = { __typename?: 'Mutation', updateDocumentSpaceSection?: { __typename?: 'UpdateDocumentSpaceSectionPayload', clientMutationId?: string | null } | null };

export type DeleteSpaceSectionMutationVariables = Exact<{
  sectionId: Scalars['BigInt']['input'];
  moveDocumentsToSectionId?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type DeleteSpaceSectionMutation = { __typename?: 'Mutation', deleteDocumentSpaceSection?: { __typename?: 'DeleteDocumentSpaceSectionPayload', clientMutationId?: string | null } | null };

export type MoveSpaceSectionMutationVariables = Exact<{
  sectionId: Scalars['BigInt']['input'];
  direction: SpaceSectionMoveType;
}>;


export type MoveSpaceSectionMutation = { __typename?: 'Mutation', moveSpaceSection?: { __typename?: 'MoveSpaceSectionPayload', clientMutationId?: string | null } | null };

export type CreateSpaceSectionAfterMutationVariables = Exact<{
  title: Scalars['String']['input'];
  afterSectionId: Scalars['BigInt']['input'];
}>;


export type CreateSpaceSectionAfterMutation = { __typename?: 'Mutation', insertSpaceSectionAfter?: { __typename?: 'InsertSpaceSectionAfterPayload', clientMutationId?: string | null } | null };

export type SpaceSectionsQueryVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
}>;


export type SpaceSectionsQuery = { __typename?: 'Query', documentSpaceSections?: { __typename?: 'DocumentSpaceSectionsConnection', nodes: Array<{ __typename?: 'DocumentSpaceSection', title?: string | null, id: string } | null> } | null };

export type MoveSpaceItemMutationVariables = Exact<{
  withId: Scalars['BigInt']['input'];
  targetItemId: Scalars['BigInt']['input'];
  location: SpaceItemMoveType;
}>;


export type MoveSpaceItemMutation = { __typename?: 'Mutation', moveSpaceItem?: { __typename?: 'MoveSpaceItemPayload', clientMutationId?: string | null } | null };

export type MoveSpaceItemToSectionMutationVariables = Exact<{
  withId: Scalars['BigInt']['input'];
  targetSectionId: Scalars['BigInt']['input'];
}>;


export type MoveSpaceItemToSectionMutation = { __typename?: 'Mutation', moveSpaceItemToSection?: { __typename?: 'MoveSpaceItemToSectionPayload', clientMutationId?: string | null } | null };

export type CreateSpaceItemsMutationVariables = Exact<{
  documentId: Scalars['BigInt']['input'];
  targets?: InputMaybe<Array<InputMaybe<IdsOfSpaceAndSectionInput>> | InputMaybe<IdsOfSpaceAndSectionInput>>;
}>;


export type CreateSpaceItemsMutation = { __typename?: 'Mutation', addDocumentToMultipleSpaces?: { __typename?: 'AddDocumentToMultipleSpacesPayload', documentSpaceItems?: Array<{ __typename?: 'DocumentSpaceItem', id: string, document?: { __typename?: 'Document', id: string } | null } | null> | null } | null };

export type CrmContactsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type CrmContactsQuery = { __typename?: 'Query', rankedSearchCrmContactsByName?: { __typename?: 'CrmContactMatchesConnection', nodes: Array<{ __typename?: 'CrmContactMatch', firstName?: string | null, lastName: string, email?: string | null, mobile?: string | null, id: string, crmId: string, territory?: string | null, organization?: string | null, crmContactPhaseMappingsByContactId: { __typename?: 'CrmContactPhaseMappingsConnection', nodes: Array<{ __typename?: 'CrmContactPhaseMapping', phase?: { __typename?: 'CampaignPhase', name: string, campaign?: { __typename?: 'Campaign', name: string } | null } | null } | null> }, documentSpaceCrmMappings: { __typename?: 'DocumentSpaceCrmMappingsConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentSpaceCrmMapping', documentSpaceId: string } | null> } } | null>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type CrmContactsWithoutSearchQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type CrmContactsWithoutSearchQuery = { __typename?: 'Query', crmContacts?: { __typename?: 'CrmContactsConnection', nodes: Array<{ __typename?: 'CrmContact', firstName?: string | null, lastName: string, email?: string | null, mobile?: string | null, id: string, crmId: string, territory?: string | null, organization?: string | null, crmContactPhaseMappingsByContactId: { __typename?: 'CrmContactPhaseMappingsConnection', nodes: Array<{ __typename?: 'CrmContactPhaseMapping', phase?: { __typename?: 'CampaignPhase', name: string, campaign?: { __typename?: 'Campaign', name: string } | null } | null } | null> }, documentSpaceCrmMappings: { __typename?: 'DocumentSpaceCrmMappingsConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentSpaceCrmMapping', documentSpaceId: string } | null> } } | null>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type CreateDocumentSpaceCrmMappingMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  crmContactId: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateDocumentSpaceCrmMappingMutation = { __typename?: 'Mutation', createDocumentSpaceCrmMapping?: { __typename?: 'CreateDocumentSpaceCrmMappingPayload', clientMutationId?: string | null } | null, updateDocumentSpace?: { __typename?: 'UpdateDocumentSpacePayload', clientMutationId?: string | null } | null };

export type DocumentSpacesForContactQueryVariables = Exact<{
  contactId: Scalars['BigInt']['input'];
}>;


export type DocumentSpacesForContactQuery = { __typename?: 'Query', documentSpaceCrmMappings?: { __typename?: 'DocumentSpaceCrmMappingsConnection', nodes: Array<{ __typename?: 'DocumentSpaceCrmMapping', documentSpace?: { __typename?: 'DocumentSpace', id: string, name?: string | null, config?: { __typename?: 'DocumentSpaceConfig', name?: string | null } | null } | null } | null> } | null };

export type CreateDocumentSpaceLinkMutationVariables = Exact<{
  documentSpaceId: Scalars['BigInt']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  sectionTitle: Scalars['String']['input'];
}>;


export type CreateDocumentSpaceLinkMutation = { __typename?: 'Mutation', createDocumentSpaceLink?: { __typename?: 'CreateDocumentSpaceLinkPayload', clientMutationId?: string | null } | null };

export type DeleteDocumentSpaceLinkMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteDocumentSpaceLinkMutation = { __typename?: 'Mutation', deleteDocumentSpaceLink?: { __typename?: 'DeleteDocumentSpaceLinkPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceLinkMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  sectionTitle: Scalars['String']['input'];
}>;


export type UpdateDocumentSpaceLinkMutation = { __typename?: 'Mutation', updateDocumentSpaceLink?: { __typename?: 'UpdateDocumentSpaceLinkPayload', clientMutationId?: string | null } | null };

export type UpdateDocumentSpaceLinkPositionMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  position: Scalars['BigFloat']['input'];
}>;


export type UpdateDocumentSpaceLinkPositionMutation = { __typename?: 'Mutation', updateDocumentSpaceLink?: { __typename?: 'UpdateDocumentSpaceLinkPayload', clientMutationId?: string | null } | null };

export type CreateDocumentSpaceLinkMappingMutationVariables = Exact<{
  spaceId: Scalars['BigInt']['input'];
  linkId: Scalars['BigInt']['input'];
}>;


export type CreateDocumentSpaceLinkMappingMutation = { __typename?: 'Mutation', createDocumentSpaceLinkMapping?: { __typename?: 'CreateDocumentSpaceLinkMappingPayload', clientMutationId?: string | null } | null };

export type DeleteDocumentSpaceLinkMappingMutationVariables = Exact<{
  mappingId: Scalars['BigInt']['input'];
}>;


export type DeleteDocumentSpaceLinkMappingMutation = { __typename?: 'Mutation', deleteDocumentSpaceLinkMapping?: { __typename?: 'DeleteDocumentSpaceLinkMappingPayload', clientMutationId?: string | null } | null };
export type ShortTeamFragment = { __typename?: 'Team', id: string, name: string, isVisible: boolean, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, myMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null };

export type MyManagedMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyManagedMembershipsQuery = { __typename?: 'Query', memberships?: { __typename?: 'MembershipsConnection', nodes: Array<{ __typename?: 'Membership', id: string, isManagedManually: boolean, isSyncedWithExternalGroups: boolean, currentState: MembershipState, createdAt: any, updatedAt: any, team?: { __typename?: 'Team', id: string, name: string, isVisible: boolean, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, myMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null } | null } | null> } | null };

export type MyAdminTeamsQueryVariables = Exact<{
  internalMemberFilter: MembershipFilter;
}>;


export type MyAdminTeamsQuery = { __typename?: 'Query', myAdminTeams?: { __typename?: 'TeamsConnection', nodes: Array<{ __typename?: 'Team', id: string, name: string, isVisible: boolean, userMemberships: { __typename?: 'MembershipsConnection', totalCount: number }, internalUserMemberships: { __typename?: 'MembershipsConnection', totalCount: number }, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, myMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null } | null> } | null };

export type MyAdminTeamsShortQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAdminTeamsShortQuery = { __typename?: 'Query', myAdminTeams?: { __typename?: 'TeamsConnection', nodes: Array<{ __typename?: 'Team', id: string, name: string, isVisible: boolean, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, myMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null } | null> } | null };

export type AllTeamsQueryVariables = Exact<{
  internalMemberFilter: MembershipFilter;
}>;


export type AllTeamsQuery = { __typename?: 'Query', myActiveTeams?: { __typename?: 'TeamsConnection', nodes: Array<{ __typename?: 'Team', id: string, name: string, isVisible: boolean, myMembership?: { __typename?: 'Membership', isSyncedWithExternalGroups: boolean, isManagedManually: boolean, createdAt: any, updatedAt: any, mayAdministrate: boolean, id: string, currentState: MembershipState, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null, userMemberships: { __typename?: 'MembershipsConnection', totalCount: number }, internalUserMemberships: { __typename?: 'MembershipsConnection', totalCount: number }, tenant?: { __typename?: 'Tenant', id: string, name: string } | null } | null> } | null, myInvitations?: { __typename?: 'TeamsConnection', nodes: Array<{ __typename?: 'Team', id: string, name: string, isVisible: boolean, userMemberships: { __typename?: 'MembershipsConnection', totalCount: number }, internalUserMemberships: { __typename?: 'MembershipsConnection', totalCount: number }, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, myMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null } | null> } | null };

export type MyTeamsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTeamsCountQuery = { __typename?: 'Query', myTeams?: { __typename?: 'TeamsConnection', totalCount: number } | null };

export type TeamDetailsByIdQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type TeamDetailsByIdQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, name: string, isVisible: boolean, activeUserMemberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, userHasActiveLicense?: boolean | null, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean, user?: { __typename?: 'User', id: string, email: string, firebaseAuthId?: string | null, displayName?: string | null } | null } | null> }, invitedUserMemberships: { __typename?: 'MembershipsConnection', nodes: Array<{ __typename?: 'Membership', id: string, user?: { __typename?: 'User', id: string, email: string, firebaseAuthId?: string | null, displayName?: string | null } | null } | null> }, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, myMembership?: { __typename?: 'Membership', id: string, currentState: MembershipState, mayAdministrate: boolean, mayBanUsers: boolean, mayDecideMembershipRequests: boolean, mayInviteUsers: boolean, mayOrderLicencesForThisTeam: boolean } | null } | null, workspaceSubscriptions?: { __typename?: 'WorkspaceSubscriptionsConnection', totalCount: number, nodes: Array<{ __typename?: 'WorkspaceSubscription', id: string, teamId: string, team?: { __typename?: 'Workspace', id: string, name: string, firebaseId: string } | null } | null> } | null };

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'Query', myAccount?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, mergedConfig?: { [key: string]: any } | Array<{ [key: string]: any } | string | number | boolean | null> | null, tenant?: { __typename?: 'Tenant', name: string, hasExternalGroups: boolean } | null } | null> } | null };

export type SendInvitationsMutationVariables = Exact<{
  teamId: Scalars['BigInt']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SendInvitationsMutation = { __typename?: 'Mutation', inviteToTeamByEmail?: { __typename?: 'InviteToTeamByEmailPayload', memberships?: Array<{ __typename?: 'Membership', id: string, user?: { __typename?: 'User', id: string, email: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null> | null } | null };

export type RemoveUserFromTeamMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type RemoveUserFromTeamMutation = { __typename?: 'Mutation', deleteMembership?: { __typename?: 'DeleteMembershipPayload', membership?: { __typename?: 'Membership', currentState: MembershipState } | null } | null };

export type ChangeRoleMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  mayAdministrate: Scalars['Boolean']['input'];
}>;


export type ChangeRoleMutation = { __typename?: 'Mutation', updateMembership?: { __typename?: 'UpdateMembershipPayload', clientMutationId?: string | null } | null };

export type AcceptTeamInvitationMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type AcceptTeamInvitationMutation = { __typename?: 'Mutation', updateMembership?: { __typename?: 'UpdateMembershipPayload', membership?: { __typename?: 'Membership', currentState: MembershipState } | null } | null };

export type WorkspacesForTeamQueryVariables = Exact<{
  teamId: Scalars['BigInt']['input'];
}>;


export type WorkspacesForTeamQuery = { __typename?: 'Query', workspaceSubscriptions?: { __typename?: 'WorkspaceSubscriptionsConnection', nodes: Array<{ __typename?: 'WorkspaceSubscription', id: string, team?: { __typename?: 'Workspace', id: string, name: string } | null } | null> } | null, myMemberships?: { __typename?: 'MembershipsConnection', nodes: Array<{ __typename?: 'Membership', team?: { __typename?: 'Team', id: string, name: string } | null } | null> } | null };

export type AddWorkspaceSubscriptionMutationVariables = Exact<{
  teamId: Scalars['BigInt']['input'];
  workspaceId: Scalars['BigInt']['input'];
}>;


export type AddWorkspaceSubscriptionMutation = { __typename?: 'Mutation', createWorkspaceSubscription?: { __typename?: 'CreateWorkspaceSubscriptionPayload', clientMutationId?: string | null } | null };

export type DeleteWorkspaceSubscriptionMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteWorkspaceSubscriptionMutation = { __typename?: 'Mutation', deleteWorkspaceSubscription?: { __typename?: 'DeleteWorkspaceSubscriptionPayload', clientMutationId?: string | null } | null };

export const DownloadableDocumentFragmentDoc = gql`
    fragment DownloadableDocument on Document {
  id
  downloadUrl
  displayTitle
  topTitle
  teaserText
  pages
  mimeType
  doesSupportSharedspace
  isDownloadable
  doesSupportFlows
  isUnbranded
  externalId
  expirationDate
  tags
  fileName
  firestoreId
  numNormalPages
  deletedAt
  internalLinks
  displayDate
  fileSize
  thumbnailDownloadUrl
  tags
  originalMimeType
  workspace {
    id
    myPrivileges {
      mayAdministrate
    }
  }
  rootWorkspace {
    firebaseId
    isHcpUploadWorkspace
    id
    myPrivileges {
      mayAdministrate
    }
  }
}
    `;
export const IncludeMagicPagesFragmentDoc = gql`
    fragment IncludeMagicPages on Document {
  documentRevisionByIdAndCurrentRevisionNumber {
    documentPagesByDocumentIdAndRevisionNumber {
      nodes {
        id
        pageType
        pageNumber
        linkedDocument {
          id
          firestoreId
        }
      }
    }
  }
}
    `;
export const DocumentSearchResultFragmentDoc = gql`
    fragment DocumentSearchResult on Document {
  displayTitle
  mimeType
  originalMimeType
  pages
  id
  rootWorkspace {
    isHcpUploadWorkspace
    id
    name
  }
  workspace {
    name
    parentId
  }
  doesSupportSharedspace
  thumbnailDownloadUrl
  doesSupportFlows
  tags
  documentExpiration {
    expiredAt
  }
}
    `;
export const WorkspaceDocumentFragmentDoc = gql`
    fragment WorkspaceDocument on Document {
  rootWorkspace {
    isHcpUploadWorkspace
  }
  fileName
  displayTitle
  firestoreId
  fileSize
  downloadUrl
  displayDate
  id
  lastModifiedAt
  mimeType
  originalMimeType
  originalStorageId
  order
  pages
  storageId
  teaserText
  tags
  thumbnailDownloadUrl
  topTitle
  isPublished
  isUnbranded
  doesSupportSharedspace
  doesSupportFlows
  numNormalPages
  workspaceId
  isDownloadable
  allowUserDownload
  externalId
  displayTeaserTextInSpace
  expirationDate
  workspace {
    name
    mayUseUrlBasedDocumentImport
  }
  documentExpiration {
    expiredAt
  }
}
    `;
export const WorkspaceDocumentWithLinkingPagesFragmentDoc = gql`
    fragment WorkspaceDocumentWithLinkingPages on Document {
  ...WorkspaceDocument
  importSource
  linkingPages {
    nodes {
      id
      pageNumber
      document {
        displayTitle
        id
        firestoreId
        thumbnailDownloadUrl
        workspace {
          id
        }
      }
    }
  }
}
    ${WorkspaceDocumentFragmentDoc}`;
export const ShortDocumentFragmentDoc = gql`
    fragment ShortDocument on Document {
  fileName
  displayTitle
  firestoreId
  fileSize
  downloadUrl
  displayDate
  id
  lastModifiedAt
  mimeType
  originalMimeType
  order
  pages
}
    `;
export const ExternalDocumentFragmentDoc = gql`
    fragment ExternalDocument on Document {
  id
  veevaDocumentMetadatum {
    veevaDocumentId
  }
  workspace {
    name
    id
    root {
      id
    }
  }
}
    `;
export const RootWorkspaceFragmentDoc = gql`
    fragment RootWorkspace on Workspace {
  isHcpUploadWorkspace
  name
  id
  myPrivileges {
    mayAdministrate
  }
}
    `;
export const ChildWorkspaceFragmentDoc = gql`
    fragment ChildWorkspace on Workspace {
  root {
    isHcpUploadWorkspace
  }
  isHcpUploadWorkspace
  name
  id
  parentId
  myPrivileges {
    mayAdministrate
  }
  documents(filter: {deletedAt: {isNull: true}}) {
    totalCount
  }
  childWorkspaces {
    totalCount
  }
}
    `;
export const RootWorkspaceWithChildrenFragmentDoc = gql`
    fragment RootWorkspaceWithChildren on Workspace {
  isHcpUploadWorkspace
  name
  id
  tags
  parentId
  childWorkspaces(orderBy: [TEAM_RANK_DESC, CREATED_AT_ASC, ID_ASC]) {
    nodes {
      ...ChildWorkspace
    }
  }
  root {
    firebaseId
    isHcpUploadWorkspace
    id
    myPrivileges {
      mayAdministrate
    }
    id
  }
  descendants {
    nodes {
      id
      name
    }
  }
}
    ${ChildWorkspaceFragmentDoc}`;
export const FlowDocumentFragmentDoc = gql`
    fragment FlowDocument on Document {
  id
  downloadUrl
  displayTitle
  topTitle
  teaserText
  pages
  mimeType
  doesSupportSharedspace
  fileName
  firestoreId
  deletedAt
  internalLinks
  thumbnailDownloadUrl
  numNormalPages
  workspaceId
  documentExpiration {
    expiredAt
  }
}
    `;
export const PageConfigFragmentDoc = gql`
    fragment PageConfig on DocumentPage {
  id
  pageNumber
  pageType
  updatedAt
  documentId
  linkedDocument {
    id
    displayTitle
    thumbnailDownloadUrl
    pages
    mimeType
    originalMimeType
    workspace {
      id
      root {
        id
      }
    }
    firestoreId
  }
}
    `;
export const ShortDocumentSpaceFragmentDoc = gql`
    fragment ShortDocumentSpace on DocumentSpace {
  id
  name
  updatedAt
}
    `;

export const ShortTeamFragmentDoc = gql`
    fragment ShortTeam on Team {
  id
  name
  isVisible
  tenant {
    id
    name
  }
  myMembership {
    id
    currentState
    mayAdministrate
    mayBanUsers
    mayDecideMembershipRequests
    mayInviteUsers
    mayOrderLicencesForThisTeam
  }
}
    `;
export const CreateUserFromFirebaseDocument = gql`
    mutation createUserFromFirebase {
  createUserFromFirebase(input: {}) {
    result {
      me {
        firebaseAuthId
        email
      }
    }
  }
}
    `;

export function useCreateUserFromFirebaseMutation() {
  return Urql.useMutation<CreateUserFromFirebaseMutation, CreateUserFromFirebaseMutationVariables>(CreateUserFromFirebaseDocument);
};
export const AcceptAppConsentDocument = gql`
    mutation AcceptAppConsent($now: Datetime!, $id: BigInt!) {
  updateUser(input: {patch: {appConsentGivenAt: $now}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useAcceptAppConsentMutation() {
  return Urql.useMutation<AcceptAppConsentMutation, AcceptAppConsentMutationVariables>(AcceptAppConsentDocument);
};
export const DocumentSpaceSearchDocument = gql`
    query DocumentSpaceSearch($search: String!) {
  documentSpaces(
    filter: {name: {includesInsensitive: $search}}
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
    }
  }
}
    `;

export function useDocumentSpaceSearchQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceSearchQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceSearchQuery, DocumentSpaceSearchQueryVariables | undefined>({ query: DocumentSpaceSearchDocument, variables: undefined, ...options });
};
export const DocumentSpacePickerDocument = gql`
    query DocumentSpacePicker($search: String!, $documentId: BigInt) {
  documentSpaces(
    filter: {name: {includesInsensitive: $search}}
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      documentSpaceItems(condition: {documentId: $documentId}) {
        nodes {
          documentId
        }
      }
      config {
        name
      }
    }
  }
}
    `;

export function useDocumentSpacePickerQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpacePickerQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpacePickerQuery, DocumentSpacePickerQueryVariables | undefined>({ query: DocumentSpacePickerDocument, variables: undefined, ...options });
};
export const GetDocumentByIdDocument = gql`
    query GetDocumentById($id: BigInt!) {
  document(id: $id) {
    ...DownloadableDocument
    ...IncludeMagicPages
  }
}
    ${DownloadableDocumentFragmentDoc}
${IncludeMagicPagesFragmentDoc}`;

export function useGetDocumentByIdQuery(options?: Omit<Urql.UseQueryArgs<never, GetDocumentByIdQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetDocumentByIdQuery, GetDocumentByIdQueryVariables | undefined>({ query: GetDocumentByIdDocument, variables: undefined, ...options });
};
export const GetDocumentByFirestoreIdDocument = gql`
    query GetDocumentByFirestoreId($id: String!) {
  document: documentByFirestoreId(firestoreId: $id) {
    ...DownloadableDocument
    ...IncludeMagicPages
  }
}
    ${DownloadableDocumentFragmentDoc}
${IncludeMagicPagesFragmentDoc}`;

export function useGetDocumentByFirestoreIdQuery(options?: Omit<Urql.UseQueryArgs<never, GetDocumentByFirestoreIdQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetDocumentByFirestoreIdQuery, GetDocumentByFirestoreIdQueryVariables | undefined>({ query: GetDocumentByFirestoreIdDocument, variables: undefined, ...options });
};
export const GetTeamCandidatesDocument = gql`
    query GetTeamCandidates($search: String!, $tenantId: BigInt!, $teamId: BigInt!) {
  tenant(id: $tenantId) {
    id
    name
    users(
      orderBy: EMAIL_ASC
      filter: {or: [{email: {includesInsensitive: $search}}, {displayName: {includesInsensitive: $search}}]}
    ) {
      nodes {
        id
        displayName
        email
        memberships(condition: {teamId: $teamId}) {
          nodes {
            id
            currentState
            mayAdministrate
          }
        }
      }
    }
  }
}
    `;

export function useGetTeamCandidatesQuery(options?: Omit<Urql.UseQueryArgs<never, GetTeamCandidatesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetTeamCandidatesQuery, GetTeamCandidatesQueryVariables | undefined>({ query: GetTeamCandidatesDocument, variables: undefined, ...options });
};
export const DocumentHistoryDocument = gql`
    query DocumentHistory($first: Int = 50, $offset: Int = 0) {
  documentHistoryEntries(
    first: $first
    offset: $offset
    orderBy: [STARTS_AT_DESC, ID_ASC]
    filter: {documentExists: true}
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      runId
      document {
        id
        thumbnailDownloadUrl
        displayTitle
      }
      date
      startsAt
      endsAt
      duration {
        seconds
        minutes
        hours
        days
      }
      activeDuration {
        seconds
        minutes
        hours
      }
      label {
        assignmentRevision
        hcpCount
        hcpContacts {
          nodes {
            id
            firstName
            lastName
          }
        }
        text
        crmContactId
        crmContact {
          lastName
          firstName
        }
      }
    }
  }
}
    `;

export function useDocumentHistoryQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentHistoryQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentHistoryQuery, DocumentHistoryQueryVariables | undefined>({ query: DocumentHistoryDocument, variables: undefined, ...options });
};
export const NumUnlabeledDocumentViewsDocument = gql`
    query NumUnlabeledDocumentViews {
  documentHistoryEntries(filter: {documentExists: true, labelExists: false}) {
    totalCount
  }
}
    `;

export function useNumUnlabeledDocumentViewsQuery(options?: Omit<Urql.UseQueryArgs<never, NumUnlabeledDocumentViewsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<NumUnlabeledDocumentViewsQuery, NumUnlabeledDocumentViewsQueryVariables | undefined>({ query: NumUnlabeledDocumentViewsDocument, variables: undefined, ...options });
};
export const MarkAsVisitDocument = gql`
    mutation MarkAsVisit($documentViewIds: [UUID!]!, $crmContactId: BigInt) {
  markAsVisit(
    input: {documentViewId: $documentViewIds, crmContactId: $crmContactId}
  ) {
    clientMutationId
  }
}
    `;

export function useMarkAsVisitMutation() {
  return Urql.useMutation<MarkAsVisitMutation, MarkAsVisitMutationVariables>(MarkAsVisitDocument);
};
export const MarkAsSelfStudyDocument = gql`
    mutation MarkAsSelfStudy($documentViewIds: [UUID!]!) {
  markAsSelfStudy(input: {documentViewId: $documentViewIds}) {
    clientMutationId
  }
}
    `;

export function useMarkAsSelfStudyMutation() {
  return Urql.useMutation<MarkAsSelfStudyMutation, MarkAsSelfStudyMutationVariables>(MarkAsSelfStudyDocument);
};
export const SearchDocumentsDocument = gql`
    query SearchDocuments($term: String!, $mustBeAdmin: Boolean, $rootId: BigInt) {
  searchDocuments(
    term: $term
    mustBeAdmin: $mustBeAdmin
    rootId: $rootId
    shortenMatches: false
  ) {
    nodes {
      matchInDisplayTitle
      document {
        ...DocumentSearchResult
      }
    }
  }
}
    ${DocumentSearchResultFragmentDoc}`;

export function useSearchDocumentsQuery(options?: Omit<Urql.UseQueryArgs<never, SearchDocumentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SearchDocumentsQuery, SearchDocumentsQueryVariables | undefined>({ query: SearchDocumentsDocument, variables: undefined, ...options });
};
export const DocumentsByWorkspaceDocument = gql`
    query DocumentsByWorkspace($workspaceId: BigInt!) {
  documents(
    condition: {workspaceId: $workspaceId}
    filter: {deletedAt: {isNull: true}}
    orderBy: [ORDER_DESC, UPLOADED_AT_DESC]
  ) {
    nodes {
      ...DocumentSearchResult
    }
  }
}
    ${DocumentSearchResultFragmentDoc}`;

export function useDocumentsByWorkspaceQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentsByWorkspaceQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentsByWorkspaceQuery, DocumentsByWorkspaceQueryVariables | undefined>({ query: DocumentsByWorkspaceDocument, variables: undefined, ...options });
};
export const DocumentsSharedWithCrmContactDocument = gql`
    query DocumentsSharedWithCrmContact($crmContactId: BigInt!, $documentSpaceId: BigInt!) {
  crmContact(id: $crmContactId) {
    documentsSharedWithContact(exceptDocumentSpaceId: $documentSpaceId) {
      nodes {
        id
      }
    }
  }
}
    `;

export function useDocumentsSharedWithCrmContactQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentsSharedWithCrmContactQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentsSharedWithCrmContactQuery, DocumentsSharedWithCrmContactQueryVariables | undefined>({ query: DocumentsSharedWithCrmContactDocument, variables: undefined, ...options });
};
export const WorkspaceForDocumentDocument = gql`
    query WorkspaceForDocument($documentId: BigInt!) {
  document(id: $documentId) {
    workspaceId
    rootWorkspace {
      isHcpUploadWorkspace
      id
    }
  }
}
    `;

export function useWorkspaceForDocumentQuery(options?: Omit<Urql.UseQueryArgs<never, WorkspaceForDocumentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<WorkspaceForDocumentQuery, WorkspaceForDocumentQueryVariables | undefined>({ query: WorkspaceForDocumentDocument, variables: undefined, ...options });
};
export const AllDocumentSpaceConfigsDocument = gql`
    query AllDocumentSpaceConfigs {
  myAdministratedTeams(filter: {isWorkspace: {equalTo: false}}) {
    nodes {
      id
      name
      tenant {
        id
      }
      documentSpaceConfigs {
        nodes {
          id
          groupId
          name
          logoUrl
          heroImageUrl
          updatedAt
          tenantGroup {
            name
          }
          spaceCount
          team {
            id
            name
          }
        }
      }
    }
  }
}
    `;

export function useAllDocumentSpaceConfigsQuery(options?: Omit<Urql.UseQueryArgs<never, AllDocumentSpaceConfigsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<AllDocumentSpaceConfigsQuery, AllDocumentSpaceConfigsQueryVariables | undefined>({ query: AllDocumentSpaceConfigsDocument, variables: undefined, ...options });
};
export const DocumentSpaceConfigDocument = gql`
    query DocumentSpaceConfig($id: BigInt!) {
  documentSpaceConfig(id: $id) {
    id
    createdAt
    groupId
    defaultLanguage
    displayOptOut
    footerLinks
    footerText
    heroImageUrl
    heroLinkText
    heroLinkUrl
    heroSubtitle
    heroTitle
    legalNote
    legalNoteUrl
    logoUrl
    name
    title
    productName
    indication
    linkedTabOrder
    newTab
    requiresEmailAuthentication
    spaceCount
    teamId
    team {
      name
    }
    updatedAt
    documentSpaceLinksByConfigId(orderBy: POSITION_ASC) {
      nodes {
        isMandatory
        position
        sectionTitle
        title
        url
        id
        nodeId
        documentSpaceLinkTranslationsByLinkId {
          nodes {
            id
            languageCode
            sectionTitle
            url
            title
          }
        }
      }
    }
    documentSpaceConfigTranslationsByConfigId {
      nodes {
        languageCode
        id
        heroImageUrl
        heroLinkUrl
        heroTitle
        footerText
        legalNote
        legalNoteUrl
        footerLinks
      }
    }
  }
}
    `;

export function useDocumentSpaceConfigQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceConfigQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceConfigQuery, DocumentSpaceConfigQueryVariables | undefined>({ query: DocumentSpaceConfigDocument, variables: undefined, ...options });
};
export const UpdateDocumentSpaceConfigBannerDocument = gql`
    mutation UpdateDocumentSpaceConfigBanner($id: BigInt!, $heroImageUrl: String, $heroLinkUrl: String) {
  updateDocumentSpaceConfig(
    input: {id: $id, patch: {heroImageUrl: $heroImageUrl, heroLinkUrl: $heroLinkUrl}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigBannerMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigBannerMutation, UpdateDocumentSpaceConfigBannerMutationVariables>(UpdateDocumentSpaceConfigBannerDocument);
};
export const UpdateDocumentSpaceConfigNameDocument = gql`
    mutation UpdateDocumentSpaceConfigName($id: BigInt!, $name: String!) {
  updateDocumentSpaceConfig(input: {id: $id, patch: {name: $name}}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigNameMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigNameMutation, UpdateDocumentSpaceConfigNameMutationVariables>(UpdateDocumentSpaceConfigNameDocument);
};
export const UpdateDocumentSpaceConfigSettingsDocument = gql`
    mutation UpdateDocumentSpaceConfigSettings($id: BigInt!, $name: String!, $title: String!, $productName: String, $indication: String, $requiresEmailAuthentication: Boolean!, $groupId: BigInt) {
  updateDocumentSpaceConfig(
    input: {id: $id, patch: {name: $name, title: $title, productName: $productName, indication: $indication, requiresEmailAuthentication: $requiresEmailAuthentication, groupId: $groupId}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigSettingsMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigSettingsMutation, UpdateDocumentSpaceConfigSettingsMutationVariables>(UpdateDocumentSpaceConfigSettingsDocument);
};
export const UpdateDocumentSpaceConfigTranslationBannerDocument = gql`
    mutation UpdateDocumentSpaceConfigTranslationBanner($id: BigInt!, $heroImageUrl: String, $heroLinkUrl: String) {
  updateDocumentSpaceConfigTranslation(
    input: {id: $id, patch: {heroImageUrl: $heroImageUrl, heroLinkUrl: $heroLinkUrl}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigTranslationBannerMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigTranslationBannerMutation, UpdateDocumentSpaceConfigTranslationBannerMutationVariables>(UpdateDocumentSpaceConfigTranslationBannerDocument);
};
export const UpdateDocumentSpaceConfigLinkDocument = gql`
    mutation UpdateDocumentSpaceConfigLink($id: BigInt!, $sectionTitle: String, $title: String, $url: String!, $isMandatory: Boolean!) {
  updateDocumentSpaceLink(
    input: {patch: {isMandatory: $isMandatory, sectionTitle: $sectionTitle, title: $title, url: $url}, id: $id}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigLinkMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigLinkMutation, UpdateDocumentSpaceConfigLinkMutationVariables>(UpdateDocumentSpaceConfigLinkDocument);
};
export const UpdateDocumentSpaceConfigLinkTranslationDocument = gql`
    mutation UpdateDocumentSpaceConfigLinkTranslation($id: BigInt!, $sectionTitle: String, $title: String, $url: String!) {
  updateDocumentSpaceLinkTranslation(
    input: {patch: {sectionTitle: $sectionTitle, title: $title, url: $url}, id: $id}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigLinkTranslationMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigLinkTranslationMutation, UpdateDocumentSpaceConfigLinkTranslationMutationVariables>(UpdateDocumentSpaceConfigLinkTranslationDocument);
};
export const UpdateDocumentSpaceConfigFooterDocument = gql`
    mutation UpdateDocumentSpaceConfigFooter($id: BigInt!, $footerText: String) {
  updateDocumentSpaceConfig(input: {id: $id, patch: {footerText: $footerText}}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigFooterMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigFooterMutation, UpdateDocumentSpaceConfigFooterMutationVariables>(UpdateDocumentSpaceConfigFooterDocument);
};
export const UpdateDocumentSpaceConfigTranslationFooterDocument = gql`
    mutation UpdateDocumentSpaceConfigTranslationFooter($id: BigInt!, $footerText: String) {
  updateDocumentSpaceConfigTranslation(
    input: {id: $id, patch: {footerText: $footerText}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigTranslationFooterMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigTranslationFooterMutation, UpdateDocumentSpaceConfigTranslationFooterMutationVariables>(UpdateDocumentSpaceConfigTranslationFooterDocument);
};
export const UpdateDocumentSpaceConfigFooterLinksDocument = gql`
    mutation UpdateDocumentSpaceConfigFooterLinks($id: BigInt!, $footerLinks: JSON) {
  updateDocumentSpaceConfig(input: {id: $id, patch: {footerLinks: $footerLinks}}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigFooterLinksMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigFooterLinksMutation, UpdateDocumentSpaceConfigFooterLinksMutationVariables>(UpdateDocumentSpaceConfigFooterLinksDocument);
};
export const UpdateDocumentSpaceConfigTranslationFooterLinksDocument = gql`
    mutation UpdateDocumentSpaceConfigTranslationFooterLinks($id: BigInt!, $footerLinks: JSON) {
  updateDocumentSpaceConfigTranslation(
    input: {id: $id, patch: {footerLinks: $footerLinks}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigTranslationFooterLinksMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigTranslationFooterLinksMutation, UpdateDocumentSpaceConfigTranslationFooterLinksMutationVariables>(UpdateDocumentSpaceConfigTranslationFooterLinksDocument);
};
export const UpdateDocumentSpaceConfigLegalNoteDocument = gql`
    mutation UpdateDocumentSpaceConfigLegalNote($id: BigInt!, $legalNote: String, $legalNoteUrl: String) {
  updateDocumentSpaceConfig(
    input: {id: $id, patch: {legalNote: $legalNote, legalNoteUrl: $legalNoteUrl}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigLegalNoteMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigLegalNoteMutation, UpdateDocumentSpaceConfigLegalNoteMutationVariables>(UpdateDocumentSpaceConfigLegalNoteDocument);
};
export const UpdateDocumentSpaceConfigTranslationLegalNoteDocument = gql`
    mutation UpdateDocumentSpaceConfigTranslationLegalNote($id: BigInt!, $legalNote: String, $legalNoteUrl: String) {
  updateDocumentSpaceConfigTranslation(
    input: {id: $id, patch: {legalNote: $legalNote, legalNoteUrl: $legalNoteUrl}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigTranslationLegalNoteMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigTranslationLegalNoteMutation, UpdateDocumentSpaceConfigTranslationLegalNoteMutationVariables>(UpdateDocumentSpaceConfigTranslationLegalNoteDocument);
};
export const DeleteDocumentSpaceConfigLinkDocument = gql`
    mutation DeleteDocumentSpaceConfigLink($linkId: BigInt!) {
  deleteDocumentSpaceLink(input: {id: $linkId}) {
    clientMutationId
  }
}
    `;

export function useDeleteDocumentSpaceConfigLinkMutation() {
  return Urql.useMutation<DeleteDocumentSpaceConfigLinkMutation, DeleteDocumentSpaceConfigLinkMutationVariables>(DeleteDocumentSpaceConfigLinkDocument);
};
export const CreateDocumentSpaceConfigLinkDocument = gql`
    mutation CreateDocumentSpaceConfigLink($configId: BigInt!, $url: String!, $title: String!, $sectionTitle: String, $isMandatory: Boolean!) {
  createDocumentSpaceLink(
    input: {documentSpaceLink: {title: $title, sectionTitle: $sectionTitle, url: $url, configId: $configId, isMandatory: $isMandatory}}
  ) {
    clientMutationId
    documentSpaceLink {
      id
    }
  }
}
    `;

export function useCreateDocumentSpaceConfigLinkMutation() {
  return Urql.useMutation<CreateDocumentSpaceConfigLinkMutation, CreateDocumentSpaceConfigLinkMutationVariables>(CreateDocumentSpaceConfigLinkDocument);
};
export const CreateDocumentSpaceConfigLinkTranslationDocument = gql`
    mutation CreateDocumentSpaceConfigLinkTranslation($linkId: BigInt!, $languageCode: String!, $url: String!, $title: String!, $sectionTitle: String) {
  createDocumentSpaceLinkTranslation(
    input: {documentSpaceLinkTranslation: {title: $title, sectionTitle: $sectionTitle, url: $url, linkId: $linkId, languageCode: $languageCode}}
  ) {
    clientMutationId
  }
}
    `;

export function useCreateDocumentSpaceConfigLinkTranslationMutation() {
  return Urql.useMutation<CreateDocumentSpaceConfigLinkTranslationMutation, CreateDocumentSpaceConfigLinkTranslationMutationVariables>(CreateDocumentSpaceConfigLinkTranslationDocument);
};
export const UpdateDocumentSpaceConfigLogoDocument = gql`
    mutation UpdateDocumentSpaceConfigLogo($id: BigInt!, $logoUrl: String!) {
  updateDocumentSpaceConfig(input: {id: $id, patch: {logoUrl: $logoUrl}}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigLogoMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigLogoMutation, UpdateDocumentSpaceConfigLogoMutationVariables>(UpdateDocumentSpaceConfigLogoDocument);
};
export const CopyDocumentSpaceConfigDocument = gql`
    mutation CopyDocumentSpaceConfig($id: BigInt!, $name: String!, $teamId: BigInt!, $copyTranslations: Boolean!, $compatibilityGroupId: BigInt) {
  copyDocumentSpaceConfig(
    input: {configId: $id, name: $name, copyTranslations: $copyTranslations, teamId: $teamId, compatibilityGroupId: $compatibilityGroupId}
  ) {
    newConfig {
      id
      name
    }
  }
}
    `;

export function useCopyDocumentSpaceConfigMutation() {
  return Urql.useMutation<CopyDocumentSpaceConfigMutation, CopyDocumentSpaceConfigMutationVariables>(CopyDocumentSpaceConfigDocument);
};
export const CreateDocumentSpaceConfigWithDefaultsDocument = gql`
    mutation CreateDocumentSpaceConfigWithDefaults($name: String!, $teamId: BigInt!, $compatibilityGroupId: BigInt) {
  createDocumentSpaceConfigWithDefaults(
    input: {name: $name, teamId: $teamId, compatibilityGroupId: $compatibilityGroupId}
  ) {
    newConfig {
      id
      name
    }
  }
}
    `;

export function useCreateDocumentSpaceConfigWithDefaultsMutation() {
  return Urql.useMutation<CreateDocumentSpaceConfigWithDefaultsMutation, CreateDocumentSpaceConfigWithDefaultsMutationVariables>(CreateDocumentSpaceConfigWithDefaultsDocument);
};
export const DeleteSharedSpaceTemplateDocument = gql`
    mutation DeleteSharedSpaceTemplate($id: BigInt!, $replacementConfigId: BigInt) {
  deleteSharedSpaceTemplate(
    input: {configId: $id, replacementConfigId: $replacementConfigId}
  ) {
    result {
      deletedConfigId
      usedReplacementConfigId
      affectedSpaceCount
      status
    }
  }
}
    `;

export function useDeleteSharedSpaceTemplateMutation() {
  return Urql.useMutation<DeleteSharedSpaceTemplateMutation, DeleteSharedSpaceTemplateMutationVariables>(DeleteSharedSpaceTemplateDocument);
};
export const DocumentSpaceCompatibilityGroupsDocument = gql`
    query DocumentSpaceCompatibilityGroups {
  documentSpaceLinkGroups {
    nodes {
      id
      name
      tenantId
    }
  }
}
    `;

export function useDocumentSpaceCompatibilityGroupsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceCompatibilityGroupsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceCompatibilityGroupsQuery, DocumentSpaceCompatibilityGroupsQueryVariables | undefined>({ query: DocumentSpaceCompatibilityGroupsDocument, variables: undefined, ...options });
};
export const CreateDocumentSpaceConfigTranslationDocument = gql`
    mutation CreateDocumentSpaceConfigTranslation($configId: BigInt!, $languageCode: String!) {
  createDocumentSpaceConfigTranslation(
    input: {documentSpaceConfigTranslation: {configId: $configId, languageCode: $languageCode}}
  ) {
    clientMutationId
    documentSpaceConfigTranslation {
      id
      languageCode
    }
  }
}
    `;

export function useCreateDocumentSpaceConfigTranslationMutation() {
  return Urql.useMutation<CreateDocumentSpaceConfigTranslationMutation, CreateDocumentSpaceConfigTranslationMutationVariables>(CreateDocumentSpaceConfigTranslationDocument);
};
export const DeleteDocumentSpaceConfigTranslationDocument = gql`
    mutation DeleteDocumentSpaceConfigTranslation($id: BigInt!) {
  deleteDocumentSpaceConfigTranslation(input: {id: $id}) {
    clientMutationId
  }
}
    `;

export function useDeleteDocumentSpaceConfigTranslationMutation() {
  return Urql.useMutation<DeleteDocumentSpaceConfigTranslationMutation, DeleteDocumentSpaceConfigTranslationMutationVariables>(DeleteDocumentSpaceConfigTranslationDocument);
};
export const WorkspaceDocumentsDocument = gql`
    query WorkspaceDocuments($workspaceId: BigInt!) {
  documents(
    condition: {workspaceId: $workspaceId}
    filter: {deletedAt: {isNull: true}}
    orderBy: [ORDER_DESC, UPLOADED_AT_DESC]
  ) {
    nodes {
      ...WorkspaceDocument
    }
  }
}
    ${WorkspaceDocumentFragmentDoc}`;

export function useWorkspaceDocumentsQuery(options?: Omit<Urql.UseQueryArgs<never, WorkspaceDocumentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<WorkspaceDocumentsQuery, WorkspaceDocumentsQueryVariables | undefined>({ query: WorkspaceDocumentsDocument, variables: undefined, ...options });
};
export const DocumentDocument = gql`
    query Document($id: BigInt!) {
  document(id: $id) {
    ...WorkspaceDocumentWithLinkingPages
    deletedAt
    rootWorkspace {
      id
      myPrivileges {
        mayAdministrate
      }
    }
  }
  documentUsageCounts(documentId: $id) {
    numCustomFlows
    numPresentations
    numSpaces
  }
}
    ${WorkspaceDocumentWithLinkingPagesFragmentDoc}`;

export function useDocumentQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentQuery, DocumentQueryVariables | undefined>({ query: DocumentDocument, variables: undefined, ...options });
};
export const DocumentEditorShellDocument = gql`
    query DocumentEditorShell($id: BigInt!) {
  document(id: $id) {
    ...WorkspaceDocument
    deletedAt
    rootWorkspace {
      id
      myPrivileges {
        mayAdministrate
      }
    }
  }
}
    ${WorkspaceDocumentFragmentDoc}`;

export function useDocumentEditorShellQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentEditorShellQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentEditorShellQuery, DocumentEditorShellQueryVariables | undefined>({ query: DocumentEditorShellDocument, variables: undefined, ...options });
};
export const ShortDocumentDocument = gql`
    query ShortDocument($id: BigInt!) {
  document(id: $id) {
    ...ShortDocument
  }
}
    ${ShortDocumentFragmentDoc}`;

export function useShortDocumentQuery(options?: Omit<Urql.UseQueryArgs<never, ShortDocumentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<ShortDocumentQuery, ShortDocumentQueryVariables | undefined>({ query: ShortDocumentDocument, variables: undefined, ...options });
};
export const DocumentRevisionCheckDocument = gql`
    query DocumentRevisionCheck($id: BigInt!) {
  document(id: $id) {
    mimeType
    isProcessing
    currentRevisionNumber
    documentRevisions(first: 1, orderBy: REVISION_NUMBER_DESC) {
      nodes {
        revisionNumber
        hasProcessingError
      }
    }
  }
}
    `;

export function useDocumentRevisionCheckQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentRevisionCheckQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentRevisionCheckQuery, DocumentRevisionCheckQueryVariables | undefined>({ query: DocumentRevisionCheckDocument, variables: undefined, ...options });
};
export const CreateDocumentDocument = gql`
    mutation CreateDocument($document: DocumentInput!) {
  createDocument(input: {document: $document}) {
    document {
      id
      firestoreId
    }
  }
}
    `;

export function useCreateDocumentMutation() {
  return Urql.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument);
};
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($id: BigInt!, $patch: DocumentPatch!) {
  updateDocument(input: {patch: $patch, id: $id}) {
    document {
      id
    }
  }
}
    `;

export function useUpdateDocumentMutation() {
  return Urql.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument);
};
export const MoveDocumentDocument = gql`
    mutation MoveDocument($documentId: BigInt!, $toWorkspaceId: BigInt!) {
  updateDocument(input: {patch: {workspaceId: $toWorkspaceId}, id: $documentId}) {
    document {
      id
      workspaceId
    }
  }
}
    `;

export function useMoveDocumentMutation() {
  return Urql.useMutation<MoveDocumentMutation, MoveDocumentMutationVariables>(MoveDocumentDocument);
};
export const CopyDocumentDocument = gql`
    mutation CopyDocument($newName: String!, $targetWorkspaceId: BigInt!, $withId: BigInt!) {
  copyDocument(
    input: {newName: $newName, targetWorkspaceId: $targetWorkspaceId, withId: $withId}
  ) {
    clientMutationId
    copiedDocument {
      id
    }
  }
}
    `;

export function useCopyDocumentMutation() {
  return Urql.useMutation<CopyDocumentMutation, CopyDocumentMutationVariables>(CopyDocumentDocument);
};
export const ReorderDocumentDocument = gql`
    mutation ReorderDocument($documentId: BigInt!, $aboveId: BigInt, $belowId: BigInt) {
  placeDocument(
    input: {withId: $documentId, aboveId: $aboveId, belowId: $belowId}
  ) {
    documents {
      id
    }
  }
}
    `;

export function useReorderDocumentMutation() {
  return Urql.useMutation<ReorderDocumentMutation, ReorderDocumentMutationVariables>(ReorderDocumentDocument);
};
export const AllTagsDocument = gql`
    query AllTags {
  alreadyUsedTagsList
}
    `;

export function useAllTagsQuery(options?: Omit<Urql.UseQueryArgs<never, AllTagsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<AllTagsQuery, AllTagsQueryVariables | undefined>({ query: AllTagsDocument, variables: undefined, ...options });
};
export const DocumentUsageCountsDocument = gql`
    query DocumentUsageCounts($documentId: BigInt!) {
  documentUsageCounts(documentId: $documentId) {
    numCustomFlows
    numPresentations
    numSpaces
  }
}
    `;

export function useDocumentUsageCountsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentUsageCountsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentUsageCountsQuery, DocumentUsageCountsQueryVariables | undefined>({ query: DocumentUsageCountsDocument, variables: undefined, ...options });
};
export const FindVeevaDocumentsDocument = gql`
    query FindVeevaDocuments {
  documents(
    filter: {veevaDocumentMetadatumExists: true}
    condition: {deletedAt: null}
  ) {
    nodes {
      ...ExternalDocument
    }
  }
}
    ${ExternalDocumentFragmentDoc}`;

export function useFindVeevaDocumentsQuery(options?: Omit<Urql.UseQueryArgs<never, FindVeevaDocumentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<FindVeevaDocumentsQuery, FindVeevaDocumentsQueryVariables | undefined>({ query: FindVeevaDocumentsDocument, variables: undefined, ...options });
};
export const VeevaDocumentMetadataDocument = gql`
    query VeevaDocumentMetadata($documentId: BigInt!) {
  veevaDocumentMetadata(condition: {documentId: $documentId}) {
    nodes {
      expirationDate
      majorVersion
      minorVersion
      versionCreationDate
      veevaDocumentId
      documentNumber
    }
  }
}
    `;

export function useVeevaDocumentMetadataQuery(options?: Omit<Urql.UseQueryArgs<never, VeevaDocumentMetadataQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<VeevaDocumentMetadataQuery, VeevaDocumentMetadataQueryVariables | undefined>({ query: VeevaDocumentMetadataDocument, variables: undefined, ...options });
};
export const FetchCurrentUserDocument = gql`
    query FetchCurrentUser {
  myAccount {
    totalCount
    nodes {
      id
      displayName
      email
      externalGroupsSyncedAt
      tenant {
        id
        name
        hasExternalGroups
      }
    }
  }
}
    `;

export function useFetchCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<never, FetchCurrentUserQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables | undefined>({ query: FetchCurrentUserDocument, variables: undefined, ...options });
};
export const CreateWorkspaceDocument = gql`
    mutation CreateWorkspace($name: String!) {
  createWorkspaceAndJoin(input: {name: $name}) {
    result {
      createdWorkspace {
        id
        name
      }
    }
  }
}
    `;

export function useCreateWorkspaceMutation() {
  return Urql.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument);
};
export const MyWorkspacesDocument = gql`
    query MyWorkspaces {
  workspaces {
    nodes {
      name
      id
      tags
      parentId
      firebaseId
      isHcpUploadWorkspace
      root {
        firebaseId
        isHcpUploadWorkspace
        id
        myPrivileges {
          mayAdministrate
        }
        id
      }
    }
  }
}
    `;

export function useMyWorkspacesQuery(options?: Omit<Urql.UseQueryArgs<never, MyWorkspacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyWorkspacesQuery, MyWorkspacesQueryVariables | undefined>({ query: MyWorkspacesDocument, variables: undefined, ...options });
};
export const MyRootWorkspacesDocument = gql`
    query MyRootWorkspaces {
  workspaces(
    condition: {parentId: null}
    orderBy: [TEAM_RANK_DESC, NAME_LOWERCASE_ASC, ID_ASC]
  ) {
    nodes {
      ...RootWorkspace
    }
  }
}
    ${RootWorkspaceFragmentDoc}`;

export function useMyRootWorkspacesQuery(options?: Omit<Urql.UseQueryArgs<never, MyRootWorkspacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyRootWorkspacesQuery, MyRootWorkspacesQueryVariables | undefined>({ query: MyRootWorkspacesDocument, variables: undefined, ...options });
};
export const RootWorkspacesWithChildrenDocument = gql`
    query RootWorkspacesWithChildren {
  workspaces(
    condition: {parentId: null}
    orderBy: [TEAM_RANK_DESC, NAME_LOWERCASE_ASC, ID_ASC]
  ) {
    nodes {
      ...RootWorkspaceWithChildren
    }
  }
}
    ${RootWorkspaceWithChildrenFragmentDoc}`;

export function useRootWorkspacesWithChildrenQuery(options?: Omit<Urql.UseQueryArgs<never, RootWorkspacesWithChildrenQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<RootWorkspacesWithChildrenQuery, RootWorkspacesWithChildrenQueryVariables | undefined>({ query: RootWorkspacesWithChildrenDocument, variables: undefined, ...options });
};
export const WorkspaceWithChildWorkspacesDocument = gql`
    query WorkspaceWithChildWorkspaces($id: BigInt!) {
  workspace(id: $id) {
    isHcpUploadWorkspace
    root {
      isHcpUploadWorkspace
    }
    canBeDeleted
    mayUseUrlBasedDocumentImport
    childWorkspaces(orderBy: [TEAM_RANK_DESC, CREATED_AT_ASC, ID_ASC]) {
      nodes {
        ...ChildWorkspace
      }
    }
    name
    ancestors(reversed: true) {
      nodes {
        id
        name
      }
    }
    parent {
      id
      name
    }
    myPrivileges {
      mayAdministrate
    }
    workspaceSubscriptionsByTeamId(
      filter: {subteamId: {isNull: false}, subteamExists: true}
      orderBy: TEAM_BY_SUBTEAM_ID__NAME_ASC
    ) {
      nodes {
        subteam {
          name
          id
        }
      }
    }
  }
}
    ${ChildWorkspaceFragmentDoc}`;

export function useWorkspaceWithChildWorkspacesQuery(options?: Omit<Urql.UseQueryArgs<never, WorkspaceWithChildWorkspacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<WorkspaceWithChildWorkspacesQuery, WorkspaceWithChildWorkspacesQueryVariables | undefined>({ query: WorkspaceWithChildWorkspacesDocument, variables: undefined, ...options });
};
export const WorkspaceTreeDocument = gql`
    query WorkspaceTree($parentId: BigInt, $orderBy: [WorkspacesOrderBy!]!) {
  workspaces(condition: {parentId: $parentId}, orderBy: $orderBy) {
    nodes {
      isHcpUploadWorkspace
      root {
        isHcpUploadWorkspace
      }
      name
      id
      childWorkspaces {
        totalCount
      }
      descendants {
        nodes {
          id
        }
      }
      myPrivileges {
        mayAdministrate
      }
    }
  }
}
    `;

export function useWorkspaceTreeQuery(options?: Omit<Urql.UseQueryArgs<never, WorkspaceTreeQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<WorkspaceTreeQuery, WorkspaceTreeQueryVariables | undefined>({ query: WorkspaceTreeDocument, variables: undefined, ...options });
};
export const WorkspaceDetailsDocument = gql`
    query WorkspaceDetails($id: BigInt!) {
  workspace(id: $id) {
    isHcpUploadWorkspace
    root {
      isHcpUploadWorkspace
    }
    name
    id
    canBeDeleted
    documents(filter: {deletedAt: {isNull: true}}) {
      totalCount
    }
    ancestors(reversed: true) {
      nodes {
        id
        name
      }
      totalCount
    }
    parentId
    totalMemberCount
    workspaceSubscriptionsByTeamId(
      filter: {subteamId: {isNull: false}, subteamExists: true}
      orderBy: TEAM_BY_SUBTEAM_ID__NAME_ASC
    ) {
      nodes {
        subteam {
          name
          id
        }
      }
    }
  }
}
    `;

export function useWorkspaceDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, WorkspaceDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<WorkspaceDetailsQuery, WorkspaceDetailsQueryVariables | undefined>({ query: WorkspaceDetailsDocument, variables: undefined, ...options });
};
export const UpdateWorkspaceNameDocument = gql`
    mutation UpdateWorkspaceName($id: BigInt!, $name: String!) {
  updateWorkspace(input: {patch: {name: $name}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useUpdateWorkspaceNameMutation() {
  return Urql.useMutation<UpdateWorkspaceNameMutation, UpdateWorkspaceNameMutationVariables>(UpdateWorkspaceNameDocument);
};
export const TeamCandidatesForWorkspaceDocument = gql`
    query TeamCandidatesForWorkspace($id: BigInt!) {
  myMemberships(
    filter: {mayAdministrate: {equalTo: true}, team: {isWorkspace: {equalTo: false}}}
  ) {
    nodes {
      team {
        id
        name
        workspaceSubscriptionsBySubteamId(filter: {teamId: {equalTo: $id}}) {
          nodes {
            id
          }
        }
      }
    }
  }
}
    `;

export function useTeamCandidatesForWorkspaceQuery(options?: Omit<Urql.UseQueryArgs<never, TeamCandidatesForWorkspaceQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<TeamCandidatesForWorkspaceQuery, TeamCandidatesForWorkspaceQueryVariables | undefined>({ query: TeamCandidatesForWorkspaceDocument, variables: undefined, ...options });
};
export const DeleteWorkspaceDocument = gql`
    mutation DeleteWorkspace($id: BigInt!) {
  deleteWorkspace(input: {id: $id}) {
    clientMutationId
  }
}
    `;

export function useDeleteWorkspaceMutation() {
  return Urql.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument);
};
export const CreateSubfolderDocument = gql`
    mutation CreateSubfolder($parentId: BigInt!, $name: String!) {
  createWorkspaceAndJoin(input: {name: $name, parentId: $parentId}) {
    clientMutationId
    result {
      createdWorkspace {
        id
        firebaseId
        isHcpUploadWorkspace
      }
    }
  }
}
    `;

export function useCreateSubfolderMutation() {
  return Urql.useMutation<CreateSubfolderMutation, CreateSubfolderMutationVariables>(CreateSubfolderDocument);
};
export const MoveFolderDocument = gql`
    mutation MoveFolder($id: BigInt!, $parentId: BigInt!) {
  updateWorkspace(input: {patch: {parentId: $parentId}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useMoveFolderMutation() {
  return Urql.useMutation<MoveFolderMutation, MoveFolderMutationVariables>(MoveFolderDocument);
};
export const InitDocument = gql`
    query init {
  myWorkspaces: workspaces {
    nodes {
      name
      id
      tags
      parentId
      firebaseId
      isHcpUploadWorkspace
      root {
        firebaseId
        isHcpUploadWorkspace
        id
        tags
        myPrivileges {
          mayAdministrate
        }
        id
      }
    }
  }
  myRootWorkspaces: workspaces(
    condition: {parentId: null}
    orderBy: [TEAM_RANK_DESC, NAME_LOWERCASE_ASC, ID_ASC]
  ) {
    nodes {
      ...RootWorkspace
    }
  }
  myAccount {
    nodes {
      firebaseAuthId
      email
      mergedFlags(includeSuperteams: true)
      mergedConfig(includeSuperteams: true)
      id
      displayName
      tenantId
      appConsentGivenAt
      userContactDetail {
        profileImageUrl
      }
    }
  }
  documentSpaceConfigs {
    totalCount
  }
}
    ${RootWorkspaceFragmentDoc}`;

export function useInitQuery(options?: Omit<Urql.UseQueryArgs<never, InitQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<InitQuery, InitQueryVariables | undefined>({ query: InitDocument, variables: undefined, ...options });
};
export const SendWorkspaceNotificationDocument = gql`
    mutation SendWorkspaceNotification($eventType: PvNotificationEventType!, $workspaceId: String!, $headerText: String!, $bodyText: String!, $documentId: BigInt!) {
  pvAddWorkspaceNotification(
    input: {eventType: $eventType, firebaseWorkspaceId: $workspaceId, headerText: $headerText, bodyText: $bodyText, documentId: $documentId}
  ) {
    clientMutationId
  }
}
    `;

export function useSendWorkspaceNotificationMutation() {
  return Urql.useMutation<SendWorkspaceNotificationMutation, SendWorkspaceNotificationMutationVariables>(SendWorkspaceNotificationDocument);
};
export const FtsSearchDocumentsDocument = gql`
    query FtsSearchDocuments($term: String!, $pageLength: Int, $pageOffset: Int) {
  ftsSearchDocuments(
    term: $term
    pageLength: $pageLength
    pageOffset: $pageOffset
  ) {
    totalCount
    nodes {
      titleHeadline
      fileNameHeadline
      documentScore
      bestPageScore
      totalScore
      totalMatchingPages
      pageHits {
        pageNumber
        score
        headline
      }
      document {
        displayTitle
        mimeType
        pages
        id
        firestoreId
        displayDate
        rootWorkspace {
          isHcpUploadWorkspace
          name
          id
        }
        workspace {
          name
          id
        }
        doesSupportSharedspace
        thumbnailDownloadUrl
        tags
      }
    }
  }
}
    `;

export function useFtsSearchDocumentsQuery(options?: Omit<Urql.UseQueryArgs<never, FtsSearchDocumentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<FtsSearchDocumentsQuery, FtsSearchDocumentsQueryVariables | undefined>({ query: FtsSearchDocumentsDocument, variables: undefined, ...options });
};
export const FtsSearchDocumentSpacesDocument = gql`
    query FtsSearchDocumentSpaces($term: String!, $searchPersonalMessage: Boolean, $pageLength: Int, $pageOffset: Int) {
  ftsSearchDocumentSpaces(
    term: $term
    searchPersonalMessage: $searchPersonalMessage
    pageLength: $pageLength
    pageOffset: $pageOffset
  ) {
    totalCount
    nodes {
      documentSpaceId
      nameOfSpace
      nameOfSpaceHeadline
      nameOfCrmContact
      nameOfCrmContactHeadline
      personalMessage
      personalMessageHeadline
      totalScore
    }
  }
}
    `;

export function useFtsSearchDocumentSpacesQuery(options?: Omit<Urql.UseQueryArgs<never, FtsSearchDocumentSpacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<FtsSearchDocumentSpacesQuery, FtsSearchDocumentSpacesQueryVariables | undefined>({ query: FtsSearchDocumentSpacesDocument, variables: undefined, ...options });
};
export const FtsSearchFlowsDocument = gql`
    query FtsSearchFlows($term: String!, $pageLength: Int, $pageOffset: Int, $creatorId: BigInt!) {
  ftsSearchFlows(
    term: $term
    pageLength: $pageLength
    pageOffset: $pageOffset
    filter: {flow: {creatorId: {equalTo: $creatorId}}}
  ) {
    totalCount
    nodes {
      flowId
      title
      titleHeadline
      titleScore
      bestPageScore
      totalScore
      totalMatchingPages
      pageHits {
        pageNumber
        score
        headline
      }
      flow {
        creatorId
        thumbnailUrl
        createdAt
        updatedAt
        allFlowItems {
          totalCount
        }
      }
    }
  }
}
    `;

export function useFtsSearchFlowsQuery(options?: Omit<Urql.UseQueryArgs<never, FtsSearchFlowsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<FtsSearchFlowsQuery, FtsSearchFlowsQueryVariables | undefined>({ query: FtsSearchFlowsDocument, variables: undefined, ...options });
};;;
export const LeaveTeamDocument = gql`
    mutation LeaveTeam($teamId: BigInt!) {
  leaveTeam(input: {teamId: $teamId}) {
    deletedMembership {
      id
      currentState
    }
  }
}
    `;

export function useLeaveTeamMutation() {
  return Urql.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(LeaveTeamDocument);
};
export const UserContactDetailDocument = gql`
    query UserContactDetail {
  myAccount {
    nodes {
      id
      userContactDetail {
        id
        userId
        businessCardUrl
        appointmentBookingUrl
        displayName
        email
        jobTitle
        phone
        profileImageUrl
      }
    }
  }
}
    `;

export function useUserContactDetailQuery(options?: Omit<Urql.UseQueryArgs<never, UserContactDetailQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<UserContactDetailQuery, UserContactDetailQueryVariables | undefined>({ query: UserContactDetailDocument, variables: undefined, ...options });
};
export const UpdateContactDetailsDocument = gql`
    mutation UpdateContactDetails($id: BigInt!, $displayName: String, $email: String, $jobTitle: String, $phone: String, $appointmentBookingUrl: String, $profileImageUrl: String) {
  updateUserContactDetail(
    input: {patch: {displayName: $displayName, email: $email, jobTitle: $jobTitle, phone: $phone, appointmentBookingUrl: $appointmentBookingUrl, profileImageUrl: $profileImageUrl}, id: $id}
  ) {
    userContactDetail {
      displayName
      businessCardUrl
      appointmentBookingUrl
      email
      id
      jobTitle
      phone
      profileImageUrl
      userId
    }
  }
}
    `;

export function useUpdateContactDetailsMutation() {
  return Urql.useMutation<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>(UpdateContactDetailsDocument);
};
export const UpdateUserConfigDocument = gql`
    mutation UpdateUserConfig($configPartial: JSON!) {
  updateUserConfigPartial(input: {configPatch: $configPartial}) {
    clientMutationId
  }
}
    `;

export function useUpdateUserConfigMutation() {
  return Urql.useMutation<UpdateUserConfigMutation, UpdateUserConfigMutationVariables>(UpdateUserConfigDocument);
};
export const DocumentSpaceStatisticsDocument = gql`
    query DocumentSpaceStatistics($includePreview: Boolean!) {
  maLatestSpaceVisits(tz: "Europe/Amsterdam", includePreview: $includePreview) {
    nodes {
      documentSpaceId
      latestVisitDay
      name
    }
    totalCount
  }
  documentSpaces(condition: {trackingDeactivated: true}) {
    totalCount
  }
}
    `;

export function useDocumentSpaceStatisticsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceStatisticsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceStatisticsQuery, DocumentSpaceStatisticsQueryVariables | undefined>({ query: DocumentSpaceStatisticsDocument, variables: undefined, ...options });
};
export const LatestSpaceVisitsDocument = gql`
    query LatestSpaceVisits($documentSpaceId: BigInt!) {
  maDocumentSpaceVisitsStatistics(
    orderBy: STARTS_AT_DESC
    filter: {duration: {greaterThan: {seconds: 3}}}
    condition: {isPreview: false, documentSpaceId: $documentSpaceId}
  ) {
    nodes {
      id
      startsAt
      interactions
      isPreview
      duration {
        hours
        minutes
        seconds
      }
    }
    totalCount
  }
}
    `;

export function useLatestSpaceVisitsQuery(options?: Omit<Urql.UseQueryArgs<never, LatestSpaceVisitsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<LatestSpaceVisitsQuery, LatestSpaceVisitsQueryVariables | undefined>({ query: LatestSpaceVisitsDocument, variables: undefined, ...options });
};
export const DocumentSpaceVisitsDocument = gql`
    query DocumentSpaceVisits($documentSpaceId: BigInt!) {
  maDocumentSpaceVisitsStatistics(
    orderBy: STARTS_AT_DESC
    filter: {duration: {greaterThan: {seconds: 3}}}
    condition: {isPreview: false, documentSpaceId: $documentSpaceId}
  ) {
    nodes {
      id
      startsAt
      interactions
      isPreview
      duration {
        hours
        minutes
        seconds
      }
    }
    totalCount
  }
  maDocumentSpaceStatistics(condition: {documentSpaceId: $documentSpaceId}) {
    nodes {
      name
      numDownloads
      numLinkClicks
      totalVisits
      avgDuration {
        hours
        minutes
        seconds
      }
    }
  }
}
    `;

export function useDocumentSpaceVisitsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceVisitsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceVisitsQuery, DocumentSpaceVisitsQueryVariables | undefined>({ query: DocumentSpaceVisitsDocument, variables: undefined, ...options });
};
export const DocumentSpaceVisitDetailsDocument = gql`
    query DocumentSpaceVisitDetails($visitId: BigInt!) {
  maVisitDetails(condition: {visitId: $visitId}) {
    nodes {
      documentId
      displayTitle
      thumbnailDownloadUrl
      isPreview
      startsAt
      type
      url
      watchRate
      duration {
        hours
        minutes
        seconds
      }
    }
  }
}
    `;

export function useDocumentSpaceVisitDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceVisitDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceVisitDetailsQuery, DocumentSpaceVisitDetailsQueryVariables | undefined>({ query: DocumentSpaceVisitDetailsDocument, variables: undefined, ...options });
};
export const DocumentSpaceDetailStatisticsDocument = gql`
    query DocumentSpaceDetailStatistics($id: BigInt!) {
  maDocumentSpaceVisitsStatistics(
    orderBy: STARTS_AT_DESC
    filter: {documentSpaceId: {equalTo: $id}, isPreview: {equalTo: false}}
  ) {
    nodes {
      startsAt
      interactions
      isPreview
      duration {
        hours
        minutes
        seconds
      }
    }
  }
  maDocumentSpaceStatistics(filter: {documentSpaceId: {equalTo: $id}}) {
    nodes {
      name
      numDownloads
      numLinkClicks
      totalVisits
      avgDuration {
        hours
        minutes
        seconds
      }
    }
  }
  maDocumentSpaceLinkStatistics(filter: {documentSpaceId: {equalTo: $id}}) {
    nodes {
      numClicks
      url
    }
  }
  maDocumentSpaceDocumentStatistics(
    condition: {documentSpaceId: $id, mimeType: "application/pdf"}
    orderBy: NUM_VISITS_DESC
  ) {
    nodes {
      numDownloads
      numVisits
      averageDurationInDocumentPerVisit {
        hours
        minutes
        seconds
      }
      displayTitle
      documentId
      mimeType
      thumbnailDownloadUrl
      maxDurationInDocumentAcrossVisits {
        hours
        minutes
        seconds
      }
    }
  }
  maDocumentSpaceVideoStatistics(
    condition: {documentSpaceId: $id}
    orderBy: NUM_VISITS_DESC
  ) {
    nodes {
      displayTitle
      maxWatchRateAcrossVisits
      numDownloads
      numVisits
      thumbnailDownloadUrl
    }
  }
}
    `;

export function useDocumentSpaceDetailStatisticsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceDetailStatisticsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceDetailStatisticsQuery, DocumentSpaceDetailStatisticsQueryVariables | undefined>({ query: DocumentSpaceDetailStatisticsDocument, variables: undefined, ...options });
};
export const TopPagesPerSpaceAndDocumentDocument = gql`
    query TopPagesPerSpaceAndDocument($spaceId: BigInt!, $docId: BigInt!) {
  maDocumentSpacePageStatistics(
    condition: {documentSpaceId: $spaceId, documentId: $docId}
    first: 3
    orderBy: [MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC, PAGE_NUMBER_ASC]
  ) {
    nodes {
      numVisits
      pageNumber
      averageDurationOnPagePerVisit {
        hours
        minutes
        seconds
      }
      maxDurationOnPageAcrossVisits {
        hours
        minutes
        seconds
      }
    }
  }
}
    `;

export function useTopPagesPerSpaceAndDocumentQuery(options?: Omit<Urql.UseQueryArgs<never, TopPagesPerSpaceAndDocumentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<TopPagesPerSpaceAndDocumentQuery, TopPagesPerSpaceAndDocumentQueryVariables | undefined>({ query: TopPagesPerSpaceAndDocumentDocument, variables: undefined, ...options });
};
export const DocumentStatisticsDocument = gql`
    query DocumentStatistics($orderBy: [MaDocumentStatisticsOrderBy!], $first: Int!, $search: String!) {
  maDocumentStatistics(
    orderBy: $orderBy
    first: $first
    filter: {displayTitle: {includesInsensitive: $search}}
  ) {
    nodes {
      numDownloads
      numVisits
      numShares
      numCurrentShares
      averageDurationInDocumentPerVisit {
        hours
        minutes
        seconds
      }
      displayTitle
      documentId
      mimeType
      thumbnailDownloadUrl
      maxDurationInDocumentAcrossVisits {
        hours
        minutes
        seconds
      }
    }
    totalCount
  }
}
    `;

export function useDocumentStatisticsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentStatisticsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentStatisticsQuery, DocumentStatisticsQueryVariables | undefined>({ query: DocumentStatisticsDocument, variables: undefined, ...options });
};
export const TopPagesPerDocumentDocument = gql`
    query TopPagesPerDocument($docId: BigInt!) {
  maPageStatistics(
    condition: {documentId: $docId}
    first: 3
    orderBy: [MAX_DURATION_ON_PAGE_ACROSS_VISITS_DESC, PAGE_NUMBER_ASC]
    filter: {pageNumber: {isNull: false}}
  ) {
    nodes {
      numVisits
      pageNumber
      averageDurationOnPagePerVisit {
        hours
        minutes
        seconds
      }
      maxDurationOnPageAcrossVisits {
        hours
        minutes
        seconds
      }
    }
  }
}
    `;

export function useTopPagesPerDocumentQuery(options?: Omit<Urql.UseQueryArgs<never, TopPagesPerDocumentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<TopPagesPerDocumentQuery, TopPagesPerDocumentQueryVariables | undefined>({ query: TopPagesPerDocumentDocument, variables: undefined, ...options });
};
export const UsageAnalyticsDocument = gql`
    query UsageAnalytics($year: BigFloat!) {
  maUsageByTeamsAndYears(condition: {year: $year}) {
    nodes {
      analyticsAlias
      nPresentations
      nTimesOpenedADocument
      nTimesOpenedTheApp
      nUploads
      tenantId
      nUsersThatOpenedTheAppAtLeastOnce
      nUsersThatPresentedAtLeastOnce
      year
    }
  }
  maUsageByTeamsAllTimeMembershipAndYears(condition: {year: $year}) {
    nodes {
      analyticsAlias
      nPresentations
      nTimesOpenedADocument
      nTimesOpenedTheApp
      nUploads
      tenantId
      nUsersThatOpenedTheAppAtLeastOnce
      nUsersThatPresentedAtLeastOnce
      year
    }
  }
  maUsageByTeams {
    nodes {
      analyticsAlias
      nUsersTotal
      nUsersTotalRegistered
      nNewUsersCreatedInLastSixMonths
      nNewUsersCreatedInLastYear
      nNewUsersRegisteredInLastSixMonths
      nNewUsersRegisteredInLastYear
    }
  }
}
    `;

export function useUsageAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<never, UsageAnalyticsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<UsageAnalyticsQuery, UsageAnalyticsQueryVariables | undefined>({ query: UsageAnalyticsDocument, variables: undefined, ...options });
};
export const SpaceUsageAnalyticsDocument = gql`
    query SpaceUsageAnalytics($year: BigFloat!) {
  maSpaceUsageByTeamsAndYears(condition: {year: $year}) {
    nodes {
      analyticsAlias
      nTotalClicks
      nTotalDocumentVisits
      nTotalDownloads
      nTotalSpaceVisits
      nTotalSpaces
    }
  }
}
    `;

export function useSpaceUsageAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<never, SpaceUsageAnalyticsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SpaceUsageAnalyticsQuery, SpaceUsageAnalyticsQueryVariables | undefined>({ query: SpaceUsageAnalyticsDocument, variables: undefined, ...options });
};
export const CustomFlowsDocument = gql`
    query CustomFlows($creatorId: BigInt!) {
  flows(filter: {creatorId: {equalTo: $creatorId}}, orderBy: UPDATED_AT_DESC) {
    nodes {
      id
      title
    }
  }
}
    `;

export function useCustomFlowsQuery(options?: Omit<Urql.UseQueryArgs<never, CustomFlowsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<CustomFlowsQuery, CustomFlowsQueryVariables | undefined>({ query: CustomFlowsDocument, variables: undefined, ...options });
};
export const DeleteCustomFlowDocument = gql`
    mutation DeleteCustomFlow($id: BigInt!) {
  deleteFlow(input: {id: $id}) {
    clientMutationId
    deletedFlowNodeId
  }
}
    `;

export function useDeleteCustomFlowMutation() {
  return Urql.useMutation<DeleteCustomFlowMutation, DeleteCustomFlowMutationVariables>(DeleteCustomFlowDocument);
};
export const CreateCustomFlowDocument = gql`
    mutation CreateCustomFlow($title: String!) {
  createFlow(input: {flow: {title: $title}}) {
    flow {
      id
      title
    }
  }
}
    `;

export function useCreateCustomFlowMutation() {
  return Urql.useMutation<CreateCustomFlowMutation, CreateCustomFlowMutationVariables>(CreateCustomFlowDocument);
};
export const CopyCustomFlowDocument = gql`
    mutation CopyCustomFlow($id: BigInt!, $newTitle: String!) {
  copyFlow(input: {withId: $id, newTitle: $newTitle}) {
    copiedFlow {
      id
      title
    }
  }
}
    `;

export function useCopyCustomFlowMutation() {
  return Urql.useMutation<CopyCustomFlowMutation, CopyCustomFlowMutationVariables>(CopyCustomFlowDocument);
};
export const CustomFlowWithoutExpiredDocumentsDocument = gql`
    query CustomFlowWithoutExpiredDocuments($id: BigInt!) {
  flow(id: $id) {
    id
    creatorId
    legalAppendixPages(filter: {document: {documentExpirationExists: false}}) {
      nodes {
        id
        document {
          displayTitle
          documentExpiration {
            expiredAt
          }
        }
      }
    }
    title
    flowItems(
      orderBy: [ORDER_ASC]
      filter: {or: [{page: {document: {documentExpirationExists: false}}}, {video: {documentExpirationExists: false}}]}
    ) {
      nodes {
        id
        pageId
        page {
          id
          pageNumber
          document {
            ...FlowDocument
          }
        }
        video {
          ...FlowDocument
        }
        nodeId
      }
    }
    distinctDocuments(filter: {documentExpirationExists: false}) {
      nodes {
        ...FlowDocument
      }
    }
  }
}
    ${FlowDocumentFragmentDoc}`;

export function useCustomFlowWithoutExpiredDocumentsQuery(options?: Omit<Urql.UseQueryArgs<never, CustomFlowWithoutExpiredDocumentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<CustomFlowWithoutExpiredDocumentsQuery, CustomFlowWithoutExpiredDocumentsQueryVariables | undefined>({ query: CustomFlowWithoutExpiredDocumentsDocument, variables: undefined, ...options });
};
export const CustomFlowDocument = gql`
    query CustomFlow($id: BigInt!) {
  flow(id: $id) {
    id
    creatorId
    legalAppendixPages {
      nodes {
        id
        document {
          displayTitle
          documentExpiration {
            expiredAt
          }
        }
      }
    }
    title
    flowItems(orderBy: [ORDER_ASC]) {
      nodes {
        id
        pageId
        page {
          id
          pageNumber
          document {
            ...FlowDocument
          }
        }
        video {
          ...FlowDocument
        }
        nodeId
      }
    }
    distinctDocuments {
      nodes {
        ...FlowDocument
      }
    }
  }
}
    ${FlowDocumentFragmentDoc}`;

export function useCustomFlowQuery(options?: Omit<Urql.UseQueryArgs<never, CustomFlowQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<CustomFlowQuery, CustomFlowQueryVariables | undefined>({ query: CustomFlowDocument, variables: undefined, ...options });
};
export const GetDocumentPagesByDocumentIdDocument = gql`
    query GetDocumentPagesByDocumentId($documentId: BigInt!) {
  document(id: $documentId) {
    documentRevisionByIdAndCurrentRevisionNumber {
      documentPagesByDocumentIdAndRevisionNumber {
        nodes {
          id
        }
      }
    }
    currentRevisionNumber
  }
}
    `;

export function useGetDocumentPagesByDocumentIdQuery(options?: Omit<Urql.UseQueryArgs<never, GetDocumentPagesByDocumentIdQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetDocumentPagesByDocumentIdQuery, GetDocumentPagesByDocumentIdQueryVariables | undefined>({ query: GetDocumentPagesByDocumentIdDocument, variables: undefined, ...options });
};
export const AppendFlowItemsDocument = gql`
    mutation AppendFlowItems($flowId: BigInt!, $pageIds: [BigInt!]!) {
  appendPagesToFlow(input: {flowId: $flowId, pageIds: $pageIds}) {
    flowItems {
      pageId
    }
  }
}
    `;

export function useAppendFlowItemsMutation() {
  return Urql.useMutation<AppendFlowItemsMutation, AppendFlowItemsMutationVariables>(AppendFlowItemsDocument);
};
export const AppendVideoDocument = gql`
    mutation AppendVideo($flowId: BigInt!, $videoId: BigInt!) {
  appendVideosToFlow(input: {flowId: $flowId, videoIds: [$videoId]}) {
    clientMutationId
  }
}
    `;

export function useAppendVideoMutation() {
  return Urql.useMutation<AppendVideoMutation, AppendVideoMutationVariables>(AppendVideoDocument);
};
export const RemoveFlowItemDocument = gql`
    mutation RemoveFlowItem($id: BigInt!) {
  deleteFlowItem(input: {id: $id}) {
    clientMutationId
    deletedFlowItemNodeId
  }
}
    `;

export function useRemoveFlowItemMutation() {
  return Urql.useMutation<RemoveFlowItemMutation, RemoveFlowItemMutationVariables>(RemoveFlowItemDocument);
};
export const ReorderFlowPageDocument = gql`
    mutation ReorderFlowPage($flowItemId: BigInt!, $beforeId: BigInt, $behindId: BigInt) {
  placeFlowItem(
    input: {withId: $flowItemId, beforeId: $beforeId, behindId: $behindId}
  ) {
    flowItems {
      id
    }
  }
}
    `;

export function useReorderFlowPageMutation() {
  return Urql.useMutation<ReorderFlowPageMutation, ReorderFlowPageMutationVariables>(ReorderFlowPageDocument);
};
export const RenameCustomFlowDocument = gql`
    mutation RenameCustomFlow($id: BigInt!, $title: String!) {
  updateFlow(input: {patch: {title: $title}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useRenameCustomFlowMutation() {
  return Urql.useMutation<RenameCustomFlowMutation, RenameCustomFlowMutationVariables>(RenameCustomFlowDocument);
};
export const GetDocumentsOfSpaceDocument = gql`
    query GetDocumentsOfSpace($spaceId: BigInt!) {
  documentSpace(id: $spaceId) {
    documentSpaceItems {
      nodes {
        documentId
      }
    }
  }
}
    `;

export function useGetDocumentsOfSpaceQuery(options?: Omit<Urql.UseQueryArgs<never, GetDocumentsOfSpaceQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetDocumentsOfSpaceQuery, GetDocumentsOfSpaceQueryVariables | undefined>({ query: GetDocumentsOfSpaceDocument, variables: undefined, ...options });
};
export const FlowIsSharedDocument = gql`
    query FlowIsShared($flowId: BigInt!) {
  documentSpaceItems(first: 1, condition: {flowId: $flowId}) {
    totalCount
  }
}
    `;

export function useFlowIsSharedQuery(options?: Omit<Urql.UseQueryArgs<never, FlowIsSharedQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<FlowIsSharedQuery, FlowIsSharedQueryVariables | undefined>({ query: FlowIsSharedDocument, variables: undefined, ...options });
};
export const MagicPagesDocument = gql`
    query MagicPages($id: BigInt!) {
  document(id: $id) {
    documentRevisionByIdAndCurrentRevisionNumber {
      documentPagesByDocumentIdAndRevisionNumber(orderBy: PAGE_NUMBER_ASC) {
        nodes {
          ...PageConfig
        }
        totalCount
      }
    }
  }
}
    ${PageConfigFragmentDoc}`;

export function useMagicPagesQuery(options?: Omit<Urql.UseQueryArgs<never, MagicPagesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MagicPagesQuery, MagicPagesQueryVariables | undefined>({ query: MagicPagesDocument, variables: undefined, ...options });
};
export const UpdatePageTypeDocument = gql`
    mutation UpdatePageType($id: BigInt!, $pageType: PageType!, $linkedDocumentId: BigInt) {
  updateDocumentPage(
    input: {id: $id, patch: {linkedDocumentId: $linkedDocumentId, pageType: $pageType}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdatePageTypeMutation() {
  return Urql.useMutation<UpdatePageTypeMutation, UpdatePageTypeMutationVariables>(UpdatePageTypeDocument);
};
export const DocumentSpacesDocument = gql`
    query DocumentSpaces($orderBy: DocumentSpacesOrderBy!) {
  documentSpaces(orderBy: [$orderBy]) {
    nodes {
      id
      name
      createdAt
      updatedAt
      documentSpaceItems {
        totalCount
      }
      documentSpaceAccesses {
        nodes {
          role
          user {
            id
          }
        }
        totalCount
      }
      config {
        name
      }
      documentSpaceVouchers(condition: {isPreview: false, isTechnical: false}) {
        totalCount
      }
      visitStatistics {
        lastVisitAt
      }
      documentSpaceCrmMapping {
        crmContact {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

export function useDocumentSpacesQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpacesQuery, DocumentSpacesQueryVariables | undefined>({ query: DocumentSpacesDocument, variables: undefined, ...options });
};
export const DocumentSpacesCountDocument = gql`
    query DocumentSpacesCount {
  documentSpaces {
    totalCount
  }
}
    `;

export function useDocumentSpacesCountQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpacesCountQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpacesCountQuery, DocumentSpacesCountQueryVariables | undefined>({ query: DocumentSpacesCountDocument, variables: undefined, ...options });
};
export const DocumentSpacesSearchDocument = gql`
    query DocumentSpacesSearch($search: String!) {
  documentSpaces(
    orderBy: UPDATED_AT_DESC
    filter: {name: {includesInsensitive: $search}}
  ) {
    nodes {
      createdAt
      updatedAt
      name
      id
      updatedAt
      documentSpaceItems {
        totalCount
      }
      documentSpaceAccesses {
        nodes {
          role
          user {
            id
          }
        }
        totalCount
      }
    }
  }
}
    `;

export function useDocumentSpacesSearchQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpacesSearchQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpacesSearchQuery, DocumentSpacesSearchQueryVariables | undefined>({ query: DocumentSpacesSearchDocument, variables: undefined, ...options });
};
export const DocumentSpaceDocument = gql`
    query DocumentSpace($id: BigInt!) {
  documentSpace(id: $id) {
    name
    id
    personalMessage
    tenantId
    allowedEmailAddresses
    trackingDeactivated
    visitStatistics {
      firstVisitAt
      lastVisitAt
      visitCount
    }
    documentSpaceVouchers(condition: {isPreview: false, isTechnical: false}) {
      totalCount
    }
    config {
      id
      name
      requiresEmailAuthentication
      documentSpaceLinksByConfigId(orderBy: POSITION_ASC) {
        nodes {
          title
          sectionTitle
          url
          isMandatory
          id
          nodeId
          position
          documentSpaceLinkMappingsByLinkId(condition: {spaceId: $id}) {
            nodes {
              id
            }
          }
          documentSpaceLinkTranslationsByLinkId {
            nodes {
              id
              languageCode
              sectionTitle
              title
              url
            }
          }
        }
      }
    }
    documentSpaceCrmMapping {
      crmContact {
        crmId
        email
        firstName
        id
        lastName
        territory
        organization
        mobile
        crmContactPhaseMappingsByContactId {
          nodes {
            phase {
              campaignPhaseLinksByPhaseId {
                nodes {
                  name
                  id
                }
              }
            }
          }
        }
        authorsOfDocumentSpaces(ifAny: [INVITED, VISITED]) {
          nodes {
            id
            displayName
          }
        }
      }
    }
    documentSpaceSections(orderBy: POSITION_ASC) {
      nodes {
        id
        title
        position
        documentSpaceItemsBySectionId(
          filter: {or: [{document: {deletedAt: {isNull: true}}}, {flowId: {isNull: false}}]}
          orderBy: POSITION_DESC
        ) {
          nodes {
            id
            position
            flowId
            document {
              createdById
              deletedAt
              displayDate
              displayTitle
              downloadUrl
              fileName
              fileSize
              firestoreId
              id
              numNormalPages
              internalLinks
              isPublished
              lastModifiedAt
              lastModifiedById
              literatureReferences
              mimeType
              originalMimeType
              pages
              storageId
              tags
              teaserText
              thumbnailDownloadUrl
              thumbnailStorageId
              topTitle
              uploadedAt
              workspaceId
              documentExpiration {
                expiredAt
              }
            }
            flow {
              id
              title
              thumbnailUrl
              flowItems {
                totalCount
              }
            }
          }
        }
      }
    }
    documentSpaceLinks(orderBy: POSITION_DESC) {
      nodes {
        id
        nodeId
        position
        sectionTitle
        title
        url
      }
    }
    documentSpaceAccesses {
      nodes {
        displayContactDetails
        id
        role
        userId
        user {
          id
          displayName
          userContactDetail {
            profileImageUrl
            businessCardUrl
            appointmentBookingUrl
            displayName
            email
            jobTitle
            id
            phone
          }
          email
        }
      }
    }
  }
}
    `;

export function useDocumentSpaceQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceQuery, DocumentSpaceQueryVariables | undefined>({ query: DocumentSpaceDocument, variables: undefined, ...options });
};
export const DocumentSpaceConfigsDocument = gql`
    query DocumentSpaceConfigs {
  documentSpaceConfigs(filter: {teamExists: true}) {
    nodes {
      name
      id
    }
    totalCount
  }
}
    `;

export function useDocumentSpaceConfigsQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpaceConfigsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpaceConfigsQuery, DocumentSpaceConfigsQueryVariables | undefined>({ query: DocumentSpaceConfigsDocument, variables: undefined, ...options });
};
export const UpdateDocumentSpaceConfigDocument = gql`
    mutation UpdateDocumentSpaceConfig($id: BigInt!, $configId: BigInt!) {
  updateDocumentSpace(input: {patch: {configId: $configId}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceConfigMutation() {
  return Urql.useMutation<UpdateDocumentSpaceConfigMutation, UpdateDocumentSpaceConfigMutationVariables>(UpdateDocumentSpaceConfigDocument);
};
export const UpdateDocumentSpaceNameDocument = gql`
    mutation UpdateDocumentSpaceName($id: BigInt!, $name: String!) {
  updateDocumentSpace(input: {patch: {name: $name}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceNameMutation() {
  return Urql.useMutation<UpdateDocumentSpaceNameMutation, UpdateDocumentSpaceNameMutationVariables>(UpdateDocumentSpaceNameDocument);
};
export const UpdateDocumentSpaceMessageDocument = gql`
    mutation UpdateDocumentSpaceMessage($id: BigInt!, $message: String!) {
  updateDocumentSpace(input: {patch: {personalMessage: $message}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceMessageMutation() {
  return Urql.useMutation<UpdateDocumentSpaceMessageMutation, UpdateDocumentSpaceMessageMutationVariables>(UpdateDocumentSpaceMessageDocument);
};
export const DeactivateSpaceTrackingDocument = gql`
    mutation DeactivateSpaceTracking($id: BigInt!) {
  updateDocumentSpace(input: {patch: {trackingDeactivated: true}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useDeactivateSpaceTrackingMutation() {
  return Urql.useMutation<DeactivateSpaceTrackingMutation, DeactivateSpaceTrackingMutationVariables>(DeactivateSpaceTrackingDocument);
};
export const UpdateAllowedEmailAddressDocument = gql`
    mutation UpdateAllowedEmailAddress($id: BigInt!, $email: String!) {
  updateDocumentSpace(input: {patch: {allowedEmailAddresses: [$email]}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useUpdateAllowedEmailAddressMutation() {
  return Urql.useMutation<UpdateAllowedEmailAddressMutation, UpdateAllowedEmailAddressMutationVariables>(UpdateAllowedEmailAddressDocument);
};
export const CreateDocumentSpaceVoucherDocument = gql`
    mutation CreateDocumentSpaceVoucher($id: BigInt!, $campaignPhaseLinkId: BigInt, $isPreview: Boolean!) {
  pvCreateVoucherForDocumentSpace(
    input: {byId: $id, campaignPhaseLinkId: $campaignPhaseLinkId, isPreview: $isPreview}
  ) {
    result {
      urlSegment
    }
  }
}
    `;

export function useCreateDocumentSpaceVoucherMutation() {
  return Urql.useMutation<CreateDocumentSpaceVoucherMutation, CreateDocumentSpaceVoucherMutationVariables>(CreateDocumentSpaceVoucherDocument);
};
export const CreateDocumentSpaceSectionDocument = gql`
    mutation CreateDocumentSpaceSection($spaceId: BigInt!, $title: String) {
  createDocumentSpaceSection(
    input: {documentSpaceSection: {documentSpaceId: $spaceId, title: $title}}
  ) {
    clientMutationId
  }
}
    `;

export function useCreateDocumentSpaceSectionMutation() {
  return Urql.useMutation<CreateDocumentSpaceSectionMutation, CreateDocumentSpaceSectionMutationVariables>(CreateDocumentSpaceSectionDocument);
};
export const CreateDocumentSpaceItemDocument = gql`
    mutation CreateDocumentSpaceItem($spaceId: BigInt!, $docId: BigInt!, $sectionId: BigInt) {
  createDocumentSpaceItem(
    input: {documentSpaceItem: {documentSpaceId: $spaceId, documentId: $docId, sectionId: $sectionId}}
  ) {
    clientMutationId
  }
}
    `;

export function useCreateDocumentSpaceItemMutation() {
  return Urql.useMutation<CreateDocumentSpaceItemMutation, CreateDocumentSpaceItemMutationVariables>(CreateDocumentSpaceItemDocument);
};
export const UpdateDocumentSpaceItemPositionDocument = gql`
    mutation UpdateDocumentSpaceItemPosition($spaceId: BigInt!, $docId: BigInt!, $position: BigFloat!) {
  updateDocumentSpaceItemByDocumentIdAndDocumentSpaceId(
    input: {patch: {position: $position}, documentId: $docId, documentSpaceId: $spaceId}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceItemPositionMutation() {
  return Urql.useMutation<UpdateDocumentSpaceItemPositionMutation, UpdateDocumentSpaceItemPositionMutationVariables>(UpdateDocumentSpaceItemPositionDocument);
};
export const DeleteDocumentSpaceItemDocument = gql`
    mutation DeleteDocumentSpaceItem($spaceId: BigInt!, $docId: BigInt!) {
  deleteDocumentSpaceItemByDocumentIdAndDocumentSpaceId(
    input: {documentId: $docId, documentSpaceId: $spaceId}
  ) {
    clientMutationId
  }
}
    `;

export function useDeleteDocumentSpaceItemMutation() {
  return Urql.useMutation<DeleteDocumentSpaceItemMutation, DeleteDocumentSpaceItemMutationVariables>(DeleteDocumentSpaceItemDocument);
};
export const CreateDocumentSpaceDocument = gql`
    mutation CreateDocumentSpace($name: String!, $crmContactId: BigInt, $configId: BigInt) {
  createDocumentSpaceWithCrmContact(
    input: {payload: {name: $name, crmContactId: $crmContactId, configId: $configId}}
  ) {
    result {
      documentSpace {
        id
      }
      crmContact {
        id
      }
    }
  }
}
    `;

export function useCreateDocumentSpaceMutation() {
  return Urql.useMutation<CreateDocumentSpaceMutation, CreateDocumentSpaceMutationVariables>(CreateDocumentSpaceDocument);
};
export const DeleteDocumentSpaceDocument = gql`
    mutation DeleteDocumentSpace($id: BigInt!) {
  deleteDocumentSpace(input: {id: $id}) {
    clientMutationId
  }
}
    `;

export function useDeleteDocumentSpaceMutation() {
  return Urql.useMutation<DeleteDocumentSpaceMutation, DeleteDocumentSpaceMutationVariables>(DeleteDocumentSpaceDocument);
};
export const CloneDocumentSpaceDocument = gql`
    mutation CloneDocumentSpace($id: BigInt!, $newName: String!, $crmContactId: BigInt) {
  cloneDocumentSpace(
    input: {withId: $id, newName: $newName, crmContactId: $crmContactId}
  ) {
    clonedSpace {
      id
    }
  }
}
    `;

export function useCloneDocumentSpaceMutation() {
  return Urql.useMutation<CloneDocumentSpaceMutation, CloneDocumentSpaceMutationVariables>(CloneDocumentSpaceDocument);
};
export const GetShortDocumentSpacesDocument = gql`
    query GetShortDocumentSpaces {
  documentSpaces(orderBy: UPDATED_AT_DESC) {
    nodes {
      ...ShortDocumentSpace
    }
  }
}
    ${ShortDocumentSpaceFragmentDoc}`;

export function useGetShortDocumentSpacesQuery(options?: Omit<Urql.UseQueryArgs<never, GetShortDocumentSpacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetShortDocumentSpacesQuery, GetShortDocumentSpacesQueryVariables | undefined>({ query: GetShortDocumentSpacesDocument, variables: undefined, ...options });
};
export const SearchUsersWithinTenantDocument = gql`
    query SearchUsersWithinTenant($search: String!, $tenantId: BigInt!, $spaceId: BigInt!) {
  usersByFlags(
    anyOf: ["space_collab"]
    restrictToTeamsOfTenants: [$tenantId]
    orderBy: EMAIL_ASC
    first: 10
    condition: {tenantId: $tenantId}
    filter: {or: [{email: {includesInsensitive: $search}}, {displayName: {includesInsensitive: $search}}]}
  ) {
    nodes {
      id
      displayName
      email
      documentSpaceAccesses(filter: {documentSpaceId: {equalTo: $spaceId}}) {
        nodes {
          id
          role
        }
      }
    }
  }
}
    `;

export function useSearchUsersWithinTenantQuery(options?: Omit<Urql.UseQueryArgs<never, SearchUsersWithinTenantQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SearchUsersWithinTenantQuery, SearchUsersWithinTenantQueryVariables | undefined>({ query: SearchUsersWithinTenantDocument, variables: undefined, ...options });
};
export const AddCollaboratorDocument = gql`
    mutation addCollaborator($spaceId: BigInt!, $userId: BigInt!, $displayContactDetails: Boolean!) {
  inviteToSpaceByEmail(
    input: {spaceId: $spaceId, invitedUserId: $userId, role: "admin", displayContactDetails: $displayContactDetails}
  ) {
    clientMutationId
  }
}
    `;

export function useAddCollaboratorMutation() {
  return Urql.useMutation<AddCollaboratorMutation, AddCollaboratorMutationVariables>(AddCollaboratorDocument);
};
export const UpdateAccessDocument = gql`
    mutation updateAccess($id: BigInt!, $displayContactDetails: Boolean!) {
  updateDocumentSpaceAccess(
    input: {patch: {displayContactDetails: $displayContactDetails}, id: $id}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateAccessMutation() {
  return Urql.useMutation<UpdateAccessMutation, UpdateAccessMutationVariables>(UpdateAccessDocument);
};
export const RemoveAccessDocument = gql`
    mutation removeAccess($id: BigInt!) {
  deleteDocumentSpaceAccess(input: {id: $id}) {
    clientMutationId
  }
}
    `;

export function useRemoveAccessMutation() {
  return Urql.useMutation<RemoveAccessMutation, RemoveAccessMutationVariables>(RemoveAccessDocument);
};
export const TransferOwnershipDocument = gql`
    mutation transferOwnership($accessId: BigInt!, $displayContactDetails: Boolean!) {
  transferOwnershipOfSpace(input: {accessId: $accessId}) {
    clientMutationId
  }
  updateDocumentSpaceAccess(
    input: {patch: {displayContactDetails: $displayContactDetails}, id: $accessId}
  ) {
    clientMutationId
  }
}
    `;

export function useTransferOwnershipMutation() {
  return Urql.useMutation<TransferOwnershipMutation, TransferOwnershipMutationVariables>(TransferOwnershipDocument);
};
export const SearchDocumentSpacesDocument = gql`
    query SearchDocumentSpaces($term: String!) {
  searchDocumentSpaces(term: $term) {
    nodes {
      matchInName
      matchInPersonalMessage
      similarity
      rank
      documentSpace {
        id
        name
        personalMessage
        createdAt
        updatedAt
        documentSpaceItems {
          totalCount
        }
        config {
          name
        }
      }
      documentMatches {
        document {
          id
          thumbnailDownloadUrl
        }
        matchInFileName
        matchInDisplayTitle
        rank
        similarity
      }
    }
    totalCount
  }
}
    `;

export function useSearchDocumentSpacesQuery(options?: Omit<Urql.UseQueryArgs<never, SearchDocumentSpacesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SearchDocumentSpacesQuery, SearchDocumentSpacesQueryVariables | undefined>({ query: SearchDocumentSpacesDocument, variables: undefined, ...options });
};
export const RenameSpaceSectionDocument = gql`
    mutation RenameSpaceSection($sectionId: BigInt!, $title: String) {
  updateDocumentSpaceSection(input: {patch: {title: $title}, id: $sectionId}) {
    clientMutationId
  }
}
    `;

export function useRenameSpaceSectionMutation() {
  return Urql.useMutation<RenameSpaceSectionMutation, RenameSpaceSectionMutationVariables>(RenameSpaceSectionDocument);
};
export const DeleteSpaceSectionDocument = gql`
    mutation DeleteSpaceSection($sectionId: BigInt!, $moveDocumentsToSectionId: BigInt) {
  deleteDocumentSpaceSection(
    input: {id: $sectionId, moveDocumentsToSectionId: $moveDocumentsToSectionId}
  ) {
    clientMutationId
  }
}
    `;

export function useDeleteSpaceSectionMutation() {
  return Urql.useMutation<DeleteSpaceSectionMutation, DeleteSpaceSectionMutationVariables>(DeleteSpaceSectionDocument);
};
export const MoveSpaceSectionDocument = gql`
    mutation MoveSpaceSection($sectionId: BigInt!, $direction: SpaceSectionMoveType!) {
  moveSpaceSection(input: {direction: $direction, withId: $sectionId}) {
    clientMutationId
  }
}
    `;

export function useMoveSpaceSectionMutation() {
  return Urql.useMutation<MoveSpaceSectionMutation, MoveSpaceSectionMutationVariables>(MoveSpaceSectionDocument);
};
export const CreateSpaceSectionAfterDocument = gql`
    mutation CreateSpaceSectionAfter($title: String!, $afterSectionId: BigInt!) {
  insertSpaceSectionAfter(
    input: {newSection: {title: $title}, afterSectionId: $afterSectionId}
  ) {
    clientMutationId
  }
}
    `;

export function useCreateSpaceSectionAfterMutation() {
  return Urql.useMutation<CreateSpaceSectionAfterMutation, CreateSpaceSectionAfterMutationVariables>(CreateSpaceSectionAfterDocument);
};
export const SpaceSectionsDocument = gql`
    query SpaceSections($spaceId: BigInt!) {
  documentSpaceSections(
    condition: {documentSpaceId: $spaceId}
    orderBy: POSITION_ASC
  ) {
    nodes {
      title
      id
    }
  }
}
    `;

export function useSpaceSectionsQuery(options?: Omit<Urql.UseQueryArgs<never, SpaceSectionsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SpaceSectionsQuery, SpaceSectionsQueryVariables | undefined>({ query: SpaceSectionsDocument, variables: undefined, ...options });
};
export const MoveSpaceItemDocument = gql`
    mutation MoveSpaceItem($withId: BigInt!, $targetItemId: BigInt!, $location: SpaceItemMoveType!) {
  moveSpaceItem(
    input: {withId: $withId, targetItemId: $targetItemId, location: $location}
  ) {
    clientMutationId
  }
}
    `;

export function useMoveSpaceItemMutation() {
  return Urql.useMutation<MoveSpaceItemMutation, MoveSpaceItemMutationVariables>(MoveSpaceItemDocument);
};
export const MoveSpaceItemToSectionDocument = gql`
    mutation MoveSpaceItemToSection($withId: BigInt!, $targetSectionId: BigInt!) {
  moveSpaceItemToSection(
    input: {withId: $withId, targetSectionId: $targetSectionId}
  ) {
    clientMutationId
  }
}
    `;

export function useMoveSpaceItemToSectionMutation() {
  return Urql.useMutation<MoveSpaceItemToSectionMutation, MoveSpaceItemToSectionMutationVariables>(MoveSpaceItemToSectionDocument);
};
export const CreateSpaceItemsDocument = gql`
    mutation CreateSpaceItems($documentId: BigInt!, $targets: [IdsOfSpaceAndSectionInput]) {
  addDocumentToMultipleSpaces(input: {documentId: $documentId, targets: $targets}) {
    documentSpaceItems {
      id
      document {
        id
      }
    }
  }
}
    `;

export function useCreateSpaceItemsMutation() {
  return Urql.useMutation<CreateSpaceItemsMutation, CreateSpaceItemsMutationVariables>(CreateSpaceItemsDocument);
};
export const CrmContactsDocument = gql`
    query CRMContacts($search: String!, $limit: Int!, $offset: Int!) {
  rankedSearchCrmContactsByName(
    term: $search
    ifSpellingIsSimilar: true
    ifPronunciationIsSimilar: false
    thresholdForSpellingSimilarity: 0.33
    first: $limit
    offset: $offset
    orderBy: [FULLTEXT_RANK_DESC, SIMILARITY_DESC, LAST_NAME_ASC, FIRST_NAME_ASC, ID_ASC]
  ) {
    nodes {
      firstName
      lastName
      email
      mobile
      id
      crmId
      territory
      organization
      crmContactPhaseMappingsByContactId {
        nodes {
          phase {
            name
            campaign {
              name
            }
          }
        }
      }
      documentSpaceCrmMappings {
        totalCount
        nodes {
          documentSpaceId
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

export function useCrmContactsQuery(options?: Omit<Urql.UseQueryArgs<never, CrmContactsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<CrmContactsQuery, CrmContactsQueryVariables | undefined>({ query: CrmContactsDocument, variables: undefined, ...options });
};
export const CrmContactsWithoutSearchDocument = gql`
    query CRMContactsWithoutSearch($limit: Int!, $offset: Int!) {
  crmContacts(
    orderBy: [LAST_NAME_ASC, FIRST_NAME_ASC, ID_ASC]
    first: $limit
    offset: $offset
    condition: {active: true}
  ) {
    nodes {
      firstName
      lastName
      email
      mobile
      id
      crmId
      territory
      organization
      crmContactPhaseMappingsByContactId {
        nodes {
          phase {
            name
            campaign {
              name
            }
          }
        }
      }
      documentSpaceCrmMappings {
        totalCount
        nodes {
          documentSpaceId
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

export function useCrmContactsWithoutSearchQuery(options?: Omit<Urql.UseQueryArgs<never, CrmContactsWithoutSearchQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<CrmContactsWithoutSearchQuery, CrmContactsWithoutSearchQueryVariables | undefined>({ query: CrmContactsWithoutSearchDocument, variables: undefined, ...options });
};
export const CreateDocumentSpaceCrmMappingDocument = gql`
    mutation CreateDocumentSpaceCrmMapping($spaceId: BigInt!, $crmContactId: BigInt!, $name: String!) {
  createDocumentSpaceCrmMapping(
    input: {documentSpaceCrmMapping: {documentSpaceId: $spaceId, crmContactId: $crmContactId}}
  ) {
    clientMutationId
  }
  updateDocumentSpace(input: {patch: {name: $name}, id: $spaceId}) {
    clientMutationId
  }
}
    `;

export function useCreateDocumentSpaceCrmMappingMutation() {
  return Urql.useMutation<CreateDocumentSpaceCrmMappingMutation, CreateDocumentSpaceCrmMappingMutationVariables>(CreateDocumentSpaceCrmMappingDocument);
};
export const DocumentSpacesForContactDocument = gql`
    query DocumentSpacesForContact($contactId: BigInt!) {
  documentSpaceCrmMappings(condition: {crmContactId: $contactId}) {
    nodes {
      documentSpace {
        id
        name
        config {
          name
        }
      }
    }
  }
}
    `;

export function useDocumentSpacesForContactQuery(options?: Omit<Urql.UseQueryArgs<never, DocumentSpacesForContactQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<DocumentSpacesForContactQuery, DocumentSpacesForContactQueryVariables | undefined>({ query: DocumentSpacesForContactDocument, variables: undefined, ...options });
};
export const CreateDocumentSpaceLinkDocument = gql`
    mutation CreateDocumentSpaceLink($documentSpaceId: BigInt!, $title: String!, $url: String!, $sectionTitle: String!) {
  createDocumentSpaceLink(
    input: {documentSpaceLink: {title: $title, url: $url, documentSpaceId: $documentSpaceId, sectionTitle: $sectionTitle}}
  ) {
    clientMutationId
  }
}
    `;

export function useCreateDocumentSpaceLinkMutation() {
  return Urql.useMutation<CreateDocumentSpaceLinkMutation, CreateDocumentSpaceLinkMutationVariables>(CreateDocumentSpaceLinkDocument);
};
export const DeleteDocumentSpaceLinkDocument = gql`
    mutation DeleteDocumentSpaceLink($id: BigInt!) {
  deleteDocumentSpaceLink(input: {id: $id}) {
    clientMutationId
  }
}
    `;

export function useDeleteDocumentSpaceLinkMutation() {
  return Urql.useMutation<DeleteDocumentSpaceLinkMutation, DeleteDocumentSpaceLinkMutationVariables>(DeleteDocumentSpaceLinkDocument);
};
export const UpdateDocumentSpaceLinkDocument = gql`
    mutation UpdateDocumentSpaceLink($id: BigInt!, $title: String!, $url: String!, $sectionTitle: String!) {
  updateDocumentSpaceLink(
    input: {id: $id, patch: {title: $title, url: $url, sectionTitle: $sectionTitle}}
  ) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceLinkMutation() {
  return Urql.useMutation<UpdateDocumentSpaceLinkMutation, UpdateDocumentSpaceLinkMutationVariables>(UpdateDocumentSpaceLinkDocument);
};
export const UpdateDocumentSpaceLinkPositionDocument = gql`
    mutation UpdateDocumentSpaceLinkPosition($id: BigInt!, $position: BigFloat!) {
  updateDocumentSpaceLink(input: {id: $id, patch: {position: $position}}) {
    clientMutationId
  }
}
    `;

export function useUpdateDocumentSpaceLinkPositionMutation() {
  return Urql.useMutation<UpdateDocumentSpaceLinkPositionMutation, UpdateDocumentSpaceLinkPositionMutationVariables>(UpdateDocumentSpaceLinkPositionDocument);
};
export const CreateDocumentSpaceLinkMappingDocument = gql`
    mutation CreateDocumentSpaceLinkMapping($spaceId: BigInt!, $linkId: BigInt!) {
  createDocumentSpaceLinkMapping(
    input: {documentSpaceLinkMapping: {linkId: $linkId, spaceId: $spaceId}}
  ) {
    clientMutationId
  }
}
    `;

export function useCreateDocumentSpaceLinkMappingMutation() {
  return Urql.useMutation<CreateDocumentSpaceLinkMappingMutation, CreateDocumentSpaceLinkMappingMutationVariables>(CreateDocumentSpaceLinkMappingDocument);
};
export const DeleteDocumentSpaceLinkMappingDocument = gql`
    mutation DeleteDocumentSpaceLinkMapping($mappingId: BigInt!) {
  deleteDocumentSpaceLinkMapping(input: {id: $mappingId}) {
    clientMutationId
  }
}
    `;

export function useDeleteDocumentSpaceLinkMappingMutation() {
  return Urql.useMutation<DeleteDocumentSpaceLinkMappingMutation, DeleteDocumentSpaceLinkMappingMutationVariables>(DeleteDocumentSpaceLinkMappingDocument);
};
export const MyManagedMembershipsDocument = gql`
    query MyManagedMemberships {
  memberships(
    condition: {isSyncedWithExternalGroups: true}
    orderBy: [UPDATED_AT_DESC]
  ) {
    nodes {
      id
      isManagedManually
      isSyncedWithExternalGroups
      currentState
      createdAt
      updatedAt
      team {
        ...ShortTeam
      }
    }
  }
}
    ${ShortTeamFragmentDoc}`;

export function useMyManagedMembershipsQuery(options?: Omit<Urql.UseQueryArgs<never, MyManagedMembershipsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyManagedMembershipsQuery, MyManagedMembershipsQueryVariables | undefined>({ query: MyManagedMembershipsDocument, variables: undefined, ...options });
};
export const MyAdminTeamsDocument = gql`
    query MyAdminTeams($internalMemberFilter: MembershipFilter!) {
  myAdminTeams {
    nodes {
      ...ShortTeam
      userMemberships: memberships(condition: {subteamId: null}) {
        totalCount
      }
      internalUserMemberships: memberships(
        condition: {subteamId: null}
        filter: $internalMemberFilter
      ) {
        totalCount
      }
    }
  }
}
    ${ShortTeamFragmentDoc}`;

export function useMyAdminTeamsQuery(options?: Omit<Urql.UseQueryArgs<never, MyAdminTeamsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyAdminTeamsQuery, MyAdminTeamsQueryVariables | undefined>({ query: MyAdminTeamsDocument, variables: undefined, ...options });
};
export const MyAdminTeamsShortDocument = gql`
    query myAdminTeamsShort {
  myAdminTeams {
    nodes {
      ...ShortTeam
    }
  }
}
    ${ShortTeamFragmentDoc}`;

export function useMyAdminTeamsShortQuery(options?: Omit<Urql.UseQueryArgs<never, MyAdminTeamsShortQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyAdminTeamsShortQuery, MyAdminTeamsShortQueryVariables | undefined>({ query: MyAdminTeamsShortDocument, variables: undefined, ...options });
};
export const AllTeamsDocument = gql`
    query AllTeams($internalMemberFilter: MembershipFilter!) {
  myActiveTeams: myTeamsByMembershipState(
    myCurrentState: ACTIVE
    filter: {isWorkspace: {equalTo: false}}
  ) {
    nodes {
      ...ShortTeam
      myMembership {
        isSyncedWithExternalGroups
        isManagedManually
        createdAt
        updatedAt
        mayAdministrate
      }
      userMemberships: memberships(condition: {subteamId: null}) {
        totalCount
      }
      internalUserMemberships: memberships(
        condition: {subteamId: null}
        filter: $internalMemberFilter
      ) {
        totalCount
      }
    }
  }
  myInvitations: myTeamsByMembershipState(
    myCurrentState: INVITED
    filter: {isWorkspace: {equalTo: false}}
  ) {
    nodes {
      ...ShortTeam
      userMemberships: memberships(condition: {subteamId: null}) {
        totalCount
      }
      internalUserMemberships: memberships(
        condition: {subteamId: null}
        filter: $internalMemberFilter
      ) {
        totalCount
      }
    }
  }
}
    ${ShortTeamFragmentDoc}`;

export function useAllTeamsQuery(options?: Omit<Urql.UseQueryArgs<never, AllTeamsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<AllTeamsQuery, AllTeamsQueryVariables | undefined>({ query: AllTeamsDocument, variables: undefined, ...options });
};
export const MyTeamsCountDocument = gql`
    query MyTeamsCount {
  myTeams(filter: {isWorkspace: {equalTo: false}}) {
    totalCount
  }
}
    `;

export function useMyTeamsCountQuery(options?: Omit<Urql.UseQueryArgs<never, MyTeamsCountQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyTeamsCountQuery, MyTeamsCountQueryVariables | undefined>({ query: MyTeamsCountDocument, variables: undefined, ...options });
};
export const TeamDetailsByIdDocument = gql`
    query TeamDetailsById($id: BigInt!) {
  team(id: $id) {
    ...ShortTeam
    activeUserMemberships: memberships(
      condition: {subteamId: null, currentState: ACTIVE}
      orderBy: USER_BY_USER_ID__DISPLAY_NAME_ASC
    ) {
      totalCount
      nodes {
        user {
          id
          email
          firebaseAuthId
          displayName
        }
        id
        userHasActiveLicense
        currentState
        mayAdministrate
        mayBanUsers
        mayDecideMembershipRequests
        mayInviteUsers
        mayOrderLicencesForThisTeam
      }
    }
    invitedUserMemberships: memberships(
      condition: {subteamId: null, currentState: INVITED}
      orderBy: USER_BY_USER_ID__DISPLAY_NAME_ASC
    ) {
      nodes {
        user {
          id
          email
          firebaseAuthId
          displayName
        }
        id
      }
    }
  }
  workspaceSubscriptions(filter: {subteamId: {equalTo: $id}}) {
    totalCount
    nodes {
      id
      teamId
      team {
        id
        name
        firebaseId
      }
    }
  }
}
    ${ShortTeamFragmentDoc}`;

export function useTeamDetailsByIdQuery(options?: Omit<Urql.UseQueryArgs<never, TeamDetailsByIdQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<TeamDetailsByIdQuery, TeamDetailsByIdQueryVariables | undefined>({ query: TeamDetailsByIdDocument, variables: undefined, ...options });
};
export const MyAccountDocument = gql`
    query MyAccount {
  myAccount {
    nodes {
      id
      mergedConfig
      tenant {
        name
        hasExternalGroups
      }
    }
  }
}
    `;

export function useMyAccountQuery(options?: Omit<Urql.UseQueryArgs<never, MyAccountQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<MyAccountQuery, MyAccountQueryVariables | undefined>({ query: MyAccountDocument, variables: undefined, ...options });
};
export const SendInvitationsDocument = gql`
    mutation SendInvitations($teamId: BigInt!, $emails: [String!], $emailText: String, $notifyUsers: Boolean) {
  inviteToTeamByEmail(
    input: {emails: $emails, teamId: $teamId, emailText: $emailText, notifyUsers: $notifyUsers}
  ) {
    memberships {
      id
      user {
        id
        email
      }
      team {
        id
        name
      }
    }
  }
}
    `;

export function useSendInvitationsMutation() {
  return Urql.useMutation<SendInvitationsMutation, SendInvitationsMutationVariables>(SendInvitationsDocument);
};
export const RemoveUserFromTeamDocument = gql`
    mutation RemoveUserFromTeam($id: BigInt!) {
  deleteMembership(input: {id: $id}) {
    membership {
      currentState
    }
  }
}
    `;

export function useRemoveUserFromTeamMutation() {
  return Urql.useMutation<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>(RemoveUserFromTeamDocument);
};
export const ChangeRoleDocument = gql`
    mutation ChangeRole($id: BigInt!, $mayAdministrate: Boolean!) {
  updateMembership(input: {patch: {mayAdministrate: $mayAdministrate}, id: $id}) {
    clientMutationId
  }
}
    `;

export function useChangeRoleMutation() {
  return Urql.useMutation<ChangeRoleMutation, ChangeRoleMutationVariables>(ChangeRoleDocument);
};;;
export const AcceptTeamInvitationDocument = gql`
    mutation AcceptTeamInvitation($id: BigInt!) {
  updateMembership(input: {patch: {currentState: ACTIVE}, id: $id}) {
    membership {
      currentState
    }
  }
}
    `;

export function useAcceptTeamInvitationMutation() {
  return Urql.useMutation<AcceptTeamInvitationMutation, AcceptTeamInvitationMutationVariables>(AcceptTeamInvitationDocument);
};
export const WorkspacesForTeamDocument = gql`
    query WorkspacesForTeam($teamId: BigInt!) {
  workspaceSubscriptions(filter: {subteamId: {equalTo: $teamId}}) {
    nodes {
      id
      team {
        id
        name
      }
    }
  }
  myMemberships(
    filter: {mayAdministrate: {equalTo: true}, team: {isWorkspace: {equalTo: true}}}
  ) {
    nodes {
      team {
        id
        name
      }
    }
  }
}
    `;

export function useWorkspacesForTeamQuery(options?: Omit<Urql.UseQueryArgs<never, WorkspacesForTeamQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<WorkspacesForTeamQuery, WorkspacesForTeamQueryVariables | undefined>({ query: WorkspacesForTeamDocument, variables: undefined, ...options });
};
export const AddWorkspaceSubscriptionDocument = gql`
    mutation AddWorkspaceSubscription($teamId: BigInt!, $workspaceId: BigInt!) {
  createWorkspaceSubscription(
    input: {workspaceSubscription: {teamId: $workspaceId, currentState: ACTIVE, subteamId: $teamId}}
  ) {
    clientMutationId
  }
}
    `;

export function useAddWorkspaceSubscriptionMutation() {
  return Urql.useMutation<AddWorkspaceSubscriptionMutation, AddWorkspaceSubscriptionMutationVariables>(AddWorkspaceSubscriptionDocument);
};
export const DeleteWorkspaceSubscriptionDocument = gql`
    mutation DeleteWorkspaceSubscription($id: BigInt!) {
  deleteWorkspaceSubscription(input: {id: $id}) {
    clientMutationId
  }
}
    `;

export function useDeleteWorkspaceSubscriptionMutation() {
  return Urql.useMutation<DeleteWorkspaceSubscriptionMutation, DeleteWorkspaceSubscriptionMutationVariables>(DeleteWorkspaceSubscriptionDocument);
};
export type LabelsOfDocumentViewHcpContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CrmContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PresentationHcpTargetInput = {
  documentViewId?: InputMaybe<Scalars['UUID']['input']>;
  expectedRevision?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplacePresentationHcpsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmContactIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  labelText?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Array<InputMaybe<PresentationHcpTargetInput>>>;
};

export type PresentationAssignmentsQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  first: Scalars['Int']['input'];
}>;

export type PresentationAssignmentsQuery = { __typename?: 'Query', documentHistoryEntries?: { __typename?: 'DocumentHistoryEntriesConnection', nodes: Array<{ __typename?: 'DocumentHistoryEntry', id: string, label?: { __typename?: 'LabelsOfDocumentView', assignmentRevision: string, text: string, hcpCount: number, hcpContacts: { __typename?: 'CrmContactsConnection', nodes: Array<{ __typename?: 'CrmContact', id: string, firstName?: string | null, lastName: string } | null> } } | null } | null> } | null };

export type ReplacePresentationHcpsMutationVariables = Exact<{
  input: ReplacePresentationHcpsInput;
}>;

export type ReplacePresentationHcpsMutation = { __typename?: 'Mutation', replacePresentationHcps?: { __typename?: 'ReplacePresentationHcpsPayload', labelsOfDocumentViews?: Array<{ __typename?: 'LabelsOfDocumentView', documentViewId: string, assignmentRevision: string, text: string, hcpCount: number, hcpContacts: { __typename?: 'CrmContactsConnection', nodes: Array<{ __typename?: 'CrmContact', id: string, firstName?: string | null, lastName: string } | null> } } | null> | null } | null };

export const PresentationAssignmentsDocument = gql`
    query PresentationAssignments($ids: [UUID!]!, $first: Int!) {
  documentHistoryEntries(
    first: $first
    filter: {id: {in: $ids}, documentExists: true}
  ) {
    nodes {
      id
      label {
        assignmentRevision
        text
        hcpCount
        hcpContacts {
          nodes {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

export function usePresentationAssignmentsQuery(options?: Omit<Urql.UseQueryArgs<never, PresentationAssignmentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<PresentationAssignmentsQuery, PresentationAssignmentsQueryVariables | undefined>({ query: PresentationAssignmentsDocument, variables: undefined, ...options });
}

export const ReplacePresentationHcpsDocument = gql`
    mutation ReplacePresentationHcps($input: ReplacePresentationHcpsInput!) {
  replacePresentationHcps(input: $input) {
    labelsOfDocumentViews {
      documentViewId
      assignmentRevision
      text
      hcpCount
      hcpContacts {
        nodes {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

export function useReplacePresentationHcpsMutation() {
  return Urql.useMutation<ReplacePresentationHcpsMutation, ReplacePresentationHcpsMutationVariables>(ReplacePresentationHcpsDocument);
}
